(function() {
    'use strict';

    angular
        .module('app.settings', [

        ]);
})();
(function () {
    'use strict';

    angular.module('app.settings').service('editLocationTransportService', editLocationTransportService);

    /* @ngInject */
    function editLocationTransportService($q, $mdDialog, baldrisConfigService, dataLegacyService, locationService) {
        var dataService = dataLegacyService;
        var self = this;

        self.locationTransport = null;
        self.isNew = false;

        self.loadLocationTransport = loadLocationTransport;
        self.saveLocationTransport = saveLocationTransport;
        self.calculatePrice = calculatePrice;
        self.isGeneralCollection = isGeneralCollection;
        self.isGeneralCremation = isGeneralCremation;
        self.toggleGeneralCollection = toggleGeneralCollection;
        self.toggleGeneralCremation = toggleGeneralCremation;
        self.isCremationTransport = isCremationTransport;
        self.isGeneralDepartment = isGeneralDepartment;
        self.toggleGeneralDepartment = toggleGeneralDepartment;
        self.toggleCremationTransport = toggleCremationTransport;
        self.shouldNotCalculatePrice = shouldNotCalculatePrice;
        self.toggleShouldNotCalculatePrice = toggleShouldNotCalculatePrice;

        var transportConfigs = null;
        var transportCalculationConfig = {
            isSet: false,
            startAmount: 0,
            distanceAmount: 0,
            minimumAmount: 0,
            hoursAmount: 0,
            additionalHoursAmount: 0,
        };

        function loadLocationTransport(locationTransportId) {
            reset();
            if (!locationTransportId || locationTransportId.toLowerCase() === 'new') {
                self.isNew = true;
                self.locationTransport = locationService.getEmptyLocationTransport();

                // Set ChangeStates
                self.locationTransport.changeState = 1;
                return baldrisConfigService.getByCategory('Transport').then(function (configs) {
                    transportConfigs = configs;
                    return true;
                });
            } else {
                var promises = [];
                promises.push(dataService.getById('LocationTransports', locationTransportId, true));
                promises.push(baldrisConfigService.getByCategory('Transport'));

                return $q.all(promises).then(function (response) {
                    self.locationTransport = response[0];
                    transportConfigs = response[1];
                    calculatePrice();
                    return true;
                });
            }
        }

        function saveLocationTransport() {
            // Set changestate on location to ensure saving
            if (self.locationTransport.changeState !== 1) {
                self.locationTransport.changeState = 2;
                var updateCommand = locationService.createUpdateCommandFromViewModel(self.locationTransport);
                return dataService.updateItem('LocationTransports', updateCommand).then(function (savedLocationTransport) {
                    self.locationTransport = savedLocationTransport;
                    self.isNew = false;
                    return true;
                });
            } else {
                return dataService.insertItem('LocationTransports', self.locationTransport).then(function (savedLocationTransport) {
                    self.locationTransport = savedLocationTransport;
                    self.isNew = false;
                    return true;
                });
            }
        }

        function calculatePrice() {
            if (!transportCalculationConfig.isSet) {
                extractCalculationConfig();
            }
            var price = transportCalculationConfig.startAmount;
            if (self.locationTransport.distance) {
                price += self.locationTransport.distance * transportCalculationConfig.distanceAmount;
            }
            if (self.locationTransport.driverHours) {
                price += self.locationTransport.driverHours * transportCalculationConfig.hoursAmount;
            }
            if (self.locationTransport.additionalHours) {
                price += self.locationTransport.additionalHours * transportCalculationConfig.additionalHoursAmount;
            }
            if (self.locationTransport.additionalCost) {
                price += self.locationTransport.additionalCost;
            }
            if (transportCalculationConfig.minimumAmount && price < transportCalculationConfig.minimumAmount) {
                price = transportCalculationConfig.minimumAmount;
            }
            self.locationTransport.price = price;
        }

        function extractCalculationConfig() {
            var startAmountConfig = getConfigByName('TransportStartAmount');
            if (startAmountConfig && startAmountConfig.dataValueAsString) {
                transportCalculationConfig.startAmount = Number(startAmountConfig.dataValueAsString) || 0;
            }
            var distanceAmountConfig = getConfigByName('TransportDistanceAmount');
            if (distanceAmountConfig && distanceAmountConfig.dataValueAsString) {
                transportCalculationConfig.distanceAmount = Number(distanceAmountConfig.dataValueAsString) || 0;
            }
            var minimumAmountConfig = getConfigByName('TransportMinimalAmount');
            if (minimumAmountConfig && minimumAmountConfig.dataValueAsString) {
                transportCalculationConfig.minimumAmount = Number(minimumAmountConfig.dataValueAsString) || 0;
            }
            var hoursAmountConfig = getConfigByName('TransportHoursAmount');
            if (hoursAmountConfig && hoursAmountConfig.dataValueAsString) {
                transportCalculationConfig.hoursAmount = Number(hoursAmountConfig.dataValueAsString) || 0;
            }
            var additionalHoursAmountConfig = getConfigByName('TransportHoursAmount');
            if (additionalHoursAmountConfig && additionalHoursAmountConfig.dataValueAsString) {
                transportCalculationConfig.additionalHoursAmount = Number(additionalHoursAmountConfig.dataValueAsString) || 0;
            }
            transportCalculationConfig.isSet = true;
        }

        function getConfigByName(name) {
            if (!transportConfigs || transportConfigs.length === 0) return null;
            for (var i = 0; i < transportConfigs.length; i++) {
                var config = transportConfigs[i];
                if (config && config.name === name) {
                    return config;
                }
            }
            return null;
        }

        function isGeneralCollection() {
            return self.locationTransport.options & 32;
        }

        function isGeneralCremation() {
            return self.locationTransport.options & 64;
        }

        function isCremationTransport() {
            return self.locationTransport.options & 512;
        }

        function isGeneralDepartment() {
            return self.locationTransport.options & 1024;
        }

        function shouldNotCalculatePrice() {
            return self.locationTransport.options & 2;
        }

        function toggleShouldNotCalculatePrice() {
            if (self.locationTransport.options & 2) {
                self.locationTransport.options &= ~2;
            } else {
                self.locationTransport.options |= 2;
            }
        }

        function toggleGeneralDepartment() {
            if (self.locationTransport.options & 1024) {
                self.locationTransport.options &= ~1024;
            } else {
                self.locationTransport.options |= 1024;
                self.locationTransport.options &= ~32;
                self.locationTransport.options &= ~64;
                self.locationTransport.departureLocation = null;
                self.locationTransport.departureLocationId = null;
                self.locationTransport.departureLocationRemarks = null;
            }
        }

        function toggleCremationTransport() {
            if (self.locationTransport.options & 512) {
                self.locationTransport.options &= ~512;
            } else {
                self.locationTransport.options |= 512;
            }
        }

        function toggleGeneralCollection() {
            if (self.locationTransport.options & 32) {
                self.locationTransport.options &= ~32;
            } else {
                self.locationTransport.options |= 32;
                self.locationTransport.options &= ~1024;
                self.locationTransport.options &= ~64;
                self.locationTransport.departureLocation = null;
                self.locationTransport.departureLocationId = null;
                self.locationTransport.departureLocationRemarks = null;
            }
        }

        function toggleGeneralCremation() {
            if (self.locationTransport.options & 64) {
                self.locationTransport.options &= ~64;
            } else {
                self.locationTransport.options |= 64;
                self.locationTransport.options &= ~32;
                self.locationTransport.options &= ~1024;
                self.locationTransport.departureLocation = null;
                self.locationTransport.departureLocationId = null;
                self.locationTransport.departureLocationRemarks = null;
            }
        }

        function reset() {
            self.locationTransport = null;
            self.isNew = false;
            transportConfigs = null;
            transportCalculationConfig = {
                isSet: false,
                startAmount: 0,
                distanceAmount: 0,
                minimumAmount: 0,
                hoursAmount: 0,
                additionalHoursAmount: 0,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('EditLocationTransportController', EditLocationTransportController);

    /* @ngInject */
    function EditLocationTransportController($stateParams, $window, loadingService, editLocationTransportService) {
        var vm = this;
        vm.data = editLocationTransportService;

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editLocationTransportService.loadLocationTransport($stateParams.locationTransportId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editLocationTransportService.saveLocationTransport(vm.data.locationTransport).then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            })
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.settings').controller('EditProgramTypeController', EditProgramTypeController);

    /* @ngInject */
    function EditProgramTypeController($stateParams, $window, loadingService, dataLegacyService, baldrisApiBase, Upload, programService) {
        var dataService = dataLegacyService;
        var vm = this;

        vm.loadingService = loadingService;
        vm.removeImage = removeImage;
        vm.uploadImage = uploadImage;
        vm.removeTemplate = removeTemplate;
        vm.uploadTemplate = uploadTemplate;
        vm.isProcessing = false;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            if ($stateParams.programTypeId && $stateParams.programTypeId !== 'new') {
                dataService
                    .getById('ServiceSheetTypes', $stateParams.programTypeId, true)
                    .then(function (programType) {
                        vm.programType = programType;
                        vm.loadingService.setLoadingStatus(false);
                    })
                    .catch(function (message) {
                        vm.loadingService.setLoadingStatus(false);
                    });
            } else {
                vm.programType = programService.getEmptyProgramType();
                vm.programType.changeState = 1;
                vm.loadingService.setLoadingStatus(false);
            }
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setBackgroundLoadingStatus(true);
            vm.isProcessing = true;
            if (vm.programType.changeState === 1) {
                dataService
                    .insertItem('ServiceSheetTypes', vm.programType)
                    .then(function (insertedProgramType) {
                        exitView();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    })
                    .catch(function (message) {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    });
            } else {
                vm.programType.changeState = 2;
                dataService
                    .updateItem('ServiceSheetTypes', vm.programType)
                    .then(function (updatedItem) {
                        exitView();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    })
                    .catch(function (message) {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    });
            }
        }

        function removeImage() {
            vm.programType.previewImageUrl = null;
            vm.programType.previewImageId = null;
            vm.programType.changeState = 2;
            vm.validation.programTypeForm.$setDirty();
        }

        function uploadImage(file) {
            vm.loadingService.setBackgroundLoadingStatus(true);
            vm.isProcessing = true;
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        var baldrisFile = resp.data[0];
                        vm.programType.previewImageUrl = baldrisFile.url;
                        vm.programType.previewImageId = baldrisFile.id;
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    }
                },
                function (resp) {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                    vm.isProcessing = false;
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function removeTemplate() {
            vm.programType.templateFileUrl = null;
            vm.programType.templateFileId = null;
            vm.programType.changeState = 2;
            vm.validation.programTypeForm.$setDirty();
        }

        function uploadTemplate(file) {
            vm.loadingService.setBackgroundLoadingStatus(true);
            vm.isProcessing = true;
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        var baldrisFile = resp.data[0];
                        vm.programType.templateFileName = baldrisFile.name;
                        vm.programType.templateFileId = baldrisFile.id;
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isProcessing = false;
                    }
                },
                function (resp) {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                    vm.isProcessing = false;
                    console.log('Error status: ' + resp.status);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').service('editProgramStyleService', editProgramStyleService);

    /* @ngInject */
    function editProgramStyleService($q, $mdDialog, $document, dataLegacyService, programService) {
        var dataService = dataLegacyService;
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadProgramStyle = loadProgramStyle;
        self.saveProgramStyle = saveProgramStyle;
        self.openEditProgramSlotStyleDialog = openEditProgramSlotStyleDialog;

        function loadProgramStyle(programStyleId) {
            reset();
            if (!programStyleId || programStyleId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    programStyle: null,
                    slotStyles: [],
                };

                // Set ChangeStates
                self.updateModel.programStyle.changeState = 1;

                return $q.when(true);
            } else {
                return dataService.getUpdateModel('ProgramStyles', programStyleId).then(function (updateModel) {
                    self.updateModel = updateModel;

                    return true;
                });
            }
        }

        function saveProgramStyle() {
            // Set changestate on location to ensure saving
            if (self.updateModel.programStyle.changeState !== 1) {
                self.updateModel.programStyle.changeState = 2;
            }

            return dataService.updateFromUpdateModel('ProgramStyles', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                self.isNew = false;
                return true;
            });
        }

        function openEditProgramSlotStyleDialog(e, programSlotStyle) {
            var editModel;
            if (!programSlotStyle) {
                editModel = programService.getEmptyProgramSlotStyle();
                editModel.changeState = 1;
            } else {
                editModel = angular.copy(programSlotStyle);
            }
            $mdDialog
                .show({
                    controller: 'EditProgramSlotStyleDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/program/dialogs/edit-program-slot-style-dialog/edit-program-slot-style-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                    locals: {
                        programSlotStyle: editModel,
                    },
                })
                .then(function (updatedEditModel) {
                    if (updatedEditModel) {
                        if (!self.updateModel.slotStyles) self.updateModel.slotStyles = [];
                        var index = self.updateModel.slotStyles.indexOf(programSlotStyle);
                        if (updatedEditModel.changeState === 1) {
                            if (index > -1) {
                                self.updateModel.slotStyles.splice(index, 1);
                            }
                            self.updateModel.slotStyles.push(updatedEditModel);
                        } else {
                            if (index > -1) {
                                self.updateModel.slotStyles.splice(index, 1);
                            }
                            self.updateModel.slotStyles.push(updatedEditModel);
                        }
                        if (self.validation && self.validation.programStyleForm) {
                            self.validation.programStyleForm.$setDirty();
                        }
                    }
                });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('EditProgramStyleController', EditProgramStyleController);

    /* @ngInject */
    function EditProgramStyleController($stateParams, $window, loadingService, editProgramStyleService) {
        var vm = this;
        vm.data = editProgramStyleService;

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.getFontStyleDescription = getFontStyleDescription;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editProgramStyleService.loadProgramStyle($stateParams.programStyleId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editProgramStyleService.saveProgramStyle(vm.data.updateModel).then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            })
        }

        function getFontStyleDescription(serialized, object) {
            if (serialized) return serialized;
            if (!object) return null;
            return object.font + ' (' + object.style + ', ' + object.size + ' pts.)';
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.settings').controller('EditProgramSlotController', EditProgramSlotController);

    /* @ngInject */
    function EditProgramSlotController($stateParams, $window, loadingService, dataLegacyService, programService) {
        var dataService = dataLegacyService;
        var vm = this;

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            if ($stateParams.programSlotId && $stateParams.programSlotId !== 'new') {
                dataService
                    .getById('ProgramSlots', $stateParams.programSlotId, true)
                    .then(function (programSlot) {
                        vm.programSlot = programSlot;
                        vm.loadingService.setLoadingStatus(false);
                    })
                    .catch(function (message) {
                        vm.loadingService.setLoadingStatus(false);
                    });
            } else {
                vm.programSlot = programService.getEmptyProgramSlot();
                vm.programSlot.changeState = 1;
                vm.loadingService.setLoadingStatus(false);
            }
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setBackgroundLoadingStatus(true);
            if (vm.programSlot.changeState === 1) {
                dataService
                    .insertItem('ProgramSlots', vm.programSlot)
                    .then(function (insertedProgramSlot) {
                        exitView();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    })
                    .catch(function (message) {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    });
            } else {
                vm.programSlot.changeState = 2;
                dataService
                    .updateItem('ProgramSlots', vm.programSlot)
                    .then(function (updatedItem) {
                        exitView();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    })
                    .catch(function (message) {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.workOrder', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderToolbarController', WorkOrderToolbarController);


    /* @ngInject */
    function WorkOrderToolbarController(workOrderViewService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;

        vm.currentData = workOrderViewService.currentData;
        vm.service = workOrderViewService;
    }

})();


(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderOptionsToolbarController', WorkOrderOptionsToolbarController);

    /* @ngInject */
    function WorkOrderOptionsToolbarController(workOrderViewService, workOrderOptionsService, loadingService, $window) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderOptionsService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            workOrderOptionsService.saveOptions().then(function (workOrderDto) {
                // Update currentData with updated data
                vm.service.currentData.workOrder.orderCode = workOrderDto.orderCode;
                vm.service.currentData.workOrder.options = workOrderDto.options;
                vm.service.currentData.workOrder.workOrderTypeId = workOrderDto.workOrderTypeId;
                vm.service.currentData.workOrder.workOrderTypeName = workOrderDto.workOrderTypeName;
                vm.service.currentData.workOrder.caseWorkerId = workOrderDto.caseWorkerId;
                vm.service.currentData.workOrder.caseWorkerDisplayName = workOrderDto.caseWorkerDisplayName;
                vm.service.currentData.workOrder.departmentId = workOrderDto.departmentId;
                vm.service.currentData.workOrder.departmentOrganizationDisplayName = workOrderDto.departmentOrganizationDisplayName;
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
  'use strict';

  angular
      .module('app.workOrder')
      .controller('WorkOrderConsignmentsSidebarController', WorkOrderConsignmentsSidebarController);

  /* @ngInject */
  function WorkOrderConsignmentsSidebarController() {
      var vm = this;

  }
})();
(function () {
    'use strict';

    angular.module('app.settings').controller('LocationTransportsController', LocationTransportsController);

    /* @ngInject */
    function LocationTransportsController(loadingService, dataLegacyService, $state) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.locationTransports = [];

        vm.loadingService = loadingService;
        vm.addLocationTransport = addLocationTransport;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService
                .getAll('LocationTransports')
                .then(function (locationTransports) {
                    vm.locationTransports = locationTransports;
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.locationTransports = [];
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function addLocationTransport(e) {
            $state.go('app.configuration.transportSettings.locationTransportById', { locationTransportId: 'new' });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('TransportGeneralSettingsController', TransportGeneralSettingsController);

    /* @ngInject */
    function TransportGeneralSettingsController(loadingService, dataLegacyService, $scope, $translate, $window, baldrisConfigService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.baldrisConfigs = [];
        vm.labelTextMap = {
            TransportAdditionalHoursAmount: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.ADDITIONAL_HOURS_AMOUNT',
            TransportDistanceAmount: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.DISTANCE_AMOUNT',
            TransportHoursAmount: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.HOURS_AMOUNT',
            TransportMinimalAmount: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.MINIMAL_AMOUNT',
            TransportStartAmount: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.START_AMOUNT',
            TransportDestinationLocationType: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.DESTINATION_LOCATION_TYPE',
            TransportByLookupStringType: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.TRANSPORT_BY_LOOKUP_STRING_TYPE',
            TransportExcludingVat: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.TRANSPORT_EXCLUDING_VAT',
            TransportIncludingVat: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.TRANSPORT_INCLUDING_VAT',
            FamilyIndividualShare: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.FAMILY_INDIVIDUAL_SHARE',
            ShouldRestrictTransportSuggestions: 'SETTINGS.TRANSPORT_SETTINGS.GENERAL_SETTINGS.SHOULD_RESTRICT_TRANSPORT_SUGGESTIONS',
        };
        vm.isCurrencyMap = {
            TransportAdditionalHoursAmount: true,
            TransportDistanceAmount: true,
            TransportHoursAmount: true,
            TransportMinimalAmount: true,
            TransportStartAmount: true,
        };

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.onValueChanged = onValueChanged;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            baldrisConfigService
                .getByCategory('Transport', true)
                .then(function (baldrisConfigs) {
                    vm.baldrisConfigs = baldrisConfigs;
                    var idString = _.reduce(
                        vm.baldrisConfigs,
                        function (acc, n) {
                            if (acc) return acc + ',' + n.customFieldDataId;
                            return n.customFieldDataId;
                        },
                        ''
                    );
                    return dataService
                        .getPaginatedItems('CustomFieldData', 10, 0, idString, true)
                        .then(function (customFieldData) {
                            _.forEach(vm.baldrisConfigs, function (bc) {
                                bc.customFieldData = _.find(customFieldData, {
                                    id: bc.customFieldDataId,
                                });
                            });
                            vm.loadingService.setLoadingStatus(false);
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                })
                .catch(function (error) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function onValueChanged(baldrisConfig) {
            if (baldrisConfig) {
                if (baldrisConfig.id === '00000000-0000-0000-0000-000000000000') {
                    baldrisConfig.changeState = 1;
                } else {
                    baldrisConfig.changeState = 2;
                }
                if (baldrisConfig.customFieldData) {
                    if (baldrisConfig.customFieldData.id === '00000000-0000-0000-0000-000000000000') {
                        baldrisConfig.customFieldData.changeState = 1;
                    } else {
                        baldrisConfig.customFieldData.changeState = 2;
                    }
                }
                console.log("BaldrisConfig '" + baldrisConfig.name + "' changed");
            }
        }

        function exitView() {
            if (vm.generalSettingsForm && vm.generalSettingsForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.generalSettingsForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            }
        }

        function saveAndExitView() {
            if (vm.baldrisConfigs && vm.baldrisConfigs.length > 0) {
                vm.loadingService.setLoadingStatus(true);
                var updateList = [];
                for (var index = 0; index < vm.baldrisConfigs.length; index++) {
                    var baldrisConfig = vm.baldrisConfigs[index];
                    if (baldrisConfig.customFieldData && baldrisConfig.customFieldData.changeState !== 0) {
                        updateList.push(baldrisConfig.customFieldData);
                    }
                }
                if (updateList.length > 0) {
                    dataService
                        .bulkUpdate('CustomFieldData', updateList)
                        .then(function (updatedItems) {
                            if (vm.generalSettingsForm && vm.generalSettingsForm.$dirty) {
                                vm.generalSettingsForm.$setPristine();
                            }
                            // Invalidate caching -> quickfix: invalidate baldrisConfigCache && lookupstrings-transporttylookupstringtype && locations-transportdestinationlocationtype regardless of what's been changed
                            baldrisConfigService.invalidateCache();
                            dataService.invalidateCache('LookupStrings', 'TransportByLookupStringType');
                            dataService.invalidateCache('Locations', 'TransportDestinationLocationType');
                            exitView();
                            vm.loadingService.setLoadingStatus(false);
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                } else {
                    exitView();
                }
            } else {
                exitView();
            }
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (vm.generalSettingsForm && vm.generalSettingsForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                } else {
                    event.preventDefault();
                    vm.loadingService.setBackgroundLoadingStatus(false);
                }
            }
        });
    }
})();

(function() {
  "use strict";

  angular.module("app.settings").controller("ConfigurationReferenceTypeViewController", ConfigurationReferenceTypeViewController);

  /* @ngInject */
  function ConfigurationReferenceTypeViewController(
    $q,
    $compile,
    $scope,
    $mdDialog,
    $document,
    $stateParams,
    $translate,
    gravatarService,
    settingsReferenceTypes,
    DTColumnBuilder,
    referenceList,
    configurationReferenceTypesService,
    datatableService
  ) {
    var vm = this;
    vm.referenceList = referenceList;
    vm.currentData = configurationReferenceTypesService.currentData;
    vm.currentData.referenceList = referenceList;
    vm.selectedReferences = [];

    // Methods
    vm.getPrimaryText = getPrimaryText;
    vm.getSecondaryText = getSecondaryText;
    vm.getImagepath = getImagepath;
    vm.getIconName = getIconName;
    vm.toggleSelectedReferenceId = toggleSelectedReferenceId;
    vm.toggleSelectAll = toggleSelectAll;
    vm.idExists = idExists;
    vm.getGravatarText = getGravatarText;

    // INIT

    // Get selectedReferenceType
    var selectedReferenceType = null;
    for (var index = 0; index < settingsReferenceTypes.length; index++) {
      var referenceType = settingsReferenceTypes[index];
      if (referenceType.route === $stateParams.routeId) {
        selectedReferenceType = referenceType;
        break;
      }
    }

    vm.dtInstance = {};
    vm.dtOptions = datatableService
      .getLocalizedOptionsWithPromise(getPromise())
      .withPaginationType("simple")
      .withDisplayLength(50)
      .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
      .withOption("lengthMenu", [10, 20, 30, 50, 100, 200])
      .withOption("responsive", true)
      .withOption("scrollY", "auto")
      .withOption("initComplete", function() {
        var api = this.api(),
          searchBox = angular.element("body").find("#reference-list-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function(event) {
            api.search(event.target.value).draw();
          });
        }
      })
      .withOption("createdRow", function(row, data, dataIndex) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
      })
      .withOption("headerCallback", function(header) {
        if (!vm.headerCompiled) {
          // Use this headerCompiled field to only compile header once
          vm.headerCompiled = true;
          $compile(angular.element(header).contents())($scope);
        }
      })
      .withOption("rowCallback", function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $("td", nRow).unbind("click");
        $("td", nRow).bind("click", function() {
          $scope.$apply(function() {
            openEditDialog(aData);
          });
        });
        $("td", nRow).addClass("clickable");
        if (aData[selectedReferenceType["deletedPath"]]) {
          $("td", nRow).addClass("is-deleted");
        }
        return nRow;
      });

    vm.dtColumnDefs = [
      {
        // Target the checkbox column
        targets: 0,
        filterable: false,
        sortable: false,
        width: "50px"
      }
    ];

    vm.dtColumns = [
      DTColumnBuilder.newColumn(null)
        .withTitle('<md-checkbox ng-checked="vm.currentData.selectedReferences.length > 0" ng-click="vm.toggleSelectAll()" aria-label="{{}}"></md-checkbox>')
        .notSortable()
        .renderWith(function(data, type, full, meta) {
          return (
            "<md-checkbox ng-checked=\"vm.idExists('" +
            data.id +
            "', vm.currentData.selectedReferences)\"  ng-click=\"vm.toggleSelectedReferenceId('" +
            data.id +
            "', $event)\"  aria-label=\"{{vm.idExists('" +
            data.id +
            "', vm.currentData.selectedReferences) ? 'Deselect' : 'Select'}}\"></md-checkbox>"
          );
        })
    ];

    var imageMarkup = '<img class="md-avatar" alt="<PRIMARY_TEXT>" src="<IMAGE_PATH>?preset=baldris-thumb-40"/>';
    var gravatarMarkup = '<img class="md-avatar" src="<GRAVATAR_TEXT>" alt="<PRIMARY_TEXT>">';
    var iconMarkup = '<div class="avatar-icon">' + '    <md-icon md-font-icon="<ICON_NAME>" class="s24">' + "    </md-icon>" + "</div>";

    if (selectedReferenceType.imagePath || selectedReferenceType.iconPath) {
      vm.dtColumnDefs.push({
        // Target the image column
        targets: 1,
        filterable: false,
        sortable: false,
        width: "63px"
      });
      vm.dtOptions = vm.dtOptions.withOption("order", [[2, "asc"]]);

      vm.dtColumns.push(
        DTColumnBuilder.newColumn(selectedReferenceType.secondaryPath)
          .withTitle("")
          .notSortable()
          .renderWith(function(data, type, full, meta) {
            if (getImagepath(full)) {
              return imageMarkup
                .split("<IMAGE_PATH>")
                .join(getImagepath(full))
                .split("<PRIMARY_TEXT>");
            }
            if (getGravatarText(full)) {
              return gravatarMarkup
                .split("<GRAVATAR_TEXT>")
                .join(gravatarService.url(getGravatarText(full)))
                .split("<PRIMARY_TEXT>");
            }
            return iconMarkup.split("<ICON_NAME>").join(getIconName(full));
          })
      );
    } else {
      vm.dtOptions = vm.dtOptions.withOption("order", [[1, "asc"]]);
    }

    vm.dtColumns.push(DTColumnBuilder.newColumn(selectedReferenceType.primaryPath).withTitle($translate.instant(selectedReferenceType.primaryTitle)));

    if (selectedReferenceType.secondaryPath) {
      vm.dtColumns.push(DTColumnBuilder.newColumn(selectedReferenceType.secondaryPath).withTitle($translate.instant(selectedReferenceType.secondaryTitle)));
    }

    // Private Methods

    function typeHasImageOrGravatar(referenceType) {}

    function getPrimaryText(reference) {
      if (reference && selectedReferenceType) {
        return reference[selectedReferenceType["primaryPath"]];
      }
      return "";
    }

    function getSecondaryText(reference) {
      if (reference && selectedReferenceType && selectedReferenceType.secondaryPath && angular.isDefined(reference[selectedReferenceType["secondaryPath"]])) {
        return reference[selectedReferenceType["secondaryPath"]] || "";
      }
      return "";
    }

    function getImagepath(reference) {
      if (reference && selectedReferenceType && selectedReferenceType.imagePath && angular.isDefined(reference[selectedReferenceType["imagePath"]])) {
        return reference[selectedReferenceType["imagePath"]] || "";
      }
      return "";
    }

    function getGravatarText(reference) {
      if (reference && selectedReferenceType && selectedReferenceType.gravatarPath && angular.isDefined(reference[selectedReferenceType["gravatarPath"]])) {
        return reference[selectedReferenceType["gravatarPath"]] || getPrimaryText(reference);
      }
      return "";
    }

    function getIconName(reference) {
      if (reference && selectedReferenceType && selectedReferenceType.iconPath && angular.isDefined(reference[selectedReferenceType["iconPath"]])) {
        return reference[selectedReferenceType["iconPath"]] || selectedReferenceType.fallbackPath || "";
      }
      return selectedReferenceType.fallbackPath || "";
    }

    function toggleSelectedReferenceId(id, e) {
      if (!id) return;
      var selectedReferenceIndex = -1;
      for (var index = 0; index < vm.currentData.selectedReferences.length; index++) {
        var element = vm.currentData.selectedReferences[index];
        if (element && element.id && element.id === id) {
          selectedReferenceIndex = index;
          break;
        }
      }
      if (selectedReferenceIndex > -1) {
        vm.currentData.selectedReferences.splice(selectedReferenceIndex, 1);
      } else {
        var selectedReference = getReferenceById(id);
        if (selectedReference) {
          vm.currentData.selectedReferences.push(selectedReference);
        }
      }
    }

    function toggleSelectAll() {
      if (vm.currentData.selectedReferences.length === 0) {
        // Check if we have filtered data
        if (vm.dtInstance.DataTable.rows({ filter: "applied" }).nodes().length != vm.referenceList.length) {
          var filteredData = vm.dtInstance.DataTable.rows({ filter: "applied" }).data();
          if (filteredData.length > 0) {
            vm.currentData.selectedReferences = [];
            for (var index = 0; index < filteredData.length; index++) {
              var element = filteredData[index];
              if (element) {
                vm.currentData.selectedReferences.push(element);
              }
            }
          }
        } else {
          vm.currentData.selectedReferences = vm.referenceList.slice();
        }
      } else {
        vm.currentData.selectedReferences = [];
      }
    }

    function getReferenceById(id) {
      if (!id || !vm.referenceList || vm.referenceList.length === 0) return null;
      for (var index = 0; index < vm.referenceList.length; index++) {
        var reference = vm.referenceList[index];
        if (reference && reference.id && reference.id === id) {
          return reference;
        }
      }
      return null;
    }

    function idExists(id, collection) {
      if (!id || !collection || collection.length === 0) return false;
      for (var index = 0; index < collection.length; index++) {
        var element = collection[index];
        if (element && element.id && element.id === id) {
          return true;
        }
      }

      return false;
    }

    function getPromise() {
      return $q.when(vm.referenceList);
    }

    function openEditDialog(reference) {
      return $mdDialog
        .show({
          controller: "ReferenceTypeQuickEditDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/settings/dialogs/reference-type-quick-edit-dialog/reference-type-quick-edit-dialog.tmpl.html",
          parent: angular.element($document.body),
          targetEvent: null,
          locals: {
            referenceId: reference.id,
            referenceDeclaration: selectedReferenceType
          },
          clickOutsideToClose: true
        })
        .then(function(updateReference) {
          if (updateReference) {
            var index = vm.referenceList.indexOf(reference);
            vm.referenceList.splice(index, 1);
            vm.referenceList.push(updateReference);
            vm.dtInstance.changeData(getPromise());
          }
          return updateReference;
        });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ProgramTypesController', ProgramTypesController);

    /* @ngInject */
    function ProgramTypesController(loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.programTypes = [];

        vm.loadingService = loadingService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService
                .getAll('ServiceSheetTypes')
                .then(function (programTypes) {
                    vm.programTypes = programTypes;
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.programTypes = [];
                    vm.loadingService.setLoadingStatus(false);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ProgramStylesController', ProgramStylesController);

    /* @ngInject */
    function ProgramStylesController(loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.programStyles = [];

        vm.loadingService = loadingService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService
                .getAll('ProgramStyles')
                .then(function (programStyles) {
                    vm.programStyles = programStyles;
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.programStyles = [];
                    vm.loadingService.setLoadingStatus(false);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ProgramSlotsController', ProgramSlotsController);

    /* @ngInject */
    function ProgramSlotsController(loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.programSlots = [];

        vm.loadingService = loadingService;
        vm.getSlotIcon = getSlotIcon;
        vm.getDataTypeText = getDataTypeText;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService
                .getAll('ProgramSlots')
                .then(function (programSlots) {
                    vm.programSlots = programSlots;
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.programSlots = [];
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function getSlotIcon(programSlot) {
            switch (programSlot.dataType) {
                case 0:
                case 10:
                    return 'icon icon-comment-text';
                case 1:
                    return 'icon icon-format-list-numbers';
                case 2:
                case 3:
                    return 'icon icon-numeric';
                case 4:
                    return 'icon icon-timetable';
                case 5:
                    return 'icon icon-check-circle';
                case 6:
                case 9:
                    return 'icon icon-book-multiple';
                case 7:
                    return 'icon icon-microphone';
                case 8:
                    return 'icon icon-music-note';
                default:
                    return 'icon icon-comment-text';
            }
        }

        function getDataTypeText(programSlot) {
            switch (programSlot.dataType) {
                case 0:
                case 10:
                    return 'PROGRAMS.DATA_TYPE.STRING';
                case 1:
                    return 'PROGRAMS.DATA_TYPE.LOOKUP_STRING';
                case 2:
                    return 'PROGRAMS.DATA_TYPE.LONG';
                case 3:
                    return 'PROGRAMS.DATA_TYPE.DECIMAL';
                case 4:
                    return 'PROGRAMS.DATA_TYPE.DATE_TIME';
                case 5:
                    return 'PROGRAMS.DATA_TYPE.BOOLEAN';
                case 6:
                    return 'PROGRAMS.DATA_TYPE.SONG';
                case 9:
                    return 'PROGRAMS.DATA_TYPE.PRAYER';
                case 7:
                    return 'PROGRAMS.DATA_TYPE.SOLO';
                case 8:
                    return 'PROGRAMS.DATA_TYPE.MUSIC';
                default:
                    return 'PROGRAMS.DATA_TYPE.STRING';
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('LocationListController', LocationListController);

    /* @ngInject */
    function LocationListController($stateParams, $state, $filter, locationConfigService, loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.data = locationConfigService;
        vm.loadingService = loadingService;

        vm.editLocation = editLocation;

        activate();

        function activate() {
            locationConfigService.currentLocations = [];

            if ($stateParams.locationType) {
                locationConfigService.selectedLocationType = $stateParams.locationType;
            }

            vm.loadingService.setLoadingStatus(true);
            dataService.getByTypeId('Locations', $stateParams.locationTypeId).then(function (locations) {
                locations = $filter('filter')(locations, { isDeleted: false });
                vm.locations = $filter('orderBy')(locations, 'name');
                locationConfigService.currentLocations = vm.locations;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function editLocation(location) {
            if (location) {
                $state.go('app.configuration.locations.editLocation', {
                    locationId: location.id,
                });
            }
        }
    }

    angular.module('app.settings').controller('LocationListToolbarController', LocationListToolbarController);

    /* @ngInject */
    function LocationListToolbarController($state, $filter, $mdSidenav, locationConfigService, currentUser) {
        var vm = this;
        vm.data = locationConfigService;

        activate();

        function activate() {
            // Check for current state
            if ($state.params && $state.params.searchString) {
                vm.data.searchString = $state.params.searchString;
            }
        }

        vm.toggleSidenav = toggleSidenav;

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('InvoiceTransferSettingsController', InvoiceTransferSettingsController);

    /* @ngInject */
    function InvoiceTransferSettingsController(loadingService, dataLegacyService, $scope, $translate, $window, baldrisConfigService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.baldrisConfigs = [];
        vm.labelTextMap = {
            AllowPaidTrackableEmails: 'SETTINGS.INVOICE_SETTINGS.TRANSFER_SETTINGS.ALLOW_PAID_TRACKABLE_EMAILS',
            AllowPaidMultiChannel: 'SETTINGS.INVOICE_SETTINGS.TRANSFER_SETTINGS.ALLOW_PAID_MULTI_CHANNEL',
        };
        vm.isCurrencyMap = {
            InvoiceDueFee: true,
            ExpeditionFee: true,
        };
        vm.customFieldWhiteList = ['AllowPaidTrackableEmails', 'AllowPaidMultiChannel'];

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.getConfigByName = getConfigByName;
        vm.saveView = saveView;
        vm.onValueChanged = onValueChanged;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            baldrisConfigService
                .getByCategory('Invoice', true)
                .then(function (baldrisConfigs) {
                    vm.baldrisConfigs = baldrisConfigs;
                    var idString = '';
                    // Get CustomFieldDataIds from white listed fields
                    var whiteListedConfigs = _.filter(vm.baldrisConfigs, function (bc) {
                        return _.indexOf(vm.customFieldWhiteList, bc.name) > -1;
                    });
                    var idString = _.reduce(
                        whiteListedConfigs,
                        function (acc, n) {
                            if (acc) return acc + ',' + n.customFieldDataId;
                            return n.customFieldDataId;
                        },
                        ''
                    );
                    return dataService
                        .getPaginatedItems('CustomFieldData', 10, 0, idString, true)
                        .then(function (customFieldData) {
                            _.forEach(whiteListedConfigs, function (bc) {
                                bc.customFieldData = _.find(customFieldData, { id: bc.customFieldDataId });
                            });
                            vm.loadingService.setLoadingStatus(false);
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                })
                .catch(function (error) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function getConfigByName(configName) {
            if (!configName || !vm.baldrisConfigs || vm.baldrisConfigs.length === 0) return null;
            var config = _.find(vm.baldrisConfigs, { name: configName });
            return config;
        }

        function onValueChanged(baldrisConfig) {
            if (baldrisConfig) {
                if (baldrisConfig.id === '00000000-0000-0000-0000-000000000000') {
                    baldrisConfig.changeState = 1;
                } else {
                    baldrisConfig.changeState = 2;
                }
                if (baldrisConfig.customFieldData) {
                    if (baldrisConfig.customFieldData.id === '00000000-0000-0000-0000-000000000000') {
                        baldrisConfig.customFieldData.changeState = 1;
                    } else {
                        baldrisConfig.customFieldData.changeState = 2;
                    }
                }
                console.log("BaldrisConfig '" + baldrisConfig.name + "' changed");
            }
        }

        function saveView() {
            if (vm.baldrisConfigs && vm.baldrisConfigs.length > 0) {
                vm.loadingService.setLoadingStatus(true);
                var updateList = [];
                for (var index = 0; index < vm.baldrisConfigs.length; index++) {
                    var baldrisConfig = vm.baldrisConfigs[index];
                    if (baldrisConfig.customFieldData && baldrisConfig.customFieldData.changeState !== 0) {
                        updateList.push(baldrisConfig.customFieldData);
                    }
                }
                if (updateList.length > 0) {
                    dataService
                        .bulkUpdate('CustomFieldData', updateList)
                        .then(function (updatedItems) {
                            if (vm.tranferSettingsForm && vm.tranferSettingsForm.$dirty) {
                                vm.tranferSettingsForm.$setPristine();
                            }
                            // Invalidate caching -> quickfix: invalidate baldrisConfigCache
                            baldrisConfigService.invalidateCache();
                            vm.baldrisConfigs = [];
                            activate();
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                } else {
                    activate();
                }
            } else {
                activate();
            }
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (vm.tranferSettingsForm && vm.tranferSettingsForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                } else {
                    event.preventDefault();
                    vm.loadingService.setBackgroundLoadingStatus(false);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('InvoiceGeneralSettingsController', InvoiceGeneralSettingsController);

    /* @ngInject */
    function InvoiceGeneralSettingsController(loadingService, dataLegacyService, $scope, $translate, $window, baldrisConfigService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.baldrisConfigs = [];
        vm.labelTextMap = {
            CollectionDueText: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.COLLECTION_DUE_TEXT',
            CremationGrantProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CREMATION_GRANT_PRODUCT',
            CustomerPartyType: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CUSTOMER_PARTY_TYPE',
            DecimalRoundingProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.DECIMAL_ROUNDING_PRODUCT',
            DiscountProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.DISCOUNT_PRODUCT',
            ExpeditionFee: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.EXPEDITION_FEE',
            FuneralGrantProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.FUNERAL_GRANT_PRODUCT',
            InterestProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INTEREST_PRODUCT',
            InvoiceCollectionOffset: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_COLLECTION_OFFSET',
            InvoiceDueFee: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_DUE_FEE',
            InvoiceDueInterest: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_DUE_INTEREST',
            InvoiceDueOffset: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_DUE_OFFSET',
            InvoiceDueText: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_DUE_TEXT',
            InvoiceFileType: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_FILE_TYPE',
            InvoiceIdentificationConfigOrder: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_IDENTIFICATION_CONFIG_ORDER',
            InvoiceIdentificationCustomerLength: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_IDENTIFICATION_CUSTOMER_LENGTH',
            InvoiceIdentificationInvoiceLength: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_IDENTIFICATION_INVOICE_LENGTH',
            InvoiceJournalWriter: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_JOURNAL_WRITER',
            InvoiceReminderOffset: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_REMINDER_OFFSET',
            InvoiceTermsText: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.INVOICE_TERMS_TEXT',
            LastCustomerNumber: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.LAST_CUSTOMER_NUMBER',
            LastInvoiceNumber: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.LAST_INVOICE_NUMBER',
            LastReturningCustomerNumber: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.LAST_RETURNING_CUSTOMER_NUMBER',
            OverdueFeeProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.OVERDUE_FEE_PRODUCT',
            PrepaidAmountProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.PREPAID_AMOUNT_PRODUCT',
            TransportGrantProduct: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.TRANSPORT_GRANT_PRODUCT',
            UseDecimalRounding: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.USE_DECIMAL_ROUNDING',
            UseInvoiceIdentificationSystem: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.USE_INVOICE_IDENTIFICATION_SYSTEM',
            UseYearPrefix: 'SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.USE_YEAR_PREFIX',
        };
        vm.isCurrencyMap = {
            InvoiceDueFee: true,
            ExpeditionFee: true,
        };
        vm.customFieldWhiteList = [
            'InvoiceDueFee',
            'InvoiceDueInterest',
            'InvoiceTermsText',
            'InvoiceDueOffset',
            'UseInvoiceIdentificationSystem',
            'InvoiceIdentificationConfigOrder',
            'InvoiceIdentificationCustomerLength',
            'InvoiceIdentificationInvoiceLength',
            'UseYearPrefix',
            'InvoiceJournalWriter',
            'UseDecimalRounding',
            'DecimalRoundingProduct',
        ];

        vm.exportFileTypes = [
            {
                value: 'xledger',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.XLEDGER',
                extension: 'csv',
            },
            {
                value: 'vismaglobal',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.VISMA_GLOBAL',
                extension: 'csv',
            },
            {
                value: 'mamut',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.MAMUT',
                extension: 'csv',
            },
            {
                value: 'vismabusiness',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.VISMA_BUSINESS',
                extension: 'txt',
            },
            {
                value: 'generic',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.GENERIC',
                extension: 'csv',
            },
            {
                value: 'pdf',
                text: 'SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.PDF',
                extension: 'pdf',
            },
        ];

        vm.loadingService = loadingService;

        activate();

        // Methods
        vm.getConfigByName = getConfigByName;
        vm.saveView = saveView;
        vm.onValueChanged = onValueChanged;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            baldrisConfigService
                .getByCategory('Invoice', true)
                .then(function (baldrisConfigs) {
                    vm.baldrisConfigs = baldrisConfigs;
                    var idString = '';
                    // Get CustomFieldDataIds from white listed fields
                    var whiteListedConfigs = _.filter(vm.baldrisConfigs, function (bc) {
                        return _.indexOf(vm.customFieldWhiteList, bc.name) > -1;
                    });
                    var idString = _.reduce(
                        whiteListedConfigs,
                        function (acc, n) {
                            if (acc) return acc + ',' + n.customFieldDataId;
                            return n.customFieldDataId;
                        },
                        ''
                    );
                    return dataService
                        .getPaginatedItems('CustomFieldData', 10, 0, idString, true)
                        .then(function (customFieldData) {
                            _.forEach(whiteListedConfigs, function (bc) {
                                bc.customFieldData = _.find(customFieldData, { id: bc.customFieldDataId });
                            });
                            vm.loadingService.setLoadingStatus(false);
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                })
                .catch(function (error) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function getConfigByName(configName) {
            if (!configName || !vm.baldrisConfigs || vm.baldrisConfigs.length === 0) return null;
            return _.find(vm.baldrisConfigs, { name: configName });
        }

        function onValueChanged(baldrisConfig) {
            if (baldrisConfig) {
                if (baldrisConfig.id === '00000000-0000-0000-0000-000000000000') {
                    baldrisConfig.changeState = 1;
                } else {
                    baldrisConfig.changeState = 2;
                }
                if (baldrisConfig.customFieldData) {
                    if (baldrisConfig.customFieldData.id === '00000000-0000-0000-0000-000000000000') {
                        baldrisConfig.customFieldData.changeState = 1;
                    } else {
                        baldrisConfig.customFieldData.changeState = 2;
                    }
                }
                console.log("BaldrisConfig '" + baldrisConfig.name + "' changed");
            }
        }

        function saveView() {
            if (vm.baldrisConfigs && vm.baldrisConfigs.length > 0) {
                vm.loadingService.setLoadingStatus(true);
                var updateList = [];
                for (var index = 0; index < vm.baldrisConfigs.length; index++) {
                    var baldrisConfig = vm.baldrisConfigs[index];
                    if (baldrisConfig.customFieldData && baldrisConfig.customFieldData.changeState !== 0) {
                        updateList.push(baldrisConfig.customFieldData);
                    }
                }
                if (updateList.length > 0) {
                    dataService
                        .bulkUpdate('CustomFieldData', updateList)
                        .then(function (updatedItems) {
                            if (vm.generalSettingsForm && vm.generalSettingsForm.$dirty) {
                                vm.generalSettingsForm.$setPristine();
                            }
                            // Invalidate caching -> quickfix: invalidate baldrisConfigCache && lookupstrings-transporttylookupstringtype && locations-transportdestinationlocationtype regardless of what's been changed
                            baldrisConfigService.invalidateCache();
                            dataService.invalidateCache('LookupStrings', 'TransportByLookupStringType');
                            dataService.invalidateCache('Locations', 'TransportDestinationLocationType');
                            vm.baldrisConfigs = [];
                            activate();
                        })
                        .catch(function (error) {
                            vm.loadingService.setLoadingStatus(false);
                        });
                } else {
                    activate();
                }
            } else {
                activate();
            }
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (vm.generalSettingsForm && vm.generalSettingsForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                } else {
                    event.preventDefault();
                    vm.loadingService.setBackgroundLoadingStatus(false);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('LegalUnitConfigEditController', LegalUnitConfigEditController);

    /* @ngInject */
    function LegalUnitConfigEditController(
        $q,
        $stateParams,
        $mdToast,
        $translate,
        loadingService,
        dataLegacyService,
        addressService,
        locationService,
        legalUnit,
        organization
    ) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.loadingService = loadingService;
        vm.organization = angular.copy(organization);
        vm.legalUnit = angular.copy(legalUnit);
        vm.hasChanges = false;
        vm.updateModel = {
            legalUnit: angular.copy(legalUnit),
            organization: angular.copy(organization),
            location: null,
            postAddress: null,
            streetAddress: null,
        };
        vm.postAddress = [];
        vm.streetAddress = [];
        vm.initialized = false;

        vm.getBackgroundImage = getBackgroundImage;
        vm.onAddressChanged = onAddressChanged;
        vm.onLegalUnitChanged = onLegalUnitChanged;
        vm.submitLegalUnit = submitLegalUnit;

        activate();

        function activate() {
            if ($stateParams.legalUnitId === 'new') {
                vm.updateModel.location = locationService.getEmptyLocation();
                createPostAddress();
                createStreetAddress();
                vm.initialized = true;
            } else {
                var promises = [];
                vm.loadingService.setLoadingStatus(true);
                if (legalUnit.locationId) promises.push(dataService.getById('Locations', legalUnit.locationId, true));
                if (legalUnit.postAddressId) promises.push(dataService.getById('Addresses', legalUnit.postAddressId, true));
                promises.push(dataService.getAll('AddressTypes'));
                promises.push(dataService.getByPartyId('Emails', organization.id, true));
                promises.push(dataService.getByPartyId('Telephones', organization.id, true));
                $q.all(promises).then(function (response) {
                    if (legalUnit.locationId) {
                        vm.updateModel.location = response[0];
                        if (legalUnit.postAddressId) {
                            vm.updateModel.postAddress = response[1];
                            vm.postAddress.push(vm.updateModel.postAddress);
                            vm.addressTypes = response[2];
                        } else {
                            vm.addressTypes = response[1];
                            createPostAddress();
                        }
                        if (vm.updateModel.location.addressId) {
                            dataService.getById('Addresses', vm.updateModel.location.addressId, true).then(function (streetAddress) {
                                vm.updateModel.streetAddress = streetAddress;
                                vm.streetAddress.push(vm.updateModel.streetAddress);
                                vm.loadingService.setLoadingStatus(false);
                                vm.initialized = true;
                            });
                        } else {
                            vm.loadingService.setLoadingStatus(false);
                            vm.initialized = true;
                            createStreetAddress();
                        }
                    } else {
                        if (legalUnit.postAddressId) {
                            vm.updateModel.postAddress = response[0];
                            vm.postAddress.push(vm.updateModel.postAddress);
                            vm.addressTypes = response[1];
                        } else {
                            vm.addressTypes = response[0];
                            createPostAddress();
                        }
                        vm.loadingService.setLoadingStatus(false);
                        vm.initialized = true;
                    }
                    vm.updateModel.emails = response[response.length - 2];
                    vm.updateModel.telephones = response[response.length - 1];
                });
            }
        }

        function saveChanges() {
            vm.loadingService.setLoadingStatus(true);
            return dataService.updateFromUpdateModel('LegalUnits', vm.updateModel).then(function (response) {
                vm.loadingService.setLoadingStatus(false);
                vm.hasChanges = false;
                vm.updateModel = response;
                vm.legalUnit = response.legalUnit;
                vm.organization = response.organization;
                dataService.invalidateCache('LegalUnits');
                return response;
            });
        }

        function submitLegalUnit(legalUnit, organization) {
            vm.updateModel.legalUnit = legalUnit;
            vm.updateModel.organization = organization;
            saveChanges().then(function () {
                hideUnsavedChangesToast();
            });
        }

        function onLegalUnitChanged(dtoModel) {
            if (dtoModel) {
                if (dtoModel.$type.indexOf('Organization') > -1) {
                    vm.updateModel.organization = dtoModel;
                    showUnsavedChangesToast();
                } else if (dtoModel.$type.indexOf('LegalUnit') > -1) {
                    vm.updateModel.legalUnit = dtoModel;
                    showUnsavedChangesToast();
                }
            }
        }

        function onAddressChanged(action, dtoModel) {
            if (action === 'change') {
                showUnsavedChangesToast();
            }
        }

        function showUnsavedChangesToast() {
            if (!vm.hasChanges && vm.editableContentForm.$valid) {
                vm.hasChanges = true;
                var toast = $mdToast
                    .simple()
                    .textContent($translate.instant('COMMON.DATA.YOU_HAVE_UNSAVED_CHANGES'))
                    .actionKey('s')
                    .actionHint($translate.instant('COMMON.DATA.PRESS_CTR_S_TO'))
                    .action($translate.instant('COMMON.DATA.SAVE'))
                    .dismissHint($translate.instant('COMMON.DATA.ACTIVATE_ESCAPE_KEY'))
                    .highlightAction(true)
                    // Accent is used by default, this just demonstrates the usage.
                    .highlightClass('md-accent')
                    .position('bottom right')
                    .hideDelay(0);

                $mdToast
                    .show(toast)
                    .then(function (response) {
                        if (response === 'ok') {
                            saveChanges().then(function () {});
                        } else {
                            console.log('Toast dismissed.');
                            vm.hasChanges = false;
                        }
                    })
                    .catch(function () {
                        console.log('Toast failed or was forced to close early by another toast.');
                        vm.hasChanges = false;
                    });
            } else if (vm.hasChanges && !vm.editableContentForm.$valid) {
                hideUnsavedChangesToast();
            }
        }

        function hideUnsavedChangesToast() {
            $mdToast.hide();
        }

        function getBackgroundImage() {
            if (vm.legalUnit && vm.legalUnit.imageFilepath) {
                return {
                    'background-image': 'url("' + vm.legalUnit.imageFilepath + '?width=1920")',
                };
            } else {
                return {
                    'background-image': 'url("/assets/images/backgrounds/forest.jpg")',
                };
            }
        }

        function getAddressTypeByName(addressTypes, name) {
            return _.find(addressTypes, function (at) {
                return at.name.indexOf(name) > -1;
            });
        }

        function createPostAddress() {
            var postAddress = addressService.getEmptyAddress();
            postAddress.partyId = organization.id;
            postAddress.changeState = 1;
            var postAddressType = getAddressTypeByName(vm.addressTypes, 'Post');
            if (postAddressType) postAddress.addressTypeId = postAddressType.id;
            vm.updateModel.postAddress = postAddress;
            vm.postAddress.push(vm.updateModel.postAddress);
        }

        function createStreetAddress() {
            var streetAddress = addressService.getEmptyAddress();
            streetAddress.partyId = organization.id;
            streetAddress.changeState = 1;
            var streetAddressType = getAddressTypeByName(vm.addressTypes, 'Besøk');
            if (streetAddressType) streetAddress.addressTypeId = streetAddressType.id;
            vm.updateModel.streetAddress = streetAddress;
            vm.streetAddress.push(vm.updateModel.streetAddress);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('DepartmentConfigEditController', DepartmentConfigEditController);

    /* @ngInject */
    function DepartmentConfigEditController(
        $q,
        $stateParams,
        $mdToast,
        $translate,
        loadingService,
        dataLegacyService,
        addressService,
        locationService,
        department,
        organization
    ) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.loadingService = loadingService;
        vm.organization = angular.copy(organization);
        vm.department = angular.copy(department);
        vm.hasChanges = false;
        vm.updateModel = {
            department: angular.copy(department),
            organization: angular.copy(organization),
            location: null,
            postAddress: null,
            streetAddress: null,
        };
        vm.postAddress = [];
        vm.streetAddress = [];
        vm.initialized = false;

        vm.getBackgroundImage = getBackgroundImage;
        vm.onAddressChanged = onAddressChanged;
        vm.onDepartmentChanged = onDepartmentChanged;
        vm.submitDepartment = submitDepartment;

        activate();

        function activate() {
            if ($stateParams.departmentId === 'new') {
                vm.updateModel.location = locationService.getEmptyLocation();
                createPostAddress();
                createStreetAddress();
                vm.initialized = true;
            } else {
                var promises = [];
                vm.loadingService.setLoadingStatus(true);
                if (department.locationId) promises.push(dataService.getById('Locations', department.locationId, true));
                if (department.postAddressId) promises.push(dataService.getById('Addresses', department.postAddressId, true));
                promises.push(dataService.getAll('AddressTypes'));
                promises.push(dataService.getByPartyId('Emails', organization.id, true));
                promises.push(dataService.getByPartyId('Telephones', organization.id, true));
                $q.all(promises).then(function (response) {
                    if (department.locationId) {
                        vm.updateModel.location = response[0];
                        if (department.postAddressId) {
                            vm.updateModel.postAddress = response[1];
                            vm.postAddress.push(vm.updateModel.postAddress);
                            vm.addressTypes = response[2];
                        } else {
                            vm.addressTypes = response[1];
                            createPostAddress();
                        }
                        if (vm.updateModel.location.addressId) {
                            dataService.getById('Addresses', vm.updateModel.location.addressId, true).then(function (streetAddress) {
                                vm.updateModel.streetAddress = streetAddress;
                                vm.streetAddress.push(vm.updateModel.streetAddress);
                                vm.loadingService.setLoadingStatus(false);
                                vm.initialized = true;
                            });
                        } else {
                            vm.loadingService.setLoadingStatus(false);
                            vm.initialized = true;
                            createStreetAddress();
                        }
                    } else {
                        if (department.postAddressId) {
                            vm.updateModel.postAddress = response[0];
                            vm.postAddress.push(vm.updateModel.postAddress);
                            vm.addressTypes = response[1];
                        } else {
                            vm.addressTypes = response[0];
                            createPostAddress();
                        }
                        vm.loadingService.setLoadingStatus(false);
                        vm.initialized = true;
                    }
                    vm.updateModel.emails = response[response.length - 2];
                    vm.updateModel.telephones = response[response.length - 1];
                });
            }
        }

        function saveChanges() {
            vm.loadingService.setLoadingStatus(true);
            return dataService.updateFromUpdateModel('Departments', vm.updateModel).then(function (response) {
                vm.loadingService.setLoadingStatus(false);
                vm.hasChanges = false;
                vm.updateModel = response;
                vm.department = response.department;
                vm.organization = response.organization;
                dataService.invalidateCache('Departments');
                return response;
            });
        }

        function submitDepartment(department, organization) {
            console.log('Submit controller');
            vm.updateModel.department = department;
            vm.updateModel.organization = organization;
            saveChanges().then(function () {
                hideUnsavedChangesToast();
            });
        }

        function onDepartmentChanged(dtoModel) {
            if (dtoModel) {
                if (dtoModel.$type.indexOf('Organization') > -1) {
                    vm.updateModel.organization = dtoModel;
                    showUnsavedChangesToast();
                } else if (dtoModel.$type.indexOf('Department') > -1) {
                    vm.updateModel.department = dtoModel;
                    showUnsavedChangesToast();
                }
            }
        }

        function onAddressChanged(action, dtoModel) {
            if (action === 'change') {
                showUnsavedChangesToast();
            }
        }

        function showUnsavedChangesToast() {
            if (!vm.hasChanges && vm.editableContentForm.$valid) {
                vm.hasChanges = true;
                var toast = $mdToast
                    .simple()
                    .textContent($translate.instant('COMMON.DATA.YOU_HAVE_UNSAVED_CHANGES'))
                    .actionKey('s')
                    .actionHint($translate.instant('COMMON.DATA.PRESS_CTR_S_TO'))
                    .action($translate.instant('COMMON.DATA.SAVE'))
                    .dismissHint($translate.instant('COMMON.DATA.ACTIVATE_ESCAPE_KEY'))
                    .highlightAction(true)
                    // Accent is used by default, this just demonstrates the usage.
                    .highlightClass('md-accent')
                    .position('bottom right')
                    .hideDelay(0);

                $mdToast
                    .show(toast)
                    .then(function (response) {
                        if (response === 'ok') {
                            saveChanges().then(function () {});
                        } else {
                            console.log('Toast dismissed.');
                            vm.hasChanges = false;
                        }
                    })
                    .catch(function () {
                        console.log('Toast failed or was forced to close early by another toast.');
                        vm.hasChanges = false;
                    });
            } else if (vm.hasChanges && !vm.editableContentForm.$valid) {
                hideUnsavedChangesToast();
            }
        }

        function hideUnsavedChangesToast() {
            $mdToast.hide();
        }

        function getBackgroundImage() {
            if (vm.department && vm.department.imageFilepath) {
                return {
                    'background-image': 'url("' + vm.department.imageFilepath + '?width=1920")',
                };
            } else {
                return {
                    'background-image': 'url("/assets/images/backgrounds/forest.jpg")',
                };
            }
        }

        function getAddressTypeByName(addressTypes, name) {
            return _.find(addressTypes, function (at) {
                return at.name.indexOf(name) > -1;
            });
        }

        function createPostAddress() {
            var postAddress = addressService.getEmptyAddress();
            postAddress.partyId = organization.id;
            postAddress.changeState = 1;
            var postAddressType = getAddressTypeByName(vm.addressTypes, 'Post');
            if (postAddressType) postAddress.addressTypeId = postAddressType.id;
            vm.updateModel.postAddress = postAddress;
            vm.postAddress.push(vm.updateModel.postAddress);
        }

        function createStreetAddress() {
            var streetAddress = addressService.getEmptyAddress();
            streetAddress.partyId = organization.id;
            streetAddress.changeState = 1;
            var streetAddressType = getAddressTypeByName(vm.addressTypes, 'Besøk');
            if (streetAddressType) streetAddress.addressTypeId = streetAddressType.id;
            vm.updateModel.streetAddress = streetAddress;
            vm.streetAddress.push(vm.updateModel.streetAddress);
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.settings").controller("DepartmentConfigListController", DepartmentConfigListController);

  /* @ngInject */
  function DepartmentConfigListController($state, loadingService, currentDepartments) {
    var vm = this;
    vm.loadingService = loadingService;
    vm.currentDepartments = currentDepartments;
    vm.editDepartment = editDepartment;
    vm.addDepartment = addDepartment;

    function editDepartment(department) {
      if (department) {
        $state.go("app.configuration.departments.editDepartment", { departmentId: department.id });
      }
    }

    function addDepartment() {
      $state.go("app.configuration.departments.editDepartment", { departmentId: "new" });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('CustomerListController', CustomerListController);

    /* @ngInject */
    function CustomerListController($stateParams, $state, $filter, customerService, loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.customers = [];
        vm.loadingService = loadingService;

        vm.editCustomer = editCustomer;

        activate();

        function activate() {
            customerService.currentCustomers = [];

            if ($stateParams.searchString) {
                customerService.searchString = $stateParams.searchString;
            }

            vm.loadingService.setLoadingStatus(true);

            if (customerService.searchString && customerService.searchString.length === 1) {
                dataService.getByAlphabetLetter('Customers', customerService.searchString || 'A').then(function (customers) {
                    //customers = $filter('filter')(customers, { isDeleted: false });
                    vm.customers = $filter('orderBy')(customers, 'partyDisplayName');
                    customerService.currentCustomers = vm.customers;
                    vm.loadingService.setLoadingStatus(false);
                });
            } else if (customerService.searchString && customerService.searchString.length > 1) {
                dataService.search('Customers', customerService.searchString).then(function (customers) {
                    //customers = $filter('filter')(customers, { isDeleted: false });
                    vm.customers = $filter('orderBy')(customers, 'partyDisplayName');
                    customerService.currentCustomers = vm.customers;
                    vm.loadingService.setLoadingStatus(false);
                });
            }
        }

        function editCustomer(customer) {
            if (customer) {
                $state.go('app.configuration.customers.editCustomer', { customerId: customer.id });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ContactListController', ContactListController);

    /* @ngInject */
    function ContactListController($stateParams, $state, $filter, contactService, loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.contacts = [];
        vm.loadingService = loadingService;
        vm.data = contactService;

        vm.editContact = editContact;

        activate();

        function activate() {
            contactService.currentContacts = [];

            if ($stateParams.contactType) {
                contactService.selectedContactType = $stateParams.contactType;
            }

            vm.loadingService.setLoadingStatus(true);
            dataService.getByUri('Contacts', 'GetByType/' + $stateParams.internalType + '/' + $stateParams.internalTypeId).then(function (contacts) {
                contacts = $filter('filter')(contacts, { isDeleted: false });
                vm.contacts = $filter('orderBy')(contacts, 'displayName');
                contactService.currentContacts = vm.contacts;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function editContact(contact) {
            if (contact) {
                switch (contact.internalType) {
                    case 'Supplier':
                        $state.go('app.configuration.contacts.editSupplier', { supplierId: contact.id });
                        break;
                    case 'Participant':
                        $state.go('app.configuration.contacts.editParticipant', { participantId: contact.id });
                        break;
                    case 'Party':
                        $state.go('app.configuration.contacts.editParty', { partyId: contact.id });
                        break;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ConsignmentsGeneralSettingsController', ConsignmentsGeneralSettingsController);

    /* @ngInject */
    function ConsignmentsGeneralSettingsController(loadingService, signatureJobService, consignmentsActivated) {
        var vm = this;
        vm.loadingService = loadingService;

        activate();

        vm.consignmentsActivated = consignmentsActivated;
        vm.webhooksActivated = false;
        vm.webHooksCount = 0;

        // Methods
        vm.isExternalServiceAuthenticated = isExternalServiceAuthenticated;
        vm.toggleConsignments = toggleConsignments;
        vm.createWebhooks = createWebhooks;

        function activate() {
            checkWebhooks();
        }

        function checkWebhooks() {
            return signatureJobService.checkExternalWebhooks().then(function (response) {
                if (response && response.webHooksCount > 0) {
                    vm.webhooksActivated = true;
                    vm.webHooksCount = response.webHooksCount;
                }
            });
        }

        function toggleConsignments() {
            vm.loadingService.setLoadingStatus(true);
            signatureJobService
                .toggleGetAcceptIsActivated()
                .then(function (isActivated) {
                    signatureJobService.setConsignmentsActivated(isActivated);
                    vm.consignmentsActivated = isActivated;
                    if (vm.consignmentsActivated) {
                        return checkWebhooks();
                    }
                })
                .finally(function () {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function createWebhooks() {
            vm.loadingService.setLoadingStatus(true);
            signatureJobService
                .createExternalWebhooks()
                .then(function (response) {
                    if (response && response.webHooksCount > 0) {
                        vm.webhooksActivated = true;
                        vm.webHooksCount = response.webHooksCount;
                    }
                })
                .finally(function () {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function isExternalServiceAuthenticated() {
            return signatureJobService.isExternalServiceAuthenticated();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .component('editBaldrisConfig', {
            bindings: {
                baldrisConfig: '=',
                customFieldData: '=',
                labelText: '@',
                isCurrency: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/settings/configuration/components/edit-baldris-config/edit-baldris-config.tmpl.html',
            controller: 'EditBaldrisConfigController as vm',
        })
        .controller('EditBaldrisConfigController', EditBaldrisConfigController);

    /* @ngInject */
    function EditBaldrisConfigController($q, customFieldTypeOptions, dataService, customFieldDataService) {
        var vm = this;
        vm.isLoading = true;

        vm.dataOptions = null;
        vm.templateUrl = null;

        vm.onValueChanged = onValueChanged;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        //INIT
        vm.$onInit = function () {
            vm.searchText = null;

            //Load CurrentData
            if (vm.baldrisConfig.customFieldDataId && vm.baldrisConfig.customFieldDataId !== '00000000-0000-0000-0000-000000000000' && !vm.customFieldData) {
                dataService.getById('CustomFieldData', vm.baldrisConfig.customFieldDataId, true).then(function (customFieldData) {
                    loadCurrentData(customFieldData).then(function (extendedCustomFieldData) {
                        vm.customFieldData = extendedCustomFieldData;
                        vm.isLoading = false;
                    });
                });
            } else {
                ensureHasData();
                loadCurrentData(vm.customFieldData).then(function (extendedCustomFieldData) {
                    vm.customFieldData = extendedCustomFieldData;
                    vm.isLoading = false;
                });
                //vm.isLoading = false;
            }
        };

        function loadCurrentData(customFieldData) {
            if (customFieldData) {
                setDataOptions(customFieldData);
            }
            if (vm.dataOptions.dataSource && customFieldData && customFieldData[vm.dataOptions.targetProperty]) {
                return dataService.getById(vm.dataOptions.dataSource, customFieldData[vm.dataOptions.targetProperty], true).then(function (returnData) {
                    customFieldData[vm.dataOptions.targetModel] = returnData;
                    return customFieldData;
                });
            } else {
                return $q.when(customFieldData);
            }
        }

        function setDataOptions(customFieldData) {
            vm.dataOptions = getDataTypeOptions(customFieldData.dataType);
            // 'app/main/custom-field/components/edit-custom-field/templates/edit-string.tmpl.html'
            vm.templateUrl = vm.dataOptions.editTemplate;
            if (vm.templateUrl) {
                vm.templateUrl = vm.templateUrl.replace('custom-field/components/edit-custom-field', 'settings/configuration/components/edit-baldris-config');
            }
        }

        function querySearch(query) {
            if (vm.baldrisConfig.dataTypeDiscriminator) {
                if (query) {
                    return dataService.searchByConfigName(vm.dataOptions.dataSource, vm.baldrisConfig.dataTypeDiscriminator, query);
                } else {
                    return dataService.getByConfigName(vm.dataOptions.dataSource, vm.baldrisConfig.dataTypeDiscriminator);
                }
            } else {
                return dataService.search(vm.dataOptions.dataSource, query);
            }
        }

        function setChangeState(entity) {
            if (entity.id === '00000000-0000-0000-0000-000000000000') {
                entity.changeState = 1;
            } else {
                entity.changeState = 2;
            }
        }

        function onValueChanged() {
            if (vm.baldrisConfig) {
                setChangeState(vm.baldrisConfig);
                if (vm.baldrisConfig.customFieldData) {
                    setChangeState(vm.baldrisConfig.customFieldData);
                }
                if (vm.customFieldData) {
                    setChangeState(vm.customFieldData);
                }
                console.log("BaldrisConfig '" + vm.baldrisConfig.name + "' changed");
            }
        }

        function searchTextChange(text) {
            if (vm.baldrisConfig.allowCustom) {
                if (vm.baldrisConfig.data && vm.baldrisConfig.data[0]) {
                    vm.baldrisConfig.data[0].stringData = text;
                    setChangeState(vm.baldrisConfig.data[0]);
                }
                if (vm.baldrisConfig.customFieldData) {
                    vm.baldrisConfig.customFieldData.stringData = text;
                    setChangeState(vm.baldrisConfig.customFieldData);
                }
                if (vm.customFieldData) {
                    vm.customFieldData.stringData = text;
                    setChangeState(vm.customFieldData);
                }
            }
        }

        function selectedItemChange(item) {
            if (vm.baldrisConfig.data && vm.baldrisConfig.data[0]) {
                setChangeState(vm.baldrisConfig.data[0]);
            }
            if (vm.baldrisConfig.customFieldData) {
                setChangeState(vm.baldrisConfig.customFieldData);
            }
            if (vm.customFieldData) {
                setChangeState(vm.customFieldData);
            }
            if (item) {
                if (vm.baldrisConfig.data && vm.baldrisConfig.data[0]) {
                    vm.baldrisConfig.data[0][vm.dataOptions.targetProperty] = item[vm.dataOptions.sourceProperty];
                }
                if (vm.baldrisConfig.customFieldData) {
                    vm.baldrisConfig.customFieldData[vm.dataOptions.targetProperty] = item[vm.dataOptions.sourceProperty];
                }
                if (vm.customFieldData) {
                    vm.customFieldData[vm.dataOptions.targetProperty] = item[vm.dataOptions.sourceProperty];
                }
            } else {
                if (vm.baldrisConfig.data && vm.baldrisConfig.data[0]) {
                    vm.baldrisConfig.data[0][vm.dataOptions.targetProperty] = null;
                }
                if (vm.baldrisConfig.customFieldData) {
                    vm.baldrisConfig.customFieldData[vm.dataOptions.targetProperty] = null;
                }
                if (vm.customFieldData) {
                    vm.customFieldData[vm.dataOptions.targetProperty] = null;
                }
            }
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.baldrisConfig.data[0]);
            }
        }

        function ensureHasData() {
            if ((!vm.baldrisConfig.customFieldDataId || vm.baldrisConfig.customFieldDataId === '00000000-0000-0000-0000-000000000000') && !vm.customFieldData) {
                vm.customFieldData = customFieldDataService.getEmptyCustomFieldData();
                vm.dataOptions = getDataTypeOptions(vm.customFieldData.dataType);
                vm.templateUrl = vm.dataOptions.editTemplate;
            }
        }

        function getDataTypeOptions(dataType) {
            var dataOptions = null;
            angular.forEach(customFieldTypeOptions, function (option, key) {
                if (option.value === dataType) {
                    dataOptions = option;
                }
            });
            return dataOptions;
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.referenceTypes", []).config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, $mdThemingProvider) {
    $translatePartialLoaderProvider.addPart("app/main/reference-types/location");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/address");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/balance-account");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/casket");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/country");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/email");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/lookup-string");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/participant-role");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/party");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/state");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/supplier");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/telephone");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/work-order-type");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/municipality");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/baldris-user");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/participant");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/font-style");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/auto-task");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/auto-product");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/customer");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/urn");
    $translatePartialLoaderProvider.addPart("app/main/reference-types/vat");
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('workOrderTypeSelect', {
            bindings: {
                workOrderTypeId: '=',
                workOrderType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                displayText: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/work-order-type/components/work-order-type-select/work-order-type-select.tmpl.html',
            controller: 'WorkOrderTypeSelectController as vm',
        })
        .controller('WorkOrderTypeSelectController', WorkOrderTypeSelectController);

    /* @ngInject */
    function WorkOrderTypeSelectController($translate, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.workOrderTypes = [];

        vm.onChange = onChange;

        vm.$onInit = function () {
            dataService.getAll('WorkOrderTypes').then(function (workOrderTypes) {
                vm.isDisabled = false;
                vm.workOrderTypes = workOrderTypes;
                onChange();
            });
        };

        function onChange() {
            if (vm.workOrderTypeId && vm.workOrderTypeId !== 'none') {
                for (var index = 0; index < vm.workOrderTypes.length; index++) {
                    var workOrderType = vm.workOrderTypes[index];
                    if (vm.workOrderTypeId === workOrderType.id) {
                        vm.workOrderType = workOrderType;
                        vm.onUpdate({ action: 'selected', item: vm.workOrderType });
                        if (angular.isDefined(vm.displayText)) {
                            vm.displayText = workOrderType.name;
                        }
                        break;
                    }
                }
            } else {
                vm.workOrderType = null;
                vm.workOrderTypeId = null;
                vm.onUpdate({ action: 'deselected', item: null });
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.workOrderType);
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("workOrderTypeMultiSelect", {
      bindings: {
        workOrderTypeIds: "=",
        workOrderTypes: "=",
        onUpdate: "&",
        labelText: "@",
        isRequired: "="
      },
      templateUrl:
        "app/main/reference-types/work-order-type/components/work-order-type-multi-select/work-order-type-multi-select.tmpl.html",
      controller: "WorkOrderTypeMultiSelectController as vm"
    })
    .controller("WorkOrderTypeMultiSelectController", WorkOrderTypeMultiSelectController);

  /* @ngInject */
  function WorkOrderTypeMultiSelectController($translate, dataService) {
    var vm = this;
    vm.isDisabled = true;
    vm.availabelWorkOrderTypes = [];

    vm.onChange = onChange;

    vm.$onInit = function() {
      vm.workOrderTypeIds = vm.workOrderTypeIds || [];
      vm.workOrderTypes = vm.workOrderTypes || [];
      dataService.getAll("WorkOrderTypes").then(function(workOrderTypes) {
        vm.isDisabled = false;
        vm.availabelWorkOrderTypes = workOrderTypes;
        onChange();
      });
    };

    function onChange() {
      if (vm.workOrderTypeIds && vm.workOrderTypeIds.length > 0) {
        vm.workOrderTypes = [];
        for (var index = 0; index < vm.availabelWorkOrderTypes.length; index++) {
          var workOrderType = vm.availabelWorkOrderTypes[index];
          if (vm.workOrderTypeIds.indexOf(workOrderType.id) > -1) {
            vm.workOrderTypes.push(workOrderType);
          }
        }
      } else {
        vm.workOrderTypes = [];
      }
      vm.onUpdate({ action: "changed", value: vm.workOrderTypeIds });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('urnSelect', {
            bindings: {
                urnId: '=',
                urn: '=',
                onSelected: '=',
                labelText: '@',
                displayText: '=',
                minQueryLength: '='
            },
            templateUrl: 'app/main/reference-types/urn/components/urn-select/urn-select.tmpl.html',
            controller: 'UrnSelectController as vm',
        })
        .controller('UrnSelectController', UrnSelectController);

    /* @ngInject */
    function UrnSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getType = getType;

        //INIT
        vm.$onInit = function () {
            //Get Current Urn
            if (vm.urnId) {
                dataService.getById('Urns', vm.urnId, true).then(function (urn) {
                    vm.urn = urn;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService.search('Urns', query).then(function (urns) {
                    urns = $filter('filter')(urns, { isDeleted: false });
                    return $filter('orderBy')(urns, 'name');
                });
            } else {
                return dataService.getAll('Urns').then(function (urns) {
                    urns = $filter('filter')(urns, { isDeleted: false });
                    return $filter('orderBy')(urns, 'name');
                });
            }

        }

        function searchTextChange(text) {

        }

        function getType(urn) {
            var returnString = '';
            if (urn.material) {
                returnString += urn.material;
            }
            if (urn.color) {
                if (returnString) returnString += ' / ';
                returnString += urn.color;
            }
            if (returnString) {
                returnString = '(' + returnString + ')';
            }
            return returnString;
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.urnId = item.id;
                vm.urnForm.urn.$setValidity('invalidUrn', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.urnId = null;
                if (vm.searchText) {
                    vm.urnForm.urn.$setValidity('invalidUrn', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('telephoneTypeSelect', {
            bindings: {
                telephoneTypeId: '=',
                telephoneType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/reference-types/telephone/components/telephone-type-select/telephone-type-select.tmpl.html',
            controller: 'TelephoneTypeSelectController as vm',
        })
        .controller('TelephoneTypeSelectController', TelephoneTypeSelectController);

    /* @ngInject */
    function TelephoneTypeSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.telephoneTypes = [];
        vm.onChange = onChange;

        //INIT
        vm.$onInit = function () {
            // Get options
            dataService.getAll('TelephoneTypes').then(function (telephoneTypes) {
                vm.isDisabled = false;
                vm.telephoneTypes = telephoneTypes;
                if (!vm.telephoneTypeId || vm.telephoneTypeId === '00000000-0000-0000-0000-000000000000') {
                    for (var i = 0; i < vm.telephoneTypes.length; i++) {
                        var telephoneType = vm.telephoneTypes[i];
                        if (telephoneType.isDefault) {
                            vm.telephoneType = telephoneType;
                            vm.telephoneTypeId = telephoneType.id;
                            break;
                        }
                    }
                }
            });
        }

        function onChange() {
            if (vm.telephoneTypeId) {
                for (var index = 0; index < vm.telephoneTypes.length; index++) {
                    var telephoneType = vm.telephoneTypes[index];
                    if (vm.telephoneTypeId === telephoneType.id) {
                        vm.telephoneType = telephoneType;
                        break;
                    }
                }
            } else {
                vm.telephoneType = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.telephoneType);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('telephoneList', {
            bindings: {
                collection: '=',
                partyId: '=',
                baldrisUserId: '=',
                locationId: '='
            },
            templateUrl: 'app/main/reference-types/telephone/components/telephone-list/telephone-list.tmpl.html',
            controller: 'TelephoneListController as vm',
        })
        .controller('TelephoneListController', TelephoneListController);

    /* @ngInject */
    function TelephoneListController(dataService, telephoneService, $mdDialog, $document) {
        var vm = this;
        vm.addNewTelephone = addNewTelephone;
        vm.showEditTelephoneDialog = showEditTelephoneDialog;
        vm.getIconName = getIconName;
        vm.deleteOrUndo = deleteOrUndo;
        vm.getFormattedNumber = getFormattedNumber;

        var dialogOptions = {
            controller: 'EditTelephoneDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/reference-types/telephone/components/edit-telephone-dialog/edit-telephone-dialog.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: null,
            clickOutsideToClose: true,
            multiple: true,
            locals: {
                telephone: null
            }
        };
        function addNewTelephone(e) {
            var newTelephone = telephoneService.getEmptyTelephone();
            //Determine next sortOrder
            var highestSortOrder = 0;
            for (var i = 0, len = vm.collection.length; i < len; i++) {
                if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
                    highestSortOrder = vm.collection[i].sortOrder;
                }
            }
            newTelephone.sortOrder = highestSortOrder + 10;
            if (vm.partyId) {
                newTelephone.partyId = vm.partyId;
            }
            if (vm.locationId) {
                newTelephone.locationId = vm.locationId;
            }
            if (vm.baldrisUserId) {
                newTelephone.baldrisUserId = vm.baldrisUserId;
            }

            dialogOptions.targetEvent = e;
            dialogOptions.locals.telephone = newTelephone;

            $mdDialog.show(dialogOptions).then(function (updatedTelephone) {
                if (updatedTelephone) {
                    if (updatedTelephone.changeState == 1) {
                        // Should be new Telephone so we just insert it to the array
                        vm.collection.push(updatedTelephone);
                        if (vm.telephoneForm) {
                            vm.telephoneForm.$setDirty();
                        }
                    }
                }
            });
        }

        function showEditTelephoneDialog(telephone, e) {
            if (telephone.$type === 'Baldris.Core.Data.Entities.Dto.TelephoneDto, Baldris.Core.Data.Entities') {
                showTelephone(telephone);
            } else {
                dataService.getById('Telephones', telephone.id, true).then(function (fullTelephone) {
                    showTelephone(fullTelephone);
                });
            }

            function showTelephone(telephoneToShow) {
                dialogOptions.targetEvent = e;
                dialogOptions.locals.telephone = telephoneToShow;
                dialogOptions.multiple = true;

                $mdDialog.show(dialogOptions).then(function (updatedTelephone) {
                    if (updatedTelephone) {
                        if (updatedTelephone.changeState == 2) {
                            // Should be modified Telephone, locate and replace
                            for (var index = 0; index < vm.collection.length; index++) {
                                var element = vm.collection[index];
                                if (element.id === updatedTelephone.id) {
                                    vm.collection.splice(index, 1);
                                    vm.collection.push(updatedTelephone);
                                    break;
                                }
                            }
                        }
                        if (vm.telephoneForm) {
                            vm.telephoneForm.$setDirty();
                        }
                    }
                });
            }
        }

        function deleteTelephone(telephone, e) {
            // if newly created, we remove it entirely
            if (telephone.changeState === 1) {
                var index = vm.collection.indexOf(telephone);
                vm.collection.splice(index, 1);
                if (vm.telephoneForm) {
                    vm.telephoneForm.$setDirty();
                }
            } else {
                if (telephone.$type === 'Baldris.Core.Data.Entities.Dto.TelephoneDto, Baldris.Core.Data.Entities') {
                    // mark as deleted
                    telephone.changeState = 3;
                    if (vm.telephoneForm) {
                        vm.telephoneForm.$setDirty();
                    }
                } else {
                    // Get full Telephone and mark for deletion
                    dataService.getById('Telephones', telephone.id, true).then(function (fullTelephone) {
                        fullTelephone.changeState = 3;
                        // replace the telephone in the collection
                        for (var index = 0; index < vm.collection.length; index++) {
                            var element = vm.collection[index];
                            if (element.id === fullTelephone.id) {
                                vm.collection.splice(index, 1);
                                vm.collection.push(fullTelephone);
                                break;
                            }
                        }
                        if (vm.telephoneForm) {
                            vm.telephoneForm.$setDirty();
                        }
                    });
                }
            }
        }

        function undoDelete(telephone) {
            telephone.changeState = 2;
        }

        function deleteOrUndo(telephone) {
            if (telephone.changeState === 3) {
                undoDelete(telephone);
            } else {
                deleteTelephone(telephone);
            }
        }

        function getIconName(telephone) {
            if (telephone.telephoneTypeIconName) {
                return telephone.telephoneTypeIconName;
            } else if (telephone.telephoneType && telephone.telephoneType.iconName) {
                return telephone.telephoneType.iconName;
            }
            else {
                return "icon-phone";
            }
        }

        function getFormattedNumber(telephoneObject) {
            if (telephoneObject && telephoneObject.telephoneNumber) {
                return phoneUtils.formatNational(telephoneObject.telephoneNumber, telephoneObject.isoCode2 || 'NO');
            }
            return null;
        }

        //INIT
        if (!vm.collection) {
            vm.collection = [];
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('inlineTelephoneList', {
            bindings: {
                collection: '=',
                partyId: '=',
                baldrisUserId: '=',
                locationId: '=',
                isDisabled: '<',
                disableAdd: '<',
                onUpdate: '&',
                isSingleEntry: '<',
            },
            templateUrl: 'app/main/reference-types/telephone/components/inline-telephone-list/inline-telephone-list.tmpl.html',
            controller: 'InlineTelephoneListController as vm',
        })
        .controller('InlineTelephoneListController', InlineTelephoneListController);

    /* @ngInject */
    function InlineTelephoneListController($window, $mdDialog, $translate, dataService, telephoneService, orderByFilter) {
        var vm = this;

        vm.addNewTelephone = addNewTelephone;
        vm.onTelephoneChanged = onTelephoneChanged;
        vm.newTelephoneChip = newTelephoneChip;
        vm.selectTelephone = selectTelephone;
        vm.deleteTelephone = deleteTelephone;
        vm.getSelectedTelephoneType = getSelectedTelephoneType;
        vm.openTelephoneTypeMenu = openTelephoneTypeMenu;
        vm.setTelephoneType = setTelephoneType;
        vm.selectedTelephone = null;
        vm.showMoreOptions = false;

        //INIT
        vm.$onInit = function () {
            if (!vm.collection) {
                vm.collection = [];
            } else {
                // Get default telephone
                vm.collection = orderByFilter(vm.collection, ['sortOrder']);
                vm.selectedTelephone = getDefaultObject(vm.collection);
            }

            dataService.getAll('TelephoneTypes').then(function (telephoneTypes) {
                vm.telephoneTypes = telephoneTypes;
                vm.defaultTelephoneType = getDefaultObject(vm.telephoneTypes);

                if (vm.collection.length === 0) {
                    // Add blank telephone
                    var newTelephone = getEmptyTelephone();
                    newTelephone.isDefault = true;
                    newTelephone.sortOrder = 0;
                    newTelephone.changeState = 0;

                    vm.collection.push(newTelephone);
                    vm.selectedTelephone = vm.collection[0];
                }
            });
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
                vm.isDisabled = changesObj.isDisabled.currentValue;
            }
        };

        function getDefaultObject(objects) {
            if (!objects || objects.length === 0) return null;
            var defaultObject = null;
            for (var i = 0, len = objects.length; i < len; i++) {
                if (!defaultObject) {
                    defaultObject = objects[i];
                }
                if (objects[i].isDefault) {
                    defaultObject = objects[i];
                    break;
                }
                if (defaultObject.sortOrder > objects[i].sortOrder) {
                    defaultObject = objects[i];
                }
            }
            return defaultObject;
        }

        function getEmptyTelephone() {
            var newTelephone = telephoneService.getEmptyTelephone();
            //Determine next sortOrder
            var highestSortOrder = 0;
            var isDefault = !vm.collection || vm.collection.length === 0;
            for (var i = 0, len = vm.collection.length; i < len; i++) {
                if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
                    highestSortOrder = vm.collection[i].sortOrder;
                }
            }
            newTelephone.sortOrder = highestSortOrder + 10;
            newTelephone.isDefault = isDefault;
            if (vm.defaultTelephoneType) {
                newTelephone.telephoneTypeId = vm.defaultTelephoneType.id;
                newTelephone.telephoneType = vm.defaultTelephoneType;
                newTelephone.telephoneTypeName = vm.defaultTelephoneType.name;
            }
            return newTelephone;
        }

        function addNewTelephone(e) {
            var newTelephone = getEmptyTelephone();

            if (vm.partyId) {
                newTelephone.partyId = vm.partyId;
            }
            if (vm.baldrisUserId) {
                newTelephone.baldrisUserId = vm.baldrisUserId;
            }
            if (vm.locationId) {
                newTelephone.locationId = vm.locationId;
            }
            vm.collection.push(newTelephone);
            vm.selectedTelephone = newTelephone;
            vm.telephoneListForm.$setDirty();
            var defaultTelephoneElement = $window.document.getElementById('DefaultTelephoneNumber');
            defaultTelephoneElement.focus();
            vm.onUpdate({ action: 'add', value: newTelephone });
        }

        function onTelephoneChanged(telephone) {
            if (telephone.id && telephone.id !== '00000000-0000-0000-0000-000000000000') {
                telephone.changeState = 2;
            } else {
                telephone.changeState = 1;
            }
            vm.collection = orderByFilter(vm.collection, ['sortOrder']);
            vm.telephoneListForm.$setDirty();
            vm.onUpdate({ action: 'change', value: telephone });
        }

        function newTelephoneChip(chip) {}

        function selectTelephone(telephone) {
            vm.selectedTelephone = telephone;
            var defaultTelephoneElement = $window.document.getElementById('DefaultTelephoneNumber');
            defaultTelephoneElement.focus();
        }

        function deleteTelephone(telephone, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('TELEPHONES.TELEPHONE_LIST.DELETE_TELEPHONE'))
                .textContent(
                    $translate.instant('TELEPHONES.TELEPHONE_LIST.DELETE_TELEPHONE_CONFIRM', {
                        telephone: telephone.streetTelephone1 ? telephone.streetTelephone1 : $translate.instant('TELEPHONES.TELEPHONE.TELEPHONE'),
                    })
                )
                .ariaLabel($translate.instant('TELEPHONES.TELEPHONE_LIST.DELETE_TELEPHONE'))
                .targetEvent(e)
                .ok($translate.instant('TELEPHONES.TELEPHONE_LIST.DELETE_TELEPHONE'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    if (telephone.id && telephone.id !== '00000000-0000-0000-0000-000000000000') {
                        dataService.deleteItem('Telephones', telephone).then(function () {
                            // Remove from collection
                            var index = vm.collection.indexOf(telephone);
                            vm.collection.splice(index, 1);
                            replaceIfSelected(telephone);
                            vm.onUpdate({ action: 'remove', value: telephone });
                        });
                    } else {
                        // Remove from collection
                        var index = vm.collection.indexOf(telephone);
                        vm.collection.splice(index, 1);
                        replaceIfSelected(telephone);
                        vm.onUpdate({ action: 'remove', value: telephone });
                    }
                },
                function () {
                    // Do nothing
                }
            );
        }

        function replaceIfSelected(telephone) {
            // Check if telephone was selected
            if (vm.selectedTelephone === telephone) {
                // Select default telephone, if any
                vm.selectedTelephone = getDefaultObject(vm.collection);
                // If no telephone selected, create blank
                if (!vm.selectedTelephone) {
                    var newTelephone = getEmptyTelephone();
                    newTelephone.isDefault = true;
                    newTelephone.sortOrder = 0;
                    newTelephone.changeState = 0;

                    vm.collection.push(newTelephone);
                    vm.selectedTelephone = vm.collection[0];
                }
            }
        }

        function openTelephoneTypeMenu($mdMenu, ev) {
            vm.originatorEv = ev;
            $mdMenu.open(ev);
        }

        function setTelephoneType(telephoneType) {
            if (vm.selectedTelephone) {
                vm.selectedTelephone.telephoneTypeId = telephoneType.id;
                vm.selectedTelephone.telephoneTypeName = telephoneType.name;
                onTelephoneChanged(vm.selectedTelephone);
            }
        }

        function getSelectedTelephoneType() {
            if (vm.selectedTelephone) {
                if (vm.telephoneTypes && vm.telephoneTypes.length > 0) {
                    for (var index = 0; index < vm.telephoneTypes.length; index++) {
                        var telephoneType = vm.telephoneTypes[index];
                        if (vm.selectedTelephone.telephoneTypeId === telephoneType.id) {
                            return telephoneType;
                        }
                    }
                }
                if (vm.selectedTelephone.telephoneTypeName) {
                    return {
                        name: vm.selectedTelephone.telephoneTypeName,
                        iconName: 'icon-help',
                    };
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditTelephoneDialogController', EditTelephoneDialogController);

    /* @ngInject */
    function EditTelephoneDialogController($mdDialog, telephone, $translate, dataService, telephoneService, countryService) {
        var vm = this;

        // Data
        vm.telephone = telephone;
        vm.selectedCountry = null;
        vm.selectedCountryId = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onCountryChange = onCountryChange;

        //INIT
        if (vm.telephone.isoCode2) {
            countryService.getByIsoCode(vm.telephone.isoCode2).then(function (foundCountry) {
                vm.selectedCountry = foundCountry;
            });
        } else {
            // Get deafult country
            dataService.search('BaldrisConfigs', 'DefaultCountry').then(function (baldrisConfigs) {
                if (baldrisConfigs && baldrisConfigs.length > 0) {
                    vm.selectedCountryId = baldrisConfigs[0].dataTargetId;
                    dataService.getById('Countries', vm.selectedCountryId, true).then(function (defaultCountry) {
                        vm.selectedCountry = defaultCountry;
                        vm.telephone.isoCode2 = defaultCountry.isoCode2;
                    });
                }
            });
        }

        function onCountryChange(country) {
            if (country) {
                vm.telephone.isoCode2 = country.isoCode2;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.selectedCountry && vm.selectedCountry.isoCode2) {
                vm.telephone.isoCode2 = vm.selectedCountry.isoCode2;
            }
            if (!vm.telephone.id || vm.telephone.id === '00000000-0000-0000-0000-000000000000') {
                vm.telephone.changeState = 1;
            } else {
                vm.telephone.changeState = 2;
            }
            $mdDialog.hide(vm.telephone);
        }

    }

} ());
(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('SearchSupplierDialogController', SearchSupplierDialogController);

    /* @ngInject */
    function SearchSupplierDialogController($q, $mdDialog, $filter, $translate, asDto, allowAdditions, dataService) {
        var vm = this;

        //Data
        vm.selectedSupplier = null;
        vm.selectedSupplierType = null;
        vm.supplierTypes = [];
        vm.isSearching = false;
        vm.isLoadingSupplier = false;
        vm.showOnlyFromWorkOrder = false;
        vm.allowAdditions = allowAdditions || false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSearchChange = onSearchChange;
        vm.selectItem = selectItem;
        vm.selectSupplierType = selectSupplierType;
        vm.openAddSupplierDialog = openAddSupplierDialog;

        //////////
        // Init

        activate();

        ////////////////////
        // PRIVATE METHODS

        function activate() {
            // Get Supplier Types
            var promises = [];
            promises.push(dataService.getAll('SupplierTypes'));
            vm.isSearching = true;
            $q.all(promises).then(function (result) {
                vm.supplierTypes = result[0];
                // Add special types
                var allSupplierType = _.find(vm.supplierTypes, { id: 'all' });
                if (!allSupplierType) {
                    allSupplierType = {
                        id: 'all',
                        name: $translate.instant('SUPPLIERS.SEARCH_SUPPLIER_DIALOG.ALL_SUPPLIERS'),
                        sortOrder: -10,
                    };
                    vm.supplierTypes.push(allSupplierType);
                }
                vm.selectedSupplierType = allSupplierType;
                // Initial search
                onSearchChange();
            });
        }

        function closeDialog(selectedSupplier) {
            if (selectedSupplier) {
                if (asDto) {
                    vm.isLoadingSupplier = true;
                    dataService.getById('Suppliers', selectedSupplier.id, true).then(function (selectedItem) {
                        $mdDialog.hide(selectedItem);
                        vm.isLoadingSupplier = false;
                    });
                } else {
                    $mdDialog.hide(selectedSupplier);
                }
            } else {
                $mdDialog.hide(selectedSupplier);
            }
        }

        function selectSupplierType(supplierType) {
            vm.selectedSupplierType = supplierType;
            vm.searchResults = [];
            onSearchChange();
        }

        function onSearchChange() {
            if (vm.searchText && vm.searchText.length > 0) {
                vm.isSearching = true;
                if (vm.selectedSupplierType && vm.selectedSupplierType.id) {
                    vm.isSearching = true;
                    if (vm.selectedSupplierType.id === 'all') {
                        dataService.search('Suppliers', vm.searchText).then(function (searchResults) {
                            vm.searchResults = searchResults.data || searchResults;
                            vm.isSearching = false;
                        });
                    } else {
                        dataService
                            .search('Suppliers', vm.searchText, null, null, {
                                searchString: vm.searchText,
                                supplierTypeId: vm.selectedSupplierType.id,
                            })
                            .then(function (searchResults) {
                                vm.searchResults = searchResults.data || searchResults;
                                vm.isSearching = false;
                            });
                    }
                } else {
                    vm.searchResults = [];
                }
            } else {
                // Get All
                if (vm.selectedSupplierType && vm.selectedSupplierType.id) {
                    vm.isSearching = true;
                    if (vm.selectedSupplierType.id === 'all') {
                        dataService.getAll('Suppliers').then(function (searchResults) {
                            vm.searchResults = searchResults;
                            vm.isSearching = false;
                        });
                    } else {
                        dataService.getByUri('Suppliers', 'BySupplierTypeId/' + vm.selectedSupplierType.id).then(function (searchResults) {
                            vm.searchResults = searchResults;
                            vm.isSearching = false;
                        });
                    }
                } else {
                    vm.searchResults = [];
                    vm.isSearching = false;
                }
            }
        }

        function selectItem(item) {
            if (item) {
                if (!vm.selectedSupplier) {
                    vm.selectedSupplier = item;
                } else if (item.id === vm.selectedSupplier.id) {
                    vm.selectedSupplier = null;
                } else {
                    vm.selectedSupplier = item;
                }
            } else {
                vm.selectedSupplier = null;
            }
        }

        function openAddSupplierDialog(e) {
            supplierService.showEditSupplierDialog(e, 'new', false).then(function (insertedSupplier) {
                if (insertedSupplier) {
                    closeDialog(insertedSupplier);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('supplierSelect', {
            bindings: {
                supplier: '=',
                supplierId: '=',
                onChanged: '<',
                isDisabled: '<',
                supplierConfig: '<',
                labelText: '@',
                minQueryLength: '=',
                displayText: '=',
            },
            templateUrl:
                'app/main/reference-types/supplier/components/supplier-select/supplier-select.tmpl.html',
            controller: 'SupplierSelectController as vm',
        })
        .controller('SupplierSelectController', SupplierSelectController);

    /* @ngInject */
    function SupplierSelectController($filter, $mdDialog, dataService) {
        var vm = this;
        var cachedResults = [];

        vm.$onInit = function () {
            vm.onSupplierChanged = onSupplierChanged;
            vm.querySearch = querySearch;
            vm.openSearchDialog = openSearchDialog;
            vm.searchTextChange = searchTextChange;

            vm.searchText = null;

            //Get Current Supplier
            if (vm.supplierId && !vm.supplier) {
                dataService
                    .getById('Suppliers', vm.supplierId, true)
                    .then(function (supplier) {
                        vm.supplier = supplier;
                    });
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        /*///////////*/

        function onSupplierChanged(item, e) {
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(item, e);
            }
            if (item) {
                vm.supplierId = item.id;
                vm.supplierForm.supplier.$setValidity('invalidSupplier', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.partyDisplayName;
                }
            } else {
                if (
                    vm.supplierId &&
                    vm.supplierId !== '00000000-0000-0000-0000-000000000000'
                ) {
                    // Set dirty
                    vm.supplierForm.$setDirty();
                }
                vm.supplierId = null;
                if (vm.searchText) {
                    vm.supplierForm.supplier.$setValidity(
                        'invalidSupplier',
                        false
                    );
                } else {
                    vm.supplierForm.supplier.$setValidity(
                        'invalidSupplier',
                        true
                    );
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }

        function searchTextChange(text) {
            if (!text && !vm.supplier) {
                vm.supplierForm.supplier.$setValidity('invalidSupplier', true);
            }
        }

        function querySearch(query) {
            if (vm.supplierConfig) {
                if (cachedResults.length === 0) {
                    return dataService
                        .getByConfigName('Suppliers', vm.supplierConfig)
                        .then(function (suppliers) {
                            cachedResults = suppliers;
                            return getFiltered(cachedResults, query);
                        });
                }
            } else {
                if (!query) {
                    return dataService
                        .getAll('Suppliers')
                        .then(function (suppliers) {
                            return suppliers;
                        });
                }
                return dataService
                    .search('Suppliers', query)
                    .then(function (searchResult) {
                        return searchResult.data;
                    });
            }
        }

        function getFiltered(collection, query) {
            if (!query) return collection;
            return $filter('filter')(collection, query);
        }

        function openSearchDialog(e) {
            $mdDialog
                .show({
                    controller: 'SearchSupplierDialogController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/reference-types/supplier/dialogs/search-supplier-dialog/search-supplier-dialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                    locals: {
                        asDto: false,
                        allowAdditions: false,
                    },
                })
                .then(function (selectedSupplier) {
                    if (selectedSupplier) {
                        vm.supplier = selectedSupplier;
                        vm.supplierId = selectedSupplier.id;
                        vm.supplierForm.$setDirty();
                    }
                });
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("stateSelect", {
      bindings: {
        stateId: "=",
        state: "=",
        countryId: "=",
        onSelected: "=",
        allowCustom: "=",
        customValue: "=",
        labelText: "@",
        stateConfig: "=",
        minQueryLength: "=",
        displayText: "=",
        isDisabled: "<",
        onUpdate: "&"
      },
      templateUrl: "app/main/reference-types/state/components/state-select/state-select.tmpl.html",
      controller: "StateSelectController as vm"
    })
    .controller("StateSelectController", StateSelectController);

  /* @ngInject */
  function StateSelectController($filter, dataService) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    //INIT
    vm.$onInit = function() {
      //Get Current State
      if (vm.stateId) {
        dataService.getById("States", vm.stateId, true).then(function(state) {
          vm.state = state;
        });
      } else if (vm.allowCustom && vm.customValue) {
        vm.searchText = vm.customValue;
      }

      vm.minLength = 0;
      if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
        vm.minLength = vm.minQueryLength;
      }
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
        vm.isDisabled = changesObj.isDisabled.currentValue;
      }
    };

    // ******************************
    // Internal methods
    // ******************************

    function querySearch(query) {
      return dataService.search("States", query, vm.countryId, "countryId").then(function(countries) {
        return $filter("orderBy")(countries, "name");
      });
    }

    function searchTextChange(text) {
      if (vm.allowCustom) {
        vm.customValue = text;
      }
    }

    function selectedItemChange(item) {
      if (angular.isFunction(vm.onSelected)) {
        vm.onSelected(item);
      }
      if (item) {
        if (item.id !== vm.stateId) {
          vm.onUpdate({ action: "selected", value: item });
        }
        vm.stateId = item.id;
        vm.stateForm.state.$setValidity("invalidState", true);
        if (vm.allowCustom) {
          vm.customValue = item.name;
        }
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = item.name;
        }
      } else {
        if (vm.stateId && vm.stateId !== "00000000-0000-0000-0000-000000000000") {
          vm.onUpdate({ action: "deselected", value: null });
        }
        vm.stateId = null;
        if (vm.searchText && !vm.allowCustom) {
          vm.stateForm.state.$setValidity("invalidState", false);
        }
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = null;
        }
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('SearchPartyDialogController', SearchPartyDialogController);

    /* @ngInject */
    function SearchPartyDialogController($q, $mdDialog, $filter, $translate, apiController, workOrderId, asDto, allowAdditions, dataService, partyService) {
        var vm = this;

        //Data
        vm.selectedParty = null;
        vm.selectedPartyType = null;
        vm.partyTypes = [];
        vm.isSearching = false;
        vm.isLoadingParty = false;
        vm.showOnlyFromWorkOrder = false;
        vm.workOrderId = workOrderId;
        vm.allowAdditions = allowAdditions || false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSearchChange = onSearchChange;
        vm.selectItem = selectItem;
        vm.isPerson = isPerson;
        vm.isOrganization = isOrganization;
        vm.selectPartyType = selectPartyType;
        vm.openAddPartyDialog = openAddPartyDialog;
        vm.getTitle = getTitle;
        vm.getPartyTypeText = getPartyTypeText;

        //////////
        // Init

        activate();

        ////////////////////
        // PRIVATE METHODS

        function activate() {
            // Get Party Types
            var promises = [];
            promises.push(dataService.getAll('PartyTypes'));
            vm.isSearching = true;
            $q.all(promises).then(function (result) {
                vm.partyTypes = vm.partyTypes.concat(result[0]);
                // Add special types
                var allPartyType = {
                    id: 'all',
                    name: $translate.instant('PARTY.SEARCH_PARTY_DIALOG.ALL_THIRD_PARTIES'),
                    sortOrder: -10,
                };
                vm.partyTypes.push(allPartyType);
                if (workOrderId) {
                    var currentWorkOrderPartyType = {
                        id: 'workOrder',
                        name: $translate.instant('PARTY.SEARCH_PARTY_DIALOG.PERSONS_IN_CURRENT_WORKORDER'),
                        sortOrder: -20,
                    };
                    vm.partyTypes.push(currentWorkOrderPartyType);
                    vm.selectedPartyType = currentWorkOrderPartyType;
                } else {
                    vm.selectedPartyType = allPartyType;
                }
                // Initial search
                onSearchChange();
            });
        }

        function getTitle() {
            switch (apiController) {
                case 'Persons':
                    return 'PARTY.SEARCH_PARTY_DIALOG.TITLE_PERSON';
                case 'Organizations':
                    return 'PARTY.SEARCH_PARTY_DIALOG.TITLE_ORGANIZATION';
                default:
                    return 'PARTY.SEARCH_PARTY_DIALOG.TITLE';
            }
        }

        function isPerson(party) {
            return (
                party &&
                (vm.selectedParty.$type === 'Baldris.Core.Data.Entities.Dto.PersonDto, Baldris.Core.Data.Entities' ||
                    vm.selectedParty.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.PersonShortDto, Baldris.Core.Data.Entities')
            );
        }

        function isOrganization(party) {
            return (
                party &&
                (vm.selectedParty.$type === 'Baldris.Core.Data.Entities.Dto.OrganizationDto, Baldris.Core.Data.Entities' ||
                    vm.selectedParty.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.OrganizationShortDto, Baldris.Core.Data.Entities')
            );
        }

        function closeDialog(selectedParty) {
            $mdDialog.hide(selectedParty);
        }

        function selectPartyType(partyType) {
            vm.selectedPartyType = partyType;
            vm.searchResults = [];
            onSearchChange();
        }

        function onSearchChange() {
            if (vm.searchText && vm.searchText.length > 1) {
                vm.isSearching = true;
                if (vm.selectedPartyType && vm.selectedPartyType.id) {
                    vm.isSearching = true;
                    if (vm.selectedPartyType.id === 'all') {
                        dataService.search(apiController, vm.searchText).then(function (searchResults) {
                            vm.searchResults = searchResults.data || searchResults;
                            vm.isSearching = false;
                        });
                    } else if (vm.selectedPartyType.id === 'workOrder') {
                        dataService
                            .getByWorkOrderId('Parties', workOrderId, false, {
                                overridePseudomization: true,
                            })
                            .then(function (searchResults) {
                                searchResults = $filter('filter')(searchResults, {
                                    displayName: vm.searchText,
                                });
                                vm.searchResults = searchResults;
                                vm.isSearching = false;
                            });
                    } else {
                        dataService.search(apiController, vm.searchText, vm.selectedPartyType.id, 'partyTypeId').then(function (searchResults) {
                            vm.searchResults = searchResults.data || searchResults;
                            vm.isSearching = false;
                        });
                    }
                } else {
                    vm.searchResults = [];
                }
            } else {
                // Get All
                if (vm.selectedPartyType && vm.selectedPartyType.id) {
                    vm.isSearching = true;
                    if (vm.selectedPartyType.id === 'all') {
                        // Don't allow fetching of all parties
                        vm.isSearching = false;
                        vm.searchResults = [];
                    } else if (vm.selectedPartyType.id === 'workOrder') {
                        dataService
                            .getByWorkOrderId('Parties', workOrderId, false, {
                                overridePseudomization: true,
                            })
                            .then(function (searchResults) {
                                vm.searchResults = searchResults;
                                vm.isSearching = false;
                            });
                    } else {
                        dataService.getByUri(apiController, 'ByPartyTypeId/' + vm.selectedPartyType.id).then(function (searchResults) {
                            vm.searchResults = searchResults;
                            vm.isSearching = false;
                        });
                    }
                } else {
                    vm.searchResults = [];
                    vm.isSearching = false;
                }
            }
        }

        function selectItem(item) {
            if (item) {
                if (asDto) {
                    vm.isLoadingParty = true;
                    dataService.getById(apiController, item.id, true).then(function (selectedItem) {
                        vm.selectedParty = selectedItem;
                        vm.isLoadingParty = false;
                    });
                } else {
                    vm.selectedParty = item;
                }
            }
        }

        function openAddPartyDialog(e) {
            partyService.showAddPartyDialog(e, apiController).then(function (insertedParty) {
                if (insertedParty) {
                    closeDialog(insertedParty);
                }
            });
        }

        function getPartyTypeText(partyType) {
            if (!partyType || !partyType.name) return null;
            if (partyType.type === 'SYSTEM.REFERENCE_PERSON_TYPE') {
                return 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.' + partyType.name;
            }
            return partyType.name;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('PartyPrivacyDialogController', PartyPrivacyDialogController);

    /* @ngInject */
    function PartyPrivacyDialogController(
        $q,
        $window,
        $mdDialog,
        $translate,
        partyService,
        dataService,
        partyId,
        referencePersonId,
        referencePersonTypeMask,
        workOrderId,
        Upload,
        baldrisApiBase,
        workOrderReferencePersonService,
        transactionalMailService,
        $http,
        baldrisConfigService,
        consignmentsActivated
    ) {
        var vm = this;
        vm.partyId = partyId;

        activate();

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.setSignature = setSignature;
        vm.uploadSignedConsentForm = uploadSignedConsentForm;
        vm.uploadSignedLetterOfAttorney = uploadSignedLetterOfAttorney;
        vm.getSignatureWidth = getSignatureWidth;
        vm.getSignatureHeight = getSignatureHeight;
        vm.openSignatureDialog = openSignatureDialog;
        vm.retractConsent = retractConsent;
        vm.fieldsHaveChanges = fieldsHaveChanges;
        vm.fieldChanged = fieldChanged;
        vm.saveTemporaryChanges = saveTemporaryChanges;
        vm.getPreviewUrl = getPreviewUrl;
        vm.readyToSave = readyToSave;
        vm.hasApprovedLetterOfAttorneyFields = hasApprovedLetterOfAttorneyFields;
        vm.selectPdf = selectPdf;
        vm.getSignedConsentFileId = getSignedConsentFileId;
        vm.getSignedLetterOfAttorneyFileId = getSignedLetterOfAttorneyFileId;
        vm.openSigningMethodMenu = openSigningMethodMenu;

        function reset() {
            vm.partyDto = null;
            vm.workOrderDto = null;
            vm.partyPrivacyFields = [];
            vm.privacyFields = [];
            vm.showNameInputs = false;
            vm.requiredFields = [];
            vm.optionalFields = [];
            vm.isSigned = false;
            vm.useSignature = false;
            vm.hasLetterOfAttorney = false;
            vm.useUploadedFile = false;
            vm.isReadOnly = false;
            vm.printPrivacyConsentForm = false;
            vm.printLetterOfAttorneyForm = false;
            vm.sendSignedCopiesTo = [];
        }

        function activate() {
            reset();

            // Get fields from db
            var promises = [];
            promises.push(
                referencePersonId
                    ? dataService.getByUri('Privacy', 'ActivatedPrivacyFields/ByReferencePersonId/' + referencePersonId, true)
                    : dataService.getByUri('Privacy', 'ActivatedPrivacyFields/ByPartyId/' + vm.partyId, true)
            );
            promises.push(dataService.getById('Persons', vm.partyId, true));

            if (workOrderId) {
                promises.push(dataService.getById('WorkOrders', workOrderId));
                promises.push(
                    dataService.getByUri('ReferencePersons', 'SignatureStatus/ByWorkOrderId/' + workOrderId, { referencePersonId: referencePersonId })
                );
                promises.push(dataService.getById('ReferencePersons', referencePersonId));
            }
            promises.push(dataService.getByUri('Accounts', 'CurrentTenant'));

            vm.isSaving = true;
            return $q.all(promises).then(function (response) {
                vm.partyPrivacyFields = response[0] || [];
                vm.partyDto = response[1];
                if (vm.partyDto && vm.partyDto.primaryEmail) {
                    vm.sendSignedCopy = true;
                    baldrisConfigService.getByName('SendSignedPrivacyFormsAsDefault').then(function (config) {
                        if (config && config[0] && config[0].customFieldData.boolData === false) {
                            vm.sendSignedCopy = false;
                        }
                    });
                    vm.sendSignedCopiesTo.push({
                        email: vm.partyDto.primaryEmail,
                        name: vm.partyDto.firstName + ' ' + vm.partyDto.lastName,
                    });
                }
                if (workOrderId) {
                    vm.workOrderDto = response[2];
                    vm.signedStatuses = response[3];
                    vm.workOrderReferencePersonDto = response[4];
                }

                vm.currentTenant = response[response.length - 1];
                vm.consignmentsActivated = consignmentsActivated;

                vm.isResponsibleForFuneral = referencePersonTypeMask.indexOf('contractor') > -1;

                if (!vm.partyDto.firstName && !vm.partyDto.lastName) {
                    vm.showNameInputs = true;
                }

                vm.isSigned =
                    vm.signedStatuses &&
                    vm.signedStatuses.length > 0 &&
                    vm.signedStatuses.find(function (status) {
                        return status.internalName === 'PrivacyConsentFormWorkOrder' && status.hasSigned;
                    });
                vm.isReadOnly = vm.isSigned;
                if (vm.isSigned) {
                    selectPdf(getSignedConsentFileId());
                }

                // vm.hasLetterOfAttorney = vm.workOrderReferencePersonDto && vm.workOrderReferencePersonDto.signedLetterOfAttorneyFileId !== null;

                if (!vm.partyPrivacyFields || vm.partyPrivacyFields.length === 0) {
                    vm.hasStarted = false;
                    return dataService.getAll('PrivacyFields').then(function (privacyFields) {
                        if (privacyFields && privacyFields.length > 0) {
                            separateFields(privacyFields, vm.workOrderDto);
                        }
                        if (!vm.partyPrivacyFields || vm.partyPrivacyFields.length === 0) {
                            return getNoMatchFields().then(function (noMatchFields) {
                                separateFields(noMatchFields, vm.workOrderDto);
                                filterFields();
                                vm.isSaving = false;
                                return true;
                            });
                        } else {
                            filterFields();
                            vm.isSaving = false;
                            return true;
                        }
                    });
                } else {
                    vm.hasStarted = true;
                    filterFields();
                    vm.isSaving = false;
                    return true;
                }
            });
        }

        function getSignedConsentFileId() {
            if (vm.isSigned) {
                var document = vm.signedStatuses.find(function (status) {
                    return status.internalName === 'PrivacyConsentFormWorkOrder' && status.hasSigned;
                });
                if (document) {
                    return document.documentId;
                }
            }
            return null;
        }

        function getSignedLetterOfAttorneyFileId() {
            if (vm.isSigned) {
                var document = vm.signedStatuses.find(function (status) {
                    return status.internalName === 'GeneralLetterOfAttorney' && status.hasSigned;
                });
                if (document) {
                    return document.documentId;
                }
            }
            return null;
        }

        function hasAllMasks(privacyFieldMask, referencePersonType) {
            if (!privacyFieldMask || privacyFieldMask === 'none') return true;
            var returnValue = true;
            var masks = privacyFieldMask.split(', ');
            masks.forEach(function (mask) {
                returnValue = returnValue && referencePersonType.indexOf(mask) > -1;
            });
            return returnValue;
        }

        function separateFields(privacyFields, workOrderDto) {
            var mask = referencePersonTypeMask || 'none';
            var filteredPartyFields = privacyFields.filter(function (privacyField) {
                if (
                    (!privacyField.workOrderTypeId || (workOrderDto && workOrderDto.workOrderTypeId === privacyField.workOrderTypeId)) &&
                    !privacyField.isDeleted &&
                    !privacyField.legalRemarks &&
                    !privacyField.onlyWhenNoMatch &&
                    privacyField.referencePersonTypeMask === 'none'
                )
                    return true;
                return (
                    (!privacyField.workOrderTypeId || (workOrderDto && workOrderDto.workOrderTypeId === privacyField.workOrderTypeId)) &&
                    !privacyField.isDeleted &&
                    !privacyField.legalRemarks &&
                    !privacyField.onlyWhenNoMatch &&
                    hasAllMasks(privacyField.referencePersonTypeMask, mask)
                );
            });
            vm.partyPrivacyFields = filteredPartyFields.map(convertToActivatedPrivacyField);

            var filteredWorkOrderFields = privacyFields.filter(function (privacyField) {
                if (!privacyField.isDeleted && privacyField.legalRemarks && !privacyField.onlyWhenNoMatch && privacyField.referencePersonTypeMask === 'none')
                    return true;
                return (
                    !privacyField.isDeleted &&
                    privacyField.legalRemarks &&
                    !privacyField.onlyWhenNoMatch &&
                    hasAllMasks(privacyField.referencePersonTypeMask, mask)
                );
            });
            vm.partyWorkOrderFields = filteredWorkOrderFields.map(convertToActivatedPrivacyField);
        }

        function fieldsHaveChanges() {
            if (!vm.requiredFields && !vm.optionalFields && !vm.generalAttorneyFields && !vm.partyWorkOrderFields) {
                return false;
            }
            return (
                _.some(vm.requiredFields.concat(vm.optionalFields).concat(vm.generalAttorneyFields), function (field) {
                    return !field || !field.hasOwnProperty('id') || (field.hasOwnProperty('changeState') && field.changeState !== 0);
                }) ||
                _.some(vm.partyWorkOrderFields, function (field) {
                    return !field || !field.hasOwnProperty('id') || (field.hasOwnProperty('changeState') && field.changeState !== 0);
                })
            );
        }

        function hasApprovedLetterOfAttorneyFields() {
            if (!vm.generalAttorneyFields || vm.generalAttorneyFields.length === 0) return false;
            return _.some(vm.generalAttorneyFields, function (field) {
                return field.value;
            });
        }

        function fieldChanged(field) {
            field.changeState = 2;
            // reset the signature so that it will have to be collected again
            vm.signatureUrl = null;
        }

        function getPreviewUrl() {
            return partyService.getConsentFormPreviewUrl(vm.partyDto.id, workOrderId, vm.printLetterOfAttorneyForm);
        }

        function getNoMatchFields() {
            return dataService.getAll('PrivacyFields').then(function (privacyFields) {
                var filteredFields = [];
                if (privacyFields && privacyFields.length > 0) {
                    filteredFields = privacyFields.filter(function (privacyField) {
                        return privacyField.onlyWhenNoMatch;
                    });
                }
                return filteredFields;
            });
        }

        function openSignatureDialog(e) {
            var parentEl = angular.element(document.body);
            if (fieldsHaveChanges()) {
                saveTemporaryChanges(null).then(function () {
                    $mdDialog
                        .show({
                            controller: 'SignatureDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/common/dialogs/signature-dialog/signature-dialog.tmpl.html',
                            parent: parentEl,
                            targetEvent: e,
                            multiple: true,
                            clickOutsideToClose: false,
                        })
                        .then(function (response) {
                            if (response) {
                                vm.signatureUrl = response;
                            }
                        });
                });
            } else {
                $mdDialog
                    .show({
                        controller: 'SignatureDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/common/dialogs/signature-dialog/signature-dialog.tmpl.html',
                        parent: parentEl,
                        targetEvent: e,
                        multiple: true,
                        clickOutsideToClose: false,
                    })
                    .then(function (response) {
                        if (response) {
                            vm.signatureUrl = response;
                        }
                    });
            }
        }

        function retractConsent(e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .multiple(true)
                .title($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.RETRACT_CONSENT'))
                .textContent($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.RETRACT_CONSENT_CONFIRM'))
                .ariaLabel($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.RETRACT_CONSENT'))
                .targetEvent(e)
                .ok($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.RETRACT_CONSENT'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    vm.isSaving = true;
                    partyService.retractConsent(vm.partyId).then(function () {
                        activate();
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function closeDialog() {
            if (!vm.isSigned && !vm.hasStarted) {
                $mdDialog.hide('none');
            } else if (vm.isSigned) {
                $mdDialog.hide('isConsentedData');
            }
            $mdDialog.hide('hasStarted');
        }

        function saveAndCloseDialog() {
            return saveTemporaryChanges(null, true).then(function () {
                return generateAndUploadFiles().then(function () {
                    vm.isSaving = false;
                    return true;
                });
            });
        }

        function generateAndUploadFiles() {
            if (vm.signatureUrl) {
                return dataService.uploadSignature(vm.signatureUrl, vm.partyId).then(function () {
                    return partyService.generateConsentPdf(vm.partyId, workOrderId).then(function (consentFileResponse) {
                        if (referencePersonId && hasApprovedLetterOfAttorneyFields()) {
                            return workOrderReferencePersonService.generateLetterOfAttorneyPdf(referencePersonId).then(function (letterOfAttorneyResponse) {
                                return sendMailAndCloseDialog(consentFileResponse.url, letterOfAttorneyResponse.url);
                            });
                        } else {
                            return sendMailAndCloseDialog(consentFileResponse.url, null);
                        }
                    });
                });
            } else if (vm.useUploadedFile) {
                // TODO: Fix upload of consent files
                // Set privacy options
                if (!vm.partyDto.privacyOptions) {
                    vm.partyDto.privacyOptions = 16;
                } else {
                    vm.partyDto.privacyOptions |= 16;
                }
                var promises = [];
                promises.push(dataService.updateItem('Parties', vm.partyDto));
                if (vm.workOrderReferencePersonDto) {
                    promises.push(dataService.updateItem('ReferencePersons', vm.workOrderReferencePersonDto));
                }
                return $q.all(promises).then(function (uploadedFileResponse) {
                    return sendMailAndCloseDialog(vm.partyDto, uploadedFileResponse.length > 1 ? vm.workOrderReferencePersonDto : null);
                });
            }
        }

        function sendMailAndCloseDialog(signedConsentFileUrl, signedLetterOfAttorneyFileUrl) {
            if (vm.sendSignedCopy && vm.sendSignedCopiesTo.length > 0) {
                // TODO: Actually send the emails
                var transactionalMail = transactionalMailService.getEmptyTransactionalMail();
                transactionalMail.subject = $translate.instant('PARTY.PARTY_PRIVACY_DIALOG.YOUR_COPY_OF_SIGNED_DOCUMENTS');
                transactionalMail.bodyText = $translate.instant(
                    'PARTY.PARTY_PRIVACY_DIALOG.YOUR_COPY_OF_THE_SIGNED_DOCUMENTS_ARE_ATTACHED_AS_PREVIOUSLY_AGREED'
                );
                transactionalMail.to = vm.sendSignedCopiesTo;
                transactionalMail.originType = 'Party';
                transactionalMail.originId = vm.partyId;
                transactionalMail.skipTracking = false;
                transactionalMail.attachments = [];
                if (signedConsentFileUrl) {
                    transactionalMail.attachments.push({
                        reportId: '00000000-0000-0000-0000-000000000000',
                        parameterName: null,
                        parameterId: '00000000-0000-0000-0000-000000000000',
                        filename: ($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.CONSENT_FORM') || 'CForm') + '.pdf',
                        filepath: signedConsentFileUrl,
                    });
                }
                if (signedLetterOfAttorneyFileUrl) {
                    transactionalMail.attachments.push({
                        reportId: '00000000-0000-0000-0000-000000000000',
                        parameterName: null,
                        parameterId: '00000000-0000-0000-0000-000000000000',
                        filename: ($translate.instant('PARTY.PARTY_PRIVACY_DIALOG.LETTER_OF_ATTORNEY_FORM') || 'LForm') + '.pdf',
                        filepath: signedLetterOfAttorneyFileUrl,
                    });
                }
                if (vm.workOrderDto && vm.workOrderDto.departmentId) {
                    transactionalMail.departmentId = vm.workOrderDto.departmentId;
                    return dataService.getById('Departments', vm.workOrderDto.departmentId).then(function (departmentDto) {
                        transactionalMail.from = {
                            email: departmentDto.primaryEmail,
                            name: departmentDto.displayName,
                        };
                        transactionalMailService.sendEmail(transactionalMail).then(function () {
                            $mdDialog.hide('isConsentedData');
                        });
                    });
                } else {
                    return dataService.getCurrentUser().then(function (currentUser) {
                        transactionalMail.from = {
                            email: currentUser.email,
                            name: currentUser.firstName + (currentUser.lastName ? ' ' + currentUser.lastName : ''),
                        };
                        transactionalMailService.sendEmail(transactionalMail).then(function () {
                            $mdDialog.hide('isConsentedData');
                        });
                    });
                }
            } else {
                if (signedConsentFileUrl) {
                    return $mdDialog.hide('isConsentedData');
                } else {
                    return $mdDialog.hide('hasBeenStarted');
                }
            }
        }

        function saveTemporaryChanges(e, dontSetSavingCompletedFlag) {
            vm.isSaving = true;
            var privacyFields = vm.requiredFields.concat(vm.optionalFields);
            // Make sure privacy fields are saved
            if (vm.generalAttorneyFields && vm.generalAttorneyFields.length > 0) {
                privacyFields = privacyFields.concat(vm.generalAttorneyFields);
            }
            var promises = [];
            if (privacyFields.length > 0) {
                privacyFields.forEach(function (privacyField) {
                    if (privacyField.hasOwnProperty('id')) {
                        if (privacyField.hasOwnProperty('changeState') && privacyField.changeState === 2) {
                            privacyField.changeState = 0;
                            promises.push(dataService.updateItem('Privacy/ActivatedPrivacyFields', privacyField));
                        } else if (privacyField.hasOwnProperty('changeState') && privacyField.changeState === 3) {
                            promises.push(dataService.deleteItem('Privacy/ActivatedPrivacyFields', privacyField));
                        }
                    } else {
                        privacyField.changeState = 0;
                        promises.push(dataService.insertItem('Privacy/ActivatedPrivacyFields', privacyField));
                    }
                });
                if (promises.length > 0) {
                    return $q.all(promises).then(function (fieldResponse) {
                        if (vm.consignmentsActivated) {
                            return $q.when($mdDialog.hide('hasBeenStarted'));
                        }
                        return activate();
                    });
                }
            }
            vm.isSaving = dontSetSavingCompletedFlag ? true : false;
            if (vm.consignmentsActivated) {
                return $q.when($mdDialog.hide('hasBeenStarted'));
            }
            return activate();
        }

        function uploadSignedConsentForm(file) {
            if (fieldsHaveChanges()) {
                saveTemporaryChanges(null).then(function () {
                    uploadFile(file, vm.partyDto, 'signedConsentFile');
                });
            } else {
                uploadFile(file, vm.partyDto, 'signedConsentFile');
            }
        }

        function uploadFile(file, target, targetProperty) {
            vm.isSaving = true;
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    vm.isSaving = false;
                    if (resp && resp.data && resp.data.length > 0) {
                        vm.useUploadedFile = true;
                        var baldrisFile = resp.data[0];
                        target[targetProperty + 'Id'] = baldrisFile.id;
                        target[targetProperty + 'Filepath'] = baldrisFile.filepath;
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function uploadSignedLetterOfAttorney(file) {
            if (fieldsHaveChanges()) {
                saveTemporaryChanges(null).then(function () {
                    uploadFile(file, vm.workOrderReferencePersonDto, 'signedLetterOfAttorneyFile');
                });
            } else {
                uploadFile(file, vm.workOrderReferencePersonDto, 'signedLetterOfAttorneyFile');
            }
        }

        function setSignature(useSignatureValue, useFileUploadValue) {
            vm.useSignature = useSignatureValue;
            vm.useUploadedFile = useFileUploadValue;
        }

        function filterFields() {
            vm.requiredFields = getRequiredFields(vm.partyPrivacyFields);
            vm.optionalFields = getOptionalFields(vm.partyPrivacyFields);
            vm.generalAttorneyFields =
                vm.partyWorkOrderFields && vm.partyWorkOrderFields.length > 0 ? vm.partyWorkOrderFields : getGeneralAttorneyFields(vm.partyPrivacyFields);
            if (vm.generalAttorneyFields && vm.generalAttorneyFields.length > 0) {
                vm.printLetterOfAttorneyForm = true;
            }
        }

        function getGeneralAttorneyFields(privacyFields) {
            if (!privacyFields || privacyFields.length === 0) return [];
            return privacyFields.filter(function (privacyField) {
                return privacyField.legalRemarks || privacyField.isWorkOrderField;
            });
        }

        function getRequiredFields(privacyFields) {
            if (!privacyFields || privacyFields.length === 0) return [];
            return privacyFields.filter(function (privacyField) {
                return privacyField.isRequired && !privacyField.legalRemarks;
            });
        }

        function getOptionalFields(privacyFields) {
            if (!privacyFields || privacyFields.length === 0) return [];
            return privacyFields.filter(function (privacyField) {
                return !privacyField.isRequired && !privacyField.legalRemarks;
            });
        }

        function convertToActivatedPrivacyField(privacyField) {
            return {
                value: privacyField.isRequired,
                text: privacyField.text,
                description: privacyField.description,
                legalRemarks: privacyField.legalRemarks,
                remarks: null,
                discriminator: privacyField.discriminator,
                sortOrder: privacyField.sortOrder,
                isRequired: privacyField.isRequired,
                privacyFieldId: privacyField.id,
                partyId: vm.partyId,
                isWorkOrderField: !!privacyField.legalRemarks,
                workOrderId: privacyField.legalRemarks ? workOrderId : null,
                referencePersonId: privacyField.legalRemarks ? referencePersonId : null,
            };
        }

        function getSignatureWidth() {
            if ($window.innerWidth < 600) return $window.innerWidth - 48 + 'px';
            return 552 + 'px';
        }

        function getSignatureHeight() {
            if ($window.innerWidth < 600) return ($window.innerWidth - 48) * 1.414 + 'px';
            return 552 * 1.414 + 'px';
        }

        function readyToSave() {
            var haveChanges = fieldsHaveChanges();
            return (
                !vm.isSaving &&
                !fieldsHaveChanges() &&
                (vm.signatureUrl ||
                    vm.partyDto.signedConsentFileId ||
                    (vm.workOrderReferencePersonDto ? vm.workOrderReferencePersonDto.signedLetterOfAttorneyFileId : false))
            );
        }

        function selectPdf(pdfId) {
            vm.selectedPdf = pdfId;
        }

        function openSigningMethodMenu($mdMenu, e) {
            $mdMenu.open(e);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('NewPartyDialogController', NewPartyDialogController);

    /* @ngInject */
    function NewPartyDialogController($mdDialog, partyService, dataService, apiController) {
        var vm = this;

        //Data
        vm.party = null;
        vm.addresses = [];
        vm.emails = [];
        vm.telephones = [];

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.onPartyTypeChange = onPartyTypeChange;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////
        // Init

        if (apiController === 'Persons') {
            vm.party = partyService.getEmptyPerson();
        } else if (apiController === 'Organizations') {
            vm.party = partyService.getEmptyOrganization();
        }

        /////////////////////
        // PRIVATE METHODS

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addresses[0] && vm.addresses[0].localizedAddress) {
                vm.party.updateOrInsertPrimaryAddressCommand = vm.addresses[0];
            }
            if (vm.emails[0] && vm.emails[0].emailAddress) {
                vm.party.updateOrInsertPrimaryEmailCommand = vm.emails[0];
            }
            if (vm.telephones[0] && vm.telephones[0].telephoneNumber) {
                vm.party.updateOrInsertPrimaryTelephoneCommand = vm.telephones[0];
            }
            dataService.insertItem(apiController || 'Parties', vm.party).then(function (insertedParty) {
                if (insertedParty) {
                    $mdDialog.hide(insertedParty);
                }
            });
        }

        function onPartyTypeChange(partyType) {
            if (partyType === 'ORGANIZATION') {
                vm.party = partyService.getEmptyOrganization();
                apiController = 'Organizations';
            } else {
                vm.party = partyService.getEmptyPerson();
                apiController = 'Persons';
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("ssnInput", {
      bindings: {
        ssn: "=ngModel",
        alwaysShow: "<",
        isRequired: "<",
        isDisabled: "<",
        ssnMaxLength: "<",
        dateOfBirth: "<",
        sex: "<",
        onUpdate: "&"
      },
      templateUrl: "app/main/reference-types/party/components/ssn-input/ssn-input.tmpl.html",
      controller: "SsnInputController as vm"
    })
    .controller("SsnInputController", SsnInputController);

  /* @ngInject */
  function SsnInputController() {
    var vm = this;
    vm.alwaysShow = vm.alwaysShow || false;
    vm.showSsn = false;
    vm.ignoreValidation = false;
    var initialSsnMaxLength = 5;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
      vm.isDisabled = vm.isDisabled || false;
      vm.ssnMaxLength = vm.ssnMaxLength || 5;
      initialSsnMaxLength = vm.ssnMaxLength;
      if (!vm.ssn) {
        vm.showSsn = true;
      } else {
        onSocialSecurityNumberChange();
      }
    };

    //Changes
    vm.$onChanges = function(changesObj) {
      if (changesObj.dateOfBirth) {
        vm.dateOfBirth = changesObj.dateOfBirth.currentValue;
        onSocialSecurityNumberChange();
      }
      if (changesObj.sex) {
        vm.sex = changesObj.sex.currentValue;
        onSocialSecurityNumberChange();
      }
    };

    //Methods
    vm.openMenu = openMenu;
    vm.onSocialSecurityNumberChange = onSocialSecurityNumberChange;
    vm.toggleIgnoreValidation = toggleIgnoreValidation;

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function toggleIgnoreValidation() {
      if (vm.ignoreValidation) {
        vm.ignoreValidation = false;
        vm.ssnMaxLength = initialSsnMaxLength;
        onSocialSecurityNumberChange();
      } else {
        vm.ignoreValidation = true;
        ignoreInvalidSSN();
      }
    }

    function onSocialSecurityNumberChange(sex) {
      sex = sex || vm.sex;
      if (vm.ssn && !vm.ignoreValidation && vm.ssnForm && vm.ssnForm.socialSecurityNumber) {
        if (!vm.dateOfBirth) {
          vm.ssnForm.socialSecurityNumber.$setValidity("missingDateOfBirth", false);
        } else {
          vm.ssnForm.socialSecurityNumber.$setValidity("missingDateOfBirth", true);
          var pno = moment(vm.dateOfBirth).format("DDMMYY") + vm.ssn;
          //Check for valid SSN
          if (pno && pno.length >= 11) {
            //Check for sexMismatch
            var n = parseInt(pno.substr(8, 1));
            if (n % 2 != 0 && sex == "m") {
              vm.ssnForm.socialSecurityNumber.$setValidity("sexMismatch", true);
            } else if (n % 2 != 0 && sex != "m") {
              vm.ssnForm.socialSecurityNumber.$setValidity("sexMismatch", false);
            } else if (n % 2 == 0 && sex == "f") {
              vm.ssnForm.socialSecurityNumber.$setValidity("sexMismatch", true);
            } else {
              vm.ssnForm.socialSecurityNumber.$setValidity("sexMismatch", false);
            }
          }
          if (checkPersonalnumberNo(pno)) {
            vm.ssnForm.socialSecurityNumber.$setValidity("invalidSSN", true);
          } else {
            vm.ssnForm.socialSecurityNumber.$setValidity("invalidSSN", false);
          }
        }
      }
    }

    function ignoreInvalidSSN() {
      vm.ssnMaxLength = 250;

      vm.ssnForm.socialSecurityNumber.$setValidity("invalidSSN", true);
      vm.ssnForm.socialSecurityNumber.$setValidity("sexMismatch", true);
      vm.ssnForm.socialSecurityNumber.$setValidity("missingDateOfBirth", true);
      vm.ssnForm.socialSecurityNumber.$setValidity("md-maxlength", true);
      vm.ssnForm.socialSecurityNumber.$setValidity("ng-maxlength", true);

      vm.ssn = vm.ssnForm.socialSecurityNumber.$viewValue;
    }

    // CODE from: http://www.webforumet.no/forum/threads/direkte-personnummer-validering.11496/
    // Author: Pong
    function checkPersonalnumberNo(pno) {
      // Check length
      if (pno.length != 11) return false;

      // Split
      var day = pno.substr(0, 2);
      var month = pno.substr(2, 2);
      var year = pno.substr(4, 2);
      var ind = pno.substr(6, 3);
      var c1 = pno.substr(9, 1);
      var c2 = pno.substr(10, 1);
      var yearno = parseInt(year, 10);

      if (ind > 0 && ind < 500) {
        yearno += 1900;
      } else if (ind > 499 && ind < 750 && year > 55 && year < 100) {
        yearno += 1800;
      } else if (ind > 499 && ind < 999 && year >= 0 && year < 40) {
        yearno += 2000;
      } else if (ind > 899 && ind < 999 && year > 39 && year < 100) {
        yearno += 1900;
      } else {
        return false;
      }

      var d1 = parseInt(day.substr(0, 1));
      var d2 = parseInt(day.substr(1, 1));
      var m1 = parseInt(month.substr(0, 1));
      var m2 = parseInt(month.substr(1, 1));
      var a1 = parseInt(year.substr(0, 1));
      var a2 = parseInt(year.substr(1, 1));
      var i1 = parseInt(ind.substr(0, 1));
      var i2 = parseInt(ind.substr(1, 1));
      var i3 = parseInt(ind.substr(2, 1));

      // Calculate control check c1
      var c1calc = 11 - ((3 * d1 + 7 * d2 + 6 * m1 + m2 + 8 * a1 + 9 * a2 + 4 * i1 + 5 * i2 + 2 * i3) % 11);
      if (c1calc == 11) c1calc = 0;
      if (c1calc == 10) return false;
      if (c1 != c1calc) return false;

      // Calculate control check c2
      var c2calc =
        11 - ((5 * d1 + 4 * d2 + 3 * m1 + 2 * m2 + 7 * a1 + 6 * a2 + 5 * i1 + 4 * i2 + 3 * i3 + 2 * c1calc) % 11);
      if (c2calc == 11) c2calc = 0;
      if (c2calc == 10) return false;
      if (c2 != c2calc) return false;

      return true;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('personCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/reference-types/party/components/person-card/person-card.tmpl.html',
            controller: 'PersonCardController as vm',
        })
        .controller('PersonCardController', PersonCardController);

    /* @ngInject */
    function PersonCardController($mdDialog, $document, $state, $translate, $mdToast, maritalStatusOptions) {
        var vm = this;
        vm.maritalStatusArray = [];
        vm.navigateToPerson = navigateToPerson;
        vm.deletePerson = deletePerson;
        vm.getFormattedNumber = getFormattedNumber;

        //Init
        angular.forEach(maritalStatusOptions, function (option) {
            if (vm.baldrisModel.maritalStatus & option.value) {
                vm.maritalStatusArray.push(option.text);
            }
        });

        function navigateToPerson(person) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(person);
                } else {
                    $state.go('app.person.byId', { id: person.id });
                }
            }
        }

        function deletePerson(person) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(person);
                }
            }
        }

        function getFormattedNumber(telephoneObject) {
            if (telephoneObject && telephoneObject.telephoneNumber) {
                return phoneUtils.formatNational(telephoneObject.telephoneNumber, telephoneObject.isoCode2 || 'NO');
            }
            return null;
        }        

        //TRANSLATIONS
        var savedText;
        $translate('DECEASED.EDIT-DECEASED-DIALOG.SAVED-TEXT').then(function (translation) {
            savedText = translation;
        });
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('partySelect', {
            bindings: {
                partyId: '=',
                party: '=',
                onSelected: '=',
                partyConfig: '=',
                labelText: '@',
                minQueryLength: '=',
                displayText: '=',
            },
            templateUrl: 'app/main/reference-types/party/components/party-select/party-select.tmpl.html',
            controller: 'PartySelectController as vm',
        })
        .controller('PartySelectController', PartySelectController);

    /* @ngInject */
    function PartySelectController($filter, dataService, partyService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.openSearchDialog = openSearchDialog;

        vm.$onInit = function () {
            //Get Current Location
            if (vm.partyId) {
                dataService.getById('Parties', vm.partyId).then(function (party) {
                    vm.party = party;
                });
            }

            vm.minLength = 1;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        // ******************************
        // Internal methods
        // ******************************

        function querySearch(query) {
            if (vm.partyConfig) {
                return dataService.getByConfigName('Parties', vm.partyConfig).then(function (parties) {
                    parties = parties.data || parties;
                    if (query) {
                        parties = $filter('filter')(parties, query);
                    }
                    return $filter('orderBy')(parties, 'displayName');
                });
            } else {
                if (query) {
                    return dataService.search('Parties', query).then(function (parties) {
                        parties = parties.data || parties;
                        parties = $filter('filter')(parties, {
                            isDeleted: false,
                        });
                        return $filter('orderBy')(parties, 'displayName');
                    });
                }
            }
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.partyId = item.id;
                vm.partyForm.party.$setValidity('invalidParty', true);
            } else {
                if (vm.partyId && vm.partyId !== '00000000-0000-0000-0000-000000000000') {
                    // Set dirty
                    vm.partyForm.$setDirty();
                }
                vm.partyId = null;
                if (vm.searchText) {
                    vm.partyForm.party.$setValidity('invalidParty', false);
                }
            }
        }

        function openSearchDialog(e) {
            partyService.showSearchDialog(e, 'Parties', null, false, true).then(function (selectedParty) {
                if (selectedParty) {
                    vm.party = selectedParty;
                    vm.partyId = selectedParty.id;
                    vm.partyForm.$setDirty();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('partyPrivacySummary', {
            bindings: {
                partyId: '=',
                partyPrivacyOptions: '=',
                referencePersonId: '=',
                referencePersonTypeMask: '=',
                workOrderId: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/party/components/party-privacy-summary/party-privacy-summary.tmpl.html',
            controller: 'PartyPrivacySummaryController as vm',
        })
        .controller('PartyPrivacySummaryController', PartyPrivacySummaryController);

    /* @ngInject */
    function PartyPrivacySummaryController($mdDialog, $q, dataService, loadingService, signatureJobService) {
        var vm = this;

        var NOT_STARTED = 'notStarted';
        var STARTED = 'started';
        var AWAITING_SIGNATURE = 'awaitingSignature';
        var FINISHED = 'finished';

        vm.isLoading = false;
        vm.isContractor = false;
        vm.consignmentsActivated = false;
        vm.privacyFieldsActivated = false;
        vm.consentFormStatus = NOT_STARTED;
        vm.letterOfAttorneyStatus = NOT_STARTED;

        vm.isPrivacySet = isPrivacySet;
        vm.openPartyPrivacyDialog = openPartyPrivacyDialog;
        vm.isPrivacyExempt = isPrivacyExempt;
        vm.isPseudomized = isPseudomized;
        vm.isConsignmentsFinished = isConsignmentsFinished;
        vm.isConsignmentsStarted = isConsignmentsStarted;
        vm.isConsignmentsAwaitingSignatures = isConsignmentsAwaitingSignatures;

        // Ux
        vm.getPrivacyIcon = getPrivacyIcon;
        vm.getPrivacyIconClass = getPrivacyIconClass;
        vm.getHeaderText = getHeaderText;
        vm.getSubheaderText = getSubheaderText;

        vm.$onInit = function () {
            vm.isContractor = vm.referencePersonTypeMask.indexOf('contractor') > -1;
            if (!isPrivacyExempt()) {
                vm.isLoading = true;
                loadingService.setBackgroundLoadingStatus(true);
                var promises = [];

                promises.push(signatureJobService.getConsignmentsActivated());
                promises.push(dataService.getByUri('Privacy', 'ActivatedPrivacyFields/ByReferencePersonId/' + vm.referencePersonId));
                promises.push(signatureJobService.getRelevantSignatureJobsByWorkOrderId(vm.workOrderId, vm.referencePersonId));

                $q.all(promises)
                    .then(function (response) {
                        vm.consignmentsActivated = response[0] && vm.partyPrivacyOptions && vm.partyPrivacyOptions.indexOf('isDeceasedEntity') === -1;
                        vm.privacyFieldsActivated = response[1] && response[1].length > 0;
                        if (vm.privacyFieldsActivated) {
                            // We only check if we have activated fields as that's a prerequisite for
                            // having consent form & letter of attorney
                            checkConsentFormConsignment(response[2]);
                            if (vm.referencePersonTypeMask.indexOf('contractor') > -1) {
                                checkLetterOfAttorneyConsignment(response[2]);
                            }
                        }
                    })
                    .finally(function () {
                        vm.isLoading = false;
                        loadingService.setBackgroundLoadingStatus(false);
                        vm.onUpdate({
                            privacyFieldsActivated: vm.privacyFieldsActivated,
                            consentFormStatus: vm.consentFormStatus,
                            letterOfAttorneyStatus: vm.letterOfAttorneyStatus,
                        });
                    });
            }
        };

        function checkConsentFormConsignment(consignmentStatuses) {
            if (!consignmentStatuses || consignmentStatuses.length === 0) return;

            var consentFormStatus = consignmentStatuses.find(function (cs) {
                return cs.internalName === 'PrivacyConsentFormWorkOrder';
            });

            if (!consentFormStatus) return;

            if (consentFormStatus.hasSigned) {
                vm.consentFormStatus = FINISHED;
            } else if (consentFormStatus.signatureJobId) {
                vm.consentFormStatus = AWAITING_SIGNATURE;
            } else {
                vm.consentFormStatus = STARTED;
            }
        }

        function checkLetterOfAttorneyConsignment(consignmentStatuses) {
            if (!consignmentStatuses || consignmentStatuses.length === 0) return;

            var letterOfAttorneyStatus = consignmentStatuses.find(function (cs) {
                return cs.internalName === 'GeneralLetterOfAttorney';
            });

            if (!letterOfAttorneyStatus) return;

            if (letterOfAttorneyStatus.hasSigned) {
                vm.letterOfAttorneyStatus = FINISHED;
            } else if (letterOfAttorneyStatus.signatureJobId) {
                vm.letterOfAttorneyStatus = AWAITING_SIGNATURE;
            } else {
                vm.letterOfAttorneyStatus = STARTED;
            }
        }

        function isPrivacySet() {
            if (!vm.partyPrivacyOptions) return false;

            return (
                vm.partyPrivacyOptions.indexOf('none') === -1 &&
                vm.partyPrivacyOptions.indexOf('hasBeenStarted') === -1 &&
                !isPrivacyExempt() &&
                !isPseudomized()
            );
        }

        function isConsignmentsFinished() {
            return vm.consentFormStatus === FINISHED && (!vm.isContractor || vm.letterOfAttorneyStatus === FINISHED);
        }

        function isConsignmentsStarted() {
            return isConsignmentsAwaitingSignatures() || vm.consentFormStatus === STARTED || vm.letterOfAttorneyStatus === STARTED;
        }

        function isConsignmentsAwaitingSignatures() {
            return vm.consentFormStatus === AWAITING_SIGNATURE || vm.letterOfAttorneyStatus === AWAITING_SIGNATURE;
        }

        function isPrivacyExempt() {
            if (!vm.partyPrivacyOptions) return false;
            return vm.partyPrivacyOptions.indexOf('exemptFromGdpr') > -1;
        }

        function isPseudomized() {
            if (!vm.partyPrivacyOptions) return false;
            return vm.partyPrivacyOptions.indexOf('isPseudomized') > -1;
        }

        function openPartyPrivacyDialog(e) {
            var parentEl = angular.element(document.body);
            $mdDialog
                .show({
                    controller: 'PartyPrivacyDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/reference-types/party/dialogs/party-privacy-dialog/party-privacy-dialog.tmpl.html',
                    parent: parentEl,
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        partyId: vm.partyId,
                        referencePersonId: vm.referencePersonId,
                        referencePersonTypeMask: vm.referencePersonTypeMask,
                        workOrderId: vm.workOrderId,
                    },
                    clickOutsideToClose: true,
                    resolve: {
                        /* @ngInject */
                        consignmentsActivated: function (signatureJobService) {
                            return signatureJobService.getConsignmentsActivated();
                        },
                    },
                })
                .then(function (response) {
                    if (response !== 'hasStarted') {
                        vm.partyPrivacyOptions = response;
                    }
                    vm.$onInit();
                });
        }

        var ICON_OK = 'icon-thumb-up-outline';
        var ICON_HEADS_UP = 'icon-bell-ring';
        var ICON_ALERT = 'icon-alert';
        function getPrivacyIcon() {
            if (vm.consignmentsActivated) {
                if (vm.isConsignmentsFinished() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                    return ICON_OK;
                }
                if (vm.isPseudomized()) {
                    return ICON_HEADS_UP;
                }
                return ICON_ALERT;
            }

            if (vm.isPrivacySet() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                return ICON_OK;
            }
            if (vm.isPseudomized()) {
                return ICON_HEADS_UP;
            }
            return ICON_ALERT;
        }

        var GREEN_FOREGROUND = 'green-600-fg';
        var YELLOW_FOREGROUND = 'amber-500-fg';
        var ORANGE_FOREGROUND = 'amber-800-fg';
        var RED_FOREGROUND = 'red-500-fg';
        function getPrivacyIconClass() {
            if (vm.consignmentsActivated) {
                if (vm.isConsignmentsFinished() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                    return GREEN_FOREGROUND;
                }
                if (vm.isPseudomized() || (vm.isConsignmentsStarted() && vm.isConsignmentsAwaitingSignatures())) {
                    return YELLOW_FOREGROUND;
                }
                if (vm.isConsignmentsStarted() && !vm.isConsignmentsAwaitingSignatures()) {
                    return ORANGE_FOREGROUND;
                }
                return RED_FOREGROUND;
            }

            if (vm.isPrivacySet() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                return GREEN_FOREGROUND;
            }
            if (vm.isPseudomized()) {
                return YELLOW_FOREGROUND;
            }
            return RED_FOREGROUND;
        }

        var PRIVACY_SET_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_SET';
        var PRIVACY_EXEMPT_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_EXEMPT';
        var PRIVACY_PSEUDOMIZED_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_PSEUDOMIZED';
        var PRIVACY_STARTED_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_CONSENT_STARTED';
        var PRIVACY_NOT_SET_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_NOT_SET';
        function getHeaderText() {
            if (vm.consignmentsActivated) {
                if (vm.isConsignmentsFinished()) {
                    return PRIVACY_SET_TEXT;
                }
                if (vm.isPrivacyExempt() && !vm.isPseudomized()) {
                    return PRIVACY_EXEMPT_TEXT;
                }
                if (vm.isPseudomized()) {
                    return PRIVACY_PSEUDOMIZED_TEXT;
                }
                if (vm.isConsignmentsStarted()) {
                    return PRIVACY_STARTED_TEXT;
                }
                return PRIVACY_NOT_SET_TEXT;
            }

            if (vm.isPrivacySet()) {
                return PRIVACY_SET_TEXT;
            }
            if (vm.isPrivacyExempt() && !vm.isPseudomized()) {
                return PRIVACY_EXEMPT_TEXT;
            }
            if (vm.isPseudomized()) {
                return PRIVACY_PSEUDOMIZED_TEXT;
            }
            return PRIVACY_NOT_SET_TEXT;
        }

        var ALL_GOOD_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_ALL_GOOD';
        var PARTY_PSEUDOMIZED_TEXT = 'PARTY.EDIT_PARTY.PSEUDOMIZED';
        var NOT_SENT_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_CONSENT_NOT_SENT';
        var AWAITING_SIGNATURE_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_CONSENT_AWAITING_SIGNATURE';
        var NEEDS_REVIEW_TEXT = 'PARTY.EDIT_PARTY.PRIVACY_NEEDS_REVIEW';
        function getSubheaderText() {
            if (vm.consignmentsActivated) {
                if (vm.isConsignmentsFinished() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                    return ALL_GOOD_TEXT;
                }
                if (vm.isPseudomized()) {
                    return PARTY_PSEUDOMIZED_TEXT;
                }
                if (vm.isConsignmentsStarted() && !vm.isConsignmentsAwaitingSignatures()) {
                    return NOT_SENT_TEXT;
                }
                if (vm.isConsignmentsStarted() && vm.isConsignmentsAwaitingSignatures()) {
                    return AWAITING_SIGNATURE_TEXT;
                }
                return NEEDS_REVIEW_TEXT;
            }

            if (vm.isPrivacySet() || (vm.isPrivacyExempt() && !vm.isPseudomized())) {
                return ALL_GOOD_TEXT;
            }
            if (vm.isPseudomized()) {
                return PARTY_PSEUDOMIZED_TEXT;
            }
            return NEEDS_REVIEW_TEXT;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('organizationCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/reference-types/party/components/organization-card/organization-card.tmpl.html',
            controller: 'OrganizationCardController as vm',
        })
        .controller('OrganizationCardController', OrganizationCardController);

    /* @ngInject */
    function OrganizationCardController($mdDialog, $document, $state, $translate, $mdToast) {
        var vm = this;
        vm.maritalStatusArray = [];
        vm.navigateToOrganization = navigateToOrganization;
        vm.deleteOrganization = deleteOrganization;
        vm.getFormattedNumber = getFormattedNumber;

        //Init

        function navigateToOrganization(organization) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(organization);
                } else {
                    $state.go('app.organization.byId', { id: organization.id });
                }
            }
        }

        function deleteOrganization(organization) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(organization);
                }
            }
        }

        function getFormattedNumber(telephoneObject) {
            if (telephoneObject && telephoneObject.telephoneNumber) {
                return phoneUtils.formatNational(telephoneObject.telephoneNumber, telephoneObject.isoCode2 || 'NO');
            }
            return null;
        }

        //TRANSLATIONS
        var savedText;
        $translate('DECEASED.EDIT-DECEASED-DIALOG.SAVED-TEXT').then(function (translation) {
            savedText = translation;
        });
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('editParty', {
            bindings: {
                baldrisModel: '=',
                showDeathDate: '=',
                showAddresses: '=',
                showEmails: '=',
                showTelephones: '=',
                showRemarks: '=',
                onChange: '=',
                isDisabled: '=',
                includeSsn: '=',
            },
            templateUrl:
                'app/main/reference-types/party/components/edit-party/edit-party.tmpl.html',
            controller: 'EditPartyComponentController as vm',
        })
        .controller(
            'EditPartyComponentController',
            EditPartyComponentController
        );

    /* @ngInject */
    function EditPartyComponentController() {
        var vm = this;
        vm.partyChanged = partyChanged;
        vm.isOrganization = isOrganization;

        function partyChanged() {
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.baldrisModel);
            }
            if (vm.partyForm && vm.partyForm.$dirty) {
                if (
                    vm.baldrisModel.id &&
                    vm.baldrisModel.id != '00000000-0000-0000-0000-000000000000'
                ) {
                    vm.baldrisModel.changeState = 2;
                } else {
                    vm.baldrisModel.changeState = 1;
                }
                //Update displayName
                if (!isOrganization()) {
                    vm.baldrisModel.displayName = vm.baldrisModel.lastName
                        ? vm.baldrisModel.lastName +
                          (vm.baldrisModel.firstName
                              ? ', ' + vm.baldrisModel.firstName
                              : '')
                        : vm.baldrisModel.firstName
                        ? vm.baldrisModel.firstName
                        : '';
                } else {
                    vm.baldrisModel.displayName = vm.baldrisModel
                        .preferShortName
                        ? vm.baldrisModel.shortName
                        : vm.baldrisModel.name;
                }
            }
        }

        function isOrganization() {
            return (
                vm.baldrisModel &&
                vm.baldrisModel.hasOwnProperty('organizationNumber')
            );
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("deathDateSelect", {
      bindings: {
        dateOfDeath: "=ngModel",
        isDisabled: "=",
        isRequired: "<",
        allowApproximate: "<",
        approximateModel: "=",
        dateOfBirth: "=",
        maxTime: "=",
        minTime: "=",
        maxText: "@",
        minText: "@",
        onUpdate: "&"
      },
      templateUrl: "app/main/reference-types/party/components/death-date-select/death-date-select.tmpl.html",
      controller: "DeathDateSelectController as vm"
    })
    .controller("DeathDateSelectController", DeathDateSelectController);

  /* @ngInject */
  function DeathDateSelectController() {
    var vm = this;
    vm.showApproximate = false;
    vm.showTimePart = false;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
      if (vm.dateOfDeath) {
        var m = moment(vm.dateOfDeath);
        if (m.isValid()) {
          vm.timePart = m.format("LT");
        }
      }
      if (vm.allowApproximate && vm.approximateModel) {
        vm.showApproximate = true;
      }
    };

    // Methods
    vm.datePartChanged = datePartChanged;
    vm.timePartChanged = timePartChanged;
    vm.approximateChanged = approximateChanged;
    vm.toggleApproximate = toggleApproximate;
    vm.openMenu = openMenu;

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function setTimeValidation(isValid) {
      if (vm.deathDateForm.timePart) {
        vm.deathDateForm.timePart.$setValidity("invalidTime", isValid);
      }
    }

    function setTimePart() {
      var timeMoment = moment(vm.timePart, "LT");
      if (timeMoment.isValid()) {
        var dateMoment = moment(vm.dateOfDeath);
        dateMoment.hour(timeMoment.hour());
        dateMoment.minute(timeMoment.minute());
        vm.dateOfDeath = dateMoment.format("YYYY-MM-DDTHH:mm:ss");
        setTimeValidation(true);
      } else {
        setTimeValidation(false);
      }
    }

    function datePartChanged() {
      if (!vm.dateOfDeath) {
        vm.timePart = null;
      } else {
        if (vm.dateOfBirth) {
          if (moment(vm.dateOfBirth).isAfter(vm.dateOfDeath, "day")) {
            vm.deathDateForm.datePart.$setValidity("beforeBirth", false);
          } else {
            vm.deathDateForm.datePart.$setValidity("beforeBirth", true);
          }
        }
        if (vm.timePart) {
          var dateMoment = moment(vm.dateOfDeath);
          if (dateMoment.isValid()) {
            setTimePart();
          }
        } else {
          vm.timePart = moment(vm.dateOfDeath).format("LT");
          setTimePart();
        }
      }
    }

    function timePartChanged() {
      if (!vm.dateOfDeath) {
        vm.dateOfDeath = moment().format("YYYY-MM-DDTHH:mm:ss");
      }
      if (!vm.timePart) {
        vm.timePart = moment()
          .startOf("day")
          .format("LT");
      }
      setTimePart();
    }

    function approximateChanged() {
      vm.dateOfDeath = null;
    }

    function toggleApproximate(value) {
      if (value) {
        vm.showTimePart = false;
        vm.deathDateForm.datePart.$setValidity("valid", true);
        vm.deathDateForm.datePart.$setValidity("required", true);
        vm.deathDateForm.datePart.$setValidity("mindate", true);
        vm.deathDateForm.datePart.$setValidity("maxdate", true);
        vm.deathDateForm.datePart.$setValidity("beforeBirth", true);
        vm.dateOfDeath = null;
      } else {
        vm.approximateModel = null;
        vm.deathDateForm.approximatePart.$setValidity("required", true);
      }

      vm.showApproximate = value;
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("birthDateSelect", {
      bindings: {
        dateOfBirth: "=ngModel",
        isDisabled: "=",
        isRequired: "<",
        allowApproximate: "<",
        approximateModel: "=",
        dateOfDeath: "=",
        maxTime: "=",
        minTime: "=",
        maxText: "@",
        minText: "@",
        onUpdate: "&"
      },
      templateUrl: "app/main/reference-types/party/components/birth-date-select/birth-date-select.tmpl.html",
      controller: "BirthDateSelectController as vm"
    })
    .controller("BirthDateSelectController", BirthDateSelectController);

  /* @ngInject */
  function BirthDateSelectController() {
    var vm = this;
    vm.showApproximate = false;
    vm.showTimePart = false;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
      if (vm.dateOfBirth) {
        var m = moment(vm.dateOfBirth);
        if (m.isValid()) {
          vm.timePart = m.format("LT");
        }
      }
      if (vm.allowApproximate && vm.approximateModel) {
        vm.showApproximate = true;
      }
    };

    // Methods
    vm.datePartChanged = datePartChanged;
    vm.timePartChanged = timePartChanged;
    vm.approximateChanged = approximateChanged;
    vm.toggleApproximate = toggleApproximate;
    vm.openMenu = openMenu;

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function setTimeValidation(isValid) {
      if (vm.birthDateForm.timePart) {
        vm.birthDateForm.timePart.$setValidity("invalidTime", isValid);
      }
    }

    function setTimePart() {
      var timeMoment = moment(vm.timePart, "LT");
      if (timeMoment.isValid()) {
        var dateMoment = moment(vm.dateOfBirth);
        dateMoment.hour(timeMoment.hour());
        dateMoment.minute(timeMoment.minute());
        vm.dateOfBirth = dateMoment.format("YYYY-MM-DDTHH:mm:ss");
        setTimeValidation(true);
      } else {
        setTimeValidation(false);
      }
    }

    function datePartChanged() {
      if (!vm.dateOfBirth) {
        vm.timePart = null;
      } else {
        if (vm.dateOfDeath) {
          if (moment(vm.dateOfBirth).isAfter(vm.dateOfDeath, "day")) {
            vm.birthDateForm.datePart.$setValidity("afterDeath", false);
          } else {
            vm.birthDateForm.datePart.$setValidity("afterDeath", true);
          }
        }
        if (vm.timePart) {
          var dateMoment = moment(vm.dateOfBirth);
          if (dateMoment.isValid()) {
            setTimePart();
          }
        } else {
          vm.timePart = moment(vm.dateOfBirth).format("LT");
          setTimePart();
        }
      }
    }

    function timePartChanged() {
      if (!vm.dateOfBirth) {
        vm.dateOfBirth = moment().format("YYYY-MM-DDTHH:mm:ss");
      }
      if (!vm.timePart) {
        vm.timePart = moment()
          .startOf("day")
          .format("LT");
      }
      setTimePart();
    }

    function approximateChanged() {
      vm.dateOfBirth = null;
    }

    function toggleApproximate(value) {
      if (value) {
        vm.showTimePart = false;
        vm.birthDateForm.datePart.$setValidity("valid", true);
        vm.birthDateForm.datePart.$setValidity("required", true);
        vm.birthDateForm.datePart.$setValidity("mindate", true);
        vm.birthDateForm.datePart.$setValidity("maxdate", true);
        vm.birthDateForm.datePart.$setValidity("afterDeath", true);
        vm.dateOfBirth = null;
      } else {
        vm.approximateModel = null;
        vm.birthDateForm.approximatePart.$setValidity("required", true);
      }

      vm.showApproximate = value;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('participantRoleSelect', {
            bindings: {
                participantRole: '=',
                participantRoleId: '=',
                onSelected: '=',
                labelText: '@',
                minQueryLength: '=',
                displayText: '='
            },
            templateUrl: 'app/main/reference-types/participant-role/components/participant-role-select/participant-role-select.tmpl.html',
            controller: 'ParticipantRoleSelectController as vm',
        })
        .controller('ParticipantRoleSelectController', ParticipantRoleSelectController);

    /* @ngInject */
    function ParticipantRoleSelectController($filter, dataService) {
        var vm = this;
        
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        vm.$onInit = function () {
            //Get Current participantRole
            if (vm.participantRoleId && !vm.participantRole) {
                dataService.getById('ParticipantRoles', vm.participantRoleId).then(function (participantRole) {
                    vm.participantRole = participantRole;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }


        
        // ******************************
        // Internal methods
        // ******************************

        function querySearch(query) {
            return dataService.search('ParticipantRoles', query).then(function (participantRoles) {
                return $filter('orderBy')(participantRoles, 'name');
            });
        }

        function searchTextChange(text) {

        }
        
        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.participantRoleId = item.id;
                vm.participantRoleForm.participantRole.$setValidity('invalidRole',true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.participantRoleId = null;
                if (vm.searchText) {
                    vm.participantRoleForm.participantRole.$setValidity('invalidRole',false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function() {
  "use strict";

  angular.module("app.referenceTypes").controller("SearchParticipantDialogController", SearchParticipantDialogController);

  /* @ngInject */
  function SearchParticipantDialogController($q, $mdDialog, $filter, $translate, asDto, allowAdditions, dataService, participantService) {
    var vm = this;

    //Data
    vm.selectedParticipant = null;
    vm.selectedParticipantType = null;
    vm.participantTypes = [];
    vm.isSearching = false;
    vm.isLoadingParticipant = false;
    vm.showOnlyFromWorkOrder = false;
    vm.allowAdditions = allowAdditions || false;

    // Methods
    vm.closeDialog = closeDialog;
    vm.onSearchChange = onSearchChange;
    vm.selectItem = selectItem;
    vm.selectParticipantType = selectParticipantType;
    vm.openAddParticipantDialog = openAddParticipantDialog;

    //////////
    // Init

    activate();

    ////////////////////
    // PRIVATE METHODS

    function activate() {
      // Get Participant Types
      var promises = [];
      promises.push(dataService.getAll("ParticipantTypes"));
      vm.isSearching = true;
      $q.all(promises).then(function(result) {
        vm.participantTypes = result[0];
        // Add special types
        var allParticipantType = _.find(vm.participantTypes, { id: "all" });
        if (!allParticipantType) {
          allParticipantType = {
            id: "all",
            name: $translate.instant("PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.ALL_PARTICIPANTS"),
            sortOrder: -10
          };
          vm.participantTypes.push(allParticipantType);
        }
        vm.selectedParticipantType = allParticipantType;
        // Initial search
        onSearchChange();
      });
    }

    function closeDialog(selectedParticipant) {
      if (selectedParticipant) {
        if (asDto) {
          vm.isLoadingParticipant = true;
          dataService.getById("Participants", selectedParticipant.id, true).then(function(selectedItem) {
            $mdDialog.hide(selectedItem);
            vm.isLoadingParticipant = false;
          });
        } else {
          $mdDialog.hide(selectedParticipant);
        }
      } else {
        $mdDialog.hide(selectedParticipant);
      }
    }

    function selectParticipantType(participantType) {
      vm.selectedParticipantType = participantType;
      vm.searchResults = [];
      onSearchChange();
    }

    function onSearchChange() {
      if (vm.searchText && vm.searchText.length > 0) {
        vm.isSearching = true;
        if (vm.selectedParticipantType && vm.selectedParticipantType.id) {
          vm.isSearching = true;
          if (vm.selectedParticipantType.id === "all") {
            dataService.search("Participants", vm.searchText).then(function(searchResults) {
              searchResults = $filter("filter")(searchResults, { isDeleted: false });
              searchResults = $filter("orderBy")(searchResults, "partyDisplayName");
              vm.searchResults = searchResults;
              vm.isSearching = false;
            });
          } else {
            dataService
              .search("Participants", vm.searchText, null, null, {
                searchString: vm.searchText,
                participantTypeIds: [vm.selectedParticipantType.id]
              })
              .then(function(searchResults) {
                searchResults = $filter("filter")(searchResults, { isDeleted: false });
                searchResults = $filter("orderBy")(searchResults, "partyDisplayName");
                vm.searchResults = searchResults;
                vm.isSearching = false;
              });
          }
        } else {
          vm.searchResults = [];
        }
      } else {
        // Get All
        if (vm.selectedParticipantType && vm.selectedParticipantType.id) {
          vm.isSearching = true;
          if (vm.selectedParticipantType.id === "all") {
            dataService.getAll("Participants").then(function(searchResults) {
              searchResults = $filter("filter")(searchResults, { isDeleted: false });
              searchResults = $filter("orderBy")(searchResults, "partyDisplayName");
              vm.searchResults = searchResults;
              vm.isSearching = false;
            });
          } else {
            dataService.getByTypeId("Participants", vm.selectedParticipantType.id).then(function(searchResults) {
              searchResults = $filter("filter")(searchResults, { isDeleted: false });
              searchResults = $filter("orderBy")(searchResults, "partyDisplayName");
              vm.searchResults = searchResults;
              vm.isSearching = false;
            });
          }
        } else {
          vm.searchResults = [];
          vm.isSearching = false;
        }
      }
    }

    function selectItem(item) {
      if (item) {
        if (!vm.selectedParticipant) {
          vm.selectedParticipant = item;
        } else if (item.id === vm.selectedParticipant.id) {
          vm.selectedParticipant = null;
        } else {
          vm.selectedParticipant = item;
        }
      } else {
        vm.selectedParticipant = null;
      }
    }

    function openAddParticipantDialog(e) {
      participantService.showEditParticipantDialog(e, "new", false).then(function(insertedParticipant) {
        if (insertedParticipant) {
          closeDialog(insertedParticipant);
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditParticipantDialogController', EditParticipantDialogController);

    /* @ngInject */
    function EditParticipantDialogController($filter, $mdDialog, dataService, participantService, partyService, loadingService, participantId, participantTypeIds, asDto) {
        var vm = this;

        vm.updateModel = null;
        vm.isNew = false;
        vm.loadingService = loadingService;
        vm.isSearching = false;

        vm.onNameChange = onNameChange;
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////
        // Init

        activate();


        ////////////////////
        // PRIVATE METHODS

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            if (participantId && participantId !== 'new' && participantId !== '00000000-0000-0000-0000-000000000000') {
                // Load updatemodel
                dataService.getUpdateModel('Participants', participantId).then(function (updateModel) {
                    vm.updateModel = updateModel;
                    vm.loadingService.setLoadingStatus(false);
                })
            } else {
                // Set as new
                vm.isNew = true;
                vm.updateModel = {
                    participant: participantService.getEmptyParticipant(),
                    partyUpdateModel: {
                        party: partyService.getEmptyPerson()
                    },
                    participantTypeParticipants: [],
                    participantProducts: [],
                    participantAutoTasks: []
                };
                vm.updateModel.participant.changeState = 1;
                vm.updateModel.partyUpdateModel.party.changeState = 1;

                // TODO: Fetch pre-determined participantTypes
                vm.loadingService.setLoadingStatus(false);
            }
        }

        function searchPersons() {
            var searchText = vm.updateModel.party.lastName;
            if (vm.updateModel.party.firstName) {
                if (searchText) {
                    searchText += ', ' + vm.updateModel.party.firstName;
                } else {
                    searchText = vm.updateModel.party.firstName;
                }
            }

            if (searchText) {
                vm.isSearching = true;
                vm.searchResults = [];
                dataService.search('Persons', searchText).then(function (searchResults) {
                    searchResults = $filter('filter')(searchResults, {isDeleted: false});
                    searchResults = $filter('orderBy')(searchResults, 'displayName');
                    vm.searchResults = searchResults;
                    vm.isSearching = false;
                });
            }
        }

        function onNameChange() {
            // Only start search if we have both a first and last name
            if (vm.isNew && vm.updateModel.party.firstName && vm.updateModel.party.lastName) {
                searchPersons();
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            dataService.updateFromUpdateModel('Participants', vm.updateModel).then(function (insertedData) {
                dataService.getById('Participants', insertedData.participant.id).then(function (participantFdo) {
                    $mdDialog.hide(participantFdo);
                });
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('municipalitySelect', {
            bindings: {
                municipalityId: '=',
                municipality: '=',
                onSelected: '=',
                labelText: '@',
                municipalityConfig: '=',
                minQueryLength: '=',
                displayText: '=',
            },
            templateUrl: 'app/main/reference-types/municipality/components/municipality-select/municipality-select.tmpl.html',
            controller: 'MunicipalitySelectController as vm',
        })
        .controller('MunicipalitySelectController', MunicipalitySelectController);

    /* @ngInject */
    function MunicipalitySelectController($filter, dataService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current Municipality
            if (vm.municipalityId) {
                dataService.getById('Municipalities', vm.municipalityId, true).then(function (municipality) {
                    vm.municipality = municipality;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        vm.isDisabled = true;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            return dataService.search('Municipalities', query).then(function (municipalities) {
                municipalities = municipalities.data || municipalities;
                return $filter('orderBy')(municipalities, 'name');
            });
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.municipalityId = item.id;
                vm.municipalityForm.municipality.$setValidity('invalidMunicipality', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                if (vm.municipalityId && vm.municipalityId !== '00000000-0000-0000-0000-000000000000') {
                    // Set dirty
                    vm.municipalityForm.$setDirty();
                }
                vm.municipalityId = null;
                if (vm.searchText) {
                    vm.municipalityForm.municipality.$setValidity('invalidMunicipality', false);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('lookupStringTypeSelect', {
            bindings: {
                lookupStringTypeId: '=',
                lookupStringType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                displayText: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/lookup-string/components/lookup-string-type-select/lookup-string-type-select.tmpl.html',
            controller: 'LookupStringTypeSelectController as vm',
        })
        .controller('LookupStringTypeSelectController', LookupStringTypeSelectController);

    /* @ngInject */
    function LookupStringTypeSelectController($translate, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.lookupStringTypes = [];

        vm.onChange = onChange;

        vm.$onInit = function () {
            dataService.getAll('LookupStringTypes').then(function (lookupStringTypes) {
                vm.isDisabled = false;
                vm.lookupStringTypes = lookupStringTypes;
                onChange();
            });
        };

        function onChange() {
            if (vm.lookupStringTypeId && vm.lookupStringTypeId !== 'none') {
                for (var index = 0; index < vm.lookupStringTypes.length; index++) {
                    var lookupStringType = vm.lookupStringTypes[index];
                    if (vm.lookupStringTypeId === lookupStringType.id) {
                        vm.lookupStringType = lookupStringType;
                        if (angular.isDefined(vm.displayText)) {
                            vm.displayText = lookupStringType.name;
                        }
                        break;
                    }
                }
            } else {
                vm.lookupStringType = null;
                vm.lookupStringTypeId = null;
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.lookupStringType);
            }
            vm.onUpdate({ action: 'changed', value: vm.lookupStringType });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('lookupStringSelect', {
            bindings: {
                lookupStringId: '=',
                lookupString: '=',
                isDisabled: '=ngDisabled',
                onSelected: '=',
                labelText: '@',
                allowCustom: '=',
                customValue: '=',
                lookupStringConfig: '=',
                lookupStringTypeId: '=',
                minQueryLength: '=',
                displayText: '=',
                lookupStringDescription: '=',
                useDescription: '=',
                hideLabel: '=',
                onUpdate: '&',
            },
            templateUrl:
                'app/main/reference-types/lookup-string/components/lookup-string-select/lookup-string-select.tmpl.html',
            controller: 'LookupStringSelectController as vm',
        })
        .controller(
            'LookupStringSelectController',
            LookupStringSelectController
        );

    /* @ngInject */
    function LookupStringSelectController($q, $filter, $scope, dataService) {
        var vm = this;
        var cachedResults = [];

        vm.$onInit = function () {
            //Get Current lookupString
            if (vm.lookupStringId) {
                dataService
                    .getById('LookupStrings', vm.lookupStringId, true)
                    .then(function (lookupString) {
                        vm.lookupString = lookupString;
                    });
            } else if (vm.allowCustom && vm.customValue) {
                vm.searchText = vm.customValue;
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        vm.$postLink = function () {
            if (vm.allowCustom) {
                $scope.$watch(
                    function () {
                        return vm.customValue;
                    },
                    function (newValue, oldValue) {
                        if (newValue && newValue !== oldValue) {
                            vm.searchText = newValue;
                            vm.lookupStringForm.$setDirty();
                        }
                    }
                );
            }
        };

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getText = getText;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.lookupStringConfig) {
                if (cachedResults.length === 0) {
                    return dataService
                        .getByConfigName('LookupStrings', vm.lookupStringConfig)
                        .then(function (lookupStrings) {
                            lookupStrings = $filter('filter')(lookupStrings, {
                                isDeleted: false,
                            });
                            cachedResults = $filter('orderBy')(lookupStrings, [
                                'sortOrder',
                                'lookupNumber',
                                'lookupValue',
                            ]);
                            return getFiltered(cachedResults, query);
                        });
                }
                return $q.when(getFiltered(cachedResults, query));
            } else {
                if (vm.lookupStringTypeId) {
                    return dataService
                        .search(
                            'LookupStrings',
                            query,
                            vm.lookupStringTypeId,
                            'lookupStringTypeId'
                        )
                        .then(function (searchResult) {
                            var lookupStrings =
                                searchResult.data || searchResult;
                            lookupStrings = $filter('filter')(lookupStrings, {
                                isDeleted: false,
                            });
                            return $filter('orderBy')(lookupStrings, [
                                'sortOrder',
                                'lookupNumber',
                                'lookupValue',
                            ]);
                        });
                } else {
                    return dataService
                        .search('LookupStrings', query)
                        .then(function (searchResult) {
                            var lookupStrings =
                                searchResult.data || searchResult;
                            lookupStrings = $filter('filter')(lookupStrings, {
                                isDeleted: false,
                            });
                            return $filter('orderBy')(lookupStrings, [
                                'sortOrder',
                                'lookupNumber',
                                'lookupValue',
                            ]);
                        });
                }
            }
        }

        function getFiltered(collection, query) {
            if (!query) return collection;
            return $filter('filter')(collection, query);
        }

        function getText(lookupString) {
            if (!lookupString) return null;
            if (vm.useDescription && lookupString.description) {
                return lookupString.description;
            }
            return lookupString.lookupValue;
        }

        function searchTextChange(text) {
            if (vm.allowCustom) {
                if (vm.customValue !== text) {
                    // Set dirty
                    vm.lookupStringForm.$setDirty();
                    vm.onUpdate({ action: 'changed', value: text });
                }
                vm.customValue = text;
            }
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.lookupStringId = item.id;
                vm.lookupStringForm.lookupString.$setValidity(
                    'invalidLookupString',
                    true
                );
                if (vm.allowCustom) {
                    vm.customValue = getText(item);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.lookupValue;
                }
                if (angular.isDefined(vm.lookupStringDescription)) {
                    vm.lookupStringDescription = item.description;
                }
                vm.onUpdate({ action: 'selected', value: item });
            } else {
                if (
                    vm.lookupStringId &&
                    vm.lookupStringId !== '00000000-0000-0000-0000-000000000000'
                ) {
                    // Set dirty
                    vm.lookupStringForm.$setDirty();
                }
                vm.lookupStringId = null;
                if (vm.searchText && !vm.allowCustom) {
                    vm.lookupStringForm.lookupString.$setValidity(
                        'invalidLookupString',
                        false
                    );
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                vm.lookupStringForm.$setDirty();
                vm.onUpdate({ action: 'deselected', value: null });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller(
            'SearchLocationDialogController',
            SearchLocationDialogController
        );

    /* @ngInject */
    function SearchLocationDialogController($mdDialog, dataService) {
        var vm = this;

        //Data
        vm.selectedLocation = null;
        vm.isSearching = false;
        vm.isLoadingLocation = false;
        vm.selectedLocationTypeId = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSearchChange = onSearchChange;
        vm.selectItem = selectItem;
        vm.selectLocationType = selectLocationType;

        //////////
        // INIT
        vm.isFetchingTypes = true;
        dataService.getAll('LocationTypes').then(function (locationTypes) {
            vm.locationTypes = locationTypes;
            vm.isFetchingTypes = false;
        });
        function closeDialog(selectedLocation) {
            $mdDialog.hide(selectedLocation);
        }

        function onSearchChange() {
            if (vm.selectedLocationTypeId) {
                vm.isSearching = true;
                if (vm.searchText) {
                    dataService
                        .search(
                            'Locations',
                            vm.searchText,
                            vm.selectedLocationTypeId,
                            'locationTypeId'
                        )
                        .then(function (searchResults) {
                            vm.searchResults = searchResults.data;
                            vm.isSearching = false;
                        });
                } else {
                    dataService
                        .getByUri(
                            'Locations',
                            'ByLocationTypeId/' + vm.selectedLocationTypeId
                        )
                        .then(function (searchResults) {
                            vm.searchResults = searchResults;
                            vm.isSearching = false;
                        });
                }
            } else {
                vm.searchResults = [];
            }
        }

        function selectLocationType(locationType) {
            vm.selectedLocationTypeId = locationType.id;
            onSearchChange();
        }

        function selectItem(item) {
            if (item) {
                vm.selectedLocation = item;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditSuggestedTransportDialogController', EditSuggestedTransportDialogController);

    /* @ngInject */
    function EditSuggestedTransportDialogController($mdDialog, suggestedTransport, locationService) {
        var vm = this;
        vm.suggestedTransport = suggestedTransport;

        activate();

        ////////////////

        vm.onDestinationChanged = onDestinationChanged;

        function activate() {
            if (!vm.suggestedTransport) {
                vm.suggestedTransport = locationService.getEmptyLocationTransport();
                vm.suggestedTransport.changeState = 1;
            }
        }

        function onDestinationChanged(selectedDestination) {
            if (selectedDestination && !vm.suggestedTransport.description) {
                var departure = vm.suggestedTransport.departureLocation ? vm.suggestedTransport.departureLocation.name : '';
                vm.suggestedTransport.description = departure + ' -> ' + selectedDestination.name;
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditRequiredEquipmentDialogController', EditRequiredEquipmentDialogController);

    /* @ngInject */
    function EditRequiredEquipmentDialogController($mdDialog, locationEquipment, locationService) {
        var vm = this;
        vm.locationEquipment = locationEquipment;

        activate();

        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        ////////////////

        function activate() {
            if (!vm.locationEquipment) {
                vm.locationEquipment = locationService.getEmptyLocationEquipment();
                vm.locationEquipment.changeState = 1;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.locationEquipment.changeState !== 1) {
                vm.locationEquipment.changeState = 2;
            }
            $mdDialog.hide(vm.locationEquipment);
        }
    }

})();


(function () {
  "use strict";

  angular.module("app.referenceTypes").controller("AddLocationRelationshipDialogController", AddLocationRelationshipDialogController);

  /* @ngInject */
  function AddLocationRelationshipDialogController($mdDialog, locationService, parentLocationId) {
    var vm = this;
    vm.locationRelationship = locationService.getEmptyLocationRelationship();
    vm.locationRelationship.parentLocationId = parentLocationId;

    vm.closeDialog = closeDialog;
    vm.saveChanges = saveChanges;

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveChanges() {
      $mdDialog.hide(vm.locationRelationship);
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('AddLocationDialogController', AddLocationDialogController);

    /* @ngInject */
    function AddLocationDialogController(
        $mdDialog,
        $timeout,
        dataService,
        loadingService,
        locationService,
        baldrisConfigService,
        locationConfig,
        locationName
    ) {
        var vm = this;
        vm.updateModel = null;
        vm.ignoreExisting = false;
        vm.loadingService = loadingService;

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.onLocationNameChange = onLocationNameChange;
        vm.getExistingLocationsAsString = getExistingLocationsAsString;
        vm.setIgnoreStatus = setIgnoreStatus;

        activate();

        ////////////////

        function activate() {
            vm.updateModel = {
                location: locationService.getEmptyLocation(),
                address: null,
                locationTypes: [],
                attachedProducts: [],
                autoTasks: [],
                requiredEquipment: [],
                emails: [],
                telephones: [],
            };
            vm.updateModel.location.name = locationName;
            if (locationConfig) {
                vm.loadingService.setBackgroundLoadingStatus(true);
                baldrisConfigService.getByName(locationConfig).then(function (configs) {
                    if (configs && configs.length > 0) {
                        dataService.getById('LocationTypes', configs[0].customFieldData.dataTargetId, false).then(function (locationType) {
                            if (locationType) {
                                vm.updateModel.location.locationTypeIds.push(locationType.id);
                            }
                            vm.loadingService.setBackgroundLoadingStatus(false);
                        });
                    } else {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    }
                });
            }
            // Search to check that name not already exist
            if (locationName) {
                $timeout(function () {
                    onLocationNameChange();
                }, 1000);
            }
        }

        function onLocationNameChange() {
            if (vm.updateModel.location.name) {
                dataService.search('Locations', vm.updateModel.location.name).then(function (searchResults) {
                    searchResults = searchResults.data || searchResults;
                    vm.existingLocations = searchResults || [];
                    if (searchResults && searchResults.length > 0) {
                        if (!vm.ignoreExisting) {
                            vm.addLocationForm.locationName.$setValidity('existingLocations', false);
                        }
                    } else {
                        vm.addLocationForm.locationName.$setValidity('existingLocations', true);
                    }
                });
            } else {
                vm.addLocationForm.locationName.$setValidity('existingLocations', true);
            }
        }

        function getExistingLocationsAsString() {
            if (!vm.existingLocations || vm.existingLocations.length === 0) return null;
            var returnString = 'Lignende sted(er) finnes allerede: ';
            returnString += vm.existingLocations.reduce(function (a, b) {
                if (a) {
                    a += '; ' + b.name + locationTypesToString(b.locationTypes);
                    return a;
                }
                a = b.name + locationTypesToString(b.locationTypes);
                return a;
            }, '');
            return returnString;
        }

        function locationTypesToString(locationTypes) {
            if (!locationTypes || locationTypes.length === 0) {
                return '';
            }
            var returnString = locationTypes.reduce(function (previousValue, currentValue) {
                if (previousValue) {
                    previousValue += ', ' + currentValue.name;
                    return previousValue;
                }
                return currentValue.name;
            }, '');

            return ' (' + returnString + ')';
        }

        function setIgnoreStatus(value) {
            vm.ignoreExisting = value;
            if (vm.existingLocations && vm.existingLocations.length > 0) {
                vm.addLocationForm.locationName.$setValidity('existingLocations', value);
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            vm.loadingService.setBackgroundLoadingStatus(true);
            dataService.insertItem('Locations', vm.updateModel.location).then(function (insertedLocation) {
                vm.loadingService.setBackgroundLoadingStatus(false);
                $mdDialog.hide(insertedLocation);
            });
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("relatedLocationsList", {
      bindings: {
        relatedLocations: "<",
        hideHeader: "<",
        locationId: "<",
        onAdd: "&",
        onDelete: "&",
      },
      templateUrl: "app/main/reference-types/location/components/related-locations-list/related-locations-list.tmpl.html",
      controller: "RelatedLocationsListController as vm",
    })
    .controller("RelatedLocationsListController", RelatedLocationsListController);

  /* @ngInject */
  function RelatedLocationsListController(locationService, $mdDialog, $document, $translate, locationRelation) {
    var vm = this;
    vm.addRelatedLocation = addRelatedLocation;
    vm.deleteRelatedLocation = deleteRelatedLocation;
    vm.getTranslatedRelationshipText = getTranslatedRelationshipText;

    vm.$onInit = function () {};

    function addRelatedLocation(e) {
      if (!vm.relatedLocations) vm.relatedLocations = [];
    }

    function deleteRelatedLocation(locationRelationship, e) {
      _.remove(vm.relatedLocations, function (item) {
        return item === locationRelationship;
      });
      vm.onDelete({ value: locationRelationship });
    }

    function getTranslatedRelationshipText(relationship) {
      if (extractRelationTypes(relationship).length === 0) return null;
      var returnString = extractRelationTypes(relationship).reduce(function (previousValue, currentValue) {
        if (previousValue === "") return $translate.instant(currentValue);
        return previousValue + ", " + $translate.instant(currentValue);
      }, "");
      return returnString;
    }

    function extractRelationTypes(relationship) {
      var relationTypes = [];
      angular.forEach(locationRelation, function (option) {
        if (relationship & option.value) {
          relationTypes.push(option.text);
        }
      });
      return relationTypes;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('locationTypeSingleSelect', {
            bindings: {
                locationTypeId: '=',
                locationType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                displayText: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/location/components/location-type-single-select/location-type-single-select.tmpl.html',
            controller: 'LocationTypeSingleSelectController as vm',
        })
        .controller('LocationTypeSingleSelectController', LocationTypeSingleSelectController);

    /* @ngInject */
    function LocationTypeSingleSelectController($translate, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.locationTypes = [];

        vm.onChange = onChange;

        vm.$onInit = function () {
            dataService.getAll('LocationTypes').then(function (locationTypes) {
                vm.isDisabled = false;
                vm.locationTypes = locationTypes;
                onChange();
            });
        };

        function onChange() {
            if (vm.locationTypeId && vm.locationTypeId !== 'none') {
                for (var index = 0; index < vm.locationTypes.length; index++) {
                    var locationType = vm.locationTypes[index];
                    if (vm.locationTypeId === locationType.id) {
                        vm.locationType = locationType;
                        if (angular.isDefined(vm.displayText)) {
                            vm.displayText = locationType.name;
                        }
                        break;
                    }
                }
            } else {
                vm.locationType = null;
                vm.locationTypeId = null;
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.locationType);
            }
            vm.onUpdate({ action: 'changed', value: vm.locationType });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('locationTypeSelect', {
            bindings: {
                locationTypes: '=',
                labelText: '@'
            },
            templateUrl: 'app/main/reference-types/location/components/location-type-select/location-type-select.tmpl.html',
            controller: 'LocationTypeSelectController as vm',
        })
        .controller('LocationTypeSelectController', LocationTypeSelectController);

    /* @ngInject */
    function LocationTypeSelectController($filter, dataService, locationService) {
        var vm = this;

        vm.selectedLocationType = null;
        vm.selectedLocationTypes = [];
        vm.searchText = null;
        vm.selectForm = null;
        vm.locationTypeSearch = locationTypeSearch;
        vm.transformChip = transformChip;
        vm.onAddLocationType = onAddLocationType;
        vm.onRemoveLocationType = onRemoveLocationType;
        vm.onSelectLocationType = onSelectLocationType;

        //Init
        //INIT
        vm.$onInit = function () {
            //Create targetList
            if (vm.locationTypes && vm.locationTypes.length > 0) {
                vm.selectedLocationTypes = vm.locationTypes.map(function (locationLocationType) {
                    return {
                        id: locationLocationType.locationTypeId,
                        name: locationLocationType.locationTypeName
                    };
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        //userSearch
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return {name: chip, type: 'new'}
        }

        /**
         * Search for LocationTypes.
         */
        function locationTypeSearch(query) {
            if (query) {
                return dataService.search("LocationTypes", query).then(function (locationTypes) {
                    return $filter('orderBy')(locationTypes, 'name');
                });
            } else {
                return dataService.getAll("LocationTypes").then(function (locationTypes) {
                    return $filter('orderBy')(locationTypes, 'name');
                });
            }
        }

        function onSelectLocationType(locationType) {
            vm.currentLocationType = locationType;
        }


        function onAddLocationType(locationType) {
            if (!vm.locationTypes) {
                vm.locationTypes = [];
            }
            vm.selectForm.$setDirty();
            // Check if location type is already added
            for (var i = 0; i < vm.locationTypes.length; i++) {
                var locationLocationType = vm.locationTypes[i];
                if (locationLocationType.locationTypeId === locationType.id) {
                    // Location Type exist
                    if (locationLocationType.changeState != 1) {
                        locationLocationType.changeState = 2;
                        return;
                    }
                }
            }
            // Add locationType if not exist
            var locationLocationType = locationService.getEmptyLocationLocationType();
            locationLocationType.changeState = 1;
            locationLocationType.locationType = locationType;
            locationLocationType.locationTypeId = locationType.id;
            vm.locationTypes.push(locationLocationType);
        }

        function onRemoveLocationType(locationType) {
            vm.selectForm.$setDirty();
            // Find and remove locationType
            for (var i = 0; i < vm.locationTypes.length; i++) {
                var locationLocationType = vm.locationTypes[i];
                if (locationLocationType.locationTypeId === locationType.id) {
                    if (locationLocationType.changeState === 1) {
                        // Hasn't been saved and can be removed safely
                        vm.locationTypes.splice(i, 1);
                    } else {
                        // mark as deleted
                        locationLocationType.changeState = 3;
                    }
                }
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('locationSelect', {
            bindings: {
                locationId: '=',
                location: '=',
                onSelected: '=',
                labelText: '@',
                locationConfig: '=',
                disableSearch: '=',
                minQueryLength: '=',
                displayText: '=',
                isDisabled: '=',
            },
            templateUrl: 'app/main/reference-types/location/components/location-select/location-select.tmpl.html',
            controller: 'LocationSelectController as vm',
        })
        .controller('LocationSelectController', LocationSelectController);

    /* @ngInject */
    function LocationSelectController($filter, $q, dataService, locationService, $mdDialog, $document) {
        var vm = this;
        var cachedResults = [];
        vm.$onInit = function () {
            //Get Current Location
            if (vm.locationId) {
                dataService.getById('Locations', vm.locationId, true).then(function (location) {
                    vm.location = location;
                });
            }

            vm.minLength = 1;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.resetInput = resetInput;
        vm.openSearchDialog = openSearchDialog;
        vm.openAddLocationDialog = openAddLocationDialog;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.locationConfig) {
                if (cachedResults.length === 0) {
                    return dataService.getByConfigName('Locations', vm.locationConfig).then(function (locations) {
                        cachedResults = locations;
                        return getFiltered(cachedResults, query);
                    });
                }
                return $q.when(getFiltered(cachedResults, query));
            } else {
                return dataService.search('Locations', query).then(function (searchResult) {
                    if (searchResult.data) {
                        return searchResult.data;
                    }
                    return searchResult;
                });
            }
        }

        function getFiltered(collection, query) {
            if (!query) return collection;
            return $filter('filter')(collection, query);
        }

        function searchTextChange(text) {}

        function openSearchDialog(e) {
            $mdDialog
                .show({
                    controller: 'SearchLocationDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/reference-types/location/dialogs/search-location-dialog/search-location-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                })
                .then(function (selectedLocation) {
                    if (selectedLocation) {
                        vm.location = selectedLocation;
                        vm.locationId = selectedLocation.id;
                    }
                });
        }

        function openAddLocationDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddLocationDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/reference-types/location/dialogs/add-location-dialog/add-location-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                    locals: {
                        locationConfig: vm.locationConfig,
                        locationName: vm.searchText,
                    },
                })
                .then(function (addedLocation) {
                    if (addedLocation) {
                        vm.location = addedLocation;
                        vm.locationId = addedLocation.id;
                    }
                });
        }

        function resetInput() {
            vm.locationId = null;
            vm.location = null;
            vm.searchText = null;
            vm.locationForm.location.$setValidity('invalidLocation', true);
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.locationId = item.id;
                vm.locationForm.location.$setValidity('invalidLocation', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                if (vm.locationId && vm.locationId !== '00000000-0000-0000-0000-000000000000') {
                    // Set dirty
                    vm.locationForm.$setDirty();
                }
                vm.locationId = null;
                if (vm.searchText) {
                    vm.locationForm.location.$setValidity('invalidLocation', false);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditFontStyleDialogController', EditFontStyleDialogController);

    /* @ngInject */
    function EditFontStyleDialogController($mdDialog, dataService, fontStyle, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.fontStyle = fontStyle;

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            vm.loadingService.setBackgroundLoadingStatus(true);
            if (vm.fontStyle.changeState === 1) {
                dataService.insertItem('FontStyles', vm.fontStyle).then(function (insertedFontStyle) {
                    $mdDialog.hide(insertedFontStyle);
                    vm.loadingService.setBackgroundLoadingStatus(false);
                });
            } else {
                dataService.updateItem('FontStyles', vm.fontStyle).then(function () {
                    $mdDialog.hide(vm.fontStyle);
                    vm.loadingService.setBackgroundLoadingStatus(false);
                });
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('fontStyleSelect', {
            bindings: {
                fontStyleId: '=',
                fontStyle: '=',
                onSelected: '=',
                labelText: '@',
                customValue: '=',
                fontStyleConfig: '=',
                minQueryLength: '=',
                displayText: '=',
                onUpdate: '&'
            },
            templateUrl: 'app/main/reference-types/font-style/components/font-style-select/font-style-select.tmpl.html',
            controller: 'FontStyleSelectController as vm',
        })
        .controller('FontStyleSelectController', FontStyleSelectController);

    /* @ngInject */
    function FontStyleSelectController($filter, $mdDialog, $document, dataService, fontStyleService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current fontStyle
            if (vm.fontStyleId && vm.fontStyleId !== '00000000-0000-0000-0000-000000000000') {
                dataService.getById('FontStyles', vm.fontStyleId, true).then(function (fontStyle) {
                    vm.fontStyle = fontStyle;
                    if(angular.isDefined(vm.displayText)) {
                        vm.displayText = fontStyle.description;
                    }

                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.openAddFontStyleDialog = openAddFontStyleDialog;
        vm.openEditFontStyleDialog = openEditFontStyleDialog;


        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.fontStyleConfig) {
                if (query) {
                    return dataService.searchByConfigName('FontStyles', vm.fontStyleConfig, query).then(function (fontStyles) {
                        return $filter('orderBy')(fontStyles, ['font', 'description']);
                    });
                } else {
                    return dataService.getByConfigName('FontStyles', vm.fontStyleConfig).then(function (fontStyles) {
                        return $filter('orderBy')(fontStyles, ['font', 'description']);
                    });
                }
            } else {
                if (query) {
                    return dataService.search('FontStyles', query).then(function (fontStyles) {
                        return $filter('orderBy')(fontStyles, ['font', 'description']);
                    });
                } else {
                    return dataService.getAll('FontStyles').then(function (fontStyles) {
                        return $filter('orderBy')(fontStyles, ['font', 'description']);
                    });
                }

            }

        }

        function searchTextChange(text) {

        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.fontStyleId = item.id;
                vm.fontStyleForm.fontStyle.$setValidity("invalidFontStyle", true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.description;
                }
                vm.onUpdate({ action: 'selected', value: item });
            } else {
                vm.fontStyleId = null;
                if (vm.searchText) {
                    vm.fontStyleForm.fontStyle.$setValidity("invalidFontStyle", false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                if (vm.searchText) {
                    vm.onUpdate({action: 'notFound', value: vm.searchText});
                } else {
                    vm.onUpdate({action: 'deselected', value: null});
                }
            }
        }

        function openAddFontStyleDialog(e) {
            var fontStyle = fontStyleService.getEmptyFontStyle();
            fontStyle.changeState = 1;
            fontStyle.font = vm.searchText;

            $mdDialog.show({
                controller: 'EditFontStyleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/font-style/dialogs/edit-font-style-dialog/edit-font-style-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    fontStyle: fontStyle
                }
            }).then(function (addedFontStyle) {
                if (addedFontStyle) {
                    vm.fontStyle = addedFontStyle;
                    vm.fontStyleId = addedFontStyle.id;
                }
            });
        }

        function openEditFontStyleDialog(e) {
            var fontStyle = angular.copy(vm.fontStyle);
            fontStyle.changeState = fontStyle.changeState === 1 ? 1 : 2;

            $mdDialog.show({
                controller: 'EditFontStyleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/font-style/dialogs/edit-font-style-dialog/edit-font-style-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                clickOutsideToClose: true,
                locals: {
                    fontStyle: fontStyle
                }
            }).then(function (addedFontStyle) {
                if (addedFontStyle) {
                    vm.fontStyle = addedFontStyle;
                    vm.fontStyleId = addedFontStyle.id;
                }
            });
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('equipmentSelect', {
            bindings: {
                equipment: '=',
                equipmentId: '=',
                onChanged: '<',
                isDisabled: '<',
                equipmentConfig: '<',
                labelText: '@',
                minQueryLength: '=',
                displayText: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/equipment/components/equipment-select/equipment-select.tmpl.html',
            controller: 'EquipmentSelectController as vm',
        })
        .controller('EquipmentSelectController', EquipmentSelectController);

    /* @ngInject */
    function EquipmentSelectController($filter, dataService) {
        var vm = this;

        vm.$onInit = function () {
            vm.onEquipmentChanged = onEquipmentChanged;
            vm.querySearch = querySearch;
            vm.openSearchDialog = openSearchDialog;
            vm.resetInput = resetInput;
            vm.searchTextChange = searchTextChange;

            vm.searchText = null;

            //Get Current Equipment
            if (vm.equipmentId && vm.equipmentId !== '00000000-0000-0000-0000-000000000000' && !vm.equipment) {
                dataService.getById('Equipment', vm.equipmentId, true).then(function (equipment) {
                    vm.equipment = equipment;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        /*///////////*/

        function onEquipmentChanged(item, e) {
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(item, e);
            }
            if (item) {
                vm.equipmentId = item.id;
                vm.equipmentForm.equipment.$setValidity('invalidEquipment', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
                vm.onUpdate({ action: 'selected', item: item });
            } else {
                vm.equipmentId = null;
                if (vm.searchText) {
                    vm.equipmentForm.equipment.$setValidity('invalidEquipment', false);
                } else {
                    vm.equipmentForm.equipment.$setValidity('invalidEquipment', true);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                vm.onUpdate({ action: 'deselected', item: null });
            }
        }

        function searchTextChange(text) {
            if (!text && !vm.equipment) {
                vm.equipmentForm.equipment.$setValidity('invalidEquipment', true);
            }
        }

        function querySearch(query) {
            if (vm.equipmentConfig) {
                if (query) {
                    return dataService.searchByConfigName('Equipment', vm.equipmentConfig, query).then(function (equipment) {
                        return $filter('orderBy')(equipment, 'name');
                    });
                } else {
                    return dataService.getByConfigName('Equipment', vm.equipmentConfig).then(function (equipment) {
                        return $filter('orderBy')(equipment, 'name');
                    });
                }
            } else {
                if (!query) {
                    return dataService.getAll('Equipment').then(function (equipment) {
                        return equipment;
                    });
                }
                return dataService.search('Equipment', query).then(function (equipment) {
                    return equipment.data || equipment;
                });
            }
        }

        function openSearchDialog(e) {
            $mdDialog
                .show({
                    controller: 'SearchEquipmentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/reference-types/equipment/dialogs/search-equipment-dialog/search-equipment-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                })
                .then(function (selectedEquipment) {
                    if (selectedEquipment) {
                        vm.equipment = selectedEquipment;
                        vm.equipmentId = selectedEquipment.id;
                    }
                });
        }

        function resetInput() {
            vm.equipmentId = null;
            vm.equipment = null;
            vm.searchText = null;
            vm.equipmentForm.equipment.$setValidity('invalidEquipment', true);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('inlineEmailList', {
            bindings: {
                collection: '=',
                partyId: '=',
                baldrisUserId: '=',
                locationId: '=',
                isDisabled: '<',
                disableAdd: '<',
                onUpdate: '&',
                isSingleEntry: '<',
            },
            templateUrl: 'app/main/reference-types/email/components/inline-email-list/inline-email-list.tmpl.html',
            controller: 'InlineEmailListController as vm',
        })
        .controller('InlineEmailListController', InlineEmailListController);

    /* @ngInject */
    function InlineEmailListController($window, $mdDialog, $translate, dataService, emailService, orderByFilter) {
        var vm = this;

        vm.addNewEmail = addNewEmail;
        vm.onEmailChanged = onEmailChanged;
        vm.newEmailChip = newEmailChip;
        vm.selectEmail = selectEmail;
        vm.deleteEmail = deleteEmail;
        vm.getSelectedEmailType = getSelectedEmailType;
        vm.openEmailTypeMenu = openEmailTypeMenu;
        vm.setEmailType = setEmailType;
        vm.selectedEmail = null;
        vm.showMoreOptions = false;

        //INIT
        vm.$onInit = function () {
            if (!vm.collection) {
                vm.collection = [];
            } else {
                // Get default email
                vm.collection = orderByFilter(vm.collection, ['sortOrder']);
                vm.selectedEmail = getDefaultObject(vm.collection);
            }

            dataService.getAll('EmailTypes').then(function (emailTypes) {
                vm.emailTypes = emailTypes;
                vm.defaultEmailType = getDefaultObject(vm.emailTypes);

                if (vm.collection.length === 0) {
                    // Add blank email
                    var newEmail = getEmptyEmail();
                    newEmail.isDefault = true;
                    newEmail.sortOrder = 0;
                    newEmail.changeState = 0;

                    vm.collection.push(newEmail);
                    vm.selectedEmail = vm.collection[0];
                }
            });
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
                vm.isDisabled = changesObj.isDisabled.currentValue;
            }
        };

        function getDefaultObject(objects) {
            if (!objects || objects.length === 0) return null;
            var defaultObject = null;
            for (var i = 0, len = objects.length; i < len; i++) {
                if (!defaultObject) {
                    defaultObject = objects[i];
                }
                if (objects[i].isDefault) {
                    defaultObject = objects[i];
                    break;
                }
                if (defaultObject.sortOrder > objects[i].sortOrder) {
                    defaultObject = objects[i];
                }
            }
            return defaultObject;
        }

        function getEmptyEmail() {
            var newEmail = emailService.getEmptyEmail();
            //Determine next sortOrder
            var highestSortOrder = 0;
            var isDefault = !vm.collection || vm.collection.length === 0;
            for (var i = 0, len = vm.collection.length; i < len; i++) {
                if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
                    highestSortOrder = vm.collection[i].sortOrder;
                }
            }
            newEmail.sortOrder = highestSortOrder + 10;
            newEmail.isDefault = isDefault;
            if (vm.defaultEmailType) {
                newEmail.emailTypeId = vm.defaultEmailType.id;
                newEmail.emailType = vm.defaultEmailType;
                newEmail.emailTypeName = vm.defaultEmailType.name;
            }
            return newEmail;
        }

        function addNewEmail(e) {
            var newEmail = getEmptyEmail();

            if (vm.partyId) {
                newEmail.partyId = vm.partyId;
            }
            if (vm.baldrisUserId) {
                newEmail.baldrisUserId = vm.baldrisUserId;
            }
            if (vm.locationId) {
                newEmail.locationId = vm.locationId;
            }
            vm.collection.push(newEmail);
            vm.selectedEmail = newEmail;
            vm.emailListForm.$setDirty();
            var defaultEmailElement = $window.document.getElementById('DefaultEmailAddress');
            defaultEmailElement.focus();
            vm.onUpdate({ action: 'add', value: newEmail });
        }

        function onEmailChanged(email) {
            if (email.id && email.id !== '00000000-0000-0000-0000-000000000000') {
                email.changeState = 2;
            } else {
                email.changeState = 1;
            }
            vm.collection = orderByFilter(vm.collection, ['sortOrder']);
            vm.emailListForm.$setDirty();
            vm.onUpdate({ action: 'change', value: email });
        }

        function newEmailChip(chip) {}

        function selectEmail(email) {
            vm.selectedEmail = email;
            var defaultEmailElement = $window.document.getElementById('DefaultEmailAddress');
            defaultEmailElement.focus();
        }

        function deleteEmail(email, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('EMAILS.EMAIL_LIST.DELETE_EMAIL'))
                .textContent(
                    $translate.instant('EMAILS.EMAIL_LIST.DELETE_EMAIL_CONFIRM', {
                        email: email.streetEmail1 ? email.streetEmail1 : $translate.instant('EMAILS.EMAIL.EMAIL'),
                    })
                )
                .ariaLabel($translate.instant('EMAILS.EMAIL_LIST.DELETE_EMAIL'))
                .targetEvent(e)
                .ok($translate.instant('EMAILS.EMAIL_LIST.DELETE_EMAIL'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    if (email.id && email.id !== '00000000-0000-0000-0000-000000000000') {
                        dataService.deleteItem('Emails', email).then(function () {
                            // Remove from collection
                            var index = vm.collection.indexOf(email);
                            vm.collection.splice(index, 1);
                            replaceIfSelected(email);
                            vm.onUpdate({ action: 'remove', value: email });
                        });
                    } else {
                        // Remove from collection
                        var index = vm.collection.indexOf(email);
                        vm.collection.splice(index, 1);
                        replaceIfSelected(email);
                        vm.onUpdate({ action: 'remove', value: email });
                    }
                },
                function () {
                    // Do nothing
                }
            );
        }

        function replaceIfSelected(email) {
            // Check if email was selected
            if (vm.selectedEmail === email) {
                // Select default email, if any
                vm.selectedEmail = getDefaultObject(vm.collection);
                // If no email selected, create blank
                if (!vm.selectedEmail) {
                    var newEmail = getEmptyEmail();
                    newEmail.isDefault = true;
                    newEmail.sortOrder = 0;
                    newEmail.changeState = 0;

                    vm.collection.push(newEmail);
                    vm.selectedEmail = vm.collection[0];
                }
            }
        }

        function openEmailTypeMenu($mdMenu, ev) {
            vm.originatorEv = ev;
            $mdMenu.open(ev);
        }

        function setEmailType(emailType) {
            if (vm.selectedEmail) {
                vm.selectedEmail.emailTypeId = emailType.id;
                vm.selectedEmail.emailTypeName = emailType.name;
                onEmailChanged(vm.selectedEmail);
            }
        }

        function getSelectedEmailType() {
            if (vm.selectedEmail) {
                if (vm.emailTypes && vm.emailTypes.length > 0) {
                    for (var index = 0; index < vm.emailTypes.length; index++) {
                        var emailType = vm.emailTypes[index];
                        if (vm.selectedEmail.emailTypeId === emailType.id) {
                            return emailType;
                        }
                    }
                }
                if (vm.selectedEmail.emailTypeName) {
                    return {
                        name: vm.selectedEmail.emailTypeName,
                        iconName: 'icon-help',
                    };
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('emailTypeSelect', {
            bindings: {
                emailTypeId: '=',
                emailType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/reference-types/email/components/email-type-select/email-type-select.tmpl.html',
            controller: 'EmailTypeSelectController as vm',
        })
        .controller('EmailTypeSelectController', EmailTypeSelectController);

    /* @ngInject */
    function EmailTypeSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.emailTypes = [];
        vm.onChange = onChange;
        
        //INIT
        vm.$onInit = function () {
            // Get options
            dataService.getAll('EmailTypes').then(function (emailTypes) {
                vm.isDisabled = false;
                vm.emailTypes = emailTypes;
                if (!vm.emailTypeId || vm.telephoneTypeId === '00000000-0000-0000-0000-000000000000') {
                    for (var i = 0; i < vm.emailTypes.length; i++) {
                        var emailType = vm.emailTypes[i];
                        if (emailType.isDefault) {
                            vm.emailType = emailType;
                            vm.emailTypeId = emailType.id;
                            break;
                        }
                    }
                }
            });
        }

        function onChange() {
            if (vm.emailTypeId) {
                for (var index = 0; index < vm.emailTypes.length; index++) {
                    var emailType = vm.emailTypes[index];
                    if (vm.emailTypeId === emailType.id) {
                        vm.emailType = emailType;
                        break;
                    }
                }
            } else {
                vm.emailType = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.emailType);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('emailList', {
            bindings: {
                collection: '=',
                partyId: '=',
                baldrisUserId: '=',
                locationId: '='
            },
            templateUrl: 'app/main/reference-types/email/components/email-list/email-list.tmpl.html',
            controller: 'EmailListController as vm',
        })
        .controller('EmailListController', EmailListController);

    /* @ngInject */
    function EmailListController(dataService, emailService, $mdDialog, $document) {
        var vm = this;
        vm.addNewEmail = addNewEmail;
        vm.showEditEmailDialog = showEditEmailDialog;
        vm.getIconName = getIconName;
        vm.deleteOrUndo = deleteOrUndo;

        var dialogOptions = {
            controller: 'EditEmailDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/reference-types/email/components/edit-email-dialog/edit-email-dialog.tmpl.html',
            parent: angular.element($document.body),
            targetEvent: null,
            clickOutsideToClose: true,
            multiple: true,
            locals: {
                email: null
            }
        };

        function addNewEmail(e) {
            var newEmail = emailService.getEmptyEmail();
            //Determine next sortOrder
            var highestSortOrder = 0;
            for (var i = 0, len = vm.collection.length; i < len; i++) {
                if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
                    highestSortOrder = vm.collection[i].sortOrder;
                }
            }
            newEmail.sortOrder = highestSortOrder + 10;
            if (vm.partyId) {
                newEmail.partyId = vm.partyId;
            }
            if (vm.locationId) {
                newEmail.locationId = vm.locationId;
            }
            if (vm.baldrisUserId) {
                newEmail.baldrisUserId = vm.baldrisUserId;
            }

            dialogOptions.targetEvent = e;
            dialogOptions.locals.email = newEmail;

            $mdDialog.show(dialogOptions).then(function (updatedEmail) {
                if (updatedEmail) {
                    if (updatedEmail.changeState == 1) {
                        // Should be new Email so we just insert it to the array
                        vm.collection.push(updatedEmail);
                        if (vm.emailListForm) {
                            vm.emailListForm.$setDirty();
                        }
                    }
                }
            });
        }

        function showEditEmailDialog(email, e) {
            if (email.$type === 'Baldris.Core.Data.Entities.Dto.EmailDto, Baldris.Core.Data.Entities') {
                showEmail(email);
            } else {
                dataService.getById('Emails', email.id, true).then(function (fullEmail) {
                    showEmail(fullEmail);
                });
            }

            function showEmail(emailToShow) {
                dialogOptions.targetEvent = e;
                dialogOptions.locals.email = emailToShow;
                dialogOptions.multiple = true;

                $mdDialog.show(dialogOptions).then(function (updatedEmail) {
                    if (updatedEmail) {
                        if (updatedEmail.changeState == 2) {
                            // Should be modified Email, locate and replace
                            for (var index = 0; index < vm.collection.length; index++) {
                                var element = vm.collection[index];
                                if (element.id === updatedEmail.id) {
                                    vm.collection.splice(index, 1);
                                    vm.collection.push(updatedEmail);
                                    break;
                                }
                            }
                        }
                        if (vm.emailListForm) {
                            vm.emailListForm.$setDirty();
                        }
                    }
                });
            }
        }

        function deleteEmail(email, e) {
            // if newly created, we remove it entirely
            if (email.changeState === 1) {
                var index = vm.collection.indexOf(email);
                vm.collection.splice(index, 1);
                if (vm.emailListForm) {
                    vm.emailListForm.$setDirty();
                }
            } else {
                if (email.$type === 'Baldris.Core.Data.Entities.Dto.EmailDto, Baldris.Core.Data.Entities') {
                    // mark as deleted
                    email.changeState = 3;
                    if (vm.emailListForm) {
                        vm.emailListForm.$setDirty();
                    }
                } else {
                    // Get full Email and mark for deletion
                    dataService.getById('Emails', email.id, true).then(function (fullEmail) {
                        fullEmail.changeState = 3;
                        // replace the email in the collection
                        for (var index = 0; index < vm.collection.length; index++) {
                            var element = vm.collection[index];
                            if (element.id === fullEmail.id) {
                                vm.collection.splice(index, 1);
                                vm.collection.push(fullEmail);
                                break;
                            }
                        }
                        if (vm.emailListForm) {
                            vm.emailListForm.$setDirty();
                        }
                    });
                }
            }
        }

        function undoDelete(email) {
            email.changeState = 2;
        }

        function deleteOrUndo(email) {
            if (email.changeState === 3) {
                undoDelete(email);
            } else {
                deleteEmail(email);
            }
        }

        function getIconName(email) {
            if (email.emailTypeIconName) {
                return email.emailTypeIconName;
            } else if (email.emailType && email.emailType.iconName) {
                return email.emailType.iconName;
            }
            else {
                return "icon-email";
            }
        }

        //INIT
        if (!vm.collection) {
            vm.collection = [];
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditEmailDialogController', EditEmailDialogController);

    /* @ngInject */
    function EditEmailDialogController($mdDialog, email, $translate, dataService, emailService, countryService) {
        var vm = this;

        // Data
        vm.email = email;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.defaultCountryId && vm.email.countryId && vm.defaultCountryId != vm.email.countryId) {
                vm.email.isAbroadEmail = true;
            }
            if (!vm.email.id || vm.email.id === '00000000-0000-0000-0000-000000000000') {
                vm.email.changeState = 1;
            } else {
                vm.email.changeState = 2;
            }
            $mdDialog.hide(vm.email);
        }

    }

} ());
(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("countrySelect", {
      bindings: {
        countryId: "=",
        country: "=",
        onSelected: "=",
        allowCustom: "=",
        customValue: "=",
        labelText: "@",
        minQueryLength: "=",
        displayText: "=",
        isDisabled: "<",
        onUpdate: "&"
      },
      templateUrl: "app/main/reference-types/country/components/country-select/country-select.tmpl.html",
      controller: "CountrySelectController as vm"
    })
    .controller("CountrySelectController", CountrySelectController);

  /* @ngInject */
  function CountrySelectController($filter, dataService) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    //INIT
    vm.$onInit = function() {
      //Get Current Country
      if (vm.countryId) {
        dataService.getById("Countries", vm.countryId, true).then(function(country) {
          vm.country = country;
        });
      } else if (vm.allowCustom && vm.customValue) {
        vm.searchText = vm.customValue;
      }
      vm.minLength = 0;
      if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
        vm.minLength = vm.minQueryLength;
      }
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
        vm.isDisabled = changesObj.isDisabled.currentValue;
      }
    };

    // ******************************
    // Internal methods
    // ******************************

    function querySearch(query) {
      return dataService.search("Countries", query).then(function(countries) {
        return $filter("orderBy")(countries, "name");
      });
    }

    function searchTextChange(text) {
      if (vm.allowCustom) {
        vm.customValue = text;
      }
    }

    function selectedItemChange(item) {
      if (angular.isFunction(vm.onSelected)) {
        vm.onSelected(item);
      }
      if (item) {
        if (item.id !== vm.countryId) {
          vm.onUpdate({ action: "selected", value: item });
        }
        vm.countryId = item.id;
        vm.countryForm.country.$setValidity("invalidCountry", true);
        if (vm.allowCustom) {
          vm.customValue = item.name;
        }
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = item.name;
        }
      } else {
        if (vm.countryId && vm.countryId !== "00000000-0000-0000-0000-000000000000") {
          // Set dirty
          vm.onUpdate({ action: "deselected", value: null });
          vm.countryForm.$setDirty();
        }
        vm.countryId = null;
        if (vm.searchText && !vm.allowCustom) {
          vm.countryForm.country.$setValidity("invalidCountry", false);
        }
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = null;
        }
      }
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("countryIso2Select", {
      bindings: {
        countryId: "=",
        country: "=",
        iso2Code: "=",
        onUpdate: "&",
        labelText: "@",
        displayText: "="
      },
      templateUrl: "app/main/reference-types/country/components/country-iso2-select/country-iso2-select.tmpl.html",
      controller: "CountryIso2SelectController as vm"
    })
    .controller("CountryIso2SelectController", CountryIso2SelectController);

  /* @ngInject */
  function CountryIso2SelectController($filter, dataService) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;

    //INIT
    vm.$onInit = function() {
      //Get Current Country
      if (vm.iso2Code) {
        dataService.getByUri("Countries", "ByIsoCode/" + vm.iso2Code).then(function(country) {
          vm.country = country;
          if (country) {
            vm.countryId = country.id;
          }
        });
      }
      vm.minLength = 0;
    };

    // ******************************
    // Internal methods
    // ******************************

    function querySearch(query) {
      return dataService.search("Countries", query).then(function(countries) {
        return $filter("orderBy")(countries, "name");
      });
    }

    function searchTextChange(text) {}

    function selectedItemChange(item) {
      if (item) {
        vm.countryId = item.id;
        vm.iso2Code = item.isoCode2;
        vm.countryForm.country.$setValidity("invalidCountry", true);
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = item.name;
        }
        vm.onUpdate({ action: "selected", value: item });
      } else {
        if (vm.countryId && vm.countryId !== "00000000-0000-0000-0000-000000000000") {
          // Set dirty
          vm.countryForm.$setDirty();
        }
        vm.countryId = null;
        vm.iso2Code = null;
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = null;
        }
        vm.onUpdate({ action: "deselected", value: null });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('casketSelect', {
            bindings: {
                casketId: '=',
                casket: '=',
                casketAttributes: '=',
                onSelected: '=',
                labelText: '@',
                displayText: '=',
                minQueryLength: '=',
            },
            templateUrl:
                'app/main/reference-types/casket/components/casket-select/casket-select.tmpl.html',
            controller: 'CasketSelectController as vm',
        })
        .controller('CasketSelectController', CasketSelectController);

    /* @ngInject */
    function CasketSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getType = getType;
        vm.casketAttributesChanged = false;
        vm.showMoreOptions = false;

        //INIT
        vm.$onInit = function () {
            //Get Current Casket
            if (vm.casketId) {
                dataService
                    .getById('Caskets', vm.casketId, true)
                    .then(function (casket) {
                        vm.casket = casket;
                    });
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService
                    .search('Caskets', query)
                    .then(function (caskets) {
                        caskets = $filter('filter')(caskets, {
                            isDeleted: false,
                        });
                        return $filter('orderBy')(caskets, 'name');
                    });
            } else {
                return dataService.getAll('Caskets').then(function (caskets) {
                    caskets = $filter('filter')(caskets, { isDeleted: false });
                    return $filter('orderBy')(caskets, 'name');
                });
            }
        }

        function searchTextChange(text) {}

        function getType(casket) {
            var returnString = '';
            if (casket.material) {
                returnString += casket.material;
            }
            if (casket.color) {
                if (returnString) returnString += ' / ';
                returnString += casket.color;
            }
            if (returnString) {
                returnString = '(' + returnString + ')';
            }
            return returnString;
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                // Check if we need to update attributes
                if (
                    vm.casketId !== item.id &&
                    angular.isDefined(vm.casketAttributes)
                ) {
                    if (
                        vm.casketAttributes !== 'none' &&
                        vm.casketAttributes !== item.attributes
                    ) {
                        vm.casketAttributesChanged = true;
                    }
                    vm.casketAttributes = item.attributes;
                }
                vm.casketId = item.id;
                vm.casketForm.casket.$setValidity('invalidCasket', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                if (
                    vm.casketId &&
                    vm.casketId !== '00000000-0000-0000-0000-000000000000'
                ) {
                    // Set dirty
                    vm.casketForm.$setDirty();
                }
                vm.casketId = null;
                if (vm.searchText) {
                    vm.casketForm.casket.$setValidity('invalidCasket', false);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('EditAttachedAutoTaskDialogController', EditAttachedAutoTaskDialogController);

    /* @ngInject */
    function EditAttachedAutoTaskDialogController($mdDialog, attachedAutoTask, attachedProductDiscriminator) {
        var vm = this;

        // Data
        vm.attachedAutoTask = attachedAutoTask;
        vm.attachedProductDiscriminator = attachedProductDiscriminator;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onAutoTaskSelected = onAutoTaskSelected;
        vm.toggleAttachedTypeId = toggleAttachedTypeId;

        //////////
        // INIT

        function closeDialog() {
            $mdDialog.hide();
        }

        function toggleAttachedTypeId() {
            if (vm.attachedAutoTask.attachedTypeId) {
                vm.attachedAutoTask.attachedTypeId = null;
            } else {
                vm.attachedAutoTask.attachedTypeId = vm.attachedTypeId;
            }
        }

        function onAutoTaskSelected(autoTask) {
            if (autoTask) {
                vm.attachedAutoTask.autoTaskSubject = autoTask.subject;
            } else {
                vm.attachedAutoTask.autoTaskSubject = null;
            }
        }

        function saveAndCloseDialog() {
            if (!vm.attachedAutoTask.id || vm.attachedAutoTask.id === '00000000-0000-0000-0000-000000000000') {
                vm.attachedAutoTask.changeState = 1;
            } else {
                vm.attachedAutoTask.changeState = 2;
            }
            $mdDialog.hide(vm.attachedAutoTask);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('autoTaskSelect', {
            bindings: {
                autoTaskId: '=',
                autoTask: '=',
                labelText: '@',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/auto-task/components/auto-task-select/auto-task-select.tmpl.html',
            controller: 'AutoTaskSelectController as vm',
        })
        .controller('AutoTaskSelectController', AutoTaskSelectController);

    /* @ngInject */
    function AutoTaskSelectController(dataService, $q, $filter) {
        var vm = this;
        vm.autoTasks = [];
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchText = null;

        vm.$onInit = function () {
            //Get Current AutoTask
            if (vm.autoTaskId && vm.autoTaskId !== '00000000-0000-0000-0000-000000000000' && (!vm.autoTask || vm.autoTask.id !== vm.autoTaskId)) {
                dataService.getById('AutoTasks', vm.autoTaskId, true).then(function (autoTask) {
                    vm.autoTask = autoTask;
                });
            }
        };

        function querySearch(searchText) {
            if (vm.autoTasks.length === 0) {
                return dataService.getAll('AutoTasks').then(function (autoTasks) {
                    if (autoTasks && autoTasks.length > 0) {
                        autoTasks = $filter('orderBy')(autoTasks, 'subject');
                        vm.autoTasks = autoTasks;
                    }

                    return vm.autoTasks;
                });
            }
            return $q.when(vm.autoTasks);
        }

        function selectedItemChange(item) {
            vm.autoTaskForm.$setDirty();
            if (item) {
                vm.autoTaskId = item.id;
                vm.autoTaskForm.autoTask.$setValidity('invalidAutoTask', true);
                vm.onUpdate({ action: 'selected', value: item });
            } else {
                vm.autoTaskId = null;
                if (vm.searchText) {
                    vm.autoTaskForm.autoTask.$setValidity('invalidAutoTask', false);
                }

                vm.onUpdate({ action: 'deselected', value: null });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('autoTaskList', {
            bindings: {
                autoTasks: '=',
                attachedType: '@',
                attachedTypeId: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/auto-task/components/attached-auto-task-list/attached-auto-task-list.tmpl.html',
            controller: 'AutoTaskListController as vm',
        })
        .controller('AutoTaskListController', AutoTaskListController);

    /* @ngInject */
    function AutoTaskListController(autoTaskService, attachedProductDiscriminator) {
        var vm = this;

        vm.showEditAutoTaskDialog = showEditAutoTaskDialog;
        vm.deleteOrUndoAutoTask = deleteOrUndoAutoTask;
        vm.getDiscriminatorText = getDiscriminatorText;

        //INIT
        vm.$onInit = function () {};

        function onAutoTaskChanged(autoTask, action) {
            vm.onUpdate({ action: action || 'updated', value: autoTask });
        }

        function getDiscriminatorText(autoTask) {
            if (!autoTask) return null;
            for (var i = 0; i < attachedProductDiscriminator.length; i++) {
                var discriminator = attachedProductDiscriminator[i];
                if (discriminator.value === autoTask.discriminator) {
                    return discriminator.text;
                }
            }
        }

        function showEditAutoTaskDialog(autoTask, e) {
            var autoTaskCopy = null;
            if (autoTask) {
                autoTaskCopy = angular.copy(autoTask);
            } else {
                autoTaskCopy = autoTaskService.getEmptyAttachedAutoTask(vm.attachedType);
                autoTaskCopy.changeState = 1;
                autoTaskCopy.attachedTypeId = vm.attachedTypeId;
            }
            autoTaskService.showEditDialog(e, autoTaskCopy).then(function (editedAutoTask) {
                if (editedAutoTask) {
                    if (editedAutoTask.changeState === 1) {
                        vm.autoTasks.push(editedAutoTask);
                    } else {
                        autoTask.remarks = editedAutoTask.remarks;
                        autoTask.validThrough = editedAutoTask.validThrough;
                        autoTask.discriminator = editedAutoTask.discriminator;
                        autoTask.departmentId = editedAutoTask.departmentId;
                        autoTask.departmentName = editedAutoTask.departmentName;
                        autoTask.attachedTypeId = editedAutoTask.attachedTypeId;
                        autoTask.attachedTypeName = editedAutoTask.attachedTypeName;
                        autoTask.autoTaskId = editedAutoTask.autoTaskId;
                        autoTask.autoTaskSubject = editedAutoTask.autoTaskSubject;
                        autoTask.changeState = editedAutoTask.changeState;
                    }
                }
            });
        }

        function deleteOrUndoAutoTask(autoTask, e) {
            if (!autoTask) return;
            if (autoTask.changeState === 3) {
                autoTask.changeState = 2;
            } else if (autoTask.changeState === 1) {
                var index = vm.autoTasks.indexOf(autoTask);
                vm.autoTasks.splice(index, 1);
            } else {
                autoTask.changeState = 3;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').controller('EditAutoProductDialogController', EditAutoProductDialogController);

    /* @ngInject */
    function EditAutoProductDialogController($mdDialog, autoProduct, attachedProductDiscriminator) {
        var vm = this;

        // Data
        vm.autoProduct = autoProduct;
        vm.attachedTypeId = autoProduct.attachedTypeId;
        vm.attachedProductDiscriminator = attachedProductDiscriminator;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onProductSelected = onProductSelected;
        vm.toggleAttachedTypeId = toggleAttachedTypeId;

        //////////
        // INIT

        function closeDialog() {
            $mdDialog.hide();
        }

        function onProductSelected(product) {
            if (product) {
                vm.autoProduct.productName = product.name;
            } else {
                vm.autoProduct.productName = null;
            }
        }

        function toggleAttachedTypeId() {
            if (vm.autoProduct.attachedTypeId) {
                vm.autoProduct.attachedTypeId = null;
            } else {
                vm.autoProduct.attachedTypeId = vm.attachedTypeId;
            }
        }

        function saveAndCloseDialog() {
            if (!vm.autoProduct.id || vm.autoProduct.id === '00000000-0000-0000-0000-000000000000') {
                vm.autoProduct.changeState = 1;
            } else {
                vm.autoProduct.changeState = 2;
            }
            $mdDialog.hide(vm.autoProduct);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('autoProductList', {
            bindings: {
                autoProducts: '=',
                attachedType: '@',
                attachedTypeId: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/reference-types/auto-product/components/auto-product-list/auto-product-list.tmpl.html',
            controller: 'AutoProductListController as vm',
        })
        .controller('AutoProductListController', AutoProductListController);

    /* @ngInject */
    function AutoProductListController(autoProductService, attachedProductDiscriminator) {
        var vm = this;

        vm.showEditAutoProductDialog = showEditAutoProductDialog;
        vm.deleteOrUndoAutoProduct = deleteOrUndoAutoProduct;
        vm.getDiscriminatorText = getDiscriminatorText;

        //INIT
        vm.$onInit = function () {};

        function onAutoProductChanged(autoProduct, action) {
            vm.onUpdate({ action: action || 'updated', value: autoProduct });
        }

        function getDiscriminatorText(autoProduct) {
            if (!autoProduct) return null;
            for (var i = 0; i < attachedProductDiscriminator.length; i++) {
                var discriminator = attachedProductDiscriminator[i];
                if (discriminator.value === autoProduct.discriminator) {
                    return discriminator.text;
                }
            }
        }

        function showEditAutoProductDialog(autoProduct, e) {
            var autoProductCopy = null;
            if (autoProduct) {
                autoProductCopy = angular.copy(autoProduct);
            } else {
                autoProductCopy = autoProductService.getEmptyAutoProduct(vm.attachedType);
                autoProductCopy.amount = 1;
                autoProductCopy.billTo = 1;
                autoProductCopy.attachedTypeId = vm.attachedTypeId;
            }
            autoProductService.showEditDialog(e, autoProductCopy).then(function (editedAutoProduct) {
                if (editedAutoProduct) {
                    if (editedAutoProduct.changeState === 1) {
                        vm.autoProducts.push(editedAutoProduct);
                    } else {
                        autoProduct.remarks = editedAutoProduct.remarks;
                        autoProduct.amount = editedAutoProduct.amount;
                        autoProduct.triggerAmount = editedAutoProduct.triggerAmount;
                        autoProduct.amountFollowsParentAmount = editedAutoProduct.amountFollowsParentAmount;
                        autoProduct.billTo = editedAutoProduct.billTo;
                        autoProduct.validThrough = editedAutoProduct.validThrough;
                        autoProduct.discriminator = editedAutoProduct.discriminator;
                        autoProduct.defaultIfEmpty = editedAutoProduct.defaultIfEmpty;
                        autoProduct.departmentId = editedAutoProduct.departmentId;
                        autoProduct.departmentName = editedAutoProduct.departmentName;
                        autoProduct.attachedTypeId = editedAutoProduct.attachedTypeId;
                        autoProduct.attachedTypeName = editedAutoProduct.attachedTypeName;
                        autoProduct.productId = editedAutoProduct.productId;
                        autoProduct.productName = editedAutoProduct.productName;
                        autoProduct.changeState = editedAutoProduct.changeState;
                    }
                }
            });
        }

        function deleteOrUndoAutoProduct(autoProduct, e) {
            if (!autoProduct) return;
            if (autoProduct.changeState === 3) {
                autoProduct.changeState = 2;
            } else if (autoProduct.changeState === 1) {
                var index = vm.autoProducts.indexOf(autoProduct);
                vm.autoProducts.splice(index, 1);
            } else {
                autoProduct.changeState = 3;
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .directive("streetAddressSearch", addressSearch);

  /* @ngInject */
  function addressSearch() {
    var directive = {
      link: link,
      templateUrl:
        "app/main/reference-types/address/directives/street-address-search/street-address-search.tmpl.html",
      restrict: "EA",
      scope: {
        onSelected: "=",
        labelText: "@"
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var placeSearch, autocomplete;

      initAutocomplete();

      function initAutocomplete() {
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        var inputElement = element.find("input")[0];
        autocomplete = new google.maps.places.Autocomplete(
          /** @type {!HTMLInputElement} */ (inputElement),
          { types: [] }
        );

        geolocate(autocomplete);

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        autocomplete.addListener("place_changed", fillInAddress);
        element.find("input").removeAttr("placeholder");
      }

      function fillInAddress() {
        if (angular.isFunction(scope.onSelected)) {
          var selectedPlace = autocomplete.getPlace();
          if (selectedPlace) scope.onSelected(selectedPlace);
        }
        // // Get the place details from the autocomplete object.
        // var place = autocomplete.getPlace();

        // for (var component in componentForm) {
        //     document.getElementById(component).value = '';
        //     document.getElementById(component).disabled = false;
        // }

        // // Get each component of the address from the place details
        // // and fill the corresponding field on the form.
        // for (var i = 0; i < place.address_components.length; i++) {
        //     var addressType = place.address_components[i].types[0];
        //     if (componentForm[addressType]) {
        //         var val = place.address_components[i][componentForm[addressType]];
        //         document.getElementById(addressType).value = val;
        //     }
        // }
      }

      // Bias the autocomplete object to the user's geographical location,
      // as supplied by the browser's 'navigator.geolocation' object.
      function geolocate(autocomplete) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
})();

(function () {
    'use strict';

    angular
    .module('app.referenceTypes')
    .directive('editAddress', editAddress);

    /* @ngInject */
    function editAddress() {
        
        var directive = {
            link: link,
            templateUrl: 'app/main/reference-types/address/directives/edit-address/edit-address.tmpl.html',
            restrict: 'EA',
            scope: {
                baldrisModel: '=',
                onChange: '='
            },
            controller: 'EditAddressController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

        function link(scope, element, attrs) {
          /* */
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditAddressController', EditAddressController);

    /* @ngInject */
    function EditAddressController() {
        var vm = this;
        vm.showMoreOptions = false;
        vm.addressChanged = addressChanged;
        vm.toggleMoreOptions = toggleMoreOptions;
        
        function toggleMoreOptions() {
            vm.showMoreOptions = !vm.showMoreOptions;
            if (vm.baldrisModel.isNew) vm.baldrisModel.isNew = false;
        }
        
        function addressChanged() {
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.baldrisModel);
            }
            if (vm.editAddressForm.$dirty) {
                if (vm.baldrisModel.id && vm.baldrisModel.id != '00000000-0000-0000-0000-000000000000') {
                    vm.baldrisModel.changeState = 2;
                } else {
                    vm.baldrisModel.changeState = 1;
                }
            }
        }
    }
})(); 
(function() {
  "use strict";

  angular.module("app.referenceTypes").directive("addressSearch", addressSearch);

  /* @ngInject */
  function addressSearch(dataService, addressService, countryService, $timeout) {
    var directive = {
      link: link,
      templateUrl: "app/main/reference-types/address/directives/address-search/address-search.tmpl.html",
      restrict: "EA",
      scope: {
        labelText: "@",
        address: "=",
        onUpdate: "&",
        isDisabled: "="
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var placeSearch, autocomplete;
      scope.inputElement = element.find("input")[0];
      scope.onTextInputChanged = onTextInputChanged;
      initAutocomplete();

      function initAutocomplete() {
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        autocomplete = new google.maps.places.Autocomplete(/** @type {!HTMLInputElement} */ (scope.inputElement), {
          types: []
        });

        geolocate(autocomplete);

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        autocomplete.addListener("place_changed", fillInAddress);
        element.find("input").removeAttr("placeholder");
      }

      function onTextInputChanged() {
        scope.onUpdate({ action: "typed", value: scope.address });
      }

      function fillInAddress() {
        if (scope.address) {
          var selectedAddress = autocomplete.getPlace();
          if (selectedAddress) {
            if (selectedAddress.address_components && selectedAddress.address_components.length > 0) {
              var cityFound = false;
              var stateName = null;
              var municipalityName = null;
              var countryIsoCode = null;
              scope.address.streetAddress1 = selectedAddress.name;
              $timeout(function() {
                scope.inputElement.value = selectedAddress.name;
              }, 250);
              scope.address.localizedAddress = selectedAddress.formatted_address;
              if (selectedAddress.geometry && selectedAddress.geometry.location) {
                scope.address.latitude = selectedAddress.geometry.location.lat();
                scope.address.longitude = selectedAddress.geometry.location.lng();
              }
              var street = "";
              var streetNumber = "";
              for (var index = 0; index < selectedAddress.address_components.length; index++) {
                var element = selectedAddress.address_components[index];
                if (element.types.indexOf("street_number") > -1) {
                  streetNumber = element.long_name;
                }

                if (element.types.indexOf("route") > -1) {
                  street = element.long_name;
                }

                if (element.types.indexOf("postal_town") > -1) {
                  scope.address.city = element.long_name;
                  cityFound = true;
                }
                if (element.types.indexOf("postal_code") > -1) {
                  scope.address.zipCode = element.long_name;
                }
                if (element.types.indexOf("locality") > -1 && !cityFound) {
                  scope.address.city = element.long_name;
                  cityFound = true;
                }
                if (element.types.indexOf("administrative_area_level_1") > -1) {
                  stateName = element.long_name;
                }
                if (element.types.indexOf("administrative_area_level_2") > -1) {
                  municipalityName = element.long_name;
                  scope.address.municipalityName = municipalityName;
                }
                if (element.types.indexOf("country") > -1) {
                  countryIsoCode = element.short_name;
                }
              }

              if (street + " " + streetNumber !== selectedAddress.name) {
                scope.address.streetAddress1 = street + " " + streetNumber;
                $timeout(function() {
                  scope.inputElement.value = street + " " + streetNumber;
                }, 250);
              } else {
                scope.address.streetAddress1 = selectedAddress.name;
                $timeout(function() {
                  scope.inputElement.value = selectedAddress.name;
                }, 250);
              }

              if (countryIsoCode) {
                countryService.getByIsoCode(countryIsoCode, true).then(function(country) {
                  if (country) {
                    scope.address.countryId = country.id;
                    scope.address.country = country;
                    if (stateName) {
                      dataService.search("States", stateName, scope.address.countryId, "countryId").then(function(states) {
                        if (states && states.length > 0) {
                          scope.address.stateId = states[0].id;
                          scope.address.state = states[0];
                        }
                      });
                    }
                  }
                });
              }
            }
            scope.onUpdate({ action: "selected", value: scope.address });
          }
        }
      }

      // Bias the autocomplete object to the user's geographical location,
      // as supplied by the browser's 'navigator.geolocation' object.
      function geolocate(autocomplete) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.referenceTypes").controller("EditAddressDialogController", EditAddressDialogController);

  /* @ngInject */
  function EditAddressDialogController($mdDialog, address, dataService, addressService, countryService) {
    var vm = this;

    // Data
    vm.address = address;
    vm.defaultCountryId;
    vm.editManually = false;

    // Methods
    vm.closeDialog = closeDialog;
    vm.saveAndCloseDialog = saveAndCloseDialog;
    vm.onZipCodeChange = onZipCodeChange;
    vm.onAddressSelected = onAddressSelected;
    vm.getFormattedAddress = getFormattedAddress;

    //////////
    // INIT

    // Get deafult country
    dataService.search("BaldrisConfigs", "DefaultCountry").then(function(baldrisConfigs) {
      if (baldrisConfigs && baldrisConfigs.length > 0) {
        vm.defaultCountryId = baldrisConfigs[0].dataTargetId;
        dataService.getById("Countries", vm.defaultCountryId, true).then(function(defaultCountry) {
          if (!vm.address.countryId) {
            vm.address.countryId = defaultCountry.id;
            vm.address.country = defaultCountry;
          }
        });
      }
    });

    function closeDialog() {
      $mdDialog.hide();
    }

    function onZipCodeChange() {
      if (address.country && address.country.isoCode2) {
        addressService.getPostalCode(address.zipCode, address.country.isoCode2).then(function(returnData) {
          if (returnData && returnData.postalcodes && returnData.postalcodes.length > 0) {
            address.city = returnData.postalcodes[0].placeName;
          }
        });
      }
    }

    function onAddressSelected(selectedAddress) {
      if (selectedAddress && selectedAddress.address_components && selectedAddress.address_components.length > 0) {
        var cityFound = false;
        var stateName = null;
        var municipalityName = null;
        var countryIsoCode = null;
        vm.address.streetAddress1 = selectedAddress.name;
        vm.address.localizedAddress = selectedAddress.formatted_address;
        if (selectedAddress.geometry && selectedAddress.geometry.location) {
          vm.address.latitude = selectedAddress.geometry.location.lat();
          vm.address.longitude = selectedAddress.geometry.location.lng();
        }
        for (var index = 0; index < selectedAddress.address_components.length; index++) {
          var element = selectedAddress.address_components[index];
          if (element.types.indexOf("postal_town") > -1) {
            vm.address.city = element.long_name;
            cityFound = true;
          }
          if (element.types.indexOf("postal_code") > -1) {
            vm.address.zipCode = element.long_name;
          }
          if (element.types.indexOf("locality") > -1 && !cityFound) {
            vm.address.city = element.long_name;
            cityFound = true;
          }
          if (element.types.indexOf("administrative_area_level_1") > -1) {
            stateName = element.long_name;
          }
          if (element.types.indexOf("administrative_area_level_2") > -1) {
            municipalityName = element.long_name;
            vm.address.municipalityName = municipalityName;
          }
          if (element.types.indexOf("country") > -1) {
            countryIsoCode = element.short_name;
          }
        }
        if (countryIsoCode) {
          countryService.getByIsoCode(countryIsoCode, true).then(function(country) {
            if (country) {
              vm.address.countryId = country.id;
              vm.address.country = country;
              if (stateName) {
                dataService.search("States", stateName, vm.address.countryId, "countryId").then(function(states) {
                  if (states && states.length > 0) {
                    vm.address.stateId = states[0].id;
                    vm.address.state = states[0];
                  }
                });
              }
            }
          });
        }
      }
    }

    function getFormattedAddress() {
      return addressService.getFormattedAddress(vm.address);
    }

    function saveAndCloseDialog() {
      if (vm.defaultCountryId && vm.address.countryId && vm.defaultCountryId != vm.address.countryId) {
        vm.address.isAbroadAddress = true;
      }
      if (!vm.address.id || vm.address.id === "00000000-0000-0000-0000-000000000000") {
        vm.address.changeState = 1;
      } else {
        vm.address.changeState = 2;
      }
      $mdDialog.hide(vm.address);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('inlineAddressList', {
            bindings: {
                collection: '=',
                partyId: '=',
                baldrisUserId: '=',
                isDisabled: '<',
                disableAdd: '<',
                onUpdate: '&',
                isSingleEntry: '<',
            },
            templateUrl: 'app/main/reference-types/address/components/inline-address-list/inline-address-list.tmpl.html',
            controller: 'InlineAddressListController as vm',
        })
        .controller('InlineAddressListController', InlineAddressListController);

    /* @ngInject */
    function InlineAddressListController($window, $mdDialog, $translate, dataService, addressService) {
        var vm = this;

        vm.addNewAddress = addNewAddress;
        vm.onAddressChanged = onAddressChanged;
        vm.newAddressChip = newAddressChip;
        vm.selectAddress = selectAddress;
        vm.deleteAddress = deleteAddress;
        vm.getSelectedAddressType = getSelectedAddressType;
        vm.openAddressTypeMenu = openAddressTypeMenu;
        vm.setAddressType = setAddressType;
        vm.selectedAddress = null;
        vm.showMoreOptions = false;

        //INIT
        vm.$onInit = function () {
            if (!vm.collection) {
                vm.collection = [];
            } else {
                // Get default address
                vm.selectedAddress = getDefaultObject(vm.collection);
            }

            dataService.getAll('AddressTypes').then(function (addressTypes) {
                vm.addressTypes = addressTypes;
                vm.defaultAddressType = getDefaultObject(vm.addressTypes);

                if (vm.collection.length === 0) {
                    // Add blank address
                    var newAddress = getEmptyAddress();
                    newAddress.isDefault = true;
                    newAddress.sortOrder = 0;
                    newAddress.changeState = 0;

                    vm.collection.push(newAddress);
                    vm.selectedAddress = vm.collection[0];
                }
            });

            // Get deafult country
            dataService.search('BaldrisConfigs', 'DefaultCountry').then(function (baldrisConfigs) {
                if (baldrisConfigs && baldrisConfigs.length > 0) {
                    vm.defaultCountryId = baldrisConfigs[0].customFieldData.dataTargetId;
                    dataService.getById('Countries', vm.defaultCountryId, true).then(function (defaultCountry) {
                        vm.defaultCountry = defaultCountry;
                    });
                }
            });
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
                vm.isDisabled = changesObj.isDisabled.currentValue;
            }
        };

        function getDefaultObject(objects) {
            if (!objects || objects.length === 0) return null;
            var defaultObject = null;
            for (var i = 0, len = objects.length; i < len; i++) {
                if (!defaultObject) {
                    defaultObject = objects[i];
                }
                if (objects[i].isDefault) {
                    defaultObject = objects[i];
                    break;
                }
                if (defaultObject.sortOrder > objects[i].sortOrder) {
                    defaultObject = objects[i];
                }
            }
            return defaultObject;
        }

        function getEmptyAddress() {
            var newAddress = addressService.getEmptyAddress();
            //Determine next sortOrder
            var highestSortOrder = 0;
            var isDefault = !vm.collection || vm.collection.length === 0;
            for (var i = 0, len = vm.collection.length; i < len; i++) {
                if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
                    highestSortOrder = vm.collection[i].sortOrder;
                }
            }
            newAddress.sortOrder = highestSortOrder + 10;
            newAddress.isDefault = isDefault;
            if (vm.defaultAddressType) {
                newAddress.addressTypeId = vm.defaultAddressType.id;
                newAddress.addressType = vm.defaultAddressType;
                newAddress.addressTypeName = vm.defaultAddressType.name;
            }
            return newAddress;
        }

        function addNewAddress(e) {
            var newAddress = getEmptyAddress();

            if (vm.partyId) {
                newAddress.partyId = vm.partyId;
            }
            if (vm.baldrisUserId) {
                newAddress.baldrisUserId = vm.baldrisUserId;
            }
            vm.collection.push(newAddress);
            vm.selectedAddress = newAddress;
            vm.addressListForm.$setDirty();
            var defaultAddressElement = $window.document.getElementById('AddressSearchInput');
            defaultAddressElement.focus();
            vm.onUpdate({ action: 'add', value: newAddress });
        }

        function onAddressChanged(address, skipLocalized) {
            if (address.id && address.id !== '00000000-0000-0000-0000-000000000000') {
                address.changeState = 2;
            } else {
                address.changeState = 1;
            }
            if (!skipLocalized) {
                // update localized string automatically if no country and no state is set is set
                address.localizedAddress =
                    address.streetAddress1 + (address.streetAddress2 ? ' ' + address.streetAddress2 : '') + ', ' + address.zipCode + ' ' + address.city;
                if (address.streetAddress1 && address.zipCode && address.city && !address.countryId) {
                    // set deafult country when basic address is filled out
                    address.countryId = vm.defaultCountryId;
                    address.country = vm.defaultCountry;
                    address.countryName = vm.defaultCountry.name;
                }
            }
            if (address.countryId && address.countryId !== vm.defaultCountryId) {
                // mark as abroad address
                address.isAbroadAddress = true;
            }
            vm.onUpdate({ action: 'change', value: address });
            vm.addressListForm.$setDirty();
        }

        function newAddressChip(chip) {}

        function selectAddress(address) {
            vm.selectedAddress = address;
        }

        function deleteAddress(address, e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('ADDRESSES.ADDRESS_LIST.DELETE_ADDRESS'))
                .textContent(
                    $translate.instant('ADDRESSES.ADDRESS_LIST.DELETE_ADDRESS_CONFIRM', {
                        address: address.streetAddress1 ? address.streetAddress1 : $translate.instant('ADDRESSES.ADDRESS.ADDRESS'),
                    })
                )
                .ariaLabel($translate.instant('ADDRESSES.ADDRESS_LIST.DELETE_ADDRESS'))
                .targetEvent(e)
                .ok($translate.instant('ADDRESSES.ADDRESS_LIST.DELETE_ADDRESS'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    if (address.id && address.id !== '00000000-0000-0000-0000-000000000000') {
                        dataService.deleteItem('Addresses', address).then(function () {
                            // Remove from collection
                            var index = vm.collection.indexOf(address);
                            vm.collection.splice(index, 1);
                            replaceIfSelected(address);
                            vm.onUpdate({
                                action: 'remove',
                                value: address,
                            });
                        });
                    } else {
                        // Remove from collection
                        var index = vm.collection.indexOf(address);
                        vm.collection.splice(index, 1);
                        replaceIfSelected(address);
                        vm.onUpdate({ action: 'remove', value: address });
                    }
                },
                function () {
                    // Do nothing
                }
            );
        }

        function replaceIfSelected(address) {
            // Check if address was selected
            if (vm.selectedAddress === address) {
                // Select default address, if any
                vm.selectedAddress = getDefaultObject(vm.collection);
                // If no address selected, create blank
                if (!vm.selectedAddress) {
                    var newAddress = getEmptyAddress();
                    newAddress.isDefault = true;
                    newAddress.sortOrder = 0;
                    newAddress.changeState = 0;

                    vm.collection.push(newAddress);
                    vm.selectedAddress = vm.collection[0];
                }
            }
        }

        function openAddressTypeMenu($mdMenu, ev) {
            vm.originatorEv = ev;
            $mdMenu.open(ev);
        }

        function setAddressType(addressType) {
            if (vm.selectedAddress) {
                vm.selectedAddress.addressTypeId = addressType.id;
                vm.selectedAddress.addressTypeName = addressType.name;
                onAddressChanged(vm.selectedAddress);
            }
        }

        function getSelectedAddressType() {
            if (vm.selectedAddress) {
                if (vm.addressTypes && vm.addressTypes.length > 0) {
                    for (var index = 0; index < vm.addressTypes.length; index++) {
                        var addressType = vm.addressTypes[index];
                        if (vm.selectedAddress.addressTypeId === addressType.id) {
                            return addressType;
                        }
                    }
                }
                if (vm.selectedAddress.addressTypeName) {
                    return {
                        name: vm.selectedAddress.addressTypeName,
                        iconName: 'icon-help',
                    };
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('addressTypeSelect', {
            bindings: {
                addressTypeId: '=',
                addressType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/reference-types/address/components/address-type-select/address-type-select.tmpl.html',
            controller: 'AddressTypeSelectController as vm',
        })
        .controller('AddressTypeSelectController', AddressTypeSelectController);

    /* @ngInject */
    function AddressTypeSelectController($q, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.addressTypes = [];
        vm.onChange = onChange;
        
        //INIT
        vm.$onInit = function () {
            var promises = [];
            // Get options
            promises.push(dataService.getAll('AddressTypes'));

            //Get current choice
            if (vm.addressTypeId && !vm.addressType) {
                promises.push(dataService.getById('AddressTypes', vm.addressTypeId, true));
            }

            $q.all(promises).then(function (response) {
                vm.isDisabled = false;
                vm.addressTypes = response[0];
                if (response.length > 1) {
                    vm.addressType = response[1];
                } else {
                    for (var i = 0; i < vm.addressTypes.length; i++) {
                        var addressType = vm.addressTypes[i];
                        if (addressType.isDefault) {
                            vm.addressType = addressType;
                            vm.addressTypeId = addressType.id;
                            break;
                        }
                    }
                }
            })
        }


        function onChange() {
            if (vm.addressType) {
                vm.addressTypeId = vm.addressType.id;
            } else {
                vm.addressTypeId = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.addressType);
            }
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.referenceTypes")
    .component("addressList", {
      bindings: {
        collection: "=",
        partyId: "=",
        baldrisUserId: "="
      },
      templateUrl:
        "app/main/reference-types/address/components/address-list/address-list.tmpl.html",
      controller: "AddressListController as vm"
    })
    .controller("AddressListController", AddressListController);

  /* @ngInject */
  function AddressListController(dataService, addressService) {
    var vm = this;

    vm.addNewAddress = addNewAddress;
    vm.getAddressAsString = getAddressAsString;
    vm.showEditAddressDialog = showEditAddressDialog;
    vm.getIconName = getIconName;
    vm.deleteOrUndo = deleteOrUndo;

    //INIT
    vm.$onInit = function() {
      if (!vm.collection) {
        vm.collection = [];
      }
    };

    function addNewAddress(e) {
      var newAddress = addressService.getEmptyAddress();
      //Determine next sortOrder
      var highestSortOrder = 0;
      var isDefault = true;
      for (var i = 0, len = vm.collection.length; i < len; i++) {
        if (vm.collection[i] && vm.collection[i].sortOrder > highestSortOrder) {
          highestSortOrder = vm.collection[i].sortOrder;
        }
        if (vm.collection[i].isDefault) {
          isDefault = false;
        }
      }
      newAddress.sortOrder = highestSortOrder + 10;
      if (vm.partyId) {
        newAddress.partyId = vm.partyId;
      }
      if (vm.baldrisUserId) {
        newAddress.baldrisUserId = vm.baldrisUserId;
      }

      addressService
        .showEditDialog(e, newAddress)
        .then(function(updatedAddress) {
          if (updatedAddress) {
            if (updatedAddress.changeState === 1) {
              // Should be new Address so we just insert it to the array
              vm.collection.push(updatedAddress);
              if (vm.addressListForm) {
                vm.addressListForm.$setDirty();
              }
            }
          }
        });
    }

    function showEditAddressDialog(address, e) {
      if (
        address.$type ===
        "Baldris.Core.Data.Entities.Dto.AddressDto, Baldris.Core.Data.Entities"
      ) {
        showAddress(address);
      } else {
        dataService
          .getById("Addresses", address.id, true)
          .then(function(fullAddress) {
            showAddress(fullAddress);
          });
      }

      function showAddress(addressToShow) {
        addressService
          .showEditDialog(e, addressToShow)
          .then(function(updatedAddress) {
            if (updatedAddress) {
              if (updatedAddress.changeState === 2) {
                // Should be modified Address, locate and replace
                for (var index = 0; index < vm.collection.length; index++) {
                  var element = vm.collection[index];
                  if (element.id === updatedAddress.id) {
                    vm.collection.splice(index, 1);
                    vm.collection.push(updatedAddress);
                    break;
                  }
                }
              }
              if (vm.addressListForm) {
                vm.addressListForm.$setDirty();
              }
            }
          });
      }
    }

    function deleteAddress(address, e) {
      // if newly created, we remove it entirely
      if (address.changeState === 1) {
        var index = vm.collection.indexOf(address);
        vm.collection.splice(index, 1);
        if (vm.addressListForm) {
          vm.addressListForm.$setDirty();
        }
      } else {
        if (
          address.$type ===
          "Baldris.Core.Data.Entities.Dto.AddressDto, Baldris.Core.Data.Entities"
        ) {
          address.changeState = 3;
          if (vm.addressListForm) {
            vm.addressListForm.$setDirty();
          }
        } else {
          dataService
            .getById("Addresses", address.id, true)
            .then(function(fullAddress) {
              fullAddress.changeState = 3;
              // replace the address in the collection
              for (var index = 0; index < vm.collection.length; index++) {
                var element = vm.collection[index];
                if (element.id === fullAddress.id) {
                  vm.collection.splice(index, 1);
                  vm.collection.push(fullAddress);
                  break;
                }
              }
              if (vm.addressListForm) {
                vm.addressListForm.$setDirty();
              }
            });
        }
      }
    }

    function undoDelete(address) {
      address.changeState = 2;
    }

    function deleteOrUndo(address) {
      if (address.changeState === 3) {
        undoDelete(address);
      } else {
        deleteAddress(address);
      }
    }

    function getAddressAsString(address) {
      if (
        angular.isDefined(address.localizedAddress) &&
        address.localizedAddress
      ) {
        return address.localizedAddress;
      } else {
        return extractAddress(address);
      }
    }

    function getIconName(address) {
      if (address.addressTypeIconName) {
        return address.addressTypeIconName;
      } else if (address.addressType && address.addressType.iconName) {
        return address.addressType.iconName;
      } else {
        return "icon-map-marker";
      }
    }

    function extractAddress(address) {
      var returnString = "";

      returnString =
        address.streetAddress1 + ", " + address.zipCode + " " + address.city;
      if (address.state) {
        returnString += ", " + address.state.name;
      }

      if (address.isAbroadAddress && address.country) {
        returnString += ", " + address.country.name.toUpperCase();
      }

      return returnString;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.calendar', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .component('statusListItem', {
            bindings: {
                baldrisModel: '='
            },
            require: {
                listController: '^statusList'
            },
            templateUrl: 'app/main/note-or-task/components/status-list/status-list-item/status-list-item.tmpl.html',
            controller: 'StatusListItemController as vm',
        })
        .controller('StatusListItemController', StatusListItemController);

    /* @ngInject */
    function StatusListItemController() {
        var vm = this;

        vm.openEditDialog = openEditDialog;
        vm.isOverDue = isOverDue;
        vm.toggleTask = toggleTask;

        function isOverDue() {
            return moment().isAfter(vm.baldrisModel.dueTime, 'day');
        }

        function openEditDialog(e) {
            vm.listController.openEditDialog(vm.baldrisModel, e);
        }

        function toggleTask(e) {
            vm.listController.toggleTask(vm.baldrisModel, e);
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.noteOrTask', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('noteOrTask', {
            bindings: {
                baldrisModel: '=',
                showWorkOrderInfo: '<',
            },
            require: {
                listController: '^noteOrTaskList',
            },
            templateUrl: 'app/main/note-or-task/components/note-or-task-list/note-or-task/note-or-task.tmpl.html',
            controller: 'NoteOrTaskController as vm',
        })
        .controller('NoteOrTaskController', NoteOrTaskController);

    /* @ngInject */
    function NoteOrTaskController($filter, $mdDialog, $document, $mdToast, noteOrTaskOptions, $state, noteOrTaskViewService, noteOrTaskService) {
        var vm = this;
        vm.getCompletedUsers = getCompletedUsers;
        vm.toggleTask = toggleTask;
        vm.openEditDialog = openEditDialog;
        vm.isOverdue = isOverdue;
        vm.navigateToWorkOrder = navigateToWorkOrder;
        vm.toDate = null;

        vm.$onInit = function () {
            //Extract flags to bools for easier control in templates
            vm.isTask = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('isTask') > -1;
            vm.isAutogenerated = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('isAutoGenerated') > -1;
            vm.isFollowUp = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('isFollowUp') > -1;
            vm.isIndividualCompleteTask = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('isIndividualCompleteTask') > -1;
            vm.isPrivate = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('isPrivate') > -1;
            vm.hasOutcomes = vm.baldrisModel.options && vm.baldrisModel.options.indexOf('hasOutcomes') > -1;

            vm.toDate = getToDate();
        };

        function getCompletedUsers() {
            if (!vm.baldrisModel.recipients || vm.baldrisModel.recipients.length === 0) {
                return [];
            }

            return vm.baldrisModel.recipients.filter(function (recipient) {
                return recipient.hasCompletedTask;
            });
        }

        function toggleTask(e) {
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            vm.listController.toggleTask(vm.baldrisModel);
        }

        function openEditDialog(e) {
            vm.listController.openEditDialog(vm.baldrisModel, e);
        }

        function getToDate() {
            if (
                (vm.baldrisModel.objectType && vm.baldrisModel.objectType.indexOf('Calendar') > -1) ||
                (vm.baldrisModel.dbType && vm.baldrisModel.dbType.indexOf('Calendar') > -1)
            ) {
                if (vm.baldrisModel.endTime && !moment(vm.baldrisModel.endTime).isSame(vm.baldrisModel.startTime, 'day')) {
                    return moment(vm.baldrisModel.endTime).endOf('day').toDate();
                }
                return moment(vm.baldrisModel.startTime).endOf('day').toDate();
            }
            return moment(vm.baldrisModel.dueTime).endOf('day').toDate();
        }

        function isOverdue() {
            if (vm.toDate && moment(vm.toDate).isBefore(new Date())) {
                return true;
            }
            return false;
        }

        function navigateToWorkOrder(e) {
            if (e) {
                e.stopPropagation();
            }
            $state.go('app.workOrder.byId.deceased', {
                workOrderId: vm.baldrisModel.workOrderId,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.externalOrder', [

        ]);
})(); 
(function () {
    'use strict';

    angular.module('app.externalOrder').controller('EditHeadstoneInscriptionDialogController', EditHeadstoneInscriptionDialogController);

    /* @ngInject */
    function EditHeadstoneInscriptionDialogController($q, $mdDialog, dataService, workOrderId, headstoneInscription, deceasedId) {
        var vm = this;
        vm.isNew = false;
        vm.hasProduct = false;
        vm.nameSuggestions = [];

        activate();

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteHeadstoneInscription = deleteHeadstoneInscription;
        vm.onProductChanged = onProductChanged;
        vm.addNameSuggestion = addNameSuggestion;

        ////////////////

        function activate() {
            vm.headstoneInscription = headstoneInscription;

            if (!vm.headstoneInscription.id || vm.headstoneInscription.id === '00000000-0000-0000-0000-000000000000') {
                vm.isNew = true;
                vm.headstoneInscription.changeState = 1;
            }

            if (vm.headstoneInscription.productId) {
                vm.hasProduct = true;
            }

            var promises = [];

            if (workOrderId) {
                promises.push(dataService.getByWorkOrderId('Deceased', workOrderId));
            }

            if (deceasedId) {
                promises.push(dataService.getByUri('Persons', 'ByDeceasedId/' + deceasedId));
            }

            if (promises.length > 0) {
                $q.all(promises).then(function (response) {
                    if (workOrderId && response[0] && response[0].length > 0) {
                        vm.nameSuggestions = response[0].map(convertToSuggestion);
                    }
                    if (deceasedId && response[1] && response[1].length > 0) {
                        var filteredPersons = response[1].filter(function (person) {
                            return person.dateOfDeath || person.dateOfDeathApproximate;
                        });
                        if (filteredPersons && filteredPersons.length > 0) {
                            vm.nameSuggestions = vm.nameSuggestions.concat(filteredPersons.map(convertToSuggestion));
                        }
                    }
                    vm.isLoading = false;
                });
            } else {
                vm.isLoading = false;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.headstoneInscription.id) {
                vm.headstoneInscription.changeState = 2;
            }
            $mdDialog.hide(vm.headstoneInscription);
        }

        function deleteHeadstoneInscription() {
            vm.headstoneInscription.changeState = 3;
            $mdDialog.hide(vm.headstoneInscription);
        }

        function onProductChanged(product) {
            if (!product || product.id === vm.headstoneInscription.productId) return; // Don't do anything if not a product or same product we already have
            vm.headstoneInscription.overriddenName = product.name;
            vm.headstoneInscription.overriddenPrice = product.price > 0 ? product.price : vm.headstoneInscription.overriddenPrice || 0; // Don't change price if price == 0
            if (!vm.headstoneInscription.productAmount) vm.headstoneInscription.productAmount = 1;
        }

        function convertToSuggestion(person) {
            var suggestion = { name: null, lifeSpan: null, id: person.id };
            if (person.firstName || person.lastName) {
                suggestion.name = person.firstName + ' ' + person.lastName;
            } else if (person.displayName) {
                if (person.displayName.indexOf(', ') > -1) {
                    var names = person.displayName.split(', ');
                    suggestion.name = names[1] + ' ' + names[0];
                } else {
                    suggestion.name = person.displayName;
                }
            }
            if (person.dateOfBirth) {
                suggestion.lifeSpan = '* ' + moment(person.dateOfBirth).format('D-M-YYYY');
            } else if (person.dateOfBirthApproximate) {
                suggestion.lifeSpan = '* ' + person.dateOfBirthApproximate;
            }
            if (person.dateOfDeath) {
                if (suggestion.lifeSpan) {
                    suggestion.lifeSpan += '   † ' + moment(person.dateOfDeath).format('D-M-YYYY');
                } else {
                    suggestion.lifeSpan = '† ' + moment(person.dateOfDeath).format('D-M-YYYY');
                }
            } else if (person.dateOfDeathApproximate) {
                if (suggestion.lifeSpan) {
                    suggestion.lifeSpan += '   † ' + person.dateOfDeathApproximate;
                } else {
                    suggestion.lifeSpan = '† ' + person.dateOfDeathApproximate;
                }
            }
            return suggestion;
        }

        function addNameSuggestion(suggestion) {
            vm.headstoneInscription.text = suggestion.name + '\n' + suggestion.lifeSpan;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditHeadstoneAdditionDialogController', EditHeadstoneAdditionDialogController);

    /* @ngInject */
    function EditHeadstoneAdditionDialogController($mdDialog, headstoneAddition) {
        var vm = this;
        vm.isNew = false;

        activate();

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteHeadstoneAddition = deleteHeadstoneAddition;
        vm.onProductChanged = onProductChanged;

        ////////////////

        function activate() {
            vm.headstoneAddition = headstoneAddition;

            if (!vm.headstoneAddition.id || vm.headstoneAddition.id === '00000000-0000-0000-0000-000000000000') {
                vm.isNew = true;
                vm.headstoneAddition.changeState = 1;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.headstoneAddition.changeState !== 1) {
                vm.headstoneAddition.changeState = 2;
            }
            $mdDialog.hide(vm.headstoneAddition);
        }

        function deleteHeadstoneAddition() {
            vm.headstoneAddition.changeState = 3;
            $mdDialog.hide(vm.headstoneAddition);
        }

        function onProductChanged(product) {
            if (!product || product.id === vm.headstoneAddition.productId) return; // Don't do anything if not a product or same product we already have
            vm.headstoneAddition.overriddenName = product.name;
            vm.headstoneAddition.overriddenPrice = product.price > 0 ? product.price : vm.headstoneAddition.overriddenPrice; // Don't change price if price == 0
            if (!vm.headstoneAddition.productAmount) vm.headstoneAddition.productAmount = 1;
        }
    }

})();


(function () {
    'use strict';

    angular.module('app.externalOrder').controller('EditGraveInfoDialogController', EditGraveInfoDialogController);

    /* @ngInject */
    function EditGraveInfoDialogController($mdDialog, grave, workOrderId, partyService) {
        var vm = this;
        vm.isNew = false;

        activate();

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.removeLeaseHolder = removeLeaseHolder;
        vm.openChooseLeaseHolderDialog = openChooseLeaseHolderDialog;

        ////////////////

        function activate() {
            vm.grave = grave;

            if (!vm.grave.id || vm.grave.id === '00000000-0000-0000-0000-000000000000') {
                vm.isNew = true;
                vm.grave.changeState = 1;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.grave.id) {
                vm.grave.changeState = 2;
            }
            $mdDialog.hide(vm.grave);
        }

        function removeLeaseHolder() {
            vm.grave.leaseHolderDisplayName = null;
            vm.grave.leaseHolderId = null;
        }

        function openChoosePersonDialog(e) {
            return partyService.showSearchDialog(e, 'Parties', workOrderId, true, false);
        }

        function openChooseLeaseHolderDialog(e) {
            openChoosePersonDialog(e).then(function (selectedParty) {
                if (selectedParty) {
                    vm.grave.leaseHolderName = selectedParty.displayName;
                    vm.grave.leaseHolderId = selectedParty.id;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .component('headstoneOrderCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/external-order/headstone-order/components/headstone-order-card/headstone-order-card.tmpl.html',
            controller: 'HeadstoneOrderCardController as vm',
        })
        .controller('HeadstoneOrderCardController', HeadstoneOrderCardController);

    /* @ngInject */
    function HeadstoneOrderCardController() {
        var vm = this;
        vm.navigateToHeadstoneOrder = navigateToHeadstoneOrder;
        vm.deleteHeadstoneOrder = deleteHeadstoneOrder;


        function navigateToHeadstoneOrder(headstoneOrder) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(headstoneOrder);
                }
            }
        }

        function deleteHeadstoneOrder(headstoneOrder, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(headstoneOrder, e);
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .component('deceasedShipmentCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/external-order/deceased-shipment/components/deceased-shipment-card/deceased-shipment-card.tmpl.html',
            controller: 'DeceasedShipmentCardController as vm',
        })
        .controller('DeceasedShipmentCardController', DeceasedShipmentCardController);

    /* @ngInject */
    function DeceasedShipmentCardController() {
        var vm = this;
        vm.navigateToShipment = navigateToShipment;
        vm.deleteShipment = deleteShipment;


        function navigateToShipment(shipment) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(shipment);
                }
            }
        }

        function deleteShipment(shipment) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(shipment);
                }
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.deceased', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('EditGrantApplicationDialogController', EditGrantApplicationDialogController);

    /* @ngInject */
    function EditGrantApplicationDialogController($mdDialog, grantApplication, deceased) {
        var vm = this;

        //Data
        vm.grantApplication = grantApplication;
        vm.deceased = deceased;

        // Methods
        vm.closeDialog = closeDialog;

        activate();

        //////////

        function activate() {
            if (!vm.grantApplication || vm.grantApplication.id === '00000000-0000-0000-0000-000000000000') {
                vm.grantApplication.deceasedId = deceased.id;
                vm.grantApplication.deceasedPersonDisplayName = deceased.personDisplayName;
            }
        }

        function closeDialog(grantApplication) {
            $mdDialog.hide(grantApplication);
        }


    }

}());
(function() {
    'use strict';

    angular
        .module('app.workOrderReferencePerson', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .controller('EditReferencePersonToolbarController', EditReferencePersonToolbarController);


    /* @ngInject */
    function EditReferencePersonToolbarController($window, $translate, editReferencePersonViewService, loadingService) {
        var vm = this;

        // Data
        vm.data = editReferencePersonViewService;
        vm.loadingService = loadingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.referencePersonForm && vm.data.validation.referencePersonForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.referencePersonForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editReferencePersonViewService.saveReferencePerson().then(function () {
                if (vm.data.validation && vm.data.validation.referencePersonForm && vm.data.validation.referencePersonForm.$dirty) {
                    vm.data.validation.referencePersonForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .controller(
            'EditReferencePersonSidebarController',
            EditReferencePersonSidebarController
        );

    /* @ngInject */
    function EditReferencePersonSidebarController(
        $translate,
        editReferencePersonViewService,
        loadingService
    ) {
        var vm = this;

        // Data
        vm.data = editReferencePersonViewService;
        vm.loadingService = loadingService;

        // Methods
        vm.referenceTypeChanged = referenceTypeChanged;

        function referenceTypeChanged(value) {
            if (value && value.indexOf('deceased') > -1) {
                vm.data.showDateOfDeath = true;
            } else {
                vm.data.updateModel.referencePerson.dateOfDeath = null;
                vm.data.updateModel.referencePerson.dateOfDeathApproximate =
                    null;
                vm.data.showDateOfDeath = false;
            }
            if (
                value &&
                value.indexOf('spouse') > -1 &&
                !vm.data.updateModel.referencePerson.familyRelation
            ) {
                vm.data.updateModel.referencePerson.familyRelation =
                    $translate.instant(
                        'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.SPOUSE'
                    );
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .component('referencePersonTypeSelect', {
            bindings: {
                referencePersonType: '=ngModel',
                isDisabled: '=ngDisabled',
                onUpdate: '&',
                labelText: '@' 
            },
            templateUrl: 'app/main/work-order-reference-person/components/reference-person-type-select/reference-person-type-select.tmpl.html',
            controller: 'ReferencePersonTypeSelectController as vm',
        })
        .controller('ReferencePersonTypeSelectController', ReferencePersonTypeSelectController);

    /* @ngInject */
    function ReferencePersonTypeSelectController(referencePersonTypeOptions) {
        var vm = this;
        vm.options = referencePersonTypeOptions;
        
        vm.isSelected = isSelected;
        vm.toggle = toggle;

        function isSelected(option) {
            if (vm.referencePersonType & option.value) {
                return true;
            }
            return false;
        }

        function toggle(option) {
            if (isSelected(option)) {                
                vm.referencePersonType &= ~option.value;
            } else {
                vm.referencePersonType |= option.value;
            }
            vm.onUpdate({ value: vm.referencePersonType });
            if (vm.referenceTypeForm) {
                vm.referenceTypeForm.$setDirty();
            }
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.workOrderReferencePerson")
    .component("referencePersonTypeMultiSelect", {
      bindings: {
        referencePersonTypes: "=",
        referencePersonType: "=",
        onUpdate: "&",
        labelText: "@",
        isRequired: "="
      },
      templateUrl:
        "app/main/work-order-reference-person/components/reference-person-type-multi-select/reference-person-type-multi-select.tmpl.html",
      controller: "ReferencePersonTypeMultiSelectController as vm"
    })
    .controller("ReferencePersonTypeMultiSelectController", ReferencePersonTypeMultiSelectController);

  /* @ngInject */
  function ReferencePersonTypeMultiSelectController(referencePersonTypeOptions) {
    var vm = this;
    vm.isDisabled = true;
    vm.referencePersonTypeOptions = referencePersonTypeOptions;

    vm.onChange = onChange;

    vm.$onInit = function() {
      vm.referencePersonTypes = vm.referencePersonTypes || [];
      vm.referencePersonType = vm.referencePersonType || 0;
      if (vm.referencePersonType && vm.referencePersonType !== 0) {
        for (var index = 0; index < vm.referencePersonTypeOptions.length; index++) {
          var option = vm.referencePersonTypeOptions[index];
          if (vm.referencePersonType & option.value) {
            vm.referencePersonTypes.push(option);
          }
        }
      }
    };

    function onChange() {
      if (vm.referencePersonTypes && vm.referencePersonTypes.length > 0) {
        vm.referencePersonType = 0;
        for (var index = 0; index < vm.referencePersonTypes.length; index++) {
          var option = vm.referencePersonTypes[index];
          vm.referencePersonType |= option.value;
        }
      } else {
        vm.referencePersonType = 0;
      }
      vm.onUpdate({ action: "changed", value: vm.referencePersonType });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .component('referencePersonListItem', {
            bindings: {
                baldrisModel: '=ngModel',
                highlight: '=',
                onOpen: '=',
                onDelete: '&',
            },
            templateUrl:
                'app/main/work-order-reference-person/components/reference-person-list-item/reference-person-list-item.tmpl.html',
            controller: 'ReferencePersonListItemController as vm',
        })
        .controller(
            'ReferencePersonListItemController',
            ReferencePersonListItemController
        );

    /* @ngInject */
    function ReferencePersonListItemController(
        referencePersonTypeOptions,
        $translate
    ) {
        var vm = this;

        vm.$onInit = function () {
            //Init
            extractReferencePersonTypes();
        };

        vm.referencePersonTypeArray = [];
        vm.showEditReferencePersonDialog = showEditReferencePersonDialog;
        vm.deleteReferencePerson = deleteReferencePerson;
        vm.isRestricted = isRestricted;
        vm.getReferencePersonTypesString = getReferencePersonTypesString;

        function extractReferencePersonTypes() {
            vm.referencePersonTypeArray = [];
            angular.forEach(referencePersonTypeOptions, function (option) {
                if (
                    vm.baldrisModel.referencePersonType &&
                    vm.baldrisModel.referencePersonType.indexOf(option.value) >
                        -1
                ) {
                    vm.referencePersonTypeArray.push(option.text);
                }
            });
        }

        function getReferencePersonTypesString() {
            if (vm.referencePersonTypeArray.length === 0) return null;
            var returnString = vm.referencePersonTypeArray.reduce(function (
                previousValue,
                currentValue
            ) {
                if (previousValue === '')
                    return $translate.instant(currentValue);
                return previousValue + ', ' + $translate.instant(currentValue);
            },
            '');
            return returnString;
        }

        function showEditReferencePersonDialog(referencePerson, e) {
            if (angular.isFunction(vm.onOpen)) {
                vm.onOpen(referencePerson, e);
            }
        }

        function deleteReferencePerson(e) {
            vm.onDelete({
                action: 'delete',
                value: vm.baldrisModel,
                $event: e,
            });
        }

        function isRestricted() {
            return vm.baldrisModel.personPrivacyOptions & 64;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .component('funeralArrangementRightsSelect', {
            bindings: {
                funeralArrangementRight: '=ngModel',
                isDisabled: '=ngDisabled',
                labelText: '@' 
            },
            templateUrl: 'app/main/work-order-reference-person/components/funeral-arrangement-rights-select/funeral-arrangement-rights-select.tmpl.html',
            controller: 'FuneralArrangementRightsSelectController as vm',
        })
        .controller('FuneralArrangementRightsSelectController', FuneralArrangementRightsSelectController);

    /* @ngInject */
    function FuneralArrangementRightsSelectController(funeralArrangementRightOptions) {
        var vm = this;
        vm.options = funeralArrangementRightOptions;
        
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.workOrderReferencePerson")
    .controller("EditReferencePersonDialogController", EditReferencePersonDialogController);

  /* @ngInject */
  function EditReferencePersonDialogController($mdDialog, referencePerson, event, $translate, dataService) {
    var vm = this;
    vm.isDisabled = false;

    // Data
    vm.referencePerson = referencePerson;

    // Methods
    vm.closeDialog = closeDialog;
    vm.saveAndCloseDialog = saveAndCloseDialog;

    //////////

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveAndCloseDialog() {
      var vmCopy = vm;
      if (vm.referencePersonForm.$dirty) {
        if (!vm.referencePerson.id || vm.referencePerson.id === "00000000-0000-0000-0000-000000000000") {
          vm.referencePerson.changeState = 1;
          if (vm.referencePerson.person) {
            vm.referencePerson.person.changeState = 1;
          }
          dataService.insertItem("WorkOrderReferencePersons", vm.referencePerson).then(function(insertData) {
            $mdDialog.hide(insertData);
          });
        } else {
          vm.referencePerson.changeState = 2;
          if (vm.referencePerson.person) {
            vm.referencePerson.person.changeState = 2;
          }
          dataService.updateItem("WorkOrderReferencePersons", vm.referencePerson).then(function() {
            $mdDialog.hide(vm.referencePerson);
          });
        }
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderShipmentsController', WorkOrderShipmentsController);

    /* @ngInject */
    function WorkOrderShipmentsController(workOrderViewService, workOrderShipmentsViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderShipmentsViewService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderShipmentsViewService.loadShipments(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service('workOrderShipmentsViewService', workOrderShipmentsViewService);

    /* @ngInject */
    function workOrderShipmentsViewService($state, $mdDialog, $document, $translate, dataService, loadingService) {
        var self = this;
        self.shipments = null;
        self.workOrder = null;

        self.loadShipments = loadShipments;
        self.navigateToShipment = navigateToShipment;
        self.showAddShipmentDialog = showAddShipmentDialog;
        self.deleteShipment = deleteShipment;

        function loadShipments(workOrder) {
            self.workOrder = workOrder;
            return dataService.getByWorkOrderId('DeceasedShipments', workOrder.id).then(function (shipments) {
                self.shipments = shipments;
                return true;
            })
        }

        function navigateToShipment(shipment, deceased) {
            if (deceased) {
                $state.go('app.workOrder.byId.deceasedShipmentById', {deceasedShipmentId: 'new', workOrderId: self.workOrder.id, workOrderDeceased: deceased });
            } else {
                $state.go('app.workOrder.byId.deceasedShipmentById', {deceasedShipmentId: shipment.id, workOrderId: self.workOrder.id, workOrderDeceased: null });
            }
        }

        function showAddShipmentDialog(e) {
            dataService.getByWorkOrderId('WorkOrderDeceased', self.workOrder.id).then(function (workOrderDeceased) {
                if (workOrderDeceased && workOrderDeceased.length > 0) {
                    if (workOrderDeceased && workOrderDeceased.length === 1) {
                        // If only one deceased, create directly
                        navigateToShipment(null, workOrderDeceased[0]);
                    } else {
                        $mdDialog.show({
                            controller: 'AddDeceasedShipmentDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/work-order/dialogs/add-shipment-dialog/add-shipment-dialog.tmpl.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            locals: {
                                workOrderId: self.workOrder.id
                            },
                            clickOutsideToClose: true
                        }).then(function (deceased) {
                            if (deceased) {
                                navigateToShipment(null, deceased);
                            }
                        });
                    }
                }
            });

        }

        function deleteShipment(shipment, e) {
            //Prompt for confirmation
            var confirm = $mdDialog.confirm()
                .title($translate.instant('EXTERNAL_ORDERS.DECEASED_SHIPMENT.DELETE_SHIPMENT_TITLE'))
                .textContent($translate.instant('EXTERNAL_ORDERS.DECEASED_SHIPMENT.DELETE_SHIPMENT_CONFIRM', { shipmentText: shipment.departureLocationName + ' → ' + shipment.arrivalLocationName }))
                .ariaLabel($translate.instant('EXTERNAL_ORDERS.DECEASED_SHIPMENT.DELETE_SHIPMENT_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('EXTERNAL_ORDERS.DECEASED_SHIPMENT.DELETE_SHIPMENT_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(function () {
                loadingService.setBackgroundLoadingStatus(true);
                dataService.deleteItem('DeceasedShipments', shipment).then(function (deletedItem) {
                    if (deletedItem) {
                        // Remove program from view
                        var index = self.shipments.indexOf(shipment);
                        self.shipments.splice(index, 1);
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                })
            }, function () {
                // Do nothing
            });
        }
    }

})();


(function () {
    'use strict';

    angular.module('app.workOrder').controller('WorkOrderReportsController', WorkOrderReportsController);

    /* @ngInject */
    function WorkOrderReportsController($scope, $timeout, workOrderViewService, workOrderReportsViewService, loadingService, baldrisApiLegacyBase) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderReportsViewService;
        vm.baldrisApiBase = baldrisApiLegacyBase;

        vm.openSendEmailDialog = openSendEmailDialog;
        vm.showReportLogs = showReportLogs;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderReportsViewService.loadReports(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
                vm.loadingService.setBackgroundLoadingStatus(true);
                workOrderReportsViewService.loadReportLogs(vm.service.currentData.workOrder).then(function () {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                });
                // Initialize reloading - 30 seconds
                vm.reloader = $timeout(activate, 30000);
            });
        }

        function openSendEmailDialog(report, e) {
            if (e) {
                e.stopPropagation();
            }
            return workOrderReportsViewService.openSendEmailDialog(report, e).then(function (response) {
                vm.loadingService.setBackgroundLoadingStatus(true);
                workOrderReportsViewService.loadReportLogs(vm.service.currentData.workOrder).then(function () {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                });
            });
        }

        function showReportLogs(report, e) {
            vm.data.selectedReport = report;
        }

        $scope.$on('$destroy', function (p1, p2) {
            if (vm.reloader) {
                $timeout.cancel(vm.reloader);
            }
        });
    }

    angular.module('app.workOrder').controller('WorkOrderReportsSidebarController', WorkOrderReportsSidebarController);

    /* @ngInject */
    function WorkOrderReportsSidebarController(workOrderViewService, workOrderReportsViewService, loadingService, baldrisApiBase) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderReportsViewService;
        vm.baldrisApiBase = baldrisApiBase;
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderReportsViewService', workOrderReportsViewService);

    /* @ngInject */
    function workOrderReportsViewService($q, transactionalMailService, $filter, $mdDialog, dataService) {
        var self = this;
        self.reports = null;
        self.reportLogs = null;
        self.workOrder = null;
        self.selectedReport = null;
        self.showDeleted = false;

        self.loadReports = loadReports;
        self.openSendEmailDialog = openSendEmailDialog;
        self.loadReportLogs = loadReportLogs;
        self.getLatestReportLogByReportId = getLatestReportLogByReportId;
        self.getReportLogsByReportId = getReportLogsByReportId;
        self.getStatusIcon = getStatusIcon;
        self.getStatusColor = getStatusColor;
        self.getFailedCountByReportId = getFailedCountByReportId;
        self.getStatusAction = getStatusAction;
        self.previewReport = previewReport;
        self.isReportConsented = isReportConsented;
        self.reportFilter = reportFilter;

        function loadReports(workOrder, forceReload) {
            if (self.workOrder !== workOrder) self.selectedReport = null;
            self.workOrder = workOrder;
            self.reportLogs = null;

            // dataService.getByUri("Reports", "ConsentedReportsByWorkOrderId/" + self.workOrder.id).then(function(consentedReports) {
            //   self.consentedReports = consentedReports;
            // });

            if (forceReload || !self.reports || self.reports.length === 0) {
                return dataService.getByUri('Reports', 'ByInternalCategory/' + 'WorkOrder', { includeSoftDeleted: true }).then(function (reports) {
                    //reports = $filter("filter")(reports, { isDeleted: false });
                    self.reports = reports;

                    return self.reports;
                });
            }
            return $q.when(self.reports);
        }

        function reportFilter(value) {
            if (self.showDeleted) return true;
            return !value.isDeleted;
        }

        function loadReportLogs(workOrder) {
            self.reportLogs = null;
            return dataService.getByWorkOrderId('ReportLogs', workOrder.id).then(function (reportLogs) {
                reportLogs = $filter('orderBy')(reportLogs, 'statusTime', true);
                self.reportLogs = reportLogs;
                return self.reportLogs;
            });
        }

        function getLatestReportLogByReportId(reportId) {
            if (!self.reportLogs || self.reportLogs.length === 0) return null;
            for (var i = 0; i < self.reportLogs.length; i++) {
                var reportLog = self.reportLogs[i];
                if (reportLog.reportId === reportId) return reportLog;
            }
            return null;
        }

        function getReportLogsByReportId(reportId) {
            if (!self.reportLogs || self.reportLogs.length === 0) return [];
            var selectedReportLogs = [];
            for (var i = 0; i < self.reportLogs.length; i++) {
                var reportLog = self.reportLogs[i];
                if (reportLog.reportId === reportId) selectedReportLogs.push(reportLog);
            }
            return selectedReportLogs;
        }

        function isReportConsented(reportId) {
            return _.find(self.consentedReports, { reportId: reportId });
        }

        function getFailedCountByReportId(reportId) {
            if (!self.reportLogs || self.reportLogs.length === 0) return 0;
            var failedCount = 0;
            for (var i = 0; i < self.reportLogs.length; i++) {
                var reportLog = self.reportLogs[i];
                if (reportLog.reportId === reportId) {
                    if (reportLog.reportStatus === 32 || reportLog.reportStatus === 64) {
                        failedCount++;
                    }
                }
            }
            return failedCount;
        }

        function openSendEmailDialog(report, e) {
            if (e) {
                e.stopPropagation();
            }
            return dataService.getCurrentUser().then(function (currentUser) {
                return transactionalMailService
                    .showSendEmailDialog(e, currentUser, self.workOrder.departmentId, report.id, report.requiredTypes, self.workOrder.id, self.workOrder.id)
                    .then(function (response) {});
            });
        }

        function previewReport(report, e) {
            var parentEl = angular.element(document.body);
            $mdDialog
                .show({
                    controller: 'ReportViewerDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/report/dialogs/report-viewer-dialog/report-viewer-dialog.tmpl.html',
                    parent: parentEl,
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        reportViewerOptions: {
                            reportId: report.id,
                            workOrderId: self.workOrder.id,
                        },
                    },
                    clickOutsideToClose: true,
                })
                .then(function (response) {
                    if (response) {
                        vm.partyUpdateModel.party = response.partyDto;
                        vm.partyUpdateModel.privacyFields = response.partyPrivacyFields;
                        vm.privacyOptionsForm.$setDirty();
                    }
                });
        }

        function getStatusIcon(reportLog) {
            if (reportLog) {
                if (reportLog.reportStatus === 1) return 'icon-printer';
                if (reportLog.reportStatus === 2) return 'icon-send';
                if (reportLog.reportStatus === 4) return 'icon-server-network';
                if (reportLog.reportStatus === 8) return 'icon-email';
                if (reportLog.reportStatus === 16) return 'icon-email-open';
                if (reportLog.reportStatus === 32) return 'icon-close-circle';
                if (reportLog.reportStatus === 64) return 'icon-close-circle';
            }
            return 'icon-help';
        }

        function getStatusColor(reportLog) {
            if (reportLog) {
                if (reportLog.reportStatus === 1) return 'amber-300-fg';
                if (reportLog.reportStatus === 2) return 'amber-700-fg';
                if (reportLog.reportStatus === 4) return 'green-100-fg';
                if (reportLog.reportStatus === 8) return 'green-300-fg';
                if (reportLog.reportStatus === 16) return 'green-600-fg';
                if (reportLog.reportStatus === 32) return 'red-500-fg';
                if (reportLog.reportStatus === 64) return 'red-500-fg';
            }
            return null;
        }

        function getStatusAction(reportLog) {
            if (reportLog) {
                if (reportLog.reportStatus === 1) return 'WORK_ORDERS.WORK_ORDER.REPORTS.EXPORTED';
                if (reportLog.reportStatus === 2) return 'WORK_ORDERS.WORK_ORDER.REPORTS.SENT';
                if (reportLog.reportStatus === 4) return 'WORK_ORDERS.WORK_ORDER.REPORTS.PROCESSED';
                if (reportLog.reportStatus === 8) return 'WORK_ORDERS.WORK_ORDER.REPORTS.DELIVERED';
                if (reportLog.reportStatus === 16) return 'WORK_ORDERS.WORK_ORDER.REPORTS.OPENED';
                if (reportLog.reportStatus === 32) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BOUNCED';
                if (reportLog.reportStatus === 64) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BLOCKED';
            }
            return null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderReferencePersonsController', WorkOrderReferencePersonsController);

    /* @ngInject */
    function WorkOrderReferencePersonsController($stateParams, workOrderViewService, workOrderReferencePersonsViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.service = workOrderViewService;
        vm.data = workOrderReferencePersonsViewService;
        vm.highlightedId = $stateParams.highlightedId;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderReferencePersonsViewService.loadReferencePersons(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service(
            'workOrderReferencePersonsViewService',
            workOrderReferencePersonsViewService
        );

    /* @ngInject */
    function workOrderReferencePersonsViewService(
        dataService,
        $translate,
        workOrderReferencePersonService,
        $mdDialog,
        $document,
        $state
    ) {
        var self = this;

        self.referencePersons = null;
        self.workOrder = null;

        self.loadReferencePersons = loadReferencePersons;
        self.openReferencePerson = openReferencePerson;
        self.showAddNewReferencePersonDialog = showAddNewReferencePersonDialog;
        self.deleteReferencePerson = deleteReferencePerson;

        function loadReferencePersons(workOrder) {
            reset();
            self.workOrder = workOrder;
            return dataService
                .getByWorkOrderId('ReferencePersons', workOrder.id)
                .then(function (referencePersons) {
                    self.workOrder.referencePersons = referencePersons;
                    self.referencePersons = referencePersons;
                    return true;
                });
        }

        function openReferencePerson(referencePerson) {
            $state.go('app.workOrder.byId.referencePersonById', {
                referencePersonId: referencePerson.id,
            });
        }

        function showAddNewReferencePersonDialog(e) {
            if (!self.isAddingReferencePerson) {
                self.isAddingReferencePerson = true;
                dataService
                    .getByWorkOrderId('WorkOrderDeceased', self.workOrder.id)
                    .then(function (workOrderDeceasedList) {
                        $mdDialog
                            .show({
                                controller:
                                    'AddReferencePersonDialogController',
                                controllerAs: 'vm',
                                templateUrl:
                                    'app/main/work-order/dialogs/add-reference-person-dialog/add-reference-person-dialog.tmpl.html',
                                parent: angular.element($document.body),
                                targetEvent: e,
                                clickOutsideToClose: true,
                                multiple: true,
                                locals: {
                                    workOrderDeceasedList:
                                        workOrderDeceasedList || [],
                                },
                            })
                            .then(function (choice) {
                                self.isAddingReferencePerson = false;
                                if (choice) {
                                    $state.go(
                                        'app.workOrder.byId.referencePersonById',
                                        {
                                            referencePersonId: 'new',
                                            referencePerson: choice,
                                            workOrderDeceasedList:
                                                workOrderDeceasedList,
                                        }
                                    );
                                }
                            });
                    });
            }
        }

        function deleteReferencePerson(referencePerson, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title(
                    $translate.instant(
                        'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.REMOVE_REFERENCE_PERSON_TITLE'
                    )
                )
                .textContent(
                    $translate.instant(
                        'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.REMOVE_REFERENCE_PERSON_CONFIRM',
                        {
                            referencePersonName:
                                referencePerson.lastName +
                                ', ' +
                                referencePerson.firstName,
                        }
                    )
                )
                .ariaLabel(
                    $translate.instant(
                        'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.REFERENCE_PERSON'
                    )
                )
                .targetEvent(e)
                .ok(
                    $translate.instant(
                        'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.REMOVE_REFERENCE_PERSON'
                    )
                )
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService
                        .deleteItem('ReferencePersons', referencePerson)
                        .then(function () {
                            // Remove deceased from view
                            var index =
                                self.referencePersons.indexOf(referencePerson);
                            self.referencePersons.splice(index, 1);
                        });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function reset() {
            self.referencePersons = null;
            self.workOrder = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderProgramController', WorkOrderProgramController);

    /* @ngInject */
    function WorkOrderProgramController(workOrderViewService, workOrderProgramViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderProgramViewService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderProgramViewService.loadPrograms(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service('workOrderProgramViewService', workOrderProgramViewService);

    /* @ngInject */
    function workOrderProgramViewService(
        $state,
        $mdDialog,
        $document,
        $translate,
        dataService,
        commonService
    ) {
        var self = this;
        self.programs = null;
        self.workOrder = null;

        self.currentData = {
            programs: null,
            workOrder: null,
        };

        self.loadPrograms = loadPrograms;
        self.navigateToProgram = navigateToProgram;
        self.showAddProgramDialog = showAddProgramDialog;
        self.deleteProgram = deleteProgram;

        function loadPrograms(workOrder) {
            self.workOrder = workOrder;
            return dataService
                .getByWorkOrderId('ServiceSheets', workOrder.id)
                .then(function (programs) {
                    self.programs = programs;
                    return true;
                });
        }

        function navigateToProgram(program) {
            $state.go('app.workOrder.byId.programById', {
                programId: program.id,
            });
        }

        function showAddProgramDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddProgramDialogController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/work-order/dialogs/add-program-dialog/add-program-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrderId: self.workOrder.id,
                        departmentId: self.workOrder.departmentId,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (selectedCeremony) {
                    if (selectedCeremony) {
                        $state.go('app.workOrder.byId.programById', {
                            programId: 'new',
                            workOrder: self.workOrder,
                            ceremony: selectedCeremony,
                        });
                    }
                });
        }

        function deleteProgram(program, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title(
                    $translate.instant(
                        'PROGRAMS.DELETE_PROGRAM.DELETE_PROGRAM_TITLE'
                    )
                )
                .textContent(
                    $translate.instant(
                        'PROGRAMS.DELETE_PROGRAM.DELETE_PROGRAM_CONFIRM',
                        { programName: program.programName }
                    )
                )
                .ariaLabel(
                    $translate.instant(
                        'PROGRAMS.DELETE_PROGRAM.DELETE_PROGRAM_TITLE'
                    )
                )
                .targetEvent(e)
                .ok(
                    $translate.instant(
                        'PROGRAMS.DELETE_PROGRAM.DELETE_PROGRAM_ACTION'
                    )
                )
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService
                        .deleteItem('ServiceSheets', program)
                        .then(function (deletedItem) {
                            // Remove program from view
                            var programIndex = self.programs.indexOf(program);
                            self.programs.splice(programIndex, 1);
                        });
                },
                function () {
                    // Do nothing
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderOptionsService', workOrderOptionsService);

    /* @ngInject */
    function workOrderOptionsService($state, $q, $mdDialog, $translate, loadingService, dataService) {
        var self = this;
        self.workOrderDto = null;
        self.workOrderFdo = null;
        self.canDeleteWorkOrder = false;

        self.loadOptions = loadOptions;
        self.saveOptions = saveOptions;
        self.deleteWorkOrder = deleteWorkOrder;

        function loadOptions(workOrder) {
            reset();
            self.workOrderFdo = workOrder;

            var promises = [];
            promises.push(dataService.getById('WorkOrders', workOrder.id, true));
            promises.push(dataService.getByUri('WorkOrders', workOrder.id + '/CanDelete'));

            return $q.all(promises).then(function (response) {
                self.workOrderDto = response[0];
                self.canDeleteWorkOrder = response[1];
                return self.workOrderDto;
            });
        }

        function saveOptions() {
            return dataService.updateItem('WorkOrders', self.workOrderDto).then(function () {
                return dataService.getById('WorkOrders', self.workOrderDto.id, true).then(function (updatedWorkOrderDto) {
                    self.workOrderDto = updatedWorkOrderDto;
                    return self.workOrderDto;
                });
            });
        }

        function deleteWorkOrder(e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER_TITLE'))
                .textContent(
                    $translate.instant('WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER_CONFIRM', {
                        workOrderCode: self.workOrderFdo.orderCode,
                    })
                )
                .ariaLabel($translate.instant('WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    loadingService.setLoadingStatus(true);
                    return dataService
                        .deleteItem('WorkOrders', self.workOrderFdo)
                        .then(function (deletedItem) {
                            loadingService.setLoadingStatus(false);
                            $state.go('app.workOrder.dashboard.latest', {
                                latestAmount: 50,
                                date: moment().format('YYYY-MM-DD'),
                            });
                            return true;
                        })
                        .catch(function (message) {
                            loadingService.setLoadingStatus(false);
                            return message;
                        });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function reset() {
            self.workOrderDto = null;
            self.workOrderFdo = null;
            self.canDeleteWorkOrder = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderOptionsController', WorkOrderOptionsController);

    /* @ngInject */
    function WorkOrderOptionsController(workOrderViewService, workOrderOptionsService, loadingService, $window) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderOptionsService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderOptionsService.loadOptions(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            workOrderOptionsService.saveOptions().then(function (workOrderDto) {
                // Update currentData with updated data
                vm.service.currentData.workOrder.orderCode = workOrderDto.orderCode;
                vm.service.currentData.workOrder.options = workOrderDto.options;
                vm.service.currentData.workOrder.workOrderTypeId = workOrderDto.workOrderTypeId;
                vm.service.currentData.workOrder.workOrderTypeName = workOrderDto.workOrderTypeName;
                vm.service.currentData.workOrder.caseWorkerId = workOrderDto.caseWorkerId;
                vm.service.currentData.workOrder.caseWorkerDisplayName = workOrderDto.caseWorkerDisplayName;
                vm.service.currentData.workOrder.departmentId = workOrderDto.departmentId;
                vm.service.currentData.workOrder.departmentOrganizationDisplayName = workOrderDto.departmentOrganizationDisplayName;
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderObituaryNoticeController', WorkOrderObituaryNoticeController);

    /* @ngInject */
    function WorkOrderObituaryNoticeController(workOrderViewService, workOrderObituaryNoticeViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.isDisabled = false;
        vm.service = workOrderViewService;
        vm.data = workOrderObituaryNoticeViewService;
        vm.deleteObituaryNotice = deleteObituaryNotice;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderObituaryNoticeViewService.loadObituaryNotices(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function deleteObituaryNotice(obituaryNotice, e) {
            vm.loadingService.setLoadingStatus(true);
            workOrderObituaryNoticeViewService.deleteObituaryNotice(obituaryNotice, e).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderObituaryNoticeViewService', workOrderObituaryNoticeViewService);

    /* @ngInject */
    function workOrderObituaryNoticeViewService(
        $q,
        $state,
        $mdDialog,
        $document,
        $translate,
        dataService,
        commonService,
        baldrisConfigService,
        obituaryNoticeService,
        loadingService
    ) {
        var self = this;
        self.obituaryNotices = null;
        self.workOrder = null;
        self.hasAdstateConfig = false;

        self.navigateToObituaryNotice = navigateToObituaryNotice;
        self.deleteObituaryNotice = deleteObituaryNotice;
        self.loadObituaryNotices = loadObituaryNotices;
        self.showAddNewObituaryNoticeDialog = showAddNewObituaryNoticeDialog;
        self.showRetrieveAdstateEntriesDialog = showRetrieveAdstateEntriesDialog;

        function loadObituaryNotices(workOrder) {
            reset();
            self.workOrder = workOrder;
            var promises = [];
            promises.push(dataService.getByWorkOrderId('ObituaryNotices', workOrder.id));
            promises.push(getAdstateConfigs());
            return $q.all(promises).then(function (response) {
                self.obituaryNotices = response[0];
                return true;
            });
        }

        function reloadObituaryNotices() {
            if (!self.workOrder) return $q.when(false);
            return dataService.getByWorkOrderId('ObituaryNotices', self.workOrder.id, true).then(function (obituaryNotices) {
                self.obituaryNotices = obituaryNotices;
                return true;
            });
        }

        function navigateToObituaryNotice(obituaryNotice) {
            $state.go('app.workOrder.byId.obituaryNoticeById', { obituaryNoticeId: obituaryNotice.id });
        }

        function deleteObituaryNotice(obituaryNotice, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('OBITUARY_NOTICES.OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE_TITLE'))
                .textContent(
                    $translate.instant('OBITUARY_NOTICES.OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE_CONFIRM', {
                        obituaryNoticeName:
                            obituaryNotice.obituaryNoticeTypeName +
                            (' (' + obituaryNotice.supplierPartyDisplayName + ')' ? obituaryNotice.supplierPartyDisplayName : ''),
                    })
                )
                .ariaLabel($translate.instant('OBITUARY_NOTICES.OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('OBITUARY_NOTICES.OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE.DELETE_OBITUARY_NOTICE_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            return $mdDialog.show(confirm).then(
                function () {
                    return dataService.deleteItem('ObituaryNotices', obituaryNotice).then(function () {
                        var index = self.obituaryNotices.indexOf(obituaryNotice);
                        self.obituaryNotices.splice(index, 1);
                        return obituaryNotice;
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function showAddNewObituaryNoticeDialog(e) {
            dataService.getByWorkOrderId('Deceased', self.workOrder.id).then(function (deceased) {
                if (deceased && deceased.length > 0) {
                    return $mdDialog
                        .show({
                            controller: 'AddObituaryNoticeDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/work-order/dialogs/add-obituary-notice-dialog/add-obituary-notice-dialog.tmpl.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            locals: {
                                deceased: deceased,
                            },
                            clickOutsideToClose: true,
                        })
                        .then(function (response) {
                            if (response && response.type === 'ADSTATE') {
                                return showCreateAdstateEntryDialog(response.deceasedId, e);
                            }
                            if (response && response.type === 'CUSTOM') {
                                $state.go('app.workOrder.byId.obituaryNoticeById', {
                                    obituaryNoticeId: 'new',
                                    deceasedId: response.deceasedId,
                                });
                            }
                        });
                }
            });
        }

        function showCreateAdstateEntryDialog(deceasedId, e) {
            return $mdDialog.show({
                controller: 'CreateAdstateEntryDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/obituary-notice/dialogs/create-adstate-entry-dialog/create-adstate-entry-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    deceasedId: deceasedId,
                },
                clickOutsideToClose: true,
            });
        }

        function showRetrieveAdstateEntriesDialog(e) {
            return $mdDialog
                .show({
                    controller: 'RetrieveAdstateEntriesDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/obituary-notice/dialogs/retrieve-adstate-entries-dialog/retrieve-adstate-entries-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrder: self.workOrder,
                        obituaryNotices: self.obituaryNotices,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (response) {
                    if (response && response.adstateEntries && angular.isArray(response.adstateEntries) && response.adstateEntries.length > 0) {
                        loadingService.setLoadingStatus(true);
                        var promises = [];
                        for (var i = 0; i < response.adstateEntries.length; i++) {
                            var adstateEntry = response.adstateEntries[i];
                            if (adstateEntry.targetId !== 'none' && adstateEntry.targetId !== 'new') {
                                var updateCommand = {
                                    savePreviewFilesAsAttachments: response.saveAttachments,
                                    createSupplierIfNotFound: true,
                                    adstateAd: adstateEntry,
                                };
                                promises.push(obituaryNoticeService.updateFromAdstateEntry(updateCommand));
                            } else if (adstateEntry.targetId === 'new') {
                                var createCommand = {
                                    targetWorkOrderId: self.workOrder.id,
                                    targetDeceasedId: null,
                                    savePreviewFilesAsAttachments: response.saveAttachments,
                                    createSupplierIfNotFound: true,
                                    adstateAd: adstateEntry,
                                };
                                if (self.workOrder.deceased && self.workOrder.deceased.length > 0) {
                                    createCommand.targetDeceasedId = self.workOrder.deceased[0].deceasedId;
                                }
                                promises.push(obituaryNoticeService.createFromAdstateEntry(createCommand));
                            }
                        }
                        return $q.all(promises).then(function () {
                            return reloadObituaryNotices().then(function () {
                                loadingService.setLoadingStatus(false);
                                return true;
                            });
                        });
                    } else {
                        return;
                    }
                });
        }

        function getAdstateConfigs() {
            return baldrisConfigService.getByCategory('AdState').then(function (configs) {
                var departmentId = self.workOrder.departmentId;
                var foundPassword = false;
                var foundUsername = false;
                for (var i = 0; i < configs.length; i++) {
                    var config = configs[i];
                    if (
                        config.departmentId === departmentId &&
                        config.name === 'AdStatePassword' &&
                        (config.dataValueAsString || config.customFieldData.dataValueAsString)
                    ) {
                        foundPassword = true;
                    }
                    if (
                        config.departmentId === departmentId &&
                        config.name === 'AdStateUsername' &&
                        (config.dataValueAsString || config.customFieldData.dataValueAsString)
                    ) {
                        foundUsername = true;
                    }
                }
                self.hasAdstateConfig = foundPassword && foundUsername;
                return true;
            });
        }

        function reset() {
            self.obituaryNotices = null;
            self.workOrder = null;
            self.hasAdstateConfig = false;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('WorkOrderNotesAndTasksController', WorkOrderNotesAndTasksController);

    /* @ngInject */
    function WorkOrderNotesAndTasksController(workOrderViewService, noteOrTaskService, $mdDialog, $document) {
        var vm = this;
        vm.listApi = {};
        vm.addNote = addNote;
        vm.addTask = addTask;

        vm.currentData = workOrderViewService.currentData;
        vm.service = workOrderViewService;

        function addNote(e) {
            vm.listApi.addNote(e);
        }

        function addTask(e) {
            vm.listApi.addTask(e);
        }

        function openEditDialog(noteOrTask, e) {
            $mdDialog
                .show({
                    controller: 'EditNoteOrTaskDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/note-or-task/dialogs/edit-note-or-task-dialog/edit-note-or-task-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        noteOrTask: noteOrTask,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (noteOrTask) {
                    if (noteOrTask) {
                        if (noteOrTask.changeState === 3) {
                            vm.currentData.workOrder.notesAndTasks = vm.currentData.workOrder.notesAndTasks.filter(function (nt) {
                                return nt.id !== noteOrTask.id;
                            });
                        } else {
                            var notesAndTasks = vm.currentData.workOrder.notesAndTasks.filter(function (nt) {
                                return nt.id !== noteOrTask.id;
                            });
                            notesAndTasks.push(noteOrTask);
                            vm.currentData.workOrder.notesAndTasks = notesAndTasks;
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service('workOrderNotesAndTasksViewService', workOrderNotesAndTasksViewService);

    /* @ngInject */
    function workOrderNotesAndTasksViewService($state, $mdDialog, $document, $translate, dataService) {
        var self = this;

    }

})();


(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderInvoicingService', workOrderInvoicingService);

    /* @ngInject */
    function workOrderInvoicingService(
        $q,
        $state,
        $mdDialog,
        $document,
        $translate,
        dataService,
        baldrisApiBase,
        workOrderService,
        commonService,
        loadingService,
        accountService
    ) {
        var self = this;
        self.workOrderProducts = null;
        self.salesOrders = null;
        self.invoices = null;
        self.workOrder = null;

        self.loadData = loadData;
        self.getInvoicePreviewPath = getInvoicePreviewPath;
        self.showEditWorkOrderProductDialog = showEditWorkOrderProductDialog;
        self.previewSalesOrder = previewSalesOrder;
        self.getPriceIncludingVat = getPriceIncludingVat;
        self.getTotalPriceWorkOrderProducts = getTotalPriceWorkOrderProducts;
        self.getTransferredPriceWorkOrderProducts = getTransferredPriceWorkOrderProducts;
        self.getUntransferredPriceWorkOrderProducts = getUntransferredPriceWorkOrderProducts;
        self.showAddSalesOrderDialog = showAddSalesOrderDialog;
        self.showAddToExistingSalesOrderDialog = showAddToExistingSalesOrderDialog;
        self.navigateToSalesOrder = navigateToSalesOrder;
        self.navigateToInvoice = navigateToInvoice;
        self.hasUntransferredProducts = hasUntransferredProducts;

        function loadData(workOrder) {
            reset();
            self.workOrder = workOrder;
            var promises = [];
            promises.push(dataService.getByWorkOrderId('WorkOrderProducts', workOrder.id));
            if (self.canReadInvoice) {
                promises.push(dataService.getByWorkOrderId('SalesOrders', workOrder.id));
                promises.push(dataService.getByWorkOrderId('Invoices', workOrder.id));
            }
            return $q.all(promises).then(function (response) {
                self.workOrderProducts = response[0];
                if (self.canReadInvoice) {
                    self.salesOrders = response[1];
                    self.invoices = response[2];
                }
                return true;
            });
        }

        function getInvoicePreviewPath(invoice) {
            if (invoice.exportedFileFilepath) return invoice.exportedFileFilepath;
            return baldrisApiBase + '/api/Invoices/GetExportedFile/' + invoice.id;
        }

        function previewSalesOrder(salesOrder) {
            $state.go('app.salesOrder.details.preview', {
                salesOrderId: salesOrder.id,
                report: salesOrder.reportReportTemplate || 'SalesOrder.trdp',
            });
        }

        function getPriceIncludingVat(workOrderProduct) {
            return commonService.priceFunctions.getPriceIncludingVat(
                workOrderProduct.productVatRate,
                commonService.priceFunctions.getTotalPrice(workOrderProduct.amount, workOrderProduct.overriddenPrice)
            );
        }

        function getTotalPriceWorkOrderProducts(workOrderProducts) {
            if (!workOrderProducts || workOrderProducts.length === 0) return 0;
            return workOrderProducts.reduce(function (total, workOrderProduct) {
                total += getPriceIncludingVat(workOrderProduct);
                return total;
            }, 0);
        }

        function getTransferredPriceWorkOrderProducts(workOrderProducts) {
            if (!workOrderProducts || workOrderProducts.length === 0) return 0;
            return workOrderProducts.reduce(function (total, workOrderProduct) {
                if (workOrderProduct.isTransferedToOrder) {
                    total += getPriceIncludingVat(workOrderProduct);
                }
                return total;
            }, 0);
        }

        function getUntransferredPriceWorkOrderProducts(workOrderProducts) {
            if (!workOrderProducts || workOrderProducts.length === 0) return 0;
            return workOrderProducts.reduce(function (total, workOrderProduct) {
                if (!workOrderProduct.isTransferedToOrder) {
                    total += getPriceIncludingVat(workOrderProduct);
                }
                return total;
            }, 0);
        }

        function showEditWorkOrderProductDialog(workOrderProduct, e) {
            $mdDialog
                .show({
                    controller: 'EditWorkOrderProductDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/edit-work-order-product-dialog/edit-work-order-product-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        workOrderId: self.workOrder.id,
                        workOrderProduct: workOrderProduct ? angular.copy(workOrderProduct) : workOrderService.getEmptyWorkOrderDeceased(),
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updatedWorkOrderProduct) {
                    if (updatedWorkOrderProduct) {
                        if (workOrderProduct && workOrderProduct.id && workOrderProduct.id !== '00000000-0000-0000-0000-000000000000') {
                            var index = self.workOrderProducts.indexOf(workOrderProduct);
                            self.workOrderProducts.splice(index, 1);
                        }
                        if (!(updatedWorkOrderProduct.hasOwnProperty('changeState') && updatedWorkOrderProduct.changeState === 3)) {
                            self.workOrderProducts.push(updatedWorkOrderProduct);
                        }
                    }
                });
        }

        function showAddSalesOrderDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddSalesOrderDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/add-sales-order-dialog/add-sales-order-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        workOrder: self.workOrder,
                        workOrderProducts: self.workOrderProducts,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (addedSalesOrder) {
                    if (addedSalesOrder) {
                        // reload as both workOrderProducts and sales orders have changed
                        loadingService.setLoadingStatus(true);
                        loadData(self.workOrder).then(function () {
                            loadingService.setLoadingStatus(false);
                        });
                    }
                });
        }

        function showAddToExistingSalesOrderDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddToExistingSalesOrderDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/add-to-existing-sales-order-dialog/add-to-existing-sales-order-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        salesOrders: self.salesOrders,
                        workOrderProducts: self.workOrderProducts.filter(function (workOrderProduct) {
                            return !workOrderProduct.isTransferedToOrder;
                        }),
                    },
                    clickOutsideToClose: true,
                })
                .then(function (addedSalesOrder) {
                    if (addedSalesOrder) {
                        // reload as both workOrderProducts and sales orders have changed
                        loadingService.setLoadingStatus(true);
                        loadData(self.workOrder).then(function () {
                            loadingService.setLoadingStatus(false);
                        });
                    }
                });
        }

        function navigateToSalesOrder(salesOrder) {
            $state.go('app.salesOrder.details', { salesOrderId: salesOrder.id });
        }

        function navigateToInvoice(invoice) {
            $state.go('app.invoice.details', { invoiceId: invoice.id });
        }

        function deleteCalendarEvent(calendarEvent, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .textContent(
                    $translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_CONFIRM', {
                        graveName: grave.graveTypeName,
                    })
                )
                .ariaLabel($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService.deleteItem('CalendarEvents', calendarEvent).then(function (deletedItem) {
                        if (deletedItem) {
                            // Remove calendarEvent from view
                            var calendarEventIndex = self.calendarEvents.indexOf(calendarEvent);
                            self.calendarEvents.splice(calendarEventIndex, 1);
                        }
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function hasUntransferredProducts() {
            if (!self.workOrderProducts || self.workOrderProducts.length === 0) return false;
            return self.workOrderProducts.reduce(function (isUntransferred, workOrderProduct) {
                return isUntransferred || !workOrderProduct.isTransferedToOrder;
            }, false);
        }

        function reset() {
            self.canReadInvoice = accountService.userHasScopes(['read:invoice']);
            self.canWriteInvoice = accountService.userHasScopes(['write:invoice']);
            self.workOrderProducts = null;
            self.salesOrders = null;
            self.invoices = null;
            self.workOrder = null;
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.workOrder").controller("WorkOrderInvoicingController", WorkOrderInvoicingController);

  /* @ngInject */
  function WorkOrderInvoicingController(workOrderViewService, workOrderInvoicingService, loadingService) {
    var vm = this;

    vm.loadingService = loadingService;

    vm.service = workOrderViewService;
    vm.data = workOrderInvoicingService;

    vm.showTransferredProducts = false;

    vm.productFilter = productFilter;

    activate();

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      workOrderInvoicingService.loadData(vm.service.currentData.workOrder).then(function() {
        vm.loadingService.setLoadingStatus(false);
      });
    }

    function productFilter(workOrderProduct) {
      return vm.showTransferredProducts ? true : !workOrderProduct.isTransferedToOrder;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderInvoicingSidebarController', WorkOrderInvoicingSidebarController);

    /* @ngInject */
    function WorkOrderInvoicingSidebarController(workOrderViewService, workOrderInvoicingService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderInvoicingService;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderHeadstoneOrderController', WorkOrderHeadstoneOrderController);

    /* @ngInject */
    function WorkOrderHeadstoneOrderController(workOrderViewService, workOrderHeadstonerOrderViewService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderHeadstonerOrderViewService;


        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderHeadstonerOrderViewService.loadHeadstoneOrders(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderHeadstonerOrderViewService', workOrderHeadstonerOrderViewService);

    /* @ngInject */
    function workOrderHeadstonerOrderViewService($state, $mdDialog, $document, $translate, dataService, commonService) {
        var self = this;
        self.headstoneOrders = null;
        self.workOrder = null;

        self.navigateToHeadstoneOrder = navigateToHeadstoneOrder;
        self.addHeadstoneOrder = addHeadstoneOrder;
        self.deleteHeadstoneOrder = deleteHeadstoneOrder;
        self.loadHeadstoneOrders = loadHeadstoneOrders;

        function loadHeadstoneOrders(workOrder) {
            reset();
            self.workOrder = workOrder;
            return dataService.getByWorkOrderId('HeadstoneOrders', workOrder.id).then(function (headstoneOrders) {
                self.headstoneOrders = headstoneOrders;

                return true;
            });
        }

        function navigateToHeadstoneOrder(headstoneOrder) {
            $state.go('app.workOrder.byId.headstoneOrderById', { headstoneOrderId: headstoneOrder.id });
        }

        function addHeadstoneOrder(e) {
            $mdDialog
                .show({
                    controller: 'AddHeadstoneOrderDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/add-headstone-order-dialog/add-headstone-order-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        workOrderId: self.workOrder.id,
                    },
                })
                .then(function (externalOrderType) {
                    if (externalOrderType) {
                        dataService.getByWorkOrderId('WorkOrderDeceased', self.workOrder.id).then(function (workOrderDeceased) {
                            if (workOrderDeceased && workOrderDeceased.length > 0) {
                                $state.go('app.workOrder.byId.headstoneOrderById', {
                                    headstoneOrderId: 'new',
                                    workOrder: self.workOrder,
                                    workOrderDeceased: workOrderDeceased[0],
                                    externalOrderType: externalOrderType,
                                });
                            }
                        });
                    }
                });
        }

        function deleteHeadstoneOrder(headstoneOrder, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_HEADSTONE_ORDER_TITLE'))
                .textContent(
                    $translate.instant('EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_HEADSTONE_ORDER_CONFIRM', {
                        headstoneOrderName: headstoneOrder.externalOrderTypeName + ' (' + headstoneOrder.supplierPartyDisplayName + ')',
                    })
                )
                .ariaLabel($translate.instant('EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_HEADSTONE_ORDER_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_HEADSTONE_ORDER_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    return dataService.deleteItem('HeadstoneOrders', headstoneOrder).then(function () {
                        // Remove grave from view
                        var index = self.headstoneOrders.indexOf(headstoneOrder);
                        self.headstoneOrders.splice(index, 1);
                        return headstoneOrder;
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function reset() {
            self.headstoneOrders = null;
            self.workOrder = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderGroomingTransportController', WorkOrderGroomingTransportController);

    /* @ngInject */
    function WorkOrderGroomingTransportController(workOrderViewService, workOrderGroomingTransportViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderGroomingTransportViewService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderGroomingTransportViewService.loadGroomingTransports(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderGroomingTransportViewService', workOrderGroomingTransportViewService);

    /* @ngInject */
    function workOrderGroomingTransportViewService($q, $state, $mdDialog, $document, $translate, dataService, calendarService) {
        var self = this;
        self.groomingTransports = null;
        self.workOrder = null;

        self.loadGroomingTransports = loadGroomingTransports;
        self.navigateToGroomingTransport = navigateToGroomingTransport;
        self.showAddGroomingTransportDialog = showAddGroomingTransportDialog;
        self.deleteGroomingTransport = deleteGroomingTransport;
        self.isGrooming = calendarService.classUtils.isGrooming;
        self.isTransport = calendarService.classUtils.isTransport;

        function loadGroomingTransports(workOrder, forceReload) {
            self.workOrder = workOrder;
            return dataService.getByWorkOrderId('Transports', workOrder.id).then(function (events) {
                self.groomingTransports = events;
                return true;
            });
        }

        function navigateToGroomingTransport(groomingTransport, calendarEventType, workOrderDeceased, locationTransport) {
            var state = '';
            var stateOptions = calendarEventType
                ? {
                      calendarEventId: 'new',
                      calendarEventTypeId: calendarEventType.id,
                      calendarEventType: calendarEventType,
                      deceased: workOrderDeceased ? workOrderDeceased : self.workOrder.deceased,
                  }
                : { calendarEventId: groomingTransport.id };
            if (groomingTransport.hasOwnProperty('locationTransportId')) {
                state = 'app.workOrder.byId.locationTransportById';
                var apiController = 'Transports';
                if (calendarService.options.isGrooming(calendarEventType.options)) {
                    apiController = 'Groomings';
                }
                stateOptions = {
                    deceased: workOrderDeceased ? workOrderDeceased : self.workOrder.deceased,
                    locationTransportId: groomingTransport.locationTransportId,
                    calendarEventTypeId: groomingTransport.suggestedTransportTypeId,
                    calendarEventType: calendarEventType,
                    apiController: apiController,
                    transportSuggestion: locationTransport,
                };
            } else if (calendarService.classUtils.isGrooming(groomingTransport)) {
                state = 'app.workOrder.byId.groomingById';
            } else if (calendarService.classUtils.isTransport(groomingTransport)) {
                state = 'app.workOrder.byId.transportById';
            }
            $state.go(state, stateOptions);
        }

        function showAddGroomingTransportDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddGroomingTransportDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/add-grooming-transport-dialog/add-grooming-transport-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrderId: self.workOrder.id,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (groomingTransport) {
                    if (groomingTransport) {
                        dataService.getByWorkOrderId('Deceased', self.workOrder.id).then(function (workOrderDeceased) {
                            if (workOrderDeceased && workOrderDeceased.length > 0) {
                                if (groomingTransport.hasOwnProperty('locationTransportId')) {
                                    dataService.getById('LocationTransports', groomingTransport.locationTransportId).then(function (locationTransport) {
                                        dataService
                                            .getById('CalendarEventTypes', groomingTransport.suggestedTransportTypeId)
                                            .then(function (calendarEventType) {
                                                navigateToGroomingTransport(groomingTransport, calendarEventType, workOrderDeceased, locationTransport);
                                            });
                                    });
                                } else {
                                    navigateToGroomingTransport(groomingTransport, groomingTransport.calendarEventType, workOrderDeceased);
                                }
                            }
                        });
                    }
                });
        }

        function deleteGroomingTransport(groomingTransport, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('CALENDAR.DELETE_EVENT.DELETE_EVENT_TITLE'))
                .textContent(
                    $translate.instant('CALENDAR.DELETE_EVENT.DELETE_EVENT_CONFIRM', {
                        eventName: calendarService.classUtils.isTransport(groomingTransport, true)
                            ? (groomingTransport.originSerialized || groomingTransport.originName) +
                              ' ⇨ ' +
                              (groomingTransport.destinationSerialized || groomingTransport.destinationName)
                            : groomingTransport.locationSerialized || groomingTransport.locationName,
                    })
                )
                .ariaLabel($translate.instant('CALENDAR.DELETE_EVENT.DELETE_EVENT_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService.deleteItem('CalendarEvents', groomingTransport).then(function () {
                        // Remove program from view
                        var programIndex = self.groomingTransports.indexOf(groomingTransport);
                        self.groomingTransports.splice(programIndex, 1);
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderGraveController', WorkOrderGraveController);

    /* @ngInject */
    function WorkOrderGraveController(workOrderViewService, workOrderGraveViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderGraveViewService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderGraveViewService.loadGraves(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderGraveViewService', workOrderGraveViewService);

    /* @ngInject */
    function workOrderGraveViewService($state, $mdDialog, $document, $translate, dataService) {
        var self = this;
        self.graves = null;
        self.workOrder = null;

        self.loadGraves = loadGraves;
        self.navigateToGrave = navigateToGrave;
        self.showAddGraveDialog = showAddGraveDialog;
        self.deleteGrave = deleteGrave;

        function loadGraves(workOrder) {
            self.workOrder = workOrder;
            return dataService.getByWorkOrderId('Graves', workOrder.id).then(function (graves) {
                self.graves = graves;
                return true;
            });
        }

        function navigateToGrave(grave, workOrderDeceased) {
            if (!grave.id || grave.id.toLowerCase() === 'new') {
                $state.go('app.workOrder.byId.graveById', {
                    graveId: 'new',
                    graveTypeId: grave.graveTypeId,
                    deceased: workOrderDeceased,
                    graveDefaults: grave,
                });
            } else {
                $state.go('app.workOrder.byId.graveById', { graveId: grave.id });
            }
        }

        function showAddGraveDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddGraveDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/add-grave-dialog/add-grave-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrderId: self.workOrder.id,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (grave) {
                    if (grave) {
                        dataService.getByWorkOrderId('WorkOrderDeceased', self.workOrder.id).then(function (workOrderDeceased) {
                            if (workOrderDeceased && workOrderDeceased.length > 0) {
                                var selectedWorkOrderDeceased = [];
                                for (var i = 0; i < workOrderDeceased.length; i++) {
                                    var wod = workOrderDeceased[i];
                                    if (!wod.graveId) {
                                        selectedWorkOrderDeceased.push(wod);
                                    }
                                }
                                navigateToGrave(grave, selectedWorkOrderDeceased);
                            }
                        });
                    }
                });
        }

        function deleteGrave(grave, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .textContent(
                    $translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_CONFIRM', {
                        graveName: grave.graveTypeName,
                    })
                )
                .ariaLabel($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService.deleteItem('Graves', grave).then(function () {
                        // Remove grave from view
                        var graveIndex = self.graves.indexOf(grave);
                        self.graves.splice(graveIndex, 1);
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderFlowerOrderController', WorkOrderFlowerOrderController);

    /* @ngInject */
    function WorkOrderFlowerOrderController(workOrderViewService, workOrderFlowerOrderViewService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderFlowerOrderViewService;


        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderFlowerOrderViewService.loadFlowerOrders(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service(
            'workOrderFlowerOrderViewService',
            workOrderFlowerOrderViewService
        );

    /* @ngInject */
    function workOrderFlowerOrderViewService(
        $state,
        $mdDialog,
        $translate,
        dataService,
        commonService
    ) {
        var self = this;
        self.flowerOrders = null;
        self.workOrder = null;

        self.navigateToFlowerOrder = navigateToFlowerOrder;
        self.addFlowerOrder = addFlowerOrder;
        self.deleteFlowerOrder = deleteFlowerOrder;
        self.loadFlowerOrders = loadFlowerOrders;

        function loadFlowerOrders(workOrder) {
            reset();
            self.workOrder = workOrder;
            return dataService
                .getByWorkOrderId('FlowerOrders', workOrder.id)
                .then(function (flowerOrders) {
                    self.flowerOrders = flowerOrders;
                    return true;
                });
        }

        function navigateToFlowerOrder(flowerOrder) {
            $state.go('app.workOrder.byId.flowerOrderById', {
                flowerOrderId: flowerOrder.id,
            });
        }

        function addFlowerOrder(e) {
            $state.go('app.workOrder.byId.flowerOrderById', {
                flowerOrderId: 'new',
                workOrder: self.workOrder,
            });
        }

        function deleteFlowerOrder(flowerOrder, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title(
                    $translate.instant(
                        'FLOWER_ORDERS.FLOWER_ORDER.DELETE_FLOWER_ORDER.DELETE_FLOWER_ORDER_TITLE'
                    )
                )
                .textContent(
                    $translate.instant(
                        'FLOWER_ORDERS.FLOWER_ORDER.DELETE_FLOWER_ORDER.DELETE_FLOWER_ORDER_CONFIRM',
                        {
                            flowerOrderName:
                                flowerOrder.supplierPartyDisplayName,
                        }
                    )
                )
                .ariaLabel(
                    $translate.instant(
                        'FLOWER_ORDERS.FLOWER_ORDER.DELETE_FLOWER_ORDER.DELETE_FLOWER_ORDER_TITLE'
                    )
                )
                .targetEvent(e)
                .ok(
                    $translate.instant(
                        'FLOWER_ORDERS.FLOWER_ORDER.DELETE_FLOWER_ORDER.DELETE_FLOWER_ORDER_ACTION'
                    )
                )
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    return dataService
                        .deleteItem('FlowerOrders', flowerOrder)
                        .then(function () {
                            // Remove flowerORder from view
                            var index = self.flowerOrders.indexOf(flowerOrder);
                            self.flowerOrders.splice(index, 1);
                            index =
                                self.workOrder.externalOrders.indexOf(
                                    flowerOrder
                                );
                            self.workOrder.externalOrders.splice(index, 1);
                            return true;
                        });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function reset() {
            self.flowerOrders = null;
            self.workOrder = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderDeceasedController', WorkOrderDeceasedController);

    /* @ngInject */
    function WorkOrderDeceasedController(workOrderViewService, workOrderDeceasedViewService, loadingService) {
        var vm = this;

        vm.service = workOrderViewService;
        vm.data = workOrderDeceasedViewService;
        vm.loadingService = loadingService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            //Load deceased data
            workOrderDeceasedViewService.loadDeceased(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderDeceasedViewService', workOrderDeceasedViewService);

    /* @ngInject */
    function workOrderDeceasedViewService($q, $state, $mdDialog, $document, $translate, dataService, deceasedService, workOrderService, commonService) {
        var self = this;

        self.deceased = null;
        self.workOrder = null;

        self.navigateToDeceased = navigateToDeceased;
        self.deleteWorkOrderDeceased = deleteWorkOrderDeceased;
        self.showAddNewDeceasedDialog = showAddNewDeceasedDialog;
        self.loadDeceased = loadDeceased;

        function loadDeceased(workOrder) {
            // reset currentData
            reset();
            self.workOrder = workOrder;

            return dataService.getByWorkOrderId('Deceased', self.workOrder.id).then(function (deceased) {
                self.deceased = deceased;
                return true;
            });
        }

        function navigateToDeceased(deceased) {
            $state.go('app.workOrder.byId.deceasedById', {
                deceasedId: deceased.id,
            });
        }

        function deleteWorkOrderDeceased(deceased, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('DECEASED.DELETE_DECEASED.REMOVE_DECEASED_TITLE'))
                .textContent($translate.instant('DECEASED.DELETE_DECEASED.REMOVE_DECEASED_CONFIRM', { deceasedName: deceased.displayName }))
                .ariaLabel($translate.instant('DECEASED.DELETE_DECEASED.REMOVE_DECEASED'))
                .targetEvent(e)
                .ok($translate.instant('DECEASED.DELETE_DECEASED.REMOVE_DECEASED'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    // Get WorkOrderDeceased
                    dataService.getByWorkOrderId('WorkOrderDeceased', self.workOrder.id).then(function (workOrderDeceasedList) {
                        for (var index = 0; index < workOrderDeceasedList.length; index++) {
                            var element = workOrderDeceasedList[index];
                            if (element.deceasedId === deceased.id) {
                                dataService.deleteItem('WorkOrderDeceased', element).then(function (deletedItem) {
                                    // Remove deceased from view
                                    var deceasedIndex = self.deceased.indexOf(deceased);
                                    self.deceased.splice(deceasedIndex, 1);
                                });
                                break;
                            }
                        }
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function showAddNewDeceasedDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddWorkOrderDeceasedDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/work-order/dialogs/add-reference-person-dialog/add-reference-person-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                })
                .then(function (choice) {
                    if (choice) {
                        if (choice.hasOwnProperty('appliedCasketAttributes')) {
                            var newWorkOrderDeceased = workOrderService.getEmptyWorkOrderDeceased();
                            newWorkOrderDeceased.deceasedId = choice.id;
                            newWorkOrderDeceased.workOrderId = self.workOrder.id;
                            dataService.insertItem('WorkOrderDeceased', newWorkOrderDeceased).then(function (insertedWd) {
                                if (!self.deceased) self.deceased = [];
                                self.deceased.push(choice);
                            });
                        } else {
                            $state.go('app.workOrder.byId.deceasedById', {
                                deceasedId: 'new',
                                person: choice,
                            });
                        }
                    }
                });
        }

        function reset() {
            self.deceased = null;
            self.workOrder = null;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('WorkOrderConsignmentsController', WorkOrderConsignmentsController);

    /* @ngInject */
    function WorkOrderConsignmentsController(workOrderViewService, loadingService, signatureJobService, $state) {
        var vm = this;

        vm.service = workOrderViewService;
        vm.loadingService = loadingService;

        vm.addConsignment = addConsignment;
        vm.openConsignment = openConsignment;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            //Load ceremony data
            loadConsignments(vm.service.currentData.workOrder.id).then(function (consignments) {
                vm.consignments = consignments;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function loadConsignments(workOrderId) {
            return signatureJobService.getSignatureJobsByWorkOrderId(workOrderId);
        }

        function addConsignment(e) {
            $state.go('app.workOrder.byId.createConsignment');
        }

        function openConsignment(e, consignment) {
            $state.go('app.workOrder.byId.consignmentById', { signatureJobId: consignment.id });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderCeremonyController', WorkOrderCeremonyController);

    /* @ngInject */
    function WorkOrderCeremonyController(workOrderViewService, workOrderCeremonyViewService, loadingService) {
        var vm = this;

        vm.service = workOrderViewService;
        vm.data = workOrderCeremonyViewService;
        vm.loadingService = loadingService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            //Load ceremony data
            workOrderCeremonyViewService.loadCeremonies(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service('workOrderCeremonyViewService', workOrderCeremonyViewService);

    /* @ngInject */
    function workOrderCeremonyViewService(
        $q,
        $state,
        $mdDialog,
        $document,
        $translate,
        dataService
    ) {
        var self = this;

        self.ceremonies = null;
        self.workOrder = null;

        self.loadCeremonies = loadCeremonies;
        self.navigateToCeremony = navigateToCeremony;
        self.showAddCeremonyDialog = showAddCeremonyDialog;
        self.deleteCeremony = deleteCeremony;

        function loadCeremonies(workOrder, forceReload) {
            reset();
            self.workOrder = workOrder;
            if (
                forceReload ||
                !self.ceremonies ||
                self.ceremonies.length === 0
            ) {
                return dataService
                    .getByWorkOrderId('Ceremonies', workOrder.id)
                    .then(function (ceremonies) {
                        self.ceremonies = ceremonies;
                        return true;
                    });
            }
        }

        function navigateToCeremony(ceremony) {
            $state.go('app.workOrder.byId.ceremonyById', {
                calendarEventId: ceremony.id,
            });
        }

        function showAddCeremonyDialog(e) {
            dataService
                .getByWorkOrderId('Deceased', self.workOrder.id)
                .then(function (workOrderDeceased) {
                    var includeOptions = 16;
                    var excludeOptions = 8192;
                    if (workOrderDeceased && workOrderDeceased.length > 0) {
                        // Only check the first one
                        if (workOrderDeceased[0].options & 1) {
                            includeOptions = 8192;
                            excludeOptions = 0;
                        }
                    }
                    $mdDialog
                        .show({
                            controller: 'AddCeremonyDialogController',
                            controllerAs: 'vm',
                            templateUrl:
                                'app/main/work-order/dialogs/add-ceremony-dialog/add-ceremony-dialog.tmpl.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            clickOutsideToClose: true,
                            locals: {
                                includeOptions: includeOptions,
                                excludeOptions: excludeOptions,
                            },
                        })
                        .then(function (ceremonyTypeId) {
                            if (ceremonyTypeId) {
                                $state.go('app.workOrder.byId.ceremonyById', {
                                    calendarEventId: 'new',
                                    calendarEventTypeId: ceremonyTypeId,
                                    deceased: workOrderDeceased,
                                });
                            }
                        });
                });
        }

        function deleteCeremony(ceremony, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title(
                    $translate.instant(
                        'CEREMONIES.DELETE_CEREMONY.DELETE_CEREMONY_TITLE'
                    )
                )
                .textContent(
                    $translate.instant(
                        'CEREMONIES.DELETE_CEREMONY.DELETE_CEREMONY_CONFIRM',
                        {
                            ceremonyName: ceremony.ceremonyType
                                ? ceremony.ceremonyType.name
                                : $translate.instant(
                                      'CEREMONIES.CEREMONY.CEREMONY'
                                  ),
                        }
                    )
                )
                .ariaLabel(
                    $translate.instant(
                        'CEREMONIES.DELETE_CEREMONY.DELETE_CEREMONY_TITLE'
                    )
                )
                .targetEvent(e)
                .ok(
                    $translate.instant(
                        'CEREMONIES.DELETE_CEREMONY.DELETE_CEREMONY_ACTION'
                    )
                )
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService
                        .deleteItem('CalendarEvents', ceremony)
                        .then(function () {
                            // Remove ceremony from view
                            ceremonyIndex = self.ceremonies.indexOf(ceremony);
                            self.ceremonies.splice(ceremonyIndex, 1);
                        });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function reset() {
            self.ceremonies = null;
            self.workOrder = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderCalendarEventsController', WorkOrderCalendarEventsController);

    /* @ngInject */
    function WorkOrderCalendarEventsController(workOrderViewService, workOrderCalendarEventViewService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;

        vm.service = workOrderViewService;
        vm.data = workOrderCalendarEventViewService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            workOrderCalendarEventViewService.loadCalendarEvents(vm.service.currentData.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderCalendarEventViewService', workOrderCalendarEventViewService);

    /* @ngInject */
    function workOrderCalendarEventViewService($state, $mdDialog, $document, $translate, dataService, calendarService) {
        var self = this;
        self.calendarEvents = null;
        self.workOrder = null;

        self.loadCalendarEvents = loadCalendarEvents;
        self.navigateToCalendarEvent = navigateToCalendarEvent;
        self.showAddCalendarEventDialog = showAddCalendarEventDialog;
        self.deleteCalendarEvent = deleteCalendarEvent;

        function loadCalendarEvents(workOrder) {
            self.workOrder = workOrder;
            return dataService.getByWorkOrderId('CalendarEvents', workOrder.id).then(function (calendarEvents) {
                self.calendarEvents = calendarEvents;
                return true;
            });
        }

        function navigateToCalendarEvent(calendarEvent, calendarEventType, workOrderDeceased) {
            // Ceremony
            if (calendarService.classUtils.isCeremony(calendarEvent)) {
                $state.go('app.workOrder.byId.ceremonyById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    deceased: workOrderDeceased,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isGrooming(calendarEvent)) {
                $state.go('app.workOrder.byId.groomingById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    deceased: workOrderDeceased,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isTransport(calendarEvent)) {
                $state.go('app.workOrder.byId.transportById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    deceased: workOrderDeceased,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isBooking(calendarEvent)) {
                $state.go('app.workOrder.byId.bookingById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    deceased: workOrderDeceased,
                    calendarEventType: calendarEventType,
                });
            } else {
                $state.go('app.workOrder.byId.calendarEventById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    deceased: workOrderDeceased,
                    calendarEventType: calendarEventType,
                });
            }
        }

        function showAddCalendarEventDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddCalendarEventDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/calendar/dialogs/add-calendar-event-dialog/add-calendar-event-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrderId: self.workOrder.id,
                        flagOption: 'hasWorkOrder',
                    },
                    clickOutsideToClose: true,
                })
                .then(function (calendarEvent) {
                    if (calendarEvent) {
                        calendarEvent.id = 'new';
                        dataService.getByWorkOrderId('Deceased', self.workOrder.id).then(function (workOrderDeceased) {
                            if (workOrderDeceased && workOrderDeceased.length > 0) {
                                navigateToCalendarEvent(calendarEvent, calendarEvent.calendarEventType, workOrderDeceased);
                            } else {
                                navigateToCalendarEvent(calendarEvent, calendarEvent.calendarEventType);
                            }
                        });
                    }
                });
        }

        function deleteCalendarEvent(calendarEvent, e) {
            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .textContent($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_CONFIRM', { graveName: grave.graveTypeName }))
                .ariaLabel($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_TITLE'))
                .targetEvent(e)
                .ok($translate.instant('GRAVES.DELETE_GRAVE.DELETE_GRAVE_ACTION'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    dataService.deleteItem('CalendarEvents', calendarEvent).then(function (deletedItem) {
                        if (deletedItem) {
                            // Remove calendarEvent from view
                            var calendarEventIndex = self.calendarEvents.indexOf(calendarEvent);
                            self.calendarEvents.splice(calendarEventIndex, 1);
                        }
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.workOrder").controller("WorkOrderAttachmentsController", WorkOrderAttachmentsController);

  /* @ngInject */
  function WorkOrderAttachmentsController(workOrderViewService, workOrderAttachmentsViewService, loadingService) {
    var vm = this;

    vm.loadingService = loadingService;

    vm.isDisabled = false;
    vm.service = workOrderViewService;
    vm.data = workOrderAttachmentsViewService;

    activate();

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      workOrderAttachmentsViewService.loadAttachments(vm.service.currentData.workOrder).then(function() {
        vm.loadingService.setLoadingStatus(false);
      });
    }
  }

  angular
    .module("app.workOrder")
    .controller("WorkOrderAttachmentsSidebarController", WorkOrderAttachmentsSidebarController);

  /* @ngInject */
  function WorkOrderAttachmentsSidebarController(
    workOrderViewService,
    workOrderAttachmentsViewService,
    loadingService
  ) {
    var vm = this;

    vm.loadingService = loadingService;

    vm.isDisabled = false;
    vm.service = workOrderViewService;
    vm.data = workOrderAttachmentsViewService;
  }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').service('workOrderAttachmentsViewService', workOrderAttachmentsViewService);

    /* @ngInject */
    function workOrderAttachmentsViewService($http, $mdDialog, $translate, $q, dataService, loadingService, workOrderService, baldrisApiBase) {
        var self = this;
        self.workOrderAttachments = null;
        self.workOrder = null;
        self.uploadFiles = [];
        self.selectedAttachments = [];

        self.loadAttachments = loadAttachments;
        self.uploadSelectedFiles = uploadSelectedFiles;
        self.toggleSelected = toggleSelected;
        self.isAttachmentSelected = isAttachmentSelected;
        self.toggleAll = toggleAll;
        self.downloadSelected = downloadSelected;
        self.downloadSingle = downloadSingle;
        self.deleteSelected = deleteSelected;

        function loadAttachments(workOrder) {
            reset();
            self.workOrder = workOrder;
            self.workOrderAttachments = [];
            self.uploadFiles = [];
            return dataService.getByWorkOrderId('WorkOrderAttachments', workOrder.id).then(function (workOrderAttachments) {
                self.workOrderAttachments = workOrderAttachments;
                return self.workOrderAttachments;
            });
        }

        function uploadSelectedFiles() {
            if (self.uploadFiles && self.uploadFiles.length > 0) {
                loadingService.setLoadingStatus(true);
                var formData = new FormData();
                angular.forEach(self.uploadFiles, function (obj) {
                    if (!obj.isRemote) {
                        formData.append('files[]', obj.lfFile);
                    }
                });
                dataService.uploadFiles(formData).then(function (uploadedFiles) {
                    var dtoModels = [];
                    if (uploadedFiles && uploadedFiles.length > 0) {
                        for (var i = 0; i < uploadedFiles.length; i++) {
                            var file = uploadedFiles[i];
                            var dtoModel = workOrderService.getEmptyWorkOrderAttachment();
                            dtoModel.workOrderId = self.workOrder.id;
                            dtoModel.fileId = file.id;
                            dtoModel.changeState = 1;
                            dtoModels.push(dtoModel);
                        }
                        if (dtoModels.length > 0) {
                            dataService.bulkUpdate('WorkOrderAttachments', dtoModels).then(function (bulkList) {
                                loadAttachments(self.workOrder).then(function () {
                                    loadingService.setLoadingStatus(false);
                                });
                            });
                        }
                    }
                });
            }
        }

        function toggleSelected(attachment, e) {
            if (e) {
                e.stopPropagation();
            }
            if (attachment) {
                if (!self.selectedAttachments) self.selectedAttachments = [];
                var index = self.selectedAttachments.indexOf(attachment);
                if (index > -1) {
                    self.selectedAttachments.splice(index, 1);
                } else {
                    self.selectedAttachments.push(attachment);
                }
            }
        }

        function toggleAll() {
            if (!self.selectedAttachments) self.selectedAttachments = [];
            if (!self.workOrderAttachments) self.workOrderAttachments = [];
            if (self.workOrderAttachments.length === self.selectedAttachments.length) {
                self.selectedAttachments = [];
            } else {
                self.selectedAttachments = self.workOrderAttachments.slice();
            }
        }

        function isAttachmentSelected(attachment) {
            if (!attachment || !self.selectedAttachments || self.selectedAttachments.length === 0) return false;
            return self.selectedAttachments.indexOf(attachment) > -1;
        }

        function deleteSelected(e) {
            if (!self.selectedAttachments || self.selectedAttachments.length === 0) return;

            //Prompt for confirmation
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('COMMON.DIALOG.DELETE_SELECTED_FILES'))
                .textContent($translate.instant('COMMON.DIALOG.DELETE_SELECTED_FILES_CONFIRM'))
                .ariaLabel($translate.instant('COMMON.DIALOG.DELETE_SELECTED_FILES'))
                .targetEvent(e)
                .ok($translate.instant('COMMON.DIALOG.OK_DELETE'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            $mdDialog.show(confirm).then(
                function () {
                    loadingService.setLoadingStatus(true);
                    var promises = [];
                    for (var index = 0; index < self.selectedAttachments.length; index++) {
                        var attachment = self.selectedAttachments[index];
                        promises.push(dataService.deleteItem('WorkOrderAttachments', attachment));
                    }
                    $q.all(promises).then(function () {
                        for (var resultIndex = 0; resultIndex < self.selectedAttachments.length; resultIndex++) {
                            var deletedAttachment = self.selectedAttachments[resultIndex];
                            removeAttachment(deletedAttachment);
                        }
                        self.selectedAttachments = [];
                        loadingService.setLoadingStatus(false);
                    });
                },
                function () {
                    // Do nothing
                }
            );
        }

        function removeAttachment(attachment) {
            if (!self.workOrderAttachments || self.workOrderAttachments.length === 0) return;
            for (var index = 0; index < self.workOrderAttachments.length; index++) {
                var workOrderAttachment = self.workOrderAttachments[index];
                if (workOrderAttachment.id === attachment.id) {
                    self.workOrderAttachments.splice(index, 1);
                }
            }
        }

        function downloadSelected() {
            if (self.selectedAttachments && self.selectedAttachments.length > 0) {
                loadingService.setLoadingStatus(true);
                downloadFiles(self.selectedAttachments);
            }
        }

        function downloadSingle(attachment, e) {
            if (e) {
                e.stopPropagation();
            }
            downloadFiles([attachment], attachment.fileName);
        }

        function downloadFiles(files, fileName) {
            if (files && files.length > 0) {
                if (files.length === 1) {
                    $http.get(baldrisApiBase + '/api/BaldrisFiles/' + files[0].fileId + '/Download', { responseType: 'arraybuffer' }).then(function (data) {
                        saveFilesToDesktop(data, fileName || files[0].fileName, files[0].fileContentType);
                        loadingService.setLoadingStatus(false);
                    });
                } else {
                    var baldrisFiles = files.map(function (file) {
                        return {
                            id: file.fileId,
                            name: file.fileName,
                            url: file.fileUrl,
                            contentType: file.fileContentType,
                        };
                    });
                    $http.post(baldrisApiBase + '/api/BaldrisFiles/Compress', baldrisFiles, { responseType: 'arraybuffer' }).then(function (data) {
                        saveFilesToDesktop(data);
                        loadingService.setLoadingStatus(false);
                    });
                }
            }
        }

        function saveFilesToDesktop(data, fileName, contentType) {
            var octetStreamMime = 'application/octet-stream';
            var success = false;

            // Get the headers
            if (!fileName) {
                data.headers = data.headers();
            }

            // Get the filename from the x-filename header or default to "download.bin"
            var filename = fileName || data.headers['x-filename'] || 'baldris-download-' + moment().format('YYYY-MM-DD') + '.zip';

            // Determine the content type from the header or default to "application/octet-stream"
            var contentType = contentType || data.headers['content-type'] || octetStreamMime;

            var dataContent = data.data || data;

            try {
                // Try using msSaveBlob if supported
                console.log('Trying saveBlob method ...');
                var blob = new Blob([dataContent], { type: contentType });
                if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
                else {
                    // Try using other saveBlob implementations, if available
                    var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                    if (saveBlob === undefined) throw 'Not supported';
                    saveBlob(blob, filename);
                }
                console.log('saveBlob succeeded');
                success = true;
            } catch (ex) {
                console.log('saveBlob method failed with the following exception:');
                console.log(ex);
            }

            if (!success) {
                // Get the blob url creator
                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                if (urlCreator) {
                    // Try to use a download link
                    var link = document.createElement('a');
                    if ('download' in link) {
                        // Try to simulate a click
                        try {
                            // Prepare a blob URL
                            console.log('Trying download link method with simulated click ...');
                            var blob = new Blob([dataContent], { type: contentType });
                            var url = urlCreator.createObjectURL(blob);
                            link.setAttribute('href', url);

                            // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                            link.setAttribute('download', filename);

                            // Simulate clicking the download link
                            var event = document.createEvent('MouseEvents');
                            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                            link.dispatchEvent(event);
                            console.log('Download link method with simulated click succeeded');
                            success = true;
                        } catch (ex) {
                            console.log('Download link method with simulated click failed with the following exception:');
                            console.log(ex);
                        }
                    }

                    if (!success) {
                        // Fallback to window.location method
                        try {
                            // Prepare a blob URL
                            // Use application/octet-stream when using window.location to force download
                            console.log('Trying download link method with window.location ...');
                            var blob = new Blob([dataContent], { type: octetStreamMime });
                            var url = urlCreator.createObjectURL(blob);
                            window.location = url;
                            console.log('Download link method with window.location succeeded');
                            success = true;
                        } catch (ex) {
                            console.log('Download link method with window.location failed with the following exception:');
                            console.log(ex);
                        }
                    }
                }
            }
        }

        function reset() {
            self.workOrderAttachments = null;
            self.workOrder = null;
            self.uploadFiles = [];
            self.selectedAttachments = [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('ViewWorkOrderNoteOrTasksDialogController', ViewWorkOrderNoteOrTasksDialogController);

    /* @ngInject */
    function ViewWorkOrderNoteOrTasksDialogController($mdDialog, $state, $q, dataService, workOrderId) {
        var vm = this;

        vm.isLoading = true;
        vm.workOrder = null;
        vm.noteOrTasks = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.navigateToWorkOrder = navigateToWorkOrder;

        activate();

        //////////

        function activate() {

            var promises = [];
            promises.push(dataService.getById('WorkOrders', workOrderId));
            promises.push(dataService.getByWorkOrderId('NoteOrTasks', workOrderId));

            $q.all(promises).then(function (result) {
                vm.workOrder = result[0];
                vm.noteOrTasks = result[1];
                vm.isLoading = false;
            })
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function navigateToWorkOrder() {
            $state.go('app.workOrder.byId.deceased', { workOrderId: workOrderId })
        }
    }

} ());
(function () {
    'use strict';

    angular.module('app.workOrder').controller('EditWorkOrderProductDialogController', EditWorkOrderProductDialogController);

    /* @ngInject */
    function EditWorkOrderProductDialogController($mdDialog, workOrderProduct, workOrderId, dataService) {
        var vm = this;
        vm.isNew = false;

        vm.workOrderProduct = workOrderProduct;
        vm.workOrderProduct.workOrderId = workOrderId;
        if (!vm.workOrderProduct.id || vm.workOrderProduct.id === '00000000-0000-0000-0000-000000000000') {
            vm.isNew = true;
            vm.workOrderProduct.amount = 1;
            vm.workOrderProduct.changeState = 1;
        } else {
            vm.isNew = false;
            vm.workOrderProduct.changeState = 2;
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onProductChanged = onProductChanged;
        vm.deleteAndCloseDialog = deleteAndCloseDialog;

        // INIT - TODO: Make Deceased selectable

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            vm.workOrderProduct.productName = vm.workOrderProduct.overriddenName || vm.workOrderProduct.productName;
            vm.workOrderProduct.productPrice = vm.workOrderProduct.overriddenPrice || vm.workOrderProduct.productPrice;
            vm.workOrderProduct.productCost = vm.workOrderProduct.overriddenCost || vm.workOrderProduct.productCost;
            if (vm.workOrderProduct.productVatRate && vm.workOrderProduct.productPrice) {
                vm.workOrderProduct.productPriceIncludingVat = vm.workOrderProduct.productPrice * (1 + vm.workOrderProduct.productVatRate / 100);
            }
            if (vm.isNew) {
                dataService.insertItem('WorkOrderProducts', vm.workOrderProduct).then(function (insertedItem) {
                    $mdDialog.hide(insertedItem);
                });
            } else {
                dataService.updateItem('WorkOrderProducts', vm.workOrderProduct).then(function () {
                    $mdDialog.hide(vm.workOrderProduct);
                });
            }
        }

        function deleteAndCloseDialog() {
            vm.workOrderProduct.changeState = 3;
            dataService.deleteItem('WorkOrderProducts', vm.workOrderProduct).then(function () {
                $mdDialog.hide(vm.workOrderProduct);
            });
        }

        function onProductChanged(product) {
            if (product) {
                if (product.id !== vm.workOrderProduct.productId) {
                    vm.workOrderProduct.productName = product.name;
                    vm.workOrderProduct.productDefaultSortOrder = product.defaultSortOrder;
                    vm.workOrderProduct.productVatRate = product.vatRate;
                    vm.workOrderProduct.productProductCode = product.productCode;
                    vm.workOrderProduct.productProductTypeName = product.productTypeName;
                    vm.workOrderProduct.productUnitType = product.unitType;
                    vm.workOrderProduct.overriddenPrice = product.price;
                    vm.workOrderProduct.overriddenCost = product.productCost;
                    vm.workOrderProduct.overriddenName = product.name;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('AddWorkOrderDialogController', AddWorkOrderDialogController);

    /* @ngInject */
    function AddWorkOrderDialogController(
        $mdDialog,
        $rootScope,
        event,
        dataService,
        workOrderService,
        workOrderTypeId,
        departmentId,
        workOrderViewService,
        $state
    ) {
        var vm = this;
        vm.workOrderTypeId = workOrderTypeId;
        vm.departmentId = departmentId;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addWorkOrderForm.$valid) {
                $rootScope.loadingProgress = true;
                var newWorkOrder = workOrderService.getEmptyWorkOrder();
                newWorkOrder.departmentId = vm.departmentId;
                newWorkOrder.workOrderTypeId = vm.workOrderTypeId;
                newWorkOrder.options = vm.workOrderType.options;
                return dataService.insertItem('WorkOrders', newWorkOrder).then(function (savedWorkOrder) {
                    //Force a reload of available workOrders
                    workOrderViewService.loadAvailable(true).then(function (isLoaded) {
                        closeDialog();
                        $state.go('app.workOrder.byId.deceased', { workOrderId: savedWorkOrder.id });
                    });
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('AddWorkOrderDeceasedDialogController', AddWorkOrderDeceasedDialogController);

    /* @ngInject */
    function AddWorkOrderDeceasedDialogController($mdDialog, $filter, partyService, dataService) {
        var vm = this;
        vm.selectedParty = null;
        vm.isSearching = false;
        vm.newPerson = partyService.getEmptyPerson();
        vm.searchResults = [];
        vm.workOrderId = null;
        vm.title = 'WORK_ORDERS.ADD_WORK_ORDER_DECEASED_DIALOG.TITLE';
        vm.addText = 'WORK_ORDERS.ADD_WORK_ORDER_DECEASED_DIALOG.NEW_DECEASED';

        // Methods
        vm.closeDialog = closeDialog;
        vm.chooseNew = chooseNew;
        vm.choosePerson = choosePerson;
        vm.searchPersons = searchPersons;
        vm.onNameChange = onNameChange;
        vm.selectPerson = selectPerson;
        vm.openSearchDialog = openSearchDialog;

        //////////

        function searchPersons() {
            var searchText = vm.newPerson.lastName;
            if (vm.newPerson.firstName) {
                if (searchText) {
                    searchText += ', ' + vm.newPerson.firstName;
                } else {
                    searchText = vm.newPerson.firstName;
                }
            }

            if (searchText) {
                vm.isSearching = true;
                vm.searchResults = [];
                dataService.search('Persons', searchText).then(function (searchResults) {
                    searchResults = searchResults.data || searchResults;
                    searchResults = $filter('orderBy')(searchResults, 'displayName');
                    vm.searchResults = searchResults;
                    vm.isSearching = false;
                });
            }
        }

        function onNameChange() {
            // Only start search if we have both a first and last name
            if (vm.newPerson.firstName && vm.newPerson.lastName) {
                searchPersons();
            }
        }

        function selectPerson(person) {
            if (person) {
                if (vm.selectedParty && person.id === vm.selectedParty.id) {
                    vm.selectedParty = null;
                } else {
                    vm.selectedParty = person;
                }
            }
        }

        function openSearchDialog(e) {
            partyService.showSearchDialog(e, 'Persons', vm.workOrderId, false, false).then(function (selectedPerson) {
                if (selectedPerson) {
                    vm.searchResults = [];
                    vm.searchResults.push(selectedPerson);
                    vm.selectedParty = selectedPerson;
                }
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function chooseNew() {
            $mdDialog.hide(vm.newPerson);
        }

        function choosePerson() {
            if (vm.selectedParty && vm.selectedParty.id) {
                vm.isSearching = true;
                // We have to check if the selected person is already added as a deceased
                dataService.getByUri('Deceased', 'ByPersonId/' + vm.selectedParty.id).then(function (deceasedList) {
                    if (deceasedList && deceasedList.length > 0) {
                        vm.isSearching = false;
                        $mdDialog.hide(deceasedList[0]);
                    } else {
                        dataService.getById('Persons', vm.selectedParty.id, true).then(function (selectedPerson) {
                            vm.isSearching = false;
                            $mdDialog.hide(selectedPerson);
                        });
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('AddToExistingSalesOrderDialogController', AddToExistingSalesOrderDialogController);

    /* @ngInject */
    function AddToExistingSalesOrderDialogController($mdDialog, $q, commonService, billToOptions, dataService, salesOrders, workOrderProducts, salesOrderService, referencePersonTypeOptions) {
        var vm = this;

        // Data
        vm.updateModel = {
            salesOrder: null,
            lineItems: [],
            customer: {
                customer: null,
                billingAddress: null
            }
        };
        vm.selectedLineItems = [];
        vm.lineItems = [];
        vm.workOrderProducts = workOrderProducts;
        vm.salesOrders = salesOrders;

        activate();

        // Methods
        vm.isLineItemSelected = isLineItemSelected;
        vm.toggleLineItem = toggleLineItem;
        vm.getTotalPrice = getTotalPrice;
        vm.saveChanges = saveChanges;
        vm.closeDialog = closeDialog;
        vm.toggleAllLineItems = toggleAllLineItems;
        vm.selectSalesOrder = selectSalesOrder;

        function activate() {
            if (workOrderProducts && workOrderProducts.length > 0) {
                // INIT
                vm.selectedLineItems = convertToLineItems(workOrderProducts, true);
                vm.lineItems = vm.selectedLineItems.slice();
            }
            if (salesOrders && salesOrders.length === 1) {
                selectSalesOrder(salesOrders[0]);
            }
        }

        function selectSalesOrder(salesOrder) {
            vm.selectedSalesOrder = salesOrder;
            vm.updateModel.salesOrder = {
                id: vm.selectedSalesOrder.id,
                changeState: 0
            }
        }

        function convertToLineItems(workOrderProducts, onlyConvertUntransferred) {
            var lineItems = [];
            for (var i = 0; i < workOrderProducts.length; i++) {
                var workOrderProduct = workOrderProducts[i];
                if (onlyConvertUntransferred) {
                    if (!workOrderProduct.isTransferedToOrder) lineItems.push(salesOrderService.createSalesOrderProductFromWorkOrderProductShort(workOrderProduct));
                } else {
                    lineItems.push(salesOrderService.createSalesOrderProductFromWorkOrderProductShort(workOrderProduct));
                }
            }
            return lineItems;
        }

        function isLineItemSelected(lineItem) {
            return vm.selectedLineItems.indexOf(lineItem) > -1;
        }

        function toggleLineItem(lineItem) {
            if (isLineItemSelected(lineItem)) {
                var selectedIndex = vm.selectedLineItems.indexOf(lineItem);
                vm.selectedLineItems.splice(selectedIndex, 1);
            } else {
                vm.selectedLineItems.push(lineItem);
            }
        }

        function toggleAllLineItems() {
            if (vm.selectedLineItems.length > 0) {
                vm.selectedLineItems = [];
            } else {
                if (vm.lineItems && vm.lineItems.length > 0) {
                    vm.selectedLineItems = vm.lineItems.slice();
                }
            }
        }

        function getTotalPrice(lineItem) {
            return commonService.priceFunctions.getTotalPrice(lineItem.productAmount, lineItem.productTotalPrice);
        }

        function saveChanges() {
            if (vm.selectedLineItems.length > 0) {
                for (var index = 0; index < vm.selectedLineItems.length; index++) {
                    var lineItem = vm.selectedLineItems[index];
                    lineItem.changeState = 1;
                    vm.updateModel.lineItems.push(lineItem);
                }
            }
            return dataService.updateFromUpdateModel('SalesOrders', vm.updateModel).then(function (insertedData) {
                $mdDialog.hide(insertedData.salesOrder);
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller(
            'AddReferencePersonDialogController',
            AddReferencePersonDialogController
        );

    /* @ngInject */
    function AddReferencePersonDialogController(
        $mdDialog,
        $filter,
        partyService,
        dataService,
        workOrderDeceasedList
    ) {
        var vm = this;

        vm.selectedParty = null;
        vm.isSearching = false;
        vm.newPerson = partyService.getEmptyPerson();
        vm.searchResults = [];
        vm.workOrderId = null;
        vm.title = 'WORK_ORDERS.ADD_REFERENCE_PERSON_DIALOG.TITLE';
        vm.addText =
            'WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.ADD_NEW_REFERENCE_PERSON';

        // INIT
        if (
            workOrderDeceasedList &&
            workOrderDeceasedList.length > 0 &&
            workOrderDeceasedList[0].deceasedPersonDisplayName
        ) {
            vm.workOrderId = workOrderDeceasedList[0].workOrderId;
            var deceasedNames =
                workOrderDeceasedList[0].deceasedPersonDisplayName.split(', ');
            if (angular.isArray(deceasedNames) && deceasedNames.length > 0) {
                vm.newPerson.lastName = deceasedNames[0];
            }
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.chooseNew = chooseNew;
        vm.choosePerson = choosePerson;
        vm.searchPersons = searchPersons;
        vm.onNameChange = onNameChange;
        vm.selectPerson = selectPerson;
        vm.openSearchDialog = openSearchDialog;

        //////////

        function searchPersons() {
            var searchText = vm.newPerson.lastName;
            if (vm.newPerson.firstName) {
                if (searchText) {
                    searchText += ', ' + vm.newPerson.firstName;
                } else {
                    searchText = vm.newPerson.firstName;
                }
            }

            if (searchText) {
                vm.isSearching = true;
                vm.searchResults = [];
                dataService
                    .search('Persons', searchText)
                    .then(function (searchResults) {
                        vm.searchResults = searchResults;
                        vm.isSearching = false;
                    });
            }
        }

        function onNameChange() {
            // Only start search if we have both a first and last name
            if (vm.newPerson.firstName && vm.newPerson.lastName) {
                searchPersons();
            }
        }

        function selectPerson(person) {
            if (person) {
                if (vm.selectedParty && person.id === vm.selectedParty.id) {
                    vm.selectedParty = null;
                } else {
                    vm.selectedParty = person;
                }
            }
        }

        function openSearchDialog(e) {
            partyService
                .showSearchDialog(e, 'Persons', vm.workOrderId, false, false)
                .then(function (selectedPerson) {
                    if (selectedPerson) {
                        vm.searchResults = [];
                        vm.searchResults.push(selectedPerson);
                        vm.selectedParty = selectedPerson;
                    }
                });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function chooseNew() {
            $mdDialog.hide(vm.newPerson);
        }

        function choosePerson() {
            if (vm.selectedParty && vm.selectedParty.id) {
                vm.isSearching = true;
                dataService
                    .getById('Persons', vm.selectedParty.id, true)
                    .then(function (selectedPerson) {
                        vm.isSearching = false;
                        $mdDialog.hide(selectedPerson);
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('AddProgramDialogController', AddProgramDialogController);

    /* @ngInject */
    function AddProgramDialogController($mdDialog, $filter, workOrderId, departmentId, dataService) {
        var vm = this;

        vm.ceremony = null;
        vm.ceremonyId = null;
        vm.workOrderId = workOrderId;
        vm.departmentId = departmentId;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;


        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addProgramForm.$valid) {
                $mdDialog.hide(vm.ceremony);
            }
        }

    }

} ());
(function () {
    'use strict';

    angular.module('app.workOrder').controller('AddObituaryNoticeDialogController', AddObituaryNoticeDialogController);

    /* @ngInject */
    function AddObituaryNoticeDialogController($mdDialog, deceased) {
        var vm = this;

        // Methods
        vm.closeDialog = closeDialog;
        vm.closeAndCreate = closeAndCreate;
        vm.deceased = deceased;
        vm.selectedDeceased = deceased[0];
        vm.type = 1;

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function chooseAdState() {
            $mdDialog.hide({ type: 'ADSTATE', deceasedId: vm.selectedDeceased.id });
        }

        function chooseCustom() {
            $mdDialog.hide({ type: 'CUSTOM', deceasedId: vm.selectedDeceased.id });
        }

        function closeAndCreate() {
            if (vm.type == 1) {
                chooseAdState();
            } else {
                chooseCustom();
            }
        }

        activate();

        ////////////////

        function activate() {}
    }
})();

/**
 * Created by JSH on 23.11.2016.
 */

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('AddHeadstoneOrderDialogController', AddHeadstoneOrderDialogController);

    /* @ngInject */
    function AddHeadstoneOrderDialogController($mdDialog, workOrderId) {
        var vm = this;

        vm.externalOrderType = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        // INIT - TODO: Make Deceased selectable

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            $mdDialog.hide(vm.externalOrderType);
        }

    }

} ());
(function () {
    'use strict';

    angular.module('app.workOrder').controller('AddGroomingTransportDialogController', AddGroomingTransportDialogController);

    /* @ngInject */
    function AddGroomingTransportDialogController($mdDialog, workOrderId, dataService, calendarService, groomingService, transportService) {
        var vm = this;

        vm.isTransport = true;

        vm.model = calendarService.getEmptyCalendarEvent();
        vm.model.changeState = 1;
        vm.model.workOrderId = workOrderId;
        vm.suggestedTransports = [];
        vm.isLoadingSuggestedTransports = false;
        vm.selectedSuggestion = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.selectSuggestion = selectSuggestion;
        vm.selectSuggestionAndClose = selectSuggestionAndClose;

        // INIT - TODO: Make Deceased selectable
        activate();

        //////////

        function activate() {
            if (workOrderId) {
                vm.isLoadingSuggestedTransports = true;
                dataService.getByUri('TransportSuggestions', 'ByWorkOrderId/' + workOrderId).then(function (suggestedTransports) {
                    vm.suggestedTransports = suggestedTransports;
                    vm.isLoadingSuggestedTransports = false;
                });
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addTransportForm.$valid) {
                var calendarEventType = angular.copy(vm.model.calendarEventType);
                var calendarEventTypeId = angular.copy(vm.model.calendarEventTypeId);
                if (calendarService.options.isGrooming(vm.model.calendarEventType.options)) {
                    vm.model = groomingService.getEmptyGrooming();
                } else {
                    vm.model = transportService.getEmptyTransport();
                }
                vm.model.calendarEventType = calendarEventType;
                vm.model.calendarEventTypeId = calendarEventTypeId;
                $mdDialog.hide(vm.model);
            }
        }

        function selectSuggestion(suggestion) {
            if (vm.selectedSuggestion === suggestion) {
                vm.selectedSuggestion = null;
            } else {
                vm.selectedSuggestion = suggestion;
            }
        }

        function selectSuggestionAndClose() {
            if (vm.selectedSuggestion) {
                $mdDialog.hide(vm.selectedSuggestion);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('AddGraveDialogController', AddGraveDialogController);

    /* @ngInject */
    function AddGraveDialogController($mdDialog, $q, $translate, workOrderId, dataService, graveService, referencePersonTypeOptions) {
        var vm = this;

        vm.grave = graveService.getEmptyGrave();
        vm.deceased = [];
        vm.foundDeceasedWithoutGrave = false;
        vm.isLoadingDeceased = true;
        vm.suggestedLeaseHolder = null;
        vm.suggestedPrevioulsyBuried = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.toggleSuggestedLeaseHolder = toggleSuggestedLeaseHolder;
        vm.toggleSuggestedPreviouslyBuried = toggleSuggestedPreviouslyBuried;
        vm.getReferencePersonTypesString = getReferencePersonTypesString;

        // INIT - TODO: Make Deceased selectable

        var promises = [];

        promises.push(dataService.getByWorkOrderId('Deceased', workOrderId, true));
        promises.push(dataService.getByWorkOrderId('ReferencePersons', workOrderId, false, { overridePseudomization: true }));

        $q.all(promises).then(function (response) {
            var deceased = response[0];
            var referencePersons = response[1];

            // Find deceased
            vm.deceased = deceased;
            for (var index = 0; index < vm.deceased.length; index++) {
                var deceased = vm.deceased[index];
                if (!deceased.graveId) {
                    vm.foundDeceasedWithoutGrave = true;
                }
            }

            // Suggest LeaseHolder and prev. buried
            for (var index = 0; index < referencePersons.length; index++) {
                var refPerson = referencePersons[index];
                if (!vm.grave.leaseHolderId && refPerson.referencePersonType && refPerson.referencePersonType.indexOf('graveLeaseHolder') > -1) {
                    vm.grave.leaseHolderId = refPerson.personId;
                    vm.grave.leaseHolderDisplayName = refPerson.lastName + ', ' + refPerson.firstName;
                    vm.grave.leaseHolderDateOfBirth = refPerson.dateOfBirth;
                    vm.grave.leaseHolderSocialSecurityNumber = refPerson.socialSecurityNumber;
                    vm.grave.leaseHolderImageUrl = refPerson.imageUrl;
                    vm.grave.leaseHolderReferencePersonType = refPerson.referencePersonType;
                    vm.suggestedLeaseHolder = refPerson;
                }
                if (!vm.grave.previouslyBuried && refPerson.referencePersonType && refPerson.referencePersonType.indexOf('deceased') > -1) {
                    vm.grave.previouslyBuriedId = refPerson.personId;
                    vm.grave.previouslyBuriedDisplayName = refPerson.lastName + ', ' + refPerson.firstName;
                    vm.grave.previouslyBuriedReferencePersonType = refPerson.referencePersonType;
                    vm.grave.previouslyBuriedDateOfBirth = refPerson.dateOfBirth;
                    vm.grave.previouslyBuriedDateOfDeath = refPerson.dateOfDeath;
                    vm.grave.lpreviouslyBuriedSocialSecurityNumber = refPerson.socialSecurityNumber;
                    vm.grave.previouslyBuriedImageUrl = refPerson.imageUrl;
                    vm.suggestedPrevioulsyBuried = refPerson;
                }
            }

            vm.isLoadingDeceased = false;
        });

        //////////

        function toggleSuggestedLeaseHolder() {
            if (!vm.grave.leaseHolderId && vm.suggestedLeaseHolder) {
                vm.grave.leaseHolderId = vm.suggestedLeaseHolder.personId;
                vm.grave.leaseHolderDisplayName = vm.suggestedLeaseHolder.lastName + ', ' + vm.suggestedLeaseHolder.firstName;
                vm.grave.leaseHolderReferencePersonType = vm.suggestedLeaseHolder.referencePersonType;
                vm.grave.leaseHolderDateOfBirth = vm.suggestedLeaseHolder.dateOfBirth;
                vm.grave.leaseHolderDateOfDeath = vm.suggestedLeaseHolder.dateOfDeath;
                vm.grave.leaseHolderSocialSecurityNumber = vm.suggestedLeaseHolder.socialSecurityNumber;
                vm.grave.leaseHolderImageUrl = vm.suggestedLeaseHolder.imageUrl;
            } else {
                vm.grave.leaseHolderId = null;
                vm.grave.leaseHolderDisplayName = null;
                vm.grave.leaseHolderReferencePersonType = null;
            }
        }

        function toggleSuggestedPreviouslyBuried() {
            if (!vm.grave.previouslyBuriedId && vm.suggestedPrevioulsyBuried) {
                vm.grave.leaseHolderId = vm.suggestedPrevioulsyBuried.personId;
                vm.grave.previouslyBuriedDisplayName = vm.suggestedPrevioulsyBuried.lastName + ', ' + vm.suggestedPrevioulsyBuried.firstName;
                vm.grave.previouslyBuriedReferencePersonType = vm.suggestedPrevioulsyBuried.referencePersonType;
                vm.grave.previouslyBuriedDateOfBirth = vm.suggestedPrevioulsyBuried.dateOfBirth;
                vm.grave.previouslyBuriedDateOfDeath = vm.suggestedPrevioulsyBuried.dateOfDeath;
                vm.grave.previouslyBuriedSocialSecurityNumber = vm.suggestedPrevioulsyBuried.socialSecurityNumber;
                vm.grave.previouslyBuriedImageUrl = vm.suggestedPrevioulsyBuried.imageUrl;
            } else {
                vm.grave.previouslyBuriedId = null;
                vm.grave.previouslyBuriedDisplayName = null;
                vm.grave.previouslyBuriedReferencePersonType = null;
            }
        }

        function getReferencePersonTypesString(referencePersonType) {
            var referencePersonTypeArray = [];
            angular.forEach(referencePersonTypeOptions, function (option) {
                if (referencePersonType && referencePersonType.indexOf(option.value) > -1) {
                    referencePersonTypeArray.push(option.text);
                }
            });
            if (referencePersonTypeArray.length === 0) return null;
            var returnString = referencePersonTypeArray.reduce(function (previousValue, currentValue) {
                if (previousValue === '') return $translate.instant(currentValue);
                return previousValue + ', ' + $translate.instant(currentValue);
            }, '');
            return returnString;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addGraveForm.$valid) {
                $mdDialog.hide(vm.grave);
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.workOrder")
    .controller("AddCeremonyDialogController", AddCeremonyDialogController);

  /* @ngInject */
  function AddCeremonyDialogController(
    $mdDialog,
    includeOptions,
    excludeOptions
  ) {
    var vm = this;

    vm.ceremonyType = null;
    vm.ceremonyTypeId = null;
    vm.includeOptions = includeOptions;
    vm.excludeOptions = excludeOptions;

    // Methods
    vm.closeDialog = closeDialog;
    vm.saveAndCloseDialog = saveAndCloseDialog;

    //////////

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveAndCloseDialog() {
      if (vm.addCeremonyForm.$valid) {
        $mdDialog.hide(vm.ceremonyTypeId);
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').controller('WorkOrderDashboardLatestController', WorkOrderDashboardLatestController);

    /* @ngInject */
    function WorkOrderDashboardLatestController($rootScope, $state, workOrderService, workOrderDashboardViewService) {
        var vm = this;
        vm.workOrders = [];
        vm.latestAmount = $state.params.latestAmount || 25;
        vm.isLoadingWorkOrders = true;
        vm.currentData = workOrderDashboardViewService;
        vm.currentData.searchTermChanged = onSearchTermChanged;

        activate();

        ////////////////

        function activate() {
            setLoadingStatus(true);
            var workOrderTypeId = null;
            if ($state.params.workOrderTypeId === 'default') {
                for (var i = 0; i < vm.currentData.workOrderTypes.length; i++) {
                    var workOrderType = vm.currentData.workOrderTypes[i];
                    if (workOrderType.isDefault) {
                        workOrderTypeId = workOrderType.id;
                        break;
                    }
                }
            } else {
                workOrderTypeId = $state.params.workOrderTypeId;
            }
            workOrderService.getLatest(vm.latestAmount, workOrderTypeId, $state.params.departmentId, vm.currentData.searchTerm).then(function (workOrders) {
                vm.workOrders = workOrders.data;
                setLoadingStatus(false);
            });
            setDepartment($state.params.departmentId);
            setWorkOrderType(workOrderTypeId);
        }

        function setLoadingStatus(value) {
            vm.isLoadingWorkOrders = value;
            $rootScope.loadingProgress = value;
        }

        function setWorkOrderType(workOrderTypeId) {
            if (workOrderTypeId) {
                for (var i = 0; i < vm.currentData.workOrderTypes.length; i++) {
                    var workOrderType = vm.currentData.workOrderTypes[i];
                    if (workOrderType.id === workOrderTypeId) {
                        vm.currentData.selectedWorkOrderType = workOrderType;
                        break;
                    }
                }
            } else {
                vm.currentData.selectedWorkOrderType = null;
            }
        }

        function setDepartment(departmentId) {
            if (departmentId) {
                for (var i = 0; i < vm.currentData.departments.length; i++) {
                    var department = vm.currentData.departments[i];
                    if (department.id === departmentId) {
                        vm.currentData.selectedDepartment = department;
                    }
                }
            } else {
                // Set first department
                if (vm.currentData.departments && vm.currentData.departments.length > 0) {
                    vm.currentData.selectedDepartment = vm.currentData.departments[0];
                } else {
                    vm.currentData.selectedDepartment = null;
                }
            }
        }

        function onSearchTermChanged() {
            vm.workOrders = [];
            setLoadingStatus(true);
            workOrderService
                .getLatest(vm.latestAmount, vm.currentData.selectedWorkOrderType.id, $state.params.departmentId, vm.currentData.searchTerm)
                .then(function (workOrders) {
                    vm.workOrders = workOrders.data;
                    setLoadingStatus(false);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .component('workOrderSelect', {
            bindings: {
                workOrderId: '=',
                workOrder: '=',
                onSelected: '=',
                labelText: '@',
                workOrderTypeId: '<',
                departmentId: '<',
                disableSearch: '=',
                minQueryLength: '=',
                displayText: '=',
                isRequired: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/work-order/components/work-order-select/work-order-select.tmpl.html',
            controller: 'WorkOrderSelectController as vm',
        })
        .controller('WorkOrderSelectController', WorkOrderSelectController);

    /* @ngInject */
    function WorkOrderSelectController(dataService, workOrderService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current WorkOrder
            if (vm.workOrderId) {
                workOrderService.getById(vm.workOrderId).then(function (workOrder) {
                    vm.workOrder = workOrder;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.getDeceased = getDeceased;
        vm.openSearchDialog = openSearchDialog;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            return workOrderService.findWorkOrder(query, vm.workOrderTypeId, vm.departmentId).then(function (searchResult) {
                return searchResult.data;
            });
        }

        function searchTextChange(text) {}

        function openSearchDialog(e) {}

        function getDeceased(deceasedString) {
            if (!deceasedString) return null;
            return deceasedString.split(' // ');
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.onUpdate({ action: 'selected', value: item });
                vm.workOrderId = item.id;
                vm.workOrderForm.workOrder.$setValidity('invalidWorkOrder', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.orderCode;
                }
            } else {
                vm.onUpdate({ action: 'deselected', value: null });
                vm.workOrderId = null;
                if (vm.searchText) {
                    vm.workOrderForm.workOrder.$setValidity('invalidWorkOrder', false);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.common', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('workOrderOptionsSelect', {
            bindings: {
                options: '=',
                onChanged: '=',
                isDisabled: '=',
                labelText: '@'
            },
            templateUrl: 'app/main/work-order/components/work-order-options-select/work-order-options-select.tmpl.html',
            controller: 'WorkOrderOptionsSelectController as vm',
        })
        .controller('WorkOrderOptionsSelectController', WorkOrderOptionsSelectController);

    /* @ngInject */
    function WorkOrderOptionsSelectController(workOrderOptions) {
        var vm = this;
        vm.workOrderOptions = workOrderOptions;
        vm.isSelected = isSelected;
        vm.toggle = toggle;

        function isSelected(option) {
            if (vm.options & option.value) {
                return true;
            }
            return false;
        }

        function toggle(option) {
            if (isSelected(option)) {                
                vm.options &= ~option.value;
            } else {
                vm.options |= option.value;
            }
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(vm.options);
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .component('workOrderListItem', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/work-order/components/work-order-list-item/work-order-list-item.tmpl.html',
            controller: 'WorkOrderListItemController as vm',
        })
        .controller('WorkOrderListItemController', WorkOrderListItemController);

    /* @ngInject */
    function WorkOrderListItemController($state, noteOrTaskOptions) {
        var vm = this;
        vm.getProgressValue = getProgressValue;
        vm.navigateToWorkOrder = navigateToWorkOrder;
        vm.getForegroundColor = getForegroundColor;

        function getProgressValue() {
            if (vm.baldrisModel.completedCount + vm.baldrisModel.uncompletedCount === 0) {
                return 100;
            }
            return Math.round(vm.baldrisModel.completedCount / (vm.baldrisModel.completedCount + vm.baldrisModel.uncompletedCount) * 100);
        }

        function getForegroundColor(color) {
            var colors = tinycolor(color).monochromatic();

            colors.map(function (t) { return t.toHexString(); }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
            return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
        }

        function navigateToWorkOrder() {
            if (vm.baldrisModel.id) {
                $state.go('app.workOrder.byId.deceased', { workOrderId: vm.baldrisModel.id });
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .component('workOrderDeceasedCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/work-order/components/work-order-deceased-card/work-order-deceased-card.tmpl.html',
            controller: 'DeceasedCardController as vm',
        })
        .controller('WorkOrderDeceasedCardController', WorkOrderDeceasedCardController);

    /* @ngInject */
    function WorkOrderDeceasedCardController($state, maritalStatusOptions) {
        var vm = this;
        vm.maritalStatusArray = [];

        vm.$onInit = function () {
            //Init
            angular.forEach(maritalStatusOptions, function (option) {
                if (vm.baldrisModel.maritalStatus & option.value) {
                    vm.maritalStatusArray.push(option.text);
                }
            });
        }

        vm.extractAddress = extractAddress;
        vm.navigateToDeceased = navigateToDeceased;
        vm.deleteDeceased = deleteDeceased;



        function navigateToDeceased(deceased) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(deceased);
                } else {
                    $state.go('app.deceased.byId', { id: deceased.id });
                }
            }
        }

        function deleteDeceased(deceased) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(deceased);
                }
            }
        }

        function extractAddress(address) {
            var returnString = "";

            returnString = address.streetAddress1 + ', ' + address.zipCode + ' ' + address.city;
            if (address.countryName) {
                returnString += ', ' + address.countryName.toUpperCase();
            }


            return returnString;
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .component('workOrderAttachmentList', {
            bindings: {
                attachments: '=',
                selectedAttachments: '=',
                workOrderId: '=',
                externalOrderId: '=',
                calendarEventId: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/work-order/components/work-order-attachment-list/work-order-attachment-list.tmpl.html',
            controller: 'WorkOrderAttachmentListController as vm',
        })
        .controller('WorkOrderAttachmentListController', WorkOrderAttachmentListController);

    /* @ngInject */
    function WorkOrderAttachmentListController($http, $mdDialog, $translate, $q, loadingService, dataService, baldrisApiBase, workOrderService) {
        var vm = this;

        vm.uploadSelectedFiles = uploadSelectedFiles;
        vm.toggleSelected = toggleSelected;
        vm.isAttachmentSelected = isAttachmentSelected;
        vm.downloadSingle = downloadSingle;

        // METHODS
        function uploadSelectedFiles() {
            if (vm.uploadFiles && vm.uploadFiles.length > 0) {
                loadingService.setBackgroundLoadingStatus(true);
                vm.isUploading = true;
                var formData = new FormData();
                angular.forEach(vm.uploadFiles, function (obj) {
                    if (!obj.isRemote) {
                        formData.append('files[]', obj.lfFile);
                    }
                });
                dataService.uploadFiles(formData).then(function (uploadedFiles) {
                    var dtoModels = [];
                    if (uploadedFiles && uploadedFiles.length > 0) {
                        for (var i = 0; i < uploadedFiles.length; i++) {
                            var file = uploadedFiles[i];
                            var dtoModel = workOrderService.getEmptyWorkOrderAttachment();
                            dtoModel.workOrderId = vm.workOrderId;
                            dtoModel.calendarEventId = vm.calendarEventId;
                            dtoModel.externalOrderId = vm.externalOrderId;
                            dtoModel.fileId = file.id;
                            dtoModel.fileName = file.name;
                            dtoModel.fileFilepath = file.filepath;
                            dtoModel.fileContentType = file.contentType;
                            dtoModel.changeState = 1;
                            dtoModels.push(dtoModel);
                        }
                        if (dtoModels.length > 0) {
                            var promises = [];
                            dtoModels.forEach(function (model) {
                                promises.push(dataService.insertItem('WorkOrderAttachments', model));
                            });
                            $q.all(promises).then(function (bulkList) {
                                loadingService.setBackgroundLoadingStatus(false);
                                vm.onUpdate({ action: 'uploaded', data: bulkList });
                                vm.attachments = vm.attachments.concat(bulkList);
                                vm.uploadFiles = [];
                                vm.isUploading = false;
                            });
                        } else {
                            vm.isUploading = false;
                            loadingService.setBackgroundLoadingStatus(false);
                        }
                    } else {
                        vm.isUploading = false;
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                });
            }
        }

        function toggleSelected(attachment, e) {
            if (e) {
                e.stopPropagation();
            }
            if (attachment) {
                if (!vm.selectedAttachments) vm.selectedAttachments = [];
                var index = vm.selectedAttachments.indexOf(attachment);
                if (index > -1) {
                    vm.selectedAttachments.splice(index, 1);
                } else {
                    vm.selectedAttachments.push(attachment);
                }
            }
        }

        function isAttachmentSelected(attachment) {
            if (!attachment || !vm.selectedAttachments || vm.selectedAttachments.length === 0) return false;
            return vm.selectedAttachments.indexOf(attachment) > -1;
        }

        function downloadSingle(attachment, e) {
            if (e) {
                e.stopPropagation();
            }
            if (attachment.$type == 'Baldris.Core.Data.Entities.Dto.WorkOrderAttachmentDto, Baldris.Core.Data.Entities') {
                // Fake change type
                var attachmentClone = angular.copy(attachment);
                attachmentClone.$type = 'Baldris.Core.Data.Entities.Fdo.WorkOrderAttachmentFdo, Baldris.Core.Data.Entities';
                downloadFiles([attachmentClone], attachmentClone.fileName);
            } else {
                downloadFiles([attachment], attachment.fileName);
            }
        }

        function downloadFiles(files, fileName) {
            $http.put(baldrisApiBase + '/api/WorkOrderAttachments/CompressAttachments', files, { responseType: 'arraybuffer' }).then(function (data) {
                var octetStreamMime = 'application/octet-stream';
                var success = false;

                // Get the headers
                data.headers = data.headers();

                // Get the filename from the x-filename header or default to "download.bin"
                var filename = fileName || data.headers['x-filename'] || 'baldris-download-' + moment().format('YYYY-MM-DD') + '.zip';

                // Determine the content type from the header or default to "application/octet-stream"
                var contentType = data.headers['content-type'] || octetStreamMime;

                try {
                    // Try using msSaveBlob if supported
                    console.log('Trying saveBlob method ...');
                    var blob = new Blob([data], { type: contentType });
                    if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
                    else {
                        // Try using other saveBlob implementations, if available
                        var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                        if (saveBlob === undefined) throw 'Not supported';
                        saveBlob(blob, filename);
                    }
                    console.log('saveBlob succeeded');
                    success = true;
                } catch (ex) {
                    console.log('saveBlob method failed with the following exception:');
                    console.log(ex);
                }

                if (!success) {
                    // Get the blob url creator
                    var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    if (urlCreator) {
                        // Try to use a download link
                        var link = document.createElement('a');
                        if ('download' in link) {
                            // Try to simulate a click
                            try {
                                // Prepare a blob URL
                                console.log('Trying download link method with simulated click ...');
                                var blob = new Blob([data.data], { type: contentType });
                                var url = urlCreator.createObjectURL(blob);
                                link.setAttribute('href', url);

                                // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                                link.setAttribute('download', filename);

                                // Simulate clicking the download link
                                var event = document.createEvent('MouseEvents');
                                event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                                link.dispatchEvent(event);
                                console.log('Download link method with simulated click succeeded');
                                success = true;
                            } catch (ex) {
                                console.log('Download link method with simulated click failed with the following exception:');
                                console.log(ex);
                            }
                        }

                        if (!success) {
                            // Fallback to window.location method
                            try {
                                // Prepare a blob URL
                                // Use application/octet-stream when using window.location to force download
                                console.log('Trying download link method with window.location ...');
                                var blob = new Blob([data.data], { type: octetStreamMime });
                                var url = urlCreator.createObjectURL(blob);
                                window.location = url;
                                console.log('Download link method with window.location succeeded');
                                success = true;
                            } catch (ex) {
                                console.log('Download link method with window.location failed with the following exception:');
                                console.log(ex);
                            }
                        }
                    }
                }
                loadingService.setBackgroundLoadingStatus(false);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.transport', [

        ]);
})(); 
(function () {
    'use strict';

    angular.module('app.transport').factory('transportLogisticsViewService', transportLogisticsViewService);

    /* @ngInject */
    function transportLogisticsViewService($rootScope, $q, $filter, dataLegacyService, transportService) {
        var dataService = dataLegacyService;
        var currentData = {
            transports: [],
            departments: [],
            locations: [],
            deceased: [],
            dates: [],
            fromDate: null,
            toDate: null,
            isSet: false,
        };
        var service = {
            currentData: currentData,
            getLatestCompletedTransport: getLatestCompletedTransport,
            getNextUncompletedTransport: getNextUncompletedTransport,
            initializeFromDates: initializeFromDates,
            updateTransport: updateTransport,
            toggle: toggle,
        };

        return service;

        function updateTransport(updatedTransport) {
            // HotFix: Just recreate the locationCollection
            $rootScope.loadingProgress = true;
            currentData.locations = createLocationGroups(currentData.calendarEventDeceased, currentData.transports);
            $rootScope.loadingProgress = false;
        }

        function toggle(transport) {
            $rootScope.loadingProgress = true;
            return transportService.canToggleTransport(transport).then(function (canToggleTransport) {
                if (canToggleTransport) {
                    return transportService.toggleTransport(transport).then(function (updatedTransport) {
                        if (updatedTransport) {
                            transport.isCompleted = updatedTransport.isCompleted;
                            transport.completedTime = updatedTransport.completedTime;
                            transport.completedById = updatedTransport.completedById;
                            transport.completedBy = updatedTransport.completedBy;
                            transport.lastModifiedBy = updatedTransport.lastModifiedBy;
                            transport.lastModifiedAt = updatedTransport.lastModifiedAt;
                            transport.completedByDisplayName = updatedTransport.completedByDisplayName;
                            // HotFix: Just recreate the locationCollection

                            currentData.locations = createLocationGroups(currentData.calendarEventDeceased, currentData.transports);
                        }
                        $rootScope.loadingProgress = false;
                        return transport;
                    });
                }
                $rootScope.loadingProgress = false;
                return transport;
            });
        }

        function initializeFromDates(fromDate, toDate) {
            currentData.isSet = false;
            var promises = [];
            promises.push(dataService.getBetweenDates('CalendarEvents', fromDate, toDate));
            promises.push(getDepartments());
            promises.push(dataService.getBetweenDates('CalendarEventDeceased', fromDate, toDate));

            return $q.all(promises).then(function (returnData) {
                currentData.transports = extractGroomingTransports(returnData[0]);
                currentData.departments = returnData[1];
                currentData.calendarEventDeceased = returnData[2];
                currentData.fromDate = fromDate;
                currentData.toDate = toDate;
                currentData.locations = createLocationGroups(currentData.calendarEventDeceased, currentData.transports);
                currentData.deceased = createDeceasedGroups(currentData.calendarEventDeceased, currentData.transports);
                currentData.dates = createDateGroups(currentData.transports);
                currentData.isSet = true;
                return true;
            });
        }

        function extractGroomingTransports(events) {
            if (!events || events.length === 0) return [];
            return events.filter(function (event) {
                return event.$type.indexOf('Transport') > -1 || event.$type.indexOf('Grooming') > -1;
            });
        }

        function getBetweenDates(fromDate, toDate) {
            return dataService.getBetweenDates('Transports', fromDate, toDate).then(function (transports) {
                return transports;
            });
        }

        function getDepartments() {
            return dataService.getAll('Departments').then(function (departments) {
                return departments;
            });
        }

        function createDeceasedGroups(calendarEventDeceased, transports) {
            if (!calendarEventDeceased || calendarEventDeceased.length === 0) return [];
            var deceasedIds = []; // To easier keep track which deceased are added
            var deceased = [];
            //Gather distinct deceased
            for (var index = 0; index < calendarEventDeceased.length; index++) {
                var CEDeceased = calendarEventDeceased[index];
                if (CEDeceased && CEDeceased.calendarEventOptions & 128 && CEDeceased.deceasedId && deceasedIds.indexOf(CEDeceased.deceasedId) === -1) {
                    deceased.push({
                        id: CEDeceased.deceasedId,
                        displayName: CEDeceased.deceasedPersonDisplayName,
                        dateOfBirth: CEDeceased.deceasedPersonDateOfBirth,
                        dateOfDeath: CEDeceased.deceasedPersonDateOfDeath,
                        socialSecurityNumber: CEDeceased.deceasedPersonSocialSecurityNumber,
                        transports: [],
                    });
                    deceasedIds.push(CEDeceased.deceasedId);
                }
            }

            //Filter transports and attach to deceased
            for (var index = 0; index < calendarEventDeceased.length; index++) {
                var element = calendarEventDeceased[index];
                if (element && element.calendarEventOptions & 128) {
                    var deceasedIndex = deceasedIds.indexOf(element.deceasedId);
                    var currentDeceased = deceased[deceasedIndex];
                    var transport = getTransportById(element.calendarEventId, transports);
                    if (transport) {
                        currentDeceased.transports.push(transport);
                    }
                }
            }
            return deceased;
        }

        function getTransportById(id, transports) {
            for (var i = 0; i < transports.length; i++) {
                var transport = transports[i];
                if (id === transport.id) {
                    return transport;
                }
            }
        }

        function createDateGroups(transports) {
            if (!transports || transports.length === 0) return [];
            var dateStrings = []; // To easier keep track of added dates
            var dateGroups = [];
            //Order by startDate
            var orderedTransports = $filter('orderBy')(transports, 'start');
            //Gater distinct dates
            for (var index = 0; index < orderedTransports.length; index++) {
                var transport = orderedTransports[index];
                if (transport.start) {
                    if (dateStrings.indexOf(moment(transport.start).format('YYYY.MM.DD')) === -1) {
                        dateStrings.push(moment(transport.start).format('YYYY.MM.DD'));
                        dateGroups.push({ date: moment(transport.start).format('YYYY-MM-DDTHH:mm:ss') });
                    }
                }
            }

            //Filter transports and attach to dateGroups
            for (var index = 0; index < dateGroups.length; index++) {
                var dateGroup = dateGroups[index];
                dateGroup.transports = orderedTransports.filter(function (transport) {
                    if (transport.start) {
                        if (moment(transport.start).isSame(dateGroup.date, 'day')) {
                            return true;
                        }
                    }
                });
            }

            return dateGroups;
        }

        function createLocationGroups(calendarEventDeceased, transports) {
            if (!transports || transports.length === 0) return [];
            var locationStrings = []; // To easier keep track which locations are added
            var locations = [];
            //Group by deceased
            var deceasedGroups = createDeceasedGroups(calendarEventDeceased, transports);
            //Gather distinct locations
            for (var index = 0; index < deceasedGroups.length; index++) {
                var deceased = deceasedGroups[index];
                var currentLocation = getCurrentLocation(deceased);
                if (currentLocation && currentLocation.name && locationStrings.indexOf(currentLocation.name) === -1) {
                    locationStrings.push(currentLocation.name);
                    locations.push(currentLocation);
                }
            }

            //Filter deceased and attach to locations
            for (var index = 0; index < locations.length; index++) {
                var location = locations[index];
                location.deceased = deceasedGroups.filter(function (deceasedGroup) {
                    var deceasedLocation = getCurrentLocation(deceasedGroup);
                    if (deceasedLocation.name === location.name) {
                        return true;
                    }
                });
            }
            return locations;
        }

        function getCurrentLocation(deceased) {
            if (!deceased || deceased.transports.length === 0) {
                return null;
            }
            //Order by startDate
            deceased.transports = $filter('orderBy')(deceased.transports, 'calendarEvent.start');
            var finishedFound = false;
            var currentLocation = null;
            for (var index = 0; index < deceased.transports.length; index++) {
                var transport = deceased.transports[index];
                if (transport.isCompleted) {
                    finishedFound = true;
                    if (transport.destination) {
                        currentLocation = transport.destination;
                    } else {
                        currentLocation = {
                            name: transport.destinationSerialized,
                        };
                    }
                }
            }
            //If we haven't found any completed transports, we return the first transport's origin
            if (!finishedFound) {
                if (deceased.transports[0].origin) {
                    currentLocation = deceased.transports[0].origin;
                } else {
                    currentLocation = {
                        name: deceased.transports[0].originSerialized,
                    };
                }
            }
            return currentLocation;
        }

        function getLatestCompletedTransport(deceased) {
            if (!deceased || !deceased.transports || deceased.transports.length === 0) {
                return null;
            }
            //Order by startDate
            deceased.transports = $filter('orderBy')(deceased.transports, 'calendarEvent.start');
            var finishedFound = false;
            var currentTransport = null;
            for (var index = 0; index < deceased.transports.length; index++) {
                var transport = deceased.transports[index];
                if (transport.isCompleted) {
                    finishedFound = true;
                    currentTransport = transport;
                }
            }
            return currentTransport;
        }

        function getNextUncompletedTransport(deceased) {
            if (!deceased || !deceased.transports || deceased.transports.length === 0) {
                return null;
            }
            //Order by startDate
            deceased.transports = $filter('orderBy')(deceased.transports, 'calendarEvent.start');
            var finishedFound = false;
            var currentIndex = 0;
            var currentTransport = null;
            for (var index = 0; index < deceased.transports.length; index++) {
                var transport = deceased.transports[index];
                if (transport.isCompleted) {
                    finishedFound = true;
                    currentIndex = index;
                }
            }
            //If we haven't found any completed transports, we return the first transport's origin
            if (!finishedFound) {
                currentTransport = deceased.transports[0];
            } else {
                //If the last transport is completed we don't have any next transport
                if (deceased.transports.length > currentIndex + 1) {
                    currentTransport = deceased.transports[currentIndex + 1];
                }
            }
            return currentTransport;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('TransportLogisticsLocationsController', TransportLogisticsLocationsController);

    /* @ngInject */
    function TransportLogisticsLocationsController(transportLogisticsViewService) {
        var vm = this;

        vm.currentData = transportLogisticsViewService.currentData;
        vm.getNextTransport = getNextTransport;
        vm.getCurrentTransport = getCurrentTransport;
        vm.isUpdatingList = false;
        vm.toggleTransport = toggleTransport;

        function getNextTransport(deceased) {
            return transportLogisticsViewService.getNextUncompletedTransport(deceased);            
        }
        
        function getCurrentTransport(deceased) {
            return transportLogisticsViewService.getLatestCompletedTransport(deceased);            
        }

        function toggleTransport(transport) {
            vm.isUpdatingList = true;
            transportLogisticsViewService.toggle(transport).then(function () {
                transportLogisticsViewService.updateTransport(transport);
                vm.isUpdatingList = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('TransportLogisticsDeceasedController', TransportLogisticsDeceasedController);

    /* @ngInject */
    function TransportLogisticsDeceasedController(transportLogisticsViewService) {
        var vm = this;

        vm.currentData = transportLogisticsViewService.currentData;
        
        vm.onChangedTransport = onChangedTransport;
        
        function onChangedTransport(transport) {
            transportLogisticsViewService.updateTransport(transport);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('TransportLogisticsDatesController', TransportLogisticsDatesController);

    /* @ngInject */
    function TransportLogisticsDatesController(transportLogisticsViewService) {
        var vm = this;

        vm.currentData = transportLogisticsViewService.currentData;
        
        vm.onChangedTransport = onChangedTransport;
        
        function onChangedTransport(transport) {
            transportLogisticsViewService.updateTransport(transport);
        }
    }
})();
(function() {
  "use strict";

  angular
    .module("app.transport")
    .controller("TransportLogisticsDashboardController", TransportLogisticsDashboardController);

  /* @ngInject */
  function TransportLogisticsDashboardController($stateParams, $state, transportLogisticsViewService) {
    var vm = this;
    vm.getFinishedCount = getFinishedCount;
    vm.getUnfinishedCount = getUnfinishedCount;
    vm.getOverdueCount = getOverdueCount;
    vm.goToState = goToState;

    vm.currentData = transportLogisticsViewService.currentData;

    function goToState(stateName) {
      $state.go("app.transport.logistics." + stateName);
    }

    function getFinishedCount() {
      if (!vm.currentData || vm.currentData.transports.length === 0) {
        return 0;
      }
      var count = 0;
      for (var index = 0; index < vm.currentData.transports.length; index++) {
        var transport = vm.currentData.transports[index];
        if (transport.isCompleted) {
          count++;
        }
      }
      return count;
    }

    function getUnfinishedCount() {
      if (!vm.currentData || vm.currentData.transports.length === 0) {
        return 0;
      }
      var count = 0;
      for (var index = 0; index < vm.currentData.transports.length; index++) {
        var transport = vm.currentData.transports[index];
        if (!transport.isCompleted && moment(transport.start).isSameOrAfter(moment(), "day")) {
          count++;
        }
      }
      return count;
    }

    function getOverdueCount() {
      if (!vm.currentData || vm.currentData.transports.length === 0) {
        return 0;
      }
      var count = 0;
      for (var index = 0; index < vm.currentData.transports.length; index++) {
        var transport = vm.currentData.transports[index];
        if (!transport.isCompleted && moment(transport.start).isBefore(moment(), "day")) {
          count++;
        }
      }
      return count;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.transport')
        .component('transportTypeSelect', {
            bindings: {
                transportTypeId: '=',
                transportType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/transport/components/transport-type-select/transport-type-select.tmpl.html',
            controller: 'TransportTypeSelectController as vm',
        })
        .controller('TransportTypeSelectController', TransportTypeSelectController);

    /* @ngInject */
    function TransportTypeSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.transportTypes = [];
        vm.onChange = onChange;
        
        // Get options
        dataService.getAll("TransportTypes").then(function (transportTypes) {
            vm.isDisabled = false;
            vm.transportTypes = transportTypes;
        });

        function onChange() {
            if (vm.transportTypeId) {
                for (var index = 0; index < vm.transportTypes.length; index++) {
                    var transportType = vm.transportTypes[index];
                    if (vm.transportTypeId === transportType.id) {
                        vm.transportType = transportType;
                        break;
                    }
                }
            } else {
                vm.transportType = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.transportType);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.transport')
        .component('transportListItem', {
            bindings: {
                baldrisModel: '=',
                showDeceased: '=',
                onChange: '='
            },
            templateUrl: 'app/main/transport/components/transport-list-item/transport-list-item.tmpl.html',
            controller: 'TransportListItemController as vm',
        })
        .controller('TransportListItemController', TransportListItemController);

    /* @ngInject */
    function TransportListItemController($mdDialog, $document, $state, $mdToast, transportService) {
        var vm = this;
        vm.showEditTransportDialog = showEditTransportDialog;
        vm.getTransportClasses = getTransportClasses;
        vm.toggleTransport = toggleTransport;

        function toggleTransport(transport, e) {
            if (e) {
                e.stopPropagation();
            }
            transportService.canToggleTransport(transport).then(function (canToggleTransport) {
                if (canToggleTransport) {
                    transportService.toggleTransport(transport).then(function (updatedTransport) {
                        transport.isCompleted = updatedTransport.isCompleted;
                        transport.completedTime = updatedTransport.completedTime;
                        transport.completedById = updatedTransport.completedById;
                        transport.completedBy = updatedTransport.completedBy;
                        transport.lastModifiedBy = updatedTransport.lastModifiedBy;
                        transport.lastModifiedAt = updatedTransport.lastModifiedAt;
                        transport.completedByDisplayName = updatedTransport.completedByDisplayName;
                        if (angular.isFunction(vm.onChange)) {
                            vm.onChange(transport);
                        }
                    });
                }
            });
        }

        function getTransportClasses(transport) {
            if (transport.isCompleted) {
                return 'green-200-bg';
            }
            if (!transport.isCompleted && moment(transport.start).isBefore(moment(), 'day')) {
                return 'red-200-bg';
            }
            return 'orange-200-bg';
        }


        function showEditTransportDialog(transport, e) {
            if (transport) {
                if (transport.workOrderId) {
                    if (transport.$type.indexOf('Transport') > -1) {
                        $state.go('app.workOrder.byId.transportById', {
                            workOrderId: transport.workOrderId,
                            calendarEventId: transport.id
                        });
                    } else {
                        $state.go('app.workOrder.byId.groomingById', {
                            workOrderId: transport.workOrderId,
                            calendarEventId: transport.id
                        });
                    }
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.transport')
        .component('transportCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/transport/components/transport-card/transport-card.tmpl.html',
            controller: 'TransportCardController as vm',
        })
        .controller('TransportCardController', TransportCardController);

    /* @ngInject */
    function TransportCardController($mdDialog, $document, $translate, $mdToast, $state) {
        var vm = this;

        vm.getForegroundColor = getForegroundColor;
        vm.showEditTransportDialog = showEditTransportDialog;
        vm.navigateToTransport = navigateToTransport;
        vm.deleteTransport = deleteTransport;

        //Init

        function getForegroundColor(color) {
            var colors = tinycolor(color).monochromatic();

            colors.map(function (t) { return t.toHexString(); }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
            return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
        }

        function showEditTransportDialog(deceased, e) {
            $mdDialog.show({
                controller: 'EditDeceasedDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/deceased/components/edit-deceased-dialog/edit-deceased-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    deceased: angular.copy(deceased),
                    event: e
                }
            }).then(function (updatedDeceased) {
                if (updatedDeceased) {
                    vm.baldrisModel = updatedDeceased;
                    $mdToast.show($mdToast.simple().textContent(savedText));
                }
            });
        }

        function navigateToTransport() {
            if (angular.isFunction(vm.onOpen)) {
                vm.onOpen(vm.baldrisModel);
            }
        }

        function deleteTransport() {
            if (angular.isFunction(vm.onDelete)) {
                vm.onDelete(vm.baldrisModel);
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.transactionalMail', [

        ]);
})();
(function () {
    'use strict';

    angular.module('app.transactionalMail').controller('SendEmailDialogController', SendEmailDialogController);

    /* @ngInject */
    function SendEmailDialogController(
        $mdDialog,
        $document,
        $q,
        $translate,
        $filter,
        transactionalMailService,
        baldrisConfigService,
        loadingService,
        dataLegacyService,
        toastService,
        currentUser,
        departmentId,
        reportId,
        attachedUrls,
        attachedFiles,
        parameterName,
        parameterId,
        workOrderId,
        baldrisApiBase,
        transactionType,
        skipTracking
    ) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.loadingService = loadingService;
        vm.baldrisApiBase = baldrisApiBase;

        vm.fromList = [];
        vm.email = transactionalMailService.getEmptyTransactionalMail();
        vm.useUserAddressAsDefault = false;

        vm.showSuggestions = false;

        vm.closeDialog = closeDialog;
        vm.sendEmail = sendEmail;
        vm.openAddCustomEmailRecipientDialog = openAddCustomEmailRecipientDialog;
        vm.transformChip = transformChip;
        vm.querySearch = querySearch;
        vm.isNotSelected = isNotSelected;
        vm.selectSuggestion = selectSuggestion;
        vm.togglePasswordProtection = togglePasswordProtection;
        vm.getPreviewUrl = getPreviewUrl;
        vm.addEmailItem = addEmailItem;
        vm.isAdded = isAdded;
        vm.toggleUseUserAddressAsDefault = toggleUseUserAddressAsDefault;
        vm.isProcessing = true;
        vm.removeAttachment = removeAttachment;

        activate();

        function activate() {
            vm.loadingService.setBackgroundLoadingStatus(true);

            // Check wether to use user address as default from-address
            vm.useUserAddressAsDefault = localStorage.getItem('send-email-dialog:useUserAddressAsDefault') === 'true';

            vm.email.skipTracking = skipTracking || false;

            vm.email.originType = transactionType;
            vm.email.originId = parameterId;
            var promises = [];
            promises.push(dataService.getById('Reports', reportId));
            promises.push(dataService.getByTypeId('ReportEmails', reportId));
            promises.push(baldrisConfigService.getByName('AllowPaidTrackableEmails'));
            if (departmentId) {
                vm.email.departmentId = departmentId;
                promises.push(dataService.getById('Departments', departmentId));
            }
            if (workOrderId) {
                promises.push(dataService.getById('WorkOrders', workOrderId));
                promises.push(dataService.getByUri('Mail', 'RelevantPartiesByWorkOrderId/' + workOrderId, { context: transactionType }));
            }

            $q.all(promises).then(function (response) {
                var filepath = null;
                if (attachedUrls && attachedUrls.length > 0) {
                    filepath = attachedUrls[0];
                }
                vm.email.attachments.push({
                    reportId: reportId,
                    parameterName: parameterName,
                    parameterId: parameterId,
                    filename: response[0].name,
                    filepath: filepath,
                });
                // Additional attachments
                if (attachedFiles && attachedFiles.length > 0) {
                    vm.email.attachments = vm.email.attachments.concat(attachedFiles);
                }
                vm.email.subject = response[0].name;
                vm.predefinedPassword = response[0].password;
                if (vm.predefinedPassword) {
                    togglePasswordProtection();
                }
                if (response[2] && response[2][0] && response[2][0].customFieldDataBoolData) {
                    vm.trackableEmailsIsAllowed = true;
                }
                if (departmentId) {
                    vm.fromList.push({
                        email: response[3].primaryEmail,
                        name: response[3].organizationDisplayName,
                    });
                    if (workOrderId && response[4] && response[4].deceasedSerialized) {
                        vm.email.subject += ' - ' + response[4].deceasedSerialized;
                    }
                } else {
                    if (workOrderId && response[3] && response[3].deceasedSerialized) {
                        vm.email.subject += ' - ' + response[3].deceasedSerialized;
                    }
                }
                if (workOrderId && response[response.length - 1]) {
                    vm.emailSuggestions = response[response.length - 1];
                }
                if (response[1] && response[1].length > 0) {
                    vm.email.to = response[1].map(function (reportEmail) {
                        if (reportEmail.emailPartyDisplayName.indexOf(', ') > -1) {
                            var namesArray = reportEmail.emailPartyDisplayName.split(', ');
                            reportEmail.emailPartyDisplayName = namesArray[1] + ' ' + namesArray[0];
                        }
                        return {
                            email: reportEmail.emailEmailAddress,
                            name: reportEmail.emailPartyDisplayName,
                        };
                    });
                }
                //TODO: Find recipients based on report and workOrderId

                vm.fromList.push({
                    email: currentUser.email,
                    name: currentUser.firstName + (currentUser.lastName ? ' ' + currentUser.lastName : ''),
                });
                if (vm.useUserAddressAsDefault && vm.fromList.length > 1) {
                    vm.email.from = vm.fromList[vm.fromList.length - 1];
                } else {
                    vm.email.from = vm.fromList[0];
                }

                vm.loadingService.setBackgroundLoadingStatus(false);
                vm.isProcessing = false;
            });
        }

        function openAddCustomEmailRecipientDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddCustomEmailRecipientDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/transactional-mail/dialogs/add-custom-email-recipient-dialog/add-custom-email-recipient-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                })
                .then(function (recipient) {
                    if (recipient) {
                        vm.email.to.push(recipient);
                    }
                });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function sendEmail() {
            vm.isProcessing = true;
            vm.loadingService.setBackgroundLoadingStatus(true);
            if (vm.password) {
                _.forEach(vm.email.attachments, function (attachment) {
                    attachment.password = vm.password;
                });
                localStorage.setItem('send-email-dialog:predefinedPassword', vm.password);
            }
            transactionalMailService
                .sendEmail(vm.email)
                .then(function (response) {
                    if (response) {
                        toastService.success($translate.instant('TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.EMAIL_SUCCESS'));
                        $mdDialog.hide();
                    } else {
                        toastService.error($translate.instant('TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.EMAIL_FAILURE'));
                    }
                    vm.isProcessing = false;
                    vm.loadingService.setBackgroundLoadingStatus(false);
                })
                .catch(function (message) {
                    console.log(message);
                    vm.loadingService.setBackgroundLoadingStatus(false);
                    vm.isProcessing = false;
                    toastService.error($translate.instant('TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.EMAIL_FAILURE'));
                });
        }

        function togglePasswordProtection() {
            if (vm.password) {
                vm.password = null;
            } else {
                vm.password = vm.predefinedPassword || '' + _.random(10000000, 99999999);
            }
        }

        function toggleUseUserAddressAsDefault() {
            if (vm.useUserAddressAsDefault) {
                localStorage.setItem('send-email-dialog:useUserAddressAsDefault', 'false');
                vm.useUserAddressAsDefault = false;
            } else {
                localStorage.setItem('send-email-dialog:useUserAddressAsDefault', 'true');
                vm.useUserAddressAsDefault = true;
                if (vm.email.from.email !== currentUser.email) {
                    for (var index = 0; index < vm.fromList.length; index++) {
                        var emailItem = vm.fromList[index];
                        if (emailItem.email === currentUser.email) {
                            vm.email.from = emailItem;
                            break;
                        }
                    }
                }
            }
        }

        function querySearch(query) {
            if (query) {
                return dataService.search('Emails', query, null, null, { count: 25 }).then(function (emails) {
                    return $filter('orderBy')(emails, 'emailAddress');
                });
            }
        }
        function addEmailItem(emailItem, e) {
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
            if (emailItem) {
                if (!vm.email.to) vm.email.to = [];
                if (isAdded(emailItem)) {
                    for (var i = 0; i < vm.email.to.length; i++) {
                        var recipient = vm.email.to[i];
                        if (recipient.email === emailItem.emailAddress) {
                            vm.email.to.splice(i, 1);
                            break;
                        }
                    }
                } else {
                    vm.email.to.push({
                        email: emailItem.emailAddress,
                        name: getFormattedName(emailItem),
                    });
                }
            }
        }

        function isAdded(emailItem) {
            for (var i = 0; i < vm.email.to.length; i++) {
                var recipient = vm.email.to[i];
                if (recipient.email === emailItem.emailAddress) {
                    return true;
                }
            }
            return false;
        }

        function transformChip(chip) {
            // If it is an object, it's an emailFdo from searchResult
            if (angular.isObject(chip)) {
                return {
                    email: chip.emailAddress,
                    name: getFormattedName(chip),
                };
            }

            // Otherwise, we have to extract emailAddress and name
            var emailObject = {
                email: null,
                name: '',
            };
            if (chip.indexOf(' ') > 0) {
                var splitArray = chip.split(' ');
                for (var i = 0; i < splitArray.length; i++) {
                    var obj = splitArray[i];
                    if (obj.indexOf('@') > -1) {
                        emailObject.email = obj;
                    } else {
                        emailObject.name += ' ' + obj;
                    }
                }
            } else {
                if (chip.indexOf('@') > -1) {
                    emailObject.email = chip;
                } else {
                    emailObject.name = chip;
                }
            }
            return emailObject;
        }

        function getFormattedName(emailFdo) {
            var name;
            if (emailFdo.partyId) {
                if (emailFdo.partyDisplayName.indexOf(', ') > -1) {
                    var namesArray = emailFdo.partyDisplayName.split(', ');
                    name = namesArray[1] + ' ' + namesArray[0];
                } else {
                    name = emailFdo.partyDisplayName;
                }
            } else if (emailFdo.locationId) {
                name = emailFdo.locationName;
            } else if (emailFdo.baldrisUderId) {
                if (emailFdo.baldrisUserDisplayName.indexOf(', ') > -1) {
                    var namesArray = emailFdo.baldrisUserDisplayName.split(', ');
                    name = namesArray[1] + ' ' + namesArray[0];
                } else {
                    name = emailFdo.baldrisUserDisplayName;
                }
            }
            return name;
        }

        function isNotSelected(suggestion) {
            for (var i = 0; i < vm.email.to.length; i++) {
                var recipient = vm.email.to[i];
                if (recipient.email === suggestion.email) {
                    return false;
                }
            }
            return true;
        }

        function selectSuggestion(suggestion) {
            vm.email.to.push({
                email: suggestion.email,
                name: suggestion.fullName,
            });
        }

        function getPreviewUrl(attachment) {
            if (attachment.filepath) return attachment.filepath;
            return vm.baldrisApiBase + '/api/Reports/AsPdf/' + attachment.reportId + '/' + attachment.parameterName + '/' + attachment.parameterId;
        }

        function removeAttachment(attachment) {
            var index = vm.email.attachments.indexOf(attachment);
            if (index >= 0) {
                vm.email.attachments.splice(index, 1);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.transactionalMail')
        .controller('AddCustomEmailRecipientDialogController', AddCustomEmailRecipientDialogController);

    /* @ngInject */
    function AddCustomEmailRecipientDialogController($mdDialog) {
        var vm = this;
        vm.recipient = {
            email: null,
            name: null
        }

        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            $mdDialog.hide(vm.recipient);
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.transactionalMail")
    .component("transactionalEmailAddressList", {
      bindings: {
        transactionalEmailAddresses: "=",
        emailSuggestions: "=",
        showSuggestions: "=",
        onUpdate: "&"
      },
      templateUrl: "app/main/transactional-mail/components/transactional-email-address-list/transactional-email-address-list.tmpl.html",
      controller: "TransactionalEmailAddressListController as vm"
    })
    .controller("TransactionalEmailAddressListController", TransactionalEmailAddressListController);

  /* @ngInject */
  function TransactionalEmailAddressListController($filter, dataService) {
    var vm = this;

    vm.transactionalEmailAddresses = vm.transactionalEmailAddresses || [];

    vm.transformChip = transformChip;
    vm.querySearch = querySearch;
    vm.isNotSelected = isNotSelected;
    vm.selectSuggestion = selectSuggestion;
    vm.addEmailItem = addEmailItem;
    vm.isAdded = isAdded;
    vm.onRemoveChip = onRemoveChip;

    function querySearch(query) {
      if (query) {
        return dataService.search("Emails", query, null, null, { count: 25 }).then(function(emails) {
          return $filter("orderBy")(emails, "emailAddress");
        });
      }
    }

    function addEmailItem(emailItem, e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      if (emailItem) {
        if (!vm.transactionalEmailAddresses) vm.transactionalEmailAddresses = [];
        if (isAdded(emailItem)) {
          for (var i = 0; i < vm.transactionalEmailAddresses.length; i++) {
            var recipient = vm.transactionalEmailAddresses[i];
            if (recipient.email === emailItem.emailAddress) {
              vm.transactionalEmailAddresses.splice(i, 1);
              vm.onUpdate({ action: "removed", value: recipient });
              break;
            }
          }
        } else {
          var emailObject = { email: emailItem.emailAddress, name: getFormattedName(emailItem) };
          vm.transactionalEmailAddresses.push(emailObject);
          vm.onUpdate({ action: "added", value: emailObject });
        }
      }
    }

    function isAdded(emailItem) {
      for (var i = 0; i < vm.transactionalEmailAddresses.length; i++) {
        var recipient = vm.transactionalEmailAddresses[i];
        if (recipient.email === emailItem.emailAddress) {
          return true;
        }
      }
      return false;
    }

    function transformChip(chip) {
      var emailObject = {
        email: null,
        name: ""
      };

      // If it is an object, it's an emailFdo from searchResult
      if (angular.isObject(chip)) {
        emailObject.email = chip.emailAddress;
        emailObject.name = getFormattedName(chip);
        vm.onUpdate({ action: "added", value: emailObject });
        return emailObject;
      }

      // return null if no email address is provided
      if (chip.indexOf("@") < 0) return null;

      // Otherwise, we have to extract emailAddress and name

      if (chip.indexOf(" ") > 0) {
        var splitArray = chip.split(" ");
        for (var i = 0; i < splitArray.length; i++) {
          var obj = splitArray[i];
          if (obj.indexOf("@") > -1) {
            emailObject.email = obj;
          } else {
            emailObject.name += " " + obj;
          }
        }
      } else {
        if (chip.indexOf("@") > -1) {
          emailObject.email = chip;
        } else {
          emailObject.name = chip;
        }
      }
      vm.onUpdate({ action: "added", value: emailObject });
      return emailObject;
    }

    function onRemoveChip(chip) {
      vm.onUpdate({ action: "removed", value: chip });
    }

    function getFormattedName(emailFdo) {
      var name;
      if (emailFdo.partyId) {
        if (emailFdo.partyDisplayName.indexOf(", ") > -1) {
          var namesArray = emailFdo.partyDisplayName.split(", ");
          name = namesArray[1] + " " + namesArray[0];
        } else {
          name = emailFdo.partyDisplayName;
        }
      } else if (emailFdo.locationId) {
        name = emailFdo.locationName;
      } else if (emailFdo.baldrisUderId) {
        if (emailFdo.baldrisUserDisplayName.indexOf(", ") > -1) {
          var namesArray = emailFdo.baldrisUserDisplayName.split(", ");
          name = namesArray[1] + " " + namesArray[0];
        } else {
          name = emailFdo.baldrisUserDisplayName;
        }
      }
      return name;
    }

    function isNotSelected(suggestion) {
      for (var i = 0; i < vm.transactionalEmailAddresses.length; i++) {
        var recipient = vm.transactionalEmailAddresses[i];
        if (recipient.email === suggestion.email) {
          return false;
        }
      }
      return true;
    }

    function selectSuggestion(suggestion) {
      var emailObject = { email: suggestion.email, name: suggestion.fullName };
      vm.transactionalEmailAddresses.push(emailObject);
      vm.onUpdate({ action: "added", value: emailObject });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs', []);
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').controller('CreateConsignmentDialogController', CreateConsignmentDialogController);

    /* @ngInject */
    function CreateConsignmentDialogController($mdDialog, createCommand, signatureJobService, loadingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.createCommand = createCommand || signatureJobService.getCreateSignatureJobCommand();
        vm.workOrderId = vm.createCommand.workOrderId || null;

        vm.isExternalServiceAuthenticated = function () {
            return signatureJobService.isExternalServiceAuthenticated();
        };

        vm.export = function () {
            if (vm.canSave()) {
                vm.loadingService.setBackgroundLoadingStatus(true);
                vm.isDisabled = true;
                signatureJobService
                    .createSignatureJobFromReports(vm.createCommand)
                    .then(function (signatureJob) {
                        $mdDialog.hide(signatureJob);
                    })
                    .finally(function () {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        vm.isDisabled = false;
                    });
            }
        };

        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.canSave = function () {
            return (
                !vm.isDisabled &&
                signatureJobService.isExternalServiceAuthenticated() &&
                vm.createForm &&
                vm.createCommand &&
                vm.createForm.$valid &&
                !loadingService.isLoading
            );
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.song', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.song')
        .controller('SongListController', SongListController);

    /* @ngInject */
    function SongListController($stateParams, $filter, songLibraryService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = songLibraryService;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            songLibraryService.getSongsByCollection($stateParams.collectionName || 'all').then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.song')
        .controller('SongListToolbarController', SongListToolbarController);

    /* @ngInject */
    function SongListToolbarController(songLibraryService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = songLibraryService;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.song')
        .component('songSelect', {
            bindings: {
                songId: '=',
                song: '=',
                onSelected: '=',
                onAddNew: '=',
                allowCustom: '=',
                customValue: '=',
                labelText: '@',
                minQueryLength: '=',
                displayText: '=',
                onUpdate: '&',
                hideLabel: '<',
            },
            templateUrl:
                'app/main/song/components/song-select/song-select.tmpl.html',
            controller: 'SongSelectController as vm',
        })
        .controller('SongSelectController', SongSelectController);

    /* @ngInject */
    function SongSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.onInputChange = onInputChange;

        vm.$onInit = function () {
            //Get Current Song
            if (
                vm.songId &&
                vm.songId !== '00000000-0000-0000-0000-000000000000' &&
                !vm.song
            ) {
                // If we already know the title through display-text, just fake it
                if (vm.displayText || vm.customValue) {
                    vm.song = {
                        id: vm.songId,
                        title: vm.displayText || vm.customValue,
                    };
                } else {
                    dataService
                        .getById('Songs', vm.songId)
                        .then(function (song) {
                            vm.song = song;
                        });
                }
            } else if (vm.allowCustom && vm.customValue) {
                vm.searchText = vm.customValue;
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService
                    .search('Songs', query)
                    .then(function (searchResult) {
                        return searchResult.data || searchResult;
                    });
            } else {
                return dataService.getAll('Songs').then(function (songs) {
                    return songs;
                });
            }
        }

        function searchTextChange(text) {
            if (vm.allowCustom) {
                vm.customValue = text;
                vm.onUpdate({ action: 'changed', value: text });
            }
        }

        function onInputChange() {
            if (vm.allowCustom && !vm.songId && vm.song) {
                vm.onUpdate({ action: 'customValue', value: vm.customValue });
            }
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.songId = item.id;
                vm.songForm.song.$setValidity('invalidSong', true);
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.title;
                }
                if (vm.allowCustom) {
                    vm.customValue = item.title;
                }
                vm.onUpdate({ action: 'selected', value: item });
            } else {
                vm.songId = null;
                if (vm.searchText && !vm.allowCustom) {
                    vm.songForm.song.$setValidity('invalidSong', false);
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                vm.songForm.$setDirty();
                vm.onUpdate({ action: 'deselected', value: null });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').controller('EditConsignmentController', EditConsignmentController);

    /* @ngInject */
    function EditConsignmentController($stateParams, $window, signatureJobService, signatureJobEventTypes, loadingService) {
        var vm = this;

        vm.signatureJob = null;
        vm.loadingService = loadingService;

        loadSignatureJob($stateParams.signatureJobId);

        function loadSignatureJob(signatureJobId) {
            vm.loadingService.setLoadingStatus(true);
            signatureJobService
                .getSignatureJobById(signatureJobId)
                .then(function (signatureJob) {
                    vm.signatureJob = signatureJob;
                })
                .finally(function () {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        vm.isAuthenticated = signatureJobService.isExternalServiceAuthenticated;

        vm.exitView = function () {
            $window.history.back();
        };

        vm.getExternalUrl = function () {
            if (!vm.signatureJob || !vm.signatureJob.externalId) {
                return null;
            }

            return (
                'https://app.getaccept.com/auth/sso/login?token=' +
                encodeURIComponent(signatureJobService.getExternalServiceAuthenticationToken()) +
                '&go=' +
                encodeURIComponent('/document/edit/' + vm.signatureJob.externalId)
            );
        };

        vm.getRecipientInitials = function (recipient) {
            if (!recipient || !recipient.partyDisplayName) {
                return '--';
            }
            if (recipient.partyDisplayName.indexOf(', ') > -1) {
                var nameParts = recipient.partyDisplayName.split(', ');
                // Returns first letter of firstName + first letter of lastName
                return nameParts[1][0].toUpperCase() + nameParts[0][0].toUpperCase();
            }
            if (recipient.partyDisplayName.indexOf(' ') > -1) {
                var nameParts = recipient.partyDisplayName.split(' ');
                return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
            }
            if (recipient.partyDisplayName.length >= 2) {
                return recipient.partyDisplayName.substring(0, 3).toUpperCase();
            }
            return recipient.partyDisplayName.toUpperCase();
        };

        vm.getBorderStyleForStatus = function getBorderStyleForStatus(recipient) {
            var status = getMostRelevantStatus(recipient);

            switch (status) {
                case signatureJobEventTypes.EXPIRED.value:
                case signatureJobEventTypes.REJECTED.value:
                case signatureJobEventTypes.RECALLED.value:
                case signatureJobEventTypes.HARD_BOUNCED.value:
                    return 'solid 3px #E53935';
                case signatureJobEventTypes.SIGNED.value:
                    return 'solid 3px #43A047';
                case signatureJobEventTypes.VIEWED.value:
                case signatureJobEventTypes.REVIEWED.value:
                case signatureJobEventTypes.PRINTED.value:
                case signatureJobEventTypes.DOWNLOADED.value:
                    return vm.signatureJob.shouldBeSigned ? 'solid 3px #FFD54F' : 'solid 3px #43A047';
            }

            return 'solid 3px #BDBDBD';
        };

        vm.getMostRelevantEventTypeText = function (recipient) {
            var eventType = getMostRelevantStatus(recipient);
            var signatureJobEventType = null;

            for (var key in signatureJobEventTypes) {
                if (signatureJobEventTypes.hasOwnProperty(key) && signatureJobEventTypes[key].value === eventType) {
                    signatureJobEventType = signatureJobEventTypes[key];
                }
            }
            return signatureJobEventType ? signatureJobEventType.text : 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.UNKNOWN';
        };

        function getMostRelevantStatus(recipient) {
            if (!recipient || !vm.signatureJob.events || vm.signatureJob.events.length === 0) {
                return signatureJobEventTypes.UNKNOWN.value;
            }
            // Filter to relevant recipient
            var recipientEvents = vm.signatureJob.events.filter(function (event) {
                return event.eventInstigatorId === recipient.id;
            });
            if (!recipientEvents || recipientEvents.length === 0) {
                return signatureJobEventTypes.UNKNOWN.value;
            }

            // Sort by most relevant eventType
            var eventTypeOrder = [
                signatureJobEventTypes.HARD_BOUNCED.value,
                signatureJobEventTypes.DELETED.value,
                signatureJobEventTypes.REJECTED.value,
                signatureJobEventTypes.RECALLED.value,
                signatureJobEventTypes.EXPIRED.value,
                signatureJobEventTypes.SIGNED.value,
                signatureJobEventTypes.PRINTED.value,
                signatureJobEventTypes.DOWNLOADED.value,
                signatureJobEventTypes.FORWARDED.value,
                signatureJobEventTypes.REVIEWED.value,
                signatureJobEventTypes.VIEWED.value,
                signatureJobEventTypes.APPROVED.value,
                signatureJobEventTypes.COMMENTED.value,
                signatureJobEventTypes.SENT.value,
                signatureJobEventTypes.ADDED.value,
                signatureJobEventTypes.EXPORTED_TO_EXTERNAL.value,
                signatureJobEventTypes.SEALED.value,
                signatureJobEventTypes.UPDATED.value,
                signatureJobEventTypes.CREATED.value,
                signatureJobEventTypes.UNKNOWN.value,
            ];

            recipientEvents = recipientEvents.sort(function (a, b) {
                var aEventTypeIndex = eventTypeOrder.indexOf(a.eventType);
                var bEventTypeIndex = eventTypeOrder.indexOf(b.eventType);

                if (aEventTypeIndex === bEventTypeIndex) {
                    if (a.eventTime < b.eventTime) {
                        return -1;
                    }
                    if (a.eventTime > b.eventTime) {
                        return 1;
                    }
                    return 0;
                }

                return aEventTypeIndex - bEventTypeIndex;
            });

            return recipientEvents[0].eventType;
        }
    }

    angular.module('app.signatureJobs').controller('EditConsignmentSidebarController', EditConsignmentSidebarController);

    /* @ngInject */
    function EditConsignmentSidebarController() {}

    angular.module('app.signatureJobs').controller('EditConsignmentToolbarController', EditConsignmentToolbarController);

    /* @ngInject */
    function EditConsignmentToolbarController($window) {
        var vm = this;

        vm.exitView = function () {
            $window.history.back();
        };
    }
})();

(function () {
    'use strict';
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').service('createConsignmentService', createConsignmentService);

    /* @ngInject */
    function createConsignmentService(loadingService, signatureJobService) {
        var self = this;
        self.createCommand = null;
        self.createForm = null;

        self.canSave = function () {
            return (
                signatureJobService.isExternalServiceAuthenticated() &&
                self.createForm &&
                self.createCommand &&
                self.createForm.$dirty &&
                self.createForm.$valid &&
                !loadingService.isLoading
            );
        };
    }
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').controller('CreateConsignmentController', CreateConsignmentController);

    /* @ngInject */
    function CreateConsignmentController($window, $stateParams, signatureJobService, loadingService, createConsignmentService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.workOrderId = $stateParams.workOrderId;
        createConsignmentService.createCommand = signatureJobService.getCreateSignatureJobCommand();
        createConsignmentService.createCommand.workOrderId = vm.workOrderId;
        vm.data = createConsignmentService;

        vm.isExternalServiceAuthenticated = function () {
            return signatureJobService.isExternalServiceAuthenticated();
        };

        vm.onSignatureJobUpdated = function (createCommand) {
            console.log(createCommand);
        };

        vm.export = function () {
            if (createConsignmentService.canSave()) {
                vm.loadingService.setLoadingStatus(true);
                signatureJobService
                    .createSignatureJobFromReports(vm.data.createCommand)
                    .then(function (signatureJob) {
                        $window.history.back();
                    })
                    .finally(function () {
                        vm.loadingService.setLoadingStatus(false);
                    });
            }
        };

        vm.exitView = function () {
            $window.history.back();
        };
    }
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').controller('CreateConsignmentSidebarController', CreateConsignmentSidebarController);

    /* @ngInject */
    function CreateConsignmentSidebarController(createConsignmentService) {
        var vm = this;
        vm.data = createConsignmentService;
    }
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').controller('CreateConsignmentToolbarController', CreateConsignmentToolbarController);

    /* @ngInject */
    function CreateConsignmentToolbarController($window, createConsignmentService, signatureJobService, loadingService) {
        var vm = this;
        vm.data = createConsignmentService;
        vm.loadingService = loadingService;

        vm.export = function () {
            if (createConsignmentService.canSave()) {
                vm.loadingService.setLoadingStatus(true);
                signatureJobService
                    .createSignatureJobFromReports(vm.data.createCommand)
                    .then(function (signatureJob) {
                        $window.history.back();
                    })
                    .finally(function () {
                        vm.loadingService.setLoadingStatus(false);
                    });
            }
        };

        vm.exitView = function () {
            $window.history.back();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureJobSignedDocumentsList', {
            bindings: {
                documents: '<',
                isCollapsed: '<?',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-signed-documents-list/signature-job-signed-documents-list.tmpl.html',
            controller: 'signatureJobSignedDocumentsListController as vm',
        })
        .controller('signatureJobSignedDocumentsListController', signatureJobSignedDocumentsListController);

    /* @ngInject */
    function signatureJobSignedDocumentsListController($q, loadingService, filesService) {
        var vm = this;

        vm.selectedFileId = null;

        vm.toggleCollapse = toggleCollapse;
        vm.downloadDocument = downloadDocument;
        vm.previewDocument = previewDocument;

        vm.$onInit = function () {
            vm.isCollapsed = vm.isCollapsed || false;
            initializeDocuments();
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj && changesObj.documents && changesObj.documents.currentValue !== changesObj.documents.previousValue) {
                initializeDocuments();
            }
        };

        function toggleCollapse() {
            vm.isCollapsed = !vm.isCollapsed;
        }

        function initializeDocuments() {
            if (vm.documents && vm.documents.length > 0) {
                loadingService.setBackgroundLoadingStatus(true);
                var promises = [];
                vm.documents.forEach(function (document) {
                    promises.push(addDocumentObjectURL(document));
                });
                $q.all(promises)
                    .then(function () {})
                    .finally(function () {
                        loadingService.setBackgroundLoadingStatus(false);
                    });
            }
        }

        function addDocumentObjectURL(document) {
            var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            if (!document.objectURL) {
                return filesService.downloadFileByFileId(document.signedFileId).then(function (response) {
                    var blob = new Blob([response.data], { type: 'application/pdf' });
                    document.objectURL = urlCreator.createObjectURL(blob);
                    return document.objectURL;
                });
            } else {
                return $q.when(document.objectURL);
            }
        }

        function downloadDocument(document) {
            if (document.objectURL) {
                filesService.saveFilesToDesktop(document.objectURL, document.signedFileName, document.signedFileContentType);
            }
        }

        function previewDocument(document) {
            if (document.objectURL) {
                window.open(document.objectURL, '_blank');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.report')
        .component('signatureJobReportMultiSelect', {
            bindings: {
                reports: '=',
                isDisabled: '<?ngDisabled',
                isRequired: '<?ngRequired',
                onReportAdded: '&',
                onReportRemoved: '&',
                reportParameters: '<?',
                workOrderId: '<?',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-report-multi-select/signature-job-report-multi-select.tmpl.html',
            controller: 'SignatureJobReportMultiSelectController as vm',
        })
        .controller('SignatureJobReportMultiSelectController', SignatureJobReportMultiSelectController);

    /* @ngInject */
    function SignatureJobReportMultiSelectController($filter, dataService, msUtils) {
        var FILENAME_EXTENSION = '.pdf';
        var REPORT_TYPES_DELIMITER = ', ';

        var vm = this;
        vm.querySearch = querySearch;
        vm.searchText = '';
        vm.reportOptions = [];
        vm.givenReportParameters = {};
        vm.minLenght = msUtils.isMobile() ? 1 : 0;

        vm.loadReportParameters = loadReportParameters;
        vm.loadReportOptions = loadReportOptions;
        vm.onAddReport = onAddReport;
        vm.onRemoveReport = onRemoveReport;
        vm.onAppendChip = onAppendChip;
        vm.removeIlligalFilenameCharacters = removeIlligalFilenameCharacters;
        vm.getDisplayFilename = getDisplayFilename;
        vm.convertReportOptionToRenderReportDto = convertReportOptionToRenderReportDto;
        vm.getReportParameters = getReportParameters;

        vm.$onInit = function () {
            vm.isDisabled = vm.isDisabled || false;
            vm.isRequired = vm.isRequired || false;

            vm.loadReportParameters();
            vm.loadReportOptions();
        };

        vm.$onChanges = function (changes) {
            if (_.isEqual(changes.reportParameters, vm.reportParameters) == false || changes.workOrderId != vm.workOrderId) {
                vm.loadReportParameters();
            }
        };

        function loadReportParameters() {
            var givenReportParameters = {};

            if (Array.isArray(vm.reportParameters)) {
                vm.reportParameters.map(function (reportParameter) {
                    givenReportParameters[reportParameter.parameterName] = reportParameter.parameterValue;
                });
            }

            if (typeof givenReportParameters.WorkOrderId == 'undefined' && typeof vm.workOrderId != 'undefined') {
                givenReportParameters.WorkOrderId = vm.workOrderId;
            }

            vm.givenReportParameters = givenReportParameters;
        }

        function loadReportOptions() {
            dataService.getByUri('Reports', 'ByInternalCategory/' + 'WorkOrder', { pageSize: 200 }).then(function (reports) {
                vm.reportOptions = reports;
            });
        }

        function querySearch(query) {
            var query_bool = query ? true : false;
            console.log('query', query, query_bool);
            if (query) {
                var filteredReports = vm.reportOptions.filter(function (report) {
                    return report.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
                });
                return $filter('orderBy')(filteredReports, 'name');
            } else {
                return $filter('orderBy')(vm.reportOptions, 'name');
            }
        }

        function onAddReport(renderReportDto) {
            vm.onReportAdded({ value: renderReportDto });
        }

        function onRemoveReport(renderReportDto) {
            vm.onReportRemoved({ value: renderReportDto });
        }

        function onAppendChip(reportChip) {
            if (typeof reportChip.reportId == 'undefined') {
                reportChip = vm.convertReportOptionToRenderReportDto(reportChip);
            }
            return reportChip;
        }

        function getDisplayFilename(filename) {
            var normalizedFilename = vm.removeIlligalFilenameCharacters(filename);
            return normalizedFilename + FILENAME_EXTENSION;
        }

        function removeIlligalFilenameCharacters(filename) {
            return filename.replace(/[/\\?%*:|"<>]/g, '');
        }

        function convertReportOptionToRenderReportDto(reportOption) {
            var reportParameters = [];
            if (typeof reportOption.requiredTypes == 'string') {
                var allowedReportParameters = reportOption.requiredTypes.split(REPORT_TYPES_DELIMITER);
                if (allowedReportParameters.length > 1) {
                    allowedReportParameters = allowedReportParameters.slice(1);
                }
                reportParameters = getReportParameters(allowedReportParameters);
            }

            return {
                reportId: reportOption.id,
                fileName: vm.getDisplayFilename(reportOption.name),
                sortOrder: reportOption.sortOrder,
                reportParameters: reportParameters,
            };
        }

        function getReportParameters(allowedReportParameters) {
            var reportParameters = [];

            allowedReportParameters.forEach(function (allowedReportParameter) {
                var parameterValue = null;
                if (typeof vm.givenReportParameters[allowedReportParameter] != 'undefined') {
                    parameterValue = vm.givenReportParameters[allowedReportParameter];
                }

                reportParameters.push({
                    parameterName: allowedReportParameter,
                    parameterValue: parameterValue,
                });
            });

            return reportParameters;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureJobRecipients', {
            bindings: {
                recipients: '=',
                signatureJobId: '<',
                signatureJobSigningIsEnabled: '<',
                workOrderId: '<',
                isDisabled: '<ngDisabled',
                isRequired: '<ngRequired',
                onRecipientAdded: '&',
                onRecipientRemoved: '&',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-recipients/signature-job-recipients.tmpl.html',
            controller: 'SignatureJobRecipientsController as vm',
        })
        .controller('SignatureJobRecipientsController', SignatureJobRecipientsController);

    /* @ngInject */
    function SignatureJobRecipientsController(partyService, toastService, $translate) {
        var vm = this;

        var possibleRecipientRoles = ['signer', 'approver', 'cc'];
        vm.recipientSearch = recipientSearch;
        vm.getPartyTypes = getPartyTypes;
        vm.transformChip = transformChip;
        vm.toggleSigningMethod = toggleSigningMethod;
        vm.toggleRecipientRole = toggleRecipientRole;
        vm.addRecipient = addRecipient;
        vm.removeRecipient = removeRecipient;
        vm.getRecipientRoleTooltip = getRecipientRoleTooltip;
        vm.getRecipientRoleIcon = getRecipientRoleIcon;

        //INIT
        vm.$onInit = function () {
            if (!vm.recipients) {
                vm.recipients = [];
            }
        };

        /**
         * Search for Participants.
         */
        function recipientSearch(query) {
            if (query) {
                return partyService.searchParties(query, 0, 100).then(function (searchResult) {
                    return searchResult.data ? searchResult.data : searchResult;
                });
            } else if (vm.workOrderId) {
                return partyService.getPartiesByWorkOrderId(vm.workOrderId, true);
            }
        }

        function getPartyTypes(party) {
            if (!party || !party.partyTypes || party.partyTypes.length === 0) {
                return [];
            }
            return party.partyTypes.map(function (partyType) {
                if (partyType.type === 'SYSTEM.REFERENCE_PERSON_TYPE') {
                    return 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.' + partyType.name;
                }
                return partyType.name;
            });
        }

        function transformChip(party) {
            // Only allow recipients with an email
            if (!party || !party.primaryEmail) {
                toastService.warning($translate.instant('SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_MUST_HAVE_EMAIL'));
                return null;
            }
            // Don't allow already added parties
            if (
                vm.recipients &&
                vm.recipients.find(function (recipient) {
                    return recipient.partyId === party.id;
                })
            ) {
                toastService.info($translate.instant('SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_ALREADY_ADDED', { recipientName: party.displayName }));
                return null;
            }

            return {
                externalId: null,
                externalStatus: null,
                remarks: null,
                sortOrder:
                    vm.recipients && vm.recipients.length > 0
                        ? Math.max.apply(
                              Math,
                              vm.recipients.map(function (o) {
                                  return o.sortOrder || 0;
                              })
                          ) + 1
                        : 0,
                shouldSign: !!vm.signatureJobSigningIsEnabled,
                recipientRole: vm.signatureJobSigningIsEnabled ? 'signer' : 'cc',
                securityQuestion: null,
                securityAnswer: null,
                signingMethod: 'email',
                partyId: party.id,
                partyDisplayName: party.displayName || (party.lastName || '') + ', ' + (party.firstName || ''),
                partyEmail: party.primaryEmail,
                partyTelephone: party.primaryTelephone,
                signatureJobId: vm.signatureJobId,
            };
        }

        function toggleSigningMethod(recipient, e) {
            if (e) {
                e.stopPropagation(); // to prevent the chip from being selected
            }
            if (!recipient || vm.isDisabled) {
                return;
            }
            if (recipient.signingMethod === 'email') {
                recipient.signingMethod = 'bankid';
            } else {
                recipient.signingMethod = 'email';
            }
        }

        function toggleRecipientRole(recipient, e) {
            if (e) {
                e.stopPropagation(); // to prevent the chip from being selected
            }
            if (!recipient || vm.isDisabled) {
                return;
            }

            var currentRoleIndex = possibleRecipientRoles.indexOf(recipient.recipientRole);
            var nextroleIndex = currentRoleIndex === possibleRecipientRoles.length - 1 ? 0 : currentRoleIndex + 1;

            recipient.recipientRole = possibleRecipientRoles[nextroleIndex];

            recipient.shouldSign = recipient.recipientRole === 'signer';
        }

        function addRecipient(recipient) {
            vm.onRecipientAdded({ $recipient: recipient });
        }

        function removeRecipient(recipient) {
            vm.onRecipientRemoved({ $recipient: recipient });
        }

        function getRecipientRoleTooltip(recipient) {
            if (!recipient || !recipient.recipientRole) {
                return 'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_SIGN';
            }

            switch (recipient.recipientRole) {
                case 'signer':
                    return 'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_SIGN';
                case 'approver':
                    return 'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_REVIEW';
                case 'cc':
                    return 'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_GET_COPY';
                default:
                    return 'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_SIGN';
            }
        }

        function getRecipientRoleIcon(recipient) {
            if (!recipient || !recipient.recipientRole) {
                return 'icon-pen';
            }

            switch (recipient.recipientRole) {
                case 'signer':
                    return 'icon-pen';
                case 'approver':
                    return 'icon-check-all';
                case 'cc':
                    return 'icon-eye';
                default:
                    return 'icon-pen';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureJobListItem', {
            bindings: {
                signatureJob: '<',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-list-item/signature-job-list-item.tmpl.html',
            controller: 'SignatureJobListItemController as vm',
        })
        .controller('SignatureJobListItemController', SignatureJobListItemController);

    /* @ngInject */
    function SignatureJobListItemController(signatureJobEventTypes) {
        var vm = this;

        vm.getRecipientInitials = getRecipientInitials;
        vm.getBorderStyleForStatus = getBorderStyleForStatus;

        function getRecipientInitials(recipient) {
            if (!recipient || !recipient.partyDisplayName) {
                return '--';
            }
            if (recipient.partyDisplayName.indexOf(', ') > -1) {
                var nameParts = recipient.partyDisplayName.split(', ');
                // Returns first letter of firstName + first letter of lastName
                return nameParts[1][0].toUpperCase() + nameParts[0][0].toUpperCase();
            }
            if (recipient.partyDisplayName.indexOf(' ') > -1) {
                var nameParts = recipient.partyDisplayName.split(' ');
                return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
            }
            if (recipient.partyDisplayName.length >= 2) {
                return recipient.partyDisplayName.substring(0, 3).toUpperCase();
            }
            return recipient.partyDisplayName.toUpperCase();
        }

        function getBorderStyleForStatus(recipient) {
            var status = getMostRelevantStatus(recipient);

            switch (status) {
                case signatureJobEventTypes.EXPIRED.value:
                case signatureJobEventTypes.REJECTED.value:
                case signatureJobEventTypes.RECALLED.value:
                case signatureJobEventTypes.HARD_BOUNCED.value:
                    return 'solid 3px #E53935';
                case signatureJobEventTypes.SIGNED.value:
                    return 'solid 3px #43A047';
                case signatureJobEventTypes.VIEWED.value:
                case signatureJobEventTypes.REVIEWED.value:
                case signatureJobEventTypes.PRINTED.value:
                case signatureJobEventTypes.DOWNLOADED.value:
                    return vm.signatureJob.shouldBeSigned ? 'solid 3px #FFD54F' : 'solid 3px #43A047';
            }

            return 'solid 3px #BDBDBD';
        }

        function getMostRelevantStatus(recipient) {
            if (!recipient || !vm.signatureJob.events || vm.signatureJob.events.length === 0) {
                return signatureJobEventTypes.UNKNOWN.value;
            }
            // Filter to relevant recipient
            var recipientEvents = vm.signatureJob.events.filter(function (event) {
                return event.eventInstigatorId === recipient.id;
            });
            if (!recipientEvents || recipientEvents.length === 0) {
                return signatureJobEventTypes.UNKNOWN.value;
            }

            // Sort by most relevant eventType
            var eventTypeOrder = [
                signatureJobEventTypes.HARD_BOUNCED.value,
                signatureJobEventTypes.DELETED.value,
                signatureJobEventTypes.REJECTED.value,
                signatureJobEventTypes.RECALLED.value,
                signatureJobEventTypes.EXPIRED.value,
                signatureJobEventTypes.SIGNED.value,
                signatureJobEventTypes.PRINTED.value,
                signatureJobEventTypes.DOWNLOADED.value,
                signatureJobEventTypes.FORWARDED.value,
                signatureJobEventTypes.REVIEWED.value,
                signatureJobEventTypes.VIEWED.value,
                signatureJobEventTypes.APPROVED.value,
                signatureJobEventTypes.COMMENTED.value,
                signatureJobEventTypes.SENT.value,
                signatureJobEventTypes.ADDED.value,
                signatureJobEventTypes.EXPORTED_TO_EXTERNAL.value,
                signatureJobEventTypes.SEALED.value,
                signatureJobEventTypes.UPDATED.value,
                signatureJobEventTypes.CREATED.value,
                signatureJobEventTypes.UNKNOWN.value,
            ];

            recipientEvents = recipientEvents.sort(function (a, b) {
                var aEventTypeIndex = eventTypeOrder.indexOf(a.eventType);
                var bEventTypeIndex = eventTypeOrder.indexOf(b.eventType);

                if (aEventTypeIndex === bEventTypeIndex) {
                    if (a.eventTime < b.eventTime) {
                        return -1;
                    }
                    if (a.eventTime > b.eventTime) {
                        return 1;
                    }
                    return 0;
                }

                return aEventTypeIndex - bEventTypeIndex;
            });

            return recipientEvents[0].eventType;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureJobEventTimeline', {
            bindings: {
                events: '<',
                isCollapsed: '<?',
                signatureJobSigningIsEnabled: '<?',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-event-timeline/signature-job-event-timeline.tmpl.html',
            controller: 'SignatureJobEventTimelineController as vm',
        })
        .controller('SignatureJobEventTimelineController', SignatureJobEventTimelineController);

    /* @ngInject */
    function SignatureJobEventTimelineController(signatureJobEventTypes) {
        var vm = this;

        vm.$onInit = function () {
            vm.isCollapsed = vm.isCollapsed || false;
            vm.signatureJobSigningIsEnabled = vm.signatureJobSigningIsEnabled || false;
        };

        vm.getInitials = function (displayName) {
            if (!displayName) {
                return '--';
            }
            if (displayName.indexOf(', ') > -1) {
                var nameParts = displayName.split(', ');
                // Returns first letter of firstName + first letter of lastName
                return nameParts[1][0].toUpperCase() + nameParts[0][0].toUpperCase();
            }
            if (displayName.indexOf(' ') > -1) {
                var nameParts = displayName.split(' ');
                return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
            }
            if (displayName.length >= 2) {
                return displayName.substring(0, 2).toUpperCase();
            }
            return displayName.toUpperCase();
        };

        vm.getEventTypeColor = function getBorderStyleForStatus(eventType) {
            switch (eventType) {
                case signatureJobEventTypes.EXPIRED.value:
                case signatureJobEventTypes.REJECTED.value:
                case signatureJobEventTypes.RECALLED.value:
                case signatureJobEventTypes.HARD_BOUNCED.value:
                    return '#E53935';
                case signatureJobEventTypes.SIGNED.value:
                    return '#43A047';
                case signatureJobEventTypes.VIEWED.value:
                case signatureJobEventTypes.REVIEWED.value:
                case signatureJobEventTypes.PRINTED.value:
                case signatureJobEventTypes.DOWNLOADED.value:
                    return vm.signatureJobSigningIsEnabled ? '#FFD54F' : '#43A047';
            }

            return '#BDBDBD';
        };

        vm.getEventTypeText = function (eventType) {
            var signatureJobEventType = null;

            for (var key in signatureJobEventTypes) {
                if (signatureJobEventTypes.hasOwnProperty(key) && signatureJobEventTypes[key].value === eventType) {
                    signatureJobEventType = signatureJobEventTypes[key];
                }
            }
            return signatureJobEventType ? signatureJobEventType.text : 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.UNKNOWN';
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureJobDocumentsList', {
            bindings: {
                documents: '<',
                isCollapsed: '<?',
            },
            templateUrl: 'app/main/signature-jobs/components/signature-job-documents-list/signature-job-documents-list.tmpl.html',
            controller: 'SignatureJobDocumentsListController as vm',
        })
        .controller('SignatureJobDocumentsListController', SignatureJobDocumentsListController);

    /* @ngInject */
    function SignatureJobDocumentsListController($q, loadingService, filesService) {
        var vm = this;

        vm.selectedFileId = null;

        vm.toggleCollapse = toggleCollapse;
        vm.downloadDocument = downloadDocument;
        vm.previewDocument = previewDocument;

        vm.$onInit = function () {
            vm.isCollapsed = vm.isCollapsed || false;
            initializeDocuments();
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj && changesObj.documents && changesObj.documents.currentValue !== changesObj.documents.previousValue) {
                initializeDocuments();
            }
        };

        function initializeDocuments() {
            if (vm.documents && vm.documents.length > 0) {
                loadingService.setBackgroundLoadingStatus(true);
                var promises = [];
                vm.documents.forEach(function (document) {
                    promises.push(addDocumentObjectURL(document));
                });
                $q.all(promises)
                    .then(function () {})
                    .finally(function () {
                        loadingService.setBackgroundLoadingStatus(false);
                    });
            }
        }

        function toggleCollapse() {
            vm.isCollapsed = !vm.isCollapsed;
        }

        function addDocumentObjectURL(document) {
            var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            if (!document.objectURL) {
                return filesService.downloadFileByFileId(document.fileId).then(function (response) {
                    var blob = new Blob([response.data], { type: 'application/pdf' });
                    document.objectURL = urlCreator.createObjectURL(blob);
                    return document.objectURL;
                });
            } else {
                return $q.when(document.objectURL);
            }
        }

        function downloadDocument(document) {
            if (document.objectURL) {
                filesService.saveFilesToDesktop(document.objectURL, document.fileName, document.fileContentType);
            }
        }

        function previewDocument(document) {
            if (document.objectURL) {
                window.open(document.objectURL, '_blank');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('signatureAuthentication', {
            transclude: true,
            templateUrl: 'app/main/signature-jobs/components/signature-authentication/signature-authentication.tmpl.html',
            controller: 'SignatureAutenticationController as vm',
        })
        .controller('SignatureAutenticationController', SignatureAutenticationController);

    /* @ngInject */
    function SignatureAutenticationController(signatureJobService, $scope, dataService) {
        var vm = this;

        vm.isLoading = true;
        vm.isAuthenticated = false;
        vm.defaultCredentials = {
            username: null,
            password: null,
        };

        vm.updateAuthenticationStatus = updateAuthenticationStatus;
        vm.setDefaultUsername = setDefaultUsername;
        vm.authenticate = authenticate;
        vm.checkAuthentication = checkAuthentication;

        vm.$onInit = function () {
            vm.checkAuthentication();
            vm.updateAuthenticationStatus();
            vm.setDefaultUsername();
        };

        vm.$postLink = function () {
            $scope.$watch(
                function () {
                    return signatureJobService.isExternalServiceAuthenticated();
                },
                function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        updateAuthenticationStatus();
                    }
                },
                true
            );
        };

        function updateAuthenticationStatus() {
            vm.isAuthenticated = signatureJobService.isExternalServiceAuthenticated();
        }

        function setDefaultUsername() {
            dataService.getCurrentUser().then(function (currentUser) {
                var username = currentUser.email;
                if (Array.isArray(currentUser.userConfigs)) {
                    currentUser.userConfigs.some(function (userConfig) {
                        if (userConfig.name === 'GetAcceptUserName' && userConfig.customFieldData) {
                            username = userConfig.customFieldData.dataValueAsString;
                            return true;
                        }
                        return false;
                    });
                }
                vm.defaultCredentials.username = username;
            });
        }

        function authenticate(credentials) {
            vm.isLoading = true;
            return signatureJobService.authenticateWithExternalService(credentials).finally(function () {
                vm.isLoading = false;
            });
        }

        function checkAuthentication() {
            vm.isLoading = true;
            return signatureJobService.getAuthenticationStatusWithExternalService().finally(function () {
                vm.isLoading = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('relevantSignatureJobs', {
            bindings: {
                workOrderId: '<',
                referencePersonId: '<?',
                isDisabled: '<?ngDisabled',
                disabledText: '@',
            },
            templateUrl: 'app/main/signature-jobs/components/relevant-signature-jobs/relevant-signature-jobs.tmpl.html',
            controller: 'RelevantSignatureJobsController as vm',
        })
        .controller('RelevantSignatureJobsController', RelevantSignatureJobsController);

    /* @ngInject */
    function RelevantSignatureJobsController($document, $state, $mdDialog, loadingService, signatureJobService) {
        var vm = this;

        vm.relevantSignatureJobs = [];
        vm.isLoading = false;

        //INIT
        vm.$onInit = function () {
            vm.referencePersonId = vm.referencePersonId || null;
            vm.isDisabled = vm.isDisabled || false;

            loadingService.setBackgroundLoadingStatus(true);
            vm.isLoading = true;

            // load relevant signature jobs
            // NOTE: we don't send an eventual referencePersonId to filter this server
            //       side as we'll need the additional referencePersonIds later
            signatureJobService
                .getRelevantSignatureJobsByWorkOrderId(vm.workOrderId)
                .then(function (relevantSignatureJobs) {
                    // identify and combine the separate jobs and attach all relevant recipients
                    // We'll just create the createCommand to do this
                    vm.relevantSignatureJobs = createCreateCommands(relevantSignatureJobs, vm.referencePersonId);
                })
                .finally(function () {
                    vm.isLoading = false;
                    loadingService.setBackgroundLoadingStatus(false);
                });
        };

        vm.getConsignmentStatusText = function (signatureJob) {
            if (!signatureJob.signatureJobId) {
                return 'SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.NOT_STARTED';
            } else if (signatureJob.hasSigned) {
                return 'SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.SIGNED';
            }
            return 'SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.IN_PROGRESS';
        };

        vm.getConsignmentStatusColor = function (signatureJob) {
            if (!signatureJob.signatureJobId) {
                return '#E53935';
            } else if (signatureJob.hasSigned) {
                return '#43A047';
            }
            return '#FFD54F';
        };

        vm.gotoConsignment = function (signatureJob) {
            $state.go('app.workOrder.byId.consignmentById', { signatureJobId: signatureJob.signatureJobId });
        };

        vm.startConsignment = function (e, createCommand) {
            $mdDialog
                .show({
                    controller: 'CreateConsignmentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/signature-jobs/dialogs/create-consignment-dialog/create-consignment-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        createCommand: createCommand,
                    },
                })
                .then(function (signatureJob) {
                    if (signatureJob) {
                        // Mark as started
                        createCommand.signatureJobId = signatureJob.id;
                    }
                });
        };

        function createCreateCommands(signatureJobs, referencePersonId) {
            var createCommands = [];
            if (!signatureJobs || signatureJobs.length === 0) {
                return createCommands;
            }
            var filteredSignatureJobs = referencePersonId
                ? signatureJobs.filter(function (job) {
                      return job.referencePersonId === referencePersonId;
                  })
                : signatureJobs;

            // Add single recipient jobs
            createCommands = filteredSignatureJobs
                .filter(function (job) {
                    return job.internalName === 'PrivacyConsentFormWorkOrder';
                })
                .map(mapToPrivacyConsentCommand);
            createCommands = createCommands.concat(
                filteredSignatureJobs
                    .filter(function (job) {
                        return job.internalName === 'GeneralLetterOfAttorney';
                    })
                    .map(mapToLetterOfAttorneyCommand)
            );

            // Add multi-recipient jobs
            // Group by reportId
            var multiRecipientCommands = filteredSignatureJobs
                .filter(function (job) {
                    return job.internalName !== 'PrivacyConsentFormWorkOrder' && job.internalName !== 'GeneralLetterOfAttorney';
                })
                .reduce(function (filteredJobs, currentJob) {
                    if (
                        !filteredJobs.find(function (job) {
                            return job.reportId === currentJob.reportId;
                        })
                    ) {
                        filteredJobs.push(mapToStandardCommand(currentJob));
                    }
                    return filteredJobs;
                }, []);
            // Add additional recipients
            multiRecipientCommands.forEach(function (command) {
                var additionalRecipients = signatureJobs.filter(function (job) {
                    return job.partyId !== command.recipients[0].partyId && job.reportId === command.reportId;
                });
                if (additionalRecipients && additionalRecipients.length > 0) {
                    command.recipients = command.recipients.concat(
                        additionalRecipients.map(function (additionalJob) {
                            return {
                                externalId: null,
                                externalStatus: null,
                                remarks: null,
                                sortOrder: 0,
                                shouldSign: true,
                                securityQuestion: null,
                                securityAnswer: null,
                                signingMethod: 'email',
                                partyId: additionalJob.partyId,
                                partyDisplayName: additionalJob.referencePersonName,
                                partyEmail: additionalJob.referencePersonEmail,
                                partyTelephone: additionalJob.referencePersonTelephone,
                            };
                        })
                    );
                }
            });
            createCommands = createCommands.concat(multiRecipientCommands);

            return createCommands;
        }

        function mapToCreateCommand(job) {
            var createCommand = signatureJobService.getCreateSignatureJobCommand();
            createCommand.signatureJobId = job.signatureJobId;
            createCommand.hasSigned = job.hasSigned;
            createCommand.subject = job.reportName;
            // Pseudo property to filter against
            createCommand.reportId = job.reportId;
            createCommand.workOrderId = vm.workOrderId;
            createCommand.reportsToInclude = [
                {
                    reportId: job.reportId,
                    fileName: getDisplayFilename(job.reportName),
                    sortOrder: 0,
                    reportParameters: [],
                },
            ];
            createCommand.recipients = [
                {
                    externalId: null,
                    externalStatus: null,
                    remarks: null,
                    sortOrder: 0,
                    shouldSign: true,
                    securityQuestion: null,
                    securityAnswer: null,
                    signingMethod: 'email',
                    partyId: job.partyId,
                    partyDisplayName: job.referencePersonName,
                    partyEmail: job.referencePersonEmail,
                    partyTelephone: job.referencePersonTelephone,
                },
            ];

            return createCommand;
        }

        function mapToStandardCommand(job) {
            var createCommand = mapToCreateCommand(job);
            createCommand.reportsToInclude[0].reportParameters = [
                {
                    parameterName: 'WorkOrderId',
                    parameterValue: vm.workOrderId,
                },
            ];

            return createCommand;
        }

        function mapToPrivacyConsentCommand(job) {
            var createCommand = mapToCreateCommand(job);
            createCommand.reportsToInclude[0].reportParameters = [
                {
                    parameterName: 'PartyId',
                    parameterValue: job.partyId,
                },
                {
                    parameterName: 'DepartmentId',
                    parameterValue: vm.departmentId,
                },
                {
                    parameterName: 'WorkOrderId',
                    parameterValue: vm.workOrderId,
                },
            ];

            return createCommand;
        }

        function mapToLetterOfAttorneyCommand(job) {
            var createCommand = mapToCreateCommand(job);
            createCommand.reportsToInclude[0].reportParameters = [
                {
                    parameterName: 'WorkOrderReferencePersonId',
                    parameterValue: job.referencePersonId,
                },
            ];

            return createCommand;
        }

        function getDisplayFilename(filename) {
            var normalizedFilename = removeIlligalFilenameCharacters(filename);
            return normalizedFilename + '.pdf';
        }

        function removeIlligalFilenameCharacters(filename) {
            return filename.replace(/[/\\?%*:|"<>]/g, '');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.signatureJobs')
        .component('createSignatureJob', {
            bindings: {
                createCommand: '=',
                workOrderId: '<',
                reportParameters: '<',
                isDisabled: '<ngDisabled',
            },
            templateUrl: 'app/main/signature-jobs/components/create-signature-job/create-signature-job.tmpl.html',
            controller: 'CreateSignatureJobController as vm',
        })
        .controller('CreateSignatureJobController', CreateSignatureJobController);

    /* @ngInject */
    function CreateSignatureJobController($translate, signatureJobService) {
        var vm = this;

        vm.$onInit = function () {
            vm.isDisabled = vm.isDisabled || false;
            if (!vm.createCommand) {
                vm.createCommand = signatureJobService.getCreateSignatureJobCommand();
            }
            if (!vm.createCommand.text) {
                vm.createCommand.text = $translate.instant('SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.DEFAULT_TEXT', {
                    recipient: '{{recipient.first_name}}',
                    sender: '{{sender.fullname}}',
                });
            }
        };

        vm.handleReportAdded = function (renderReportDto) {
            if (renderReportDto && renderReportDto.reportParameters && renderReportDto.reportParameters && renderReportDto.reportParameters.length > 0) {
                // For now, we remove all parameters that don't have a value. TODO: Figure out a way to supply values to optional reportParameters
                renderReportDto.reportParameters = renderReportDto.reportParameters.filter(function (reportParameter) {
                    return !!reportParameter.parameterValue;
                });
            }

            if (!vm.createCommand.subject && renderReportDto.fileName) {
                vm.createCommand.subject = renderReportDto.fileName.replace('.pdf', '');
            }
        };

        vm.onShouldBeSignedChanged = function (shouldBeSigned) {
            if (vm.createCommand && vm.createCommand.recipients && vm.createCommand.recipients.length > 0) {
                vm.createCommand.recipients.forEach(function (recipient) {
                    recipient.recipientRole = shouldBeSigned ? 'signer' : 'cc';
                    recipient.shouldSign = shouldBeSigned;
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ReferenceTypeQuickEditDialogController', ReferenceTypeQuickEditDialogController);

    /* @ngInject */
    function ReferenceTypeQuickEditDialogController(
        $q,
        $mdDialog,
        $rootScope,
        $state,
        Upload,
        dataService,
        dataLegacyService,
        referenceId,
        referenceDeclaration,
        baldrisApiBase
    ) {
        var vm = this;
        var currentService = referenceDeclaration.useLegacyService ? dataLegacyService : dataService;
        vm.reference = null;
        vm.referenceDeclaration = referenceDeclaration;
        vm.isLoading = true;
        vm.hasUploadFiles = false;
        vm.uploadFiles = [];
        vm.baldrisApiBase = baldrisApiBase;
        vm.isNew = false;

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.uploadImage = uploadImage;
        vm.removeImage = removeImage;
        vm.navigateToFullEdit = navigateToFullEdit;
        vm.setChangeState = setChangeState;
        vm.uploadPreviewImage = uploadPreviewImage;

        activate();

        ////////////////

        function activate() {
            setLoadingStatus(true);
            if (referenceId && referenceId !== 'new') {
                if (referenceDeclaration.hasUpdateModel) {
                    currentService.getUpdateModel(referenceDeclaration.apiController, referenceId).then(function (updateModel) {
                        vm.updateModel = updateModel;
                        setLoadingStatus(false);
                    });
                } else {
                    var promises = [];
                    promises.push(currentService.getById(referenceDeclaration.apiController, referenceId, true));
                    if (referenceDeclaration.hasAutoProducts) {
                        promises.push(currentService.getByUri('AttachedProducts', 'ByTypeName/' + referenceDeclaration.internalName + '/' + referenceId));
                        promises.push(currentService.getByUri('AttachedAutoTasks', 'ByTypeName/' + referenceDeclaration.internalName + '/' + referenceId));
                    }
                    if (referenceDeclaration.internalName === 'CustomField') {
                        promises.push(currentService.getByUri('CustomFields', referenceId + '/AttachedProducts'));
                    }
                    $q.all(promises).then(function (response) {
                        vm.reference = response[0];
                        if (referenceDeclaration.hasAutoProducts) {
                            vm.autoProducts = response[1];
                            vm.autoTasks = response[2];
                        }
                        if (referenceDeclaration.internalName === 'CustomField') {
                            vm.productChoices = response[3];
                        }
                        setLoadingStatus(false);
                    });
                    currentService.getById(referenceDeclaration.apiController, referenceId, true).then(function (reference) {
                        vm.reference = reference;
                        setLoadingStatus(false);
                    });
                }
            } else {
                vm.isNew = true;
                if (referenceDeclaration.hasUpdateModel) {
                    // Get UpdateModel
                    currentService.getByUri('Empties', 'UpdateModel/' + referenceDeclaration.internalName).then(function (updateModel) {
                        vm.updateModel = updateModel;
                        setLoadingStatus(false);
                    });
                } else {
                    // Get DTO
                    currentService.getByUri('Empties', 'Dto/' + referenceDeclaration.internalName).then(function (emptyDto) {
                        vm.reference = emptyDto;
                        vm.reference.changeState = 1;
                        setLoadingStatus(false);
                    });
                }
            }
        }

        function setChangeState(target) {
            if (target.changeState !== 1) {
                target.changeState = 2;
            }
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            setLoadingStatus(true);
            if (vm.uploadFiles && vm.uploadFiles.length > 0) {
                var formData = new FormData();
                angular.forEach(vm.uploadFiles, function (obj) {
                    if (!obj.isRemote) {
                        formData.append('files[]', obj.lfFile);
                    }
                });
                var targetIdName;
                var targetName;
                if (referenceDeclaration.imagePath.indexOf('Filepath') > -1) {
                    targetName = referenceDeclaration.imagePath.replace('Filepath', '');
                    targetIdName = referenceDeclaration.imagePath.replace('Filepath', 'Id');
                } else {
                    targetName = referenceDeclaration.imagePath;
                    targetIdName = referenceDeclaration.imagePath + 'Id';
                }
                currentService.uploadFiles(formData).then(function (uploadedFiles) {
                    if (referenceDeclaration.hasUpdateModel) {
                        vm.updateModel[getParameterName()][targetIdName] = uploadedFiles[0].id;
                        vm.updateModel[getParameterName()][targetName] = uploadedFiles[0];
                        setChangeState(vm.updateModel[getParameterName()]);
                        commitChanges();
                    } else {
                        vm.reference[targetIdName] = uploadedFiles[0].id;
                        vm.reference[targetName] = uploadedFiles[0];

                        setChangeState(vm.reference);
                        commitChanges();
                    }
                });
            } else {
                commitChanges();
            }
        }

        function commitChanges() {
            if (vm.isNew) {
                if (referenceDeclaration.hasUpdateModel) {
                    currentService.updateFromUpdateModel(referenceDeclaration.apiController, vm.updateModel).then(function (updatedData) {
                        getFdo(updatedData[getParameterName()]);
                    });
                } else {
                    vm.reference.changeState = 1;
                    var promises = [];
                    promises.push(currentService.insertItem(referenceDeclaration.apiController, vm.reference));
                    if (referenceDeclaration.hasAutoProducts && vm.autoProducts && vm.autoProducts.length > 0) {
                        for (var index = 0; index < vm.autoProducts.length; index++) {
                            var autoProduct = vm.autoProducts[index];
                            if (autoProduct.changeState === 1) {
                                promises.push(currentService.insertAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                            if (autoProduct.changeState === 2) {
                                promises.push(currentService.updateAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                            if (autoProduct.changeState === 3) {
                                promises.push(currentService.deleteAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                        }
                    }

                    if (referenceDeclaration.hasAutoProducts && vm.autoTasks && vm.autoTasks.length > 0) {
                        for (var index = 0; index < vm.autoTasks.length; index++) {
                            var autoTask = vm.autoTasks[index];
                            if (autoTask.changeState === 1) {
                                promises.push(currentService.insertAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                            if (autoTask.changeState === 2) {
                                promises.push(currentService.updateAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                            if (autoTask.changeState === 3) {
                                promises.push(currentService.deleteAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                        }
                    }

                    $q.all(promises).then(function (response) {
                        getFdo(response[0]);
                    });
                }
            } else {
                if (referenceDeclaration.hasUpdateModel) {
                    currentService.updateFromUpdateModel(referenceDeclaration.apiController, vm.updateModel).then(function (updatedData) {
                        getFdo(updatedData[getParameterName()]);
                    });
                } else {
                    vm.reference.changeState = 2;
                    var promises = [];

                    promises.push(currentService.updateItem(referenceDeclaration.apiController, vm.reference));
                    if (referenceDeclaration.hasAutoProducts && vm.autoProducts && vm.autoProducts.length > 0) {
                        for (var index = 0; index < vm.autoProducts.length; index++) {
                            var autoProduct = vm.autoProducts[index];
                            if (autoProduct.changeState === 1) {
                                promises.push(currentService.insertAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                            if (autoProduct.changeState === 2) {
                                promises.push(currentService.updateAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                            if (autoProduct.changeState === 3) {
                                promises.push(currentService.deleteAutoProduct(referenceDeclaration.apiController, autoProduct));
                            }
                        }
                    }

                    if (referenceDeclaration.hasAutoProducts && vm.autoTasks && vm.autoTasks.length > 0) {
                        for (var index = 0; index < vm.autoTasks.length; index++) {
                            var autoTask = vm.autoTasks[index];
                            if (autoTask.changeState === 1) {
                                promises.push(currentService.insertAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                            if (autoTask.changeState === 2) {
                                promises.push(currentService.updateAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                            if (autoTask.changeState === 3) {
                                promises.push(currentService.deleteAutoTask(referenceDeclaration.apiController, autoTask));
                            }
                        }
                    }

                    if (vm.productChoices && vm.productChoices.length > 0) {
                        for (var index = 0; index < vm.productChoices.length; index++) {
                            var productChoice = vm.productChoices[index];
                            if (productChoice.changeState === 1) {
                                promises.push(currentService.insertItem('CustomFields/' + productChoice.customFieldId + '/AttachedProducts', productChoice));
                            }
                            if (productChoice.changeState === 2) {
                                promises.push(currentService.updateItem('CustomFields/' + productChoice.customFieldId + '/AttachedProducts', productChoice));
                            }
                            if (productChoice.changeState === 3) {
                                promises.push(currentService.deleteItem('CustomFields/' + productChoice.customFieldId + '/AttachedProducts', productChoice));
                            }
                        }
                    }

                    $q.all(promises).then(function (response) {
                        setLoadingStatus(false);
                        $mdDialog.hide(vm.reference);
                    });
                }
            }
        }

        function getFdo(item) {
            // Get Fdo
            currentService.getById(referenceDeclaration.apiController, item.id).then(function (fdoObject) {
                setLoadingStatus(false);
                $mdDialog.hide(fdoObject);
            });
        }

        function uploadImage(targetName, targetIdName, target) {
            target = target || vm.reference;
            if (vm.uploadFiles && vm.uploadFiles.length > 0) {
                setLoadingStatus(true);
                var formData = new FormData();
                angular.forEach(vm.uploadFiles, function (obj) {
                    if (!obj.isRemote) {
                        formData.append('files[]', obj.lfFile);
                    }
                });
                currentService.uploadFiles(formData).then(function (uploadedFiles) {
                    target[targetIdName] = uploadedFiles[0].id;
                    target[targetName] = uploadedFiles[0];
                    setLoadingStatus(false);
                    setChangeState(target);
                });
            }
        }

        function uploadPreviewImage(file, targetName, targetIdName, target) {
            target = target || vm.reference;
            setLoadingStatus(true);
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        var baldrisFile = resp.data[0];
                        target[targetIdName] = baldrisFile.id;
                        target[targetName] = baldrisFile;
                        setLoadingStatus(false);
                        setChangeState(target);
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function removeImage(targetName, targetIdName, target) {
            target = target || vm.reference;
            target[targetIdName] = null;
            target[targetName] = null;
            target.changeState = 2;
        }

        function getParameterName() {
            if (!vm.referenceDeclaration.internalName) return null;
            return vm.referenceDeclaration.internalName.charAt(0).toLowerCase() + vm.referenceDeclaration.internalName.slice(1);
        }

        function getParameterIdName() {
            if (!vm.referenceDeclaration.internalName) return null;
            return vm.referenceDeclaration.internalName.charAt(0).toLowerCase() + vm.referenceDeclaration.internalName.slice(1) + 'Id';
        }

        function navigateToFullEdit() {
            if (!vm.referenceDeclaration.editState) return;
            var params = {};
            params[getParameterIdName()] = vm.reference.id;
            $state.go(vm.referenceDeclaration.editState, params);
            closeDialog();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('TransportSettingsController', TransportSettingsController);

    /* @ngInject */
    function TransportSettingsController(fuseTheming) {
        var vm = this;
        vm.fuseTheming = fuseTheming;
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').factory('configurationReferenceTypesService', configurationReferenceTypesService);

    /* @ngInject */
    function configurationReferenceTypesService() {
        var currentData = {
            selectedReferences: [],
            selectedReferenceType: null,
            referenceList: [],
        };
        var service = {
            currentData: currentData,
        };

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('ConfigurationReferenceTypesController', ConfigurationReferenceTypesController);

    /* @ngInject */
    function ConfigurationReferenceTypesController(
        $mdSidenav,
        $mdDialog,
        $document,
        $state,
        $filter,
        settingsReferenceTypes,
        currentUser,
        configurationReferenceTypesService,
        fuseTheming
    ) {
        var vm = this;
        vm.referenceTypes = settingsReferenceTypes;
        vm.currentData = configurationReferenceTypesService.currentData;
        vm.fuseTheming = fuseTheming;
        // Methods
        vm.selectReferenceType = selectReferenceType;
        vm.canViewReferenceType = canViewReferenceType;
        vm.toggleSidenav = toggleSidenav;
        vm.translated = translated;
        vm.openAddReferenceDialog = openAddReferenceDialog;

        // INIT

        selectReferenceType(vm.referenceTypes[0]);

        // Private Methods

        function translated(referenceType) {
            return $filter('translate')(referenceType.name);
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function selectAllReferences() {
            vm.selectedReferences = vm.referenceList.slice();
        }

        function selectReferenceType(referenceType, showDeleted) {
            vm.search = '';
            var reload = showDeleted !== vm.showDeleted;
            vm.showDeleted = showDeleted;
            vm.currentData.selectedReferences = [];
            vm.currentData.selectedReferenceType = referenceType;
            vm.isLoadingReferences = true;
            $state.go('app.configuration.referenceTypes.view', { routeId: referenceType.route, showDeleted: showDeleted });
        }

        function canViewReferenceType(referenceType) {
            return true;
            if (!currentUser || !currentUser.roles || !referenceType || !referenceType.permittedRoles) return false;
            var permittedRoles = referenceType.permittedRoles.split(',');
            for (var index = 0; index < permittedRoles.length; index++) {
                var role = permittedRoles[index];
                if (currentUser.roles.indexOf(role) > -1) return true;
            }
            return false;
        }

        function openAddReferenceDialog(e) {
            return $mdDialog
                .show({
                    controller: 'ReferenceTypeQuickEditDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/reference-type-quick-edit-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        referenceId: 'new',
                        referenceDeclaration: vm.currentData.selectedReferenceType,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (insertedReference) {
                    if (insertedReference) {
                        vm.referenceList.push(insertedReference);
                        selectReferenceType(vm.currentData.selectedReferenceType);
                    }
                    return updateReference;
                });
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.settings").controller("ProgramSettingsController", ProgramSettingsController);

  /* @ngInject */
  function ProgramSettingsController($mdSidenav, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('locationConfigService', locationConfigService);

    /* @ngInject */
    function locationConfigService($state) {
        var self = this;
        self.selectedLocationType = null;
        self.currentLocations = [];

        self.addLocation = addLocation;

        function addLocation(e) {
            if (self.selectedLocationType) {
                $state.go('app.configuration.locations.editLocation', { locationId: 'new', locationTypeId: self.selectedLocationType.id });
            }
        }
    }

})();


(function() {
  "use strict";

  angular.module("app.settings").controller("LocationConfigController", LocationConfigController);

  /* @ngInject */
  function LocationConfigController($state, $filter, $mdSidenav, locationTypes, currentUser, locationConfigService, fuseTheming) {
    var vm = this;
    vm.locationTypes = locationTypes;
    vm.data = locationConfigService;
    vm.fuseTheming = fuseTheming;
    activate();

    function activate() {
      // Check for current state
      if (!$state.params || !$state.params.locationType) {
        // If no state - navigate to first type
        var orderedTypes = $filter("orderBy")(locationTypes, "name");
        $state.go("app.configuration.locations.locationList", { locationTypeId: orderedTypes[0].id, locationType: orderedTypes[0] });
      }
    }

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.settings').controller('InvoiceSettingsController', InvoiceSettingsController);

    /* @ngInject */
    function InvoiceSettingsController(fuseTheming) {
        var vm = this;
        vm.fuseTheming = fuseTheming;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('EditReferenceController', EditReferenceController);

    /* @ngInject */
    function EditReferenceController(dependency) {
        var vm = this;
        vm.title = 'EditReferenceController';

    }

})();


(function() {
  "use strict";

  angular.module("app.settings").controller("DepartmentConfigController", DepartmentConfigController);

  /* @ngInject */
  function DepartmentConfigController($stateParams, $filter, $mdSidenav, fuseTheming, legalUnits, departments) {
    var vm = this;
    vm.legalUnits = legalUnits;
    vm.departments = departments;
    vm.fuseTheming = fuseTheming;
    vm.stateParams = $stateParams;

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.settings").controller("CustomersController", CustomersController);

  /* @ngInject */
  function CustomersController($state, $filter, $mdSidenav, currentUser, customerService, fuseTheming) {
    var vm = this;
    vm.alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ";
    vm.data = customerService;
    vm.fuseTheming = fuseTheming;
    activate();

    function activate() {
      // Check for current state
      if (!$state.params || !$state.params.searchString) {
        // If no state - navigate to first type
        $state.go("app.configuration.customers.customerList", {
          searchString: "A"
        });
      }
    }

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }

  angular.module("app.settings").controller("CustomersToolbarController", CustomersToolbarController);

  /* @ngInject */
  function CustomersToolbarController($state, customerService) {
    var vm = this;

    vm.data = customerService;

    vm.searchString = $state.params.searchString || null;
    vm.search = search;

    function search() {
      // Check for current state
      if (vm.searchString) {
        // If no state - navigate to first type
        $state.go("app.configuration.customers.customerList", {
          searchString: vm.searchString
        });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('customerService', customerService);

    /* @ngInject */
    function customerService($state) {
        var self = this;
        self.searchString = $state.params.searchString || null;
        self.currentCustomers = [];

        self.addCustomer = addCustomer;

        function addCustomer(e) {
            $state.go('app.configuration.customers.editCustomer', { customerId: 'new' });
        }
    }

})();


(function() {
  "use strict";

  angular.module("app.settings").controller("ContactsController", ContactsController);

  /* @ngInject */
  function ContactsController($state, $filter, $mdSidenav, contactTypes, currentUser, contactService, fuseTheming) {
    var vm = this;
    vm.contactTypes = contactTypes;
    vm.data = contactService;
    vm.fuseTheming = fuseTheming;
    activate();

    function activate() {
      // Check for current state
      if (!$state.params || !$state.params.internalType) {
        // If no state - navigate to first type
        var orderedTypes = $filter("orderBy")(contactTypes, "name");
        $state.go("app.configuration.contacts.contactList", {
          internalType: orderedTypes[0].internalType,
          internalTypeId: orderedTypes[0].id,
          contactType: orderedTypes[0]
        });
      }
    }

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }

  angular.module("app.settings").controller("ContactsToolbarController", ContactsToolbarController);

  /* @ngInject */
  function ContactsToolbarController($state, $filter, $mdSidenav, contactTypes, currentUser, contactService) {
    var vm = this;
    vm.contactTypes = contactTypes;
    vm.data = contactService;

    activate();

    function activate() {
      // Check for current state
      if ($state.params && $state.params.searchString) {
        vm.data.searchString = $state.params.searchString;
      }
    }

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings')
        .service('contactService', contactService);

    /* @ngInject */
    function contactService($state) {
        var self = this;
        self.selectedContactType = null;
        self.currentContacts = [];

        self.addContact = addContact;

        function addContact(e) {
            if (self.selectedContactType) {
                switch (self.selectedContactType.internalType) {
                    case 'SupplierType':
                        $state.go('app.configuration.contacts.editSupplier', { supplierId: 'new', supplierTypeId: self.selectedContactType.id });
                        break;
                    case 'ParticipantType':
                        $state.go('app.configuration.contacts.editParticipant', { participantId: 'new', participantTypeId: self.selectedContactType.id });
                        break;
                    case 'PartyType':
                        $state.go('app.configuration.contacts.editParty', { partyId: 'new', partyTypeId: self.selectedContactType.id });
                        break;
                }
            }
        }
    }

})();


(function () {
    'use strict';

    angular.module('app.settings').controller('ConsignmentsConfigController', ConsignmentsConfigController);

    /* @ngInject */
    function ConsignmentsConfigController($mdSidenav, fuseTheming) {
        var vm = this;
        vm.fuseTheming = fuseTheming;
        vm.toggleSidenav = toggleSidenav;

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.salesOrder', [
            // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'xeditable'
        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.salesOrder')
        .controller('SalesOrderPreviewReportController', SalesOrderPreviewReportController);

    /* @ngInject */
    function SalesOrderPreviewReportController($state) {
        var vm = this;
        vm.report = $state.params.report;
        vm.parameters = {
            SalesOrderId: $state.params.salesOrderId
        }

        activate();

        ////////////////

        function activate() {

        }
    }

})();


(function() {
  "use strict";

  angular
    .module("app.salesOrder")
    .controller("RegisterTransactionDialogController", RegisterTransactionDialogController);

  /* @ngInject */
  function RegisterTransactionDialogController(
    $mdDialog,
    $filter,
    loadingService,
    salesOrderService,
    dataService,
    invoice
  ) {
    var vm = this;
    vm.loadingService = loadingService;
    vm.invoice = invoice;
    vm.transaction = salesOrderService.getEmptyFinancialTransaction();
    vm.transaction.invoiceId = invoice.id;
    vm.transaction.customerId = invoice.customerId;
    vm.transaction.transactionDate = invoice.dueDate;
    vm.transaction.amount = (invoice.totalSumIncludingVat || 0) - (invoice.totalFinancialTransactions || 0);
    vm.closeDialog = closeDialog;
    vm.registerTransaction = registerTransaction;

    vm.totalTransactionTranslationValues = {
      transactionTotal: $filter("currency")(vm.invoice.totalFinancialTransactions),
      remaining: $filter("currency")(vm.invoice.totalSumIncludingVat - vm.invoice.totalFinancialTransactions)
    };
    function closeDialog() {
      $mdDialog.hide();
    }

    function registerTransaction() {
      vm.loadingService.setBackgroundLoadingStatus(true);
      dataService.insertItem("FinancialTransactions", vm.transaction).then(function(insertedTransaction) {
        $mdDialog.hide(insertedTransaction);
        vm.loadingService.setBackgroundLoadingStatus(false);
      });
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("MultiChannelDialogController", MultiChannelDialogController);

  /* @ngInject */
  function MultiChannelDialogController($mdDialog, $translate, salesOrderService, invoiceId) {
    var vm = this;
    vm.currentSelection = 2;

    vm.closeDialog = closeDialog;
    vm.chooseOption = chooseOption;
    vm.canSendInvoice = false;

    salesOrderService
      .canSendInvoiceToMultiChannel(invoiceId)
      .then(function(response) {
        vm.canSendInvoice = response.result;
      })
      .catch(function(error) {
        if (error && error.data && error.data.modelState) {
          vm.errorCollection = [];
          _.forEach(error.data.modelState, function(value, key) {
            if (key !== "$type") {
              var formattedKey = _.snakeCase(key);
              formattedKey = "SALES_ORDERS.MULTI_CHANNEL." + _.toUpper(formattedKey);
              vm.errorCollection.push({ value: value, key: formattedKey });
            }
          });
        }
      });

    function closeDialog() {
      $mdDialog.hide();
    }

    function chooseOption() {
      $mdDialog.hide(vm.currentSelection);
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("LockInvoiceDialogController", LockInvoiceDialogController);

  /* @ngInject */
  function LockInvoiceDialogController($mdDialog, salesOrderService, invoice) {
    var vm = this;

    vm.closeDialog = closeDialog;
    vm.lockInvoice = lockInvoice;
    vm.canSendInvoice = false;
    vm.canLockInvoice = false;

    checkInvoice(invoice);

    function checkInvoice(invoice) {
      vm.isCheckingLockedStatus = true;
      vm.isCheckingMultiChannelStatus = true;

      vm.warnings = [];
      // Subject
      if (!invoice.subject) {
        vm.warnings.push("SALES_ORDERS.INVOICE.NO_SUBJECT");
      }

      // Sales representative
      if (!invoice.salesRepresentativeId) {
        vm.warnings.push("SALES_ORDERS.INVOICE.NO_SALES_REPRESENTATIVE");
      }

      // Can Send to Multi Channel
      salesOrderService
        .canSendInvoiceToMultiChannel(invoice.id)
        .then(function(multiChannelResponse) {
          vm.canSendInvoice = multiChannelResponse.result;
        })
        .catch(function(multiChannelError) {
          if (multiChannelError && multiChannelError.data && multiChannelError.data.modelState) {
            vm.multiChannelErrorCollection = [];
            _.forEach(multiChannelError.data.modelState, function(value, key) {
              if (key === "tenant.multiChannelIsActivated") {
                vm.multiChannelNotActivated = true;
              }
              if (key !== "$type" && key !== "invoice.invoiceNumber" && key !== "invoice.isLocked") {
                var formattedKey = _.snakeCase(key);
                formattedKey = "SALES_ORDERS.MULTI_CHANNEL." + _.toUpper(formattedKey);
                vm.multiChannelErrorCollection.push({ value: value, key: formattedKey });
              }
            });
          }
        })
        .finally(function() {
          vm.isCheckingMultiChannelStatus = false;
        });

      // Can Lock Invoice
      salesOrderService
        .canLockInvoice(invoice.id)
        .then(function(lockResponse) {
          vm.canLockInvoice = lockResponse.result;
        })
        .catch(function(lockError) {
          if (lockError && lockError.data && lockError.data.modelState) {
            vm.lockErrorCollection = [];
            _.forEach(lockError.data.modelState, function(value, key) {
              if (key !== "$type") {
                var formattedKey = _.snakeCase(key);
                formattedKey = "SALES_ORDERS.LOCK_INVOICE_DIALOG." + _.toUpper(formattedKey);
                vm.lockErrorCollection.push({ value: value, key: formattedKey });
              }
            });
          }
        })
        .finally(function() {
          vm.isCheckingLockedStatus = false;
        });
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function lockInvoice() {
      if (vm.canLockInvoice) {
        vm.isLockingInvoice = true;
        salesOrderService
          .lockInvoice(invoice)
          .then(function(response) {
            $mdDialog.hide(response);
          })
          .finally(function() {
            vm.isLockingInvoice = false;
          });
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("InvoiceCopiedDialogController", InvoiceCopiedDialogController);

  /* @ngInject */
  function InvoiceCopiedDialogController($mdDialog, $state, invoiceFdo) {
    var vm = this;
    vm.invoiceFdo = invoiceFdo;
    vm.closeDialog = closeDialog;
    vm.gotoInvoice = gotoInvoice;
    vm.gotoSalesOrder = gotoSalesOrder;

    function gotoSalesOrder() {
      closeDialog();
      $state.go("app.salesOrder.details", { salesOrderId: vm.invoiceFdo.salesOrderId });
    }

    function gotoInvoice() {
      closeDialog();
      $state.go("app.invoice.details", { invoiceId: vm.invoiceFdo.id });
    }

    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.salesOrder')
        .controller('EditSalesOrderDetailsDialogController', EditSalesOrderDetailsDialogController);

    /* @ngInject */
    function EditSalesOrderDetailsDialogController($mdDialog, $translate, dataService, salesOrder) {
        var vm = this;
        vm.salesOrder = salesOrder;
        
        // METHODS
        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            dataService.updateItem('SalesOrders', vm.salesOrder).then(function (insertedData) {
                $mdDialog.hide(vm.salesOrder);
            });
        } 
    }

} ());
(function () {
  'use strict';

  angular.module('app.salesOrder').controller('EditSalesOrderAttachmentDialogController', EditSalesOrderAttachmentDialogController);

  /* @ngInject */
  function EditSalesOrderAttachmentDialogController($mdDialog, baldrisApiBase, Upload, salesOrderAttachmentService, salesOrderAttachment) {
    var vm = this;
    vm.salesOrderAttachment = salesOrderAttachment;
    vm.uploadFile = null;
    vm.isLoading = false;

    vm.loadFile = loadFile;
    vm.closeDialog = closeDialog;
    vm.saveAttachmentAndCloseDialog = saveAttachmentAndCloseDialog;
    vm.deleteAttachment = deleteAttachment;

    function loadFile(file) {
      vm.uploadFile = file;
      vm.salesOrderAttachment.fileName = file.name;
    }

    function closeDialog(salesOrderAttachment) {
      vm.isLoading = false;
      $mdDialog.hide(salesOrderAttachment);
    }

    function saveAttachmentAndCloseDialog() {
      vm.isLoading = true;
      // Upload file before saving
      if (vm.uploadFile) {
        Upload.upload({
          url: baldrisApiBase + '/api/BaldrisFiles/Upload',
          data: { file: vm.uploadFile },
        }).then(
          function (resp) {
            if (resp && resp.data && resp.data.length > 0) {
              var baldrisFile = resp.data[0];
              vm.salesOrderAttachment.fileId = baldrisFile.id;
              vm.salesOrderAttachment.filePath = baldrisFile.filepath;
              vm.salesOrderAttachment.fileContentType = baldrisFile.contentType;
              saveAttachment();
            }
          },
          function (resp) {
            console.log('Error status: ' + resp.status);
            vm.isLoading = false;
          }
        );
      } else {
        saveAttachment();
      }
    }

    function saveAttachment() {
      switch (vm.salesOrderAttachment.changeState) {
        case 1:
          salesOrderAttachmentService.addSalesOrderAttachment(vm.salesOrderAttachment).then(function (insertedAttachment) {
            closeDialog(insertedAttachment);
          });
          break;
        case 2:
          salesOrderAttachmentService.updateSalesOrderAttachment(vm.salesOrderAttachment).then(function () {
            closeDialog(vm.salesOrderAttachment);
          });
          break;
        case 3:
          salesOrderAttachmentService.deleteSalesOrderAttachment(vm.salesOrderAttachment).then(function () {
            closeDialog(vm.salesOrderAttachment);
          });
          break;
        default:
          closeDialog(vm.salesOrderAttachment);
          break;
      }
    }

    function deleteAttachment() {
      if (vm.salesOrderAttachment.changeState === 1 || vm.salesOrderAttachment.id === '00000000-0000-0000-0000-000000000000') {
        closeDialog();
      } else {
        vm.salesOrderAttachment.changeState = 3;
        vm.isLoading = true;
        saveAttachment();
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').controller('EditLineItemDialogController', EditLineItemDialogController);

    /* @ngInject */
    function EditLineItemDialogController($mdDialog, lineItemController, lineItem, dataService) {
        var vm = this;

        //Data
        vm.isDisabled = false;
        vm.lineItem = lineItem;

        // Methods
        vm.closeDialog = closeDialog;
        vm.productChanged = productChanged;
        vm.getTotalPrice = getTotalPrice;
        vm.discountChanged = discountChanged;
        vm.priceChanged = priceChanged;
        vm.priceIncludingVatChanged = priceIncludingVatChanged;
        vm.getTotalVatAmount = getTotalVatAmount;

        // INIT
        if (lineItemController === 'InvoiceItems') {
            dataService.canDelete(lineItemController, lineItem).then(function (response) {
                if (response) {
                    vm.isDisabled = !response;
                    vm.canEditChecked = true;
                }
            });
        } else {
            vm.canEditChecked = true;
        }

        vm.priceIncludingVat = vm.lineItem.productPrice + vm.lineItem.productVatAmount;

        function closeDialog(lineItem) {
            if (lineItem) {
                dataService.updateItem(lineItemController, lineItem).then(function (updatedLineItem) {
                    $mdDialog.hide(lineItem);
                });
            } else {
                $mdDialog.hide();
            }
        }

        function productChanged(newProduct) {
            if (newProduct) {
                if (newProduct.id !== vm.lineItem.productId) {
                    vm.lineItem.productCode = newProduct.productCode;
                    vm.lineItem.productName = newProduct.name;
                    vm.lineItem.productVatRate = newProduct.vatRate;
                    vm.lineItem.productBalanceAccount = newProduct.balanceAccountAccount;
                    vm.lineItem.balanceAccountId = newProduct.balanceAccountId;
                    vm.lineItem.vatId = newProduct.vatId;
                    vm.lineItem.productPrice = newProduct.price;
                    vm.lineItem.productVatAmount = getVatAmount();
                    vm.lineItem.productTotalPrice = vm.lineItem.productPrice * ((100 - vm.lineItem.productDiscount) / 100) + vm.lineItem.productVatAmount;
                    priceChanged();
                }
            } else {
                vm.lineItem.productName = null;
            }
        }

        function getTotalPrice() {
            return vm.lineItem.productAmount * vm.lineItem.productTotalPrice;
        }

        function discountChanged() {
            vm.lineItem.productVatAmount = getVatAmount();
            vm.lineItem.productTotalPrice = vm.lineItem.productPrice * ((100 - vm.lineItem.productDiscount) / 100) + vm.lineItem.productVatAmount;
        }

        function priceChanged() {
            vm.lineItem.productVatAmount = getVatAmount();
            vm.lineItem.productTotalPrice = vm.lineItem.productPrice * ((100 - vm.lineItem.productDiscount) / 100) + vm.lineItem.productVatAmount;
            if (vm.lineItem.productVatRate == 0) {
                vm.priceIncludingVat = vm.lineItem.productPrice;
            } else {
                vm.priceIncludingVat = vm.lineItem.productPrice * ((100 + vm.lineItem.productVatRate) / 100);
            }
        }

        function priceIncludingVatChanged() {
            if (vm.lineItem.productVatRate == 0) {
                vm.lineItem.productPrice = vm.priceIncludingVat;
            } else {
                vm.lineItem.productPrice = vm.priceIncludingVat / ((100 + vm.lineItem.productVatRate) / 100);
            }
            vm.lineItem.productVatAmount = getVatAmount();
            vm.lineItem.productTotalPrice = vm.lineItem.productPrice * ((100 - vm.lineItem.productDiscount) / 100) + vm.lineItem.productVatAmount;
        }

        function getVatAmount() {
            if (vm.lineItem.productVatRate == 0) {
                return 0;
            }
            return vm.lineItem.productPrice * ((100 - vm.lineItem.productDiscount) / 100) * (vm.lineItem.productVatRate / 100);
        }

        function getTotalVatAmount() {
            return vm.lineItem.productVatAmount * vm.lineItem.productAmount;
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("EditInvoiceDetailsDialogController", EditInvoiceDetailsDialogController);

  /* @ngInject */
  function EditInvoiceDetailsDialogController($mdDialog, $translate, dataService, invoice, baldrisConfigService) {
    var vm = this;
    vm.invoice = invoice;
    vm.dueOffset = 14;

    activate();

    // METHODS
    vm.closeDialog = closeDialog;
    vm.saveChanges = saveChanges;
    vm.onInvoiceDateChanged = onInvoiceDateChanged;

    function activate() {
      baldrisConfigService.getByCategory("Invoice").then(function(configs) {
        for (var i = 0; i < configs.length; i++) {
          var config = configs[i];
          if (config.name === "InvoiceDueOffset") {
            if (config.dataValueAsString) {
              vm.dueOffset = Number(config.dataValueAsString) || 14;
            }
          }
        }
      });
    }

    function onInvoiceDateChanged(invoiceDate) {
      if (invoiceDate && !vm.invoice.dueDate) {
        vm.invoice.dueDate = moment(invoiceDate)
          .add(vm.dueOffset || 14, "days")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function saveChanges() {
      dataService.updateItem("Invoices", vm.invoice).then(function(insertedData) {
        $mdDialog.hide(vm.invoice);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.salesOrder').controller('ConfirmMultiChannelDialogDialogController', ConfirmMultiChannelDialogDialogController);

  /* @ngInject */
  function ConfirmMultiChannelDialogDialogController($mdDialog, addressService, salesOrderService, updateModel) {
    var vm = this;
    vm.updateModel = updateModel;

    vm.closeDialog = closeDialog;
    vm.getFormattedBillingAddress = getFormattedBillingAddress;
    vm.isOrganization = isOrganization;
    vm.getTotalPrice = getTotalPrice;
    vm.getTotalVat = getTotalVat;
    vm.getTotalPriceIncludingVat = getTotalPriceIncludingVat;
    vm.removeAttachment = removeAttachment;
    vm.hasAttachments = hasAttachments;
    vm.sendToMultiChannel = sendToMultiChannel;

    function closeDialog() {
      vm.isLoading = false;
      $mdDialog.hide();
    }

    function sendToMultiChannel() {
      vm.isLoading = true;
      salesOrderService
        .sendInvoiceToMultiChannel(vm.updateModel)
        .then(function () {
          closeDialog();
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function hasAttachments() {
      if (!vm.updateModel.attachments || vm.updateModel.attachments.length === 0) return false;
      return _.some(vm.updateModel.attachments, { sendWithInvoice: true });
    }

    function removeAttachment(attachment) {
      var index = vm.updateModel.attachments.indexOf(attachment);
      if (index >= 0) {
        vm.updateModel.attachments.splice(index, 1);
      }
    }

    function getFormattedBillingAddress() {
      if (!vm.updateModel.customer || !vm.updateModel.customer.billingAddress) return null;
      return addressService.getFormattedAddress(vm.updateModel.customer.billingAddress);
    }

    function isOrganization() {
      if (vm.updateModel.customer && vm.updateModel.customer.partyUpdateModel && vm.updateModel.customer.partyUpdateModel.party) {
        return vm.updateModel.customer.partyUpdateModel.party.$type.indexOf('Organization') > -1;
      }
      return false;
    }

    function getTotalPrice() {
      if (!vm.updateModel.lineItems || vm.updateModel.lineItems.length === 0) {
        return 0;
      }

      var totalSum = 0;

      for (var index = 0; index < vm.updateModel.lineItems.length; index++) {
        var lineItem = vm.updateModel.lineItems[index];
        totalSum += lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * lineItem.productPrice;
      }

      return totalSum;
    }

    function getTotalVat() {
      if (!vm.updateModel.lineItems || vm.updateModel.lineItems.length === 0) {
        return 0;
      }

      var totalSum = 0;

      for (var index = 0; index < vm.updateModel.lineItems.length; index++) {
        var lineItem = vm.updateModel.lineItems[index];
        totalSum += lineItem.productAmount * lineItem.productVatAmount;
      }

      return totalSum;
    }

    function getTotalPriceIncludingVat() {
      if (!vm.updateModel.lineItems || vm.updateModel.lineItems.length === 0) {
        return 0;
      }

      var totalSum = 0;

      for (var index = 0; index < vm.updateModel.lineItems.length; index++) {
        var lineItem = vm.updateModel.lineItems[index];
        totalSum += lineItem.productAmount * lineItem.productTotalPrice;
      }

      return totalSum;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').controller('AddSalesOrderDialogController', AddSalesOrderDialogController);

    /* @ngInject */
    function AddSalesOrderDialogController(
        $mdDialog,
        $q,
        commonService,
        billToOptions,
        dataService,
        workOrder,
        workOrderProducts,
        salesOrderService,
        referencePersonTypeOptions,
        loadingService
    ) {
        var vm = this;
        vm.loadingService = loadingService;
        // Data
        vm.updateModel = {
            salesOrder: salesOrderService.getEmptySalesOrder(),
            lineItems: [],
            customer: null,
        };
        vm.updateModel.salesOrder.changeState = 1;
        vm.selectedLineItems = [];
        vm.lineItems = [];
        vm.workOrderProducts = workOrderProducts;
        vm.showWorkOrderSelect = false;

        activate();

        // Methods
        vm.isLineItemSelected = isLineItemSelected;
        vm.toggleLineItem = toggleLineItem;
        vm.getTotalPrice = getTotalPrice;
        vm.getBillToText = getBillToText;
        vm.saveChanges = saveChanges;
        vm.closeDialog = closeDialog;
        vm.onWorkOrderChanged = onWorkOrderChanged;
        vm.toggleAllLineItems = toggleAllLineItems;

        function activate() {
            var promises = [];
            vm.loadingService.setBackgroundLoadingStatus(true);
            if (workOrderProducts && workOrderProducts.length > 0) {
                // INIT
                vm.selectedLineItems = convertToLineItems(workOrderProducts, true);
                vm.lineItems = vm.selectedLineItems.slice();
            }
            promises.push(dataService.getByUri('Reports', 'ByInternalCategory/SalesOrder'));
            if (workOrder) {
                vm.showWorkOrderSelect = false;
                promises.push(extractWorkOrderData(workOrder));
            } else {
                vm.showWorkOrderSelect = true;
            }
            $q.all(promises).then(function (response) {
                if (response[0] && response[0].length > 0) {
                    vm.updateModel.salesOrder.reportId = response[0][0].id;
                }
                vm.loadingService.setBackgroundLoadingStatus(false);
            });
        }

        function convertToLineItems(workOrderProducts, onlyConvertUntransferred) {
            var lineItems = [];
            for (var i = 0; i < workOrderProducts.length; i++) {
                var workOrderProduct = workOrderProducts[i];
                if (onlyConvertUntransferred) {
                    if (!workOrderProduct.isTransferedToOrder) lineItems.push(salesOrderService.createSalesOrderProductFromWorkOrderProduct(workOrderProduct));
                } else {
                    lineItems.push(salesOrderService.createSalesOrderProductFromWorkOrderProduct(workOrderProduct));
                }
            }
            return lineItems;
        }

        function extractWorkOrderData(workOrder) {
            vm.updateModel.salesOrder.workOrderId = workOrder.id;
            vm.updateModel.salesOrder.departmentId = workOrder.departmentId;
            vm.updateModel.salesOrder.salesRepresentativeId = workOrder.caseWorkerId;

            var promises = [];

            promises.push(dataService.getByUri('SalesOrders', 'SuggestedSubjectTextByWorkOrderId/' + workOrder.id));
            promises.push(dataService.getByWorkOrderId('ReferencePersons', workOrder.id));

            return $q.all(promises).then(function (response) {
                vm.updateModel.salesOrder.subject = response[0];
                var referencePersons = response[1];
                if (referencePersons && referencePersons.length > 0) {
                    for (var i = 0; i < referencePersons.length; i++) {
                        var referencePerson = referencePersons[i];
                        if (
                            referencePerson.referencePersonType &&
                            referencePerson.referencePersonType.indexOf(referencePersonTypeOptions.CUSTOMER.value) > -1
                        ) {
                            var promises = [];
                            promises.push(dataService.getById('Persons', referencePerson.personId));
                            promises.push(dataService.getByUri('Addresses', 'ByPartyId/' + referencePerson.personId));
                            return $q.all(promises).then(function (result) {
                                vm.updateModel.customer = salesOrderService.getUpdateOrInsertCustomerByPartyIdCommand();
                                vm.updateModel.customer.partyId = result[0].id;
                                vm.updateModel.customer.partyDisplayName = result[0].displayName;
                                vm.updateModel.customer.customerForDepartmentId = vm.updateModel.salesOrder.departmentId;
                                if (result[1] && result[1].length > 0) {
                                    vm.updateModel.customer.billingAddressId = result[1][0].id;
                                }
                                return true;
                            });
                        }
                    }
                }
                return true;
            });
        }

        function isLineItemSelected(lineItem) {
            return vm.selectedLineItems.indexOf(lineItem) > -1;
        }

        function toggleLineItem(lineItem) {
            if (isLineItemSelected(lineItem)) {
                var selectedIndex = vm.selectedLineItems.indexOf(lineItem);
                vm.selectedLineItems.splice(selectedIndex, 1);
            } else {
                vm.selectedLineItems.push(lineItem);
            }
        }

        function toggleAllLineItems() {
            if (vm.selectedLineItems.length > 0) {
                vm.selectedLineItems = [];
            } else {
                if (vm.lineItems && vm.lineItems.length > 0) {
                    vm.selectedLineItems = vm.lineItems.slice();
                }
            }
        }

        function getTotalPrice(lineItem) {
            return commonService.priceFunctions.getTotalPrice(lineItem.productAmount, lineItem.productTotalPrice);
        }

        function getBillToText(billToOption) {
            var billToTextArray = [];
            angular.forEach(billToOptions, function (option) {
                if (billToOption && billToOption.indexOf(option.value) > -1) {
                    billToTextArray.push(option.text);
                }
            });
            return billToTextArray;
        }

        function saveChanges() {
            if (vm.selectedLineItems.length > 0) {
                for (var index = 0; index < vm.selectedLineItems.length; index++) {
                    var lineItem = vm.selectedLineItems[index];
                    vm.updateModel.lineItems.push(lineItem);
                }
            }
            return dataService.insertItem('SalesOrders', vm.updateModel.salesOrder).then(function (insertedSalesOrder) {
                var promises = dataService.createBulkPromises('SalesOrderItems', vm.updateModel.lineItems, 'salesOrderId', insertedSalesOrder.id);
                if (promises.length > 0) {
                    $q.all(promises).then(function () {
                        return updateOrInsertCustomer(insertedSalesOrder);
                    });
                } else {
                    return updateOrInsertCustomer(insertedSalesOrder);
                }
            });
        }

        function updateOrInsertCustomer(salesOrder) {
            if (vm.updateModel.customer) {
                return dataService.insertItem('Customers/UpdateOrInsertByPartyId', vm.updateModel.customer).then(function (customer) {
                    salesOrder.customerId = customer.id;
                    salesOrder.customerName = customer.displayName;
                    return dataService.updateItem('SalesOrders', salesOrder).then(function () {
                        $mdDialog.hide(salesOrder);
                    });
                });
            }
            $mdDialog.hide(salesOrder);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function onWorkOrderChanged(workOrder) {
            if (workOrder) {
                extractWorkOrderData(workOrder);

                if (!workOrderProducts || workOrderProducts.length === 0) {
                    dataService.getByWorkOrderId('WorkOrderProducts', workOrder.id).then(function (newWorkOrderProducts) {
                        if (newWorkOrderProducts && newWorkOrderProducts.length > 0) {
                            // INIT
                            vm.selectedLineItems = convertToLineItems(newWorkOrderProducts, true);
                            vm.lineItems = vm.selectedLineItems.slice();
                        }
                    });
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').controller('AddInvoiceDialogController', AddInvoiceDialogController);

    /* @ngInject */
    function AddInvoiceDialogController($mdDialog, $translate, $q, dataService, salesOrder, lineItems, salesOrderService) {
        var vm = this;

        // Data
        vm.updateModel = {
            invoice: salesOrderService.getEmptyInvoice(),
            lineItems: [],
            customer: {
                customer: null,
                billingAddress: null,
            },
        };
        vm.selectedLineItems = [];
        vm.unselectedLineItems = [];
        vm.lineItems = lineItems;

        // Methods
        vm.isLineItemSelected = isLineItemSelected;
        vm.toggleLineItem = toggleLineItem;
        vm.toggleAllLineItems = toggleAllLineItems;
        vm.saveChanges = saveChanges;
        vm.closeDialog = closeDialog;

        function isLineItemSelected(lineItem) {
            return vm.selectedLineItems.indexOf(lineItem) > -1;
        }

        function toggleLineItem(lineItem) {
            if (isLineItemSelected(lineItem)) {
                var selectedIndex = vm.selectedLineItems.indexOf(lineItem);
                vm.selectedLineItems.splice(selectedIndex, 1);
                vm.unselectedLineItems.push(lineItem);
            } else {
                var unselectedIndex = vm.unselectedLineItems.indexOf(lineItem);
                if (unselectedIndex > -1) {
                    vm.unselectedLineItems.splice(unselectedIndex, 1);
                    vm.selectedLineItems.push(lineItem);
                }
            }
        }

        function toggleAllLineItems() {
            if (vm.selectedLineItems.length > 0) {
                vm.selectedLineItems = [];
            } else {
                if (vm.lineItems && vm.lineItems.length > 0) {
                    vm.selectedLineItems = vm.lineItems.slice();
                }
            }
        }

        function saveChanges() {
            if (vm.selectedLineItems.length > 0) {
                for (var index = 0; index < vm.selectedLineItems.length; index++) {
                    var lineItem = vm.selectedLineItems[index];
                    var invoiceLineItem = salesOrderService.createInvoiceProductFromSalesOrderProduct(lineItem);
                    invoiceLineItem.changeState = 1;
                    vm.updateModel.lineItems.push(invoiceLineItem);
                }
            }

            return dataService.insertItem('Invoices', vm.updateModel.invoice).then(function (insertedinvoice) {
                var promises = [];
                promises = promises.concat(dataService.createBulkPromises('InvoiceItems', vm.updateModel.lineItems, 'invoiceId', insertedinvoice.id));

                if (promises.length > 0) {
                    return $q.all(promises).then(function () {
                        $mdDialog.hide(insertedinvoice);
                    });
                }

                $mdDialog.hide(insertedinvoice);
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        // INIT
        vm.selectedLineItems = lineItems.slice();
        vm.updateModel.invoice.changeState = 1;
        vm.updateModel.invoice.salesOrderId = salesOrder.id;
        vm.updateModel.invoice.customerId = salesOrder.customerId;
        vm.updateModel.invoice.salesRepresentativeId = salesOrder.salesRepresentativeId;
        if (salesOrder.subject) {
            vm.updateModel.invoice.subject = salesOrder.subject;
        } else if (salesOrder.workOrderId) {
            dataService.getById('WorkOrders', salesOrder.workOrderId).then(function (workOrder) {
                vm.updateModel.invoice.subject = workOrder.workOrderType
                    ? workOrder.workOrderType.name
                    : $translate.instant('WORK_ORDERS.WORK_ORDER.WORK_ORDER');
                if (workOrder.deceaseds && workOrder.deceaseds.length > 0) {
                    var nameList = [];
                    for (var index = 0; index < workOrder.deceaseds.length; index++) {
                        var workOrderDeceased = workOrder.deceaseds[index];
                        if (workOrderDeceased.deceased && workOrderDeceased.deceased.personDisplayName) {
                            nameList.push(workOrderDeceased.deceased.personDisplayName);
                        }
                    }
                    if (nameList.length > 0) {
                        vm.updateModel.invoice.subject += ' – ' + nameList.join('; ');
                    }
                }
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app.salesOrder')
    .component('salesOrderAttachmentsSection', {
      bindings: {
        salesOrderAttachments: '<',
        salesOrderId: '<',
        onAdded: '&',
        onUpdated: '&',
        onDeleted: '&',
      },
      templateUrl: 'app/main/sales-order/components/sales-order-attachments-section/sales-order-attachments-section.tmpl.html',
      controller: 'SalesOrderAttachmentsSectionController as vm',
    })
    .controller('SalesOrderAttachmentsSectionController', SalesOrderAttachmentsSectionController);

  /* @ngInject */

  function SalesOrderAttachmentsSectionController(salesOrderAttachmentService) {
    var vm = this;

    // Methods
    vm.editAttachment = editAttachment;
    vm.getAttachmentIcon = getAttachmentIcon;

    // INIT
    vm.$onInit = function () {};

    function editAttachment(attachment, e) {
      salesOrderAttachmentService.openEditSalesOrderAttachmentDialog(attachment, vm.salesOrderId, e).then(function (savedAttachment) {
        if (!savedAttachment) return;
        // remove existing attachment and add updated if not deleted
        if (!vm.salesOrderAttachments) vm.salesOrderAttachments = [];
        _.remove(vm.salesOrderAttachments, function (a) {
          return a.id === savedAttachment.id;
        });
        if (savedAttachment.changeState !== 3) {
          vm.salesOrderAttachments.push(savedAttachment);
        }
      });
    }

    function getAttachmentIcon(contentType) {
      if (!contentType) return 'icon-file';
      if (contentType.indexOf('image') > -1) return 'icon-file-image';
      if (contentType.indexOf('pdf') > -1) return 'icon-file-pdf';
      if (contentType.indexOf('msexcel') > -1 || contentType.indexOf('ms-excel') > -1 || contentType.indexOf('vnd.openxmlformats-officedocument.spreadsheetml.sheet') > -1) return 'icon-file-excel';
      if (contentType.indexOf('msword') > -1 || contentType.indexOf('vnd.openxmlformats-officedocument.wordprocessingml.document') > -1) return 'icon-file-word';
      if (contentType.indexOf('mspowerpoint') > -1 || contentType.indexOf('ms-powerpoint') > -1 || contentType.indexOf('vnd.openxmlformats-officedocument.presentationml.presentation') > -1)
        return 'icon-file-powerpoint';
      if (contentType.indexOf('video') > -1) return 'icon-file-video';
      return 'icon-file';
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.salesOrder')
        .component('orderLineTable', {
            bindings: {
                lineItemCollection: '=',
                lineItemController: '=',
                parentController: '=',
                getEmptyLineItem: '=',
                tableOptions: '=',
                parentIdName: '=',
                parentId: '=',
                onSelected: '=',
                onAdded: '=',
                onEdited: '=',
                onDeleted: '=',
            },
            templateUrl: 'app/main/sales-order/components/order-line-table/order-line-table.tmpl.html',
            controller: 'OrderLineTableController as vm',
        })
        .controller('OrderLineTableController', OrderLineTableController);

    /* @ngInject */
    function OrderLineTableController(dataService, toastService, $translate, $timeout, $mdDialog, $document, datatableService, salesOrderService) {
        var vm = this;

        // Data

        vm.addNewOrderLineForm = {};
        vm.canAddOrderLines = true;

        // Methods
        vm.addSalesOrderItem = addSalesOrderItem;
        vm.deleteSalesOrderItem = deleteSalesOrderItem;
        vm.editSalesOrderItem = editSalesOrderItem;
        vm.getTotalPrice = getTotalPrice;
        vm.getTotalPriceIncludingVat = getTotalPriceIncludingVat;
        vm.getTotalVat = getTotalVat;
        vm.getNewLineProduct = getNewLineProduct;
        vm.getTotalPriceLineItem = getTotalPriceLineItem;
        vm.resetNewOrderLine = resetNewOrderLine;
        vm.addNewOrderLine = addNewOrderLine;
        vm.onNewProductSelected = onNewProductSelected;
        vm.getTotalPriceIncludingVatLineItem = getTotalPriceIncludingVatLineItem;
        vm.getPriceIncludingVatLineItem = getPriceIncludingVatLineItem;

        // INIT
        vm.$onInit = function () {
            vm.newOrderLine = getNewLineProduct();
            if (vm.parentController && vm.parentId) {
                dataService.canDelete(vm.parentController, { id: vm.parentId }).then(function (response) {
                    if (!response) {
                        vm.canAddOrderLines = false;
                    }
                });
            }
        };

        /**
         * Add a line item to the databse
         */
        function addSalesOrderItem(lineItem) {
            return dataService.insertItem(vm.lineItemController, lineItem).then(function (savedSalesOrderItem) {
                // reattach product since shortDtos are stripped away on saving
                if (lineItem.productId === savedSalesOrderItem.productId) {
                    savedSalesOrderItem.product = lineItem.product;
                }
                // set changeState to no change to avoid resaving
                lineItem.changeState = 0;
                vm.lineItemCollection.push(savedSalesOrderItem);
                toastService.success($translate.instant('SALES_ORDERS.LINE_ITEM.LINE_ITEM_SAVED'));
                return savedSalesOrderItem;
            });
        }

        /**
         * Delete a line item from the database
         */
        function deleteSalesOrderItem(lineItem, e) {
            if (e) e.stopPropagation();
            return dataService.canDelete(vm.lineItemController, lineItem).then(function (response) {
                if (response) {
                    //Prompt for confirmation
                    var confirm = $mdDialog
                        .confirm()
                        .title($translate.instant('SALES_ORDERS.LINE_ITEM.DELETE_LINE_ITEM'))
                        .textContent($translate.instant('SALES_ORDERS.LINE_ITEM.DELETE_LINE_ITEM_CONFIRM', { lineItemText: lineItem.productName }))
                        .ariaLabel($translate.instant('SALES_ORDERS.LINE_ITEM.DELETE_LINE_ITEM'))
                        .targetEvent(e)
                        .ok($translate.instant('COMMON.DIALOG.OK_DELETE'))
                        .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
                    return $mdDialog.show(confirm).then(
                        function () {
                            dataService.deleteItem(vm.lineItemController, lineItem).then(function () {
                                // Remove from view
                                var index = vm.lineItemCollection.indexOf(lineItem);
                                vm.lineItemCollection.splice(index, 1);
                                toastService.success($translate.instant('SALES_ORDERS.LINE_ITEM.LINE_ITEM_DELETED'));
                                return true;
                            });
                        },
                        function () {
                            // Do nothing
                        }
                    );
                } else {
                    var alert = $mdDialog
                        .alert()
                        .title($translate.instant('COMMON.DATA.DELETE_NOT_OK'))
                        .textContent($translate.instant('SALES_ORDERS.LINE_ITEM.CANNOT_DELETE'))
                        .targetEvent(e)
                        .ok($translate.instant('COMMON.DIALOG.OK'));
                    return $mdDialog.show(alert);
                }
            });
        }

        /**
         * Open EditLineItemDialog
         */
        function editSalesOrderItem(lineItem, e) {
            return $mdDialog
                .show({
                    controller: 'EditLineItemDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/edit-line-item-dialog/edit-line-item-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        lineItemController: vm.lineItemController,
                        lineItem: angular.copy(lineItem),
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updatedSalesOrderItem) {
                    if (updatedSalesOrderItem) {
                        // set changeState to no change to avoid resaving
                        updatedSalesOrderItem.changeState = 0;
                        // Remove previous line Item from updateModel
                        for (var index = vm.lineItemCollection.length - 1; index >= 0; index--) {
                            var lineItem = vm.lineItemCollection[index];
                            if (lineItem.id === updatedSalesOrderItem.id) {
                                vm.lineItemCollection.splice(index, 1);
                            }
                        }
                        // Add to updateModel
                        vm.lineItemCollection.push(updatedSalesOrderItem);
                        toastService.success($translate.instant('SALES_ORDERS.LINE_ITEM.LINE_ITEM_SAVED'));
                    }
                    return updatedSalesOrderItem;
                });
        }

        /**
         * add new order line
         */
        function addNewOrderLine() {
            // TODO: Add confirmation dialog if all other lineItems are in a locked invoice
            if (vm.newOrderLine.product) {
                vm.newOrderLine.productCode = vm.newOrderLine.product.productCode;
                vm.newOrderLine.productName = vm.newOrderLine.product.name;
                vm.newOrderLine.productCost = vm.newOrderLine.product.productCost;
                vm.newOrderLine.productPrice = vm.newOrderLine.productPrice || vm.newOrderLine.product.price;
                vm.newOrderLine.productVatAmount =
                    vm.newOrderLine.productPrice * ((100 - vm.newOrderLine.productDiscount) / 100) * (vm.newOrderLine.product.vatRate / 100);
                vm.newOrderLine.productTotalPrice =
                    vm.newOrderLine.productPrice * ((100 - vm.newOrderLine.productDiscount) / 100) + vm.newOrderLine.productVatAmount;
                vm.newOrderLine.productVatRate = vm.newOrderLine.product.vatRate;
                vm.newOrderLine.balanceAccountId = vm.newOrderLine.product.balanceAccountId;
                vm.newOrderLine.productBalanceAccount = vm.newOrderLine.product.balanceAccountAccount;
                vm.newOrderLine.vatId = vm.newOrderLine.product.vatId;
                vm.newOrderLine.changeState = 1;
                vm.newOrderLine.salesOrderId = vm.parentId;
                addSalesOrderItem(vm.newOrderLine).then(function () {
                    // reset orderLine
                    vm.newOrderLine = getNewLineProduct();
                    if (vm.addNewOrderLineForm && vm.addNewOrderLineForm['vm.productForm']) {
                        $timeout(function () {
                            vm.addNewOrderLineForm['vm.productForm'].product.$setValidity('invalidProduct', true);
                            vm.addNewOrderLineForm['vm.productForm'].product.$setValidity('required', true);
                        });
                    }
                });
            }
        }

        /**
         * reset new order line
         */
        function resetNewOrderLine() {
            vm.newOrderLine = getNewLineProduct();
        }

        /**
         * Initialize a new salesOrderProduct
         */
        function getNewLineProduct() {
            var lineProduct = null;
            if (angular.isFunction(vm.getEmptyLineItem)) {
                lineProduct = vm.getEmptyLineItem();
            } else {
                lineProduct = salesOrderService.getEmptySalesOrderProduct();
            }

            // Get previously sortOrder
            if (vm.lineItemCollection && vm.lineItemCollection.length > 0) {
                lineProduct.sortOrder =
                    Math.max.apply(
                        Math,
                        vm.lineItemCollection.map(function (lineItem) {
                            return lineItem.sortOrder || 0;
                        })
                    ) + 10;
            } else {
                lineProduct.sortOrder = 0;
            }

            lineProduct.changeState = 1;
            lineProduct.productAmount = 1;
            lineProduct[vm.parentIdName] = vm.parentId;

            return lineProduct;
        }

        /**
         * Get Total Price for LineItem
         */
        function getTotalPriceLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            return lineItem.productAmount * (lineItem.productTotalPrice - lineItem.productVatAmount);
            // return (lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * lineItem.productPrice);
        }

        function getPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            if (!lineItem.productVatRate) {
                return lineItem.productPrice;
            }

            return lineItem.productPrice * (1 + lineItem.productVatRate / 100);
        }

        function getTotalPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            return lineItem.productAmount * lineItem.productTotalPrice;
            // return (lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * (lineItem.productPrice + lineItem.productVatAmount));
        }

        /**
         * Get Total Price
         */
        function getTotalPrice() {
            if (!vm.lineItemCollection || vm.lineItemCollection.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < vm.lineItemCollection.length; index++) {
                var lineItem = vm.lineItemCollection[index];
                totalSum += lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * lineItem.productPrice;
            }

            return totalSum;
        }

        /**
         * Get Total Vat
         */
        function getTotalVat() {
            if (!vm.lineItemCollection || vm.lineItemCollection.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < vm.lineItemCollection.length; index++) {
                var lineItem = vm.lineItemCollection[index];
                totalSum += lineItem.productAmount * lineItem.productVatAmount;
            }

            return totalSum;
        }

        /**
         * Get Total Price Including Vat
         */
        function getTotalPriceIncludingVat() {
            if (!vm.lineItemCollection || vm.lineItemCollection.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < vm.lineItemCollection.length; index++) {
                var lineItem = vm.lineItemCollection[index];
                totalSum += lineItem.productAmount * lineItem.productTotalPrice;
            }

            return totalSum;
        }

        function onNewProductSelected(product) {
            if (product) {
                vm.newOrderLine.sortOrder = product.defaultSortOrder;
                vm.newOrderLine.productPrice = product.price;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ReportViewerDialogController', ReportViewerDialogController);

    /* @ngInject */
    function ReportViewerDialogController($http, $sce, $window, $mdDialog, $translate, reportViewerOptions, dataService, baldrisApiBase, exception) {
        var vm = this;

        vm.reportViewerOptions = reportViewerOptions;
        vm.reportPdf = null;
        vm.isLoading = true;

        activate();

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.getReportWidth = getReportWidth;

        function activate() {
            vm.isLoading = true;
            $http({
                url : baldrisApiBase + '/api/Reports/AsPdf/' + reportViewerOptions.reportId +'/WorkOrderId/' + reportViewerOptions.workOrderId,
                method : 'GET',
                params : {},
                headers : {
                    'Content-type' : 'application/pdf',
                },
                responseType : 'blob'
            }).then(function(data, status, headers, config) {
                // TODO when WS success
                var file = new Blob([ data ], {
                    type : 'application/pdf'
                });
                //trick to download store a file having its URL
                var objectUrl = URL.createObjectURL(file);
                vm.reportPdf = $sce.trustAsResourceUrl(objectUrl);
                //return $window.open(fileURL, '_blank');
                // var a         = document.createElement('a');
                // a.href        = fileURL;
                // a.target      = '_blank';
                // a.download    = 'preview_file.pdf';
                // document.body.appendChild(a);
                // a.click();
                // document.body.removeChild( a );
                vm.isLoading = false;
            }).catch(function(data, status, headers, config) {
                //TODO when WS error
                exception.catcher('XHR Failed for getPreviewFile at "Invoices"')(message);
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {

        }

        function getReportWidth() {
            if ($window.innerWidth < 600) return $window.innerWidth - 48;
            return 552;
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.report')
        .component('reportSelect', {
            bindings: {
                reportId: '=',
                report: '=',
                onSelected: '=',
                onAddNew: '=',
                internalCategory: '=',
                labelText: '@',
                displayText: '=',
            },
            templateUrl: 'app/main/report/components/report-select/report-select.tmpl.html',
            controller: 'ReportSelectController as vm',
        })
        .controller('ReportSelectController', ReportSelectController);

    /* @ngInject */
    function ReportSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.reports = [];

        vm.$onInit = function () {
            //Get Current Report
            if (vm.reportId) {
                dataService.getById('Reports', vm.reportId, true).then(function (report) {
                    vm.report = report;
                });
            }

            // Get available reports from category
            if (vm.internalCategory) {
                dataService.getByUri('Reports/ByInternalCategory', vm.internalCategory).then(function (reports) {
                    vm.reports = reports.data || reports;
                });
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService.search('Reports', query).then(function (reports) {
                    return $filter('orderBy')(reports, 'name');
                });
            } else {
                return dataService.getAll('Reports').then(function (reports) {
                    return $filter('orderBy')(reports, 'name');
                });
            }
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item && vm.reportForm && vm.reportForm.report) {
                if (angular.isObject(item)) {
                    vm.reportId = item.id;
                    if (angular.isDefined(vm.displayText)) {
                        vm.displayText = item.name;
                    }
                } else if (angular.isString(item)) {
                    if (vm.reports && vm.reports.length > 0) {
                        var selectedReport = _.find(vm.reports, { id: item });
                        if (selectedReport) {
                            vm.report = selectedReport;
                            if (angular.isDefined(vm.displayText)) {
                                vm.displayText = selectedReport.name;
                            }
                        }
                    }
                }
                vm.reportForm.report.$setValidity('invalidReport', true);
            } else {
                vm.reportId = null;
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                if (vm.searchText && vm.reportForm && vm.reportForm.report) {
                    vm.reportForm.report.$setValidity('invalidReport', false);
                }
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.report")
    .component("reportMultiSelect", {
      bindings: {
        reports: "<",
        onUpdate: "&",
        internalCategory: "<",
        labelText: "@"
      },
      templateUrl: "app/main/report/components/report-multi-select/report-multi-select.tmpl.html",
      controller: "ReportMultiSelectController as vm"
    })
    .controller("ReportMultiSelectController", ReportMultiSelectController);

  /* @ngInject */
  function ReportMultiSelectController($filter, dataService, msUtils) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.searchTextChange = searchTextChange;
    vm.selectedReports = [];
    vm.minLenght = msUtils.isMobile() ? 1 : 0;

    vm.onAddReport = onAddReport;
    vm.onRemoveReport = onRemoveReport;

    vm.$onInit = function() {
      // Make chips of Current Reports
      if (vm.reports && vm.reports.length > 0) {
        vm.selectedReports = vm.reports.map(function(report) {
          return { id: report.id, name: report.name };
        });
      }
    };

    // ******************************
    // Internal methods
    // ******************************
    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      if (query) {
        if (vm.internalCategory) {
          return dataService.getByConfigName("Reports", vm.internalCategory).then(function(reports) {
            reports = $filter("filter")(reports, { name: query });
            return $filter("orderBy")(reports, "name");
          });
        }
        return dataService.search("Reports", query).then(function(reports) {
          return $filter("orderBy")(reports, "name");
        });
      } else {
        if (vm.internalCategory) {
          return dataService.getByConfigName("Reports", vm.internalCategory).then(function(reports) {
            return $filter("orderBy")(reports, "name");
          });
        }
        return dataService.getAll("Reports").then(function(reports) {
          return $filter("orderBy")(reports, "name");
        });
      }
    }

    function searchTextChange(text) {}

    function onAddReport(reportChip) {
      if (!vm.reports) vm.reports = [];
      if (!_.some(vm.reports, { id: reportChip.id })) {
        vm.reports.push(reportChip);
        vm.onUpdate({ action: "added", item: reportChip });
      }
    }

    function onRemoveReport(reportChip) {
      if (!vm.reports) {
        vm.reports = [];
        return;
      }
      var removedChips = _.remove(vm.reports, function(report) {
        return report.id == reportChip.id;
      });
      if (removedChips && removedChips.length > 0) {
        vm.onUpdate({ action: "removed", item: reportChip });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .component('baldrisPdfViewer', {
            bindings: {
                pdfId: '<',
                onUpdate: '&',
            },
            templateUrl:
                'app/main/report/components/baldris-pdf-viewer/baldris-pdf-viewer.tmpl.html',
            controller: 'BaldrisPdfViewerController as vm',
        })
        .controller('BaldrisPdfViewerController', BaldrisPdfViewerController);

    /* @ngInject */
    function BaldrisPdfViewerController($http, baldrisApiBase) {
        var vm = this;

        vm.isLoading = true;
        vm.pdf = null;

        vm.$onInit = function () {};

        vm.$onChanges = function (changes) {
            if (
                changes.pdfId &&
                changes.pdfId.currentValue &&
                changes.pdfId.previousValue !== changes.pdfId.currentValue
            ) {
                loadPdf(changes.pdfId.currentValue);
            }
        };

        function loadPdf(pdfId) {
            vm.isLoading = true;
            $http
                .get(
                    baldrisApiBase + '/api/BaldrisFiles/' + pdfId + '/Download',
                    {
                        responseType: 'blob',
                    }
                )
                .then(function (pdfResponse) {
                    vm.pdf = URL.createObjectURL(pdfResponse.data);
                    vm.isLoading = false;
                    vm.onUpdate({ value: pdfId });
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('telephoneService', telephoneService);

    /* @ngInject */
    function telephoneService(dataService) {
        var service = {
            bulkUpdateTelephones: bulkUpdateTelephones,
            getEmptyTelephone: getEmptyTelephone,
        };

        return service;

        function getEmptyTelephone() {
            return {
                telephoneNumber: null,
                telephoneTypeId: null,
                countryIso2: null,
            };
        }

        function bulkUpdateTelephones(telephoneList) {
            var promises = [];
            telephoneList.forEach(function (telephone) {
                if (
                    telephone.hasOwnProperty('changeState') &&
                    telephone.changeState !== 0
                ) {
                    switch (telephone.changeState) {
                        case 1:
                            promises.push(
                                dataService.insertItem('Telephones', telephone)
                            );
                            break;
                        case 2:
                            promises.push(
                                dataService.updateItem('Telephones', telephone)
                            );
                            break;
                        case 3:
                            promises.push(
                                dataService.deleteItem('Telephones', telephone)
                            );
                            break;
                        default:
                            break;
                    }
                }
            });
            return promises;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('supplierService', supplierService);

    /* @ngInject */
    function supplierService() {

        var service = {
            getEmptySupplier: getEmptySupplier
        };

        return service;

        function getEmptySupplier() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.SupplierDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                supplierNumber: null,
                description: null,
                remarks: null,
                isDeleted: false,
                partyId: '00000000-0000-0000-0000-000000000000',
                partyDisplayName: null,
                contactPersonId: null,
                contactPersonDisplayName: null,
                supplierTypeId: null,
                supplierTypeName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .service('editSupplierService', editSupplierService);

    /* @ngInject */
    function editSupplierService($q, baldrisApiBase, Upload, supplierService, partyService, dataService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadSupplier = loadSupplier;
        self.saveSupplier = saveSupplier;
        self.uploadProfileImage = uploadProfileImage;
        self.removeProfileImage = removeProfileImage;

        function loadSupplier(supplierId, supplierTypeId) {
            reset();
            if (!supplierId || supplierId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    supplier: supplierService.getEmptySupplier(),
                    partyUpdateModel: {
                        party: partyService.getEmptyOrganization(),
                        addresses: [],
                        emails: [],
                        telephones: []
                    }
                };
                self.updateModel.supplier.supplierTypeId = supplierTypeId;
                self.updateModel.supplier.changeState = 1;
                self.updateModel.partyUpdateModel.party.changeState = 1;
                return $q.when(self.updateModel);
            } else {
                return dataService.getUpdateModel('Suppliers', supplierId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    return self.updateModel;
                });
            }
        }

        function saveSupplier() {
            // ensure changeState is set to Modified on deceased and person
            if (!self.isNew) {
                self.updateModel.supplier.changeState = 2;
                self.updateModel.partyUpdateModel.party.changeState = 2;
            }

            return dataService.updateFromUpdateModel('Suppliers', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                self.isNew = false;
                return true;
            }).catch(function (message) {
                return $q.reject(message);
            });
        }

        function uploadProfileImage(file) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: {file: file}
            }).then(function (resp) {
                if (resp && resp.data && resp.data.length === 1) {
                    var baldrisFile = resp.data[0];
                    self.updateModel.partyUpdateModel.party.imageId  = baldrisFile.id;
                    self.updateModel.partyUpdateModel.party.imageFilepath = baldrisFile.filepath;
                    if (self.validation && self.validation.supplierForm) {
                        self.validation.supplierForm.$setDirty();
                    }
                }
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            });
        }

        function removeProfileImage() {
            self.updateModel.partyUpdateModel.party.imageId = null;
            self.updateModel.partyUpdateModel.party.imageFilepath = null;
            if (self.validation && self.validation.supplierForm) {
                self.validation.supplierForm.$setDirty();
            }
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            if (self.validation && self.validation.supplierForm && self.validation.supplierForm.$dirty) {
                self.validation.supplierForm.$setPristine();
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditSupplierController', EditSupplierController);

    /* @ngInject */
    function EditSupplierController($q, $scope, $window, $translate, $stateParams, editSupplierService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editSupplierService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editSupplierService.loadSupplier($stateParams.supplierId, $stateParams.supplierTypeId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            if (vm.data.validation && vm.data.validation.supplierForm && vm.data.validation.supplierForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.supplierForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editSupplierService.saveSupplier().then(function () {
                if (vm.data.validation && vm.data.validation.supplierForm && vm.data.validation.supplierForm.$dirty) {
                    vm.data.validation.supplierForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.supplierForm && vm.data.validation.supplierForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

    angular
        .module('app.referenceTypes')
        .controller('EditSupplierToolbarController', EditSupplierToolbarController);

    /* @ngInject */
    function EditSupplierToolbarController($window, $translate, $stateParams, editSupplierService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editSupplierService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.supplierForm && vm.data.validation.supplierForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.supplierForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editSupplierService.saveSupplier().then(function () {
                if (vm.data.validation && vm.data.validation.supplierForm && vm.data.validation.supplierForm.$dirty) {
                    vm.data.validation.supplierForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

    angular
        .module('app.referenceTypes')
        .controller('EditSupplierSidebarController', EditSupplierSidebarController);

    /* @ngInject */
    function EditSupplierSidebarController(editSupplierService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editSupplierService;
    }

} ());
(function () {
    'use strict';

    angular.module('app.referenceTypes').factory('partyService', partyService);

    /* @ngInject */
    function partyService($mdDialog, $document, $q, $http, exception, baldrisApiBase) {
        var service = {
            getConsentFormPreviewUrl: getConsentFormPreviewUrl,
            getEmptyOrganization: getEmptyOrganization,
            getEmptyOrganizationShort: getEmptyOrganizationShort,
            getEmptyOrganizationOrPerson: getEmptyOrganizationOrPerson,
            getEmptyPerson: getEmptyPerson,
            getEmptyPersonShort: getEmptyPersonShort,
            getPartiesByWorkOrderId: getPartiesByWorkOrderId,
            showSearchDialog: showSearchDialog,
            showAddPartyDialog: showAddPartyDialog,
            convertToPartyShortDto: convertToPartyShortDto,
            getEmptyPartyPartyType: getEmptyPartyPartyType,
            generateConsentPdf: generateConsentPdf,
            retractConsent: retractConsent,
            pseudomizeParty: pseudomizeParty,
            searchParties: searchParties,
        };

        return service;

        function getPartiesByWorkOrderId(workOrderId, includeParticipants) {
            return $http
                .get(baldrisApiBase + '/api/Parties/ByWorkOrderId/' + workOrderId, { params: { includeParticipants: includeParticipants } })
                .then(getPartiesByWorkOrderIdComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getPartiesByWorkOrderId')(message);
                });

            function getPartiesByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function searchParties(query, pageIndex, pageSize) {
            return $http
                .get(baldrisApiBase + '/api/Parties/Search', { params: { searchString: query, pageIndex: pageIndex || 0, pageSize: pageSize || 50 } })
                .then(searchPartiesComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for searchParties')(message);
                });

            function searchPartiesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function generateConsentPdf(partyId, workOrderId) {
            var url = baldrisApiBase + '/api/Parties/' + partyId + '/GenerateConsentPdf';
            if (workOrderId) {
                url += '?workOrderId=' + workOrderId;
            }
            return $http
                .put(url)
                .then(generateConsentPdfComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for generateConsentPdf at "Parties"')(message);
                    return $q.reject(message);
                });

            function generateConsentPdfComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function retractConsent(partyId) {
            return $http
                .put(baldrisApiBase + '/api/Parties/' + partyId + '/RetractConsent')
                .then(retractConsentComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for retractConsent at "Parties"')(message);
                    return $q.reject(message);
                });

            function retractConsentComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getConsentFormPreviewUrl(partyId, workOrderId, includeLetterOfAttorney) {
            if (!partyId && !workOrderId) return null;
            return (
                baldrisApiBase +
                '/api/Parties/PreviewConsentForm/' +
                partyId +
                '/' +
                workOrderId +
                (includeLetterOfAttorney ? '?includeLetterOfAttorney=true' : '')
            );
        }

        function pseudomizeParty(partyDto) {
            return $http
                .put(baldrisApiBase + '/api/Persons/Pseudomize/' + partyDto.id, partyDto)
                .then(pseudomizePartyComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for pseudomizeParty at "Parties"')(message);
                    return $q.reject(message);
                });

            function pseudomizePartyComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function showSearchDialog(e, apiController, workOrderId, asDto, allowAdditions) {
            return $mdDialog.show({
                controller: 'SearchPartyDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/party/dialogs/search-party-dialog/search-party-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    apiController: apiController || 'Parties',
                    workOrderId: workOrderId || null,
                    allowAdditions: allowAdditions || false,
                    asDto: asDto || false,
                },
                clickOutsideToClose: true,
            });
        }

        function showAddPartyDialog(e, apiController) {
            return $mdDialog.show({
                controller: 'NewPartyDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/party/dialogs/new-party-dialog/new-party-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    apiController: apiController || 'Parties',
                },
                clickOutsideToClose: true,
            });
        }

        function getEmptyPerson() {
            return {
                displayName: null,
                isDeleted: false,
                remarks: null,
                privacyOptions: 'none',
                privacyRemarks: null,
                lastName: null,
                firstName: null,
                dateOfBirth: null,
                dateOfDeath: null,
                dateOfBirthApproximate: null,
                dateOfDeathApproximate: null,
                sex: null,
                socialSecurityNumber: null,
            };
        }

        function getEmptyPersonShort() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.Shorts.PersonShortDto, Baldris.Core.Data.Entities',
                sex: null,
                displayName: null,
                dateOfBirth: null,
                dateOfDeath: null,
                socialSecurityNumber: null,
                id: '00000000-0000-0000-0000-000000000000',
                isDeleted: false,
                imageId: null,
                imageFilepath: null,
                partyTypes: null,
            };
        }

        function getEmptyOrganization() {
            return {
                isDeleted: false,
                remarks: null,
                privacyOptions: 'none',
                imageId: null,
                updateOrInsertPrimaryAddressCommand: null,
                updateOrInsertPrimaryTelephoneCommand: null,
                updateOrInsertPrimaryEmailCommand: null,
                partyTypes: [],
                name: null,
                shortName: null,
                organizationNumber: null,
                isLegalUnit: false,
                homePage: null,
                bankConnection: null,
                bankAccount: null,
                postAccount: null,
                swift: null,
                iban: null,
                isVatRegistered: false,
                preferShortName: false,
                parentOrganizationId: null,
            };
        }

        function getEmptyOrganizationOrPerson() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.OrganizationOrPersonDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                displayName: null,
                isDeleted: false,
                remarks: null,
                privacyOptions: 0,
                privacyRemarks: null,
                pseudomizedTime: null,
                pseudomizedById: null,
                pseudomizedByDisplayName: null,
                signedConsentFileId: null,
                signedConsentFileFilepath: null,
                signatureId: null,
                signatureFilepath: null,
                signatureTime: null,
                signaturePlace: null,
                canReuseSignature: false,
                imageId: null,
                imageFilepath: null,
                lastName: null,
                firstName: null,
                dateOfBirth: null,
                dateOfDeath: null,
                dateOfBirthApproximate: null,
                dateOfDeathApproximate: null,
                sex: null,
                socialSecurityNumber: null,
                imagePath: null,
                name: null,
                shortName: null,
                organizationNumber: null,
                isLegalUnit: false,
                homePage: null,
                bankConnection: null,
                bankAccount: null,
                postAccount: null,
                swift: null,
                iban: null,
                isVatRegistered: false,
                preferShortName: false,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getEmptyOrganizationShort() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.Shorts.OrganizationShortDto, Baldris.Core.Data.Entities',
                displayName: null,
                organizationNumber: null,
                parentPartyDisplayName: null,
                id: '00000000-0000-0000-0000-000000000000',
                isDeleted: false,
                imageId: null,
                imageFilepath: null,
                partyTypes: null,
            };
        }

        function getEmptyPartyPartyType() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.PartyPartyTypeDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                partyId: '00000000-0000-0000-0000-000000000000',
                partyDisplayName: null,
                partyTypeId: '00000000-0000-0000-0000-000000000000',
                partyTypeName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function convertToPartyShortDto(partyDto) {
            if (!partyDto) return null;
            if (
                partyDto.$type === 'Baldris.Core.Data.Entities.Dto.PersonDto, Baldris.Core.Data.Entities' ||
                partyDto.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.PersonShortDto, Baldris.Core.Data.Entities'
            )
                return convertToPersonShortDto(partyDto);
            if (
                partyDto.$type === 'Baldris.Core.Data.Entities.Dto.OrganizationDto, Baldris.Core.Data.Entities' ||
                partyDto.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.OrganizationShortDto, Baldris.Core.Data.Entities'
            )
                return convertToOrganizationShortDto(partyDto);
            return null;
        }

        function convertToPersonShortDto(personDto) {
            if (!personDto) return null;
            if (personDto.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.PersonShortDto, Baldris.Core.Data.Entities') return personDto;
            var shortDto = getEmptyPersonShort();
            shortDto.id = personDto.id;
            shortDto.displayName = personDto.displayName;
            shortDto.isDeleted = personDto.isDeleted;
            // partyTypes
            if (personDto.partyTypes && personDto.partyTypes.length > 0) {
                shortDto.partyTypes = personDto.partyTypes.reduce(function (a, b) {
                    if (a) {
                        a += ' // ' + (b.partyType ? b.partyType.name : '');
                        return a;
                    }
                    a = b.partyType ? b.partyType.name : '';
                    return a;
                }, '');
            }
            shortDto.sex = personDto.sex;
            shortDto.dateOfBirth = personDto.dateOfBirth;
            shortDto.dateOfDeath = personDto.dateOfDeath;
            shortDto.socialSecurityNumber = personDto.socialSecurityNumber;
            shortDto.imageId = personDto.imageId;
            shortDto.imageFilepath = personDto.image ? personDto.image.filepath : null;

            return shortDto;
        }

        function convertToOrganizationShortDto(organizationDto) {
            if (!organizationDto) return null;
            if (organizationDto.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.OrganizationShortDto, Baldris.Core.Data.Entities') return organizationDto;
            var shortDto = getEmptyOrganizationShort();
            shortDto.id = organizationDto.id;
            shortDto.displayName = organizationDto.displayName;
            shortDto.isDeleted = organizationDto.isDeleted;
            // partyTypes
            if (organizationDto.partyTypes && organizationDto.partyTypes.length > 0) {
                shortDto.partyTypes = organizationDto.partyTypes.reduce(function (a, b) {
                    if (a) {
                        a += ' // ' + (b.partyType ? b.partyType.name : '');
                        return a;
                    }
                    a = b.partyType ? b.partyType.name : '';
                    return a;
                }, '');
            }
            shortDto.imageId = organizationDto.imageId;
            shortDto.imageFilepath = organizationDto.image ? organizationDto.image.filepath : null;
            shortDto.organizationNumber = organizationDto.organizationNumber;
            shortDto.parentPartyDisplayName = organizationDto.parentParty ? organizationDto.parentParty.displayName : null;

            return shortDto;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .service('editPartyService', editPartyService);

    /* @ngInject */
    function editPartyService($q, Upload, baldrisApiBase, partyService, dataService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadParty = loadParty;
        self.saveParty = saveParty;
        self.setPartyType = setPartyType;
        self.uploadProfileImage = uploadProfileImage;
        self.removeProfileImage = removeProfileImage;

        function setPartyType(partyType) {
            if (partyType === 'PERSON') {
                self.updateModel.party = partyService.getEmptyPerson();
            } else {
                self.updateModel.party = partyService.getEmptyOrganization();
            }
            self.updateModel.party.changeState = 1;
        }

        function loadParty(partyId, partyTypeId) {
            reset();
            if (!partyId || partyId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    party: null,
                    addresses: [],
                    emails: [],
                    telephones: [],
                    partyTypes: []
                };

                if (partyTypeId) {
                    return dataService.getById('PartyTypes', partyTypeId).then(function (partyType) {
                        var partyPartyType = partyService.getEmptyPartyPartyType();
                        partyPartyType.changeState = 1;
                        partyPartyType.partyTypeId = partyTypeId;
                        partyPartyType.partyTypeName = partyType.name;
                        self.updateModel.partyTypes.push(partyPartyType);
                        return self.updateModel;
                    });
                } else {
                    return $q.when(self.updateModel);
                }
            } else {
                return dataService.getUpdateModel('Parties', partyId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    return self.updateModel;
                });
            }
        }

        function saveParty() {
            // ensure changeState is set to Modified on deceased and person
            if (!self.isNew) {
                self.updateModel.party.changeState = 2;
            }

            return dataService.updateFromUpdateModel('Parties', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                self.isNew = false;
                return true;
            }).catch(function (message) {
                return $q.reject(message);
            });
        }

        function uploadProfileImage(file) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: {file: file}
            }).then(function (resp) {
                if (resp && resp.data && resp.data.length === 1) {
                    var baldrisFile = resp.data[0];
                    self.updateModel.party.imageId  = baldrisFile.id;
                    self.updateModel.party.imageFilepath = baldrisFile.filepath;
                    if (self.validation && self.validation.partyForm) {
                        self.validation.partyForm.$setDirty();
                    }
                }
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            });
        }

        function removeProfileImage() {
            self.updateModel.party.imageId = null;
            self.updateModel.party.imageFilepath = null;
            if (self.validation && self.validation.partyForm) {
                self.validation.partyForm.$setDirty();
            }
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            if (self.validation && self.validation.partyForm && self.validation.partyForm.$dirty) {
                self.validation.partyForm.$setPristine();
            }
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditPartyController', EditPartyController);

    /* @ngInject */
    function EditPartyController($q, $scope, $window, $translate, $stateParams, editPartyService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editPartyService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editPartyService.loadParty($stateParams.partyId, $stateParams.partyTypeId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            if (vm.data.validation && vm.data.validation.partyForm && vm.data.validation.partyForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.partyForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editPartyService.saveParty().then(function () {
                if (vm.data.validation && vm.data.validation.partyForm && vm.data.validation.partyForm.$dirty) {
                    vm.data.validation.partyForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.partyForm && vm.data.validation.partyForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

    angular
        .module('app.referenceTypes')
        .controller('EditPartyToolbarController', EditPartyToolbarController);

    /* @ngInject */
    function EditPartyToolbarController($window, $translate, $stateParams, editPartyService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editPartyService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.partyForm && vm.data.validation.partyForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.partyForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editPartyService.saveParty().then(function () {
                if (vm.data.validation && vm.data.validation.partyForm && vm.data.validation.partyForm.$dirty) {
                    vm.data.validation.partyForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

    angular
        .module('app.referenceTypes')
        .controller('EditPartySidebarController', EditPartySidebarController);

    /* @ngInject */
    function EditPartySidebarController(editPartyService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editPartyService;
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('participantRoleService', participantRoleService);

    /* @ngInject */
    function participantRoleService() {

        var service = {
            getEmptyParticipantRole: getEmptyParticipantRole,
            getEmptyParticipantRoleShort: getEmptyParticipantRoleShort
        };

        return service;

        function getEmptyParticipantRole() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.ParticipantRoleDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                description: null,
                text: null,
                textAlternative: null,
                englishText: null,
                sortOrder: 0,
                isDeleted: false,
                iconName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }

        function getEmptyParticipantRoleShort() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.Shorts.ParticipantRoleShortDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                text: null,
                sortOrder: 0,
                isDeleted: false,
                iconName: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('participantService', participantService);

    /* @ngInject */
    function participantService($mdDialog, $document) {

        var service = {
            showSearchDialog: showSearchDialog,
            showEditParticipantDialog: showEditParticipantDialog,
            getEmptyParticipant: getEmptyParticipant,
            getEmptyParticipantTypeParticipant: getEmptyParticipantTypeParticipant
        };

        return service;

        function showSearchDialog(e, asDto, allowAdditions) {
            return $mdDialog.show({
                controller: 'SearchParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/participant/dialogs/search-participant-dialog/search-participant-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    allowAdditions: allowAdditions || false,
                    asDto: asDto || false
                },
                clickOutsideToClose: true
            });
        }

        function showEditParticipantDialog(e, participantId, asDto, participantTypeIds) {
            return $mdDialog.show({
                controller: 'EditParticipantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/participant/dialogs/edit-participant-dialog/edit-participant-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    participantId: participantId,
                    participantTypeIds: participantTypeIds,
                    asDto : asDto
                },
                clickOutsideToClose: true
            });
        }

        function getEmptyParticipant() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.ParticipantDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                title: null,
                prop: null,
                imagePath: null,
                remarks: null,
                info: null,
                sortOrder: 0,
                isDeleted: false,
                attachedProductsOverridesTypeProducts: false,
                partyId: '00000000-0000-0000-0000-000000000000',
                partyDisplayName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }

        function getEmptyParticipantTypeParticipant() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.ParticipantTypeParticipantDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                sortOrder: 0,
                participantTypeId: '00000000-0000-0000-0000-000000000000',
                participantTypeName: null,
                participantId: '00000000-0000-0000-0000-000000000000',
                participantPartyDisplayName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .service('editParticipantService', editParticipantService);

    /* @ngInject */
    function editParticipantService($q, participantService, baldrisApiBase, Upload, partyService, dataService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadParticipant = loadParticipant;
        self.saveParticipant = saveParticipant;
        self.uploadProfileImage = uploadProfileImage;
        self.removeProfileImage = removeProfileImage;
        self.isPerson = isPerson;

        function loadParticipant(participantId, participantTypeId) {
            reset();
            if (!participantId || participantId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    participant: participantService.getEmptyParticipant(),
                    partyUpdateModel: {
                        party: partyService.getEmptyPerson(),
                        addresses: [],
                        emails: [],
                        telephones: []
                    },
                    participantTypeParticipants: []
                };

                self.updateModel.participant.changeState = 1;
                self.updateModel.partyUpdateModel.party.changeState = 1;
                if (participantTypeId) {
                    return dataService.getById('ParticipantTypes', participantTypeId).then(function (participantType) {
                        var participantTypeParticipant = participantService.getEmptyParticipantTypeParticipant();
                        participantTypeParticipant.changeState = 1;
                        participantTypeParticipant.participantTypeId = participantTypeId;
                        participantTypeParticipant.participantTypeName = participantType.name;
                        self.updateModel.participantTypeParticipants.push(participantTypeParticipant);
                        return self.updateModel;
                    });
                } else {
                    return $q.when(self.updateModel);
                }
            } else {
                return dataService.getUpdateModel('Participants', participantId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    return self.updateModel;
                });
            }
        }

        function saveParticipant() {
            // ensure changeState is set to Modified on deceased and person
            if (!self.isNew) {
                self.updateModel.participant.changeState = 2;
                self.updateModel.partyUpdateModel.party.changeState = 2;
            }

            return dataService.updateFromUpdateModel('Participants', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                self.isNew = false;
                return true;
            }).catch(function (message) {
                return $q.reject(message);
            });
        }

        function uploadProfileImage(file) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: {file: file}
            }).then(function (resp) {
                if (resp && resp.data && resp.data.length === 1) {
                    var baldrisFile = resp.data[0];
                    self.updateModel.partyUpdateModel.party.imageId  = baldrisFile.id;
                    self.updateModel.partyUpdateModel.party.imageFilepath = baldrisFile.filepath;
                    if (self.validation && self.validation.participantForm) {
                        self.validation.participantForm.$setDirty();
                    }
                }
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            });
        }

        function removeProfileImage() {
            self.updateModel.partyUpdateModel.party.imageId = null;
            self.updateModel.partyUpdateModel.party.imageFilepath = null;
            if (self.validation && self.validation.participantForm) {
                self.validation.participantForm.$setDirty();
            }
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            if (self.validation && self.validation.participantForm && self.validation.participantForm.$dirty) {
                self.validation.participantForm.$setPristine();
            }
        }

        function isPerson() {
            if (!self.updateModel || !self.updateModel.partyUpdateModel || !self.updateModel.partyUpdateModel.party) return false;
            return self.updateModel.partyUpdateModel.party.$type.indexOf('Person') > -1;
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditParticipantController', EditParticipantController);

    /* @ngInject */
    function EditParticipantController($q, $scope, $window, $translate, $stateParams, editParticipantService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editParticipantService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editParticipantService.loadParticipant($stateParams.participantId, $stateParams.participantTypeId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            if (vm.data.validation && vm.data.validation.participantForm && vm.data.validation.participantForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.participantForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editParticipantService.saveParticipant().then(function () {
                if (vm.data.validation && vm.data.validation.participantForm && vm.data.validation.participantForm.$dirty) {
                    vm.data.validation.participantForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.participantForm && vm.data.validation.participantForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

    angular
        .module('app.referenceTypes')
        .controller('EditParticipantToolbarController', EditParticipantToolbarController);

    /* @ngInject */
    function EditParticipantToolbarController($window, $translate, $stateParams, editParticipantService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editParticipantService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.participantForm && vm.data.validation.participantForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.participantForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editParticipantService.saveParticipant().then(function () {
                if (vm.data.validation && vm.data.validation.participantForm && vm.data.validation.participantForm.$dirty) {
                    vm.data.validation.participantForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

    angular
        .module('app.referenceTypes')
        .controller('EditParticipantSidebarController', EditParticipantSidebarController);

    /* @ngInject */
    function EditParticipantSidebarController(editParticipantService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editParticipantService;
    }

} ());
(function () {
    'use strict';

    angular.module('app.referenceTypes').factory('locationService', locationService);

    /* @ngInject */
    function locationService(dataService) {
        var service = {
            createUpdateCommandFromViewModel: createUpdateCommandFromViewModel,
            getEmptyLocation: getEmptyLocation,
            getEmptyLocationRelationship: getEmptyLocationRelationship,
            getEmptyLocationReservation: getEmptyLocationReservation,
            getEmptyLocationTransport: getEmptyLocationTransport,
            getEmptyLocationEquipment: getEmptyLocationEquipment,
            getRelatedLocations: getRelatedLocations,
        };

        return service;

        function getRelatedLocations(locationId) {
            return dataService.getByUri('LocationRelationships', 'ByParentLocationId/' + locationId);
        }

        function getEmptyLocation() {
            return {
                name: null,
                description: null,
                remarks: null,
                isDeleted: false,
                suggestedMeetUpOffset: 0,
                info: null,
                imageId: null,
                addressId: null,
                contactPersonId: null,
                ownerId: null,
                municipalityId: null,
                bookingSupplierId: null,
                locationTypeIds: [],
            };
        }

        function getEmptyLocationReservation() {
            return {
                description: null,
                locationId: null,
                start: null,
                end: null,
                remarks: null,
                reservationPlaced: '0001-01-01T00:00:00+01:00',
                reservationPlacedById: null,
            };
        }

        function getEmptyLocationRelationship() {
            return {
                relationship: 'none',
                remarks: null,
                shouldRequireAdditionalTransport: false,
                parentLocationId: null,
                relatedLocationId: null,
            };
        }

        function getEmptyLocationTransport() {
            return {
                description: null,
                remarks: null,
                invoiceText: null,
                distance: null,
                driverHours: null,
                additionalHours: null,
                additionalCost: null,
                overriddenPrice: null,
                billTo: 'unknown',
                options: 'none',
                departmentId: null,
                calendarEventTypeId: null,
                suggestedTransportTypeId: null,
                suggestedTransportTypeOptions: 'none',
                departureLocationId: null,
                departureLocationRemarks: null,
                destinationLocationId: null,
                destinationLocationRemarks: null,
            };
        }

        function getEmptyLocationEquipment() {
            return {
                remarks: null,
                sortOrder: 0,
                discriminator: null,
                amount: 0,
                departmentId: null,
                equipmentId: '00000000-0000-0000-0000-000000000000',
                locationId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function createUpdateCommandFromViewModel(locationTransportViewModel) {
            return {
                id: locationTransportViewModel.id,
                description: locationTransportViewModel.description,
                remarks: locationTransportViewModel.remarks,
                invoiceText: locationTransportViewModel.invoiceText,
                distance: locationTransportViewModel.distance,
                driverHours: locationTransportViewModel.driverHours,
                additionalHours: locationTransportViewModel.additionalHours,
                additionalCost: locationTransportViewModel.additionalCost,
                overriddenPrice: locationTransportViewModel.overriddenPrice,
                billTo: locationTransportViewModel.billTo,
                options: locationTransportViewModel.options,
                departmentId: locationTransportViewModel.departmentId,
                calendarEventTypeId: locationTransportViewModel.calendarEventTypeId,
                suggestedTransportTypeId: locationTransportViewModel.suggestedTransportTypeId,
                suggestedTransportTypeOptions: locationTransportViewModel.suggestedTransportTypeOptions,
                departureLocationId: locationTransportViewModel.departureLocationId,
                departureLocationRemarks: locationTransportViewModel.departureLocationRemarks,
                destinationLocationId: locationTransportViewModel.destinationLocationId,
                destinationLocationRemarks: locationTransportViewModel.destinationLocationRemarks,
            };
        }
    }
})();

(function () {
  "use strict";

  angular.module("app.referenceTypes").service("editLocationService", editLocationService);

  /* @ngInject */
  function editLocationService($q, $mdDialog, $document, dataService, locationService, addressService, Upload, baldrisApiBase) {
    var self = this;

    self.updateModel = null;
    self.isNew = false;
    self.addressCoordinates = null;
    self.uploadFiles = null;

    self.loadLocation = loadLocation;
    self.saveLocation = saveLocation;
    self.showEditAddressDialog = showEditAddressDialog;
    self.showEditRequiredEquipmentDialog = showEditRequiredEquipmentDialog;
    self.uploadImage = uploadImage;
    self.removeImage = removeImage;
    self.onDeleteLocationRelationship = onDeleteLocationRelationship;
    self.onAddLocationRelationship = onAddLocationRelationship;

    function loadLocation(locationId, locationTypeId) {
      reset();
      if (!locationId || locationId.toLowerCase() === "new") {
        self.isNew = true;
        self.updateModel = {
          location: locationService.getEmptyLocation(),
          address: null,
          locationTypes: [],
          attachedProducts: [],
          autoTasks: [],
          requiredEquipment: [],
          suggestedTransports: [],
          emails: [],
          telephones: [],
          relatedLocations: [],
        };

        // Set ChangeStates
        self.updateModel.location.changeState = 1;

        if (locationTypeId) {
          return dataService.getById("LocationTypes", locationTypeId, true).then(function (locationType) {
            if (locationType) {
              var locationLocationType = locationService.getEmptyLocationLocationType();
              locationLocationType.changeState = 1;
              locationLocationType.locationType = locationType;
              locationLocationType.locationTypeName = locationType.name;
              locationLocationType.locationTypeId = locationType.id;
              self.updateModel.locationTypes.push(locationLocationType);
            }
            return true;
          });
        }
        return $q.when(true);
      } else {
        return dataService.getUpdateModel("Locations", locationId).then(function (updateModel) {
          self.updateModel = updateModel;
          if (self.updateModel.address && (self.updateModel.address.latitude || self.updateModel.address.latitude)) {
            self.addressCoordinates = {
              zoom: 15,
              center: {
                latitude: self.updateModel.address.latitude,
                longitude: self.updateModel.address.longitude,
              },
              marker: {
                id: self.updateModel.address.id,
                coords: {
                  latitude: self.updateModel.address.latitude,
                  longitude: self.updateModel.address.longitude,
                },
                options: { draggable: true },
                events: {
                  dragend: function (marker, eventName, args) {
                    var lat = marker.getPosition().lat();
                    var lon = marker.getPosition().lng();
                    self.updateModel.address.latitude = lat;
                    self.updateModel.address.longitude = lon;
                    if (self.updateModel.address.changeState != 1) {
                      self.updateModel.address.changeState = 2;
                    }
                    self.addressCoordinates.marker.options = {
                      draggable: true,
                      labelContent:
                        "lat: " +
                        self.addressCoordinates.marker.coords.latitude +
                        " " +
                        "lon: " +
                        self.addressCoordinates.marker.coords.longitude,
                      labelAnchor: "100 0",
                      labelClass: "marker-labels",
                    };
                  },
                },
              },
            };
          }
          return locationService.getRelatedLocations(self.updateModel.location.id).then(function (relatedLocations) {
            self.updateModel.relatedLocations = relatedLocations;
          });
        });
      }
    }

    function saveLocation() {
      // Set changestate on location to ensure saving
      if (self.updateModel.location.changeState !== 1) {
        self.updateModel.location.changeState = 2;
      }

      return dataService.updateFromUpdateModel("Locations", self.updateModel).then(function (savedUpdateModel) {
        var promises = [];
        // Delete location relationships
        if (self.updateModel.locationRelationshipDeleteQueue && self.updateModel.locationRelationshipDeleteQueue.length > 0) {
          _.forEach(self.updateModel.locationRelationshipDeleteQueue, function (n) {
            promises.push(dataService.deleteItem("LocationRelationships", n));
          });
        }
        // Create location relationships
        if (self.updateModel.locationRelationshipCreateQueue && self.updateModel.locationRelationshipCreateQueue.length > 0) {
          var promises = [];
          _.forEach(self.updateModel.locationRelationshipCreateQueue, function (n) {
            promises.push(dataService.insertItem("LocationRelationships", n));
          });
        }
        if (promises.length > 0) {
          return $q.all(promises).then(function () {
            self.updateModel = savedUpdateModel;
            self.isNew = false;
            return true;
          });
        }
        self.updateModel = savedUpdateModel;
        self.isNew = false;
        return true;
      });
    }

    function showEditAddressDialog(address, e) {
      var addressCopy;
      if (!address) {
        addressCopy = addressService.getEmptyAddress();
        addressCopy.changeState = 1;
      } else {
        addressCopy = angular.copy(address);
      }

      addressService.showEditDialog(e, addressCopy).then(function (updatedAddress) {
        if (updatedAddress) {
          self.updateModel.address = updatedAddress;
        }
      });
    }

    function showEditRequiredEquipmentDialog(locationEquipment, e) {
      var requiredEquipment = null;
      if (locationEquipment) {
        requiredEquipment = angular.copy(locationEquipment);
      }

      var dialogOptions = {
        controller: "EditRequiredEquipmentDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/reference-types/location/dialogs/edit-required-equipment-dialog/edit-required-equipment-dialog.tmpl.html",
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        multiple: true,
        locals: {
          locationEquipment: requiredEquipment,
        },
      };

      $mdDialog.show(dialogOptions).then(function (updatedRequiredEquipment) {
        if (updatedRequiredEquipment) {
          if (updatedRequiredEquipment.changeState === 1) {
            // newly create -> add
            self.updateModel.requiredEquipment.push(updatedRequiredEquipment);
          } else {
            //find and replace the locationEquipment
            var index = self.updateModel.requiredEquipment.indexOf(locationEquipment);
            self.updateModel.requiredEquipment.splice(index, 1);
            self.updateModel.requiredEquipment.push(updatedRequiredEquipment);
          }
        }
      });
    }

    function uploadImage(file) {
      Upload.upload({
        url: baldrisApiBase + "/api/BaldrisFiles/Upload",
        data: { file: file },
      }).then(
        function (resp) {
          if (resp && resp.data && resp.data.length === 1) {
            var baldrisFile = resp.data[0];
            self.updateModel.location.imageId = baldrisFile.id;
            self.updateModel.location.imageFilepath = baldrisFile.filepath;
            if (self.validation && self.validation.participantForm) {
              self.validation.participantForm.$setDirty();
            }
          }
        },
        function (resp) {
          console.log("Error status: " + resp.status);
        }
      );
    }

    function removeImage() {
      self.updateModel.location.imageId = null;
      self.updateModel.location.imageFilepath = null;
      if (self.validation && self.validation.participantForm) {
        self.validation.participantForm.$setDirty();
      }
    }

    function onDeleteLocationRelationship(locationRelationship) {
      if (locationRelationship && locationRelationship.id && locationRelationship.id !== "00000000-0000-0000-0000-000000000000") {
        // add to delete queue
        if (!self.updateModel.locationRelationshipDeleteQueue) self.updateModel.locationRelationshipDeleteQueue = [];
        self.updateModel.locationRelationshipDeleteQueue.push(locationRelationship);
      }
    }

    function onAddLocationRelationship(locationRelationshipCommand) {
      if (locationRelationshipCommand) {
        // add to create queue
        if (!self.updateModel.locationRelationshipCreateQueue) self.updateModel.locationRelationshipCreateQueue = [];
        self.updateModel.locationRelationshipCreateQueue.push(locationRelationshipCommand);
      }
    }

    function reset() {
      self.updateModel = null;
      self.isNew = false;
      self.addressCoordinates = null;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditLocationController', EditLocationController);

    /* @ngInject */
    function EditLocationController($window, $stateParams, loadingService, editLocationService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editLocationService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editLocationService.loadLocation($stateParams.locationId, $stateParams.locationTypeId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editLocationService.saveLocation().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.referenceTypes')
        .controller('EditLocationSidebarController', EditLocationSidebarController);

    /* @ngInject */
    function EditLocationSidebarController($window, $stateParams, loadingService, editLocationService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editLocationService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editLocationService.saveLocation().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.referenceTypes')
        .controller('EditLocationToolbarController', EditLocationToolbarController);

    /* @ngInject */
    function EditLocationToolbarController($window, $stateParams, loadingService, editLocationService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editLocationService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editLocationService.saveLocation().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('fontStyleService', fontStyleService);

    /* @ngInject */
    function fontStyleService() {

        var service = {
            getEmptyFontStyle: getEmptyFontStyle
        };

        return service;

        function getEmptyFontStyle() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.FontStyleDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                font: null,
                style: null,
                size: 0,
                lineHeight: 0,
                color: null,
                description: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.referenceTypes').factory('emailService', emailService);

    /* @ngInject */
    function emailService(dataService) {
        var service = {
            bulkUpdateEmails: bulkUpdateEmails,
            getEmptyEmail: getEmptyEmail,
        };

        return service;

        function getEmptyEmail() {
            return {
                emailAddress: null,
                emailTypeId: null,
            };
        }

        function bulkUpdateEmails(emailList) {
            var promises = [];
            emailList.forEach(function (email) {
                if (
                    email.hasOwnProperty('changeState') &&
                    email.changeState !== 0
                ) {
                    switch (email.changeState) {
                        case 1:
                            promises.push(
                                dataService.insertItem('Emails', email)
                            );
                            break;
                        case 2:
                            promises.push(
                                dataService.updateItem('Emails', email)
                            );
                            break;
                        case 3:
                            promises.push(
                                dataService.deleteItem('Emails', email)
                            );
                            break;
                        default:
                            break;
                    }
                }
            });
            return promises;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('customerService', customerService);

    /* @ngInject */
    function customerService() {

        var service = {
            getEmptyCustomer: getEmptyCustomer
        };

        return service;

        function getEmptyCustomer() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.CustomerDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                isReturningCustomer: false,
                isSocialServicesRepresentative: false,
                customerNumber: null,
                partyId: '00000000-0000-0000-0000-000000000000',
                partyDisplayName: null,
                billingAddressId: null,
                billingAddressLocalizedAddress: null,
                customerTypeId: null,
                customerTypeName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .service('editCustomerService', editCustomerService);

    /* @ngInject */
    function editCustomerService($q, $mdDialog, $document, dataService, customerService, addressService, partyService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;
        self.addressCoordinates = null;
        self.uploadFiles = null;

        self.loadCustomer = loadCustomer;
        self.saveCustomer = saveCustomer;
        self.showEditAddressDialog = showEditAddressDialog;

        function loadCustomer(customerId) {
            reset();
            if (!customerId || customerId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    customer: customerService.getEmptyCustomer(),
                    partyUpdateModel: {
                        party: partyService.getEmptyPerson(),
                        addresses: [],
                        emails: [],
                        telephones: []
                    },
                    billingAddress: null,
                    targetDepartmentId: null
                };

                // Set ChangeStates
                self.updateModel.customer.changeState = 1;

                return $q.when(true);
            } else {
                return dataService.getUpdateModel('Customers', customerId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    if (self.updateModel.billingAddress && (self.updateModel.billingAddress.latitude || self.updateModel.billingAddress.latitude)) {
                        self.addressCoordinates = {
                            zoom: 15,
                            center: {
                                latitude: self.updateModel.billingAddress.latitude,
                                longitude: self.updateModel.billingAddress.longitude
                            },
                            marker : {
                                id: self.updateModel.billingAddress.id,
                                coords: {
                                    latitude: self.updateModel.billingAddress.latitude,
                                    longitude: self.updateModel.billingAddress.longitude
                                },
                                options: { draggable: true },
                                events: {
                                    dragend: function (marker, eventName, args) {

                                        var lat = marker.getPosition().lat();
                                        var lon = marker.getPosition().lng();
                                        self.updateModel.billingAddress.latitude = lat;
                                        self.updateModel.billingAddress.longitude = lon;
                                        if (self.updateModel.billingAddress.changeState !== 1) {
                                            self.updateModel.billingAddress.changeState = 2;
                                        }
                                        self.addressCoordinates.marker.options = {
                                            draggable: true,
                                            labelContent: "lat: " + self.addressCoordinates.marker.coords.latitude + ' ' + 'lon: ' + self.addressCoordinates.marker.coords.longitude,
                                            labelAnchor: "100 0",
                                            labelClass: "marker-labels"
                                        };
                                    }
                                }
                            }
                        }
                    }
                    // if (self.updateModel.customer && self.updateModel.customer.billingAddressId && self.updateModel.partyUpdateModel
                    //     && self.updateModel.partyUpdateModel.addresses && self.updateModel.partyUpdateModel.addresses.length > 0) {
                    //     // Hide billing address from addresses list to prevent mis-information and double updating
                    //     for (var i = 0; i < self.updateModel.partyUpdateModel.addresses.length; i++) {
                    //         var partyAddress = self.updateModel.partyUpdateModel.addresses[i];
                    //         if (partyAddress.id === self.updateModel.customer.billingAddressId) {
                    //             self.updateModel.partyUpdateModel.addresses.splice(i, 1);
                    //             break;
                    //         }
                    //     }
                    // }
                    return true;
                });
            }
        }

        function saveCustomer() {
            // Set changestate on location to ensure saving
            if (self.updateModel.customer.changeState !== 1) {
                self.updateModel.customer.changeState = 2;
            }

            if (self.updateModel.partyUpdateModel.party.changeState !== 1) {
                self.updateModel.partyUpdateModel.party.changeState = 2;
            }

            return dataService.updateFromUpdateModel("Customers", self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                self.isNew = false;
                return true;
            });
        }

        function showEditAddressDialog(address, e) {
            var addressCopy;
            if (!address) {
                addressCopy = addressService.getEmptyAddress();
                addressCopy.changeState = 1;
            } else {
                addressCopy = angular.copy(address);
            }

            addressService.showEditDialog(e, addressCopy).then(function (updatedAddress) {
                if (updatedAddress) {
                    self.updateModel.billingAddress = updatedAddress;
                }
            });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.addressCoordinates = null;
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .controller('EditCustomerController', EditCustomerController);

    /* @ngInject */
    function EditCustomerController($window, $stateParams, loadingService, editCustomerService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editCustomerService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editCustomerService.loadCustomer($stateParams.customerId).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editCustomerService.saveCustomer().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.referenceTypes')
        .controller('EditCustomerSidebarController', EditCustomerSidebarController);

    /* @ngInject */
    function EditCustomerSidebarController($window, $stateParams, loadingService, editCustomerService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editCustomerService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editCustomerService.saveCustomer().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.referenceTypes')
        .controller('EditCustomerToolbarController', EditCustomerToolbarController);

    /* @ngInject */
    function EditCustomerToolbarController($window, $stateParams, loadingService, editCustomerService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editCustomerService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editCustomerService.saveCustomer().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
/**
 * Created by JSH on 30.11.2016.
 */
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('countryService', countryService);

    /* @ngInject */
    function countryService($http, baldrisApiBase, exception) {

        var service = {
            getByIsoCode: getByIsoCode
        };

        return service;

        function getByIsoCode(isoCode2, asShort) {

            asShort = asShort || false;

            return $http.get(baldrisApiBase + '/api/Countries/ByIsoCode/' + isoCode2, {
                params: {
                    asShort: asShort
                }
            })
                .then(getByIsoCodeComplete)
                .catch(function(message) {
                    exception.catcher('XHR Failed for getByIsoCode at "Countries"')(message);
                });

            function getByIsoCodeComplete(data, status, headers, config) {
                return data.data;
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.referenceTypes').factory('autoTaskService', autoTaskService);

    /* @ngInject */
    function autoTaskService($mdDialog, $document) {
        var service = {
            getEmptyAutoTask: getEmptyAutoTask,
            getEmptyAttachedAutoTask: getEmptyAttachedAutoTask,
            showEditDialog: showEditDialog,
        };

        return service;

        function getEmptyAutoTask() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.AutoTaskDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                subject: null,
                text: null,
                options: 0,
                dueTimeOffset: null,
                dueTimeModifier: null,
                sortOrder: 0,
                noteOrTaskTypeId: null,
                noteOrTaskTypeName: null,
                initialQueueId: null,
                initialQueueName: null,
                supplierId: null,
                supplierPartyDisplayName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getEmptyAttachedAutoTask(attachedTypeName) {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.AttachedAutoTaskDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                validThrough: null,
                discriminator: null,
                departmentId: null,
                departmentName: null,
                attachedTypeId: null,
                attachedTypeName: attachedTypeName,
                autoTaskId: '00000000-0000-0000-0000-000000000000',
                autoTaskSubject: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function showEditDialog(e, attachedAutoTask) {
            return $mdDialog.show({
                controller: 'EditAttachedAutoTaskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/auto-task/dialogs/edit-attached-auto-task-dialog/edit-attached-auto-task-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    attachedAutoTask: attachedAutoTask,
                },
                clickOutsideToClose: true,
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.referenceTypes').factory('autoProductService', autoProductService);

    /* @ngInject */
    function autoProductService($mdDialog, $document) {
        var service = {
            getEmptyAutoProduct: getEmptyAutoProduct,
            showEditDialog: showEditDialog,
        };

        return service;

        function getEmptyAutoProduct(attachedTypeName) {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.AttachedProductDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                amount: null,
                triggerAmount: null,
                amountFollowsParentAmount: false,
                billTo: 0,
                validThrough: null,
                discriminator: null,
                defaultIfEmpty: false,
                departmentId: null,
                departmentName: null,
                attachedTypeId: null,
                attachedTypeName: attachedTypeName,
                productId: '00000000-0000-0000-0000-000000000000',
                productName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function showEditDialog(e, autoProduct) {
            return $mdDialog.show({
                controller: 'EditAutoProductDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reference-types/auto-product/dialogs/edit-auto-product-dialog/edit-auto-product-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    autoProduct: autoProduct,
                },
                clickOutsideToClose: true,
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .factory('addressService', addressService);

    /* @ngInject */
    function addressService(
        $mdDialog,
        $document,
        $http,
        exception,
        dataService
    ) {
        var service = {
            bulkUpdateAddresses: bulkUpdateAddresses,
            getEmptyAddress: getEmptyAddress,
            getFormattedAddress: getFormattedAddress,
            getPostalCode: getPostalCode,
            showEditDialog: showEditDialog,
        };

        return service;

        function getPostalCode(postalCode, isoCode2) {
            return $http
                .get('//api.geonames.org/postalCodeLookupJSON', {
                    params: {
                        postalcode: postalCode,
                        country: isoCode2,
                        username: 'shsoft',
                    },
                })
                .then(insertItemComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getPostalCode')(message);
                });

            function insertItemComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyAddress() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.AddressDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                streetAddress1: null,
                streetAddress2: null,
                zipCode: null,
                city: null,
                stateCountrySerialized: null,
                localizedAddress: null,
                isAbroadAddress: false,
                isDefault: false,
                sortOrder: 0,
                latitude: null,
                longitude: null,
                remarks: null,
                isDeleted: false,
                addressTypeId: null,
                addressType: null,
                countryId: null,
                country: null,
                stateId: null,
                state: null,
                partyId: null,
                party: null,
                baldrisUserId: null,
                baldrisUser: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function showEditDialog(e, address) {
            return $mdDialog.show({
                controller: 'EditAddressDialogController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/reference-types/address/dialogs/edit-address-dialog/edit-address-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    address: address,
                },
                clickOutsideToClose: true,
            });
        }

        function getFormattedAddress(address) {
            if (address.localizedAddress) {
                return address.localizedAddress.split(', ').join('\n\r');
            } else {
                return (
                    address.streetAddress1 +
                    '\n\r' +
                    address.zipCode +
                    ' ' +
                    address.city +
                    (address.stateCountrySerialized
                        ? '\n\r' + address.stateCountrySerialized
                        : address.country
                        ? '\n\r' + address.country.name
                        : '')
                );
            }
        }

        function bulkUpdateAddresses(addressList) {
            var promises = [];
            addressList.forEach(function (address) {
                if (
                    address.hasOwnProperty('changeState') &&
                    address.changeState !== 0
                ) {
                    switch (address.changeState) {
                        case 1:
                            promises.push(
                                dataService.insertItem('Addresses', address)
                            );
                            break;

                        case 2:
                            promises.push(
                                dataService.updateItem('Addresses', address)
                            );
                            break;

                        case 3:
                            promises.push(
                                dataService.deleteItem('Addresses', address)
                            );
                            break;

                        default:
                            break;
                    }
                }
            });
            return promises;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.program', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.program')
        .controller('EditProgramSlotStyleDialogController', EditProgramSlotStyleDialogController);

    /* @ngInject */
    function EditProgramSlotStyleDialogController($mdDialog, dataService, programSlotStyle, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.programSlotStyle = programSlotStyle;

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.programSlotStyle.changeState !== 1) {
                vm.programSlotStyle.changeState = 2;
            }
            $mdDialog.hide(vm.programSlotStyle);
            /*vm.loadingService.setBackgroundLoadingStatus(true);
            if (vm.fontStyle.changeState === 1) {
                dataService.insertItem('FontStyles', vm.fontStyle).then(function (insertedFontStyle) {
                    $mdDialog.hide(insertedFontStyle);
                });
            } else {
                dataService.updateItem('FontStyles', vm.fontStyle).then(function () {
                    $mdDialog.hide(vm.fontStyle);
                });
            }*/
        }
    }

})();


(function () {
    'use strict';

    angular.module('app.program').controller('EditProgramElementDialogController', EditProgramElementDialogController);

    /* @ngInject */
    function EditProgramElementDialogController(
        $mdDialog,
        $filter,
        logger,
        dataService,
        programElement,
        programService,
        programElementService,
        programElementVerseService
    ) {
        var vm = this;

        vm.programElement = programElement;
        vm.availableVerses = [];
        vm.currentAvailableVerse = null;
        vm.currentSelectedVerse = null;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onSongSelected = onSongSelected;
        vm.removeAllVerses = removeAllVerses;
        vm.removeCurrentVerse = removeCurrentVerse;
        vm.selectAllVerses = selectAllVerses;
        vm.selectCurrentVerse = selectCurrentVerse;
        vm.getRecommendedVerses = getRecommendedVerses;
        vm.removeProgramElementVerse = removeProgramElementVerse;
        vm.selectSongVerse = selectSongVerse;
        vm.markAsSelected = markAsSelected;
        vm.onProgramSlotSelected = onProgramSlotSelected;
        vm.onDataTypeChanged = onDataTypeChanged;
        vm.getVerseText = getVerseText;

        //////////
        getAvailableVerses(vm.programElement.songDataId);

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.programElement.changeState !== 1) {
                vm.programElement.changeState = 2;
            }
            $mdDialog.hide(vm.programElement);
        }

        function markAsSelected(selectedObject) {
            logger.info('ng-click event fired', selectedObject, 'ng-click');
            if (selectedObject.$type === 'Baldris.Core.Data.Entities.Fdo.SongVerseFdo, Baldris.Core.Data.Entities') {
                vm.currentAvailableVerse = selectedObject;
                vm.currentElementVerse = null;
            } else {
                vm.currentAvailableVerse = null;
                vm.currentElementVerse = selectedObject;
            }
        }

        function onSongSelected(song) {
            if (song && song.id !== vm.programElement.songDataId) {
                // New song selected -> remove all selected verses
                removeAllVerses();
                // Get available verses for song
                getAvailableVerses(song.id);
            }
        }

        function onProgramSlotSelected(programSlot) {
            if (programSlot) {
                vm.programElement.overridenTitle = null;
            }
        }

        function onDataTypeChanged() {
            removeAllVerses();
        }

        function removeAllVerses() {
            if (vm.programElement.programElementVerses && vm.programElement.programElementVerses.length > 0) {
                // Looping backwards in case we need to remove elements
                for (var elementVerseIndex = vm.programElement.programElementVerses.length - 1; elementVerseIndex >= 0; elementVerseIndex--) {
                    var elementVerse = vm.programElement.programElementVerses[elementVerseIndex];
                    removeProgramElementVerse(elementVerse);
                }
                vm.currentElementVerse = null;
            }
        }

        function removeProgramElementVerse(elementVerse, e) {
            if (e) {
                e.stopPropagation();
            }
            if (!elementVerse.id) {
                // Not saved to database -> remove
                var elementVerseIndex = vm.programElement.programElementVerses.indexOf(elementVerse);
                vm.programElement.programElementVerses.splice(elementVerseIndex, 1);
            } else {
                elementVerse.changeState = 3;
            }
        }

        function removeCurrentVerse() {
            if (vm.currentElementVerse) {
                removeProgramElementVerse(vm.currentElementVerse);
                vm.currentElementVerse = null;
            }
        }

        function selectAllVerses() {
            if (vm.availableVerses && vm.availableVerses.length > 0) {
                // Create verseCollection if not exist
                if (!vm.programElement.programElementVerses) vm.programElement.programElementVerses = [];
                for (var index = 0; index < vm.availableVerses.length; index++) {
                    var currentVerse = vm.availableVerses[index];
                    selectSongVerse(currentVerse);
                }
                vm.currentAvailableVerse = null;
            }
        }

        function selectSongVerse(songVerse, e) {
            if (e) {
                e.stopPropagation();
            }
            // Create verseCollection if not exist
            if (!vm.programElement.programElementVerses) vm.programElement.programElementVerses = [];
            // Add verse
            var elementVerse = programElementVerseService.getEmptyProgramElementVerse();
            elementVerse.verseId = songVerse.id;
            elementVerse.verse = songVerse;
            elementVerse.verseNumber = songVerse.verseNumber;
            elementVerse.verseText = songVerse.text;
            // Get previously sortOrder
            if (vm.programElement.programElementVerses && vm.programElement.programElementVerses.length > 0) {
                elementVerse.sortOrder =
                    Math.max.apply(
                        Math,
                        vm.programElement.programElementVerses.map(function (ev) {
                            return ev.sortOrder || 0;
                        })
                    ) + 1;
            } else {
                elementVerse.sortOrder = 1;
            }
            vm.programElement.programElementVerses.push(elementVerse);
        }

        function selectCurrentVerse() {
            if (vm.currentAvailableVerse) {
                selectSongVerse(vm.currentAvailableVerse);
                vm.currentAvailableVerse = null;
            }
        }

        function getRecommendedVerses() {
            programService.getRecommendedVersesForSlot(vm.programElement.programSlotId, vm.programElement.songDataId).then(function (recommendedVerses) {
                if (recommendedVerses && recommendedVerses.length > 0) {
                    // Remove all currently selected
                    removeAllVerses();
                    // Create verseCollection if not exist
                    if (!vm.programElement.programElementVerses) vm.programElement.programElementVerses = [];
                    for (var index = 0; index < recommendedVerses.length; index++) {
                        var recommendedVerse = recommendedVerses[index];
                        recommendedVerse.changeState = 1;
                        vm.programElement.programElementVerses.push(recommendedVerse);
                    }
                }
            });
        }

        function getAvailableVerses(songId) {
            if (songId) {
                dataService.getByUri('SongVerses', 'BySongId/' + songId).then(function (foundVerses) {
                    vm.availableVerses = foundVerses;
                });
            }
        }

        function getVerseText(verseNumber) {
            if (!verseNumber || !vm.availableVerses || vm.availableVerses.length === 0) {
                return null;
            }
            var verse = vm.availableVerses.find(function (verse) {
                return verse.verseNumber && verse.verseNumber === verseNumber;
            });

            if (verse) {
                return verse.text;
            }

            return null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .controller('AddProgramElementDialogController', AddProgramElementDialogController);

    /* @ngInject */
    function AddProgramElementDialogController($mdDialog, programId, dataService, programElementService) {
        var vm = this;
        
        vm.programElement = programElementService.getEmptyProgramElement();
        vm.programElement.changeState = 1;
        vm.programElement.programId = programId;

        // Methods
        vm.onProgramSlotSelected = onProgramSlotSelected;
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////
        function onProgramSlotSelected(programSlot) {
            if (programSlot) {
                vm.programElement.sortOrder = programSlot.sortOrder;
                vm.programElement.dataType = programSlot.dataType;
                vm.programElement.shouldBeVisibleInPrint = programSlot.shouldBeVisibleInPrint;
                vm.programElement.programSlotLookupStringCategoryId = programSlot.lookupStringCategoryId;
                if (vm.programElement.dataType && vm.programElement.dataType === 5) {
                    vm.programElement.boolData = true;
                }
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.programElement.dataType && vm.programElement.dataType === 5) {
                vm.programElement.boolData = true;
            }
            $mdDialog.hide(vm.programElement); 
        }

    }

}());
(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programTypeSelect', {
            bindings: {
                programTypeId: '=',
                programType: '=',
                onSelected: '=',
                labelText: '@',
                minQueryLength: '=',
                displayText: '=',
            },
            templateUrl:
                'app/main/program/components/program-type-select/program-type-select.tmpl.html',
            controller: 'ProgramTypeSelectController as vm',
        })
        .controller('ProgramTypeSelectController', ProgramTypeSelectController);

    /* @ngInject */
    function ProgramTypeSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.isInitializing = true;

        vm.$onInit = function () {
            //Get Current ProgramType
            if (vm.programTypeId && !vm.programType) {
                dataService
                    .getById('ServiceSheetTypes', vm.programTypeId)
                    .then(function (programType) {
                        vm.programType = programType;
                        vm.isInitializing = false;
                    });
            } else {
                vm.isInitializing = false;
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService
                    .search('ServiceSheetTypes', query)
                    .then(function (searchResult) {
                        return searchResult.data;
                    });
            } else {
                return dataService
                    .getAll('ServiceSheetTypes')
                    .then(function (programTypes) {
                        return programTypes;
                    });
            }
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.programTypeId = item.id;
                vm.programTypeForm.programType.$setValidity(
                    'invalidProgramType',
                    true
                );
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                if (
                    vm.programTypeId &&
                    vm.programTypeId !== '00000000-0000-0000-0000-000000000000'
                ) {
                    // Set dirty
                    vm.programTypeForm.$setDirty();
                }
                vm.programTypeId = null;
                if (vm.searchText) {
                    vm.programTypeForm.programType.$setValidity(
                        'invalidProgramType',
                        false
                    );
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programStyleSelect', {
            bindings: {
                programStyleId: '=',
                programStyle: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                onUpdate: '&'
            },
            templateUrl: 'app/main/program/components/program-style-select/program-style-select.tmpl.html',
            controller: 'ProgramStyleSelectController as vm',
        })
        .controller('ProgramStyleSelectController', ProgramStyleSelectController);

    /* @ngInject */
    function ProgramStyleSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.programStyles = [];
        vm.onChange = onChange;
        
        // Get options
        dataService.getAll("ProgramStyles").then(function (programStyles) {
            vm.isDisabled = false;
            vm.programStyles = programStyles;
        });

        function onChange() {
            if (vm.programStyleId) {
                for (var index = 0; index < vm.programStyles.length; index++) {
                    var programStyle = vm.programStyles[index];
                    if (vm.programStyleId === programStyle.id) {
                        vm.programStyle = programStyle;
                        break;
                    }
                }
                vm.onUpdate({ action: 'selected', value: vm.programStyle });
            } else {
                vm.programStyle = null;
                vm.onUpdate({ action: 'deselected', value: null });
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.programStyle);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programSlotSelect', {
            bindings: {
                programSlotId: '=',
                programSlot: '=',
                onSelected: '=',
                labelText: '@',
                minQueryLength: '=',
                displayText: '='
            },
            templateUrl: 'app/main/program/components/program-slot-select/program-slot-select.tmpl.html',
            controller: 'ProgramSlotSelectController as vm',
        })
        .controller('ProgramSlotSelectController', ProgramSlotSelectController);

    /* @ngInject */
    function ProgramSlotSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        vm.$onInit = function () {
            //Get Current ProgramSlot
            if (vm.programSlotId && !vm.programSlot) {
                dataService.getById('ProgramSlots', vm.programSlotId).then(function (programSlot) {
                    vm.programSlot = programSlot;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }


        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService.search('ProgramSlots', query).then(function (programSlots) {
                    return $filter('orderBy')(programSlots, 'name');
                });
            } else {
                return dataService.getAll('ProgramSlots').then(function (programSlots) {
                    return $filter('orderBy')(programSlots, 'name');
                });
            }

        }

        function searchTextChange(text) {

        }


        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.programSlotId = item.id;
                vm.programSlotForm.programSlot.$setValidity('invalidProgramSlot', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.title || item.name;
                }
            } else {
                vm.programSlotId = null;
                if (vm.searchText) {
                    vm.programSlotForm.programSlot.$setValidity('invalidProgramSlot', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programSlotElement', {
            bindings: {
                programSlotElement: '=ngModel',
                isDisabled: '=ngDisabled',
                onUpdate: '&',
                onEdit: '&',
                onDelete: '&',
                calendarEventTypeId: '<',
                locationId: '<',
            },
            templateUrl:
                'app/main/program/components/program-slot-element/program-slot-element.tmpl.html',
            controller: 'ProgramSlotElementController as vm',
        })
        .controller(
            'ProgramSlotElementController',
            ProgramSlotElementController
        );

    /* @ngInject */
    function ProgramSlotElementController(
        $filter,
        dataService,
        programService
    ) {
        var vm = this;

        vm.songSelected = false;
        vm.recommendedVersesNotFound = false;

        vm.getSlotIcon = getSlotIcon;
        vm.getRecommendedVerses = getRecommendedVerses;
        vm.onProgramElementChanged = onProgramElementChanged;
        vm.getSongVerses = getSongVerses;
        vm.onSongChanged = onSongChanged;
        vm.toggleVisibleInPrint = toggleVisibleInPrint;
        vm.hasVerses = hasVerses;

        function onSongChanged(action, song, programSlot) {
            if (action === 'selected' && song) {
                // Get recommended verses
                removeAllVerses(programSlot.data);
                vm.songSelected = true;
                vm.recommendedVersesNotFound = false;
                getRecommendedVerses(
                    programSlot.slotId,
                    song.id,
                    vm.calendarEventTypeId,
                    vm.locationId
                ).then(function (recommendedVerses) {
                    if (!recommendedVerses || recommendedVerses.length === 0) {
                        vm.recommendedVersesNotFound = true;
                    }
                    if (!programSlot.data.programElementVerses)
                        programSlot.data.programElementVerses = [];

                    programSlot.data.programElementVerses =
                        programSlot.data.programElementVerses.concat(
                            recommendedVerses
                        );
                });
            }
            if (action === 'deselected') {
                vm.songSelected = false;
                removeAllVerses(programSlot.data);
            }
            onProgramElementChanged(programSlot.data);
        }

        function getRecommendedVerses(
            programSlotId,
            songId,
            calendarEventTypeId,
            locationId
        ) {
            return programService
                .getRecommendedVersesForSlot(
                    programSlotId,
                    songId,
                    calendarEventTypeId,
                    locationId
                )
                .then(function (recommendedVerses) {
                    var verseCollection = [];
                    if (recommendedVerses && recommendedVerses.length > 0) {
                        for (
                            var index = 0;
                            index < recommendedVerses.length;
                            index++
                        ) {
                            var recommendedVerse = recommendedVerses[index];
                            recommendedVerse.changeState = 1;
                            verseCollection.push(recommendedVerse);
                        }
                    }
                    return verseCollection;
                });
        }

        function removeAllVerses(programElementUpdateModel) {
            if (
                programElementUpdateModel.programElementVerses &&
                programElementUpdateModel.programElementVerses.length > 0
            ) {
                // Looping backwards in case we need to remove elements
                for (
                    var elementVerseIndex =
                        programElementUpdateModel.programElementVerses.length -
                        1;
                    elementVerseIndex >= 0;
                    elementVerseIndex--
                ) {
                    var elementVerse =
                        programElementUpdateModel.programElementVerses[
                            elementVerseIndex
                        ];
                    removeProgramElementVerse(
                        elementVerse,
                        programElementUpdateModel.programElementVerses
                    );
                }
            }
        }

        function removeProgramElementVerse(elementVerse, verseCollection) {
            if (elementVerse.changeState === 1) {
                // Not saved to database -> remove
                var elementVerseIndex = verseCollection.indexOf(elementVerse);
                verseCollection.splice(elementVerseIndex, 1);
            } else {
                elementVerse.changeState = 3;
            }
        }

        function getSongVerses(element) {
            var returnString = '';
            if (element && element.programElementVerses) {
                var elementVerses = $filter('orderBy')(
                    element.programElementVerses,
                    'sortOrder'
                );
                for (var index = 0; index < elementVerses.length; index++) {
                    var elementVerse = elementVerses[index];
                    if (
                        elementVerse.verseNumber &&
                        elementVerse.changeState != 3
                    ) {
                        if (returnString) returnString += ', ';
                        returnString += elementVerse.verseNumber;
                    }
                }
            }
            if (!returnString) {
                return vm.songSelected
                    ? vm.recommendedVersesNotFound
                        ? 'PROGRAMS.PROGRAM_SLOT_ELEMENT.RECOMMENDED_VERSES_NOT_FOUND'
                        : 'PROGRAMS.PROGRAM_SLOT_ELEMENT.FETCHING_RECOMMENDED_VERSES'
                    : 'PROGRAMS.PROGRAM_SLOT_ELEMENT.NO_SONG_SELECTED';
            }
            return returnString;
        }

        function hasVerses(element) {
            if (
                !element ||
                !element.programElementVerses ||
                element.programElementVerses.length === 0
            ) {
                return false;
            }
            return element.programElementVerses.reduce(function (
                previousValue,
                currentValue
            ) {
                return previousValue || currentValue.changeState !== 3;
            },
            false);
        }

        function getSlotIcon(programSlot) {
            switch (programSlot.dataType) {
                case 'string':
                case 'custom':
                    return 'icon icon-comment-text';
                case 'lookupString':
                    return 'icon icon-format-list-numbers';
                case 'long':
                case 'decimal':
                    return 'icon icon-numeric';
                case 'dateTime':
                    return 'icon icon-timetable';
                case 'boolean':
                    return 'icon icon-check-circle';
                case 'song':
                case 'prayer':
                    return 'icon icon-book-multiple';
                case 'solo':
                    return 'icon icon-microphone';
                case 'music':
                    return 'icon icon-music-note';
                default:
                    return 'icon icon-comment-text';
            }
        }

        function onProgramElementChanged(programElement) {
            if (programElement.isNew) {
                programElement.isNew = false;
            }
            if (programElement.id) {
                programElement.changeState = 2;
            }
            vm.onUpdate({ value: vm.programSlotElemet });
        }

        function toggleVisibleInPrint() {
            if (vm.programSlotElementForm) {
                vm.programSlotElementForm.$setDirty();
            }
            onProgramElementChanged(vm.programSlotElement.data);
            vm.programSlotElement.data.shouldBeVisibleInPrint =
                !vm.programSlotElement.data.shouldBeVisibleInPrint;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programOptionsSelect', {
            bindings: {
                programOption: '=',
                visibleOptions: '=',
                onChanged: '=',
                isDisabled: '=',
                labelText: '@',
            },
            templateUrl: 'app/main/program/components/program-options-select/program-options-select.tmpl.html',
            controller: 'ProgramOptionsSelectController as vm',
        })
        .controller('ProgramOptionsSelectController', ProgramOptionsSelectController);

    /* @ngInject */
    function ProgramOptionsSelectController(programOptions) {
        var vm = this;
        vm.programOptions = programOptions;
        vm.isSelected = isSelected;
        vm.toggle = toggle;
        vm.isVisible = isVisible;

        function isSelected(option) {
            if (vm.programOption && vm.programOption.indexOf(option.value) > -1) {
                return true;
            }
            return false;
        }

        function isVisible(option) {
            if (!vm.visibleOptions || vm.visibleOptions === 'none') return true;
            return vm.visibleOptions.indexOf(option.value) > -1;
        }

        function toggle(option) {
            if (isSelected(option)) {
                vm.programOption = vm.programOption.replace(', ' + option.value, '');
                vm.programOption = vm.programOption.replace(option.value, '');
                if (!vm.programOption) {
                    vm.programOption = 'none';
                }
            } else {
                if (vm.programOption === 'none') {
                    vm.programOption = null;
                }
                if (vm.programOption) {
                    vm.programOption += ', ' + option.value;
                } else {
                    vm.programOption = option.value;
                }
            }
            vm.programOptionsForm.$setDirty();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programDataTypeSelect', {
            bindings: {
                programDataType: '=',
                onChanged: '=',
                isDisabled: '=',
                labelText: '@',
                onUpdate: '&'
            },
            templateUrl: 'app/main/program/components/program-data-type-select/program-data-type-select.tmpl.html',
            controller: 'ProgramDataTypeSelectController as vm',
        })
        .controller('ProgramDataTypeSelectController', ProgramDataTypeSelectController);

    /* @ngInject */
    function ProgramDataTypeSelectController(programDataTypeOptions) {
        var vm = this;
        vm.dataTypeOptions = programDataTypeOptions;
        vm.dataTypeChanged = dataTypeChanged;
        
        function dataTypeChanged() {
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.programDataType);
            }
            vm.onUpdate({ action: 'changed', value: vm.programDataType });
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.program')
        .component('programCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/program/components/program-card/program-card.tmpl.html',
            controller: 'ProgramCardController as vm',
        })
        .controller('ProgramCardController', ProgramCardController);

    /* @ngInject */
    function ProgramCardController($mdDialog, $document, $translate, $mdToast) {
        var vm = this;
        vm.navigateToProgram = navigateToProgram;
        vm.deleteProgram = deleteProgram;

        function navigateToProgram(program, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(program, e);
                } else {
                    $state.go('app.program.byId', { id: program.id });
                }
            }
        }

        function deleteProgram(program, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(program, e);
                }
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.product', [
            // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'xeditable'
        ]);
})(); 
(function () {
    'use strict';

    angular.module('app.product').controller('ProductsViewController', ProductsViewController);

    /* @ngInject */
    function ProductsViewController(
        $q,
        $filter,
        $compile,
        $scope,
        $translate,
        $mdDialog,
        $document,
        $stateParams,
        products,
        DTColumnBuilder,
        datatableService
    ) {
        var vm = this;
        vm.isLoadingProducts = true;
        vm.productTypes = [];
        vm.currentProducts = products;
        vm.currentProductTypeId = $stateParams.productTypeId;

        // Methods

        vm.dtInstance = {};
        vm.dtOptions = datatableService
            .getLocalizedOptionsWithPromise(getPromise())
            .withPaginationType('simple')
            .withDisplayLength(50)
            .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('lengthMenu', [10, 20, 30, 50, 100, 200])
            .withOption('responsive', true)
            .withOption('scrollY', 'auto')
            .withOption('initComplete', function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#product-list-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            })
            .withOption('createdRow', function (row, data, dataIndex) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    // Use this headerCompiled field to only compile header once
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('rowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function () {
                    $scope.$apply(function () {
                        openEditDialog(aData);
                    });
                });
                $('td', nRow).addClass('clickable');
                return nRow;
            });

        vm.dtColumnDefs = [
            {
                // Target the image column
                targets: 0,
                filterable: false,
                sortable: false,
                width: '63px',
            },
        ];

        vm.dtColumns = [
            DTColumnBuilder.newColumn('productImageFilepath')
                .withTitle('<md-icon md-font-icon="icon-file-image"></md-icon>')
                .notSortable()
                .renderWith(function (data, type, full, meta) {
                    if (full.productImage) return '<img class="md-avatar" alt="' + full.name + '" src="' + full.productImage.filepath + '?w=40&h=40"/>';
                    if (full.productImageFilepath) return '<img class="md-avatar" alt="' + full.name + '" src="' + full.productImageFilepath + '?w=40&h=40"/>';
                    return '<img class="md-avatar" alt="' + full.name + '" src="/assets/images/ecommerce/product-image-placeholder.png"/>';
                }),
            DTColumnBuilder.newColumn('productCode').withTitle($translate.instant('PRODUCTS.PRODUCT.PRODUCT_CODE')),
            DTColumnBuilder.newColumn('name').withTitle($translate.instant('PRODUCTS.PRODUCT.NAME')),
            DTColumnBuilder.newColumn('price')
                .withTitle($translate.instant('PRODUCTS.PRODUCT.PRICE'))
                .renderWith(function (data, type, full, meta) {
                    return $filter('currency')(data);
                }),
            DTColumnBuilder.newColumn('vatRate')
                .withTitle($translate.instant('PRODUCTS.PRODUCT.VAT_RATE'))
                .renderWith(function (data, type, full, meta) {
                    if (data) return data + ' %';
                    if (full && full.vat) return full.vat.rate + ' %';
                    return '––';
                }),
            DTColumnBuilder.newColumn('priceIncludingVat')
                .withTitle($translate.instant('PRODUCTS.PRODUCT.PRICE_INCLUDING_VAT'))
                .renderWith(function (data, type, full, meta) {
                    return $filter('currency')(data);
                }),
        ];

        function getPromise() {
            return $q.when(sortAndFilterProducts(vm.currentProducts));
        }

        function sortAndFilterProducts(products) {
            var filteredProducts = $filter('orderBy')(products, 'name');
            filteredProducts = $filter('filter')(filteredProducts, { isDiscontinued: false });
            return filteredProducts;
        }

        function openEditDialog(product, e) {
            return $mdDialog
                .show({
                    controller: 'EditProductDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/product/dialogs/edit-product-dialog/edit-product-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        product: product ? angular.copy(product) : productService.getEmptyProduct(),
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updateModel) {
                    if (updateModel && updateModel.product) {
                        findAndRemoveProduct(updateModel.product);
                        if (updateModel.product.productTypeId === vm.currentProductTypeId && updateModel.product.changeState != 3) {
                            vm.currentProducts.push(updateModel.product);
                        }
                        vm.dtInstance.changeData(getPromise());
                    }
                    return updateModel;
                });
        }

        function findAndRemoveProduct(product) {
            if (!product || !product.id || !vm.currentProducts || vm.currentProducts.length === 0) return; // Not enough data
            for (var index = 0; index < vm.currentProducts.length; index++) {
                var element = vm.currentProducts[index];
                if (element.id === product.id) {
                    vm.currentProducts.splice(index, 1);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.product').controller('EditProductTypeDialogController', EditProductTypeDialogController);

    /* @ngInject */
    function EditProductTypeDialogController($mdDialog, dataLegacyService, productTypeId, productService, loadingService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.productType = null;
        vm.loadingService = loadingService;

        // METHODS
        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteProductType = deleteProductType;

        // INIT

        vm.loadingService.setLoadingStatus(true);
        if (!productTypeId || productTypeId === '00000000-0000-0000-0000-000000000000' || productTypeId === 'new') {
            vm.isNew = true;
        }

        if (!vm.isNew) {
            dataService.getById('ProductTypes', productTypeId, true).then(function (productType) {
                vm.productType = productType;
                vm.loadingService.setLoadingStatus(false);
            });
        } else {
            vm.productType = productService.getEmptyProductType();
            vm.productType.changeState = 1;
            vm.loadingService.setLoadingStatus(false);
        }

        function closeDialog(data) {
            $mdDialog.hide(data);
        }

        function saveChanges() {
            vm.loadingService.setBackgroundLoadingStatus(true);
            if (vm.productType.changeState !== 1) {
                vm.productType.changeState = 2;
                dataService.updateItem('ProductTypes', vm.productType).then(function () {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                    closeDialog(vm.productType);
                });
            } else {
                dataService.insertItem('ProductTypes', vm.productType).then(function (insertedData) {
                    vm.loadingService.setBackgroundLoadingStatus(false);
                    closeDialog(insertedData);
                });
            }
        }

        function deleteProductType() {
            if (vm.isNew) {
                closeDialog();
            } else {
                vm.loadingService.setBackgroundLoadingStatus(true);
                vm.productType.changeState = 3;
                dataService
                    .deleteItem('ProductTypes', vm.productType)
                    .then(function (deletedData) {
                        // Make sure changeState is set to delete
                        deletedData.changeState = 3;
                        vm.loadingService.setBackgroundLoadingStatus(false);
                        closeDialog(deletedData);
                    })
                    .catch(function (errorObject) {
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.product').controller('EditProductDialogController', EditProductDialogController);

    /* @ngInject */
    function EditProductDialogController($rootScope, $mdDialog, $q, $filter, Upload, baldrisApiLegacyBase, dataLegacyService, product, productService) {
        var dataService = dataLegacyService;
        var baldrisApiBase = baldrisApiLegacyBase;
        var vm = this;
        vm.updateModel = null;
        vm.isLoading = true;
        $rootScope.loadingProgress = true;
        vm.isNew = false;
        vm.productTypes = [];
        vm.balanceAccounts = [];
        vm.vats = [];
        vm.suppliers = [];
        vm.hasUploadFiles = false;
        vm.uploadFiles = [];

        // METHODS
        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteProduct = deleteProduct;
        vm.loadReferenceData = loadReferenceData;
        vm.updateReferenceData = updateReferenceData;
        vm.onPriceChanged = onPriceChanged;
        vm.onPriceVatChanged = onPriceVatChanged;
        vm.uploadProductImage = uploadProductImage;
        vm.removeProductImage = removeProductImage;

        // INIT

        // Supplier-search
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        var supplierSearchElement = $('md-select-header.supplier-select-header').find('input');
        supplierSearchElement.on('keydown', function (ev) {
            ev.stopPropagation();
        });

        if (!product.id || product.id === '00000000-0000-0000-0000-000000000000') {
            vm.isNew = true;
        }

        // Fetch updateModel
        loadReferenceData().then(function () {
            if (!vm.isNew) {
                dataService.getUpdateModel('Products', product.id).then(function (updateModel) {
                    vm.updateModel = updateModel;
                    setLoadingStatus(false);
                });
            } else {
                vm.updateModel = {
                    $type: 'Baldris.Core.Data.Entities.UpdateModels.ProductUpdateModel, Baldris.Core.Data.Entities',
                    product: product,
                    productStocks: [],
                    autoTasks: null,
                    productImages: [],
                };
                setLoadingStatus(false);
            }
        });

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            setLoadingStatus(true);
            if (vm.isNew) {
                vm.updateModel.product.changeState = 1;
            } else {
                vm.updateModel.product.changeState = 2;
            }
            if (vm.uploadFiles && vm.uploadFiles.length > 0) {
                uploadProductImage().then(function () {
                    dataService.updateFromUpdateModel('Products', vm.updateModel).then(function (insertedData) {
                        setLoadingStatus(false);
                        dataService.invalidateCache('Products');
                        $mdDialog.hide(insertedData);
                    });
                });
            } else {
                dataService.updateFromUpdateModel('Products', vm.updateModel).then(function (insertedData) {
                    setLoadingStatus(false);
                    dataService.invalidateCache('Products');
                    $mdDialog.hide(insertedData);
                });
            }
        }

        function deleteProduct() {
            if (vm.isNew) {
                closeDialog();
            } else {
                setLoadingStatus(true);
                vm.updateModel.product.changeState = 3;
                dataService.updateFromUpdateModel('Products', vm.updateModel).then(function (insertedData) {
                    // Make sure changeState is set to delete
                    insertedData.product.changeState = 3;
                    setLoadingStatus(false);
                    $mdDialog.hide(insertedData);
                });
            }
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function loadReferenceData() {
            var promises = [];

            promises.push(
                dataService.getAll('ProductTypes').then(function (productTypes) {
                    vm.productTypes = productTypes;
                    return vm.productTypes;
                })
            );
            promises.push(
                dataService.getAll('BalanceAccounts').then(function (balanceAccounts) {
                    vm.balanceAccounts = $filter('filter')(balanceAccounts, { isDeleted: false });
                    return vm.balanceAccounts;
                })
            );
            promises.push(
                dataService.getAll('Vats').then(function (vats) {
                    vm.vats = $filter('filter')(vats, { isDeleted: false });
                    return vm.balanceAccounts;
                })
            );

            return $q.all(promises);
        }

        function updateReferenceData() {
            if (vm.updateModel.product.balanceAccount) {
                vm.updateModel.product.balanceAccountId = vm.updateModel.product.balanceAccount.id;
            } else {
                vm.updateModel.product.balanceAccountId = null;
            }
            if (vm.updateModel.product.productType) {
                vm.updateModel.product.productTypeId = vm.updateModel.product.productType.id;
                if (!vm.updateModel.product.productCode) {
                    productService.getHighestProductCodeByProductType(vm.updateModel.product.productTypeId).then(function (productCode) {
                        if (productCode) {
                            var isnum = /^\d+$/.test(productCode);
                            if (isnum) {
                                var incrementvalue = +productCode + 1;
                                vm.updateModel.product.productCode = ('00000000000000000000000000000' + incrementvalue).slice(productCode.length * -1);
                            } else {
                                vm.updateModel.product.productCode = productCode.replace(/\d+$/, function (n) {
                                    return ++n;
                                });
                            }
                        }
                    });
                }
            } else {
                vm.updateModel.product.productTypeId = null;
            }
            if (vm.updateModel.product.vat) {
                vm.updateModel.product.vatId = vm.updateModel.product.vat.id;
            } else {
                vm.updateModel.product.vatId = null;
            }
            onPriceChanged();
        }

        function onPriceChanged() {
            if (vm.updateModel.product) {
                if (vm.updateModel.product.price && vm.updateModel.product.vat && vm.updateModel.product.vat.rate > 0) {
                    vm.updateModel.product.priceIncludingVat = vm.updateModel.product.price * ((100 + vm.updateModel.product.vat.rate) / 100);
                    return;
                }
                vm.updateModel.product.priceIncludingVat = vm.updateModel.product.price || 0;
            }
        }

        function onPriceVatChanged() {
            if (vm.updateModel.product) {
                if (vm.updateModel.product.priceIncludingVat && vm.updateModel.product.vat && vm.updateModel.product.vat.rate > 0) {
                    vm.updateModel.product.price = vm.updateModel.product.priceIncludingVat / ((100 + vm.updateModel.product.vat.rate) / 100);
                    return;
                }
                vm.updateModel.product.price = vm.updateModel.product.priceIncludingVat || 0;
            }
        }

        function uploadProductImage(file) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        var baldrisFile = resp.data[0];
                        vm.updateModel.product.productImageId = baldrisFile.id;
                        vm.updateModel.product.productImage = baldrisFile;
                        vm.updateModel.product.productImageFilepath = baldrisFile.filepath;
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function removeProductImage() {
            vm.updateModel.product.productImageId = null;
            vm.updateModel.product.productImage = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('vatSelect', {
            bindings: {
                vatId: '=',
                vat: '=',
                onSelected: '=',
                labelText: '@',
                vatConfig: '=',
                disableSearch: '=',
                minQueryLength: '=',
                displayText: '='
            },
            templateUrl: 'app/main/product/components/vat-select/vat-select.tmpl.html',
            controller: 'VatSelectController as vm',
        })
        .controller('VatSelectController', VatSelectController);

    /* @ngInject */
    function VatSelectController($filter, dataService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current Location
            if (vm.vatId && vm.vatId !== '00000000-0000-0000-0000-000000000000' && !vm.vat) {
                dataService.getById('Vats', vm.vatId, true).then(function (vat) {
                    vm.vat = vat;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.vatConfig) {
                if (query) {
                    return dataService.searchByConfigName('Vats', vm.locationConfig, query).then(function (vats) {
                        vats = $filter('filter')(vats, { isDeleted: false });
                        return $filter('orderBy')(vats, ['rate','name']);
                    });
                } else {
                    return dataService.getByConfigName('Vats', vm.locationConfig).then(function (vats) {
                        vats = $filter('filter')(vats, { isDeleted: false });
                        return $filter('orderBy')(vats, ['rate','name']);
                    });
                }
            } else {
                if (query) {
                    return dataService.search('Vats', query).then(function (vats) {
                        vats = $filter('filter')(vats, {isDeleted: false});
                        return $filter('orderBy')(vats, ['rate','name']);
                    });
                } else {
                    return dataService.getAll('Vats').then(function (vats) {
                        vats = $filter('filter')(vats, {isDeleted: false});
                        return $filter('orderBy')(vats, ['rate','name']);
                    });
                }
            }

        }

        function searchTextChange(text) {

        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.vatId = item.id;
                vm.vatForm.vat.$setValidity('invalidVat', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.vatId = null;
                if (vm.searchText) {
                    vm.vatForm.vat.$setValidity('invalidVat', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('productTypeSelect', {
            bindings: {
                productTypeId: '=',
                productType: '=',
                onSelected: '=',
                labelText: '@',
                productTypeConfig: '=',
                disableSearch: '=',
                minQueryLength: '=',
                displayText: '='
            },
            templateUrl: 'app/main/product/components/product-type-select/product-type-select.tmpl.html',
            controller: 'ProductTypeSelectController as vm',
        })
        .controller('ProductTypeSelectController', ProductTypeSelectController);

    /* @ngInject */
    function ProductTypeSelectController($filter, dataService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current Location
            if (vm.productTypeId && !vm.productType) {
                dataService.getById('ProductTypes', vm.productTypeId, true).then(function (productType) {
                    vm.productType = productType;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.productTypeConfig) {
                if (query) {
                    return dataService.searchByConfigName('ProductTypes', vm.locationConfig, query).then(function (productTypes) {
                        productTypes = $filter('filter')(productTypes, { isDeleted: false });
                        return $filter('orderBy')(productTypes, 'name');
                    });
                } else {
                    return dataService.getByConfigName('ProductTypes', vm.locationConfig).then(function (productTypes) {
                        productTypes = $filter('filter')(productTypes, { isDeleted: false });
                        return $filter('orderBy')(productTypes, 'name');
                    });
                }
            } else {
                if (query) {
                    return dataService.search('ProductTypes', query).then(function (productTypes) {
                        productTypes = $filter('filter')(productTypes, {isDeleted: false});
                        return $filter('orderBy')(productTypes, 'name');
                    });
                } else {
                    return dataService.getAll('ProductTypes').then(function (productTypes) {
                        productTypes = $filter('filter')(productTypes, {isDeleted: false});
                        return $filter('orderBy')(productTypes, 'name');
                    });
                }
            }

        }

        function searchTextChange(text) {

        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.productTypeId = item.id;
                vm.productTypeForm.productType.$setValidity('invalidProductType', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.productTypeId = null;
                if (vm.searchText) {
                    vm.productTypeForm.productType.$setValidity('invalidProductType', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.product')
        .component('productSelect', {
            bindings: {
                productId: '=',
                product: '=',
                onSelected: '=',
                isRequired: '=',
                isDisabled: '=',
                disableSearch: '=',
                labelText: '@',
                productConfig: '=',
                queryUriOverride: '=',
                queryController: '@',
                onUpdate: '&',
                suggestedProducts: '=',
            },
            templateUrl: 'app/main/product/components/product-select/product-select.tmpl.html',
            controller: 'ProductSelectController as vm',
        })
        .controller('ProductSelectController', ProductSelectController);

    /* @ngInject */
    function ProductSelectController($q, $filter, dataService, $mdDialog, $document, $translate) {
        var vm = this;
        var cachedResults = [];

        vm.$onInit = function () {
            vm.querySearch = querySearch;
            vm.selectedItemChange = selectedItemChange;
            vm.searchTextChange = searchTextChange;
            vm.getTypes = getTypes;
            vm.resetInput = resetInput;
            vm.openSearchDialog = openSearchDialog;
            vm.isRequiredOption = vm.isRequired || false;
            vm.isDisabledOption = vm.isDisabled;

            vm.searchText = null;

            //Get Current Product
            if (vm.productId && vm.productId !== '00000000-0000-0000-0000-000000000000' && (!vm.product || vm.product.id !== vm.productId)) {
                dataService.getById('Products', vm.productId, true).then(function (product) {
                    vm.product = product;
                });
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.queryUriOverride) {
                return dataService.getByUri(vm.queryController, vm.queryUriOverride).then(function (products) {
                    return products;
                });
            } else {
                if (vm.productConfig) {
                    if (cachedResults.length === 0) {
                        return dataService.getByConfigName('Products', vm.productConfig).then(function (products) {
                            cachedResults = products;
                            return getFiltered(cachedResults, query);
                        });
                    }
                } else {
                    if (query) {
                        return dataService.search('Products', query).then(function (searchResult) {
                            return searchResult.data || searchResult;
                        });
                    } else {
                        if (vm.suggestedProducts && vm.suggestedProducts.length > 0) {
                            return $q.when(vm.suggestedProducts);
                        } else {
                            return dataService.getAll('Products').then(function (products) {
                                return products;
                            });
                        }
                    }
                }
            }
        }

        function getFiltered(collection, query) {
            if (!query) return collection;
            return $filter('filter')(collection, query);
        }

        function searchTextChange(text) {}

        function openSearchDialog(e) {
            $mdDialog
                .show({
                    controller: 'SearchEntityDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/common/dialogs/search-entity-dialog/search-entity-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        entityOptions: {
                            title: $translate.instant('PRODUCTS.PRODUCT_SELECT.PRODUCT_SEARCH_TITLE'),
                            entityTypeController: 'ProductTypes',
                            entityTypeSort: 'name',
                            entityTypeItemTemplate: 'app/main/product/components/product-select/product-type-item.tmpl.html',
                            entityTypeIdName: 'productTypeId',
                            entityController: 'Products',
                            entitySort: 'name',
                            entityItemTemplate: 'app/main/product/components/product-select/product-item.tmpl.html',
                            entityDeletedProperty: 'isDiscontinued',
                        },
                    },
                    clickOutsideToClose: true,
                })
                .then(function (selectedProduct) {
                    if (selectedProduct) {
                        vm.product = selectedProduct;
                        selectedItemChange(vm.product);
                        if (vm.productForm) {
                            vm.productForm.$setDirty();
                        }
                    }
                });
        }

        function resetInput() {
            vm.productId = null;
            vm.product = null;
            vm.searchText = null;
            vm.productForm.product.$setValidity('invalidProduct', true);
        }

        function getTypes(typesString) {
            return typesString.split(' // ');
        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.productId = item.id;
                vm.productForm.product.$setValidity('invalidProduct', true);
                vm.onUpdate({ action: 'selected', value: item });
            } else {
                vm.productId = null;
                if (vm.searchText) {
                    vm.productForm.product.$setValidity('invalidProduct', false);
                }
                vm.productForm.$setDirty();
                vm.onUpdate({ action: 'deselected', value: null });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.referenceTypes')
        .component('balanceAccountSelect', {
            bindings: {
                balanceAccountId: '=',
                balanceAccount: '=',
                onSelected: '=',
                labelText: '@',
                balanceAccountConfig: '=',
                disableSearch: '=',
                minQueryLength: '=',
                displayText: '='
            },
            templateUrl: 'app/main/product/components/balance-account-select/balance-account-select.tmpl.html',
            controller: 'BalanceAccountSelectController as vm',
        })
        .controller('BalanceAccountSelectController', BalanceAccountSelectController);

    /* @ngInject */
    function BalanceAccountSelectController($filter, dataService) {
        var vm = this;

        vm.$onInit = function () {
            //Get Current Location
            if (vm.balanceAccountId && vm.balanceAccountId !== '00000000-0000-0000-0000-000000000000' && !vm.balanceAccount) {
                dataService.getById('BalanceAccounts', vm.balanceAccountId, true).then(function (balanceAccount) {
                    vm.balanceAccount = balanceAccount;
                });
            }

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        }

        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.balanceAccountConfig) {
                if (query) {
                    return dataService.searchByConfigName('BalanceAccounts', vm.locationConfig, query).then(function (balanceAccounts) {
                        balanceAccounts = $filter('filter')(balanceAccounts, { isDeleted: false });
                        return $filter('orderBy')(balanceAccounts, ['account','name']);
                    });
                } else {
                    return dataService.getByConfigName('BalanceAccounts', vm.locationConfig).then(function (balanceAccounts) {
                        balanceAccounts = $filter('filter')(balanceAccounts, { isDeleted: false });
                        return $filter('orderBy')(balanceAccounts, ['account','name']);
                    });
                }
            } else {
                if (query) {
                    return dataService.search('BalanceAccounts', query).then(function (balanceAccounts) {
                        balanceAccounts = $filter('filter')(balanceAccounts, {isDeleted: false});
                        return $filter('orderBy')(balanceAccounts, ['account','name']);
                    });
                } else {
                    return dataService.getAll('BalanceAccounts').then(function (balanceAccounts) {
                        balanceAccounts = $filter('filter')(balanceAccounts, {isDeleted: false});
                        return $filter('orderBy')(balanceAccounts, ['account','name']);
                    });
                }
            }

        }

        function searchTextChange(text) {

        }

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }

            if (item) {
                vm.balanceAccountId = item.id;
                vm.balanceAccountForm.balanceAccount.$setValidity('invalidBalanceAccount', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.balanceAccountId = null;
                if (vm.searchText) {
                    vm.balanceAccountForm.balanceAccount.$setValidity('invalidBalanceAccount', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.privacy', []);
})();
(function () {
    'use strict';

    angular
        .module('app.privacy')
        .controller('PrivacyFieldListController', PrivacyFieldListController);

    /* @ngInject */
    function PrivacyFieldListController($state, $filter, privacyFields, currentUser, privacyFieldsService) {
        var vm = this;
        vm.data = privacyFieldsService;
        vm.privacyFields = privacyFields || [];

        activate();

        function activate() {
            vm.data.selectedWorkOrderType = $state.params.workOrderType;
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.privacy').controller('EditPrivacyFieldController', EditPrivacyFieldController);

    /* @ngInject */
    function EditPrivacyFieldController($filter, $stateParams, $window, currentUser, privacyFieldsService, loadingService, dataLegacyService) {
        var dataService = dataLegacyService;
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = privacyFieldsService;

        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.onAttachedReportChange = onAttachedReportChange;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            return privacyFieldsService.loadPrivacyField($stateParams.privacyFieldId).then(function (privacyField) {
                vm.privacyField = privacyField;
                return dataService.getByTypeId('PrivacyFieldReports', privacyField.id).then(function (privacyFieldReports) {
                    vm.attachedReports = privacyFieldReports.map(function (privacyFieldReport) {
                        return { id: privacyFieldReport.reportId, name: privacyFieldReport.reportName };
                    });
                    vm.attachedReportDtos = privacyFieldReports;
                    vm.loadingService.setLoadingStatus(false);
                });
            });
        }

        function onAttachedReportChange(action, report) {
            console.log(action + ': ' + report.name);
            if (action === 'added') {
                addPrivacyFieldReport(report);
            } else if (action === 'removed') {
                removePrivacyFieldReport(report);
            }
        }

        function addPrivacyFieldReport(report) {
            if (!vm.attachedReportDtos) vm.attachedReportDtos = [];
            if (!_.some(vm.attachedReportDtos, { reportId: report.id })) {
                var privacyFieldReportDto = privacyFieldsService.getEmptyPrivacyFieldReport();
                privacyFieldReportDto.reportId = report.id;
                privacyFieldReportDto.reportName = report.name;
                privacyFieldReportDto.privacyFieldId = vm.privacyField.id;
                privacyFieldReportDto.privacyFieldText = vm.privacyField.text;
                privacyFieldReportDto.changeState = 1;
                vm.attachedReportDtos.push(privacyFieldReportDto);
            }
        }

        function removePrivacyFieldReport(report) {
            if (!vm.attachedReportDtos) {
                vm.attachedReportDtos = [];
                return;
            }
            var attachedReportDto = _.find(vm.attachedReportDtos, { reportId: report.id });
            if (attachedReportDto.changeState !== 1) {
                attachedReportDto.changeState = 3;
            } else {
                var removedItems = _.remove(vm.attachedReportDtos, function (attachedReport) {
                    return attachedReport.reportId == report.id;
                });
            }
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            privacyFieldsService.savePrivacyField(vm.privacyField).then(function (privacyField) {
                if (!privacyField) privacyField = vm.privacyField;
                // Ensure correct privacyFieldId for all attached reports
                if (vm.attachedReportDtos && vm.attachedReportDtos.length > 0) {
                    _.forEach(vm.attachedReportDtos, function (attachedReportDto) {
                        attachedReportDto.privacyFieldId = privacyField.id;
                        attachedReportDto.privacyFieldText = privacyField.text;
                    });
                    dataService.bulkUpdate('PrivacyFieldReports', vm.attachedReportDtos).then(function () {
                        exitView();
                        vm.loadingService.setLoadingStatus(false);
                    });
                } else {
                    exitView();
                    vm.loadingService.setLoadingStatus(false);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.privacy').controller('PseudomizePartyDialogController', PseudomizePartyDialogController);

    /* @ngInject */
    function PseudomizePartyDialogController($mdDialog, partyService, dataLegacyService, partyDto, loadingService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.partyDto = partyDto;
        vm.loadingService = loadingService;

        activate();

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService.canDelete('Parties', partyDto).then(function (canDelete) {
                vm.canDelete = canDelete;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            vm.loadingService.setLoadingStatus(true);
            partyService.pseudomizeParty(vm.partyDto).then(function (pseudomizedParty) {
                vm.loadingService.setLoadingStatus(false);
                $mdDialog.hide(pseudomizedParty);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.privacy').controller('PreviewConsentFormDialogController', PreviewConsentFormDialogController);

    /* @ngInject */
    function PreviewConsentFormDialogController($mdDialog, baldrisApiLegacyBase, targetForm) {
        var baldrisApiBase = baldrisApiLegacyBase;
        var vm = this;
        vm.referencePersonType = 0;
        vm.workOrderTypeId = null;
        vm.departmentId = null;
        vm.targetForm = targetForm;

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.getPreviewUrl = getPreviewUrl;

        function closeDialog() {
            $mdDialog.hide();
        }

        function getPreviewUrl() {
            if (!vm.workOrderTypeId || !vm.departmentId || angular.isUndefined(vm.referencePersonType) || !angular.isNumber(vm.referencePersonType))
                return null;
            return (
                baldrisApiBase +
                '/api/PrivacyFields/' +
                (targetForm === 'consentForm' ? 'PreviewConsentForm' : 'PreviewLetterOfAttorneyForm') +
                '/' +
                vm.workOrderTypeId +
                '/' +
                vm.departmentId +
                '/' +
                vm.referencePersonType
            );
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.privacy').controller('DeletePartyDialogController', DeletePartyDialogController);

    /* @ngInject */
    function DeletePartyDialogController($mdDialog, partyService, dataLegacyService, partyDto, loadingService) {
        var dataService = dataLegacyService;
        var vm = this;

        vm.loadingService = loadingService;
        vm.partyDto = partyDto;
        vm.canDelete = false;

        activate();

        // Public Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            dataService.canDelete('Parties', partyDto).then(function (canDelete) {
                vm.canDelete = canDelete;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            vm.loadingService.setLoadingStatus(true);
            dataService.deleteItem('Parties', vm.partyDto).then(function (deletedParty) {
                vm.loadingService.setLoadingStatus(false);
                $mdDialog.hide(deletedParty);
            });
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.privacy")
    .component("privacyFieldMultiSelect", {
      bindings: {
        privacyFieldIds: "=",
        privacyFields: "=",
        onUpdate: "&",
        labelText: "@",
        isRequired: "="
      },
      templateUrl: "app/main/privacy/components/privacy-field-multi-select/privacy-field-multi-select.tmpl.html",
      controller: "PrivacyFieldMultiSelectController as vm"
    })
    .controller("PrivacyFieldMultiSelectController", PrivacyFieldMultiSelectController);

  /* @ngInject */
  function PrivacyFieldMultiSelectController($translate, dataService) {
    var vm = this;
    vm.isDisabled = true;
    vm.availabelPrivacyFields = [];

    vm.onChange = onChange;
    vm.getSelectedItems = getSelectedItems;

    vm.$onInit = function() {
      vm.privacyFieldIds = vm.privacyFieldIds || [];
      vm.privacyFields = vm.privacyFields || [];
      dataService.getAll("PrivacyFields").then(function(privacyFields) {
        vm.isDisabled = false;
        vm.availabelPrivacyFields = privacyFields;
        onChange();
      });
    };

    function onChange() {
      if (vm.privacyFieldIds && vm.privacyFieldIds.length > 0) {
        vm.privacyFields = [];
        for (var index = 0; index < vm.availabelPrivacyFields.length; index++) {
          var privacyField = vm.availabelPrivacyFields[index];
          if (vm.privacyFieldIds.indexOf(privacyField.id) > -1) {
            vm.privacyFields.push(privacyField);
          }
        }
      } else {
        vm.privacyFields = [];
      }
      vm.onUpdate({ action: "changed", value: vm.privacyFieldIds });
    }

    function getSelectedItems() {
      if (!vm.privacyFields || vm.privacyFields.length === 0) return vm.labelText;
      return vm.privacyFields.reduce(function(acc, current) {
        if (acc !== "") {
          acc += ", " + current.text;
        } else {
          acc = current.text;
        }

        return acc;
      }, "");
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.obituaryNotice', [

        ]);
})(); 
(function () {
    'use strict';

    angular.module('app.obituaryNotice').controller('RetrieveAdstateEntriesDialogController', RetrieveAdstateEntriesDialogController);

    /* @ngInject */
    function RetrieveAdstateEntriesDialogController($q, $translate, $mdDialog, $rootScope, workOrder, obituaryNotices, obituaryNoticeService) {
        var vm = this;
        vm.isLoading = true;
        vm.saveAttachments = true;
        vm.adstateData = null;
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.getAds = getAds;
        vm.addSsl = addSsl;

        activate();

        ////////////////

        function activate() {
            setLoadingStatus(true);
            obituaryNoticeService.retrieveFromAdstateByWorkOrderId(workOrder.id).then(function (adstateData) {
                vm.adstateData = adstateData;
                vm.convertedAds = getAds();
                setLoadingStatus(false);
            });
        }

        function getAds() {
            if (vm.adstateData && vm.adstateData.length > 0) {
                return vm.adstateData.map(convertAd);
            }
            return [];
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            $mdDialog.hide({ adstateEntries: vm.convertedAds, saveAttachments: vm.saveAttachments });
        }

        function createUpdateList(adstateEntry) {
            if (!obituaryNotices || obituaryNotices.length === 0) {
                adstateEntry.updateList.push({
                    value: 'new',
                    text: 'OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.SAVE_AS_NEW',
                });
                return;
            }
            var matchedIds = [];
            for (var i = 0; i < obituaryNotices.length; i++) {
                var obituaryNotice = obituaryNotices[i];
                if (adstateEntry.id == obituaryNotice.externalId) {
                    adstateEntry.updateList.push({
                        value: obituaryNotice.id,
                        text: $translate.instant('OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.UPDATE_EXISTING', {
                            obituaryNoticeName:
                                obituaryNotice.obituaryNoticeType +
                                (obituaryNotice.supplierName
                                    ? ' (' +
                                      obituaryNotice.supplierName +
                                      (obituaryNotice.publishTime ? ', ' + moment(obituaryNotice.publishTime).format('L') : '') +
                                      ')'
                                    : ''),
                        }),
                    });
                    matchedIds.push(obituaryNotice.id);
                    if (hasAdstateEntryChanged(adstateEntry, obituaryNotice)) {
                        adstateEntry.targetId = obituaryNotice.id;
                    }
                    break;
                }
            }
            if (adstateEntry.updateList.length === 1) {
                // No matching obituary notice found
                for (var i = 0; i < obituaryNotices.length; i++) {
                    var obituaryNotice = obituaryNotices[i];
                    if (!matchedIds.indexOf(obituaryNotice.id) > 0) {
                        adstateEntry.updateList.push({
                            value: obituaryNotice.id,
                            text: $translate.instant('OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.UPDATE_EXISTING', {
                                obituaryNoticeName:
                                    obituaryNotice.obituaryNoticeTypeName +
                                    (obituaryNotice.supplierPartyDisplayName
                                        ? ' (' +
                                          obituaryNotice.supplierPartyDisplayName +
                                          (obituaryNotice.publishTime ? ', ' + moment(obituaryNotice.publishTime).format('L') : '') +
                                          ')'
                                        : ''),
                            }),
                        });
                    }
                }
                adstateEntry.updateList.push({
                    value: 'new',
                    text: 'OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.SAVE_AS_NEW',
                });
            }
        }

        function hasAdstateEntryChanged(adstateEntry, obituaryNotice) {
            return parseInt(adstateEntry.version) !== obituaryNotice.externalVersion;
        }

        function addSsl(uri) {
            return uri.replace('http://', 'https://');
        }

        function convertAd(adstateEntry) {
            var convertedAd = {
                currency: adstateEntry.currency,
                customerContact: adstateEntry.customerContact,
                customerPrice: adstateEntry.customerPrice ? parseFloat(adstateEntry.customerPrice).toFixed(2) : 0.0,
                endCustomerPrice: adstateEntry.endCustomerPrice ? parseFloat(adstateEntry.endCustomerPrice).toFixed(2) : 0.0,
                height: adstateEntry.height,
                id: adstateEntry.id,
                insertionDates: adstateEntry.insertionDates,
                mediaName: adstateEntry.mediaName,
                previewLargeUrl: addSsl(adstateEntry.previewLargeUrl),
                previewUrl: addSsl(adstateEntry.previewUrl),
                pdfUrl: adstateEntry.pdfUrl,
                targetId: 'none',
                status: adstateEntry.status,
                templateCategory: adstateEntry.templateCategory,
                templateName: adstateEntry.templateName,
                version: adstateEntry.version,
                width: adstateEntry.width,
                updateList: [{ value: 'none', text: 'OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.IGNORE' }],
            };
            createUpdateList(convertedAd);
            return convertedAd;
        }
    }
})();

/**
 * Created by JSH on 24.11.2016.
 */

(function () {
    'use strict';

    angular
        .module('app.obituaryNotice')
        .controller('CreateAdstateEntryDialogController', CreateAdstateEntryDialogController);

    /* @ngInject */
    function CreateAdstateEntryDialogController($rootScope, $mdDialog, obituaryNoticeService, deceasedId, $httpParamSerializer, $sce) {
        var vm = this;
        vm.isLoading = true;
        vm.editData = false;
        vm.adstateData = null;
        vm.closeDialog = closeDialog;
        vm.getAdstateUrl = getAdstateUrl;

        activate();

        ////////////////

        function activate() {
            setLoadingStatus(true);
            obituaryNoticeService.getAdstateDataByDeceasedId(deceasedId).then(function (adstateData) {
                vm.ceremonyTime = moment(adstateData.ceremonyTime).format("YYYY-MM-DDTHH:mm:ss");
                vm.adstateData = adstateData;
                setLoadingStatus(false);
            })
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function getAdstateUrl() {
            // AdState object
            var adstateObject = {
                1: vm.adstateData.departmentName,
                4: vm.adstateData.userName,
                7: vm.adstateData.workOrderCode,
                19: vm.adstateData.password
            }

            // Optional values
            if (vm.adstateData.departmentCode) {
                adstateObject['2'] = vm.adstateData.departmentCode;
            }
            if (vm.adstateData.consumerTelephone) {
                adstateObject['5'] = vm.adstateData.consumerTelephone;
            }
            if (vm.adstateData.consumerEmail) {
                adstateObject['6'] = vm.adstateData.consumerEmail;
            }
            if (vm.adstateData.deceasedDateOfBirth) {
                adstateObject['10'] = moment(vm.adstateData.deceasedDateOfBirth).format('DDMMYYYY');
            }
            if (vm.adstateData.deceasedDateOfDeath) {
                adstateObject['11'] = moment(vm.adstateData.deceasedDateOfDeath).format('DDMMYYYY');
            }
            if (vm.adstateData.deceasedPlaceOfDeath) {
                adstateObject['12'] = vm.adstateData.deceasedPlaceOfDeath;
            }
            if (vm.adstateData.ceremonyType) {
                adstateObject['13'] = vm.adstateData.ceremonyType;
            }
            if (vm.adstateData.ceremonyPlace) {
                adstateObject['14'] = vm.adstateData.ceremonyPlace;
            }
            if (vm.adstateData.ceremonyTime) {
                adstateObject['15'] = moment(vm.adstateData.ceremonyTime).format('DDMMYYYY');
            }
            if (vm.adstateData.ceremonyTime) {
                adstateObject['16'] = moment(vm.adstateData.ceremonyTime).format('HHmm');
            }
            if (vm.adstateData.deceasedSpouse) {
                adstateObject['17'] = vm.adstateData.deceasedSpouse;
            }
            if (vm.adstateData.deceasedChildren) {
                adstateObject['18'] = vm.adstateData.deceasedChildren;
            }
            if (vm.adstateData.deceasedFirstName) {
                adstateObject['20'] = vm.adstateData.deceasedFirstName;
            }
            if (vm.adstateData.deceasedLastName) {
                adstateObject['21'] = vm.adstateData.deceasedLastName;
            }
            if (vm.adstateData.deceasedMunicipalityOfResidence) {
                adstateObject['22'] = vm.adstateData.deceasedMunicipalityOfResidence;
            }
            if (vm.adstateData.consumerName) {
                adstateObject['23'] = vm.adstateData.consumerName;
            }
            return $sce.trustAsResourceUrl("https://fe.adstate.net/is_login.php?" + $httpParamSerializer(adstateObject));
        }
    }

})();

/**
 * Created by JSH on 23.11.2016.
 */

(function () {
    'use strict';

    angular
        .module('app.obituaryNotice')
        .component('obituaryNoticeTypeSelect', {
            bindings: {
                obituaryNoticeTypeId: '=',
                obituaryNoticeType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/obituary-notice/components/obituary-notice-type-select/obituary-notice-type-select.tmpl.html',
            controller: 'ObituaryNoticeTypeSelectController as vm',
        })
        .controller('ObituaryNoticeTypeSelectController', ObituaryNoticeTypeSelectController);

    /* @ngInject */
    function ObituaryNoticeTypeSelectController($filter, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.obituaryNoticeTypes = [];
        vm.onChange = onChange;

        // Get options
        dataService.getAll('ObituaryNoticeTypes').then(function (obituaryNoticeTypes) {
            vm.isDisabled = false;
            obituaryNoticeTypes = $filter('filter')(obituaryNoticeTypes, { isProducedExternally: false });
            vm.obituaryNoticeTypes = obituaryNoticeTypes;
        });

        function onChange() {
            if (vm.obituaryNoticeTypeId) {
                for (var index = 0; index < vm.obituaryNoticeTypes.length; index++) {
                    var obituaryNoticeType = vm.obituaryNoticeTypes[index];
                    if (vm.obituaryNoticeTypeId === obituaryNoticeType.id) {
                        vm.obituaryNoticeType = obituaryNoticeType;
                        break;
                    }
                }
            } else {
                vm.obituaryNoticeType = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.obituaryNoticeType);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.obituaryNotice')
        .component('obituaryNoticeCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/obituary-notice/components/obituary-notice-card/obituary-notice-card.tmpl.html',
            controller: 'ObituaryNoticeCardController as vm',
        })
        .controller('ObituaryNoticeCardController', ObituaryNoticeCardController);

    /* @ngInject */
    function ObituaryNoticeCardController($mdDialog, $document, $translate, $mdToast) {
        var vm = this;
        vm.navigateToObituaryNotice = navigateToObituaryNotice;
        vm.deleteObituaryNotice = deleteObituaryNotice;
        vm.getStyle = getStyle;
        //Init
        
        
        function getStyle(field) {
            if (!field.obituaryNoticeFieldType.fontStyle) return null;
            var fieldStyle = {};
            if (field.obituaryNoticeFieldType.fontStyle.size && field.obituaryNoticeFieldType.fontStyle.size > 0) {
                fieldStyle['font-size'] = field.obituaryNoticeFieldType.fontStyle.size + 'px';
            }
            if (field.obituaryNoticeFieldType.fontStyle.style && field.obituaryNoticeFieldType.fontStyle.style.indexOf('bold') > -1) {
                fieldStyle['font-weight'] = 'bold';
            }
            if (field.obituaryNoticeFieldType.fontStyle.style && field.obituaryNoticeFieldType.fontStyle.style.indexOf('italic') > -1) {
                fieldStyle['font-style'] = 'italic';
            }
            return fieldStyle;
        }

        function navigateToObituaryNotice(obituaryNotice, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(obituaryNotice, e);
                } else {
                    $state.go('app.obituaryNotices.byId', { id: grave.id });
                }
            }
        }

        function deleteObituaryNotice(obituaryNotice, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(obituaryNotice, e);
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular.module('app.noteOrTask').controller('EditNoteOrTaskDialogController', EditNoteOrTaskDialogController);

    /* @ngInject */
    function EditNoteOrTaskDialogController($rootScope, $mdDialog, $q, dataService, noteOrTaskService, noteOrTaskOptions, noteOrTaskTabs, noteOrTask) {
        var vm = this;
        vm.noteOrTask = noteOrTask;
        vm.noteOrTaskTabs = noteOrTaskTabs;
        vm.isLoading = false;
        $rootScope.loadingProgress = false;

        //Extract flags to bools for easier control in templates
        vm.isTask = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_TASK.value) > -1;
        vm.isAutogenerated = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_AUTO_GENERATED.value) > -1;
        vm.isFollowUp = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_FOLLOW_UP.value) > -1;
        vm.isIndividualCompleteTask = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_INDIVIDUAL_COMPLETE_TASK.value) > -1;
        vm.isPrivate = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_PRIVATE.value) > -1;
        vm.hasOutcomes = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.HAS_OUTCOMES.value) > -1;
        vm.isStatus = noteOrTask.options && noteOrTask.options.indexOf(noteOrTaskOptions.IS_STATUS.value) > -1;
        vm.isCalendarNoteOrTask = false;
        vm.isWorkOrderNoteOrTask = false;
        vm.isNew = false;

        // METHODS
        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteNoteOrTask = deleteNoteOrTask;
        vm.revalidateDateFields = revalidateDateFields;

        // INIT
        // Determine ApiController
        var controller = 'NoteOrTasks';
        if (
            noteOrTask.dbType === 'Baldris.Entities.Common.WorkOrderNoteOrTask' ||
            noteOrTask.modelType === 'WorkOrderNoteOrTask' ||
            (noteOrTask.objectType && noteOrTask.objectType.indexOf('WorkOrder') > -1)
        ) {
            vm.noteOrTask.modelType = 'WorkOrderNoteOrTask';
            controller = 'NoteOrTasks';
            vm.isWorkOrderNoteOrTask = true;
        } else if (
            noteOrTask.dbType === 'Baldris.Entities.Common.CalendarNoteOrTask' ||
            noteOrTask.modelType === 'CalendarNoteOrTask' ||
            (noteOrTask.objectType && noteOrTask.objectType.indexOf('Calendar') > -1)
        ) {
            vm.noteOrTask.modelType = 'CalendarNoteOrTask';
            controller = 'NoteOrTasks';
            vm.isCalendarNoteOrTask = true;
        }

        if (!noteOrTask.id || noteOrTask.id === '00000000-0000-0000-0000-000000000000') {
            vm.isNew = true;
        }

        // Fetch updateModel
        // if (!vm.isNew) {
        //     dataService.getUpdateModel(controller, noteOrTask.id).then(function (updateModel) {
        //         vm.updateModel = updateModel;
        //         setLoadingStatus(false);
        //     });
        // } else {
        //     vm.updateModel = {
        //         noteOrTask: noteOrTask,
        //         recipients: []
        //     };
        //     setLoadingStatus(false);
        // }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            setLoadingStatus(true);
            if (vm.isNew) {
                dataService.insertItem(controller, vm.noteOrTask).then(function (insertedNoteOrTask) {
                    insertedNoteOrTask.recipients = vm.noteOrTask.recipients;
                    vm.noteOrTask = insertedNoteOrTask;
                    saveRecipients(vm.noteOrTask).then(function (updatedNoteOrTask) {
                        setLoadingStatus(false);
                        $mdDialog.hide(updatedNoteOrTask);
                    });
                });
            } else {
                // Set modeltype for update command
                if (vm.noteOrTask.objectType && vm.noteOrTask.objectType.indexOf('WorkOrder') > -1) {
                    vm.noteOrTask.modelType = 'WorkOrderNoteOrTask';
                } else {
                    vm.noteOrTask.modelType = 'CalendarNoteOrTask';
                }
                dataService.updateItem(controller, vm.noteOrTask).then(function () {
                    saveRecipients(vm.noteOrTask).then(function (updatedNoteOrTask) {
                        setLoadingStatus(false);
                        $mdDialog.hide(updatedNoteOrTask);
                    });
                });
            }
        }

        function saveRecipients(noteOrTask) {
            if (vm.noteOrTask.recipients && vm.noteOrTask.recipients.length > 0) {
                var promises = dataService.createBulkPromises('NoteOrTaskUsers', vm.noteOrTask.recipients, 'noteOrTaskId', noteOrTask.id);
                return $q.all(promises).then(function () {
                    return dataService.getById(controller, noteOrTask.id);
                });
            }
            return $q.when(noteOrTask);
        }

        function deleteNoteOrTask() {
            if (vm.isNew) {
                closeDialog();
            } else {
                setLoadingStatus(true);
                dataService.deleteItem(controller, vm.noteOrTask).then(function () {
                    // Make sure changeState is set to delete
                    vm.noteOrTask.changeState = 3;
                    setLoadingStatus(false);
                    $mdDialog.hide(vm.noteOrTask);
                });
            }
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function revalidateDateFields() {
            //console.info(vm.editNoteOrTaskForm);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('statusList', {
            bindings: {
                collection: '=',
                externalOrderId: '=',
                workOrderId: '=',
                api: '=?',
                hideAddButton: '=',
                onOpen: '=',
                onDelete: '='
            },
            templateUrl: 'app/main/note-or-task/components/status-list/status-list.tmpl.html',
            controller: 'StatusListController as vm',
        })
        .controller('StatusListController', StatusListController);

    /* @ngInject */
    function StatusListController($mdDialog, $document, noteOrTaskService) {
        var vm = this;

        // Data

        // METHODS
        vm.openEditDialog = openEditDialog;
        vm.toggleTask = toggleTask;

        // INIT
        vm.$onInit = function () {

        }

        function openEditDialog(noteOrTask, e) {
            $mdDialog.show({
                controller: 'EditNoteOrTaskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/note-or-task/dialogs/edit-note-or-task-dialog/edit-note-or-task-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    noteOrTask: angular.copy(noteOrTask)
                },
                clickOutsideToClose: true
            }).then(function (updatedData) {

            });
        }

        function toggleTask(task, e) {
            noteOrTaskService.canToggleTask(task).then(function (canToggle) {
                if (canToggle) {
                    noteOrTaskService.toggleTask(task).then(function (updatedTask) {
                        task = updatedTask;
                        //Find the task and update it with the updatedTask
                        for (var index = 0; index < vm.collection.length; index++) {
                            var element = vm.collection[index];
                            if (element.id === updatedTask.id) {
                                element.isCompleted = updatedTask.isCompleted;
                                element.completedBySerialized = updatedTask.completedBySerialized;
                                element.firstCompleted = updatedTask.firstCompleted;
                                break;
                            }
                        }
                    });
                } else {

                }
            })
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('notesAndTasksSummary', {
            bindings: {
                completedCount: '=',
                uncompletedCount: '=',
                notesCount: '='
            },
            templateUrl: 'app/main/note-or-task/components/notes-and-tasks-summary/notes-and-tasks-summary.tmpl.html',
            controller: 'NotesAndTasksSummaryController as vm',
        })
        .controller('NotesAndTasksSummaryController', NotesAndTasksSummaryController);

    /* @ngInject */
    function NotesAndTasksSummaryController() {
        var vm = this;

        vm.getProgressValue = getProgressValue;

        function getProgressValue() {
            if (vm.completedCount + vm.uncompletedCount === 0) {
                return 0;
            }
            return Math.round(vm.completedCount / (vm.completedCount + vm.uncompletedCount) * 100);
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('noteOrTaskUserMultiSelect', {
            bindings: {
                targetCollection: '=',
                onAdd: '=',
                onRemove: '=',
                hasComplete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/note-or-task/components/note-or-task-user-multi-select/note-or-task-user-multi-select.tmpl.html',
            controller: 'NoteOrTaskUserMultiSelectController as vm',
        })
        .controller('NoteOrTaskUserMultiSelectController', NoteOrTaskUserMultiSelectController);

    /* @ngInject */
    function NoteOrTaskUserMultiSelectController(logger, dataService, noteOrTaskService, $filter, gravatarService) {
        var vm = this;

        vm.selectedUsers = [];
        vm.selectedUser = null;
        vm.currentUser = null;
        vm.searchTextUser = null;
        vm.userSearch = userSearch;
        vm.transformChip = transformChip;
        vm.onAddUser = onAddUser;
        vm.onRemoveUser = onRemoveUser;
        vm.onSelectUser = onSelectUser;
        vm.toggleCompleted = toggleCompleted;

        //INIT
        vm.$onInit = function () {
            //Create faux selectedUsers
            if (vm.targetCollection && vm.targetCollection.length > 0) {
                vm.selectedUsers = vm.targetCollection.sort(function (a,b) {
                    return a.sortOrder - b.sortOrder;
                }).map(function (noteOrTaskUser) {
                    return {
                        id: noteOrTaskUser.userId,
                        user: noteOrTaskUser.user,
                        userEmail: noteOrTaskUser.userEmail,
                        userImageUrl: noteOrTaskUser.userImageUrl,
                        hasCompletedTask: noteOrTaskUser.hasCompletedTask,
                        image: noteOrTaskUser.userProfileImageFilepath ? noteOrTaskUser.userImageUrl + '?preset=baldris-thumb-40': gravatarService.url(noteOrTaskUser.userEmail)
                    };
                });
            }
        }

        //userSearch
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return {
                        id: chip.id,
                        user: chip.displayName,
                        userEmail: chip.email,
                        userImageUrl: chip.profileImageUrl,
                        hasCompletedTask: false,
                        image: chip.image
                };
            }
            // Otherwise, create a new one
            return { name: chip, type: 'new' }
        }
        /**
         * Search for users.
         */
        function userSearch(query) {
            return dataService.search('BaldrisUsers', query).then(function (users) {
                users = users.map(function (baldrisUser) {
                    // baldrisUser.id = noteOrTaskUser.userId;
                    // baldrisUser.userName = noteOrTaskUser.userEmail;
                    // baldrisUser.email = noteOrTaskUser.userEmail;
                    // baldrisUser.phoneNumber = null;
                    // baldrisUser.dateOfBirth = null;
                    // baldrisUser.displayName = noteOrTaskUser.userDisplayName;
                    // baldrisUser.profileImageId = null;
                    // baldrisUser.profileImageFilepath = noteOrTaskUser.userProfileImageFilepath;
                    // baldrisUser.isDeleted = false;
                    // baldrisUser.hasCompletedTask = noteOrTaskUser.hasCompletedTask;
                    // Get correct imagePath
                    baldrisUser.image = baldrisUser.profileImageUrl ? baldrisUser.profileImageUrl + '?preset=baldris-thumb-40' : gravatarService.url(baldrisUser.email);
                    return baldrisUser;
                });
                return $filter('orderBy')(users, 'displayName');
            });
        }

        function toggleCompleted(noteOrTaskUser) {
            if (noteOrTaskUser) {
                noteOrTaskUser.hasCompletedTask = !noteOrTaskUser.hasCompletedTask;
                noteOrTaskUser.completedTaskDate = noteOrTaskUser.hasCompletedTask ? new Date() : null;
                noteOrTaskUser.changeState = noteOrTaskUser.changeState !== 1 ? 2 : 1;
                // Find the user in the chip-collection and set accordingly
                for (var i = 0; i < vm.selectedUsers.length; i++) {
                    var selectedUser = vm.selectedUsers[i];
                    if (selectedUser.id === noteOrTaskUser.userId) {
                        selectedUser.hasCompletedTask = noteOrTaskUser.hasCompletedTask;
                        break;
                    }
                }
            }
        }

        function onSelectUser(user) {
            if (user) {
                //logger.info('Selected: ' + user.displayName);
                for (var index = 0; index < vm.targetCollection.length; index++) {
                    var element = vm.targetCollection[index];
                    if (element.userId === user.id) {
                        vm.currentUser = element;
                        // Set changeState
                        if (!vm.currentUser.id) {
                            vm.currentUser.changeState = 2;
                        }
                        break;
                    }
                }
            }
        }

        function onAddUser(user) {
            if (!vm.targetCollection) {
                vm.targetCollection = [];
            }
            var noteOrTaskUser = noteOrTaskService.getEmptyNoteOrTaskUser();
            noteOrTaskUser.userId = user.id;
            noteOrTaskUser.user = user.user;
            noteOrTaskUser.userEmail = user.userEmail;
            noteOrTaskUser.userImageUrl = user.userImageUrl;
            if (vm.targetCollection.length > 0) {
                //Set sortOrder to highest + 10
                noteOrTaskUser.sortOrder = Math.max.apply(Math, vm.targetCollection.map(function (o) { return o.sortOrder; })) + 10;
            }
            vm.targetCollection.push(noteOrTaskUser);
            //logger.info('Added: ' + user.displayName);
            if (angular.isFunction(vm.onAdd)) {
                vm.onAdd(noteOrTaskUser);
            }
        }

        function onRemoveUser(user) {
            //get user from targetCollection
            angular.forEach(vm.targetCollection, function (noteOrTaskUser) {
                if (noteOrTaskUser.userId === user.id) {
                    if (!noteOrTaskUser.id) {
                        //noteOrTaskUser hasn't been saved and can safely be removed from the array
                        var index = vm.targetCollection.indexOf(noteOrTaskUser);
                        vm.targetCollection.splice(index, 1);
                    } else {
                        //noteOrTaskUser is saved in the database and must be marked as removed
                        noteOrTaskUser.changeState = 3;
                    }
                    if (angular.isFunction(vm.onAdd)) {
                        vm.onRemove(noteOrTaskUser);
                    }
                }
            });
            logger.info('Removed: ' + user.displayName);
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('noteOrTaskTypeSelect', {
            bindings: {
                noteOrTaskTypeId: '<ngModel',
                labelText: '@',
                isDisabled: '<ngDisabled',
                isRequired: '<ngRequired',
                onUpdate: '&',
            },
            templateUrl: 'app/main/note-or-task/components/note-or-task-type-select/note-or-task-type-select.tmpl.html',
            controller: 'NoteOrTaskTypeSelectController as vm',
        })
        .controller('NoteOrTaskTypeSelectController', NoteOrTaskTypeSelectController);

    /* @ngInject */
    function NoteOrTaskTypeSelectController(noteOrTaskService) {
        var vm = this;

        vm.isDisabled = true;
        vm.noteOrTaskTypes = [];
        vm.searchTerm = '';

        vm.onChange = onChange;
        vm.clearSearchTerm = clearSearchTerm;

        //INIT
        vm.$onInit = function () {
            // Get options
            noteOrTaskService.getAllNoteOrTaskTypes().then(function (noteOrTaskTypes) {
                vm.isDisabled = false;
                vm.noteOrTaskTypes = noteOrTaskTypes;
            });
        };

        function onChange() {
            vm.onUpdate({ $noteOrTaskTypeId: vm.noteOrTaskTypeId, $noteOrTaskType: findNoteOrTaskType(vm.noteOrTaskTypeId) });
        }

        function findNoteOrTaskType(noteOrTaskTypeId) {
            if (noteOrTaskTypeId || !vm.noteOrTaskTypes || vm.noteOrTaskType.length === 0) {
                return null;
            }
            return vm.noteOrTaskTypes.find(function (noteOrTaskType) {
                return noteOrTaskType.id === noteOrTaskTypeId;
            });
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .component('noteOrTaskList', {
            bindings: {
                collection: '=',
                calendarStartDate: '=',
                workOrderId: '=',
                tabFilter: '@',
                inheritanceType: '@',
                api: '=?',
                hideAddButton: '=',
                createDateGroups: '<',
                showWorkOrderInfo: '<',
                hideStatuses: '<',
            },
            templateUrl: 'app/main/note-or-task/components/note-or-task-list/note-or-task-list.tmpl.html',
            controller: 'NoteOrTaskListController as vm',
        })
        .controller('NoteOrTaskListController', NoteOrTaskListController);

    /* @ngInject */
    function NoteOrTaskListController($scope, $filter, $mdDialog, $document, dataService, noteOrTaskOptions, noteOrTaskViewService, noteOrTaskService) {
        var vm = this;
        vm.toggleTask = toggleTask;
        vm.openEditDialog = openEditDialog;
        vm.addNote = addNote;
        vm.addTask = addTask;
        vm.getIsoDate = getIsoDate;
        vm.noteOrTaskGroups = [];
        vm.selectedMode = 'md-fling';

        vm.$onInit = function () {
            // Define api
            vm.api = {
                addNote: addNote,
                addTask: addTask,
            };
            //INIT
            createNoteOrTaskGroups();
            vm.isOpen = false;
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.tabFilter) {
                if (changesObj.tabFilter.currentValue != changesObj.tabFilter.previousValue) {
                    //createNoteOrTaskGroups();
                    console.log('onChanges fired');
                }
            }
        };

        vm.$postLink = function () {
            $scope.$watch(
                function () {
                    return vm.collection;
                },
                function (newValue, oldValue) {
                    if (!angular.equals(newValue, oldValue)) {
                        // Create Groups
                        //createNoteOrTaskGroups();
                        console.log('postLink watch fired');
                    }
                },
                true
            );
        };

        function toggleTask(task) {
            noteOrTaskService.canToggleTask(task).then(function (canToggle) {
                if (canToggle) {
                    noteOrTaskService.toggleTask(task).then(function (updatedTask) {
                        //task = updatedTask;
                        findAndReplaceInAllGroups(task, updatedTask);
                        //createNoteOrTaskGroups();
                    });
                } else {
                }
            });
        }

        function findAndReplaceInAllGroups(task, updatedTask) {
            //Find the task in main collection and replace it with the updatedTask

            removeFromCollection(task, vm.collection);
            vm.collection.push(updatedTask);
            var hasBeenPushed = false;
            //Find the task in dategroups and replace it with the updatedTask

            for (var index = 0; index < vm.noteOrTaskGroups.length; index++) {
                var group = vm.noteOrTaskGroups[index];
                removeFromCollection(task, group.noteOrTasks);
                // Check if we have to add updatedTask
                if (group.isCompletedGroup && updatedTask.isCompleted) {
                    group.noteOrTasks.push(updatedTask);
                    hasBeenPushed = true;
                }
                if (group.isUncompletedGroup && !updatedTask.isCompleted) {
                    group.noteOrTasks.push(updatedTask);
                    hasBeenPushed = true;
                }
                if (group.dateGroups && group.dateGroups.length > 0) {
                    for (var dateIndex = 0; dateIndex < group.dateGroups.length; dateIndex++) {
                        var dateGroup = group.dateGroups[dateIndex];
                        var removeIndex = removeFromCollection(task, dateGroup.noteOrTasks);
                        if (removeIndex === -1) {
                        }
                    }
                }
                if (!hasBeenPushed) {
                }
            }
        }

        function removeFromCollection(task, collection) {
            if (task && task.id && collection && collection.length > 0) {
                for (var index = 0; index < collection.length; index++) {
                    var current = collection[index];
                    if (current.id === task.id) {
                        collection.splice(index, 1);
                        return index;
                    }
                }
            }
            return -1;
        }

        function createNoteOrTaskGroups() {
            if (vm.hideStatuses) {
                vm.collection = $filter('filter')(vm.collection, function (value, index, array) {
                    return value.options.indexOf('isStatus') === -1;
                });
            }
            if (vm.tabFilter) {
                vm.noteOrTaskGroups = createNoteOrTaskGroupsByTabName(vm.collection, vm.tabFilter, vm.createDateGroups);
            } else {
                vm.noteOrTaskGroups = noteOrTaskViewService.createNoteOrTaskGroups(vm.collection, false, vm.createDateGroups);
            }
        }

        function createNoteOrTaskGroupsByTabName(collection, tabName, createDateGroups) {
            //filter by tabName
            var filteredNoteOrTasks = $filter('noteOrTaskInTab')(collection, tabName);

            //Create groups
            return noteOrTaskViewService.createNoteOrTaskGroups(filteredNoteOrTasks, false, createDateGroups);
        }

        function openEditDialog(noteOrTask, e) {
            $mdDialog
                .show({
                    controller: 'EditNoteOrTaskDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/note-or-task/dialogs/edit-note-or-task-dialog/edit-note-or-task-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        noteOrTask: noteOrTask,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (noteOrTask) {
                    if (noteOrTask) {
                        if (noteOrTask.changeState === 3 || !isNoteInCurrentTab(noteOrTask) || !isNoteOrTaskInCurrentRange(noteOrTask)) {
                            findAndRemoveNoteOrTask(noteOrTask);
                            createNoteOrTaskGroups();
                        } else {
                            findAndReplaceNoteOrTask(noteOrTask);
                            createNoteOrTaskGroups();
                        }
                    }
                });
        }

        function findAndReplaceNoteOrTask(noteOrTask) {
            //Find the noteOrTask and replace it with the given noteOrTask
            var matchFound = false;
            for (var index = 0; index < vm.collection.length; index++) {
                var element = vm.collection[index];
                if (element.id === noteOrTask.id) {
                    matchFound = true;
                    vm.collection.splice(index, 1);
                    vm.collection.push(noteOrTask);
                    break;
                }
            }
            if (!matchFound) {
                vm.collection.push(noteOrTask);
            }
        }

        function findAndRemoveNoteOrTask(noteOrTask) {
            //Find the noteOrTask and remove it
            for (var index = 0; index < vm.collection.length; index++) {
                var element = vm.collection[index];
                if (element.id === noteOrTask.id) {
                    vm.collection.splice(index, 1);
                    break;
                }
            }
        }

        function isNoteOrTaskInCurrentRange(noteOrTask) {
            if (!vm.calendarStartDate) return true; // If range is not defined, return true
            var startDate = moment(noteOrTask.startTime).startOf('day');
            var endDate = moment(noteOrTask.endTime).endOf('day');
            return moment(vm.calendarStartDate).isBetween(startDate, endDate, null, '[]');
        }

        function isNoteInCurrentTab(noteOrTask) {
            if (!vm.tabFilter) return true; // If tabFilter is not defined, return true
            return noteOrTask.tab == vm.tabFilter;
        }

        function getEmptyNoteOrTask() {
            var noteOrTask = null;
            if (vm.inheritanceType === 'Calendar') {
                noteOrTask = noteOrTaskService.getEmptyCalendarNoteOrTask();
                if (vm.calendarStartDate) {
                    noteOrTask.startTime = moment(vm.calendarStartDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    noteOrTask.endTime = moment(vm.calendarStartDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                } else {
                    noteOrTask.startTime = moment(new Date()).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    noteOrTask.endTime = moment(new Date()).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                }
            } else if (vm.inheritanceType === 'WorkOrder') {
                noteOrTask = noteOrTaskService.getEmptyWorkOrderNoteOrTask();
                noteOrTask.workOrderId = vm.workOrderId;
            } else {
                // Assume it's WorkOrder
                noteOrTask = noteOrTaskService.getEmptyWorkOrderNoteOrTask();
                noteOrTask.workOrderId = vm.workOrderId;
            }
            noteOrTask.tab = vm.tabFilter;
            return noteOrTask;
        }

        function addNote(e) {
            var noteOrTask = getEmptyNoteOrTask();

            openEditDialog(noteOrTask, e);
        }

        function addTask(e) {
            var noteOrTask = getEmptyNoteOrTask();
            noteOrTask.options = 'isTask';
            openEditDialog(noteOrTask, e);
        }

        function getIsoDate(date) {
            if (date) {
                return moment(date).format('YYYY-MM-DD');
            }
            return null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.grooming', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.grooming')
        .component('groomingTypeSelect', {
            bindings: {
                groomingTypeId: '=',
                groomingType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '='
            },
            templateUrl: 'app/main/grooming/components/grooming-type-select/grooming-type-select.tmpl.html',
            controller: 'GroomingTypeSelectController as vm',
        })
        .controller('GroomingTypeSelectController', GroomingTypeSelectController);

    /* @ngInject */
    function GroomingTypeSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.groomingTypes = [];
        vm.onChange = onChange;
        
        // Get options
        dataService.getAll("GroomingTypes").then(function (groomingTypes) {
            vm.isDisabled = false;
            vm.groomingTypes = groomingTypes;
        });

        function onChange() {
            if (vm.groomingTypeId) {
                for (var index = 0; index < vm.groomingTypes.length; index++) {
                    var groomingType = vm.groomingTypes[index];
                    if (vm.groomingTypeId === groomingType.id) {
                        vm.groomingType = groomingType;
                        break;
                    }
                }
            } else {
                vm.groomingType = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.groomingType);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.grooming')
        .component('groomingCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/grooming/components/grooming-card/grooming-card.tmpl.html',
            controller: 'GroomingCardController as vm',
        })
        .controller('GroomingCardController', GroomingCardController);

    /* @ngInject */
    function GroomingCardController($mdDialog, $document, $translate, $mdToast, maritalStatusOptions) {
        var vm = this;

        vm.getForegroundColor = getForegroundColor;
        vm.showEditGroomingDialog = showEditGroomingDialog;
        vm.navigateToGrooming = navigateToGrooming;
        vm.deleteGrooming = deleteGrooming;
        //Init

        function getForegroundColor(color) {
            var colors = tinycolor(color).monochromatic();

            colors.map(function (t) { return t.toHexString(); }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
            return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
        }

        function showEditGroomingDialog(deceased, e) {
            $mdDialog.show({
                controller: 'EditDeceasedDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/deceased/components/edit-deceased-dialog/edit-deceased-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    deceased: angular.copy(deceased),
                    event: e
                }
            }).then(function (updatedDeceased) {
                if (updatedDeceased) {
                    vm.baldrisModel = updatedDeceased;
                    $mdToast.show($mdToast.simple().textContent(savedText));
                }
            });
        }

        function navigateToGrooming() {
            if (angular.isFunction(vm.onOpen)) {
                vm.onOpen(vm.baldrisModel);
            }
        }

        function deleteGrooming() {
            if (angular.isFunction(vm.onDelete)) {
                vm.onDelete(vm.baldrisModel);
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.grave', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.grave')
        .component('graveTypeSelect', {
            bindings: {
                graveTypeId: '=',
                graveType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                displayText: '=',
            },
            templateUrl: 'app/main/grave/components/grave-type-select/grave-type-select.tmpl.html',
            controller: 'GraveTypeSelectController as vm',
        })
        .controller('GraveTypeSelectController', GraveTypeSelectController);

    /* @ngInject */
    function GraveTypeSelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.graveTypes = [];
        vm.onChange = onChange;

        //INIT
        vm.$onInit = function () {
            // Get options
            dataService.getAll('GraveTypes').then(function (graveTypes) {
                vm.isDisabled = false;
                vm.graveTypes = graveTypes.filter(function (value) {
                    return !value.isDeleted || value.id === vm.graveTypeId;
                });
                // Select type if id is provided
                onChange(true);
            });
        };

        function onChange(isInternal) {
            if (vm.graveTypeId) {
                for (var index = 0; index < vm.graveTypes.length; index++) {
                    var graveType = vm.graveTypes[index];
                    if (vm.graveTypeId === graveType.id) {
                        vm.graveType = graveType;
                        if (angular.isDefined(vm.displayText)) {
                            vm.displayText = graveType.name;
                        }
                        if (angular.isFunction(vm.onSelected)) {
                            vm.onSelected(graveType);
                        }
                        break;
                    }
                }
            } else {
                vm.graveType = null;
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
                if (angular.isFunction(vm.onSelected)) {
                    vm.onSelected(null);
                }
            }
            if (!isInternal && angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.graveType);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.grave')
        .component('graveCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '='
            },
            templateUrl: 'app/main/grave/components/grave-card/grave-card.tmpl.html',
            controller: 'GraveCardController as vm',
        })
        .controller('GraveCardController', GraveCardController);

    /* @ngInject */
    function GraveCardController($mdDialog, clipboard, $translate, toastService) {
        var vm = this;
        vm.navigateToGrave = navigateToGrave;
        vm.deleteGrave = deleteGrave;
        vm.copyToClipboard = copyToClipboard;

        function navigateToGrave(grave) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(grave);
                } else {
                    $state.go('app.graves.byId', { id: grave.id });
                }
            }
        }

        function deleteGrave(grave) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(grave);
                }
            }
        }

        function copyToClipboard(e) {
            if (e) {
                e.stopPropagation();
            }
            if (!clipboard.supported) {
                toastService.error($translate.instant('COMMON.DATA.NO_CLIPBOARD_SUPPORT'), $translate.instant('COMMON.DATA.UNSUPPORTED'));
            } else {
                clipboard.copyText(vm.baldrisModel.temporaryMarkerName || vm.baldrisModel.deceasedFullNames);
                toastService.info($translate.instant('GRAVES.EDIT_GRAVE.NAME_COPIED'), $translate.instant('COMMON.DATA.COPIED'));
            }

        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.flowerOrder', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.flowerOrder')
        .controller('EditFlowerDialogController', EditFlowerDialogController);

    /* @ngInject */
    function EditFlowerDialogController(
        $mdDialog,
        $translate,
        updateModel,
        flowerOrderService,
        workOrderId,
        dataService
    ) {
        var vm = this;
        vm.isNew = false;
        vm.isLoading = true;

        activate();

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.onRibbonChanged = onRibbonChanged;
        vm.onFlowerProductSelected = onFlowerProductSelected;
        vm.deleteRibbon = deleteRibbon;
        vm.addRibbon = addRibbon;
        vm.addRibbonName = addRibbonName;
        vm.deleteFlower = deleteFlower;

        vm.nameSuggestions = [];

        var andString;

        ////////////////

        function activate() {
            andString = $translate.instant('COMMON.DATA.AND_DELIMITER');
            vm.updateModel = updateModel;

            if (
                !vm.updateModel.flower.id ||
                vm.updateModel.flower.id ===
                    '00000000-0000-0000-0000-000000000000'
            ) {
                vm.isNew = true;
            }
            if (workOrderId) {
                dataService
                    .getByWorkOrderId('ReferencePersons', workOrderId, false, {
                        overridePseudomization: true,
                    })
                    .then(function (workOrderReferencePersons) {
                        if (
                            workOrderReferencePersons &&
                            workOrderReferencePersons.length > 0
                        ) {
                            vm.nameSuggestions = workOrderReferencePersons.map(
                                function (referencePerson) {
                                    var suggestion = {
                                        name: referencePerson.firstName,
                                        relation:
                                            referencePerson.familyRelation,
                                    };

                                    return suggestion;
                                }
                            );
                        }
                        vm.isLoading = false;
                    });
            } else {
                vm.isLoading = false;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.updateModel.flower.id) {
                vm.updateModel.flower.changeState = 2;
            }
            $mdDialog.hide(vm.updateModel);
        }

        function deleteFlower() {
            vm.updateModel.shouldDelete = true;
            $mdDialog.hide(vm.updateModel);
        }

        function onFlowerProductSelected(product) {
            if (product && product.id !== vm.updateModel.flower.productId) {
                if (!vm.updateModel.flower.amount)
                    vm.updateModel.flower.amount = 1;
                vm.updateModel.flower.name = product.name;
                vm.updateModel.flower.historicalPrice = product.price;
            }
        }

        function onRibbonChanged(ribbon) {
            if (ribbon.id) {
                ribbon.changeState = 2;
            }
        }

        function deleteRibbon(ribbon) {
            if (!ribbon.id) {
                var ribbonIndex = vm.updateModel.ribbons.indexOf(ribbon);
                vm.updateModel.ribbons.splice(ribbonIndex, 1);
            } else {
                ribbon.changeState = 3;
            }
        }

        function addRibbon() {
            var ribbon = flowerOrderService.getEmptyFlowerRibbon();
            ribbon.flowerId = vm.updateModel.flower.id;
            // Get previously sortOrder
            if (vm.updateModel.ribbons && vm.updateModel.ribbons.length > 0) {
                ribbon.sortOrder =
                    Math.max.apply(
                        Math,
                        vm.updateModel.ribbons.map(function (ev) {
                            return ev.sortOrder || 0;
                        })
                    ) + 10;
            } else {
                ribbon.sortOrder = 0;
            }
            vm.updateModel.ribbons.push(ribbon);
        }

        function addRibbonName(nameSuggestion, ribbon) {
            if (
                ribbon &&
                ribbon.names &&
                ribbon.names.indexOf(nameSuggestion.name) === -1
            ) {
                // replace last ' and ' with comma
                if (ribbon && ribbon.names.indexOf(andString) > -1) {
                    var andSplit = ribbon.names.split(andString);
                    ribbon.names = andSplit.join(', ');
                }
                if (ribbon.names) {
                    ribbon.names += andString + nameSuggestion.name;
                } else {
                    ribbon.names = nameSuggestion.name;
                }
            } else if (ribbon && !ribbon.names) {
                ribbon.names = nameSuggestion.name;
            } else if (ribbon && ribbon.names) {
                // remove name from string
                // replace last ' and ' with comma
                if (ribbon && ribbon.names.indexOf(andString) > -1) {
                    var andSplit = ribbon.names.split(andString);
                    ribbon.names = andSplit.join(', ');
                }
                if (ribbon && ribbon.names.indexOf(', ') > -1) {
                    ribbon.names = ribbon.names.replace(
                        ', ' + nameSuggestion.name,
                        ''
                    );
                    ribbon.names = ribbon.names.replace(
                        nameSuggestion.name + ', ',
                        ''
                    );
                } else {
                    ribbon.names = ribbon.names.replace(
                        nameSuggestion.name,
                        ''
                    );
                }
                if (ribbon && ribbon.names.indexOf(', ') > -1) {
                    // replace last comma with ' and '
                    var commaSplit = ribbon.names.split(', ');
                    ribbon.names =
                        commaSplit.slice(0, -1).join(', ') +
                        andString +
                        commaSplit[commaSplit.length - 1];
                }
            }
            console.log('Added ' + nameSuggestion.name);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.flowerOrder')
        .component('flowerOrderCard', {
            bindings: {
                baldrisModel: '<',
                onOpen: '<',
                onDelete: '<',
                disableLinks: '<'
            },
            templateUrl: 'app/main/flower-order/components/flower-order-card/flower-order-card.tmpl.html',
            controller: 'FlowerOrderCardController as vm',
        })
        .controller('FlowerOrderCardController', FlowerOrderCardController);

    /* @ngInject */
    function FlowerOrderCardController() {
        var vm = this;

        vm.$onInit = function () {
            vm.navigateToFlowerOrder = navigateToFlowerOrder;
            vm.deleteFlowerOrder = deleteFlowerOrder;
        }

        /*///////////*/

        function navigateToFlowerOrder(flowerOrder, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(flowerOrder);
                } else {
                    $state.go('app.ceremony.byId', { id: ceremony.id });
                }
            }
        }

        function deleteFlowerOrder(flowerOrder, e) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(flowerOrder, e);
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular.module('app.externalOrder').factory('headstoneOrderService', headstoneOrderService);

    /* @ngInject */
    function headstoneOrderService($mdDialog, $document) {
        var service = {
            getEmptyHeadstoneOrder: getEmptyHeadstoneOrder,
            getEmptyHeadstoneOrderInscription: getEmptyHeadstoneOrderInscription,
            getEmptyHeadstoneOrderAddition: getEmptyHeadstoneOrderAddition,
            showEditHeadstoneInscriptionDialog: showEditHeadstoneInscriptionDialog,
            showEditHeadstoneAdditionDialog: showEditHeadstoneAdditionDialog,
            showEditGraveInfoDialog: showEditGraveInfoDialog,
        };

        return service;

        function getEmptyHeadstoneOrder() {
            return {
                isNewHeadstone: false,
                headstoneHeight: null,
                headstoneWidth: null,
                headstoneDepth: null,
                headstoneWeight: null,
                shouldReserveSpaceForFurtherInscriptions: false,
                estimatedFurtherInscriptions: null,
                estimatedDeliveryTime: null,
                productId: null,
                productAmount: null,
                overriddenPrice: null,
                overriddenName: null,
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                supplierId: null,
                workOrderId: null,
                externalOrderTypeId: null,
                deliveryTime: null,
                deliveryLocationId: null,
                alternateDeliveryAddressId: null,
                deceasedId: null,
                calendarEventId: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
            };
        }

        function getEmptyHeadstoneOrderInscription() {
            return {
                text: null,
                remarks: null,
                sortOrder: 0,
                productId: null,
                productAmount: null,
                overriddenPrice: null,
                overriddenName: null,
                inscriptionTypeId: null,
                inscriptionFormId: null,
                inscriptionColorId: null,
                inscriptionFontId: null,
                imageId: null,
                headstoneOrderId: null,
            };
        }

        function getEmptyHeadstoneOrderAddition() {
            return {
                description: null,
                remarks: null,
                sortOrder: 0,
                productId: null,
                productAmount: null,
                overriddenPrice: null,
                overriddenName: null,
                headstoneOrderId: null,
            };
        }

        function showEditHeadstoneInscriptionDialog(e, headstoneOrderInscription, workOrderId, deceasedId) {
            return $mdDialog.show({
                controller: 'EditHeadstoneInscriptionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/external-order/headstone-order/dialogs/edit-headstone-inscription-dialog/edit-headstone-inscription-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    headstoneInscription: headstoneOrderInscription,
                    workOrderId: workOrderId,
                    deceasedId: deceasedId,
                },
                clickOutsideToClose: true,
            });
        }

        function showEditHeadstoneAdditionDialog(e, headstoneOrderAddition) {
            return $mdDialog.show({
                controller: 'EditHeadstoneAdditionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/external-order/headstone-order/dialogs/edit-headstone-addition-dialog/edit-headstone-addition-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    headstoneAddition: headstoneOrderAddition,
                },
                clickOutsideToClose: true,
            });
        }

        function showEditGraveInfoDialog(e, grave, workOrderId) {
            return $mdDialog.show({
                controller: 'EditGraveInfoDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/external-order/headstone-order/dialogs/edit-grave-info-dialog/edit-grave-info-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    grave: grave,
                    workOrderId: workOrderId,
                },
                clickOutsideToClose: true,
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.externalOrder').service('editHeadstoneOrderService', editHeadstoneOrderService);

    /* @ngInject */
    function editHeadstoneOrderService($q, headstoneOrderService, dataService, graveService, editCustomFieldService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;
        self.noteOrTaskFdos = [];

        self.loadHeadstoneOrder = loadHeadstoneOrder;
        self.saveHeadstoneOrder = saveHeadstoneOrder;
        self.openEditHeadstoneInscriptionDialog = openEditHeadstoneInscriptionDialog;
        self.openEditHeadstoneAdditionDialog = openEditHeadstoneAdditionDialog;
        self.onProductChanged = onProductChanged;
        self.openEditGraveInfoDialog = openEditGraveInfoDialog;

        function loadHeadstoneOrder(headstoneOrderId, workOrderId, workOrderDeceased, externalOrderType) {
            reset();
            if (!headstoneOrderId || headstoneOrderId.toLowerCase() === 'new') {
                var promises = [];
                self.isNew = true;
                self.updateModel = {
                    headstoneOrder: headstoneOrderService.getEmptyHeadstoneOrder(),
                    headstoneOrderAdditions: [],
                    headstoneOrderInscriptions: [],
                    detailsData: [],
                    grave: null,
                };

                if (angular.isDefined(workOrderId) && workOrderId) {
                    self.updateModel.headstoneOrder.workOrderId = workOrderId;
                    promises.push(dataService.getByWorkOrderId('Graves', workOrderId));
                }
                if (angular.isDefined(workOrderDeceased) && workOrderDeceased && workOrderDeceased.deceasedId) {
                    self.updateModel.headstoneOrder.deceasedId = workOrderDeceased.deceasedId;
                }
                if (angular.isDefined(externalOrderType) && externalOrderType) {
                    self.updateModel.headstoneOrder.externalOrderTypeId = externalOrderType.id;
                    self.updateModel.headstoneOrder.externalOrderTypeName = externalOrderType.name;
                }

                if (promises.length > 0) {
                    return $q.all(promises).then(function (response) {
                        self.updateModel.grave = getGraveByDeceasedId(response[0], self.updateModel.headstoneOrder.deceasedId);
                        return self.updateModel;
                    });
                }

                // Set as dirty to allow saving
                if (self.validation && self.validation.headstoneOrderForm && self.validation.headstoneOrderForm.$pristine) {
                    self.validation.headstoneOrderForm.$setDirty();
                }

                return $q.when(self.updateModel);
            } else {
                var promises = [];
                promises.push(dataService.getById('HeadstoneOrders', headstoneOrderId));
                promises.push(dataService.getByUri('HeadstoneOrderAdditions', 'ByHeadstoneOrderId/' + headstoneOrderId));
                promises.push(dataService.getByUri('HeadstoneOrderInscriptions', 'ByHeadstoneOrderId/' + headstoneOrderId));
                promises.push(dataService.getByUri('WorkOrderAttachments', 'ByExternalOrderId/' + headstoneOrderId));
                if (angular.isDefined(workOrderId) && workOrderId) {
                    promises.push(dataService.getByWorkOrderId('Graves', workOrderId));
                }
                return $q.all(promises).then(function (result) {
                    self.updateModel = {
                        headstoneOrder: result[0],
                        headstoneOrderAdditions: result[1],
                        headstoneOrderInscriptions: result[2],
                        detailsData: [],
                        attachments: result[3],
                        grave: workOrderId ? getGraveByDeceasedId(result[4], result[0].deceasedId) : null,
                    };
                    return self.updateModel;
                });
            }
        }

        function getGraveByDeceasedId(graves, deceasedId) {
            if (!deceasedId || !graves || graves.length === 0) return null;
            var matchedGrave = null;
            graves.forEach(function (grave) {
                if (grave.deceased && grave.deceased.length > 0) {
                    grave.deceased.forEach(function (deceased) {
                        if (deceased.id === deceasedId) {
                            matchedGrave = grave;
                        }
                    });
                }
            });
            return matchedGrave;
        }

        function saveHeadstoneOrder() {
            if (
                !self.updateModel.headstoneOrder.id ||
                self.updateModel.headstoneOrder.id === 'new' ||
                self.updateModel.headstoneOrder.id === '00000000-0000-0000-0000-000000000000'
            ) {
                return dataService.insertItem('HeadstoneOrders', self.updateModel.headstoneOrder).then(function (insertedHeadstoneOrder) {
                    self.isNew = false;
                    self.updateModel.headstoneOrder = insertedHeadstoneOrder;
                    return saveAdditionalData(self.updateModel.headstoneOrder);
                });
            }

            return dataService.updateItem('HeadstoneOrders', self.updateModel.headstoneOrder).then(function () {
                self.isNew = false;
                return saveAdditionalData(self.updateModel.headstoneOrder);
            });
        }

        function saveAdditionalData(headstoneOrder) {
            self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

            var promises = [];
            promises = promises.concat(
                dataService.createBulkPromises('HeadstoneOrderAdditions', self.updateModel.headstoneOrderAdditions, 'headStoneOrderId', headstoneOrder.id)
            );
            promises = promises.concat(
                dataService.createBulkPromises('HeadstoneOrderInscriptions', self.updateModel.headstoneOrderInscriptions, 'headStoneOrderId', headstoneOrder.id)
            );
            promises = promises.concat(
                dataService.createBulkPromises('CustomFieldData', self.updateModel.detailsData, 'attachedTypeId', headstoneOrder.id, 'ExternalOrder')
            );

            if (self.updateModel.grave) {
                var grave = self.updateModel.grave;

                if (!grave.id) {
                    promises.push(dataService.insertItem('Graves', grave));
                } else if (grave.changeState === 2) {
                    promises.push(dataService.updateItem('Graves', grave));
                }
            }

            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    return self.updateModel;
                });
            }
            return self.updateModel;
        }

        function onProductChanged(product) {
            if (!product || product.id === self.updateModel.headstoneOrder.productId) return; // Don't do anything if not a product or same product we already have
            self.updateModel.headstoneOrder.overriddenName = product.name;
            self.updateModel.headstoneOrder.overriddenPrice = product.price > 0 ? product.price : self.updateModel.headstoneOrder.overriddenPrice; // Don't change price if price == 0
            if (!self.updateModel.headstoneOrder.productAmount) self.updateModel.headstoneOrder.productAmount = 1;
        }

        function openEditHeadstoneInscriptionDialog(e, headstoneInscription) {
            var headstoneOrderInscription = null;
            if (!headstoneInscription) {
                headstoneOrderInscription = headstoneOrderService.getEmptyHeadstoneOrderInscription();
                if (self.updateModel.headstoneOrderInscriptions && self.updateModel.headstoneOrderInscriptions.length > 0) {
                    headstoneOrderInscription.sortOrder =
                        Math.max.apply(
                            Math,
                            self.updateModel.headstoneOrderInscriptions.map(function (inscription) {
                                return inscription.sortOrder || 0;
                            })
                        ) + 10;
                } else {
                    self.updateModel.headstoneOrderInscriptions = [];
                }
            } else {
                headstoneOrderInscription = angular.copy(headstoneInscription);
            }
            headstoneOrderService
                .showEditHeadstoneInscriptionDialog(
                    e,
                    headstoneOrderInscription,
                    self.updateModel.headstoneOrder.workOrderId,
                    self.updateModel.headstoneOrder.deceasedId
                )
                .then(function (updateHeadstoneInscription) {
                    if (updateHeadstoneInscription) {
                        if (!self.updateModel.headstoneOrderInscriptions) self.updateModel.headstoneOrderInscriptions = [];
                        var index = self.updateModel.headstoneOrderInscriptions.indexOf(headstoneInscription);
                        if (
                            !updateHeadstoneInscription.id ||
                            updateHeadstoneInscription.id === 'new' ||
                            updateHeadstoneInscription.id === '00000000-0000-0000-0000-000000000000'
                        ) {
                            // New inscription -> add to collection
                            self.updateModel.headstoneOrderInscriptions.push(updateHeadstoneInscription);
                        } else {
                            // Remove old entry -> add updated entry
                            self.updateModel.headstoneOrderInscriptions.splice(index, 1);
                            self.updateModel.headstoneOrderInscriptions.push(updateHeadstoneInscription);
                        }
                        if (self.validation && self.validation.headstoneOrderForm) {
                            self.validation.headstoneOrderForm.$setDirty();
                        }
                    }
                });
        }

        function openEditHeadstoneAdditionDialog(e, headstoneAddition) {
            var headstoneOrderAddition = null;
            if (!headstoneAddition) {
                headstoneOrderAddition = headstoneOrderService.getEmptyHeadstoneOrderAddition();
                if (self.updateModel.headstoneOrderAdditions && self.updateModel.headstoneOrderAdditions.length > 0) {
                    headstoneOrderAddition.sortOrder =
                        Math.max.apply(
                            Math,
                            self.updateModel.headstoneOrderAdditions.map(function (inscription) {
                                return inscription.sortOrder || 0;
                            })
                        ) + 10;
                } else {
                    self.updateModel.headstoneOrderAdditions = [];
                }
            } else {
                headstoneOrderAddition = angular.copy(headstoneAddition);
            }
            headstoneOrderService.showEditHeadstoneAdditionDialog(e, headstoneOrderAddition).then(function (updateHeadstoneAddition) {
                if (updateHeadstoneAddition) {
                    if (!self.updateModel.headstoneOrderAdditions) self.updateModel.headstoneOrderAdditions = [];
                    if (
                        !updateHeadstoneAddition.id ||
                        updateHeadstoneAddition.id === 'new' ||
                        updateHeadstoneAddition.id === '00000000-0000-0000-0000-000000000000'
                    ) {
                        // New inscription -> add to collection
                        self.updateModel.headstoneOrderAdditions.push(updateHeadstoneAddition);
                    } else {
                        // Remove old entry -> add updated entry
                        var index = self.updateModel.headstoneOrderAdditions.indexOf(headstoneAddition);
                        self.updateModel.headstoneOrderAdditions.splice(index, 1);
                        self.updateModel.headstoneOrderAdditions.push(updateHeadstoneAddition);
                    }
                    if (self.validation && self.validation.headstoneOrderForm) {
                        self.validation.headstoneOrderForm.$setDirty();
                    }
                }
            });
        }

        function openEditGraveInfoDialog(e, grave) {
            var graveDto = null;
            if (!grave) {
                graveDto = graveService.getEmptyGrave();
                if (self.updateModel.headstoneOrder.deceasedId) {
                    if (!grave.deceasedIds) {
                        grave.deceasedIds = [];
                    }
                    grave.deceasedIds.push(self.updateModel.headstoneOrder.deceasedId);
                }
                if (self.updateModel.headstoneOrder.workOrderId) {
                    grave.targetWorkOrderId = self.updateModel.headstoneOrder.workOrderId;
                }
            } else {
                graveDto = angular.copy(grave);
            }
            headstoneOrderService.showEditGraveInfoDialog(e, graveDto, self.updateModel.headstoneOrder.workOrderId).then(function (updatedGrave) {
                if (updatedGrave) {
                    self.updateModel.grave = updatedGrave;
                    if (self.validation && self.validation.headstoneOrderForm) {
                        self.validation.headstoneOrderForm.$setDirty();
                    }
                }
            });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.noteOrTaskFdos = [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditHeadstoneOrderController', EditHeadstoneOrderController);

    /* @ngInject */
    function EditHeadstoneOrderController($scope, $translate, $window, $stateParams, editHeadstoneOrderService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editHeadstoneOrderService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editHeadstoneOrderService.loadHeadstoneOrder($stateParams.headstoneOrderId, $stateParams.workOrderId, $stateParams.workOrderDeceased, $stateParams.externalOrderType).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editHeadstoneOrderService.saveHeadstoneOrder().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.headstoneOrderForm && vm.data.validation.headstoneOrderForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

}());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditHeadstoneOrderToolbarController', EditHeadstoneOrderToolbarController);

    /* @ngInject */
    function EditHeadstoneOrderToolbarController($window, editHeadstoneOrderService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editHeadstoneOrderService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editHeadstoneOrderService.saveHeadstoneOrder().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditHeadstoneOrderSidebarController', EditHeadstoneOrderSidebarController);

    /* @ngInject */
    function EditHeadstoneOrderSidebarController($window, editHeadstoneOrderService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editHeadstoneOrderService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editHeadstoneOrderService.saveHeadstoneOrder().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .service('editDeceasedShipmentService', editDeceasedShipmentService);

    /* @ngInject */
    function editDeceasedShipmentService($q, externalOrderService, partyService, addressService, dataService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadDeceasedShipment = loadDeceasedShipment;
        self.saveDeceasedShipment = saveDeceasedShipment;
        self.openSelectSenderDialog = openSelectSenderDialog;
        self.openSelectReceiverDialog = openSelectReceiverDialog;
        self.openEditAddressDialog = openEditAddressDialog;
        self.getFormattedReceiverAddress = getFormattedReceiverAddress;

        function loadDeceasedShipment(deceasedShipmentId, workOrderId, workOrderDeceased, workOrder) {
            reset();
            if (!deceasedShipmentId || deceasedShipmentId.toLowerCase() === 'new') {
                var promises = [];
                self.isNew = true;
                self.updateModel = {
                    deceasedShipment: externalOrderService.getEmptyDeceasedShipmentDto(),
                    receiver: null,
                    receiverAddress: null
                };

                if (angular.isDefined(workOrderId)) {
                    self.updateModel.deceasedShipment.workOrderId = workOrderId;
                    if (angular.isDefined(workOrderDeceased) && workOrderDeceased && workOrderDeceased.deceasedId) {
                        self.updateModel.deceasedShipment.deceasedId = workOrderDeceased.deceasedId;
                        if (workOrderDeceased.deceasedCasketId) {
                            promises.push(dataService.getById('Caskets', workOrderDeceased.deceasedCasketId, true));
                        }
                    }
                    if (angular.isDefined(workOrder) && workOrder && workOrder.departmentId) {
                        promises.push(dataService.getById('Departments', workOrder.departmentId));
                    }
                }
                self.updateModel.deceasedShipment.changeState = 1;
                if (promises.length > 0) {
                    $q.all(promises).then(function (result) {
                        for (var i = 0; i < result.length; i++) {
                            var obj = result[i];
                            if (obj.$type === 'Baldris.Core.Data.Entities.Dto.Shorts.CasketShortDto, Baldris.Core.Data.Entities') {
                                self.updateModel.deceasedShipment.casketAttributes = obj.attributes;
                            }
                            if (obj.$type === 'Baldris.Core.Data.Entities.Dto.DepartmentDto, Baldris.Core.Data.Entities') {
                                self.updateModel.deceasedShipment.sender = obj.organization;
                                self.updateModel.deceasedShipment.senderId = obj.organizationId;
                            }
                        }
                        return self.updateModel;
                    })
                }
                return $q.when(self.updateModel);
            } else {
                return dataService.getUpdateModel('DeceasedShipments', deceasedShipmentId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    return self.updateModel;
                });
            }
        }

        function saveDeceasedShipment() {
            // ensure changeState is set to Modified on deceased and person
            if (!self.isNew) {
                self.updateModel.deceasedShipment.changeState = 2;
            }

            return dataService.updateFromUpdateModel('DeceasedShipments', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                return self.updateModel;
            });
        }


        function openSelectSenderDialog(e) {
            partyService.showSearchDialog(e, 'Parties', self.updateModel.deceasedShipment.workOrderId, false, true).then(function (selectedParty) {
                if (selectedParty) {
                    self.updateModel.deceasedShipment.senderId = selectedParty.id;
                    self.updateModel.deceasedShipment.sender = partyService.convertToPartyShortDto(selectedParty);
                }
            })
        }

        function openSelectReceiverDialog(e) {
            partyService.showSearchDialog(e, 'Parties', self.updateModel.deceasedShipment.workOrderId, true, true).then(function (selectedParty) {
                if (selectedParty && selectedParty.id !== self.updateModel.deceasedShipment.receiverId) {
                    self.updateModel.deceasedShipment.receiverId = selectedParty.id;
                    self.updateModel.deceasedShipment.receiver = partyService.convertToPartyShortDto(selectedParty);
                    self.updateModel.receiver = selectedParty;
                    self.isLoadingReceiverAddress = true;
                    dataService.getByUri('Addresses','GetDefaultAddressByPartyId/' + selectedParty.id, { asDto: true }).then(function (defaultAddress) {
                        if (defaultAddress) {
                            self.updateModel.deceasedShipment.alternateDeliveryAddressId = defaultAddress.id;
                            self.updateModel.receiverAddress = defaultAddress;
                        }
                        self.isLoadingReceiverAddress = false;
                    })
                }
            })
        }

        function openEditAddressDialog(e) {
            var address = null;
            if (self.updateModel.receiverAddress) {
                address = angular.copy(self.updateModel.receiverAddress);
            } else {
                address = addressService.getEmptyAddress();
                address.changeState = 1;
                address.partyId = self.updateModel.deceasedShipment.receiverId;
            }
            addressService.showEditDialog(e, address).then(function (updatedAddress) {
                if (updatedAddress) {
                    self.updateModel.deceasedShipment.alternateDeliveryAddressId = updatedAddress.id;
                    self.updateModel.receiverAddress = updatedAddress;
                }
            })
        }

        function getFormattedReceiverAddress() {
            return addressService.getFormattedAddress(self.updateModel.receiverAddress);
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditDeceasedShipmentController', EditDeceasedShipmentController);

    /* @ngInject */
    function EditDeceasedShipmentController($window, $stateParams, editDeceasedShipmentService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editDeceasedShipmentService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedShipmentService.loadDeceasedShipment($stateParams.deceasedShipmentId, $stateParams.workOrderId, $stateParams.workOrderDeceased).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedShipmentService.saveDeceasedShipment().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .controller('EditDeceasedShipmentToolbarController', EditDeceasedShipmentToolbarController);

    /* @ngInject */
    function EditDeceasedShipmentToolbarController($window, editDeceasedShipmentService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editDeceasedShipmentService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedShipmentService.saveDeceasedShipment().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .component('externalOrderTypeSelect', {
            bindings: {
                externalOrderTypeId: '=',
                externalOrderType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                externalOrderTypeConfig: '=',
                displayText: '='
            },
            templateUrl: 'app/main/external-order/components/external-order-type-select/external-order-type-select.tmpl.html',
            controller: 'ExternalOrderTypeSelectController as vm',
        })
        .controller('ExternalOrderTypeSelectController', ExternalOrderTypeSelectController);

    /* @ngInject */
    function ExternalOrderTypeSelectController(dataService, $filter, baldrisConfigService) {
        var vm = this;

        vm.$onInit = function () {
            vm.externalOrderTypes = [];
            vm.isDisabled = true;

            vm.onChange = onChange;
            // Get externalOrderTypes
            if (vm.externalOrderTypeConfig) {
                dataService.getByConfigName('ExternalOrderTypes', vm.externalOrderTypeConfig).then(function (externalOrderTypes) {
                    externalOrderTypes = $filter('filter')(externalOrderTypes, { isDeleted: false });
                    externalOrderTypes = $filter('orderBy')(externalOrderTypes, 'name');
                    vm.externalOrderTypes = externalOrderTypes;
                    vm.isDisabled = false;
                });
            } else {
                dataService.getAll('ExternalOrderTypes').then(function (externalOrderTypes) {
                    externalOrderTypes = $filter('filter')(externalOrderTypes, { isDeleted: false });
                    externalOrderTypes = $filter('orderBy')(externalOrderTypes, 'name');
                    vm.externalOrderTypes = externalOrderTypes;
                    vm.isDisabled = false;
                });
            }
        }

        function onChange() {
            if (vm.externalOrderTypeId) {
                for (var index = 0; index < vm.externalOrderTypes.length; index++) {
                    var externalOrderType = vm.externalOrderTypes[index];
                    if (vm.externalOrderTypeId === externalOrderType.id) {
                        vm.externalOrderType = externalOrderType;
                        if(angular.isDefined(vm.displayText)) {
                            vm.displayText = externalOrderType.name;
                        }
                        break;
                    }
                }
            } else {
                vm.externalOrderType = null;
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.externalOrderType);
            }
        }
    }

} ());
(function() {
    'use strict';

    angular
        .module('app.department', [

        ]);
})(); 
(function() {
  "use strict";

  angular
    .module("app.department")
    .component("legalUnitSelect", {
      bindings: {
        legalUnitId: "=",
        legalUnit: "=",
        onSelected: "=",
        labelText: "@",
        isRequired: "=",
        displayText: "=",
        isDisabled: "<",
        onUpdate: "&"
      },
      templateUrl: "app/main/department/components/legal-unit-select/legal-unit-select.tmpl.html",
      controller: "LegalUnitSelectController as vm"
    })
    .controller("LegalUnitSelectController", LegalUnitSelectController);

  /* @ngInject */
  function LegalUnitSelectController($filter, dataService) {
    var vm = this;
    vm.isDisabled = true;
    vm.legalUnits = [];

    vm.onChange = onChange;

    vm.$onInit = function() {
      dataService.getAll("LegalUnits").then(function(legalUnits) {
        vm.isDisabled = false;

        legalUnits = $filter("filter")(legalUnits, { isDeleted: false });

        vm.legalUnits = legalUnits;
      });
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
        vm.isDisabled = changesObj.isDisabled.currentValue;
      }
    };

    function onChange() {
      if (vm.legalUnitId) {
        for (var index = 0; index < vm.legalUnits.length; index++) {
          var legalUnit = vm.legalUnits[index];
          if (vm.legalUnitId === legalUnit.id) {
            vm.legalUnit = legalUnit;
            if (angular.isDefined(vm.displayText)) {
              vm.displayText = legalUnit.organizationDisplayName;
            }
            vm.onUpdate({ action: "change", value: legalUnit });
            break;
          }
        }
      } else {
        vm.legalUnit = null;
        if (angular.isDefined(vm.displayText)) {
          vm.displayText = null;
        }
        vm.onUpdate({ action: "deselect", value: null });
      }
      if (angular.isFunction(vm.onSelected)) {
        vm.onSelected(vm.legalUnit);
      }
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.department")
    .component("editLegalUnit", {
      bindings: {
        legalUnit: "<",
        organization: "<",
        isDisabled: "<",
        onSubmit: "&",
        onChange: "&"
      },
      templateUrl: "app/main/department/components/edit-legal-unit/edit-legal-unit.tmpl.html",
      controller: "EditLegalUnitController as vm"
    })
    .controller("EditLegalUnitController", EditLegalUnitController);

  /* @ngInject */
  function EditLegalUnitController(Upload, baldrisApiBase, loadingService) {
    var vm = this;
    vm.submitForm = submitForm;
    vm.onValueChanged = onValueChanged;
    vm.reset = reset;
    vm.removeImage = removeImage;
    vm.uploadImage = uploadImage;

    vm.$onInit = function() {
      reset();
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
        vm.isDisabled = changesObj.isDisabled.currentValue;
      }
    };

    function reset(notifyChange) {
      vm.legalUnitDto = angular.copy(vm.legalUnit);
      vm.organizationDto = angular.copy(vm.organization);
      if (notifyChange) {
        onValueChanged(vm.legalUnitDto);
        onValueChanged(vm.organizationDto);
      }
    }

    function onValueChanged(dtoModel) {
      if (dtoModel) {
        if (dtoModel.id === "00000000-0000-0000-0000-000000000000") {
          dtoModel.changeState = 1;
        } else {
          dtoModel.changeState = 2;
        }
        vm.onChange({ value: dtoModel });
      }
    }

    function submitForm() {
      if (!vm.isDisabled) {
        console.log("Submit component");
        vm.onSubmit({ legalUnit: vm.legalUnitDto, organization: vm.organizationDto });
      }
    }

    function removeImage(idProperty, filePathProperty, model) {
      model[idProperty] = null;
      model[filePathProperty] = null;
      onValueChanged(model);
    }

    function uploadImage(file, idProperty, filePathProperty, model) {
      loadingService.setBackgroundLoadingStatus(true);
      vm.isDisabled = true;
      Upload.upload({
        url: baldrisApiBase + "/api/BaldrisFiles/Upload",
        data: { file: file }
      }).then(
        function(resp) {
          if (resp && resp.data && resp.data.length > 0) {
            var baldrisFile = resp.data[0];
            model[idProperty] = baldrisFile.id;
            model[filePathProperty] = baldrisFile.filepath;
            onValueChanged(model);
          }
          loadingService.setBackgroundLoadingStatus(false);
          vm.isDisabled = false;
        },
        function(resp) {
          console.log("Error status: " + resp.status);
          loadingService.setBackgroundLoadingStatus(false);
          vm.isDisabled = false;
        }
      );
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.department")
    .component("editDepartment", {
      bindings: {
        department: "<",
        organization: "<",
        isDisabled: "<",
        onSubmit: "&",
        onChange: "&"
      },
      templateUrl: "app/main/department/components/edit-department/edit-department.tmpl.html",
      controller: "EditDepartmentController as vm"
    })
    .controller("EditDepartmentController", EditDepartmentController);

  /* @ngInject */
  function EditDepartmentController(Upload, baldrisApiBase, loadingService) {
    var vm = this;
    vm.submitForm = submitForm;
    vm.onValueChanged = onValueChanged;
    vm.reset = reset;
    vm.removeImage = removeImage;
    vm.uploadImage = uploadImage;

    vm.$onInit = function() {
      reset();
    };

    vm.$onChanges = function(changesObj) {
      if (changesObj.isDisabled && changesObj.isDisabled.currentValue !== changesObj.isDisabled.previousValue) {
        vm.isDisabled = changesObj.isDisabled.currentValue;
      }
    };

    function reset(notifyChange) {
      vm.departmentDto = angular.copy(vm.department);
      vm.organizationDto = angular.copy(vm.organization);
      if (notifyChange) {
        onValueChanged(vm.departmentDto);
        onValueChanged(vm.organizationDto);
      }
    }

    function onValueChanged(dtoModel) {
      if (dtoModel) {
        if (dtoModel.id === "00000000-0000-0000-0000-000000000000") {
          dtoModel.changeState = 1;
        } else {
          dtoModel.changeState = 2;
        }
        vm.onChange({ value: dtoModel });
      }
    }

    function submitForm() {
      if (!vm.isDisabled) {
        console.log("Submit component");
        vm.onSubmit({ department: vm.departmentDto, organization: vm.organizationDto });
      }
    }

    function removeImage(idProperty, filePathProperty, model) {
      model[idProperty] = null;
      model[filePathProperty] = null;
      onValueChanged(model);
    }

    function uploadImage(file, idProperty, filePathProperty, model) {
      loadingService.setBackgroundLoadingStatus(true);
      vm.isDisabled = true;
      Upload.upload({
        url: baldrisApiBase + "/api/BaldrisFiles/Upload",
        data: { file: file }
      }).then(
        function(resp) {
          if (resp && resp.data && resp.data.length > 0) {
            var baldrisFile = resp.data[0];
            model[idProperty] = baldrisFile.id;
            model[filePathProperty] = baldrisFile.filepath;
            onValueChanged(model);
          }
          loadingService.setBackgroundLoadingStatus(false);
          vm.isDisabled = false;
        },
        function(resp) {
          console.log("Error status: " + resp.status);
          loadingService.setBackgroundLoadingStatus(false);
          vm.isDisabled = false;
        }
      );
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.department')
        .component('departmentSelect', {
            bindings: {
                departmentId: '=',
                department: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                displayText: '='
            },
            templateUrl: 'app/main/department/components/department-select/department-select.tmpl.html',
            controller: 'DepartmentSelectController as vm',
        })
        .controller('DepartmentSelectController', DepartmentSelectController);

    /* @ngInject */
    function DepartmentSelectController($filter, dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.departments = [];

        vm.onChange = onChange;

        vm.$onInit = function () {
            dataService.getAll('Departments').then(function (departments) {
                vm.isDisabled = false;

                departments = $filter('filter')(departments, { isDeleted: false });

                vm.departments = departments;
            });
        }

        function onChange() {
            if (vm.departmentId) {
                for (var index = 0; index < vm.departments.length; index++) {
                    var department = vm.departments[index];
                    if (vm.departmentId === department.id) {
                        vm.department = department;
                        if(angular.isDefined(vm.displayText)) {
                            vm.displayText = department.organizationDisplayName;
                        }
                        break;
                    }
                }
            } else {
                vm.department = null;
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.department);
            }
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.department")
    .component("departmentList", {
      bindings: {
        departments: "=",
        canEdit: "=",
        canAdd: "=",
        onEdit: "&",
        onAdd: "&"
      },
      templateUrl: "app/main/department/components/department-list/department-list.tmpl.html",
      controller: "DepartmentListController as vm"
    })
    .controller("DepartmentListController", DepartmentListController);

  /* @ngInject */
  function DepartmentListController(departmentService) {
    var vm = this;
    vm.editDepartment = editDepartment;
    vm.addDepartment = addDepartment;

    function editDepartment(department) {
      if (vm.canEdit) {
        vm.onEdit({ value: department });
      }
    }

    function addDepartment() {
      if (vm.canAdd) {
        vm.onAdd({ value: departmentService.getEmptyDepartment() });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('SearchDeceasedDialogController', SearchDeceasedDialogController);

    /* @ngInject */
    function SearchDeceasedDialogController($mdDialog, dataService) {
        var vm = this;

        //Data
        vm.selectedDeceased = null;
        vm.isSearching = false;
        vm.isLoadingDeceased = false;

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSearchChange = onSearchChange;
        vm.getWorkOrdersString = getWorkOrdersString;
        vm.selectItem = selectItem;
        
        //////////

        function closeDialog(selectedDeceased) {
            $mdDialog.hide(selectedDeceased);
        }

        function onSearchChange() {
            if (vm.searchText && vm.searchText.length > 1) {
                vm.isSearching = true;
                dataService.search('Deceased', vm.searchText).then(function (searchResults) {
                    vm.searchResults = searchResults;
                    vm.isSearching = false;
                })
            }
        }

        function getWorkOrdersString(deceased) {
            var returnString = '';
            if (deceased && deceased.workOrders) {
                for (var index = 0; index < deceased.workOrders.length; index++) {
                    var element = deceased.workOrders[index];
                    var delimeter = index == 0 ? '' : ' // ';
                    returnString += delimeter + element.orderCode;
                }
            }
            return returnString;
        }

        function selectItem(item) {
            if (item) {
                vm.isLoadingDeceased = true;
                dataService.getById("Deceased", item.id).then(function (selectedItem) {
                    vm.selectedDeceased = selectedItem;
                    vm.isLoadingDeceased = false;
                });
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('EditDeceasedDialogController', EditDeceasedDialogController);

    /* @ngInject */
    function EditDeceasedDialogController($mdDialog, deceased, event, $translate, dataService) {
        var vm = this;
        vm.isDisabled = false;
        vm.closeDialog = closeDialog;
        vm.selectedIndex = 0;

        // Data
        vm.deceased = deceased;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            var vmCopy = vm;
            if (vm.deceasedForm.$dirty) {
                if (!vm.deceased.id || vm.deceased.id === '00000000-0000-0000-0000-000000000000') {
                    vm.deceased.changeState = 1;
                    if (vm.deceased.person) {
                        vm.deceased.person.changeState = 1;
                    }
                    dataService.insertItem("Deceased", vm.deceased).then(function (insertData) {
                        $mdDialog.hide(insertData);
                    });
                } else {
                    vm.deceased.changeState = 2;
                    if (vm.deceased.person) {
                        vm.deceased.person.changeState = 2;
                    }
                    dataService.deceased.updateItem("Deceased", vm.deceased).then(function () {
                        $mdDialog.hide(vm.deceased);
                    });
                }
            }
        }

    }

} ());

(function () {
    'use strict';

    angular
        .module('app.deceased')
        .component('deceasedCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '=',
            },
            templateUrl: 'app/main/deceased/components/deceased-card/deceased-card.tmpl.html',
            controller: 'DeceasedCardController as vm',
        })
        .controller('DeceasedCardController', DeceasedCardController);

    /* @ngInject */
    function DeceasedCardController($mdDialog, $document, $state, $translate, $mdToast, maritalStatusOptions) {
        var vm = this;
        vm.maritalStatusArray = [];

        vm.$onInit = function () {
            //Init
            if (vm.baldrisModel.maritalStatus && vm.baldrisModel.maritalStatus !== 'none') {
                var maritalStatus = vm.baldrisModel.maritalStatus.split(', ');
                angular.forEach(maritalStatusOptions, function (option) {
                    if (maritalStatus.indexOf(option.value) > -1) {
                        vm.maritalStatusArray.push(option.text);
                    }
                });
            }
        };

        vm.extractAddress = extractAddress;
        vm.navigateToDeceased = navigateToDeceased;
        vm.deleteDeceased = deleteDeceased;

        function navigateToDeceased(deceased) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(deceased);
                } else {
                    $state.go('app.deceased.byId', { id: deceased.id });
                }
            }
        }

        function deleteDeceased(deceased) {
            if (!vm.disableLinks) {
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(deceased);
                }
            }
        }

        function extractAddress(address) {
            var returnString = '';

            returnString = address.streetAddress1 + ', ' + address.zipCode + ' ' + address.city;
            if (address.countryName) {
                returnString += ', ' + address.countryName.toUpperCase();
            }

            return returnString;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.customField', [

        ]);
})();
(function () {
    'use strict';

    angular.module('app.customField').controller('EditProductChoiceDialogController', EditProductChoiceDialogController);

    /* @ngInject */
    function EditProductChoiceDialogController($mdDialog, productChoice) {
        var vm = this;

        // Data
        vm.productChoice = productChoice;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;
        vm.onProductSelected = onProductSelected;

        //////////
        // INIT

        function closeDialog() {
            $mdDialog.hide();
        }

        function onProductSelected(product) {
            if (product) {
                vm.productChoice.productName = product.name;
            } else {
                vm.productChoice.productName = null;
            }
        }

        function saveAndCloseDialog() {
            if (!vm.productChoice.id || vm.productChoice.id === '00000000-0000-0000-0000-000000000000') {
                vm.productChoice.changeState = 1;
            } else {
                vm.productChoice.changeState = 2;
            }
            $mdDialog.hide(vm.productChoice);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.customField')
        .component('productChoicesList', {
            bindings: {
                productChoices: '=',
                customFieldId: '=',
                onUpdate: '&',
            },
            templateUrl: 'app/main/custom-field/components/product-choices-list/product-choices-list.tmpl.html',
            controller: 'ProductChoicesListController as vm',
        })
        .controller('ProductChoicesListController', ProductChoicesListController);

    /* @ngInject */
    function ProductChoicesListController(editCustomFieldService) {
        var vm = this;

        vm.showEditProductChoiceDialog = showEditProductChoiceDialog;
        vm.deleteOrUndoProductChoice = deleteOrUndoProductChoice;

        //INIT
        vm.$onInit = function () {};

        function onProductChoiceChanged(productChoice, action) {
            vm.onUpdate({ action: action || 'updated', value: productChoice });
        }

        function showEditProductChoiceDialog(productChoice, e) {
            var productChoiceCopy = null;
            if (productChoice) {
                productChoiceCopy = angular.copy(productChoice);
            } else {
                productChoiceCopy = editCustomFieldService.getEmptyProductChoice();
                productChoiceCopy.changeState = 1;
                productChoiceCopy.amount = 1;
                productChoiceCopy.billTo = 1;
                productChoiceCopy.customFieldId = vm.customFieldId;
            }
            editCustomFieldService.showEditProductChoiceDialog(e, productChoiceCopy).then(function (editedProductChoice) {
                if (editedProductChoice) {
                    if (editedProductChoice.changeState === 1) {
                        vm.productChoices.push(editedProductChoice);
                    } else {
                        productChoice.remarks = editedProductChoice.remarks;
                        productChoice.amount = editedProductChoice.amount;
                        productChoice.billTo = editedProductChoice.billTo;
                        productChoice.departmentId = editedProductChoice.departmentId;
                        productChoice.departmentName = editedProductChoice.departmentName;
                        productChoice.productId = editedProductChoice.productId;
                        productChoice.productName = editedProductChoice.productName;
                        productChoice.customFieldId = editedProductChoice.customFieldId;
                        productChoice.changeState = editedProductChoice.changeState;
                    }
                }
            });
        }

        function deleteOrUndoProductChoice(productChoice, e) {
            if (!productChoice) return;
            if (productChoice.changeState === 3) {
                productChoice.changeState = 2;
            } else if (productChoice.changeState === 1) {
                var index = vm.productChoices.indexOf(productChoice);
                vm.productChoices.splice(index, 1);
            } else {
                productChoice.changeState = 3;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.customField')
        .component('editCustomField', {
            bindings: {
                baldrisModel: '=',
                onChange: '=',
            },
            templateUrl:
                'app/main/custom-field/components/edit-custom-field/edit-custom-field.tmpl.html',
            controller: 'EditCustomFieldController as vm',
        })
        .controller('EditCustomFieldController', EditCustomFieldController);

    /* @ngInject */
    function EditCustomFieldController(
        customFieldTypeOptions,
        dataService,
        customFieldDataService
    ) {
        var vm = this;
        vm.isDisabled = false;

        vm.onValueChanged = onValueChanged;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.addNewData = addNewData;
        vm.deleteData = deleteData;
        vm.onProductChanged = onProductChanged;

        //INIT
        vm.$onInit = function () {
            vm.dataOptions = getDataTypeOptions(vm.baldrisModel.dataType);
            vm.templateUrl = vm.dataOptions.editTemplate;

            vm.searchText = null;

            ensureHasData();

            //Load CurrentData
            if (
                vm.dataOptions.dataSource &&
                vm.baldrisModel.data &&
                vm.baldrisModel.data[0] &&
                vm.baldrisModel.data[0][vm.dataOptions.targetProperty]
            ) {
                dataService
                    .getById(
                        vm.dataOptions.dataSource,
                        vm.baldrisModel.data[0][vm.dataOptions.targetProperty],
                        true
                    )
                    .then(function (returnData) {
                        vm.baldrisModel.data[0][vm.dataOptions.targetModel] =
                            returnData;
                    });
            }

            // Load suggested products
            if (vm.dataOptions.value === 21) {
                dataService
                    .getByUri(
                        'CustomFields',
                        vm.baldrisModel.id + '/AttachedProducts'
                    )
                    .then(function (attachedProducts) {
                        if (attachedProducts && attachedProducts.length > 0) {
                            var ids = attachedProducts.map(function (
                                attachedProduct
                            ) {
                                return attachedProduct.productId;
                            });
                            dataService
                                .getByIds('Products', ids)
                                .then(function (suggestedProducts) {
                                    vm.suggestedProducts =
                                        suggestedProducts.map(function (
                                            product
                                        ) {
                                            var attachedProduct =
                                                attachedProducts.find(function (
                                                    ap
                                                ) {
                                                    return (
                                                        ap.productId ===
                                                        product.id
                                                    );
                                                });
                                            if (attachedProduct) {
                                                product.suggestedAmount =
                                                    attachedProduct.amount;
                                            }
                                            return product;
                                        });
                                });
                        }
                    });
            }

            // Set custom text
            if (vm.baldrisModel.allowCustom) {
                vm.searchText = vm.baldrisModel.data[0].stringData;
            }
        };

        function addNewData() {
            if (!angular.isArray(vm.baldrisModel.data)) {
                vm.baldrisModel.data = [];
            }
            var customData = customFieldDataService.getEmptyCustomFieldData();
            customData.customFieldId = vm.baldrisModel.id;
            customData.dataType = vm.baldrisModel.dataType;
            vm.baldrisModel.data.push(customData);
        }

        function deleteData(customFieldDataDto) {
            if (
                !customFieldDataDto ||
                !vm.baldrisModel.data ||
                vm.baldrisModel.data.length <= 0
            )
                return;
            if (
                customFieldDataDto.id === '00000000-0000-0000-0000-000000000000'
            ) {
                var index = vm.baldrisModel.data.indexOf(customFieldDataDto);
                vm.baldrisModel.data.splice(index, 1);
            } else {
                customFieldDataDto.changeState = 3;
            }
        }

        function querySearch(query) {
            if (vm.baldrisModel.dataTypeDiscriminator) {
                if (query) {
                    return dataService.searchByConfigName(
                        vm.dataOptions.dataSource,
                        vm.baldrisModel.dataTypeDiscriminator,
                        query
                    );
                } else {
                    return dataService.getByConfigName(
                        vm.dataOptions.dataSource,
                        vm.baldrisModel.dataTypeDiscriminator
                    );
                }
            } else {
                return dataService.search(vm.dataOptions.dataSource, query);
            }
        }

        function onValueChanged(dataObject) {
            if (dataObject) {
                if (
                    !dataObject.id ||
                    dataObject.id === '00000000-0000-0000-0000-000000000000'
                ) {
                    dataObject.changeState = 1;
                } else {
                    dataObject.changeState = 2;
                }
            } else {
                if (
                    !vm.baldrisModel.data[0].id ||
                    vm.baldrisModel.data[0].id ===
                        '00000000-0000-0000-0000-000000000000'
                ) {
                    vm.baldrisModel.data[0].changeState = 1;
                } else {
                    vm.baldrisModel.data[0].changeState = 2;
                }
            }
        }

        function onProductChanged(dataObject, product) {
            if (product && product.suggestedAmount && !dataObject.decimalData) {
                dataObject.decimalData = product.suggestedAmount;
            }
            onValueChanged(dataObject);
        }

        function searchTextChange(text) {
            if (vm.baldrisModel.allowCustom) {
                vm.baldrisModel.data[0].stringData = text;
                if (
                    !vm.baldrisModel.data[0].id ||
                    vm.baldrisModel.data[0].id ===
                        '00000000-0000-0000-0000-000000000000'
                ) {
                    vm.baldrisModel.data[0].changeState = 1;
                } else {
                    vm.baldrisModel.data[0].changeState = 2;
                }
                if (angular.isFunction(vm.onChange)) {
                    vm.onChange(vm.baldrisModel.data[0]);
                }
            }
        }

        function selectedItemChange(item) {
            if (
                !vm.baldrisModel.data[0].id ||
                vm.baldrisModel.data[0].id ===
                    '00000000-0000-0000-0000-000000000000'
            ) {
                vm.baldrisModel.data[0].changeState = 1;
            } else {
                vm.baldrisModel.data[0].changeState = 2;
            }
            if (item) {
                vm.baldrisModel.data[0][vm.dataOptions.targetProperty] =
                    item[vm.dataOptions.sourceProperty];
            } else {
                if (
                    vm.baldrisModel.data[0][vm.dataOptions.targetProperty] &&
                    vm.baldrisModel.data[0][vm.dataOptions.targetProperty] !==
                        '00000000-0000-0000-0000-000000000000'
                ) {
                    // Set dirty
                    vm.editCustomFieldForm.$setDirty();
                }
                vm.baldrisModel.data[0][vm.dataOptions.targetProperty] = null;
            }
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.baldrisModel.data[0]);
            }
        }

        function ensureHasData() {
            if (!angular.isArray(vm.baldrisModel.data)) {
                vm.baldrisModel.data = [];
            }
            if (vm.baldrisModel.data.length === 0) {
                var customData =
                    customFieldDataService.getEmptyCustomFieldData();
                customData.customFieldId = vm.baldrisModel.id;
                customData.dataType = vm.baldrisModel.dataType;
                vm.baldrisModel.data.push(customData);
            } else {
                if (
                    !vm.baldrisModel.data[0].hasOwnProperty('dataValueAsString')
                ) {
                    var dataTarget =
                        vm.baldrisModel.data[0][vm.dataOptions.targetProperty];
                    var dataModel =
                        vm.baldrisModel.data[0][vm.dataOptions.targetModel];
                    vm.baldrisModel.data = [];
                    var customData =
                        customFieldDataService.getEmptyCustomFieldData();
                    customData.customFieldId = vm.baldrisModel.id;
                    customData.dataType = vm.baldrisModel.dataType;
                    customData[vm.dataOptions.targetProperty] = dataTarget;
                    customData[vm.dataOptions.targetModel] = dataModel;
                    vm.baldrisModel.data.push(customData);
                } else {
                    // Ensure ChangeState of 0
                    vm.baldrisModel.data[0].changeState = 0;
                }
            }
        }

        function getDataTypeOptions(dataType) {
            var dataOptions = null;
            angular.forEach(customFieldTypeOptions, function (option, key) {
                if (option.value === dataType) {
                    dataOptions = option;
                }
            });
            return dataOptions;
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.customField")
    .component("customFieldDataTypeSelect", {
      bindings: {
        selectedDataType: "=",
        onUpdate: "&",
        isDisabled: "=",
        labelText: "@"
      },
      templateUrl:
        "app/main/custom-field/components/custom-field-data-type-select/custom-field-data-type-select.tmpl.html",
      controller: "CustomFieldDataTypeSelectController as vm"
    })
    .controller(
      "CustomFieldDataTypeSelectController",
      CustomFieldDataTypeSelectController
    );

  /* @ngInject */
  function CustomFieldDataTypeSelectController(customFieldTypeOptions) {
    var vm = this;

    vm.dataTypes = [];

    vm.onSelectChanged = onSelectChanged;

    vm.$onInit = function() {
      for (var key in customFieldTypeOptions) {
        if (customFieldTypeOptions.hasOwnProperty(key)) {
          vm.dataTypes.push({
            value: customFieldTypeOptions[key].value,
            text: customFieldTypeOptions[key].text
          });
        }
      }
    };

    /*///////////*/

    function onSelectChanged(dataType) {
      vm.onUpdate({ action: "changed", value: dataType });
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.customField")
    .component("customFieldCategorySelect", {
      bindings: {
        customFieldCategoryId: "=",
        customFieldCategory: "=",
        onUpdate: "&",
        labelText: "@",
        isRequired: "=",
        displayText: "="
      },
      templateUrl:
        "app/main/custom-field/components/custom-field-category-select/custom-field-category-select.tmpl.html",
      controller: "CustomFieldCategorySelectController as vm"
    })
    .controller(
      "CustomFieldCategorySelectController",
      CustomFieldCategorySelectController
    );

  /* @ngInject */
  function CustomFieldCategorySelectController($filter, dataService) {
    var vm = this;
    vm.isDisabled = true;
    vm.customFieldCategories = [];
    vm.deletedCategories = [];

    vm.onChange = onChange;

    vm.$onInit = function() {
      dataService
        .getAll("CustomFieldCategories")
        .then(function(customFieldCategories) {
          vm.isDisabled = false;

          var activeCustomFieldCategories = $filter("filter")(
            customFieldCategories,
            {
              isDeleted: false
            }
          );

          var deletedCustomFieldCategories = $filter("filter")(
            customFieldCategories,
            {
              isDeleted: true
            }
          );

          vm.customFieldCategories = vm.customFieldCategories.concat(
            activeCustomFieldCategories
          );

          vm.deletedCategories = vm.deletedCategories.concat(
            deletedCustomFieldCategories
          );

          // select current
          if (
            vm.customFieldCategoryId &&
            vm.customFieldCategoryId !== "00000000-0000-0000-0000-000000000000"
          ) {
            vm.customFieldCategory = getCategoryByIdFromCollection(
              vm.customFieldCategoryId,
              vm.customFieldCategories
            );
            if (!vm.customFieldCategory) {
              // Not Found => try deleted
              vm.customFieldCategory = getCategoryByIdFromCollection(
                vm.customFieldCategoryId,
                vm.deletedCategories
              );
              if (vm.customFieldCategory) {
                vm.customFieldCategories.push(vm.customFieldCategory);
              }
            }
          }
        });
    };

    function getCategoryByIdFromCollection(categoryId, collection) {
      if (
        !categoryId ||
        categoryId === "00000000-0000-0000-0000-000000000000" ||
        !collection ||
        collection.length === 0
      )
        return null;
      for (var index = 0; index < collection.length; index++) {
        var category = collection[index];
        if (category.id === categoryId) {
          return category;
        }
      }
      return null;
    }

    function onChange() {
      if (vm.customFieldCategory) {
        vm.customFieldCategoryId = vm.customFieldCategory.id;
      } else {
        vm.customFieldCategoryId = null;
      }
      vm.onUpdate({ action: "change", value: vm.customFieldCategory });
    }
  }
})();

(function () {
    'use strict';

    angular
    .module('app.common')
    .directive('sexSelect', sexSelect);

    /* @ngInject */
    function sexSelect() {
        
        var directive = {
            link: link,
            templateUrl: 'app/main/common/directives/sex-select/sex-select.tmpl.html',
            restrict: 'EA',
            scope: {
                sex: '=',
                onChange: '=',
                labelText: '@' 
            },
            controller: "SexSelectController",
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

        function link(scope, element, attrs) {
          /* */
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.common')
        .controller('SexSelectController', SexSelectController);

    /* @ngInject */
    function SexSelectController(sexSelectOptions) {
        var vm = this;
        vm.sexOptions = sexSelectOptions;
        vm.sexChanged = sexChanged;
        
        //Set to unknown if we have a unknown type (duh!)
        if (vm.sex && vm.sex != 'm' && vm.sex != 'f' && vm.sex != 'o' && vm.sex != 'u') {
            vm.sex = 'u';
        }
        
        function sexChanged() {
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.sex);
            }
        }
    }
})(); 
/**
 * Code from https://stackoverflow.com/questions/18130808/preventing-dealing-with-double-button-clicks-in-angular#18130876
 * Cred: Daniel van Heerden
 */
(function() {
    'use strict';

    angular
        .module('app.common')
        .directive('oneClickOnly', oneClickOnly);

    /* @ngInject */
    function oneClickOnly ($parse, $compile) {

        var directive = {
            restrict: 'A',
            compile: function(tElement, tAttrs) {

                if (tAttrs.ngClick)
                    throw "Cannot have both ng-click and one-click-only on an element";

                tElement.attr('ng-click', 'oneClick($event)');
                tElement.attr('ng-dblclick', 'dblClickStopper($event)');

                tElement.removeAttr('one-click-only');
                var fn = $parse(tAttrs['oneClickOnly']);

                return {
                    pre: function(scope, iElement, iAttrs, controller) {
                        console.log(scope, controller);
                        var run = false;
                        scope.oneClick = function(event) {
                            if (run) {
                                throw "Already clicked";
                            }
                            run = true;
                            $(event.toElement).attr('disabled', 'disabled');

                            fn(scope, { $event: event });

                            return true;
                        };
                        scope.dblClickStopper = function(event) {
                            event.preventDefault();
                            throw "Double click not allowed!";
                            return false;
                        };

                        $compile(iElement)(scope);
                    }
                };
            },
            scope: true
        };
        return directive;
    }
})();
/**
 * Created by JSH on 15.11.2016.
 */
(function() {
    'use strict';

    angular
        .module('app.common')
        .directive('inputFiles', inputFiles);

    function inputFiles () {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                files: '=inputFiles',
                hasFiles: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            element.bind('change', function () {
                scope.$apply(function () {
                    if (element[0].files) {
                        scope.files.length = 0;

                        angular.forEach(element[0].files, function (f) {
                            scope.files.push(f);
                        });

                        scope.hasFiles = true;
                    }
                });
            });

            if (element[0].form) {
                angular.element(element[0].form)
                    .bind('reset', function () {
                        scope.$apply(function () {
                            scope.files.length = 0;
                            scope.hasFiles = false;
                        });
                    });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.common').directive('baldrisImgSrc', [
        'baldrisImageBase',
        'dataService',
        function (baldrisImageBase, dataService) {
            function link(scope, element, attrs) {
                scope.$watch(attrs.baldrisImgSrc, function (value) {
                    var preset = attrs['preset'];
                    evaluateUrl(value, preset).then(function (evaluatedUrl) {
                        attrs.$set('src', evaluatedUrl || null);
                    });
                });

                function isValidImageUrl(url) {
                    if (!url) return false;
                    if (_.startsWith(url, '/') && (_.endsWith(url, 'jpg') || _.endsWith(url, 'jpeg') || _.endsWith(url, 'png') || _.endsWith(url, 'gif'))) {
                        return true;
                    }
                    return false;
                }

                function evaluateUrl(url, preset) {
                    return dataService.getCurrentUser().then(function (currentUser) {
                        var evaluatedUrl = null;

                        if (_.startsWith(url, 'http') || _.startsWith(url, '//')) {
                            // use url
                            evaluatedUrl = url;
                            if (url.indexOf('baldris') > -1 && preset) {
                                evaluatedUrl += '?preset=' + preset;
                            }
                        } else {
                            if (isValidImageUrl(url)) {
                                // use new image service
                                evaluatedUrl = baldrisImageBase + url + '?sasToken=' + encodeURIComponent(currentUser.sasToken);
                                if (preset) {
                                    evaluatedUrl += '&preset=' + preset;
                                }
                            }
                        }

                        return evaluatedUrl;
                    });
                }
            }

            return {
                link: link,
            };
        },
    ]);
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .controller('SignatureDialogController', SignatureDialogController);

    /* @ngInject */
    function SignatureDialogController($window, $mdDialog) {
        var vm = this;

        vm.isInPortrait = getIsInPortrait();
        vm.getIsInPortrait = getIsInPortrait;
        vm.getSignatureWidth = getSignatureWidth;
        vm.getSignatureHeight = getSignatureHeight;
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            var signature = vm.acceptSignature();
            $mdDialog.hide(signature.dataUrl);
        }

        function getIsInPortrait() {
            return $window.matchMedia("(orientation: portrait)").matches;
        }

        function getSignatureWidth() {
            if ($window.innerWidth < 850) return $window.innerWidth;
            return 850;
        }

        function getSignatureHeight() {
            if ($window.innerHeight < 400) return $window.innerHeight - 64;
            return 336;
        }
    }

} ());
(function () {
    'use strict';

    angular.module('app.common').controller('SearchEntityDialogController', SearchEntityDialogController);

    /* @ngInject */
    function SearchEntityDialogController($mdDialog, $filter, entityOptions, dataService) {
        var vm = this;

        //Data
        vm.selectedEntity = null;
        vm.isSearching = false;
        vm.isLoadingEntity = false;
        vm.selectedEntityTypeId = null;
        vm.entityOptions = entityOptions;
        vm.entityTypes = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.onSearchChange = onSearchChange;
        vm.selectItem = selectItem;
        vm.selectEntityType = selectEntityType;
        vm.getTypes = getTypes;

        //////////
        // INIT
        vm.isFetchingTypes = true;
        dataService.getAll(entityOptions.entityTypeController).then(function (entityTypes) {
            // filter away deleted
            if (entityTypes && entityTypes.length > 0 && entityTypes[0] && angular.isDefined(entityTypes[0].isDeleted)) {
                entityTypes = $filter('filter')(entityTypes, { isDeleted: false });
            }
            if (entityOptions.entityTypeSort) {
                vm.entityTypes = $filter('orderBy')(entityTypes, entityOptions.entityTypeSort);
            } else {
                vm.entityTypes = entityTypes;
            }
            vm.isFetchingTypes = false;
        });

        function closeDialog(selectedEntity) {
            $mdDialog.hide(selectedEntity);
        }

        function onSearchChange() {
            if (vm.selectedEntityTypeId) {
                vm.isSearching = true;
                dataService
                    .search(entityOptions.entityController, vm.searchText || '', vm.selectedEntityTypeId, entityOptions.entityTypeIdName)
                    .then(function (searchResults) {
                        var entities = searchResults.data || searchResults;
                        if (entities && entities.length > 0 && entities[0] && angular.isDefined(entities[0].isDeleted)) {
                            entities = $filter('filter')(entities, { isDeleted: false });
                        } else if (entityOptions.entityDeletedProperty) {
                            var searchFilter = {};
                            searchFilter[entityOptions.entityDeletedProperty] = false;
                            entities = $filter('filter')(entities, searchFilter);
                        }
                        if (entityOptions.entitySort) {
                            vm.searchResults = $filter('orderBy')(entities, entityOptions.entitySort);
                        } else {
                            vm.searchResults = entities;
                        }
                        vm.isSearching = false;
                    });
            } else {
                vm.searchResults = [];
            }
        }

        function selectEntityType(entityType) {
            vm.selectedEntityTypeId = entityType.id;
            onSearchChange();
        }

        function selectItem(item) {
            if (item) {
                vm.selectedEntity = item;
            }
        }

        function getTypes(typesString) {
            return typesString.split(' // ');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('openCasketSelect', {
            bindings: {
                openCasket: '=',
                onChanged: '=',
                isDisabled: '=',
                labelText: '@'
            },
            templateUrl: 'app/main/common/components/open-casket-select/open-casket-select.tmpl.html',
            controller: 'OpenCasketSelectController as vm',
        })
        .controller('OpenCasketSelectController', OpenCasketSelectController);

    /* @ngInject */
    function OpenCasketSelectController(openCasketOptions) {
        var vm = this;
        vm.openCasketOptions = openCasketOptions;
        vm.openCasketChanged = openCasketChanged;
        
        function openCasketChanged() {
            if (angular.isFunction(vm.onChange)) {
                vm.onChange(vm.openCasket);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('meetupSelect', {
            bindings: {
                meetup: '=',
                onChanged: '<',
                isDisabled: '<',
                labelText: '@',
                allowCustom: '<'
            },
            templateUrl: 'app/main/common/components/meetup-select/meetup-select.tmpl.html',
            controller: 'MeetupSelectController as vm',
        })
        .controller('MeetupSelectController', MeetupSelectController);

    /* @ngInject */
    function MeetupSelectController(meetupOptions) {
        var vm = this;

        vm.meetupOptions = meetupOptions;

        vm.$onInit = function () {
            vm.onMeetupChanged = onMeetupChanged;
        }

        /*///////////*/

        function onMeetupChanged(e) {
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(vm.meetup, e);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('manyToManySelect', {
            bindings: {
                manyToManyList: '=', // The list containing the manyToManyTypes
                manyToManyName: '@', // The server DTO-name of the manyToManyTypes. Eg. "LocationLocationTypeDto"
                referenceId: '=', // The Id of the type you're adding types to. Eg. location.Id
                referenceIdName: '@', // The name of the Id property on the manyToManyType of the type you're adding types to. Eg. "locationId"
                sourceController: '@', // The name of the controller the fetches types. Eg. "LocationTypes"
                sourceIdName: '@', // The name of the Id property on the sourceType from the controller. Eg. "id"
                sourceName: '@', // The name of the Name property on the sourceType from the controller. Eg. "name"
                targetIdName: '@', // The name of the source Id property on the manyToManyType of the type you're adding types to. Eg. "locationTypeId"
                targetName: '@', // The name of the source Name property on the manyToManyType of the type you're adding types to. Eg. "locationTypeName",
                onUpdate: '&',
                labelText: '@',
                placeholderText: '@',
                minQueryLength: '=',
                isRequired: '<',
                listContainsOnlyForeignKeys: '<',
            },
            templateUrl: 'app/main/common/components/many-to-many-select/many-to-many-select.tmpl.html',
            controller: 'ManyToManySelectController as vm',
        })
        .controller('ManyToManySelectController', ManyToManySelectController);

    /* @ngInject */
    function ManyToManySelectController(dataService, $filter, $scope) {
        var vm = this;

        vm.sourceList = [];
        vm.searchText = null;
        vm.search = search;
        vm.onAddSource = onAddSource;
        vm.onRemoveSource = onRemoveSource;
        vm.transformChip = transformChip;
        vm.manyToManyForm = {};

        //INIT
        vm.$onInit = function () {
            //Create sourceList
            if (!vm.listContainsOnlyForeignKeys) {
                if (vm.manyToManyList && vm.manyToManyList.length > 0) {
                    vm.sourceList = vm.manyToManyList.map(function (manyToManyType) {
                        return {
                            id: manyToManyType[vm.targetIdName],
                            name: manyToManyType[vm.targetName],
                        };
                    });
                }
            } else {
                // Get selected from server
                if (vm.manyToManyList && vm.manyToManyList.length > 0) {
                    dataService.getByUri(vm.sourceController, '', { ids: vm.manyToManyList }).then(function (types) {
                        vm.sourceList = types.map(function (manyToManyType) {
                            return {
                                id: manyToManyType[vm.targetIdName],
                                name: manyToManyType[vm.targetName],
                            };
                        });
                    });
                }
            }

            validate();

            vm.minLength = 0;
            if (angular.isDefined(vm.minQueryLength) && angular.isNumber(vm.minQueryLength)) {
                vm.minLength = vm.minQueryLength;
            }
        };

        vm.$postLink = function () {
            $scope.$watch(
                function () {
                    return vm.manyToManyForm;
                },
                function (newValue, oldValue) {
                    if (newValue && newValue.selections) {
                        validate();
                    }
                }
            );
        };

        //userSearch
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }
        /**
         * Search for users.
         */
        function search(query) {
            if (query) {
                return dataService.search(vm.sourceController, query).then(function (sources) {
                    sources = sources.data || sources;
                    sources = sources.map(function (manyToManyType) {
                        return {
                            id: manyToManyType[vm.sourceIdName],
                            name: manyToManyType[vm.sourceName],
                        };
                    });
                    sources = $filter('orderBy')(sources, vm.sourceName);
                    return sources;
                });
            } else {
                return dataService.getAll(vm.sourceController).then(function (sources) {
                    sources = sources.map(function (manyToManyType) {
                        return {
                            id: manyToManyType[vm.sourceIdName],
                            name: manyToManyType[vm.sourceName],
                        };
                    });
                    sources = $filter('orderBy')(sources, vm.sourceName);
                    return sources;
                });
            }
        }

        function onAddSource(fauxSource) {
            if (!vm.manyToManyList) {
                vm.manyToManyList = [];
            }
            // Get DTO
            if (!vm.listContainsOnlyForeignKeys) {
                dataService.getByUri('Empties', 'Dto/' + vm.manyToManyName).then(function (emptyDto) {
                    emptyDto[vm.targetIdName] = fauxSource.id;
                    emptyDto[vm.targetName] = fauxSource.name;
                    emptyDto[vm.referenceIdName] = vm.referenceId;
                    emptyDto.changeState = 1;
                    vm.manyToManyList.push(emptyDto);
                    vm.onUpdate({ action: 'added', value: emptyDto });
                    validate();
                });
            } else {
                vm.manyToManyList.push(fauxSource.id);
            }
        }

        function onRemoveSource(fauxSource) {
            if (!vm.listContainsOnlyForeignKeys) {
                //get manyToManyType from manyToManyList
                angular.forEach(vm.manyToManyList, function (manyToManyType) {
                    if (manyToManyType[vm.targetIdName] === fauxSource.id) {
                        if (manyToManyType.changeState === 1) {
                            //manyToManyType hasn't been saved and can safely be removed from the array
                            var index = vm.manyToManyList.indexOf(manyToManyType);
                            vm.manyToManyList.splice(index, 1);
                        } else {
                            //manyToManyType is saved in the database and must be marked as removed
                            manyToManyType.changeState = 3;
                        }
                        vm.onUpdate({ action: 'added', value: manyToManyType });
                    }
                });
            } else {
                var idIndex = vm.manyToManyList.indexOf(fauxSource.id);
                vm.manyToManyList.splice(idIndex, 1);
            }
            validate();
        }

        function validate() {
            if (vm.isRequired && (!vm.sourceList || vm.sourceList.length === 0)) {
                if (vm.manyToManyForm && vm.manyToManyForm.selections) {
                    vm.manyToManyForm.selections.$setValidity('required', false);
                }
            } else {
                if (vm.manyToManyForm && vm.manyToManyForm.selections) {
                    vm.manyToManyForm.selections.$setValidity('required', true);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('iconSelect', {
            bindings: {
                iconName: '=',
                onChanged: '=',
                isDisabled: '=',
                labelText: '@'
            },
            templateUrl: 'app/main/common/components/icon-select/icon-select.tmpl.html',
            controller: 'IconSelectController as vm',
        })
        .controller('IconSelectController', IconSelectController);

    /* @ngInject */
    function IconSelectController($q, $filter, msApi) {
        var vm = this;
        vm.icons = {};
        vm.selectedIcon = null;
        vm.searchText = '';

        // Load Icons
        msApi.resolve('icons@get').then(function (icons) {
            vm.icons = icons.icons;
            if (vm.iconName) {
                // find and select current icon
                for (var i = 0; i < vm.icons.length; i++) {
                    var icon = vm.icons[i];
                    if (icon && icon.properties && icon.properties.name && ('icon-' + icon.properties.name) === vm.iconName) {
                        vm.selectedIcon = icon;
                        break;
                    }
                }
            }
        });

        // Methods
        vm.onModelChanged = onModelChanged;
        vm.querySearch = querySearch;

        function onModelChanged() {
            if (vm.selectedIcon) {
                vm.iconName = 'icon-' + vm.selectedIcon.properties.name;
            } else {
                vm.iconName = null;
            }
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(vm.iconName);
            }
        }

        function querySearch(searchText) {
            if (searchText) {
                var filteredResults = $filter('filter')(vm.icons, searchText);
                return $q.when(filteredResults);
            }
            return $q.when(vm.icons);
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('enumFlagSelect', {
            bindings: {
                enumFlag: '=',
                enumFlagOptions: '@',
                onChanged: '=',
                isDisabled: '=',
                onUpdate: '&',
                labelText: '@',
            },
            templateUrl: 'app/main/common/components/enum-flag-select/enum-flag-select.tmpl.html',
            controller: 'EnumFlagSelectController as vm',
        })
        .controller('EnumFlagSelectController', EnumFlagSelectController);

    /* @ngInject */
    function EnumFlagSelectController($injector) {
        var vm = this;

        vm.$onInit = function () {
            //Get Enum Flag Options
            if (vm.enumFlagOptions) {
                vm.options = $injector.get(vm.enumFlagOptions);
            }
        };

        vm.isSelected = isSelected;
        vm.toggle = toggle;

        function isSelected(option) {
            if (vm.enumFlag) {
                var enumOptions = vm.enumFlag.split(', ');
                return enumOptions.indexOf(option.value) > -1;
            } else {
                if (vm.enumFlag && vm.enumFlag.indexOf(option.value) > -1) {
                    return true;
                }
            }

            return false;
        }

        function toggle(option) {
            if (isSelected(option)) {
                if (vm.enumFlag.indexOf(',') > -1) {
                    var enumOptions = vm.enumFlag.split(', ');
                    var optionIndex = enumOptions.indexOf(option.value);
                    if (optionIndex > -1) {
                        enumOptions.splice(optionIndex, 1);
                    }
                    vm.enumFlag = enumOptions.join(', ');
                } else {
                    vm.enumFlag = vm.enumFlag.replace(option.value, '');
                }

                if (!vm.enumFlag) {
                    vm.enumFlag = 'none';
                }
            } else {
                if (vm.enumFlag === 'none') {
                    vm.enumFlag = null;
                }
                if (vm.enumFlag) {
                    vm.enumFlag += ', ' + option.value;
                } else {
                    vm.enumFlag = option.value;
                }
            }
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(vm.enumFlag);
            }
            if (vm.dataForm) {
                vm.dataForm.$setDirty();
            }
            vm.onUpdate({ value: vm.enumFlag, option: option.value });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('editPriceInput', {
            bindings: {
                priceExVat: '=',
                vatRate: '=',
                isRequired: '<',
                onUpdate: '&',
                labelText: '@',
                isDisabled: '='
            },
            templateUrl: 'app/main/common/components/edit-price-input/edit-price-input.tmpl.html',
            controller: 'EditPriceInputController as vm',
        })
        .controller('EditPriceInputController', EditPriceInputController);

    /* @ngInject */
    function EditPriceInputController($scope) {
        var vm = this;

        vm.onPriceChanged = onPriceChanged;
        vm.onPriceVatChanged = onPriceVatChanged;

        //INIT
        vm.$onInit = function () {
            vm.isRequired = vm.isRequired || false;
            if (!vm.isDisabled) {
                vm.vatRate = vm.vatRate || 0;
            }
            vm.priceIncVat = 0;
            // Data
            if (vm.priceExVat) {
                onPriceChanged();
            }
        }

        vm.$postLink = function() {
            $scope.$watch(function() { return vm.priceExVat; }, function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    onPriceChanged();
                }
            });
        }

        function onPriceChanged() {
            if (vm.priceExVat && vm.vatRate > 0) {
                vm.priceIncVat = vm.priceExVat * ((100 + vm.vatRate) / 100);
                return;
            }
            vm.priceIncVat = vm.priceExVat || 0;
        }

        function onPriceVatChanged() {
            if (vm.priceIncVat && vm.vatRate > 0) {
                vm.priceExVat = vm.priceIncVat / ((100 + vm.vatRate) / 100);
                return;
            }
            vm.priceExVat = vm.priceIncVat || 0;
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.common")
    .component("dateTimeSelect", {
      bindings: {
        baldrisModel: "=ngModel",
        isDisabled: "=",
        isRequired: "<",
        labelDateText: "@",
        labelTimeText: "@",
        hideTimePart: "=",
        maxTime: "=",
        minTime: "=",
        maxText: "@",
        minText: "@",
        onUpdate: "&"
      },
      templateUrl: "app/main/common/components/date-time-select/date-time-select.tmpl.html",
      controller: "DateTimeSelectController as vm"
    })
    .controller("DateTimeSelectController", DateTimeSelectController);

  /* @ngInject */
  function DateTimeSelectController($scope) {
    var vm = this;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
      if (vm.baldrisModel) {
        var m = moment(vm.baldrisModel);
        if (m.isValid()) {
          vm.timePart = m.format("LT");
        }
      }
    };

    //Changes
    vm.$postLink = function() {
      $scope.$watch(
        function() {
          return vm.baldrisModel;
        },
        function(newValue, oldValue) {
          if (newValue) {
            var m = moment(vm.baldrisModel);
            if (m.isValid()) {
              vm.timePart = m.format("LT");
            }
          } else {
            vm.timePart = null;
          }
        }
      );
    };

    // Methods
    vm.datePartChanged = datePartChanged;
    vm.timePartChanged = timePartChanged;

    function setTimeValidation(isValid) {
      vm.dateTimeForm.timePart.$setValidity("invalidTime", isValid);
    }

    function setTimePart() {
      var timeMoment = moment(vm.timePart, "LT");
      if (timeMoment.isValid()) {
        var dateMoment = moment(vm.baldrisModel);
        dateMoment.hour(timeMoment.hour());
        dateMoment.minute(timeMoment.minute());
        vm.baldrisModel = dateMoment.format("YYYY-MM-DDTHH:mm:ss");
        setTimeValidation(true);
      } else {
        setTimeValidation(false);
      }
    }

    function datePartChanged() {
      if (!vm.baldrisModel) {
        vm.timePart = null;
      } else {
        if (vm.timePart) {
          var dateMoment = moment(vm.baldrisModel);
          if (dateMoment.isValid()) {
            setTimePart();
          }
        } else {
          vm.timePart = moment()
            .add(1, "hours")
            .startOf("hour")
            .format("LT");
          setTimePart();
        }
      }
    }

    function timePartChanged() {
      if (!vm.baldrisModel) {
        vm.baldrisModel = moment().format("YYYY-MM-DDTHH:mm:ss");
      }
      if (!vm.timePart) {
        vm.timePart = moment()
          .startOf("day")
          .format("LT");
      }
      setTimePart();
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.common")
    .component("dateTimeRangeSelect", {
      bindings: {
        startTime: "=",
        endTime: "=",
        isDisabled: "=",
        isRequired: "<",
        labelStartText: "@",
        labelEndText: "@",
        maxTime: "=",
        minTime: "=",
        maxText: "@",
        minText: "@",
        mode: "@",
        onUpdate: "&"
      },
      templateUrl: "app/main/common/components/date-time-range-select/date-time-range-select.tmpl.html",
      controller: "DateTimeRangeSelectController as vm"
    })
    .controller("DateTimeRangeSelectController", DateTimeRangeSelectController);

  /* @ngInject */
  function DateTimeRangeSelectController() {
    var vm = this;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
      if (vm.startTime) {
        var m = moment(vm.startTime);
        if (m.isValid()) {
          vm.startTimePart = m.format("LT");
        }
      }
      if (vm.endTime) {
        var m = moment(vm.endTime);
        if (m.isValid()) {
          vm.endTimePart = m.format("LT");
        }
      }
    };

    // Methods
    vm.checkOverlap = checkOverlap;
    vm.datePartChanged = datePartChanged;
    vm.timePartChanged = timePartChanged;

    function setTimeValidation(isValid, target) {
      vm.dateTimeRangeForm[target + "Time"].$setValidity("invalidTime", isValid);
    }

    function setTimePart(target) {
      var timeMoment = moment(vm[target + "TimePart"], "LT");
      if (timeMoment.isValid()) {
        var dateMoment = moment(vm[target + "Time"]);
        dateMoment.hour(timeMoment.hour());
        dateMoment.minute(timeMoment.minute());
        vm[target + "Time"] = dateMoment.format("YYYY-MM-DDTHH:mm:ss");
        setTimeValidation(true, target);
      } else {
        setTimeValidation(false, target);
      }
    }

    function datePartChanged(target) {
      if (!vm[target + "Time"]) {
        vm[target + "TimePart"] = null;
      } else {
        if (vm[target + "TimePart"]) {
          var dateMoment = moment(vm[target + "Time"]);
          if (dateMoment.isValid()) {
            setTimePart(target);
            if (target === "start") {
              vm.endTime = moment(vm.startTime)
                .add(1, "hours")
                .format("YYYY-MM-DDTHH:mm:ss");
              setTimePart("end");
            }
          }
        } else {
          if (target === "start") {
            vm[target + "TimePart"] = vm.endTime
              ? moment(vm.endTime)
                  .add(-1, "hours")
                  .format("LT")
              : moment()
                  .add(1, "hours")
                  .startOf("hour")
                  .format("LT");
          } else {
            vm[target + "TimePart"] = vm.startTime
              ? moment(vm.startTime)
                  .add(1, "hours")
                  .format("LT")
              : moment()
                  .add(1, "hours")
                  .startOf("hour")
                  .format("LT");
          }
          setTimePart(target);
        }
        if (target === "start" && !vm.endTime) {
          // Also set end-time
          vm.endTimePart = moment(vm.startTime)
            .add(1, "hours")
            .format("LT");
          vm.endTime = moment(vm.startTime)
            .add(1, "hours")
            .format("YYYY-MM-DDTHH:mm:ss");
        } else if (target === "end" && !vm.startTime) {
          // Also set start-time
          vm.startTimePart = moment(vm.endTime)
            .add(1, "hours")
            .format("LT");
          vm.startTime = moment(vm.endTime)
            .add(1, "hours")
            .format("YYYY-MM-DDTHH:mm:ss");
        }
      }
      checkOverlap();
    }

    function timePartChanged(target) {
      if (!vm[target + "Time"]) {
        vm[target + "Time"] = moment().format("YYYY-MM-DDTHH:mm:ss");
      }
      if (!vm[target + "TimePart"]) {
        vm[target + "TimePart"] = moment()
          .startOf("day")
          .format("LT");
      }
      setTimePart(target);
      if (target === "start") {
        vm.endTime = moment(vm.startTime)
          .add(1, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
        vm.endTimePart = moment(vm.endTime).format("LT");
      }

      checkOverlap();
    }

    function setOverlapValidation(isValid, target) {
      setTimeOverlapValidation(isValid, target);
      setDateOverlapValidation(isValid, target);
    }

    function setTimeOverlapValidation(isValid, target) {
      vm.dateTimeRangeForm[target + "Time"].$setValidity("timeOverlap", isValid);
    }

    function setDateOverlapValidation(isValid, target) {
      vm.dateTimeRangeForm[target + "Date"].$setValidity("dateOverlap", isValid);
    }

    function checkOverlap() {
      if (!vm.startTime || !vm.endTime) {
        setOverlapValidation(true, "start");
        setOverlapValidation(true, "end");
        onUpdate();
        return;
      }
      if (moment(vm.startTime).isAfter(vm.endTime, "day")) {
        setDateOverlapValidation(false, "start");
        setDateOverlapValidation(false, "end");
        onUpdate();
        return;
      } else if (moment(vm.startTime).isAfter(vm.endTime)) {
        setTimeOverlapValidation(false, "start");
        setTimeOverlapValidation(false, "end");
        onUpdate();
        return;
      }
      setOverlapValidation(true, "start");
      setOverlapValidation(true, "end");
      onUpdate();
    }

    function onUpdate() {
      vm.onUpdate({ startTime: vm.startTime, endDate: vm.endTime });
    }
  }
})();

(function() {
  "use strict";

  // Original Code copied from https://github.com/angular/material/blob/master/src/components/datepicker/js/datepickerDirective.js
  // Goal is to remove the dependency on the native JS Date Object and use only strings to avoid all timezone issues
  // Moment.js will be used to perform date-operations

  angular.module("app.common").directive("dateSelect", datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepicker
   * @module material.components.datepicker
   *
   * @param {String} ng-model The component's model. Expects a string in the format of yyyy-MM-ddTHH:mm:ss.
   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
   *  updated. Also allows for a timezone to be specified.
   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">
   *    Read more at the ngModelOptions docs.</a>
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar
   *  is opened.
   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the
   *  calendar is closed.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   * @param {String=} md-min-date Expression representing a min date (inclusive). Expects a string in the format of yyyy-MM-ddTHH:mm:ss.
   * @param {String=} md-max-date Expression representing a max date (inclusive). Expects a string in the format of yyyy-MM-ddTHH:mm:ss.
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a string in the format of yyyy-MM-ddTHH:mm:ss and returning a
   *  boolean whether it can be selected or not.
   * @param {String=} md-placeholder The date input placeholder value.
   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input
   *  is focused.
   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar
   *  on-demand.
   * @param {String=} md-current-view Default open view of the calendar pane. Can be either
   *  "month" or "year".
   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
   *  This option can be used if the user is only supposed to choose from a certain date type
   *  (e.g. only selecting the month).
   * Can be either "month" or "day". **Note** that this will overwrite the `md-current-view` value.
   *
   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that
   *  this may cause the datepicker to not align properly with other components.
   *  **Use at your own risk.** Possible values are:
   * * `"all"` - Hides all icons.
   * * `"calendar"` - Only hides the calendar icon.
   * * `"triangle"` - Only hides the triangle icon.
   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see {@link api/service/$mdDateLocaleProvider $mdDateLocaleProvider}.
   *
   * This component supports
   * [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   * * `debounceInterval`: ms to delay input processing (since last debounce reset);
   *    default value 500ms
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */

  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
    return {
      template: function(tElement, tAttrs) {
        // Buttons are not in the tab order because users can open the calendar via keyboard
        // interaction on the text input, and multiple tab stops for one component (picker)
        // may be confusing.
        var hiddenIcons = tAttrs.mdHideIcons;
        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;

        var calendarButton =
          hiddenIcons === "all" || hiddenIcons === "calendar"
            ? ""
            : '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
              'tabindex="-1" aria-hidden="true" ' +
              'ng-click="ctrl.openCalendarPane($event)">' +
              '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
              'md-svg-src="' +
              $$mdSvgRegistry.mdCalendar +
              '"></md-icon>' +
              "</md-button>";

        var triangleButton = "";

        if (hiddenIcons !== "all" && hiddenIcons !== "triangle") {
          triangleButton =
            "" +
            '<md-button type="button" md-no-ink ' +
            'class="md-datepicker-triangle-button md-icon-button" ' +
            'ng-click="ctrl.openCalendarPane($event)" ' +
            'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
            '<div class="md-datepicker-expand-triangle"></div>' +
            "</md-button>";

          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
        }

        return (
          calendarButton +
          '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
          "<input " +
          (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : "") +
          'class="md-datepicker-input" ' +
          'ng-model="ctrl.inputStringValue" ' +
          'ui-mask="99.99.9999" ' +
          'ui-mask-placeholder-char=" "' +
          'ng-change="ctrl.handleInputEvent()" ' +
          'aria-haspopup="true" ' +
          'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
          'ng-focus="ctrl.setFocused(true)" ' +
          'ng-blur="ctrl.setFocused(false)"> ' +
          triangleButton +
          "</div>" +
          // This pane will be detached from here and re-attached to the document body.
          '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
          '<div class="md-datepicker-input-mask">' +
          '<div class="md-datepicker-input-mask-opaque"></div>' +
          "</div>" +
          '<div class="md-datepicker-calendar">' +
          '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
          'md-current-view="{{::ctrl.currentView}}" ' +
          'md-mode="{{::ctrl.mode}}" ' +
          'md-min-date="ctrl.minDate" ' +
          'md-max-date="ctrl.maxDate" ' +
          'md-date-filter="ctrl.dateFilter" ' +
          'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
          "</md-calendar>" +
          "</div>" +
          "</div>"
        );
      },
      require: ["ngModel", "dateSelect", "?^mdInputContainer", "?^form"],
      scope: {
        minDate: "=mdMinDate",
        maxDate: "=mdMaxDate",
        placeholder: "@mdPlaceholder",
        currentView: "@mdCurrentView",
        mode: "@mdMode",
        dateFilter: "=mdDateFilter",
        isOpen: "=?mdIsOpen",
        debounceInterval: "=mdDebounceInterval",
        dateLocale: "=mdDateLocale"
      },
      controller: DatePickerCtrl,
      controllerAs: "ctrl",
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];
        var mdInputContainer = controllers[2];
        var parentForm = controllers[3];
        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);

        if (mdInputContainer) {
          // We need to move the spacer after the datepicker itself,
          // because md-input-container adds it after the
          // md-datepicker-input by default. The spacer gets wrapped in a
          // div, because it floats and gets aligned next to the datepicker.
          // There are easier ways of working around this with CSS (making the
          // datepicker 100% wide, change the `display` etc.), however they
          // break the alignment with any other form controls.
          var spacer = element[0].querySelector(".md-errors-spacer");

          if (spacer) {
            element.after(angular.element("<div>").append(spacer));
          }

          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
          mdInputContainer.input = element;
          mdInputContainer.element
            .addClass(INPUT_CONTAINER_CLASS)
            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== "calendar" && attr.mdHideIcons !== "all");

          if (!mdInputContainer.label) {
            $mdAria.expect(element, "aria-label", attr.mdPlaceholder);
          } else if (!mdNoAsterisk) {
            attr.$observe("required", function(value) {
              mdInputContainer.label.toggleClass("md-required", !!value);
            });
          }

          scope.$watch(
            mdInputContainer.isErrorGetter ||
              function() {
                return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
              },
            mdInputContainer.setInvalid
          );
        } else if (parentForm) {
          // If invalid, highlights the input when the parent form is submitted.
          var parentSubmittedWatcher = scope.$watch(
            function() {
              return parentForm.$submitted;
            },
            function(isSubmitted) {
              if (isSubmitted) {
                mdDatePickerCtrl.updateErrorState();
                parentSubmittedWatcher();
              }
            }
          );
        }
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = "md-datepicker-invalid";

  /** Class applied to the datepicker when it's open. */
  var OPEN_CLASS = "md-datepicker-open";

  /** Class applied to the md-input-container, if a datepicker is placed inside it */
  var INPUT_CONTAINER_CLASS = "_md-datepicker-floating-label";

  /** Class to be applied when the calendar icon is enabled. */
  var HAS_CALENDAR_ICON_CLASS = "_md-datepicker-has-calendar-icon";

  /** Class to be applied when the triangle icon is enabled. */
  var HAS_TRIANGLE_ICON_CLASS = "_md-datepicker-has-triangle-icon";

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /** Used for checking whether the current user agent is on iOS or Android. */
  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  function DatePickerCtrl(
    $scope,
    $element,
    $attrs,
    $window,
    $mdConstant,
    $mdTheming,
    $mdUtil,
    $mdDateLocale,
    $$mdDateUtil,
    $$rAF,
    $filter,
    $timeout
  ) {
    /** @final */
    this.$window = $window;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /** @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /** @final */
    this.$timeout = $timeout;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!angular.JQLite}
     */
    this.documentElement = angular.element(document.documentElement);

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector("input");

    /** @final {!angular.JQLite} */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector(".md-datepicker-input-container");

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector(".md-datepicker-calendar-pane");

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector(".md-datepicker-button");

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {!angular.JQLite}
     */
    this.inputMask = angular.element($element[0].querySelector(".md-datepicker-input-mask-opaque"));

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Attributes} */
    this.$attrs = $attrs;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @type {Date} */
    this.date = null;

    /** @type {String} */
    this.dateString = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /** @type {boolean} Whether the calendar should open when the input is focused. */
    this.openOnFocus = $attrs.hasOwnProperty("mdOpenOnFocus");

    /** @final */
    this.mdInputContainer = null;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    /** @type {String} Unique id for the calendar pane. */
    this.calendarPaneId = "md-date-pane-" + $mdUtil.nextUid();

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /**
     * Name of the event that will trigger a close. Necessary to sniff the browser, because
     * the resize event doesn't make sense on mobile and can have a negative impact since it
     * triggers whenever the browser zooms in on a focused input.
     */
    this.windowEventName = IS_MOBILE_REGEX.test(navigator.userAgent || navigator.vendor || window.opera)
      ? "orientationchange"
      : "resize";

    /** Pre-bound close handler so that the event listener can be removed. */
    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);

    /** The built-in AngularJS date filter. */
    this.ngDateFilter = $filter("date");

    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
    this.leftMargin = 20;

    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
    this.topMargin = null;

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if ($attrs.tabindex) {
      this.ngInputElement.attr("tabindex", $attrs.tabindex);
      $attrs.$set("tabindex", null);
    } else {
      $attrs.$set("tabindex", "-1");
    }

    $attrs.$set("aria-owns", this.calendarPaneId);

    $mdTheming($element);
    $mdTheming(angular.element(this.calendarPane));

    var self = this;

    $scope.$on("$destroy", function() {
      self.detachCalendarPane();
    });

    if ($attrs.mdIsOpen) {
      $scope.$watch("ctrl.isOpen", function(shouldBeOpen) {
        if (shouldBeOpen) {
          self.openCalendarPane({
            target: self.inputElement
          });
        } else {
          self.closeCalendarPane();
        }
      });
    }

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }
  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  DatePickerCtrl.prototype.$onInit = function() {
    /**
     * Holds locale-specific formatters, parsers, labels etc. Allows
     * the user to override specific ones from the $mdDateLocale provider.
     * @type {!Object}
     */
    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();
  };

  /**
   * Sets up the controller's reference to ngModelController and
   * applies AngularJS's `input[type="date"]` directive.
   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
   * @param {Object} inputDirective Config for AngularJS's `input` directive.
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
    this.ngModelCtrl = ngModelCtrl;
    this.mdInputContainer = mdInputContainer;

    // The input needs to be [type="date"] in order to be picked up by AngularJS.
    // this.$attrs.$set("type", "date");

    // Invoke the `input` directive link function, adding a stub for the element.
    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
    // It works by calling the link function directly which then adds the proper `$parsers` and
    // `$formatters` to the ngModel controller.
    inputDirective[0].link.pre(
      this.$scope,
      {
        on: angular.noop,
        val: angular.noop,
        0: {}
      },
      this.$attrs,
      [ngModelCtrl]
    );

    var self = this;

    // Responds to external changes to the model value.
    self.ngModelCtrl.$formatters.push(function(value) {
      if (value && !angular.isString(value)) {
        throw Error(
          "The ng-model for date-select must be a String instance and a value " +
            "that can be parsed into a date. Currently the model is of type: " +
            typeof value
        );
      }
      var m = moment(value);

      if (value && !m.isValid()) {
        throw Error(
          "The ng-model for date-select must be a String instance and a value " +
            "that can be parsed into a date. The current value of: " +
            value +
            " can't be parsed"
        );
      }

      // Format as datestring without timezone
      value = value ? m.format("YYYY-MM-DDTHH:mm:ss") : null;

      self.onExternalChange(value);

      return value;
    });

    // Responds to external error state changes (e.g. ng-required based on another input).
    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));

    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
    // the `<md-datepicker>`.
    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, "updateOn");

    if (updateOn) {
      this.ngInputElement.on(updateOn, angular.bind(this.$element, this.$element.triggerHandler, updateOn));
    }
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on("md-calendar-change", function(event, date) {
      self.setModelValue(date);
      self.onExternalChange(date);
      self.closeCalendarPane();
    });

    self.ngInputElement.on("input", angular.bind(self, self.resizeInputElement));

    var debounceInterval = angular.isDefined(this.debounceInterval) ? this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
    self.ngInputElement.on("input", self.$mdUtil.debounce(self.handleInputEvent, debounceInterval, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on("keydown", function(event) {
      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    if (self.openOnFocus) {
      self.ngInputElement.on("focus", angular.bind(self, self.openCalendarPane));
      angular.element(self.$window).on("blur", self.windowBlurHandler);

      $scope.$on("$destroy", function() {
        angular.element(self.$window).off("blur", self.windowBlurHandler);
      });
    }

    $scope.$on("md-calendar-close", function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperitively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs.ngDisabled) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, "placeholder", {
      get: function() {
        return self.inputElement.placeholder;
      },
      set: function(value) {
        self.inputElement.placeholder = value || "";
      }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;

    if (this.calendarButton) {
      this.calendarButton.disabled = isDisabled;
    }
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {String=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (date && moment(date).isValid()) {
      // Force all dates to midnight in order to ignore the time portion.
      date = moment(date)
        .startOf("day")
        .toDate();

      if (this.minDate && moment(this.minDate).isValid()) {
        var minDate = moment(this.minDate).startOf("day");
        this.ngModelCtrl.$setValidity("mindate", moment(date).isSameOrAfter(minDate));
      }

      if (this.maxDate && moment(this.maxDate).isValid()) {
        var maxDate = moment(this.maxDate).startOf("day");
        this.ngModelCtrl.$setValidity("maxdate", moment(date).isSameOrBefore(maxDate));
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity("filtered", this.dateFilter(date));
      }
    } else if (date && !moment(date).isValid()) {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      this.ngModelCtrl.$setValidity("valid", false);
    }

    var input = this.inputStringValue;
    var m = moment(input, "L");

    if (!m.isValid() && this.ngModelCtrl.$valid) {
      this.ngModelCtrl.$setValidity("valid", date == null || date === "");
    }

    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
  };

  /**
   * Check to see if the input is valid as the validation should fail if the model is invalid
   *
   * @param {String} inputString
   * @param {String} parsedDate
   * @return {boolean} Whether the input is valid
   */
  DatePickerCtrl.prototype.isInputValid = function(inputString, parsedDate) {
    return (
      inputString === "" ||
      (this.dateUtil.isValidDate(parsedDate) &&
        this.locale.isDateComplete(inputString) &&
        this.isDateEnabled(parsedDate))
    );
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ["mindate", "maxdate", "filtered", "valid"].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputStringValue ? this.inputStringValue.length + EXTRA_INPUT_SIZE : EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputStringValue;
    var m = moment(inputString, "L").startOf("day");
    var parsedDate = inputString ? m.toDate() : null;
    //this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = inputString == null || inputString === "" || m.isValid();

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.setModelValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {String=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return (
      this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
      (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date))
    );
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    var body = document.body;

    calendarPane.style.transform = "";
    this.$element.addClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
    angular.element(body).addClass("md-datepicker-is-showing");

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = body.getBoundingClientRect();

    if (!this.topMargin || this.topMargin < 0) {
      this.topMargin = (this.inputMask.parent().prop("clientHeight") - this.ngInputElement.prop("clientHeight")) / 2;
    }

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = bodyRect.top < 0 && document.body.scrollTop == 0 ? -bodyRect.top : document.body.scrollTop;

    var viewportLeft = bodyRect.left < 0 && document.body.scrollLeft == 0 ? -bodyRect.left : document.body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // Creates an overlay with a hole the same size as element. We remove a pixel or two
    // on each end to make it overlap slightly. The overlay's background is added in
    // the theme in the form of a box-shadow with a huge spread.
    this.inputMask.css({
      position: "absolute",
      left: this.leftMargin + "px",
      top: this.topMargin + "px",
      width: elementRect.width - 1 + "px",
      height: elementRect.height - 2 + "px"
    });

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = "scale(" + scale + ")";
      }

      calendarPane.classList.add("md-datepicker-pos-adjusted");
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom && viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add("md-datepicker-pos-adjusted");
    }

    calendarPane.style.left = paneLeft + "px";
    calendarPane.style.top = paneTop + "px";
    document.body.appendChild(calendarPane);

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add("md-pane-open");
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
    angular.element(document.body).removeClass("md-datepicker-is-showing");
    this.calendarPane.classList.remove("md-pane-open");
    this.calendarPane.classList.remove("md-datepicker-pos-adjusted");

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the
      // angular state of this element to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {Event} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
      this.isCalendarOpen = this.isOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();
      this.evalAttr("ngFocus");

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propagated up to the body and handled.
      var self = this;
      this.$timeout(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propagated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on("click touchstart", self.bodyClickHandler);
      }, 100);

      window.addEventListener(this.windowEventName, this.windowEventHandler);
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      var self = this;

      self.detachCalendarPane();
      self.ngModelCtrl.$setTouched();
      self.evalAttr("ngBlur");

      self.documentElement.off("click touchstart", self.bodyClickHandler);
      window.removeEventListener(self.windowEventName, self.windowEventHandler);

      self.calendarPaneOpenedFrom.focus();
      self.calendarPaneOpenedFrom = null;

      if (self.openOnFocus) {
        // Ensures that all focus events have fired before resetting
        // the calendar. Prevents the calendar from reopening immediately
        // in IE when md-open-on-focus is set. Also it needs to trigger
        // a digest, in order to prevent issues where the calendar wasn't
        // showing up on the next open.
        self.$timeout(reset);
      } else {
        reset();
      }
    }

    function reset() {
      self.isCalendarOpen = self.isOpen = false;
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector("md-calendar")).controller("mdCalendar");
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focus();
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }

    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
    // because they also get called when the calendar is opened/closed.
    if (!this.openOnFocus) {
      this.evalAttr(isFocused ? "ngFocus" : "ngBlur");
    }

    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      var isInCalendar = this.$mdUtil.getClosest(event.target, "md-calendar");

      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };

  /**
   * Handles the event when the user navigates away from the current tab. Keeps track of
   * whether the input was focused when the event happened, in order to prevent the calendar
   * from re-opening.
   */
  DatePickerCtrl.prototype.handleWindowBlur = function() {
    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
  };

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   */
  DatePickerCtrl.prototype.evalAttr = function(attr) {
    if (this.$attrs[attr]) {
      this.$scope.$parent.$eval(this.$attrs[attr]);
    }
  };

  /**
   * Sets the ng-model value by first converting the date object into a string. Converting it
   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
   * the value into a Date object afterwards, before setting it on the model.
   * @param {String=} value Date to be set as the model value.
   */
  DatePickerCtrl.prototype.setModelValue = function(value) {
    // var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, "timezone");
    var m = moment(value);
    this.ngModelCtrl.$setViewValue(value ? m.format("YYYY-MM-DDTHH:mm:ss") : null);
  };

  /**
   * Updates the datepicker when a model change occurred externally.
   * @param {Date=} value Value that was set to the model.
   */
  DatePickerCtrl.prototype.onExternalChange = function(value) {
    // var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, "timezone");

    var m = moment(value);

    this.date = value ? m.toDate() : null;
    this.dateString = value;

    this.inputStringValue = value ? m.format("L") : "";
    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
    this.resizeInputElement();
    this.updateErrorState();
  };
})();

(function() {
  "use strict";

  angular
    .module("app.common")
    .component("dateRangeSelect", {
      bindings: {
        startDate: "=",
        endDate: "=",
        isDisabled: "=",
        isRequired: "<",
        labelStartText: "@",
        labelEndText: "@",
        maxTime: "=",
        minTime: "=",
        maxText: "@",
        minText: "@",
        overlapStartText: "@",
        overlapEndText: "@",
        mode: "@",
        onUpdate: "&"
      },
      templateUrl: "app/main/common/components/date-range-select/date-range-select.tmpl.html",
      controller: "DateRangeSelectController as vm"
    })
    .controller("DateRangeSelectController", DateRangeSelectController);

  /* @ngInject */
  function DateRangeSelectController() {
    var vm = this;

    //INIT
    vm.$onInit = function() {
      vm.isRequired = vm.isRequired || false;
    };

    // Methods
    vm.checkOverlap = checkOverlap;

    function setOverlapValidation(isValid) {
      vm.dateRangeForm.startDate.$setValidity("overlap", isValid);
      vm.dateRangeForm.endDate.$setValidity("overlap", isValid);
    }

    function checkOverlap() {
      if (!vm.startDate || !vm.endDate) {
        setOverlapValidation(true);
        onUpdate();
        return;
      }
      if (moment(vm.startDate).isAfter(vm.endDate, "day")) {
        setOverlapValidation(false);
        onUpdate();
        return;
      }
      setOverlapValidation(true);
      onUpdate();
    }

    function onUpdate() {
      vm.onUpdate({ startDate: vm.startDate, endDate: vm.endDate });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('billToSelect', {
            bindings: {
                billTo: '=',
                onChanged: '<',
                isDisabled: '<',
                labelText: '@'
            },
            templateUrl: 'app/main/common/components/bill-to-select/bill-to-select.tmpl.html',
            controller: 'BillToSelectController as vm',
        })
        .controller('BillToSelectController', BillToSelectController);

    /* @ngInject */
    function BillToSelectController(billToOptions) {
        var vm = this;

        vm.billToOptions = billToOptions;

        vm.$onInit = function () {
            vm.onBillToChanged = onBillToChanged;
        }

        /*///////////*/

        function onBillToChanged(e) {
            if (angular.isFunction(vm.onChanged)) {
                vm.onChanged(vm.billTo, e);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('basicAuthLoginForm', {
            bindings: {
                defaultCredentials: '<',
                onAuthenticate: '&'
            },
            templateUrl: 'app/main/common/components/basic-auth-login-form/basic-auth-login-form.tmpl.html',
            controller: 'BasicAuthLoginFormController as vm',
        })
        .controller('BasicAuthLoginFormController', BasicAuthLoginFormController);

    /* @ngInject */
    function BasicAuthLoginFormController() {
        var vm = this;

        vm.credentials = {
            username: null,
            password: null
        };

        vm.updateDefaultCredentials = updateDefaultCredentials;
        vm.authenticate = authenticate;

        vm.$onChanges = function (changes) {
            if (changes.defaultCredentials) {
                updateDefaultCredentials();
            }
        };

        function updateDefaultCredentials() {
            if(vm.credentials.username == null){
                vm.credentials.username = vm.defaultCredentials.username;
            }
            if(vm.credentials.password == null){
                vm.credentials.password = vm.defaultCredentials.password;
            }
        }

        function authenticate(event) {
            event.preventDefault();
            vm.onAuthenticate({ credentials: vm.credentials });
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('baldrisUserSelect', {
            bindings: {
                baldrisUserId: '=',
                baldrisUser: '=',
                onSelected: '=',
                labelText: '@',
                displayText: '='
            },
            templateUrl: 'app/main/common/components/baldris-user-select/baldris-user-select.tmpl.html',
            controller: 'BaldrisUserSelectController as vm',
        })
        .controller('BaldrisUserSelectController', BaldrisUserSelectController);

    /* @ngInject */
    function BaldrisUserSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;


        vm.$onInit = function () {
            //Get Current User
            if (vm.baldrisUserId && !vm.baldrisUser) {
                dataService.getById('BaldrisUsers', vm.baldrisUserId, true).then(function (baldrisUser) {
                    vm.baldrisUser = baldrisUser;
                });
            }
        }


        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (query) {
                return dataService.search('BaldrisUsers', query).then(function (baldrisFiles) {
                    return $filter('orderBy')(baldrisFiles, 'displayName');
                });
            } else {
                return dataService.getByUri('BaldrisUsers', 'Active').then(function (baldrisFiles) {
                    return $filter('orderBy')(baldrisFiles, 'displayName');
                });
            }

        }

        function searchTextChange(text) {

        }


        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.baldrisUserId = item.id;
                vm.baldrisUserForm.baldrisUser.$setValidity('invalidBaldrisUser', true);
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = item.displayName;
                }
            } else {
                vm.baldrisUserId = null;
                if (vm.searchText) {
                    vm.baldrisUserForm.baldrisUser.$setValidity('invalidBaldrisUser', false);
                }
                if(angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.common')
        .component('baldrisImage', {
            bindings: {
                imgSrc: '<',
                titleText: '<',
                altText: '<',
                preset: '@',
            },
            templateUrl: 'app/main/common/components/baldris-image/baldris-image.tmpl.html',
            controller: 'BaldrisImageController as vm',
            transclude: {
                image: 'baldrisImage',
            },
        })
        .controller('BaldrisImageController', BaldrisImageController);

    /* @ngInject */
    function BaldrisImageController($q, baldrisImageBase, dataService) {
        var vm = this;
        vm.evaluatedSrc = null;
        vm.$onInit = function () {
            evaluateUrl(vm.imgSrc).then(function (evaluatedUrl) {
                vm.evaluatedSrc = evaluatedUrl;
            });
        };

        vm.$onChanges = function (changesObj) {
            if (changesObj.imgSrc && changesObj.imgSrc.currentValue !== changesObj.imgSrc.previousValue) {
                evaluateUrl(changesObj.imgSrc.currentValue).then(function (evaluatedUrl) {
                    vm.evaluatedSrc = evaluatedUrl;
                });
            }
        };

        function isValidImageUrl(url) {
            if (!url) return false;
            if (_.endsWith(url, 'jpg') || _.endsWith(url, 'jpeg') || _.endsWith(url, 'png') || _.endsWith(url, 'gif')) {
                return true;
            }
            return false;
        }

        function evaluateUrl(url) {
            return dataService.getCurrentUser().then(function (currentUser) {
                var evaluatedUrl = null;
                if (_.startsWith(url, 'http') || _.startsWith(url, '//')) {
                    // use url
                    evaluatedUrl = url;
                    if (vm.preset) {
                        evaluatedUrl += '?preset=' + vm.preset;
                    }
                } else {
                    if (isValidImageUrl(url)) {
                        // use new image service
                        evaluatedUrl = baldrisImageBase + url + '?sasToken=' + encodeURIComponent(currentUser.sasToken);
                        if (vm.preset) {
                            evaluatedUrl += '&preset=' + vm.preset;
                        }
                    }
                }

                return evaluatedUrl;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('baldrisFileSelect', {
            bindings: {
                baldrisFileId: '=',
                baldrisFile: '=',
                onSelected: '=',
                labelText: '@',
                baldrisFileConfig: '=',
                minQueryLength: '=',
                displayText: '=',
                showPreview: '=',
            },
            templateUrl:
                'app/main/common/components/baldris-file-select/baldris-file-select.tmpl.html',
            controller: 'BaldrisFileSelectController as vm',
        })
        .controller('BaldrisFileSelectController', BaldrisFileSelectController);

    /* @ngInject */
    function BaldrisFileSelectController($filter, dataService) {
        var vm = this;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        var cachedResults = [];

        vm.$onInit = function () {
            //Get Current BaldrisFile
            if (vm.baldrisFileId && !vm.baldrisFile) {
                dataService
                    .getById('BaldrisFiles', vm.baldrisFileId, true)
                    .then(function (baldrisFile) {
                        vm.baldrisFile = baldrisFile;
                    });
            }

            vm.minLength = 0;
            if (
                angular.isDefined(vm.minQueryLength) &&
                angular.isNumber(vm.minQueryLength)
            ) {
                vm.minLength = vm.minQueryLength;
            }
        };

        // ******************************
        // Internal methods
        // ******************************
        /**
         * Search for repos... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            if (vm.baldrisFileConfig) {
                if (cachedResults.length === 0) {
                    return dataService
                        .getByConfigName('BaldrisFiles', vm.baldrisFileConfig)
                        .then(function (lookupStrings) {
                            cachedResults = lookupStrings;
                            return getFiltered(cachedResults, query);
                        });
                }
                return $q.when(getFiltered(cachedResults, query));
            } else {
                if (query) {
                    return dataService
                        .search('BaldrisFiles', query)
                        .then(function (searchResult) {
                            return searchResult.data || searchResult;
                        });
                } else {
                    return dataService
                        .getAll('BaldrisFiles')
                        .then(function (baldrisFiles) {
                            return baldrisFiles;
                        });
                }
            }
        }

        function getFiltered(collection, query) {
            if (!query) return collection;
            return $filter('filter')(collection, query);
        }

        function searchTextChange(text) {}

        function selectedItemChange(item) {
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(item);
            }
            if (item) {
                vm.baldrisFileId = item.id;
                vm.baldrisFileForm.baldrisFile.$setValidity(
                    'invalidBaldrisFile',
                    true
                );
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = item.name;
                }
            } else {
                vm.baldrisFileId = null;
                if (vm.searchText) {
                    vm.baldrisFileForm.baldrisFile.$setValidity(
                        'invalidBaldrisFile',
                        false
                    );
                }
                if (angular.isDefined(vm.displayText)) {
                    vm.displayText = null;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .component('baldrisAudit', {
            bindings: {
                auditModel: '=',
                titleText: '='
            },
            templateUrl: 'app/main/common/components/baldris-audit/baldris-audit.tmpl.html',
            controller: 'BaldrisAuditController as vm',
        })
        .controller('BaldrisAuditController', BaldrisAuditController);

    /* @ngInject */
    function BaldrisAuditController() {
        var vm = this;

    }

}());
(function() {
    'use strict';

    angular
        .module('app.ceremony', [

        ]);
})(); 
(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .controller('CeremonySearchDialogController', CeremonySearchDialogController);

    /* @ngInject */
    function CeremonySearchDialogController($mdDialog, $q, $filter, $rootScope, dataService) {
        var vm = this;
        vm.isLoading = true;
        vm.isSearching = true;
        vm.departments = [];
        vm.ceremonyTypes = [];
        vm.searchText = '';
        vm.ceremonies = [];
        vm.ceremonyTypeId = null;
        vm.departmentId = null;
        vm.selectedCeremony = null;

        activate();

        vm.selectCeremonyType = selectCeremonyType;
        vm.selectCeremony = selectCeremony;
        vm.closeDialog = closeDialog;
        vm.search = search;

        ////////////////

        function activate() {
            setLoadingStatus(true);
            var promises = [];
            promises.push(dataService.getAll('Departments'));
            promises.push(dataService.getAll('CalendarEventTypes'));

            $q.all(promises).then(function (response) {
                vm.departments = $filter('orderBy')(response[0], 'organizationDisplayName');
                var ceremonyTypes = $filter('orderBy')(response[1], 'name');
                vm.ceremonyTypes = $filter('filter')(ceremonyTypes, { isDeleted: false });
                setLoadingStatus(false);
                search();
            })
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function search() {
            vm.isSearching = true;
            vm.ceremonies = [];
            if (vm.searchText) {
                dataService.search('CalendarEvents', vm.searchText, null, null, { calendarEventTypeId: vm.ceremonyTypeId, departmentId: vm.departmentId }).then(function (ceremonies) {
                    vm.ceremonies = ceremonies;
                    vm.isSearching = false;
                })
            } else {
                dataService.getLatest('CalendarEvents', 25, { calendarEventTypeId: vm.ceremonyTypeId, departmentId: vm.departmentId }).then(function (ceremonies) {
                    vm.ceremonies = ceremonies;
                    vm.isSearching = false;
                })
            }
        }

        function selectCeremonyType(ceremonyType) {
            if (ceremonyType.id === vm.ceremonyTypeId) {
                vm.ceremonyTypeId = null;
                vm.selectedCeremony = null;
            } else {
                vm.ceremonyTypeId = ceremonyType.id;
                vm.selectedCeremony = null;
            }

            search();
        }

        function selectCeremony(ceremony) {
            vm.selectedCeremony = ceremony;
        }

        function closeDialog(selectedLocation) {
            $mdDialog.hide(selectedLocation);
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .component('upcomingCeremonySelect', {
            bindings: {
                ceremony: '=',
                ceremonyId: '=',
                onSelected: '<',
                labelText: '@',
                isRequired: '<',
                disableSearch: '<',
                workOrderId: '<',
                departmentId: '<',
                startDate: '<',
                selectCeremonialOnLoad: '<',
            },
            templateUrl:
                'app/main/ceremony/components/upcoming-ceremony-select/upcoming-ceremony-select.tmpl.html',
            controller: 'UpcomingCeremonySelectController as vm',
        })
        .controller(
            'UpcomingCeremonySelectController',
            UpcomingCeremonySelectController
        );

    /* @ngInject */
    function UpcomingCeremonySelectController(
        $document,
        $mdDialog,
        $q,
        $translate,
        dataService,
        calendarService
    ) {
        var vm = this;

        vm.$onInit = function () {
            vm.onChange = onChange;
            vm.openSearchDialog = openSearchDialog;

            vm.ceremonyGroups = [];
            vm.loadedCeremonies = [];
            loadCeremonies();
            if (vm.ceremonyId && !vm.ceremony) {
                dataService
                    .getById('Ceremonies', vm.ceremonyId)
                    .then(function (ceremony) {
                        vm.ceremony = ceremony;
                    });
            }
        };

        vm.$onChanges = function (changes) {};

        /*///////////*/

        function loadCeremonies() {
            if (vm.ceremonyGroups.length > 0) {
                return $q.when(vm.ceremonyGroups);
            }
            return dataService
                .getByUri('Ceremonies', 'Upcoming', {
                    startDate: vm.startDate || new Date(),
                    workOrderId: vm.workOrderId,
                })
                .then(function (ceremonies) {
                    vm.loadedCeremonies = ceremonies;
                    vm.ceremonyGroups = createCeremonyGroups(
                        vm.loadedCeremonies
                    );
                    if (
                        vm.selectCeremonialOnLoad &&
                        !vm.ceremony &&
                        !vm.ceremonyId
                    ) {
                        for (
                            var index = 0;
                            index < ceremonies.length;
                            index++
                        ) {
                            var ceremony = ceremonies[index];
                            if (
                                calendarService.options.isCeremonialFuneral(
                                    ceremony.options
                                ) &&
                                ceremony.workOrderId === vm.workOrderId
                            ) {
                                vm.ceremonyId = ceremony.id;
                                vm.ceremony = ceremony;
                            }
                        }
                    }
                    return vm.ceremonyGroups;
                });
        }

        function createCeremonyGroups(ceremonies) {
            if (!ceremonies || ceremonies.length === 0) return [];

            addCurrentCeremonyIfNotExist(ceremonies);

            var ceremonyGroups = [];

            var workOrderGroup = {
                text: $translate.instant(
                    'CEREMONIES.UPCOMING_CEREMONIES_SELECT.CEREMONIES_IN_CURRENT_WORK_ORDER'
                ),
                ceremonies: [],
            };

            var departmentGroup = {
                text: $translate.instant(
                    'CEREMONIES.UPCOMING_CEREMONIES_SELECT.CEREMONIES_IN_CURRENT_DEPARTMENT'
                ),
                ceremonies: [],
            };

            var otherGroup = {
                text: $translate.instant(
                    'CEREMONIES.UPCOMING_CEREMONIES_SELECT.OTHER_CEREMONIES'
                ),
                ceremonies: [],
            };

            angular.forEach(ceremonies, function (ceremony) {
                //WorkOrder
                if (
                    ceremony.workOrderId &&
                    ceremony.workOrderId === vm.workOrderId
                ) {
                    workOrderGroup.ceremonies.push(ceremony);
                }
                //Department
                else if (
                    ceremony.workOrderDepartmentId &&
                    ceremony.workOrderDepartmentId === vm.departmentId
                ) {
                    departmentGroup.ceremonies.push(ceremony);
                }
                //Other
                else {
                    otherGroup.ceremonies.push(ceremony);
                }
            });

            if (workOrderGroup.ceremonies.length > 0)
                ceremonyGroups.push(workOrderGroup);
            if (departmentGroup.ceremonies.length > 0)
                ceremonyGroups.push(departmentGroup);
            if (otherGroup.ceremonies.length > 0)
                ceremonyGroups.push(otherGroup);

            return ceremonyGroups;
        }

        function onChange() {
            if (vm.ceremonyId) {
                for (
                    var index = 0;
                    index < vm.loadedCeremonies.length;
                    index++
                ) {
                    var ceremony = vm.loadedCeremonies[index];
                    if (vm.ceremonyId === ceremony.id) {
                        vm.ceremony = ceremony;
                        break;
                    }
                }
            } else {
                vm.ceremony = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.ceremony);
            }
        }

        function addCurrentCeremonyIfNotExist(ceremonies) {
            if (!vm.ceremony) return;
            var ceremonyFound = false;
            for (var i = 0; i < ceremonies.length; i++) {
                var ceremony = ceremonies[i];
                if (vm.ceremony.id === ceremony.id) {
                    ceremonyFound = true;
                    break;
                }
            }
            if (!ceremonyFound) {
                ceremonies.push(vm.ceremony);
            }
        }

        function resetInput() {
            vm.ceremony = null;
            vm.ceremonyId = null;
        }

        function openSearchDialog(e) {
            $mdDialog
                .show({
                    controller: 'CeremonySearchDialogController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/ceremony/dialogs/ceremony-search-dialog/ceremony-search-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    multiple: true,
                    clickOutsideToClose: true,
                })
                .then(function (selectedCeremony) {
                    if (selectedCeremony) {
                        vm.ceremony = selectedCeremony;
                        vm.ceremonyId = selectedCeremony.id;
                        vm.loadedCeremonies.push(selectedCeremony);
                        vm.ceremonyGroups = createCeremonyGroups(
                            vm.loadedCeremonies
                        );
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .controller('EditCeremonyDialogController', EditCeremonyDialogController);

    /* @ngInject */
    function EditCeremonyDialogController($mdDialog, ceremony, event, $translate, dataService, editCeremonyViewService) {
        var vm = this;
        vm.isDisabled = false;
        vm.categories = [];
        vm.isLoadingCeremony = true;

        // Data
        vm.ceremony = null;
        
        dataService.getById("Ceremonies", ceremony.id).then(function (returnData) {
            vm.ceremony = returnData;
            vm.categories = editCeremonyViewService.createCategoriesWithData(vm.ceremony);
            vm.isLoadingCeremony = false;
        });
        //Transform dates
        if (vm.ceremony && vm.ceremony.calendarEvent && vm.ceremony.calendarEvent.start) {
            vm.startMoment = moment(vm.ceremony.calendarEvent.start).format('x');
        }
        if (vm.ceremony && vm.ceremony.calendarEvent && vm.ceremony.calendarEvent.end) {
            vm.endMoment = moment(vm.ceremony.calendarEvent.end).format('x');
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            var vmCopy = vm;
            if (vm.ceremonyForm.$dirty) {
                if (!vm.ceremonyForm.id || vm.ceremonyForm.id === '00000000-0000-0000-0000-000000000000') {
                    vm.ceremonyForm.changeState = 1;
                    dataService.insertItem("Ceremonies", vm.ceremony).then(function (insertData) {
                        $mdDialog.hide(insertData);
                    });
                } else {
                    vm.ceremony.changeState = 2;
                    dataService.ceremony.updateItem("Ceremonies", vm.ceremony).then(function () {
                        $mdDialog.hide(vm.ceremony);
                    });
                }
            }
        }

    }

} ());
(function() {
  "use strict";

  angular
    .module("app.ceremony")
    .component("ceremonyTypeSelect", {
      bindings: {
        ceremonyTypeId: "=",
        ceremonyType: "=",
        onSelected: "=",
        preselectIncludeOptions: "=",
        preselectExcludeOptions: "=",
        labelText: "@",
        isRequired: "="
      },
      templateUrl:
        "app/main/ceremony/components/ceremony-type-select/ceremony-type-select.tmpl.html",
      controller: "CeremonyTypeSelectController as vm"
    })
    .controller("CeremonyTypeSelectController", CeremonyTypeSelectController);

  /* @ngInject */
  function CeremonyTypeSelectController(dataService, $filter, calendarService) {
    var vm = this;
    vm.isDisabled = true;
    vm.ceremonyTypes = [];
    vm.onChange = onChange;

    // Get options
    dataService.getAll("CalendarEventTypes").then(function(ceremonyTypes) {
      vm.isDisabled = false;
      ceremonyTypes = $filter("orderBy")(ceremonyTypes, "name");
      ceremonyTypes = $filter("filter")(ceremonyTypes, { isDeleted: false });
      if (vm.preselectIncludeOptions && !vm.ceremonyTypeId) {
        // Preselect first based on options
        for (var index = 0; index < ceremonyTypes.length; index++) {
          var ceremonyType = ceremonyTypes[index];
          var excludeFilter = ceremonyType.options & vm.preselectExcludeOptions;
          var includeFilter = ceremonyType.options & vm.preselectIncludeOptions;
          if (includeFilter && !excludeFilter) {
            vm.ceremonyTypeId = ceremonyType.id;
            break;
          }
        }
      }
      vm.ceremonyTypes = $filter("filter")(ceremonyTypes, function(value) {
        return calendarService.options.isCeremony(value.options);
      });
    });

    function onChange() {
      if (vm.ceremonyTypeId) {
        for (var index = 0; index < vm.ceremonyTypes.length; index++) {
          var ceremonyType = vm.ceremonyTypes[index];
          if (vm.ceremonyTypeId === ceremonyType.id) {
            vm.ceremonyType = ceremonyType;
            break;
          }
        }
      } else {
        vm.ceremonyType = null;
      }
      if (angular.isFunction(vm.onSelected)) {
        vm.onSelected(vm.ceremonyType);
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .component('ceremonySelect', {
            bindings: {
                ceremonyId: '=',
                ceremony: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                availableCeremonies: '='
            },
            templateUrl: 'app/main/ceremony/components/ceremony-select/ceremony-select.tmpl.html',
            controller: 'CeremonySelectController as vm',
        })
        .controller('CeremonySelectController', CeremonySelectController);

    /* @ngInject */
    function CeremonySelectController(dataService) {
        var vm = this;
        vm.isDisabled = true;
        vm.onChange = onChange;
        
        function onChange() {
            if (vm.ceremonyId) {
                for (var index = 0; index < vm.availableCeremonies.length; index++) {
                    var ceremony = vm.availableCeremonies[index];
                    if (vm.ceremonyId === ceremony.id) {
                        vm.ceremony = ceremony;
                        break;
                    }
                }
            } else {
                vm.ceremony = null;
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.ceremony);
            }
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .component('ceremonyParticipantSelect', {
            bindings: {
                ceremonyParticipants: '=',
                locationId: '=',
                labelText: '@',
            },
            templateUrl:
                'app/main/ceremony/components/ceremony-participant-select/ceremony-participant-select.tmpl.html',
            controller: 'CeremonyParticipantSelectController as vm',
        })
        .controller(
            'CeremonyParticipantSelectController',
            CeremonyParticipantSelectController
        );

    /* @ngInject */
    function CeremonyParticipantSelectController(
        $filter,
        dataService,
        calendarService,
        participantRoleService,
        participantService,
        msUtils
    ) {
        var vm = this;

        vm.selectedParticipant = null;
        vm.selectedParticipants = [];
        vm.searchText = null;
        vm.selectForm = null;
        vm.participantSearch = participantSearch;
        vm.transformChip = transformChip;
        vm.onAddParticipant = onAddParticipant;
        vm.onRemoveParticipant = onRemoveParticipant;
        vm.onSelectParticipant = onSelectParticipant;
        vm.addRole = addRole;
        vm.cancelRole = cancelRole;
        vm.openSearchDialog = openSearchDialog;
        vm.newRole = null;
        vm.newRoleId = null;
        vm.minLenght = msUtils.isMobile() ? 1 : 0;

        //INIT
        vm.$onInit = function () {
            //Copy selectedParticipants
            if (vm.ceremonyParticipants && vm.ceremonyParticipants.length > 0) {
                vm.selectedParticipants = vm.ceremonyParticipants
                    .sort(function (a, b) {
                        return a.sortOrder - b.sortOrder;
                    })
                    .map(function (ceremonyParticipant) {
                        return {
                            id: ceremonyParticipant.participantId,
                            participantName:
                                ceremonyParticipant.participantName,
                            participantRole: ceremonyParticipant.role,
                            participantImageUrl:
                                ceremonyParticipant.participantImageUrl,
                            participantPrimaryEmail:
                                ceremonyParticipant.participantPrimaryEmail,
                        };
                    });
            }
        };

        //userSearch
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                // Pseudo-properties for the chips
                chip.participantName = chip.partyDisplayName;
                chip.participantRole = null;
                chip.participantImageUrl = chip.imageUrl;
                chip.participantPrimaryEmail = chip.primaryEmail;
                return chip;
            }
            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }

        /**
         * Search for Participants.
         */
        function participantSearch(query) {
            if (query) {
                return dataService
                    .search('Participants', query)
                    .then(function (searchResult) {
                        return searchResult.data
                            ? searchResult.data
                            : searchResult;
                    });
            } else if (vm.locationId) {
                return dataService.getByUri(
                    'Participants',
                    'FrequentByLocationId/' + vm.locationId
                );
            }
            return dataService.getByUri('Participants', 'Frequent');
        }

        function onSelectParticipant(participant) {
            if (participant) {
                vm.currentParticipant = participant;
                var currentCeremonyParticipant = getCeremonyParticipantById(
                    participant.id
                );
                vm.newRoleId = angular.copy(
                    currentCeremonyParticipant.participantRoleId
                );
                vm.newOverriddenRoleName =
                    currentCeremonyParticipant.overriddenRoleName;
                vm.newSortOrder = currentCeremonyParticipant.sortOrder;
                vm.showSelected = true;
            }
        }

        function addRole() {
            vm.currentParticipant.participantRole =
                vm.newOverriddenRoleName || vm.newRole.name;
            //Attach role to ceremonyParticipant
            var currentCeremonyParticipant = getCeremonyParticipantById(
                vm.currentParticipant.id
            );
            currentCeremonyParticipant.participantRoleId = vm.newRole.id;
            currentCeremonyParticipant.sortOrder = vm.newSortOrder;
            currentCeremonyParticipant.overriddenRoleName =
                vm.newOverriddenRoleName;
            if (currentCeremonyParticipant.hasOwnProperty('id')) {
                currentCeremonyParticipant.changeState = 2;
            }
            cancelRole();
        }

        function cancelRole() {
            vm.newRole = null;
            vm.newRoleId = null;
            vm.showSelected = false;
            vm.newOverriddenRoleName = null;
        }

        function onAddParticipant(participant) {
            if (!vm.ceremonyParticipants) {
                vm.ceremonyParticipants = [];
            }
            var ceremonyParticipant =
                calendarService.getEmptyCalendarEventParticipant();
            ceremonyParticipant.participantId = participant.id;
            // Query api for default role
            dataService
                .getByUri(
                    'ParticipantRoles',
                    'DefaultByParticipantId/' + participant.id
                )
                .then(function (defaultRole) {
                    ceremonyParticipant.participantRoleId = defaultRole.id;
                    ceremonyParticipant.sortOrder = defaultRole.sortOrder;
                    participant.participantRole = defaultRole.name;
                })
                .catch(function () {
                    if (vm.ceremonyParticipants.length > 0) {
                        //Set sortOrder to highest + 10
                        ceremonyParticipant.sortOrder =
                            Math.max.apply(
                                Math,
                                vm.ceremonyParticipants.map(function (o) {
                                    return o.sortOrder;
                                })
                            ) + 10;
                    } else {
                        ceremonyParticipant.sortOrder = 0;
                    }
                })
                .finally(function () {
                    vm.ceremonyParticipants.push(ceremonyParticipant);
                    vm.selectForm.$setDirty();
                });
        }

        function onRemoveParticipant(participant) {
            //get participant from ceremonyParticipants
            var ceremonyParticipant = getCeremonyParticipantById(
                participant.id
            );
            if (
                !ceremonyParticipant.calendarEventId ||
                ceremonyParticipant.calendarEventId ===
                    '00000000-0000-0000-0000-000000000000'
            ) {
                //ceremonyParticipant hasn't been saved and can safely be removed from the array
                var index =
                    vm.ceremonyParticipants.indexOf(ceremonyParticipant);
                vm.ceremonyParticipants.splice(index, 1);
            } else {
                //ceremonyParticipant is saved in the database and must be marked as removed
                ceremonyParticipant.changeState = 3;
            }
            vm.selectForm.$setDirty();
        }

        function getCeremonyParticipantById(participantId) {
            if (
                !vm.ceremonyParticipants ||
                vm.ceremonyParticipants.length === 0
            )
                return null;
            for (
                var index = 0;
                index < vm.ceremonyParticipants.length;
                index++
            ) {
                var ceremonyParticipant = vm.ceremonyParticipants[index];
                if (ceremonyParticipant.participantId === participantId) {
                    return ceremonyParticipant;
                }
            }
        }

        function openSearchDialog(e) {
            participantService
                .showSearchDialog(e, false, true)
                .then(function (selectedParticipant) {
                    if (selectedParticipant) {
                        if (!vm.selectedParticipants)
                            vm.selectedParticipants = [];
                        vm.selectedParticipants.push(selectedParticipant);
                        onAddParticipant(selectedParticipant);
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.ceremony')
        .component('ceremonyCard', {
            bindings: {
                baldrisModel: '=',
                onOpen: '=',
                onDelete: '=',
                disableLinks: '=',
            },
            templateUrl:
                'app/main/ceremony/components/ceremony-card/ceremony-card.tmpl.html',
            controller: 'CeremonyCardController as vm',
        })
        .controller('CeremonyCardController', CeremonyCardController);

    /* @ngInject */
    function CeremonyCardController(
        $mdDialog,
        $state,
        $document,
        $mdToast,
        dataService,
        accountService
    ) {
        var vm = this;

        vm.isLoadingParticipants = true;
        vm.getForegroundColor = getForegroundColor;
        vm.showEditCeremonyDialog = showEditCeremonyDialog;
        vm.navigateToCeremony = navigateToCeremony;
        vm.deleteCeremony = deleteCeremony;
        vm.canDelete = canDelete;
        vm.canRead = canRead;

        //Init
        vm.$onInit = function () {
            if (vm.baldrisModel && vm.baldrisModel.id) {
                if (!accountService.canReadPrivacyData()) {
                    vm.isLoadingParticipants = false;
                } else {
                    dataService
                        .getByUri(
                            'CalendarEventParticipants',
                            'ByCalendarEventId/' + vm.baldrisModel.id
                        )
                        .then(function (calendarEventParticipants) {
                            if (
                                calendarEventParticipants &&
                                calendarEventParticipants.length > 0
                            ) {
                                vm.baldrisModel.participantsSerialized =
                                    getParticipantsAsSerializedString(
                                        calendarEventParticipants
                                    );
                            }
                            vm.isLoadingParticipants = false;
                        });
                }
            }
        };

        function getParticipantsAsSerializedString(calendarEventParticipants) {
            calendarEventParticipants = calendarEventParticipants.sort(
                function (a, b) {
                    return a.sortOrder - b.sortOrder;
                }
            );
            return calendarEventParticipants.reduce(function (prev, current) {
                var returnString = prev;
                if (prev !== '') returnString += ' // ';
                returnString += current.participantName;
                if (current.participantRoleName) {
                    returnString += ' (' + current.participantRoleName + ')';
                }
                return returnString;
            }, '');
        }

        function getForegroundColor(color) {
            var colors = tinycolor(color).monochromatic();

            colors.map(function (t) {
                return t.toHexString();
            }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
            return tinycolor
                .mostReadable(color, ['#fff', colors[3]])
                .toHexString();
        }

        function navigateToCeremony(ceremony) {
            if (!vm.disableLinks) {
                if (!canRead(ceremony)) {
                    return;
                }
                if (angular.isFunction(vm.onOpen)) {
                    vm.onOpen(ceremony);
                } else {
                    $state.go('app.ceremony.byId', { id: ceremony.id });
                }
            }
        }

        function canRead(ceremony) {
            return (
                accountService.canReadCalendarEvents() &&
                (ceremony.workOrderId
                    ? accountService.canReadWorkOrders()
                    : true)
            );
        }

        function canDelete(ceremony) {
            return (
                accountService.canDeleteCalendarEvents() &&
                (ceremony.workOrderId
                    ? accountService.canWriteWorkOrders()
                    : true)
            );
        }

        function deleteCeremony(ceremony, e) {
            if (!vm.disableLinks) {
                if (!canDelete(ceremony)) {
                    return;
                }
                if (angular.isFunction(vm.onDelete)) {
                    vm.onDelete(ceremony, e);
                }
            }
        }

        function showEditCeremonyDialog(ceremony, e) {
            if (
                !accountService.canReadCalendarEvents() ||
                (ceremony.workOrderId && !accountService.canReadWorkOrders())
            ) {
                return;
            }
            $mdDialog
                .show({
                    controller: 'EditCeremonyDialogController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/ceremony/components/edit-ceremony-dialog/edit-ceremony-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    clickOutsideToClose: true,
                    locals: {
                        ceremony: angular.copy(ceremony),
                        event: e,
                    },
                })
                .then(function (updatedCeremony) {
                    if (updatedCeremony) {
                        vm.baldrisModel = updatedCeremony;
                        $mdToast.show($mdToast.simple().textContent(savedText));
                    }
                });
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.calendar")
    .controller("WeekViewToolbarController", WeekViewToolbarController);

  /* @ngInject */
  function WeekViewToolbarController(calendarViewService) {
    var vm = this;

    vm.service = calendarViewService;

    vm.isCalendarSelectOpen = false;
  }
})();

(function() {
  "use strict";

  angular
    .module("app.calendar")
    .controller("WeekViewSidebarController", WeekViewSidebarController);

  /* @ngInject */
  function WeekViewSidebarController(calendarWeekViewService) {
    var vm = this;

    vm.service = calendarWeekViewService;
  }
})();

(function() {
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarMainToolbarController', CalendarMainToolbarController);

    /* @ngInject */
    function CalendarMainToolbarController(calendarViewService) {
        var vm = this;

        vm.service = calendarViewService;

        vm.isCalendarSelectOpen = false;
    }
})();
(function() {
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarMainSidebarController', CalendarMainSidebarController);

    /* @ngInject */
    function CalendarMainSidebarController(calendarViewService) {
        var vm = this;

        vm.service = calendarViewService;


    }
})();
(function () {
    'use strict';

    angular.module('app.externalOrder').controller('EditCalendarEventEquipmentDialogController', EditCalendarEventEquipmentDialogController);

    /* @ngInject */
    function EditCalendarEventEquipmentDialogController($mdDialog, calendarEventEquipment) {
        var vm = this;
        vm.isNew = false;

        activate();

        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteCalendarEventEquipment = deleteCalendarEventEquipment;
        vm.onEquipmentChanged = onEquipmentChanged;

        ////////////////

        function activate() {
            vm.calendarEventEquipment = calendarEventEquipment;

            if (!vm.calendarEventEquipment.id || vm.calendarEventEquipment.id === '00000000-0000-0000-0000-000000000000') {
                vm.isNew = true;
                vm.calendarEventEquipment.changeState = 1;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            if (vm.calendarEventEquipment.changeState !== 1) {
                vm.calendarEventEquipment.changeState = 2;
            }
            $mdDialog.hide(vm.calendarEventEquipment);
        }

        function deleteCalendarEventEquipment() {
            vm.calendarEventEquipment.changeState = 3;
            $mdDialog.hide(vm.calendarEventEquipment);
        }

        function onEquipmentChanged(equipment) {
            if (equipment) {
                vm.calendarEventEquipment.amount = vm.calendarEventEquipment.amount || 1;
                vm.calendarEventEquipment.equipmentName = equipment.name;
                vm.calendarEventEquipment.equipmentType = equipment.equipmentTypeName;
                vm.calendarEventEquipment.equipmentImageUrl = equipment.imageUrl;
            } else {
                vm.calendarEventEquipment.amount = 0;
                vm.calendarEventEquipment.equipmentName = null;
                vm.calendarEventEquipment.equipmentType = null;
                vm.calendarEventEquipment.equipmentImageUrl = null;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .controller('EditCalendarEventDialogController', EditCalendarEventDialogController);

    /* @ngInject */
    function EditCalendarEventDialogController($rootScope, $mdDialog, $translate, dataService, calendarService, locationService, calendarEvent) {

        var vm = this;
        vm.updateModel = null;
        vm.isLoading = true;
        $rootScope.loadingProgress = true;
        vm.isNew = false;
        vm.calendarEventTypes = [];
        vm.highlightClass = 'light';
        vm.hasCustomLocation = false;
        vm.currentLocation = null;
        vm.currentLocationId = null;

        // METHODS
        vm.closeDialog = closeDialog;
        vm.saveChanges = saveChanges;
        vm.deleteCalendarEvent = deleteCalendarEvent;
        vm.getForegroundColor = getForegroundColor;
        vm.loadCalendarEventTypes = loadCalendarEventTypes;
        vm.onCalendEventTypeChanged = onCalendEventTypeChanged;
        vm.onLocationChange = onLocationChange;

        // INIT
        loadCalendarEventTypes();
        if (calendarEvent.calendarEventType) {
            vm.eventStyle = getStyle(calendarEvent.calendarEventType);
        } else {
            vm.eventStyle = { 'background-color': '#2E8AE9', 'color': '#fff' };
        }


        if (!calendarEvent.id || calendarEvent.id === '00000000-0000-0000-0000-000000000000') {
            vm.isNew = true;
        }

        // Fetch updateModel
        if (!vm.isNew) {
            dataService.getUpdateModel('CalendarEvents', calendarEvent.id).then(function (updateModel) {
                vm.updateModel = updateModel;
                setStyle(updateModel.calendarEvent.calendarEventType);
                vm.hasCustomLocation = updateModel.calendarEvent.locationSerialized && !updateModel.calendarEvent.reservationId;
                if (updateModel.calendarEvent.reservation && updateModel.calendarEvent.reservation.location) {
                    vm.currentLocation = updateModel.calendarEvent.reservation.location;
                    vm.currentLocationId = updateModel.calendarEvent.reservation.location.id;
                }
                setLoadingStatus(false);
            });
        } else {
            vm.updateModel = {
                calendarEvent: calendarEvent,
                locationReservation: null,
                attendees: [],
                relatedDeceased: []
            };
            setLoadingStatus(false);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveChanges() {
            setLoadingStatus(true);
            if (vm.isNew) {
                vm.updateModel.calendarEvent.changeState = 1;
            } else {
                vm.updateModel.calendarEvent.changeState = 2;
            }
            dataService.updateFromUpdateModel('CalendarEvents', vm.updateModel).then(function (insertedData) {
                setLoadingStatus(false);
                $mdDialog.hide(insertedData);
            });
        }

        function deleteCalendarEvent() {
            if (vm.isNew) {
                closeDialog();
            } else {
                setLoadingStatus(true);
                vm.updateModel.calendarEvent.changeState = 3;
                dataService.updateFromUpdateModel('CalendarEvents', vm.updateModel).then(function (insertedData) {
                    // Make sure changeState is set to delete
                    insertedData.calendarEvent.changeState = 3;
                    setLoadingStatus(false);
                    $mdDialog.hide(insertedData);
                });
            }
        }

        function setLoadingStatus(value) {
            vm.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function getForegroundColor(color) {
            var colors = tinycolor(color).monochromatic();

            colors.map(function (t) { return t.toHexString(); }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
            return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
        }

        function getHighlightClass(calendarEventType) {
            if (!calendarEventType || !calendarEventType.color) {
                return 'light';
            }
            return getForegroundColor(calendarEventType.color) === '#ffffff' ? 'light' : 'dark';
        }

        function getStyle(calendarEventType) {
            if (!calendarEventType || !calendarEventType.color) {
                return {
                    'background-color': '#2E8AE9',
                    'color': '#fff'
                };
            }
            return {
                'background-color': calendarEventType.color,
                'color': getForegroundColor(calendarEventType.color)
            };
        }

        function setStyle(calendarEventType) {
            vm.eventStyle = getStyle(calendarEventType);
            vm.highlightClass = getHighlightClass(calendarEventType);
        }

        function loadCalendarEventTypes() {
            return dataService.getAll('CalendarEventTypes').then(function (calendarEventTypes) {
                vm.calendarEventTypes = calendarEventTypes;
            });
        }

        function onCalendEventTypeChanged() {
            if (vm.updateModel.calendarEvent.calendarEventType) {
                vm.updateModel.calendarEvent.calendarEventTypeId = vm.updateModel.calendarEvent.calendarEventType.id;
                setStyle(vm.updateModel.calendarEvent.calendarEventType);
            } else {
                vm.updateModel.calendarEvent.calendarEventTypeId = null;
            }
        }

        function onLocationChange(location) {
            if (location) {
                if (!vm.updateModel.locationReservation) {
                    vm.updateModel.locationReservation = locationService.getEmptyLocationReservation();
                    vm.updateModel.locationReservation.changeState = 1;
                }
                vm.updateModel.locationReservation.location = location;
                vm.updateModel.locationReservation.locationId = location.id;
                vm.updateModel.locationReservation.changeState = vm.updateModel.locationReservation.changeState != 1 ? 2 : 1;
            } else {
                if (vm.updateModel.locationReservation) {
                    vm.updateModel.locationReservation.changeState = 3;
                }
            }
        }
    }

} ());
(function () {
    'use strict';

    angular.module('app.calendar').controller('AddCalendarEventDialogController', AddCalendarEventDialogController);

    /* @ngInject */
    function AddCalendarEventDialogController(
        $mdDialog,
        workOrderId,
        flagOption,
        calendarService,
        groomingService,
        transportService,
        ceremonyService,
        bookingService
    ) {
        var vm = this;

        vm.isTransport = true;
        vm.addCalendarEventForm = null;

        vm.model = calendarService.getEmptyCalendarEvent();
        vm.model.changeState = 1;
        vm.model.workOrderId = workOrderId;
        vm.flagOption = flagOption;

        // Methods
        vm.closeDialog = closeDialog;
        vm.saveAndCloseDialog = saveAndCloseDialog;

        // INIT - TODO: Make Deceased selectable

        //////////

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveAndCloseDialog() {
            if (vm.addCalendarEventForm.$valid) {
                // Change $type to ensure correct routing
                if (calendarService.options.isGrooming(vm.model.calendarEventType.options)) {
                    vm.model = groomingService.getEmptyGrooming();
                    vm.model.workOrderId = workOrderId;
                } else if (calendarService.options.isTransport(vm.model.calendarEventType.options)) {
                    vm.model = transportService.getEmptyTransport();
                    vm.model.workOrderId = workOrderId;
                } else if (calendarService.options.isCeremony(vm.model.calendarEventType.options)) {
                    vm.model = ceremonyService.getEmptyCeremony();
                    vm.model.workOrderId = workOrderId;
                } else if (calendarService.options.isBooking(vm.model.calendarEventType.options)) {
                    vm.model = bookingService.getEmptyBooking();
                    vm.model.workOrderId = workOrderId;
                }
                $mdDialog.hide(vm.model);
            }
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.calendar").controller("DayViewSidebarRightController", DayViewSidebarRightController);

  /* @ngInject */
  function DayViewSidebarRightController(calendarViewService, loadingService) {
    var vm = this;
    vm.noteOrTasks = [];
    vm.activeUsers = [];
    vm.currentBirthdays = [];
    vm.calculateAge = calculateAge;

    vm.loadingService = loadingService;

    vm.service = calendarViewService;

    calendarViewService.getActiveUsers().then(function(activeUsers) {
      vm.activeUsers = activeUsers;
      vm.currentBirthdays = getBirthdaysForDate(vm.service.data.selectedDate);
    });

    //Function to get users that have a birthday on selected date.
    function getBirthdaysForDate(date) {
      var birthdayList = [];
      if (!vm.activeUsers || vm.activeUsers.length === 0) return birthdayList;
      for (var i = 0, len = vm.activeUsers.length; i < len; i++) {
        if (vm.activeUsers[i] && vm.activeUsers[i].dateOfBirth) {
          if (
            moment(date).date() === moment(vm.activeUsers[i].dateOfBirth).date() &&
            moment(date).month() === moment(vm.activeUsers[i].dateOfBirth).month()
          ) {
            birthdayList.push(vm.activeUsers[i]);
          }
        }
      }
      return birthdayList;
    }

    function calculateAge(birthDate, currentDate) {
      if (!birthDate || !currentDate) return null;
      return moment(currentDate).diff(birthDate, "years");
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .component('calendarOptionsSelect', {
            bindings: {
                calendarOptions: '=ngModel',
                onUpdate: '&',
                isDisabled: '=',
                labelText: '@'
            },
            templateUrl: 'app/main/calendar/components/calendar-options-select/calendar-options-select.tmpl.html',
            controller: 'CalendarOptionsSelectController as vm',
        })
        .controller('CalendarOptionsSelectController', CalendarOptionsSelectController);

    /* @ngInject */
    function CalendarOptionsSelectController(calendarEventOptions) {
        var vm = this;
        vm.calendarEventOptions = calendarEventOptions;
        vm.isSelected = isSelected;
        vm.toggle = toggle;

        function isSelected(option) {
            if (vm.calendarOptions & option.value) {
                return true;
            }
            return false;
        }

        function toggle(option) {
            if (isSelected(option)) {                
                vm.calendarOptions &= ~option.value;
            } else {
                vm.calendarOptions |= option.value;
            }

            vm.onUpdate({ value: vm.calendarOptions });

            if (vm.dataForm) {
                vm.dataForm.$setDirty();
            }
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('app.calendar')
        .component('calendarEventUsers', {
            bindings: {
                eventUsers: '=',
            },
            templateUrl: 'app/main/calendar/components/calendar-event-user/calendar-event-users.tmpl.html',
            controller: 'CalendarEventUsersController as vm',
        })
        .controller('CalendarEventUsersController', CalendarEventUsersController);

    /* @ngInject */
    function CalendarEventUsersController(logger, dataService, calendarService, $filter, gravatarService, msUtils) {
        var vm = this;

        vm.selectedUser = null;
        vm.selectedUsers = [];
        vm.searchTextUser = null;
        vm.userSearch = userSearch;
        vm.onAddUser = onAddUser;
        vm.onRemoveUser = onRemoveUser;
        vm.onSelectUser = onSelectUser;
        vm.addRole = addRole;
        vm.cancelRole = cancelRole;
        vm.minLenght = msUtils.isMobile() ? 1 : 0;
        //INIT
        vm.$onInit = function () {
            //Create faux selectedUsers
            if (vm.eventUsers && vm.eventUsers.length > 0) {
                vm.selectedUsers = vm.eventUsers
                    .sort(function (a, b) {
                        return a.sortOrder - b.sortOrder;
                    })
                    .map(function (calendarUser) {
                        return {
                            id: calendarUser.userId,
                            userName: calendarUser.userEmail,
                            email: calendarUser.userEmail,
                            phoneNumber: null,
                            dateOfBirth: null,
                            displayName: calendarUser.userDisplayName,
                            profileImageId: null,
                            profileImageUrl: calendarUser.userProfileImageUrl,
                            isDeleted: false,
                            image: calendarUser.userProfileImageFilepath ? calendarUser.userProfileImageFilepath : gravatarService.url(calendarUser.userEmail),
                            role: calendarUser.role,
                        };
                    });
            }
        };

        //userSearch
        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }
        /**
         * Search for users.
         */
        function userSearch(query) {
            if (query) {
                return dataService.search('BaldrisUsers', query).then(function (users) {
                    users = users.data || users;
                    users = users.map(function (baldrisUser) {
                        // Get correct imagePath
                        baldrisUser.image = baldrisUser.profileImageUrl ? baldrisUser.profileImageUrl : gravatarService.url(baldrisUser.email);
                        return baldrisUser;
                    });
                    users = users.filter(function (user) {
                        return !user.isDeleted;
                    });
                    users = $filter('orderBy')(users, 'displayName');
                    return users;
                });
            } else {
                return dataService.getByUri('BaldrisUsers', 'Active').then(function (users) {
                    users = users.map(function (baldrisUser) {
                        // Get correct imagePath
                        baldrisUser.image = baldrisUser.profileImageUrl ? baldrisUser.profileImageUrl : gravatarService.url(baldrisUser.email);
                        return baldrisUser;
                    });
                    users = users.filter(function (user) {
                        return !user.isDeleted;
                    });
                    users = $filter('orderBy')(users, 'displayName');
                    return users;
                });
            }
        }

        function onSelectUser(user) {
            if (user) {
                for (var i = 0; i < vm.eventUsers.length; i++) {
                    var eventUser = vm.eventUsers[i];
                    if (eventUser.userId === user.id) {
                        vm.currentUser = eventUser;
                        break;
                    }
                }
                vm.currentUser.user = user;
                vm.newRole = vm.currentUser.role;
                vm.showSelected = true;
            } else {
                vm.currentUser = null;
                vm.newRole = null;
                vm.showSelected = false;
            }
        }

        function addRole() {
            vm.currentUser.role = vm.newRole;
            vm.currentUser.user.role = vm.newRole;
            if (vm.currentUser.changeState !== 1) {
                vm.currentUser.changeState = 2;
            }
            cancelRole();
        }

        function cancelRole() {
            vm.newRole = null;
            vm.showSelected = false;
        }

        function onAddUser(user) {
            if (!vm.eventUsers) {
                vm.eventUsers = [];
            }
            var eventUser = calendarService.getEmptyCalendarEventUser();
            eventUser.userId = user.id;
            eventUser.userProfileImageFilepath = user.profileImageFilepath;
            if (vm.eventUsers.length > 0) {
                //Set sortOrder to highest + 10
                eventUser.sortOrder =
                    Math.max.apply(
                        Math,
                        vm.eventUsers.map(function (o) {
                            return o.sortOrder;
                        })
                    ) + 10;
            }
            vm.eventUsers.push(eventUser);
        }

        function onRemoveUser(user) {
            //get user from eventUsers
            angular.forEach(vm.eventUsers, function (eventUser) {
                if (eventUser.userId === user.id) {
                    if (!eventUser.calendarEventId) {
                        //eventUser hasn't been saved and can safely be removed from the array
                        var index = vm.eventUsers.indexOf(eventUser);
                        vm.eventUsers.splice(index, 1);
                    } else {
                        //eventUser is saved in the database and must be marked as removed
                        eventUser.changeState = 3;
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .component('calendarEventTypeSelect', {
            bindings: {
                calendarEventTypeId: '=',
                calendarEventType: '=',
                onSelected: '=',
                labelText: '@',
                isRequired: '=',
                optionsFilter: '<',
                onUpdate: '&',
            },
            templateUrl: 'app/main/calendar/components/calendar-event-type-select/calendar-event-type-select.tmpl.html',
            controller: 'CalendarEventTypeSelectController as vm',
        })
        .controller('CalendarEventTypeSelectController', CalendarEventTypeSelectController);

    /* @ngInject */
    function CalendarEventTypeSelectController(dataService, $filter, calendarService) {
        var vm = this;
        vm.isDisabled = true;
        vm.calendarEventTypes = [];
        vm.onChange = onChange;

        // Get options
        dataService.getAll('CalendarEventTypes').then(function (calendarEventTypes) {
            vm.isDisabled = false;
            if (vm.optionsFilter) {
                vm.calendarEventTypes = $filter('filter')(calendarEventTypes, function (value) {
                    console.log(
                        'Options: ' +
                            value.options +
                            '. Filter: ' +
                            vm.optionsFilter +
                            '. Result: ' +
                            calendarService.options.isFlagSet(value.options, vm.optionsFilter)
                    );
                    return calendarService.options.isFlagSet(value.options, vm.optionsFilter);
                });
            } else {
                vm.calendarEventTypes = calendarEventTypes;
            }
        });

        function onChange() {
            if (vm.calendarEventTypeId) {
                for (var index = 0; index < vm.calendarEventTypes.length; index++) {
                    var calendarEventType = vm.calendarEventTypes[index];
                    if (vm.calendarEventTypeId === calendarEventType.id) {
                        vm.calendarEventType = calendarEventType;
                        vm.onUpdate({ action: 'selected', value: vm.calendarEventType });
                        break;
                    }
                }
            } else {
                vm.calendarEventType = null;
                vm.onUpdate({ action: 'deselected', value: null });
            }
            if (angular.isFunction(vm.onSelected)) {
                vm.onSelected(vm.calendarEventType);
            }
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.calendar")
    .component("calendarEventListItemSmall", {
      bindings: {
        baldrisModel: "=",
        onOpen: "&",
        onDelete: "&"
      },
      templateUrl:
        "app/main/calendar/components/calendar-event-list-item-small/calendar-event-list-item-small.tmpl.html",
      controller: "CalendarEventListItemSmallController as vm"
    })
    .controller("CalendarEventListItemSmallController", CalendarEventListItemSmallController);

  /* @ngInject */
  function CalendarEventListItemSmallController($state) {
    var vm = this;

    vm.getForegroundColor = getForegroundColor;
    vm.openEditDialog = openEditDialog;
    vm.getLocationText = getLocationText;
    vm.navigateToWorkOrder = navigateToWorkOrder;
    vm.isAllDay = isAllDay;

    //INIT
    vm.$onInit = function() {};

    function isAllDay() {
      if (vm.baldrisModel.isAllDay) {
        return true;
      }
      if (!vm.baldrisModel.start || !vm.baldrisModel.end) {
        return false; // Not enough data to decide
      }
      return moment(vm.baldrisModel.end).isAfter(moment(vm.baldrisModel.start).add(1, "days"));
    }

    function getLocationText() {
      switch (vm.baldrisModel.$type) {
        case "Baldris.Core.Data.Entities.Fdo.TransportFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.TransportDto, Baldris.Core.Data.Entities":
          return (
            vm.baldrisModel.originSerialized +
            (vm.baldrisModel.destinationSerialized ? " -> " + vm.baldrisModel.destinationSerialized : "")
          );
        case "Baldris.Core.Data.Entities.Fdo.GroomingFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.GroomingDto, Baldris.Core.Data.Entities":
          return (
            vm.baldrisModel.locationSerialized +
            (vm.baldrisModel.destinationSerialized ? " ( -> " + vm.baldrisModel.destinationSerialized + ")" : "")
          );
        case "Baldris.Core.Data.Entities.Fdo.CeremonyFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.CeremonyDto, Baldris.Core.Data.Entities":
          return vm.baldrisModel.locationSerialized;
        case "Baldris.Core.Data.Entities.Fdo.BookingFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.BookingDto, Baldris.Core.Data.Entities":
          return vm.baldrisModel.locationSerialized;
        default:
          return vm.baldrisModel.locationSerialized;
      }
    }

    function getForegroundColor(color) {
      var colors = tinycolor(color).monochromatic();

      colors.map(function(t) {
        return t.toHexString();
      }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
      return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
    }

    function openEditDialog(e) {
      vm.onOpen({ calendarEvent: vm.baldrisModel, e: e });
    }

    function navigateToWorkOrder(e) {
      if (e) {
        e.stopPropagation();
      }
      $state.go("app.workOrder.byId.deceased", {
        workOrderId: vm.baldrisModel.workOrderId
      });
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.calendar")
    .component("calendarEventListItem", {
      bindings: {
        baldrisModel: "="
      },
      require: {
        listController: "^calendarEventList"
      },
      templateUrl: "app/main/calendar/components/calendar-event-list-item/calendar-event-list-item.tmpl.html",
      controller: "CalendarEventListItemController as vm"
    })
    .controller("CalendarEventListItemController", CalendarEventListItemController);

  /* @ngInject */
  function CalendarEventListItemController(
    $state,
    $translate,
    calendarService,
    transportService,
    toastService,
    dataService,
    accountService
  ) {
    var vm = this;

    vm.isLoadingCounters = true;
    vm.getForegroundColor = getForegroundColor;
    vm.isAllDay = isAllDay;
    vm.isSameDay = isSameDay;
    vm.openEditDialog = openEditDialog;
    vm.getLocationText = getLocationText;
    vm.isCeremony = isCeremony;
    vm.hasCompletedStatus = hasCompletedStatus;
    vm.toggleCompleted = toggleCompleted;
    vm.openViewNoteOrTasksDialog = openViewNoteOrTasksDialog;
    vm.navigateToWorkOrder = navigateToWorkOrder;

    // Flags
    vm.canReadWorkOrders = accountService.canReadWorkOrders();
    vm.canWriteWorkOrders = accountService.canWriteWorkOrders();

    //INIT
    vm.$onInit = function() {
      if (vm.canWriteWorkOrders && !vm.isAllDay() && vm.isCeremony() && vm.baldrisModel.workOrderId) {
        dataService
          .getByUri("WorkOrders", "GetNotesAndTasksCountByWorkOrderId/" + vm.baldrisModel.workOrderId)
          .then(function(notesAndTasksCount) {
            if (notesAndTasksCount) {
              vm.baldrisModel.notesCount = notesAndTasksCount.notesCount || 0;
              vm.baldrisModel.completedCount = notesAndTasksCount.completedCount || 0;
              vm.baldrisModel.uncompletedCount = notesAndTasksCount.uncompletedCount || 0;
            }
            vm.isLoadingCounters = false;
          });
      } else {
        vm.isLoadingCounters = false;
      }
    };

    function getLocationText() {
      switch (vm.baldrisModel.$type) {
        case "Baldris.Core.Data.Entities.Fdo.TransportFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.TransportDto, Baldris.Core.Data.Entities":
          return (
            vm.baldrisModel.originSerialized +
            (vm.baldrisModel.destinationSerialized ? " -> " + vm.baldrisModel.destinationSerialized : "")
          );
        case "Baldris.Core.Data.Entities.Fdo.GroomingFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.GroomingDto, Baldris.Core.Data.Entities":
          return (
            vm.baldrisModel.locationSerialized +
            (vm.baldrisModel.destinationSerialized ? " ( -> " + vm.baldrisModel.destinationSerialized + ")" : "")
          );
        case "Baldris.Core.Data.Entities.Fdo.CeremonyFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.CeremonyDto, Baldris.Core.Data.Entities":
          return vm.baldrisModel.locationSerialized;
        case "Baldris.Core.Data.Entities.Fdo.BookingFdo, Baldris.Core.Data.Entities":
        case "Baldris.Core.Data.Entities.Dto.BookingDto, Baldris.Core.Data.Entities":
          return vm.baldrisModel.locationSerialized;
        default:
          return vm.baldrisModel.locationSerialized;
      }
    }

    function getForegroundColor(color) {
      var colors = tinycolor(color).monochromatic();

      colors.map(function(t) {
        return t.toHexString();
      }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
      return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
    }

    function isAllDay() {
      if (vm.baldrisModel.isAllDay) {
        return true;
      }
      if (!vm.baldrisModel.start || !vm.baldrisModel.end) {
        return false; // Not enough data to decide
      }
      return moment(vm.baldrisModel.end).isAfter(moment(vm.baldrisModel.start).add(1, "days"));
    }

    function isSameDay(firstDate, secondDate) {
      if (!firstDate || !secondDate) {
        return false; // Not enough data to decide
      }
      return moment(firstDate).isSame(secondDate, "day");
    }

    function openEditDialog(e) {
      if (!vm.baldrisModel.workOrderId || vm.canReadWorkOrders) {
        vm.listController.openEditDialog(vm.baldrisModel, e);
      }
    }

    function openViewNoteOrTasksDialog(e) {
      if (e) {
        e.stopPropagation();
      }
      if (vm.canReadWorkOrders) {
        vm.listController.openViewNoteOrTasksDialog(vm.baldrisModel.workOrderId, e);
      }
    }

    function isCeremony() {
      return vm.baldrisModel && vm.baldrisModel.$type && vm.baldrisModel.$type.indexOf("Ceremony") > -1;
    }

    function hasCompletedStatus() {
      return calendarService.options.hasCompletedStatus(vm.baldrisModel.options);
    }

    function toggleCompleted(e) {
      if (e) {
        e.stopPropagation();
      }
      transportService.canToggleTransport(vm.baldrisModel).then(function(canToggleTransport) {
        if (canToggleTransport) {
          transportService.toggleTransport(vm.baldrisModel).then(function(updatedTransport) {
            vm.baldrisModel.isCompleted = updatedTransport.isCompleted;
            vm.baldrisModel.completedTime = updatedTransport.completedTime;
            vm.baldrisModel.completedById = updatedTransport.completedById;
            vm.baldrisModel.completedBy = updatedTransport.completedBy;
            vm.baldrisModel.completedByDisplayName = updatedTransport.completedByDisplayName;
            toastService.success($translate.instant("CALENDAR.EVENT.STATUS_SET"));
          });
        } else {
          toastService.info($translate.instant("CALENDAR.EVENT.CANT_TOGGLE_OTHERS"));
        }
      });
    }
    function navigateToWorkOrder(e) {
      if (e) {
        e.stopPropagation();
      }
      if (!vm.baldrisModel.workOrderId || vm.canReadWorkOrders) {
        $state.go("app.workOrder.byId.deceased", { workOrderId: vm.baldrisModel.workOrderId });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .component('calendarEventList', {
            bindings: {
                collection: '<',
                startDate: '=',
                endDate: '=',
                workOrderId: '=',
                api: '=?',
                hideAddButton: '=',
                shouldCreateEmptyWorkHours: '=',
                createDateGroups: '<',
                onOpen: '&',
                onDelete: '&'
            },
            templateUrl: 'app/main/calendar/components/calendar-event-list/calendar-event-list.tmpl.html',
            controller: 'CalendarEventListController as vm',
        })
        .controller('CalendarEventListController', CalendarEventListController);

    /* @ngInject */
    function CalendarEventListController($mdDialog, $scope, $document, calendarService, calendarViewService, calendarEventOptions) {
        var vm = this;

        // Data

        vm.hourGroups = [];
        vm.dateGroups = [];

        // METHODS
        vm.openEditDialog = openEditDialog;
        vm.addCalendarEvent = addCalendarEvent;
        vm.eventsSpanMultipleDays = eventsSpanMultipleDays;
        vm.openViewNoteOrTasksDialog = openViewNoteOrTasksDialog;
        vm.shouldBeExcluded = shouldBeExcluded;

        // INIT
        vm.$onInit = function () {
            // Define api
            vm.api = {
                addCalendarEvent: addCalendarEvent
            };
            // Create Groups
            vm.hourGroups = calendarViewService.createHourGroups(vm.collection, vm.shouldCreateEmptyWorkHours);
            vm.dateGroups = calendarViewService.createDateGroups(vm.collection);
        }

        vm.$postLink = function() {
            $scope.$watch(function() { return vm.collection; }, function(newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    // Run purge
                    purgeCalendarEventsNotInRange();
                    // Create Groups
                    vm.hourGroups = calendarViewService.createHourGroups(vm.collection, vm.shouldCreateEmptyWorkHours);
                    vm.dateGroups = calendarViewService.createDateGroups(vm.collection);
                }
            }, true);
        }

        function openEditDialog(calendarEvent, e) {
            vm.onOpen({ calendarEvent: calendarEvent, e: e });
            /*if (angular.isFunction(vm.onOpen)) {
                vm.onOpen(calendarEvent, e);
            } else {
                $mdDialog.show({
                    controller: 'EditCalendarEventDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/calendar/dialogs/edit-calendar-event-dialog/edit-calendar-event-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        calendarEvent: angular.copy(calendarEvent)
                    },
                    clickOutsideToClose: true
                }).then(function (updatedData) {
                    if (updatedData && updatedData.calendarEvent) {
                        // remove "old" calendarEvent
                        findAndRemoveCalendarEvent(updatedData.calendarEvent);
                        // add if "new" calendarEvent is still in range
                        if (updatedData.calendarEvent.changeState !== 3 && isCalendarEventInRange(updatedData.calendarEvent)) {
                            dataService.getById('CalendarEvents', updatedData.calendarEvent.id).then(function (calendarFdo) {
                                vm.collection.push(calendarFdo);
                                vm.hourGroups = calendarViewService.createHourGroups(vm.collection, vm.shouldCreateEmptyWorkHours);
                            });
                        }
                    }
                });
            }*/
        }

        function openViewNoteOrTasksDialog(workOrderId, e) {
            $mdDialog.show({
                controller: 'ViewWorkOrderNoteOrTasksDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/work-order/dialogs/view-work-order-note-or-tasks-dialog/view-work-order-note-or-tasks-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    workOrderId: workOrderId
                },
                clickOutsideToClose: true
            });
        }

        function purgeCalendarEventsNotInRange() {
            if (!vm.startDate || !vm.endDate || !vm.collection || vm.collection.length === 0)
                return; // cancel if we don't have a set range or don't have a collection
            for (var i = 0; i < vm.collection.length; i++) {
                var calendarEvent = vm.collection[i];
                if (!isCalendarEventInRange(calendarEvent)) {
                    vm.collection.splice(i, 1);
                }
            }
        }

        function isCalendarEventInRange(calendarEvent) {
            if (!calendarEvent || !calendarEvent.start || !calendarEvent.end)
                return false; // return false if we don't have enough info to decide
            if (!vm.startDate || !vm.endDate)
                return true; // return true if we don't have a set range
            return moment(calendarEvent.start).isSameOrBefore(vm.endDate, 'day') && moment(calendarEvent.end).isSameOrAfter(vm.startDate, 'day');
        }

        function findAndRemoveCalendarEvent(calendarEvent) {
            for (var index = 0; index < vm.collection.length; index++) {
                var element = vm.collection[index];
                if (element.id === calendarEvent.id) {
                    vm.collection.splice(index, 1);
                    break;
                }
            }
        }

        function addCalendarEvent(e) {
            var calendarEvent = calendarService.getEmptyCalendarEvent();
            calendarEvent.workOrderId = vm.workOrderId;
            calendarEvent.start = moment(vm.startDate).hour(moment().hour()).minute(0).format("YYYY-MM-DDTHH:mm:ss");
            calendarEvent.end = moment(calendarEvent.start).add(1, 'hours').format("YYYY-MM-DDTHH:mm:ss");
            openEditDialog(calendarEvent, e);
        }

        function eventsSpanMultipleDays() {
            if (!vm.collection || vm.collection === 0) return false;
            return vm.collection.reduce(function (dateCounter, currentEvent) {
                    if (!moment(vm.collection[0].start).isSame(currentEvent.start, 'day')) {
                        dateCounter++;
                    }
                    return dateCounter;
                }, 1) !== 1;
        }

        function shouldBeExcluded(calendarEvent) {
            if (!calendarEvent) return false;
            return calendarEvent.options & calendarEventOptions.EXCLUDE_FROM_CALENDAR.value;
        }
    }

} ());
(function() {
  "use strict";

  angular
    .module("app.calendar")
    .component("calendarEventCard", {
      bindings: {
        baldrisModel: "="
      },
      templateUrl: "app/main/calendar/components/calendar-event-card/calendar-event-card.tmpl.html",
      controller: "CalendarEventCardController as vm"
    })
    .controller("CalendarEventCardController", CalendarEventCardController);

  /* @ngInject */
  function CalendarEventCardController($mdDialog, $document, $translate, $mdToast) {
    var vm = this;
    vm.showEditCalendarEventDialog = showEditCalendarEventDialog;
    vm.startMoment = moment(vm.baldrisModel.start);
    vm.getForegroundColor = getForegroundColor;

    function getForegroundColor(color) {
      var colors = tinycolor(color).monochromatic();

      colors.map(function(t) {
        return t.toHexString();
      }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
      return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
    }

    function showEditCalendarEventDialog(ceremony, e) {
      $mdDialog
        .show({
          controller: "EditDeceasedDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/deceased/components/edit-deceased-dialog/edit-deceased-dialog.tmpl.html",
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            ceremony: angular.copy(ceremony),
            event: e
          }
        })
        .then(function(updatedCeremony) {
          if (updatedCeremony) {
            vm.baldrisModel = updatedCeremony;
            $mdToast.show($mdToast.simple().textContent(savedText));
          }
        });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.account', [

        ]);
})();
(function() {
  "use strict";

  angular
    .module("app.account")
    .component("userSingleSelect", {
      bindings: {
        baldrisUserId: "=",
        baldrisUser: "=",
        onSelected: "=",
        labelText: "@",
        disableSearch: "="
      },
      templateUrl: "app/main/account/components/user-single-select/user-single-select.tmpl.html",
      controller: "UserSingleSelectController as vm"
    })
    .controller("UserSingleSelectController", UserSingleSelectController);

  /* @ngInject */
  function UserSingleSelectController($filter, dataService, accountService) {
    var vm = this;
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.searchTextChange = searchTextChange;
    vm.resetInput = resetInput;

    //Get Current BaldrisFile
    vm.$onInit = function() {
      if (vm.baldrisUserId) {
        dataService.getById("BaldrisUsers", vm.baldrisUserId, true).then(function(baldrisUser) {
          vm.baldrisUser = baldrisUser;
        });
      }
    };

    // ******************************
    // Internal methods
    // ******************************
    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch(query) {
      if (query) {
        return dataService.search("BaldrisUsers", query).then(function(baldrisUsers) {
          return $filter("orderBy")(baldrisUsers, "displayName");
        });
      } else {
        return accountService.getActiveUsers().then(function(baldrisUsers) {
          return $filter("orderBy")(baldrisUsers, "displayName");
        });
      }
    }

    function searchTextChange(text) {}

    function resetInput() {
      vm.baldrisUserId = null;
      vm.baldrisUser = null;
      vm.searchText = null;
      vm.baldrisUserForm.baldrisUser.$setValidity("invalidBaldrisUser", true);
    }

    function selectedItemChange(item) {
      if (angular.isFunction(vm.onSelected)) {
        vm.onSelected(item);
      }
      if (item) {
        vm.baldrisUserId = item.id;
        vm.baldrisUserForm.baldrisUser.$setValidity("invalidBaldrisUser", true);
      } else {
        vm.baldrisUserId = null;
        if (vm.searchText) {
          vm.baldrisUserForm.baldrisUser.$setValidity("invalidBaldrisUser", false);
        }
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').factory('salesOrderRecentService', salesOrderRecentService);

    /* @ngInject */
    function salesOrderRecentService(dataService) {
        var service = {
            getLatestSalesOrders: getLatestSalesOrders,
            getLatestSalesOrdersByUri: getLatestSalesOrdersByUri,
            getLatestPaginated: getLatestPaginated,
        };

        return service;

        function getLatestPaginated(pageSize, pageIndex, sortField, searchString, subRoute) {
            return dataService.getPaginatedItems('SalesOrders' + (subRoute ? '/' + subRoute : ''), pageSize, pageIndex, null, false, sortField, searchString);
        }

        function getLatestSalesOrders(amount) {
            return dataService.getLatest('SalesOrders', amount);
        }

        function getLatestSalesOrdersByUri(uri) {
            return dataService.getByUri('SalesOrders', uri);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').controller('SalesOrderRecentController', SalesOrderRecentController);

    /* @ngInject */
    function SalesOrderRecentController($mdDialog, $document, recentUri, $state, $stateParams, salesOrderTitle, salesOrderRecentService, fuseTheming) {
        var vm = this;
        vm.fuseTheming = fuseTheming;
        // Properties
        vm.isLoadingLatestSalesOrders = true;
        vm.salesOrderTitle = salesOrderTitle;

        // Methods
        vm.navigateToSalesOrder = navigateToSalesOrder;
        vm.showAddSalesOrderDialog = showAddSalesOrderDialog;
        vm.openMenu = openMenu;
        vm.onRecentAmountChange = onRecentAmountChange;
        vm.navigateBackward = navigateBackward;
        vm.navigateForward = navigateForward;
        vm.navigateToFirst = navigateToFirst;
        vm.navigateToLast = navigateToLast;
        vm.getEndPagination = getEndPagination;
        vm.onSearchStringChanged = onSearchStringChanged;

        // Init

        vm.recentAmount = $stateParams.recentAmount || 50;
        vm.sortField = $stateParams.sortField;
        vm.searchString = $stateParams.searchString;

        activate();

        function activate() {
            salesOrderRecentService
                .getLatestPaginated(vm.recentAmount, $stateParams.pageIndex, $stateParams.sortField, $stateParams.searchString, recentUri)
                .then(function (paginatedData) {
                    vm.paginatedData = paginatedData;
                    vm.isLoadingLatestSalesOrders = false;
                });
        }
        // Functions

        function openMenu($mdMenu, ev) {
            ev.stopPropagation();
            ev.preventDefault();
            $mdMenu.open(ev);
        }

        function navigateToSalesOrder(salesOrder) {
            $state.go('app.salesOrder.details', { salesOrderId: salesOrder.id });
        }

        function showAddSalesOrderDialog(e) {
            $mdDialog
                .show({
                    controller: 'AddSalesOrderDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/add-sales-order-dialog/add-sales-order-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrder: self.workOrder,
                        workOrderProducts: self.workOrderProducts,
                    },
                    clickOutsideToClose: true,
                    multiple: true,
                })
                .then(function (addedSalesOrder) {
                    if (addedSalesOrder) {
                        navigateToSalesOrder(addedSalesOrder);
                    }
                });
        }

        function getEndPagination() {
            return Math.min(vm.paginatedData.pageSize * (vm.paginatedData.pageIndex + 1), vm.paginatedData.count);
        }
        function navigateToFirst() {
            $state.go($state.current, {
                recentAmount: vm.recentAmount,
                pageIndex: 0,
                sortField: vm.sortField,
                searchString: vm.searchString,
            });
        }

        function navigateBackward(jumpAmount) {
            var pageIndex = 0;
            if (vm.paginatedData && vm.paginatedData.pageIndex) {
                pageIndex = Math.max(pageIndex, vm.paginatedData.pageIndex - (jumpAmount || 1));
            }
            $state.go($state.current, {
                recentAmount: vm.recentAmount,
                pageIndex: pageIndex,
                sortField: vm.sortField,
                searchString: vm.searchString,
            });
        }

        function navigateForward(jumpAmount) {
            var pageIndex = 0;
            if (vm.paginatedData && vm.paginatedData.pageCount) {
                pageIndex = Math.min(vm.paginatedData.pageCount, vm.paginatedData.pageIndex + (jumpAmount || 1));
            }
            $state.go($state.current, {
                recentAmount: vm.recentAmount,
                pageIndex: pageIndex,
                sortField: vm.sortField,
                searchString: vm.searchString,
            });
        }

        function navigateToLast() {
            var pageIndex = 0;
            if (vm.paginatedData && vm.paginatedData.pageCount) {
                pageIndex = vm.paginatedData.pageCount;
            }
            $state.go($state.current, {
                recentAmount: vm.recentAmount,
                pageIndex: pageIndex,
                sortField: vm.sortField,
                searchString: vm.searchString,
            });
        }

        function onSearchStringChanged() {
            if (vm.searchString !== $stateParams.searchString) {
                $state.go($state.current, {
                    recentAmount: vm.recentAmount,
                    pageIndex: 0,
                    sortField: vm.sortField,
                    searchString: vm.searchString,
                });
            }
        }

        function onRecentAmountChange() {
            if (vm.recentAmount) {
                localStorage.setItem('recent-sales-orders:recentAmount', vm.recentAmount);
                // Calculate new pageIndex
                var pageIndex = 0;
                if (vm.paginatedData && vm.paginatedData.count) {
                    var currentItemIndex = vm.paginatedData.pageIndex * vm.paginatedData.pageSize;
                    pageIndex = Math.floor(currentItemIndex / vm.recentAmount);
                }
                $state.go($state.current, {
                    recentAmount: vm.recentAmount,
                    pageIndex: pageIndex,
                    sortField: vm.sortField,
                    searchString: vm.searchString,
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrderReferencePerson').factory('workOrderReferencePersonService', workOrderReferencePersonService);

    /* @ngInject */
    function workOrderReferencePersonService($q, $http, exception, baldrisApiBase) {
        var service = {
            getEmptyWorkOrderReferencePerson: getEmptyWorkOrderReferencePerson,
            generateLetterOfAttorneyPdf: generateLetterOfAttorneyPdf,
        };

        return service;

        function generateLetterOfAttorneyPdf(referencePersonId) {
            return $http
                .put(baldrisApiBase + '/api/ReferencePersons/' + referencePersonId + '/GenerateLetterOfAttorneyPdf')
                .then(generateLetterOfAttorneyPdfComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for generateLetterOfAttorneyPdf at "WorkOrderReferencePersons"')(message);
                    return $q.reject(message);
                });

            function generateLetterOfAttorneyPdfComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyWorkOrderReferencePerson(workOrderId, party) {
            return {
                referencePersonType: 'none',
                funeralArrangementRight: 'noRight',
                familyRelation: null,
                municipalityOfBirth: null,
                placeOfDeath: null,
                shouldGetOrderSummary: false,
                sortOrder: 0,
                personId: party ? party.id : '00000000-0000-0000-0000-000000000000',
                firstName: party ? party.firstName : null,
                lastName: party ? party.lastName : null,
                sex: party ? party.sex : null,
                dateOfBirth: party ? party.dateOfBirth : null,
                dateOfBirthApproximate: party ? party.dateOfBirthApproximate : null,
                dateOfDeath: party ? party.dateOfDeath : null,
                dateOfDeathApproximate: party ? party.dateOfDeathApproximate : null,
                socialSecurityNumber: party ? party.socialSecurityNumber : null,
                imageId: party ? party.imageId : null,
                privacyOptions: party ? party.privacyOptions : 'none',
                workOrderId: workOrderId || '00000000-0000-0000-0000-000000000000',
                deceasedId: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrderReferencePerson').controller('EditReferencePersonController', EditReferencePersonController);

    /* @ngInject */
    function EditReferencePersonController($window, $translate, $scope, $stateParams, editReferencePersonViewService, loadingService, consignmentsActivated) {
        var vm = this;

        // Data
        vm.data = editReferencePersonViewService;
        vm.loadingService = loadingService;
        vm.consignmentsActivated = consignmentsActivated;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.isConsignmentsDisabled = isConsignmentsDisabled;
        vm.onPrivacyUpdate = onPrivacyUpdate;
        vm.showPrivacyComponents = showPrivacyComponents;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editReferencePersonViewService
                .loadReferencePerson($stateParams.referencePersonId, $stateParams.workOrderId, $stateParams.referencePerson, $stateParams.workOrderDeceasedList)
                .then(function () {
                    vm.consignmentsActivated =
                        vm.consignmentsActivated &&
                        vm.data.updateModel.referencePerson.privacyOptions &&
                        vm.data.updateModel.referencePerson.privacyOptions.indexOf('isDeceasedEntity') === -1;
                })
                .finally(function () {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function isConsignmentsDisabled() {
            return (
                vm.data.updateModel.referencePerson &&
                vm.data.updateModel.referencePerson.id &&
                vm.data.updateModel.referencePerson.privacyOptions &&
                vm.data.updateModel.referencePerson.privacyOptions === 'none' &&
                (!vm.data.privacyFields || vm.data.privacyFields.length === 0) &&
                !vm.privacyFieldsActivated
            );
        }

        function showPrivacyComponents() {
            if (!vm.data.updateModel.referencePerson || !vm.data.updateModel.referencePerson.id) {
                return false;
            }
            return (
                vm.data.updateModel.referencePerson.privacyOptions &&
                vm.data.updateModel.referencePerson.privacyOptions.indexOf('isDeceasedEntity') === -1 &&
                vm.data.updateModel.referencePerson.privacyOptions.indexOf('exemptFromGdpr') === -1 &&
                vm.data.updateModel.referencePerson.referencePersonType &&
                vm.data.updateModel.referencePerson.referencePersonType.indexOf('deceased') === -1
            );
        }

        function exitView() {
            if (
                (vm.data.validation && vm.data.validation.referencePersonForm && vm.data.validation.referencePersonForm.$dirty) ||
                (vm.data.validation && vm.data.validation.referencePersonSidebarForm && vm.data.validation.referencePersonSidebarForm.$dirty)
            ) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.referencePersonForm.$setPristine();
                    vm.data.validation.referencePersonSidebarForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            }
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editReferencePersonViewService
                .saveReferencePerson()
                .then(function () {
                    if (
                        (vm.data.validation && vm.data.validation.referencePersonForm && vm.data.validation.referencePersonForm.$dirty) ||
                        (vm.data.validation && vm.data.validation.referencePersonSidebarForm && vm.data.validation.referencePersonSidebarForm.$dirty)
                    ) {
                        vm.data.validation.referencePersonForm.$setPristine();
                        vm.data.validation.referencePersonSidebarForm.$setPristine();
                    }
                    exitView();
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function onPrivacyUpdate(privacyFieldsActivated) {
            vm.privacyFieldsActivated = privacyFieldsActivated;
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (
                (vm.data.validation && vm.data.validation.referencePersonForm && vm.data.validation.referencePersonForm.$dirty) ||
                (vm.data.validation && vm.data.validation.referencePersonSidebarForm && vm.data.validation.referencePersonSidebarForm.$dirty)
            ) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                } else {
                    event.preventDefault();
                    vm.loadingService.setBackgroundLoadingStatus(false);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrderReferencePerson').service('editReferencePersonViewService', editReferencePersonViewService);

    /* @ngInject */
    function editReferencePersonViewService($q, workOrderReferencePersonService, dataService, addressService, emailService, telephoneService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadReferencePerson = loadReferencePerson;
        self.saveReferencePerson = saveReferencePerson;
        self.isPseudomized = isPseudomized;

        function loadReferencePerson(referencePersonId, workOrderId, party, workOrderDeceasedList) {
            reset();
            if (!referencePersonId || referencePersonId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    referencePerson: workOrderReferencePersonService.getEmptyWorkOrderReferencePerson(workOrderId, party),
                    addresses: [],
                    telephones: [],
                    emails: [],
                };
                if (workOrderDeceasedList && workOrderDeceasedList.length > 0 && workOrderDeceasedList[0].deceasedId) {
                    self.updateModel.referencePerson.deceasedId = workOrderDeceasedList[0].deceasedId;
                }

                if (self.updateModel.referencePerson.personId) {
                    var promises = [];
                    promises.push(dataService.getByPartyId('Addresses', self.updateModel.referencePerson.personId, true));
                    promises.push(dataService.getByPartyId('Telephones', self.updateModel.referencePerson.personId, true));
                    promises.push(dataService.getByPartyId('Emails', self.updateModel.referencePerson.personId, true));

                    return $q.all(promises).then(function (result) {
                        self.updateModel.addresses = result[0];
                        self.updateModel.telephones = result[1];
                        self.updateModel.emails = result[2];

                        // Set as dirty to allow saving
                        if (self.validation && self.validation.referencePersonForm && self.validation.referencePersonForm.$pristine) {
                            self.validation.referencePersonForm.$setDirty();
                        }

                        return self.updateModel;
                    });
                } else {
                    return $q.when(self.updateModel);
                }
            } else {
                return dataService.getById('ReferencePersons', referencePersonId).then(function (referencePerson) {
                    self.updateModel = {
                        referencePerson: referencePerson,
                    };
                    self.updateModel.referencePerson.workOrderId = workOrderId;
                    if (self.updateModel.referencePerson.referencePersonType && self.updateModel.referencePerson.referencePersonType.indexOf('deceased') > -1) {
                        self.showDateOfDeath = true;
                    }
                    var promises = [];
                    promises.push(dataService.getByPartyId('Addresses', referencePerson.personId, true));
                    promises.push(dataService.getByPartyId('Telephones', referencePerson.personId, true));
                    promises.push(dataService.getByPartyId('Emails', referencePerson.personId, true));
                    promises.push(dataService.getByUri('Privacy', 'ActivatedPrivacyFields/ByReferencePersonId/' + referencePerson.id, true));
                    return $q.all(promises).then(function (response) {
                        self.updateModel.addresses = response[0];
                        self.updateModel.telephones = response[1];
                        self.updateModel.emails = response[2];
                        self.privacyFields = response[3];
                        return self.updateModel;
                    });
                });
            }
        }

        function saveReferencePerson() {
            if (!self.updateModel.referencePerson.hasOwnProperty('id')) {
                return dataService
                    .insertItem('ReferencePersons', self.updateModel.referencePerson)
                    .then(function (insertedReferencePerson) {
                        self.updateModel.referencePerson = insertedReferencePerson;
                        self.isNew = false;
                        return saveAddressesEmailsAndTelephones(self.updateModel.referencePerson);
                    })
                    .catch(function (message) {
                        return $q.reject(message);
                    });
            } else {
                return dataService
                    .updateItem('ReferencePersons', self.updateModel.referencePerson)
                    .then(function () {
                        self.isNew = false;
                        return saveAddressesEmailsAndTelephones(self.updateModel.referencePerson);
                    })
                    .catch(function (message) {
                        return $q.reject(message);
                    });
            }
        }

        function saveAddressesEmailsAndTelephones(referencePerson) {
            var promises = [];

            // Addresses
            promises = promises.concat(dataService.createBulkPromises('Addresses', self.updateModel.addresses, 'partyId', referencePerson.personId));

            // Emails
            promises = promises.concat(dataService.createBulkPromises('Emails', self.updateModel.emails, 'partyId', referencePerson.personId));

            // Telephones
            promises = promises.concat(dataService.createBulkPromises('Telephones', self.updateModel.telephones, 'partyId', referencePerson.personId));

            if (promises.length > 0) {
                return $q.all(promises).then(function () {
                    return true;
                });
            }
            return true;
        }

        function isPseudomized() {
            if (!self.updateModel || !self.updateModel.referencePerson || !self.updateModel.referencePerson.privacyOptions) return false;
            return self.updateModel.referencePerson.privacyOptions.indexOf('isPseudomized') > -1;
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.showDateOfDeath = false;
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.workOrder").controller("WorkOrderController", WorkOrderController);

  /* @ngInject */
  function WorkOrderController($state, $mdSidenav, fuseTheming, workOrder, workOrderViewService, consignmentsActivated) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.currentData = workOrderViewService.currentData;
    vm.service = workOrderViewService;
    vm.service.currentData.viewData.isLoadingAvailableWorkOrders = true;
    vm.service.currentData.viewData.isLoadingWorkOrder = true;
    vm.service.currentData.viewData.jumpAmount = 10;
    vm.service.currentData.viewData.tabFilter = workOrderViewService.getTabName($state.current.name);
    vm.consignmentsActivated = consignmentsActivated;

    //Set current Work Order
    workOrderViewService.setCurrent(workOrder.id, workOrder).then(function(returnData) {
      vm.currentData.viewData.isLoadingWorkOrder = false;
      vm.currentData = returnData;
    });

    //Load Available Work Orders to navigate
    workOrderViewService.loadAvailable().then(function(isLoaded) {
      vm.currentData.viewData.isLoadingAvailableWorkOrders = false;
    });

    workOrderViewService.loadNoteOrTasks().then(function(isLoaded) {
      vm.currentData.viewData.isLoadingNoteOrTasks = false;
    });

    //Get selectedTav
    for (var index = 0; index < vm.currentData.viewData.stateIndex.length; index++) {
      var element = vm.currentData.viewData.stateIndex[index];
      if (element == $state.current.name) {
        vm.currentData.viewData.viewDataselectedIndex = index;
      }
    }

    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .factory('workOrderViewService', workOrderViewService);

    /* @ngInject */
    function workOrderViewService(
        $q,
        $filter,
        $state,
        dataService,
        noteOrTaskViewService,
        workOrderService,
        logger
    ) {
        var currentData = {
            workOrder: null,
            availableWorkOrders: null,
            isSet: false,
            dataTimeStamp: null,
            tenant: null,
            viewData: {
                stateIndex: [
                    'app.workOrder.byId.deceased',
                    'app.workOrder.byId.referencePersons',
                    'app.workOrder.byId.ceremonies',
                    'app.workOrder.byId.flowerOrders',
                    'app.workOrder.byId.programs',
                    'app.workOrder.byId.groomingAndTransports',
                    'app.workOrder.byId.graves',
                    'app.workOrder.byId.obituaryNotices',
                    'app.workOrder.byId.calendarEvents',
                    'app.workOrder.byId.notesAndTasks',
                    'app.workOrder.byId.invoicing',
                    'app.workOrder.byId.shipments',
                    'app.workOrder.byId.headstoneOrders',
                    'app.workOrder.byId.options',
                    'app.workOrder.byId.reports',
                    'app.workOrder.byId.attachments',
                    'app.workOrder.byId.summary',
                    'app.workOrder.byId.consignments',
                ],
                selectedIndex: 0,
            },
        };
        var service = {
            setCurrent: setCurrent,
            currentData: currentData,
            loadDeceased: loadDeceased,
            loadNoteOrTasks: loadNoteOrTasks,
            loadAvailable: loadAvailable,
            loadReferencePersons: loadReferencePersons,
            loadCeremonyData: loadCeremonyData,
            loadProgramData: loadProgramData,
            loadCalendarEvents: loadCalendarEvents,
            loadObituaryNoticeData: loadObituaryNoticeData,
            loadGraveData: loadGraveData,
            getGroomingAndTransports: getGroomingAndTransports,
            createNoteOrTaskGroupsByTabName: createNoteOrTaskGroupsByTabName,
            changeTab: changeTab,
            navigateNext: navigateNext,
            navigatePrevious: navigatePrevious,
            navigateForward: navigateForward,
            navigateBackward: navigateBackward,
            navigateToLast: navigateToLast,
            navigateToFirst: navigateToFirst,
            getCurrentWorkOrderIndex: getCurrentWorkOrderIndex,
            saveWorkOrder: saveWorkOrder,
            isSelected: isSelected,
            getTabName: getTabName,
            isOptionEnabled: isOptionEnabled,
        };

        return service;

        function isOptionEnabled(option) {
            if (!option || !currentData.workOrder.options) return false;
            return (
                currentData.workOrder.options &&
                currentData.workOrder.options.indexOf(option) > -1
            );
        }

        function changeTab(index) {
            if (
                !currentData.viewData.isLoadingAvailableWorkOrders &&
                currentData.availableWorkOrders &&
                currentData.availableWorkOrders.length > 0
            ) {
                var currentIndex = getCurrentWorkOrderIndex();
                $state.go(currentData.viewData.stateIndex[index], {
                    workOrderId: currentData.availableWorkOrders[currentIndex],
                });
                currentData.viewData.tabFilter = getTabName(
                    currentData.viewData.stateIndex[index]
                );
            }
        }

        function navigateNext() {
            navigateForward(1);
        }

        function navigatePrevious() {
            navigateBackward(1);
        }

        function navigateForward(amount) {
            if (
                !currentData.viewData.isLoadingAvailableWorkOrders &&
                currentData.availableWorkOrders &&
                currentData.availableWorkOrders.length > 1
            ) {
                var currentIndex = getCurrentWorkOrderIndex();
                if (
                    currentIndex > -1 &&
                    currentIndex <
                        currentData.availableWorkOrders.length - amount
                ) {
                    $state.go($state.current, {
                        workOrderId:
                            currentData.availableWorkOrders[
                                currentIndex + amount
                            ],
                    });
                } else if (
                    currentIndex !=
                    currentData.availableWorkOrders.length - 1
                ) {
                    $state.go($state.current, {
                        workOrderId:
                            currentData.availableWorkOrders[
                                currentData.availableWorkOrders.length - 1
                            ],
                    });
                }
            }
        }

        function navigateBackward(amount) {
            if (
                !currentData.viewData.isLoadingAvailableWorkOrders &&
                currentData.availableWorkOrders &&
                currentData.availableWorkOrders.length > 1
            ) {
                var currentIndex = getCurrentWorkOrderIndex();
                if (currentIndex > 0 && currentIndex > amount - 1) {
                    $state.go($state.current, {
                        workOrderId:
                            currentData.availableWorkOrders[
                                currentIndex - amount
                            ],
                    });
                } else if (currentIndex != 0) {
                    $state.go($state.current, {
                        workOrderId: currentData.availableWorkOrders[0],
                    });
                }
            }
        }

        function navigateToLast() {
            if (
                !currentData.viewData.isLoadingAvailableWorkOrders &&
                currentData.availableWorkOrders &&
                currentData.availableWorkOrders.length > 1
            ) {
                var currentIndex = getCurrentWorkOrderIndex();
                if (
                    currentIndex !=
                    currentData.availableWorkOrders.length - 1
                ) {
                    $state.go($state.current, {
                        workOrderId:
                            currentData.availableWorkOrders[
                                currentData.availableWorkOrders.length - 1
                            ],
                    });
                }
            }
        }

        function navigateToFirst() {
            if (
                !currentData.viewData.isLoadingAvailableWorkOrders &&
                currentData.availableWorkOrders &&
                currentData.availableWorkOrders.length > 1
            ) {
                var currentIndex = getCurrentWorkOrderIndex();
                if (currentIndex != 0) {
                    $state.go($state.current, {
                        workOrderId: currentData.availableWorkOrders[0],
                    });
                }
            }
        }

        function getCurrentWorkOrderIndex() {
            for (
                var i = 0, len = currentData.availableWorkOrders.length;
                i < len;
                i++
            ) {
                if (
                    currentData.availableWorkOrders[i] ===
                    currentData.workOrder.id
                ) {
                    return i;
                }
            }
            return -1;
        }

        function saveWorkOrder() {
            dataService
                .updateItem('WorkOrders', currentData.workOrder)
                .then(function (updateWorkOrderResult) {
                    currentData.viewData.workOrderForm.$setPristine();
                    $mdToast.show($mdToast.simple().textContent('SAVED!'));
                });
        }

        function isSelected(elementName) {
            switch (elementName) {
                case 'DECEASED':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[0] ||
                        $state.current.name == 'app.workOrder.byId.deceasedById'
                    );
                    break;
                case 'REFERENCE_PERSONS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[1] ||
                        $state.current.name ==
                            'app.workOrder.byId.referencePersonById'
                    );
                    break;
                case 'CEREMONY':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[2] ||
                        $state.current.name == 'app.workOrder.byId.ceremonyById'
                    );
                    break;
                case 'FLOWER_ORDERS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[3] ||
                        $state.current.name ==
                            'app.workOrder.byId.flowerOrderById'
                    );
                    break;
                case 'PROGRAMS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[4] ||
                        $state.current.name == 'app.workOrder.byId.programById'
                    );
                    break;
                case 'GROOMING_TRANSPORT':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[5] ||
                        $state.current.name ==
                            'app.workOrder.byId.transportById' ||
                        $state.current.name == 'app.workOrder.byId.groomingById'
                    );
                    break;
                case 'GRAVES':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[6] ||
                        $state.current.name == 'app.workOrder.byId.graveById'
                    );
                    break;
                case 'OBITUARY_NOTICES':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[7] ||
                        $state.current.name ==
                            'app.workOrder.byId.obituaryNoticeById'
                    );
                    break;
                case 'CALENDAR_EVENTS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[8] ||
                        $state.current.name ==
                            'app.workOrder.byId.calendarEventById'
                    );
                    break;
                case 'NOTES_AND_TASKS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[9] ||
                        $state.current.name ==
                            'app.workOrder.byId.noteOrTaskById'
                    );
                    break;
                case 'INVOICING':
                    return (
                        $state.current.name ==
                        currentData.viewData.stateIndex[10]
                    );
                case 'SHIPMENTS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[11] ||
                        $state.current.name == 'app.workOrder.byId.shipments'
                    );
                    break;
                case 'HEADSTONE_ORDERS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[12] ||
                        $state.current.name ==
                            'app.workOrder.byId.headstoneOrders'
                    );
                    break;
                case 'OPTIONS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[13] ||
                        $state.current.name == 'app.workOrder.byId.options'
                    );
                    break;
                case 'REPORTS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[14] ||
                        $state.current.name == 'app.workOrder.byId.reports'
                    );
                    break;
                case 'ATTACHMENTS':
                    return (
                        $state.current.name ==
                            currentData.viewData.stateIndex[15] ||
                        $state.current.name == 'app.workOrder.byId.attachments'
                    );
                    break;
                case 'SUMMARY':
                    return (
                        $state.current.name ==
                        currentData.viewData.stateIndex[16]
                    );
                    break;
                case 'CONSIGNMENTS':
                    return (
                        $state.current.name ==
                        currentData.viewData.stateIndex[17] || $state.current.name ==
                        'app.workOrder.byId.consignmentById'
                    );
                    break;
            }
        }

        function getTabName(state) {
            switch (state) {
                case 'app.workOrder.byId.deceased':
                case 'app.workOrder.byId.deceasedById':
                    return 'Deceased';
                    break;
                case 'app.workOrder.byId.referencePersons':
                case 'app.workOrder.byId.referencePersonById':
                    return 'WorkOrderPerson';
                    break;
                case 'app.workOrder.byId.ceremonies':
                case 'app.workOrder.byId.ceremonyById':
                    return 'Ceremony';
                    break;
                case 'app.workOrder.byId.groomingAndTransports':
                case 'app.workOrder.byId.transportById':
                case 'app.workOrder.byId.groomingById':
                    return 'Transport';
                    break;
                case 'app.workOrder.byId.flowerOrders':
                case 'app.workOrder.byId.flowerOrderById':
                    return 'FlowerOrder';
                    break;
                case 'app.workOrder.byId.programs':
                case 'app.workOrder.byId.programById':
                    return 'ServiceSheet';
                    break;
                case 'app.workOrder.byId.graves':
                case 'app.workOrder.byId.graveById':
                    return 'Grave';
                    break;
                case 'app.workOrder.byId.obituaryNotices':
                case 'app.workOrder.byId.obituaryNoticeById':
                    return 'ObituaryNotice';
                    break;
                case 'app.workOrder.byId.calendarEvents':
                case 'app.workOrder.byId.calendarEventById':
                    return 'Event';
                    break;
                case 'app.workOrder.byId.notesAndTasks':
                case 'app.workOrder.byId.noteOrTaskById':
                    return 'Deceased';
                    break;
                case 'app.workOrder.byId.invoicing':
                    return 'Invoicing';
                case 'app.workOrder.byId.shipments':
                    return 'Shipment';
                case 'app.workOrder.byId.headstoneOrders':
                    return 'HeadstoneOrder';
                case 'app.workOrder.byId.options':
                    return 'Options';
                case 'app.workOrder.byId.reports':
                    return 'Reports';
                case 'app.workOrder.byId.attachments':
                    return 'Attachments';
                case 'app.workOrder.byId.summary':
                    return 'Deceased';
                    break;
                case 'app.workOrder.byId.consignments':
                    case 'app.workOrder.byId.consignmentById':
                        return 'Consignment';
                        break;
            }
        }

        function setCurrent(id, workOrder) {
            var promises = [];

            if (workOrder) {
                currentData.workOrder = workOrder;
                currentData.isSet = true;
                currentData.dataTimeStamp = new Date();
            } else {
                promises.push(dataService.getById('WorkOrders', id));
            }

            if (!currentData.tenant) {
                promises.push(dataService.getByUri('Accounts', 'CurrentTenant'));
            }
            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    if (!workOrder) {
                        currentData.workOrder = response[0];
                    }

                    currentData.tenant = response[response.length - 1] ? response[response.length - 1] : currentData.tenant;
                    currentData.isSet = true;
                    currentData.dataTimeStamp = new Date();
                    return currentData;
                });
            }
            return $q.when(currentData);
        }

        function createNoteOrTaskGroupsByTabName(collection, tabName) {
            //filter by tabName
            var filteredNoteOrTasks = $filter('noteOrTaskInTab')(
                collection,
                tabName
            );

            //Create groups
            return noteOrTaskViewService.createNoteOrTaskGroups(
                filteredNoteOrTasks
            );
        }

        function getGroomingAndTransports() {
            if (!currentData.workOrder) return $q.when([]);
            var promises = [];

            promises.push(
                dataService.getByWorkOrderId(
                    'Transports',
                    currentData.workOrder.id
                )
            );
            promises.push(
                dataService.getByWorkOrderId(
                    'Groomings',
                    currentData.workOrder.id
                )
            );
            return $q.all(promises).then(function (returnData) {
                var groomingsAndTransports = [];
                //Get transports and isolate groomingIds
                var groomingIds = [];
                for (var index = 0; index < returnData[0].length; index++) {
                    var element = returnData[0][index];
                    if (element.linkedGroomingId) {
                        groomingIds.push(element.linkedGroomingId);
                    }
                    groomingsAndTransports.push(element);
                }

                //Get groomings that are not arlready linked to a transport
                for (var index = 0; index < returnData[1].length; index++) {
                    var element = returnData[1][index];
                    if (groomingIds.indexOf(element.id) === -1) {
                        groomingsAndTransports.push(element);
                    }
                }

                return groomingsAndTransports;
            });
        }

        function loadGraveData() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('Graves', currentData.workOrder.id)
                .then(function (graves) {
                    for (
                        var index = 0;
                        index < currentData.workOrder.deceaseds.length;
                        index++
                    ) {
                        var workOrderDeceased =
                            currentData.workOrder.deceaseds[index];
                        for (
                            var innerIndex = 0;
                            innerIndex < graves.length;
                            innerIndex++
                        ) {
                            var grave = graves[innerIndex];
                            if (
                                workOrderDeceased.deceased &&
                                workOrderDeceased.deceased.graveId === grave.id
                            ) {
                                workOrderDeceased.deceased.grave = grave;
                            }
                        }
                    }
                    return true;
                });
        }

        function loadObituaryNoticeData() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('ObituaryNotices', currentData.workOrder.id)
                .then(function (obituaryNotices) {
                    if (!currentData.workOrder.externalOrders) {
                        currentData.workOrder.externalOrders = obituaryNotices;
                    } else if (
                        currentData.workOrder.externalOrders.length === 0
                    ) {
                        currentData.workOrder.externalOrders = obituaryNotices;
                    } else {
                        addOrReplcaceToArray(
                            obituaryNotices,
                            currentData.workOrder.externalOrders
                        );
                        //currentData.workOrder.externalOrders = currentData.workOrder.externalOrders.concat(obituaryNotices);
                    }
                    return true;
                });
        }

        function loadProgramData() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('Programs', currentData.workOrder.id)
                .then(function (programs) {
                    if (!currentData.workOrder.externalOrders) {
                        currentData.workOrder.externalOrders = programs;
                    } else if (
                        currentData.workOrder.externalOrders.length === 0
                    ) {
                        currentData.workOrder.externalOrders = programs;
                    } else {
                        addOrReplcaceToArray(
                            programs,
                            currentData.workOrder.externalOrders
                        );
                        //currentData.workOrder.externalOrders = currentData.workOrder.externalOrders.concat(programs);
                    }
                    return true;
                });
        }

        function addOrReplcaceToArray(newData, targetArray) {
            if (!targetArray || targetArray.length === 0) {
                targetArray = newData;
                return;
            }
            for (var index = 0; index < newData.length; index++) {
                var newElement = newData[index];
                var matchFound = false;
                for (
                    var oldIndex = 0;
                    oldIndex < targetArray.length;
                    oldIndex++
                ) {
                    var oldElement = targetArray[oldIndex];
                    if (newElement.id === oldElement.id) {
                        //Already exists -> replace with new one
                        matchFound = true;
                        targetArray.splice(oldIndex, 1);
                        targetArray.push(newElement);
                        break;
                    }
                }
                if (!matchFound) {
                    targetArray.push(newElement);
                }
            }
        }

        function loadAvailable(forceReload) {
            forceReload = forceReload || false;
            if (forceReload) {
                return workOrderService
                    .getAvailableIds()
                    .then(function (availableWorkOrders) {
                        currentData.availableWorkOrders = availableWorkOrders;
                        return true;
                    });
            } else {
                if (
                    currentData.availableWorkOrders &&
                    currentData.availableWorkOrders.length > 0
                ) {
                    return $q.when(true);
                } else {
                    return workOrderService
                        .getAvailableIds()
                        .then(function (availableWorkOrders) {
                            currentData.availableWorkOrders =
                                availableWorkOrders;
                            return true;
                        });
                }
            }
        }

        function loadCalendarEvents() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('CalendarEvents', currentData.workOrder.id)
                .then(function (events) {
                    currentData.workOrder.events = events;
                    return true;
                });
        }

        function loadCeremonyData() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('CalendarEvents', currentData.workOrder.id)
                .then(function (ceremonies) {
                    currentData.workOrder.ceremonies = ceremonies;
                    return true;
                });
        }

        function loadNoteOrTasks() {
            if (!currentData.workOrder) return $q.when(false);
            currentData.viewData.isLoadingNoteOrTasks = true;
            return dataService
                .getByWorkOrderId('NoteOrTasks', currentData.workOrder.id)
                .then(function (noteOrTasks) {
                    currentData.workOrder.notesAndTasks = noteOrTasks;
                    logger.info(
                        'NotesAndTasksLoaded for "' +
                            currentData.workOrder.orderCode +
                            '": ' +
                            (noteOrTasks && noteOrTasks.length
                                ? noteOrTasks.length
                                : 0),
                        noteOrTasks
                    );
                    currentData.viewData.isLoadingNoteOrTasks = false;
                    return true;
                });
        }

        function loadReferencePersons() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId(
                    'WorkOrderReferencePersons',
                    currentData.workOrder.id
                )
                .then(function (referencePersons) {
                    currentData.workOrder.referencePersons = referencePersons;
                    return true;
                });
        }

        function loadDeceased() {
            if (!currentData.workOrder) return $q.when(false);
            return dataService
                .getByWorkOrderId('Deceased', currentData.workOrder.id)
                .then(function (deceased) {
                    currentData.deceased = deceased;
                    return true;
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').factory('workOrderService', workOrderService);

    /* @ngInject */
    function workOrderService($http, $q, exception, baldrisApiBase) {
        var locations;

        var service = {
            findWorkOrder: findWorkOrder,
            getAvailableIds: getAvailableIds,
            getByEventDates: getByEventDates,
            getById: getWorkOrderById,
            getEmptyWorkOrderDeceased: getEmptyWorkOrderDeceased,
            getEmptyWorkOrder: getEmptyWorkOrder,
            getEmptyWorkOrderWorkOrderProduct: getEmptyWorkOrderWorkOrderProduct,
            getLatest: getLatest,
            getEmptyWorkOrderAttachment: getEmptyWorkOrderAttachment,
        };

        return service;

        function findWorkOrder(searchString, workOrderTypeId, departmentId, pageIndex, pageSize) {
            pageIndex = pageIndex || 0;
            pageSize = pageSize || 50;

            return $http
                .get(baldrisApiBase + '/api/WorkOrders/Items', {
                    params: {
                        searchString: searchString,
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        workOrderTypeId: workOrderTypeId,
                        departmentId: departmentId,
                    },
                })
                .then(findWorkOrderComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for findWorkOrder')(message);
                    return $q.reject(message);
                });

            function findWorkOrderComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getAvailableIds() {
            return $http
                .get(baldrisApiBase + '/api/WorkOrders/Ids')
                .then(getAvailableIdsComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getAvailableIds')(message);
                    return $q.reject(message);
                });

            function getAvailableIdsComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByEventDates(startDate, endDate) {
            return $http
                .get(baldrisApiBase + '/api/WorkOrders/ByEventDates', {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                })
                .then(getByEventDatesComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getByEventDates')(message);
                    return $q.reject(message);
                });

            function getByEventDatesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getWorkOrderById(id) {
            return $http
                .get(baldrisApiBase + '/api/WorkOrders/' + id)
                .then(getWorkOrderByIdComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    exception.catcher('XHR Failed for getWorkOrderById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getWorkOrderByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getLatest(count, workOrderTypeId, departmentId, searchString, deepSearch) {
            return $http
                .get(baldrisApiBase + '/api/WorkOrders/Items', {
                    params: {
                        departmentId: departmentId,
                        workOrderTypeId: workOrderTypeId,
                        searchString: searchString,
                        deepSearch: deepSearch || false,
                    },
                })
                .then(getAllComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getAll')(message);
                    return $q.reject(message);
                });

            function getAllComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyWorkOrderDeceased() {
            return {
                remarks: null,
                sortOrder: 0,
                workOrderId: null,
                deceasedId: null,
            };
        }

        function getEmptyWorkOrderWorkOrderProduct() {
            return {
                addedRemarks: null,
                billTo: 'unknown',
                workOrderId: '00000000-0000-0000-0000-000000000000',
                productId: '00000000-0000-0000-0000-000000000000',
                overriddenPrice: null,
                overriddenCost: null,
                overriddenName: null,
                amount: 0,
                label: null,
                remarks: null,
            };
        }

        function getEmptyWorkOrder() {
            return {
                isLocked: false,
                lockedDate: null,
                lockedById: null,
                lockedBy: null,
                privacyRemarks: null,
                workOrderTypeId: null,
                caseWorkerId: null,
                remarksForInvoice: null,
                remarks: null,
                workOrderInfo: null,
                departmentId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function getEmptyWorkOrderAttachment() {
            return {
                remarks: null,
                sortOrder: 0,
                fileId: '00000000-0000-0000-0000-000000000000',
                workOrderId: '00000000-0000-0000-0000-000000000000',
                externalOrderId: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .service('workOrderSearchService', workOrderSearchService);

    /* @ngInject */
    function workOrderSearchService(loadingService, workOrderService) {
        var self = this;


        function searchWorkOrders(count, workOrderTypeId, departmentId, searchString) {
            return workOrderService.getLatest(count, workOrderTypeId, departmentId, searchString, true);
        }
    }

})();


(function() {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('WorkOrderSearchController', WorkOrderSearchController);

    /* @ngInject */
    function WorkOrderSearchController($filter, $mdDialog, $document, $state, $mdSidenav, workOrderTypes, departments, workOrderService, loadingService) {
        var vm = this;

        vm.amount = 50;
        vm.workOrderTypes = workOrderTypes;
        vm.departments = departments;

        vm.toggleSidenav = toggleSidenav;

        vm.selectWorkOrderType = selectWorkOrderType;
        vm.selectDepartment = selectDepartment;
        vm.loadingService = loadingService;
        vm.navigateToWorkOrder = navigateToWorkOrder;
        vm.searchTermChanged = searchTermChanged;

        vm.showAddWorkOrderDialog = showAddWorkOrderDialog;

        // INIT
        reloadSearch();

        // METHODS

        function reloadSearch() {
            searchWorkOrders(vm.amount || 50, (vm.selectedWorkOrderType ? vm.selectedWorkOrderType.id : null), (vm.selectedDepartment ? vm.selectedDepartment.id : null), vm.searchTerm);
        }

        function searchWorkOrders(count, workOrderTypeId, departmentId, searchString) {
            vm.loadingService.setLoadingStatus(true);
            workOrderService.getLatest(count, workOrderTypeId, departmentId, searchString, true).then(function(workOrders) {
                vm.searchResults = workOrders;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function searchTermChanged() {
            reloadSearch();
        }

        function navigateToWorkOrder(workOrder) {
            if (workOrder.id) {
                $state.go('app.workOrder.byId.deceased', { workOrderId: workOrder.id });
            }
        }

        function showAddWorkOrderDialog(e) {
            $mdDialog.show({
                controller: 'AddWorkOrderDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/work-order/dialogs/add-work-order-dialog/add-work-order-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    event: e
                }
            }).then(function (addedWorkOrder) {
                if (addedWorkOrder) {

                }
            });
        }

        function selectWorkOrderType(workOrderType) {
            if (vm.selectedWorkOrderType === workOrderType) {
                vm.selectedWorkOrderType = null;
            } else {
                vm.selectedWorkOrderType = workOrderType;
            }
            reloadSearch();
        }

        function selectDepartment(department) {
            if (vm.selectedDepartment === department) {
                vm.selectedDepartment = null;
            } else {
                vm.selectedDepartment = department;
            }
            reloadSearch();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.calendar').service('quickRegistrationDeceasedService', quickRegistrationDeceasedService);

    /* @ngInject */
    function quickRegistrationDeceasedService(
        $q,
        $translate,
        $filter,
        dataService,
        calendarService,
        workOrderService,
        partyService,
        deceasedService,
        workOrderReferencePersonService,
        ceremonyService,
        groomingService,
        emailService,
        addressService,
        telephoneService
    ) {
        var self = this;

        self.updateModel = null;

        self.initialize = initialize;
        self.insertData = insertData;
        self.addCeremony = addCeremony;
        self.addGrooming = addGrooming;
        self.searchPersons = searchPersons;
        self.getTelephones = getTelephones;
        self.getEmails = getEmails;
        self.getAddresses = getAddresses;
        self.getPersonById = getPersonById;
        self.onCeremonyTypeChanged = onCeremonyTypeChanged;
        self.onEntityChanged = onEntityChanged;
        self.onWorkOrderTypeChanged = onWorkOrderTypeChanged;

        function initialize(selectedDate) {
            reset();
            self.updateModel = {
                workOrder: workOrderService.getEmptyWorkOrder(),
                deceased: deceasedService.getEmptyDeceased(),
                deceasedAddresses: [],
                contact: workOrderReferencePersonService.getEmptyWorkOrderReferencePerson(),
                contactEmails: [],
                contactTelephones: [],
                appointment: calendarService.getEmptyCalendarEvent(),
                appointmentAddress: addressService.getEmptyAddress(),
                appointmentAssistants: [],
                grooming: null,
                groomingAssistants: [],
                ceremony: null,
            };
            self.updateModel.contactEmails.push(emailService.getEmptyEmail());

            self.updateModel.contactTelephones.push(telephoneService.getEmptyTelephone());

            // Set Date
            if (selectedDate) {
                var hour = moment().startOf('hour').hour() + 1;
                self.updateModel.appointment.start = moment(selectedDate).hour(hour).minute(0).format('YYYY-MM-DDTHH:mm:ss');
                self.updateModel.appointment.end = moment(selectedDate)
                    .hour(hour + 1)
                    .minute(0)
                    .format('YYYY-MM-DDTHH:mm:ss');
            } else {
                var hour = moment().startOf('hour').hour() + 1;
                self.updateModel.appointment.start = moment().hour(hour).minute(0).format('YYYY-MM-DDTHH:mm:ss');
                self.updateModel.appointment.end = moment()
                    .hour(hour + 1)
                    .minute(0)
                    .format('YYYY-MM-DDTHH:mm:ss');
            }

            var searchString = $translate.instant('WORK_ORDERS.QUICK_REGISTRATION.CONFERENCE_NAME');
            return dataService.getAll('CalendarEventTypes').then(function (calendarEventTypes) {
                if (calendarEventTypes && calendarEventTypes.length > 0) {
                    var calendarEventType = calendarEventTypes.find(function (eventType) {
                        return eventType.options && eventType.options.indexOf('isConference') > -1;
                    });
                    self.updateModel.appointment.calendarEventTypeId = calendarEventType ? calendarEventType.id : null;
                    self.updateModel.appointment.options = calendarEventType ? calendarEventType.options : 'none';
                }
                return self.updateModel;
            });
        }

        function insertData() {
            return dataService
                .insertItem('WorkOrders', self.updateModel.workOrder)
                .then(function (insertedWorkOrder) {
                    self.updateModel.deceased.targetWorkOrderId = insertedWorkOrder.id;
                    return dataService.insertItem('Deceased', self.updateModel.deceased).then(function (insertedDeceased) {
                        var promises = [];
                        self.updateModel.contact.workOrderId = insertedWorkOrder.id;
                        promises.push(dataService.insertItem('ReferencePersons', self.updateModel.contact));
                        promises = promises.concat(
                            dataService.createBulkPromises('Addresses', self.updateModel.deceasedAddresses, 'partyId', insertedDeceased.personId)
                        );
                        var addressIndex = -1;
                        if (self.updateModel.appointmentAddress.localizedAddress) {
                            addressIndex = promises.length;
                            promises.push(dataService.insertItem('Addresses', self.updateModel.appointmentAddress));
                        }
                        var groomingIndex = -1;
                        if (self.updateModel.grooming) {
                            groomingIndex = promises.length;
                            self.updateModel.grooming.workOrderId = insertedWorkOrder.id;
                            promises.push(dataService.insertItem('Groomings', self.updateModel.grooming));
                        }
                        var ceremonyIndex = -1;
                        if (self.updateModel.ceremony) {
                            ceremonyIndex = promises.length;
                            self.updateModel.ceremony.workOrderId = insertedWorkOrder.id;
                            promises.push(dataService.insertItem('Ceremonies', self.updateModel.ceremony));
                        }
                        return $q.all(promises).then(function (response) {
                            var innerPromises = [];
                            if (addressIndex > -1) {
                                self.updateModel.appointment.addressId = response[addressIndex].id;
                            }
                            self.updateModel.appointment.workOrderId = insertedWorkOrder.id;
                            innerPromises.push(dataService.insertItem('CalendarEvents', self.updateModel.appointment));
                            innerPromises = innerPromises.concat(
                                dataService.createBulkPromises('Emails', self.updateModel.contactEmails, 'partyId', response[0].personId)
                            );
                            innerPromises = innerPromises.concat(
                                dataService.createBulkPromises('Telephones', self.updateModel.contactTelephones, 'partyId', response[0].personId)
                            );
                            if (groomingIndex > -1) {
                                innerPromises = innerPromises.concat(
                                    dataService.createBulkPromises(
                                        'CalendarEventUsers',
                                        self.updateModel.groomingAssistants,
                                        'calendarEventId',
                                        response[groomingIndex].id
                                    )
                                );
                            }
                            return $q.all(innerPromises).then(function (innerResponse) {
                                var appointmentPromises = dataService.createBulkPromises(
                                    'CalendarEventUsers',
                                    self.updateModel.appointmentAssistants,
                                    'calendarEventId',
                                    innerResponse[0].id
                                );
                                var appointmentDeceased = calendarService.getEmptyCalendarEventDeceased();
                                appointmentDeceased.calendarEventId = innerResponse[0].id;
                                appointmentDeceased.deceasedId = insertedDeceased.id;
                                appointmentPromises.push(dataService.insertItem('CalendarEventDeceased', appointmentDeceased));

                                if (groomingIndex > -1) {
                                    var groomingDeceased = calendarService.getEmptyCalendarEventDeceased();
                                    groomingDeceased.calendarEventId = response[groomingIndex].id;
                                    groomingDeceased.deceasedId = insertedDeceased.id;
                                    appointmentPromises.push(dataService.insertItem('CalendarEventDeceased', groomingDeceased));
                                }

                                if (ceremonyIndex > -1) {
                                    var ceremonyDeceased = calendarService.getEmptyCalendarEventDeceased();
                                    ceremonyDeceased.calendarEventId = response[ceremonyIndex].id;
                                    ceremonyDeceased.deceasedId = insertedDeceased.id;
                                    appointmentPromises.push(dataService.insertItem('CalendarEventDeceased', ceremonyDeceased));
                                }

                                return $q.all(appointmentPromises).then(function () {
                                    return insertedWorkOrder;
                                });
                            });
                        });
                    });
                })
                .catch(function (message) {
                    return $q.reject(message);
                });
        }

        function addCeremony() {
            self.updateModel.ceremony = ceremonyService.getEmptyCeremony();
            self.updateModel.ceremony.changeState = 1;
        }

        function addGrooming() {
            self.updateModel.grooming = groomingService.getEmptyGrooming();
            self.updateModel.grooming.changeState = 1;
        }

        function searchPersons(searchText) {
            return dataService.search('Persons', searchText).then(function (searchResults) {
                searchResults = $filter('filter')(searchResults, { isDeleted: false });
                searchResults = $filter('orderBy')(searchResults, 'displayName');
                return searchResults;
            });
        }

        function getTelephones(partyId) {
            return dataService.getByPartyId('Telephones', partyId, true).then(function (telephones) {
                telephones = $filter('filter')(telephones, { isDeleted: false });
                telephones = $filter('orderBy')(telephones, ['-isDefault', 'sortOrder']);
                return telephones;
            });
        }

        function getEmails(partyId) {
            return dataService.getByPartyId('Emails', partyId, true).then(function (emails) {
                emails = $filter('filter')(emails, { isDeleted: false });
                emails = $filter('orderBy')(emails, ['-isDefault', 'sortOrder']);
                return emails;
            });
        }

        function getAddresses(partyId) {
            return dataService.getByPartyId('Addresses', partyId, true).then(function (addresses) {
                addresses = $filter('filter')(addresses, { isDeleted: false });
                addresses = $filter('orderBy')(addresses, ['-isDefault', 'sortOrder']);
                return addresses;
            });
        }

        function getPersonById(partyId) {
            return dataService.getById('Persons', partyId, true).then(function (person) {
                return person;
            });
        }

        function onCeremonyTypeChanged(ceremonyType) {
            if (ceremonyType && self.updateModel.ceremony) {
                self.updateModel.ceremony.options = ceremonyType.options;
            }
        }

        function onEntityChanged(entity) {
            if (entity) {
                if (!entity.id || entity.id === '00000000-0000-0000-0000-000000000000') {
                    entity.changeState = 1;
                } else {
                    entity.changeState = 2;
                }
            }
        }

        function onWorkOrderTypeChanged(workOrderType) {
            if (self.updateModel.workOrder && workOrderType) {
                self.updateModel.workOrder.options = workOrderType.options;
            }
        }

        function reset() {
            self.updateModel = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.workOrder')
        .controller('QuickRegistrationDeceasedController', QuickRegistrationDeceasedController);

    /* @ngInject */
    function QuickRegistrationDeceasedController($window, $stateParams, $q, loadingService, quickRegistrationDeceasedService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = quickRegistrationDeceasedService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.onDeceasedNameChange = onDeceasedNameChange;
        vm.onContactNameChange = onContactNameChange;
        vm.useExistingContact = useExistingContact;
        vm.useExistingDeceased = useExistingDeceased;
        vm.selectDeceasedPerson = selectDeceasedPerson;
        vm.isDeceasedDisabled = isDeceasedDisabled;
        vm.isContactDisabled = isContactDisabled;
        vm.selectContactPerson = selectContactPerson;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            quickRegistrationDeceasedService.initialize($stateParams.selectedDate).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            return quickRegistrationDeceasedService.insertData().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                // Something went wrong... What do?
            });
        }

        function onDeceasedNameChange() {
            if (!vm.data.updateModel || !vm.data.updateModel.deceasedPerson || vm.data.updateModel.deceasedPerson.id !== '00000000-0000-0000-0000-000000000000') return;
            if (!vm.data.updateModel.deceasedPerson.lastName || !vm.data.updateModel.deceasedPerson.firstName) return;
            var searchText = vm.data.updateModel.deceasedPerson.lastName;
            if (vm.data.updateModel.deceasedPerson.firstName) {
                if (searchText) {
                    searchText += ', ' + vm.data.updateModel.deceasedPerson.firstName;
                } else {
                    searchText = vm.data.updateModel.deceasedPerson.firstName;
                }
            }

            if (searchText) {
                vm.isSearchingDeceased = true;
                vm.searchResultsDeceased = [];
                quickRegistrationDeceasedService.searchPersons(searchText).then(function (searchResults) {
                    vm.searchResultsDeceased = searchResults;
                    vm.isSearchingDeceased = false;
                });
            }
        }

        function onContactNameChange() {
            if (!vm.data.updateModel || !vm.data.updateModel.contactPerson || vm.data.updateModel.contactPerson.id !== '00000000-0000-0000-0000-000000000000') return;
            if (!vm.data.updateModel.contactPerson.lastName || !vm.data.updateModel.contactPerson.firstName) return;
            var searchText = vm.data.updateModel.contactPerson.lastName;
            if (vm.data.updateModel.contactPerson.firstName) {
                if (searchText) {
                    searchText += ', ' + vm.data.updateModel.contactPerson.firstName;
                } else {
                    searchText = vm.data.updateModel.contactPerson.firstName;
                }
            }

            if (searchText) {
                vm.isSearchingContact = true;
                vm.searchResultsContact = [];
                quickRegistrationDeceasedService.searchPersons(searchText).then(function (searchResults) {
                    vm.searchResultsContact = searchResults;
                    vm.isSearchingContact = false;
                });
            }
        }

        function useExistingContact(person) {
            vm.selectedContactParty = null;
            vm.searchResultsContact = [];
            var promises = [];
            promises.push(quickRegistrationDeceasedService.getPersonById(person.id));
            promises.push(quickRegistrationDeceasedService.getTelephones(person.id));
            promises.push(quickRegistrationDeceasedService.getEmails(person.id));
            $q.all(promises).then(function (result) {
                vm.data.updateModel.contactPerson = result[0];
                vm.data.updateModel.contactTelephones = result[1];
                vm.data.updateModel.contactEmails = result[2];

                if (vm.data.updateModel.contactTelephones && vm.data.updateModel.contactTelephones.length > 0) {
                    vm.data.updateModel.contactTelephones[0].changeState = 2;
                }
                if (vm.data.updateModel.contactEmails && vm.data.updateModel.contactEmails.length > 0) {
                    vm.data.updateModel.contactEmails[0].changeState = 2;
                }
            });
        }

        function useExistingDeceased(person) {
            vm.selectedDeceasedParty = null;
            vm.searchResultsDeceased = null;
            var promises = [];
            promises.push(quickRegistrationDeceasedService.getPersonById(person.id));
            promises.push(quickRegistrationDeceasedService.getAddresses(person.id));

            $q.all(promises).then(function (result) {
                vm.data.updateModel.deceasedPerson = result[0];
                vm.data.updateModel.deceasedAddresses = result[1];
            });
        }

        function selectDeceasedPerson(person) {
            if (person) {
                if (vm.selectedDeceasedParty && person.id === vm.selectedDeceasedParty.id) {
                    vm.selectedDeceasedParty = null;
                } else {
                    vm.selectedDeceasedParty = person;
                }
            }
        }

        function selectContactPerson(person) {
            if (person) {
                if (vm.selectedContactParty && person.id === vm.selectedContactParty.id) {
                    vm.selectedContactParty = null;
                } else {
                    vm.selectedContactParty = person;
                }
            }
        }

        function isDeceasedDisabled() {
            return vm.data.updateModel && vm.data.updateModel.deceasedPerson && vm.data.updateModel.deceasedPerson.id && vm.data.updateModel.deceasedPerson.id !== '00000000-0000-0000-0000-000000000000';
        }

        function isContactDisabled() {
            return vm.data.updateModel && vm.data.updateModel.contactPerson && vm.data.updateModel.contactPerson.id && vm.data.updateModel.contactPerson.id !== '00000000-0000-0000-0000-000000000000';
        }
    }

    angular
        .module('app.workOrder')
        .controller('QuickRegistrationDeceasedToolbarController', QuickRegistrationDeceasedToolbarController);

    /* @ngInject */
    function QuickRegistrationDeceasedToolbarController($window, loadingService, quickRegistrationDeceasedService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = quickRegistrationDeceasedService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            quickRegistrationDeceasedService.insertData().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                // Something went wrong... What do?
            });
        }

    }

    angular
        .module('app.workOrder')
        .controller('QuickRegistrationDeceasedSidebarController', QuickRegistrationDeceasedSidebarController);

    /* @ngInject */
    function QuickRegistrationDeceasedSidebarController($window, loadingService, quickRegistrationDeceasedService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = quickRegistrationDeceasedService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            quickRegistrationDeceasedService.insertData().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                // Something went wrong... What do?
            });
        }

    }

} ());
(function() {
    'use strict';

    angular
        .module('app.workOrder')
        .filter('noteOrTaskInTab', noteOrTaskInTab);
        
    /* @ngInject */
    function noteOrTaskInTab() {
        return noteOrTaskInTabFilter;

        ////////////////

        function noteOrTaskInTabFilter(noteOrTasks, tabName) {
            return noteOrTasks.filter(function(noteOrTask) {
                
                if (noteOrTask.tab && noteOrTask.tab === tabName) {
                    return noteOrTask;
                }                       
            });
        }
    }
})();
(function() {
  "use strict";

  angular.module("app.workOrder").controller("WorkOrderDashboardController", WorkOrderDashboardController);

  /* @ngInject */
  function WorkOrderDashboardController(
    $filter,
    $mdDialog,
    $document,
    $state,
    $mdSidenav,
    workOrderTypes,
    departments,
    workOrderDashboardViewService,
    fuseTheming
  ) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.currentDate = moment($state.params.date, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss");
    vm.currentWeek = moment($state.params.date, "YYYY-MM-DD").format("W");
    vm.getCurrentWeekRange = getCurrentWeekRange;

    vm.currentData = workOrderDashboardViewService;

    vm.currentData.workOrderTypes = workOrderTypes;
    vm.currentData.departments = departments;
    vm.toggleSidenav = toggleSidenav;

    vm.selectWorkOrderType = selectWorkOrderType;
    vm.selectDepartment = selectDepartment;

    vm.getForegroundColor = getForegroundColor;
    vm.showAddWorkOrderDialog = showAddWorkOrderDialog;

    // INIT
    activate();

    function activate() {
      workOrderDashboardViewService.getWeekData(vm.currentDate, vm.amountLatest).then(function(weekData) {
        vm.weekData = weekData;
        vm.isLoadingWorkOrders = false;
      });
    }

    function getForegroundColor(color) {
      var colors = tinycolor(color).monochromatic();

      colors.map(function(t) {
        return t.toHexString();
      }); // [ "#ff0000", "#2a0000", "#550000", "#800000", "#aa0000", "#d40000" ]
      return tinycolor.mostReadable(color, ["#fff", colors[3]]).toHexString();
    }

    function getCurrentWeekRange() {
      var startDate = moment(vm.currentDate)
        .startOf("isoWeek")
        .format("YYYY-MM-DDTHH:mm:ss");
      var endDate = moment(vm.currentDate)
        .endOf("isoWeek")
        .format("YYYY-MM-DDTHH:mm:ss");

      return $filter("date")(startDate, "fullDate") + " - " + $filter("date")(endDate, "fullDate");
    }

    function showAddWorkOrderDialog(e) {
      $mdDialog
        .show({
          controller: "AddWorkOrderDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/work-order/dialogs/add-work-order-dialog/add-work-order-dialog.tmpl.html",
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            event: e,
            workOrderTypeId: vm.currentData.selectedWorkOrderType ? vm.currentData.selectedWorkOrderType.id : null,
            departmentId: vm.currentData.selectedDepartment ? vm.currentData.selectedDepartment.id : null
          }
        })
        .then(function(addedWorkOrder) {
          if (addedWorkOrder) {
          }
        });
    }

    function selectWorkOrderType(workOrderType) {
      // if already selected - don't do anything
      if (vm.currentData.selectedWorkOrderType == workOrderType) {
        return;
      } else {
        vm.currentData.searchTerm = "";
        $state.go(
          $state.current,
          {
            date: $state.params.date,
            latestAmount: $state.params.latestAmount,
            workOrderTypeId: workOrderType ? workOrderType.id : null,
            departmentId: $state.params.departmentId
          },
          { reload: false }
        );
      }
    }

    function selectDepartment(department) {
      // if already selected - don't do anything
      if (vm.currentData.selectedDepartment == department) {
        return;
      } else {
        vm.currentData.searchTerm = "";
        $state.go(
          $state.current,
          {
            date: $state.params.date,
            latestAmount: $state.params.latestAmount,
            workOrderTypeId: $state.params.workOrderTypeId,
            departmentId: department ? department.id : null
          },
          { reload: false }
        );
      }
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.workOrder').factory('workOrderDashboardViewService', workOrderDashboardViewService);

    /* @ngInject */
    function workOrderDashboardViewService($q, $filter, workOrderService) {
        var extractedData = {
            events: null,
            eventTypes: null,
            recentWorkOrders: null,
        };
        var service = {
            getWeekData: getWeekData,
            currentWeekData: null,
            selectedWorkOrderType: null,
            selectedDepartment: null,
            searchTerm: null,
            workOrders: [],
            departments: [],
        };

        return service;

        function getWeekData(dateInWeek, amountLatest) {
            var startMoment = moment(dateInWeek).startOf('isoWeek');
            var endMoment = moment(dateInWeek).endOf('isoWeek');

            amountLatest = amountLatest || 10;

            var promises = [];
            // promises.push(
            //   workOrderService.getByEventDates(
            //     startMoment.format("YYYY-MM-DDTHH:mm:ss"),
            //     endMoment.format("YYYY-MM-DDTHH:mm:ss")
            //   )
            // );
            // promises.push(workOrderService.getLatest(amountLatest));
            promises.push($q.when([]));
            promises.push($q.when([]));

            return $q.all(promises).then(function (returnData) {
                var workOrdersInWeek = returnData[0];
                var latestWorkOrders = returnData[1];
                //extract events
                extractedData.events = extractEvents(workOrdersInWeek);
                extractedData.eventTypes = createEventTypeGroups(extractedData.events);
                extractedData.recentWorkOrders = latestWorkOrders;
                return extractedData;
            });
        }

        function extractEvents(workOrders) {
            var events = [];
            //return empty array if we don't have any workOrders
            if (!workOrders || workOrders.length === 0) return events;

            for (var i = 0, len = workOrders.length; i < len; i++) {
                if (workOrders[i] && workOrders[i].events && workOrders[i].events.length > 0) {
                    events = events.concat(workOrders[i].events);
                }
            }
            return events;
        }

        function createEventTypeGroups(events) {
            var eventTypes = [];
            //return empty array if we don't have any events
            if (!events || events.length === 0) return eventTypes;

            var createdGroups = [];

            for (var i = 0, len = events.length; i < len; i++) {
                if (events[i] && events[i].calendarEventType && createdGroups.indexOf(events[i].calendarEventTypeId) === -1) {
                    eventTypes.push(angular.copy(events[i].calendarEventType));
                    createdGroups.push(events[i].calendarEventTypeId);
                }
            }

            //Put events in groups
            for (var i = 0, len = eventTypes.length; i < len; i++) {
                eventTypes[i].calendarEvents = $filter('inEventGroup')(eventTypes[i], events);
                //Filter by date
                eventTypes[i].dateGroups = createDateGroups(eventTypes[i].calendarEvents);
            }

            return eventTypes;
        }

        function createDateGroups(events) {
            var dateGroups = [];
            //return empty array if we don't have any events
            if (!events || events.length === 0) return dateGroups;

            var createdGroups = [];

            for (var i = 0, len = events.length; i < len; i++) {
                if (events[i] && events[i].start && createdGroups.indexOf(moment(events[i].start).format('YYYY-MM-DD')) === -1) {
                    dateGroups.push({
                        date: moment(events[i].start).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                    });
                    createdGroups.push(moment(events[i].start).format('YYYY-MM-DD'));
                }
            }

            //Put events in groups
            for (var i = 0, len = dateGroups.length; i < len; i++) {
                dateGroups[i].calendarEvents = $filter('atDate')(dateGroups[i].date, events);
            }

            return dateGroups;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.transport').factory('transportService', transportService);

    /* @ngInject */
    function transportService($http, $q, exception, baldrisApiBase) {
        var service = {
            canToggleTransport: canToggleTransport,
            getEmptyTransport: getEmptyTransport,
            toggleTransport: toggleTransport,
        };

        return service;

        function canToggleTransport(transport) {
            return $http
                .get(baldrisApiBase + '/api/CalendarEvents/' + transport.id + '/CanToggle')
                .then(canToggleTransportComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for canToggleTransport')(message);
                });

            function canToggleTransportComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function toggleTransport(transport) {
            return $http
                .put(baldrisApiBase + '/api/CalendarEvents/' + transport.id + '/Toggle')
                .then(toggleTransportComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for toggleTransport')(message);
                });

            function toggleTransportComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyTransport() {
            return {
                subject: null,
                text: null,
                attendanceTime: null,
                start: null,
                end: null,
                isAllDay: false,
                internalType: null,
                internalId: null,
                recurrencePattern: null,
                exceptionAppointments: null,
                attendeesMustRsvp: false,
                remarks: null,
                options: 'none',
                billTo: 'unknown',
                calendarEventTypeId: null,
                isCompleted: false,
                completedTime: null,
                completedById: null,
                workOrderId: null,
                hostId: null,
                reservationId: null,
                locationId: null,
                locationRemarks: null,
                addressId: null,
                addressRemarks: null,
                supplierId: null,
                remarksSupplier: null,
                confirmedById: null,
                confirmedDate: null,
                isConfirmed: false,
                confirmationRemarks: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                distance: null,
                driverHours: null,
                additionalHours: null,
                price: null,
                additionalCost: null,
                priceRemarks: null,
                isTransportTaxed: false,
                transportDescription: null,
                originId: null,
                originRemarks: null,
                originSerialized: null,
                destinationId: null,
                destinationRemarks: null,
                destinationSerialized: null,
                helpersFamily: null,
                helpersFuneralHome: null,
                helpersRemarks: null,
                transportById: null,
                transportBySerialized: null,
                casketEquipmentId: null,
                casketEquipmentSerialized: null,
                noteOnPhysician: null,
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.transport')
        .factory('transportViewService', transportViewService);

    /* @ngInject */
    function transportViewService($q, $filter, dataService) {
        
        var service = {
            getBetweenDates: getBetweenDates            
        };

        return service;
        
        function getBetweenDates(fromDate, toDate) {
            return dataService.getBetweenDates("Transports", fromDate, toDate);
        }
        
        function getDepartments() {
            return dataService.getAll("Departments");
        }
    }
})();
(function() {
  "use strict";

  angular.module("app.transport").controller("TransportLogisticsController", TransportLogisticsController);

  /* @ngInject */
  function TransportLogisticsController($state, $stateParams, transportLogisticsViewService, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.currentDate = moment($stateParams.date, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss");
    vm.fromDate = moment(vm.currentDate)
      .startOf("isoWeek")
      .format("YYYY-MM-DDTHH:mm:ss");
    vm.toDate = moment(vm.currentDate)
      .endOf("isoWeek")
      .format("YYYY-MM-DDTHH:mm:ss");
    vm.showFinishedTransports = false;
    vm.nextWeek = nextWeek;
    vm.previousWeek = previousWeek;

    vm.isLoading = true;
    vm.currentData = transportLogisticsViewService.currentData;

    transportLogisticsViewService.initializeFromDates(vm.fromDate, vm.toDate).then(function(departments) {
      vm.isLoading = false;
    });

    function navigateToDate(date) {
      $state.go($state.current, { date: moment(date).format("YYYY-MM-DD") });
    }

    function nextWeek() {
      vm.isLoading = true;
      vm.currentDate = moment(vm.currentDate)
        .add(1, "weeks")
        .format("YYYY-MM-DDTHH:mm:ss");
      navigateToDate(vm.currentDate);
    }

    function previousWeek() {
      vm.isLoading = true;
      vm.currentDate = moment(vm.currentDate)
        .add(-1, "weeks")
        .format("YYYY-MM-DDTHH:mm:ss");
      navigateToDate(vm.currentDate);
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.transport").service("editTransportService", editTransportService);

  /* @ngInject */
  function editTransportService(
    $q,
    dataService,
    calendarService,
    locationService,
    editCustomFieldService,
    transportService,
    baldrisConfigService,
    deceasedService
  ) {
    var self = this;
    var transportConfigs = null;
    var transportCalculationConfig = {
      isSet: false,
      startAmount: 0,
      distanceAmount: 0,
      minimumAmount: 0,
      hoursAmount: 0,
      additionalHoursAmount: 0
    };

    self.updateModel = null;
    self.isNew = false;
    self.options = calendarService.options;

    self.loadTransport = loadTransport;
    self.saveTransport = saveTransport;
    self.getTransportString = getTransportString;
    self.calculatePrice = calculatePrice;
    self.registerPrice = registerPrice;
    self.onIsCompletedChange = onIsCompletedChange;

    function loadTransport(
      transportId,
      workOrderId,
      deceased,
      calendarEventTypeId,
      calendarEventType,
      selectedDate,
      transportSuggestion
    ) {
      reset();
      if (!transportId || transportId.toLowerCase() === "new") {
        self.isNew = true;
        self.updateModel = {
          calendarEvent: transportService.getEmptyTransport(),
          locationReservation: locationService.getEmptyLocationReservation(),
          customFieldCategories: [],
          calendarEventUsers: [],
          details: [],
          detailsData: [],
          equipment: [],
          participants: [],
          calendarEventDeceased: [],
          deceased: []
        };
        self.updateModel.calendarEvent.workOrderId = workOrderId;

        if (selectedDate) {
          var hour =
            moment()
              .startOf("hour")
              .hour() + 1;
          self.updateModel.calendarEvent.start = moment(selectedDate)
            .hour(hour)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
          self.updateModel.calendarEvent.end = moment(selectedDate)
            .hour(hour + 1)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
        } else {
          var hour =
            moment()
              .startOf("hour")
              .hour() + 1;
          self.updateModel.calendarEvent.start = moment()
            .hour(hour)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
          self.updateModel.calendarEvent.end = moment()
            .hour(hour + 1)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
        }

        if (calendarEventType) {
          self.updateModel.calendarEvent.subject = calendarEventType.name;
        }

        if (transportSuggestion) {
          self.updateModel.calendarEvent.distance = transportSuggestion.distance;
          self.updateModel.calendarEvent.driverHours = transportSuggestion.driverHours;
          self.updateModel.calendarEvent.additionalHours = transportSuggestion.additionalHours;
          self.updateModel.calendarEvent.additionalCost = transportSuggestion.additionalCost;
          self.updateModel.calendarEvent.price = transportSuggestion.totalPrice;
          self.updateModel.calendarEvent.billTo = transportSuggestion.billTo;
          self.updateModel.calendarEvent.options = transportSuggestion.suggestedTransportTypeOptions;
          self.updateModel.calendarEvent.originId = transportSuggestion.departureLocationId;
          self.updateModel.calendarEvent.originRemarks = transportSuggestion.departureLocationRemarks;
          self.updateModel.calendarEvent.destinationId = transportSuggestion.destinationLocationId;
          self.updateModel.calendarEvent.destinationRemarks = transportSuggestion.destinationLocationRemarks;
          self.updateModel.calendarEvent.subject = transportSuggestion.suggestedTransportTypeName;
          self.updateModel.calendarEvent.transportDescription = transportSuggestion.invoiceText;
          registerPrice();
        }

        // Set ChangeStates
        self.updateModel.calendarEvent.changeState = 1;
        self.updateModel.locationReservation.changeState = 1;

        // Add deceased
        if (deceased && deceased.length > 0) {
          for (var i = 0; i < deceased.length; i++) {
            var workOrderDeceased = deceased[i];
            var calendarEventDeceased = calendarService.getEmptyCalendarEventDeceased();
            calendarEventDeceased.changeState = 1;
            calendarEventDeceased.deceasedId = workOrderDeceased.deceasedId;
            calendarEventDeceased.deceasedPersonDisplayName = workOrderDeceased.deceasedPersonDisplayName;
            self.updateModel.calendarEventDeceased.push(calendarEventDeceased);
          }
        }

        // Get CustomFields
        if (calendarEventTypeId) {
          self.updateModel.calendarEvent.calendarEventTypeId = calendarEventTypeId;
          if (calendarEventType) {
            self.updateModel.calendarEvent.calendarEventType = calendarEventType;
            self.updateModel.calendarEvent.options = calendarEventType.options;
          }
          var promises = [];
          promises.push(
            dataService.getByUri(
              "CalendarEventTypes",
              self.updateModel.calendarEvent.calendarEventTypeId + "/GetCustomFields"
            )
          );
          promises.push(baldrisConfigService.getByCategory("Transport"));
          return $q.all(promises).then(function(response) {
            transportConfigs = response[1];
            if (transportSuggestion) {
              calculatePrice();
            }
            return editCustomFieldService.extractCategories(response[0]).then(function(categories) {
              self.customFieldCategories = categories;
              return editCustomFieldService
                .addDataToCategories(self.customFieldCategories, self.updateModel.detailsData)
                .then(function() {
                  return true;
                });
            });
          });
        } else {
          return baldrisConfigService.getByCategory("Transport").then(function(configs) {
            transportConfigs = configs;
            calculatePrice();
            return true;
          });
        }
      } else {
        return dataService.getUpdateModel("Transports", transportId).then(function(updateModel) {
          self.updateModel = updateModel;
          //Ensure calendarEvent
          if (!self.updateModel.calendarEvent) {
            self.updateModel.calendarEvent = calendarService.getEmptyEvent();
            self.updateModel.calendarEvent.changeState = 1;
          }

          var promises = [];
          promises.push(
            dataService.getByUri(
              "CalendarEventTypes",
              self.updateModel.calendarEvent.calendarEventTypeId + "/GetCustomFields"
            )
          );
          promises.push(baldrisConfigService.getByCategory("Transport"));

          return $q.all(promises).then(function(response) {
            transportConfigs = response[1];
            return editCustomFieldService.extractCategories(response[0]).then(function(categories) {
              self.customFieldCategories = categories;
              return editCustomFieldService
                .addDataToCategories(self.customFieldCategories, self.updateModel.detailsData)
                .then(function() {
                  return true;
                });
            });
          });
        });
      }
    }

    function saveTransport() {
      if (self.updateModel.calendarEvent.id === "00000000-0000-0000-0000-000000000000") {
        self.updateModel.calendarEvent.changeState = 1;
      } else {
        self.updateModel.calendarEvent.changeState = 2;
      }

      // Add newly created CustomFieldData to collection
      self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(
        self.updateModel.customFieldCategories
      );

      return dataService.updateFromUpdateModel("Transports", self.updateModel).then(function(savedUpdateModel) {
        self.updateModel = savedUpdateModel;
        self.isNew = false;

        return true;
      });
    }

    function getTransportString() {
      if (!self.updateModel) return null;
      var returnString = "";
      if (self.updateModel.calendarEvent && self.updateModel.calendarEvent.calendarEventType) {
        returnString = self.updateModel.calendarEvent.calendarEventType.name;
      }
      if (self.updateModel.calendarEvent.start) {
        if (returnString) returnString += ", ";
        returnString += moment(self.updateModel.calendarEvent.start).format("LLLL");
      }
      return returnString;
    }

    function calculatePrice() {
      if (self.updateModel.isPriceRegistered) return;
      if (!transportCalculationConfig.isSet) {
        extractCalculationConfig();
      }
      var price = transportCalculationConfig.startAmount;
      if (self.updateModel.calendarEvent.distance) {
        price += self.updateModel.calendarEvent.distance * transportCalculationConfig.distanceAmount;
      }
      if (self.updateModel.calendarEvent.driverHours) {
        price += self.updateModel.calendarEvent.driverHours * transportCalculationConfig.hoursAmount;
      }
      if (self.updateModel.calendarEvent.additionalHours) {
        price += self.updateModel.calendarEvent.additionalHours * transportCalculationConfig.additionalHoursAmount;
      }
      if (self.updateModel.calendarEvent.additionalCost) {
        price += self.updateModel.calendarEvent.additionalCost;
      }
      if (transportCalculationConfig.minimumAmount && price < transportCalculationConfig.minimumAmount) {
        price = transportCalculationConfig.minimumAmount;
      }
      self.updateModel.calendarEvent.price = price;
    }

    function registerPrice() {
      if (self.updateModel.calendarEvent.price) {
        self.updateModel.isPriceRegistered = true;
      } else {
        self.updateModel.isPriceRegistered = false;
      }
    }

    function extractCalculationConfig() {
      var startAmountConfig = getConfigByName("TransportStartAmount");
      if (startAmountConfig && startAmountConfig.dataValueAsString) {
        transportCalculationConfig.startAmount = Number(startAmountConfig.dataValueAsString) || 0;
      }
      var distanceAmountConfig = getConfigByName("TransportDistanceAmount");
      if (distanceAmountConfig && distanceAmountConfig.dataValueAsString) {
        transportCalculationConfig.distanceAmount = Number(distanceAmountConfig.dataValueAsString) || 0;
      }
      var minimumAmountConfig = getConfigByName("TransportMinimalAmount");
      if (minimumAmountConfig && minimumAmountConfig.dataValueAsString) {
        transportCalculationConfig.minimumAmount = Number(minimumAmountConfig.dataValueAsString) || 0;
      }
      var hoursAmountConfig = getConfigByName("TransportHoursAmount");
      if (hoursAmountConfig && hoursAmountConfig.dataValueAsString) {
        transportCalculationConfig.hoursAmount = Number(hoursAmountConfig.dataValueAsString) || 0;
      }
      var additionalHoursAmountConfig = getConfigByName("TransportHoursAmount");
      if (additionalHoursAmountConfig && additionalHoursAmountConfig.dataValueAsString) {
        transportCalculationConfig.additionalHoursAmount = Number(additionalHoursAmountConfig.dataValueAsString) || 0;
      }
      transportCalculationConfig.isSet = true;
    }

    function getConfigByName(name) {
      if (!transportConfigs || transportConfigs.length === 0) return null;
      for (var i = 0; i < transportConfigs.length; i++) {
        var config = transportConfigs[i];
        if (config && config.name === name) {
          return config;
        }
      }
      return null;
    }

    function onIsCompletedChange() {
      if (self.updateModel.calendarEvent.isCompleted) {
        self.updateModel.calendarEvent.completedTime = moment().format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.updateModel.calendarEvent.completedTime = null;
        self.updateModel.calendarEvent.completedBy = null;
        self.updateModel.calendarEvent.completedById = null;
        self.updateModel.calendarEvent.completedByDisplayName = null;
      }
    }

    function reset() {
      self.updateModel = null;
      self.isNew = false;
      transportConfigs = null;
      transportCalculationConfig = {
        isSet: false,
        startAmount: 0,
        distanceAmount: 0,
        minimumAmount: 0,
        hoursAmount: 0,
        additionalHoursAmount: 0
      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('EditTransportController', EditTransportController);

    /* @ngInject */
    function EditTransportController($window, $stateParams, loadingService, editTransportService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editTransportService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editTransportService.loadTransport($stateParams.transportId, $stateParams.workOrderId, $stateParams.deceased, $stateParams.transportTypeId, $stateParams.transportType, $stateParams.selectedDate, $stateParams.transportSuggestion).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editTransportService.saveTransport().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('EditTransportToolbarController', EditTransportToolbarController);

    /* @ngInject */
    function EditTransportToolbarController($window, loadingService, editTransportService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editTransportService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;


        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editTransportService.saveTransport().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.transport')
        .controller('EditTransportSidebarController', EditTransportSidebarController);

    /* @ngInject */
    function EditTransportSidebarController($window, loadingService, editTransportService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editTransportService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;


        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editTransportService.saveTransport().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular.module('app.transactionalMail').factory('transactionalMailService', transactionalMailService);

    /* @ngInject */
    function transactionalMailService($http, $q, exception, $mdDialog, $document, baldrisApiLegacyBase) {
        var baldrisApiBase = baldrisApiLegacyBase;
        var service = {
            showSendEmailDialog: showSendEmailDialog,
            getEmptyTransactionalMail: getEmptyTransactionalMail,
            getEmptyReportAttachment: getEmptyReportAttachment,
            getEmptyEmailRecipient: getEmptyEmailRecipient,
            sendEmail: sendEmail,
        };

        return service;

        function sendEmail(transactionalEmail) {
            return $http
                .post(baldrisApiBase + '/api/Mail/Send', transactionalEmail)
                .then(sendEmailComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for sendEmail at "MailController"')(message);
                    return $q.reject(message);
                });

            function sendEmailComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function showSendEmailDialog(
            e,
            currentUser,
            departmentId,
            reportId,
            parameterName,
            parameterId,
            workOrderId,
            transactionType,
            attachedUrls,
            skipTracking,
            attachedFiles
        ) {
            return $mdDialog.show({
                controller: 'SendEmailDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/transactional-mail/dialogs/send-email-dialog/send-email-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    currentUser: currentUser,
                    departmentId: departmentId,
                    reportId: reportId,
                    parameterName: parameterName,
                    parameterId: parameterId,
                    workOrderId: workOrderId,
                    transactionType: transactionType,
                    attachedUrls: attachedUrls,
                    skipTracking: skipTracking,
                    attachedFiles: attachedFiles,
                },
                clickOutsideToClose: true,
            });
        }

        function getEmptyTransactionalMail() {
            return {
                from: null,
                subject: null,
                to: [],
                cc: [],
                bcc: [],
                bodyText: null,
                bodyTextHtml: null,
                originType: null,
                originId: '00000000-0000-0000-0000-000000000000',
                departmentId: null,
                skipTracking: false,
                attachments: [],
            };
        }

        function getEmptyReportAttachment() {
            return {
                reportId: null,
                parameterName: null,
                parameterId: null,
                additionalParameters: [],
                filename: null,
                password: null,
            };
        }

        function getEmptyEmailRecipient() {
            return {
                email: null,
                name: null,
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.statistics', [

        ]);
})();
(function() {
  "use strict";

  angular.module("app.statistics").service("salesStatisticsService", salesStatisticsService);

  /* @ngInject */
  function salesStatisticsService(monthNamesTranslatable) {
    var self = this;

    self.months = monthNamesTranslatable;
    self.currentDate = new Date();
    self.fromDate = moment()
      .startOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.toDate = moment()
      .endOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.calculationRoute = "ByInvoiceDate";
    self.dataRoute = "PerDepartment";
    self.currentRange = "THIS_MONTH";
    self.selectedYear = moment().year();
    self.selectedMonth = moment().month();

    self.setCurrentMonth = setCurrentMonth;
    self.setLastMonth = setLastMonth;
    self.setCurrentYear = setCurrentYear;
    self.setLastYear = setLastYear;
    self.setYearMonth = setYearMonth;
    self.getYears = getYears;

    function setYearMonth(year, month) {
      if (month === -1) {
        self.fromDate = moment()
          .year(year)
          .startOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .year(year)
          .endOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.fromDate = moment()
          .month(month)
          .year(year)
          .startOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .month(month)
          .year(year)
          .endOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentMonth() {
      self.fromDate = moment()
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastMonth() {
      self.fromDate = moment()
        .add("months", -1)
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("months", -1)
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentYear() {
      self.fromDate = moment()
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastYear() {
      self.fromDate = moment()
        .add("years", -1)
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("years", -1)
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function getYears() {
      var currentYear = moment().year();
      var years = [];
      for (var i = currentYear; i > currentYear - 16; i--) {
        years.push(i);
      }
      return years;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.statistics').controller('SalesStatisticsController', SalesStatisticsController);

    /* @ngInject */
    function SalesStatisticsController($timeout, currentUser, dataLegacyService, salesStatisticsService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.getDataName = getDataName;
        vm.getTotal = getTotal;
        vm.getTotalAmount = getTotalAmount;

        vm.service = salesStatisticsService;
        vm.service.onUpdate = loadStatistics;

        loadStatistics();

        function loadStatistics() {
            $timeout(function () {
                if (vm.service.fromDate && vm.service.toDate) {
                    dataService
                        .getByUri('Statistics', 'Sales/' + salesStatisticsService.calculationRoute + '/' + salesStatisticsService.dataRoute, {
                            startDate: salesStatisticsService.fromDate,
                            endDate: salesStatisticsService.toDate,
                        })
                        .then(function (data) {
                            vm.data = data;
                        });
                }
            });
        }

        function getDataName(dataEntry) {
            if (dataEntry) {
                return dataEntry.productType || dataEntry.productName || dataEntry.departmentName || dataEntry.salesRepresentative || '––';
            }
        }

        function getTotal() {
            if (!vm.data || vm.data.length === 0) return 0;
            return vm.data.reduce(function (sum, dataEntry) {
                return sum + dataEntry.count;
            }, 0);
        }

        function getTotalAmount() {
            if (!vm.data || vm.data.length === 0) return 0;
            return vm.data.reduce(function (sum, dataEntry) {
                return sum + dataEntry.amount;
            }, 0);
        }
    }

    angular.module('app.statistics').controller('SalesStatisticsSidebarController', SalesStatisticsSidebarController);

    /* @ngInject */
    function SalesStatisticsSidebarController($timeout, currentUser, salesStatisticsService, accountService) {
        var vm = this;
        vm.service = salesStatisticsService;
        vm.setNewRange = setNewRange;

        function setNewRange() {
            $timeout(function () {
                if (vm.service.currentRange) {
                    switch (vm.service.currentRange) {
                        case 'THIS_MONTH':
                            vm.service.setCurrentMonth();
                            break;
                        case 'LAST_MONTH':
                            vm.service.setLastMonth();
                            break;
                        case 'THIS_YEAR':
                            vm.service.setCurrentYear();
                            break;
                        case 'LAST_YEAR':
                            vm.service.setLastYear();
                            break;
                    }
                }
            });
        }
    }

    angular.module('app.statistics').controller('SalesStatisticsToolbarController', SalesStatisticsToolbarController);

    /* @ngInject */
    function SalesStatisticsToolbarController(currentUser, salesStatisticsService) {
        var vm = this;
        vm.getTitle = getTitle;

        function getTitle() {
            switch (salesStatisticsService.dataRoute) {
                case 'PerProductType':
                    return 'STATISTICS.SALES.SALES_PER_PRODUCT_TYPE';
                case 'PerProduct':
                    return 'STATISTICS.SALES.SALES_PER_PRODUCT';
                case 'PerDepartment':
                    return 'STATISTICS.SALES.SALES_PER_DEPARTMENT';
                case 'PerSalesRepresentative':
                    return 'STATISTICS.SALES.SALES_PER_SALES_REPRESENTATIVE';
            }
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.statistics").service("deceasedStatisticsService", deceasedStatisticsService);

  /* @ngInject */
  function deceasedStatisticsService(monthNamesTranslatable) {
    var self = this;

    self.months = monthNamesTranslatable;
    self.currentDate = new Date();
    self.fromDate = moment()
      .startOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.toDate = moment()
      .endOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.calculationRoute = "ByCeremonyDate";
    self.dataRoute = "PerMunicipalityOfResidence";
    self.currentRange = "THIS_MONTH";
    self.selectedYear = moment().year();
    self.selectedMonth = moment().month();

    self.setCurrentMonth = setCurrentMonth;
    self.setLastMonth = setLastMonth;
    self.setCurrentYear = setCurrentYear;
    self.setLastYear = setLastYear;
    self.setYearMonth = setYearMonth;
    self.getYears = getYears;

    function setYearMonth(year, month) {
      if (month === -1) {
        self.fromDate = moment()
          .year(year)
          .startOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .year(year)
          .endOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.fromDate = moment()
          .month(month)
          .year(year)
          .startOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .month(month)
          .year(year)
          .endOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentMonth() {
      self.fromDate = moment()
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastMonth() {
      self.fromDate = moment()
        .add("months", -1)
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("months", -1)
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentYear() {
      self.fromDate = moment()
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastYear() {
      self.fromDate = moment()
        .add("years", -1)
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("years", -1)
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function getYears() {
      var currentYear = moment().year();
      var years = [];
      for (var i = currentYear; i > currentYear - 16; i--) {
        years.push(i);
      }
      return years;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.statistics').controller('DeceasedStatisticsController', DeceasedStatisticsController);

    /* @ngInject */
    function DeceasedStatisticsController($timeout, currentUser, dataLegacyService, deceasedStatisticsService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.getDataName = getDataName;
        vm.getTotal = getTotal;

        vm.service = deceasedStatisticsService;
        vm.service.onUpdate = loadStatistics;

        vm.options = {
            chart: {
                type: 'historicalBarChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 65,
                    left: 50,
                },
                x: function (d) {
                    return getDataName(d);
                },
                y: function (d) {
                    return d.count;
                },
                showValues: true,
                valueFormat: function (d) {
                    return d;
                },
                duration: 100,
                xAxis: {
                    axisLabel: 'X Axis',
                    rotateLabels: 30,
                    showMaxMin: false,
                },
                yAxis: {
                    axisLabel: 'Y Axis',
                    axisLabelDistance: -10,
                },
                zoom: {
                    enabled: true,
                    scaleExtent: [1, 10],
                    useFixedDomain: false,
                    useNiceScale: false,
                    horizontalOff: false,
                    verticalOff: true,
                    unzoomEventType: 'dblclick.zoom',
                },
            },
        };

        loadStatistics();

        function loadStatistics() {
            $timeout(function () {
                if (vm.service.fromDate && vm.service.toDate) {
                    dataService
                        .getByUri('Statistics', 'Deceased/' + deceasedStatisticsService.calculationRoute + '/' + deceasedStatisticsService.dataRoute, {
                            startDate: deceasedStatisticsService.fromDate,
                            endDate: deceasedStatisticsService.toDate,
                        })
                        .then(function (data) {
                            vm.data = data;
                        });
                }
            });
        }

        function getDataName(dataEntry) {
            if (dataEntry) {
                return dataEntry.municipalityName || dataEntry.departmentName || '––';
            }
        }

        function getTotal() {
            if (!vm.data || vm.data.length === 0) return 0;
            return vm.data.reduce(function (sum, dataEntry) {
                return sum + dataEntry.count;
            }, 0);
        }
    }

    angular.module('app.statistics').controller('DeceasedStatisticsSidebarController', DeceasedStatisticsSidebarController);

    /* @ngInject */
    function DeceasedStatisticsSidebarController($timeout, currentUser, deceasedStatisticsService) {
        var vm = this;
        vm.service = deceasedStatisticsService;
        vm.setNewRange = setNewRange;

        function setNewRange() {
            $timeout(function () {
                if (vm.service.currentRange) {
                    switch (vm.service.currentRange) {
                        case 'THIS_MONTH':
                            vm.service.setCurrentMonth();
                            break;
                        case 'LAST_MONTH':
                            vm.service.setLastMonth();
                            break;
                        case 'THIS_YEAR':
                            vm.service.setCurrentYear();
                            break;
                        case 'LAST_YEAR':
                            vm.service.setLastYear();
                            break;
                    }
                }
            });
        }
    }

    angular.module('app.statistics').controller('DeceasedStatisticsToolbarController', DeceasedStatisticsToolbarController);

    /* @ngInject */
    function DeceasedStatisticsToolbarController(currentUser, deceasedStatisticsService) {
        var vm = this;
        vm.getTitle = getTitle;

        function getTitle() {
            switch (deceasedStatisticsService.dataRoute) {
                case 'PerMunicipalityOfResidence':
                    return 'STATISTICS.DECEASED.DECEASED_PER_MUNICIPALITY_OF_RESIDENCE';
                case 'PerCeremonyMunicipality':
                    return 'STATISTICS.DECEASED.DECEASED_PER_CEREMONY_MUNICIPALITY';
                case 'PerDepartment':
                    return 'STATISTICS.DECEASED.DECEASED_PER_DEPARTMENT';
            }
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.statistics").service("ceremonyStatisticsService", ceremonyStatisticsService);

  /* @ngInject */
  function ceremonyStatisticsService(monthNamesTranslatable) {
    var self = this;

    self.months = monthNamesTranslatable;
    self.currentDate = new Date();
    self.fromDate = moment()
      .startOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.toDate = moment()
      .endOf("month")
      .format("YYYY-MM-DDTHH:mm:ss");
    self.calculationRoute = "ByCeremonyDate";
    self.dataRoute = "PerCeremonyType";
    self.currentRange = "THIS_MONTH";
    self.selectedYear = moment().year();
    self.selectedMonth = moment().month();

    self.setCurrentMonth = setCurrentMonth;
    self.setLastMonth = setLastMonth;
    self.setCurrentYear = setCurrentYear;
    self.setLastYear = setLastYear;
    self.setYearMonth = setYearMonth;
    self.getYears = getYears;

    function setYearMonth(year, month) {
      if (month === -1) {
        self.fromDate = moment()
          .year(year)
          .startOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .year(year)
          .endOf("year")
          .format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.fromDate = moment()
          .month(month)
          .year(year)
          .startOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
        self.toDate = moment()
          .month(month)
          .year(year)
          .endOf("month")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentMonth() {
      self.fromDate = moment()
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastMonth() {
      self.fromDate = moment()
        .add("months", -1)
        .startOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("months", -1)
        .endOf("month")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = moment(self.fromDate).month();
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setCurrentYear() {
      self.fromDate = moment()
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function setLastYear() {
      self.fromDate = moment()
        .add("years", -1)
        .startOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.toDate = moment()
        .add("years", -1)
        .endOf("year")
        .format("YYYY-MM-DDTHH:mm:ss");
      self.selectedYear = moment(self.fromDate).year();
      self.selectedMonth = -1;
      if (angular.isFunction(self.onUpdate)) {
        self.onUpdate();
      }
    }

    function getYears() {
      var currentYear = moment().year();
      var years = [];
      for (var i = currentYear; i > currentYear - 16; i--) {
        years.push(i);
      }
      return years;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.statistics').controller('CeremonyStatisticsController', CeremonyStatisticsController);

    /* @ngInject */
    function CeremonyStatisticsController($timeout, currentUser, dataLegacyService, ceremonyStatisticsService) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.getDataName = getDataName;
        vm.getTotal = getTotal;

        vm.service = ceremonyStatisticsService;
        vm.service.onUpdate = loadStatistics;

        loadStatistics();

        function loadStatistics() {
            $timeout(function () {
                if (vm.service.fromDate && vm.service.toDate) {
                    dataService
                        .getByUri('Statistics', 'Ceremony/' + ceremonyStatisticsService.calculationRoute + '/' + ceremonyStatisticsService.dataRoute, {
                            startDate: ceremonyStatisticsService.fromDate,
                            endDate: ceremonyStatisticsService.toDate,
                        })
                        .then(function (data) {
                            vm.data = data;
                        });
                }
            });
        }

        function getDataName(dataEntry) {
            if (dataEntry) {
                return dataEntry.locationName || dataEntry.liturgyName || dataEntry.departmentName || dataEntry.ceremonyTypeName || '––';
            }
        }

        function getTotal() {
            if (!vm.data || vm.data.length === 0) return 0;
            return vm.data.reduce(function (sum, dataEntry) {
                return sum + dataEntry.count;
            }, 0);
        }
    }

    angular.module('app.statistics').controller('CeremonyStatisticsSidebarController', CeremonyStatisticsSidebarController);

    /* @ngInject */
    function CeremonyStatisticsSidebarController($timeout, currentUser, ceremonyStatisticsService) {
        var vm = this;
        vm.service = ceremonyStatisticsService;
        vm.setNewRange = setNewRange;

        function setNewRange() {
            $timeout(function () {
                if (vm.service.currentRange) {
                    switch (vm.service.currentRange) {
                        case 'THIS_MONTH':
                            vm.service.setCurrentMonth();
                            break;
                        case 'LAST_MONTH':
                            vm.service.setLastMonth();
                            break;
                        case 'THIS_YEAR':
                            vm.service.setCurrentYear();
                            break;
                        case 'LAST_YEAR':
                            vm.service.setLastYear();
                            break;
                    }
                }
            });
        }
    }

    angular.module('app.statistics').controller('CeremonyStatisticsToolbarController', CeremonyStatisticsToolbarController);

    /* @ngInject */
    function CeremonyStatisticsToolbarController(currentUser, ceremonyStatisticsService) {
        var vm = this;
        vm.getTitle = getTitle;

        function getTitle() {
            switch (ceremonyStatisticsService.dataRoute) {
                case 'PerCeremonyType':
                    return 'STATISTICS.CEREMONY.CEREMONY_PER_CEREMONY_TYPE';
                case 'PerLocation':
                    return 'STATISTICS.CEREMONY.CEREMONY_PER_LOCATION';
                case 'PerDepartment':
                    return 'STATISTICS.CEREMONY.CEREMONY_PER_DEPARTMENT';
                case 'PerLiturgy':
                    return 'STATISTICS.CEREMONY.CEREMONY_PER_LITURGY';
                case 'PerLiturgyAndCeremonyType':
                    return 'STATISTICS.CEREMONY.CEREMONY_PER_LITURGY_AND_CEREMONY_TYPE';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.song')
        .service('songLibraryService', songLibraryService);

    /* @ngInject */
    function songLibraryService($q, $state, dataService, songService) {
        var self = this;
        self.selectedCollection = 'all';
        self.currentSongs = [];

        self.getSongsByCollection = getSongsByCollection;

        function getSongsByCollection(collectionName) {
            self.selectedCollection = collectionName;
            if (!collectionName || collectionName === 'all') {
                return dataService.getAll('Songs').then(function (songs) {
                    self.currentSongs = songs;
                    return self.currentSongs;
                });
            } else {
                return songService.getSongsByCollectionName(collectionName).then(function (songs) {
                    self.currentSongs = songs;
                    return self.currentSongs;
                });
            }
        }
    }

})();


(function() {
  "use strict";

  angular.module("app.song").controller("SongLibraryController", SongLibraryController);

  /* @ngInject */
  function SongLibraryController($state, $filter, $mdSidenav, $mdDialog, songCollectionNames, songLibraryService, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.songCollectionNames = songCollectionNames;
    vm.data = songLibraryService;

    activate();

    function activate() {}

    vm.toggleSidenav = toggleSidenav;
    vm.openPreviewConsentFormDialog = openPreviewConsentFormDialog;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function openPreviewConsentFormDialog(e) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        controller: "PreviewConsentFormDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/privacy/dialogs/preview-consent-form-dialog/preview-consent-form-dialog.tmpl.html",
        parent: parentEl,
        targetEvent: e,
        multiple: true,
        clickOutsideToClose: true
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.song').factory('songService', songService);

    /* @ngInject */
    function songService($http, $q, baldrisLegacyApiBase, exception) {
        var baldrisApiBase = baldrisLegacyApiBase;
        var service = {
            getEmptySong: getEmptySong,
            getEmptySongVerse: getEmptySongVerse,
            getSongCollectionNames: getSongCollectionNames,
            getSongsByCollectionName: getSongsByCollectionName,
        };

        return service;

        function getSongCollectionNames() {
            return $http
                .get(baldrisApiBase + '/api/Songs/GetCollectionNames')
                .then(getSongCollectionNamesComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getSongCollectionNames')(message);
                });

            function getSongCollectionNamesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getSongsByCollectionName(collectionName) {
            return $http
                .get(baldrisApiBase + '/api/Songs/ByCollectionName', {
                    params: {
                        collectionName: collectionName,
                    },
                })
                .then(getSongsByCollectionNameComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getSongsByCollectionNameComplete')(message);
                });

            function getSongsByCollectionNameComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptySong() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.SongDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                title: null,
                originalTitle: null,
                searchTerms: null,
                identifier: null,
                language: null,
                year: 0,
                remarks: null,
                options: 0,
                isDeleted: false,
                textComposer: null,
                composer: null,
                translator: null,
                fromCollection: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getEmptySongVerse() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.SongVerseDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                verseNumber: null,
                text: null,
                sortOrder: null,
                isDeleted: false,
                songId: '00000000-0000-0000-0000-000000000000',
                songTitle: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.song').service('editSongService', editSongService);

    /* @ngInject */
    function editSongService($q, $state, dataLegacyService, songService) {
        var dataService = dataLegacyService;
        var self = this;
        self.updateModel = null;

        self.loadSong = loadSong;
        self.saveSong = saveSong;
        self.addSongVerse = addSongVerse;
        self.onSongVerseChanged = onSongVerseChanged;

        function loadSong(songId) {
            self.updateModel = null;
            if (!songId || songId === 'new') {
                self.updateModel = {
                    song: songService.getEmptySong(),
                    songVerses: [],
                };
                self.updateModel.song.changeState = 1;
                return $q.when(self.updateModel);
            } else {
                return dataService.getUpdateModel('Songs', songId).then(function (updateModel) {
                    self.updateModel = updateModel;
                    return self.updateModel;
                });
            }
        }

        function saveSong() {
            // Set changestate on location to ensure saving
            if (self.updateModel.song.changeState !== 1) {
                self.updateModel.song.changeState = 2;
            }

            return dataService.updateFromUpdateModel('Songs', self.updateModel).then(function (savedUpdateModel) {
                self.updateModel = savedUpdateModel;
                return self.updateModel;
            });
        }

        function addSongVerse() {
            var songVerse = songService.getEmptySongVerse();
            songVerse.changeState = 1;
            // set sort order
            if (self.updateModel.songVerses && self.updateModel.songVerses.length > 0) {
                songVerse.sortOrder =
                    Math.max.apply(
                        Math,
                        self.updateModel.songVerses.map(function (ev) {
                            return ev.sortOrder || 1;
                        })
                    ) + 1;
            } else {
                songVerse.sortOrder = 0;
            }
            songVerse.verseNumber = '' + songVerse.sortOrder;
            self.updateModel.songVerses.push(songVerse);
        }

        function onSongVerseChanged(songVerse) {
            if (songVerse.changeState !== 1) {
                songVerse.changeState = 2;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.song')
        .controller('EditSongController', EditSongController);

    /* @ngInject */
    function EditSongController($stateParams, $window, $translate, $scope, editSongService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editSongService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editSongService.loadSong($stateParams.songId || 'new').then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            if (vm.data.validation && vm.data.validation.songForm && vm.data.validation.songForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.songForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editSongService.saveSong().then(function () {
                if (vm.data.validation && vm.data.validation.songForm && vm.data.validation.songForm.$dirty) {
                    vm.data.validation.songForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.songForm && vm.data.validation.songForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

    angular
        .module('app.song')
        .controller('EditSongToolbarController', EditSongToolbarController);

    /* @ngInject */
    function EditSongToolbarController(editSongService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editSongService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.songForm && vm.data.validation.songForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.songForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editSongService.saveSong().then(function () {
                if (vm.data.validation && vm.data.validation.songForm && vm.data.validation.songForm.$dirty) {
                    vm.data.validation.songForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.signatureJobs').factory('signatureJobService', signatureJobService);

    /* @ngInject */
    function signatureJobService($http, baldrisApiBase, exception, $q, $translate) {
        var externalServiceAuthenticationToken = null;
        var consignmentsActivated = null;

        var service = {
            createSignatureJobFromReports: createSignatureJobFromReports,
            getSignatureJobsByWorkOrderId: getSignatureJobsByWorkOrderId,
            getAuthenticationStatusWithExternalService: getAuthenticationStatusWithExternalService,
            authenticateWithExternalService: authenticateWithExternalService,
            getExternalServiceAuthenticationToken: getExternalServiceAuthenticationToken,
            setExternalServiceAuthenticationToken: setExternalServiceAuthenticationToken,
            getConsignmentsActivated:getConsignmentsActivated,
            setConsignmentsActivated:setConsignmentsActivated,
            isExternalServiceAuthenticated: isExternalServiceAuthenticated,
            getCreateSignatureJobCommand: getCreateSignatureJobCommand,
            getRelevantSignatureJobsByWorkOrderId: getRelevantSignatureJobsByWorkOrderId,
            getSignatureJobById: getSignatureJobById,
            checkExternalWebhooks: checkExternalWebhooks,
            toggleGetAcceptIsActivated: toggleGetAcceptIsActivated,
            createExternalWebhooks: createExternalWebhooks,
        };

        return service;

        function getSignatureJobById(signatureJobId) {
            return $http
                .get(baldrisApiBase + '/api/SignatureJobs/' + signatureJobId)
                .then(getSignatureJobById)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getgetSignatureJobsByWorkOrderId');
                    return $q.reject(message);
                });

            function getSignatureJobById(data, status, headers, config) {
                return data.data;
            }
        }

        function getSignatureJobsByWorkOrderId(workOrderId) {
            return $http
                .get(baldrisApiBase + '/api/SignatureJobs/ByWorkOrderId/' + workOrderId)
                .then(getgetSignatureJobsByWorkOrderIdComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getgetSignatureJobsByWorkOrderId');
                });

            function getgetSignatureJobsByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getAuthenticationStatusWithExternalService() {
            return $http
                .get(baldrisApiBase + '/api/SignatureJobs/IsAuthenticatedWithExternalService')
                .then(getAuthenticationStatusWithExternalServiceComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for getAuthenticationStatusWithExternalService');
                });

            function getAuthenticationStatusWithExternalServiceComplete(data, status, headers, config) {
                if (data.data.isSuccessful == true) {
                    setExternalServiceAuthenticationToken(data.data.payload);
                } else {
                    setExternalServiceAuthenticationToken(null);
                }
            }
        }

        function authenticateWithExternalService(credentials) {
            var body = {
                userName: credentials.username,
                password: credentials.password,
                persistCredentials: true,
            };

            return $http
                .post(baldrisApiBase + '/api/SignatureJobs/AuthenticateWithExternalService', body)
                .then(authenticateWithExternalServiceComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for authenticateWithExternalService');
                });

            function authenticateWithExternalServiceComplete(data, status, headers, config) {
                if (data.data.isSuccessful == true) {
                    setExternalServiceAuthenticationToken(data.data.payload);
                } else {
                    setExternalServiceAuthenticationToken(null);
                }
            }
        }

        function getRelevantSignatureJobsByWorkOrderId(workOrderId, referencePersonId, overridePseudomization) {
            return $http
                .get(baldrisApiBase + '/api/ReferencePersons/SignatureStatus/ByWorkOrderId/' + workOrderId, {
                    params: {
                        referencePersonId: referencePersonId,
                        overridePseudomization: overridePseudomization,
                    },
                })
                .then(getRelevantSignatureJobsByWorkOrderIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for getRelevantSignatureJobsByWorkOrderId');
                    return $q.reject(message);
                });

            function getRelevantSignatureJobsByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function createSignatureJobFromReports(createCommand) {
            return $http
                .post(baldrisApiBase + '/api/SignatureJobs/FromReports', createCommand)
                .then(createSignatureJobFromReportsComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for createSignatureJobFromReports');
                    return $q.reject(message);
                });

            function createSignatureJobFromReportsComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function checkExternalWebhooks() {
            return $http
                .get(baldrisApiBase + '/api/SignatureJobs/CheckExternalServiceWebHooks')
                .then(checkExternalWebhooksComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for checkExternalWebhooks');
                    return $q.reject(message);
                });

            function checkExternalWebhooksComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function toggleGetAcceptIsActivated() {
            return $http
                .put(baldrisApiBase + '/api/SignatureJobs/ToggleGetAcceptIsEnabled')
                .then(toggleGetAcceptIsActivatedComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for toggleGetAcceptIsActivated');
                    return $q.reject(message);
                });

            function toggleGetAcceptIsActivatedComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function createExternalWebhooks() {
            return $http
                .post(baldrisApiBase + '/api/SignatureJobs/CreateExternalWebHooks')
                .then(createExternalWebhooksComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    }
                    exception.catcher('XHR Failed for createExternalWebhooks');
                    return $q.reject(message);
                });

            function createExternalWebhooksComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getExternalServiceAuthenticationToken() {
            return externalServiceAuthenticationToken;
        }

        function setExternalServiceAuthenticationToken(newToken) {
            externalServiceAuthenticationToken = newToken;
        }

        function getConsignmentsActivated() {
            if (consignmentsActivated) {
                return $q.when(consignmentsActivated);
            } else {
                return $http
                    .get(baldrisApiBase + '/api/Accounts/CurrentTenant')
                    .then(getConsignmentsActivatedComplete)
                    .catch(function (message) {
                        //exception.catcher('XHR Failed for getCurrentUser')(message);
                    });
            }
            
            function getConsignmentsActivatedComplete(data, status, headers, config) {
                consignmentsActivated = data.data && data.data.tenantOptions && data.data.tenantOptions.indexOf('getAcceptIsActivated') > -1;
                return consignmentsActivated;
            }
        }        

        function setConsignmentsActivated(updatedConsignmentsActivated) {
            consignmentsActivated = updatedConsignmentsActivated;
        }

        function isExternalServiceAuthenticated() {
            return externalServiceAuthenticationToken != null;
        }

        function getCreateSignatureJobCommand() {
            return {
                subject: null,
                text: null,
                expirationTime: moment().add('d', 7),
                useAutomaticReminders: false,
                requireInitials: false,
                canForwardSignature: false,
                requireDrawnSignature: false,
                shouldBeSigned: true,
                useSequentialSigning: false,
                workOrderId: null,
                externalToken: null,
                sendAutomatically: true,
                isSelfSigning: false,
                recipients: [],
                additionalDocuments: [],
                reportsToInclude: [],
            };
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.settings").factory("baldrisConfigService", baldrisConfigService);

  /* @ngInject */
  function baldrisConfigService($rootScope, $http, $q, exception, baldrisApiBase, localStorageService) {
    var CACHED_BALDRIS_CONFIG_KEY = "baldrisConfigs.data";

    var baldrisConfigsCache = {
      isSet: false,
      dataTimeStamp: null,
      data: null
    };

    var service = {
      getAll: getAll,
      getByName: getByName,
      getByCategory: getByCategory,
      clearLocalData: clearLocalData,
      invalidateCache: invalidateCache,
      getEmptyBaldrisConfig: getEmptyBaldrisConfig
    };

    //init
    getLocalData();

    return service;

    function getEmptyBaldrisConfig() {
      return {
        $type: "Baldris.Core.Data.Entities.Dto.BaldrisConfigDto, Baldris.Core.Data.Entities",
        id: "00000000-0000-0000-0000-000000000000",
        name: null,
        discriminator: null,
        internalCategory: null,
        sortOrder: 0,
        customFieldDataId: "00000000-0000-0000-0000-000000000000",
        departmentId: null,
        legalUnitId: null,
        workOrderTypeId: null,
        changeState: 0,
        createdBy: null,
        createdAt: null,
        lastModifiedBy: null,
        lastModifiedAt: null
      };
    }

    function getLocalData() {
      var baldrisConfigsData = localStorageService.get(CACHED_BALDRIS_CONFIG_KEY);
      if (baldrisConfigsData) {
        baldrisConfigsCache = baldrisConfigsData;
      }
    }

    function getAll() {
      if (baldrisConfigsCache.isSet) {
        if (getExpiredStatus(baldrisConfigsCache, 1, "days")) {
          //Update if data is old
          updateBaldrisConfigs();
        }
        return $q.when(baldrisConfigsCache.data);
      }
      return $http
        .get(baldrisApiBase + "/api/BaldrisConfigs")
        .then(getAllComplete)
        .catch(function(message) {
          exception.catcher("XHR Failed for getAll")(message);
        });

      function getAllComplete(data, status, headers, config) {
        baldrisConfigsCache.activeUsers = data.data;
        baldrisConfigsCache.isSet = true;
        baldrisConfigsCache.dataTimeStamp = new Date();
        localStorageService.set(CACHED_BALDRIS_CONFIG_KEY, baldrisConfigsCache);
        return baldrisConfigsCache.data;
      }
    }

    function getByCategory(categoryName, forceReload) {
      if (!forceReload && baldrisConfigsCache.isSet) {
        if (getExpiredStatus(baldrisConfigsCache, 1, "hours")) {
          //Update if data is old
          updateBaldrisConfigs();
        }
        return $q.when(extractConfigsByCategory(categoryName));
      } else {
        return updateBaldrisConfigs().then(function() {
          return extractConfigsByCategory(categoryName);
        });
      }
    }

    function getByName(name, forceReload) {
      if (!forceReload && baldrisConfigsCache.isSet) {
        if (getExpiredStatus(baldrisConfigsCache, 1, "hours")) {
          //Update if data is old
          updateBaldrisConfigs();
        }
        return $q.when(extractConfigsByName(name));
      } else {
        return updateBaldrisConfigs().then(function() {
          return extractConfigsByName(name);
        });
      }
    }

    function extractConfigsByCategory(categoryName) {
      var extractedConfigs = [];
      for (var i = 0, len = baldrisConfigsCache.data.length; i < len; i++) {
        if (baldrisConfigsCache.data[i].internalCategory === categoryName) {
          extractedConfigs.push(baldrisConfigsCache.data[i]);
        }
      }
      return extractedConfigs;
    }

    function extractConfigsByName(name) {
      var extractedConfigs = [];
      for (var i = 0, len = baldrisConfigsCache.data.length; i < len; i++) {
        if (baldrisConfigsCache.data[i].name === name) {
          extractedConfigs.push(baldrisConfigsCache.data[i]);
        }
      }
      return extractedConfigs;
    }

    function updateBaldrisConfigs() {
      return $http.get(baldrisApiBase + "/api/BaldrisConfigs").then(function(data, status, headers, config) {
        baldrisConfigsCache.data = data.data;
        baldrisConfigsCache.isSet = true;
        baldrisConfigsCache.dataTimeStamp = new Date();
        localStorageService.set(CACHED_BALDRIS_CONFIG_KEY, baldrisConfigsCache);
      });
    }

    function clearLocalData() {
      return localStorageService.remove(CACHED_BALDRIS_CONFIG_KEY);
    }

    function invalidateCache() {
      clearLocalData();
      baldrisConfigsCache = {
        isSet: false,
        dataTimeStamp: null,
        data: null
      };
    }

    function getExpiredStatus(cache, offset, granularity) {
      if (!cache || !cache.isSet) return true;
      var dataMoment = moment(cache.dataTimeStamp);
      var expiredMoment = moment(cache.dataTimeStamp).add(offset, granularity);
      if (dataMoment.isAfter(expiredMoment)) return true;
      return false;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').factory('salesOrderService', salesOrderService);

    /* @ngInject */
    function salesOrderService($http, $q, exception, baldrisApiBase, $window, commonService) {
        var service = {
            canLockInvoice: canLockInvoice,
            canSendInvoiceToMultiChannel: canSendInvoiceToMultiChannel,
            copyInvoice: copyInvoice,
            createInvoiceProductFromSalesOrderProduct: createInvoiceProductFromSalesOrderProduct,
            createSalesOrderProductFromWorkOrderProduct: createSalesOrderProductFromWorkOrderProduct,
            getEmptyInvoice: getEmptyInvoice,
            getEmptyInvoiceProduct: getEmptyInvoiceProduct,
            getPreviewFile: getPreviewFile,
            getEmptySalesOrder: getEmptySalesOrder,
            getEmptySalesOrderProduct: getEmptySalesOrderProduct,
            getEmptyCustomer: getEmptyCustomer,
            getEmptyFinancialTransaction: getEmptyFinancialTransaction,
            getUpdateOrInsertCustomerByPartyIdCommand: getUpdateOrInsertCustomerByPartyIdCommand,
            lockInvoice: lockInvoice,
            getInvoiceJournalFile: getInvoiceJournalFile,
            sendInvoiceToMultiChannel: sendInvoiceToMultiChannel,
        };

        return service;

        function lockInvoice(invoice) {
            return $http
                .put(baldrisApiBase + '/api/Invoices/' + invoice.id + '/Lock')
                .then(lockInvoiceComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for lockInvoice at "Invoices"')(message);
                    return $q.reject(message);
                });

            function lockInvoiceComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function canSendInvoiceToMultiChannel(invoiceId) {
            return $http.get(baldrisApiBase + '/api/Invoices/CanSendInvoice/' + invoiceId).then(function (response, status, headers, config) {
                return response.data;
            });
        }

        function canLockInvoice(invoiceId) {
            return $http.get(baldrisApiBase + '/api/Invoices/CanLockInvoice/' + invoiceId).then(function (response, status, headers, config) {
                return response.data;
            });
        }

        function sendInvoiceToMultiChannel(invoiceUpdateModel) {
            return $http.post(baldrisApiBase + '/api/Invoices/MultiChannel/' + invoiceUpdateModel.invoice.id, invoiceUpdateModel).then(function (response) {
                return response.data;
            });
        }

        function copyInvoice(invoiceId, copyAsCreditNote) {
            if (copyAsCreditNote) {
                return $http.post(baldrisApiBase + '/api/Invoices/CreditInvoice/' + invoiceId).then(function (response) {
                    return response.data;
                });
            }
            return $http.post(baldrisApiBase + '/api/Invoices/CopyInvoice/' + invoiceId).then(function (response) {
                return response.data;
            });
        }

        function getPreviewFile(controllerName, id) {
            return $http({
                url: baldrisApiBase + '/api/' + controllerName + '/GetExportedFile/' + id,
                method: 'GET',
                params: {},
                headers: {
                    'Content-type': 'application/pdf',
                },
                responseType: 'arraybuffer',
            })
                .then(function (data, status, headers, config) {
                    // TODO when WS success
                    var file = new Blob([data], {
                        type: 'application/pdf',
                    });
                    //trick to download store a file having its URL
                    var fileURL = URL.createObjectURL(file);
                    //return $window.open(fileURL, '_blank');
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'preview_file.pdf';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    return true;
                })
                .catch(function (data, status, headers, config) {
                    //TODO when WS error
                    exception.catcher('XHR Failed for getPreviewFile at "Invoices"')(message);
                });
        }

        function getInvoiceJournalFile(startDate, endDate, excludeAlreadyExported, journalFormat, extension, encoding) {
            return $http({
                url: baldrisApiBase + '/api/Invoices/JournalFile/BetweenDates',
                method: 'GET',
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    excludeAlreadyExported: excludeAlreadyExported,
                    journalFormat: journalFormat,
                    encoding: encoding,
                },
                headers: {
                    'Content-type': 'application/octet-stream',
                },
                responseType: 'arraybuffer',
            })
                .then(function (data, status, headers, config) {
                    var octetStreamMime = 'application/octet-stream';
                    var success = false;

                    // Get the headers
                    data.headers = data.headers();

                    // Get the filename from the x-filename header or default to "download.bin"
                    var filename =
                        data.headers['x-filename'] ||
                        'invoice journal ' + moment(startDate).format('YYYY-MM-DD') + '___' + moment(endDate).format('YYYY-MM-DD') + '.' + (extension || 'csv');

                    // Determine the content type from the header or default to "application/octet-stream"
                    var contentType = data.headers['content-type'] || octetStreamMime;

                    try {
                        // Try using msSaveBlob if supported
                        console.log('Trying saveBlob method ...');
                        var blob = new Blob([data], { type: contentType });
                        if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
                        else {
                            // Try using other saveBlob implementations, if available
                            var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                            if (saveBlob === undefined) throw 'Not supported';
                            saveBlob(blob, filename);
                        }
                        console.log('saveBlob succeeded');
                        success = true;
                    } catch (ex) {
                        console.log('saveBlob method failed with the following exception:');
                        console.log(ex);
                    }

                    if (!success) {
                        // Get the blob url creator
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            // Try to use a download link
                            var link = document.createElement('a');
                            if ('download' in link) {
                                // Try to simulate a click
                                try {
                                    // Prepare a blob URL
                                    console.log('Trying download link method with simulated click ...');
                                    var blob = new Blob([data.data], { type: contentType });
                                    var url = urlCreator.createObjectURL(blob);
                                    link.setAttribute('href', url);

                                    // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                                    link.setAttribute('download', filename);

                                    // Simulate clicking the download link
                                    var event = document.createEvent('MouseEvents');
                                    event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                                    link.dispatchEvent(event);
                                    console.log('Download link method with simulated click succeeded');
                                    success = true;
                                } catch (ex) {
                                    console.log('Download link method with simulated click failed with the following exception:');
                                    console.log(ex);
                                }
                            }

                            if (!success) {
                                // Fallback to window.location method
                                try {
                                    // Prepare a blob URL
                                    // Use application/octet-stream when using window.location to force download
                                    console.log('Trying download link method with window.location ...');
                                    var blob = new Blob([data.data], { type: octetStreamMime });
                                    var url = urlCreator.createObjectURL(blob);
                                    window.location = url;
                                    console.log('Download link method with window.location succeeded');
                                    success = true;
                                } catch (ex) {
                                    console.log('Download link method with window.location failed with the following exception:');
                                    console.log(ex);
                                }
                            }
                            return true;
                        }
                    }
                })
                .catch(function (data, status, headers, config) {
                    //TODO when WS error
                    exception.catcher('XHR Failed for getInvoiceJournalFile at "Invoices"')(data);
                });
        }

        function getEmptyInvoiceProduct() {
            return {
                modelType: 'InvoiceProduct',
                sortOrder: 0,
                remarks: null,
                invoiceId: '00000000-0000-0000-0000-000000000000',
                productCode: null,
                productName: null,
                productAmount: 0,
                productCost: null,
                productPrice: 0,
                productDiscount: 0,
                productVatAmount: 0,
                productTotalPrice: 0,
                productVatRate: 0,
                productBalanceAccount: null,
                productId: null,
                balanceAccountId: null,
                vatId: null,
                text: null,
                color: null,
                backgroundColor: null,
                changeState: 1,
            };
        }

        function getEmptyFinancialTransaction() {
            return {
                transactionDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                amount: 0,
                details: null,
                remarks: 0,
                financialTransactionTypeId: null,
                invoiceId: '00000000-0000-0000-0000-000000000000',
                customerId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function getUpdateOrInsertCustomerByPartyIdCommand() {
            return {
                partyId: '00000000-0000-0000-0000-000000000000',
                customerForDepartmentId: '00000000-0000-0000-0000-000000000000',
                billingAddressId: null,
            };
        }

        function getEmptySalesOrderProduct() {
            return {
                modelType: 'SalesOrderProduct',
                sortOrder: 0,
                remarks: null,
                salesOrderId: '00000000-0000-0000-0000-000000000000',
                productCode: null,
                productName: null,
                productAmount: 0,
                productCost: null,
                productPrice: 0,
                productDiscount: 0,
                productVatAmount: 0,
                productTotalPrice: 0,
                productVatRate: 0,
                productBalanceAccount: null,
                productId: null,
                balanceAccountId: null,
                vatId: null,
                workOrderProductId: null,
                text: null,
                color: null,
                backgroundColor: null,
            };
        }

        function createSalesOrderProductFromWorkOrderProduct(workOrderProduct) {
            var salesOrderProduct = getEmptySalesOrderProduct();
            salesOrderProduct.productCode = workOrderProduct.productCode;
            salesOrderProduct.productName = workOrderProduct.overriddenName || workOrderProduct.productName;
            salesOrderProduct.productAmount = workOrderProduct.amount || 0;
            salesOrderProduct.productPrice = workOrderProduct.overriddenPrice || workOrderProduct.productPrice || 0;
            salesOrderProduct.productVatRate = workOrderProduct.productVatRate || 0;
            salesOrderProduct.productBalanceAccount = workOrderProduct.productBalanceAccount;
            salesOrderProduct.productId = workOrderProduct.productId;
            salesOrderProduct.balanceAccountId = workOrderProduct.productBalanceAccountId;
            salesOrderProduct.vatId = workOrderProduct.productVatId;
            salesOrderProduct.workOrderProductId = workOrderProduct.id;
            salesOrderProduct.workOrderProduct = workOrderProduct;
            salesOrderProduct.sortOrder = workOrderProduct.productDefaultSortOrder;
            salesOrderProduct.productVatAmount = commonService.priceFunctions.getVatAmount(salesOrderProduct.productVatRate, salesOrderProduct.productPrice);
            salesOrderProduct.productTotalPrice = salesOrderProduct.productVatAmount + salesOrderProduct.productPrice;
            return salesOrderProduct;
        }

        function getEmptyInvoice() {
            return {
                subject: null,
                details: null,
                info: null,
                remarks: null,
                ourReference: null,
                yourReference: null,
                invoiceDate: null,
                dueDate: null,
                terms: null,
                isReminder: false,
                isCreditNote: false,
                reportId: null,
                salesOrderId: '00000000-0000-0000-0000-000000000000',
                salesRepresentativeId: null,
                parentInvoiceId: null,
                customerId: null,
            };
        }

        function getEmptySalesOrder() {
            return {
                subject: null,
                details: null,
                info: null,
                remarks: null,
                validThrough: null,
                reportId: null,
                workOrderId: null,
                departmentId: '00000000-0000-0000-0000-000000000000',
                salesRepresentativeId: null,
                customerId: null,
                orderTypeId: null,
            };
        }

        function getEmptyCustomer() {
            return {
                isReturningCustomer: false,
                isSocialServicesRepresentative: false,
                isDeleted: false,
                customerForDepartmentId: '00000000-0000-0000-0000-000000000000',
                partyId: '00000000-0000-0000-0000-000000000000',
                billingAddressId: null,
                customerTypeId: null,
            };
        }

        function createInvoiceProductFromSalesOrderProduct(salesOrderProduct) {
            var invoiceProduct = getEmptyInvoiceProduct();
            invoiceProduct.modelType = 'InvoiceProduct';
            invoiceProduct.productCode = salesOrderProduct.productCode;
            invoiceProduct.productName = salesOrderProduct.productName;
            invoiceProduct.productAmount = salesOrderProduct.productAmount;
            invoiceProduct.productPrice = salesOrderProduct.productPrice;
            invoiceProduct.productCost = salesOrderProduct.productCost;
            invoiceProduct.productDiscount = salesOrderProduct.productDiscount;
            invoiceProduct.productVatAmount = salesOrderProduct.productVatAmount;
            invoiceProduct.productTotalPrice = salesOrderProduct.productTotalPrice;
            invoiceProduct.productVatRate = salesOrderProduct.productVatRate;
            invoiceProduct.productBalanceAccount = salesOrderProduct.productBalanceAccount;
            invoiceProduct.productId = salesOrderProduct.productId;
            invoiceProduct.balanceAccountId = salesOrderProduct.balanceAccountId;
            invoiceProduct.vatId = salesOrderProduct.vatId;
            invoiceProduct.sortOrder = salesOrderProduct.sortOrder;
            invoiceProduct.remarks = salesOrderProduct.remarks;
            invoiceProduct.text = salesOrderProduct.text;
            invoiceProduct.color = salesOrderProduct.color;
            invoiceProduct.backgroundColor = salesOrderProduct.backgroundColor;
            return invoiceProduct;
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.salesOrder').factory('salesOrderAttachmentService', salesOrderAttachmentService);

  /* @ngInject */
  function salesOrderAttachmentService($mdDialog, dataService) {
    var service = {
      addSalesOrderAttachment: addSalesOrderAttachment,
      deleteSalesOrderAttachment: deleteSalesOrderAttachment,
      getEmptySalesOrderAttachment: getEmptySalesOrderAttachment,
      updateSalesOrderAttachment: updateSalesOrderAttachment,
      openEditSalesOrderAttachmentDialog: openEditSalesOrderAttachmentDialog,
    };

    return service;

    function getEmptySalesOrderAttachment() {
      return {
        $type: 'Baldris.Core.Data.Entities.Dto.SalesOrderAttachmentDto, Baldris.Core.Data.Entities',
        id: '00000000-0000-0000-0000-000000000000',
        remarks: null,
        sortOrder: 0,
        sendWithInvoice: false,
        fileId: '00000000-0000-0000-0000-000000000000',
        filePath: null,
        fileName: null,
        fileContentType: null,
        salesOrderId: '00000000-0000-0000-0000-000000000000',
        salesOrderSubject: null,
        changeState: 0,
        createdBy: null,
        createdAt: null,
        lastModifiedBy: null,
        lastModifiedAt: null,
      };
    }

    function openEditSalesOrderAttachmentDialog(attachment, salesOrderId, event) {
      if (!attachment) {
        attachment = getEmptySalesOrderAttachment();
        attachment.changeState = 1;
        attachment.sendWithInvoice = true;
      } else {
        attachment.changeState = 2;
      }
      if (salesOrderId) {
        attachment.salesOrderId = salesOrderId;
      }
      return $mdDialog.show({
        controller: 'EditSalesOrderAttachmentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/sales-order/dialogs/edit-sales-order-attachment-dialog/edit-sales-order-attachment-dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: event,
        locals: {
          salesOrderAttachment: attachment,
        },
      });
    }

    function addSalesOrderAttachment(salesOrderAttachment) {
      salesOrderAttachment.changeState = 1;
      return dataService.insertItem('SalesOrderAttachments', salesOrderAttachment);
    }

    function deleteSalesOrderAttachment(salesOrderAttachment) {
      salesOrderAttachment.changeState = 3;
      return dataService.deleteItem('SalesOrderAttachments', salesOrderAttachment);
    }

    function updateSalesOrderAttachment(salesOrderAttachment) {
      salesOrderAttachment.changeState = 2;
      return dataService.updateItem('SalesOrderAttachments', salesOrderAttachment);
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").factory("salesOrderRecentInvoicesService", salesOrderRecentInvoicesService);

  /* @ngInject */
  function salesOrderRecentInvoicesService(dataService) {
    var service = {
      getLatestInvoices: getLatestInvoices,
      getLatestInvoicesByUri: getLatestInvoicesByUri,
      getLatestPaginated: getLatestPaginated
    };

    return service;

    function getLatestPaginated(pageSize, pageIndex, sortField, searchString) {
      return dataService.getPaginatedItems("Invoices", pageSize, pageIndex, null, false, sortField, searchString);
    }

    function getLatestInvoices(amount) {
      return dataService.getLatest("Invoices", amount);
    }

    function getLatestInvoicesByUri(uri) {
      return dataService.getByUri("Invoices", uri);
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("SalesOrderRecentInvoicesController", SalesOrderRecentInvoicesController);

  /* @ngInject */
  function SalesOrderRecentInvoicesController(
    $state,
    $stateParams,
    $mdDialog,
    invoiceTitle,
    recentUri,
    salesOrderRecentInvoicesService,
    baldrisApiBase,
    fuseTheming
  ) {
    var vm = this;

    // Properties
    vm.isLoadingLatestSalesOrders = true;
    vm.invoiceTitle = invoiceTitle;
    vm.fuseTheming = fuseTheming;
    // Methods
    vm.navigateToSalesOrder = navigateToSalesOrder;
    vm.navigateToInvoice = navigateToInvoice;
    vm.onRecentAmountChange = onRecentAmountChange;
    vm.navigateBackward = navigateBackward;
    vm.navigateForward = navigateForward;
    vm.navigateToFirst = navigateToFirst;
    vm.navigateToLast = navigateToLast;
    vm.getEndPagination = getEndPagination;
    vm.onSearchStringChanged = onSearchStringChanged;
    vm.openMenu = openMenu;
    vm.getPreviewUrl = getPreviewUrl;
    vm.openRegisterTransactionDialog = openRegisterTransactionDialog;

    // Init
    if ($stateParams.recentAmount) {
      vm.showRecentAmount = true;
      vm.recentAmount = localStorage.getItem("recent-invoices:recentAmount") || $stateParams.recentAmount;
      vm.sortField = $stateParams.sortField;
      vm.searchString = $stateParams.searchString;
    }

    activate();

    function activate() {
      if (vm.showRecentAmount) {
        salesOrderRecentInvoicesService
          .getLatestPaginated($stateParams.recentAmount, $stateParams.pageIndex, $stateParams.sortField, $stateParams.searchString)
          .then(function(paginatedData) {
            vm.paginatedData = paginatedData;
            vm.isLoadingLatestSalesOrders = false;
          });
      } else {
        salesOrderRecentInvoicesService.getLatestInvoicesByUri(recentUri).then(function(invoices) {
          vm.paginatedData = {
            count: invoices.length || 0,
            data: invoices,
            pageCount: 0,
            pageIndex: 0,
            pageSize: invoices.length
          };
          vm.isLoadingLatestSalesOrders = false;
        });
      }
    }

    // Functions
    function openMenu($mdMenu, ev) {
      ev.stopPropagation();
      ev.preventDefault();
      $mdMenu.open(ev);
    }

    function openRegisterTransactionDialog(invoice, ev) {
      return $mdDialog
        .show({
          controller: "RegisterTransactionDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/sales-order/dialogs/register-transaction-dialog/register-transaction-dialog.tmpl.html",
          parent: angular.element(document.body),
          targetEvent: ev,
          multiple: true,
          clickOutsideToClose: true,
          locals: {
            invoice: invoice
          }
        })
        .then(function(registeredTransaction) {
          if (registeredTransaction) {
            invoice.totalFinancialTransactions += registeredTransaction.amount;
          }
        });
    }

    function getPreviewUrl(invoice) {
      if (!invoice.id || (!invoice.reportId && !invoice.exportedFileFilepath)) return null;

      return invoice.exportedFileFilepath || baldrisApiBase + "/api/Reports/AsPdf/" + invoice.reportId + "/InvoiceId/" + invoice.id;
    }

    function navigateToSalesOrder(salesOrderId) {
      $state.go("app.salesOrder.details", { salesOrderId: salesOrderId });
    }

    function navigateToInvoice(invoice) {
      $state.go("app.invoice.details", { invoiceId: invoice.id });
    }

    function getEndPagination() {
      return Math.min(vm.paginatedData.pageSize * (vm.paginatedData.pageIndex + 1), vm.paginatedData.count);
    }
    function navigateToFirst() {
      $state.go($state.current, {
        recentAmount: vm.recentAmount,
        pageIndex: 0,
        sortField: vm.sortField,
        searchString: vm.searchString
      });
    }

    function navigateBackward(jumpAmount) {
      var pageIndex = 0;
      if (vm.paginatedData && vm.paginatedData.pageIndex) {
        pageIndex = Math.max(pageIndex, vm.paginatedData.pageIndex - (jumpAmount || 1));
      }
      $state.go($state.current, {
        recentAmount: vm.recentAmount,
        pageIndex: pageIndex,
        sortField: vm.sortField,
        searchString: vm.searchString
      });
    }

    function navigateForward(jumpAmount) {
      var pageIndex = 0;
      if (vm.paginatedData && vm.paginatedData.pageCount) {
        pageIndex = Math.min(vm.paginatedData.pageCount, vm.paginatedData.pageIndex + (jumpAmount || 1));
      }
      $state.go($state.current, {
        recentAmount: vm.recentAmount,
        pageIndex: pageIndex,
        sortField: vm.sortField,
        searchString: vm.searchString
      });
    }

    function navigateToLast() {
      var pageIndex = 0;
      if (vm.paginatedData && vm.paginatedData.pageCount) {
        pageIndex = vm.paginatedData.pageCount;
      }
      $state.go($state.current, {
        recentAmount: vm.recentAmount,
        pageIndex: pageIndex,
        sortField: vm.sortField,
        searchString: vm.searchString
      });
    }

    function onSearchStringChanged() {
      if (vm.searchString !== $stateParams.searchString) {
        $state.go($state.current, {
          recentAmount: vm.recentAmount,
          pageIndex: 0,
          sortField: vm.sortField,
          searchString: vm.searchString
        });
      }
    }

    function onRecentAmountChange() {
      var currentAmount = parseInt(localStorage.getItem("recent-invoices:recentAmount") || $stateParams.recentAmount, 10);
      if (vm.recentAmount && currentAmount && vm.recentAmount !== currentAmount) {
        localStorage.setItem("recent-invoices:recentAmount", vm.recentAmount);
        // Calculate new pageIndex
        var pageIndex = 0;
        if (vm.paginatedData && vm.paginatedData.count) {
          var currentItemIndex = vm.paginatedData.pageIndex * vm.paginatedData.pageSize;
          pageIndex = Math.floor(currentItemIndex / vm.recentAmount);
        }
        $state.go($state.current, {
          recentAmount: vm.recentAmount,
          pageIndex: pageIndex,
          sortField: vm.sortField,
          searchString: vm.searchString
        });
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").service("salesOrderJournalService", salesOrderJournalService);

  /* @ngInject */
  function salesOrderJournalService($q, dataService, salesOrderService) {
    var self = this;
    self.startDate = null;
    self.endDate = null;
    self.excludeExported = false;
    self.journalEntries = [];
    self.journalReports = [];

    self.exportFileTypes = [
      {
        value: "xledger",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.XLEDGER",
        extension: "csv"
      },
      {
        value: "vismaglobal",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.VISMA_GLOBAL",
        extension: "csv"
      },
      {
        value: "mamut",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.MAMUT",
        extension: "csv"
      },
      {
        value: "vismabusiness",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.VISMA_BUSINESS",
        extension: "txt"
      },
      {
        value: "generic",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.GENERIC",
        extension: "csv"
      },
      {
        value: "pdf",
        text: "SALES_ORDERS.INVOICE_JOURNAL.FILE_EXPORT.PDF",
        extension: "pdf"
      }
    ];
    self.selectedExportFileType = "pdf";

    self.encodings = [
      { value: "ASCII", text: "ASCII" },
      { value: "UTF-16 BE", text: "Big Endian Unicode (UTF-16 BE)" },
      { value: "UTF-7", text: "UTF-7" },
      { value: "UTF-8", text: "UTF-8" },
      { value: "UTF-16", text: "Unicode (UTF-16)" },
      { value: "UTF-32", text: "UTF-32" }
    ];
    self.selectedEncoding = "UTF-8";

    self.loadJournalEntries = loadJournalEntries;
    self.downloadJournalFile = downloadJournalFile;
    self.reset = reset;

    function loadJournalEntries() {
      self.journalEntries = [];
      var promises = [];
      promises.push(
        dataService.getByUri("Invoices", "JournalEntries/BetweenDates", {
          startDate: self.startDate,
          endDate: self.endDate,
          excludeAlreadyExported: self.excludeExported
        })
      );
      if (self.journalReports.length === 0) {
        promises.push(dataService.getByConfigName("Reports", "InvoiceJournal"));
      }
      return $q.all(promises).then(function(result) {
        self.journalEntries = result[0] || [];
        if (result.length > 1) {
          self.journalReports = result[1];
        }
      });
    }

    function downloadJournalFile() {
      var extension = "csv";
      for (var index = 0; index < self.exportFileTypes.length; index++) {
        var fileType = self.exportFileTypes[index];
        if (fileType.value === self.selectedExportFileType) {
          extension = fileType.extension;
          break;
        }
      }
      salesOrderService
        .getInvoiceJournalFile(self.startDate, self.endDate, self.excludeExported, self.selectedExportFileType, extension, self.selectedEncoding)
        .then(function() {});
    }

    function reset() {
      self.startDate = null;
      self.endDate = null;
      self.excludeExported = false;
      self.journalEntries = [];
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.salesOrder").controller("SalesOrderJournalController", SalesOrderJournalController);

  /* @ngInject */
  function SalesOrderJournalController($timeout, loadingService, currentUser, baldrisApiBase, salesOrderJournalService, baldrisConfigService, fuseTheming) {
    var vm = this;
    vm.loadingService = loadingService;
    vm.data = salesOrderJournalService;
    vm.baldrisApiBase = baldrisApiBase;
    vm.fuseTheming = fuseTheming;
    vm.onUpdate = onUpdate;

    activate();

    function activate() {
      baldrisConfigService.getByName("InvoiceJournalWriter").then(function(baldrisConfig) {
        if (baldrisConfig && baldrisConfig.length > 0 && baldrisConfig[0].dataValueAsString) {
          salesOrderJournalService.selectedExportFileType = baldrisConfig[0].dataValueAsString.toLowerCase();
        }
      });
      baldrisConfigService.getByName("InvoiceJournalEncoding").then(function(baldrisConfig) {
        if (baldrisConfig && baldrisConfig.length > 0 && baldrisConfig[0].dataValueAsString) {
          salesOrderJournalService.selectedEncoding = baldrisConfig[0].dataValueAsString;
        }
      });
    }

    function onUpdate() {
      $timeout(function() {
        if (vm.data.startDate && vm.data.endDate) {
          vm.loadingService.setLoadingStatus(true);
          salesOrderJournalService.loadJournalEntries().then(function() {
            vm.loadingService.setLoadingStatus(false);
          });
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').service('editSalesOrderService', editSalesOrderService);

    /* @ngInject */
    function editSalesOrderService(
        $q,
        dataService,
        $translate,
        $mdDialog,
        $document,
        loadingService,
        toastService,
        salesOrderService,
        addressService,
        partyService
    ) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;
        self.canDelete = false;

        self.loadSalesOrder = loadSalesOrder;
        self.saveSalesOrder = saveSalesOrder;
        self.editSalesOrderDetails = editSalesOrderDetails;
        self.openChoosePersonDialog = openChoosePersonDialog;
        self.addNewInvoice = addNewInvoice;
        self.getTotalPrice = getTotalPrice;
        self.getTotalPriceIncludingVat = getTotalPriceIncludingVat;
        self.getTotalVat = getTotalVat;
        self.getTotalInvoiced = getTotalInvoiced;
        self.getTotalInvoicedDiff = getTotalInvoicedDiff;
        self.getTotalInvoicedIncludingVat = getTotalInvoicedIncludingVat;
        self.getTotalInvoicedIncludingVatDiff = getTotalInvoicedIncludingVatDiff;
        self.getTotalInvoicedVat = getTotalInvoicedVat;
        self.getTotalInvoicedVatDiff = getTotalInvoicedVatDiff;
        self.getFormattedBillingAddress = getFormattedBillingAddress;
        self.getPriceIncludingVatLineItem = getPriceIncludingVatLineItem;
        self.getTotalPriceIncludingVatLineItem = getTotalPriceIncludingVatLineItem;
        self.deleteSalesOrder = deleteSalesOrder;

        function loadSalesOrder(salesOrderId, workOrder) {
            reset();
            if (!salesOrderId || salesOrderId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    salesOrder: salesOrderService.getEmptySalesOrder(),
                    lineItems: [],
                    customer: {
                        customer: salesOrderService.getEmptyCustomer(),
                        billingAddress: null,
                    },
                };

                // Set ChangeStates
                self.updateModel.salesOrder.changeState = 1;

                var promises = [];
                // Add deceased
                if (workOrder) {
                    self.updateModel.salesOrder.workOrderId = workOrder.id;
                    self.updateModel.salesOrder.departmentId = workOrder.departmentId;

                    // Try get Customer

                    promises.push(dataService.getByUri('SalesOrders', 'SuggestedSubjectTextByWorkOrderId/' + workOrder.id));
                    promises.push(dataService.getByWorkOrderId('WorkOrderReferencePersons', workOrder.id));
                    promises.push(dataService.getByConfigName('Reports', 'SalesOrder'));

                    return $q.all(promises).then(function (result) {
                        self.updateModel.salesOrder.subject = result[0];
                        self.updateModel.salesOrder.reportId = result[2][0].id;
                        self.updateModel.salesOrder.report = result[2][0];
                        var referencePersons = result[1];
                        if (referencePersons && referencePersons.length > 0) {
                            promises = [];
                            for (var i = 0; i < referencePersons.length; i++) {
                                var referencePerson = referencePersons[i];
                                if (referencePerson.referencePersonType & referencePersonTypeOptions.CUSTOMER.value) {
                                    promises.push(dataService.getById('Persons', referencePerson.personId));
                                    promises.push(
                                        dataService.getByUri('Addresses', 'GetDefaultAddressByPartyId/' + referencePerson.personId, {
                                            asDto: true,
                                        })
                                    );
                                    promises.push(dataService.getByUri('Emails', 'GetDefaultEmailByPartyId/' + referencePerson.personId));
                                    promises.push(dataService.getByUri('Telephones', 'GetDefaultTelephoneByPartyId/' + referencePerson.personId));
                                    break;
                                }
                            }
                            if (promises.length > 0) {
                                return $q.all(promises).then(function (innerResult) {
                                    self.updateModel.customer.customer.id = innerResult[0].id;
                                    self.updateModel.customer.customer.partyDisplayName = innerResult[0].displayName;
                                    self.updateModel.customer.customer.changeState = 1;
                                    if (innerResult[1]) {
                                        self.updateModel.customer.customer.billingAddressId = innerResult[1].id;
                                        self.updateModel.customer.billingAddress = innerResult[1];
                                        self.updateModel.customer.billingAddress.changeState = 2;
                                    }
                                    if (innerResult[2]) {
                                        self.customerPrimaryEmail = innerResult[2].emailAddress;
                                    }
                                    if (innerResult[3] && innerResult[3].telephoneNumber) {
                                        if (phoneUtils.isValidNumber(innerResult[3].telephoneNumber, innerResult[3].isoCode2 || 'no')) {
                                            self.customerPrimaryTelephone = phoneUtils.formatInternational(
                                                innerResult[3].telephoneNumber,
                                                innerResult[3].isoCode2 || 'no'
                                            );
                                        }
                                    }
                                });
                            }
                            return self.updateModel;
                        }
                        return self.updateModel;
                    });
                }
            } else {
                var promises = [];

                promises.push(dataService.getById('SalesOrders', salesOrderId));
                promises.push(dataService.getByUri('SalesOrderItems', 'BySalesOrderId/' + salesOrderId));
                promises.push(dataService.getByUri('Invoices', 'BySalesOrderId/' + salesOrderId));
                promises.push(dataService.canDelete('SalesOrders', { id: salesOrderId }));
                promises.push(dataService.getByUri('SalesOrderAttachments', 'BySalesOrderId/' + salesOrderId));
                return $q.all(promises).then(function (result) {
                    self.updateModel = result[0];
                    self.updateModel = {
                        salesOrder: result[0],
                        lineItems: result[1],
                        customer: {
                            customer: null,
                            billingAddress: null,
                        },
                    };
                    self.updateModel.invoices = result[2];
                    self.canDelete = result[3];
                    self.updateModel.attachments = result[4];
                    if (self.updateModel && self.updateModel.salesOrder && self.updateModel.salesOrder.customerId) {
                        return dataService.getById('Customers', self.updateModel.salesOrder.customerId).then(function (innerResult) {
                            self.updateModel.customer.customer = innerResult;
                        });
                    } else if (!self.updateModel.customer) {
                        // Ensure customer updateModel
                        self.updateModel.customer = {
                            customer: salesOrderService.getEmptyCustomer(),
                            billingAddress: null,
                        };
                    }
                    return self.updateModel;
                });
            }
        }

        function saveSalesOrder() {
            // Set changestate on calendarEvent to ensure saving
            if (self.updateModel.salesOrder.changeState !== 1) {
                self.updateModel.salesOrder.changeState = 2;
            }
            var customerPromise;
            if (self.updateModel.customer.customer.changeState === 1) {
                customerPromise = dataService.insertItem('Customers', self.updateModel.customer.customer);
            } else {
                customerPromise = dataService.updateItem('Customers', self.updateModel.customer.customer);
            }

            return customerPromise.then(function (customer) {
                self.updateModel.salesOrder.customerId = customer.id;
                if (self.updateModel.salesOrder.changeState === 1) {
                    return dataService.insertItem('SalesOrders', self.updateModel.salesOrder).then(function (savedSalesOrder) {
                        self.updateModel.salesOrder = savedSalesOrder;
                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.salesOrder.id);
                    });
                } else {
                    return dataService.updateItem('SalesOrders', self.updateModel.salesOrder).then(function (savedSalesOrder) {
                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.salesOrder.id);
                    });
                }
            });
        }

        function saveAdditionalData(salesOrderId) {
            var promises = [];
            promises = promises.concat(dataService.createBulkPromises('SalesOrderAttachments', self.updateModel.attachments, 'salesOrderId', salesOrderId));

            return $q.all(promises).then(function (response) {
                return response;
            });
        }

        /**
         * Get Total Price
         */
        function getTotalPrice() {
            if (!self.updateModel || !self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * lineItem.productPrice;
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced
         */
        function getTotalInvoiced() {
            if (!self.updateModel || !self.updateModel.invoices || self.updateModel.invoices.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.invoices.length; index++) {
                var invoice = self.updateModel.invoices[index];
                if (invoice.isCreditNote) {
                    totalSum -= invoice.totalSum;
                } else {
                    totalSum += invoice.totalSum;
                }
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced Diff
         */
        function getTotalInvoicedDiff() {
            return getTotalInvoiced() - getTotalPrice();
        }

        /**
         * Get Total Vat
         */
        function getTotalVat() {
            if (!self.updateModel || !self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * lineItem.productVatAmount;
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced Vat
         */
        function getTotalInvoicedVat() {
            if (!self.updateModel || !self.updateModel.invoices || self.updateModel.invoices.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.invoices.length; index++) {
                var invoice = self.updateModel.invoices[index];
                if (invoice.isCreditNote) {
                    totalSum -= invoice.totalVat;
                } else {
                    totalSum += invoice.totalVat;
                }
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced Vat Diff
         */
        function getTotalInvoicedVatDiff() {
            return getTotalInvoicedVat() - getTotalVat();
        }

        /**
         * Get Total Price Including Vat
         */
        function getTotalPriceIncludingVat() {
            if (!self.updateModel || !self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * lineItem.productTotalPrice;
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced Including Vat
         */
        function getTotalInvoicedIncludingVat() {
            if (!self.updateModel || !self.updateModel.invoices || self.updateModel.invoices.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.invoices.length; index++) {
                var invoice = self.updateModel.invoices[index];
                if (invoice.isCreditNote) {
                    totalSum -= invoice.totalSumIncludingVat;
                } else {
                    totalSum += invoice.totalSumIncludingVat;
                }
            }

            return totalSum;
        }

        /**
         * Get Total Invoiced Including Vat Diff
         */
        function getTotalInvoicedIncludingVatDiff() {
            return getTotalInvoicedIncludingVat() - getTotalPriceIncludingVat();
        }

        function getPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            if (!lineItem.productVatRate) {
                return lineItem.productPrice;
            }

            return lineItem.productPrice * (1 + lineItem.productVatRate / 100);
        }

        function getTotalPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            return lineItem.productAmount * lineItem.productTotalPrice;
            // return (lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * (lineItem.productPrice + lineItem.productVatAmount));
        }

        function editSalesOrderDetails(e) {
            var salesOrderCopy = angular.copy(self.updateModel.salesOrder);
            return $mdDialog
                .show({
                    controller: 'EditSalesOrderDetailsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/edit-sales-order-details-dialog/edit-sales-order-details-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        salesOrder: salesOrderCopy,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (editedSalesOrder) {
                    if (editedSalesOrder) {
                        // Add to updateModel
                        self.updateModel.salesOrder = editedSalesOrder;
                        if (
                            self.updateModel.salesOrder.salesRepresentativeId &&
                            self.updateModel.salesOrder.salesRepresentative &&
                            self.updateModel.salesOrder.salesRepresentativeDisplayName !== self.updateModel.salesOrder.salesRepresentative.displayName
                        ) {
                            self.updateModel.salesOrder.salesRepresentativeDisplayName = self.updateModel.salesOrder.salesRepresentative.displayName;
                        }
                        toastService.success($translate.instant('SALES_ORDERS.SALES_ORDER.SALES_ORDER_SAVED'));
                    }
                    return editedSalesOrder;
                });
        }

        function openChoosePersonDialog(e) {
            partyService.showSearchDialog(e, 'Parties', self.updateModel.salesOrder.workOrderId, false, true).then(function (selectedParty) {
                if (selectedParty) {
                    self.updateModel.customer.partyUpdateModel = null;
                    self.updateModel.customer.customer = salesOrderService.getEmptyCustomer();
                    self.updateModel.customer.customer.partyId = selectedParty.id;
                    self.updateModel.customer.customer.displayName = selectedParty.displayName;
                    self.updateModel.customer.customer.changeState = 1;
                    self.updateModel.customer.customer.customerForDepartmentId = self.updateModel.salesOrder.departmentId;
                    self.updateModel.customer.customer.primaryEmail = selectedParty.primaryEmail;
                    self.updateModel.customer.customer.primaryTelephone = selectedParty.primaryTelephone;
                    self.updateModel.customer.customer.primaryTelephone = selectedParty.primaryTelephone;
                    self.updateModel.customer.customer.billingAddress = { localizedAddress: selectedParty.primaryAddress };

                    dataService.getByUri('Addresses', 'GetDefaultAddressByPartyId/' + selectedParty.id).then(function (address) {
                        if (address) {
                            self.updateModel.customer.customer.billingAddressId = address.id;
                            self.updateModel.customer.billingAddress = address;
                            self.updateModel.customer.billingAddress.changeState = 2;
                        } else {
                            self.updateModel.customer.customer.billingAddressId = null;
                            self.updateModel.customer.billingAddress = null;
                        }

                        saveSalesOrder().then(function () {
                            toastService.success($translate.instant('SALES_ORDERS.SALES_ORDER.SALES_ORDER_SAVED'));
                        });
                    });
                }
            });
        }

        function addNewInvoice(e) {
            var unInvoicedItems = [];
            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                if (!lineItem.invoiceProducts || lineItem.invoiceProducts.length === 0) {
                    unInvoicedItems.push(lineItem);
                }
            }
            return $mdDialog
                .show({
                    controller: 'AddInvoiceDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/add-invoice-dialog/add-invoice-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        lineItems: unInvoicedItems,
                        salesOrder: self.updateModel.salesOrder,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (insertedInvoice) {
                    if (insertedInvoice) {
                        // Add to updateModel
                        if (!self.updateModel.invoices) self.updateModel.invoices = [];
                        self.updateModel.invoices.push(insertedInvoice);
                        toastService.success($translate.instant('SALES_ORDERS.INVOICE.INVOICE_SAVED'));
                    }
                    return insertedInvoice;
                });
        }

        function getFormattedBillingAddress() {
            if (!self.updateModel.customer || !self.updateModel.customer.billingAddress) return null;
            return addressService.getFormattedAddress(self.updateModel.customer.billingAddress);
        }

        function deleteSalesOrder(e) {
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('SALES_ORDERS.SALES_ORDER.DELETE_SALES_ORDER_TITLE'))
                .textContent($translate.instant('SALES_ORDERS.SALES_ORDER.DELETE_SALES_ORDER_CONFIRM'))
                .ariaLabel($translate.instant('SALES_ORDERS.SALES_ORDER.DELETE_SALES_ORDER'))
                .targetEvent(e)
                .ok($translate.instant('SALES_ORDERS.SALES_ORDER.DELETE_SALES_ORDER'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            return $mdDialog.show(confirm).then(function () {
                loadingService.setLoadingStatus(true);
                return dataService.deleteItem('SalesOrders', self.updateModel.salesOrder).then(function (deletedSalesOrder) {
                    return deletedSalesOrder;
                });
            });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.customerPrimaryEmail = null;
            self.customerPrimaryTelephone = null;
            self.canDelete = false;
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.salesOrder').controller('EditSalesOrderController', EditSalesOrderController);

  /* @ngInject */
  function EditSalesOrderController(
    $timeout,
    $state,
    $scope,
    $stateParams,
    loadingService,
    $window,
    $filter,
    currentUser,
    salesOrderService,
    editSalesOrderService,
    baldrisApiBase,
    transactionalMailService,
    dataService,
    baldrisConfigService,
    fuseTheming
  ) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.salesOrderService = salesOrderService;
    vm.data = editSalesOrderService;
    vm.loadingService = loadingService;
    vm.selectedIndex = 0;
    vm.trackableEmailsIsAllowed = false;

    // Methods
    vm.goBack = goBack;
    vm.gotoInvoice = gotoInvoice;
    vm.saveAndExitView = saveAndExitView;
    vm.getPreviewUrl = getPreviewUrl;
    vm.deleteSalesOrder = deleteSalesOrder;
    vm.openSendPreviewDialog = openSendPreviewDialog;
    vm.getStatusAction = getStatusAction;
    vm.getStatusColor = getStatusColor;
    vm.getStatusIcon = getStatusIcon;

    // INIT

    activate();

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      editSalesOrderService.loadSalesOrder($stateParams.salesOrderId, $stateParams.workOrder).then(function () {
        vm.loadingService.setLoadingStatus(false);
        if (vm.data.updateModel && vm.data.updateModel.salesOrder) {
          baldrisConfigService.getByName('AllowPaidTrackableEmails').then(function (config) {
            if (config && config[0] && config[0].customFieldDataBoolData) {
              vm.trackableEmailsIsAllowed = true;
              loadReportLogs(vm.data.updateModel.salesOrder);
            }
          });
        }
      });
    }

    /**
     * Go to orders page
     */
    function goBack() {
      $window.history.back();
    }

    /**
     * Go to invoice page
     */
    function gotoInvoice(invoice) {
      $state.go('app.invoice.details', { invoiceId: invoice.id });
    }

    function saveAndExitView() {
      vm.loadingService.setLoadingStatus(true);
      editSalesOrderService.saveSalesOrder().then(function () {
        goBack();
        vm.loadingService.setLoadingStatus(false);
      });
    }

    function deleteSalesOrder(e) {
      editSalesOrderService
        .deleteSalesOrder(e)
        .then(function () {
          goBack();
          vm.loadingService.setLoadingStatus(false);
        })
        .catch(function (message) {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    function getPreviewUrl() {
      if (!vm.data.updateModel || !vm.data.updateModel.salesOrder.id || !vm.data.updateModel.salesOrder.reportId) return null;
      return baldrisApiBase + '/api/Reports/AsPdf/' + vm.data.updateModel.salesOrder.reportId + '/SalesOrderId/' + vm.data.updateModel.salesOrder.id;
    }

    function openSendPreviewDialog(e, skipTracking) {
      var attachedFiles = null;
      if (vm.data.updateModel.attachments && vm.data.updateModel.attachments.length > 0) {
        var includeAttachments = _.filter(vm.data.updateModel.attachments, function (a) {
          return a.sendWithInvoice;
        });
        if (includeAttachments && includeAttachments.length > 0) {
          attachedFiles = includeAttachments.map(function (a) {
            return { filename: a.fileName, filepath: a.filePath, contentType: a.fileContentType };
          });
        }
      }
      transactionalMailService
        .showSendEmailDialog(
          e,
          currentUser,
          vm.data.updateModel.salesOrder.departmentId,
          vm.data.updateModel.salesOrder.reportId,
          'SalesOrderId',
          vm.data.updateModel.salesOrder.id,
          vm.data.updateModel.salesOrder.workOrderId,
          'SalesOrder',
          null,
          skipTracking,
          attachedFiles
        )
        .then(function (result) {
          loadReportLogs();
        });
    }

    function loadReportLogs(salesOrder) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
      salesOrder = salesOrder || vm.data.updateModel.salesOrder;
      vm.isLoadingReportLogs = true;
      vm.reportLogs = null;
      return dataService.getByWorkOrderId('ReportLogs', salesOrder.id).then(function (reportLogs) {
        reportLogs = $filter('orderBy')(reportLogs, 'statusTime', true);
        var groupedReports = _.groupBy(reportLogs, function (value) {
          return value.recipient;
        });
        _.forOwn(groupedReports, function (value, key) {
          value = $filter('orderBy')(value, 'statusTime', true);
        });
        if (!angular.equals(groupedReports, vm.groupedReports)) {
          vm.groupedReports = groupedReports;
        }
        vm.reportLogs = reportLogs;
        vm.isLoadingReportLogs = false;
        // Initialize reloading - 60 seconds
        vm.reloader = $timeout(loadReportLogs, 60000);
        return vm.reportLogs;
      });
    }

    $scope.$on('$destroy', function (p1, p2) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
    });

    function getStatusIcon(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus === 1) return 'icon-printer';
        if (reportLog.reportStatus === 2) return 'icon-send';
        if (reportLog.reportStatus === 4) return 'icon-server-network';
        if (reportLog.reportStatus === 8) return 'icon-email';
        if (reportLog.reportStatus === 16) return 'icon-email-open';
        if (reportLog.reportStatus === 32) return 'icon-close-circle';
        if (reportLog.reportStatus === 64) return 'icon-close-circle';
      }
      return 'icon-help';
    }

    function getStatusColor(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus === 1) return 'amber-300-fg';
        if (reportLog.reportStatus === 2) return 'amber-700-fg';
        if (reportLog.reportStatus === 4) return 'green-100-fg';
        if (reportLog.reportStatus === 8) return 'green-300-fg';
        if (reportLog.reportStatus === 16) return 'green-600-fg';
        if (reportLog.reportStatus === 32) return 'red-500-fg';
        if (reportLog.reportStatus === 64) return 'red-500-fg';
      }
      return null;
    }

    function getStatusAction(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus === 1) return 'WORK_ORDERS.WORK_ORDER.REPORTS.EXPORTED';
        if (reportLog.reportStatus === 2) return 'WORK_ORDERS.WORK_ORDER.REPORTS.SENT';
        if (reportLog.reportStatus === 4) return 'WORK_ORDERS.WORK_ORDER.REPORTS.PROCESSED';
        if (reportLog.reportStatus === 8) return 'WORK_ORDERS.WORK_ORDER.REPORTS.DELIVERED';
        if (reportLog.reportStatus === 16) return 'WORK_ORDERS.WORK_ORDER.REPORTS.OPENED';
        if (reportLog.reportStatus === 32) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BOUNCED';
        if (reportLog.reportStatus === 64) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BLOCKED';
      }
      return null;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').service('editInvoiceService', editInvoiceService);

    /* @ngInject */
    function editInvoiceService(
        $q,
        dataService,
        $translate,
        $filter,
        $mdDialog,
        $document,
        toastService,
        salesOrderService,
        loadingService,
        addressService,
        partyService
    ) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadInvoice = loadInvoice;
        self.saveInvoice = saveInvoice;
        self.getTotalPrice = getTotalPrice;
        self.getTotalPriceIncludingVat = getTotalPriceIncludingVat;
        self.getTotalVat = getTotalVat;
        self.editInvoiceDetails = editInvoiceDetails;
        self.openChoosePersonDialog = openChoosePersonDialog;
        self.lockInvoice = lockInvoice;
        self.getLockedDate = getLockedDate;
        self.getLockedBy = getLockedBy;
        self.createPdf = createPdf;
        self.getFormattedBillingAddress = getFormattedBillingAddress;
        self.getPriceIncludingVatLineItem = getPriceIncludingVatLineItem;
        self.getTotalPriceIncludingVatLineItem = getTotalPriceIncludingVatLineItem;
        self.deleteInvoice = deleteInvoice;

        function loadInvoice(invoiceId, salesOrder) {
            reset();
            if (!invoiceId || invoiceId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    invoice: salesOrderService.getEmptyInvoice(),
                    customer: {
                        customer: salesOrderService.getEmptyCustomer(),
                        billingAddress: null,
                    },
                    lineItems: [],
                    transactions: [],
                    attachments: [],
                };

                // Set ChangeStates
                self.updateModel.invoice.changeState = 1;

                var promises = [];
                // Add deceased
                if (salesOrder) {
                    self.updateModel.invoice.salesOrderId = salesOrder.id;
                    self.updateModel.invoice.customerId = salesOrder.customerId;

                    promises.push(dataService.getByUri('Reports/ByInternalCategory', 'Invoice'));

                    if (self.updateModel.invoice.customerId) {
                        promises.push(dataService.getById('Customers', self.updateModel.invoice.customerId));
                    }

                    return $q.all(promises).then(function (result) {
                        var report = result[0].data ? result[0].data[0] : result[0][0];
                        self.updateModel.invoice.reportId = report.id;
                        self.updateModel.invoice.report = report;
                        if (result.length === 2 && result[1]) {
                            self.updateModel.customer.customer = result[1];
                            promises = [];
                            if (self.updateModel.customer.customer.billingAddressId) {
                                promises.push(dataService.getById('Addresses', self.updateModel.customer.customer.billingAddressId));
                            } else {
                                promises.push(dataService.getByUri('Addresses', 'GetDefaultAddressByPartyId/' + self.updateModel.customer.customer.partyId));
                            }
                            return $q.all(promises).then(function (innerResult) {
                                if (innerResult[0]) {
                                    self.updateModel.customer.customer.billingAddressId = innerResult[0].id;
                                    self.updateModel.customer.billingAddress = innerResult[0];
                                }
                            });
                        }
                        return self.updateModel;
                    });
                }
            } else {
                var promises = [];

                promises.push(dataService.getById('Invoices', invoiceId));
                promises.push(dataService.getByUri('InvoiceItems', 'ByInvoiceId/' + invoiceId));

                return $q.all(promises).then(function (result) {
                    self.updateModel = result[0];
                    self.updateModel = {
                        invoice: result[0],
                        customer: {
                            customer: null,
                            billingAddress: null,
                        },
                        lineItems: result[1],
                        transactions: [],
                        attachments: [],
                    };
                    promises = [];
                    promises.push(dataService.getByUri('SalesOrderAttachments', 'BySalesOrderId/' + self.updateModel.invoice.salesOrderId));
                    if (self.updateModel && self.updateModel.invoice && self.updateModel.invoice.customerId) {
                        promises.push(dataService.getById('Customers', self.updateModel.invoice.customerId));
                    } else if (!self.updateModel.customer) {
                        // Ensure customer updateModel
                        self.updateModel.customer = {
                            customer: salesOrderService.getEmptyCustomer(),
                            billingAddress: null,
                        };
                    }
                    return $q.all(promises).then(function (innerResponse) {
                        self.updateModel.attachments = innerResponse[0];
                        if (innerResponse.length == 2) {
                            self.updateModel.customer.customer = innerResponse[1];
                        }
                        return self.updateModel;
                    });
                });
            }
        }

        function saveInvoice() {
            // Set changestate on calendarEvent to ensure saving
            if (self.updateModel.invoice.changeState !== 1) {
                self.updateModel.invoice.changeState = 2;
            }

            var customerPromise;
            if (self.updateModel.customer.customer.changeState === 1) {
                customerPromise = dataService.insertItem('Customers', self.updateModel.customer.customer);
            } else {
                customerPromise = dataService.updateItem('Customers', self.updateModel.customer.customer);
            }

            return customerPromise.then(function (customer) {
                self.updateModel.invoice.customerId = customer.id;
                if (self.updateModel.invoice.changeState === 1) {
                    return dataService.insertItem('Invoices', self.updateModel.invoice).then(function (savedInvoice) {
                        self.updateModel.invoice = savedInvoice;
                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.invoice.id);
                    });
                } else {
                    return dataService.updateItem('Invoices', self.updateModel.invoice).then(function () {
                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.invoice.id);
                    });
                }
            });
        }

        function saveAdditionalData(salesOrderId) {
            var promises = [];
            promises = promises.concat(dataService.createBulkPromises('SalesOrderAttachments', self.updateModel.attachments, 'salesOrderId', salesOrderId));

            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    toastService.success($translate.instant('SALES_ORDERS.INVOICE.INVOICE_SAVED'));
                    return response;
                });
            } else {
                toastService.success($translate.instant('SALES_ORDERS.INVOICE.INVOICE_SAVED'));
            }
        }

        /**
         * Get the locked date
         */
        function getLockedDate() {
            if (self.updateModel.invoice.isLocked && self.updateModel.invoice.lockedTime) {
                return (
                    $filter('date')(self.updateModel.invoice.lockedTime, 'mediumDate') +
                    ', ' +
                    $filter('date')(self.updateModel.invoice.lockedTime, 'shortTime')
                );
            }
            return '–';
        }

        /**
         * Get the locked by user
         */
        function getLockedBy() {
            if (self.updateModel.invoice.isLocked && self.updateModel.invoice.lockedById) {
                return self.updateModel.invoice.lockedByDisplayName;
            }
            return $translate.instant('ACCOUNTS.UNKNOWN_USER');
        }

        /**
         * Get Total Price
         */
        function getTotalPrice() {
            if (!self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * lineItem.productPrice;
            }

            return totalSum;
        }

        /**
         * Get Total Vat
         */
        function getTotalVat() {
            if (!self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * lineItem.productVatAmount;
            }

            return totalSum;
        }

        /**
         * Get Total Price Including Vat
         */
        function getTotalPriceIncludingVat() {
            if (!self.updateModel.lineItems || self.updateModel.lineItems.length === 0) {
                return 0;
            }

            var totalSum = 0;

            for (var index = 0; index < self.updateModel.lineItems.length; index++) {
                var lineItem = self.updateModel.lineItems[index];
                totalSum += lineItem.productAmount * lineItem.productTotalPrice;
            }

            return totalSum;
        }

        function getPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            if (!lineItem.productVatRate) {
                return lineItem.productPrice;
            }

            return lineItem.productPrice * (1 + lineItem.productVatRate / 100);
        }

        function getTotalPriceIncludingVatLineItem(lineItem) {
            if (!lineItem) {
                return 0;
            }

            return lineItem.productAmount * lineItem.productTotalPrice;
            // return (lineItem.productAmount * ((100 - lineItem.productDiscount) / 100) * (lineItem.productPrice + lineItem.productVatAmount));
        }

        function editInvoiceDetails(e) {
            var invoiceCopy = angular.copy(self.updateModel.invoice);
            return $mdDialog
                .show({
                    controller: 'EditInvoiceDetailsDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/edit-invoice-details-dialog/edit-invoice-details-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        invoice: invoiceCopy,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (editedInvoice) {
                    if (editedInvoice) {
                        // Add to updateModel
                        self.updateModel.invoice = editedInvoice;
                        toastService.success($translate.instant('SALES_ORDERS.INVOICE.INVOICE_SAVED'));
                    }
                    return editedInvoice;
                });
        }

        function openChoosePersonDialog(e) {
            dataService.getById('SalesOrders', self.updateModel.invoice.salesOrderId, true).then(function (salesOrder) {
                partyService.showSearchDialog(e, 'Parties', salesOrder.workOrderId, false, true).then(function (selectedParty) {
                    if (selectedParty) {
                        self.updateModel.customer.partyUpdateModel = null;
                        self.updateModel.customer.customer = salesOrderService.getEmptyCustomer();
                        self.updateModel.customer.customer.partyId = selectedParty.id;
                        self.updateModel.customer.customer.displayName = selectedParty.displayName;
                        self.updateModel.customer.customer.changeState = 1;
                        self.updateModel.customer.customer.customerForDepartmentId = self.updateModel.salesOrder.departmentId;
                        self.updateModel.customer.customer.primaryEmail = selectedParty.primaryEmail;
                        self.updateModel.customer.customer.primaryTelephone = selectedParty.primaryTelephone;
                        self.updateModel.customer.customer.primaryTelephone = selectedParty.primaryTelephone;
                        self.updateModel.customer.customer.billingAddress = { localizedAddress: selectedParty.primaryAddress };

                        dataService.getByUri('Addresses', 'GetDefaultAddressByPartyId/' + selectedParty.id).then(function (address) {
                            if (address) {
                                self.updateModel.customer.customer.billingAddressId = address.id;
                                self.updateModel.customer.billingAddress = address;
                                self.updateModel.customer.billingAddress.changeState = 2;
                            } else {
                                self.updateModel.customer.customer.billingAddressId = null;
                                self.updateModel.customer.billingAddress = null;
                            }

                            saveInvoice()
                                .then(function () {
                                    toastService.success($translate.instant('SALES_ORDERS.SALES_ORDER.SALES_ORDER_SAVED'));
                                })
                                .catch(function () {
                                    toastService.error('Noe gikk galt...', 'Oops!');
                                });
                        });
                    }
                });
            });
        }

        function lockInvoice(e) {
            return $mdDialog
                .show({
                    controller: 'LockInvoiceDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/sales-order/dialogs/lock-invoice-dialog/lock-invoice-dialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        invoice: self.updateModel.invoice,
                    },
                })
                .then(function (updatedInvoice) {
                    if (updatedInvoice) {
                        // Update relevant properties
                        self.updateModel.invoice.invoiceNumber = updatedInvoice.invoiceNumber;
                        self.updateModel.invoice.prefix = updatedInvoice.prefix;
                        self.updateModel.invoice.customerIdentificationCode = updatedInvoice.customerIdentificationCode;
                        self.updateModel.invoice.exportedFile = updatedInvoice.exportedFile;
                        self.updateModel.invoice.exportedFileFilepath = updatedInvoice.exportedFileFilepath;
                        self.updateModel.invoice.exportedFileId = updatedInvoice.exportedFileId;
                        self.updateModel.invoice.isLocked = updatedInvoice.isLocked;
                        self.updateModel.invoice.lockedTime = updatedInvoice.lockedTime;
                        self.updateModel.invoice.lockedById = updatedInvoice.lockedById;
                        self.updateModel.invoice.lockedBy = updatedInvoice.lockedBy;
                        self.updateModel.invoice.lockedByDisplayName = updatedInvoice.lockedByDisplayName;
                    }
                    return updatedInvoice;
                });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.customerPrimaryEmail = null;
            self.customerPrimaryTelephone = null;
        }

        function createPdf() {
            loadingService.setLoadingStatus(true);
            dataService.getByUri('Invoices', 'GenerateExportedFile/' + self.updateModel.invoice.id).then(function (exportedfile) {
                self.updateModel.invoice.exportedFileId = exportedfile.id;
                self.updateModel.invoice.exportedFile = exportedfile;
                self.updateModel.invoice.exportedFileFilepath = exportedfile.filepath;
                loadingService.setLoadingStatus(false);
            });
        }

        function getFormattedBillingAddress() {
            if (!self.updateModel.customer || !self.updateModel.customer.billingAddress) return null;
            return addressService.getFormattedAddress(self.updateModel.customer.billingAddress);
        }

        function deleteInvoice(e) {
            var confirm = $mdDialog
                .confirm()
                .title($translate.instant('SALES_ORDERS.INVOICE.DELETE_INVOICE_TITLE'))
                .textContent($translate.instant('SALES_ORDERS.INVOICE.DELETE_INVOICE_CONFIRM'))
                .ariaLabel($translate.instant('SALES_ORDERS.INVOICE.DELETE_INVOICE'))
                .targetEvent(e)
                .ok($translate.instant('SALES_ORDERS.INVOICE.DELETE_INVOICE'))
                .cancel($translate.instant('COMMON.DIALOG.CANCEL'));
            return $mdDialog.show(confirm).then(function () {
                loadingService.setLoadingStatus(true);
                return dataService.deleteItem('Invoices', self.updateModel.invoice).then(function (deletedInvoice) {
                    return deletedInvoice;
                });
            });
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.salesOrder').controller('EditInvoiceController', EditInvoiceController);

  /* @ngInject */
  function EditInvoiceController(
    $timeout,
    $window,
    $state,
    $filter,
    $scope,
    $stateParams,
    $mdDialog,
    loadingService,
    datatableService,
    salesOrderService,
    editInvoiceService,
    baldrisApiBase,
    currentUser,
    transactionalMailService,
    dataService,
    baldrisConfigService,
    fuseTheming
  ) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.salesOrderService = salesOrderService;
    vm.loadingService = loadingService;
    vm.data = editInvoiceService;
    vm.selectedIndex = 0;
    vm.trackableEmailsIsAllowed = false;

    // Methods
    vm.gotoSalesOrder = gotoSalesOrder;
    vm.goBack = goBack;
    vm.openMenu = openMenu;
    vm.lockInvoice = lockInvoice;
    vm.saveAndExitView = saveAndExitView;
    vm.getPreviewUrl = getPreviewUrl;
    vm.deleteInvoice = deleteInvoice;
    vm.openSendInvoiceDialog = openSendInvoiceDialog;
    vm.openMultiChannelDialog = openMultiChannelDialog;
    vm.getStatusAction = getStatusAction;
    vm.getStatusColor = getStatusColor;
    vm.getStatusIcon = getStatusIcon;
    vm.copyInvoice = copyInvoice;
    vm.creditInvoice = creditInvoice;

    // INIT
    activate();

    function activate() {
      vm.dtInstanceInvoices = {};
      vm.dtOptionsInvoices = datatableService.getLocalizedOptions().withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>').withOption('responsive', true).withOption('order', []);

      vm.loadingService.setLoadingStatus(true);
      editInvoiceService.loadInvoice($stateParams.invoiceId, $stateParams.salesOrder).then(function () {
        vm.loadingService.setLoadingStatus(false);
        if (vm.data.updateModel && vm.data.updateModel.invoice) {
          baldrisConfigService.getByName('AllowPaidTrackableEmails').then(function (config) {
            if (config && config[0] && config[0].customFieldDataBoolData) {
              vm.trackableEmailsIsAllowed = true;
              loadReportLogs(vm.data.updateModel.invoice);
            }
          });
        }
      });
    }

    function openMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }

    function saveAndExitView() {
      vm.loadingService.setLoadingStatus(true);
      editInvoiceService.saveInvoice().then(function () {
        gotoSalesOrder();
        vm.loadingService.setLoadingStatus(false);
      });
    }

    function lockInvoice(e) {
      editInvoiceService.lockInvoice(vm.updateModel.invoice, e).then(function (updateInvoice) {
        if (updateInvoice) {
          // Reload to get all inserted data
          activate();
        }
      });
    }

    function deleteInvoice(e) {
      editInvoiceService
        .deleteInvoice(e)
        .then(function () {
          gotoSalesOrder();
          vm.loadingService.setLoadingStatus(false);
        })
        .catch(function (message) {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    /**
     * Go to orders page
     */
    function goBack() {
      $window.history.back();
    }

    function gotoSalesOrder() {
      $state.go('app.salesOrder.details', { salesOrderId: vm.data.updateModel.invoice.salesOrderId });
    }

    function getPreviewUrl() {
      if (!vm.data.updateModel.invoice.id || !vm.data.updateModel.invoice.reportId) return null;
      return baldrisApiBase + '/api/Reports/AsPdf/' + vm.data.updateModel.invoice.reportId + '/InvoiceId/' + vm.data.updateModel.invoice.id;
    }

    function openSendInvoiceDialog(e, skipTracking) {
      var attachedFiles = null;
      if (vm.data.updateModel.attachments && vm.data.updateModel.attachments.length > 0) {
        var includeAttachments = _.filter(vm.data.updateModel.attachments, function (a) {
          return a.sendWithInvoice;
        });
        if (includeAttachments && includeAttachments.length > 0) {
          attachedFiles = includeAttachments.map(function (a) {
            return { filename: a.fileName, filepath: a.filePath, contentType: a.fileContentType };
          });
        }
      }
      transactionalMailService
        .showSendEmailDialog(
          e,
          currentUser,
          vm.data.updateModel.invoice.salesOrderDepartmentId,
          vm.data.updateModel.invoice.reportId,
          'InvoiceId',
          vm.data.updateModel.invoice.id,
          vm.data.updateModel.invoice.salesOrderWorkOrderId,
          'Invoice',
          [vm.data.updateModel.invoice.exportedFileFilepath],
          skipTracking,
          attachedFiles
        )
        .then(function (result) {
          loadReportLogs();
        });
    }

    function openMultiChannelDialog(e) {
      return $mdDialog
        .show({
          controller: 'MultiChannelDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/sales-order/dialogs/multi-channel-dialog/multi-channel-dialog.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: e,
          multiple: true,
          locals: {
            invoiceId: vm.data.updateModel.invoice.id,
          },
        })
        .then(function (selectedOption) {
          if (selectedOption) {
            if (selectedOption === 1) {
              return openSendInvoiceDialog(e, true);
            } else if (selectedOption === 2) {
              return openSendInvoiceDialog(e, false);
            } else if (selectedOption === 3) {
              return sendInvoiceToMultiChannel(vm.data.updateModel, e);
            }
            return false;
          }
          return false;
        });
    }

    function sendInvoiceToMultiChannel(updateModel, e) {
      return $mdDialog
        .show({
          controller: 'ConfirmMultiChannelDialogDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/sales-order/dialogs/confirm-multichannel-dialog/confirm-multichannel-dialog.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: e,
          multiple: true,
          locals: {
            updateModel: angular.copy(updateModel),
          },
        })
        .then(function (selectedOption) {});
      vm.loadingService.setLoadingStatus(true);
      return salesOrderService
        .sendInvoiceToMultiChannel(updateModel)
        .then(function () {
          loadReportLogs(updateModel.invoice);
        })
        .finally(function () {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    function copyInvoice(invoiceId, e) {
      copyOrCreditInvoice(invoiceId, false, e);
    }

    function creditInvoice(invoiceId, e) {
      copyOrCreditInvoice(invoiceId, true, e);
    }

    function copyOrCreditInvoice(invoiceId, copyAsCreditNote, e) {
      vm.loadingService.setBackgroundLoadingStatus(true);
      salesOrderService.copyInvoice(invoiceId, copyAsCreditNote).then(function (newInvoiceFdo) {
        vm.loadingService.setBackgroundLoadingStatus(false);
        $mdDialog.show({
          controller: 'InvoiceCopiedDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/sales-order/dialogs/invoice-copied-dialog/invoice-copied-dialog.tmpl.html',
          parent: angular.element(document.body),
          targetEvent: e,
          multiple: true,
          locals: {
            invoiceFdo: newInvoiceFdo,
          },
        });
      });
    }

    function loadReportLogs(invoice) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
      invoice = invoice || vm.data.updateModel.invoice;
      vm.isLoadingReportLogs = true;
      vm.reportLogs = null;
      return dataService.getByWorkOrderId('ReportLogs', invoice.id).then(function (reportLogs) {
        reportLogs = $filter('orderBy')(reportLogs, 'statusTime', true);

        var groupedReports = _.groupBy(reportLogs, function (value) {
          return value.recipient;
        });
        _.forOwn(groupedReports, function (value, key) {
          value = $filter('orderBy')(value, 'statusTime', true);
        });
        if (!angular.equals(groupedReports, vm.groupedReports)) {
          vm.groupedReports = groupedReports;
        }
        vm.reportLogs = reportLogs;
        vm.isLoadingReportLogs = false;
        // Initialize reloading - 60 seconds
        vm.reloader = $timeout(loadReportLogs, 60000);
        return vm.reportLogs;
      });
    }

    $scope.$on('$destroy', function (p1, p2) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
    });

    function getStatusIcon(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus & 1) return 'icon-export';
        if (reportLog.reportStatus & 2) return 'icon-send';
        if (reportLog.reportStatus & 4) return 'icon-server-network';
        if (reportLog.reportStatus & 8) return 'icon-email';
        if (reportLog.reportStatus & 16) return 'icon-email-open';
        if (reportLog.reportStatus & 32) return 'icon-close-circle';
        if (reportLog.reportStatus & 64) return 'icon-close-circle';
      }
      return 'icon-help';
    }

    function getStatusColor(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus & 1) return 'amber-300-fg';
        if (reportLog.reportStatus & 2) return 'amber-700-fg';
        if (reportLog.reportStatus & 4) return 'green-100-fg';
        if (reportLog.reportStatus & 8) return 'green-300-fg';
        if (reportLog.reportStatus & 16) return 'green-600-fg';
        if (reportLog.reportStatus & 32) return 'red-500-fg';
        if (reportLog.reportStatus & 64) return 'red-500-fg';
      }
      return null;
    }

    function getStatusAction(reportLog) {
      if (reportLog) {
        if (reportLog.reportStatus & 1) return 'WORK_ORDERS.WORK_ORDER.REPORTS.EXPORTED';
        if (reportLog.reportStatus & 2) return 'WORK_ORDERS.WORK_ORDER.REPORTS.SENT';
        if (reportLog.reportStatus & 4) return 'WORK_ORDERS.WORK_ORDER.REPORTS.PROCESSED';
        if (reportLog.reportStatus & 8) return 'WORK_ORDERS.WORK_ORDER.REPORTS.DELIVERED';
        if (reportLog.reportStatus & 16) return 'WORK_ORDERS.WORK_ORDER.REPORTS.OPENED';
        if (reportLog.reportStatus & 32) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BOUNCED';
        if (reportLog.reportStatus & 64) return 'WORK_ORDERS.WORK_ORDER.REPORTS.BLOCKED';
      }
      return null;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.location', [

        ]);

})(); 
(function() {
    'use strict';

    angular
        .module('app.location')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider) {
        $translatePartialLoaderProvider.addPart('app/main/reference-types/location');

        

    }
})();
(function () {
    'use strict';


})();
(function () {
    'use strict';

    angular.module('app.program').factory('programService', programService);

    /* @ngInject */
    function programService($http, $q, baldrisApiBase, exception, loadingService) {
        var service = {
            getEmptyProgram: getEmptyProgram,
            getEmptyProgramSlot: getEmptyProgramSlot,
            getEmptyProgramType: getEmptyProgramType,
            getRecommendedVersesForSlot: getRecommendedVersesForSlot,
            getEmptyProgramSlotStyle: getEmptyProgramSlotStyle,
            getTemplateFile: getTemplateFile,
            transferProgramToSupplier: transferProgramToSupplier,
            transferProgramInMemory: transferProgramInMemory,
        };

        return service;

        function getEmptyProgram() {
            return {
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                finalizedBy: null,
                supplierId: null,
                workOrderId: null,
                externalOrderTypeId: null,
                deliveryTime: null,
                deliveryLocationId: null,
                alternateDeliveryAddressId: null,
                deceasedId: null,
                calendarEventId: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
                programName: null,
                programOptions: null,
                programDateFormat: null,
                programAlternateName: null,
                programAmount: 0,
                programTypeId: null,
                externalTemplateId: null,
                programStyleId: null,
                externalStyleId: null,
                programSymbolId: null,
            };
        }

        function getRecommendedVersesForSlot(programSlotId, songId, calendarEventTypeId, locationId) {
            return $http
                .get(baldrisApiBase + '/api/SongVerses/RecommendedVersesBySongId/' + songId, {
                    params: {
                        programSlotId: programSlotId,
                        calendarEventTypeId: calendarEventTypeId,
                        locationId: locationId,
                    },
                })
                .then(getRecommendedVersesForSlotComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getRecommendedVersesForSlot')(message);
                });

            function getRecommendedVersesForSlotComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function transferProgramToSupplier(updateModel) {
            return $http
                .post(baldrisApiBase + '/api/Programs/TransferToSupplier/' + updateModel.program.supplierId, updateModel)
                .then(transferProgramComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for transferProgramToSupplier at "Programs"')(message);
                    return $q.reject(message);
                });

            function transferProgramComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function transferProgramInMemory(programId) {
            return $http
                .post(baldrisApiBase + '/api/Programs/SendProgramToInMemory/' + programId)
                .then(transferProgramInMemoryComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for transferProgramInMemory at "Programs"')(message);
                    return $q.reject(message);
                });

            function transferProgramInMemoryComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyProgramSlot() {
            return {
                name: null,
                description: null,
                title: null,
                titleAlternative: null,
                englishTitle: null,
                dataTypeDiscriminator: null,
                shouldBeVisibleInPrint: false,
                isDeleted: false,
                sortOrder: 0,
                dataType: 0,
                iconName: null,
                lookupStringCategoryId: null,
                defaultDataId: null,
            };
        }

        function getEmptyProgramType() {
            return {
                name: null,
                sortOrder: 0,
                description: null,
                isDeleted: false,
                remarks: null,
                iconName: null,
                templateFileId: null,
                externalTemplateId: null,
                previewImageId: null,
            };
        }

        function getEmptyProgramSlotStyle() {
            return {
                internalIdentifier: null,
                remarks: null,
                programStyleId: '00000000-0000-0000-0000-000000000000',
                programSlotId: null,
                fontStyleId: '00000000-0000-0000-0000-000000000000',
                titleStyleId: '00000000-0000-0000-0000-000000000000',
                creditStyleId: null,
            };
        }

        function getTemplateFile(id) {
            loadingService.setLoadingStatus(true);
            return $http({
                url: baldrisApiBase + '/api/ServiceSheets/' + id + '/ExportTemplate',
                method: 'GET',
                params: {},
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'arraybuffer',
            })
                .then(function (data, status, headers, config) {
                    var octetStreamMime = 'application/octet-stream';
                    var success = false;

                    // Get the headers
                    data.headers = data.headers();

                    // Get the filename from the x-filename header or default to "download.bin"
                    var contentFileName = null;
                    if (data.headers['content-disposition'] && data.headers['content-disposition'].indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(data.headers['content-disposition']);
                        if (matches != null && matches[1]) {
                            contentFileName = matches[1].replace(/['"]/g, '');
                        }
                    }
                    contentFileName = decodeURIComponent(contentFileName);
                    var filename = contentFileName || 'template_file.idml';

                    // Determine the content type from the header or default to "application/octet-stream"
                    var contentType = data.headers['content-type'] || octetStreamMime;

                    try {
                        // Try using msSaveBlob if supported
                        console.log('Trying saveBlob method ...');
                        var blob = new Blob([data], { type: contentType });
                        if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
                        else {
                            // Try using other saveBlob implementations, if available
                            var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                            if (saveBlob === undefined) throw 'Not supported';
                            saveBlob(blob, filename);
                        }
                        console.log('saveBlob succeeded');
                        success = true;
                    } catch (ex) {
                        console.log('saveBlob method failed with the following exception:');
                        console.log(ex);
                    }

                    if (!success) {
                        // Get the blob url creator
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            // Try to use a download link
                            var link = document.createElement('a');
                            if ('download' in link) {
                                // Try to simulate a click
                                try {
                                    // Prepare a blob URL
                                    console.log('Trying download link method with simulated click ...');
                                    var blob = new Blob([data.data], {
                                        type: contentType,
                                    });
                                    var url = urlCreator.createObjectURL(blob);
                                    link.setAttribute('href', url);

                                    // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                                    link.setAttribute('download', filename);

                                    // Simulate clicking the download link
                                    var event = document.createEvent('MouseEvents');
                                    event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                                    link.dispatchEvent(event);
                                    console.log('Download link method with simulated click succeeded');
                                    success = true;
                                } catch (ex) {
                                    console.log('Download link method with simulated click failed with the following exception:');
                                    console.log(ex);
                                }
                            }

                            if (!success) {
                                // Fallback to window.location method
                                try {
                                    // Prepare a blob URL
                                    // Use application/octet-stream when using window.location to force download
                                    console.log('Trying download link method with window.location ...');
                                    var blob = new Blob([data.data], {
                                        type: octetStreamMime,
                                    });
                                    var url = urlCreator.createObjectURL(blob);
                                    window.location = url;
                                    console.log('Download link method with window.location succeeded');
                                    success = true;
                                } catch (ex) {
                                    console.log('Download link method with window.location failed with the following exception:');
                                    console.log(ex);
                                }
                            }
                            loadingService.setLoadingStatus(false);
                            return true;
                        }
                    }
                    loadingService.setLoadingStatus(false);
                })
                .catch(function (data, status, headers, config) {
                    //TODO when WS error
                    loadingService.setLoadingStatus(false);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .factory('programElementService', programElementService);

    /* @ngInject */
    function programElementService() {
        var service = {
            getEmptyProgramElement: getEmptyProgramElement,
        };

        return service;

        function getEmptyProgramElement() {
            return {
                overridenTitle: null,
                subtitle: null,
                shouldBeVisibleInPrint: false,
                sortOrder: 0,
                remarks: null,
                dataType: 'none',
                stringData: null,
                longData: null,
                decimalData: null,
                dateTimeData: null,
                boolData: false,
                lookupStringDataId: null,
                songDataId: null,
                calendarEventParticipantId: null,
                programId: '00000000-0000-0000-0000-000000000000',
                programSlotId: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .factory('programElementVerseService', programElementVerseService);

    /* @ngInject */
    function programElementVerseService($http, $q, exception) {
        var service = {
            getEmptyProgramElementVerse: getEmptyProgramElementVerse,
        };

        return service;

        function getEmptyProgramElementVerse() {
            return {
                sortOrder: 0,
                programElementId: '00000000-0000-0000-0000-000000000000',
                verseId: '00000000-0000-0000-0000-000000000000',
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.program').service('editProgramService', editProgramService);

    /* @ngInject */
    function editProgramService(
        dataService,
        $mdDialog,
        $document,
        $q,
        $filter,
        baldrisConfigService,
        programService,
        programOptions,
        programElementService,
        baldrisApiBase,
        editCustomFieldService,
        $translate,
        workOrderService,
        transactionalMailService,
        Upload,
        loadingService,
        toastService
    ) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;
        self.customFieldCategories = [];
        self.useProgramSupplier = false;

        self.saveUpdateModel = saveUpdateModel;
        self.initUpdateModel = initUpdateModel;
        self.getSongVerses = getSongVerses;
        self.showEditProgramElementDialog = showEditProgramElementDialog;
        self.showAddProgramElementDialog = showAddProgramElementDialog;
        self.updateProgramElement = updateProgramElement;
        self.addProgramElement = addProgramElement;
        self.deleteData = deleteData;
        self.programElementService = programElementService;
        self.loadProgram = loadProgram;
        self.getSlotIcon = getSlotIcon;
        self.shouldShowAlternateName = shouldShowAlternateName;
        self.addToProgramSlot = addToProgramSlot;
        self.editData = editData;
        self.createProgramElement = createProgramElement;
        self.onProgramElementChanged = onProgramElementChanged;
        self.downloadTemplateFile = downloadTemplateFile;
        self.getTemplateFileDownloadLink = getTemplateFileDownloadLink;
        self.onProgramStyleChanged = onProgramStyleChanged;
        self.sendProgramOrder = sendProgramOrder;
        self.customFieldCategoryFilter = customFieldCategoryFilter;
        self.customFieldFilter = customFieldFilter;
        self.uploadAttachments = uploadAttachments;
        self.canSendProgramOrder = canSendProgramOrder;
        self.getProgramSlotContentAsString = getProgramSlotContentAsString;
        self.filterSlots = filterSlots;
        self.sendToInMemory = sendToInMemory;

        function loadProgram(programId, workOrder, calendarEvent) {
            reset();
            if (!programId || programId === '00000000-0000-0000-0000-000000000000' || programId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    program: programService.getEmptyProgram(),
                    programElements: [],
                    programFiles: [],
                    programSlots: [],
                    detailsData: [],
                };
                self.updateModel.program.workOrderId = workOrder.id;
                self.updateModel.program.calendarEventId = calendarEvent ? calendarEvent.id : null;
                self.updateModel.program.calendarEvent = calendarEvent ? calendarEvent : null;
                return baldrisConfigService.getByName('ProgramSheetOrderType').then(function (config) {
                    var orderTypeId = config[0].dataTargetId;
                    self.updateModel.program.externalOrderTypeId = orderTypeId;
                    var promises = [];
                    promises.push(dataService.getAll('ProgramStyles'));
                    promises.push(
                        dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: self.updateModel.program.id,
                            attachedDataTargetName: 'ExternalOrder',
                            attachedTypeId: self.updateModel.program.externalOrderTypeId,
                            attachedTypeName: 'ExternalOrderType',
                        })
                    );
                    promises.push(
                        dataService.getByUri('Reports', 'ByTemplateName', {
                            templateName: 'CeremonyProgramOrder',
                        })
                    );
                    if (self.updateModel.program.calendarEvent) {
                        promises.push(
                            dataService.getByUri('ProgramSlots', 'ByCalendarEventTypeId/' + self.updateModel.program.calendarEvent.calendarEventTypeId, {
                                asDto: false,
                                shouldReturnAllIfEmpty: true,
                            })
                        );
                    }
                    return $q.all(promises).then(function (response) {
                        if (response && response[0] && response[0][0] && response[0][0].id) {
                            self.updateModel.program.programStyleId = response[0][0].id;
                            self.updateModel.program.programOptions = response[0][0].options || 0;
                        }
                        var customFields = response[1];
                        self.programOrderReport = response[2];
                        if (self.updateModel.program.calendarEvent) {
                            self.updateModel.programSlots = response[3];
                        }
                        return finishLoading(customFields);
                    });
                });
            } else {
                var promises = [];
                promises.push(dataService.getById('ServiceSheets', programId));
                promises.push(dataService.getByUri('ProgramElements', 'ByServiceSheetId/' + programId));
                promises.push(dataService.getByUri('ServiceSheetFiles', 'ByServiceSheetId/' + programId));
                promises.push(dataService.getByUri('ServiceSheetFiles', 'ByServiceSheetId/' + programId));
                return $q.all(promises).then(function (response) {
                    self.updateModel = {
                        program: response[0],
                        programElements: response[1],
                        programFiles: response[2],
                        programSlots: [],
                        detailsData: [],
                    };
                    if (self.updateModel && self.updateModel.program) {
                        promises = [];
                        if (self.updateModel.program.externalOrderTypeId) {
                            promises.push(
                                dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                                    attachedDataTargetId: self.updateModel.program.id,
                                    attachedDataTargetName: 'ExternalOrder',
                                    attachedTypeId: self.updateModel.program.externalOrderTypeId,
                                    attachedTypeName: 'ExternalOrderType',
                                })
                            );
                        }
                        if (self.updateModel.program.calendarEventId) {
                            promises.push(dataService.getById('CalendarEvents', self.updateModel.program.calendarEventId));
                        }
                        promises.push(
                            dataService.getByUri('Reports', 'ByTemplateName', {
                                templateName: 'CeremonyProgramOrder',
                            })
                        );
                        promises.push(dataService.getByUri('WorkOrderAttachments', 'ByExternalOrderId/' + programId));
                        if (promises.length > 0) {
                            return $q.all(promises).then(function (response) {
                                var customFields = [];
                                if (self.updateModel.program.externalOrderTypeId) {
                                    customFields = response[0];
                                }
                                self.programOrderReport = response[response.length - 2];
                                self.updateModel.attachments = response[response.length - 1] || [];
                                if (self.updateModel.program.calendarEventId) {
                                    self.updateModel.program.calendarEvent = response[response.length - 3];
                                    dataService
                                        .getByUri('ProgramSlots', 'ByCalendarEventTypeId/' + self.updateModel.program.calendarEvent.calendarEventTypeId, {
                                            asDto: false,
                                            shouldReturnAllIfEmpty: true,
                                        })
                                        .then(function (programSlots) {
                                            self.updateModel.programSlots = programSlots;
                                            return finishLoading(customFields);
                                        });
                                } else {
                                    return finishLoading(customFields);
                                }
                            });
                        } else {
                            return true;
                        }
                    }
                });
            }
        }

        function finishLoading(categories) {
            var promises = [];
            promises.push(initUpdateModel(self.updateModel));
            promises.push(baldrisConfigService.getByName('UseProgramSupplier'));
            return $q.all(promises).then(function (response) {
                var config = response[1] !== null ? response[1][0] : null;
                if (config && config.dataValueAsString && (config.dataValueAsString === 'true' || config.dataValueAsString === 'True')) {
                    self.useProgramSupplier = true;
                }
                self.customFieldCategories = categories;
                return true;
            });
        }

        function onProgramElementChanged(programElement) {
            if (programElement.isNew) {
                programElement.isNew = false;
            }
            if (programElement.id) {
                programElement.changeState = 2;
            }
            if (self.validation && self.validation.programForm) {
                self.validation.programForm.$setDirty();
            }
        }

        function getSlotIcon(programSlot) {
            switch (programSlot.dataType) {
                case 0:
                case 10:
                    return 'icon icon-comment-text';
                case 1:
                    return 'icon icon-format-list-numbers';
                case 2:
                case 3:
                    return 'icon icon-numeric';
                case 4:
                    return 'icon icon-timetable';
                case 5:
                    return 'icon icon-checkbox-marked';
                case 6:
                case 9:
                    return 'icon icon-book-multiple';
                case 7:
                    return 'icon icon-microphone';
                case 8:
                    return 'icon icon-music-note';
                default:
                    return 'icon icon-comment-text';
            }
        }

        function shouldShowAlternateName() {
            return self.updateModel.program.programOptions & programOptions.SHOULD_USE_ALTERNATE_NAME.value;
        }

        function addToProgramSlot(programSlot, e) {
            var newProgramElementUpdateModel = {
                programElement: programElementService.getEmptyProgramElement(),
                programElementVerses: [],
            };
            newProgramElementUpdateModel.programElement.changeState = 1;
            newProgramElementUpdateModel.programElement.dataType = programSlot.dataType;
            newProgramElementUpdateModel.programElement.programSlotId = programSlot.slotId;
            newProgramElementUpdateModel.programElement.programSlotTitle = programSlot.title;
            newProgramElementUpdateModel.programElement.sortOrder = programSlot.sortOrder;
            newProgramElementUpdateModel.programElement.shouldBeVisibleInPrint = programSlot.shouldBeVisibleInPrint;
            newProgramElementUpdateModel.programElement.programSlotLookupStringCategoryId = programSlot.lookupStringCategoryId;
            if (newProgramElementUpdateModel.programElement.dataType && newProgramElementUpdateModel.programElement.dataType === 5) {
                newProgramElementUpdateModel.programElement.boolData = true;
            }
            // Open Edit Data dialog
            showEditProgramElementDialog(newProgramElementUpdateModel, e).then(function (editedProgramElement) {
                if (editedProgramElement) {
                    // Add element
                    addProgramElement(self.updateModel, editedProgramElement);
                }
            });
        }

        function createProgramElement(e) {
            showAddProgramElementDialog(self.updateModel.program.id, e).then(function (newProgramElement) {
                if (newProgramElement) {
                    var elementUpdateModel = {
                        programElement: newProgramElement,
                        programElementVerses: [],
                    };
                    // Open Edit Data dialog
                    showEditProgramElementDialog(elementUpdateModel, e).then(function (editedProgramElement) {
                        if (editedProgramElement) {
                            // Add element
                            addProgramElement(self.updateModel, editedProgramElement);
                        }
                    });
                }
            });
        }

        function editData(programSlot, e) {
            var programElementCopy = angular.copy(programSlot.data);
            programElementCopy.programSlotLookupStringCategoryId = programSlot.lookupStringCategoryId;
            showEditProgramElementDialog(programElementCopy, e).then(function (editedProgramElementCopy) {
                if (editedProgramElementCopy) {
                    // Update the collection with the new data
                    updateProgramElement(self.updateModel, editedProgramElementCopy, programSlot.slotId);
                }
            });
        }

        function showEditProgramElementDialog(programElement, e) {
            return $mdDialog.show({
                controller: 'EditProgramElementDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/program/dialogs/edit-program-element-dialog/edit-program-element-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    programElement: programElement,
                },
                clickOutsideToClose: true,
            });
        }

        function showAddProgramElementDialog(programId, e) {
            return $mdDialog.show({
                controller: 'AddProgramElementDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/program/dialogs/add-program-element-dialog/add-program-element-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    programId: programId,
                },
                clickOutsideToClose: true,
            });
        }

        function deleteData(programSlot) {
            if (programSlot.data) {
                if (programSlot.data.isNew || !programSlot.data.id) {
                    programSlot.data = null;
                } else {
                    programSlot.data.changeState = 3;
                }

                programSlot.changeState = 3;
                if (self.validation && self.validation.programForm) {
                    self.validation.programForm.$setDirty();
                }
            }
        }

        function addProgramElement(updateModel, programElementUpdateModel) {
            var slotFound = false;
            // Check if we have an available slot to put the element on
            if (programElementUpdateModel.programElement.programSlotId) {
                for (var slotIndex = 0; slotIndex < updateModel.slotCollection.length; slotIndex++) {
                    var fauxSlot = updateModel.slotCollection[slotIndex];
                    if (fauxSlot.slotId === programElementUpdateModel.programElement.programSlotId && !fauxSlot.data) {
                        fauxSlot.data = programElementUpdateModel;
                        slotFound = true;
                        break;
                    }
                }
            }
            // Create new slot if we didn't find any available
            if (!slotFound) {
                var fauxSlot = {
                    slotId: programElementUpdateModel.programElement.programSlotId,
                    title:
                        programElementUpdateModel.programElement.overridenTitle ||
                        (programElementUpdateModel.programElement.programSlotTitle
                            ? programElementUpdateModel.programElement.programSlotTitle
                            : 'PROGRAMS.EDIT_PROGRAM.MISSING_TITLE'),
                    sortOrder: programElementUpdateModel.programElement.sortOrder,
                    shouldBeVisibleInPrint: programElementUpdateModel.programElement.shouldBeVisibleInPrint,
                    dataType: programElementUpdateModel.programElement.dataType,
                    data: programElementUpdateModel,
                };
                updateModel.slotCollection.push(fauxSlot);
            }
            // Add to updateModel's save collection
            updateModel.programElements.push(programElementUpdateModel);
            if (self.validation && self.validation.programForm) {
                self.validation.programForm.$setDirty();
            }
        }

        function updateProgramElement(updateModel, programElement, oldSlotId) {
            // If oldSlotId is different from new slotId, we have to remove the data from the old one
            if (programElement.programSlotId !== oldSlotId) {
                for (var slotIndex = 0; slotIndex < updateModel.slotCollection.length; slotIndex++) {
                    var fauxSlot = updateModel.slotCollection[slotIndex];
                    if (fauxSlot.slotId === oldSlotId) {
                        fauxSlot.data = null;
                        break;
                    }
                }
            }
            // If programElement contains deleted songVerses, extract them and put them in a collection for saving later
            if (programElement.programElementVerses && programElement.programElementVerses.length > 0) {
                var deletedVerses = programElement.programElementVerses.filter(function (verse) {
                    return verse.hasOwnProperty('changeState') && verse.changeState === 3;
                });

                if (deletedVerses && deletedVerses.length > 0) {
                    if (!self.updateModel.deletedVerses) {
                        self.updateModel.deletedVerses = [];
                    }
                    self.updateModel.deletedVerses = self.updateModel.deletedVerses.concat(deletedVerses);
                    // Remove deleted verses from program element
                    programElement.programElementVerses = programElement.programElementVerses.filter(function (verse) {
                        return !verse.id || !verse.hasOwnProperty('changeState') || verse.changeState !== 3;
                    });
                }
            }
            attachElementToSlot(updateModel, programElement);
            // Update the programElements collection
            if (!updateModel.programElements) updateModel.programElements = [];
            if (programElement.id && programElement.hasOwnProperty('changeState') && programElement.changeState !== 0) {
                // Remove old entry
                for (var elementIndex = updateModel.programElements.length - 1; elementIndex >= 0; elementIndex--) {
                    var element = updateModel.programElements[elementIndex];
                    if (element.id === programElement.id) {
                        updateModel.programElements.splice(elementIndex, 1);
                    }
                }
            }
            updateModel.programElements.push(programElement);
            if (self.validation && self.validation.programForm) {
                self.validation.programForm.$setDirty();
            }
        }

        function attachElementToSlot(updateModel, programElement) {
            var slotFound = false;
            if (programElement.programSlotId) {
                // Try to find existing slot
                for (var slotIndex = 0; slotIndex < updateModel.slotCollection.length; slotIndex++) {
                    var fauxSlot = updateModel.slotCollection[slotIndex];
                    if (fauxSlot.slotId === programElement.programSlotId) {
                        // Update slot
                        fauxSlot.title =
                            programElement.overridenTitle ||
                            (programElement.programSlotTitle ? programElement.programSlotTitle : 'PROGRAMS.EDIT_PROGRAM.MISSING_TITLE');
                        fauxSlot.sortOrder = programElement.sortOrder;
                        fauxSlot.shouldBeVisibleInPrint = programElement.shouldBeVisibleInPrint;
                        fauxSlot.dataType = programElement.dataType;
                        if (!fauxSlot.data) {
                            fauxSlot.data = programElement;
                        } else {
                            // Update programElement
                            if (!fauxSlot.data) {
                                fauxSlot.data = programElement;
                            } else {
                                fauxSlot.data.id = programElement.id;
                                fauxSlot.data.overridenTitle = programElement.overridenTitle;
                                fauxSlot.data.subtitle = programElement.subtitle;
                                fauxSlot.data.shouldBeVisibleInPrint = programElement.shouldBeVisibleInPrint;
                                fauxSlot.data.sortOrder = programElement.sortOrder;
                                fauxSlot.data.remarks = programElement.remarks;
                                fauxSlot.data.dataType = programElement.dataType;
                                if (fauxSlot.data.stringData !== programElement.stringData) {
                                    fauxSlot.data.stringData = programElement.stringData;
                                }
                                fauxSlot.data.longData = programElement.longData;
                                fauxSlot.data.decimalData = programElement.decimalData;
                                fauxSlot.data.dateTimeData = programElement.dateTimeData;
                                fauxSlot.data.boolData = programElement.boolData;
                                fauxSlot.data.lookupStringDataId = programElement.lookupStringDataId;
                                fauxSlot.data.lookupStringDataLookupValue = programElement.lookupStringDataLookupValue;
                                if (fauxSlot.data.songDataId !== programElement.songDataId) {
                                    fauxSlot.data.songDataId = programElement.songDataId;
                                    fauxSlot.data.songDataTitle = programElement.songDataTitle;
                                }
                                fauxSlot.data.calendarEventParticipantId = programElement.calendarEventParticipantId;
                                fauxSlot.data.calendarEventParticipantParticipantPartyDisplayName =
                                    programElement.calendarEventParticipantParticipantPartyDisplayName;
                                fauxSlot.data.programId = programElement.programId;
                                fauxSlot.data.programProgramName = programElement.programProgramName;
                                fauxSlot.data.programSlotId = programElement.programSlotId;
                                fauxSlot.data.programSlotName = programElement.programSlotName;
                                fauxSlot.data.programSlotTitle = programElement.programSlotTitle;
                                fauxSlot.data.changeState = programElement.changeState;
                                fauxSlot.data.createdBy = programElement.createdBy;
                                fauxSlot.data.createdAt = programElement.createdAt;
                                fauxSlot.data.lastModifiedBy = programElement.lastModifiedBy;
                                fauxSlot.data.lastModifiedAt = programElement.lastModifiedAt;
                                fauxSlot.data.programElementVerses = programElement.programElementVerses;
                            }
                            fauxSlot.dataVerses = programElement.programElementVerses;
                        }

                        slotFound = true;
                        break;
                    }
                }
            }
            if (!slotFound) {
                // Create new fauxSlot
                var fauxSlot = {
                    slotId: programElement.programSlotId,
                    title:
                        programElement.overridenTitle ||
                        (programElement.programSlotTitle ? programElement.programSlotTitle : 'PROGRAMS.EDIT_PROGRAM.MISSING_TITLE'),
                    sortOrder: programElement.sortOrder,
                    shouldBeVisibleInPrint: programElement.shouldBeVisibleInPrint,
                    dataType: programElement.dataType,
                    data: programElement,
                };
                updateModel.slotCollection.push(fauxSlot);
            }
        }

        function saveUpdateModel(updateModel) {
            if (
                !updateModel.program.id ||
                updateModel.program.id === '00000000-0000-0000-0000-000000000000' ||
                updateModel.program.id.toLowerCase() === 'new'
            ) {
                return dataService.insertItem('ServiceSheets', updateModel.program).then(function (insertedServiceSheet) {
                    updateModel.program = insertedServiceSheet;
                    return saveAdditionalData(updateModel);
                });
            }
            return dataService
                .updateItem('ServiceSheets', updateModel.program)
                .then(function () {
                    if (self.validation && self.validation.programForm) {
                        self.validation.programForm.$setPristine();
                    }
                    return saveAdditionalData(updateModel);
                })
                .catch(function (message) {
                    return $q.reject(message);
                });
        }

        function saveAdditionalData(updateModel) {
            extractDataFromSlots(updateModel);
            updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

            var promises = dataService.createBulkPromises('ProgramElements', updateModel.programElements, 'programId', updateModel.program.id);

            promises = promises.concat(
                dataService.createBulkPromises('CustomFieldData', updateModel.detailsData, 'attachedTypeId', updateModel.program.id, 'ExternalOrder')
            );

            if (updateModel.deletedVerses && updateModel.deletedVerses.length > 0) {
                var promises = dataService.createBulkPromises('ProgramElementVerses', updateModel.deletedVerses);
            }
            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    return updateModel;
                });
            }

            return $q.when(updateModel);
        }

        function extractDataFromSlots(updateModel) {
            // We have to get the programElements from the slotscollection to be sure to get newly created ones
            updateModel.programElements = [];
            for (var slotIndex = 0; slotIndex < updateModel.slotCollection.length; slotIndex++) {
                var fauxSlot = updateModel.slotCollection[slotIndex];
                if (fauxSlot.data) {
                    if (
                        (fauxSlot.data.id &&
                            fauxSlot.data.hasOwnProperty('changeState') &&
                            (fauxSlot.data.changeState === 2 || fauxSlot.data.changeState === 3)) ||
                        (!fauxSlot.data.id && !fauxSlot.data.isNew)
                    ) {
                        updateModel.programElements.push(fauxSlot.data);
                    }
                }
            }
        }

        function initUpdateModel(updateModel) {
            return $q.when(mergeSlotsWithElements(updateModel));
        }

        function mergeSlotsWithElements(updateModel) {
            var slotCollection = [];
            if (updateModel.programElements && updateModel.programElements.length > 0) {
                //Loop through elements, create new faux slot collection
                for (var elementIndex = 0; elementIndex < updateModel.programElements.length; elementIndex++) {
                    var element = updateModel.programElements[elementIndex];
                    var fauxSlot = {
                        slotId: element.programSlotId,
                        title: element.overridenTitle || (element.programSlotTitle ? element.programSlotTitle : 'PROGRAMS.EDIT_PROGRAM.MISSING_TITLE'),
                        sortOrder: element.sortOrder,
                        shouldBeVisibleInPrint: element.shouldBeVisibleInPrint,
                        dataType: element.dataType,
                        lookupStringCategoryId: element.programSlotLookupStringCategoryId,
                        data: element,
                    };
                    slotCollection.push(fauxSlot);
                }
            }

            //Also insert slots that don't have any data
            if (updateModel.programSlots && updateModel.programSlots.length > 0) {
                for (var slotIndex = 0; slotIndex < updateModel.programSlots.length; slotIndex++) {
                    var programSlot = updateModel.programSlots[slotIndex];
                    var slotFound = false;
                    for (var fauxIndex = 0; fauxIndex < slotCollection.length; fauxIndex++) {
                        var fauxSlot = slotCollection[fauxIndex];
                        if (fauxSlot.slotId === programSlot.id) {
                            slotFound = true;
                            fauxSlot.lookupStringCategoryId = programSlot.lookupStringCategoryId;
                            break;
                        }
                    }
                    if (!slotFound && !programSlot.isDeleted) {
                        var newProgramElement = programElementService.getEmptyProgramElement();
                        newProgramElement.isNew = true;
                        newProgramElement.dataType = programSlot.dataType;
                        newProgramElement.programSlotId = programSlot.id;
                        newProgramElement.programSlotTitle = programSlot.title;
                        newProgramElement.sortOrder = programSlot.sortOrder;
                        newProgramElement.shouldBeVisibleInPrint = programSlot.shouldBeVisibleInPrint;
                        newProgramElement.programSlotLookupStringCategoryId = programSlot.lookupStringCategoryId;
                        if (
                            (!updateModel.program.id ||
                                updateModel.program.id === 'new' ||
                                updateModel.program.id === '00000000-0000-0000-0000-000000000000') &&
                            programSlot.defaultDataId
                        ) {
                            // Only on new programs
                            newProgramElement.isNew = false || (programSlot.dataType === 5 && !programSlot.defaultDataBoolData);

                            newProgramElement.stringData = programSlot.defaultDataStringData;
                            newProgramElement.longData = programSlot.defaultDataLongData;
                            newProgramElement.decimalData = programSlot.defaultDataDecimalData;
                            newProgramElement.dateTimeData = programSlot.defaultDataDateTimeData;
                            newProgramElement.boolData = programSlot.defaultDataBoolData;
                            newProgramElement.lookupStringDataId = programSlot.defaultDataLookupStringDataId;
                            newProgramElement.songDataId = programSlot.defaultDataSongDataId;
                        }
                        var newFauxSlot = {
                            slotId: programSlot.id,
                            title: programSlot.title || programSlot.name,
                            sortOrder: programSlot.sortOrder,
                            shouldBeVisibleInPrint: programSlot.shouldBeVisibleInPrint,
                            dataType: programSlot.dataType,
                            lookupStringCategoryId: programSlot.lookupStringCategoryId,
                            data: newProgramElement,
                        };
                        slotCollection.push(newFauxSlot);
                    }
                }
            }

            updateModel.slotCollection = slotCollection;

            return updateModel;
        }

        function getProgramSlotContentAsString(programSlot) {
            if (!programSlot || !programSlot.data) return null;
            switch (programSlot.dataType) {
                case 'string':
                case 'custom':
                    return programSlot.data.stringData;
                case 'lookupString':
                    return programSlot.data.lookupStringDataDescription || programSlot.data.lookupStringDataLookupValue || programSlot.data.stringData;
                case 'long':
                case 'decimal':
                    return programSlot.data.longData || programSlot.data.decimalData || programSlot.data.stringData;
                case 'dateTime':
                    return moment(programSlot.data.dateTimeData).format('L') || programSlot.data.stringData;
                case 'boolean':
                    return programSlot.data.boolData
                        ? 'PROGRAMS.EDIT_PROGRAM.IS_SELECTED'
                        : 'PROGRAMS.EDIT_PROGRAM.IS_NOT_SELECTED' || programSlot.data.stringData;
                case 'song':
                case 'prayer':
                    if (programSlot.data.songDataId) {
                        return (programSlot.data.songDataTitle || programSlot.data.stringData) + ' (' + getSongVerses(programSlot.data) + ')';
                    }
                    return programSlot.data.songDataTitle || programSlot.data.stringData;
                case 'solo':
                case 'music':
                    return programSlot.data.songDataTitle || programSlot.data.stringData;
                default:
                    return programSlot.data.stringData;
            }
        }

        function filterSlots(value, index, array) {
            return value.changeState !== 3 && !value.data.isNew;
        }

        function getSongVerses(element) {
            var returnString = '';
            if (element && element.programElementVerses) {
                var elementVerses = $filter('orderBy')(element.programElementVerses, 'sortOrder');
                for (var index = 0; index < elementVerses.length; index++) {
                    var elementVerse = elementVerses[index];
                    if (elementVerse.verseNumber && elementVerse.changeState != 3) {
                        if (returnString) returnString += ', ';
                        returnString += elementVerse.verseNumber;
                    }
                }
            }
            return returnString;
        }

        function downloadTemplateFile() {
            programService.getTemplateFile(self.updateModel.program.id).then(function () {});
        }

        function getTemplateFileDownloadLink() {
            return baldrisApiBase + '/api/Programs/ExportTemplate/' + self.updateModel.program.id;
        }

        function onProgramStyleChanged(programStyle) {
            if (programStyle) {
                self.updateModel.program.programOptions |= programStyle.options;
            }
        }

        function sendProgramOrder(e) {
            if (e) {
                e.stopPropagation();
            }
            if (self.useProgramSupplier) {
                loadingService.setLoadingStatus(true);
                programService.transferProgramToSupplier(self.updateModel).then(function () {
                    loadingService.setLoadingStatus(false);
                    toastService.success($translate.instant('TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.EMAIL_SUCCESS'));
                });
            } else {
                dataService.getCurrentUser().then(function (currentUser) {
                    transactionalMailService
                        .showSendEmailDialog(
                            e,
                            currentUser,
                            null,
                            self.programOrderReport.id,
                            self.programOrderReport.requiredTypes,
                            self.updateModel.program.workOrderId,
                            self.updateModel.program.workOrderId
                        )
                        .then(function (response) {});
                });
            }
        }

        function canSendProgramOrder() {
            if (self.useProgramSupplier) {
                return self.updateModel.program.supplierId !== null;
            }
            return true;
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.customFieldCategories = [];
            self.useProgramSupplier = false;
        }

        function customFieldCategoryFilter(value, index, array) {
            if (value.customFields && value.customFields.length > 0) {
                var hasData = value.customFields.reduce(function (acc, current) {
                    return acc || (current.data && current.data.length > 0);
                }, false);
                return !value.isDeleted || hasData;
            }
            return false;
        }

        function customFieldFilter(value, index, array) {
            if (value.data && value.data.length > 0) {
                return true;
            }
            return !value.isDeleted;
        }

        function uploadAttachments(files) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { files: files },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        for (var i = 0; i < resp.data.length; i++) {
                            var file = resp.data[i];
                            var dtoModel = workOrderService.getEmptyWorkOrderAttachment();
                            dtoModel.workOrderId = self.updateModel.program.workOrderId;
                            dtoModel.externalOrderId = self.updateModel.program.id;
                            dtoModel.fileId = file.id;
                            dtoModel.changeState = 1;
                            dtoModel.fileFilepath = file.filepath + '?w=300&h=300&mode=crop';
                            dtoModel.fileName = file.name;
                            if (!self.updateModel.attachments) self.updateModel.attachments = [];
                            self.updateModel.attachments.push(dtoModel);
                        }
                        if (self.validation && self.validation.programForm) {
                            self.validation.programForm.$setDirty();
                        }
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function sendToInMemory(e) {
            return programService.transferProgramInMemory(self.updateModel.program.id).then(function (inMemoryResult) {
                if (inMemoryResult && inMemoryResult.statusCode === 'OK') {
                    self.updateModel.program.externalId = inMemoryResult.externalId;
                    self.updateModel.program.externalOrderId = inMemoryResult.url;
                    toastService.success($translate.instant('PROGRAMS.EDIT_PROGRAM.TRANSFER_IN_MEMORY_SUCCESS'));
                } else {
                    toastService.error($translate.instant('PROGRAMS.EDIT_PROGRAM.TRANSFER_IN_MEMORY_ERROR'));
                }
                return inMemoryResult;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .controller('EditProgramController', EditProgramController);

    /* @ngInject */
    function EditProgramController(
        $window,
        $scope,
        $translate,
        $stateParams,
        editProgramService,
        loadingService
    ) {
        var vm = this;

        vm.data = editProgramService;
        vm.loadingService = loadingService;
        vm.showAll = false;
        vm.defaultOVisibleOptions =
            'shouldUseAlternativeTitles, shouldUseEnglishTitles, shouldIncludePersonTitles, shouldIncludeComposers, shouldUseAlternateName, hasCustomPicture';
        vm.visibleOptions = vm.defaultOVisibleOptions;
        vm.toggleAllOptions = toggleAllOptions;

        // Init
        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editProgramService
                .loadProgram(
                    $stateParams.programId,
                    $stateParams.workOrder,
                    $stateParams.ceremony
                )
                .then(function () {
                    if (
                        vm.data.isNew ||
                        !vm.data.updateModel ||
                        !vm.data.updateModel.programElements ||
                        vm.data.updateModel.programElements.length === 0
                    ) {
                        vm.showAll = true;
                    }
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function exitView() {
            if (
                vm.data.validation &&
                vm.data.validation.programForm &&
                vm.data.validation.programForm.$dirty
            ) {
                if (
                    confirm(
                        $translate.instant(
                            'COMMON.DATA.UNSAVED_CHANGES_CONFIRM'
                        )
                    ) == true
                ) {
                    vm.data.validation.programForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            }
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editProgramService
                .saveUpdateModel(vm.data.updateModel)
                .then(function () {
                    if (
                        vm.data.validation &&
                        vm.data.validation.programForm &&
                        vm.data.validation.programForm.$dirty
                    ) {
                        vm.data.validation.programForm.$setPristine();
                    }
                    exitView();
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function toggleAllOptions() {
            if (vm.visibleOptions === vm.defaultOVisibleOptions) {
                vm.visibleOptions = null;
            } else {
                vm.visibleOptions = vm.defaultOVisibleOptions;
            }
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
                if (
                    vm.data.validation &&
                    vm.data.validation.programForm &&
                    vm.data.validation.programForm.$dirty
                ) {
                    if (
                        confirm(
                            $translate.instant(
                                'COMMON.DATA.UNSAVED_CHANGES_CONFIRM'
                            )
                        ) == true
                    ) {
                    } else {
                        event.preventDefault();
                        vm.loadingService.setBackgroundLoadingStatus(false);
                    }
                }
            }
        );
    }
})();

(function () {
    'use strict';

    angular
        .module('app.program')
        .controller('EditProgramToolbarController', EditProgramToolbarController);

    /* @ngInject */
    function EditProgramToolbarController(editProgramService, $window, $translate, loadingService) {
        var vm = this;
        vm.data = editProgramService;
        vm.loadingService = loadingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function exitView() {
            if (vm.data.validation && vm.data.validation.programForm && vm.data.validation.programForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.programForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editProgramService.saveUpdateModel(vm.data.updateModel).then(function () {
                if (vm.data.validation && vm.data.validation.programForm && vm.data.validation.programForm.$dirty) {
                    vm.data.validation.programForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

})();


(function() {
  "use strict";

  angular
    .module("app.program")
    .controller("EditProgramSidebarController", EditProgramSidebarController);

  /* @ngInject */
  function EditProgramSidebarController(
    $stateParams,
    editProgramService,
    baldrisApiBase,
    loadingService
  ) {
    var vm = this;
    vm.data = editProgramService;
    vm.loadingService = loadingService;

    vm.baldrisApiBase = baldrisApiBase;

    vm.saveAndStay = saveAndStay;
    vm.sendToInMemory = sendToInMemory;

    function saveAndStay() {
      vm.loadingService.setLoadingStatus(true);
      var isNew =
        !vm.data.updateModel.program ||
        vm.data.updateModel.program.id ||
        vm.data.updateModel.program.id === "new" ||
        vm.data.updateModel.program.id !==
          "00000000-0000-0000-0000-000000000000";

      editProgramService
        .saveUpdateModel(vm.data.updateModel)
        .then(function(savedUpdateModel) {
          if (
            vm.data.validation &&
            vm.data.validation.programForm &&
            vm.data.validation.programForm.$dirty
          ) {
            vm.data.validation.programForm.$setPristine();
          }
          if (!isNew) {
            vm.loadingService.setLoadingStatus(false);
          } else {
            editProgramService
              .loadProgram(savedUpdateModel.program.id)
              .then(function() {
                if (
                  vm.data.isNew ||
                  !vm.data.updateModel ||
                  !vm.data.updateModel.programElements ||
                  vm.data.updateModel.programElements.length === 0
                ) {
                  vm.showAll = true;
                }
                vm.loadingService.setLoadingStatus(false);
              });
          }
        })
        .catch(function(message) {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    function sendToInMemory() {
      vm.loadingService.setLoadingStatus(true);
      editProgramService
        .sendToInMemory()
        .then(function(result) {
          vm.loadingService.setLoadingStatus(false);
        })
        .catch(function(message) {
          vm.loadingService.setLoadingStatus(false);
        });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.product').factory('productService', productService);

    /* @ngInject */
    function productService($http, baldrisApiLegacyBase) {
        var baldrisApiBase = baldrisApiLegacyBase;
        var service = {
            getEmptyProduct: getEmptyProduct,
            getEmptyProductType: getEmptyProductType,
            getHighestProductCodeByProductType: getHighestProductCodeByProductType,
        };

        return service;

        function getEmptyProduct() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.ProductDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                productCode: null,
                supplierCode: null,
                name: null,
                nameAlternative: null,
                englishName: null,
                internalName: null,
                description: null,
                remarks: null,
                supplierId: null,
                supplier: null,
                departmentId: null,
                department: null,
                isStockedProduct: false,
                productStocks: null,
                isService: false,
                isRemoteOrder: false,
                productCost: null,
                price: null,
                isDiscontinued: false,
                balanceAccountId: null,
                balanceAccount: null,
                defaultSortOrder: 0,
                unitType: null,
                groupProductBy: null,
                productImageId: null,
                productImage: null,
                priceIncludingVat: null,
                vatId: '00000000-0000-0000-0000-000000000000',
                vat: null,
                productTypeId: null,
                productType: null,
                autoTasks: null,
                productImages: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getEmptyProductType() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.ProductTypeDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                description: null,
                categoryCode: null,
                iconName: null,
                isDeleted: false,
                imageId: null,
                imageFilepath: null,
                parentCategoryId: null,
                parentCategoryName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getHighestProductCodeByProductType(productTypeId) {
            return $http
                .get(baldrisApiBase + '/api//Products/GetHighestProductCode/' + productTypeId)
                .then(getHighestProductCodeByProductTypeComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getHighestProductCodeByProductType at "Products"')(message);
                });

            function getHighestProductCodeByProductTypeComplete(data, status, headers, config) {
                return data.data;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.product').controller('ProductsController', ProductsController);

    /* @ngInject */
    function ProductsController(
        $mdSidenav,
        $state,
        dataLegacyService,
        $mdDialog,
        $document,
        currentUser,
        $filter,
        productsViewService,
        productService,
        baldrisApiLegacyBase,
        fuseTheming
    ) {
        var dataService = dataLegacyService;
        var baldrisApiBase = baldrisApiLegacyBase;
        var vm = this;
        vm.fuseTheming = fuseTheming;
        vm.isLoadingProductTypes = true;
        vm.isLoadingProducts = true;
        vm.productTypes = [];
        vm.currentData = productsViewService.currentData;
        vm.addNewProduct = addNewProduct;
        vm.getCatalogUrl = getCatalogUrl;

        // Public Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProductType = selectProductType;
        vm.openEditProductTypeDialog = openEditProductTypeDialog;

        // INIT
        dataService.getAll('ProductTypes').then(function (productTypes) {
            vm.productTypes = $filter('orderBy')(productTypes, 'name');
            if (!vm.currentData.selectedProductType && $state.params.productTypeId) {
                for (var i = 0; i < vm.productTypes.length; i++) {
                    var productType = vm.productTypes[i];
                    if (productType.id === $state.params.productTypeId) {
                        vm.currentData.selectedProductType = productType;
                        break;
                    }
                }
            }
            if (vm.currentData.selectedProductType && !$state.params.productTypeId) {
                selectProductType(vm.currentData.selectedProductType);
            }
            if (!vm.currentData.selectedProductType && !$state.params.productTypeId && vm.productTypes && vm.productTypes.length > 0) {
                selectProductType(vm.productTypes[0]);
            }
        });

        dataService
            .getByUri('Reports', 'ByTemplatePath', {
                templatePath: 'Default/ProductCatalog.trdp',
            })
            .then(function (productCatalogReport) {
                vm.productCatalogReport = productCatalogReport;
            });

        dataService
            .getByUri('Reports', 'ByTemplatePath', {
                templatePath: 'Default/ProductCatalogByProductType.trdp',
            })
            .then(function (productCatalogByProductTypeReport) {
                vm.productCatalogByProductTypeReport = productCatalogByProductTypeReport;
            });

        // Private Methods

        function openEditProductTypeDialog(productTypeId, e) {
            return $mdDialog
                .show({
                    controller: 'EditProductTypeDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/product/dialogs/edit-product-type-dialog/edit-product-type-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        productTypeId: productTypeId,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updatedProductType) {
                    if (updatedProductType) {
                        addOrReplaceProductType(updatedProductType);
                    }
                    return updatedProductType;
                });
        }

        function addOrReplaceProductType(productType) {
            if (!vm.productTypes) vm.productTypes = [];
            for (var index = 0; index < vm.productTypes.length; index++) {
                var currentProductType = vm.productTypes[index];
                if (currentProductType.id === productType.id) {
                    vm.productTypes.splice(index, 1);
                    vm.productTypes.push(productType);
                    return;
                }
            }
            vm.productTypes.push(productType);
            selectProductType(productType);
        }
        function selectProductType(productType) {
            vm.currentData.selectedProductType = productType;
            $state.go('app.products.view', { productTypeId: productType.id });
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function addNewProduct(e) {
            var newProduct = productService.getEmptyProduct();
            newProduct.productTypeId = vm.currentData.selectedProductType.id;
            return openEditDialog(newProduct, e);
        }

        function openEditDialog(product, e) {
            return $mdDialog
                .show({
                    controller: 'EditProductDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/product/dialogs/edit-product-dialog/edit-product-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        product: angular.copy(product),
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updateModel) {
                    if (updateModel && updateModel.product) {
                        // reload current state
                        $state.reload();
                    }
                    return updateModel;
                });
        }

        function getCatalogUrl() {
            if (!vm.productCatalogReport) return null;
            return baldrisApiBase + '/api/Reports/AsPdf/' + vm.productCatalogReport.id + '/ProductTypeId/00000000-0000-0000-0000-000000000000';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.product')
        .factory('productsViewService', productsViewService);

    /* @ngInject */
    function productsViewService() {

        var currentData = {
            selectedProducts: [],
            selectedProductType: null,
            currentProducts: []
        };

        var service = {
            currentData: currentData
        };

        return service;       
        
    }
})();
(function () {
    'use strict';

    angular.module('app.privacy').controller('PrivacySearchController', PrivacySearchController);

    /* @ngInject */
    function PrivacySearchController($state, $mdSidenav, partyTypes, dataLegacyService, loadingService, fuseTheming) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.fuseTheming = fuseTheming;
        vm.partyTypes = partyTypes;

        vm.toggleSidenav = toggleSidenav;

        vm.selectPartyType = selectPartyType;
        vm.loadingService = loadingService;
        vm.navigateToPrivacyDetails = navigateToPrivacyDetails;
        vm.searchTermChanged = searchTermChanged;
        vm.showSsn = showSsn;

        // INIT
        reloadSearch();

        // METHODS

        function reloadSearch() {
            if (vm.searchTerm) {
                searchWorkOrders(null, vm.searchTerm, vm.selectedPartyType ? vm.selectedPartyType.id : null);
            }
        }

        function searchWorkOrders(partyDiscriminator, searchString, partyTypeId) {
            vm.loadingService.setLoadingStatus(true);
            var apiController = 'Persons';
            dataService.search(apiController, searchString, partyTypeId, 'partyTypeId').then(function (parties) {
                vm.searchResults = parties;
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function searchTermChanged() {
            reloadSearch();
        }

        function navigateToPrivacyDetails(party) {
            if (party.id) {
                $state.go('app.privacy.partyById.details', { partyId: party.id });
            }
        }

        function selectPartyType(partyType) {
            if (vm.selectedPartyType === partyType) {
                vm.selectedPartyType = null;
            } else {
                vm.selectedPartyType = partyType;
            }
            reloadSearch();
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function showSsn(party, e) {
            e.stopPropagation();
            party.showSsn = true;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.privacy').service('privacyFieldsService', privacyFieldsService);

    /* @ngInject */
    function privacyFieldsService($q, $state, dataLegacyService) {
        var dataService = dataLegacyService;
        var self = this;
        self.selectedWorkOrderType = null;
        self.currentLocations = [];

        self.addPrivacyField = addPrivacyField;
        self.loadPrivacyField = loadPrivacyField;
        self.getEmptyPrivacyField = getEmptyPrivacyField;
        self.getEmptyPrivacyFieldReport = getEmptyPrivacyFieldReport;
        self.savePrivacyField = savePrivacyField;

        function addPrivacyField(e) {
            if (self.selectedWorkOrderType) {
            }
        }

        function loadPrivacyField(privacyFieldId) {
            if (!privacyFieldId || privacyFieldId === 'new') {
                var privacyField = getEmptyPrivacyField();
                if (self.selectedWorkOrderType) {
                    privacyField.workOrderTypeId = self.selectedWorkOrderType.id;
                }
                return $q.when(privacyField);
            } else {
                return dataService.getById('PrivacyFields', privacyFieldId, true);
            }
        }

        function savePrivacyField(privacyField) {
            if (privacyField.id === '00000000-0000-0000-0000-000000000000') {
                privacyField.changeState = 1;
                return dataService.insertItem('PrivacyFields', privacyField);
            } else {
                privacyField.changeState = 2;
                return dataService.updateItem('PrivacyFields', privacyField);
            }
        }

        function getEmptyPrivacyField() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.PrivacyFieldDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                text: null,
                description: null,
                legalRemarks: null,
                discriminator: null,
                isDeleted: false,
                isRequired: false,
                sortOrder: 0,
                referencePersonTypeMask: 0,
                onlyWhenNoMatch: false,
                workOrderTypeId: null,
                workOrderTypeName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function getEmptyPrivacyFieldReport() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.PrivacyFieldReportDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                reportId: '00000000-0000-0000-0000-000000000000',
                reportName: null,
                privacyFieldId: '00000000-0000-0000-0000-000000000000',
                privacyFieldText: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.privacy").controller("PrivacyFieldsController", PrivacyFieldsController);

  /* @ngInject */
  function PrivacyFieldsController($state, $filter, $mdSidenav, $mdDialog, workOrderTypes, currentUser, privacyFieldsService, fuseTheming) {
    var vm = this;
    vm.workOrderTypes = workOrderTypes;
    vm.data = privacyFieldsService;
    vm.fuseTheming = fuseTheming;
    activate();

    function activate() {}

    vm.toggleSidenav = toggleSidenav;
    vm.openPreviewConsentFormDialog = openPreviewConsentFormDialog;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function openPreviewConsentFormDialog(e, targetForm) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        controller: "PreviewConsentFormDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/privacy/dialogs/preview-consent-form-dialog/preview-consent-form-dialog.tmpl.html",
        parent: parentEl,
        targetEvent: e,
        multiple: true,
        clickOutsideToClose: true,
        locals: {
          targetForm: targetForm
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.privacy').controller('PrivacyDetailsController', PrivacyDetailsController);

    /* @ngInject */
    function PrivacyDetailsController(
        $q,
        $scope,
        $window,
        $translate,
        $mdDialog,
        $stateParams,
        dataLegacyService,
        loadingService,
        referencePersonTypeOptions,
        privacyActions,
        fuseTheming
    ) {
        var dataService = dataLegacyService;
        var vm = this;
        vm.loadingService = loadingService;
        vm.fuseTheming = fuseTheming;
        vm.selectedTab = 'party';
        vm.selectedTabIndex = 0;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.activate = activate;
        vm.getReferencePersonTypesString = getReferencePersonTypesString;
        vm.openPseudomizePartyDialog = openPseudomizePartyDialog;
        vm.openDeletePartyDialog = openDeletePartyDialog;
        vm.getPrivacyActionString = getPrivacyActionString;
        vm.isPseudomized = isPseudomized;

        //////////
        // INIT

        activate();

        function activate(tab) {
            vm.selectedTab = tab || 'party';
            switch (tab) {
                case 'related-data':
                    vm.selectedTabIndex = 1;
                    loadRelatedData();
                    break;
                case 'export':
                    vm.selectedTabIndex = 2;
                    generateExportFile();
                    break;
                case 'log':
                    vm.selectedTabIndex = 3;
                    vm.privacyLogs = [];
                    vm.loadingService.setLoadingStatus(true);
                    dataService.getByPartyId('PrivacyLogs', $stateParams.partyId).then(function (privacyLogs) {
                        vm.privacyLogs = privacyLogs;
                        vm.loadingService.setLoadingStatus(false);
                    });
                    break;
                case 'party':
                default:
                    vm.selectedTabIndex = 0;
                    vm.loadingService.setLoadingStatus(true);
                    dataService.getUpdateModel('Parties', $stateParams.partyId).then(function (updateModel) {
                        vm.updateModel = updateModel;
                        vm.loadingService.setLoadingStatus(false);
                    });
            }
        }

        function isPseudomized() {
            if (!vm.updateModel || !vm.updateModel.party) return false;
            return vm.updateModel.party.privacyOptions & 32;
        }

        function openPseudomizePartyDialog(e) {
            var parentEl = angular.element(document.body);
            $mdDialog
                .show({
                    controller: 'PseudomizePartyDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/privacy/dialogs/pseudomize-party-dialog/pseudomize-party-dialog.tmpl.html',
                    parent: parentEl,
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        partyDto: vm.updateModel.party,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (response) {
                    if (response) {
                        vm.updateModel = {
                            party: response,
                        };
                    }
                });
        }

        function openDeletePartyDialog(e) {
            var parentEl = angular.element(document.body);
            $mdDialog
                .show({
                    controller: 'DeletePartyDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/privacy/dialogs/delete-party-dialog/delete-party-dialog.tmpl.html',
                    parent: parentEl,
                    targetEvent: e,
                    multiple: true,
                    locals: {
                        partyDto: vm.updateModel.party,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (response) {
                    if (response) {
                        vm.updateModel = {
                            party: response,
                        };
                    }
                });
        }

        function getPrivacyActionString(privacyAction) {
            return privacyActions[privacyAction];
        }

        function generateExportFile() {
            vm.loadingService.setLoadingStatus(true);
            vm.exportData = null;
            vm.exportModel = null;
            var promises = [];
            promises.push(dataService.getUpdateModel('Parties', $stateParams.partyId));
            promises.push(loadRelatedData(true));
            promises.push(dataService.getByPartyId('PrivacyLogs', $stateParams.partyId));

            $q.all(promises).then(function (response) {
                vm.exportModel = {
                    person: response[0].party,
                    addresses: response[0].addresses,
                    emails: response[0].emails,
                    telephones: response[0].telephones,
                    relatedData: {
                        workOrders: response[1][0],
                        customer: response[1][1],
                        invoices: response[1][2],
                        salesOrders: response[1][3],
                        graves: response[1][4],
                        calendarEvents: response[1][5],
                    },
                    accessLog: response[2],
                };
                vm.exportData = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(vm.exportModel));
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function loadRelatedData(shouldWaitForAll) {
            vm.workOrderReferencePersons = [];
            vm.customers = [];
            vm.invoices = [];
            vm.salesOrders = [];
            vm.graves = [];
            vm.calendarEvents = [];

            if (shouldWaitForAll) {
                vm.isLoadingRelatedData = true;
                var promises = [];

                promises.push(dataService.getByPartyId('WorkOrderReferencePersons', $stateParams.partyId));
                promises.push(dataService.getByPartyId('Customers', $stateParams.partyId));
                promises.push(dataService.getByPartyId('Invoices', $stateParams.partyId));
                promises.push(dataService.getByPartyId('SalesOrders', $stateParams.partyId));
                promises.push(dataService.getByPartyId('Graves', $stateParams.partyId));
                promises.push(dataService.getByPartyId('CalendarEvents', $stateParams.partyId));

                return $q.all(promises).then(function (response) {
                    vm.workOrderReferencePersons = response[0];
                    vm.customers = response[1];
                    vm.invoices = response[2];
                    vm.salesOrders = response[3];
                    vm.graves = response[4];
                    vm.calendarEvents = response[5];
                    vm.isLoadingRelatedData = false;
                    return response;
                });
            } else {
                vm.isLoadingWorkOrderReferencePersons = true;
                dataService.getByPartyId('WorkOrderReferencePersons', $stateParams.partyId).then(function (workOrderReferencePersons) {
                    vm.workOrderReferencePersons = workOrderReferencePersons;
                    vm.isLoadingWorkOrderReferencePersons = false;
                });

                vm.isLoadingCustomerRelationship = true;
                dataService.getByPartyId('Customers', $stateParams.partyId).then(function (customers) {
                    vm.customers = customers;
                    vm.isLoadingCustomerRelationship = false;
                });

                vm.isLoadingInvoices = true;
                dataService.getByPartyId('Invoices', $stateParams.partyId).then(function (invoices) {
                    vm.invoices = invoices;
                    vm.isLoadingInvoices = false;
                });

                vm.isLoadingSalesOrders = true;
                dataService.getByPartyId('SalesOrders', $stateParams.partyId).then(function (salesOrders) {
                    vm.salesOrders = salesOrders;
                    vm.isLoadingSalesOrders = false;
                });

                vm.isLoadingLeaseHolderResponsibility = true;
                dataService.getByPartyId('Graves', $stateParams.partyId).then(function (graves) {
                    vm.graves = graves;
                    vm.isLoadingLeaseHolderResponsibility = false;
                });

                vm.isLoadingCalendarEvents = true;
                dataService.getByPartyId('CalendarEvents', $stateParams.partyId).then(function (calendarEvents) {
                    vm.calendarEvents = calendarEvents;
                    vm.isLoadingCalendarEvents = false;
                });

                return $q.when(true);
            }
        }

        function exitView() {
            if (vm.validation && vm.validation.partyForm && vm.validation.partyForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.validation.partyForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            }
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            vm.updateModel.party.changeState = 2;
            dataService
                .updateFromUpdateModel('Parties', vm.updateModel)
                .then(function (updatedModel) {
                    if (vm.validation && vm.validation.partyForm && vm.validation.partyForm.$dirty) {
                        vm.validation.partyForm.$setPristine();
                        vm.updateModel = updatedModel;
                    }
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function getReferencePersonTypesString(referencePersonType) {
            var referencePersonTypeArray = [];
            angular.forEach(referencePersonTypeOptions, function (option) {
                if (referencePersonType & option.value) {
                    referencePersonTypeArray.push(option.text);
                }
            });
            if (referencePersonTypeArray.length === 0) return null;
            var returnString = referencePersonTypeArray.reduce(function (previousValue, currentValue) {
                if (previousValue === '') return $translate.instant(currentValue);
                return previousValue + ', ' + $translate.instant(currentValue);
            }, '');
            return returnString;
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (vm.validation && vm.validation.partyForm && vm.validation.partyForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                } else {
                    event.preventDefault();
                    loadingService.setBackgroundLoadingStatus(false);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.obituaryNotice').factory('obituaryNoticeService', obituaryNoticeService);

    /* @ngInject */
    function obituaryNoticeService($http, baldrisApiBase) {
        var service = {
            getEmptyObituaryNotice: getEmptyObituaryNotice,
            getEmptyObituaryNoticeFieldTypeShort: getEmptyObituaryNoticeFieldTypeShort,
            getEmptyObituaryNoticeFieldShort: getEmptyObituaryNoticeFieldShort,
            getEmptyObituaryNoticeField: getEmptyObituaryNoticeField,
            getAdstateDataByDeceasedId: getAdstateDataByDeceasedId,
            retrieveFromAdstateByWorkOrderId: retrieveFromAdstateByWorkOrderId,
            updateFromAdstateEntry: updateFromAdstateEntry,
            createFromAdstateEntry: createFromAdstateEntry,
        };

        return service;

        function getEmptyObituaryNoticeField() {
            return {
                fieldValue: null,
                sortOrder: 0,
                remarks: null,
                imageId: null,
                image: null,
                obituaryNoticeTemplateId: null,
                obituaryNoticeId: null,
                obituaryNoticeFieldTypeId: null,
            };
        }

        function getEmptyObituaryNoticeFieldShort() {
            return {
                fieldValue: null,
                sortOrder: 0,
                imageId: null,
                imageFilepath: null,
                obituaryNoticeTemplateId: null,
                obituaryNoticeId: null,
                obituaryNoticeFieldTypeId: null,
            };
        }

        function getEmptyObituaryNoticeFieldTypeShort() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.Shorts.ObituaryNoticeFieldTypeShortDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                externalIdentifier: null,
                fieldType: 0,
                sortOrder: 0,
                iconName: null,
                fontStyleId: null,
                fontStyle: null,
                obituaryNoticeTypeId: null,
                obituaryNoticeType: null,
            };
        }

        function getEmptyObituaryNotice() {
            return {
                publishTime: null,
                externalTemplateName: null,
                noticeWidth: null,
                noticeHeight: null,
                price: null,
                cost: null,
                currency: null,
                previewUrl: null,
                columns: null,
                classified: null,
                previewFileId: null,
                previewFile: null,
                obituaryNoticeTypeId: null,
                obituaryNoticeType: null,
                obituaryNoticeTemplateId: null,
                obituaryNoticeTemplate: null,
                fields: [],
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                finalizedBy: null,
                supplierId: null,
                supplier: null,
                workOrderId: null,
                workOrder: null,
                externalOrderTypeId: null,
                externalOrderType: null,
                deliveryTime: null,
                deliveryLocationId: null,
                deliveryLocation: null,
                alternateDeliveryAddressId: null,
                alternateDeliveryAddress: null,
                deceasedId: null,
                deceased: null,
                ceremonyId: null,
                ceremony: null,
                details: [],
                orderStatuses: [],
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
            };
        }

        function getAdstateDataByDeceasedId(deceasedId) {
            return $http
                .get(baldrisApiBase + '/api/AdState/AdStateData/ByDeceasedId/' + deceasedId)
                .then(getAdstateDataByDeceasedIdComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getAdstateDataByDeceasedId at "ObituaryNotices"')(message);
                });

            function getAdstateDataByDeceasedIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function retrieveFromAdstateByWorkOrderId(workOrderId) {
            return $http
                .get(baldrisApiBase + '/api/AdState/ExternalService/RetrieveByWorkOrderId/' + workOrderId)
                .then(retrieveFromAdstateByWorkOrderIdComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for retrieveFromAdstateByWorkOrderId at "ObituaryNotices"')(message);
                });

            function retrieveFromAdstateByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateFromAdstateEntry(updateObituaryNoticeFromAdstateAdCommand) {
            return $http
                .put(baldrisApiBase + '/api/ObituaryNotices/FromAdstateAd', updateObituaryNoticeFromAdstateAdCommand)
                .then(updateFromAdstateEntryComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for updateFromAdstateEntryComplete at "ObituaryNotices"')(message);
                });

            function updateFromAdstateEntryComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function createFromAdstateEntry(createObituaryNoticeFromAdstateAdCommand) {
            return $http
                .post(baldrisApiBase + '/api/ObituaryNotices/FromAdstateAd', createObituaryNoticeFromAdstateAdCommand)
                .then(createFromAdstateEntryComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for createFromAdstateEntryComplete at "ObituaryNotices"')(message);
                });

            function createFromAdstateEntryComplete(data, status, headers, config) {
                return data.data;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.obituaryNotice').service('editObituaryNoticeService', editObituaryNoticeService);

    /* @ngInject */
    function editObituaryNoticeService($q, dataService, editCustomFieldService, obituaryNoticeService, Upload, baldrisApiBase, workOrderService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadObituaryNotice = loadObituaryNotice;
        self.saveUpdateModel = saveUpdateModel;
        self.uploadPreviewImage = uploadPreviewImage;
        self.removePreviewFile = removePreviewFile;
        self.uploadAttachments = uploadAttachments;

        function loadObituaryNotice(obituaryNoticeId, obituaryNoticeTypeId, workOrderId, deceasedId) {
            reset();
            if (!obituaryNoticeId || obituaryNoticeId === 'new') {
                self.updateModel = {
                    obituaryNotice: obituaryNoticeService.getEmptyObituaryNotice(),
                    attachments: [],
                };
                self.updateModel.obituaryNotice.obituaryNoticeTypeId = obituaryNoticeTypeId;
                self.updateModel.obituaryNotice.workOrderId = workOrderId;
                self.updateModel.obituaryNotice.deceasedId = deceasedId || null;
                return $q.when(self.updateModel);
            } else {
                var promises = [];
                promises.push(dataService.getById('ObituaryNotices', obituaryNoticeId));
                promises.push(dataService.getByUri('WorkOrderAttachments', 'ByExternalOrderId/' + obituaryNoticeId));
                return $q.all(promises).then(function (response) {
                    self.updateModel = {
                        obituaryNotice: response[0],
                        attachments: response[1],
                    };
                });
            }
        }
        function saveUpdateModel(updateModel) {
            if (
                !updateModel.obituaryNotice.id ||
                updateModel.obituaryNotice.id === 'new' ||
                updateModel.obituaryNotice.id === '00000000-0000-0000-0000-000000000000'
            ) {
                return dataService.insertItem('ObituaryNotices', updateModel.obituaryNotice).then(function (insertedObituaryNotice) {
                    return insertedObituaryNotice;
                });
            }
            //updateModel.detailsData = editCustomFieldService.extractDataFromCategories(updateModel.customFieldCategories);
            return dataService.updateItem('ObituaryNotices', updateModel.obituaryNotice).then(function () {
                return updateModel.obituaryNotice;
            });
        }

        function initUpdateModel(updateModel) {
            return $q.when(mergeTypesWithFields(updateModel));
        }

        function mergeTypesWithFields(updateModel) {
            var fieldTypeCollection = [];
            if (updateModel.obituaryNoticeType && updateModel.obituaryNoticeType.fields && updateModel.obituaryNoticeType.fields.length > 0) {
                fieldTypeCollection = updateModel.obituaryNoticeType.fields;
            }
            // Attach notice fields to fieldTypes
            if (updateModel.obituaryNoticeFields && updateModel.obituaryNoticeFields.length > 0) {
                for (var fieldIndex = 0; fieldIndex < updateModel.obituaryNoticeFields.length; fieldIndex++) {
                    var field = updateModel.obituaryNoticeFields[fieldIndex];
                    var typeFound = false;
                    // Check if field is in collection
                    for (var typeIndex = 0; typeIndex < fieldTypeCollection.length; typeIndex++) {
                        var type = fieldTypeCollection[typeIndex];
                        if (field.obituaryNoticeFieldTypeId === type.id) {
                            typeFound = true;
                            type.data = field;
                        }
                    }
                    if (!typeFound) {
                        var type = field.obituaryNoticeFieldType;
                        type.data = field;
                        fieldTypeCollection.push(type);
                    }
                }
            }

            // Add empty fields to fieldTypes without data
            for (var typeIndex = 0; typeIndex < fieldTypeCollection.length; typeIndex++) {
                var type = fieldTypeCollection[typeIndex];
                if (!type.data) {
                    type.data = obituaryNoticeService.getEmptyObituaryNoticeField();
                }
            }

            updateModel.fieldTypeCollection = fieldTypeCollection;

            return updateModel;
        }

        function uploadPreviewImage(file) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { file: file },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length === 1) {
                        var baldrisFile = resp.data[0];
                        self.updateModel.obituaryNotice.previewFileId = baldrisFile.id;
                        self.updateModel.obituaryNotice.previewFileFilepath = baldrisFile.filepath;
                        if (self.validation && self.validation.obituaryNoticeForm) {
                            self.validation.obituaryNoticeForm.$setDirty();
                        }
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function uploadAttachments(files) {
            Upload.upload({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                data: { files: files },
            }).then(
                function (resp) {
                    if (resp && resp.data && resp.data.length > 0) {
                        for (var i = 0; i < resp.data.length; i++) {
                            var file = resp.data[i];
                            var dtoModel = workOrderService.getEmptyWorkOrderAttachment();
                            dtoModel.workOrderId = self.updateModel.obituaryNotice.workOrderId;
                            dtoModel.externalOrderId = self.updateModel.obituaryNotice.id;
                            dtoModel.fileId = file.id;
                            dtoModel.changeState = 1;
                            dtoModel.fileFilepath = file.filepath + '?w=300&h=300&mode=crop';
                            dtoModel.fileName = file.name;
                            if (!self.updateModel.attachments) self.updateModel.attachments = [];
                            self.updateModel.attachments.push(dtoModel);
                        }
                        if (self.validation && self.validation.obituaryNoticeForm) {
                            self.validation.obituaryNoticeForm.$setDirty();
                        }
                    }
                },
                function (resp) {
                    console.log('Error status: ' + resp.status);
                }
            );
        }

        function removePreviewFile() {
            self.updateModel.obituaryNotice.previewFileId = null;
            self.updateModel.obituaryNotice.previewFileFilepath = null;
            if (self.validation && self.validation.obituaryNoticeForm) {
                self.validation.obituaryNoticeForm.$setDirty();
            }
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            if (self.validation && self.validation.obituaryNoticeForm && self.validation.obituaryNoticeForm.$dirty) {
                self.validation.obituaryNoticeForm.$setPristine();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.obituaryNotice')
        .controller('EditObituaryNoticeController', EditObituaryNoticeController);

    /* @ngInject */
    function EditObituaryNoticeController($window, $stateParams, editObituaryNoticeService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editObituaryNoticeService;

        // Init
        activate();

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editObituaryNoticeService.loadObituaryNotice($stateParams.obituaryNoticeId, $stateParams.obituaryNoticeTypeId, $stateParams.workOrderId, $stateParams.deceasedId).then(function() {
                vm.loadingService.setLoadingStatus(false);
            }).catch(function(message) {
                vm.loadingService.setLoadingStatus(false);
                });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            editObituaryNoticeService.saveUpdateModel(vm.data.updateModel).then(function () {
                exitView();
            }).catch(function(message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

    angular
        .module('app.obituaryNotice')
        .controller('EditObituaryNoticeToolbarController', EditObituaryNoticeToolbarController);

    /* @ngInject */
    function EditObituaryNoticeToolbarController($window, $translate, editObituaryNoticeService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editObituaryNoticeService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT


        function exitView() {
            if (vm.data.validation && vm.data.validation.obituaryNoticeForm && vm.data.validation.obituaryNoticeForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.obituaryNoticeForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editObituaryNoticeService.saveUpdateModel(vm.data.updateModel).then(function () {
                if (vm.data.validation && vm.data.validation.obituaryNoticeForm && vm.data.validation.obituaryNoticeForm.$dirty) {
                    vm.data.validation.obituaryNoticeForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

    angular
        .module('app.obituaryNotice')
        .controller('EditObituaryNoticeSidebarController', EditObituaryNoticeSidebarController);

    /* @ngInject */
    function EditObituaryNoticeSidebarController(editObituaryNoticeService, loadingService, Upload, baldrisApiBase) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editObituaryNoticeService;


    }

} ());
(function () {
    'use strict';

    angular.module('app.noteOrTask').factory('noteOrTaskService', noteOrTaskService);

    /* @ngInject */
    function noteOrTaskService($http, $q, $filter, exception, baldrisApiBase) {
        var eventTypes;

        var service = {
            canToggleTask: canToggleTask,
            createHourGroups: createHourGroups,
            getAllNoteOrTaskTypes: getAllNoteOrTaskTypes,
            getAllTaskQueues: getAllTaskQueues,
            getEmptyNoteOrTask: getEmptyNoteOrTask,
            getEmptyWorkOrderNoteOrTask: getEmptyWorkOrderNoteOrTask,
            getEmptyCalendarNoteOrTask: getEmptyCalendarNoteOrTask,
            getEmptyNoteOrTaskUser: getEmptyNoteOrTaskUser,
            toggleTask: toggleTask,
        };

        return service;

        function getAllNoteOrTaskTypes(includeSoftDeleted) {
            includeSoftDeleted = includeSoftDeleted || false;
            return $http
                .get(baldrisApiBase + '/api/NoteOrTaskTypes', {
                    params: {
                        includeSoftDeleted: includeSoftDeleted,
                    },
                })
                .then(getAllNoteOrTaskTypesComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getAllNoteOrTaskTypes')(message);
                    return $q.reject(message);
                });

            function getAllNoteOrTaskTypesComplete(data) {
                return data.data;
            }
        }

        function getAllTaskQueues() {
            return $http
                .get(baldrisApiBase + '/api/TaskQueues')
                .then(getAllTaskQueuesComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for getAllTaskQueues')(message);
                    return $q.reject(message);
                });

            function getAllTaskQueuesComplete(data) {
                return data.data;
            }
        }

        function canToggleTask(task) {
            return $http
                .get(baldrisApiBase + '/api/NoteOrTasks/' + task.id + '/CanToggle')
                .then(canToggleTaskComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for canToggleTask')(message);
                });

            function canToggleTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function toggleTask(task) {
            return $http
                .put(baldrisApiBase + '/api/NoteOrTasks/' + task.id + '/Toggle')
                .then(toggleTaskComplete)
                .catch(function (message) {
                    exception.catcher('XHR Failed for toggleTask')(message);
                });

            function toggleTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getEmptyNoteOrTask(modelType) {
            return {
                modelType: modelType,
                subject: null,
                text: null,
                createdByUserId: null,
                tab: null,
                options: 'none',
                noteOrTaskTypeId: null,
                workOrderId: null,
                calendarEventId: null,
                externalOrderId: null,
                isSticky: false,
                startTime: null,
                endTime: null,
                recurrencePattern: null,
                exceptionNoteOrTasks: null,
                imageId: null,
                isCompleted: false,
                dueTime: null,
                taskOutcomeId: null,
                taskQueueId: null,
            };
        }

        function getEmptyWorkOrderNoteOrTask() {
            return getEmptyNoteOrTask('WorkOrderNoteOrTask');
        }

        function getEmptyCalendarNoteOrTask() {
            return getEmptyNoteOrTask('CalendarNoteOrTask');
        }

        function getEmptyNoteOrTaskUser() {
            return {
                sortOrder: 0,
                hasCompletedTask: false,
                completedTaskDate: null,
                remarks: null,
                userId: null,
                noteOrTaskId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function createHourGroups(events, shouldCreateAllWorkHourGroups) {
            var hourGroups = [];
            // sort events
            events = $filter('orderBy')(events, 'start', false);

            var createdHours = [];
            shouldCreateAllWorkHourGroups = shouldCreateAllWorkHourGroups || false;
            if (shouldCreateAllWorkHourGroups) {
                //Allday-group
                hourGroups.push({
                    moment: moment().startOf('day'),
                    from: -1,
                    isAllDay: true,
                    to: 0,
                });
                createdHours.push(-1);
                //Create groups from 8-16
                var step;
                for (step = 8; step < 17; step++) {
                    hourGroups.push({
                        moment: moment().hour(step).minute(0),
                        from: step,
                        isAllDay: false,
                        to: step + 1,
                    });
                    createdHours.push(step);
                }
            }

            // make groups
            angular.forEach(events, function (event) {
                var startMoment = moment(event.start);
                var nextDayMoment = startMoment.add(1, 'days');
                var endMoment = moment(event.end);
                var hour = startMoment.hour();

                if (event.isAllDay || endMoment.isSameOrAfter(nextDayMoment)) {
                    hour = -1;
                }

                //Check that the group havent been created
                if (createdHours.indexOf(hour) === -1) {
                    if (hour === -1) {
                        hourGroups.push({
                            moment: startMoment.startOf('day'),
                            from: hour,
                            isAllDay: true,
                            to: hour + 1,
                        });
                    } else {
                        hourGroups.push({
                            moment: startMoment.startOf('hour'),
                            isAllDay: false,
                            from: hour,
                            to: hour + 1,
                        });
                    }

                    createdHours.push(hour);
                }
            });

            //Put events in groups
            angular.forEach(hourGroups, function (group) {
                group.events = $filter('hourGroup')(events, group);
            });

            return hourGroups;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.noteOrTask')
        .factory('noteOrTaskViewService', noteOrTaskViewService);

    /* @ngInject */
    function noteOrTaskViewService($filter, noteOrTaskOptions) {
        var service = {
            createNoteOrTaskGroups: createNoteOrTaskGroups,
            createDateGroups: createDateGroups,
            createWorkOrderGroups: createWorkOrderGroups,
            createGroupForNoteOrTask: createGroupForNoteOrTask,
        };

        return service;

        function createNoteOrTaskGroups(
            noteOrTasks,
            shouldCreateEmptyGroups,
            shouldCreateDateGroups
        ) {
            shouldCreateEmptyGroups = shouldCreateEmptyGroups || false;
            shouldCreateDateGroups = shouldCreateDateGroups || false;
            var noteOrTaskGroups = [];
            noteOrTaskGroups.push(createUncompletedGroup());
            noteOrTaskGroups.push(createCompletedGroup());
            noteOrTaskGroups.push(createNoteGroup());

            //Put notes and tasks in groups
            angular.forEach(noteOrTaskGroups, function (group) {
                group.noteOrTasks = $filter('noteOrTaskGroup')(
                    noteOrTasks,
                    group
                );
                if (shouldCreateDateGroups) {
                    group.dateGroups = createDateGroups(group.noteOrTasks);
                }
            });

            return noteOrTaskGroups;
        }

        function createGroupForNoteOrTask(noteOrTask) {
            //Completed task
            var group = null;
            if (
                noteOrTask.options &&
                noteOrTask.options.indexOf('isTask') > -1 &&
                noteOrTask.isCompleted &&
                noteOrTaskGroup.isCompletedGroup
            ) {
                group = createCompletedGroup();
            }

            //Uncompleted task
            if (
                noteOrTask.options &&
                noteOrTask.options.indexOf('isTask') > -1 &&
                !noteOrTask.isCompleted &&
                noteOrTaskGroup.isUncompletedGroup
            ) {
                group = createUncompletedGroup();
            }

            //Follow-up
            if (
                noteOrTask.options &&
                noteOrTask.options.indexOf('isFollowUp') > -1 &&
                noteOrTaskGroup.isFollowUpGroup
            ) {
                group = createFollowUpGroup();
            }

            //Note
            if (
                !(
                    noteOrTask.options &&
                    noteOrTask.options.indexOf('isTask') > -1
                ) &&
                !(
                    noteOrTask.options &&
                    noteOrTask.options.indexOf('isFollowUp') > -1
                ) &&
                noteOrTaskGroup.isNoteGroup
            ) {
                group = createNoteGroup();
            }

            group.noteOrTasks = [];
            group.push(noteOrTask);
        }

        function createUncompletedGroup() {
            return {
                title: 'NOTE_OR_TASKS.MENU.UNCOMPLETED_TASKS',
                sortOrder: 0,
                isCompletedGroup: false,
                isUncompletedGroup: true,
                isNoteGroup: false,
                isFollowUpGroup: false,
                noteOrTasks: [],
            };
        }

        function createCompletedGroup() {
            return {
                title: 'NOTE_OR_TASKS.MENU.COMPLETED_TASKS',
                isCompletedGroup: true,
                isUncompletedGroup: false,
                sortOrder: 2,
                isNoteGroup: false,
                isFollowUpGroup: false,
                noteOrTasks: [],
            };
        }

        function createNoteGroup() {
            return {
                title: 'NOTE_OR_TASKS.MENU.NOTES',
                sortOrder: 1,
                isCompletedGroup: false,
                isUncompletedGroup: false,
                isNoteGroup: true,
                isFollowUpGroup: false,
                noteOrTasks: [],
            };
        }

        function createFollowUpGroup() {
            return {
                title: 'NOTE_OR_TASKS.MENU.FOLLOW_UP',
                sortOrder: 1,
                isCompletedGroup: false,
                isUncompletedGroup: false,
                isNoteGroup: false,
                isFollowUpGroup: true,
                noteOrTasks: [],
            };
        }

        function createDateGroups(
            noteOrTasks,
            shouldCreateEmptyDateGroups,
            startDate,
            endDate
        ) {
            shouldCreateEmptyDateGroups = shouldCreateEmptyDateGroups || false;

            var dateGroups = [];
            // sort events
            noteOrTasks = $filter('orderBy')(noteOrTasks, 'startTime', false);

            var createdDates = [];

            if (shouldCreateEmptyDateGroups) {
                // TODO: Add functionality for creating empty dates
            }

            // make groups
            angular.forEach(noteOrTasks, function (noteOrTask) {
                if (noteOrTask.startTime) {
                    var startMoment = moment(noteOrTask.startTime);
                    var dateString = startMoment.format('YYYYMMDD');

                    //Check that the group haven't been created
                    if (createdDates.indexOf(dateString) === -1) {
                        dateGroups.push({
                            start: startMoment
                                .startOf('day')
                                .format('YYYY-MM-DDTHH:mm:ss'),
                            end: startMoment
                                .endOf('day')
                                .format('YYYY-MM-DDTHH:mm:ss'),
                            week: startMoment.format('w'),
                        });

                        createdDates.push(startMoment.format('YYYYMMDD'));
                    }
                } else if (noteOrTask.dueTime) {
                    // Check for dueTime
                    var startMoment = moment(noteOrTask.dueTime);
                    var dateString = startMoment.format('YYYYMMDD');

                    //Check that the group haven't been created
                    if (createdDates.indexOf(dateString) === -1) {
                        dateGroups.push({
                            start: startMoment
                                .startOf('day')
                                .format('YYYY-MM-DDTHH:mm:ss'),
                            end: startMoment
                                .endOf('day')
                                .format('YYYY-MM-DDTHH:mm:ss'),
                            week: startMoment.format('w'),
                        });

                        createdDates.push(startMoment.format('YYYYMMDD'));
                    }
                } else {
                    // Unknown start time
                    //Check that the group haven't been created
                    if (createdDates.indexOf('UNKNOWN') === -1) {
                        dateGroups.push({
                            start: null,
                            end: null,
                            week: null,
                            label: 'CALENDAR.EVENT.UNKNOWN_START_TIME',
                        });

                        createdDates.push('UNKNOWN');
                    }
                }
            });

            //Put events in groups
            angular.forEach(dateGroups, function (group) {
                group.noteOrTasks = $filter('dateGroup')(noteOrTasks, group);
                group.noteOrTaskGroups = createNoteOrTaskGroups(
                    group.noteOrTasks,
                    false
                );
            });

            return dateGroups;
        }

        function createWorkOrderGroups(noteOrTasks) {
            var workOrderGroups = [];
            // sort events
            noteOrTasks = $filter('orderBy')(noteOrTasks, 'workOrderId', false);

            var createdWorkOrderIds = [];

            // make groups
            angular.forEach(noteOrTasks, function (noteOrTask) {
                if (noteOrTask.workOrderId) {
                    //Check that the group haven't been created
                    if (
                        createdWorkOrderIds.indexOf(noteOrTask.workOrderId) ===
                        -1
                    ) {
                        workOrderGroups.push({
                            workOrderDeceasedSerialized:
                                noteOrTask.workOrderDeceasedSerialized,
                            workOrderFirstCeremonyAttendeesSerialized:
                                noteOrTask.workOrderFirstCeremonyAttendeesSerialized,
                            workOrderFirstCeremonyLocationSerialized:
                                noteOrTask.workOrderFirstCeremonyLocationSerialized,
                            workOrderFirstCeremonyStartTime:
                                noteOrTask.workOrderFirstCeremonyStartTime,
                            workOrderFirstCeremonyTypeColor:
                                noteOrTask.workOrderFirstCeremonyTypeColor,
                            workOrderFirstCeremonyTypeIconName:
                                noteOrTask.workOrderFirstCeremonyTypeIconName,
                            workOrderFirstCeremonyTypeName:
                                noteOrTask.workOrderFirstCeremonyTypeName,
                            workOrderId: noteOrTask.workOrderId,
                            workOrderOrderCode: noteOrTask.workOrderOrderCode,
                            workOrderTypeName: noteOrTask.workOrderTypeName,
                        });

                        createdWorkOrderIds.push(noteOrTask.workOrderId);
                    }
                }
            });

            //Put events in groups
            angular.forEach(workOrderGroups, function (group) {
                group.noteOrTasks = noteOrTasks.filter(function (noteOrTask) {
                    return noteOrTask.workOrderId === group.workOrderId;
                });
                group.noteOrTaskGroups = createNoteOrTaskGroups(
                    group.noteOrTasks,
                    false
                );
            });

            return workOrderGroups;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.noteOrTask').filter('noteOrTaskGroup', noteOrTaskGroup);

    /* @ngInject */
    function noteOrTaskGroup(noteOrTaskOptions) {
        return noteOrTaskGroupFilter;

        ////////////////

        function noteOrTaskGroupFilter(noteOrTasks, noteOrTaskGroup) {
            return noteOrTasks.filter(function (noteOrTask) {
                //Completed task
                if (
                    noteOrTask.options &&
                    noteOrTask.options.indexOf('isTask') > -1 &&
                    noteOrTask.isCompleted &&
                    noteOrTaskGroup.isCompletedGroup
                ) {
                    return noteOrTask;
                }

                //Uncompleted task
                if (
                    noteOrTask.options &&
                    noteOrTask.options.indexOf('isTask') > -1 &&
                    !noteOrTask.isCompleted &&
                    noteOrTaskGroup.isUncompletedGroup
                ) {
                    return noteOrTask;
                }

                //Follow-up
                if (
                    noteOrTask.options &&
                    noteOrTask.options.indexOf('isFollowUp') > -1 &&
                    noteOrTaskGroup.isFollowUpGroup
                ) {
                    return noteOrTask;
                }

                //Note
                if (
                    !(
                        noteOrTask.options &&
                        noteOrTask.options.indexOf('isTask') > -1
                    ) &&
                    !(
                        noteOrTask.options &&
                        noteOrTask.options.indexOf('isFollowUp') > -1
                    ) &&
                    noteOrTaskGroup.isNoteGroup
                ) {
                    return noteOrTask;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.home', [

        ]);
})(); 
(function () {
    'use strict';

    angular.module('app.home').service('homeService', homeService);

    /* @ngInject */
    function homeService($q, dataService, noteOrTaskOptions, accountService) {
        var self = this;
        self.loadData = loadData;

        self.upcomingEvents = [];
        self.noteOrTasks = [];
        self.workOrderNoteOrTasks = [];
        self.workOrders = [];

        self.isLoadingEvents = false;
        self.isLoadingNoteOrTasks = false;
        self.isLoadingWorkOrders = false;

        function loadData(fromDate, toDate, currentUser) {
            self.isLoadingEvents = accountService.canReadCalendarEvents();
            self.isLoadingNoteOrTasks = accountService.canReadCalendarEvents();
            self.isLoadingWorkOrders = accountService.canReadWorkOrders();
            self.isLoadingWorkOrderNoteOrTasks = accountService.canReadWorkOrders();

            // reset
            self.upcomingEvents = [];
            self.noteOrTasks = [];
            self.workOrders = [];

            if (self.isLoadingEvents) {
                dataService
                    .getByUri('CalendarEvents', 'BetweenDates', {
                        startDate: fromDate,
                        endDate: toDate,
                        userId: currentUser.id,
                    })
                    .then(function (upcomingEvents) {
                        self.upcomingEvents = upcomingEvents;
                        self.isLoadingEvents = false;
                    });
            }

            if (self.isLoadingNoteOrTasks) {
                var calendarFromDate = moment(fromDate).add(-14, 'days').format('YYYY-MM-DDTHH:mm:ss');
                dataService
                    .getByUri('NoteOrTasks', 'BetweenDates', {
                        startDate: fromDate,
                        endDate: toDate,
                        userId: currentUser.id,
                    })
                    .then(function (noteOrTasks) {
                        self.noteOrTasks = noteOrTasks;
                        self.isLoadingNoteOrTasks = false;
                    });
            }

            if (self.isLoadingWorkOrders) {
                dataService
                    .getByUri('WorkOrders', 'Items', {
                        caseWorkerId: currentUser.id,
                        pageSize: 10,
                    })
                    .then(function (workOrders) {
                        self.workOrders = workOrders;
                        self.isLoadingWorkOrders = false;
                    });
            }
        }

        function filterOldNotesAndTask(collection, cutOffDate) {
            if (!collection || collection.length === 0 || !cutOffDate) return [];
            return collection.filter(function (noteOrTask) {
                if (noteOrTask.$type === 'Baldris.Core.Data.Entities.Fdo.CalendarNoteOrTaskFdo') {
                    if ((moment(noteOrTask.startTime).isSameOrAfter(cutOffDate), 'day')) return true;
                    if (noteOrTask.options & noteOrTaskOptions.IS_TASK.value && !noteOrTask.isCompleted) return true;
                    return false;
                } else {
                    // Assume it's a workOrderNoteOrTask
                    if (noteOrTask.options & noteOrTaskOptions.IS_TASK.value && !noteOrTask.dueTime && !noteOrTask.isCompleted) return true;
                    if ((moment(noteOrTask.dueTime).isSameOrAfter(cutOffDate), 'day')) return true;
                    return false;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.grooming').factory('groomingService', groomingService);

    /* @ngInject */
    function groomingService() {
        var service = {
            getEmptyGrooming: getEmptyGrooming,
        };

        return service;

        function getEmptyGrooming() {
            return {
                subject: null,
                text: null,
                attendanceTime: null,
                start: null,
                end: null,
                isAllDay: false,
                internalType: null,
                internalId: null,
                recurrencePattern: null,
                exceptionAppointments: null,
                attendeesMustRsvp: false,
                remarks: null,
                options: 'none',
                billTo: 'unknown',
                calendarEventTypeId: null,
                isCompleted: false,
                completedTime: null,
                completedById: null,
                workOrderId: null,
                hostId: null,
                reservationId: null,
                locationId: null,
                locationRemarks: null,
                addressId: null,
                addressRemarks: null,
                supplierId: null,
                remarksSupplier: null,
                confirmedById: null,
                confirmedDate: null,
                isConfirmed: false,
                confirmationRemarks: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                distance: null,
                driverHours: null,
                additionalHours: null,
                price: null,
                additionalCost: null,
                priceRemarks: null,
                isTransportTaxed: false,
                transportDescription: null,
                originId: null,
                originRemarks: null,
                originSerialized: null,
                destinationId: null,
                destinationRemarks: null,
                destinationSerialized: null,
                helpersFamily: null,
                helpersFuneralHome: null,
                helpersRemarks: null,
                transportById: null,
                transportBySerialized: null,
                casketEquipmentId: null,
                casketEquipmentSerialized: null,
                noteOnPhysician: null,
                clothingId: null,
                clothingSerialized: null,
                personalClothing: null,
                personalBelongings: null,
                groomingDescription: null,
            };
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.grooming").service("editGroomingService", editGroomingService);

  /* @ngInject */
  function editGroomingService(
    $q,
    dataService,
    calendarService,
    locationService,
    editCustomFieldService,
    groomingService,
    baldrisConfigService,
    deceasedService
  ) {
    var self = this;
    var transportConfigs = null;
    var transportCalculationConfig = {
      isSet: false,
      startAmount: 0,
      distanceAmount: 0,
      minimumAmount: 0,
      hoursAmount: 0,
      additionalHoursAmount: 0
    };

    self.updateModel = null;
    self.isNew = false;
    self.options = calendarService.options;

    self.loadGrooming = loadGrooming;
    self.saveGrooming = saveGrooming;
    self.getGroomingString = getGroomingString;
    self.calculatePrice = calculatePrice;
    self.registerPrice = registerPrice;
    self.isTransport = isTransport;
    self.onIsCompletedChange = onIsCompletedChange;

    function loadGrooming(
      groomingId,
      workOrderId,
      deceased,
      calendarEventTypeId,
      calendarEventType,
      selectedDate,
      transportSuggestion
    ) {
      reset();
      if (!groomingId || groomingId.toLowerCase() === "new") {
        self.isNew = true;
        self.updateModel = {
          calendarEvent: groomingService.getEmptyGrooming(),
          locationReservation: locationService.getEmptyLocationReservation(),
          calendarEventUsers: [],
          details: [],
          detailsData: [],
          equipment: [],
          participants: [],
          calendarEventDeceased: [],
          deceased: []
        };
        self.updateModel.calendarEvent.workOrderId = workOrderId;

        if (selectedDate) {
          var hour =
            moment()
              .startOf("hour")
              .hour() + 1;
          self.updateModel.calendarEvent.start = moment(selectedDate)
            .hour(hour)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
          self.updateModel.calendarEvent.end = moment(selectedDate)
            .hour(hour + 1)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
        } else {
          var hour =
            moment()
              .startOf("hour")
              .hour() + 1;
          self.updateModel.calendarEvent.start = moment()
            .hour(hour)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
          self.updateModel.calendarEvent.end = moment()
            .hour(hour + 1)
            .minute(0)
            .format("YYYY-MM-DDTHH:mm:ss");
        }

        if (calendarEventType) {
          self.updateModel.calendarEvent.subject = calendarEventType.name;
        }

        if (transportSuggestion) {
          self.updateModel.calendarEvent.distance = transportSuggestion.distance;
          self.updateModel.calendarEvent.driverHours = transportSuggestion.driverHours;
          self.updateModel.calendarEvent.additionalHours = transportSuggestion.additionalHours;
          self.updateModel.calendarEvent.additionalCost = transportSuggestion.additionalCost;
          self.updateModel.calendarEvent.price = transportSuggestion.totalPrice;
          self.updateModel.calendarEvent.billTo = transportSuggestion.billTo;
          self.updateModel.calendarEvent.options = transportSuggestion.suggestedTransportTypeOptions;
          self.updateModel.calendarEvent.originId = transportSuggestion.departureLocationId;
          self.updateModel.calendarEvent.originRemarks = transportSuggestion.departureLocationRemarks;
          self.updateModel.calendarEvent.locationId = transportSuggestion.departureLocationId;
          self.updateModel.calendarEvent.locationRemarks = transportSuggestion.departureLocationRemarks;
          self.updateModel.calendarEvent.destinationId = transportSuggestion.destinationLocationId;
          self.updateModel.calendarEvent.destinationRemarks = transportSuggestion.destinationLocationRemarks;
          self.updateModel.calendarEvent.subject = transportSuggestion.suggestedTransportTypeName;
          self.updateModel.calendarEvent.transportDescription = transportSuggestion.invoiceText;
          registerPrice();
        }

        // Set ChangeStates
        self.updateModel.calendarEvent.changeState = 1;
        self.updateModel.locationReservation.changeState = 1;

        // Add deceased
        if (deceased && deceased.length > 0) {
          for (var i = 0; i < deceased.length; i++) {
            var workOrderDeceased = deceased[i];
            var calendarEventDeceased = calendarService.getEmptyCalendarEventDeceased();
            calendarEventDeceased.changeState = 1;
            calendarEventDeceased.deceasedId = workOrderDeceased.deceasedId;
            calendarEventDeceased.deceasedPersonDisplayName = workOrderDeceased.deceasedPersonDisplayName;
            self.updateModel.calendarEventDeceased.push(calendarEventDeceased);
          }
        }

        // Get CustomFields
        if (calendarEventTypeId) {
          self.updateModel.calendarEvent.calendarEventTypeId = calendarEventTypeId;
          if (calendarEventType) {
            self.updateModel.calendarEvent.calendarEventType = calendarEventType;
            self.updateModel.calendarEvent.options = calendarEventType.options;
          }
          var promises = [];
          promises.push(
            dataService.getByUri(
              "CalendarEventTypes",
              self.updateModel.calendarEvent.calendarEventTypeId + "/GetCustomFields"
            )
          );
          promises.push(baldrisConfigService.getByCategory("Transport"));
          return $q.all(promises).then(function(response) {
            transportConfigs = response[1];
            if (transportSuggestion) {
              calculatePrice();
            }
            return editCustomFieldService.extractCategories(response[0]).then(function(categories) {
              self.customFieldCategories = categories;
              return editCustomFieldService
                .addDataToCategories(self.customFieldCategories, self.updateModel.detailsData)
                .then(function() {
                  return true;
                });
            });
          });
        } else {
          return baldrisConfigService.getByCategory("Transport").then(function(configs) {
            transportConfigs = configs;
            calculatePrice();
            return true;
          });
        }
      } else {
        return dataService.getUpdateModel("Groomings", groomingId).then(function(updateModel) {
          self.updateModel = updateModel;
          //Ensure calendarEvent
          if (!self.updateModel.calendarEvent) {
            self.updateModel.calendarEvent = calendarService.getEmptyEvent();
            self.updateModel.calendarEvent.changeState = 1;
          }

          var promises = [];
          promises.push(
            dataService.getByUri(
              "CalendarEventTypes",
              self.updateModel.calendarEvent.calendarEventTypeId + "/GetCustomFields"
            )
          );
          promises.push(baldrisConfigService.getByCategory("Transport"));

          return $q.all(promises).then(function(response) {
            transportConfigs = response[1];
            return editCustomFieldService.extractCategories(response[0]).then(function(categories) {
              self.customFieldCategories = categories;
              return editCustomFieldService
                .addDataToCategories(self.customFieldCategories, self.updateModel.detailsData)
                .then(function() {
                  return true;
                });
            });
          });
        });
      }
    }

    function saveGrooming() {
      if (self.updateModel.calendarEvent.id === "00000000-0000-0000-0000-000000000000") {
        self.updateModel.calendarEvent.changeState = 1;
      } else {
        self.updateModel.calendarEvent.changeState = 2;
      }

      for (var i = 0; i < self.updateModel.deceased.length; i++) {
        var deceased = self.updateModel.deceased[i];
        if (deceased.id === "00000000-0000-0000-0000-000000000000") {
          deceased.changeState = 1;
        } else {
          deceased.changeState = 2;
        }
      }

      // Add newly created CustomFieldData to collection
      self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

      return dataService.updateFromUpdateModel("Groomings", self.updateModel).then(function(savedUpdateModel) {
        self.updateModel = savedUpdateModel;
        self.isNew = false;

        return true;
      });
    }

    function getGroomingString() {
      if (!self.updateModel) return null;
      var returnString = "";
      if (self.updateModel.calendarEvent && self.updateModel.calendarEvent.calendarEventType) {
        returnString = self.updateModel.calendarEvent.calendarEventType.name;
      }
      if (self.updateModel.calendarEvent.start) {
        if (returnString) returnString += ", ";
        returnString += moment(self.updateModel.calendarEvent.start).format("LLLL");
      }
      return returnString;
    }

    function calculatePrice() {
      if (self.updateModel.isPriceRegistered) return;
      if (!transportCalculationConfig.isSet) {
        extractCalculationConfig();
      }
      var price = transportCalculationConfig.startAmount;
      if (self.updateModel.calendarEvent.distance) {
        price += self.updateModel.calendarEvent.distance * transportCalculationConfig.distanceAmount;
      }
      if (self.updateModel.calendarEvent.driverHours) {
        price += self.updateModel.calendarEvent.driverHours * transportCalculationConfig.hoursAmount;
      }
      if (self.updateModel.calendarEvent.additionalHours) {
        price += self.updateModel.calendarEvent.additionalHours * transportCalculationConfig.additionalHoursAmount;
      }
      if (self.updateModel.calendarEvent.additionalCost) {
        price += self.updateModel.calendarEvent.additionalCost;
      }
      if (transportCalculationConfig.minimumAmount && price < transportCalculationConfig.minimumAmount) {
        price = transportCalculationConfig.minimumAmount;
      }
      self.updateModel.calendarEvent.price = price;
    }

    function registerPrice() {
      if (self.updateModel.calendarEvent.price) {
        self.updateModel.isPriceRegistered = true;
      } else {
        self.updateModel.isPriceRegistered = false;
      }
    }

    function extractCalculationConfig() {
      var startAmountConfig = getConfigByName("TransportStartAmount");
      if (startAmountConfig && startAmountConfig.dataValueAsString) {
        transportCalculationConfig.startAmount = Number(startAmountConfig.dataValueAsString) || 0;
      }
      var distanceAmountConfig = getConfigByName("TransportDistanceAmount");
      if (distanceAmountConfig && distanceAmountConfig.dataValueAsString) {
        transportCalculationConfig.distanceAmount = Number(distanceAmountConfig.dataValueAsString) || 0;
      }
      var minimumAmountConfig = getConfigByName("TransportMinimalAmount");
      if (minimumAmountConfig && minimumAmountConfig.dataValueAsString) {
        transportCalculationConfig.minimumAmount = Number(minimumAmountConfig.dataValueAsString) || 0;
      }
      var hoursAmountConfig = getConfigByName("TransportHoursAmount");
      if (hoursAmountConfig && hoursAmountConfig.dataValueAsString) {
        transportCalculationConfig.hoursAmount = Number(hoursAmountConfig.dataValueAsString) || 0;
      }
      var additionalHoursAmountConfig = getConfigByName("TransportHoursAmount");
      if (additionalHoursAmountConfig && additionalHoursAmountConfig.dataValueAsString) {
        transportCalculationConfig.additionalHoursAmount = Number(additionalHoursAmountConfig.dataValueAsString) || 0;
      }
      transportCalculationConfig.isSet = true;
    }

    function getConfigByName(name) {
      if (!transportConfigs || transportConfigs.length === 0) return null;
      for (var i = 0; i < transportConfigs.length; i++) {
        var config = transportConfigs[i];
        if (config && config.name === name) {
          return config;
        }
      }
      return null;
    }

    function reset() {
      self.updateModel = null;
      self.isNew = false;
      transportConfigs = null;
      transportCalculationConfig = {
        isSet: false,
        startAmount: 0,
        distanceAmount: 0,
        minimumAmount: 0,
        hoursAmount: 0,
        additionalHoursAmount: 0
      };
    }

    function onIsCompletedChange() {
      if (self.updateModel.calendarEvent.isCompleted) {
        self.updateModel.calendarEvent.completedTime = moment().format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.updateModel.calendarEvent.completedTime = null;
        self.updateModel.calendarEvent.completedBy = null;
        self.updateModel.calendarEvent.completedById = null;
        self.updateModel.calendarEvent.completedByDisplayName = null;
      }
    }

    function isTransport() {
      return calendarService.options.isTransport(self.updateModel.calendarEvent.options);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.grooming')
        .controller('EditGroomingController', EditGroomingController);

    /* @ngInject */
    function EditGroomingController($window, $stateParams, loadingService, editGroomingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editGroomingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editGroomingService.loadGrooming($stateParams.groomingId, $stateParams.workOrderId, $stateParams.deceased, $stateParams.groomingTypeId, $stateParams.groomingType, $stateParams.selectedDate, $stateParams.transportSuggestion).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editGroomingService.saveGrooming().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.grooming')
        .controller('EditGroomingToolbarController', EditGroomingToolbarController);

    /* @ngInject */
    function EditGroomingToolbarController($window, loadingService, editGroomingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editGroomingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;


        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editGroomingService.saveGrooming().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.grooming')
        .controller('EditGroomingSidebarController', EditGroomingSidebarController);

    /* @ngInject */
    function EditGroomingSidebarController($window, loadingService, editGroomingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editGroomingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;


        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editGroomingService.saveGrooming().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular.module('app.grave').factory('graveService', graveService);

    /* @ngInject */
    function graveService($http, $q, exception) {
        var service = {
            getEmptyGrave: getEmptyGrave,
        };

        return service;

        function getEmptyGrave() {
            return {
                graveNumber: null,
                graveLeaseNumber: null,
                isAnonymousGrave: false,
                graveShouldBeOnNewField: false,
                remarks: null,
                leaseHolderId: null,
                leaseHolderRemarks: null,
                leaseHolderHasOtherLeases: false,
                leaseHolderOtherLeasesRemarks: null,
                temporaryMarkerId: null,
                temporaryMarkerPlaqueName: null,
                temporaryMarkerRemarks: null,
                leaseTransferId: null,
                leaseTransferSerialized: null,
                graveTypeId: null,
                cemeteryId: null,
                previouslyBuriedId: null,
                deceasedIds: [],
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.grave').service('editGraveService', editGraveService);

    /* @ngInject */
    function editGraveService($q, dataService, partyService, editCustomFieldService, graveService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadGrave = loadGrave;
        self.saveGrave = saveGrave;
        self.getGraveString = getGraveString;
        self.openChooseLeaseHolderDialog = openChooseLeaseHolderDialog;
        self.openChoosePreviouslyBuriedDialog = openChoosePreviouslyBuriedDialog;
        self.removeLeaseHolder = removeLeaseHolder;
        self.removePreviouslyBuried = removePreviouslyBuried;

        function loadGrave(graveId, workOrderId, workOrderDeceasedList, graveTypeId, graveDefaults) {
            reset();
            if (!graveId || graveId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    grave: graveDefaults || graveService.getEmptyGrave(),
                    leaseHolder: null,
                    previouslyBuried: null,
                    deceased: [],
                };

                self.updateModel.grave.targetWorkOrderId = workOrderId;

                if (self.validation && self.validation.graveForm) {
                    self.validation.graveForm.$setDirty();
                }

                var promises = [];

                // Add deceased
                if (workOrderDeceasedList && workOrderDeceasedList.length > 0) {
                    for (var i = 0; i < workOrderDeceasedList.length; i++) {
                        var workOrderDeceased = workOrderDeceasedList[i];
                        self.updateModel.grave.deceasedIds.push(workOrderDeceased.deceasedId);
                        promises.push(dataService.getById('Deceased', workOrderDeceased.deceasedId, true));
                    }
                }

                // Get CustomFields
                if (graveTypeId) {
                    self.updateModel.grave.graveTypeId = graveTypeId;
                    promises.push(
                        dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: self.updateModel.grave.id,
                            attachedDataTargetName: 'Grave',
                            attachedTypeId: self.updateModel.grave.graveTypeId,
                            attachedTypeName: 'GraveTypeType',
                        })
                    );
                }
                if (promises.length > 0) {
                    return $q.all(promises).then(function (response) {
                        if (workOrderDeceasedList && workOrderDeceasedList.length > 0) {
                            for (var i = 0; i < workOrderDeceasedList.length; i++) {
                                response[i].changeState = 2;
                                self.updateModel.deceased.push(response[i]);
                            }
                        }
                        if (graveTypeId) {
                            self.customFieldCategories = response[self.updateModel.deceased.length];
                        }
                        return true;
                    });
                } else {
                    return $q.when(true);
                }
            } else {
                return dataService.getById('Graves', graveId).then(function (grave) {
                    self.updateModel = {
                        grave: grave,
                        leaseHolder: null,
                        previouslyBuried: null,
                        targetWorkOrderId: workOrderId,
                        deceased: [],
                    };
                    self.updateModel.grave.targetWorkOrderId = workOrderId;
                    var promises = [];
                    var customFieldCategoriesIndex = -1;
                    var leaseHolderIndex = -1;
                    var previouslyBuriedIndex = -1;
                    // Get CustomFields
                    if (self.updateModel.grave.graveTypeId) {
                        promises.push(
                            dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                                attachedDataTargetId: self.updateModel.grave.id,
                                attachedDataTargetName: 'Grave',
                                attachedTypeId: self.updateModel.grave.graveTypeId,
                                attachedTypeName: 'GraveTypeType',
                            })
                        );
                        customFieldCategoriesIndex += promises.length;
                    }
                    // Lease Holder
                    if (self.updateModel.grave.leaseHolderId) {
                        promises.push(dataService.getById('Parties', self.updateModel.grave.leaseHolderId));
                        leaseHolderIndex += promises.length;
                    }
                    // Previously buried
                    if (self.updateModel.grave.previouslyBuriedId) {
                        promises.push(dataService.getById('Persons', self.updateModel.grave.previouslyBuriedId));
                        previouslyBuriedIndex += promises.length;
                    }
                    if (promises.length > 0) {
                        return $q.all(promises).then(function (response) {
                            if (self.updateModel.grave.graveTypeId) {
                                self.customFieldCategories = response[customFieldCategoriesIndex];
                            }
                            if (self.updateModel.grave.leaseHolderId) {
                                self.updateModel.leaseHolder = response[leaseHolderIndex];
                            }
                            if (self.updateModel.grave.previouslyBuriedId) {
                                self.updateModel.previouslyBuried = response[previouslyBuriedIndex];
                            }
                            return true;
                        });
                    }
                    return true;
                });
            }
        }

        function saveGrave() {
            if (!self.updateModel.grave.id || self.updateModel.grave.id === '00000000-0000-0000-0000-000000000000' || self.updateModel.grave.id === 'new') {
                return dataService.insertItem('Graves', self.updateModel.grave).then(function (insertedGrave) {
                    self.isNew = false;
                    self.updateModel.grave = insertedGrave;
                    if (self.validation && self.validation.graveForm) {
                        self.validation.graveForm.$setPristine();
                    }
                    return saveAdditionalData(self.updateModel.grave);
                });
            } else {
                return dataService.updateItem('Graves', self.updateModel.grave).then(function () {
                    self.isNew = false;
                    if (self.validation && self.validation.graveForm) {
                        self.validation.graveForm.$setPristine();
                    }
                    return saveAdditionalData(self.updateModel.grave);
                });
            }
        }

        function saveAdditionalData(grave) {
            // Add newly created CustomFieldData to collection
            self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.updateModel.customFieldCategories);
            var promises = dataService.createBulkPromises('CustomFieldData', self.updateModel.detailsData, 'attachedTypeId', grave.id, 'Grave');

            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    return true;
                });
            }
            return true;
        }

        function getGraveString() {
            if (!self.updateModel) return null;
            var returnString = '';
            if (self.updateModel.grave && self.updateModel.grave.graveType) {
                returnString = self.updateModel.grave.graveType.name;
            }
            return returnString;
        }

        function removeLeaseHolder() {
            self.updateModel.grave.leaseHolder = null;
            self.updateModel.grave.leaseHolderId = null;
            self.updateModel.leaseHolder = null;
            if (self.validation && self.validation.graveForm) {
                self.validation.graveForm.$setDirty();
            }
        }

        function removePreviouslyBuried() {
            self.updateModel.grave.previouslyBuried = null;
            self.updateModel.grave.previouslyBuriedId = null;
            self.updateModel.previouslyBuriedId = null;
            self.updateModel.previouslyBuried = null;
            if (self.validation && self.validation.graveForm) {
                self.validation.graveForm.$setDirty();
            }
        }

        function openChoosePersonDialog(e) {
            return partyService.showSearchDialog(e, 'Parties', self.updateModel.targetWorkOrderId, true, true);
        }

        function openChooseLeaseHolderDialog(e) {
            openChoosePersonDialog(e).then(function (selectedParty) {
                if (selectedParty) {
                    self.updateModel.grave.leaseHolderDisplayName = selectedParty.displayName;
                    self.updateModel.grave.leaseHolderId = selectedParty.id;
                    self.updateModel.leaseHolder = selectedParty;
                    if (self.validation && self.validation.graveForm) {
                        self.validation.graveForm.$setDirty();
                    }
                }
            });
        }

        function openChoosePreviouslyBuriedDialog(e) {
            openChoosePersonDialog(e).then(function (selectedParty) {
                if (selectedParty) {
                    self.updateModel.grave.previouslyBuriedDisplayName = selectedParty.displayName;
                    self.updateModel.grave.previouslyBuriedId = selectedParty.id;
                    self.updateModel.previouslyBuried = selectedParty;
                    if (self.validation && self.validation.graveForm) {
                        self.validation.graveForm.$setDirty();
                    }
                }
            });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
        }
    }
})();

(function() {
  "use strict";

  angular
    .module("app.grave")
    .controller("EditGraveController", EditGraveController);

  /* @ngInject */
  function EditGraveController(
    $window,
    $scope,
    $stateParams,
    $translate,
    loadingService,
    editGraveService
  ) {
    var vm = this;

    vm.loadingService = loadingService;
    vm.data = editGraveService;

    // Methods
    vm.exitView = exitView;
    vm.saveAndExitView = saveAndExitView;

    vm.$onInit = function() {
      activate();
    };

    //////////

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      editGraveService
        .loadGrave(
          $stateParams.graveId,
          $stateParams.workOrderId,
          $stateParams.deceased,
          $stateParams.graveTypeId,
          $stateParams.graveDefaults
        )
        .then(function() {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    function exitView() {
      if (
        vm.data.validation &&
        vm.data.validation.graveForm &&
        vm.data.validation.graveForm.$dirty
      ) {
        if (
          confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) ==
          true
        ) {
          vm.data.validation.graveForm.$setPristine();
          $window.history.back();
        }
      } else {
        $window.history.back();
      }
    }

    function saveAndExitView() {
      vm.loadingService.setLoadingStatus(true);
      editGraveService.saveGrave().then(function() {
        if (
          vm.data.validation &&
          vm.data.validation.graveForm &&
          vm.data.validation.graveForm.$dirty
        ) {
          vm.data.validation.graveForm.$setPristine();
        }
        exitView();
        vm.loadingService.setLoadingStatus(false);
      });
    }

    // Prevent from navigating away on unsaved changes
    $scope.$on("$stateChangeStart", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (
        vm.data.validation &&
        vm.data.validation.graveForm &&
        vm.data.validation.graveForm.$dirty
      ) {
        if (
          confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) ==
          true
        ) {
        } else {
          event.preventDefault();
          vm.loadingService.setBackgroundLoadingStatus(false);
        }
      }
    });
  }
})();

(function() {
  "use strict";

  angular
    .module("app.grave")
    .controller("EditGraveToolbarController", EditGraveToolbarController);

  /* @ngInject */
  function EditGraveToolbarController(
    $window,
    $scope,
    $translate,
    loadingService,
    editGraveService
  ) {
    var vm = this;

    vm.loadingService = loadingService;
    vm.data = editGraveService;

    // Methods
    vm.exitView = exitView;
    vm.saveAndExitView = saveAndExitView;

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      editGraveService
        .loadGrave(
          $stateParams.graveId,
          $stateParams.workOrderId,
          $stateParams.deceased,
          $stateParams.graveTypeId
        )
        .then(function() {
          vm.loadingService.setLoadingStatus(false);
        });
    }

    function exitView() {
      if (
        vm.data.validation &&
        vm.data.validation.graveForm &&
        vm.data.validation.graveForm.$dirty
      ) {
        if (
          confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) ==
          true
        ) {
          vm.data.validation.graveForm.$setPristine();
          $window.history.back();
        }
      } else {
        $window.history.back();
      }
    }

    function saveAndExitView() {
      vm.loadingService.setLoadingStatus(true);
      editGraveService.saveGrave().then(function() {
        if (
          vm.data.validation &&
          vm.data.validation.graveForm &&
          vm.data.validation.graveForm.$dirty
        ) {
          vm.data.validation.graveForm.$setPristine();
        }
        exitView();
        vm.loadingService.setLoadingStatus(false);
      });
    }

    // Prevent from navigating away on unsaved changes
    $scope.$on("$stateChangeStart", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (
        vm.data.validation &&
        vm.data.validation.graveForm &&
        vm.data.validation.graveForm.$dirty
      ) {
        if (
          confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) ==
          true
        ) {
        } else {
          event.preventDefault();
          vm.loadingService.setBackgroundLoadingStatus(false);
        }
      }
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.flowerOrder')
        .factory('flowerOrderService', flowerOrderService);

    /* @ngInject */
    function flowerOrderService($http, $q, exception) {
        var service = {
            getEmptyFlowerOrder: getEmptyFlowerOrder,
            getEmptyFlower: getEmptyFlower,
            getEmptyFlowerRibbon: getEmptyFlowerRibbon,
        };

        return service;

        function getEmptyFlowerOrder() {
            return {
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                finalizedBy: null,
                supplierId: null,
                workOrderId: null,
                externalOrderTypeId: null,
                deliveryTime: null,
                deliveryLocationId: null,
                alternateDeliveryAddressId: null,
                deceasedId: null,
                calendarEventId: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
            };
        }

        function getEmptyFlower() {
            return {
                name: null,
                description: null,
                amount: null,
                remarks: null,
                historicalPrice: null,
                historicalCost: null,
                sortOrder: 0,
                imageId: null,
                flowerOrderId: null,
                productId: null,
            };
        }

        function getEmptyFlowerRibbon() {
            return {
                text: null,
                names: null,
                remarks: null,
                ribbonColorSpecified: null,
                sortOrder: 0,
                ribbonColorId: null,
                flowerId: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.flowerOrder').service('editFlowerOrderService', editFlowerOrderService);

    /* @ngInject */
    function editFlowerOrderService(
        $mdDialog,
        $document,
        $q,
        dataService,
        calendarService,
        workOrderService,
        flowerOrderService,
        editCustomFieldService,
        baldrisConfigService
    ) {
        var self = this;

        self.updateModel = null;
        self.isNew = null;
        self.newFlower = null;

        self.loadFlowerOrder = loadFlowerOrder;
        self.onCeremonyChanged = onCeremonyChanged;
        self.addFlower = addFlower;
        self.editFlower = editFlower;
        self.saveFlowerOrder = saveFlowerOrder;

        var suggestedMeetUpOffsets = null;

        function loadFlowerOrder(flowerOrderId, workOrderId, workOrder) {
            reset();
            if (!flowerOrderId || flowerOrderId === '00000000-0000-0000-0000-000000000000' || flowerOrderId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    flowerOrder: flowerOrderService.getEmptyFlowerOrder(),
                    flowers: [],
                    ribbons: [],
                };
                self.updateModel.flowerOrder.workOrderId = workOrderId;
                self.updateModel.flowerOrder.workOrder = workOrder;
                return baldrisConfigService.getByName('FlowerOrderType').then(function (config) {
                    var orderTypeId = config[0].dataTargetId;
                    self.updateModel.flowerOrder.externalOrderTypeId = orderTypeId;
                    var promises = [];
                    promises.push(
                        dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: self.updateModel.flowerOrder.id,
                            attachedDataTargetName: 'ExternalOrder',
                            attachedTypeId: self.updateModel.flowerOrder.externalOrderTypeId,
                            attachedTypeName: 'ExternalOrderType',
                        })
                    );
                    promises.push(baldrisConfigService.getByName('SuggestedMeetUpOffset'));
                    promises.push(dataService.getByWorkOrderId('Ceremonies', workOrderId));

                    return $q.all(promises).then(function (response) {
                        suggestedMeetUpOffsets = response[1];
                        if (response[2] && response[2].length > 0) {
                            var ceremonies = response[2];
                            if (ceremonies.length > 0) {
                                self.updateModel.flowerOrder.calendarEvent = ceremonies[0];
                                self.updateModel.flowerOrder.calendarEventId = ceremonies[0].id;
                                return onCeremonyChanged(self.updateModel.flowerOrder.calendarEvent).then(function () {
                                    self.customFieldCategories = response[0];
                                    return setDirtyStatus();
                                });
                            }
                        }
                        return loadCustomFields(response[0]).then(function () {
                            return setDirtyStatus();
                        });
                    });
                });
            } else {
                var promises = [];
                promises.push(dataService.getById('FlowerOrders', flowerOrderId));
                promises.push(baldrisConfigService.getByName('SuggestedMeetUpOffset'));
                promises.push(dataService.getByUri('Flowers', 'ByFlowerOrderId/' + flowerOrderId));
                return $q.all(promises).then(function (response) {
                    self.updateModel = {
                        flowerOrder: response[0],
                        flowers: response[2],
                        ribbons: [],
                    };
                    suggestedMeetUpOffsets = response[1];
                    return dataService
                        .getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: self.updateModel.flowerOrder.id,
                            attachedDataTargetName: 'ExternalOrder',
                            attachedTypeId: self.updateModel.flowerOrder.externalOrderTypeId,
                            attachedTypeName: 'ExternalOrderType',
                        })
                        .then(function (categories) {
                            self.customFieldCategories = categories;
                            return true;
                        });
                });
            }
        }

        function setDirtyStatus() {
            // Set as dirty to allow saving
            if (self.validation && self.validation.flowerOrderForm && self.validation.flowerOrderForm.$pristine) {
                self.validation.flowerOrderForm.$setDirty();
            }

            return true;
        }

        function saveFlowerOrder() {
            if (!self.updateModel.flowerOrder.id) {
                return dataService.insertItem('FlowerOrders', self.updateModel.flowerOrder).then(function (insertedFlowerOrder) {
                    self.isNew = false;
                    self.updateModel.flowerOrder = insertedFlowerOrder;
                    return saveAdditionalData(self.updateModel.flowerOrder);
                });
            }

            return dataService.updateItem('FlowerOrders', self.updateModel.flowerOrder).then(function () {
                self.isNew = false;
                return saveAdditionalData(self.updateModel.flowerOrder);
            });
        }

        function saveAdditionalData(flowerOrder) {
            // Add newly created CustomFieldData to collection
            self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

            var promises = [];
            promises = promises.concat(dataService.createBulkPromises('Flowers', self.updateModel.flowers, 'flowerOrderId', flowerOrder.id));
            promises = promises.concat(dataService.createBulkPromises('FlowerRibbons', self.updateModel.ribbons));
            promises = promises.concat(
                dataService.createBulkPromises('CustomFieldData', self.updateModel.detailsData, 'attachedTypeId', flowerOrder.id, 'ExternalOrder')
            );

            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    return true;
                });
            }
            return true;
        }

        function onCeremonyChanged(ceremony) {
            if (ceremony && ceremony.locationId) {
                return dataService
                    .getById('Locations', ceremony.locationId)
                    .then(function (location) {
                        if (location) {
                            self.updateModel.flowerOrder.deliveryLocationId = location.id;
                            self.updateModel.flowerOrder.deliveryLocation = location;
                            self.updateModel.flowerOrder.deliveryTime = getDeliveryTimeByOffset(location.suggestedMeetUpOffset, ceremony.start);
                        }
                    });
            }
            return $q.when(true);
        }

        function getDeliveryTimeByOffset(offset, sourceTime) {
            if (!offset) {
                offset = getOffset();
            }
            return moment(sourceTime)
                .add(offset / 10000, 'ms')
                .format('YYYY-MM-DDTHH:mm:ss');
        }

        function getOffset() {
            if (!suggestedMeetUpOffsets || suggestedMeetUpOffsets.length === 0) return -54000000000;
            var globalOffset = null;
            for (var i = 0; i < suggestedMeetUpOffsets.length; i++) {
                var baldrisConfig = suggestedMeetUpOffsets[i];
                if (!baldrisConfig.departmentId && baldrisConfig.dataValueAsString) {
                    globalOffset = Number(baldrisConfig.dataValueAsString);
                }
                if (
                    self.updateModel.flowerOrder.workOrder &&
                    baldrisConfig.departmentId &&
                    baldrisConfig.departmentId === self.updateModel.flowerOrder.workOrder.departmentId
                ) {
                    return Number(baldrisConfig.dataValueAsString);
                    break;
                }
            }
            return globalOffset ? globalOffset : -54000000000;
        }

        function addFlower() {
            if (!self.newFlower || !self.newFlower.flower.product) return;
            self.newFlower.flower.name = self.newFlower.flower.product.name;
            self.newFlower.flower.amount = 1;
            self.newFlower.flower.historicalPrice = self.newFlower.flower.product.price;
            // Get previously sortOrder
            if (self.updateModel.flowers && self.updateModel.flowers.length > 0) {
                self.newFlower.flower.sortOrder =
                    Math.max.apply(
                        Math,
                        self.updateModel.flowers.map(function (ev) {
                            return ev.sortOrder || 0;
                        })
                    ) + 10;
            } else {
                self.newFlower.flower.sortOrder = 0;
            }
            self.updateModel.flowers.push(self.newFlower);
            resetFlower();
        }

        function editFlower(flower, e) {
            var editModel;
            if (!flower) {
                editModel = {
                    flower: flowerOrderService.getEmptyFlower(),
                    ribbons: [],
                };
                editModel.flower.changeState = 1;
                editModel.ribbons.push(flowerOrderService.getEmptyFlowerRibbon());
                // Get previously sortOrder
                if (self.updateModel.flowers && self.updateModel.flowers.length > 0) {
                    editModel.flower.sortOrder =
                        Math.max.apply(
                            Math,
                            self.updateModel.flowers.map(function (ev) {
                                return ev.sortOrder || 0;
                            })
                        ) + 10;
                } else {
                    editModel.flower.sortOrder = 0;
                }
                editModel.ribbons[0].changeState = 1;
            } else {
                editModel = {
                    flower: angular.copy(flower),
                    ribbons: angular.copy(flower.ribbons),
                };
            }
            $mdDialog
                .show({
                    controller: 'EditFlowerDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/flower-order/dialogs/edit-flower-dialog/edit-flower-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        updateModel: editModel,
                        workOrderId: self.updateModel.flowerOrder.workOrderId,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (updateModel) {
                    if (updateModel && self.updateModel.flowers.indexOf(flower) > -1) {
                        // Replace original flower
                        var flowerIndex = self.updateModel.flowers.indexOf(flower);
                        self.updateModel.flowers.splice(flowerIndex, 1);
                        if (updateModel.shouldDelete) {
                            if (updateModel.flower.id) {
                                updateModel.flower.changeState = 3;
                                self.updateModel.flowers.push(updateModel.flower);
                            }
                        } else {
                            self.updateModel.flowers.push(updateModel.flower);
                        }
                        if (self.validation && self.validation.flowerOrderForm) {
                            self.validation.flowerOrderForm.$setDirty();
                        }
                        extractFlowerRibbons(updateModel);
                    } else if (updateModel) {
                        if (updateModel.shouldDelete) {
                            if (updateModel.flower.id) {
                                updateModel.flower.changeState = 3;
                                self.updateModel.flowers.push(updateModel);
                            }
                        } else {
                            self.updateModel.flowers.push(updateModel.flower);
                        }
                        if (self.validation && self.validation.flowerOrderForm) {
                            self.validation.flowerOrderForm.$setDirty();
                        }
                        extractFlowerRibbons(updateModel);
                    }
                });
        }

        function extractFlowerRibbons(flowerUpdateModel) {
            if (flowerUpdateModel && flowerUpdateModel.ribbons && flowerUpdateModel.ribbons.length > 0) {
                // Rebuild ribbon collection
                flowerUpdateModel.flower.ribbons = [];
                flowerUpdateModel.ribbons.forEach(function (ribbon) {
                    if (ribbon.hasOwnProperty('changeState') && ribbon.changeState === 3) {
                        self.updateModel.ribbons.push(ribbon);
                    } else {
                        flowerUpdateModel.flower.ribbons.push(ribbon);
                    }
                });
            }
        }

        function reset() {
            self.updateModel = null;
            self.isNew = null;
            suggestedMeetUpOffsets = null;
            resetFlower();
        }

        function resetFlower() {
            self.newFlower = {
                flower: flowerOrderService.getEmptyFlower(),
                ribbons: [],
            };
            self.newFlower.flower.changeState = 1;
            self.newFlower.ribbons.push(flowerOrderService.getEmptyFlowerRibbon());
            self.newFlower.ribbons[0].changeState = 1;
            self.lookupString = null;
            self.lookupStringId = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.flowerOrder')
        .controller('EditFlowerOrderController', EditFlowerOrderController);

    /* @ngInject */
    function EditFlowerOrderController($window, $scope, $translate, editFlowerOrderService, $stateParams, loadingService) {
        var vm = this;
        vm.data = editFlowerOrderService;
        vm.loadingService = loadingService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        ////////////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editFlowerOrderService.loadFlowerOrder($stateParams.flowerOrderId, $stateParams.workOrderId, $stateParams.workOrder).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editFlowerOrderService.saveFlowerOrder().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                if (vm.data.validation && vm.data.validation.flowerOrderForm && vm.data.validation.flowerOrderForm.$dirty) {
                    if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {

                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                };
            });
    }

})();


(function () {
    'use strict';

    angular
        .module('app.flowerOrder')
        .controller('EditFlowerOrderToolbarController', EditFlowerOrderToolbarController);

    /* @ngInject */
    function EditFlowerOrderToolbarController($window, editFlowerOrderService, loadingService) {
        var vm = this;
        vm.data = editFlowerOrderService;
        vm.loadingService = loadingService;

        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;


        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editFlowerOrderService.saveFlowerOrder().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.externalOrder')
        .factory('externalOrderService', externalOrderService);

    /* @ngInject */
    function externalOrderService() {

        var service = {
            getEmptyDeceasedShipmentDto: getEmptyDeceasedShipmentDto,
            getEmptyHeadstoneOrderDto: getEmptyHeadstoneOrderDto
        };

        return service;

        function getEmptyDeceasedShipmentDto() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.DeceasedShipmentDto, Baldris.Core.Data.Entities',
                senderId: null,
                sender: null,
                recieverId: null,
                reciever: null,
                carrierTypeId: null,
                carrierType: null,
                carrierId: null,
                carrier: null,
                departureLocationId: null,
                departureLocation: null,
                arrivalLocationId: null,
                arrivalLocation: null,
                options: 0,
                casketAttributes: 0,
                carrierNumber: null,
                carrierWayBill: null,
                shipmentRemarks: null,
                stopOver: null,
                enclosedDocuments: null,
                enclosedDocumentsAreOriginals: false,
                laissesPasserAuthorityOfIssue: null,
                laissesPasserIssueDate: null,
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                finalizedBy: null,
                supplierId: null,
                supplier: null,
                workOrderId: null,
                workOrder: null,
                externalOrderTypeId: null,
                externalOrderType: null,
                deliveryTime: null,
                deliveryLocationId: null,
                deliveryLocation: null,
                alternateDeliveryAddressId: null,
                alternateDeliveryAddress: null,
                deceasedId: null,
                deceased: null,
                calendarEventId: null,
                calendarEvent: null,
                details: null,
                noteOrTasks: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }

        function getEmptyHeadstoneOrderDto() {
            return {
                type: 'Baldris.Core.Data.Entities.Dto.HeadstoneOrderDto, Baldris.Core.Data.Entities',
                isNewHeadstone: false,
                headstoneHeight: null,
                headstoneWidth: null,
                headstoneDepth: null,
                headstoneWeight: null,
                shouldReserveSpaceForFutherInscriptions: false,
                estimatedFurtherInscriptions: null,
                estimatedDeliveryTime: null,
                productId: null,
                productAmount: null,
                overriddenPrice: null,
                overriddenName: null,
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                isFinalized: false,
                finalizedTime: null,
                finalizedById: null,
                supplierId: null,
                workOrderId: null,
                externalOrderTypeId: null,
                deliveryTime: null,
                deliveryLocationId: null,
                alternateDeliveryAddressId: null,
                deceasedId: null,
                calendarEventId: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                externalOrderedBy: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function() {
  "use strict";

  angular.module("app.export", []);
})();

(function() {
  "use strict";

  angular.module("app.export").controller("ExportReferencePersonsController", ExportReferencePersonsController);

  /* @ngInject */
  function ExportReferencePersonsController($timeout, $http, baldrisApiBase, currentUser, dataService, loadingService) {
    var vm = this;
    vm.loadingService = loadingService;
    vm.onUpdate = onUpdate;
    vm.downloadAsCsv = downloadAsCsv;

    function onUpdate() {
      $timeout(function() {
        if (vm.startDate && vm.endDate) {
          vm.loadingService.setLoadingStatus(true);
          dataService
            .getByUri("WorkOrderReferencePersons", "GetReferencePersonList", {
              startDate: vm.startDate,
              endDate: vm.endDate,
              referencePersonTypeFilter: vm.selectedReferencePersonType,
              workOrderTypes: vm.selectedWorkOrderTypeIds,
              privacyFields: vm.selectedPrivacyFieldIds
            })
            .then(function(result) {
              vm.result = result;
              vm.loadingService.setLoadingStatus(false);
            });
        }
      });
    }

    function downloadAsCsv() {
      vm.loadingService.setLoadingStatus(true);
      return $http({
        url: baldrisApiBase + "/api/WorkOrderReferencePersons/GetReferencePersonList/AsCsv",
        method: "GET",
        params: {
          startDate: vm.startDate,
          endDate: vm.endDate,
          referencePersonTypeFilter: vm.selectedReferencePersonType,
          workOrderTypes: vm.selectedWorkOrderTypeIds,
          privacyFields: vm.selectedPrivacyFieldIds
        },
        headers: {
          "Content-type": "application/octet-stream"
        },
        responseType: "arraybuffer"
      })
        .then(function(data, status, headers, config) {
          var octetStreamMime = "application/octet-stream";
          var success = false;

          // Get the headers
          data.headers = data.headers();

          // Get the filename from the x-filename header or default to "download.bin"
          var filename =
            data.headers["x-filename"] ||
            "person_list_" +
              moment(vm.startDate).format("YYYY-MM-DD") +
              "___" +
              moment(vm.endDate).format("YYYY-MM-DD") +
              ".csv";

          // Determine the content type from the header or default to "application/octet-stream"
          var contentType = data.headers["content-type"] || octetStreamMime;

          try {
            // Try using msSaveBlob if supported
            console.log("Trying saveBlob method ...");
            var blob = new Blob([data], { type: contentType });
            if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
            else {
              // Try using other saveBlob implementations, if available
              var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
              if (saveBlob === undefined) throw "Not supported";
              saveBlob(blob, filename);
            }
            console.log("saveBlob succeeded");
            success = true;
          } catch (ex) {
            console.log("saveBlob method failed with the following exception:");
            console.log(ex);
          }

          if (!success) {
            // Get the blob url creator
            var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            if (urlCreator) {
              // Try to use a download link
              var link = document.createElement("a");
              if ("download" in link) {
                // Try to simulate a click
                try {
                  // Prepare a blob URL
                  console.log("Trying download link method with simulated click ...");
                  var blob = new Blob([data.data], { type: contentType });
                  var url = urlCreator.createObjectURL(blob);
                  link.setAttribute("href", url);

                  // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                  link.setAttribute("download", filename);

                  // Simulate clicking the download link
                  var event = document.createEvent("MouseEvents");
                  event.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                  link.dispatchEvent(event);
                  console.log("Download link method with simulated click succeeded");
                  success = true;
                } catch (ex) {
                  console.log("Download link method with simulated click failed with the following exception:");
                  console.log(ex);
                }
              }

              if (!success) {
                // Fallback to window.location method
                try {
                  // Prepare a blob URL
                  // Use application/octet-stream when using window.location to force download
                  console.log("Trying download link method with window.location ...");
                  var blob = new Blob([data.data], { type: octetStreamMime });
                  var url = urlCreator.createObjectURL(blob);
                  window.location = url;
                  console.log("Download link method with window.location succeeded");
                  success = true;
                } catch (ex) {
                  console.log("Download link method with window.location failed with the following exception:");
                  console.log(ex);
                }
              }
              vm.loadingService.setLoadingStatus(false);
              return true;
            }
          }
          vm.loadingService.setLoadingStatus(false);
        })
        .catch(function(data, status, headers, config) {
          //TODO when WS error
          vm.loadingService.setLoadingStatus(false);
        });
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.department").service("departmentService", departmentService);

  /* @ngInject */
  function departmentService($filter, $q, dataService) {
    var self = this;

    self.getAllDepartments = getAllDepartments;
    self.getDepartmentById = getDepartmentById;
    self.getEmptyDepartment = getEmptyDepartment;
    self.getEmptyLegalUnit = getEmptyLegalUnit;
    self.getLegalUnitById = getLegalUnitById;
    self.getOrganizationByDepartmentId = getOrganizationByDepartmentId;
    self.getOrganizationByLegalUnitId = getOrganizationByLegalUnitId;

    function getAllDepartments(includeDeleted, forceReload) {
      return dataService.getAll("Departments", forceReload).then(function(departments) {
        if (!includeDeleted) {
          departments = $filter("filter")(departments, { isDeleted: false });
        }
        return departments;
      });
    }

    function getDepartmentById(departmentId, forceReload) {
      return dataService.getById("Departments", departmentId, true, forceReload);
    }

    function getLegalUnitById(legalUnitId, forceReload) {
      return dataService.getById("LegalUnits", legalUnitId, true, forceReload);
    }

    function getOrganizationByDepartmentId(departmentId, forceReload) {
      return getDepartmentById(departmentId, forceReload).then(function(department) {
        return dataService.getById("Parties", department.organizationId, true, forceReload);
      });
    }

    function getOrganizationByLegalUnitId(legalUnitId, forceReload) {
      return getLegalUnitById(legalUnitId, forceReload).then(function(legalUnit) {
        return dataService.getById("Parties", legalUnit.organizationId, true, forceReload);
      });
    }

    function getEmptyDepartment() {
      var department = {
        $type: "Baldris.Core.Data.Entities.Dto.DepartmentDto, Baldris.Core.Data.Entities",
        id: "00000000-0000-0000-0000-000000000000",
        isDeleted: false,
        departmentNumber: null,
        organizationId: null,
        organizationDisplayName: null,
        logoId: null,
        logoFilepath: null,
        alternativeLogoId: null,
        alternativeLogoFilepath: null,
        whiteLogoId: null,
        whiteLogoFilepath: null,
        imageId: null,
        imageFilepath: null,
        legalUnitId: null,
        legalUnitOrganizationDisplayName: null,
        locationId: null,
        locationName: null,
        postAddressId: null,
        postAddressLocalizedAddress: null,
        changeState: 0,
        createdBy: null,
        createdAt: null,
        lastModifiedBy: null,
        lastModifiedAt: null
      };

      return department;
    }

    function getEmptyLegalUnit() {
      var department = {
        $type: "Baldris.Core.Data.Entities.Dto.LegalUnitDto, Baldris.Core.Data.Entities",
        id: "00000000-0000-0000-0000-000000000000",
        isDeleted: false,
        organizationId: null,
        organizationDisplayName: null,
        logoId: null,
        logoFilepath: null,
        locationId: null,
        locationName: null,
        postAddressId: null,
        postAddressLocalizedAddress: null,
        changeState: 0,
        createdBy: null,
        createdAt: null,
        lastModifiedBy: null,
        lastModifiedAt: null
      };

      return department;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.deceased').factory('deceasedService', deceasedService);

    /* @ngInject */
    function deceasedService($mdDialog, $document) {
        var service = {
            getEmptyDeceased: getEmptyDeceased,
            getEmptyDeceasedShort: getEmptyDeceasedShort,
            getEmptyGrantApplication: getEmptyGrantApplication,
            showEditGrantApplicationDialog: showEditGrantApplicationDialog,
        };

        return service;

        function showEditGrantApplicationDialog(e, grantApplication, deceased) {
            return $mdDialog.show({
                controller: 'EditGrantApplicationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/deceased/grant-application/dialogs/edit-grant-application-dialog/edit-grant-application-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    grantApplication: grantApplication,
                    deceased: deceased,
                },
                clickOutsideToClose: true,
            });
        }

        function getEmptyDeceased() {
            return {
                personId: '00000000-0000-0000-0000-000000000000',
                firstName: null,
                lastName: null,
                sex: null,
                dateOfBirth: null,
                dateOfBirthApproximate: null,
                dateOfDeath: null,
                dateOfDeathApproximate: null,
                socialSecurityNumber: null,
                imageId: null,
                updateOrInsertAddressCommand: null,
                maritalStatus: 'none',
                yearOfMarriage: null,
                municipalityOfResidenceId: null,
                municipalityOfBirthId: null,
                municipalityOfDeathId: null,
                placeOfDeathId: null,
                placeOfDeathRemarks: null,
                placeOfDeathAddressId: null,
                causeOfDeath: null,
                infectionStatusId: null,
                infectionStatusRemarks: null,
                casketId: null,
                appliedCasketAttributes: 'none',
                casketRemarks: null,
                urnId: null,
                urnRemarks: null,
                probate: 'none',
                deceasedLeavesBehind: 'none',
                assets: null,
                citizenship: null,
                congregationId: null,
                religionId: null,
                workTitle: null,
                closestFamily: null,
                implants: 'none',
                options: 'none',
                graveId: null,
                remarks: null,
                targetWorkOrderId: null,
            };
        }

        function getEmptyDeceasedShort() {
            return {
                type: 'Baldris.Core.Data.Entities.Dto.Shorts.DeceasedShortDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                personId: null,
                personDisplayName: null,
                personDateOfBirth: null,
                personDateOfDeath: null,
                personSocialSecurityNumber: null,
                workOrders: null,
                casketName: null,
                casketRemarks: null,
                urnName: null,
                urnRemarks: null,
                maritalStatus: 0,
                municipalityOfResidenceId: null,
                municipalityOfBirthId: null,
                municipalityOfDeathId: null,
                placeOfDeathId: null,
                placeOfDeathAddressId: null,
                casketId: null,
                urnId: null,
                congregationId: null,
                religionId: null,
                graveId: null,
            };
        }

        function getEmptyGrantApplication() {
            return {
                options: 'none',
                funeralCost: null,
                transportCost: null,
                otherCost: null,
                governmentCost: null,
                headstoneCost: null,
                assets: null,
                insurancePayout: null,
                pensionPayout: null,
                otherPayout: null,
                unionForm: null,
                workPlace: null,
                remarks: null,
                deceasedId: null,
                workOrderId: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('EditDeceasedController', EditDeceasedController);

    /* @ngInject */
    function EditDeceasedController(
        $q,
        $scope,
        $window,
        $translate,
        $stateParams,
        editDeceasedViewService,
        loadingService
    ) {
        var vm = this;
        vm.countryId = null;
        vm.loadingService = loadingService;
        vm.data = editDeceasedViewService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.showYearOfMarriage = showYearOfMarriage;

        //////////
        // INIT

        activate();

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedViewService
                .loadDeceased(
                    $stateParams.deceasedId,
                    $stateParams.workOrderId,
                    $stateParams.person
                )
                .then(function () {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function exitView() {
            if (
                vm.data.validation &&
                vm.data.validation.deceasedForm &&
                vm.data.validation.deceasedForm.$dirty
            ) {
                if (
                    confirm(
                        $translate.instant(
                            'COMMON.DATA.UNSAVED_CHANGES_CONFIRM'
                        )
                    ) == true
                ) {
                    vm.data.validation.deceasedForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            }
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedViewService
                .saveDeceased()
                .then(function () {
                    if (
                        vm.data.validation &&
                        vm.data.validation.deceasedForm &&
                        vm.data.validation.deceasedForm.$dirty
                    ) {
                        vm.data.validation.deceasedForm.$setPristine();
                    }
                    exitView();
                    vm.loadingService.setLoadingStatus(false);
                })
                .catch(function (message) {
                    vm.loadingService.setLoadingStatus(false);
                });
        }

        function showYearOfMarriage() {
            if (!vm.data.updateModel || !vm.data.updateModel.deceased)
                return false;
            return (
                vm.data.updateModel.deceased.maritalStatus & 2 ||
                vm.data.updateModel.deceased.maritalStatus & 4
            );
        }

        // Prevent from navigating away on unsaved changes
        $scope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
                if (
                    vm.data.validation &&
                    vm.data.validation.deceasedForm &&
                    vm.data.validation.deceasedForm.$dirty
                ) {
                    if (
                        confirm(
                            $translate.instant(
                                'COMMON.DATA.UNSAVED_CHANGES_CONFIRM'
                            )
                        ) == true
                    ) {
                    } else {
                        event.preventDefault();
                        loadingService.setBackgroundLoadingStatus(false);
                    }
                }
            }
        );
    }
})();

(function () {
    'use strict';

    angular.module('app.deceased').service('editDeceasedViewService', editDeceasedViewService);

    /* @ngInject */
    function editDeceasedViewService($q, deceasedService, partyService, workOrderService, dataService, editCustomFieldService) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;

        self.loadDeceased = loadDeceased;
        self.saveDeceased = saveDeceased;
        self.openEditGrantApplicationDialog = openEditGrantApplicationDialog;

        function loadDeceased(deceasedId, workOrderId, person) {
            reset();
            if (!deceasedId || deceasedId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    deceased: deceasedService.getEmptyDeceased(),
                    addresses: [],
                };

                if (angular.isDefined(workOrderId)) {
                    self.updateModel.deceased.targetWorkOrderId = workOrderId;
                }
                var promises = [];

                if (person) {
                    if (person.id) {
                        promises.push(dataService.getByPartyId('Addresses', person.id, true));
                    }
                    self.updateModel.deceased.firstName = person.firstName;
                    self.updateModel.deceased.lastName = person.lastName;
                }

                promises.push(
                    dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                        attachedDataTargetId: '00000000-0000-0000-0000-000000000000',
                        attachedDataTargetName: 'Deceased',
                        attachedTypeName: 'Deceased',
                        attachedTypeId: null,
                    })
                );

                // Set as dirty to allow saving
                if (self.validation && self.validation.deceasedForm && self.validation.deceasedForm.$pristine) {
                    self.validation.deceasedForm.$setDirty();
                }

                return $q.all(promises).then(function (result) {
                    if (person && person.id) {
                        self.updateModel.addresses = result[0];
                    }
                    self.customFieldCategories = result[result.length - 1];
                    self.isLoadingCustomFieldData = false;
                    return {
                        updateModel: self.updateModel,
                        isNew: self.isNew,
                        customFieldCategories: self.customFieldCategories,
                    };
                });
            } else {
                var promises = [];
                promises.push(dataService.getById('Deceased', deceasedId));
                promises.push(
                    dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                        attachedDataTargetId: deceasedId,
                        attachedDataTargetName: 'Deceased',
                        attachedTypeName: 'Deceased',
                        attachedTypeId: null,
                    })
                );
                promises.push(dataService.getByUri('GrantApplications', 'ByDeceasedId/' + deceasedId));
                return $q.all(promises).then(function (response) {
                    self.updateModel = {
                        deceased: response[0],
                        addresses: [],
                        grantApplications: response[2],
                    };
                    return dataService.getByPartyId('Addresses', self.updateModel.deceased.personId, true).then(function (addresses) {
                        self.updateModel.addresses = addresses;
                        if (angular.isDefined(workOrderId)) {
                            self.updateModel.deceased.targetWorkOrderId = workOrderId;
                        }
                        self.customFieldCategories = response[1];
                        self.isLoadingCustomFieldData = false;
                        return {
                            updateModel: self.updateModel,
                            isNew: self.isNew,
                            customFieldCategories: self.customFieldCategories,
                        };
                    });
                });
            }
        }

        function saveDeceased() {
            if (!self.isNew) {
                return dataService
                    .updateItem('Deceased', self.updateModel.deceased)
                    .then(function () {
                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.deceased);
                    })
                    .catch(function (message) {
                        return $q.reject(message);
                    });
            } else {
                return dataService
                    .insertItem('Deceased', self.updateModel.deceased)
                    .then(function (insertedDeceased) {
                        self.updateModel.deceased = insertedDeceased;

                        self.isNew = false;
                        return saveAdditionalData(self.updateModel.deceased);
                    })
                    .catch(function (message) {
                        return $q.reject(message);
                    });
            }
        }

        function saveAdditionalData(deceased) {
            // Collect CustomFieldData
            self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

            var promises = [];
            promises = promises.concat(dataService.createBulkPromises('GrantApplications', self.updateModel.grantApplications, 'deceasedId', deceased.id));
            promises = promises.concat(dataService.createBulkPromises('Addresses', self.updateModel.addresses, 'partyId', deceased.personId));
            promises = promises.concat(
                dataService.createBulkPromises('CustomFieldData', self.updateModel.detailsData, 'attachedTypeId', deceased.id, 'Deceased')
            );

            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    return true;
                });
            }
            return true;
        }

        function openEditGrantApplicationDialog(e, grantApplication) {
            var applicationCopy;
            if (!grantApplication) {
                applicationCopy = deceasedService.getEmptyGrantApplication();
            } else {
                applicationCopy = angular.copy(grantApplication);
            }
            deceasedService.showEditGrantApplicationDialog(e, applicationCopy, self.updateModel.deceased).then(function (updatedGrantApplication) {
                if (updatedGrantApplication) {
                    updatedGrantApplication.workOrderId = self.updateModel.deceased.targetWorkOrderId;
                    if (!self.updateModel.grantApplications) self.updateModel.grantApplications = [];
                    if (!updatedGrantApplication.id) {
                        self.updateModel.grantApplications.push(updatedGrantApplication);
                    } else {
                        updatedGrantApplication.changeState = 2;
                        var index = self.updateModel.grantApplications.indexOf(grantApplication);
                        self.updateModel.grantApplications.splice(index, 1);
                        self.updateModel.grantApplications.push(updatedGrantApplication);
                    }
                    if (self.validation && self.validation.deceasedForm) {
                        self.validation.deceasedForm.$setDirty();
                    }
                }
            });
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            if (self.validation && self.validation.deceasedForm && self.validation.deceasedForm.$dirty) {
                self.validation.deceasedForm.$setPristine();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('EditDeceasedToolbarController', EditDeceasedToolbarController);

    /* @ngInject */
    function EditDeceasedToolbarController($window, $translate, editDeceasedViewService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editDeceasedViewService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////
        // INIT


        function exitView() {
            if (vm.data.validation && vm.data.validation.deceasedForm && vm.data.validation.deceasedForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.deceasedForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editDeceasedViewService.saveDeceased().then(function () {
                if (vm.data.validation && vm.data.validation.deceasedForm && vm.data.validation.deceasedForm.$dirty) {
                    vm.data.validation.deceasedForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            }).catch(function (message) {
                vm.loadingService.setLoadingStatus(false);
            });
        }
    }

} ());
(function () {
    'use strict';

    angular
        .module('app.deceased')
        .controller('EditDeceasedSidebarController', EditDeceasedSidebarController);

    /* @ngInject */
    function EditDeceasedSidebarController(editDeceasedViewService, loadingService) {
        var vm = this;
        vm.loadingService = loadingService;
        vm.data = editDeceasedViewService;

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.customField')
        .factory('editCustomFieldService', editCustomFieldService);

    /* @ngInject */
    function editCustomFieldService($q, $mdDialog, $document) {
        var service = {
            addDataToCategories: addDataToCategories,
            extractDataFromCategories: extractDataFromCategories,
            extractCategories: extractCategories,
            createCategoriesFromCustomFields: createCategoriesFromCustomFields,
            getEmptyProductChoice: getEmptyProductChoice,
            showEditProductChoiceDialog: showEditProductChoiceDialog,
        };

        return service;

        function getEmptyProductChoice() {
            return {
                remarks: null,
                amount: null,
                billTo: 'none',
                departmentId: null,
                customFieldId: '00000000-0000-0000-0000-000000000000',
                productId: '00000000-0000-0000-0000-000000000000',
                productName: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }

        function showEditProductChoiceDialog(e, productChoice) {
            return $mdDialog.show({
                controller: 'EditProductChoiceDialogController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/custom-field/dialogs/edit-product-choice-dialog/edit-product-choice-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    productChoice: productChoice,
                },
                clickOutsideToClose: true,
            });
        }

        function addDataToCategories(categories, data) {
            return $q.when(mergeCategoriesWithData(categories, data));
        }

        function extractCategories(customfields) {
            return $q.when(createCategoriesFromCustomFields(customfields));
        }

        function createCategoriesFromCustomFields(customFields) {
            if (!customFields || (customFields && customFields.length === 0)) {
                // return customFields if we don't have any customFields
                return customFields;
            }
            var addedCategoryIds = [];
            var categories = [];
            // Loop through fields and extract category info
            for (var i = 0; i < customFields.length; i++) {
                var customField = customFields[i];
                if (customField.customFieldCategoryId) {
                    if (
                        addedCategoryIds.indexOf(
                            customField.customFieldCategoryId
                        ) < 0
                    ) {
                        // Extract and add to collection if not already extracted
                        var category = {
                            id: customField.customFieldCategoryId,
                            name: customField.customFieldCategoryName,
                            sortOrder: customField.customFieldCategorySortOrder,
                            isDeleted: customField.customFieldCategoryIsDeleted,
                            customFields: [],
                        };
                        category.customFields.push(customField);
                        categories.push(category);
                        addedCategoryIds.push(
                            customField.customFieldCategoryId
                        );
                    } else {
                        // Add customField to already extracted category
                        var existingCategory = getElementById(
                            categories,
                            customField.customFieldCategoryId
                        );
                        existingCategory.customFields.push(customField);
                    }
                }
            }
            // Remove empty categories - just in case
            categories = categories.filter(function (elem, index, arr) {
                return elem.customFields && elem.customFields.length > 0;
            });
            return categories;
        }

        function getElementById(collection, id) {
            if (!collection || collection.length === 0) return null;
            for (var i = 0; i < collection.length; i++) {
                var element = collection[i];
                if (element.id === id) return element;
            }
        }

        function extractDataFromCategories(categories) {
            if (!categories || categories.length === 0) {
                // return empty array if we don't have any categories
                return [];
            }
            var data = [];
            //Loop through categories
            for (
                var categoryIndex = 0;
                categoryIndex < categories.length;
                categoryIndex++
            ) {
                var category = categories[categoryIndex];
                //Loop through fields in each category
                if (category.customFields && category.customFields.length > 0) {
                    for (
                        var fieldIndex = 0;
                        fieldIndex < category.customFields.length;
                        fieldIndex++
                    ) {
                        var field = category.customFields[fieldIndex];
                        if (field.data && field.data.length > 0) {
                            // loop through data
                            for (
                                var dataIndex = 0;
                                dataIndex < field.data.length;
                                dataIndex++
                            ) {
                                var dataElement = field.data[dataIndex];
                                // Only keep updated and created - 0 == falsy
                                if (dataElement.changeState)
                                    data.push(dataElement);
                            }
                        }
                    }
                }
            }
            return data;
        }

        function mergeCategoriesWithData(categories, data) {
            if (!categories || (categories && categories.length === 0)) {
                // return categories if we don't have any categories
                return categories;
            }
            if (!data || (data && data.length === 0)) {
                //return categories as is if we don't have any data
                return categories;
            }
            //Loop through categories
            for (
                var categoryIndex = 0;
                categoryIndex < categories.length;
                categoryIndex++
            ) {
                var category = categories[categoryIndex];
                //Loop through fields in each category
                if (category.customFields && category.customFields.length > 0) {
                    for (
                        var fieldIndex = 0;
                        fieldIndex < category.customFields.length;
                        fieldIndex++
                    ) {
                        var field = category.customFields[fieldIndex];
                        //Loop through details and attach to field
                        for (
                            var detailIndex = 0;
                            detailIndex < data.length;
                            detailIndex++
                        ) {
                            var detail = data[detailIndex];
                            if (detail.customFieldId === field.id) {
                                if (!field.data) {
                                    field.data = [];
                                }
                                field.data.push(detail);
                            }
                        }
                    }
                }
            }

            return categories;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.common')
        .service('toastService', toastService);

    /* @ngInject */
    function toastService(toastr) {
        var self = this;

        self.success = success;
        self.info = info;
        self.warning = warning;
        self.error = error;

        function success(text, title) {
            toastr.success(text, title);
        }

        function info(text, title) {
            toastr.info(text, title);
        }

        function warning(text, title) {
            toastr.warning(text, title);
        }

        function error(text, title) {
            toastr.error(text, title);
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.common')
        .service('loadingService', loadingService);

    /* @ngInject */
    function loadingService($rootScope) {
        var self = this;
        self.setLoadingStatus = setLoadingStatus;
        self.setBackgroundLoadingStatus = setBackgroundLoadingStatus;
        self.isLoading = false;
        self.isLoadingInBackground = false;
        ////////////////

        function setLoadingStatus(value) {
            self.isLoading = value;
            $rootScope.loadingProgress = value;
        }

        function setBackgroundLoadingStatus(value) {
            self.isLoadingInBackground = value;
            $rootScope.loadingProgress = value;
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.common')
        .factory('datatableService', datatableService);

    /* @ngInject */
    function datatableService(DTOptionsBuilder, DTDefaultOptions, $translate) {

        var service = {
            getLocalizedOptions: getLocalizedOptions,
            getLocalizedOptionsWithPromise: getLocalizedOptionsWithPromise
        };
        
        DTDefaultOptions.setLoadingTemplate('<md-whiteframe class="md-whiteframe-1dp" layout="column"><md-progress-linear md-mode="query"></md-progress-linear><div layout="column" layout-padding layout-align="space-around"><h2>{{\'COMMON.DATA.DATATABLE_PROCESSING\' | translate}}</h2></div></md-progress-circular></md-whiteframe>');        
        
        return service;

        function getLocalizedOptions() {
            return DTOptionsBuilder.newOptions()
                .withLanguage({
                    "sEmptyTable": $translate.instant('COMMON.DATA.NO_DATA_FOUND'),
                    "sInfo": $translate.instant('COMMON.DATA.DATATABLE_INFO'),
                    "sInfoEmpty": $translate.instant('COMMON.DATA.DATATABLE_INFO_EMPTY'),
                    "sInfoFiltered": $translate.instant('COMMON.DATA.DATATABLE_INFO_FILTERED'),
                    "sInfoPostFix": "",
                    "sInfoThousands": $translate.instant('COMMON.DATA.DATATABLE_INFO_THOUSANDS'),
                    "sLengthMenu": $translate.instant('COMMON.DATA.DATATABLE_LENGTH_MENU'),
                    "sLoadingRecords": $translate.instant('COMMON.DATA.DATATABLE_LOADING'),
                    "sProcessing": $translate.instant('COMMON.DATA.DATATABLE_PROCESSING'),
                    "sSearch": $translate.instant('COMMON.DATA.DATATABLE_SEARCH'),
                    "sZeroRecords": $translate.instant('COMMON.DATA.DATATABLE_ZERO_RECORDS'),
                    "oPaginate": {
                        "sFirst": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.FIRST'),
                        "sLast": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.LAST'),
                        "sNext": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.NEXT'),
                        "sPrevious": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.PREVIOUS')
                    },
                    "oAria": {
                        "sSortAscending": $translate.instant('COMMON.DATA.DATATABLE_ARIA.SORT_ASCENDING'),
                        "sSortDescending": $translate.instant('COMMON.DATA.DATATABLE_ARIA.SORT_DESCENDING')
                    }
                });
        }

        function getLocalizedOptionsWithPromise(promise) {
            return DTOptionsBuilder.fromFnPromise(function () {
                return promise;
            })
                .withLanguage({
                    "sEmptyTable": $translate.instant('COMMON.DATA.NO_DATA_FOUND'),
                    "sInfo": $translate.instant('COMMON.DATA.DATATABLE_INFO'),
                    "sInfoEmpty": $translate.instant('COMMON.DATA.DATATABLE_INFO_EMPTY'),
                    "sInfoFiltered": $translate.instant('COMMON.DATA.DATATABLE_INFO_FILTERED'),
                    "sInfoPostFix": "",
                    "sInfoThousands": $translate.instant('COMMON.DATA.DATATABLE_INFO_THOUSANDS'),
                    "sLengthMenu": $translate.instant('COMMON.DATA.DATATABLE_LENGTH_MENU'),
                    "sLoadingRecords": $translate.instant('COMMON.DATA.DATATABLE_LOADING'),
                    "sProcessing": $translate.instant('COMMON.DATA.DATATABLE_PROCESSING'),
                    "sSearch": $translate.instant('COMMON.DATA.DATATABLE_SEARCH'),
                    "sZeroRecords": $translate.instant('COMMON.DATA.DATATABLE_ZERO_RECORDS'),
                    "oPaginate": {
                        "sFirst": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.FIRST'),
                        "sLast": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.LAST'),
                        "sNext": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.NEXT'),
                        "sPrevious": $translate.instant('COMMON.DATA.DATATABLE_PAGINATION.PREVIOUS')
                    },
                    "oAria": {
                        "sSortAscending": $translate.instant('COMMON.DATA.DATATABLE_ARIA.SORT_ASCENDING'),
                        "sSortDescending": $translate.instant('COMMON.DATA.DATATABLE_ARIA.SORT_DESCENDING')
                    }
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.common').service('commonService', commonService);

    /* @ngInject */
    function commonService() {
        var self = this;

        self.addOrReplaceToArray = addOrReplaceToArray;
        self.priceFunctions = {
            getTotalPrice: getTotalPrice,
            getPriceIncludingVat: getPriceIncludingVat,
            getPriceExcludingVat: getPriceExcludingVat,
            getVatAmount: getVatAmount,
        };

        ////////////////

        function addOrReplaceToArray(newData, targetArray) {
            if (!targetArray || targetArray.length === 0) {
                targetArray = newData;
                return;
            }
            for (var index = 0; index < newData.length; index++) {
                var newElement = newData[index];
                var matchFound = false;
                for (
                    var oldIndex = 0;
                    oldIndex < targetArray.length;
                    oldIndex++
                ) {
                    var oldElement = targetArray[oldIndex];
                    if (newElement.id === oldElement.id) {
                        //Already exists -> replace with new one
                        matchFound = true;
                        targetArray.splice(oldIndex, 1);
                        targetArray.push(newElement);
                        break;
                    }
                }
                if (!matchFound) {
                    targetArray.push(newElement);
                }
            }
        }

        function getTotalPrice(amount, itemPrice) {
            return amount * itemPrice;
        }

        function getPriceIncludingVat(vatRate, itemPrice) {
            if (vatRate == 0) {
                return itemPrice;
            }
            return itemPrice * ((100 + vatRate) / 100);
        }

        function getPriceExcludingVat(vatRate, itemPriceIncludingVat) {
            if (vatRate == 0) {
                return itemPriceIncludingVat;
            }
            return itemPriceIncludingVat / ((100 + vatRate) / 100);
        }

        function getVatAmount(vatRate, itemPrice) {
            if (vatRate == 0) {
                return 0;
            }
            return itemPrice * (vatRate / 100);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.common')
        .filter('serializedList', serializedList);

    function serializedList() {
        return serializedListFilter;

        ////////////////

        function serializedListFilter(data) {
            if (!data) return data;
            return data.replace(/\/\/?/g, '<span class="serialized-list-delimiter">//</span>');
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('app.common')
        .filter('padding', padding);

    function padding() {
        return paddingFilter;

        ////////////////

        function paddingFilter(n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = '' + num;
            while (num.length < len) {
                num = '0' + num;
            }
            return num;
        }
    }
})();


(function() {
    'use strict';
    angular
        .module('app.common')
        .filter('nl2br', nl2br);

    function nl2br() {
        return nl2brFilter;

        ////////////////

        function nl2brFilter(data) {
            if (!data) return data;
            return data.replace(/\n\r?/g, '<br />');
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.ceremony').factory('ceremonyService', ceremonyService);

    /* @ngInject */
    function ceremonyService() {
        var service = {
            getEmptyCeremony: getEmptyCeremony,
            getEmptyCeremonyDeceased: getEmptyCeremonyDeceased,
        };

        return service;

        function getEmptyCeremony() {
            return {
                subject: null,
                text: null,
                attendanceTime: null,
                start: null,
                end: null,
                isAllDay: false,
                internalType: null,
                internalId: null,
                recurrencePattern: null,
                exceptionAppointments: null,
                attendeesMustRsvp: false,
                remarks: null,
                options: 'none',
                billTo: 'unknown',
                calendarEventTypeId: null,
                isCompleted: false,
                completedTime: null,
                completedById: null,
                workOrderId: null,
                hostId: null,
                reservationId: null,
                locationId: null,
                locationRemarks: null,
                addressId: null,
                addressRemarks: null,
                supplierId: null,
                remarksSupplier: null,
                confirmedById: null,
                confirmedDate: null,
                isConfirmed: false,
                confirmationRemarks: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
                isSilentCeremony: false,
                isCeremonialFuneral: false,
                liturgy: null,
            };
        }

        function getEmptyCeremonyDeceased() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.CalendarEventDeceasedDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                remarks: null,
                sortOrder: 0,
                calendarEventId: '00000000-0000-0000-0000-000000000000',
                calendarEvent: null,
                deceasedId: '00000000-0000-0000-0000-000000000000',
                deceased: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.calendar').service('calendarWeekViewService', calendarWeekViewService);

    /* @ngInject */
    function calendarWeekViewService($q, dataService) {
        var self = this;

        self.getNotesAndTaskCountByDate = getNotesAndTaskCountByDate;
        self.toggleSelectedCalendarEventType = toggleSelectedCalendarEventType;
        self.isCalendarEventTypeSelected = isCalendarEventTypeSelected;
        self.toggleAllSelectedCalendarEventTypes = toggleAllSelectedCalendarEventTypes;

        self.selectedCalendarEventTypes = [];
        self.calendarEventTypes = [];

        activate();

        function getNotesAndTaskCountByDate(date) {
            return dataService.getByUri('NoteOrTasks', 'NotesAndTasksCount/ByDate', { date: date });
        }

        function activate() {
            dataService.getAll('CalendarEventTypes').then(function (calendarEventTypes) {
                self.selectedCalendarEventTypes = self.selectedCalendarEventTypes.concat(calendarEventTypes);
                self.calendarEventTypes = calendarEventTypes;
            });
        }

        function toggleSelectedCalendarEventType(calendarEventType) {
            if (!calendarEventType) return;
            var index = self.selectedCalendarEventTypes.indexOf(calendarEventType);
            if (index > -1) {
                self.selectedCalendarEventTypes.splice(index, 1);
            } else {
                self.selectedCalendarEventTypes.push(calendarEventType);
            }
        }

        function toggleAllSelectedCalendarEventTypes() {
            if (self.selectedCalendarEventTypes.length > 0) {
                self.selectedCalendarEventTypes = [];
            } else {
                self.selectedCalendarEventTypes = self.selectedCalendarEventTypes.concat(self.calendarEventTypes);
            }
        }

        function isCalendarEventTypeSelected(calendarEventTypeId) {
            if (!calendarEventTypeId) return false;
            for (var index = 0; index < self.selectedCalendarEventTypes.length; index++) {
                var element = self.selectedCalendarEventTypes[index];
                if (element.id === calendarEventTypeId) return true;
            }
            return false;
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.calendar").controller("WeekViewController", WeekViewController);

  /* @ngInject */
  function WeekViewController(
    $scope,
    $timeout,
    $state,
    $q,
    $stateParams,
    currentUser,
    calendarViewService,
    calendarWeekViewService,
    loadingService
  ) {
    var vm = this;
    vm.dateGroups = [];
    vm.currentUser = currentUser;

    vm.loadingService = loadingService;
    vm.orderEvents = orderEvents;

    vm.service = calendarViewService;
    vm.weekViewService = calendarWeekViewService;
    vm.currentDate = moment($stateParams.date, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss");
    vm.startDate = moment(vm.currentDate)
      .startOf("week")
      .format("YYYY-MM-DDTHH:mm:ss");
    vm.endDate = moment(vm.currentDate)
      .endOf("week")
      .format("YYYY-MM-DDTHH:mm:ss");

    vm.weekNumber = moment(vm.currentDate).week();
    vm.service.data.selectedTab = "WEEK";
    calendarViewService.setSelectedDate(vm.currentDate);

    vm.navigateToDayView = navigateToDayView;

    activate();

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      calendarViewService.getByDateRange(vm.startDate, vm.endDate).then(function(events) {
        vm.dateGroups = calendarViewService.createDateGroups(events, true, vm.startDate, vm.endDate);
        loadNotesAndTaskCount(vm.dateGroups);
        vm.loadingService.setLoadingStatus(false);
        // Initialize reloading - 3 min
        vm.reloader = $timeout(reload, 300000);
      });
    }

    function loadNotesAndTaskCount() {
      if (!vm.dateGroups || vm.dateGroups.length === 0) return;
      var promises = [];

      for (var index = 0; index < 7; index++) {
        vm.dateGroups[index].isLoading = true;
        promises.push(calendarWeekViewService.getNotesAndTaskCountByDate(vm.dateGroups[index].start));
      }

      $q.all(promises).then(function(response) {
        for (var index = 0; index < 7; index++) {
          vm.dateGroups[index].notesAndTaskCount = response[index];
          vm.dateGroups[index].isLoading = false;
        }
      });
    }

    function navigateToDayView(date) {
      $state.go("app.calendar.day-view", {
        date: moment(date).format("YYYY-MM-DD")
      });
    }

    function reload() {
      activate();
    }

    $scope.$on("$destroy", function(p1, p2) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
    });

    function orderEvents(event) {
      if (event.isAllDay || moment(event.end).isAfter(moment(event.start).add(1, "days"))) {
        return "0";
      }

      return moment(event.start).format("LT");
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.calendar').factory('calendarService', calendarService);

    /* @ngInject */
    function calendarService(calendarEventOptions, $mdDialog, $document) {
        var eventTypes;

        var service = {
            getEmptyEvent: getEmptyCalendarEvent,
            getEmptyCalendarEvent: getEmptyCalendarEvent,
            getEmptyCalendarEventUser: getEmptyCalendarEventUser,
            getEmptyCalendarEventDeceased: getEmptyCalendarEventDeceased,
            getEmptyCalendarEventParticipant: getEmptyCalendarEventParticipant,
            getEmptyCalendarEventEquipment: getEmptyCalendarEventEquipment,
            showEditCalendarEventEquipmentDialog: showEditCalendarEventEquipmentDialog,
            options: {
                hasParticipants: hasParticipants,
                hasProgram: hasProgram,
                hasCompletedStatus: hasCompletedStatus,
                isBooking: isBooking,
                isCeremony: isCeremony,
                isCeremonialFuneral: isCeremonialFuneral,
                isGrooming: isGrooming,
                isTransport: isTransport,
                showSupplier: showSupplier,
                shouldIncludeComposers: shouldIncludeComposers,
                shouldIncludeDates: shouldIncludeDates,
                shouldCapitalizeLocationName: shouldCapitalizeLocationName,
                hasWorkOrder: hasWorkOrder,
                isCremation: isCremation,
                toggleFlag: toggleFlag,
                isFlagSet: isFlagSet,
            },
            classUtils: {
                isCalendarEvent: isObjectCalendarEvent,
                isBooking: isObjectBooking,
                isCeremony: isObjectCeremony,
                isGrooming: isObjectGrooming,
                isTransport: isObjectTransport,
            },
        };

        return service;

        function isObjectCalendarEvent(event, useStrictComparison) {
            if (!event) return false;
            return event.hasOwnProperty('calendarEventTypeId') && useStrictComparison
                ? !isObjectBooking(event) && !isObjectCeremony(event) && !isObjectGrooming(event) && !isObjectTransport(event)
                : true;
        }

        function hasParticipants(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.HAS_PARTICIPANTS.value) > -1;
        }

        function hasProgram(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.HAS_PROGRAM.value) > -1;
        }

        function hasCompletedStatus(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.HAS_COMPLETED_STATUS.value) > -1;
        }

        function isBooking(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_BOOKING.value) > -1;
        }

        function isObjectBooking(event, useStrictComparison) {
            if (!event) return false;
            return (
                event.hasOwnProperty('isConfirmed') &&
                (useStrictComparison ? !isObjectCeremony(event) && !isObjectGrooming(event) && !isObjectTransport(event) : true)
            );
        }

        function isCeremony(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_CEREMONY.value) > -1;
        }

        function isObjectCeremony(event) {
            if (!event) return false;
            return event.hasOwnProperty('isCeremonialFuneral');
        }

        function isCeremonialFuneral(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_CEREMONIAL_FUNERAL.value) > -1;
        }

        function isGrooming(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_GROOMING.value) > -1;
        }

        function isObjectGrooming(event) {
            if (!event) return false;
            return event.hasOwnProperty('groomingDescription');
        }

        function isTransport(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_TRANSPORT.value) > -1;
        }

        function isObjectTransport(event, useStrictComparison) {
            if (!event) return false;
            return event.hasOwnProperty('transportDescription') && (useStrictComparison ? !isObjectGrooming(event) : true);
        }

        function showSupplier(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.SHOW_SUPPLIER.value) > -1;
        }

        function shouldIncludeComposers(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.SHOULD_INCLUDE_COMPOSERS.value) > -1;
        }

        function shouldIncludeDates(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.SHOULD_INCLUDE_DATES.value) > -1;
        }

        function shouldCapitalizeLocationName(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.SHOULD_CAPITALIZE_LOCATION_NAME.value) > -1;
        }

        function hasWorkOrder(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.HAS_WORK_ORDER.value) > -1;
        }

        function isCremation(options) {
            if (!options || !calendarEventOptions) return false;
            return options && options.indexOf(calendarEventOptions.IS_CREMATION.value) > -1;
        }

        function isFlagSet(options, flag) {
            if (!flag || flag === 'none') return !options;
            if (flag && flag.indexOf(',') > -1) {
                // checking for multiple flags -> return true if any match
                var returnValue = false;
                var flags = flag.split(', ');
                flags.forEach(function (currentFlag) {
                    returnValue = returnValue || isFlagSet(options, currentFlag);
                });
                return returnValue;
            }
            return options && options.indexOf(flag) > -1;
        }

        function toggleFlag(options, flag) {
            if (isFlagSet(option, flag)) {
                options = options.replace(', ' + flag, '');
                options = options.replace(flag, '');
                if (!options) {
                    options = 'none';
                }
            } else {
                if (options === 'none') {
                    options = null;
                }
                if (options) {
                    options += ', ' + flag;
                } else {
                    options = flag;
                }
            }
            return options;
        }

        function getEmptyCalendarEvent() {
            return {
                subject: null,
                text: null,
                attendanceTime: null,
                start: null,
                end: null,
                isAllDay: false,
                internalType: null,
                internalId: null,
                recurrencePattern: null,
                exceptionAppointments: null,
                attendeesMustRsvp: false,
                remarks: null,
                options: 'none',
                billTo: 'unknown',
                calendarEventTypeId: null,
                isCompleted: false,
                completedTime: null,
                completedById: null,
                workOrderId: null,
                hostId: null,
                reservationId: null,
                locationId: null,
                locationRemarks: null,
                addressId: null,
                addressRemarks: null,
            };
        }

        function getEmptyCalendarEventUser() {
            return {
                sortOrder: 0,
                role: null,
                remarks: null,
                rsvpStatus: 'haventResponded',
                rsvpChangedTime: null,
                rsvpMessage: null,
                calendarEventId: '00000000-0000-0000-0000-000000000000',
                calendarEvent: null,
                userId: null,
            };
        }

        function getEmptyCalendarEventEquipment() {
            return {
                amount: null,
                remarks: null,
                sortOrder: 0,
                equipmentId: '00000000-0000-0000-0000-000000000000',
                calendarEventId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function getEmptyCalendarEventDeceased() {
            return {
                remarks: null,
                sortOrder: 0,
                calendarEventId: '00000000-0000-0000-0000-000000000000',
                deceasedId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function getEmptyCalendarEventParticipant() {
            return {
                internalIdentifier: null,
                overriddenRoleName: null,
                sortOrder: 0,
                remarks: null,
                hideInProgram: false,
                calendarEventId: '00000000-0000-0000-0000-000000000000',
                participantRoleId: null,
                participantId: '00000000-0000-0000-0000-000000000000',
            };
        }

        function showEditCalendarEventEquipmentDialog(calendarEventEquipment, e) {
            return $mdDialog.show({
                controller: 'EditCalendarEventEquipmentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/calendar/dialogs/edit-calendar-event-equipment-dialog/edit-calendar-event-equipment-dialog.tmpl.html',
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                locals: {
                    calendarEventEquipment: calendarEventEquipment,
                },
                clickOutsideToClose: true,
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.calendar').factory('calendarViewService', calendarViewService);

    /* @ngInject */
    function calendarViewService($rootScope, $filter, $q, $mdDialog, $document, $state, dataService, calendarService) {
        var serviceData = {
            selectedDate: null,
            selectedDateAsUnix: '',
            currentEvents: [],
            currentNotesAndTasks: [],
            selectedTab: '',
        };

        var service = {
            data: serviceData,
            setSelectedDate: setSelectedDate,
            createHourGroups: createHourGroups,
            createDateGroups: createDateGroups,
            getByDate: getByDate,
            getByDateRange: getByDateRange,
            getActiveUsers: getActiveUsers,
            getFirstDayOfWeek: getFirstDayOfWeek,
            getLastDayOfWeek: getLastDayOfWeek,
            isSelected: isSelected,
            changeTab: changeTab,
            navigateToDate: navigateToDate,
            navigateNext: navigateNext,
            navigatePrevious: navigatePrevious,
            selectedDateChanged: selectedDateChanged,
            navigateToCalendarEvent: navigateToCalendarEvent,
            addCalendarEvent: addCalendarEvent,
            addIncomingWorkOrder: addIncomingWorkOrder,
            mergeCollection: mergeCollection,
            noteOrTaskApi: { noob: null },
        };

        return service;

        //METHODS
        function navigateToCalendarEvent(calendarEvent, calendarEventType) {
            // Ceremony
            if (calendarService.classUtils.isCeremony(calendarEvent)) {
                $state.go('app.calendar.day-view.ceremonyById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    selectedDate: serviceData.selectedDate,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isGrooming(calendarEvent)) {
                $state.go('app.calendar.day-view.groomingById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    selectedDate: serviceData.selectedDate,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isTransport(calendarEvent)) {
                $state.go('app.calendar.day-view.transportById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    selectedDate: serviceData.selectedDate,
                    calendarEventType: calendarEventType,
                });
            } else if (calendarService.classUtils.isBooking(calendarEvent)) {
                $state.go('app.calendar.day-view.bookingById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    selectedDate: serviceData.selectedDate,
                    calendarEventType: calendarEventType,
                });
            } else {
                $state.go('app.calendar.day-view.calendarEventById', {
                    calendarEventId: calendarEvent.id,
                    calendarEventTypeId: calendarEvent.calendarEventTypeId,
                    selectedDate: serviceData.selectedDate,
                    calendarEventType: calendarEventType,
                });
            }
        }

        function addCalendarEvent(e) {
            $mdDialog
                .show({
                    controller: 'AddCalendarEventDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/calendar/dialogs/add-calendar-event-dialog/add-calendar-event-dialog.tmpl.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    locals: {
                        workOrderId: null,
                        flagOption: 0,
                    },
                    clickOutsideToClose: true,
                })
                .then(function (calendarEvent) {
                    if (calendarEvent) {
                        calendarEvent.id = 'new';
                        navigateToCalendarEvent(calendarEvent, calendarEvent.calendarEventType);
                    }
                });
        }

        function addIncomingWorkOrder(e) {
            $state.go('app.calendar.day-view.quickRegistration', {
                selectedDate: serviceData.selectedDate,
            });
        }

        function navigateToDate(date) {
            $state.go($state.current, {
                date: moment(date).startOf('day').format('YYYY-MM-DD'),
            });
        }

        function navigateNext(amount, scale) {
            navigateToDate(
                moment(serviceData.selectedDate)
                    .add(amount || 1, scale || 'days')
                    .format('YYYY-MM-DDTHH:mm:ss')
            );
        }

        function navigatePrevious(amount, scale) {
            navigateToDate(
                moment(serviceData.selectedDate)
                    .add(amount || -1, scale || 'days')
                    .format('YYYY-MM-DDTHH:mm:ss')
            );
        }

        function selectedDateChanged() {
            navigateToDate(serviceData.selectedDate);
        }

        function changeTab(newTab) {
            switch (newTab) {
                case 'DAY':
                    $state.go('app.calendar.day-view', {
                        date: moment(serviceData.selectedDate).format('YYYY-MM-DD'),
                    });
                    break;
                case 'WEEK':
                    $state.go('app.calendar.week-view', {
                        date: moment(serviceData.selectedDate).format('YYYY-MM-DD'),
                    });
                    break;
                default:
                    $state.go('app.calendar.day-view', {
                        date: moment(serviceData.selectedDate).format('YYYY-MM-DD'),
                    });
                    break;
            }
        }

        function isSelected(tab) {
            return serviceData.selectedTab === tab;
        }

        function getActiveUsers() {
            return dataService.getAll('BaldrisUsers').then(function (baldrisUsers) {
                if (baldrisUsers && baldrisUsers.length > 0) {
                    baldrisUsers = baldrisUsers.filter(function (baldrisUser) {
                        return !baldrisUser.isDeleted || baldrisUser.isAlumni;
                    });
                }
                return baldrisUsers;
            });
        }

        function getByDate(date, isNewDate) {
            isNewDate = isNewDate || false;
            var endDate = moment(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
            if (!serviceData.currentEvents || isNewDate) serviceData.currentEvents = [];
            if (!serviceData.currentNotesAndTasks || isNewDate) serviceData.currentNotesAndTasks = [];

            var promises = [];
            promises.push(dataService.getBetweenDates('CalendarEvents', date, endDate));
            promises.push(dataService.getBetweenDates('NoteOrTasks', date, endDate));

            return $q.all(promises).then(function (returnData) {
                serviceData.currentEvents = mergeCollection(returnData[0], serviceData.currentEvents);
                if (returnData[1]) {
                    serviceData.currentNotesAndTasks = mergeCollection(returnData[1].notes.concat(returnData[1].tasks), serviceData.currentNotesAndTasks);
                    // Filter out work order note and tasks
                    if (serviceData.currentNotesAndTasks && serviceData.currentNotesAndTasks.length > 0) {
                        serviceData.currentNotesAndTasks = serviceData.currentNotesAndTasks.filter(function (nt) {
                            return !nt.workOrderId;
                        });
                    }
                }
                return {
                    requestedDate: date,
                    events: returnData[0],
                    noteOrTasks: returnData[1],
                };
            });
        }

        function getByDateRange(startDate, endDate) {
            endDate = moment(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
            return dataService.getBetweenDates('CalendarEvents', startDate, endDate).then(function (events) {
                return events;
            });
        }

        function mergeCollection(newCollection, oldCollection) {
            newCollection = newCollection.data || newCollection;
            var combinedCollection = [];
            if (!oldCollection || oldCollection.length === 0) {
                combinedCollection = newCollection || [];
                return combinedCollection;
            }
            if (!newCollection || newCollection.length === 0) {
                combinedCollection = oldCollection || [];
                return combinedCollection;
            }
            combinedCollection = oldCollection;
            for (var i = 0; i < newCollection.length; i++) {
                var newObject = newCollection[i];
                if (newObject && newObject.id) {
                    var oldObject = getById(newObject.id, combinedCollection);
                    if (!oldObject) {
                        // Doesn't exist => add
                        combinedCollection.push(newObject);
                    } else {
                        if (!angular.equals(newObject, oldObject)) {
                            // Object has changed => replace
                            var oldIndex = combinedCollection.indexOf(oldObject);
                            combinedCollection.splice(oldIndex, 1);
                            combinedCollection.push(newObject);
                        }
                    }
                }
            }
            return combinedCollection;
        }

        function getById(id, collection) {
            if (!collection || collection.length === 0) return null;
            for (var i = 0; i < collection.length; i++) {
                var obj = collection[i];
                if (obj && obj.id === id) {
                    return obj;
                }
            }
            return null;
        }

        function setSelectedDate(newDate) {
            if (angular.isString(newDate)) {
                serviceData.selectedDate = newDate;
                serviceData.selectedDateAsUnix = moment(newDate).format('x');
            } else {
                serviceData.selectedDate = moment(newDate).format('YYYY-MM-DDTHH:mm:ss');
                serviceData.selectedDateAsUnix = moment(newDate).format('x');
            }

            $rootScope.$broadcast('baldris::calendar::selectedDateChanged', newDate);
        }

        function getFirstDayOfWeek() {
            return moment(serviceData.selectedDate).startOf('week').format('YYYY-MM-DDTHH:mm:ss');
        }

        function getLastDayOfWeek() {
            return moment(serviceData.selectedDate).endOf('week').format('YYYY-MM-DDTHH:mm:ss');
        }

        function createHourGroups(events, shouldCreateAllWorkHourGroups) {
            if (!events) {
                events = [];
            }
            events = events.data || events;
            var hourGroups = [];
            // sort events
            events = $filter('orderBy')(events, 'start', false);

            var createdHours = [];
            shouldCreateAllWorkHourGroups = shouldCreateAllWorkHourGroups || false;
            if (shouldCreateAllWorkHourGroups) {
                //Allday-group
                hourGroups.push({
                    moment: moment().startOf('day'),
                    from: -1,
                    isAllDay: true,
                    to: 0,
                });
                createdHours.push(-1);
                //Create groups from 8-16
                var step;
                for (step = 8; step < 17; step++) {
                    hourGroups.push({
                        moment: moment().hour(step).minute(0),
                        from: step,
                        isAllDay: false,
                        to: step + 1,
                    });
                    createdHours.push(step);
                }
            }

            // make groups
            angular.forEach(events, function (event) {
                var startMoment = moment(event.start);
                var nextDayMoment = startMoment.add(1, 'days');
                var endMoment = moment(event.end);
                var hour = startMoment.hour();

                if (event.isAllDay || endMoment.isSameOrAfter(nextDayMoment)) {
                    hour = -1;
                }

                //Check that the group havent been created
                if (createdHours.indexOf(hour) === -1) {
                    if (hour === -1) {
                        hourGroups.push({
                            moment: startMoment.startOf('day'),
                            from: hour,
                            isAllDay: true,
                            to: hour + 1,
                        });
                    } else {
                        hourGroups.push({
                            moment: startMoment.startOf('hour'),
                            isAllDay: false,
                            from: hour,
                            to: hour + 1,
                        });
                    }

                    createdHours.push(hour);
                }
            });

            //Put events in groups
            angular.forEach(hourGroups, function (group) {
                group.events = $filter('hourGroup')(events, group);
            });

            return hourGroups;
        }

        function createDateGroups(events, shouldCreateEmptyDateGroups, startDate, endDate) {
            events = events.data || events;
            shouldCreateEmptyDateGroups = shouldCreateEmptyDateGroups || false;

            var dateGroups = [];
            // sort events
            events = $filter('orderBy')(events, 'start', false);

            var createdDates = [];

            if (shouldCreateEmptyDateGroups) {
                // TODO: Add functionality for creating empty dates
                var currentMoment = moment(startDate).startOf('day');
                while (currentMoment.isSameOrBefore(endDate, 'day')) {
                    dateGroups.push({
                        start: currentMoment.startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        end: currentMoment.endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                        week: currentMoment.format('w'),
                    });

                    createdDates.push(currentMoment.format('YYYYMMDD'));
                    currentMoment.add(1, 'days');
                }
            }

            // make groups
            angular.forEach(events, function (event) {
                if (event.start) {
                    var startMoment = moment(event.start);
                    var dateString = startMoment.format('YYYYMMDD');

                    //Check that the group havent been created
                    if (createdDates.indexOf(dateString) === -1) {
                        dateGroups.push({
                            start: startMoment.startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                            end: startMoment.endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
                            week: startMoment.format('w'),
                        });

                        createdDates.push(startMoment.format('YYYYMMDD'));
                    }
                } else {
                    // Unknown start time
                    //Check that the group havent been created
                    if (createdDates.indexOf('UNKNOWN') === -1) {
                        dateGroups.push({
                            start: null,
                            end: null,
                            week: null,
                            label: 'CALENDAR.EVENT.UNKNOWN_START_TIME',
                        });

                        createdDates.push('UNKNOWN');
                    }
                }
            });

            // Purge unwanted groups
            if (startDate && endDate) {
                for (var index = 0; index < dateGroups.length; index++) {
                    var dateGroup = dateGroups[index];
                    if (!(moment(dateGroup.start).isSameOrAfter(startDate, 'day') && moment(dateGroup.start).isSameOrBefore(endDate, 'day'))) {
                        dateGroups.splice(index, 1);
                    }
                }
            }

            //Put events in groups
            angular.forEach(dateGroups, function (group) {
                group.events = $filter('dateGroup')(events, group);
                group.hourGroups = createHourGroups(group.events, false);
            });

            return dateGroups;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.calendar')
        .filter('inEventGroup', inEventGroup);
        
    /* @ngInject */
    function inEventGroup() {
        return inEventGroupFilter;

        ////////////////

        function inEventGroupFilter(calendarEventType, calendarEvents) {
            return calendarEvents.filter(function(calendarEvent) {
                if (calendarEvent.calendarEventTypeId === calendarEventType.id) {
                    return calendarEvent;
                }
            });
        }
    }
})();
(function() {
  "use strict";

  angular.module("app.calendar").filter("hourGroup", hourGroup);

  function hourGroup() {
    return filterFilter;

    ////////////////

    function filterFilter(events, hourGroup) {
      return events.filter(function(event) {
        var startMoment = moment(event.start);
        var nextDayMoment = startMoment.add(1, "days");
        var endMoment = moment(event.end);
        var hour = startMoment.hour();

        if ((event.isAllDay || endMoment.isSameOrAfter(nextDayMoment)) && hourGroup.from === -1) {
          return event;
        }

        if (!(event.isAllDay || endMoment.isSameOrAfter(nextDayMoment))) {
          if (hour >= hourGroup.from && hour < hourGroup.to) {
            return event;
          }
        }
      });
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.calendar").filter("dateGroup", dateGroup);

  function dateGroup() {
    return filterFilter;

    ////////////////

    function filterFilter(objects, dateGroup) {
      if (objects && objects.length > 0) {
        return objects.filter(function(object) {
          if (
            (!object.start || !object.startTime || !object.dueTime) &&
            dateGroup.label === "CALENDAR.EVENT.UNKNOWN_START_TIME"
          ) {
            return object;
          } else if (
            object.start &&
            moment(object.start).isSameOrBefore(dateGroup.end, "day") &&
            moment(object.end).isSameOrAfter(dateGroup.start, "day")
          ) {
            return object;
          } else if (
            object.startTime &&
            moment(object.startTime).isSameOrBefore(dateGroup.end, "day") &&
            moment(object.endTime).isSameOrAfter(dateGroup.start, "day")
          ) {
            return object;
          } else if (
            object.dueTime &&
            moment(object.dueTime).isSameOrBefore(dateGroup.end, "day") &&
            moment(object.dueTime).isSameOrAfter(dateGroup.start, "day")
          ) {
            return object;
          }
        });
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.calendar").filter("atDate", atDate);

  /* @ngInject */
  function atDate() {
    return atDateFilter;

    ////////////////

    function atDateFilter(date, collection) {
      return collection.filter(function(value) {
        var start = value.start || value.startTime;
        var end = value.end || value.endTime;
        //We can only determine if we have both start and end
        if (start && end) {
          //Between
          if (moment(date).isSameOrAfter(start, "day") && moment(date).isSameOrBefore(end, "day")) {
            return value;
          }
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.calendar').service('editCalendarEventService', editCalendarEventService);

    /* @ngInject */
    function editCalendarEventService(
        $q,
        $translate,
        dataService,
        calendarService,
        loadingService,
        locationService,
        editCustomFieldService,
        deceasedService,
        bookingService,
        ceremonyService,
        transportService,
        groomingService,
        addressService,
        baldrisConfigService
    ) {
        var self = this;

        self.updateModel = null;
        self.isNew = false;
        self.isLoadingCustomFieldData = false;
        self.isLoadingEquipment = false;

        var transportConfigs = null;
        var transportCalculationConfig = {
            isSet: false,
            startAmount: 0,
            distanceAmount: 0,
            minimumAmount: 0,
            hoursAmount: 0,
            additionalHoursAmount: 0,
        };

        self.loadCalendarEvent = loadCalendarEvent;
        self.saveCalendarEvent = saveCalendarEvent;
        self.onLocationSelected = onLocationSelected;
        self.options = calendarService.options;
        self.onIsCompletedChange = onIsCompletedChange;
        self.addAddress = addAddress;
        self.removeAddress = removeAddress;
        self.onEntityChanged = onEntityChanged;
        self.openEditCalendarEventEquipmentDialog = openEditCalendarEventEquipmentDialog;
        self.isFlagSet = isFlagSet;
        self.toggleFlag = toggleFlag;
        self.calculatePrice = calculatePrice;
        self.registerPrice = registerPrice;
        self.getCalendarEventString = getCalendarEventString;
        self.customFieldCategoryFilter = customFieldCategoryFilter;
        self.customFieldFilter = customFieldFilter;
        self.deleteCalendarEvent = deleteCalendarEvent;

        function loadCalendarEvent(
            calendarEventId,
            workOrderId,
            deceased,
            calendarEventTypeId,
            apiControllerName,
            calendarEventType,
            selectedDate,
            transportSuggestion
        ) {
            loadingService.setLoadingStatus(true);
            reset();
            apiControllerName = apiControllerName || 'CalendarEvents';
            if (!calendarEventId || calendarEventId.toLowerCase() === 'new') {
                self.isNew = true;
                self.updateModel = {
                    calendarEvent: getEmptyEvent(apiControllerName),
                    customFieldCategories: [],
                    calendarEventUsers: [],
                    details: [],
                    detailsData: [],
                    equipment: [],
                    participants: [],
                    calendarEventDeceased: [],
                    deceased: [],
                };
                self.updateModel.calendarEvent.workOrderId = workOrderId;

                // Add deceased
                if (deceased && deceased.length > 0) {
                    // Track most recent date of death
                    var mostRecentDateOfDeath = null;
                    for (var i = 0; i < deceased.length; i++) {
                        var workOrderDeceased = deceased[i];
                        var calendarEventDeceased = calendarService.getEmptyCalendarEventDeceased();
                        calendarEventDeceased.changeState = 1;
                        calendarEventDeceased.deceasedId = workOrderDeceased.id;
                        self.updateModel.calendarEventDeceased.push(calendarEventDeceased);
                        if (workOrderDeceased.dateOfDeath && !mostRecentDateOfDeath) {
                            mostRecentDateOfDeath = moment(workOrderDeceased.dateOfDeath).format('YYYY-MM-DDTHH:mm:ss');
                        } else if (
                            workOrderDeceased.dateOfDeath &&
                            mostRecentDateOfDeath &&
                            moment(workOrderDeceased.dateOfDeath).isAfter(mostRecentDateOfDeath)
                        ) {
                            mostRecentDateOfDeath = moment(workOrderDeceased.dateOfDeath).format('YYYY-MM-DDTHH:mm:ss');
                        }
                    }
                    // Suggest ceremony time based on deceased date of death
                    // TODO: Make configurable and i18n
                    if (calendarService.classUtils.isCeremony(self.updateModel.calendarEvent) && mostRecentDateOfDeath && !selectedDate) {
                        switch (moment(mostRecentDateOfDeath).day()) {
                            case 0: // Sunday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(5, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 1: // Monday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(8, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 2: // Tuesday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(7, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 3: // Wednesday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(8, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 4: // Thursday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(8, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 5: // Friday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(7, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                            case 6: // Saturday
                                self.updateModel.calendarEvent.start = moment(mostRecentDateOfDeath)
                                    .add(6, 'days')
                                    .hour(13)
                                    .minute(0)
                                    .format('YYYY-MM-DDTHH:mm:ss');
                                self.updateModel.calendarEvent.end = moment(self.updateModel.calendarEvent.start).add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss');
                                break;
                        }
                    } else if (selectedDate) {
                        var hour = moment().startOf('hour').hour() + 1;
                        self.updateModel.calendarEvent.start = moment(selectedDate).hour(hour).minute(0).format('YYYY-MM-DDTHH:mm:ss');
                        self.updateModel.calendarEvent.end = moment(selectedDate)
                            .hour(hour + 1)
                            .minute(0)
                            .format('YYYY-MM-DDTHH:mm:ss');
                    }
                } else if (selectedDate) {
                    var hour = moment().startOf('hour').hour() + 1;
                    self.updateModel.calendarEvent.start = moment(selectedDate).hour(hour).minute(0).format('YYYY-MM-DDTHH:mm:ss');
                    self.updateModel.calendarEvent.end = moment(selectedDate)
                        .hour(hour + 1)
                        .minute(0)
                        .format('YYYY-MM-DDTHH:mm:ss');
                }

                if (calendarEventType) {
                    self.updateModel.calendarEvent.subject = calendarEventType.name;
                    self.updateModel.calendarEvent.options = calendarEventType.options;
                }

                if (transportSuggestion) {
                    self.updateModel.calendarEvent.distance = transportSuggestion.distance;
                    self.updateModel.calendarEvent.driverHours = transportSuggestion.driverHours;
                    self.updateModel.calendarEvent.additionalHours = transportSuggestion.additionalHours;
                    self.updateModel.calendarEvent.additionalCost = transportSuggestion.additionalCost;
                    self.updateModel.calendarEvent.price = transportSuggestion.totalPrice;
                    self.updateModel.calendarEvent.billTo = transportSuggestion.billTo;
                    self.updateModel.calendarEvent.options = transportSuggestion.suggestedTransportTypeOptions;
                    self.updateModel.calendarEvent.originId = transportSuggestion.departureLocationId;
                    self.updateModel.calendarEvent.originRemarks = transportSuggestion.departureLocationRemarks;
                    self.updateModel.calendarEvent.destinationId = transportSuggestion.destinationLocationId;
                    self.updateModel.calendarEvent.destinationRemarks = transportSuggestion.destinationLocationRemarks;
                    if (apiControllerName === 'Groomings') {
                        self.updateModel.calendarEvent.locationId = transportSuggestion.departureLocationId;
                        self.updateModel.calendarEvent.locationRemarks = transportSuggestion.departureLocationRemarks;
                    }
                    self.updateModel.calendarEvent.subject = transportSuggestion.suggestedTransportTypeName;
                    self.updateModel.calendarEvent.transportDescription = transportSuggestion.invoiceText;
                    registerPrice();
                }

                // Get CustomFields
                if (calendarEventTypeId) {
                    self.updateModel.calendarEvent.calendarEventTypeId = calendarEventTypeId;
                    if (calendarEventType) {
                        self.updateModel.calendarEvent.calendarEventType = calendarEventType;
                        self.updateModel.calendarEvent.options = calendarEventType.options;
                    }
                    return loadRemainingData(self.updateModel.calendarEvent, self.updateModel.calendarEvent.calendarEventTypeId, transportSuggestion).then(
                        function (returnData) {
                            loadingService.setLoadingStatus(false);
                            loadingService.setBackgroundLoadingStatus(false);
                            return returnData;
                        }
                    );
                } else {
                    return $q.when({
                        updateModel: self.updateModel,
                        isNew: true,
                        customFieldCategories: [],
                    });
                }
            } else {
                var promises = [];
                // CalendarEvent - 0
                promises.push(dataService.getById(apiControllerName, calendarEventId));
                // CalendarEventUsers - 1
                promises.push(dataService.getByUri('CalendarEventUsers', 'ByCalendarEventId/' + calendarEventId));
                // CalendarEventEquipment - 2
                promises.push(dataService.getByUri('CalendarEventEquipment', 'ByCalendarEventId/' + calendarEventId));
                // CalendarEventParticipants - 3
                promises.push(dataService.getByUri('CalendarEventParticipants', 'ByCalendarEventId/' + calendarEventId));
                // CalendarEventDeceased - 4
                promises.push(dataService.getByUri('CalendarEventDeceased', 'ByCalendarEventId/' + calendarEventId));
                return $q.all(promises).then(function (response) {
                    self.updateModel = {
                        calendarEvent: response[0],
                        customFieldCategories: [],
                        calendarEventUsers: response[1],
                        details: [],
                        detailsData: [],
                        equipment: response[2],
                        participants: response[3],
                        calendarEventDeceased: response[4],
                        deceased: [],
                    };
                    //Ensure calendarEvent
                    if (!self.updateModel.calendarEvent) {
                        self.updateModel.calendarEvent = calendarService.getEmptyEvent();
                        self.updateModel.calendarEvent.changeState = 1;
                    }
                    return loadRemainingData(self.updateModel.calendarEvent, self.updateModel.calendarEvent.calendarEventTypeId, transportSuggestion).then(
                        function (returnData) {
                            loadingService.setLoadingStatus(false);
                            loadingService.setBackgroundLoadingStatus(false);
                            return returnData;
                        }
                    );
                });
            }
        }

        function loadRemainingData(calendarEvent, calendarEventTypeId, transportSuggestion) {
            // Main loading is now finished -> set appropriate loading status
            loadingService.setLoadingStatus(false);
            loadingService.setBackgroundLoadingStatus(true);
            self.isLoadingCustomFieldData = true;
            self.isLoadingEquipment = true;

            var promises = [];
            promises.push(baldrisConfigService.getByCategory('Transport'));
            if (calendarEvent.id && calendarEvent.id !== '00000000-0000-0000-0000-000000000000') {
                if (calendarEventTypeId) {
                    promises.push(
                        dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: calendarEvent.id,
                            attachedDataTargetName: 'CalendarEvent',
                            attachedTypeId: calendarEventTypeId,
                            attachedTypeName: 'CalendarEventType',
                        })
                    );
                    if (calendarService.options.isFlagSet(calendarEvent.options, 'isConference')) {
                        self.isConference = true;
                        promises.push(
                            dataService.getByUri('Reports', 'ByTemplateName', {
                                templateName: 'RegistrationOfIncomingWorkOrder',
                            })
                        );
                    }
                } else {
                    self.isLoadingCustomFieldData = false;
                }
            } else {
                self.isLoadingEquipment = false;
                if (calendarEventTypeId) {
                    promises.push(
                        dataService.getByUri('CustomFieldCategories', 'WithDataByAttachedId', {
                            attachedDataTargetId: '00000000-0000-0000-0000-000000000000',
                            attachedDataTargetName: 'CalendarEvent',
                            attachedTypeId: calendarEventTypeId,
                            attachedTypeName: 'CalendarEventType',
                        })
                    );
                    if (calendarService.options.isFlagSet(calendarEvent.options, 'isConference')) {
                        self.isConference = true;
                        promises.push(
                            dataService.getByUri('Reports', 'ByTemplateName', {
                                templatePath: 'RegistrationOfIncomingWorkOrder',
                            })
                        );
                    }
                } else {
                    self.isLoadingCustomFieldData = false;
                }
            }
            if (promises.length > 0) {
                return $q.all(promises).then(function (response) {
                    transportConfigs = response[0];
                    if (transportSuggestion) {
                        calculatePrice();
                    }
                    if (response && response.length > 0) {
                        if (calendarEvent.id && calendarEvent.id !== '00000000-0000-0000-0000-000000000000') {
                            self.isLoadingEquipment = false;
                            if (calendarEventTypeId) {
                                if (self.isConference) {
                                    self.registrationReport = response[2];
                                }
                                self.customFieldCategories = response[1];
                                self.isLoadingCustomFieldData = false;
                                return {
                                    updateModel: self.updateModel,
                                    isNew: self.isNew,
                                    customFieldCategories: self.customFieldCategories,
                                };
                            } else {
                                self.isLoadingCustomFieldData = false;
                                return {
                                    updateModel: self.updateModel,
                                    isNew: self.isNew,
                                    customFieldCategories: [],
                                };
                            }
                        } else {
                            self.isLoadingEquipment = false;
                            if (calendarEventTypeId) {
                                if (self.isConference) {
                                    self.registrationReport = response[2];
                                }
                                self.customFieldCategories = response[1];
                                self.isLoadingCustomFieldData = false;
                                return {
                                    updateModel: self.updateModel,
                                    isNew: self.isNew,
                                    customFieldCategories: self.customFieldCategories,
                                };
                            } else {
                                self.isLoadingCustomFieldData = false;
                                return {
                                    updateModel: self.updateModel,
                                    isNew: self.isNew,
                                    customFieldCategories: [],
                                };
                            }
                        }
                    } else {
                        self.isLoadingCustomFieldData = false;
                        self.isLoadingEquipment = false;
                        return {
                            updateModel: self.updateModel,
                            isNew: self.isNew,
                            customFieldCategories: [],
                        };
                    }
                });
            } else {
                self.isLoadingCustomFieldData = false;
                self.isLoadingEquipment = false;
                return $q.when({
                    updateModel: self.updateModel,
                    isNew: self.isNew,
                    customFieldCategories: [],
                });
            }
        }

        function saveCalendarEvent(apiControllerName) {
            apiControllerName = apiControllerName || 'CalendarEvents';

            if (self.updateModel.calendarEvent.id && self.updateModel.calendarEvent.id !== '00000000-0000-0000-0000-000000000000') {
                // Update
                return dataService.updateItem(apiControllerName, self.updateModel.calendarEvent).then(function () {
                    self.isNew = false;
                    return saveRemainingData(self.updateModel.calendarEvent);
                });
            }
            // Insert

            return dataService.insertItem(apiControllerName, self.updateModel.calendarEvent).then(function (insertedCalendarEvent) {
                self.updateModel.calendarEvent = insertedCalendarEvent;
                self.isNew = false;

                return saveRemainingData(self.updateModel.calendarEvent);
            });
        }

        // self.updateModel = {
        //     calendarEvent: getEmptyEvent(apiControllerName),
        //     customFieldCategories: [],
        //     calendarEventUsers: [],
        //     details: [],
        //     detailsData: [],
        //     equipment: [],
        //     participants: [],
        //     calendarEventDeceased: [],
        //     deceased: [],
        // };

        function saveRemainingData(calendarEvent) {
            var promises = [];
            promises = promises.concat(dataService.createBulkPromises('CalendarEventParticipants', self.updateModel.participants, 'calendarEventId', calendarEvent.id));
            promises = promises.concat(dataService.createBulkPromises('CalendarEventUsers', self.updateModel.calendarEventUsers, 'calendarEventId', calendarEvent.id));
            promises = promises.concat(dataService.createBulkPromises('CalendarEventEquipment', self.updateModel.equipment, 'calendarEventId', calendarEvent.id));
            promises = promises.concat(dataService.createBulkPromises('CalendarEventDeceased', self.updateModel.calendarEventDeceased, 'calendarEventId', calendarEvent.id));


            // Add newly created CustomFieldData to collection
            self.updateModel.detailsData = editCustomFieldService.extractDataFromCategories(self.customFieldCategories);

            promises = promises.concat(
                dataService.createBulkPromises('CustomFieldData', self.updateModel.detailsData, 'attachedTypeId', calendarEvent.id, 'CalendarEvent')
            );

            if (promises.length > 0) {
                return $q.all(promises);
            }
            return $q.when(promises);
        }

        function deleteCalendarEvent(apiControllerName) {
            apiControllerName = apiControllerName || 'CalendarEvents';
            // Set changestate on calendarEvent to ensure saving
            if (self.updateModel.calendarEvent.changeState !== 1) {
                self.updateModel.calendarEvent.changeState = 3;
                return dataService.deleteItem('CalendarEvents', self.updateModel.calendarEvent);
            } else {
                return $q.when(false);
            }
        }

        function onLocationSelected(location) {
            if (location) {
                // Update location reservation
                var beforeOffset = 0.5;
                var afterOffset = 0.5;
                if (self.updateModel.calendarEvent && self.updateModel.calendarEvent.start) {
                    if (self.updateModel.calendarEvent && self.updateModel.calendarEvent.isCeremonialFuneral) {
                        beforeOffset = 1.5;
                    }

                    if (!self.updateModel.locationReservation) {
                        self.updateModel.locationReservation = locationService.getEmptyLocationReservation();
                        self.updateModel.locationReservation.changeState = 1;
                    } else {
                        if (self.updateModel.locationReservation.changeState !== 1) {
                            self.updateModel.locationReservation.changeState = 2;
                        }
                    }
                    self.updateModel.locationReservation.start = moment(self.updateModel.calendarEvent.start)
                        .subtract(beforeOffset, 'hours')
                        .format('YYYY-MM-DDTHH:mm:ss');
                    if (self.updateModel.calendarEvent && self.updateModel.calendarEvent.end) {
                        self.updateModel.locationReservation.end = moment(self.updateModel.calendarEvent.end)
                            .add(afterOffset, 'hours')
                            .format('YYYY-MM-DDTHH:mm:ss');
                    }
                }
            } else {
                if (!self.updateModel.locationReservation) {
                    self.updateModel.locationReservation.start = null;
                    self.updateModel.locationReservation.end = null;
                }
            }
        }

        function getEmptyEvent(apiControllerName) {
            switch (apiControllerName) {
                case 'Bookings':
                    return bookingService.getEmptyBooking();
                case 'Ceremonies':
                    return ceremonyService.getEmptyCeremony();
                case 'Groomings':
                    return groomingService.getEmptyGrooming();
                case 'Transports':
                    return transportService.getEmptyTransport();
                default:
                    return calendarService.getEmptyEvent();
            }
        }

        function onIsCompletedChange() {
            if (self.updateModel.calendarEvent.isCompleted) {
                self.updateModel.calendarEvent.completedTime = moment().format('YYYY-MM-DDTHH:mm:ss');
                dataService.getCurrentUser().then(function (currentUser) {
                    self.updateModel.calendarEvent.completedById = currentUser.id;
                    self.updateModel.calendarEvent.completedBy = currentUser;
                    self.updateModel.calendarEvent.completedByDisplayName = currentUser.displayName;
                });
            } else {
                self.updateModel.calendarEvent.completedTime = null;
                self.updateModel.calendarEvent.completedBy = null;
                self.updateModel.calendarEvent.completedById = null;
                self.updateModel.calendarEvent.completedByDisplayName = null;
            }
        }

        function addAddress() {
            if (self.updateModel.address) {
                self.updateModel.address.changeState = 2;
            } else {
                self.updateModel.address = addressService.getEmptyAddress();
                self.updateModel.address.changeState = 1;
            }
        }

        function removeAddress() {
            if (self.updateModel.address && self.updateModel.address.changeState === 1) {
                self.updateModel.address = null;
            } else if (self.updateModel.address) {
                self.updateModel.address.localizedAddress = null;
                self.updateModel.address.changeState = 3;
            }
        }

        function onEntityChanged(entity) {
            if (entity) {
                if (entity.changeState !== 1) {
                    entity.changeState = 2;
                }
            }
        }

        function openEditCalendarEventEquipmentDialog(calendarEventEquipment, e) {
            var calendarEventEquipmentDto = null;
            if (!calendarEventEquipment) {
                calendarEventEquipmentDto = calendarService.getEmptyCalendarEventEquipment();
            } else {
                calendarEventEquipmentDto = angular.copy(calendarEventEquipment);
            }
            calendarService.showEditCalendarEventEquipmentDialog(calendarEventEquipmentDto, e).then(function (updatedCalendarEventEquipment) {
                if (updatedCalendarEventEquipment.changeState === 1) {
                    var index = self.updateModel.equipment.indexOf(calendarEventEquipment);
                    if (index > -1) {
                        self.updateModel.equipment.splice(index, 1);
                    }
                    self.updateModel.equipment.push(updatedCalendarEventEquipment);
                } else {
                    var index = self.updateModel.equipment.indexOf(calendarEventEquipment);
                    self.updateModel.equipment.splice(index, 1);
                    self.updateModel.equipment.push(updatedCalendarEventEquipment);
                }
                if (self.validation && self.validation.calendarEventForm && self.validation.calendarEventForm.$pristine) {
                    self.validation.calendarEventForm.$setDirty();
                }
            });
        }

        function isFlagSet(flag) {
            return calendarService.options.isFlagSet(self.updateModel.calendarEvent.options, flag);
        }

        function toggleFlag(flag) {
            self.updateModel.calendarEvent.options = calendarService.options.toggleFlag(self.updateModel.calendarEvent.options, flag);
        }

        function getCalendarEventString() {
            var returnString = '';
            if (self.updateModel && self.updateModel.calendarEvent) {
                returnString = self.updateModel.calendarEvent.subject || self.updateModel.calendarEvent.calendarEventTypeName;
                if (self.updateModel.calendarEvent.deceasedSerialized) {
                    returnString += ' | ' + self.updateModel.calendarEvent.deceasedSerialized;
                }

                if (self.updateModel.calendarEvent.locationSerialized) {
                    returnString += ' – ' + self.updateModel.calendarEvent.locationSerialized;
                }
            }
            return returnString;
        }

        function customFieldCategoryFilter(value, index, array) {
            if (value.customFields && value.customFields.length > 0) {
                var hasData = value.customFields.reduce(function (acc, current) {
                    return acc || (current.data && current.data.length > 0);
                }, false);
                return !value.isDeleted || hasData;
            }
            return false;
        }

        function customFieldFilter(value, index, array) {
            if (value.data && value.data.length > 0) {
                return true;
            }
            return !value.isDeleted;
        }

        function calculatePrice() {
            if (self.updateModel.isPriceRegistered) return;
            if (!transportCalculationConfig.isSet) {
                extractCalculationConfig();
            }
            var price = transportCalculationConfig.startAmount;
            if (self.updateModel.calendarEvent.distance) {
                price += self.updateModel.calendarEvent.distance * transportCalculationConfig.distanceAmount;
            }
            if (self.updateModel.calendarEvent.driverHours) {
                price += self.updateModel.calendarEvent.driverHours * transportCalculationConfig.hoursAmount;
            }
            if (self.updateModel.calendarEvent.additionalHours) {
                price += self.updateModel.calendarEvent.additionalHours * transportCalculationConfig.additionalHoursAmount;
            }
            if (self.updateModel.calendarEvent.additionalCost) {
                price += self.updateModel.calendarEvent.additionalCost;
            }
            if (transportCalculationConfig.minimumAmount && price < transportCalculationConfig.minimumAmount) {
                price = transportCalculationConfig.minimumAmount;
            }
            self.updateModel.calendarEvent.price = price;
            if (self.validation && self.validation.calendarEventForm && self.validation.calendarEventForm.$pristine) {
                self.validation.calendarEventForm.$setDirty();
            }
        }

        function registerPrice() {
            if (self.updateModel.calendarEvent.price) {
                self.updateModel.isPriceRegistered = true;
            } else {
                self.updateModel.isPriceRegistered = false;
            }
        }

        function extractCalculationConfig() {
            var startAmountConfig = getConfigByName('TransportStartAmount');
            if (startAmountConfig && startAmountConfig.customFieldData && startAmountConfig.customFieldData.dataValueAsString) {
                transportCalculationConfig.startAmount = Number(startAmountConfig.customFieldData.dataValueAsString) || 0;
            }
            var distanceAmountConfig = getConfigByName('TransportDistanceAmount');
            if (distanceAmountConfig && distanceAmountConfig.customFieldData && distanceAmountConfig.customFieldData.dataValueAsString) {
                transportCalculationConfig.distanceAmount = Number(distanceAmountConfig.customFieldData.dataValueAsString) || 0;
            }
            var minimumAmountConfig = getConfigByName('TransportMinimalAmount');
            if (minimumAmountConfig && minimumAmountConfig.customFieldData && minimumAmountConfig.customFieldData.dataValueAsString) {
                transportCalculationConfig.minimumAmount = Number(minimumAmountConfig.customFieldData.dataValueAsString) || 0;
            }
            var hoursAmountConfig = getConfigByName('TransportHoursAmount');
            if (hoursAmountConfig && hoursAmountConfig.customFieldData && hoursAmountConfig.customFieldData.dataValueAsString) {
                transportCalculationConfig.hoursAmount = Number(hoursAmountConfig.customFieldData.dataValueAsString) || 0;
            }
            var additionalHoursAmountConfig = getConfigByName('TransportHoursAmount');
            if (additionalHoursAmountConfig && additionalHoursAmountConfig.customFieldData && additionalHoursAmountConfig.customFieldData.dataValueAsString) {
                transportCalculationConfig.additionalHoursAmount = Number(additionalHoursAmountConfig.customFieldData.dataValueAsString) || 0;
            }
            transportCalculationConfig.isSet = true;
        }

        function getConfigByName(name) {
            if (!transportConfigs || transportConfigs.length === 0) return null;
            for (var i = 0; i < transportConfigs.length; i++) {
                var config = transportConfigs[i];
                if (config && config.name === name) {
                    return config;
                }
            }
            return null;
        }

        function reset() {
            self.updateModel = null;
            self.isNew = false;
            self.isLoadingCustomFieldData = false;
            self.isLoadingEquipment = false;
            self.customFieldCategories = [];
            transportCalculationConfig = {
                isSet: false,
                startAmount: 0,
                distanceAmount: 0,
                minimumAmount: 0,
                hoursAmount: 0,
                additionalHoursAmount: 0,
            };
            // Set as pristine to allow saving
            if (self.validation && self.validation.calendarEventForm && self.validation.calendarEventForm.$dirty) {
                self.validation.calendarEventForm.$setPristine();
            }
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.calendar").controller("EditCalendarEventController", EditCalendarEventController);

  /* @ngInject */
  function EditCalendarEventController(
    $window,
    $mdDialog,
    $translate,
    $scope,
    $stateParams,
    loadingService,
    editCalendarEventService
  ) {
    var vm = this;

    vm.loadingService = loadingService;
    vm.data = editCalendarEventService;

    // Methods
    vm.exitView = exitView;
    vm.saveAndExitView = saveAndExitView;
    vm.deleteCalendarEvent = deleteCalendarEvent;

    activate();

    //////////

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      editCalendarEventService
        .loadCalendarEvent(
          $stateParams.calendarEventId,
          $stateParams.workOrderId,
          $stateParams.deceased,
          $stateParams.calendarEventTypeId,
          $stateParams.apiController || "CalendarEvents",
          $stateParams.calendarEventType,
          $stateParams.selectedDate,
          $stateParams.transportSuggestion
        )
        .then(function() {
          vm.loadingService.setLoadingStatus(false);
          // Set as pristine / dirty
          if (
            $stateParams.calendarEventId !== "new" &&
            vm.data.validation &&
            vm.data.validation.calendarEventForm &&
            vm.data.validation.calendarEventForm.$dirty
          ) {
            vm.data.validation.calendarEventForm.$setPristine();
          } else if (
            $stateParams.calendarEventId === "new" &&
            vm.data.validation &&
            vm.data.validation.calendarEventForm
          ) {
            vm.data.validation.calendarEventForm.$setDirty();
          }
        });

      // Prevent from navigating away on unsaved changes
      $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
        if (vm.data.validation && vm.data.validation.calendarEventForm && vm.data.validation.calendarEventForm.$dirty) {
          if (confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) == true) {
          } else {
            event.preventDefault();
            vm.loadingService.setBackgroundLoadingStatus(false);
          }
        }
      });
    }

    function exitView() {
      if (vm.data.validation && vm.data.validation.calendarEventForm && vm.data.validation.calendarEventForm.$dirty) {
        if (confirm($translate.instant("COMMON.DATA.UNSAVED_CHANGES_CONFIRM")) == true) {
          vm.data.validation.calendarEventForm.$setPristine();
          $window.history.back();
        }
      } else {
        $window.history.back();
      }
    }

    function saveAndExitView() {
      vm.loadingService.setLoadingStatus(true);
      editCalendarEventService.saveCalendarEvent($stateParams.apiController || "CalendarEvents").then(function() {
        if (vm.data.validation && vm.data.validation.calendarEventForm && vm.data.validation.calendarEventForm.$dirty) {
          vm.data.validation.calendarEventForm.$setPristine();
        }
        exitView();
        vm.loadingService.setLoadingStatus(false);
      });
    }

    function deleteCalendarEvent(e) {
      //Prompt for confirmation
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant("CALENDAR.DELETE_EVENT.DELETE_EVENT_TITLE"))
        .textContent(
          $translate.instant("CALENDAR.DELETE_EVENT.DELETE_EVENT_CONFIRM", {
            eventName: editCalendarEventService.getCalendarEventString()
          })
        )
        .ariaLabel($translate.instant("CALENDAR.DELETE_EVENT.DELETE_EVENT_TITLE"))
        .targetEvent(e)
        .ok($translate.instant("CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION"))
        .cancel($translate.instant("COMMON.DIALOG.CANCEL"));
      $mdDialog.show(confirm).then(
        function() {
          vm.loadingService.setLoadingStatus(true);
          editCalendarEventService
            .deleteCalendarEvent($stateParams.apiController || "CalendarEvents")
            .then(function(deletedItem) {
              if (
                vm.data.validation &&
                vm.data.validation.calendarEventForm &&
                vm.data.validation.calendarEventForm.$dirty
              ) {
                vm.data.validation.calendarEventForm.$setPristine();
              }
              vm.loadingService.setLoadingStatus(false);
              exitView();
            });
        },
        function() {
          // Do nothing
        }
      );
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.calendar')
        .controller('EditCalendarEventToolbarController', EditCalendarEventToolbarController);

    /* @ngInject */
    function EditCalendarEventToolbarController($window, $translate, $stateParams, loadingService, editCalendarEventService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editCalendarEventService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////

        function exitView() {
            if (vm.data.validation && vm.data.validation.calendarEventForm && vm.data.validation.calendarEventForm.$dirty) {
                if (confirm($translate.instant('COMMON.DATA.UNSAVED_CHANGES_CONFIRM')) == true) {
                    vm.data.validation.calendarEventForm.$setPristine();
                    $window.history.back();
                }
            } else {
                $window.history.back();
            };
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editCalendarEventService.saveCalendarEvent($stateParams.apiController || 'CalendarEvents').then(function () {
                if (vm.data.validation && vm.data.validation.calendarEventForm && vm.data.validation.calendarEventForm.$dirty) {
                    vm.data.validation.calendarEventForm.$setPristine();
                }
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function() {
    'use strict';

    angular
        .module('app.booking', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.booking')
        .controller('EditCalendarEventSidebarController', EditCalendarEventSidebarController);

    /* @ngInject */
    function EditCalendarEventSidebarController($window, $stateParams, loadingService, editCalendarEventService, baldrisApiBase) {
        var vm = this;

        vm.showEventOptions = false;
        vm.loadingService = loadingService;
        vm.data = editCalendarEventService;
        vm.baldrisApiBase = baldrisApiBase;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;
        vm.toggleShowOptions = toggleShowOptions;

        //////////

        function toggleShowOptions() {
            vm.showEventOptions = !vm.showEventOptions;
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editCalendarEventService.saveCalendarEvent($stateParams.apiController || 'CalendarEvents').then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function() {
  "use strict";

  angular.module("app.calendar").controller("DayViewController", DayViewController);

  /* @ngInject */
  function DayViewController($scope, $timeout, $stateParams, currentUser, calendarViewService, loadingService) {
    var vm = this;
    vm.events = [];
    vm.noteOrTasks = [];
    vm.currentUser = currentUser;

    vm.loadingService = loadingService;

    vm.service = calendarViewService;
    vm.currentDate = moment($stateParams.date, "YYYY-MM-DD")
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");

    calendarViewService.setSelectedDate(vm.currentDate);
    vm.service.data.selectedTab = "DAY";
    activate();

    function activate() {
      vm.loadingService.setLoadingStatus(true);
      calendarViewService.getByDate(vm.currentDate, true).then(function(calendarData) {
        vm.events = calendarData.events;
        vm.loadingService.setLoadingStatus(false);
        // Initialize reloading - 3 min
        vm.reloader = $timeout(reload, 300000);
      });
    }

    function reload() {
      activate();
      // Issues with following code. This sometimes leads to events from other dates showing up.
      /*calendarViewService.getByDate(vm.currentDate, false).then(function (calendarData) {
                // Check that date haven't changed
                if (moment(vm.currentDate).isSame(calendarData.requestedDate, 'day')) {
                    vm.events = calendarViewService.mergeCollection(calendarData.events, vm.events);
                    vm.loadingService.setLoadingStatus(false);
                    // Initialize reloading - 3 min
                    vm.reloader = $timeout(reload, 100000);
                }
            });*/
    }

    $scope.$on("$destroy", function(p1, p2) {
      if (vm.reloader) {
        $timeout.cancel(vm.reloader);
      }
    });
  }
})();

(function () {
    'use strict';

    angular.module('app.booking').factory('bookingService', bookingService);

    /* @ngInject */
    function bookingService() {
        var service = {
            getEmptyBooking: getEmptyBooking,
        };

        return service;

        function getEmptyBooking() {
            return {
                subject: null,
                text: null,
                attendanceTime: null,
                start: null,
                end: null,
                isAllDay: false,
                internalType: null,
                internalId: null,
                recurrencePattern: null,
                exceptionAppointments: null,
                attendeesMustRsvp: false,
                remarks: null,
                options: 'none',
                billTo: 'unknown',
                calendarEventTypeId: null,
                isCompleted: false,
                completedTime: null,
                completedById: null,
                workOrderId: null,
                hostId: null,
                reservationId: null,
                locationId: null,
                locationRemarks: null,
                addressId: null,
                addressRemarks: null,
                supplierId: null,
                remarksSupplier: null,
                confirmedById: null,
                confirmedDate: null,
                isConfirmed: false,
                confirmationRemarks: null,
                externalId: null,
                externalOrderId: null,
                externalVersion: null,
                externalStatus: null,
            };
        }
    }
})();

(function() {
  "use strict";

  angular.module("app.booking").service("editBookingService", editBookingService);

  /* @ngInject */
  function editBookingService(editCalendarEventService) {
    var self = this;

    self.updateModel = null;
    self.isNew = false;

    self.loadBooking = loadBooking;
    self.saveBooking = saveBooking;
    self.onLocationSelected = editCalendarEventService.onLocationSelected;
    self.options = editCalendarEventService.options;
    self.onIsCompletedChange = onIsCompletedChange;

    function loadBooking(calendarEventId, workOrderId, deceased, calendarEventTypeId, calendarEventType, selectedDate) {
      reset();
      return editCalendarEventService
        .loadCalendarEvent(
          calendarEventId,
          workOrderId,
          deceased,
          calendarEventTypeId,
          "Bookings",
          calendarEventType,
          selectedDate
        )
        .then(function(response) {
          self.updateModel = response.updateModel;
          self.customFieldCategories = response.customFieldCategories;
          self.isNew = response.isNew;
          return self;
        });
    }

    function saveBooking() {
      return editCalendarEventService.saveCalendarEvent("Bookings");
    }

    function onIsCompletedChange() {
      if (self.updateModel.calendarEvent.isCompleted) {
        self.updateModel.calendarEvent.completedTime = moment().format("YYYY-MM-DDTHH:mm:ss");
      } else {
        self.updateModel.calendarEvent.completedTime = null;
        self.updateModel.calendarEvent.completedBy = null;
        self.updateModel.calendarEvent.completedById = null;
        self.updateModel.calendarEvent.completedByDisplayName = null;
      }
    }

    function reset() {
      self.updateModel = null;
      self.isNew = false;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.booking')
        .controller('EditBookingController', EditBookingController);

    /* @ngInject */
    function EditBookingController($window, $stateParams, loadingService, editBookingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editBookingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        activate();

        //////////

        function activate() {
            vm.loadingService.setLoadingStatus(true);
            editBookingService.loadBooking($stateParams.bookingId, $stateParams.workOrderId, $stateParams.deceased, $stateParams.bookingTypeId, $stateParams.bookingType, $stateParams.selectedDate).then(function () {
                vm.loadingService.setLoadingStatus(false);
            });
        }

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editBookingService.saveBooking().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.booking')
        .controller('EditBookingToolbarController', EditBookingToolbarController);

    /* @ngInject */
    function EditBookingToolbarController($window, loadingService, editBookingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editBookingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editBookingService.saveBooking().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
(function () {
    'use strict';

    angular
        .module('app.booking')
        .controller('EditBookingSidebarController', EditBookingSidebarController);

    /* @ngInject */
    function EditBookingSidebarController($window, loadingService, editBookingService) {
        var vm = this;

        vm.loadingService = loadingService;
        vm.data = editBookingService;

        // Methods
        vm.exitView = exitView;
        vm.saveAndExitView = saveAndExitView;

        //////////

        function exitView() {
            $window.history.back();
        }

        function saveAndExitView() {
            vm.loadingService.setLoadingStatus(true);
            editBookingService.saveBooking().then(function () {
                exitView();
                vm.loadingService.setLoadingStatus(false);
            });
        }

    }

} ());
/**
 * Created by JSH on 10.11.2016.
 * Code copied from http://www.c-sharpcorner.com/uploadfile/ff2f08/token-based-authentication-using-asp-net-web-api-in-angularj/
 */

(function () {
    'use strict';

    angular.module('app.account')
        .service('loginService', loginService);

    function loginService($http, $q, $state, authenticationService, baldrisApiBase, baldrisConfigService) {
        var userInfo;
        var loginServiceURL = baldrisApiBase + '/oauth/token';
        var deviceInfo = [];
        var deferred;

        this.login = function (userName, password) {
            deferred = $q.defer();
            var data = "grant_type=password&username=" + userName + "&password=" + password;
            $http.post(loginServiceURL, data, {
                headers:
                { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).success(function (response) {
                var o = response;
                userInfo = {
                    accessToken: response.access_token,
                    userName: response.userName
                };
                authenticationService.setTokenInfo(userInfo);
                authenticationService.setHeader($http);
                deferred.resolve(null);
            })
                .error(function (err, status) {
                    deferred.resolve(err);
                });
            return deferred.promise;
        }
        this.logOut = function () {
            authenticationService.removeToken();
            // also remove BaldrisConfigs. Temporary work around to get rid of temporary cached data.
            baldrisConfigService.clearLocalData();
            $state.go('app.account.login');
        }
    }
})();
/**
 * Created by JSH on 10.11.2016.
 */

(function () {
    'use strict';
    angular.module('app.account').service('authenticationService', authenticationService);

    /** @ngInject */
    function authenticationService($state, angularAuth0, $timeout, baldrisConfigService) {
        var REQUESTED_SCOPES =
            'openid email user_metadata app_metadata picture delete:invoice ' +
            'delete:users delete:workOrders manage:advancedSettings manage:autoProduct ' +
            'manage:autoTask manage:finance manage:products read:invoice ' +
            'read:salesStatistics read:userStatistics read:users read:workOrderStatistics ' +
            'read:workOrders write:invoice write:users write:workOrders' +
            'send:email delete:privacyData write:privacyData read:privacyData' +
            'manage:contact manage:location write:calendar read:calendar delete:calendar';

        function login() {
            angularAuth0.authorize();
        }

        function handleAuthentication() {
            angularAuth0.parseHash(function (err, authResult) {
                if (authResult && authResult.accessToken && authResult.idToken) {
                    setSession(authResult);
                    $state.go('app.home');
                } else if (err) {
                    $timeout(function () {
                        $state.go('app.home');
                    });
                    console.log(err);
                }
            });
        }

        function setSession(authResult) {
            // Set the time that the access token will expire at
            var expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
            localStorage.setItem('access_token', authResult.accessToken);
            localStorage.setItem('id_token', authResult.idToken);
            localStorage.setItem('expires_at', expiresAt);
            localStorage.setItem('scopes', extractScopes(authResult) || '');
        }

        function extractScopes(authResult) {
            if (authResult.accessToken) {
                var parsedToken = parseJwt(authResult.accessToken);

                if (parsedToken.permissions && parsedToken.permissions.length) {
                    return parsedToken.permissions.join(' ');
                }
            }
            return '';
        }

        function parseJwt(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(
                window
                    .atob(base64)
                    .split('')
                    .map(function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );

            return JSON.parse(jsonPayload);
        }

        function logout() {
            // Remove tokens and expiry time from localStorage
            localStorage.removeItem('access_token');
            localStorage.removeItem('id_token');
            localStorage.removeItem('expires_at');
            localStorage.removeItem('scopes');
            // also remove BaldrisConfigs. Temporary work around to get rid of temporary cached data.
            baldrisConfigService.clearLocalData();
            $state.go('app.account.login');
        }

        function isAuthenticated() {
            // Check whether the current time is past the
            // access token's expiry time
            var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
            return new Date().getTime() < expiresAt;
        }

        return {
            login: login,
            handleAuthentication: handleAuthentication,
            logout: logout,
            isAuthenticated: isAuthenticated,
        };
    }
})();

(function() {
  "use strict";

  angular.module("app.account").factory("accountService", accountService);

  /* @ngInject */
  function accountService($http, exception, baldrisApiBase) {
    var service = {
      getActiveUsers: getActiveUsers,
      getCurrentProfile: getCurrentProfile,
      userHasScopes: userHasScopes,
      canDeleteCalendarEvents: canDeleteCalendarEvents,
      canDeleteInvoice: canDeleteInvoice,
      canDeletePrivacyData: canDeletePrivacyData,
      canDeleteUsers: canDeleteUsers,
      canDeleteWorkOrders: canDeleteWorkOrders,
      canManageContacts: canManageContacts,
      canManageLocations: canManageLocations,
      canManageAdvancedSettings: canManageAdvancedSettings,
      canManageAutoProducts: canManageAutoProducts,
      canManageAutoTasks: canManageAutoTasks,
      canManageFinance: canManageFinance,
      canManageProducts: canManageProducts,
      canReadCalendarEvents: canReadCalendarEvents,
      canReadInvoice: canReadInvoice,
      canReadPrivacyData: canReadPrivacyData,
      canReadUsers: canReadUsers,
      canReadSalesStatistics: canReadSalesStatistics,
      canReadUserStatistics: canReadUserStatistics,
      canReadWorkOrderStatistics: canReadWorkOrderStatistics,
      canReadWorkOrders: canReadWorkOrders,
      canSendEmail: canSendEmail,
      canWriteCalendarEvents: canWriteCalendarEvents,
      canWriteInvoice: canWriteInvoice,
      canWritePrivacyData: canWritePrivacyData,
      canWriteUsers: canWriteUsers,
      canWriteWorkOrders: canWriteWorkOrders
    };

    return service;

    function getActiveUsers() {
      return $http
        .get(baldrisApiBase + "/api/BaldrisUsers/Active")
        .then(getActiveUsersComplete)
        .catch(function(message) {
          exception.catcher("XHR Failed for getActiveUsers")(message);
        });

      function getActiveUsersComplete(data, status, headers, config) {
        return data.data;
      }
    }

    function getCurrentProfile() {
      var profile = localStorage.getItem("profile");
      if (profile) {
        return JSON.parse(profile);
      }
      return null;
    }

    function userHasScopes(requestedScopes) {
      var scopes = localStorage.getItem("scopes");
      if (!scopes) return false;
      var grantedScopes = scopes.split(" ");
      for (var i = 0; i < requestedScopes.length; i++) {
        if (grantedScopes.indexOf(requestedScopes[i]) < 0) {
          return false;
        }
      }
      return true;
    }

    function canSendEmail() {
      return userHasScopes(["send:email"]);
    }

    function canDeletePrivacyData() {
      return userHasScopes(["delete:privacyData"]);
    }

    function canWritePrivacyData() {
      return userHasScopes(["write:privacyData"]);
    }

    function canReadPrivacyData() {
      return userHasScopes(["read:privacyData"]);
    }

    function canManageContacts() {
      return userHasScopes(["manage:contact"]);
    }

    function canManageLocations() {
      return userHasScopes(["manage:location"]);
    }

    function canDeleteCalendarEvents() {
      return userHasScopes(["delete:calendar"]);
    }

    function canWriteCalendarEvents() {
      return userHasScopes(["write:calendar"]);
    }

    function canReadCalendarEvents() {
      return userHasScopes(["read:calendar"]);
    }

    function canDeleteWorkOrders() {
      return userHasScopes(["delete:workOrders"]);
    }

    function canWriteWorkOrders() {
      return userHasScopes(["write:workOrders"]);
    }

    function canReadWorkOrders() {
      return userHasScopes(["read:workOrders"]);
    }

    function canDeleteUsers() {
      return userHasScopes(["delete:users"]);
    }

    function canWriteUsers() {
      return userHasScopes(["write:users"]);
    }

    function canReadUsers() {
      return userHasScopes(["read:users"]);
    }

    function canDeleteInvoice() {
      return userHasScopes(["delete:invoice"]);
    }

    function canWriteInvoice() {
      return userHasScopes(["write:invoice"]);
    }

    function canReadInvoice() {
      return userHasScopes(["read:invoice"]);
    }

    function canReadUserStatistics() {
      return userHasScopes(["read:userStatistics"]);
    }

    function canReadSalesStatistics() {
      return userHasScopes(["read:salesStatistics"]);
    }

    function canReadWorkOrderStatistics() {
      return userHasScopes(["read:workOrderStatistics"]);
    }

    function canManageProducts() {
      return userHasScopes(["manage:products"]);
    }

    function canManageFinance() {
      return userHasScopes(["manage:finance"]);
    }

    function canManageAutoTasks() {
      return userHasScopes(["manage:autoTask"]);
    }

    function canManageAutoProducts() {
      return userHasScopes(["manage:autoProducts"]);
    }

    function canManageAdvancedSettings() {
      return userHasScopes(["manage:advancedSettings"]);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.account')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(authenticationService)
    {
        var vm = this;

        vm.authenticationService = authenticationService;
    }
})();
(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('CallbackController', CallbackController);

    function CallbackController() {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function() {
  "use strict";

  angular
    .module("app.core")
    .provider("msNavigationService", msNavigationServiceProvider)
    .controller("MsNavigationController", MsNavigationController)
    // Vertical
    .directive("msNavigation", msNavigationDirective)
    .controller("MsNavigationNodeController", MsNavigationNodeController)
    .directive("msNavigationNode", msNavigationNodeDirective)
    .directive("msNavigationItem", msNavigationItemDirective)
    //Horizontal
    .directive("msNavigationHorizontal", msNavigationHorizontalDirective)
    .controller("MsNavigationHorizontalNodeController", MsNavigationHorizontalNodeController)
    .directive("msNavigationHorizontalNode", msNavigationHorizontalNodeDirective)
    .directive("msNavigationHorizontalItem", msNavigationHorizontalItemDirective);

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(["ng"]).get("$log");

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error("path must be a string (eg. `dashboard.project`)");
        return;
      }

      var parts = path.split(".");

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error("path must be a string (eg. `dashboard.project`)");
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split(".");

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join("."),
            title: _id,
            weight: 1,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = "";

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + "(" + angular.toJson(item.stateParams) + ")";
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function() {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }

      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }

        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    } else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element("body").toggleClass("ms-navigation-horizontal-mobile-menu-active");
    }
  }

  /** @ngInject */
  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: "E",
      scope: {
        folded: "=",
        root: "@"
      },
      controller: "MsNavigationController as vm",
      templateUrl: "app/core/directives/ms-navigation/templates/vertical.html",
      transclude: true,
      compile: function(tElement) {
        tElement.addClass("ms-navigation");

        return function postLink(scope, iElement) {
          var bodyEl = angular.element("body"),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav("navigation");

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function() {
                $rootScope.$broadcast("msNavigation::collapse");
              });

              // Add class to the body
              bodyEl.addClass("ms-navigation-folded");

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(
            function() {
              return sidenav.isLockedOpen();
            },
            function(current, old) {
              if (angular.isUndefined(current) || angular.equals(current, old)) {
                return;
              }

              var folded = msNavigationService.getFolded();

              if (folded) {
                if (current) {
                  // Collapse everything
                  $rootScope.$broadcast("msNavigation::collapse");
                } else {
                  // Expand the active one and its parents
                  var activeItem = msNavigationService.getActiveItem();
                  if (activeItem) {
                    activeItem.scope.$emit("msNavigation::stateMatched");
                  }
                }
              }
            }
          );

          // Folded status watcher
          scope.$watch("folded", function(current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast("msNavigation::collapse");

              // Add class to the body
              bodyEl.addClass("ms-navigation-folded");

              // Set fold expander
              setFoldExpander();
            } else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit("msNavigation::stateMatched");
              }

              // Remove body class
              bodyEl.removeClass("ms-navigation-folded ms-navigation-folded-open");

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function() {
              foldExpanderEl.on("mouseenter touchstart", onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find("#main").append(foldCollapserEl);
            foldCollapserEl.on("mouseenter touchstart", onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit("msNavigation::stateMatched");
            }

            // Add class to the body
            bodyEl.addClass("ms-navigation-folded-open");

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast("msNavigation::collapse");

            // Remove body class
            bodyEl.removeClass("ms-navigation-folded-open");

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function() {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on("$stateChangeStart", function() {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on("$destroy", function() {
            foldCollapserEl.off("mouseenter touchstart");
            foldExpanderEl.off("mouseenter touchstart");
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController(
    $scope,
    $element,
    $rootScope,
    $animate,
    $state,
    msNavigationService,
    accountService
  ) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = "animate-height";

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      } else {
        vm.collapsable = !!(
          angular.isUndefined(vm.node.collapsable) ||
          typeof vm.node.collapsable !== "boolean" ||
          vm.node.collapsable === true
        );
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      } else {
        vm.collapsed = !!(
          angular.isUndefined(vm.node.collapsed) ||
          typeof vm.node.collapsed !== "boolean" ||
          vm.node.collapsed === true
        );
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (
          angular.isDefined(vm.node.stateParams) &&
          angular.isDefined($state.params) &&
          !angular.equals(vm.node.stateParams, $state.params)
        ) {
          return;
        }

        $scope.$emit("msNavigation::stateMatched");

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on("msNavigation::stateMatched", function() {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function() {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on("msNavigation::collapse", function(event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split("."),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split(".");
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on("$stateChangeSuccess", function() {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast("msNavigation::collapse", vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit("msNavigation::stateMatched");
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      } else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children("ul");

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function() {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass("collapsing");

        // Animate the height
        $animate
          .animate(
            collapseEl,
            {
              display: "block",
              height: height + "px"
            },
            {
              height: "0px"
            },
            vm.animateHeightClass
          )
          .then(function() {
            // Clear the inline styles after animation done
            collapseEl.css({
              display: "",
              height: ""
            });

            // Clear collapsing class from the node
            vm.element.removeClass("collapsing");
          });

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast("msNavigation::collapse");
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children("ul");

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        position: "absolute",
        visibility: "hidden",
        display: "block",
        height: "auto"
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        position: "",
        visibility: "",
        display: "",
        height: ""
      });

      $scope.$evalAsync(function() {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass("expanding");

        // Animate the height
        $animate
          .animate(
            expandEl,
            {
              display: "block",
              height: "0px"
            },
            {
              height: height + "px"
            },
            vm.animateHeightClass
          )
          .then(function() {
            // Clear the inline styles after animation done
            expandEl.css({
              height: ""
            });

            // Clear expanding class from the node
            vm.element.removeClass("expanding");
          });

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast("msNavigation::collapse", vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (vm.node.scopes && vm.node.scopes.length > 0 && !accountService.userHasScopes(vm.node.scopes)) {
        return true;
      }
      // anyScopes
      if (vm.node.anyScopes && vm.node.anyScopes.length > 0) {
        var anyHidden = true;
        vm.node.anyScopes.forEach(function(allowedScope) {
          anyHidden = anyHidden && !accountService.userHasScopes([allowedScope]);
        });
        return anyHidden;
      }
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }

      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: "A",
      bindToController: {
        node: "=msNavigationNode"
      },
      controller: "MsNavigationNodeController as vm",
      compile: function(tElement) {
        tElement.addClass("ms-navigation-node");

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass("group");
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: "A",
      require: "^msNavigationNode",
      compile: function(tElement) {
        tElement.addClass("ms-navigation-item");

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on("click", MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on("$destroy", function() {
            iElement.off("click");
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: "E",
      scope: {
        root: "@"
      },
      controller: "MsNavigationController as vm",
      templateUrl: "app/core/directives/ms-navigation/templates/horizontal.html",
      transclude: true,
      compile: function(tElement) {
        tElement.addClass("ms-navigation-horizontal");

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (
          angular.isDefined(vm.node.stateParams) &&
          angular.isDefined($state.params) &&
          !angular.equals(vm.node.stateParams, $state.params)
        ) {
          return;
        }

        $scope.$emit("msNavigation::stateMatched");

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on("msNavigation::stateMatched", function() {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function() {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on("msNavigation::clearActive", function() {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split(".");
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function() {
            vm.isActive = true;
          });
        } else {
          $scope.$evalAsync(function() {
            vm.isActive = false;
          });
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on("$stateChangeSuccess", function() {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast("msNavigation::clearActive");
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: "A",
      bindToController: {
        node: "=msNavigationHorizontalNode"
      },
      controller: "MsNavigationHorizontalNodeController as vm",
      compile: function(tElement) {
        tElement.addClass("ms-navigation-horizontal-node");

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass("group");
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: "A",
      require: "^msNavigationHorizontalNode",
      compile: function(tElement) {
        tElement.addClass("ms-navigation-horizontal-item");

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on("click", onClick);

          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia("gt-md")) {
              return;
            }

            iElement.toggleClass("expanded");
          }

          // Cleanup
          scope.$on("$destroy", function() {
            iElement.off("click");
          });
        };
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    var referencePersonTypeOptions = {
        NONE: {
            value: 'none',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.NONE',
        },
        CONTACT_PERSON: {
            value: 'contactPerson',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.CONTACT_PERSON',
        },
        SPOUSE: {
            value: 'spouse',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.SPOUSE',
        },
        CONTRACTOR: {
            value: 'contractor',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.CONTRACTOR',
        },
        CUSTOMER: {
            value: 'customer',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.CUSTOMER',
        },
        PARTIAL_CUSTOMER: {
            value: 'partialCustomer',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.PARTIAL_CUSTOMER',
        },
        GRAVE_LEASE_HOLDER: {
            value: 'graveLeaseHolder',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.GRAVE_LEASE_HOLDER',
        },
        LIVE_IN: {
            value: 'liveIn',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.LIVE_IN',
        },
        WITH_SHARED_CHILDREN: {
            value: 'withSharedChildren',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.WITH_SHARED_CHILDREN',
        },
        REGISTERED_PARTNER: {
            value: 'registeredPartner',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.REGISTERED_PARTNER',
        },
        HEIR: {
            value: 'heir',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.HEIR',
        },
        DECEASED: {
            value: 'deceased',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.DECEASED',
        },
        SEPERATED: {
            value: 'seperated',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.SEPERATED',
        },
        DIVORCED: {
            value: 'divorced',
            text: 'WORK_ORDER_REFERENCE_PERSONS.REFERENCE_PERSON_TYPE_SELECT.DIVORCED',
        },
    };

    var funeralArrangementRightOptions = {
        NO_RIGHT: {
            value: 'noRight',
            text: 'WORK_ORDER_REFERENCE_PERSONS.FUNERAL_ARRANGEMENT_RIGHT_SELECT.NO_RIGHT',
        },
        BY_RELATION: {
            value: 'byRelation',
            text: 'WORK_ORDER_REFERENCE_PERSONS.FUNERAL_ARRANGEMENT_RIGHT_SELECT.BY_RELATION',
        },
        BY_LETTER_OF_ATTORNEY: {
            value: 'byLetterOfAttorney',
            text: 'WORK_ORDER_REFERENCE_PERSONS.FUNERAL_ARRANGEMENT_RIGHT_SELECT.BY_LETTER_OF_ATTORNEY',
        },
        GOVERNMENT_DECISION: {
            value: 'governmentDecision',
            text: 'WORK_ORDER_REFERENCE_PERSONS.FUNERAL_ARRANGEMENT_RIGHT_SELECT.GOVERNMENT_DECISION',
        },
    };

    angular
        .module('app.workOrderReferencePerson')
        .constant('referencePersonTypeOptions', referencePersonTypeOptions);

    angular
        .module('app.workOrderReferencePerson')
        .constant(
            'funeralArrangementRightOptions',
            funeralArrangementRightOptions
        );
})();

(function() {
    'use strict';

    angular
        .module('app.workOrderReferencePerson')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider) {
        $translatePartialLoaderProvider.addPart('app/main/work-order-reference-person');

        

    }
})();
(function () {
    'use strict';

    var workOrderOptions = {
        NONE: { value: 'none', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.NONE' },
        HAS_DECEASED: { value: 'hasDeceased', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_DECEASED' },
        HAS_CEREMONIES: { value: 'hasCeremonies', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_CEREMONIES' },
        HAS_TRANSPORTS: { value: 'hasTransports', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_TRANSPORTS' },
        HAS_FLOWERS: { value: 'hasFlowers', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_FLOWERS' },
        HAS_HEADSTONES: { value: 'hasHeadstones', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_HEADSTONES' },
        HAS_GRAVE: { value: 'hasGrave', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_GRAVE' },
        HAS_OBITUARIES: { value: 'hasObituaries', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_OBITUARIES' },
        // HAS_CREMATION: { value: 256, text: "WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_CREMATION" },
        HAS_SHIPMENTS: { value: 'hasShipments', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_SHIPMENTS' },
        HAS_PROGRAMS: { value: 'hasPrograms', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_PROGRAMS' },
        HAS_REFERENCE_PERSONS: { value: 'hasReferencePersons', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_REFERENCE_PERSONS' },
        HAS_EVENTS: { value: 'hasEvents', text: 'WORK_ORDERS.WORK_ORDER.OPTIONS.HAS_EVENTS' },
    };

    angular.module('app.workOrder').constant('workOrderOptions', workOrderOptions);
})();

(function () {
    'use strict';

    angular.module('app.workOrder').config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/work-order');

        function getTemplate(templateKey, templateCache, templateRequest) {
            var tpl = templateCache.get(templateKey);
            if (tpl) {
                return tpl;
            }
            return templateRequest(templateKey);
        }

        $stateProvider
            .state('app.workOrder', {
                abstract: true,
                url: '/work-orders',
                views: {
                    'content@app': {
                        template: '<div ui-view></div>',
                    },
                },
            })
            .state('app.workOrder.dashboard', {
                url: '/dashboard/:date', //Date format: 'YYYY-MM-DD'
                views: {
                    'content@app': {
                        templateUrl: 'app/main/work-order/dashboard/work-order-dashboard.tmpl.html',
                        controller: 'WorkOrderDashboardController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    departments: function (dataService) {
                        return dataService.getAll('Departments');
                    },
                    /* @ngInject */
                    workOrderTypes: function (dataService) {
                        return dataService.getAll('WorkOrderTypes');
                    },
                },
            })
            .state('app.workOrder.dashboard.latest', {
                url: '/:latestAmount?workOrderTypeId&departmentId',
                templateUrl: 'app/main/work-order/dashboard/latest-view/work-order-dashboard-latest.tmpl.html',
                controller: 'WorkOrderDashboardLatestController',
                controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.workOrder.search', {
                url: '/search',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/work-order/search/work-order-search.tmpl.html',
                        controller: 'WorkOrderSearchController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    departments: function (dataService) {
                        return dataService.getAll('Departments');
                    },
                    /* @ngInject */
                    workOrderTypes: function (dataService) {
                        return dataService.getAll('WorkOrderTypes');
                    },
                },
            })
            .state('app.workOrder.byId', {
                url: '/:workOrderId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/work-order/work-order/work-order.tmpl.html',
                        controller: 'WorkOrderController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    workOrder: function (dataService, $stateParams) {
                        return dataService.getById('WorkOrders', $stateParams.workOrderId);
                    },
                    /* @ngInject */
                    consignmentsActivated: function(signatureJobService) {
                        return signatureJobService.getConsignmentsActivated();
                    },
                },
            })
            .state('app.workOrder.byId.deceased', {
                // DECEASED //
                url: '/deceased',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/deceased/work-order-deceased.tmpl.html',
                        controller: 'WorkOrderDeceasedController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.deceasedById', {
                url: '/edit-deceased/:deceasedId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/deceased/edit-deceased/views/toolbar.tmpl.html',
                        controller: 'EditDeceasedToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/deceased/edit-deceased/edit-deceased.tmpl.html',
                        controller: 'EditDeceasedController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/deceased/edit-deceased/views/sidebar.tmpl.html',
                        controller: 'EditDeceasedSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrder: null,
                    person: null,
                },
            })
            .state('app.workOrder.byId.referencePersons', {
                // REFERENCE-PERSONS //
                url: '/reference-persons',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/reference-persons/work-order-reference-persons.tmpl.html',
                        controller: 'WorkOrderReferencePersonsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    highlightedId: null,
                },
            })
            .state('app.workOrder.byId.referencePersonById', {
                url: '/edit-reference-person/:referencePersonId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order-reference-person/edit-reference-person/views/toolbar.tmpl.html',
                        controller: 'EditReferencePersonToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order-reference-person/edit-reference-person/edit-reference-person.tmpl.html',
                        controller: 'EditReferencePersonController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order-reference-person/edit-reference-person/views/sidebar.tmpl.html',
                        controller: 'EditReferencePersonSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrder: null,
                    referencePerson: null,
                    workOrderDeceasedList: null,
                },
                resolve: {
                    /* @ngInject */
                    consignmentsActivated: function(signatureJobService) {
                        return signatureJobService.getConsignmentsActivated();
                    },
                },
            })
            .state('app.workOrder.byId.ceremonies', {
                // CEREMONIES //
                url: '/ceremonies',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/ceremony/work-order-ceremony.tmpl.html',
                        controller: 'WorkOrderCeremonyController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.ceremonyById', {
                url: '/edit-ceremony/:calendarEventId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/ceremony/edit-ceremony/views/toolbar.tmpl.html',
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/ceremony/edit-ceremony/edit-ceremony.tmpl.html',
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/ceremony/edit-ceremony/views/sidebar.tmpl.html',
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    apiController: 'Ceremonies',
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.groomingAndTransports', {
                // GROOMING AND TRANSPORTS //
                url: '/groomings-and-transports',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/grooming-transport/work-order-grooming-transport.tmpl.html',
                        controller: 'WorkOrderGroomingTransportController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.transportById', {
                url: '/edit-transport/:calendarEventId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/transport/edit-transport/views/toolbar.tmpl.html',
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/transport/edit-transport/edit-transport.tmpl.html',
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/transport/edit-transport/views/sidebar.tmpl.html',
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    apiController: 'Transports',
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.groomingById', {
                url: '/edit-grooming/:calendarEventId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/grooming/edit-grooming/views/toolbar.tmpl.html',
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/grooming/edit-grooming/edit-grooming.tmpl.html',
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/grooming/edit-grooming/views/sidebar.tmpl.html',
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    apiController: 'Groomings',
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.locationTransportById', {
                url: '/create-from-location-transport/new',
                views: {
                    'toolbar@app.workOrder.byId': {
                        /* @ngInject */
                        templateProvider: function (dataService, $stateParams, calendarService, $templateCache, $templateRequest) {
                            return dataService.getById('CalendarEventTypes', $stateParams.calendarEventTypeId).then(function (calendarEventType) {
                                if (calendarService.options.isGrooming(calendarEventType.options)) {
                                    return getTemplate('app/main/grooming/edit-grooming/views/toolbar.tmpl.html', $templateCache, $templateRequest);
                                }
                                return getTemplate('app/main/transport/edit-transport/views/toolbar.tmpl.html', $templateCache, $templateRequest);
                            });
                        },
                        //templateUrl: "app/main/grooming/edit-grooming/views/toolbar.tmpl.html",
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        /* @ngInject */
                        templateProvider: function (dataService, $stateParams, calendarService, $templateCache, $templateRequest) {
                            return dataService.getById('CalendarEventTypes', $stateParams.calendarEventTypeId).then(function (calendarEventType) {
                                if (calendarService.options.isGrooming(calendarEventType.options)) {
                                    return getTemplate('app/main/grooming/edit-grooming/edit-grooming.tmpl.html', $templateCache, $templateRequest);
                                }
                                return getTemplate('app/main/transport/edit-transport/edit-transport.tmpl.html', $templateCache, $templateRequest);
                            });
                        },
                        //templateUrl: "app/main/grooming/edit-grooming/edit-grooming.tmpl.html",
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateProvider: function (dataService, $stateParams, calendarService, $templateCache, $templateRequest) {
                            return dataService.getById('CalendarEventTypes', $stateParams.calendarEventTypeId).then(function (calendarEventType) {
                                if (calendarService.options.isGrooming(calendarEventType.options)) {
                                    return getTemplate('app/main/grooming/edit-grooming/views/sidebar.tmpl.html', $templateCache, $templateRequest);
                                }
                                return getTemplate('app/main/transport/edit-transport/views/sidebar.tmpl.html', $templateCache, $templateRequest);
                            });
                        },
                        //templateUrl: "app/main/grooming/edit-grooming/views/sidebar.tmpl.html",
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    apiController: 'Transports',
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.flowerOrders', {
                // FLOWER ORDERS //
                url: '/flower-orders',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/flower-order/work-order-flower-order.tmpl.html',
                        controller: 'WorkOrderFlowerOrderController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.flowerOrderById', {
                url: '/edit-flower-order/:flowerOrderId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/flower-order/edit-flower-order/views/toolbar.tmpl.html',
                        controller: 'EditFlowerOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/flower-order/edit-flower-order/edit-flower-order.tmpl.html',
                        controller: 'EditFlowerOrderController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrder: null,
                },
            })
            .state('app.workOrder.byId.programs', {
                // PROGRAMS //
                url: '/programs',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/program/work-order-program.tmpl.html',
                        controller: 'WorkOrderProgramController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.programById', {
                url: '/edit-program/:programId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/program/edit-program/views/toolbar.tmpl.html',
                        controller: 'EditProgramToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/program/edit-program/edit-program.tmpl.html',
                        controller: 'EditProgramController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/program/edit-program/views/sidebar.tmpl.html',
                        controller: 'EditProgramSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrder: null,
                    ceremony: null,
                },
            })
            .state('app.workOrder.byId.graves', {
                // GRAVES //
                url: '/graves',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/grave/work-order-grave.tmpl.html',
                        controller: 'WorkOrderGraveController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.graveById', {
                url: '/edit-grave/:graveId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/grave/edit-grave/views/toolbar.tmpl.html',
                        controller: 'EditGraveToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/grave/edit-grave/edit-grave.tmpl.html',
                        controller: 'EditGraveController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    graveTypeId: null,
                    deceased: [],
                    graveDefaults: null,
                },
            })
            .state('app.workOrder.byId.obituaryNotices', {
                // OBITUARY NOTICES //
                url: '/obituary-notices',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/obituary-notice/work-order-obituary-notice.tmpl.html',
                        controller: 'WorkOrderObituaryNoticeController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.obituaryNoticeById', {
                url: '/obituary-notice/:obituaryNoticeId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/obituary-notice/edit-obituary-notice/views/toolbar.tmpl.html',
                        controller: 'EditObituaryNoticeToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/obituary-notice/edit-obituary-notice/edit-obituary-notice.tmpl.html',
                        controller: 'EditObituaryNoticeController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/obituary-notice/edit-obituary-notice/views/sidebar.tmpl.html',
                        controller: 'EditObituaryNoticeSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrder: null,
                    deceasedId: null,
                },
            })
            .state('app.workOrder.byId.calendarEvents', {
                // CALENDAR EVENTS //
                url: '/events',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/calendar-events/work-order-calendar-events.tmpl.html',
                        controller: 'WorkOrderCalendarEventsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.calendarEventById', {
                url: '/edit-calendar-event/:calendarEventId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/views/toolbar.tmpl.html',
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/edit-calendar-event.tmpl.html',
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html',
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.bookingById', {
                url: '/edit-booking/:calendarEventId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/views/toolbar.tmpl.html',
                        controller: 'EditCalendarEventToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/edit-calendar-event.tmpl.html',
                        controller: 'EditCalendarEventController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html',
                        controller: 'EditCalendarEventSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    calendarEventTypeId: null,
                    calendarEventType: null,
                    deceased: [],
                    selectedDate: null,
                    apiController: 'Bookings',
                    transportSuggestion: null,
                },
            })
            .state('app.workOrder.byId.notesAndTasks', {
                // NOTES AND TASKS //
                url: '/notes-and-tasks',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/notes-and-tasks/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                    // 'sidenav-right@app.workOrder.byId': {
                    //     templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                    //     controller: 'WorkOrderNotesAndTasksController',
                    //     controllerAs: 'vm'
                    // }
                },
            })
            .state('app.workOrder.byId.invoicing', {
                // INVOICING //
                url: '/invoicing',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/invoicing/work-order-invoicing.tmpl.html',
                        controller: 'WorkOrderInvoicingController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/invoicing/views/sidebar.tmpl.html',
                        controller: 'WorkOrderInvoicingSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.shipments', {
                // SHIPMENTS //
                url: '/shipments',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/shipments/work-order-shipments.tmpl.html',
                        controller: 'WorkOrderShipmentsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.deceasedShipmentById', {
                url: '/edit-shipment/:deceasedShipmentId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/external-order/deceased-shipment/edit-deceased-shipment/views/toolbar.tmpl.html',
                        controller: 'EditDeceasedShipmentToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/external-order/deceased-shipment/edit-deceased-shipment/edit-deceased-shipment.tmpl.html',
                        controller: 'EditDeceasedShipmentController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    workOrderDeceased: null,
                },
            })
            .state('app.workOrder.byId.headstoneOrders', {
                // HEADSTONE ORDERS //
                url: '/headstone-orders',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/headstone-order/work-order-headstone-order.tmpl.html',
                        controller: 'WorkOrderHeadstoneOrderController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.headstoneOrderById', {
                url: '/edit-headstone-order/:headstoneOrderId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/external-order/headstone-order/edit-headstone-order/views/toolbar.tmpl.html',
                        controller: 'EditHeadstoneOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/external-order/headstone-order/edit-headstone-order/edit-headstone-order.tmpl.html',
                        controller: 'EditHeadstoneOrderController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/external-order/headstone-order/edit-headstone-order/views/sidebar.tmpl.html',
                        controller: 'EditHeadstoneOrderSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    externalOrderType: null,
                    workOrderDeceased: null,
                },
            })
            .state('app.workOrder.byId.consignments', {
                // CONSIGNMENTS //
                url: '/consignments',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/consignments/work-order-consignments.tmpl.html',
                        controller: 'WorkOrderConsignmentsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/consignments/views/sidebar.tmpl.html',
                        controller: 'WorkOrderConsignmentsSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.createConsignment', {
                url: '/create-consignment',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/create-consignment/views/toolbar.tmpl.html',
                        controller: 'CreateConsignmentToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/create-consignment/create-consignment.tmpl.html',
                        controller: 'CreateConsignmentController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/create-consignment/views/sidebar.tmpl.html',
                        controller: 'CreateConsignmentSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.consignmentById', {
                url: '/edit-consignment/:signatureJobId',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/edit-consignment/views/toolbar.tmpl.html',
                        controller: 'EditConsignmentToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/edit-consignment/edit-consignment.tmpl.html',
                        controller: 'EditConsignmentController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/signature-jobs/consignment/edit-consignment/views/sidebar.tmpl.html',
                        controller: 'EditConsignmentSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.reports', {
                // REPORTS //
                url: '/reports',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/reports/work-order-reports.tmpl.html',
                        controller: 'WorkOrderReportsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/reports/views/sidebar.tmpl.html',
                        controller: 'WorkOrderReportsSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.attachments', {
                // ATTACHMENTS //
                url: '/attachments',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html',
                        controller: 'WorkOrderToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/attachments/work-order-attachments.tmpl.html',
                        controller: 'WorkOrderAttachmentsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/attachments/views/sidebar.tmpl.html',
                        controller: 'WorkOrderAttachmentsSidebarController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.workOrder.byId.options', {
                // OPTIONS //
                url: '/options',
                views: {
                    'toolbar@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/options/views/toolbar.tmpl.html',
                        controller: 'WorkOrderOptionsToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/options/work-order-options.tmpl.html',
                        controller: 'WorkOrderOptionsController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.workOrder.byId': {
                        templateUrl: 'app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html',
                        controller: 'WorkOrderNotesAndTasksController',
                        controllerAs: 'vm',
                    },
                },
            });

        // Navigation
        msNavigationServiceProvider.saveItem('workOrder', {
            title: 'Work Orders',
            icon: 'icon-briefcase',
            state: 'app.workOrder.dashboard.latest',
            stateParams: {
                date: moment().format('YYYY-MM-DD'),
                latestAmount: 50,
                workOrderTypeId: 'default',
            },
            translate: 'MENU.WORK_ORDER.WORK_ORDERS',
            weight: 1,
            scopes: ['read:workOrders'],
        });

        msNavigationServiceProvider.saveItem('workOrder.search', {
            title: 'Search Work Orders',
            icon: 'icon-magnify',
            state: 'app.workOrder.search',
            translate: 'MENU.WORK_ORDER.SEARCH',
            weight: 1,
            scopes: ['read:workOrders'],
        });

        //DUMMIES: TODO: REMOVE!!!!

        // msNavigationServiceProvider.saveItem('externalOrders', {
        //     title: 'Work Orders',
        //     icon: 'icon-content-paste',
        //     state: 'app.externalOrders',
        //     stateParams: {
        //         'date': moment().format('YYYY-MM-DD')
        //     },
        //     translate: 'MENU.EXTERNAL_ORDERS',
        //     weight: 5
        // });
    }
})();

(function() {
  "use strict";

  angular.module("app.transport").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/transport");

    $stateProvider
      .state("app.transport", {
        abstract: true,
        url: "/transports",
        views: {
          "content@app": {
            template: "<div ui-view></div>"
          }
        }
      })
      .state("app.transport.logistics", {
        url: "/logistics/{date}", //Date format: 'YYYY-MM-DD'
        abstract: true,
        params: {
          date: { value: moment().format("YYYY-MM-DD") }
        },
        templateUrl: "app/main/transport/logistics/transport-logistics.tmpl.html",
        controller: "TransportLogisticsController",
        controllerAs: "vm"
      })
      .state("app.transport.logistics.dashboard", {
        url: "/dashboard",
        templateUrl: "app/main/transport/logistics/dashboard/transport-logistics-dashboard.tmpl.html",
        controller: "TransportLogisticsDashboardController",
        controllerAs: "vm"
      })
      .state("app.transport.logistics.deceased", {
        url: "/deceased",
        templateUrl: "app/main/transport/logistics/deceased/transport-logistics-deceased.tmpl.html",
        controller: "TransportLogisticsDeceasedController",
        controllerAs: "vm"
      })
      .state("app.transport.logistics.dates", {
        url: "/dates",
        templateUrl: "app/main/transport/logistics/dates/transport-logistics-dates.tmpl.html",
        controller: "TransportLogisticsDatesController",
        controllerAs: "vm"
      })
      .state("app.transport.logistics.locations", {
        url: "/locations",
        templateUrl: "app/main/transport/logistics/locations/transport-logistics-locations.tmpl.html",
        controller: "TransportLogisticsLocationsController",
        controllerAs: "vm"
      });

    msNavigationServiceProvider.saveItem("logistics", {
      title: "Logistics",
      icon: "icon-truck",
      translate: "MENU.TRANSPORT.LOGISTICS",
      weight: 6,
      scopes: ["read:workOrders"]
    });

    msNavigationServiceProvider.saveItem("logistics.dashboard", {
      title: "Logistics",
      icon: "icon-tile-four",
      state: "app.transport.logistics.dashboard",
      translate: "MENU.TRANSPORT.DASHBOARD",
      weight: 1,
      scopes: ["read:workOrders"]
    });

    msNavigationServiceProvider.saveItem("logistics.deceased", {
      title: "Logistics",
      icon: "icon-account",
      state: "app.transport.logistics.deceased",
      translate: "MENU.TRANSPORT.DECEASED",
      weight: 2,
      scopes: ["read:workOrders"]
    });

    msNavigationServiceProvider.saveItem("logistics.dates", {
      title: "Logistics",
      icon: "icon-calendar",
      state: "app.transport.logistics.dates",
      translate: "MENU.TRANSPORT.DATES",
      weight: 3,
      scopes: ["read:workOrders"]
    });

    msNavigationServiceProvider.saveItem("logistics.locations", {
      title: "Logistics",
      icon: "icon-map-marker",
      state: "app.transport.logistics.locations",
      translate: "MENU.TRANSPORT.LOCATIONS",
      weight: 4,
      scopes: ["read:workOrders"]
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.transactionalMail')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/transactional-mail');

    }
})();
(function() {
  "use strict";

  angular.module("app.statistics").controller("StatisticsController", StatisticsController);

  /* @ngInject */
  function StatisticsController($mdSidenav, currentUser, accountService, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.toggleSidenav = toggleSidenav;
    vm.canReadWorkOrderStatistics = accountService.canReadWorkOrderStatistics();
    vm.canReadSalesStatistics = accountService.canReadSalesStatistics();

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.statistics").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/statistics");

    $stateProvider
      .state("app.statistics", {
        abstract: true,
        url: "/statistics",
        views: {
          "content@app": {
            templateUrl: "app/main/statistics/statistics.tmpl.html",
            controller: "StatisticsController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.statistics.deceased", {
        url: "/deceased",
        views: {
          "toolbar@app.statistics": {
            templateUrl: "app/main/statistics/deceased/views/toolbar.tmpl.html",
            controller: "DeceasedStatisticsToolbarController",
            controllerAs: "vm"
          },
          "content@app.statistics": {
            templateUrl: "app/main/statistics/deceased/deceased-statistics.tmpl.html",
            controller: "DeceasedStatisticsController",
            controllerAs: "vm"
          },
          "sidenav-right@app.statistics": {
            templateUrl: "app/main/statistics/deceased/views/sidebar.tmpl.html",
            controller: "DeceasedStatisticsSidebarController",
            controllerAs: "vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.statistics.ceremony", {
        url: "/ceremony",
        views: {
          "toolbar@app.statistics": {
            templateUrl: "app/main/statistics/ceremony/views/toolbar.tmpl.html",
            controller: "CeremonyStatisticsToolbarController",
            controllerAs: "vm"
          },
          "content@app.statistics": {
            templateUrl: "app/main/statistics/ceremony/ceremony-statistics.tmpl.html",
            controller: "CeremonyStatisticsController",
            controllerAs: "vm"
          },
          "sidenav-right@app.statistics": {
            templateUrl: "app/main/statistics/ceremony/views/sidebar.tmpl.html",
            controller: "CeremonyStatisticsSidebarController",
            controllerAs: "vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.statistics.sales", {
        url: "/sales",
        views: {
          "toolbar@app.statistics": {
            templateUrl: "app/main/statistics/sales/views/toolbar.tmpl.html",
            controller: "SalesStatisticsToolbarController",
            controllerAs: "vm"
          },
          "content@app.statistics": {
            templateUrl: "app/main/statistics/sales/sales-statistics.tmpl.html",
            controller: "SalesStatisticsController",
            controllerAs: "vm"
          },
          "sidenav-right@app.statistics": {
            templateUrl: "app/main/statistics/sales/views/sidebar.tmpl.html",
            controller: "SalesStatisticsSidebarController",
            controllerAs: "vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      });

    msNavigationServiceProvider.saveItem("statistics", {
      title: "Statistics",
      icon: "icon-chart-line",
      translate: "MENU.STATISTICS.STATISTICS",
      weight: 6,
      anyScopes: ["read:workOrderStatistics", "read:salesStatistics"]
    });

    msNavigationServiceProvider.saveItem("statistics.deceased", {
      title: "Deceased Statistics",
      icon: "icon-clipboard-account",
      state: "app.statistics.deceased",
      translate: "STATISTICS.DECEASED.DECEASED_STATISTICS",
      weight: 1,
      scopes: ["read:workOrderStatistics"]
    });

    msNavigationServiceProvider.saveItem("statistics.ceremony", {
      title: "Ceremony Statistics",
      icon: "icon-church",
      state: "app.statistics.ceremony",
      translate: "STATISTICS.CEREMONY.CEREMONY_STATISTICS",
      weight: 2,
      scopes: ["read:workOrderStatistics"]
    });

    msNavigationServiceProvider.saveItem("statistics.sales", {
      title: "Ceremony Statistics",
      icon: "icon-cart",
      state: "app.statistics.sales",
      translate: "STATISTICS.SALES.SALES_STATISTICS",
      weight: 3,
      scopes: ["read:salesStatistics"]
    });
  }
})();

(function() {
  "use strict";

  angular.module("app.song").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/song");

    $stateProvider
      .state("app.song", {
        abstract: true,
        url: "/song",
        views: {
          "content@app": {
            template: "<div ui-view></div>"
          }
        }
      })
      .state("app.song.songLibrary", {
        url: "/song-library",
        views: {
          "content@app": {
            templateUrl: "app/main/song/song-library/song-library.tmpl.html",
            controller: "SongLibraryController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          songCollectionNames: function(songService) {
            return songService.getSongCollectionNames();
          }
        }
      })
      .state("app.song.songLibrary.songList", {
        url: "/:collectionName",
        views: {
          "toolbar@app.song.songLibrary": {
            templateUrl: "app/main/song/song-library/song-list/partials/song-list-toolbar.tmpl.html",
            controller: "SongListToolbarController",
            controllerAs: "vm"
          },
          "content@app.song.songLibrary": {
            templateUrl: "app/main/song/song-library/song-list/song-list.tmpl.html",
            controller: "SongListController",
            controllerAs: "vm"
          }
        },
        params: {
          locationType: null
        }
      })
      .state("app.song.songLibrary.editSong", {
        url: "/edit-song/:songId",
        views: {
          "toolbar@app.song.songLibrary": {
            templateUrl: "app/main/song/edit-song/partials/edit-song-toolbar.tmpl.html",
            controller: "EditSongToolbarController",
            controllerAs: "vm"
          },
          "content@app.song.songLibrary": {
            templateUrl: "app/main/song/edit-song/edit-song.tmpl.html",
            controller: "EditSongController",
            controllerAs: "vm"
          }
        },
        params: {
          locationType: null
        }
      });

    msNavigationServiceProvider.saveItem("configuration.songLibrary", {
      title: "Song Library",
      icon: "icon-book-multiple",
      state: "app.song.songLibrary.songList",
      stateParams: {
        collectionName: "all"
      },
      translate: "SONGS.SONG_LIBRARY.SONG_LIBRARY",
      weight: 21,
      scopes: ["manage:advancedSettings"]
    });
  }
})();

(function () {
    'use strict';

    var eventTypes = {
        UNKNOWN: { value: 'unknown', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.UNKNOWN' },
        CREATED: { value: 'created', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.CREATED' },
        UPDATED: { value: 'updated', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.UPDATED' },
        EXPORTED_TO_EXTERNAL: { value: 'exportedToExternal', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.EXPORTED_TO_EXTERNAL' },
        SENT: { value: 'sent', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.SENT' },
        SIGNED: { value: 'signed', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.SIGNED' },
        EXPIRED: { value: 'expired', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.EXPIRED' },
        SEALED: { value: 'sealed', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.SEALED' },
        VIEWED: { value: 'viewed', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.VIEWED' },
        REVIEWED: { value: 'reviewed', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.REVIEWED' },
        REJECTED: { value: 'rejected', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.REJECTED' },
        RECALLED: { value: 'recalled', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.RECALLED' },
        DELETED: { value: 'deleted', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.DELETED' },
        ADDED: { value: 'added', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.ADDED' },
        APPROVED: { value: 'approved', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.APPROVED' },
        DOWNLOADED: { value: 'downloaded', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.DOWNLOADED' },
        PRINTED: { value: 'printed', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.PRINTED' },
        FORWARDED: { value: 'forwarded', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.FORWARDED' },
        COMMENTED: { value: 'commented', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.COMMENTED' },
        HARD_BOUNCED: { value: 'hardBounced', text: 'SIGNATURE_JOBS.SIGNATURE_JOB.EVENT.STATUS_TEXT.HARD_BOUNCED' },
    };

    angular.module('app.signatureJobs').constant('signatureJobEventTypes', eventTypes);
})();

(function () {
    'use strict';

    angular.module('app.signatureJobs').config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/signature-jobs');
    }
})();

(function () {
    'use strict';

    var referenceTypes = [
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.ADDRESS_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'address-types',
            internalName: 'AddressType',
            apiController: 'AddressTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-home',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/address-type.tmpl.html',
            templateTitle: 'ADDRESSES.ADDRESS_TYPE.EDIT_ADDRESS_TYPE',
            deleteText: 'ADDRESSES.ADDRESS_TYPE.DELETE_ADDRESS_TYPE',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 0,
        },
        {
            useLegacyService: false,
            name: 'SETTINGS.REFERENCE_REGISTRY.AUTO_TASKS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.SUBJECT_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.TEXT_TITLE',
            route: 'auto-tasks',
            internalName: 'AutoTask',
            apiController: 'AutoTasks',
            primaryPath: 'subject',
            secondaryPath: 'text',
            iconPath: null,
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-format-list-bulleted',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/auto-task.tmpl.html',
            templateTitle: 'AUTO_TASKS.EDIT_AUTO_TASK.EDIT_AUTO_TASK',
            deleteText: 'AUTO_TASKS.EDIT_AUTO_TASK.DELETE_AUTO_TASK',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 5,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.BALANCE_ACCOUNTS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.BALANCE_ACCOUNT_ACCOUNT_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.BALANCE_ACCOUNT_NAME_TITLE',
            route: 'balance-accounts',
            internalName: 'BalanceAccount',
            apiController: 'BalanceAccounts',
            primaryPath: 'account',
            secondaryPath: 'name',
            iconPath: 'iconName',
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-numeric',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/balance-account.tmpl.html',
            addIcon: 'icon-plus',
            permittedRoles: 'FinancialManager,Administrator',
            editRoles: 'FinancialManager,Administrator',
            sortOrder: 40,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.FILE_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'file-types',
            internalName: 'BaldrisFileType',
            apiController: 'BaldrisFileTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-folder-multiple-image',
            editState: null,
            addState: null,
            addIcon: 'icon-folder-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 30,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.USERS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.EMAIL_TITLE',
            route: 'users',
            internalName: 'BaldrisUser',
            apiController: 'BaldrisUsers',
            primaryPath: 'displayName',
            secondaryPath: 'email',
            iconPath: 'iconName',
            imagePath: 'profileImageFilepath',
            gravatarPath: 'email',
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-account-multiple',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/user.tmpl.html',
            addIcon: 'icon-account-plus',
            permittedRoles: 'Administrator',
            editRoles: 'Administrator',
            sortOrder: 10,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.CALENDAR_EVENT_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'calendar-event-types',
            internalName: 'CalendarEventType',
            apiController: 'CalendarEventTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-calendar-multiple',
            editState: null,
            addState: null,
            hasAutoProducts: true,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/calendar-event-type.tmpl.html',
            addIcon: 'icon-calendar-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.CASKETS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.COLOR_TITLE',
            route: 'caskets',
            internalName: 'Casket',
            apiController: 'Caskets',
            primaryPath: 'name',
            secondaryPath: 'color',
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-box-download',
            editState: null,
            addState: null,
            hasAutoProducts: true,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/casket.tmpl.html',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.COUNTRIES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.COUNTRY_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.CONTINENT_TITLE',
            route: 'countries',
            internalName: 'Country',
            apiController: 'Countries',
            primaryPath: 'name',
            secondaryPath: 'continent',
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-earth',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.CUSTOM_FIELD_CATEGORIES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.INTERNAL_NAME_TITLE',
            route: 'custom-field-categories',
            internalName: 'CustomFieldCategory',
            apiController: 'CustomFieldCategories',
            primaryPath: 'name',
            secondaryPath: 'internalName',
            iconPath: null,
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-folder-multiple-outline',
            editState: null,
            addState: null,
            addIcon: 'icon-folder-plus',
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/custom-field-category.tmpl.html',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.CUSTOM_FIELDS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.INTERNAL_NAME_TITLE',
            route: 'custom-fields',
            internalName: 'CustomField',
            apiController: 'CustomFields',
            primaryPath: 'name',
            secondaryPath: 'internalName',
            iconPath: null,
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-format-object-inline',
            editState: null,
            addState: null,
            hasAutoProducts: true,
            addIcon: 'icon-plus',
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/custom-field.tmpl.html',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.EMAIL_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'email-types',
            internalName: 'EmailType',
            apiController: 'EmailTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-email',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.EQUIPMENT',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'equipment',
            internalName: 'Equipment',
            apiController: 'Equipment',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-package-variant',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.EQUIPMENT_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'equipment-types',
            internalName: 'EquipmentType',
            apiController: 'EquipmentTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-package',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.EXTERNAL_ORDER_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'external-order-types',
            internalName: 'ExternalOrderType',
            apiController: 'ExternalOrderTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-clipboard-arrow-left',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.GRAVE_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'grave-types',
            internalName: 'GraveType',
            apiController: 'GraveTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-heart-box',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.GROOMING_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'grooming-types',
            internalName: 'GroomingType',
            apiController: 'GroomingTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-hotel',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.LOCATION_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'location-types',
            internalName: 'LocationType',
            apiController: 'LocationTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-map-marker-multiple',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.LOOKUP_STRINGS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.TYPE_TITLE',
            route: 'lookup-strings',
            internalName: 'LookupString',
            apiController: 'LookupStrings',
            primaryPath: 'lookupValue',
            secondaryPath: 'lookupStringTypeName',
            iconPath: 'lookupIconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            hasAutoProducts: true,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/lookup-string.tmpl.html',
            icon: 'icon-format-text',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.LOOKUP_STRING_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.DESCRIPTION_TITLE',
            route: 'lookup-string-types',
            internalName: 'LookupStringType',
            apiController: 'LookupStringTypes',
            primaryPath: 'name',
            secondaryPath: 'description',
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/lookup-string-type.tmpl.html',
            icon: 'icon-tag-text-outline',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.MUNICIPALITIES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.STATE_TITLE',
            route: 'municipalities',
            internalName: 'Municipality',
            apiController: 'Municipalities',
            primaryPath: 'name',
            secondaryPath: 'stateName',
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            hasAutoProducts: true,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/municipality.tmpl.html',
            icon: 'icon-border-none',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.OBITUARY_NOTICE_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'obituary-notice-types',
            internalName: 'ObituaryNoticeType',
            apiController: 'ObituaryNoticeTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-format-align-center',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/obituary-notice-type.tmpl.html',
            templateTitle: 'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.EDIT_OBITUARY_NOTICE_TYPE',
            deleteText: 'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.DELETE_OBITUARY_NOTICE_TYPE',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.PARTICIPANT_ROLES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'participant-roles',
            internalName: 'ParticipantRole',
            apiController: 'ParticipantRoles',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: null,
            gravatarPath: null,
            hasAutoProducts: true,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-tie',
            editState: null,
            addState: null,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/participant-role.tmpl.html',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.PARTICIPANT_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'participant-types',
            internalName: 'ParticipantType',
            apiController: 'ParticipantTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-folder-account',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.PARTY_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'party-types',
            internalName: 'PartyType',
            apiController: 'PartyTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-folder-account',
            editState: null,
            addState: null,
            addIcon: 'icon-folder-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.PROGRAM_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'program-types',
            internalName: 'ProgramType',
            apiController: 'ProgramTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'previewImageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-file-document',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.REPORTS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.DESCRIPTION_TITLE',
            route: 'reports',
            internalName: 'Report',
            apiController: 'Reports',
            primaryPath: 'name',
            secondaryPath: 'description',
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            sortOrderPath: 'sortOrder',
            icon: 'icon-printer',
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/report.tmpl.html',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.STATES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.COUNTRY_TITLE',
            route: 'states',
            internalName: 'State',
            apiController: 'States',
            primaryPath: 'name',
            secondaryPath: 'countryName',
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: null,
            icon: 'icon-shield',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.TELEPHONE_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'telephone-types',
            internalName: 'TelephoneType',
            apiController: 'TelephoneTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconPath',
            imagePath: null,
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-phone',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.URNS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.COLOR_TITLE',
            route: 'urns',
            internalName: 'Urn',
            apiController: 'Urns',
            primaryPath: 'name',
            secondaryPath: 'color',
            iconPath: null,
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-beaker-empty',
            editState: null,
            addState: null,
            hasAutoProducts: true,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/urn.tmpl.html',
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.VATS',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: 'SETTINGS.REFERENCE_REGISTRY.VAT_RATE_TITLE',
            route: 'vats',
            internalName: 'Vat',
            apiController: 'Vats',
            primaryPath: 'name',
            secondaryPath: 'rate',
            iconPath: null,
            imagePath: null,
            gravatarPath: null,
            fallbackPath: null,
            deletedPath: 'isDeleted',
            icon: 'icon-percent',
            editState: null,
            addState: null,
            addIcon: 'icon-plus',
            permittedRoles: 'User',
            editRoles: 'User',
            sortOrder: 20,
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/vat.tmpl.html',
        },
        {
            useLegacyService: true,
            name: 'SETTINGS.REFERENCE_REGISTRY.WORK_ORDER_TYPES',
            primaryTitle: 'SETTINGS.REFERENCE_REGISTRY.NAME_TITLE',
            secondaryTitle: null,
            route: 'work-order-types',
            internalName: 'WorkOrderType',
            apiController: 'WorkOrderTypes',
            primaryPath: 'name',
            secondaryPath: null,
            iconPath: 'iconName',
            imagePath: 'imageFilepath',
            gravatarPath: null,
            fallbackPath: 'icon-help',
            deletedPath: 'isDeleted',
            icon: 'icon-truck',
            quickTemplate: 'app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/work-order-type.tmpl.html',
            editState: null,
            addState: null,
            hasAutoProducts: true,
            addIcon: 'icon-plus',
            permittedRoles: 'FinancialManager,Administrator',
            editRoles: 'FinancialManager,Administrator',
            sortOrder: 20,
        },
    ];
    angular.module('app.settings').constant('settingsReferenceTypes', referenceTypes);
})();

(function () {
    'use strict';

    angular.module('app.settings').config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/settings');

        $stateProvider
            .state('app.configuration', {
                abstract: true,
                url: '/configuration',
            })
            .state('app.configuration.referenceTypes', {
                url: '/reference-types',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/reference-types/configuration-reference-types.tmpl.html',
                        controller: 'ConfigurationReferenceTypesController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.referenceTypes.view', {
                url: '/{routeId}?{showDeleted:bool}',
                templateUrl: 'app/main/settings/configuration/reference-types/reference-type-view/configuration-reference-type-view.tmpl.html',
                controller: 'ConfigurationReferenceTypeViewController',
                controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    referenceList: function (dataService, settingsReferenceTypes, $stateParams) {
                        for (var index = 0; index < settingsReferenceTypes.length; index++) {
                            var referenceType = settingsReferenceTypes[index];
                            if (referenceType.route === $stateParams.routeId) {
                                return dataService.getAll(referenceType.apiController).then(function (referenceList) {
                                    if (referenceType.deletedPath && !$stateParams.showDeleted) {
                                        referenceList = referenceList.filter(function (reference) {
                                            return !reference[referenceType.deletedPath] || reference.isAlumni;
                                        });
                                    }
                                    return referenceList;
                                });
                            }
                        }
                    },
                },
            })
            .state('app.configuration.editReference', {
                url: '/edit-reference',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/edit-reference/edit-reference.tmpl.html',
                    },
                },
            })
            .state('app.configuration.editReference.editLocation', {
                url: '/location/:locationId',
                templateUrl: 'app/main/reference-types/location/edit-location/edit-location.tmpl.html',
                controller: 'EditLocationController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings', {
                url: '/program-settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/program-settings/program-settings.tmpl.html',
                        controller: 'ProgramSettingsController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.programSettings.styles', {
                url: '/styles',
                templateUrl: 'app/main/settings/configuration/program-settings/program-styles/program-styles.tmpl.html',
                controller: 'ProgramStylesController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings.programStyleById', {
                url: '/styles/:programStyleId',
                templateUrl: 'app/main/settings/configuration/program-settings/program-styles/edit-program-style/edit-program-style.tmpl.html',
                controller: 'EditProgramStyleController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings.programTypes', {
                url: '/program-types',
                templateUrl: 'app/main/settings/configuration/program-settings/program-types/program-types.tmpl.html',
                controller: 'ProgramTypesController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings.programTypeById', {
                url: '/program-types/:programTypeId',
                templateUrl: 'app/main/settings/configuration/program-settings/program-types/edit-program-type/edit-program-type.tmpl.html',
                controller: 'EditProgramTypeController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings.programSlots', {
                url: '/program-slots',
                templateUrl: 'app/main/settings/configuration/program-settings/program-slots/program-slots.tmpl.html',
                controller: 'ProgramSlotsController',
                controllerAs: 'vm',
            })
            .state('app.configuration.programSettings.programSlotById', {
                url: '/program-slots/:programSlotId',
                templateUrl: 'app/main/settings/configuration/program-settings/program-slots/edit-program-slot/edit-program-slot.tmpl.html',
                controller: 'EditProgramSlotController',
                controllerAs: 'vm',
            })
            .state('app.configuration.contacts', {
                url: '/contacts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/contacts/contacts.tmpl.html',
                        controller: 'ContactsController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    contactTypes: function (dataService) {
                        return dataService.getByUri('Contacts', 'ContactTypes/GetContactTypes');
                    },
                },
            })
            .state('app.configuration.contacts.contactList', {
                url: '/list/:internalType/:internalTypeId?searchString',
                views: {
                    'toolbar@app.configuration.contacts': {
                        templateUrl: 'app/main/settings/configuration/contacts/partials/contacts-toolbar.tmpl.html',
                        controller: 'ContactsToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.contacts': {
                        templateUrl: 'app/main/settings/configuration/contacts/contact-list/contact-list.tmpl.html',
                        controller: 'ContactListController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    contactType: null,
                },
            })
            .state('app.configuration.contacts.editSupplier', {
                url: '/edit-supplier/:supplierId',
                views: {
                    'toolbar@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/supplier/edit-supplier/views/toolbar.tmpl.html',
                        controller: 'EditSupplierToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/supplier/edit-supplier/edit-supplier.tmpl.html',
                        controller: 'EditSupplierController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/supplier/edit-supplier/views/sidebar.tmpl.html',
                        controller: 'EditSupplierToolbarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    supplierTypeId: null,
                },
            })
            .state('app.configuration.contacts.editParticipant', {
                url: '/edit-participant/:participantId',
                views: {
                    'toolbar@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/participant/edit-participant/views/toolbar.tmpl.html',
                        controller: 'EditParticipantToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/participant/edit-participant/edit-participant.tmpl.html',
                        controller: 'EditParticipantController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/participant/edit-participant/views/sidebar.tmpl.html',
                        controller: 'EditParticipantSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    participantTypeId: null,
                },
            })
            .state('app.configuration.contacts.editParty', {
                url: '/edit-party/:partyId',
                views: {
                    'toolbar@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/party/edit-party/views/toolbar.tmpl.html',
                        controller: 'EditPartyToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/party/edit-party/edit-party.tmpl.html',
                        controller: 'EditPartyController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.configuration.contacts': {
                        templateUrl: 'app/main/reference-types/party/edit-party/views/sidebar.tmpl.html',
                        controller: 'EditPartyToolbarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    partyTypeId: null,
                },
            })
            .state('app.configuration.locations', {
                url: '/locations',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/locations/location-config.tmpl.html',
                        controller: 'LocationConfigController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    locationTypes: function ($filter, dataService) {
                        return dataService.getAll('LocationTypes').then(function (locationTypes) {
                            locationTypes = $filter('filter')(locationTypes, {
                                isDeleted: false,
                            });
                            return locationTypes;
                        });
                    },
                },
            })
            .state('app.configuration.locations.locationList', {
                url: '/list/:locationTypeId',
                views: {
                    'toolbar@app.configuration.locations': {
                        templateUrl: 'app/main/settings/configuration/locations/partials/location-config-toolbar.tmpl.html',
                        controller: 'LocationListToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.locations': {
                        templateUrl: 'app/main/settings/configuration/locations/location-list/location-list.tmpl.html',
                        controller: 'LocationListController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    locationType: null,
                },
            })
            .state('app.configuration.locations.editLocation', {
                url: '/edit-location/:locationId',
                views: {
                    'toolbar@app.configuration.locations': {
                        templateUrl: 'app/main/reference-types/location/edit-location/views/toolbar.tmpl.html',
                        controller: 'EditLocationToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.locations': {
                        templateUrl: 'app/main/reference-types/location/edit-location/edit-location.tmpl.html',
                        controller: 'EditLocationController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.configuration.locations': {
                        templateUrl: 'app/main/reference-types/location/edit-location/views/location-sidenav.tmpl.html',
                        controller: 'EditLocationToolbarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    locationTypeId: null,
                },
            })
            .state('app.configuration.departments', {
                url: '/departments',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/departments/department-config.tmpl.html',
                        controller: 'DepartmentConfigController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    legalUnits: function ($filter, dataService) {
                        return dataService.getAll('LegalUnits').then(function (legalUnits) {
                            legalUnits = $filter('filter')(legalUnits, {
                                isDeleted: false,
                            });
                            return legalUnits;
                        });
                    },
                    /* @ngInject */
                    departments: function (departmentService) {
                        return departmentService.getAllDepartments(true);
                    },
                },
            })
            .state('app.configuration.departments.departmentList', {
                url: '/:legalUnitId',
                views: {
                    'content@app.configuration.departments': {
                        templateUrl: 'app/main/settings/configuration/departments/department-list/department-list.tmpl.html',
                        controller: 'DepartmentConfigListController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    legalUnitId: {
                        type: 'string',
                        value: 'all',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentDepartments: function ($filter, $stateParams, departments) {
                        if ($stateParams.legalUnitId && $stateParams.legalUnitId !== 'all') {
                            return $filter('filter')(departments, { legalUnitId: $stateParams.legalUnitId });
                        }
                        return departments;
                    },
                },
            })
            .state('app.configuration.departments.editDepartment', {
                url: '/edit-department/:departmentId',
                views: {
                    'content@app.configuration.departments': {
                        templateUrl: 'app/main/settings/configuration/departments/edit-department/edit-department.tmpl.html',
                        controller: 'DepartmentConfigEditController',
                        controllerAs: 'vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    department: function ($stateParams, departmentService) {
                        if ($stateParams.departmentId && $stateParams.departmentId !== 'new') {
                            return departmentService.getDepartmentById($stateParams.departmentId);
                        }
                        return departmentService.getEmptyDepartment();
                    },
                    /* @ngInject */
                    organization: function ($stateParams, departmentService, partyService) {
                        if ($stateParams.departmentId && $stateParams.departmentId !== 'new') {
                            return departmentService.getOrganizationByDepartmentId($stateParams.departmentId);
                        }
                        return partyService.getEmptyOrganization();
                    },
                },
            })
            .state('app.configuration.departments.editLegalUnit', {
                url: '/edit-legal-unit/:legalUnitId',
                views: {
                    'content@app.configuration.departments': {
                        templateUrl: 'app/main/settings/configuration/departments/edit-legal-unit/edit-legal-unit.tmpl.html',
                        controller: 'LegalUnitConfigEditController',
                        controllerAs: 'vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    legalUnit: function ($stateParams, departmentService) {
                        if ($stateParams.legalUnitId && $stateParams.legalUnitId !== 'new') {
                            return departmentService.getLegalUnitById($stateParams.legalUnitId);
                        }
                        return departmentService.getEmptyLegalUnit();
                    },
                    /* @ngInject */
                    organization: function ($stateParams, departmentService, partyService) {
                        if ($stateParams.legalUnitId && $stateParams.legalUnitId !== 'new') {
                            return departmentService.getOrganizationByLegalUnitId($stateParams.legalUnitId);
                        }
                        return partyService.getEmptyOrganization();
                    },
                },
            })
            .state('app.configuration.customers', {
                url: '/customers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/customers/customers.tmpl.html',
                        controller: 'CustomersController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.customers.customerList', {
                url: '/list/:searchString',
                views: {
                    'toolbar@app.configuration.customers': {
                        templateUrl: 'app/main/settings/configuration/customers/partials/customers-toolbar.tmpl.html',
                        controller: 'CustomersToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.customers': {
                        templateUrl: 'app/main/settings/configuration/customers/customer-list/customer-list.tmpl.html',
                        controller: 'CustomerListController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    locationType: null,
                },
            })
            .state('app.configuration.customers.editCustomer', {
                url: '/edit-customer/:customerId',
                views: {
                    'toolbar@app.configuration.customers': {
                        templateUrl: 'app/main/reference-types/customer/edit-customer/views/toolbar.tmpl.html',
                        controller: 'EditCustomerToolbarController',
                        controllerAs: 'vm',
                    },
                    'content@app.configuration.customers': {
                        templateUrl: 'app/main/reference-types/customer/edit-customer/edit-customer.tmpl.html',
                        controller: 'EditCustomerController',
                        controllerAs: 'vm',
                    },
                    'sidenav-right@app.configuration.customers': {
                        templateUrl: 'app/main/reference-types/customer/edit-customer/views/customer-sidenav.tmpl.html',
                        controller: 'EditCustomerSidebarController',
                        controllerAs: 'vm',
                    },
                },
                params: {
                    partyTypeId: null,
                },
            })
            .state('app.configuration.transportSettings', {
                url: '/transport-settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/transport-settings/transport-settings.tmpl.html',
                        controller: 'TransportSettingsController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.transportSettings.generalSettings', {
                url: '/general-settings',
                templateUrl: 'app/main/settings/configuration/transport-settings/general-settings/transport-general-settings.tmpl.html',
                controller: 'TransportGeneralSettingsController',
                controllerAs: 'vm',
            })
            .state('app.configuration.transportSettings.locationTransports', {
                url: '/transport-templates',
                templateUrl: 'app/main/settings/configuration/transport-settings/location-transports/location-transports.tmpl.html',
                controller: 'LocationTransportsController',
                controllerAs: 'vm',
            })
            .state('app.configuration.transportSettings.locationTransportById', {
                url: '/transport-templates/:locationTransportId',
                templateUrl: 'app/main/settings/configuration/transport-settings/location-transports/edit-location-transport/edit-location-transport.tmpl.html',
                controller: 'EditLocationTransportController',
                controllerAs: 'vm',
            })
            .state('app.configuration.invoiceSettings', {
                url: '/invoice-settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/invoice-settings/invoice-settings.tmpl.html',
                        controller: 'InvoiceSettingsController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.invoiceSettings.generalSettings', {
                url: '/general-settings',
                templateUrl: 'app/main/settings/configuration/invoice-settings/general-settings/invoice-general-settings.tmpl.html',
                controller: 'InvoiceGeneralSettingsController',
                controllerAs: 'vm',
            })
            .state('app.configuration.invoiceSettings.multiChannelSettings', {
                url: '/multi-channel',
                templateUrl: 'app/main/settings/configuration/invoice-settings/transfer-settings/invoice-transfer-settings.tmpl.html',
                controller: 'InvoiceTransferSettingsController',
                controllerAs: 'vm',
            })
            .state('app.configuration.consignmentsSettings', {
                url: '/consignments-settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/configuration/consignments/consignments-config.tmpl.html',
                        controller: 'ConsignmentsConfigController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.configuration.consignmentsSettings.generalSettings', {
                url: '/general-settings',
                templateUrl: 'app/main/settings/configuration/consignments/general-settings/consignments-general-settings.tmpl.html',
                controller: 'ConsignmentsGeneralSettingsController',
                controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    consignmentsActivated: function(signatureJobService) {
                        return signatureJobService.getConsignmentsActivated();
                    },
                },
            });

        msNavigationServiceProvider.saveItem('configuration', {
            title: 'Configuration',
            icon: 'icon-cog',
            translate: 'MENU.CONFIGURATION.CONFIGURATION',
            weight: 7,
            anyScopes: ['manage:advancedSettings', 'manage:contact', 'manage:location', 'read:invoice'],
        });

        msNavigationServiceProvider.saveItem('configuration.referenceTypes', {
            title: 'Reference Types',
            icon: 'icon-apps',
            state: 'app.configuration.referenceTypes',
            translate: 'MENU.CONFIGURATION.REFERENCE_REGISTRY',
            weight: 10,
            scopes: ['manage:advancedSettings'],
        });
        msNavigationServiceProvider.saveItem('configuration.departmentSettings', {
            title: 'Departments',
            icon: 'icon-store',
            state: 'app.configuration.departments.departmentList',
            translate: 'MENU.CONFIGURATION.DEPARTMENTS.DEPARTMENT_REGISTRY',
            weight: 15,
            scopes: ['manage:advancedSettings'],
        });
        msNavigationServiceProvider.saveItem('configuration.programSettings', {
            title: 'Reference Types',
            icon: 'icon-apps',
            state: 'app.configuration.programSettings',
            translate: 'MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_SETTINGS',
            weight: 20,
            scopes: ['manage:advancedSettings'],
        });
        msNavigationServiceProvider.saveItem('configuration.contacts', {
            title: 'Contact Registry',
            icon: 'icon-folder-account',
            state: 'app.configuration.contacts',
            translate: 'MENU.CONFIGURATION.CONTACTS.CONTACT_REGISTRY',
            weight: 30,
            scopes: ['manage:contact'],
        });
        msNavigationServiceProvider.saveItem('configuration.customers', {
            title: 'Customer Registry',
            icon: 'icon-folder-account',
            state: 'app.configuration.customers',
            translate: 'MENU.CONFIGURATION.CUSTOMERS.CUSTOMER_REGISTRY',
            weight: 40,
            scopes: ['read:invoice'],
        });
        msNavigationServiceProvider.saveItem('configuration.locations', {
            title: 'Location Registry',
            icon: 'icon-map-marker',
            state: 'app.configuration.locations',
            translate: 'MENU.CONFIGURATION.LOCATIONS.LOCATION_REGISTRY',
            weight: 50,
            scopes: ['manage:location'],
        });
        msNavigationServiceProvider.saveItem('configuration.transportSettings', {
            title: 'Transport Settings',
            icon: 'icon-truck',
            state: 'app.configuration.transportSettings',
            translate: 'MENU.CONFIGURATION.TRANSPORT_SETTINGS.TRANSPORT_SETTINGS',
            weight: 60,
            scopes: ['manage:advancedSettings'],
        });
        msNavigationServiceProvider.saveItem('configuration.invoiceSettings', {
            title: 'Invoice Settings',
            icon: 'icon-bank',
            state: 'app.configuration.invoiceSettings.generalSettings',
            translate: 'MENU.CONFIGURATION.INVOICE_SETTINGS.INVOICE_SETTINGS',
            weight: 70,
            scopes: ['manage:finance'],
        });
        msNavigationServiceProvider.saveItem('configuration.consignmentsSettings', {
            title: 'Consignments Settings',
            icon: 'icon-pen',
            state: 'app.configuration.consignmentsSettings.generalSettings',
            translate: 'MENU.CONFIGURATION.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_SETTINGS',
            weight: 80,
            scopes: ['manage:tenants'],
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.salesOrder').config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/sales-order');

        $stateProvider
            .state('app.salesOrder', {
                abstract: true,
                url: '/sales-orders',
            })
            .state('app.salesOrder.recent', {
                url: '/recent/:recentAmount',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/recent/sales-order-recent.tmpl.html',
                        controller: 'SalesOrderRecentController as vm',
                    },
                },
                resolve: {
                    salesOrderTitle: function () {
                        return 'MENU.SALES_ORDERS.RECENT';
                    },
                    recentUri: function () {
                        return null;
                    },
                },
                params: {
                    recentAmount: { squash: true, value: '50' },
                    pageIndex: { squash: true, value: '0' },
                    searchString: { squash: true, value: null },
                },
            })
            .state('app.salesOrder.withInvoiceDrafts', {
                url: '/with-invoice-drafts/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/recent/sales-order-recent.tmpl.html',
                        controller: 'SalesOrderRecentController as vm',
                    },
                },
                resolve: {
                    salesOrderTitle: function () {
                        return 'MENU.SALES_ORDERS.WITH_INVOICE_DRAFTS';
                    },
                    recentUri: function () {
                        return 'WithInvoiceDrafts';
                    },
                },
                params: {
                    recentAmount: { squash: true, value: '50' },
                    pageIndex: { squash: true, value: '0' },
                    searchString: { squash: true, value: null },
                },
            })
            .state('app.salesOrder.withoutInvoices', {
                url: '/without-invoices/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/recent/sales-order-recent.tmpl.html',
                        controller: 'SalesOrderRecentController as vm',
                    },
                },
                resolve: {
                    salesOrderTitle: function () {
                        return 'MENU.SALES_ORDERS.WITHOUT_INVOICES';
                    },
                    recentUri: function () {
                        return 'WithoutInvoices';
                    },
                },
                params: {
                    recentAmount: { squash: true, value: '50' },
                    pageIndex: { squash: true, value: '0' },
                    searchString: { squash: true, value: null },
                },
            })
            .state('app.salesOrder.recentInvoices', {
                url: '/recent-invoices/:recentAmount/:pageIndex?sortField&searchString',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/recent-invoices/sales-order-recent-invoices.tmpl.html',
                        controller: 'SalesOrderRecentInvoicesController as vm',
                    },
                },
                resolve: {
                    invoiceTitle: function () {
                        return 'MENU.INVOICES.RECENT';
                    },
                    /* @ngInject */
                    recentUri: function ($stateParams) {
                        return 'Latest/' + $stateParams.recentAmount;
                    },
                },
            })
            .state('app.salesOrder.unlockedInvoices', {
                url: '/invoice-drafts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/recent-invoices/sales-order-recent-invoices.tmpl.html',
                        controller: 'SalesOrderRecentInvoicesController as vm',
                    },
                },
                resolve: {
                    invoiceTitle: function () {
                        return 'MENU.INVOICES.UNLOCKED';
                    },
                    recentUri: function () {
                        return '/Unlocked/';
                    },
                },
            })
            .state('app.salesOrder.details', {
                url: '/:salesOrderId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/edit-sales-order/edit-sales-order.tmpl.html',
                        controller: 'EditSalesOrderController as vm',
                    },
                },
                params: {
                    workOrder: null,
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.salesOrder.details.preview', {
                url: '/preview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/edit-sales-order/preview-report/sales-order-preview-report.tmpl.html',
                        controller: 'SalesOrderPreviewReportController as vm',
                    },
                },
                params: {
                    report: null,
                },
            })
            .state('app.invoice', {
                abstract: true,
                url: '/invoices',
            })
            .state('app.invoice.journal', {
                url: '/journal',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/journal/sales-order-journal.tmpl.html',
                        controller: 'SalesOrderJournalController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            })
            .state('app.invoice.details', {
                url: '/:invoiceId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales-order/edit-invoice/edit-invoice.tmpl.html',
                        controller: 'EditInvoiceController as vm',
                    },
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                },
            });

        msNavigationServiceProvider.saveItem('salesOrder', {
            title: 'Sales Orders',
            icon: 'icon-basket',
            translate: 'MENU.SALES_ORDERS.SALES_ORDERS',
            weight: 2,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('salesOrder.recent', {
            title: 'Sales Orders Dashboard',
            icon: 'icon-timetable',
            state: 'app.salesOrder.recent',
            stateParams: {
                recentAmount: 50,
                pageIndex: 0,
                searchString: null,
            },
            translate: 'MENU.SALES_ORDERS.RECENT',
            weight: 1,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('salesOrder.withInvoiceDrafts', {
            title: 'Sales Orders Dashboard',
            icon: 'icon-receipt',
            state: 'app.salesOrder.withInvoiceDrafts',
            translate: 'MENU.SALES_ORDERS.WITH_INVOICE_DRAFTS',
            weight: 2,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('salesOrder.withoutInvoices', {
            title: 'Sales Orders Dashboard',
            icon: 'icon-alert-box',
            state: 'app.salesOrder.withoutInvoices',
            translate: 'MENU.SALES_ORDERS.WITHOUT_INVOICES',
            weight: 3,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('invoices', {
            title: 'Invoices',
            icon: 'icon-bank',
            translate: 'MENU.INVOICES.INVOICES',
            weight: 3,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('invoices.recentInvoices', {
            title: 'Recent Invoices',
            icon: 'icon-timetable',
            state: 'app.salesOrder.recentInvoices',
            stateParams: {
                recentAmount: localStorage.getItem('recent-invoices:recentAmount') || 25,
                pageIndex: 0,
            },
            translate: 'MENU.INVOICES.RECENT',
            weight: 1,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('invoices.withoutInvoices', {
            title: 'Invoice Drafts',
            icon: 'icon-alert-box',
            state: 'app.salesOrder.unlockedInvoices',
            translate: 'MENU.INVOICES.UNLOCKED',
            weight: 2,
            scopes: ['read:invoice'],
        });

        msNavigationServiceProvider.saveItem('invoices.journal', {
            title: 'Sales Orders Dashboard',
            icon: 'icon-file-document',
            state: 'app.invoice.journal',
            translate: 'SALES_ORDERS.INVOICE_JOURNAL.INVOICE_JOURNAL',
            weight: 4,
            scopes: ['manage:finance'],
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/report');

         
    }
})();
(function () {
    'use strict';

    var casketAttributes = {
        NONE: { value: 'none', text: 'CASKETS.CASKET_ATTRIBUTES.NONE' },
        EXTRA_LONG: {
            value: 'extraLong',
            text: 'CASKETS.CASKET_ATTRIBUTES.EXTRA_LONG',
        },
        EXTRA_WIDE: {
            value: 'extraWide',
            text: 'CASKETS.CASKET_ATTRIBUTES.EXTRA_WIDE',
        },
        EXTRA_HIGH: {
            value: 'extraHigh',
            text: 'CASKETS.CASKET_ATTRIBUTES.EXTRA_HIGH',
        },
        EXTRA_HEAVY: {
            value: 'extraHeavy',
            text: 'CASKETS.CASKET_ATTRIBUTES.EXTRA_HEAVY',
        },
        CANNOT_BE_CREMATED: {
            value: 'cannotBeCremated',
            text: 'CASKETS.CASKET_ATTRIBUTES.CANNOT_BE_CREMATED',
        },
        SOLID_WOOD: {
            value: 'solidWood',
            text: 'CASKETS.CASKET_ATTRIBUTES.SOLID_WOOD',
        },
        PARTICLE_BOARD: {
            value: 'particleBoard',
            text: 'CASKETS.CASKET_ATTRIBUTES.PARTICLE_BOARD',
        },
        FIBER: { value: 'fiber', text: 'CASKETS.CASKET_ATTRIBUTES.FIBER' },
        OTHER_MATERIAL: {
            value: 'otherMaterial',
            text: 'CASKETS.CASKET_ATTRIBUTES.OTHER_MATERIAL',
        },
        RECTANGULAR: {
            value: 'rectangular',
            text: 'CASKETS.CASKET_ATTRIBUTES.RECTANGULAR',
        },
        NON_RECTANGULAR: {
            value: 'nonRectangular',
            text: 'CASKETS.CASKET_ATTRIBUTES.NON_RECTANGULAR',
        },
        CHILD_CASKET: {
            value: 'childCasket',
            text: 'CASKETS.CASKET_ATTRIBUTES.CHILD_CASKET',
        },
    };

    angular
        .module('app.referenceTypes')
        .constant('casketAttributes', casketAttributes);

    var locationRelation = {
        NONE: { value: 'none', text: 'LOCATIONS.LOCATION_RELATION.NONE' },
        IS_NATURAL_CASKET_STORAGE: {
            value: 'isNaturalCasketStorage',
            text: 'LOCATIONS.LOCATION_RELATION.IS_NATURAL_CASKET_STORAGE',
        },
        IS_NATURAL_CEMETERY: {
            value: 'isNaturalCemetery',
            text: 'LOCATIONS.LOCATION_RELATION.IS_NATURAL_CEMETERY',
        },
        IS_NATURAL_CONGREGATION_POINT: {
            value: 'isNaturalCongregationPoint',
            text: 'LOCATIONS.LOCATION_RELATION.IS_NATURAL_CONGREGATION_POINT',
        },
        IS_NATURAL_CEREMONY_LOCATION: {
            value: 'isNaturalCeremonyLocation',
            text: 'LOCATIONS.LOCATION_RELATION.IS_NATURAL_CEREMONY_LOCATION',
        },
        IS_NATURAL_VIEWING_LOCATION: {
            value: 'isNaturalViewingPoint',
            text: 'LOCATIONS.LOCATION_RELATION.IS_NATURAL_VIEWING_LOCATION',
        },
    };

    angular
        .module('app.referenceTypes')
        .constant('locationRelation', locationRelation);

    var attachedProductDiscriminator = [
        {
            value: 'PlaceOfDeath',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.PLACE_OF_DEATH',
        },
        {
            value: 'Transport',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.TRANSPORT',
        },
        {
            value: 'Grooming',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.GROOMING',
        },
        {
            value: 'Grave',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.GRAVE',
        },
        {
            value: 'ViewingLocation',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.VIEWING_LOCATION',
        },
        {
            value: 'Ceremony',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.CEREMONY',
        },
        {
            value: 'ServiceSheet',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.SERVICE_SHEET',
        },
        {
            value: 'MunicipalityOfResidence',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.MUNICIPALITY_OF_RESIDENCE',
        },
        {
            value: 'MunicipalityOfDeath',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.MUNICIPALITY_OF_DEATH',
        },
        {
            value: 'MunicipalityOfBirth',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.MUNICIPALITY_OF_BIRTH',
        },
        {
            value: 'FlowerOrder',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.FLOWER_ORDER',
        },
        {
            value: 'ObituaryNotice',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.OBITUARY_NOTICE',
        },
        {
            value: 'Shipment',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.SHIPMENT',
        },
        {
            value: 'HeadstoneOrder',
            text: 'AUTO_PRODUCTS.ATTACHED_TYPE_DISCRIMINATOR.HEADSTONE_ORDER',
        },
    ];

    angular
        .module('app.referenceTypes')
        .constant('attachedProductDiscriminator', attachedProductDiscriminator);
})();

(function () {
    'use strict';

    var programDataTypeOptions = [
        { value: 'string', text: 'PROGRAMS.DATA_TYPE.STRING' },
        { value: 'lookupString', text: 'PROGRAMS.DATA_TYPE.LOOKUP_STRING' },
        { value: 'long', text: 'PROGRAMS.DATA_TYPE.LONG' },
        { value: 'decimal', text: 'PROGRAMS.DATA_TYPE.DECIMAL' },
        { value: 'dateTime', text: 'PROGRAMS.DATA_TYPE.DATE_TIME' },
        { value: 'boolean', text: 'PROGRAMS.DATA_TYPE.BOOLEAN' },
        { value: 'song', text: 'PROGRAMS.DATA_TYPE.SONG' },
        { value: 'solo', text: 'PROGRAMS.DATA_TYPE.SOLO' },
        { value: 'music', text: 'PROGRAMS.DATA_TYPE.MUSIC' },
        { value: 'prayer', text: 'PROGRAMS.DATA_TYPE.PRAYER' },
    ];

    var programOptions = {
        NONE: { value: 'none', text: 'PROGRAMS.PROGRAM_OPTIONS.NONE' },
        SHOULD_USE_ALTERNATIVE_TITLES: {
            value: 'shouldUseAlternativeTitles',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_USE_ALTERNATIVE_TITLES',
        },
        SHOULD_USE_ENGLISH_TITLES: {
            value: 'shouldUseEnglishTitles',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_USE_ENGLISH_TITLES',
        },
        SHOULD_INCLUDE_PERSON_TITLES: {
            value: 'shouldIncludePersonTitles',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_INCLUDE_PERSON_TITLES',
        },
        SHOULD_INCLUDE_COMPOSERS: {
            value: 'shouldIncludeComposers',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_INCLUDE_COMPOSERS',
        },
        SHOULD_INCLUDE_DATES: {
            value: 'shouldIncludeDates',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_INCLUDE_DATES',
        },
        SHOULD_CAPITALIZE_LOCATION_NAME: {
            value: 'shouldCapitalizeLocationName',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_CAPITALIZE_LOCATION_NAME',
        },
        SHOULD_USE_ALTERNATE_NAME: {
            value: 'shouldUseAlternateName',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_USE_ALTERNATE_NAME',
        },
        HAS_CUSTOM_PICTURE: {
            value: 'hasCustomPicture',
            text: 'PROGRAMS.PROGRAM_OPTIONS.HAS_CUSTOM_PICTURE',
        },
        SHOULD_CAPITALIZE_FIRST_LETTER_IN_CEREMONY_TIME: {
            value: 'shouldCapitalizeFirstLetterInCeremonyTime',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_CAPITALIZE_FIRST_LETTER_IN_CEREMONY_TIME',
        },
        SHOULD_ADD_COMMA_AFTER_CEREMONY_PLACE: {
            value: 'shouldAddCommaAfterCeremonyPlace',
            text: 'PROGRAMS.PROGRAM_OPTIONS.SHOULD_ADD_COMMA_AFTER_CEREMONY_PLACE',
        },
    };

    angular
        .module('app.program')
        .constant('programDataTypeOptions', programDataTypeOptions);

    angular.module('app.program').constant('programOptions', programOptions);
})();

(function() {
    'use strict';

    angular
        .module('app.program')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/program');

         
    }
})();
(function() {
  "use strict";

  angular.module("app.product").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/product");

    $stateProvider
      .state("app.products", {
        url: "/products-and-services",
        views: {
          "content@app": {
            templateUrl: "app/main/product/products/products.tmpl.html",
            controller: "ProductsController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.products.view", {
        url: "/:productTypeId",
        templateUrl: "app/main/product/products/products-view/products-view.tmpl.html",
        controller: "ProductsViewController",
        controllerAs: "vm",
        resolve: {
          /* @ngInject */
          products: function(dataService, $stateParams) {
            return dataService.getByTypeId("Products", $stateParams.productTypeId);
          },
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      });

    msNavigationServiceProvider.saveItem("products", {
      title: "Products and Servicess",
      icon: "icon-cube-outline",
      state: "app.products",
      translate: "MENU.PRODUCTS",
      weight: 4,
      scopes: ["manage:products"]
    });
  }
})();

(function () {
    'use strict';

    var privacyActions = [
        "PRIVACY.PRIVACY_ACTION.CREATE",
        "PRIVACY.PRIVACY_ACTION.READ",
        "PRIVACY.PRIVACY_ACTION.RESTRICTED_READ",
        "PRIVACY.PRIVACY_ACTION.UPDATE",
        "PRIVACY.PRIVACY_ACTION.DELETE",
        "PRIVACY.PRIVACY_ACTION.PSEUDOMIZE",
        "PRIVACY.PRIVACY_ACTION.SEARCH",
        "PRIVACY.PRIVACY_ACTION.LOG_ACCESS",
        "PRIVACY.PRIVACY_ACTION.DOWNLOAD",
        "PRIVACY.PRIVACY_ACTION.CONSENT_BY_EMAIL",
        "PRIVACY.PRIVACY_ACTION.CONSENT_BY_SIGNATURE",
        "PRIVACY.PRIVACY_ACTION.POSSIBLE_PRIVACY_INTERACTION",
        "PRIVACY.PRIVACY_ACTION.CONSENT_RETRACTED"
    ];

    angular
        .module('app.privacy')
        .constant('privacyActions', privacyActions);
})();
(function() {
  "use strict";

  angular.module("app.privacy").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/privacy");

    $stateProvider
      .state("app.privacy", {
        abstract: true,
        url: "/privacy",
        views: {
          "content@app": {
            template: "<div ui-view></div>"
          }
        }
      })
      .state("app.privacy.search", {
        url: "/search",
        views: {
          "content@app": {
            templateUrl: "app/main/privacy/search/privacy-search.tmpl.html",
            controller: "PrivacySearchController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          },
          /* @ngInject */
          partyTypes: function(dataService) {
            return dataService.getAll("PartyTypes");
          }
        }
      })
      .state("app.privacy.privacyDetails", {
        url: "/privacyDetails/:partyId",
        views: {
          "content@app": {
            templateUrl: "app/main/privacy/privacy-details/privacy-details.tmpl.html",
            controller: "PrivacyDetailsController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.privacy.privacyFields", {
        url: "/privacy-fields",
        views: {
          "content@app": {
            templateUrl: "app/main/privacy/privacy-fields/privacy-fields.tmpl.html",
            controller: "PrivacyFieldsController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          },
          /* @ngInject */
          workOrderTypes: function(dataService) {
            return dataService.getAll("WorkOrderTypes");
          }
        }
      })
      .state("app.privacy.privacyFields.byWorkOrderType", {
        url: "/:workOrderTypeId",
        views: {
          "content@app.privacy.privacyFields": {
            templateUrl: "app/main/privacy/privacy-fields/privacy-field-list/privacy-field-list.tmpl.html",
            controller: "PrivacyFieldListController",
            controllerAs: "vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          },
          /* @ngInject */
          privacyFields: function(dataService, $stateParams) {
            if ($stateParams.workOrderTypeId && $stateParams.workOrderTypeId !== "all") {
              return dataService.getByTypeId("PrivacyFields", $stateParams.workOrderTypeId);
            }
            return dataService.getAll("PrivacyFields");
          }
        },
        params: {
          workOrderType: null
        }
      })
      .state("app.privacy.privacyFields.editPrivacyField", {
        url: "/edit-privacy-field/:privacyFieldId",
        views: {
          "content@app.privacy.privacyFields": {
            templateUrl: "app/main/privacy/privacy-fields/edit-privacy-field/edit-privacy-field.tmpl.html",
            controller: "EditPrivacyFieldController",
            controllerAs: "vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      });

    msNavigationServiceProvider.saveItem("privacy", {
      title: "Privacy",
      icon: "icon-shield",
      translate: "MENU.PRIVACY.PRIVACY",
      weight: 5,
      scopes: ["read:privacyData"]
    });

    msNavigationServiceProvider.saveItem("privacy.search", {
      title: "Search Persons",
      icon: "icon-magnify",
      state: "app.privacy.search",
      translate: "MENU.PRIVACY.SEARCH",
      weight: 1
    });

    msNavigationServiceProvider.saveItem("privacy.privacyFields", {
      title: "Privacy Fields",
      icon: "icon-server-security",
      state: "app.privacy.privacyFields.byWorkOrderType",
      translate: "PRIVACY.PRIVACY_FIELD.PRIVACY_FIELDS",
      weight: 2,
      scopes: ["manage:advancedSettings"]
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('app.obituaryNotice')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/obituary-notice');

         
    }
})();
(function () {
    'use strict';

    var noteOrTaskOptions = {
        NONE: { value: 'none', text: '' },
        IS_TASK: { value: 'isTask', text: 'IS-TASK' },
        IS_AUTO_GENERATED: { value: 'isAutoGenerated', text: 'IS-AUTO-GENERATED' },
        IS_FOLLOW_UP: { value: 'isFollowUp', text: 'IS-FOLLOW-UP' },
        IS_INDIVIDUAL_COMPLETE_TASK: { value: 'isIndividualCompleteTask', text: 'IS-INDIVIDUAL-COMPLETE-TASK' },
        IS_PRIVATE: { value: 'isPrivate', text: 'IS-PRIVATE' },
        HAS_OUTCOMES: { value: 'hasOutcomes', text: 'HAS-OUTCOMES' },
        IS_STATUS: { value: 'isStatus', text: 'IS_STATUS-OUTCOMES' },
    };

    var noteOrTaskTabs = [
        { value: 'ObituaryNotice', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.OBITUARY_NOTICE' },
        { value: 'Deceased', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.DECEASED' },
        { value: 'WorkOrderPerson', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.WORK_ORDER_PERSON' },
        //{ value: 'Order', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.ORDER' },
        { value: 'Grave', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.GRAVE' },
        { value: 'Transport', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.TRANSPORT' },
        { value: 'Ceremony', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.CEREMONY' },
        { value: 'ServiceSheet', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.SERVICE_SHEET' },
        { value: 'Event', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.EVENT' },
        { value: 'FlowerOrder', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.FLOWER_ORDER' },
        { value: 'Shipment', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.SHIPMENT' },
        { value: 'HeadstoneOrder', text: 'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.HEADSTONE_ORDER' },
    ];
    angular.module('app.noteOrTask').constant('noteOrTaskOptions', noteOrTaskOptions);

    angular.module('app.noteOrTask').constant('noteOrTaskTabs', noteOrTaskTabs);
})();

(function() {
    'use strict';

    angular
        .module('app.noteOrTask')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/note-or-task');

        
    }
})();
(function() {
  "use strict";

  angular.module("app.home").controller("HomeController", HomeController);

  /* @ngInject */
  function HomeController($state, currentUser, homeService, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.data = homeService;
    vm.currentUser = currentUser;

    activate();

    function activate() {
      var fromDate = moment()
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
      var toDate = moment(fromDate)
        .add(14, "days")
        .format("YYYY-MM-DDTHH:mm:ss");
      homeService.loadData(fromDate, toDate, currentUser);
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.home')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/home');

        $stateProvider
            .state('app.home', {
                url: '/home',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/home/home.tmpl.html',
                        controller: 'HomeController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('home', {
            title: 'Home',
            icon: 'icon-home',
            translate: 'MENU.HOME.HOME',
            state: 'app.home',
            weight: 1
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.grooming')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/grooming');

        
    }
})();
(function() {
    'use strict';

    angular
        .module('app.grave')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/grave');

         
    }
})();
(function() {
    'use strict';

    angular
        .module('app.flowerOrder')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/flower-order');


    }
})();
(function () {
    'use strict';

    var shipmentOptions = {
        NONE: { value: 0, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.NONE" },
        IS_EMBALMED: { value: 1, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.IS_EMBALMED" },
        ADDRESS_PATCH: { value: 2, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.ADDRESS_PATCH" },
        HUM_PATCH: { value: 4, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.HUM_PATCH" },
        SLIPS_ATTACHED_TO_WAY_BILL: { value: 8, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.SLIPS_ATTACHED_TO_WAY_BILL" },
        SLIPS_ATTACHED_TO_CASKET: { value: 16, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.SLIPS_ATTACHED_TO_CASKET" },
        FLIGHT_COVER: { value: 32, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.FLIGHT_COVER" },
        ZINC_CASKET: { value: 64, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.ZINC_CASKET" },
        FLIGHT_BOARD: { value: 128, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.FLIGHT_BOARD" },
        APPROVED_INTERNAL_BODYBAG: { value: 256, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.APPROVED_INTERNAL_BODYBAG" },
        APPROVED_EXTERNAL_BODYBAG: { value: 512, text: "EXTERNAL_ORDERS.SHIPMENT_OPTIONS.APPROVED_EXTERNAL_BODYBAG" }
    };

    angular
        .module('app.externalOrder')
        .constant('shipmentOptions', shipmentOptions);
})();
(function() {
    'use strict';

    angular
        .module('app.externalOrder')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/external-order');

         
    }
})();
(function() {
  "use strict";

  angular.module("app.export").controller("ExportController", ExportController);

  /* @ngInject */
  function ExportController($mdSidenav, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.toggleSidenav = toggleSidenav;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.export").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/export");

    $stateProvider
      .state("app.export", {
        abstract: true,
        url: "/export",
        views: {
          "content@app": {
            templateUrl: "app/main/export/export.tmpl.html",
            controller: "ExportController as vm"
          }
        },
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      })
      .state("app.export.referencePersons", {
        url: "/reference-persons",
        templateUrl: "app/main/export/reference-persons/export-reference-persons.tmpl.html",
        controller: "ExportReferencePersonsController as vm",
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        }
      });

    msNavigationServiceProvider.saveItem("export", {
      title: "Export",
      icon: "icon-export",
      translate: "MENU.EXPORT.EXPORT",
      weight: 8,
      anyScopes: ["read:privacyData"]
    });

    msNavigationServiceProvider.saveItem("export.referencePerson", {
      title: "Reference Persons",
      icon: "icon-account-multiple",
      state: "app.export.referencePersons",
      translate: "MENU.EXPORT.REFERENCE_PERSONS",
      weight: 10,
      scopes: ["read:privacyData"]
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('app.department')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/department');

        
    }
})();
(function () {
    'use strict';

    var deceasedLeavesBehindOptions = {
        NONE: {
            value: 'none',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.NONE',
        },
        TESTAMENT: {
            value: 'testament',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.TESTAMENT',
        },
        MARRIAGE_AGREEMENT: {
            value: 'marriageAgreement',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.MARRIAGE_AGREEMENT',
        },
        BANK_DEPOSIT: {
            value: 'bankDeposit',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.BANK_DEPOSIT',
        },
        COMMON_ASSETS_PROBATED: {
            value: 'commonAssetsProbated',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.COMMON_ASSETS_PROBATED',
        },
        HEIRS_UNDER_18_YEARS_OLD: {
            value: 'heirsUnder18YearsOld',
            text: 'DECEASED.DECEASED_LEAVES_BEHIND_SELECT.HEIRS_UNDER_18_YEARS_OLD',
        },
    };

    var probateOptions = {
        NONE: { value: 'none', text: 'DECEASED.PROBATE_SELECT.NONE' },
        NO_PROBATE: {
            value: 'noProbate',
            text: 'DECEASED.PROBATE_SELECT.NO_PROBATE',
        },
        UN_PROBATE: {
            value: 'unProbate',
            text: 'DECEASED.PROBATE_SELECT.UN_PROBATE',
        },
        PRIVATE_PROBATE: {
            value: 'privateProbate',
            text: 'DECEASED.PROBATE_SELECT.PRIVATE_PROBATE',
        },
        PUBLIC_PROBATE: {
            value: 'publicProbate',
            text: 'DECEASED.PROBATE_SELECT.PUBLIC_PROBATE',
        },
        PROBATE_BY_LAWYER: {
            value: 'probateByLawyer',
            text: 'DECEASED.PROBATE_SELECT.PROBATE_BY_LAWYER',
        },
        DECEASED_HAD_UN_PROBATE: {
            value: 'deceasedHadUnProbate',
            text: 'DECEASED.PROBATE_SELECT.DECEASED_HAD_UN_PROBATE',
        },
        DECEASED_HAD_PARTIALLY_PROBATE: {
            value: 'deceasedHadPartiallyProbate',
            text: 'DECEASED.PROBATE_SELECT.DECEASED_HAD_PARTIALLY_PROBATE',
        },
        DECEASED_HAD_PROBATE: {
            value: 'deceasedHadProbate',
            text: 'DECEASED.PROBATE_SELECT.DECEASED_HAD_PROBATE',
        },
        SIMPLE_PROBATE: {
            value: 'simpleProbate',
            text: 'DECEASED.PROBATE_SELECT.SIMPLE_PROBATE',
        },
    };

    var grantApplicationOptions = {
        NONE: {
            value: 'none',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.NONE',
        },
        FUNERAL_GRANT: {
            value: 'funeralGrant',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.FUNERAL_GRANT',
        },
        TRANSPORT_GRANT: {
            value: 'transportGrant',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.TRANSPORT_GRANT',
        },
        TRANSPORT_COST_BEYOND_LIMIT: {
            value: 'transportCostBeyondLimit',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.TRANSPORT_COST_BEYOND_LIMIT',
        },
        LONG_DISTANCE_FROM_FUNERAL_HOME: {
            value: 'longDistanceFromFuneralHome',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.LONG_DISTANCE_FROM_FUNERAL_HOME',
        },
        LONG_WAITING_TIME_FOR_FERRY: {
            value: 'longWaitingTimeForFerry',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.LONG_WAITING_TIME_FOR_FERRY',
        },
        FERRY_RENTED: {
            value: 'ferryRented',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.FERRY_RENTED',
        },
        MEMBER_OF_PUBLIC_INSURANCE: {
            value: 'memberOfPublicInsurance',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.MEMBER_OF_PUBLIC_INSURANCE',
        },
        DIED_DURING_TEMPORARY_STAY_NORDIC_COUNTRY: {
            value: 'diedDuringTemporaryStayNordicCountry',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.DIED_DURING_TEMPORARY_STAY_NORDIC_COUNTRY',
        },
        DIED_OF_WORK_INJURY: {
            value: 'diedOfWorkInjury',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.DIED_OF_WORK_INJURY',
        },
        INSURANCE_PAYOUT: {
            value: 'insurancePayout',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.INSURANCE_PAYOUT',
        },
        PENSION_PAYOUT: {
            value: 'pensionPayout',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.PENSION_PAYOUT',
        },
        OTHER_PAYOUT: {
            value: 'otherPayout',
            text: 'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.OTHER_PAYOUT',
        },
    };

    var deceasedImplants = {
        NONE: { value: 'none', text: 'DECEASED.DECEASED_IMPLANTS.NONE' },
        HEART_STIMULATOR: {
            value: 'heartStimulator',
            text: 'DECEASED.DECEASED_IMPLANTS.HEART_STIMULATOR',
        },
        HEART_STIMULATOR_IS_CHECKED: {
            value: 'heartStimulatorIsChecked',
            text: 'DECEASED.DECEASED_IMPLANTS.HEART_STIMULATOR_IS_CHECKED',
        },
    };

    angular
        .module('app.deceased')
        .constant('deceasedLeavesBehindOptions', deceasedLeavesBehindOptions);

    angular.module('app.deceased').constant('probateOptions', probateOptions);

    angular
        .module('app.deceased')
        .constant('grantApplicationOptions', grantApplicationOptions);

    angular
        .module('app.deceased')
        .constant('deceasedImplants', deceasedImplants);
})();

(function() {
    'use strict';

    angular
        .module('app.deceased')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/deceased');
        
        $stateProvider
            .state('app.deceased', {
                abstract: true,
                url: '/deceased',
                views: {
                    'content@app': {
                        template: '<div ui-view></div>'
                    }
                }
            })
            .state('app.deceased.byId', {
                url: '/:deceasedId', //Guid
                templateUrl: 'app/main/deceased/edit-deceased/edit-deceased.tmpl.html',
                controller: 'EditDeceasedController',
                controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    currentUser: function (dataService) {
                        return dataService.getCurrentUser();
                    },
                    /* @ngInject */
                    deceased: function (dataService, $stateParams) {
                        return dataService.getById("Deceased", $stateParams.deceasedId);
                    }
                }
            });
         
    }
})();
(function () {
    'use strict';

    var customFieldTypeOptions = {
        STRING: {
            value: 'string',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.STRING',
            targetProperty: 'stringData',
            targetModel: '',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-string.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-string.tmpl.html',
        },
        LOOKUP_STRING: {
            value: 'lookupString',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.LOOKUP_STRING',
            targetProperty: 'lookUpStringId',
            targetModel: 'lookupString',
            sourceProperty: 'id',
            dataSource: 'LookupStrings',
            delimiterProperty: 'lookUpStringTypeId',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-lookup-string.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-lookup-string.tmpl.html',
        },
        LOOKUP_STRING_TYPE: {
            value: 'lookupStringType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.LOOKUP_STRING_TYPE',
            targetProperty: 'lookUpStringTypeId',
            targetModel: 'lookUpStringType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'LookupStringTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-lookup-string-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-lookup-string-type.tmpl.html',
        },
        LONG: {
            value: 'long',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.LONG',
            targetProperty: 'longData',
            targetModel: '',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-long.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-long.tmpl.html',
        },
        DECIMAL: {
            value: 'decimal',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.DECIMAL',
            targetProperty: 'decimalData',
            targetModel: '',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-decimal.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-decimal.tmpl.html',
        },
        DATE_TIME: {
            value: 'dateTime',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.DATE_TIME',
            targetProperty: 'dateTimeData',
            targetModel: '',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-date-time.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-date-time.tmpl.html',
        },
        BOOLEAN: {
            value: 'boolean',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.BOOLEAN',
            targetProperty: 'boolData',
            targetModel: '',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-boolean.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-boolean.tmpl.html',
        },
        DECEASED: {
            value: 'deceased',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.DECEASED',
            targetProperty: 'deceasedId',
            targetModel: 'deceased',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'Deceased',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-deceased.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-deceased.tmpl.html',
        },
        PERSON: {
            value: 'person',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PERSON',
            targetProperty: 'partyId',
            targetModel: 'party',
            sourceProperty: 'id',
            delimiterProperty: 'partyTypeId',
            dataSource: 'Parties',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-person.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-person.tmpl.html',
        },
        ORGANIZATION: {
            value: 'organization',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.ORGANIZATION',
            targetProperty: 'partyId',
            targetModel: 'party',
            sourceProperty: 'id',
            delimiterProperty: 'partyTypeId',
            dataSource: 'Parties',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-organization.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-organization.tmpl.html',
        },
        PARTY: {
            value: 'party',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PARTY',
            targetProperty: 'partyId',
            targetModel: 'party',
            sourceProperty: 'id',
            delimiterProperty: 'partyTypeId',
            dataSource: 'Parties',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-party.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-party.tmpl.html',
        },
        PARTY_TYPE: {
            value: 'partyType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PARTY_TYPE',
            targetProperty: 'partyTypeId',
            targetModel: 'partyType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'PartyTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-party-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-party-type.tmpl.html',
        },
        SUPPLIER: {
            value: 'supplier',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.SUPPLIER',
            targetProperty: 'supplierId',
            targetModel: 'supplier',
            sourceProperty: 'id',
            delimiterProperty: 'supplierTypeId',
            dataSource: 'Suppliers',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-supplier.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-supplier.tmpl.html',
        },
        SUPPLIER_TYPE: {
            value: 'supplierType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.SUPPLIER_TYPE',
            targetProperty: 'supplierTypeId',
            targetModel: 'supplierType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'SupplierTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-supplier-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-supplier-type.tmpl.html',
        },
        PARTICIPANT: {
            value: 'participant',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PARTICIPANT',
            targetProperty: 'participantId',
            targetModel: 'participant',
            sourceProperty: 'id',
            delimiterProperty: 'participantTypeId',
            dataSource: 'Participants',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-participant.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-participant.tmpl.html',
        },
        PARTICIPANT_TYPE: {
            value: 'participantType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PARTICIPANT_TYPE',
            targetProperty: 'participantTypeId',
            targetModel: 'participantType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'ParticipantTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-participant-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-participant-type.tmpl.html',
        },
        LOCATION: {
            value: 'location',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.LOCATION',
            targetProperty: 'locationId',
            targetModel: 'location',
            sourceProperty: 'id',
            delimiterProperty: 'locationTypeId',
            dataSource: 'Locations',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-location.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-location.tmpl.html',
        },
        LOCATION_TYPE: {
            value: 'locationType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.LOCATION_TYPE',
            targetProperty: 'locationTypeId',
            targetModel: 'locationType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'LocationTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-location-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-location-type.tmpl.html',
        },
        EMAIL: {
            value: 'email',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.EMAIL',
            targetProperty: 'emailId',
            targetModel: 'email',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-email.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-email.tmpl.html',
        },
        TELEPHONE: {
            value: 'telephone',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.TELEPHONE',
            targetProperty: 'telephoneId',
            targetModel: 'telephone',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-telephone.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-telephone.tmpl.html',
        },
        ADDRESS: {
            value: 'address',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.ADDRESS',
            targetProperty: 'addressId',
            targetModel: 'address',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-address-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-address-type.tmpl.html',
        },
        PRODUCT: {
            value: 'product',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PRODUCT',
            targetProperty: 'productId',
            targetModel: 'product',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'Products',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-product.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-product.tmpl.html',
        },
        PRODUCT_TYPE: {
            value: 'productType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PRODUCT_TYPE',
            targetProperty: 'productTypeId',
            targetModel: 'productType',
            sourceProperty: 'id',
            delimiterProperty: 'productTypeId',
            dataSource: 'ProductTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-product-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-product-type.tmpl.html',
        },
        USER: {
            value: 'user',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.USER',
            targetProperty: 'baldrisUserId',
            targetModel: 'baldrisUser',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'BaldrisUsers',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-user.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-user.tmpl.html',
        },
        EQUIPMENT: {
            value: 'equipment',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.EQUIPMENT',
            targetProperty: 'equipmentId',
            targetModel: 'equipment',
            sourceProperty: 'id',
            delimiterProperty: 'equipmentTypeId',
            dataSource: 'Equipment',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-equipment.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-equipment.tmpl.html',
        },
        EQUIPMENT_TYPE: {
            value: 'equipmentType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.EQUIPMENT_TYPE',
            targetProperty: 'equipmentTypeId',
            targetModel: 'equipmentType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'EquipmentTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-equipment-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-equipment-type.tmpl.html',
        },
        GRAVE: {
            value: 'grave',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.GRAVE',
            targetProperty: 'graveId',
            targetModel: 'grave',
            sourceProperty: 'id',
            delimiterProperty: 'graveTypeId',
            dataSource: 'Graves',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-grave.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-grave.tmpl.html',
        },
        GRAVE_TYPE: {
            value: 'graveType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.GRAVE_TYPE',
            targetProperty: 'graveTypeId',
            targetModel: 'graveType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'GraveTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-grave-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-grave-type.tmpl.html',
        },
        COUNTRY: {
            value: 'country',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.COUNTRY',
            targetProperty: 'countryId',
            targetModel: 'country',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'Countries',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-country.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-country.tmpl.html',
        },
        STATE: {
            value: 'state',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.STATE',
            targetProperty: 'stateId',
            targetModel: 'state',
            sourceProperty: 'id',
            delimiterProperty: 'countryId',
            dataSource: 'States',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-state.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-state.tmpl.html',
        },
        MUNICIPALITY: {
            value: 'municipality',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.MUNICIPALITY',
            targetProperty: 'municipalityId',
            targetModel: 'municipality',
            sourceProperty: 'id',
            delimiterProperty: 'stateId',
            dataSource: 'Municipalities',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-municipality.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-municipality.tmpl.html',
        },
        FILE: {
            value: 'file',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.FILE',
            targetProperty: 'fileId',
            targetModel: 'file',
            sourceProperty: 'id',
            delimiterProperty: 'fileTypeId',
            dataSource: 'Files',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-file.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-file.tmpl.html',
        },
        FILE_TYPE: {
            value: 'fileType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.FILE_TYPE',
            targetProperty: 'fileTypeId',
            targetModel: 'fileType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'FileTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-file-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-file-type.tmpl.html',
        },
        EXTERNAL_ORDER: {
            value: 'externalOrder',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.EXTERNAL_ORDER',
            targetProperty: 'externalOrderId',
            targetModel: 'externalOrder',
            sourceProperty: 'id',
            delimiterProperty: 'externalOrderTypeId',
            dataSource: 'ExternalOrders',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-external-order.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-external-order.tmpl.html',
        },
        EXTERNAL_ORDER_TYPE: {
            value: 'externalOrderType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.EXTERNAL_ORDER_TYPE',
            targetProperty: 'externalOrderTypeId',
            targetModel: 'externalOrderType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'ExternalOrderTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-external-order-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-external-order-type.tmpl.html',
        },
        CALENDAR_EVENT: {
            value: 'calendarEvent',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.CALENDAR_EVENT',
            targetProperty: 'calendarEventId',
            targetModel: 'calendarEvent',
            sourceProperty: 'id',
            delimiterProperty: 'calendarEventTypeId',
            dataSource: 'CalendarEvents',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-calendar-event.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-calendar-event.tmpl.html',
        },
        CALENDAR_EVENT_TYPE: {
            value: 'calendarEventType',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.CALENDAR_EVENT_TYPE',
            targetProperty: 'calendarEventTypeId',
            targetModel: 'calendarEventType',
            sourceProperty: 'id',
            delimiterProperty: '',
            dataSource: 'CalendarEventTypes',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-calendar-event-type.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-calendar-event-type.tmpl.html',
        },
        CUSTOM: {
            value: 'custom',
            text: 'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.CUSTOM',
            targetProperty: 'stringData',
            sourceProperty: '',
            delimiterProperty: '',
            dataSource: '',
            editTemplate:
                'app/main/custom-field/components/edit-custom-field/templates/edit-custom.tmpl.html',
            renderTemplate:
                'app/main/custom-field/components/render-custom-field/templates/render-custom.tmpl.html',
        },
    };

    angular
        .module('app.customField')
        .constant('customFieldTypeOptions', customFieldTypeOptions);
})();

(function() {
    'use strict';

    angular
        .module('app.customField')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/custom-field');

         
    }
})();
(function () {
    'use strict';

    var maritalStatusOptions = {
        NONE: { value: 'none', text: 'COMMON.MARITAL_STATUS_SELECT.NONE' },
        UNMARRIED: {
            value: 'unmarried',
            text: 'COMMON.MARITAL_STATUS_SELECT.UNMARRIED',
        },
        MARRIED: {
            value: 'married',
            text: 'COMMON.MARITAL_STATUS_SELECT.MARRIED',
        },
        WIDOW: { value: 'widow', text: 'COMMON.MARITAL_STATUS_SELECT.WIDOW' },
        SEPERATED: {
            value: 'seperated',
            text: 'COMMON.MARITAL_STATUS_SELECT.SEPERATED',
        },
        DIVORCED: {
            value: 'divorced',
            text: 'COMMON.MARITAL_STATUS_SELECT.DIVORCED',
        },
        LIVE_IN: {
            value: 'liveIn',
            text: 'COMMON.MARITAL_STATUS_SELECT.LIVE_IN',
        },
        WITH_CHILDREN: {
            value: 'withChildren',
            text: 'COMMON.MARITAL_STATUS_SELECT.WITH_CHILDREN',
        },
        REGISTERED_PARTNER: {
            value: 'registeredPartner',
            text: 'COMMON.MARITAL_STATUS_SELECT.REGISTERED_PARTNER',
        },
        OTHER: { value: 'other', text: 'COMMON.MARITAL_STATUS_SELECT.OTHER' },
        UNKNOWN: {
            value: 'unknown',
            text: 'COMMON.MARITAL_STATUS_SELECT.UNKNOWN',
        },
    };

    var sexSelectOptions = [
        { value: 'm', text: 'COMMON.SEX_SELECT.MALE' },
        { value: 'f', text: 'COMMON.SEX_SELECT.FEMALE' },
        { value: 'o', text: 'COMMON.SEX_SELECT.OTHER' },
        { value: 'u', text: 'COMMON.SEX_SELECT.UNKNOWN' },
    ];

    var openCasketOptions = [
        { value: 'unknown', text: 'COMMON.OPEN_CASKET_OPTIONS.UNKNOWN' },
        { value: 'openCasket', text: 'COMMON.OPEN_CASKET_OPTIONS.OPEN_CASKET' },
        {
            value: 'closedCasket',
            text: 'COMMON.OPEN_CASKET_OPTIONS.CLOSED_CASKET',
        },
        {
            value: 'consultWithFamily',
            text: 'COMMON.OPEN_CASKET_OPTIONS.CONSULT_WITH_FAMILY',
        },
    ];

    var billToOptions = {
        UNKNOWN: { value: 'unknown', text: 'COMMON.BILL_TO_OPTIONS.UNKNOWN' },
        CUSTOMER: {
            value: 'customer',
            text: 'COMMON.BILL_TO_OPTIONS.CUSTOMER',
        },
        SOCIAL_SERVICES: {
            value: 'socialServices',
            text: 'COMMON.BILL_TO_OPTIONS.SOCIAL_SERVICES',
        },
        DO_NOT_BILL: {
            value: 'doNotBill',
            text: 'COMMON.BILL_TO_OPTIONS.DO_NOT_BILL',
        },
    };

    var meetupOptions = [
        { value: 0, text: 'COMMON.MEETUP_OPTIONS.NOT_SET' },
        { value: -18000000000, text: 'COMMON.MEETUP_OPTIONS.HALF_HOUR_BEFORE' },
        { value: -36000000000, text: 'COMMON.MEETUP_OPTIONS.HOUR_BEFORE' },
        {
            value: -54000000000,
            text: 'COMMON.MEETUP_OPTIONS.ONE_HALF_HOURS_BEFORE',
        },
        { value: -72000000000, text: 'COMMON.MEETUP_OPTIONS.TWO_HOURS_BEFORE' },
        {
            value: -90000000000,
            text: 'COMMON.MEETUP_OPTIONS.TWO_HALF_HOURS_BEFORE',
        },
        {
            value: -108000000000,
            text: 'COMMON.MEETUP_OPTIONS.THREE_HOURS_BEFORE',
        },
        {
            value: -126000000000,
            text: 'COMMON.MEETUP_OPTIONS.THREE_HALF_HOURS_BEFORE',
        },
        {
            value: -144000000000,
            text: 'COMMON.MEETUP_OPTIONS.FOUR_HOURS_BEFORE',
        },
    ];

    angular
        .module('app.common')
        .constant('maritalStatusOptions', maritalStatusOptions);

    angular.module('app.common').constant('sexSelectOptions', sexSelectOptions);

    angular
        .module('app.common')
        .constant('openCasketOptions', openCasketOptions);

    angular.module('app.common').constant('billToOptions', billToOptions);

    angular.module('app.common').constant('meetupOptions', meetupOptions);
})();

(function() {
    'use strict';

    angular
        .module('app.common')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, msApiProvider) {
        $translatePartialLoaderProvider.addPart('app/main/common');

        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }
})();
(function() {
  "use strict";

  angular.module("app.ceremony").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/ceremony");

    $stateProvider
      .state("app.ceremony", {
        abstract: true,
        url: "/ceremonies",
        views: {
          "content@app": {
            template: "<div ui-view></div>"
          }
        }
      })
      .state("app.ceremony.byId", {
        url: "/:id", //Guid
        templateUrl: "app/main/ceremony/edit-ceremony/edit-ceremony.tmpl.html",
        controller: "EditCeremonyController",
        controllerAs: "vm",
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          },
          /* @ngInject */
          ceremony: function(dataService, $stateParams) {
            return dataService.getById("CalendarEvents", $stateParams.id);
          }
        }
      });
  }
})();

(function() {
  "use strict";

  angular.module("app.calendar").controller("CalendarController", CalendarController);

  /* @ngInject */
  function CalendarController(calendarViewService, $mdSidenav, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.service = calendarViewService;

    vm.toggleSidenav = toggleSidenav;
    vm.isFabOpen = false;

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
  }
})();

(function () {
    'use strict';

    var calendarEventOptions = {
        NONE: { value: 'none', text: 'CALENDAR.OPTIONS.NONE' },
        HAS_PARTICIPANTS: {
            value: 'hasParticipants',
            text: 'CALENDAR.OPTIONS.HAS_PARTICIPANTS',
        },
        HAS_PROGRAM: {
            value: 'hasProgram',
            text: 'CALENDAR.OPTIONS.HAS_PROGRAM',
        },
        HAS_COMPLETED_STATUS: {
            value: 'hasCompletedStatus',
            text: 'CALENDAR.OPTIONS.HAS_COMPLETED_STATUS',
        },
        IS_BOOKING: { value: 'isBooking', text: 'CALENDAR.OPTIONS.IS_BOOKING' },
        IS_CEREMONY: {
            value: 'isCeremony',
            text: 'CALENDAR.OPTIONS.IS_CEREMONY',
        },
        IS_CEREMONIAL_FUNERAL: {
            value: 'isCeremonialFuneral',
            text: 'CALENDAR.OPTIONS.IS_CEREMONIAL_FUNERAL',
        },
        IS_GROOMING: {
            value: 'isGrooming',
            text: 'CALENDAR.OPTIONS.IS_GROOMING',
        },
        IS_TRANSPORT: {
            value: 'isTransport',
            text: 'CALENDAR.OPTIONS.IS_TRANSPORT',
        },
        SHOW_SUPPLIER: {
            value: 'showSupplier',
            text: 'CALENDAR.OPTIONS.SHOW_SUPPLIER',
        },
        SHOULD_INCLUDE_COMPOSERS: {
            value: 'shouldIncludeComposers',
            text: 'CALENDAR.OPTIONS.SHOULD_INCLUDE_COMPOSERS',
        },
        SHOULD_INCLUDE_DATES: {
            value: 'shouldIncludeDates',
            text: 'CALENDAR.OPTIONS.SHOULD_INCLUDE_DATES',
        },
        SHOULD_CAPITALIZE_LOCATION_NAME: {
            value: 'shouldCapitalizeLocationName',
            text: 'CALENDAR.OPTIONS.SHOULD_CAPITALIZE_LOCATION_NAME',
        },
        HAS_WORK_ORDER: {
            value: 'hasWorkOrder',
            text: 'CALENDAR.OPTIONS.HAS_WORK_ORDER',
        },
        IS_CREMATION: {
            value: 'isCremation',
            text: 'CALENDAR.OPTIONS.IS_CREMATION',
        },
        IS_URN_LOWERING: {
            value: 'isUrnLowering',
            text: 'CALENDAR.OPTIONS.IS_URN_LOWERING',
        },
        IS_VIEWING: { value: 'isViewing', text: 'CALENDAR.OPTIONS.IS_VIEWING' },
        IS_CONFERENCE: {
            value: 'isConference',
            text: 'CALENDAR.OPTIONS.IS_CONFERENCE',
        },
        IS_MEMORIAL_SERVICE: {
            value: 'isMemorialService',
            text: 'CALENDAR.OPTIONS.IS_MEMORIAL_SERVICE',
        },
        EXCLUDE_FROM_CALENDAR: {
            value: 'excludeFromCalendar',
            text: 'CALENDAR.OPTIONS.EXCLUDE_FROM_CALENDAR',
        },
        IS_PRIVATE: { value: 'isPrivate', text: 'CALENDAR.OPTIONS.IS_PRIVATE' },
        HIDE_FOR_CUSTOMER: {
            value: 'hideForCustomer',
            text: 'CALENDAR.OPTIONS.HIDE_FOR_CUSTOMER',
        },
    };

    angular
        .module('app.calendar')
        .constant('calendarEventOptions', calendarEventOptions);

    var monthNames = [
        {
            monthNumber: 1,
            momentNumber: 0,
            monthName: 'CALENDAR.MONTH_NAMES.JANUARY',
        },
        {
            monthNumber: 2,
            momentNumber: 1,
            monthName: 'CALENDAR.MONTH_NAMES.FEBRUARY',
        },
        {
            monthNumber: 3,
            momentNumber: 2,
            monthName: 'CALENDAR.MONTH_NAMES.MARCH',
        },
        {
            monthNumber: 4,
            momentNumber: 3,
            monthName: 'CALENDAR.MONTH_NAMES.APRIL',
        },
        {
            monthNumber: 5,
            momentNumber: 4,
            monthName: 'CALENDAR.MONTH_NAMES.MAY',
        },
        {
            monthNumber: 6,
            momentNumber: 5,
            monthName: 'CALENDAR.MONTH_NAMES.JUNE',
        },
        {
            monthNumber: 7,
            momentNumber: 6,
            monthName: 'CALENDAR.MONTH_NAMES.JULY',
        },
        {
            monthNumber: 8,
            momentNumber: 7,
            monthName: 'CALENDAR.MONTH_NAMES.AUGUST',
        },
        {
            monthNumber: 9,
            momentNumber: 8,
            monthName: 'CALENDAR.MONTH_NAMES.SEPTEMBER',
        },
        {
            monthNumber: 10,
            momentNumber: 9,
            monthName: 'CALENDAR.MONTH_NAMES.OCTOBER',
        },
        {
            monthNumber: 11,
            momentNumber: 10,
            monthName: 'CALENDAR.MONTH_NAMES.NOVEMBER',
        },
        {
            monthNumber: 12,
            momentNumber: 11,
            monthName: 'CALENDAR.MONTH_NAMES.DECEMBER',
        },
    ];
    angular
        .module('app.calendar')
        .constant('monthNamesTranslatable', monthNames);
})();

(function() {
  "use strict";

  angular.module("app.calendar").config(moduleConfig);

  /* @ngInject */
  function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
    $translatePartialLoaderProvider.addPart("app/main/calendar");

    $stateProvider
      .state("app.calendar", {
        abstract: true,
        url: "/calendar",
        views: {
          "content@app": {
            templateUrl: "app/main/calendar/calendar.tmpl.html",
            controller: "CalendarController",
            controllerAs: "vm"
          }
        }
      })
      .state("app.calendar.day-view", {
        url: "/day-view/:date", //date-format: YYYY-MM-DD
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        },
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/calendar/views/main-toolbar/calendar-main-toolbar.tmpl.html",
            controller: "CalendarMainToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/calendar/day-view/day-view.tmpl.html",
            controller: "DayViewController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/calendar/day-view/sidebar-right/day-view-sidebar-right.tmpl.html",
            controller: "DayViewSidebarRightController",
            controllerAs: "vm"
          }
        }
      })
      .state("app.calendar.day-view.calendarEventById", {
        url: "/edit-calendar-event/:calendarEventId",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/views/toolbar.tmpl.html",
            controller: "EditCalendarEventToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/edit-calendar-event.tmpl.html",
            controller: "EditCalendarEventController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html",
            controller: "EditCalendarEventSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          calendarEventTypeId: null,
          calendarEventType: null,
          deceased: [],
          selectedDate: null
        }
      })
      .state("app.calendar.day-view.bookingById", {
        url: "/edit-booking/:calendarEventId",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/views/toolbar.tmpl.html",
            controller: "EditCalendarEventToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/edit-calendar-event.tmpl.html",
            controller: "EditCalendarEventController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html",
            controller: "EditCalendarEventSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          calendarEventTypeId: null,
          calendarEventType: null,
          deceased: [],
          selectedDate: null,
          apiController: "Bookings"
        }
      })
      .state("app.calendar.day-view.ceremonyById", {
        url: "/edit-ceremony/:calendarEventId",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/ceremony/edit-ceremony/views/toolbar.tmpl.html",
            controller: "EditCalendarEventToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/ceremony/edit-ceremony/edit-ceremony.tmpl.html",
            controller: "EditCalendarEventController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/ceremony/edit-ceremony/views/sidebar.tmpl.html",
            controller: "EditCalendarEventSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          calendarEventTypeId: null,
          calendarEventType: null,
          deceased: [],
          selectedDate: null,
          apiController: "Ceremonies"
        }
      })
      .state("app.calendar.day-view.transportById", {
        url: "/edit-transport/:calendarEventId",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/transport/edit-transport/views/toolbar.tmpl.html",
            controller: "EditCalendarEventToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/transport/edit-transport/edit-transport.tmpl.html",
            controller: "EditCalendarEventController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/transport/edit-transport/views/sidebar.tmpl.html",
            controller: "EditCalendarEventSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          calendarEventTypeId: null,
          calendarEventType: null,
          deceased: [],
          selectedDate: null,
          apiController: "Transports"
        }
      })
      .state("app.calendar.day-view.groomingById", {
        url: "/edit-grooming/:calendarEventId",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/grooming/edit-grooming/views/toolbar.tmpl.html",
            controller: "EditCalendarEventToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/grooming/edit-grooming/edit-grooming.tmpl.html",
            controller: "EditCalendarEventController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/grooming/edit-grooming/views/sidebar.tmpl.html",
            controller: "EditCalendarEventSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          calendarEventTypeId: null,
          calendarEventType: null,
          deceased: [],
          selectedDate: null,
          apiController: "Groomings"
        }
      })
      .state("app.calendar.day-view.quickRegistration", {
        url: "/register-incoming",
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/work-order/quick-registration-deceased/views/toolbar.tmpl.html",
            controller: "QuickRegistrationDeceasedToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/work-order/quick-registration-deceased/quick-registration-deceased.tmpl.html",
            controller: "QuickRegistrationDeceasedController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/work-order/quick-registration-deceased/views/sidebar.tmpl.html",
            controller: "QuickRegistrationDeceasedSidebarController",
            controllerAs: "vm"
          }
        },
        params: {
          selectedDate: null
        }
      })
      .state("app.calendar.week-view", {
        url: "/week-view/:date", //date-format: YYYY-MM-DD
        resolve: {
          /* @ngInject */
          currentUser: function(dataService) {
            return dataService.getCurrentUser();
          }
        },
        views: {
          "toolbar@app.calendar": {
            templateUrl: "app/main/calendar/week-view/toolbar/week-view-toolbar.tmpl.html",
            controller: "WeekViewToolbarController",
            controllerAs: "vm"
          },
          "content@app.calendar": {
            templateUrl: "app/main/calendar/week-view/week-view.tmpl.html",
            controller: "WeekViewController",
            controllerAs: "vm"
          },
          "sidenav-right@app.calendar": {
            templateUrl: "app/main/calendar/week-view/sidebar-right/week-view-sidebar.tmpl.html",
            controller: "WeekViewSidebarController",
            controllerAs: "vm"
          }
        }
      });

    // Navigation
    msNavigationServiceProvider.saveItem("calendar", {
      title: "Home",
      icon: "icon-calendar",
      state: "app.calendar.day-view",
      stateParams: {
        date: moment().format("YYYY-MM-DD")
      },
      translate: "MENU.CALENDAR.CALENDAR",
      weight: 1,
      scopes: ["read:calendar"]
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('app.booking')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/booking');

    }
})();
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular.module('fuse', [
        // Core
        'app.core',

        // Navigation
        'app.navigation',

        // Toolbar
        'app.toolbar',

        // Quick panel
        'app.quick-panel',

        // 3rd party
        'ui.gravatar',
        'tmh.dynamicLocale',
        'angularMoment',
        'toastr',
        'angular-clipboard',
        'ui.mask',
        'ngFileUpload',
        'clickAndWait',
        'LocalStorageModule',
        'cwill747.phonenumber',
        'ng-currency',
        'auth0.auth0',
        'angular-jwt',
        'uiGmapgoogle-maps',
        'lfNgMdFileInput',
        'signature',
        'nvd3',
        'pdfjsViewer',

        // Baldris
        'blocks.exception',
        'blocks.logger',
        'app.home',
        'app.data',
        'app.calendar',
        'app.referenceTypes',
        'app.account',
        'app.common',
        'app.noteOrTask',
        'app.workOrder',
        'app.deceased',
        'app.statistics',
        'app.privacy',
        'app.workOrderReferencePerson',
        'app.ceremony',
        'app.transport',
        'app.grooming',
        'app.program',
        'app.externalOrder',
        'app.grave',
        'app.obituaryNotice',
        'app.customField',
        'app.department',
        'app.booking',
        'app.song',
        'app.salesOrder',
        'app.transactionalMail',
        'app.product',
        'app.report',
        'app.settings',
        'app.flowerOrder',
        'app.export',
        'app.signatureJobs',
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('AccountController', AccountController);

    /** @ngInject */
    function AccountController($scope, $rootScope, $state)
    {
        // Data

        //////////
        

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.account')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
        $translatePartialLoaderProvider.addPart('app/main/account');

        // State
        $stateProvider
            .state('app.account', {
                url: '/account',
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'AccountController as vm'
                    },
                    'content@app.account': {
                        templateUrl: 'app/main/account/account.tmpl.html'
                    }
                },
                bodyClass: 'login'
            })
            .state('app.account.login', {
                url: '/login', 
                templateUrl: 'app/main/account/login/login.tmpl.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('app.account.callback', {
                url: '/callback',
                templateUrl: 'app/main/account/callback/callback.tmpl.html',
                controller: 'CallbackController',
                controllerAs: 'vm'
            });
    }
})();
(function() {
  "use strict";

  angular.module("app.core").service("fuseTheming", fuseThemingService);

  /** @ngInject */
  function fuseThemingService($cookies, $log, $mdTheming, fuseThemes) {
    var service = {
      getRegisteredPalettes: getRegisteredPalettes,
      getRegisteredThemes: getRegisteredThemes,
      setActiveTheme: setActiveTheme,
      getThemeMetaData: getThemeMetaData,
      setThemesList: setThemesList,
      themes: {
        list: {},
        active: {
          name: "",
          theme: {}
        }
      }
    };

    return service;

    //////////

    /**
     * Get theme metadata
     *
     */
    function getThemeMetaData(themeName) {
      if (!themeName) {
        return fuseThemes[service.themes.active.name].metaData;
      }
      return fuseThemes[themeName].metaData;
    }

    /**
     * Get registered palettes
     *
     * @returns {*}
     */
    function getRegisteredPalettes() {
      return $mdTheming.PALETTES;
    }

    /**
     * Get registered themes
     *
     * @returns {*}
     */
    function getRegisteredThemes() {
      return $mdTheming.THEMES;
    }

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      // If theme does not exist, fallback to the default theme
      if (angular.isUndefined(service.themes.list[themeName])) {
        // If there is no theme called "default"...
        if (angular.isUndefined(service.themes.list.default)) {
          $log.error('You must have at least one theme named "default"');
          return;
        }

        $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

        // Otherwise set theme to default theme
        service.themes.active.name = "default";
        service.themes.active.theme = service.themes.list.default;
        $cookies.put("selectedTheme", service.themes.active.name);

        return;
      }

      service.themes.active.name = themeName;
      service.themes.active.theme = service.themes.list[themeName];
      $cookies.put("selectedTheme", themeName);
    }

    /**
     * Set available themes list
     *
     * @param themeList
     */
    function setThemesList(themeList) {
      service.themes.list = themeList;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function() {
  "use strict";

  var fuseThemes = {
    fuse: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Blå skumring",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-accent-bg md-hue-2"
      },
      primary: {
        name: "fuse-paleblue",
        hues: {
          default: "700",
          "hue-1": "500",
          "hue-2": "600",
          "hue-3": "A100"
        }
      },
      accent: {
        name: "light-blue",
        hues: {
          default: "600",
          "hue-1": "400",
          "hue-2": "700",
          "hue-3": "A100"
        }
      },
      warn: {
        name: "red"
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    pinkTheme: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Rosa skumring",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-accent-bg md-hue-2"
      },
      primary: {
        name: "blue-grey",
        hues: {
          default: "800",
          "hue-1": "600",
          "hue-2": "400",
          "hue-3": "A100"
        }
      },
      accent: {
        name: "pink",
        hues: {
          default: "400",
          "hue-1": "300",
          "hue-2": "600",
          "hue-3": "A100"
        }
      },
      warn: {
        name: "blue"
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    tealTheme: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Havdyp",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-accent-bg md-hue-2"
      },
      primary: {
        name: "fuse-blue",
        hues: {
          default: "900",
          "hue-1": "600",
          "hue-2": "500",
          "hue-3": "A100"
        }
      },
      accent: {
        name: "teal",
        hues: {
          default: "500",
          "hue-1": "400",
          "hue-2": "600",
          "hue-3": "A100"
        }
      },
      warn: {
        name: "deep-orange"
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    default: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Standard",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-primary-bg md-hue-2"
      },
      primary: {
        name: "oceanBlues",
        hues: {
          default: "700",
          "hue-1": "50",
          "hue-2": "600",
          "hue-3": "100"
        }
      },
      accent: {
        name: "canaryYellow",
        hues: {
          default: "600",
          "hue-1": "100",
          "hue-2": "200",
          "hue-3": "A200"
        }
      },
      warn: {
        name: "red",
        hues: {
          default: "500",
          "hue-1": "300",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    lightMode: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Lys",
        mainMenuClass: "md-grey-200-bg",
        secondaryMenuClass: "md-grey-50-bg",
        headerClass: "md-accent-bg"
      },
      primary: {
        name: "grey",
        hues: {
          default: "300",
          "hue-1": "400",
          "hue-2": "200",
          "hue-3": "100"
        }
      },
      accent: {
        name: "oceanBlues",
        hues: {
          default: "600",
          "hue-1": "50",
          "hue-2": "200",
          "hue-3": "100"
        }
      },
      warn: {
        name: "red",
        hues: {
          default: "500",
          "hue-1": "300",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    darkMode: {
      metaData: {
        canBeSelected: true,
        friendlyName: "Mørk",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-accent-bg"
      },
      primary: {
        name: "baldris-darkGrey",
        hues: {
          default: "800",
          "hue-1": "700",
          "hue-2": "500",
          "hue-3": "100"
        }
      },
      accent: {
        name: "carnation",
        hues: {
          default: "500",
          "hue-1": "400",
          "hue-2": "700",
          "hue-3": "A200"
        }
      },
      warn: {
        name: "red",
        hues: {
          default: "500",
          "hue-1": "300",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    },
    trafficLight: {
      metaData: {
        canBeSelected: false,
        friendlyName: "Traffic Delight",
        mainMenuClass: "md-primary-bg",
        secondaryMenuClass: "md-primary-bg md-hue-1",
        headerClass: "md-accent-bg md-hue-2"
      },
      primary: {
        name: "green",
        hues: {
          default: "600",
          "hue-1": "200",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      accent: {
        name: "amber",
        hues: {
          default: "500",
          "hue-1": "200",
          "hue-2": "600",
          "hue-3": "A100"
        }
      },
      warn: {
        name: "red",
        hues: {
          default: "500",
          "hue-1": "300",
          "hue-2": "800",
          "hue-3": "A100"
        }
      },
      background: {
        name: "grey",
        hues: {
          default: "A100",
          "hue-1": "A100",
          "hue-2": "100",
          "hue-3": "300"
        }
      }
    }
  };

  angular.module("app.core").constant("fuseThemes", fuseThemes);
})();

(function() {
  "use strict";

  var fusePalettes = [
    {
      name: "fuse-blue",
      options: {
        "50": "#ebf1fa",
        "100": "#c2d4ef",
        "200": "#9ab8e5",
        "300": "#78a0dc",
        "400": "#5688d3",
        "500": "#3470ca",
        "600": "#2e62b1",
        "700": "#275498",
        "800": "#21467e",
        "900": "#1a3865",
        A100: "#c2d4ef",
        A200: "#9ab8e5",
        A400: "#5688d3",
        A700: "#275498",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 A100",
        contrastStrongLightColors: "300 400"
      }
    },
    {
      name: "fuse-paleblue",
      options: {
        "50": "#ececee",
        "100": "#c5c6cb",
        "200": "#9ea1a9",
        "300": "#7d818c",
        "400": "#5c616f",
        "500": "#3c4252",
        "600": "#353a48",
        "700": "#2d323e",
        "800": "#262933",
        "900": "#1e2129",
        A100: "#c5c6cb",
        A200: "#9ea1a9",
        A400: "#5c616f",
        A700: "#2d323e",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 A100",
        contrastStrongLightColors: "300 400"
      }
    },
    {
      name: "baldris-darkGrey",
      options: {
        "50": "#f2f7f7",
        "100": "#e1e9eb",
        "200": "#c9d2d4",
        "300": "#aab1b3",
        "400": "#919899",
        "500": "#797f80",
        "600": "#616566",
        "700": "#494c4d",
        "800": "#303333",
        "900": "#18191a",
        A100: "#ffffff",
        A200: "#dadcdc",
        A400: "#898e8f",
        A700: "#5b6061",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 300 A100 A200 A400"
      }
    },
    {
      name: "carnation",
      options: {
        "50": "#fbd4d6",
        "100": "#f9babe",
        "200": "#f7a1a6",
        "300": "#f5878d",
        "400": "#f37e86",
        "500": "#f1545d",
        "600": "#cd474f",
        "700": "#a83a40",
        "800": "#842e33",
        "900": "#602125",
        A100: "#ffffff",
        A200: "#fbd4d6",
        A400: "#f37078",
        A700: "#ec1b27",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 A100 A200 A400"
      }
    },
    {
      name: "baldris-lightGrey",
      options: {
        "50": "#fafbfc",
        "100": "#cdd7dc",
        "200": "#acbdc6",
        "300": "#829ba8",
        "400": "#708c9c",
        "500": "#617d8c",
        "600": "#546d7a",
        "700": "#485d68",
        "800": "#3b4d56",
        "900": "#2f3c44",
        A100: "#fafbfc",
        A200: "#cdd7dc",
        A400: "#708c9c",
        A700: "#485d68",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 300 400 A100 A200 A400"
      }
    },
    {
      name: "baldris-amber",
      options: {
        "50": "#ffffff",
        "100": "#feedd6",
        "200": "#fcd6a0",
        "300": "#fab85a",
        "400": "#f9ac3d",
        "500": "#f89f1f",
        "600": "#f19108",
        "700": "#d37f07",
        "800": "#b56d06",
        "900": "#985c05",
        A100: "#ffffff",
        A200: "#feedd6",
        A400: "#f9ac3d",
        A700: "#d37f07",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 300 400 500 600 700 A100 A200 A400 A700"
      }
    },
    {
      name: "baldris-yellow",
      options: {
        "50": "#ffffff",
        "100": "#fff2d0",
        "200": "#ffe398",
        "300": "#fed051",
        "400": "#fec832",
        "500": "#fec014",
        "600": "#f2b201",
        "700": "#d49c01",
        "800": "#b58601",
        "900": "#976f01",
        A100: "#ffffff",
        A200: "#fff2d0",
        A400: "#fec832",
        A700: "#d49c01",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 300 400 500 600 700 800 A100 A200 A400 A700"
      }
    },
    {
      name: "baldris-beige",
      options: {
        "50": "#ffffff",
        "100": "#ffffff",
        "200": "#ffffff",
        "300": "#fffaee",
        "400": "#fef2d0",
        "500": "#feeab2",
        "600": "#fee294",
        "700": "#fdda76",
        "800": "#fdd157",
        "900": "#fcc939",
        A100: "#ffffff",
        A200: "#ffffff",
        A400: "#fef2d0",
        A700: "#fdda76",
        contrastDefaultColor: "light",
        contrastDarkColors: "50 100 200 300 400 500 600 700 800 900 A100 A200 A400 A700"
      }
    },
    {
      name: "oceanBlues",

      options: {
        "50": "#EAF6F9",

        "100": "#C3E4E9",

        "200": "#96D2D9",

        "300": "#69C0C9",

        "400": "#51B2BD",

        "500": "#46A5B3",

        "600": "#3D97A2",

        "700": "#367074",

        "800": "#324F4D",

        "900": "#20302E",

        A100: "#ffffff",

        A200: "#C8E9E9",

        A400: "#80A1A1",

        A700: "#426363",

        contrastDefaultColor: "light",

        contrastDarkColors: "50 100 200 A100"
      }
    },

    {
      name: "canaryYellow",

      options: {
        "50": "#FEF8E2",

        "100": "#FCECB6",

        "200": "#FBE087",

        "300": "#F9D559",

        "400": "#F8CA39",

        "500": "#F7C126",

        "600": "#F7B423",

        "700": "#F6A21F",

        "800": "#F6921C",

        "900": "#F47517",

        A100: "#ffffff",

        A200: "#ffdc9b",

        A400: "#d49013",

        A700: "#825501",

        contrastDefaultColor: "light",

        contrastDarkColors: "50 100 200 300 A100 A200 A400"
      }
    }
  ];

  angular.module("app.core").constant("fusePalettes", fusePalettes);
})();

(function() {
  "use strict";

  angular.module("app.core").factory("fuseGenerator", fuseGeneratorService);

  /** @ngInject */
  function fuseGeneratorService($cookies, $log, fuseTheming) {
    // Storage for simplified themes object
    var themes = {};

    var service = {
      generate: generate,
      rgba: rgba
    };

    return service;

    //////////

    /**
     * Generate less variables for each theme from theme's
     * palette by using material color naming conventions
     */
    function generate() {
      // Get registered themes and palettes and copy
      // them so we don't modify the original objects
      var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
      var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

      // First, create a simplified object that stores
      // all registered themes and their colors

      // Iterate through registered themes
      angular.forEach(registeredThemes, function(registeredTheme) {
        themes[registeredTheme.name] = {};

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(registeredTheme.colors, function(colorType, colorTypeName) {
          themes[registeredTheme.name][colorTypeName] = {
            name: colorType.name,
            levels: {
              default: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
              },
              hue1: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues["hue-1"]].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues["hue-1"]].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues["hue-1"]].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues["hue-1"]].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues["hue-1"]].contrast, 4)
              },
              hue2: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues["hue-2"]].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues["hue-2"]].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues["hue-2"]].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues["hue-2"]].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues["hue-2"]].contrast, 4)
              },
              hue3: {
                color: rgba(registeredPalettes[colorType.name][colorType.hues["hue-3"]].value),
                contrast1: rgba(registeredPalettes[colorType.name][colorType.hues["hue-3"]].contrast, 1),
                contrast2: rgba(registeredPalettes[colorType.name][colorType.hues["hue-3"]].contrast, 2),
                contrast3: rgba(registeredPalettes[colorType.name][colorType.hues["hue-3"]].contrast, 3),
                contrast4: rgba(registeredPalettes[colorType.name][colorType.hues["hue-3"]].contrast, 4)
              }
            }
          };
        });
      });

      // Process themes one more time and then store them in the service for external use
      processAndStoreThemes(themes);

      // Iterate through simplified themes
      // object and create style variables
      var styleVars = {};

      // Iterate through registered themes
      angular.forEach(themes, function(theme, themeName) {
        styleVars = {};
        styleVars["@themeName"] = themeName;

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function(colorTypes, colorTypeName) {
          // Iterate through color levels (default, hue1, hue2 & hue3)
          angular.forEach(colorTypes.levels, function(colors, colorLevelName) {
            // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
            angular.forEach(colors, function(color, colorName) {
              styleVars["@" + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
            });
          });
        });

        // Render styles
        render(styleVars);
      });
    }

    // ---------------------------
    //  INTERNAL HELPER FUNCTIONS
    // ---------------------------

    /**
     * Process and store themes for global use
     *
     * @param _themes
     */
    function processAndStoreThemes(_themes) {
      // Here we will go through every registered theme one more time
      // and try to simplify their objects as much as possible for
      // easier access to their properties.
      var themes = angular.copy(_themes);

      // Iterate through themes
      angular.forEach(themes, function(theme) {
        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function(colorType, colorTypeName) {
          theme[colorTypeName] = colorType.levels;
          theme[colorTypeName].color = colorType.levels.default.color;
          theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
          theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
          theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
          theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
          delete theme[colorTypeName].default;
        });
      });

      // Store themes and set selected theme for the first time
      fuseTheming.setThemesList(themes);

      // Remember selected theme.
      var selectedTheme = $cookies.get("selectedTheme");

      if (selectedTheme) {
        fuseTheming.setActiveTheme(selectedTheme);
      } else {
        fuseTheming.setActiveTheme("default");
      }
    }

    /**
     * Render css files
     *
     * @param styleVars
     */
    function render(styleVars) {
      var cssTemplate =
        '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

      var regex = new RegExp(Object.keys(styleVars).join("|"), "gi");
      var css = cssTemplate.replace(regex, function(matched) {
        return styleVars[matched];
      });

      var headEl = angular.element("head");
      var styleEl = angular.element('<style type="text/css"></style>');
      styleEl.html(css);
      headEl.append(styleEl);
    }

    /**
     * Convert color array to rgb/rgba
     * Also apply contrasts if needed
     *
     * @param color
     * @param _contrastLevel
     * @returns {string}
     */
    function rgba(color, _contrastLevel) {
      var contrastLevel = _contrastLevel || false;

      // Convert 255,255,255,0.XX to 255,255,255
      // According to Google's Material design specs, white primary
      // text must have opacity of 1 and we will fix that here
      // because Angular Material doesn't care about that spec
      if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color.splice(3, 4);
      }

      // If contrast level provided, apply it to the current color
      if (contrastLevel) {
        color = applyContrast(color, contrastLevel);
      }

      // Convert color array to color string (rgb/rgba)
      if (color.length === 3) {
        return "rgb(" + color.join(",") + ")";
      } else if (color.length === 4) {
        return "rgba(" + color.join(",") + ")";
      } else {
        $log.error("Invalid number of arguments supplied in the color array: " + color.length + "\n" + "The array must have 3 or 4 colors.");
      }
    }

    /**
     * Apply given contrast level to the given color
     *
     * @param color
     * @param contrastLevel
     */
    function applyContrast(color, contrastLevel) {
      var contrastLevels = {
        white: {
          "1": "1",
          "2": "0.7",
          "3": "0.3",
          "4": "0.12"
        },
        black: {
          "1": "0.87",
          "2": "0.54",
          "3": "0.26",
          "4": "0.12"
        }
      };

      // If white
      if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color[3] = contrastLevels.white[contrastLevel];
      }
      // If black
      else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
        color[3] = contrastLevels.black[contrastLevel];
      }

      return color;
    }

    /**
     * Uppercase first
     */
    function ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;

                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;

                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('blocks.logger', []);
})();
(function () {
    'use strict';

    angular
        .module('blocks.logger')
        .factory('logger', logger);

    /* @ngInject */
    function logger($log) {
        var service = {
            showToasts: true,

            error: error,
            info: info,
            success: success,
            warning: warning,

            // straight to console; bypass toastr
            log: $log.log
        };

        return service;
        /////////////////////

        function error(message, data, title) {
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title) {
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title) {
            $log.info('Success: ' + message, data);
        }

        function warning(message, data, title) {
            $log.warn('Warning: ' + message, data);
        }
    }
}());
(function () {
    'use strict';

    angular.module('blocks.exception', ['blocks.logger']);
})();
(function () {
    'use strict';

    angular
        .module('blocks.exception')
        .factory('exception', exception);

    /* @ngInject */
    function exception(logger, toastService) {
        var service = {
            catcher: catcher
        };
        return service;

        function catcher(message) {
            return function (reason) {
                logger.error(message, reason);
                toastService.error(message);
            };
        }
    }
})();
// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
(function () {
    'use strict';

    angular
        .module('blocks.exception')
        .provider('exceptionHandler', exceptionHandlerProvider)
        .config(config);

    /**
     * Must configure the exception handling
     * @return {[type]}
     */
    function exceptionHandlerProvider() {
        /* jshint validthis:true */
        this.config = {
            appErrorPrefix: undefined
        };

        this.configure = function (appErrorPrefix) {
            this.config.appErrorPrefix = appErrorPrefix;
        };

        this.$get = function () {
            return { config: this.config };
        };
    }

    /**
     * Configure by setting an optional string value for appErrorPrefix.
     * Accessible via config.appErrorPrefix (via config value).
     * @param  {[type]} $provide
     * @return {[type]}
     * @ngInject
     */
    function config($provide) {
        $provide.decorator('$exceptionHandler', extendExceptionHandler);
    }

    /**
     * Extend the $exceptionHandler service to also display a toast.
     * @param  {Object} $delegate
     * @param  {Object} exceptionHandler
     * @param  {Object} logger
     * @return {Function} the decorated $exceptionHandler service
     */
    function extendExceptionHandler($delegate, exceptionHandler, logger) {
        return function (exception, cause) {
            var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
            var errorData = { exception: exception, cause: cause };
            exception.message = appErrorPrefix + exception.message;
            $delegate(exception, cause);
            /**
             * Could add the error to a service's collection,
             * add errors to $rootScope, log errors to remote web server,
             * or log locally. Or throw hard. It is entirely up to you.
             * throw exception;
             *
             * @example
             *     throw { message: 'error message we added' };
             */
            logger.error(exception.message, errorData);
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('baldris.translate', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('baldris.translate')
        .factory('translateService', translateService);

    /* @ngInject */
    function translateService($translate, APP_LANGUAGES, $rootScope, tmhDynamicLocale, amMoment) {
        
        // STORING CURRENT LOCALE
        var currentLocale = $translate.proposedLanguage();// because of async loading
        
        var setLocale = function (locale) {
            
            currentLocale = locale;// updating current locale
            
            // asking angular-translate to load and apply proper translations
            $translate.use(locale);
        };
        
        // EVENTS
        // on successful applying translations by angular-translate
        $rootScope.$on('$translateChangeSuccess', function (event, data) {
            document.documentElement.setAttribute('lang', data.language);// sets "lang" attribute to html
            
            // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
            tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
            
            //change moment locale
            amMoment.changeLocale(data.language.toLowerCase().substring(0,2));
            moment.locale(data.language.toLowerCase().substring(0,2));
        });
        
        return {
            setLocale: setLocale
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
  "use strict";

  angular
    .module("app.toolbar")
    .controller("ToolbarController", ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $rootScope,
    $mdSidenav,
    $translate,
    fuseTheming,
    authenticationService,
    tmhDynamicLocale,
    amMoment,
    dataService
  ) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    vm.currentUser = null;
    // Data
    $rootScope.global = {
      search: ""
    };
    vm.themes = fuseTheming.themes;
    vm.bodyEl = angular.element("body");
    vm.userStatusOptions = [
      {
        title: "Online",
        icon: "icon-checkbox-marked-circle",
        color: "#4CAF50"
      },
      {
        title: "Away",
        icon: "icon-clock",
        color: "#FFC107"
      },
      {
        title: "Do not Disturb",
        icon: "icon-minus-circle",
        color: "#F44336"
      },
      {
        title: "Invisible",
        icon: "icon-checkbox-blank-circle-outline",
        color: "#BDBDBD"
      },
      {
        title: "Offline",
        icon: "icon-checkbox-blank-circle-outline",
        color: "#616161"
      }
    ];
    vm.languages = {
      en: {
        title: "English",
        translation: "TOOLBAR.ENGLISH",
        code: "en",
        flag: "us"
      },
      nb_NO: {
        title: "Norsk bokmål",
        translation: "TOOLBAR.NORWEGIAN-NB",
        code: "nb_NO",
        flag: "no"
      } /*,
            nn_NO: {
                'title'      : 'Norsk nynorsk',
                'translation': 'TOOLBAR.NORWEGIAN-NN',
                'code'       : 'nn_NO',
                'flag'       : 'no'
            }*/
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.getThemeMetaData = getThemeMetaData;
    vm.shouldShowTheme = shouldShowTheme;

    //////////

    init();

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Get theme metadata
     *
     */
    function getThemeMetaData(themeName) {
      return fuseTheming.getThemeMetaData(themeName);
    }

    /**
     * Get selectable themes
     *
     */
    function shouldShowTheme(themeName) {
      return fuseTheming.getThemeMetaData(themeName).canBeSelected;
    }

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

      // Get currentUser
      dataService.getCurrentUser().then(function(currentUser) {
        vm.currentUser = currentUser;
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      authenticationService.logout();
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass("ms-navigation-horizontal-mobile-menu-active");
    }

    // EVENTS
    // on successful applying translations by angular-translate
    $rootScope.$on("$translateChangeSuccess", function(event, data) {
      document.documentElement.setAttribute("lang", data.language); // sets "lang" attribute to html

      // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
      tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, "-"));

      //change moment locale
      amMoment.changeLocale(data.language.toLowerCase().substring(0, 2));
      moment.locale(data.language.toLowerCase().substring(0, 2));
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', []);

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController()
    {
        var vm = this;



        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
  "use strict";

  angular.module("app.navigation").controller("NavigationController", NavigationController);

  /** @ngInject */
  function NavigationController($scope, $mdMedia, fuseTheming) {
    var vm = this;
    vm.fuseTheming = fuseTheming;
    // Data
    vm.bodyEl = angular.element("body");
    vm.folded = $mdMedia("(max-width: 1599px)");
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on("$stateChangeSuccess", function() {
      vm.bodyEl.removeClass("ms-navigation-horizontal-mobile-menu-active");
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state)
    {


        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.data', [

        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('workOrderTypeService', workOrderTypeService);

    /* @ngInject */
    function workOrderTypeService($http, $q, exception) {
        
        var locations;

        var service = {
            
        };

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('telephoneService', telephoneService);

    /* @ngInject */
    function telephoneService($http, $q, exception) {
        
        var service = {
            getEmptyTelephone: getEmptyTelephone
        };

        return service;

        function getEmptyTelephone() {
            return {
                $type: "Baldris.Core.Data.Entities.Dto.TelephoneDto, Baldris.Core.Data.Entities",
                id: '00000000-0000-0000-0000-000000000000',
                telephoneNumber: null,
                isDefault: false,
                sortOrder: 0,
                isoCode2: null,
                telephoneTypeId: null,
                telephoneType: null,
                partyId: null,
                party: null,
                baldrisUserId: null,
                baldrisUser: null,
                locationId: null,
                location: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('participantService', participantService);

    /* @ngInject */
    function participantService($http, $q, exception) {

        var service = {
            getEmptyCeremonyParticipant: getEmptyCeremonyParticipant
        };

        return service;

        function getEmptyCeremonyParticipant() {
            return {
                $type: "Baldris.Core.Data.Entities.Dto.CeremonyParticipantDto, Baldris.Core.Data.Entities",
                id: '00000000-0000-0000-0000-000000000000',
                internalIdentifier: null,
                sortOrder: 0,
                remarks: null,
                showInProgram: false,
                ceremonyId: '00000000-0000-0000-0000-000000000000',
                ceremony: null,
                participantRoleId: null,
                participantId: null,
                participant: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function() {
  "use strict";

  angular.module("app.data").factory("noteOrTaskService", noteOrTaskService);

  /* @ngInject */
  function noteOrTaskService($http, $q, $filter, exception) {
    var eventTypes;

    var service = {
      canToggleTask: canToggleTask,
      createHourGroups: createHourGroups,
      getEmptyNoteOrTask: getEmptyNoteOrTask,
      getEmptyNoteOrTaskUser: getEmptyNoteOrTaskUser,
      toggleTask: toggleTask
    };

    return service;

    function canToggleTask(task) {
      return $http
        .get("/api/NoteOrTasks/" + task.id + "/CanToggle")
        .then(canToggleTaskComplete)
        .catch(function(message) {
          exception.catcher("XHR Failed for canToggleTask")(message);
        });

      function canToggleTaskComplete(data, status, headers, config) {
        return data.data;
      }
    }

    function toggleTask(task) {
      return $http
        .put("/api/NoteOrTasks/" + task.id + "/Toggle")
        .then(toggleTaskComplete)
        .catch(function(message) {
          exception.catcher("XHR Failed for toggleTask")(message);
        });

      function toggleTaskComplete(data, status, headers, config) {
        return data.data;
      }
    }

    function getEmptyNoteOrTask() {
      return {
        id: "00000000-0000-0000-0000-000000000000",
        hostSerialized: null,
        subject: null,
        text: null,
        deceased: null,
        locationSerialized: null,
        locationSerializedAlternative: null,
        englishLocationSerialized: null,
        attendeesSerialized: null,
        start: null,
        end: null,
        isAllDay: false,
        internalType: null,
        internalId: null,
        recurrencePattern: null,
        exceptionAppointments: null,
        attendeesMustRsvp: false,
        calendarEventTypeId: null,
        calendarEventType: null,
        workOrderId: null,
        workOrder: null,
        hostId: null,
        host: null,
        reservationId: null,
        reservation: null,
        attendees: [],
        changeState: 0,
        changeDate: null,
        changedById: null,
        changeRemarks: null
      };
    }

    function getEmptyNoteOrTaskUser() {
      return {
        $type: "Baldris.Core.Data.Entities.Dto.NoteOrTaskUserDto, Baldris.Core.Data.Entities",
        id: "00000000-0000-0000-0000-000000000000",
        sortOrder: 0,
        role: null,
        remarks: null,
        rsvpStatus: 0,
        rsvpChangedTime: null,
        rsvpMessage: null,
        calendarEventId: "00000000-0000-0000-0000-000000000000",
        userId: null,
        user: null,
        changeState: 0,
        changeDate: null,
        changedById: null,
        changeRemarks: null
      };
    }

    function createHourGroups(events, shouldCreateAllWorkHourGroups) {
      var hourGroups = [];
      // sort events
      events = $filter("orderBy")(events, "start", false);

      var createdHours = [];
      shouldCreateAllWorkHourGroups = shouldCreateAllWorkHourGroups || false;
      if (shouldCreateAllWorkHourGroups) {
        //Allday-group
        hourGroups.push({
          moment: moment().startOf("day"),
          from: -1,
          isAllDay: true,
          to: 0
        });
        createdHours.push(-1);
        //Create groups from 8-16
        var step;
        for (step = 8; step < 17; step++) {
          hourGroups.push({
            moment: moment()
              .hour(step)
              .minute(0),
            from: step,
            isAllDay: false,
            to: step + 1
          });
          createdHours.push(step);
        }
      }

      // make groups
      angular.forEach(events, function(event) {
        var startMoment = moment(event.start);
        var nextDayMoment = startMoment.add(1, "days");
        var endMoment = moment(event.end);
        var hour = startMoment.hour();

        if (event.isAllDay || endMoment.isSameOrAfter(nextDayMoment)) {
          hour = -1;
        }

        //Check that the group havent been created
        if (createdHours.indexOf(hour) === -1) {
          if (hour === -1) {
            hourGroups.push({
              moment: startMoment.startOf("day"),
              from: hour,
              isAllDay: true,
              to: hour + 1
            });
          } else {
            hourGroups.push({
              moment: startMoment.startOf("hour"),
              isAllDay: false,
              from: hour,
              to: hour + 1
            });
          }

          createdHours.push(hour);
        }
      });

      //Put events in groups
      angular.forEach(hourGroups, function(group) {
        group.events = $filter("hourGroup")(events, group);
      });

      return hourGroups;
    }
  }
})();

(function () {
    'use strict';

    angular.module('app.data').factory('municipalityService', municipalityService);

    /* @ngInject */
    function municipalityService($http, $q, exception) {
        var service = {
            getEmptyMunicipality: getEmptyMunicipality,
        };

        return service;

        function getEmptyMunicipality() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.MunicipalityDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                nameAlternative: null,
                englishName: null,
                municipalityCode: null,
                geonameId: null,
                isDeleted: false,
                remarks: null,
                stateId: null,
                state: null,
                imageId: null,
                image: null,
                changeState: 0,
                changeDate: null,
                changedById: null,
                changeRemarks: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.data').factory('lookupStringService', lookupStringService);

    /* @ngInject */
    function lookupStringService($http, $q, exception) {
        var service = {
            getEmptyLookupString: getEmptyLookupString,
        };

        return service;

        function getEmptyLookupString() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.LookupStringDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                lookupNumber: 0,
                lookupValue: null,
                lookupValueAlternative: null,
                lookupValueEnglish: null,
                description: null,
                remarks: false,
                sortOrder: 0,
                lookupStringTypeId: null,
                lookupStringType: null,
                imageId: null,
                image: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                LastModifiedBy: null,
                LastModifiedAt: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.data').factory('filesService', filesService);

    /* @ngInject */
    function filesService($http, $q, $translate, exception, baldrisApiBase, toastService) {
        var service = {
            downloadFileByFileId: downloadFileByFileId,
            saveFilesToDesktop: saveFilesToDesktop,
        };

        return service;

        function downloadFileByFileId(fileId) {
            return $http
                .get(baldrisApiBase + '/api/BaldrisFiles/' + fileId + '/Download', { responseType: 'arraybuffer' })
                .then(downloadFileByFileIdComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for downloadFileByFileId at "filesService"')(message);
                    return $q.reject(message);
                });

            function downloadFileByFileIdComplete(response) {
                return response;
            }
        }

        function saveFilesToDesktop(objectURL, fileName, contentType) {
            // Get the filename from the x-filename header or default to "download.bin"
            var filename = fileName || 'baldris-download-' + moment().format('YYYY-MM-DD') + '.zip';

            // Try to use a download link
            var link = document.createElement('a');
            if ('download' in link) {
                // Try to simulate a click
                try {
                    link.setAttribute('href', objectURL);

                    // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                    link.setAttribute('download', filename);

                    // Simulate clicking the download link
                    var event = document.createEvent('MouseEvents');
                    event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                    link.dispatchEvent(event);
                } catch (ex) {
                    console.log('Download link method with simulated click failed with the following exception:');
                    console.log(ex);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('emailService', emailService);

    /* @ngInject */
    function emailService($http, $q, exception) {
        
        var service = {
            getEmptyEmail: getEmptyEmail
        };

        return service;

        function getEmptyEmail() {
            return {
                $type: "Baldris.Core.Data.Entities.Dto.EmailDto, Baldris.Core.Data.Entities",
                id: '00000000-0000-0000-0000-000000000000',
                emailAddress: null,
                isDefault: false,
                sortOrder: 0,
                emailTypeId: null,
                emailType: null,
                partyId: null,
                party: null,
                baldrisUserId: null,
                baldrisUser: null,
                locationId: null,
                location: null,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('departmentService', departmentService);

    /* @ngInject */
    function departmentService($http, $q, exception) {
        
        var service = {
            
        };

        return service;
    }
})();
(function () {
    'use strict';

    angular.module('app.data').factory('dataService', dataService);

    /* @ngInject */
    function dataService($http, $location, $translate, $q, exception, $state, $filter, baldrisApiBase, toastService) {
        var isPrimed = false;
        var primePromise;
        var homeValues = null;
        var currentUser = null;
        var caches = [
            'addresstypes',
            'balanceaccounts',
            'baldrisusers',
            'calendareventtypes',
            'caskets',
            'countries',
            'departments',
            'emailtypes',
            'externalordertypes',
            'financialtransactiontypes',
            'gravetypes',
            'legalunits',
            'locations',
            'locationtypes',
            'lookupstrings',
            'lookupstringtypes',
            'municipalities',
            'obituarynoticetypes',
            'participantroles',
            'participants',
            'participanttypes',
            'parties-religionpartytype',
            'parties-congregationpartytype',
            'partytypes',
            'products',
            'producttypes',
            'programslots',
            'programstyles',
            'programtypes',
            'reports',
            'songs',
            'songverses',
            'states',
            'suppliers',
            'suppliertypes',
            'telephonetypes',
            'urns',
            'vats',
            'workordertypes',
        ];

        var cacheTypeIdMap = {
            departments: 'legalUnitId',
            lookupstrings: 'lookupStringTypeId',
            'parties-congregationpartytype': 'parentOrganizationId',
            products: 'productTypeId',
            songverses: 'songId',
            suppliers: 'supplierTypeId',
        };
        var dataCache = [];

        var service = {
            bulkUpdate: bulkUpdate,
            canDelete: canDelete,
            canEdit: canEdit,
            createBulkPromises: createBulkPromises,
            deleteItem: deleteItem,
            deleteAutoProduct: deleteAutoProduct,
            deleteAutoTask: deleteAutoTask,
            getAll: getAll,
            getBetweenDates: getBetweenDates,
            getByAlphabetLetter: getByAlphabetLetter,
            getByConfigName: getByConfigName,
            getByDeceasedId: getByDeceasedId,
            getById: getById,
            getByIds: getByIds,
            getByPartyId: getByPartyId,
            getByTypeId: getByTypeId,
            getByUri: getByUri,
            getByUserId: getByUserId,
            getByUserIdBetweenDates: getByUserIdBetweenDates,
            getByWorkOrderId: getByWorkOrderId,
            getCurrentUser: getCurrentUser,
            getCustomFieldCategoriesById: getCustomFieldCategoriesById,
            getCustomFieldDataById: getCustomFieldDataById,
            getCustomFieldsByTypeId: getCustomFieldsByTypeId,
            getLatest: getLatest,
            getPaginatedItems: getPaginatedItems,
            getUpdateModel: getUpdateModel,
            insertItem: insertItem,
            insertAutoProduct: insertAutoProduct,
            insertAutoTask: insertAutoTask,
            invalidateCache: invalidateCache,
            search: search,
            searchByConfigName: searchByConfigName,
            updateFromUpdateModel: updateFromUpdateModel,
            updateItem: updateItem,
            updateAutoProduct: updateAutoProduct,
            updateAutoTask: updateAutoTask,
            uploadFiles: uploadFiles,
            uploadSignature: uploadSignature,
        };

        return service;

        function bulkUpdate(controller, bulkList) {
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/BulkUpdate', bulkList)
                .then(bulkUpdateComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for bulkUpdate at "' + controller + '"')(message);

                    return $q.reject(message);
                });

            function bulkUpdateComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function canDelete(controller, item) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + item.id + '/CanDelete')
                .then(canDeleteComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return false;
                        return false;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for canDelete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function canDeleteComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function canEdit(controller, item) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + item.id + '/CanEdit')
                .then(canEditComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return false;
                        return false;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for canEdit at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function canEditComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function createBulkPromises(controller, itemList, parentPropertyName, parentPropertyValue, attachedTypeName) {
            var promises = [];

            if (itemList && itemList.length > 0) {
                itemList.forEach(function (item) {
                    // ensure correct parentProperty
                    if (parentPropertyName) {
                        item[parentPropertyName] = parentPropertyValue;
                    }
                    // if attachedTypeName
                    if (attachedTypeName) {
                        item.attachedTypeName = attachedTypeName;
                    }

                    if (item.id && item.id !== '00000000-0000-0000-0000-000000000000') {
                        // Update or delete
                        if (item.changeState === 3) {
                            promises.push(deleteItem(controller, item));
                        } else if (item.changeState === 2) {
                            promises.push(updateItem(controller, item));
                        }
                    } else {
                        // Insert
                        promises.push(insertItem(controller, item));
                    }
                });
            }

            return promises;
        }

        function deleteItem(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/' + controller + '/' + item.id)
                .then(deleteItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    // cacheable collection -> remove from cache
                    return removeFromCache(controller, data.data).then(function () {
                        return item;
                    });
                }
                return data.data;
            }
        }

        function deleteAutoProduct(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/AttachedProducts/' + item.id)
                .then(deleteAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteAutoProductComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function deleteAutoTask(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/AttachedAutoTasks/' + item.id)
                .then(deleteAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteAutoTaskComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getAll(controller, forceReload, params) {
            if (isCachableCollection(controller) && !forceReload) {
                return getAllFromCache(controller);
            }
            var promise = null;
            if (params) {
                promise = $http.get(baldrisApiBase + '/api/' + controller, {
                    params: params,
                });
            } else {
                promise = $http.get(baldrisApiBase + '/api/' + controller);
            }
            return promise.then(getAllComplete).catch(function (message) {
                if (message.status == '401') {
                    toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    return $q.reject(message);
                }
                exception.catcher('XHR Failed for getAll at "' + controller + '"')(message);
                return $q.reject(message);
            });

            function getAllComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getBetweenDates(controller, startDate, endDate) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/BetweenDates', {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                })
                .then(getBetweenDatesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getBetweenDates at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getBetweenDatesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByAlphabetLetter(controller, letter, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Alphabetically/' + letter, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByAlphabetLetterComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByAlphabetLetter at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByAlphabetLetterComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByConfigName(controller, configName, forceReload, params) {
            if (isCachableCollection(controller, configName) && !forceReload) {
                return getAllByConfigNameFromCache(controller, configName);
            }
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/ByConfigName/' + configName, { params: params })
                    .then(getByConfigNameComplete)
                    .catch(function (message) {
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        exception.catcher('XHR Failed for getByConfigName at "' + controller + '"')(message);
                        return $q.reject(message);
                    });
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByConfigName/' + configName)
                .then(getByConfigNameComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByConfigName at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByConfigNameComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByDeceasedId(controller, deceasedId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByDeceasedId/' + deceasedId, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByDeceasedIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByDeceasedId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByDeceasedIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getById(controller, id, asDto, forceReload) {
            asDto = asDto || false;
            if (isCachableCollection(controller) && !asDto && !forceReload) {
                return getByIdFromCache(controller, id);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByIdComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByIds(controller, ids, forceReload, params) {
            if (isCachableCollection(controller) && !forceReload) {
                return getAllFromCache(controller).then(function (data) {
                    return extractByIds(data, ids);
                });
            }
            var promise = null;
            if (params) {
                promise = $http.get(baldrisApiBase + '/api/' + controller, {
                    params: params,
                });
            } else {
                promise = $http.get(baldrisApiBase + '/api/' + controller);
            }
            return promise.then(getByIdsComplete).catch(function (message) {
                if (message.status == '401') {
                    toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    return $q.reject(message);
                }
                exception.catcher('XHR Failed for getByIds at "' + controller + '"')(message);
                return $q.reject(message);
            });

            function getByIdsComplete(data, status, headers, config) {
                return extractByIds(data.data, ids);
            }

            function extractByIds(data, ids) {
                if (data && data.length > 0) {
                    return data.filter(function (item) {
                        var isMatch = false;
                        ids.forEach(function (id) {
                            if (id === item.id) {
                                isMatch = true;
                            }
                        });
                        return isMatch;
                    });
                }
                return [];
            }
        }

        function getByPartyId(controller, partyId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByPartyId/' + partyId, {
                    params: { asDto: asDto },
                })
                .then(getByPartyIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByPartyId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByPartyIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByTypeId(controller, typeId, params, forceReload) {
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/ByTypeId/' + typeId, {
                        params: params,
                    })
                    .then(getByTypeIdComplete)
                    .catch(function (message) {
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        exception.catcher('XHR Failed for getByTypeId at "' + controller + '"')(message);
                        return $q.reject(message);
                    });
            }
            if (isCachableCollection(controller) && canGetByTypeFromCache(controller) && !forceReload) {
                return getByTypeIdFromCache(controller, typeId);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByTypeId/' + typeId)
                .then(getByTypeIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByTypeId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByTypeIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUri(controller, uri, params, forceReload, disableErrorMessage) {
            // Special condition for BaldrisUsers to enabled caching
            if (controller === 'BaldrisUsers' && uri === 'Active' && !forceReload) {
                return getAllFromCache(controller);
            }
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/' + uri, {
                        params: params,
                    })
                    .then(getByUriComplete)
                    .catch(function (message) {
                        if (message && message.status && message.status === 404) {
                            // Not Found -> return null;
                            return null;
                        }
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        if (!disableErrorMessage) {
                            exception.catcher('XHR Failed for getByUri at "' + controller + '"')(message);
                        }

                        return $q.reject(message);
                    });
            }

            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + uri)
                .then(getByUriComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    if (!disableErrorMessage) {
                        exception.catcher('XHR Failed for getByUri at "' + controller + '"')(message);
                    }
                    return $q.reject(message);
                });

            function getByUriComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUserId(controller, userId) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByUserId/' + userId)
                .then(getByUserIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByUserId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByUserIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUserIdBetweenDates(controller, userId, startDate, endDate) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByUserId/' + userId + '/BetweenDates', {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                })
                .then(getByUserIdBetweenDatesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByUserIdBetweenDates at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByUserIdBetweenDatesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByWorkOrderId(controller, workOrderId, asDto, params) {
            asDto = asDto || false;
            params = params || { asDto: asDto };
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByWorkOrderId/' + workOrderId, { params: params })
                .then(getByWorkOrderIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByWorkOrderId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCurrentUser() {
            if (currentUser) {
                return $q.when(currentUser);
            } else {
                return $http
                    .get(baldrisApiBase + '/api/Accounts/Current')
                    .then(getCurrentUserComplete)
                    .catch(function (message) {
                        //exception.catcher('XHR Failed for getCurrentUser')(message);
                        $state.go('app.account.login');
                    });
            }

            function getCurrentUserComplete(data, status, headers, config) {
                currentUser = data.data;
                return currentUser;
            }
        }

        function getCustomFieldDataById(controller, id, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id + '/GetCustomFieldData', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldDataByIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldDataById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldDataByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCustomFieldCategoriesById(controller, id, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id + '/GetCustomFieldCategories', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldCategoriesByIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldCategoriesById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldCategoriesByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCustomFieldsByTypeId(controller, typeId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + typeId + '/GetCustomFields', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldsByTypeIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldsByTypeId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldsByTypeIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getLatest(controller, amount, params) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Latest/' + amount, {
                    params: params,
                })
                .then(getLatestComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getLatest at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getLatestComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getPaginatedItems(controller, pageSize, pageIndex, ids, asDto, sortField, searchString) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Items', {
                    params: {
                        pageSize: pageSize,
                        pageIndex: pageIndex,
                        ids: ids,
                        asDto: asDto,
                        sortField: sortField,
                        searchString: searchString,
                    },
                })
                .then(getPaginatedItemsComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getPaginatedItems at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getPaginatedItemsComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getUpdateModel(controller, id) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/GetUpdateModel/' + id)
                .then(getUpdateModelComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getUpdateModel at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getUpdateModelComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function insertItem(controller, item) {
            if (item.$type && item.$type.indexOf('Fdo') > 0) {
                controller += '/FromFdo';
            }
            return $http
                .post(baldrisApiBase + '/api/' + controller, item)
                .then(insertItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    return addToCache(controller, data.data).then(function () {
                        return data.data;
                    });
                }
                return data.data;
            }
        }

        function insertAutoProduct(controller, item) {
            return $http
                .post(baldrisApiBase + '/api/AttachedProducts', item)
                .then(insertAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertAutoProductComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function insertAutoTask(controller, item) {
            return $http
                .post(baldrisApiBase + '/api/AttachedAutoTasks', item)
                .then(insertAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertAutoTaskComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function search(controller, searchString, typeId, typeParameterName, params, forceReload) {
            var paramsObject = {
                params: {
                    searchString: searchString,
                },
            };

            if (typeId) {
                paramsObject.params[typeParameterName] = typeId;
            }

            if (params) {
                params.searchString = searchString;
                paramsObject.params = params;
            }
            if (isCachableCollection(controller) && !typeId && !params && !forceReload) {
                return searchInCache(controller, searchString);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Search', paramsObject)
                .then(searchComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for search at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function searchComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function searchByConfigName(controller, configName, searchString, forceReload) {
            if (isCachableCollection(controller, configName) && !forceReload) {
                return searchByConfigNameFromCache(controller, configName, searchString);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Search/ByConfigName/' + configName, {
                    params: {
                        searchString: searchString,
                    },
                })
                .then(searchByConfigNameComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for searchByConfigName at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function searchByConfigNameComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateFromUpdateModel(controller, updateModel) {
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/FromUpdateModel', updateModel)
                .then(updateFromUpdateModelComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateFromUpdateModel at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateFromUpdateModelComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateItem(controller, item) {
            if (item.$type && item.$type.indexOf('Fdo') > 0) {
                controller += '/FromFdo';
            }
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/' + item.id, item)
                .then(updateItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    return updateInCache(controller, item).then(function () {
                        return data.data;
                    });
                }
                return data.data;
            }
        }

        function updateAutoProduct(controller, item) {
            return $http
                .put(baldrisApiBase + '/api/AttachedProducts/' + item.id, item)
                .then(updateAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateAutoProduct at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateAutoTask(controller, item) {
            return $http
                .put(baldrisApiBase + '/api/AttachedAutoTasks/' + item.id, item)
                .then(updateAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateAutoTask at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function uploadFiles(files) {
            var formData = new FormData();

            angular.forEach(files, function (file) {
                formData.append(file.name, file);
            });

            return $http({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': undefined },
                mimeType: 'multipart/form-data',
            })
                .then(uploadFilesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for uploadFiles at "BaldrisFiles"')(message);
                    return $q.reject(message);
                });

            function uploadFilesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function uploadSignature(base64String, partyId) {
            if (base64String.indexOf(',') > -1) {
                base64String = base64String.split(',')[1];
            }
            var config = {
                headers: {
                    'Content-Type': 'text/plain',
                },
            };
            return $http
                .put(baldrisApiBase + '/api/Parties/' + partyId + '/UploadSignature', base64String, config)
                .then(uploadSignatureComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for uploadSignature at BaldrisFiles"')(message);
                    return $q.reject(message);
                });

            function uploadSignatureComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function prime() {
            // This function can only be called once.
            if (primePromise) {
                return primePromise;
            }

            primePromise = $q.when(true).then(success);
            return primePromise;

            function success() {
                isPrimed = true;
            }
        }

        function ready(nextPromises) {
            var readyPromise = primePromise || prime();

            return readyPromise.then(function () {
                return $q.all(nextPromises);
            });
        }

        // CACHE-METHODS
        function invalidateCache(controller, configName) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            if (configName) {
                cacheName = cacheName + '-' + configName.toLowerCase();
            }
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Invalidating cache '" + cache.name + "'...");
                    dataCache.splice(index, 1);
                    return true;
                }
            }
            return false;
        }

        function isCachableCollection(controller, configName) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            if (configName) {
                var configCacheName = cacheName + '-' + configName.toLowerCase();
                return caches.indexOf(configCacheName) > -1;
            }
            return caches.indexOf(cacheName) > -1;
        }

        function canGetByTypeFromCache(controller) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            return angular.isDefined(cacheTypeIdMap[cacheName]);
        }

        function getCache(controller) {
            var cacheName = controller.toLowerCase();
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Accessing cache '" + cache.name + "'...");
                    return $q.when(cache);
                }
            }
            return initializeCache(controller);
        }

        function initializeCache(controller) {
            // Special case for BaldrisUsers
            if (controller === 'BaldrisUsers') {
                return getByUri(controller, 'Active', null, true).then(function (users) {
                    var cache = {
                        name: controller.toLowerCase(),
                        data: users || [],
                    };
                    dataCache.push(cache);
                    console.log("Cache '" + cache.name + "' initialized...");
                    return cache;
                });
            }
            return getAll(controller, true).then(function (data) {
                var cache = {
                    name: controller.toLowerCase(),
                    data: data || [],
                };
                dataCache.push(cache);
                console.log("Cache '" + cache.name + "' initialized...");
                return cache;
            });
        }

        function getConfigCache(controller, configName) {
            var cacheName = controller.toLowerCase() + '-' + configName.toLowerCase();
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Accessing cache '" + cache.name + "'...");
                    return $q.when(cache);
                }
            }
            return initializeConfigCache(controller, configName);
        }

        function initializeConfigCache(controller, configName) {
            return getByConfigName(controller, configName, true).then(function (data) {
                var cache = {
                    name: controller.toLowerCase() + '-' + configName.toLowerCase(),
                    data: data || [],
                };
                dataCache.push(cache);
                console.log("Cache '" + cache.name + "' initialized...");
                return cache;
            });
        }

        function removeFromCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (item && item.id && cache && cache.data) {
                    for (var index = 0; index < cache.data.length; index++) {
                        var dataItem = cache.data[index];
                        if (dataItem.id === item.id) {
                            cache.data.splice(index, 1);
                            return true;
                        }
                    }
                }
                return false;
            });
        }

        function addToCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (!item.$type || item.$type.indexOf('Fdo') === -1) {
                    // Not a fdo-object -> fetch from server
                    return getById(controller, item.id, false, true).then(function (fetchedItem) {
                        cache.data.push(fetchedItem);
                        return true;
                    });
                }
                cache.data.push(item);
                return true;
            });
        }

        function updateInCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (!item.$type || item.$type.indexOf('Fdo') === -1) {
                    // Not a fdo-object -> fetch from server
                    return getById(controller, item.id, false, true).then(function (fetchedItem) {
                        for (var index = 0; index < cache.data.length; index++) {
                            var dataItem = cache.data[index];
                            if (dataItem.id === fetchedItem.id) {
                                cache.data.splice(index, 1);
                                cache.data.push(fetchedItem);
                                return true;
                            }
                        }
                        // If not found, push it anyways
                        cache.data.push(fetchedItem);
                        return true;
                    });
                }
                for (var index = 0; index < cache.data.length; index++) {
                    var dataItem = cache.data[index];
                    if (dataItem.id === item.id) {
                        cache.data.splice(index, 1);
                        cache.data.push(item);
                        return true;
                    }
                }
                // If not found, push it anyways
                cache.data.push(item);
                return true;
            });
        }

        function getByIdFromCache(controller, id) {
            return getCache(controller).then(function (cache) {
                for (var index = 0; index < cache.data.length; index++) {
                    var dataItem = cache.data[index];
                    if (dataItem.id === id) {
                        return dataItem;
                    }
                }
                // if not found -> return from server and add to cache
                return getById(controller, id, false, true).then(function (fetchedItem) {
                    if (fetchedItem) {
                        return addToCache(controller, fetchedItem).then(function (isAdded) {
                            return fetchedItem;
                        });
                    }
                });
            });
        }

        function getByTypeIdFromCache(controller, typeId) {
            return getCache(controller).then(function (cache) {
                var filterObject = {};
                filterObject[cacheTypeIdMap[cache.name]] = typeId;
                var typeResults = $filter('filter')(cache.data, filterObject);
                if (!typeResults || typeResults.length === 0) {
                    // Search on server if no search results
                    return getByTypeId(controller, typeId, null, true);
                }
                return typeResults;
            });
        }

        function getAllFromCache(controller) {
            return getCache(controller).then(function (cache) {
                return cache.data;
            });
        }

        function searchInCache(controller, searchString) {
            return getCache(controller).then(function (cache) {
                var searchResults = $filter('filter')(cache.data, searchString);
                if (!searchResults || searchResults.length === 0) {
                    // Search on server if no search results
                    return search(controller, searchString, null, null, null, true);
                }
                return searchResults;
            });
        }

        function getAllByConfigNameFromCache(controller, configName) {
            return getConfigCache(controller, configName).then(function (cache) {
                return cache.data;
            });
        }

        function searchByConfigNameFromCache(controller, configName, searchString) {
            return getConfigCache(controller, configName).then(function (cache) {
                var searchResults = $filter('filter')(cache.data, searchString);
                if (!searchResults || searchResults.length === 0) {
                    // Search on server if no search results
                    return searchByConfigName(controller, configName, searchString, true);
                }
                return searchResults;
            });
        }
    }
})();

(function () {
    'use strict';

    var apiBase = 'http://dev.api.baldris.no';
    var apiLegacyBase = 'http://dev-api.baldris.no';
    var imageBase = 'http://localhost:5201/StreamFromStorage';

    var hostname = window.location.hostname.replace('.beta', ''); // remove beta from hostname
    var protocol = window.location.protocol;

    if (hostname.indexOf('baldris.no') > -1) {
        apiBase = protocol + '//' + hostname.replace('.baldris', '.api.baldris');
        apiLegacyBase = protocol + '//' + hostname.replace('.baldris', '-api.baldris');
        imageBase = protocol + '//' + 'images.baldris.no/StreamFromStorage';
    }
    if (hostname.indexOf('localhost') > -1) {
        apiBase = protocol + '//' + 'localhost:5101';
    }

    angular.module('app.data').constant('baldrisApiBase', apiBase);
    angular.module('app.data').constant('baldrisApiLegacyBase', apiLegacyBase);
    angular.module('app.data').constant('baldrisImageBase', imageBase);
})();

(function() {
    'use strict';

    angular
        .module('app.data')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/data');


    }
})();
(function () {
    'use strict';

    angular.module('app.data').factory('dataLegacyService', dataService);

    /* @ngInject */
    function dataService($http, $location, $translate, $q, exception, $state, $filter, baldrisApiLegacyBase, toastService) {
        var baldrisApiBase = baldrisApiLegacyBase;
        var isPrimed = false;
        var primePromise;
        var homeValues = null;
        var currentUser = null;
        var caches = [
            'addresstypes',
            'balanceaccounts',
            'baldrisusers',
            'calendareventtypes',
            'caskets',
            'countries',
            'departments',
            'emailtypes',
            'externalordertypes',
            'financialtransactiontypes',
            'gravetypes',
            'legalunits',
            'locations',
            'locationtypes',
            'lookupstrings',
            'lookupstringtypes',
            'municipalities',
            'obituarynoticetypes',
            'participantroles',
            'participants',
            'participanttypes',
            'parties-religionpartytype',
            'parties-congregationpartytype',
            'partytypes',
            'products',
            'producttypes',
            'programslots',
            'programstyles',
            'programtypes',
            'reports',
            'songs',
            'songverses',
            'states',
            'suppliers',
            'suppliertypes',
            'telephonetypes',
            'urns',
            'vats',
            'workordertypes',
        ];

        var cacheTypeIdMap = {
            departments: 'legalUnitId',
            lookupstrings: 'lookupStringTypeId',
            'parties-congregationpartytype': 'parentOrganizationId',
            products: 'productTypeId',
            songverses: 'songId',
            suppliers: 'supplierTypeId',
        };
        var dataCache = [];

        var service = {
            bulkUpdate: bulkUpdate,
            canDelete: canDelete,
            canEdit: canEdit,
            createBulkPromises: createBulkPromises,
            deleteItem: deleteItem,
            deleteAutoProduct: deleteAutoProduct,
            deleteAutoTask: deleteAutoTask,
            getAll: getAll,
            getBetweenDates: getBetweenDates,
            getByAlphabetLetter: getByAlphabetLetter,
            getByConfigName: getByConfigName,
            getByDeceasedId: getByDeceasedId,
            getById: getById,
            getByIds: getByIds,
            getByPartyId: getByPartyId,
            getByTypeId: getByTypeId,
            getByUri: getByUri,
            getByUserId: getByUserId,
            getByUserIdBetweenDates: getByUserIdBetweenDates,
            getByWorkOrderId: getByWorkOrderId,
            getCurrentUser: getCurrentUser,
            getCustomFieldCategoriesById: getCustomFieldCategoriesById,
            getCustomFieldDataById: getCustomFieldDataById,
            getCustomFieldsByTypeId: getCustomFieldsByTypeId,
            getLatest: getLatest,
            getPaginatedItems: getPaginatedItems,
            getUpdateModel: getUpdateModel,
            insertItem: insertItem,
            insertAutoProduct: insertAutoProduct,
            insertAutoTask: insertAutoTask,
            invalidateCache: invalidateCache,
            search: search,
            searchByConfigName: searchByConfigName,
            updateFromUpdateModel: updateFromUpdateModel,
            updateItem: updateItem,
            updateAutoProduct: updateAutoProduct,
            updateAutoTask: updateAutoTask,
            uploadFiles: uploadFiles,
            uploadSignature: uploadSignature,
        };

        return service;

        function bulkUpdate(controller, bulkList) {
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/BulkUpdate', bulkList)
                .then(bulkUpdateComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for bulkUpdate at "' + controller + '"')(message);

                    return $q.reject(message);
                });

            function bulkUpdateComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function canDelete(controller, item) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + item.id + '/CanDelete')
                .then(canDeleteComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return false;
                        return false;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for canDelete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function canDeleteComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function canEdit(controller, item) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + item.id + '/CanEdit')
                .then(canEditComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return false;
                        return false;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for canEdit at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function canEditComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function createBulkPromises(controller, itemList, parentPropertyName, parentPropertyValue, attachedTypeName) {
            var promises = [];

            if (itemList && itemList.length > 0) {
                itemList.forEach(function (item) {
                    // ensure correct parentProperty
                    if (parentPropertyName) {
                        item[parentPropertyName] = parentPropertyValue;
                    }
                    // if attachedTypeName
                    if (attachedTypeName) {
                        item.attachedTypeName = attachedTypeName;
                    }

                    if (item.id && item.id !== '00000000-0000-0000-0000-000000000000') {
                        // Update or delete
                        if (item.changeState === 3) {
                            promises.push(deleteItem(controller, item));
                        } else if (item.changeState === 2) {
                            promises.push(updateItem(controller, item));
                        }
                    } else {
                        // Insert
                        promises.push(insertItem(controller, item));
                    }
                });
            }

            return promises;
        }

        function deleteItem(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/' + controller + '/' + item.id)
                .then(deleteItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    // cacheable collection -> remove from cache
                    return removeFromCache(controller, data.data).then(function () {
                        return item;
                    });
                }
                return data.data;
            }
        }

        function deleteAutoProduct(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/AttachedProducts/' + item.id)
                .then(deleteAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteAutoProductComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function deleteAutoTask(controller, item) {
            return $http
                .delete(baldrisApiBase + '/api/AttachedAutoTasks/' + item.id)
                .then(deleteAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for deleteAutoTaskComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function deleteAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getAll(controller, forceReload, params) {
            if (isCachableCollection(controller) && !forceReload) {
                return getAllFromCache(controller);
            }
            var promise = null;
            if (params) {
                promise = $http.get(baldrisApiBase + '/api/' + controller, {
                    params: params,
                });
            } else {
                promise = $http.get(baldrisApiBase + '/api/' + controller);
            }
            return promise.then(getAllComplete).catch(function (message) {
                if (message.status == '401') {
                    toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    return $q.reject(message);
                }
                exception.catcher('XHR Failed for getAll at "' + controller + '"')(message);
                return $q.reject(message);
            });

            function getAllComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getBetweenDates(controller, startDate, endDate) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/BetweenDates', {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                })
                .then(getBetweenDatesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getBetweenDates at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getBetweenDatesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByAlphabetLetter(controller, letter, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Alphabetically/' + letter, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByAlphabetLetterComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByAlphabetLetter at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByAlphabetLetterComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByConfigName(controller, configName, forceReload, params) {
            if (isCachableCollection(controller, configName) && !forceReload) {
                return getAllByConfigNameFromCache(controller, configName);
            }
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/ByConfigName/' + configName, { params: params })
                    .then(getByConfigNameComplete)
                    .catch(function (message) {
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        exception.catcher('XHR Failed for getByConfigName at "' + controller + '"')(message);
                        return $q.reject(message);
                    });
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByConfigName/' + configName)
                .then(getByConfigNameComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByConfigName at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByConfigNameComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByDeceasedId(controller, deceasedId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByDeceasedId/' + deceasedId, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByDeceasedIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByDeceasedId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByDeceasedIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getById(controller, id, asDto, forceReload) {
            asDto = asDto || false;
            if (isCachableCollection(controller) && !asDto && !forceReload) {
                return getByIdFromCache(controller, id);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id, {
                    params: {
                        asDto: asDto,
                    },
                })
                .then(getByIdComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByIds(controller, ids, forceReload, params) {
            if (isCachableCollection(controller) && !forceReload) {
                return getAllFromCache(controller).then(function (data) {
                    return extractByIds(data, ids);
                });
            }
            var promise = null;
            if (params) {
                promise = $http.get(baldrisApiBase + '/api/' + controller, {
                    params: params,
                });
            } else {
                promise = $http.get(baldrisApiBase + '/api/' + controller);
            }
            return promise.then(getByIdsComplete).catch(function (message) {
                if (message.status == '401') {
                    toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                    return $q.reject(message);
                }
                exception.catcher('XHR Failed for getByIds at "' + controller + '"')(message);
                return $q.reject(message);
            });

            function getByIdsComplete(data, status, headers, config) {
                return extractByIds(data.data, ids);
            }

            function extractByIds(data, ids) {
                if (data && data.length > 0) {
                    return data.filter(function (item) {
                        var isMatch = false;
                        ids.forEach(function (id) {
                            if (id === item.id) {
                                isMatch = true;
                            }
                        });
                        return isMatch;
                    });
                }
                return [];
            }
        }

        function getByPartyId(controller, partyId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByPartyId/' + partyId, {
                    params: { asDto: asDto },
                })
                .then(getByPartyIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByPartyId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByPartyIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByTypeId(controller, typeId, params, forceReload) {
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/ByTypeId/' + typeId, {
                        params: params,
                    })
                    .then(getByTypeIdComplete)
                    .catch(function (message) {
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        exception.catcher('XHR Failed for getByTypeId at "' + controller + '"')(message);
                        return $q.reject(message);
                    });
            }
            if (isCachableCollection(controller) && canGetByTypeFromCache(controller) && !forceReload) {
                return getByTypeIdFromCache(controller, typeId);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByTypeId/' + typeId)
                .then(getByTypeIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByTypeId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByTypeIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUri(controller, uri, params, forceReload, disableErrorMessage) {
            // Special condition for BaldrisUsers to enabled caching
            if (controller === 'BaldrisUsers' && uri === 'Active' && !forceReload) {
                return getAllFromCache(controller);
            }
            if (params) {
                return $http
                    .get(baldrisApiBase + '/api/' + controller + '/' + uri, {
                        params: params,
                    })
                    .then(getByUriComplete)
                    .catch(function (message) {
                        if (message && message.status && message.status === 404) {
                            // Not Found -> return null;
                            return null;
                        }
                        if (message.status == '401') {
                            toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                            return $q.reject(message);
                        }
                        if (!disableErrorMessage) {
                            exception.catcher('XHR Failed for getByUri at "' + controller + '"')(message);
                        }

                        return $q.reject(message);
                    });
            }

            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + uri)
                .then(getByUriComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    if (!disableErrorMessage) {
                        exception.catcher('XHR Failed for getByUri at "' + controller + '"')(message);
                    }
                    return $q.reject(message);
                });

            function getByUriComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUserId(controller, userId) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByUserId/' + userId)
                .then(getByUserIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByUserId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByUserIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByUserIdBetweenDates(controller, userId, startDate, endDate) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByUserId/' + userId + '/BetweenDates', {
                    params: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                })
                .then(getByUserIdBetweenDatesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByUserIdBetweenDates at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByUserIdBetweenDatesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getByWorkOrderId(controller, workOrderId, asDto, params) {
            asDto = asDto || false;
            params = params || { asDto: asDto };
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/ByWorkOrderId/' + workOrderId, { params: params })
                .then(getByWorkOrderIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getByWorkOrderId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getByWorkOrderIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCurrentUser() {
            if (currentUser) {
                return $q.when(currentUser);
            } else {
                return $http
                    .get(baldrisApiBase + '/api/Accounts/Current')
                    .then(getCurrentUserComplete)
                    .catch(function (message) {
                        //exception.catcher('XHR Failed for getCurrentUser')(message);
                        $state.go('app.account.login');
                    });
            }

            function getCurrentUserComplete(data, status, headers, config) {
                currentUser = data.data;
                return currentUser;
            }
        }

        function getCustomFieldDataById(controller, id, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id + '/GetCustomFieldData', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldDataByIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldDataById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldDataByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCustomFieldCategoriesById(controller, id, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + id + '/GetCustomFieldCategories', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldCategoriesByIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldCategoriesById at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldCategoriesByIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getCustomFieldsByTypeId(controller, typeId, asDto) {
            asDto = asDto || false;
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/' + typeId + '/GetCustomFields', {
                    params: {
                        asShort: asDto,
                    },
                })
                .then(getCustomFieldsByTypeIdComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getCustomFieldsByTypeId at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getCustomFieldsByTypeIdComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getLatest(controller, amount, params) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Latest/' + amount, {
                    params: params,
                })
                .then(getLatestComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getLatest at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getLatestComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getPaginatedItems(controller, pageSize, pageIndex, ids, asDto, sortField, searchString) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Items', {
                    params: {
                        pageSize: pageSize,
                        pageIndex: pageIndex,
                        ids: ids,
                        asDto: asDto,
                        sortField: sortField,
                        searchString: searchString,
                    },
                })
                .then(getPaginatedItemsComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getPaginatedItems at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getPaginatedItemsComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function getUpdateModel(controller, id) {
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/GetUpdateModel/' + id)
                .then(getUpdateModelComplete)
                .catch(function (message) {
                    if (message && message.status && message.status === 404) {
                        // Not Found -> return null;
                        return null;
                    }
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for getUpdateModel at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function getUpdateModelComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function insertItem(controller, item) {
            if (item.$type && item.$type.indexOf('Fdo') > 0) {
                controller += '/FromFdo';
            }
            return $http
                .post(baldrisApiBase + '/api/' + controller, item)
                .then(insertItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    return addToCache(controller, data.data).then(function () {
                        return data.data;
                    });
                }
                return data.data;
            }
        }

        function insertAutoProduct(controller, item) {
            return $http
                .post(baldrisApiBase + '/api/AttachedProducts', item)
                .then(insertAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertAutoProductComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function insertAutoTask(controller, item) {
            return $http
                .post(baldrisApiBase + '/api/AttachedAutoTasks', item)
                .then(insertAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for insertAutoTaskComplete at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function insertAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function search(controller, searchString, typeId, typeParameterName, params, forceReload) {
            var paramsObject = {
                params: {
                    searchString: searchString,
                },
            };

            if (typeId) {
                paramsObject.params[typeParameterName] = typeId;
            }

            if (params) {
                params.searchString = searchString;
                paramsObject.params = params;
            }
            if (isCachableCollection(controller) && !typeId && !params && !forceReload) {
                return searchInCache(controller, searchString);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Search', paramsObject)
                .then(searchComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for search at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function searchComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function searchByConfigName(controller, configName, searchString, forceReload) {
            if (isCachableCollection(controller, configName) && !forceReload) {
                return searchByConfigNameFromCache(controller, configName, searchString);
            }
            return $http
                .get(baldrisApiBase + '/api/' + controller + '/Search/ByConfigName/' + configName, {
                    params: {
                        searchString: searchString,
                    },
                })
                .then(searchByConfigNameComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for searchByConfigName at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function searchByConfigNameComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateFromUpdateModel(controller, updateModel) {
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/FromUpdateModel', updateModel)
                .then(updateFromUpdateModelComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateFromUpdateModel at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateFromUpdateModelComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateItem(controller, item) {
            if (item.$type && item.$type.indexOf('Fdo') > 0) {
                controller += '/FromFdo';
            }
            return $http
                .put(baldrisApiBase + '/api/' + controller + '/' + item.id, item)
                .then(updateItemComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateItem at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateItemComplete(data, status, headers, config) {
                if (isCachableCollection(controller)) {
                    return updateInCache(controller, item).then(function () {
                        return data.data;
                    });
                }
                return data.data;
            }
        }

        function updateAutoProduct(controller, item) {
            return $http
                .put(baldrisApiBase + '/api/AttachedProducts/' + item.id, item)
                .then(updateAutoProductComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateAutoProduct at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateAutoProductComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function updateAutoTask(controller, item) {
            return $http
                .put(baldrisApiBase + '/api/AttachedAutoTasks/' + item.id, item)
                .then(updateAutoTaskComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for updateAutoTask at "' + controller + '"')(message);
                    return $q.reject(message);
                });

            function updateAutoTaskComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function uploadFiles(files) {
            var formData = new FormData();

            angular.forEach(files, function (file) {
                formData.append(file.name, file);
            });

            return $http({
                url: baldrisApiBase + '/api/BaldrisFiles/Upload',
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': undefined },
                mimeType: 'multipart/form-data',
            })
                .then(uploadFilesComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for uploadFiles at "BaldrisFiles"')(message);
                    return $q.reject(message);
                });

            function uploadFilesComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function uploadSignature(base64String, partyId) {
            if (base64String.indexOf(',') > -1) {
                base64String = base64String.split(',')[1];
            }
            var config = {
                headers: {
                    'Content-Type': 'text/plain',
                },
            };
            return $http
                .put(baldrisApiBase + '/api/Parties/' + partyId + '/UploadSignature', base64String, config)
                .then(uploadSignatureComplete)
                .catch(function (message) {
                    if (message.status == '401') {
                        toastService.error($translate.instant('COMMON.AUTHORIZATION.ACCESS_DENIED'), $translate.instant('COMMON.AUTHORIZATION.NO_ACCESS'));
                        return $q.reject(message);
                    }
                    exception.catcher('XHR Failed for uploadSignature at BaldrisFiles"')(message);
                    return $q.reject(message);
                });

            function uploadSignatureComplete(data, status, headers, config) {
                return data.data;
            }
        }

        function prime() {
            // This function can only be called once.
            if (primePromise) {
                return primePromise;
            }

            primePromise = $q.when(true).then(success);
            return primePromise;

            function success() {
                isPrimed = true;
            }
        }

        function ready(nextPromises) {
            var readyPromise = primePromise || prime();

            return readyPromise.then(function () {
                return $q.all(nextPromises);
            });
        }

        // CACHE-METHODS
        function invalidateCache(controller, configName) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            if (configName) {
                cacheName = cacheName + '-' + configName.toLowerCase();
            }
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Invalidating cache '" + cache.name + "'...");
                    dataCache.splice(index, 1);
                    return true;
                }
            }
            return false;
        }

        function isCachableCollection(controller, configName) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            if (configName) {
                var configCacheName = cacheName + '-' + configName.toLowerCase();
                return caches.indexOf(configCacheName) > -1;
            }
            return caches.indexOf(cacheName) > -1;
        }

        function canGetByTypeFromCache(controller) {
            if (!controller) return false;
            var cacheName = controller.toLowerCase();
            return angular.isDefined(cacheTypeIdMap[cacheName]);
        }

        function getCache(controller) {
            var cacheName = controller.toLowerCase();
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Accessing cache '" + cache.name + "'...");
                    return $q.when(cache);
                }
            }
            return initializeCache(controller);
        }

        function initializeCache(controller) {
            // Special case for BaldrisUsers
            if (controller === 'BaldrisUsers') {
                return getByUri(controller, 'Active', null, true).then(function (users) {
                    var cache = {
                        name: controller.toLowerCase(),
                        data: users || [],
                    };
                    dataCache.push(cache);
                    console.log("Cache '" + cache.name + "' initialized...");
                    return cache;
                });
            }
            return getAll(controller, true).then(function (data) {
                var cache = {
                    name: controller.toLowerCase(),
                    data: data || [],
                };
                dataCache.push(cache);
                console.log("Cache '" + cache.name + "' initialized...");
                return cache;
            });
        }

        function getConfigCache(controller, configName) {
            var cacheName = controller.toLowerCase() + '-' + configName.toLowerCase();
            for (var index = 0; index < dataCache.length; index++) {
                var cache = dataCache[index];
                if (cache.name === cacheName) {
                    console.log("Accessing cache '" + cache.name + "'...");
                    return $q.when(cache);
                }
            }
            return initializeConfigCache(controller, configName);
        }

        function initializeConfigCache(controller, configName) {
            return getByConfigName(controller, configName, true).then(function (data) {
                var cache = {
                    name: controller.toLowerCase() + '-' + configName.toLowerCase(),
                    data: data || [],
                };
                dataCache.push(cache);
                console.log("Cache '" + cache.name + "' initialized...");
                return cache;
            });
        }

        function removeFromCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (item && item.id && cache && cache.data) {
                    for (var index = 0; index < cache.data.length; index++) {
                        var dataItem = cache.data[index];
                        if (dataItem.id === item.id) {
                            cache.data.splice(index, 1);
                            return true;
                        }
                    }
                }
                return false;
            });
        }

        function addToCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (!item.$type || item.$type.indexOf('Fdo') === -1) {
                    // Not a fdo-object -> fetch from server
                    return getById(controller, item.id, false, true).then(function (fetchedItem) {
                        cache.data.push(fetchedItem);
                        return true;
                    });
                }
                cache.data.push(item);
                return true;
            });
        }

        function updateInCache(controller, item) {
            return getCache(controller).then(function (cache) {
                if (!item.$type || item.$type.indexOf('Fdo') === -1) {
                    // Not a fdo-object -> fetch from server
                    return getById(controller, item.id, false, true).then(function (fetchedItem) {
                        for (var index = 0; index < cache.data.length; index++) {
                            var dataItem = cache.data[index];
                            if (dataItem.id === fetchedItem.id) {
                                cache.data.splice(index, 1);
                                cache.data.push(fetchedItem);
                                return true;
                            }
                        }
                        // If not found, push it anyways
                        cache.data.push(fetchedItem);
                        return true;
                    });
                }
                for (var index = 0; index < cache.data.length; index++) {
                    var dataItem = cache.data[index];
                    if (dataItem.id === item.id) {
                        cache.data.splice(index, 1);
                        cache.data.push(item);
                        return true;
                    }
                }
                // If not found, push it anyways
                cache.data.push(item);
                return true;
            });
        }

        function getByIdFromCache(controller, id) {
            return getCache(controller).then(function (cache) {
                for (var index = 0; index < cache.data.length; index++) {
                    var dataItem = cache.data[index];
                    if (dataItem.id === id) {
                        return dataItem;
                    }
                }
                // if not found -> return from server and add to cache
                return getById(controller, id, false, true).then(function (fetchedItem) {
                    if (fetchedItem) {
                        return addToCache(controller, fetchedItem).then(function (isAdded) {
                            return fetchedItem;
                        });
                    }
                });
            });
        }

        function getByTypeIdFromCache(controller, typeId) {
            return getCache(controller).then(function (cache) {
                var filterObject = {};
                filterObject[cacheTypeIdMap[cache.name]] = typeId;
                var typeResults = $filter('filter')(cache.data, filterObject);
                if (!typeResults || typeResults.length === 0) {
                    // Search on server if no search results
                    return getByTypeId(controller, typeId, null, true);
                }
                return typeResults;
            });
        }

        function getAllFromCache(controller) {
            return getCache(controller).then(function (cache) {
                return cache.data;
            });
        }

        function searchInCache(controller, searchString) {
            return getCache(controller).then(function (cache) {
                var searchResults = $filter('filter')(cache.data, searchString);
                if (!searchResults || searchResults.length === 0) {
                    // Search on server if no search results
                    return search(controller, searchString, null, null, null, true);
                }
                return searchResults;
            });
        }

        function getAllByConfigNameFromCache(controller, configName) {
            return getConfigCache(controller, configName).then(function (cache) {
                return cache.data;
            });
        }

        function searchByConfigNameFromCache(controller, configName, searchString) {
            return getConfigCache(controller, configName).then(function (cache) {
                var searchResults = $filter('filter')(cache.data, searchString);
                if (!searchResults || searchResults.length === 0) {
                    // Search on server if no search results
                    return searchByConfigName(controller, configName, searchString, true);
                }
                return searchResults;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.data').factory('customFieldService', customFieldService);

    /* @ngInject */
    function customFieldService($http, $q, exception) {
        var service = {
            getEmptyCustomField: getEmptyCustomField,
        };

        return service;

        function getEmptyCustomField() {
            return {
                $type: 'Baldris.Core.Data.Entities.Dto.CustomFieldDto, Baldris.Core.Data.Entities',
                id: '00000000-0000-0000-0000-000000000000',
                name: null,
                description: null,
                label: null,
                labelAlternative: false,
                englishLabel: null,
                dataTypeDiscriminator: null,
                internalName: null,
                sortOrder: 0,
                numericValueIsProductAmount: false,
                isMultiSelect: false,
                isInternal: false,
                isRequiredBySystem: false,
                allowCustom: false,
                isDeleted: false,
                customFieldCategoryId: null,
                customFieldCategory: null,
                productChoices: [],
                data: null,
                dataType: 0,
                changeState: 0,
                createdBy: null,
                createdAt: null,
                lastModifiedBy: null,
                lastModifiedAt: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('customFieldDataService', customFieldDataService);

    /* @ngInject */
    function customFieldDataService($http, $q, exception) {
        var service = {
            getEmptyCustomFieldData: getEmptyCustomFieldData,
        };

        return service;

        function getEmptyCustomFieldData(attachedTypeId, attachedTypeName) {
            return {
                labelOverride: null,
                remarks: null,
                stringData: null,
                longData: null,
                decimalData: null,
                dateTimeData: null,
                boolData: false,
                attachedTypeId: attachedTypeId || null,
                attachedTypeName: attachedTypeName || null,
                sortOrder: 0,
                dataType: 0,
                customFieldId: null,
                customField: null,
                lookupStringId: null,
                lookupString: null,
                lookupStringTypeId: null,
                lookupStringType: null,
                deceasedId: null,
                deceased: null,
                partyId: null,
                party: null,
                partyTypeId: null,
                partyType: null,
                supplierId: null,
                supplier: null,
                supplierTypeId: null,
                supplierType: null,
                participantId: null,
                participant: null,
                participantTypeId: null,
                participantType: null,
                locationId: null,
                location: null,
                locationTypeId: null,
                locationType: null,
                emailId: null,
                email: null,
                telephoneId: null,
                telephone: null,
                addressId: null,
                address: null,
                productId: null,
                product: null,
                productTypeId: null,
                productType: null,
                baldrisUserId: null,
                baldrisUser: null,
                equipmentId: null,
                equipment: null,
                equipmentTypeId: null,
                equipmentType: null,
                graveId: null,
                grave: null,
                graveTypeId: null,
                graveType: null,
                countryId: null,
                country: null,
                stateId: null,
                state: null,
                municipalityId: null,
                municipality: null,
                fileId: null,
                file: null,
                fileTypeId: null,
                fileType: null,
                externalOrderId: null,
                externalOrder: null,
                externalOrderTypeId: null,
                externalOrderType: null,
                calendarEventId: null,
                calendarEvent: null,
                calendarEventTypeId: null,
                calendarEventType: null,
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('addressTypeService', addressTypeService);

    /* @ngInject */
    function addressTypeService($http, $q, exception) {
        
        var service = {
            getAll: getAll
        };

        return service;

        function getAll() {            
            return $http.get('/api/AddressTypes')
                    .then(getAllComplete)
                    .catch(function (message) {
                        exception.catcher('XHR Failed for getAll')(message);
                });

            function getAllComplete(data, status, headers, config) {
                return data.data;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, $translatePartialLoaderProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('nb_NO');
        $translateProvider.useSanitizeValueStrategy('escape');
        
       $translatePartialLoaderProvider.addPart('app/core');
       
       // store the users language preference in a cookie
       $translateProvider.useLocalStorage();
        
        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function() {
  "use strict";

  angular.module("fuse").run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, $translate, $mdToast, tmhDynamicLocale, amMoment, authenticationService) {
    // Put the authService on $rootScope so its methods
    // can be accessed from the nav bar
    $rootScope.authenticationService = authenticationService;

    // Handle the authentication
    // result in the hash
    authenticationService.handleAuthentication();

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on("$stateChangeStart", function() {
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on("$stateChangeSuccess", function() {
      $timeout(function() {
        $rootScope.loadingProgress = false;
        $mdToast.hide();
      });
    });

    var stateChangeErrorEvent = $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
      $timeout(function() {
        $rootScope.loadingProgress = false;
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on("$destroy", function() {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
      stateChangeErrorEvent();
    });

    // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
    tmhDynamicLocale.set(
      $translate
        .preferredLanguage()
        .toLowerCase()
        .replace(/_/g, "-")
    );

    //change moment locale
    amMoment.changeLocale(
      $translate
        .preferredLanguage()
        .toLowerCase()
        .substring(0, 2)
    );
    moment.locale(
      $translate
        .preferredLanguage()
        .toLowerCase()
        .substring(0, 2)
    );
  }
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {

        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/home');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
    'use strict';

    angular.module('fuse').config(config);

    /** @ngInject */
    function config(
        tmhDynamicLocaleProvider,
        localStorageServiceProvider,
        $mdDateLocaleProvider,
        $httpProvider,
        jwtOptionsProvider,
        angularAuth0Provider,
        toastrConfig,
        $sceDelegateProvider
    ) {
        //Dynamic locale translation
        tmhDynamicLocaleProvider.localeLocationPattern('../scripts/angular-i18n/angular-locale_{{locale}}.js');

        //Local-storage
        localStorageServiceProvider.setPrefix('baldris').setNotify(true, true);

        //Dates
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        // Configure $http to use the baldris-api
        $httpProvider.interceptors.push(function ($q, $rootScope, $window) {
            return {
                request: function (config) {
                    return config;
                },
                requestError: function (rejection) {
                    return $q.reject(rejection);
                },
                response: function (response) {
                    //the same response/modified/or a new one need to be returned.
                    return response;
                },
                responseError: function (rejection) {
                    return $q.reject(rejection);
                },
            };
        });

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            newestOnTop: true,
            positionClass: 'toast-bottom-full-width',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body',
            extendedTimeOut: 1000,
            timeOut: 5000,
        });

        //Get api-base
        var apiBase = 'dev.api.baldris.no';
        var apiLegacyBase = 'dev-api.baldris.no';
        var hostname = window.location.hostname;
        var protocol = window.location.protocol;
        if (hostname.indexOf('baldris.no') > -1) {
            apiBase = hostname.replace('.beta', '').replace('.baldris', '.api.baldris');
            apiLegacyBase = hostname.replace('.beta', '').replace('.baldris', '-api.baldris');
        }
        if (hostname.indexOf('localhost') > -1) {
            hostname += ':3000';
            apiBase = 'localhost:5101';
            apiLegacyBase = 'localhost:5102';
        }

        // Whitelist sce
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            protocol + '//' + apiBase + '/**',
            protocol + '//' + apiLegacyBase + '/**',
            'https://images.baldris.no/**',
            'https://baldrisdev.blob.core.windows.net/**',
            'https://stbaldristenantdatadev01.blob.core.windows.net/**',
            'https://baldrisprod1.blob.core.windows.net/**',
            'https://stbaldristenantdataprd01.blob.core.windows.net/**',
            'https://baldrisprodnorwayeast1.blob.core.windows.net/**',
        ]);

        var REQUESTED_SCOPES =
            'openid email user_metadata app_metadata picture delete:invoice ' +
            'delete:users delete:workOrders manage:advancedSettings manage:autoProduct ' +
            'manage:autoTask manage:finance manage:products read:invoice ' +
            'read:salesStatistics read:userStatistics read:users read:workOrderStatistics ' +
            'read:workOrders write:invoice write:users write:workOrders manage:tenants' +
            'send:email delete:privacyData write:privacyData read:privacyData' +
            'manage:contact manage:location write:calendar read:calendar delete:calendar';

        // Initialization for the angular-auth0 library
        angularAuth0Provider.init({
            clientID: 'yCilGeirMGAPUTyxhWaltKXJ1FJ9qHXt',
            domain: 'piksl.eu.auth0.com',
            responseType: 'token id_token',
            audience: 'https://api.baldris.no',
            redirectUri: protocol + '//' + hostname + '/account/callback',
            scope: REQUESTED_SCOPES,
        });

        // Configuration for angular-jwt
        jwtOptionsProvider.config({
            tokenGetter: function () {
                return localStorage.getItem('access_token');
            },
            whiteListedDomains: [apiBase, apiLegacyBase, 'localhost'],
        });

        // Add the jwtInterceptor to the array of HTTP interceptors
        // so that JWTs are attached as Authorization headers
        $httpProvider.interceptors.push('jwtInterceptor');
    }

    //Config gravatar
    angular.module('ui.gravatar').config([
        'gravatarServiceProvider',
        function (gravatarServiceProvider) {
            gravatarServiceProvider.defaults = {
                size: 40,
                default: 'retro',
            };
        },
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function() {
    'use strict';

    angular
        .module('baldris.user', [

        ]);
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"md-hue-2\" \nms-scroll ui-view=\"content\" flex></md-content><div id=\"reportViewer1\"></div></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/account/account.tmpl.html","<div class=\"account-view\" ui-view></div>");
$templateCache.put("app/main/calendar/calendar.tmpl.html","<div id=\"calendar\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'calendar-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s24\"></md-icon></span><span class=\"logo-text\">{{ vm.currentData.titleText }}</span>\n</div><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'calendar-sidenav-right\')\" aria-label=\"Toggle notes and tasks\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"calendar-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/calendar/views/main-sidenav/calendar-main-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"main-wrapper\"><div class=\"calendar-top-nav\" ui-view=\"toolbar\"></div><div ms-scroll class=\"scrollable main\" \nui-view=\"content\"></div></div><md-sidenav class=\"sidenav md-sidenav-right calendar-sidenav-right md-white-bg\" \nms-scroll md-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"calendar-sidenav-right\">\n<div class=\"calendar-sidenav-right-view\" ui-view=\"sidenav-right\"></div></md-sidenav><md-fab-speed-dial \nmd-direction=\"left\" md-open=\"vm.isFabOpen\" class=\"md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-accent\"><md-tooltip md-direction=\"top\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE_OR_TASK\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add Note\" \nclass=\"md-fab md-raised md-mini note-button\" ng-click=\"vm.service.noteOrTaskApi.addNote($event)\"><md-tooltip \nmd-direction=\"top\">{{ \"NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-note\" aria-label=\"Note\"></md-icon></md-button><md-button aria-label=\"Add Task\" \nclass=\"md-fab md-raised md-mini task-button\" ng-click=\"vm.service.noteOrTaskApi.addTask($event)\"><md-tooltip \nmd-direction=\"top\">{{ \"NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_TASK\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-checkbox-marked\" aria-label=\"Task\"></md-icon></md-button><md-button aria-label=\"Add Event\" \nclass=\"md-fab md-raised md-mini event-button\" ng-click=\"vm.service.addCalendarEvent($event)\"><md-tooltip \nmd-direction=\"top\">{{ \"CALENDAR.ADD_EVENT\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-calendar-plus\" \naria-label=\"Event\"></md-icon></md-button><md-button aria-label=\"Add Event\" \nclass=\"md-fab md-raised md-mini incoming-button\" ng-click=\"vm.service.addIncomingWorkOrder($event)\"><md-tooltip \nmd-direction=\"top\">{{ \"CALENDAR.ADD_INCOMING_WORK_ORDER\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-briefcase\" aria-label=\"Event\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div>\n</div>");
$templateCache.put("app/main/export/export.tmpl.html","<div id=\"baldris-export\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-export\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"MENU.EXPORT.EXPORT\">Export\n</span></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/export/partials/export-sidenav.tmpl.html\'\"></md-sidenav><div class=\"main\" ui-view ms-scroll>\n</div></div></div>");
$templateCache.put("app/main/home/home.tmpl.html","<div id=\"home\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-home\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.HOME.HOME\">Home</span></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\"><div layout=\"column\" layout-padding class=\"welcome-text white-bg\" \nmd-whiteframe=\"1\"><h2 translate=\"HOME.WELCOME_TEXT\" \ntranslate-values=\"{userName: vm.currentUser.firstName || vm.currentUser.displayName}\">Welcome!</h2></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex flex-gt-sm=\"50\" class=\"widget-collection\"><ms-widget layout=\"column\">\n<ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">{{ \"HOME.EVENTS.TITLE\" | translate }}</div>\n</div><md-content ng-if=\"!vm.data.isLoadingEvents\"><calendar-event-list \nng-if=\"vm.data.upcomingEvents.data && vm.data.upcomingEvents.data.length > 0\" collection=\"vm.data.upcomingEvents.data\" \nhide-add-button=\"true\" create-date-groups=\"true\" on-open=\"(vm.data.navigateToCalendarEvent)\"></calendar-event-list><p \nclass=\"padding-10\" ng-if=\"!vm.data.upcomingEvents || vm.data.upcomingEvents.length === 0\" \ntranslate=\"HOME.EVENTS.NO_EVENTS\"></p></md-content><md-content ng-if=\"vm.data.isLoadingEvents\" layout=\"row\" \nlayout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</md-content></ms-widget-front></ms-widget><ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"HOME.WORK_ORDERS.TITLE\" | translate }}</div></div><md-content \nng-if=\"!vm.data.isLoadingWorkOrders\"><work-order-list-item \nng-if=\"vm.data.workOrders.data && vm.data.workOrders.data.length > 0\" baldris-model=\"workOrder\" \nng-repeat=\"workOrder in vm.data.workOrders.data\"></work-order-list-item><p class=\"padding-10\" \nng-if=\"!vm.data.workOrders || vm.data.workOrders.length === 0\" translate=\"HOME.WORK_ORDERS.NO_EVENTS\"></p></md-content>\n<md-content ng-if=\"vm.data.isLoadingWorkOrders\" layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content></ms-widget-front></ms-widget></div>\n<div class=\"widget-collection\" flex-gt-sm=\"50\"><ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"HOME.NOTES_OR_TASKS.TITLE\" | translate }}</div></div><md-content \nng-if=\"!vm.data.isLoadingNoteOrTasks\"><note-or-task-list \nng-if=\"vm.data.noteOrTasks.data && vm.data.noteOrTasks.data.length > 0\" collection=\"vm.data.noteOrTasks.data\" \ncreate-date-groups=\"true\" inheritance-type=\"Calendar\" calendar-start-date=\"vm.data.selectedDate\" \nhide-add-button=\"true\" api=\"vm.service.noteOrTaskApi\" show-work-order-info=\"true\"></note-or-task-list><p \nclass=\"padding-10\" ng-if=\"!vm.data.noteOrTasks.data || vm.data.noteOrTasks.data.length === 0\" \ntranslate=\"HOME.NOTES_OR_TASKS.NO_EVENTS\"></p></md-content><md-content ng-if=\"vm.data.isLoadingNoteOrTasks\" \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></md-content></ms-widget-front></ms-widget></div></div></div></div></div>");
$templateCache.put("app/main/statistics/statistics.tmpl.html","<div id=\"statistics\" class=\"two-sidebars-toolbar page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"COMMON.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-line\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ \"MENU.STATISTICS.STATISTICS\" | translate }}</span></div><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'statistics-sidenav-right\')\" aria-label=\"Toggle notes and tasks\" translate \ntranslate-attr-aria-label=\"COMMON.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n</div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/statistics/views/sidebar.tmpl.html\'\"></md-sidenav><div class=\"toolbar-top-nav\" ui-view=\"toolbar\">\n</div><div class=\"main\" ui-view=\"content\" ms-scroll></div><md-sidenav \nclass=\"sidenav md-sidenav-right common-sidenav-right md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"statistics-sidenav-right\"><div class=\"work-order-sidenav-right-view\" \nui-view=\"sidenav-right\"></div></md-sidenav></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/account/callback/callback.tmpl.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\"><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"/assets/images/logos/baldris-logo.svg\" alt=\"baldris-logo\"></div><div layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>\n</div>");
$templateCache.put("app/main/account/login/login.tmpl.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\"><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"/assets/images/logos/baldris-logo.svg\" alt=\"baldris-logo\"></div><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to your account</div><md-button ng-click=\"vm.authenticationService.login()\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></div></div></div>");
$templateCache.put("app/main/booking/edit-booking/edit-booking.tmpl.html","<div class=\"edit-booking\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.bookingForm\" ng-if=\"!vm.loadingService.isLoading && vm.data.updateModel\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'CALENDAR.EVENT.GENERAL\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/booking/edit-booking/views/calendar-event.tmpl.html\'\"></md-content><md-content \nlayout-padding layout=\"column\"><md-input-container flex><label>{{\'CALENDAR.EVENT.REMARKS\' | translate }}</label>\n<textarea ng-model=\"vm.data.updateModel.calendarEvent.remarks\"></textarea></md-input-container></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\'\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'\"></edit-custom-field></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\" class=\"margin-left-20 margin-right-20\"><md-button \nclass=\"md-warn\" ng-click=\"vm.deleteCalendarEvent($event)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\">\n{{ \'CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\' | translate}}</md-button><span flex></span><md-button \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\">\n{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/calendar/day-view/day-view.tmpl.html","<div class=\"day-view-events\" md-whiteframe=\"1\" layout-margin><calendar-event-list ng-if=\"!vm.loadingService.isLoading\" \ncollection=\"vm.events\" start-date=\"vm.currentDate\" end-date=\"vm.currentDate\" should-create-empty-work-hours=\"true\" \non-open=\"vm.service.navigateToCalendarEvent(calendarEvent)\" api=\"vm.service.calendarEventApi\"></calendar-event-list>\n</div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/calendar/edit-calendar-event/edit-calendar-event.tmpl.html","<div class=\"edit-calendar-event\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.calendarEventForm\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'CALENDAR.EVENT.GENERAL\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/calendar/edit-calendar-event/views/calendar-event.tmpl.html\'\"></md-content>\n<md-content layout-padding layout=\"column\"><md-input-container class=\"md-block\"><label>\n{{\'CEREMONIES.CEREMONY.REMARKS\' | translate }}</label><textarea ng-model=\"vm.data.updateModel.calendarEvent.remarks\">\n</textarea></md-input-container></md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" \nlayout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\' | filter:vm.data.customFieldCategoryFilter\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingCustomFieldData\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'  | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget><div ng-if=\"vm.data.isLoadingCustomFieldData\" flex \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingEquipment\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'CEREMONIES.CEREMONY.EQUIPMENT\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditCalendarEventEquipmentDialog(null, $event)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"><md-tooltip md-direction=\"top\">\n<span translate=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content layout-padding layout=\"column\" class=\"md-padding\"><md-list><md-list-item \nclass=\"md-2-line\" \nng-repeat=\"ceremonyEquipment in vm.data.updateModel.equipment | filter:{ changeState: \'!3\' } | orderBy:\'sortOrder\'\" \nng-click=\"vm.data.openEditCalendarEventEquipmentDialog(ceremonyEquipment, $event)\"><img \nng-if=\"ceremonyEquipment.equipmentImageFilepath\" baldris-img-src=\"ceremonyEquipment.equipmentImageFilepath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ceremonyEquipment.equipmentName}}\"><div class=\"md-list-item-text\">\n<h3>{{ ceremonyEquipment.amount || 0 }} stk. {{ ceremonyEquipment.equipmentName }}</h3><p>\n{{ ceremonyEquipment.equipmentType }}</p></div></md-list-item></md-list></md-content></ms-widget-front></ms-widget><div\n ng-if=\"vm.data.isLoadingEquipment\" flex layout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div></div><div layout=\"row\" class=\"margin-left-20 margin-right-20\">\n<md-button class=\"md-warn\" ng-click=\"vm.deleteCalendarEvent($event)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\">\n{{ \'CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\' | translate}}</md-button><span flex></span><md-button \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\">\n{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/calendar/week-view/week-view.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\" class=\"week-view-events\"><div class=\"calendar-week\" layout=\"column\"><div \nclass=\"mon-wed\" layout=\"column\" layout-xl=\"row\"><div flex layout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div \nng-if=\"vm.dateGroups[0].start\" layout=\"row\" class=\"date-group-calendar-header clickable\" \nng-click=\"vm.navigateToDayView(vm.dateGroups[0].start)\"><h3 class=\"day md-primary-bg\">\n{{vm.dateGroups[0].start | date:\'EEEE\'}}</h3><h4 class=\"date\">{{vm.dateGroups[0].start | date:\'longDate\'}}</h4></div>\n<div ng-if=\"!vm.dateGroups[0].start\" layout=\"row\" class=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--\n</h3><h4 class=\"date\">{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\">\n<calendar-event-list-item-small ng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" \nbaldris-model=\"event\" ng-repeat-start=\"event in vm.dateGroups[0].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[0].events || vm.dateGroups[0].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[0].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[0].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[0].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[0].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div><div flex \nlayout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div ng-if=\"vm.dateGroups[1].start\" layout=\"row\" \nclass=\"date-group-calendar-header clickable\" ng-click=\"vm.navigateToDayView(vm.dateGroups[1].start)\"><h3 \nclass=\"day md-primary-bg\">{{vm.dateGroups[1].start | date:\'EEEE\'}}</h3><h4 class=\"date\">\n{{vm.dateGroups[1].start | date:\'longDate\'}}</h4></div><div ng-if=\"!vm.dateGroups[1].start\" layout=\"row\" \nclass=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--</h3><h4 class=\"date\">\n{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\"><calendar-event-list-item-small \nng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" baldris-model=\"event\" \nng-repeat-start=\"event in vm.dateGroups[1].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[1].events || vm.dateGroups[1].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[1].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[1].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[1].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[1].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div><div flex \nlayout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div ng-if=\"vm.dateGroups[2].start\" layout=\"row\" \nclass=\"date-group-calendar-header clickable\" ng-click=\"vm.navigateToDayView(vm.dateGroups[2].start)\"><h3 \nclass=\"day md-primary-bg\">{{vm.dateGroups[2].start | date:\'EEEE\'}}</h3><h4 class=\"date\">\n{{vm.dateGroups[2].start | date:\'longDate\'}}</h4></div><div ng-if=\"!vm.dateGroups[2].start\" layout=\"row\" \nclass=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--</h3><h4 class=\"date\">\n{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\"><calendar-event-list-item-small \nng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" baldris-model=\"event\" \nng-repeat-start=\"event in vm.dateGroups[2].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[2].events || vm.dateGroups[2].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[2].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[2].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[2].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[2].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div></div><div \nclass=\"thu-fri\" layout=\"column\" layout-xl=\"row\"><div flex layout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div \nng-if=\"vm.dateGroups[3].start\" layout=\"row\" class=\"date-group-calendar-header clickable\" \nng-click=\"vm.navigateToDayView(vm.dateGroups[3].start)\"><h3 class=\"day md-primary-bg\">\n{{vm.dateGroups[3].start | date:\'EEEE\'}}</h3><h4 class=\"date\">{{vm.dateGroups[3].start | date:\'longDate\'}}</h4></div>\n<div ng-if=\"!vm.dateGroups[3].start\" layout=\"row\" class=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--\n</h3><h4 class=\"date\">{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\">\n<calendar-event-list-item-small ng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" \nbaldris-model=\"event\" ng-repeat-start=\"event in vm.dateGroups[3].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[3].events || vm.dateGroups[3].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[3].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[3].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[3].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[3].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div><div flex \nlayout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div ng-if=\"vm.dateGroups[4].start\" layout=\"row\" \nclass=\"date-group-calendar-header clickable\" ng-click=\"vm.navigateToDayView(vm.dateGroups[4].start)\"><h3 \nclass=\"day md-primary-bg\">{{vm.dateGroups[4].start | date:\'EEEE\'}}</h3><h4 class=\"date\">\n{{vm.dateGroups[4].start | date:\'longDate\'}}</h4></div><div ng-if=\"!vm.dateGroups[4].start\" layout=\"row\" \nclass=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--</h3><h4 class=\"date\">\n{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\"><calendar-event-list-item-small \nng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" baldris-model=\"event\" \nng-repeat-start=\"event in vm.dateGroups[4].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[4].events || vm.dateGroups[4].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[4].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[4].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[4].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[4].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div></div><div \nclass=\"sat-sun\" layout=\"column\" layout-xl=\"row\"><div flex layout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div \nng-if=\"vm.dateGroups[5].start\" layout=\"row\" class=\"date-group-calendar-header clickable\" \nng-click=\"vm.navigateToDayView(vm.dateGroups[5].start)\"><h3 class=\"day md-primary-bg\">\n{{vm.dateGroups[5].start | date:\'EEEE\'}}</h3><h4 class=\"date\">{{vm.dateGroups[5].start | date:\'longDate\'}}</h4></div>\n<div ng-if=\"!vm.dateGroups[5].start\" layout=\"row\" class=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--\n</h3><h4 class=\"date\">{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\">\n<calendar-event-list-item-small ng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" \nbaldris-model=\"event\" ng-repeat-start=\"event in vm.dateGroups[5].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[5].events || vm.dateGroups[5].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[5].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[5].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[5].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[5].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div><div flex \nlayout=\"column\" class=\"calendar-day\" md-whiteframe=\"1\"><div ng-if=\"vm.dateGroups[6].start\" layout=\"row\" \nclass=\"date-group-calendar-header clickable\" ng-click=\"vm.navigateToDayView(vm.dateGroups[6].start)\"><h3 \nclass=\"day md-primary-bg\">{{vm.dateGroups[6].start | date:\'EEEE\'}}</h3><h4 class=\"date\">\n{{vm.dateGroups[6].start | date:\'longDate\'}}</h4></div><div ng-if=\"!vm.dateGroups[6].start\" layout=\"row\" \nclass=\"date-group-calendar-header\"><h3 class=\"day md-primary-bg\">--</h3><h4 class=\"date\">\n{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</h4></div><div flex layout=\"column\"><calendar-event-list-item-small \nng-if=\"vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\" baldris-model=\"event\" \nng-repeat-start=\"event in vm.dateGroups[6].events | orderBy:vm.orderEvents\" \non-open=\"vm.service.navigateToCalendarEvent(event)\"></calendar-event-list-item-small><md-divider ng-repeat-end \nng-if=\"!$last && vm.weekViewService.isCalendarEventTypeSelected(event.calendarEventTypeId)\"></md-divider><div \nng-if=\"!vm.dateGroups[6].events || vm.dateGroups[6].events.length === 0\" class=\"no-events\">\n{{ \'CALENDAR.WEEK_VIEW.NO_EVENTS\' | translate }}</div><div flex></div><div class=\"note-and-task-count\" \nng-click=\"vm.openViewNoteOrTasksDialog($event)\"><md-progress-linear ng-if=\"vm.dateGroups[6].isLoading\" md-mode=\"query\">\n</md-progress-linear><notes-and-tasks-summary completed-count=\"vm.dateGroups[6].notesAndTaskCount.completedTasks\" \nuncompleted-count=\"vm.dateGroups[6].notesAndTaskCount.uncompletedTasks\" \nnotes-count=\"vm.dateGroups[6].notesAndTaskCount.notes\"></notes-and-tasks-summary></div></div></div></div></div></div>\n<div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" layout-padding>\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/ceremony/edit-ceremony/edit-ceremony.tmpl.html","<div class=\"edit-ceremony\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.calendarEventForm\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'CEREMONIES.EDIT_CEREMONY.GENERAL\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" ng-include=\"\'app/main/ceremony/edit-ceremony/views/ceremony-calendar-event.tmpl.html\'\">\n</md-content><md-content layout-padding layout=\"column\"><div><md-checkbox \nng-model=\"vm.data.updateModel.calendarEvent.isSilentCeremony\" \naria-label=\"{{ \'CEREMONIES.CEREMONY.IS_SILENT_CEREMONY\' | translate }}\">\n{{ \'CEREMONIES.CEREMONY.IS_SILENT_CEREMONY\' | translate }}</md-checkbox></div><lookup-string-select \nlookup-string=\"vm.data.updateModel.calendarEvent.liturgyObject\" \nlookup-string-id=\"vm.data.updateModel.calendarEvent.liturgyObjectId\" lookup-string-config=\"\'LiturgyLookupStringType\'\" \nmin-query-length=\"0\" allow-custom=\"true\" custom-value=\"vm.data.updateModel.calendarEvent.liturgy\" \nlabel-text=\"{{\'CEREMONIES.CEREMONY.LITURGY\' | translate}}\"></lookup-string-select><div><md-input-container \nclass=\"md-block\"><label>{{\'CEREMONIES.CEREMONY.REMARKS\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.calendarEvent.remarks\"></textarea></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'CEREMONIES.CEREMONY.REMARKS_AUTHORITIES\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.calendarEvent.remarksSupplier\"></textarea></md-input-container></div></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\' | filter:vm.data.customFieldCategoryFilter\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingCustomFieldData\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'  | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget><div ng-if=\"vm.data.isLoadingCustomFieldData\" flex \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingEquipment\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'CEREMONIES.CEREMONY.EQUIPMENT\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditCalendarEventEquipmentDialog(null, $event)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"><md-tooltip md-direction=\"top\">\n<span translate=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content layout-padding layout=\"column\" class=\"md-padding\"><md-list><md-list-item \nclass=\"md-2-line\" \nng-repeat=\"ceremonyEquipment in vm.data.updateModel.equipment | filter:{ changeState: \'!3\' } | orderBy:\'sortOrder\'\" \nng-click=\"vm.data.openEditCalendarEventEquipmentDialog(ceremonyEquipment, $event)\"><img \nng-if=\"ceremonyEquipment.equipmentImageFilepath\" baldris-img-src=\"ceremonyEquipment.equipmentImageFilepath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ceremonyEquipment.equipmentName}}\"><div class=\"md-list-item-text\">\n<h3>{{ ceremonyEquipment.amount || 0 }} stk. {{ ceremonyEquipment.equipmentName }}</h3><p>\n{{ ceremonyEquipment.equipmentType }}</p></div></md-list-item></md-list></md-content></ms-widget-front></ms-widget><div\n ng-if=\"vm.data.isLoadingEquipment\" flex layout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div></div><div layout=\"row\" class=\"margin-left-20 margin-right-20\" \nng-if=\"!vm.loadingService.isLoading\"><md-button class=\"md-warn\" ng-click=\"vm.deleteCalendarEvent($event)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\">\n{{ \'CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\' | translate}}</md-button><span flex></span><md-button \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\">\n{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/deceased/edit-deceased/edit-deceased.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.deceasedForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-deceased-form\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'DECEASED.PERSONALIA\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/personalia.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'DECEASED.AFFECTED_MUNICIPALITIES\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/municipalities.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'DECEASED.DEATH_CIRCUMSTANCES\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/death-circumstances.html\'\">\n</md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'DECEASED.PROBATE\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/probate.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'DECEASED.CITIZENSHIP_AND_RELIGION\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/citizenship-and-religion.html\'\">\n</md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'DECEASED.MISCELLANEOUS\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/deceased/edit-deceased/views/miscellaneous.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\' | filter:vm.data.customFieldCategoryFilter\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingCustomFieldData\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'  | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" \nng-click=\"vm.exitView()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.deceasedForm.$pristine\">\n{{ \'DECEASED.EDIT_DECEASED_DIALOG.SAVE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/export/partials/export-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.EXPORT.EXPORT_TYPES\" | translate }}</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.export.referencePersons\"><p><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon>{{ \"MENU.EXPORT.REFERENCE_PERSONS\" | translate }}</p>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/export/reference-persons/export-reference-persons.tmpl.html","<div class=\"export-range md-background-bg\" md-whiteframe=\"1\" layout=\"column\"><div class=\"pb-16 header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"EXPORT.REFERENCE_PERSONS.FILTER_RESULTS\">Filter results</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"filters\"><div layout=\"column\" layout-padding flex-gt-sm=\"50\">\n<date-range-select start-date=\"vm.startDate\" end-date=\"vm.endDate\" on-update=\"vm.onUpdate()\" \nlabel-start-text=\"{{ \'SALES_ORDERS.INVOICE_JOURNAL.START_DATE\' | translate }}\" \nlabel-end-text=\"{{ \'SALES_ORDERS.INVOICE_JOURNAL.END_DATE\' | translate }}\"></date-range-select><p class=\"help-text\">\n{{ \"EXPORT.REFERENCE_PERSONS.DATES_WHEN_WORK_ORDER_CREATED\" | translate }}</p></div><div layout=\"column\" \nlayout-padding flex-gt-sm=\"50\"><work-order-type-multi-select work-order-type-ids=\"vm.selectedWorkOrderTypeIds\" \nwork-order-types=\"vm.selectedWorkOrderTypes\" \nlabel-text=\"{{ \'EXPORT.REFERENCE_PERSONS.FILTER_BY_WORK_ORDER_TYPES\' | translate }}\" on-update=\"vm.onUpdate()\">\n</work-order-type-multi-select><p class=\"help-text\">\n{{ \"EXPORT.REFERENCE_PERSONS.FILTER_WILL_MATCH_ON_EITHER_RESULTS\" | translate }}</p></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"filters\"><div layout=\"column\" layout-padding flex-gt-sm=\"50\">\n<reference-person-type-multi-select reference-person-types=\"vm.selectedReferencePersonTypes\" \nreference-person-type=\"vm.selectedReferencePersonType\" \nlabel-text=\"{{ \'EXPORT.REFERENCE_PERSONS.FILTER_BY_REFERENCE_PERSON_TYPE\' | translate }}\" on-update=\"vm.onUpdate()\">\n</reference-person-type-multi-select><p class=\"help-text\">\n{{ \"EXPORT.REFERENCE_PERSONS.FILTER_WILL_ONLY_MATCH_WHEN_ALL_TYPES_CORRESPOND\" | translate }}</p></div><div \nlayout=\"column\" layout-padding flex-gt-sm=\"50\"><privacy-field-multi-select \nprivacy-field-ids=\"vm.selectedPrivacyFieldIds\" privacy-fields=\"vm.selectedPrivacyFieldss\" \nlabel-text=\"{{ \'EXPORT.REFERENCE_PERSONS.FILTER_BY_PRIVACY_FIELD\' | translate }}\" on-update=\"vm.onUpdate()\">\n</privacy-field-multi-select><p class=\"help-text\">\n{{ \"EXPORT.REFERENCE_PERSONS.FILTER_WILL_MATCH_ON_EITHER_RESULTS\" | translate }}</p></div></div></div><div \nclass=\"result md-background-bg\" md-whiteframe=\"1\"><div class=\"header pb-16\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-chart-line\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\"><span \ntranslate=\"EXPORT.REFERENCE_PERSONS.RESULTS\">Results</span> <span ng-if=\"vm.result.length > 0\">({{ vm.result.length }})\n</span></div><span flex></span><md-button ng-if=\"vm.result.length > 0\" class=\"md-icon-button\" \nng-click=\"vm.downloadAsCsv()\"><md-tooltip md-direction=\"left\">{{ \"EXPORT.DOWNLOAD_AS_CSV\" | translate }}</md-tooltip>\n<md-icon md-font-icon=\"icon-download\" class=\"m-0 mr-16\"></md-icon></md-button></div><md-progress-linear \nng-if=\"vm.loadingService.isLoading\" md-mode=\"query\"></md-progress-linear><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPORT.REFERENCE_PERSONS.NAME\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"EXPORT.REFERENCE_PERSONS.ADDRESS\">Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EXPORT.REFERENCE_PERSONS.EMAIL\">\nEmail</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPORT.REFERENCE_PERSONS.TELEPHONE\">Telephone</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPORT.REFERENCE_PERSONS.WORK_ORDER\">Work Order</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPORT.REFERENCE_PERSONS.DECEASED\">Deceased</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.result\"><td>{{::item.displayName}}</td><td>{{::item.addressSerialized}}</td><td>{{::item.email}}\n</td><td>{{::item.telephone }}</td><td>{{::item.workOrderCode }}</td><td>{{::item.allDeceased }}</td></tr></tbody>\n</table></div>");
$templateCache.put("app/main/flower-order/edit-flower-order/edit-flower-order.tmpl.html","<div class=\"edit-flower-order\"><div ng-if=\"vm.loadingService.isLoading\" layout=\"column\" layout-margin \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.flowerOrderForm\" ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\">\n<ms-widget flex layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'FLOWER_ORDERS.FLOWER_ORDER.FLOWER_ORDER\' | translate}}</div></div><md-content layout-padding layout=\"column\">\n<supplier-select supplier=\"vm.data.updateModel.flowerOrder.supplier\" \nsupplier-id=\"vm.data.updateModel.flowerOrder.supplierId\" supplier-config=\"\'FlowerDistributorSupplierType\'\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.SUPPLIER\' | translate}}\"></supplier-select><upcoming-ceremony-select \nceremony=\"vm.data.updateModel.flowerOrder.calendarEvent\" ceremony-id=\"vm.data.updateModel.flowerOrder.calendarEventId\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.CEREMONY\' | translate}}\" \nwork-order-id=\"vm.data.updateModel.flowerOrder.workOrderId\" \ndepartment-id=\"vm.data.updateModel.flowerOrder.workOrder.departmentId\" on-selected=\"vm.data.onCeremonyChanged\">\n</upcoming-ceremony-select><location-select location=\"vm.data.updateModel.flowerOrder.deliveryLocation\" \nlocation-id=\"vm.data.updateModel.flowerOrder.deliveryLocationId\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.DELIVERY_LOCATION\' | translate}}\"></location-select><date-time-select \nng-model=\"vm.data.updateModel.flowerOrder.deliveryTime\" \nlabel-date-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.DELIVERY_DATE\' | translate}}\" \nlabel-time-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.DELIVERY_TIME\' | translate}}\"></date-time-select><div>\n<md-input-container class=\"md-block\"><label>{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.REMARKS\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.flowerOrder.remarks\"></textarea></md-input-container></div></md-content>\n</ms-widget-front></ms-widget><ms-widget flex layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'FLOWER_ORDERS.FLOWER_ORDER.FLOWERS\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.editFlower(null, $event)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_ADDITION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"FLOWER_ORDERS.FLOWER_ORDER.EDIT_FLOWER_ORDER.ADD_FLOWER\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content layout=\"column\" class=\"flower-content\"><md-list \nclass=\"flower-list\" flex><div ng-repeat=\"flower in vm.data.updateModel.flowers | orderBy:\'flower.sortOrder\'\">\n<md-list-item class=\"md-3-line\" ng-click=\"vm.data.editFlower(flower, $event)\"><img ng-if=\"flower.productImageUrl\" \nbaldris-img-src=\"flower.productImageUrl\" preset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{flower.flower.name}}\"><div\n class=\"md-list-item-text\" layout=\"column\"><h3>\n{{flower.amount}} stk. {{ flower.name }} - {{flower.historicalPriceIncludingVat | currency}} <span \nng-if=\"flower.flower.amount > 1\">({{flower.historicalPriceIncludingVat * flower.flower.amount | currency}})</span></h3>\n<h4>{{ flower.remarks }}</h4><p><ul><li ng-repeat=\"ribbon in flower.ribbons | orderBy:\'sortOrder\' \">\n{{ ribbon.text }} // {{ ribbon.names }}</li></ul></p></div></md-list-item><md-divider ng-if=\"!$last\"></md-divider>\n</div></md-list></md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\'\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'\"></edit-custom-field></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.Cancel\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}\n</md-button><md-button ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.flowerOrderForm.$pristine\" \naria-label=\"Save\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}\n</md-button></div></md-content></div>");
$templateCache.put("app/main/grave/edit-grave/edit-grave.tmpl.html","<div class=\"edit-grave\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.graveForm\"><md-content class=\"content\" ng-if=\"!vm.loadingService.isLoading\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'GRAVES.EDIT_GRAVE.GENERAL\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grave/edit-grave/views/grave-general.tmpl.html\'\"></md-content></ms-widget-front></ms-widget>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'GRAVES.EDIT_GRAVE.TEMPORARY_MARKER\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grave/edit-grave/views/grave-temporary-marker.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'GRAVES.EDIT_GRAVE.LEASE_HOLDER\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grave/edit-grave/views/grave-lease-holder.tmpl.html\'\"></md-content></ms-widget-front></ms-widget>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'GRAVES.EDIT_GRAVE.PREVIOUSLY_BURIED\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grave/edit-grave/views/grave-previously-buried.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\'\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'\"></edit-custom-field></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CANCEL\">{{ \'GRAVES.EDIT_GRAVE.CANCEL\' | translate}}\n</md-button><md-button ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.graveForm.$pristine\" \naria-label=\"Save\" translate-attr-aria-label=\"GRAVES.EDIT_GRAVE.SAVE\">{{ \'GRAVES.EDIT_GRAVE.SAVE\' | translate}}\n</md-button></div></md-content></div></div>");
$templateCache.put("app/main/grooming/edit-grooming/edit-grooming.tmpl.html","<div class=\"edit-grooming\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.calendarEventForm\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'GROOMINGS.EDIT_GROOMING.TIME_AND_PLACE\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grooming/edit-grooming/views/grooming-calendar-event.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'GROOMINGS.EDIT_GROOMING.GROOMING_DETAILS\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grooming/edit-grooming/views/grooming-general.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget ng-if=\"!vm.loadingService.isLoading && vm.data.isFlagSet(\'isTransport\')\" flex flex-gt-lg=\"50\" \nlayout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'GROOMINGS.EDIT_GROOMING.TRANSPORT\' | translate}}</div></div><md-content \nng-include=\"\'app/main/grooming/edit-grooming/views/grooming-transport.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\' | filter:vm.data.customFieldCategoryFilter\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingCustomFieldData\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'  | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget><div ng-if=\"vm.data.isLoadingCustomFieldData\" flex \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingEquipment\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'CEREMONIES.CEREMONY.EQUIPMENT\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditCalendarEventEquipmentDialog(null, $event)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"><md-tooltip md-direction=\"top\">\n<span translate=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content layout-padding layout=\"column\" class=\"md-padding\"><md-list><md-list-item \nclass=\"md-2-line\" \nng-repeat=\"ceremonyEquipment in vm.data.updateModel.equipment | filter:{ changeState: \'!3\' } | orderBy:\'sortOrder\'\" \nng-click=\"vm.data.openEditCalendarEventEquipmentDialog(ceremonyEquipment, $event)\"><img \nng-if=\"ceremonyEquipment.equipmentImageFilepath\" baldris-img-src=\"ceremonyEquipment.equipmentImageFilepath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ceremonyEquipment.equipmentName}}\"><div class=\"md-list-item-text\">\n<h3>{{ ceremonyEquipment.amount || 0 }} stk. {{ ceremonyEquipment.equipmentName }}</h3><p>\n{{ ceremonyEquipment.equipmentType }}</p></div></md-list-item></md-list></md-content></ms-widget-front></ms-widget><div\n ng-if=\"vm.data.isLoadingEquipment\" flex layout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div></div><div layout=\"row\" class=\"margin-left-20 margin-right-20\">\n<md-button class=\"md-warn\" ng-click=\"vm.deleteCalendarEvent($event)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\">\n{{ \'CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\' | translate}}</md-button><span flex></span><md-button \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\">\n{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/edit-obituary-notice.tmpl.html","<div class=\"edit-obituary-notice\"><md-content class=\"content\" ng-form=\"vm.data.validation.obituaryNoticeForm\"><div \nlayout=\"column\" layout-gt-md=\"row\" layout-wrap><ms-widget ng-if=\"vm.data.updateModel.obituaryNotice\" flex=\"100\" \nflex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.GENERAL\" | translate }}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/obituary-notice/edit-obituary-notice/views/obituary-notice-general.tmpl.html\'\">\n</md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'customFieldCategory.sortOrder\'\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{ category.customFieldCategory.name }}</div></div><md-content layout-padding \nlayout=\"column\" class=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'\"></edit-custom-field></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{ \"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.ATTACHMENTS\" | translate }}</div></div>\n<md-content class=\"program-attachments\" layout-padding layout=\"column\" \nng-include=\"\'app/main/obituary-notice/edit-obituary-notice/views/obituary-notice-attachments.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.CANCEL\">\n{{ \"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.SAVE\">\n{{ \"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.SAVE\" | translate }}</md-button></div></md-content></div>");
$templateCache.put("app/main/privacy/privacy-details/privacy-details.tmpl.html","<div id=\"privacy-details\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle notes and tasks\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-shield\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ \"PRIVACY.PRIVACY_DETAILS.PRIVACY_DETAILS\" | translate }}</span></div></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper><div class=\"sidenav-inner\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div class=\"header md-padding\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\"></md-icon><span \nclass=\"font-weight-500 font-size-14\">{{ \"MENU.PRIVACY.PRIVACY\" | translate }}</span></div><md-divider></md-divider><div\n ms-scroll class=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list>\n<md-list-item ng-click=\"vm.activate(\'party\')\" \nng-class=\"{ \'selected\': vm.selectedTab === \'party\', \'md-accent-bg\': vm.selectedTab === \'party\' }\"><p><md-icon \nmd-font-icon=\"icon-account\" class=\"s24\"></md-icon>{{ \"PARTY.PERSON.PERSON\" | translate }}</p></md-list-item>\n<md-list-item ng-click=\"vm.activate(\'related-data\')\" \nng-class=\"{ \'selected\': vm.selectedTab === \'related-data\', \'md-accent-bg\': vm.selectedTab === \'related-data\' }\"><p>\n<md-icon md-font-icon=\"icon-data\" class=\"s24\"></md-icon>{{ \"PRIVACY.PRIVACY_DETAILS.RELATED_DATA\" | translate }}</p>\n</md-list-item><md-list-item ng-click=\"vm.activate(\'export\')\" \nng-class=\"{ \'selected\': vm.selectedTab === \'export\', \'md-accent-bg\': vm.selectedTab === \'export\' }\"><p><md-icon \nmd-font-icon=\"icon-export\" class=\"s24\"></md-icon>{{ \"PRIVACY.PRIVACY_DETAILS.EXPORT_DATA\" | translate }}</p>\n</md-list-item><md-list-item ng-click=\"vm.activate(\'log\')\" \nng-class=\"{ \'selected\': vm.selectedTab === \'log\', \'md-accent-bg\': vm.selectedTab === \'log\' }\"><p><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s24\"></md-icon>{{ \"PRIVACY.PRIVACY_DETAILS.ACCESS_LOG\" | translate }}\n</p></md-list-item><md-list-item ng-click=\"null\" \nng-class=\"{ \'selected\': vm.selectedTab === \'advanced\', \'md-accent-bg\': vm.selectedTab === \'advanced\' }\"><p><md-icon \nmd-font-icon=\"icon-cog\" class=\"s24\"></md-icon>{{ \"PRIVACY.PRIVACY_DETAILS.ADVANCED\" | translate }}</p></md-list-item>\n</md-list></div></div></md-sidenav><div class=\"privacy-details-top-nav\"><md-toolbar><div class=\"md-toolbar-tools\">\n<md-button class=\"md-raised\" ng-click=\"vm.openPseudomizePartyDialog($event)\" ng-disabled=\"vm.isPseudomized()\" \naria-label=\"Pseudonymize\" translate-attr-aria-label=\"PRIVACY.PRIVACY_DETAILS.PSEUDOMIZE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"PRIVACY.PRIVACY_DETAILS.PSEUDOMIZE_DESCRIPTION\"></span></md-tooltip>\n{{ \"PRIVACY.PRIVACY_DETAILS.PSEUDOMIZE\" | translate }}</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.openDeletePartyDialog($event)\" aria-label=\"Delete\" \ntranslate-attr-aria-label=\"PRIVACY.PRIVACY_DETAILS.DELETE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PRIVACY.PRIVACY_DETAILS.DELETE_DESCRIPTION\"></span></md-tooltip>\n{{ \"PRIVACY.PRIVACY_DETAILS.DELETE\" | translate }}</md-button><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.isPseudomized() || vm.validation.partyForm.$pristine\" \naria-label=\"Save\" translate-attr-aria-label=\"COMMON.DIALOG.SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.SAVE\"></span></md-tooltip><md-icon class=\"md-accent-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar></div><div class=\"main\" ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.selectedTabIndex\"><md-tab \nlabel=\"Party\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-form=\"vm.validation.partyForm\" \nng-if=\"!vm.loadingService.isLoading\" class=\"edit-party-form\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"PARTY.PERSON.PERSON\" | translate }}</div></div><md-content layout-padding \nlayout=\"column\"><party-privacy-summary party-update-model=\"vm.updateModel\" work-order-type-id=\"null\" \nwork-order-id=\"null\" reference-person-type-mask=\"null\"></party-privacy-summary><h2 ng-if=\"vm.isPseudomized()\">\n{{ vm.updateModel.party.displayName | translate }}</h2><edit-party ng-if=\"!vm.isPseudomized()\" \nbaldris-model=\"vm.updateModel.party\" show-death-date=\"true\"></edit-party><many-to-many-select \nng-if=\"!vm.isPseudomized()\" class=\"margin-bottom-30\" many-to-many-list=\"vm.updateModel.partyTypes\" \nmany-to-many-name=\"PartyPartyTypeDto\" reference-id=\"vm.updateModel.party.id\" reference-id-name=\"partyId\" \nsource-controller=\"PartyTypes\" source-id-name=\"id\" source-name=\"name\" target-id-name=\"partyTypeId\" \ntarget-name=\"partyTypeName\" label-text=\"{{ \'PARTY.PARTY.PARTY_TYPES\' | translate }}\" \nplaceholder-text=\"{{ \'PARTY.PARTY.PARTY_TYPES\' | translate }}\"></many-to-many-select><div ng-if=\"!vm.isPseudomized()\">\n<md-checkbox ng-model=\"vm.updateModel.party.isDeleted\">{{ \"PARTY.PARTY.IS_DELETED\" | translate }}</md-checkbox></div>\n<address-list ng-if=\"!vm.isPseudomized()\" party-id=\"vm.updateModel.party.id\" collection=\"vm.updateModel.addresses\">\n</address-list><email-list ng-if=\"!vm.isPseudomized()\" party-id=\"vm.updateModel.party.id\" \ncollection=\"vm.updateModel.emails\"></email-list><telephone-list ng-if=\"!vm.isPseudomized()\" \nparty-id=\"vm.updateModel.party.id\" collection=\"vm.updateModel.telephones\"></telephone-list></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.isPseudomized() || vm.validation.partyForm.$pristine\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></div></div></md-tab><md-tab label=\"Related Data\" class=\"related-data\"><ng-include \nsrc=\"\'app/main/privacy/privacy-details/views/related-data.tmpl.html\'\"></ng-include></md-tab><md-tab label=\"Export\"><div\n ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"download-button-container\" \nng-if=\"!vm.loadingService.isLoading && vm.exportData\"><a class=\"md-button\" ng-href=\"{{ vm.exportData }}\" \ndownload=\"person-data.json\">{{ \"PRIVACY.PRIVACY_DETAILS.DOWNLOAD_RAW_DATA\" | translate }}</a></div></md-tab><md-tab \nlabel=\"Logs\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table ng-if=\"!vm.loadingService.isLoading\" \nclass=\"results simple\" ms-responsive-table><thead><tr><th translate=\"PRIVACY.PRIVACY_LOG.PRIVACY_ACTION\">Privacy Action\n</th><th translate=\"PRIVACY.PRIVACY_LOG.LOG_TIME\">Log Time</th><th translate=\"PRIVACY.PRIVACY_LOG.USER\">User</th><th \ntranslate=\"PRIVACY.PRIVACY_LOG.CONTROLLER_ACTION\">Controller Action</th></tr></thead><tbody><tr \nclass=\"result-item privacy-log\" ng-repeat=\"privacyLog in vm.privacyLogs | orderBy:\'logTime\'\"><td \nclass=\"privacy-action\">{{ vm.getPrivacyActionString(privacyLog.privacyAction || 0) | translate }}</td><td \nclass=\"log-time\">{{ privacyLog.logTime | date: \"short\" }}</td><td class=\"user\">{{ privacyLog.baldrisUserDisplayName }}\n</td><td class=\"controller-action\">{{ privacyLog.controllerAction }}</td></tr></tbody></table></md-tab><md-tab \nlabel=\"Advance\"></md-tab></md-tabs></div><md-sidenav \nclass=\"sidenav md-sidenav-right privacy-details-sidenav-right md-white-bg\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"privacy-details-sidenav-right\">\n</md-sidenav></div></div>");
$templateCache.put("app/main/privacy/privacy-fields/privacy-fields.tmpl.html","<div id=\"privacy-fields\" class=\"two-sidebars-toolbar page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header\" ng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-sm ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-folder-account\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ \"PRIVACY.PRIVACY_FIELD.PRIVACY_FIELDS\" | translate }}</span></div></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/privacy/privacy-fields/partials/privacy-fields-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"main\" ui-view=\"content\" ms-scroll></div><md-button class=\"preview-consent-form md-raised\" \nng-click=\"vm.openPreviewConsentFormDialog($event, \'consentForm\')\">\n{{ \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_CONSENT_FORM\" | translate }}</md-button><md-button \nclass=\"preview-consent-form md-raised\" ng-click=\"vm.openPreviewConsentFormDialog($event, \'letterOfAttorneyForm\')\">\n{{ \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_LETTER_OF_ATTORNEY_FORM\" | translate }}</md-button></div><md-button \nclass=\"md-fab md-accent md-icon-button add-button\" \nui-sref=\"app.privacy.privacyFields.editPrivacyField({ privacyFieldId: \'new\' })\" aria-label=\"add privacy field\" \ntranslate translate-attr-aria-label=\"PRIVACY.PRIVACY_FIELD.ADD_PRIVACY_FIELD\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/privacy/search/privacy-search.tmpl.html","<div id=\"privacy-search\" class=\"page-layout simple tabbed\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon>\n<input class=\"search-input\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search for Work Orders..\" translate \ntranslate-attr-placeholder=\"PRIVACY.SEARCH.SEARCH_PERSONS\" flex ng-change=\"vm.searchTermChanged()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 750, \'blur\': 0 } }\"></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate \ntranslate-attr-aria-label=\"WORK_ORDERS.SEARCH.SEARCH_SETTINGS\"><md-icon md-menu-origin md-menu-align-target \nmd-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-repeat=\"partyType in vm.partyTypes\"><md-button ng-click=\"vm.selectPartyType(partyType)\"><md-icon \nmd-font-icon=\"{{ vm.selectedPartyType === partyType ? \'icon-check\' : \'icon-checkbox-blank-outline\' }}\" \nmd-menu-align-target></md-icon><p>{{ partyType.name }}</p></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"content\" flex><md-content><div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"PARTY.PERSON.PERSONS\">Persons\n</span> <span class=\"secondary-text\"><span>{{ vm.searchResults.length }}</span> <span \ntranslate=\"PRIVACY.SEARCH.SEARCH_RESULTS\">Results</span></span></div></div><div class=\"loading-bar\" \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-if=\"!vm.loadingService.isLoading\" \nclass=\"results simple clickable\" ms-responsive-table><thead><tr><th \ntranslate=\"PARTY.PARTY_PRIVACY_DIALOG.PRIVACY_OPTIONS\">Privacy Options</th><th translate=\"PARTY.PARTY.DISPLAY_NAME\">\nDisplay Name</th><th translate=\"PARTY.PERSON.SOCIAL_SECURITY_NUMBER\">SSN</th><th translate=\"PARTY.PARTY.PRIMARY_EMAIL\">\nPrimary Email</th><th translate=\"PARTY.PARTY.PRIMARY_TELEPHONE\">Primary Telephone</th><th \ntranslate=\"PARTY.PARTY.PRIMARY_ADDRESS\">Primary Address</th><th translate=\"PARTY.PARTY.PARTY_TYPES\">Party Types</th>\n</tr></thead><tbody><tr class=\"result-item user\" ng-repeat=\"party in vm.searchResults\" \nui-sref=\"app.privacy.privacyDetails({partyId: party.id})\"><td class=\"privacy-options text-center\" \nmd-theme=\"trafficLight\"><md-icon md-font-icon=\"icon-shield\" \nng-class=\"{ \'md-primary-fg\': party.privacyOptions !== 0, \'md-warn-fg\': party.privacyOptions === 0 }\"></md-icon></td><td\n class=\"display-name\" md-highlight-text=\"vm.searchTerm\" md-highlight-flags=\"gi\">{{ party.displayName }}</td><td \nclass=\"social-security-number\"><md-button ng-if=\"(party.dateOfBirth || party.socialSecurityNumber) && !party.showSsn\" \nng-click=\"vm.showSsn(party, $event)\">{{ \"PRIVACY.SEARCH.SHOW_SSN\" | translate }}</md-button><span \nng-if=\"party.showSsn\">{{ party.dateOfBirth | date: \"dd.MM.yyyy\" }} {{ party.socialSecurityNumber }}</span></td><td \nclass=\"e-mail\">{{ party.primaryEmail }}</td><td class=\"telephone\">{{ party.primaryTelephone }}</td><td class=\"address\">\n{{ party.primaryAddress }}</td><td class=\"party-types\">{{ party.partyTypes }}</td></tr></tbody></table></md-content>\n</div></div>");
$templateCache.put("app/main/product/products/products.tmpl.html","<div id=\"products\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cube-outline\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PRODUCTS.PRODUCTS_AND_SERVICES\">Products and Services</span></div></div><div class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><label for=\"product-list-search\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"product-list-search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"PRODUCTS.PRODUCTS_VIEW.SEARCH_IN_LIST\"></md-input-container></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/product/products/partials/product-types-sidenav.tmpl.html\'\"></md-sidenav><div class=\"main\" \nui-view ms-scroll></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-product-button\" \nng-click=\"vm.addNewProduct($event)\" ng-disabled=\"!vm.currentData.selectedProductType.id\" aria-label=\"add product\" \ntranslate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div>");
$templateCache.put("app/main/program/edit-program/edit-program.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" layout=\"column\" layout-margin layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"edit-program\" \nng-form=\"vm.data.validation.programForm\" ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" layout-gt-lg=\"row\" \nlayout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'PROGRAMS.EDIT_PROGRAM.GENERAL\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\" ng-include=\"\'app/main/program/edit-program/views/program-general.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'customFieldCategory.sortOrder\' | filter:vm.data.customFieldCategoryFilter\">\n<ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">{{category.name}}</div></div><md-content \nlayout-padding layout=\"column\" class=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\' | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget><ms-widget ng-if=\"vm.data.updateModel.slotCollection\" \nflex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'PROGRAMS.EDIT_PROGRAM.PROGRAM_CONTENT\' | translate}}</div></div><md-content \nclass=\"border-bottom\" layout=\"row\" layout-padding><md-button ng-click=\"vm.data.createProgramElement($event)\" \naria-label=\"Add Program Element\" translate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.ADD_PROGRAM_ELEMENT\"><span \nclass=\"icon icon-plus\"></span> {{ \'PROGRAMS.EDIT_PROGRAM_ELEMENT.ADD_PROGRAM_ELEMENT\' | translate}}</md-button><span \nflex></span><md-checkbox ng-click=\"vm.showAll = !vm.showAll\" ng-checked=\"vm.showAll\">\n{{\'PROGRAMS.EDIT_PROGRAM.SHOW_EMPTY_POSTS\' | translate}}</md-checkbox></md-content><md-content class=\"program-slots\" \nlayout-padding layout=\"column\" ng-include=\"\'app/main/program/edit-program/views/program-slots.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'PROGRAMS.EDIT_PROGRAM.ATTACHMENTS\' | translate}}</div></div><md-content \nclass=\"program-attachments\" layout-padding layout=\"column\" \nng-include=\"\'app/main/program/edit-program/views/program-attachments.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM.Cancel\">{{ \'PROGRAMS.EDIT_PROGRAM.CANCEL\' | translate}}</md-button>\n<md-button ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.programForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM.SAVE\">{{ \'PROGRAMS.EDIT_PROGRAM.SAVE\' | translate}}</md-button></div>\n</div>");
$templateCache.put("app/main/sales-order/edit-invoice/edit-invoice.tmpl.html","<div id=\"edit-invoice\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go back\" ng-click=\"vm.goBack()\" translate translate-attr-aria-label=\"SALES_ORDERS.INVOICE.GO_BACK\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span ng-if=\"vm.data.updateModel.invoice.isReminder\" class=\"reminder\" translate=\"SALES_ORDERS.INVOICE.REMINDER\">\nReminder</span> <span ng-if=\"vm.data.updateModel.invoice.isCreditNote\" class=\"credit-note\" \ntranslate=\"SALES_ORDERS.INVOICE.CREDIT_NOTE\">Credit Note</span> <span \nng-if=\"!vm.data.updateModel.invoice.isCreditNote && !vm.data.updateModel.invoice.isReminder\" class=\"invoice\" \ntranslate=\"SALES_ORDERS.INVOICE.INVOICE\">Invoice</span> <span>\n{{ vm.data.updateModel.invoice.prefix }}{{ vm.data.updateModel.invoice.invoiceNumber }}</span> <span \nng-if=\"!vm.data.updateModel.invoice.invoiceNumber\">#</span></div><div class=\"subtitle secondary-text\"><span>\n{{ vm.data.updateModel.invoice.customerPartyDisplayName }}</span></div></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height ng-if=\"!vm.loadingService.isLoading\" md-selected=\"vm.selectedIndex\"><md-tab><md-tab-label><span \ntranslate=\"SALES_ORDERS.INVOICE.OVERVIEW\">Overview</span></md-tab-label><md-tab-body><div class=\"overview\"><div \nclass=\"order-section order-section-details\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-content-paste\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.DETAILS\">Order Summary\n</div></div><div class=\"section-content\"><div class=\"subject\"><div translate=\"SALES_ORDERS.SALES_ORDER.SUBJECT\" \nclass=\"caption\">Subject</div><div class=\"value\" ng-bind-html=\"vm.data.updateModel.invoice.subject | nl2br\">Subject\n</div></div><div class=\"info\"><div translate=\"SALES_ORDERS.SALES_ORDER.INFO\" class=\"caption\">Info</div><div \nclass=\"value\" ng-bind-html=\"vm.data.updateModel.invoice.info | nl2br\">Info</div></div><div \nclass=\"sales-representative\"><div translate=\"SALES_ORDERS.SALES_ORDER.SALES_REPRESENTATIVE\" class=\"caption\">\nSales Representative</div><div class=\"value\">{{ vm.data.updateModel.invoice.salesRepresentativeName }}</div></div><div \nclass=\"invoice-date\"><div translate=\"SALES_ORDERS.INVOICE.INVOICE_DATE\" class=\"caption\">Invoice Date</div><div \nclass=\"value\">{{ vm.data.updateModel.invoice.invoiceDate | date: \"shortDate\" }}<span \nng-if=\"!vm.data.updateModel.invoice.invoiceDate\" translate=\"SALES_ORDERS.INVOICE.NO_DATE\">(No date set)</span></div>\n</div><div class=\"due-date\"><div translate=\"SALES_ORDERS.INVOICE.DUE_DATE\" class=\"caption\">Due Date</div><div \nclass=\"value\">{{ vm.data.updateModel.invoice.dueDate | date: \"shortDate\" }}<span \nng-if=\"!vm.data.updateModel.invoice.dueDate\" translate=\"SALES_ORDERS.INVOICE.NO_DATE\">(No date set)</span></div></div>\n<div class=\"report-template\"><div translate=\"SALES_ORDERS.SALES_ORDER.REPORT\" class=\"caption\">Info</div><div \nclass=\"value\">{{ vm.data.updateModel.invoice.reportName }}</div></div><div class=\"remarks\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.REMARKS\" class=\"caption\">Remarks</div><div class=\"value\" \nng-bind-html=\"vm.data.updateModel.invoice.remarks | nl2br\">Remarks</div></div></div><div class=\"section-footer\">\n<md-button ng-disabled=\"vm.data.updateModel.invoice.isLocked\" class=\"md-primary\" \nng-click=\"vm.data.editInvoiceDetails($event)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.EDIT_DETAILS\" | translate }}</md-button></div></div><div \nclass=\"order-section order-section-actions\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"COMMON.DATA.ACTIONS\">Actions</div></div><div class=\"section-content\"><div class=\"status-list\"><div \nclass=\"created-status\"><div class=\"date\"><md-icon md-font-icon=\"icon-star\"></md-icon>\n{{ vm.data.updateModel.invoice.createdAt | date: \"short\" }}</div><div class=\"text\">\n{{ \"COMMON.DATA.CREATED\" | translate }}</div><div class=\"info\">{{ vm.data.updateModel.invoice.createdBy }}</div></div>\n<div ng-if=\"vm.data.updateModel.invoice.lastModifiedAt\" class=\"last-edited-status\"><div class=\"date\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>{{ vm.data.updateModel.invoice.lastModifiedAt | date: \"short\" }}</div><div \nclass=\"text\">{{ \"COMMON.DATA.LAST_EDIT\" | translate }}</div><div class=\"info\">\n{{ vm.data.updateModel.invoice.lastModifiedBy }}</div></div><div class=\"locked-status\" \nng-class=\"{ \'is-locked\': vm.data.updateModel.invoice.isLocked, \'is-unlocked\': !vm.data.updateModel.invoice.isLocked }\">\n<div class=\"date\"><md-icon \nmd-font-icon=\"{{ vm.data.updateModel.invoice.isLocked ? \'icon-lock\' : \'icon-lock-unlocked\' }}\"></md-icon>\n{{ vm.data.updateModel.invoice.lockedTime | date: \"short\" }}</div><div class=\"text\">\n{{ (vm.data.updateModel.invoice.isLocked ? \"SALES_ORDERS.INVOICE.IS_LOCKED\" : \"SALES_ORDERS.INVOICE.IS_UNLOCKED_TEXT\") | translate }}\n</div><div class=\"info\">{{ vm.data.updateModel.invoice.isLocked ? vm.data.getLockedBy() : \"\" }}</div></div></div></div>\n<div class=\"section-footer\"><md-button class=\"md-warn md-raised\" ng-disabled=\"vm.data.updateModel.invoice.isLocked\" \nng-click=\"vm.deleteInvoice($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"SALES_ORDERS.INVOICE.DELETE_INVOICE\" | translate }}</md-button><md-button \nng-if=\"!vm.data.updateModel.invoice.isLocked\" class=\"md-primary md-raised\" ng-click=\"vm.data.lockInvoice($event)\">\n<md-icon md-font-icon=\"icon-lock\"></md-icon>{{ \"SALES_ORDERS.INVOICE.LOCK_INVOICE\" | translate }}</md-button><md-button\n ng-if=\"!vm.data.updateModel.salesOrderId\" class=\"md-raised\" ng-click=\"vm.gotoSalesOrder()\"><md-icon \nmd-font-icon=\"icon-basket\"></md-icon>{{ \"SALES_ORDERS.INVOICE.GO_TO_SALES_ORDER\" | translate }}</md-button><md-menu \nng-if=\"vm.data.updateModel.invoice.isLocked\"><md-button ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-content-duplicate\"></md-icon>{{ \"SALES_ORDERS.INVOICE.COPY_CREDIT\" | translate }}\n</md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.copyInvoice(vm.data.updateModel.invoice.id, $event)\"><md-icon md-font-icon=\"icon-content-duplicate\" \nmd-menu-align-target></md-icon>{{ \"SALES_ORDERS.INVOICE.COPY\" | translate }}</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.creditInvoice(vm.data.updateModel.invoice.id, $event)\"><md-icon \nmd-font-icon=\"icon-content-duplicate\" md-menu-align-target></md-icon>{{ \"SALES_ORDERS.INVOICE.CREDIT\" | translate }}\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"order-section order-section-summary\">\n<div class=\"section-header\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</div></div><div class=\"section-content\"><div\n class=\"total-row total\"><div translate=\"SALES_ORDERS.SALES_ORDER.TOTAL\" class=\"caption\">Total</div><div \nclass=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalPrice() < 0, \'grey-500-fg\': vm.data.getTotalPrice() == 0 }\">\n{{ vm.data.getTotalPrice() | currency }}</div></div><div class=\"total-row total-including-vat\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\" class=\"caption\">Total Including VAT</div><div \nclass=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalPriceIncludingVat() < 0, \'grey-500-fg\': vm.data.getTotalPriceIncludingVat() == 0 }\">\n{{ vm.data.getTotalPriceIncludingVat() | currency }}</div></div><div class=\"total-row total-vat\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.VAT\" class=\"caption\">VAT</div><div class=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalVat() < 0, \'grey-500-fg\': vm.data.getTotalVat() == 0 }\">\n{{ vm.data.getTotalVat() | currency }}</div></div></div></div><div class=\"order-section order-section-customer\"><div \nclass=\"section-header\"><md-icon md-font-icon=\"icon-account\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.CUSTOMER\">Customer</div></div><div class=\"section-content\"><div \nclass=\"customer-name\"><div translate=\"SALES_ORDERS.CUSTOMER.NAME\" class=\"caption\">Name</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.displayName }}</div></div><div class=\"billing-address\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.BILLING_ADDRESS\" class=\"caption\">Billing Address</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.billingAddress.localizedAddress}}</div></div><div class=\"customer-number\"><div\n translate=\"SALES_ORDERS.CUSTOMER.CUSTOMER_NUMBER\" class=\"caption\">Customer Number</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.customerNumber }}</div></div><div class=\"customer-email\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.EMAIL\" class=\"caption\">Email</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.primaryEmail }}</div></div><div class=\"customer-telephone\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.TELEPHONE\" class=\"caption\">Phone</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.primaryTelephone }}</div></div></div><div class=\"section-footer\"><md-button \nng-disabled=\"vm.data.updateModel.invoice.isLocked\" class=\"md-primary\" \nng-click=\"vm.data.openChoosePersonDialog($event)\"><md-icon md-font-icon=\"icon-account-location\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.CHANGE_CUSTOMER\" | translate }}</md-button></div></div><div \nclass=\"order-section order-section-invoice-lines\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-receipt\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.LINE_ITEMS\">Line Items\n</div></div><div class=\"section-content\"><div class=\"product-code\" \nng-repeat-start=\"lineItem in vm.data.updateModel.lineItems | orderBy:\'sortOrder\'\">{{::lineItem.productCode}}</div><div \nclass=\"product-name\">{{::lineItem.productName}}</div><div class=\"amount\">{{::lineItem.productAmount}}</div><div \nclass=\"text-right total-price\" ng-repeat-end>{{ vm.data.getTotalPriceIncludingVatLineItem(lineItem) | currency }}</div>\n</div><div class=\"section-footer\"><md-button ng-disabled=\"vm.data.updateModel.invoice.isLocked\" class=\"md-primary\" \nng-click=\"vm.selectedIndex = 1\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.EDIT_LINE_ITEMS\" | translate }}</md-button></div></div><div class=\"print-consignment\"><div\n ng-if=\"vm.trackableEmailsIsAllowed\" class=\"order-section order-section-consigment\"><div class=\"section-header\">\n<md-icon md-font-icon=\"icon-email\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.CONSIGNMENT\">Consignment</div></div><md-progress-linear \nng-if=\"vm.isLoadingReportLogs\" md-mode=\"query\"></md-progress-linear><div class=\"section-content\"><div class=\"caption\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.LATEST_STATUSES\">Latest Statuses</div><div class=\"consignment\"><div \nclass=\"recipient\" ng-repeat=\"recipient in vm.groupedReports\"><md-tooltip ng-if=\"reportLog.statusText\" \nmd-direction=\"top\">{{ reportLog.statusText }}</md-tooltip><div class=\"email\"><md-icon \nmd-font-icon=\"{{ vm.getStatusIcon(recipient[0]) }}\" ng-class=\"vm.getStatusColor(recipient[0])\"></md-icon>\n{{ recipient[0].recipient }}</div><div class=\"status\">{{ vm.getStatusAction(recipient[0]) | translate }}<md-icon \nng-if=\"recipient[0].userDisplayName\" md-font-icon=\"icon-account\" class=\"s12\"></md-icon><span \nng-if=\"recipient[0].userDisplayName\">{{ recipient[0].userDisplayName }}</span><md-icon md-font-icon=\"icon-clock\" \nclass=\"s12\"></md-icon>{{ recipient[0].timestamp || recipient[0].statusTime | date: \"short\" }}</div></div></div></div>\n<div class=\"section-footer\"><md-button \nng-if=\"(!vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()) || (vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath)\" \nclass=\"md-primary\" ng-click=\"vm.openMultiChannelDialog($event)\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \nng-if=\"!vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()\">\n{{ \"SALES_ORDERS.INVOICE.SEND_PREVIEW\" | translate }}</span><span \nng-if=\"vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath\">\n{{ \"SALES_ORDERS.INVOICE.SEND_INVOICE\" | translate }}</span></md-button></div></div><div \nclass=\"order-section order-section-print-preview\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-printer\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.PRINT\">Print</div></div>\n<div class=\"section-content\"><div \nng-if=\"vm.data.updateModel.lineItems && vm.data.updateModel.lineItems.length > 0 && vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath\" \nclass=\"print-preview\"><object ng-attr-data=\"{{ vm.data.updateModel.invoice.exportedFileFilepath }}\" \ntype=\"application/pdf\"></object></div><div \nng-if=\"vm.data.updateModel.lineItems && vm.data.updateModel.lineItems.length > 0 && !vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()\" \nclass=\"print-preview\"><object ng-attr-data=\"{{ vm.getPreviewUrl() }}\" type=\"application/pdf\"></object></div></div><div \nclass=\"section-footer\"><md-button class=\"md-primary\" \nng-if=\"vm.data.updateModel.invoice.isLocked && !vm.data.updateModel.invoice.exportedFileFilepath\" \nng-click=\"vm.data.createPdf()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon>\n{{ \"SALES_ORDERS.INVOICE.GENERATE_PDF\" | translate }}</md-button><md-button class=\"md-primary\" \nng-href=\"{{ vm.data.updateModel.invoice.exportedFileFilepath }}\" target=\"_blank\" \nng-if=\"vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath\"><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon>{{ \"SALES_ORDERS.INVOICE.PREVIEW\" | translate }}</md-button><md-button \nclass=\"md-primary\" ng-href=\"{{ vm.getPreviewUrl() }}\" target=\"_blank\" \nng-if=\"!vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n{{ \"SALES_ORDERS.INVOICE.PREVIEW\" | translate }}</md-button><md-button \nng-if=\"(!vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()) || (vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath)\" \nclass=\"md-primary\" ng-click=\"vm.openSendInvoiceDialog($event, true)\"><md-icon md-font-icon=\"icon-email\"></md-icon><span\n ng-if=\"!vm.data.updateModel.invoice.isLocked && vm.getPreviewUrl()\">\n{{ \"SALES_ORDERS.INVOICE.SEND_PREVIEW\" | translate }}</span><span \nng-if=\"vm.data.updateModel.invoice.isLocked && vm.data.updateModel.invoice.exportedFileFilepath\">\n{{ \"SALES_ORDERS.INVOICE.SEND_INVOICE\" | translate }}</span></md-button></div></div></div>\n<sales-order-attachments-section sales-order-attachments=\"vm.data.updateModel.attachments\" \nsales-order-id=\"vm.data.updateModel.invoice.salesOrderId\"></sales-order-attachments-section></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"SALES_ORDERS.INVOICE.LINE_ITEMS\">Line Items</span></md-tab-label>\n<md-tab-body><div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><order-line-table \nline-item-collection=\"vm.data.updateModel.lineItems\" line-item-controller=\"\'InvoiceItems\'\" \nparent-id-name=\"\'invoiceId\'\" parent-controller=\"\'Invoices\'\" parent-id=\"vm.data.updateModel.invoice.id\" \nget-empty-line-item=\"vm.salesOrderService.getEmptyInvoiceProduct\"></order-line-table></div></md-tab-body></md-tab>\n</md-tabs><div layout=\"row\" layout-padding layout-align=\"center center\" ng-if=\"vm.loadingService.isLoading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/sales-order/edit-sales-order/edit-sales-order.tmpl.html","<div id=\"edit-sales-order\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goBack()\" translate translate-attr-aria-label=\"EC.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SALES_ORDERS.SALES_ORDER.SALES_ORDER\">Order</span> <span>\n{{ vm.data.updateModel.salesOrder.orderCode }} <span ng-if=\"vm.data.updateModel.salesOrder.workOrderOrderCode\">\n/ {{ vm.data.updateModel.salesOrder.workOrderOrderCode }}</span></span></div><div class=\"subtitle secondary-text\">\n<span>{{ vm.data.updateModel.salesOrder.customerPartyDisplayName }}</span></div></div></div></div><div class=\"content\">\n<md-tabs md-dynamic-height ng-if=\"!vm.loadingService.isLoading\" md-selected=\"vm.selectedIndex\"><md-tab><md-tab-label>\n<span translate=\"SALES_ORDERS.SALES_ORDER.OVERVIEW\">Overview</span></md-tab-label><md-tab-body><div class=\"overview\">\n<div class=\"order-section order-section-details\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-content-paste\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.DETAILS\">Order Summary</div></div><div class=\"section-content\"><div \nclass=\"subject\"><div translate=\"SALES_ORDERS.SALES_ORDER.SUBJECT\" class=\"caption\">Subject</div><div class=\"value\" \nng-bind-html=\"vm.data.updateModel.salesOrder.subject | nl2br\">Subject</div></div><div class=\"info\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.INFO\" class=\"caption\">Info</div><div class=\"value\" \nng-bind-html=\"vm.data.updateModel.salesOrder.info | nl2br\">Info</div></div><div class=\"sales-representative\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.SALES_REPRESENTATIVE\" class=\"caption\">Sales Representative</div><div class=\"value\">\n{{ vm.data.updateModel.salesOrder.salesRepresentativeName }}</div></div><div class=\"valid-through\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.VALID_THROUGH\" class=\"caption\">Valid through</div><div class=\"value\">\n{{ vm.data.updateModel.salesOrder.validThrough | date: \"shortDate\" }}</div></div><div class=\"report-template\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.REPORT\" class=\"caption\">Info</div><div class=\"value\">\n{{ vm.data.updateModel.salesOrder.reportName }}</div></div><div class=\"remarks\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.REMARKS\" class=\"caption\">Remarks</div><div class=\"value\" \nng-bind-html=\"vm.data.updateModel.salesOrder.remarks | nl2br\">Remarks</div></div></div><div class=\"section-footer\">\n<md-button class=\"md-primary\" ng-click=\"vm.data.editSalesOrderDetails($event)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon>{{ \"SALES_ORDERS.SALES_ORDER.EDIT_DETAILS\" | translate }}</md-button></div>\n</div><div class=\"order-section order-section-actions\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"COMMON.DATA.ACTIONS\">Actions</div></div><div class=\"section-content\"><div class=\"status-list\"><div \nclass=\"created-status\"><div class=\"date\">{{ vm.data.updateModel.salesOrder.createdAt | date: \"short\" }}</div><div \nclass=\"text\">{{ \"COMMON.DATA.CREATED\" | translate }}</div><div class=\"info\">\n{{ vm.data.updateModel.salesOrder.createdBy }}</div></div><div ng-if=\"vm.data.updateModel.salesOrder.lastModifiedAt\" \nclass=\"last-edited-status\"><div class=\"date\">{{ vm.data.updateModel.salesOrder.lastModifiedAt | date: \"short\" }}</div>\n<div class=\"text\">{{ \"COMMON.DATA.LAST_EDIT\" | translate }}</div><div class=\"info\">\n{{ vm.data.updateModel.salesOrder.lastModifiedBy }}</div></div></div></div><div class=\"section-footer\"><md-button \nclass=\"md-warn md-raised\" ng-disabled=\"!vm.data.canDelete\" ng-click=\"vm.deleteSalesOrder($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \"SALES_ORDERS.SALES_ORDER.DELETE_SALES_ORDER\" | translate }}</md-button></div>\n</div><div class=\"order-section order-section-summary\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</div></div><div class=\"section-content\"><div class=\"total-row total\">\n<div translate=\"SALES_ORDERS.SALES_ORDER.TOTAL\" class=\"caption\">Total</div><div class=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalPrice() < 0, \'grey-500-fg\': vm.data.getTotalPrice() == 0 }\">\n{{ vm.data.getTotalPrice() | currency }}</div></div><div class=\"total-row total-including-vat\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\" class=\"caption\">Total Including VAT</div><div \nclass=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalPriceIncludingVat() < 0, \'grey-500-fg\': vm.data.getTotalPriceIncludingVat() == 0 }\">\n{{ vm.data.getTotalPriceIncludingVat() | currency }}</div></div><div class=\"total-row total-vat\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.VAT\" class=\"caption\">VAT</div><div class=\"sum total-sum\" \nng-class=\"{ \'red-800-fg\': vm.data.getTotalVat() < 0, \'grey-500-fg\': vm.data.getTotalVat() == 0 }\">\n{{ vm.data.getTotalVat() | currency }}</div></div></div></div><div class=\"order-section order-section-customer\"><div \nclass=\"section-header\"><md-icon md-font-icon=\"icon-account\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.CUSTOMER\">Customer</div></div><div class=\"section-content\"><div \nclass=\"customer-name\"><div translate=\"SALES_ORDERS.CUSTOMER.NAME\" class=\"caption\">Name</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.displayName }}</div></div><div class=\"billing-address\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.BILLING_ADDRESS\" class=\"caption\">Billing Address</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.billingAddress.localizedAddress}}</div></div><div class=\"customer-number\"><div\n translate=\"SALES_ORDERS.CUSTOMER.CUSTOMER_NUMBER\" class=\"caption\">Customer Number</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.customerNumber }}</div></div><div class=\"customer-email\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.EMAIL\" class=\"caption\">Email</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.primaryEmail }}</div></div><div class=\"customer-telephone\"><div \ntranslate=\"SALES_ORDERS.CUSTOMER.TELEPHONE\" class=\"caption\">Phone</div><div class=\"value\">\n{{ vm.data.updateModel.customer.customer.primaryTelephone }}</div></div></div><div class=\"section-footer\"><md-button \nclass=\"md-primary\" ng-click=\"vm.data.openChoosePersonDialog($event)\"><md-icon md-font-icon=\"icon-account-location\">\n</md-icon>{{ \"SALES_ORDERS.SALES_ORDER.CHANGE_CUSTOMER\" | translate }}</md-button></div></div><div \nclass=\"order-section order-section-invoice-lines\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-receipt\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.LINE_ITEMS\">Line Items\n</div></div><div class=\"section-content\"><div class=\"product-code\" \nng-repeat-start=\"lineItem in vm.data.updateModel.lineItems | orderBy:\'sortOrder\'\">{{::lineItem.productCode}}</div><div \nclass=\"product-name\">{{::lineItem.productName}}</div><div class=\"amount\">{{::lineItem.productAmount}}</div><div \nclass=\"text-right total-price\" ng-repeat-end>{{ vm.data.getTotalPriceIncludingVatLineItem(lineItem) | currency }}</div>\n</div><div class=\"section-footer\"><md-button class=\"md-primary\" ng-click=\"vm.selectedIndex = 1\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon>{{ \"SALES_ORDERS.SALES_ORDER.EDIT_LINE_ITEMS\" | translate }}</md-button>\n</div></div><div class=\"print-consignment\"><div ng-if=\"vm.trackableEmailsIsAllowed\" \nclass=\"order-section order-section-consigment\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-email\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.CONSIGNMENT\">Consignment\n</div></div><md-progress-linear ng-if=\"vm.isLoadingReportLogs\" md-mode=\"query\"></md-progress-linear><div \nclass=\"section-content\"><div class=\"caption\" translate=\"SALES_ORDERS.SALES_ORDER.LATEST_STATUSES\">Latest Statuses</div>\n<div class=\"consignment\"><div class=\"recipient\" ng-repeat=\"recipient in vm.groupedReports\"><md-tooltip \nng-if=\"reportLog.statusText\" md-direction=\"top\">{{ reportLog.statusText }}</md-tooltip><div class=\"email\"><md-icon \nmd-font-icon=\"{{ vm.getStatusIcon(recipient[0]) }}\" ng-class=\"vm.getStatusColor(recipient[0])\"></md-icon>\n{{ recipient[0].recipient }}</div><div class=\"status\">{{ vm.getStatusAction(recipient[0]) | translate }}<md-icon \nng-if=\"recipient[0].userDisplayName\" md-font-icon=\"icon-account\" class=\"s12\"></md-icon><span \nng-if=\"recipient[0].userDisplayName\">{{ recipient[0].userDisplayName }}</span><md-icon md-font-icon=\"icon-clock\" \nclass=\"s12\"></md-icon>{{ recipient[0].timestamp || recipient[0].statusTime | date: \"short\" }}</div></div></div></div>\n<div class=\"section-footer\"><md-button ng-if=\"vm.getPreviewUrl()\" class=\"md-primary\" \nng-click=\"vm.openSendPreviewDialog($event)\"><md-icon md-font-icon=\"icon-email\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.SEND_PREVIEW\" | translate }}</md-button></div></div><div \nclass=\"order-section order-section-print-preview\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-printer\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.PRINT\">Print</div></div>\n<div class=\"section-content\"><div \nng-if=\"vm.data.updateModel.lineItems && vm.data.updateModel.lineItems.length > 0 && vm.getPreviewUrl()\" \nclass=\"print-preview\"><object ng-attr-data=\"{{ vm.getPreviewUrl() }}\" type=\"application/pdf\"></object></div></div><div \nclass=\"section-footer\"><md-button ng-if=\"vm.getPreviewUrl()\" class=\"md-primary\" target=\"_blank\" \nng-href=\"{{ vm.getPreviewUrl() }}\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.PREVIEW\" | translate }}</md-button><md-button ng-if=\"vm.getPreviewUrl()\" \nclass=\"md-primary\" ng-click=\"vm.openSendPreviewDialog($event, true)\"><md-icon md-font-icon=\"icon-email\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.SEND_PREVIEW\" | translate }}</md-button></div></div></div><div \nclass=\"order-section order-section-invoices\"><div class=\"section-header\"><md-icon md-font-icon=\"icon-receipt\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.INVOICES\">Invoices</div>\n</div><div class=\"section-content\"><div class=\"locked-status\" ng-click=\"vm.gotoInvoice(invoice)\" \nng-repeat-start=\"invoice in vm.data.updateModel.invoices | orderBy:\'createdAt\'\"><md-icon ng-if=\"invoice.isLocked\" \nmd-font-icon=\"icon-lock\" class=\"red-500-fg\"></md-icon><md-icon ng-if=\"!invoice.isLocked\" \nmd-font-icon=\"icon-lock-unlocked\" class=\"green-500-fg\"></md-icon></div><div class=\"invoice-number\" \nng-click=\"vm.gotoInvoice(invoice)\">{{::invoice.invoiceNumber || \"N/A\"}}</div><div class=\"invoice-type\" \nng-click=\"vm.gotoInvoice(invoice)\"><span ng-if=\"invoice.isReminder\" class=\"reminder\" \ntranslate=\"SALES_ORDERS.INVOICE.REMINDER\">Reminder</span> <span ng-if=\"invoice.isCreditNote\" class=\"credit-note\" \ntranslate=\"SALES_ORDERS.INVOICE.CREDIT_NOTE\">Credit Note</span> <span \nng-if=\"!invoice.isCreditNote && !invoice.isReminder\" class=\"invoice\" translate=\"SALES_ORDERS.INVOICE.INVOICE\">Invoice\n</span></div><div class=\"invoice-customer\" ng-click=\"vm.gotoInvoice(invoice)\">{{::invoice.customerPartyDisplayName}}\n</div><div ng-click=\"vm.gotoInvoice(invoice)\" class=\"text-right total-amount\" ng-repeat-end>\n{{ ::invoice.totalSumIncludingVat | currency }}</div></div><div class=\"section-footer\"><md-button class=\"md-primary\" \nng-click=\"vm.selectedIndex = 2\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.EDIT_INVOICES\" | translate }}</md-button></div></div><div \nclass=\"order-section order-section-invoice-summary\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</div></div><div class=\"section-content\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INVOICED_INCLUDING_VAT\" class=\"caption\">Total Invoiced Inc. VAT</div><div \nclass=\"value\">{{ vm.data.getTotalInvoicedIncludingVat() | currency }}</div><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.BASIS_SALESORDER\" class=\"caption\">Basis Sales Order</div><div class=\"value\">\n{{ vm.data.getTotalPriceIncludingVat() | currency }}</div><div translate=\"SALES_ORDERS.SALES_ORDER.DIFFERENCE\" \nclass=\"caption\">Difference</div><div class=\"value\" \nng-class=\"{ \'green-600-fg\': vm.data.getTotalInvoicedIncludingVatDiff() > 0, \'red-800-fg\': vm.data.getTotalInvoicedIncludingVatDiff() < 0, \'grey-500-fg\': vm.data.getTotalInvoicedIncludingVatDiff() == 0 }\">\n{{ vm.data.getTotalInvoicedIncludingVatDiff() | currency }}</div></div></div><sales-order-attachments-section \nsales-order-attachments=\"vm.data.updateModel.attachments\" sales-order-id=\"vm.data.updateModel.salesOrder.id\">\n</sales-order-attachments-section></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"SALES_ORDERS.SALES_ORDER.LINE_ITEMS\">Line Items</span></md-tab-label><md-tab-body class=\"line-items\"><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><order-line-table \nline-item-collection=\"vm.data.updateModel.lineItems\" line-item-controller=\"\'SalesOrderItems\'\" \nparent-id-name=\"\'salesOrderId\'\" parent-id=\"vm.data.updateModel.salesOrder.id\" \nget-empty-line-item=\"vm.salesOrderService.getEmptySalesOrderProduct\"></order-line-table></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"SALES_ORDERS.SALES_ORDER.INVOICES\">Invoices</span></md-tab-label><md-tab-body>\n<div class=\"order-detail-form-container invoices md-background-bg md-whiteframe-1dp\"><div layout=\"column\" \nlayout-padding><md-button ng-click=\"vm.data.addNewInvoice($event)\">\n{{ \"SALES_ORDERS.SALES_ORDER.ADD_INVOICE\" | translate }}</md-button></div><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.INVOICE.IS_LOCKED\">Locked</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.INVOICE.INVOICE_NUMBER\">Invoice No.</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.INVOICE.INVOICE_TYPE\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.INVOICE.INVOICE_DATE\">Invoice Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.INVOICE.DUE_DATE\">Due Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.INVOICE.TOTAL\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.INVOICE.TOTAL_INCLUDING_VAT\">Total incl. VAT</span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.data.updateModel.invoices\" ng-click=\"vm.gotoInvoice(invoice)\" class=\"clickable\"><td \ndata-order=\"{{ invoice.isLocked }}\"><md-icon ng-if=\"invoice.isLocked\" md-font-icon=\"icon-lock\" class=\"red-500-fg\">\n</md-icon><md-icon ng-if=\"!invoice.isLocked\" md-font-icon=\"icon-lock-unlocked\" class=\"green-500-fg\"></md-icon></td><td \ndata-order=\"{{ invoice.invoiceNumber }}\">{{ invoice.prefix }}{{ invoice.invoiceNumber || \"-\" }}</td><td><span \nng-if=\"invoice.isReminder\" class=\"reminder\" translate=\"SALES_ORDERS.INVOICE.REMINDER\">Reminder</span> <span \nng-if=\"invoice.isCreditNote\" class=\"credit-note\" translate=\"SALES_ORDERS.INVOICE.CREDIT_NOTE\">Credit Note</span> <span \nng-if=\"!invoice.isCreditNote && !invoice.isReminder\" class=\"invoice\" translate=\"SALES_ORDERS.INVOICE.INVOICE\">Invoice\n</span></td><td data-order=\"{{ invoice.invoiceDate | date: \'yyyyMMdd\' }}\">\n{{ invoice.invoiceDate | date: \"shortDate\" || \"-\" }}</td><td data-order=\"{{ invoice.dueDate | date: \'yyyyMMdd\' }}\">\n{{ invoice.dueDate | date: \"shortDate\" || \"-\" }}</td><td data-order=\"{{ invoice.totalSum }}\">\n{{ invoice.totalSum | currency }}</td><td data-order=\"{{ invoice.totalSumIncludingVat }}\">\n{{ invoice.totalSumIncludingVat | currency }}</td></tr></tbody></table></div><div \nclass=\"order-detail-form-container customer md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"SALES_ORDERS.SALES_ORDER.SUMMARY\">Summary</div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"total-sums detail-row\"><div flex-gt-sm=\"33\" layout=\"column\" class=\"detail-column\"><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INVOICED\" class=\"caption\">Total Invoiced Amount</div><div class=\"value\">\n{{ vm.data.getTotalInvoiced() | currency }}</div><div translate=\"SALES_ORDERS.SALES_ORDER.BASIS_SALESORDER\" \nclass=\"caption\">Basis Sales Order</div><div class=\"value\">{{ vm.data.getTotalPrice() | currency }}</div><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.DIFFERENCE\" class=\"caption\">Difference</div><div class=\"value\" \nng-class=\"{ \'green-600-fg\': vm.data.getTotalInvoicedDiff() > 0, \'red-800-fg\': vm.data.getTotalInvoicedDiff() < 0, \'grey-500-fg\': vm.data.getTotalInvoicedDiff() == 0 }\">\n{{ vm.data.getTotalInvoicedDiff() | currency }}</div></div><div flex-gt-sm=\"33\" layout=\"column\" class=\"detail-column\">\n<div translate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INVOICED_INCLUDING_VAT\" class=\"caption\">Total Invoiced Inc. VAT</div>\n<div class=\"value\">{{ vm.data.getTotalInvoicedIncludingVat() | currency }}</div><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.BASIS_SALESORDER\" class=\"caption\">Basis Sales Order</div><div class=\"value\">\n{{ vm.data.getTotalPriceIncludingVat() | currency }}</div><div translate=\"SALES_ORDERS.SALES_ORDER.DIFFERENCE\" \nclass=\"caption\">Difference</div><div class=\"value\" \nng-class=\"{ \'green-600-fg\': vm.data.getTotalInvoicedIncludingVatDiff() > 0, \'red-800-fg\': vm.data.getTotalInvoicedIncludingVatDiff() < 0, \'grey-500-fg\': vm.data.getTotalInvoicedIncludingVatDiff() == 0 }\">\n{{ vm.data.getTotalInvoicedIncludingVatDiff() | currency }}</div></div><div flex-gt-sm=\"33\" layout=\"column\" \nclass=\"detail-column\"><div translate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INVOICED_VAT\" class=\"caption\">Total VAT</div><div \nclass=\"value\">{{ vm.data.getTotalInvoicedVat() | currency }}</div><div \ntranslate=\"SALES_ORDERS.SALES_ORDER.BASIS_SALESORDER\" class=\"caption\">Basis Sales Order</div><div class=\"value\">\n{{ vm.data.getTotalVat() | currency }}</div><div translate=\"SALES_ORDERS.SALES_ORDER.DIFFERENCE\" class=\"caption\">\nDifference</div><div class=\"value\" \nng-class=\"{ \'green-600-fg\': vm.data.getTotalInvoicedVatDiff() > 0, \'red-800-fg\': vm.data.getTotalInvoicedVatDiff() < 0, \'grey-500-fg\': vm.data.getTotalInvoicedVatDiff() == 0 }\">\n{{ vm.data.getTotalInvoicedVatDiff() | currency }}</div></div></div></div></md-tab-body></md-tab></md-tabs><div \nlayout=\"row\" layout-padding layout-align=\"center center\" ng-if=\"vm.loadingService.isLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/sales-order/journal/sales-order-journal.tmpl.html","<div id=\"invoice-journal\" class=\"page-layout simple edit-page\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.goBack()\" translate translate-attr-aria-label=\"EC.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<span translate=\"SALES_ORDERS.INVOICE_JOURNAL.INVOICE_JOURNAL\">Invoice Journal</span></div></div></div></div><div \nclass=\"content\"><div class=\"journal-range md-background-bg\" md-whiteframe=\"1\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"SALES_ORDERS.INVOICE_JOURNAL.SELECT_RANGE\">Select Range</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"date-range\"><div layout=\"column\"><date-range-select mode=\"horizontal\" \nstart-date=\"vm.data.startDate\" end-date=\"vm.data.endDate\" on-update=\"vm.onUpdate()\"></date-range-select><md-checkbox \nng-model=\"vm.data.excludeExported\" ng-change=\"vm.onUpdate()\">\n{{ \"SALES_ORDERS.INVOICE_JOURNAL.EXCLUDE_EXPORTED\" | translate }}</md-checkbox></div><span flex></span><div \nlayout=\"column\"><md-select ng-model=\"vm.data.selectedExportFileType\"><md-option \nng-repeat=\"exportFileType in vm.data.exportFileTypes\" ng-value=\"exportFileType.value\">\n{{ exportFileType.text | translate }}</md-option></md-select><md-select ng-model=\"vm.data.selectedEncoding\"><md-option \nng-repeat=\"encoding in vm.data.encodings\" ng-value=\"encoding.value\">{{ encoding.text | translate }}</md-option>\n</md-select><md-button class=\"md-primary md-raised\" ng-click=\"vm.data.downloadJournalFile()\" \nng-disabled=\"!vm.data.startDate || !vm.data.endDate || !vm.data.journalEntries || vm.data.journalEntries.length === 0\">\n{{ \"SALES_ORDERS.INVOICE_JOURNAL.EXPORT_TO_FILE\" | translate }}</md-button><md-button \nng-if=\"vm.data.journalReports.length > 0\" ng-repeat=\"report in vm.data.journalReports\" class=\"md-raised\" \ntarget=\"_blank\" \nng-href=\"{{ vm.baldrisApiBase }}/api/Reports/DateRangedAsPdf/{{ report.id }}/{{ vm.data.startDate | date: \'yyyy-MM-dd\' }}/{{\n              vm.data.endDate | date: \'yyyy-MM-dd\'\n            }}\" \nng-disabled=\"!vm.data.startDate || !vm.data.endDate || !vm.data.journalEntries || vm.data.journalEntries.length === 0\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon>{{ report.name }}</md-button></div></div></div><div layout=\"row\" \nlayout-padding layout-align=\"center center\" ng-if=\"vm.loadingService.isLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"journal-result md-background-bg\" md-whiteframe=\"1\">\n<div class=\"pb-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" class=\"m-0 mr-16\">\n</md-icon><div class=\"h2 secondary-text\" translate=\"SALES_ORDERS.INVOICE_JOURNAL.SELECTED_INVOICES\">Selected invoices\n</div></div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"SALES_ORDERS.INVOICE.INVOICE_NUMBER\">Invoice No.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.CUSTOMER.CUSTOMER_NUMBER\">Customer No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.INVOICE.CUSTOMER\">Customer Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.INVOICE.INVOICE_DATE\">Invoice Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PRODUCTS.PRODUCT.BALANCE_ACCOUNT\">Balance Account</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_SUM_INC_VAT\">Total Sum</span></div></th></tr></thead><tbody><tr \nng-repeat=\"journalEntry in vm.data.journalEntries\"><td>{{::journalEntry.prefix}}{{::journalEntry.invoiceNumber}}</td>\n<td>{{::journalEntry.customerNumber}}</td><td>{{::journalEntry.customerDisplayName}}</td><td>\n{{::journalEntry.invoiceDate | date:\'shortDate\'}}</td><td>{{::journalEntry.balanceAccount}}</td><td class=\"text-right\">\n{{::journalEntry.totalSum | currency}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/sales-order/recent/sales-order-recent.tmpl.html","<div id=\"sales-order-recent\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span \ntranslate=\"{{ vm.salesOrderTitle }}\">Recent</span></div><div class=\"order-count secondary-text\" layout=\"row\" \nlayout-align=\"start start\"><div translate=\"SALES_ORDERS.SALES_ORDER.SALES_ORDER_PER_PAGE\">Sales orders per page:</div>\n<md-select ng-model=\"vm.recentAmount\" ng-change=\"vm.onRecentAmountChange()\"><md-option ng-value=\"10\">10</md-option>\n<md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n<md-option ng-value=\"200\">200</md-option><md-option ng-value=\"500\">500</md-option></md-select></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-model=\"vm.searchString\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" \nng-change=\"vm.onSearchStringChanged()\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SALES_ORDERS.DASHBOARD.SEARCH_TABLE\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content\" layout=\"column\" flex><div class=\"table-header\"><div><span>\n{{ \"SALES_ORDERS.SALES_ORDER.ORDER_CODE\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'ordercode\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!ordercode\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.SALES_ORDER.WORK_ORDER\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'workorder\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!workorder\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.SALES_ORDER.DECEASED\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'deceased\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!deceased\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.SALES_ORDER.SUBJECT\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'subject\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!subject\'\" \nmd-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>{{ \"SALES_ORDERS.SALES_ORDER.CUSTOMER\" | translate }}</span>\n<md-icon ng-if=\"vm.sortField === \'customer\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!customer\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.SALES_ORDER.CREATED\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'created\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!created\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.SALES_ORDER.DEPARTMENT\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'department\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!department\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.SALES_ORDER.TOTAL\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'totalsum\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!totalsum\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.SALES_ORDER.INVOICES\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'invoices\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!invoices\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div></div><md-progress-linear \nmode=\"query\" ng-if=\"vm.isLoadingLatestSalesOrders\"></md-progress-linear><div flex class=\"table-data\" \nng-if=\"!vm.isLoadingLatestSalesOrders\"><div class=\"table-item clickable\" ng-repeat=\"item in vm.paginatedData.data\" \nng-click=\"vm.navigateToSalesOrder(item)\" md-ink-ripple=\"true\"><div><span>{{ item.orderCode }}</span></div><div><span>\n{{ item.workOrderCode }}</span></div><div><span>{{ item.deceased }}</span></div><div><span>{{ item.subject }}</span>\n</div><div><span>{{ item.customerName }}</span></div><div><span>{{ item.created | date: \"shortDate\" }}</span></div>\n<div><span>{{ item.departmentName }}</span></div><div><span>{{ item.totalSumIncludingVat | currency }}</span></div>\n<div><span>{{ item.invoiceCount }}</span></div></div></div><div class=\"table-pagination\"><div class=\"results\"><div \nng-if=\"vm.paginatedData && vm.paginatedData.count > 0\"><span translate=\"COMMON.DATA.PAGINATION_INFO\" \ntranslate-values=\"{ start: vm.paginatedData.pageSize * vm.paginatedData.pageIndex + 1, end: vm.getEndPagination(), total: vm.paginatedData.count }\">\n</span> / <span translate=\"COMMON.DATA.PAGINATION_PAGE_INFO\" \ntranslate-values=\"{ currentPage: vm.paginatedData.pageIndex + 1, totalPages: vm.paginatedData.pageCount + 1 }\"></span>\n</div><div ng-if=\"!vm.paginatedData || vm.paginatedData.count === 0\">{{ \"COMMON.DATA.PAGINATION_EMPTY\" | translate }}\n</div></div><div ng-if=\"vm.paginatedData && vm.paginatedData.count > 0\" class=\"pagination-buttons\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.navigateToFirst()\" aria-label=\"Jump backwards\" \nng-disabled=\"vm.paginatedData.pageIndex === 0\" translate-attr-aria-label=\"COMMON.DATA.PAGINATION_FIRST\"><md-tooltip \nmd-direction=\"top\"><span translate=\"COMMON.DATA.PAGINATION_FIRST_TOOLTIP\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-skip-previous\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateBackward(10)\" aria-label=\"Jump backwards\" ng-disabled=\"vm.paginatedData.pageIndex === 0\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_JUMP\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_JUMP_BACKWARD_TOOLTIP\" translate-values=\"{ amount: 10 }\"></span></md-tooltip><md-icon\n md-font-icon=\"icon-fast-forward\" class=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateBackward(1)\" aria-label=\"Previous\" ng-disabled=\"vm.paginatedData.pageIndex === 0\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_PREVIOUS\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_PREVIOUS_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\" \nclass=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.navigateForward(1)\" \nng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" aria-label=\"Next\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_NEXT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_NEXT_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.navigateForward(10)\" \nng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" aria-label=\"Jump Forward\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_JUMP_FORWARD\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_JUMP_FORWARD_TOOLTIP\" translate-values=\"{ amount: 10 }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateToLast()\" ng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" \naria-label=\"Jump backwards\" translate-attr-aria-label=\"COMMON.DATA.PAGINATION_LAST\"><md-tooltip md-direction=\"top\">\n<span translate=\"COMMON.DATA.PAGINATION_LAST_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-skip-next\">\n</md-icon></md-button></div></div></div></div></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-sales-order-button\" ng-click=\"vm.showAddSalesOrderDialog($event)\" aria-label=\"add work order\" translate \ntranslate-attr-aria-label=\"SALES-ORDERS.SALES_ORDER.ADD-SALES-ORDER\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/sales-order/recent-invoices/sales-order-recent-invoices.tmpl.html","<div id=\"sales-order-recent-invoices\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span \ntranslate=\"{{ vm.invoiceTitle }}\">Recent</span></div><div ng-if=\"vm.showRecentAmount\" \nclass=\"order-count secondary-text\" layout=\"row\" layout-align=\"start start\"><div \ntranslate=\"SALES_ORDERS.INVOICE.INVOICES_PER_PAGE\">Invoices per page:</div><md-select ng-model=\"vm.recentAmount\" \nng-change=\"vm.onRecentAmountChange()\"><md-option ng-value=\"10\">10</md-option><md-option ng-value=\"25\">25</md-option>\n<md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-model=\"vm.searchString\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" \nng-change=\"vm.onSearchStringChanged()\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SALES_ORDERS.DASHBOARD.SEARCH_TABLE\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content\" layout=\"column\" flex><div class=\"table-header\"><div class=\"text-centered\">\n<span>{{ \"SALES_ORDERS.INVOICE.IS_LOCKED\" | translate }}</span></div><div><span>\n{{ \"SALES_ORDERS.INVOICE.DEPARTMENT\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'department\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!department\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.INVOICE.SUBJECT\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'subject\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!subject\'\" \nmd-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>{{ \"SALES_ORDERS.INVOICE.CUSTOMER\" | translate }}</span>\n<md-icon ng-if=\"vm.sortField === \'customer\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!customer\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.INVOICE.INVOICE_NUMBER\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'invoicenumber\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!invoicenumber\'\" \nmd-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>{{ \"SALES_ORDERS.INVOICE.INVOICE_TYPE\" | translate }}</span>\n<md-icon ng-if=\"vm.sortField === \'type\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!type\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.INVOICE.INVOICE_DATE\" | translate }}</span><md-icon ng-if=\"vm.sortField === \'invoicedate\'\" \nmd-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!invoicedate\'\" md-font-icon=\"icon-arrow-down\">\n</md-icon></div><div><span>{{ \"SALES_ORDERS.INVOICE.DUE_DATE\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'duedate\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon ng-if=\"vm.sortField === \'!duedate\'\" \nmd-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>{{ \"SALES_ORDERS.INVOICE.TOTAL\" | translate }}</span><md-icon\n ng-if=\"vm.sortField === \'totalsum\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!totalsum\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div><span>\n{{ \"SALES_ORDERS.INVOICE.TOTAL_INCLUDING_VAT\" | translate }}</span><md-icon \nng-if=\"vm.sortField === \'totalsumincludingvat\'\" md-font-icon=\"icon-arrow-up\"></md-icon><md-icon \nng-if=\"vm.sortField === \'!totalsumincludingvat\'\" md-font-icon=\"icon-arrow-down\"></md-icon></div><div \nclass=\"text-centered\"><span>{{ \"SALES_ORDERS.INVOICE.IS_PAYED_IN_FULL\" | translate }}</span></div><div></div></div>\n<md-progress-linear mode=\"query\" ng-if=\"vm.isLoadingLatestSalesOrders\"></md-progress-linear><div flex \nclass=\"table-data\" ng-if=\"!vm.isLoadingLatestSalesOrders\"><div class=\"table-item clickable\" \nng-repeat=\"item in vm.paginatedData.data\" ng-click=\"vm.navigateToInvoice(item)\" md-ink-ripple=\"true\"><div \nclass=\"icon-item\"><md-icon ng-if=\"item.isLocked\" md-font-icon=\"icon-lock\" class=\"red-500-fg\"></md-icon><md-icon \nng-if=\"!item.isLocked\" md-font-icon=\"icon-lock-unlocked\" class=\"green-500-fg\"></md-icon></div><div><span>\n{{ item.salesOrderDepartmentOrganizationDisplayName }}</span></div><div><span>{{ item.subject }}</span></div><div>\n<span>{{ item.customerPartyDisplayName }}</span></div><div><span>{{ item.prefix }}{{ item.invoiceNumber }}</span></div>\n<div><span ng-if=\"item.isReminder\">{{ \"SALES_ORDERS.INVOICE.REMINDER\" | translate }}</span> <span \nng-if=\"item.isCreditNote\" class=\"red-500-fg\">{{ \"SALES_ORDERS.INVOICE.CREDIT_NOTE\" | translate }}</span> <span \nng-if=\"!item.isReminder && !item.isCreditNote\">{{ \"SALES_ORDERS.INVOICE.INVOICE\" | translate }}</span></div><div><span>\n{{ item.invoiceDate | date: \"shortDate\" }}</span></div><div><span>{{ item.dueDate | date: \"shortDate\" }}</span></div>\n<div><span>{{ item.totalSum | currency }}</span></div><div><span>{{ item.totalSumIncludingVat | currency }}</span>\n</div><div class=\"icon-item\"><md-icon \nng-if=\"item.totalSumIncludingVat !== item.totalFinancialTransactions && (!item.totalFinancialTransactions || item.totalFinancialTransactions === 0)\" \nmd-font-icon=\"icon-star-outline\"></md-icon><md-icon \nng-if=\"item.totalSumIncludingVat !== item.totalFinancialTransactions && item.totalFinancialTransactions > 0 && item.totalFinancialTransactions < item.totalSumIncludingVat\" \nmd-font-icon=\"icon-star-half\" class=\"amber-500-fg\"></md-icon><md-icon \nng-if=\"item.totalSumIncludingVat !== item.totalFinancialTransactions && item.totalFinancialTransactions > 0 && item.totalFinancialTransactions > item.totalSumIncludingVat\" \nmd-font-icon=\"icon-star\" class=\"deep-purple-500-fg\"></md-icon><md-icon \nng-if=\"item.totalSumIncludingVat === item.totalFinancialTransactions\" md-font-icon=\"icon-star\" class=\"green-500-fg\">\n</md-icon></div><div><md-menu><md-button aria-label=\"{{ \'COMMON.DATA.SHOW_MORE_OPTIONS\' | translate }}\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.navigateToInvoice(item)\"><md-icon md-font-icon=\"icon-receipt\"></md-icon>\n{{ \"SALES_ORDERS.INVOICE.OPEN_INVOICE\" | translate }}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.navigateToSalesOrder(item.salesOrderId)\"><md-icon md-font-icon=\"icon-basket\"></md-icon>\n{{ \"SALES_ORDERS.INVOICE.GO_TO_SALES_ORDER\" | translate }}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.getPreviewUrl(item)\"><md-button ng-href=\"{{ vm.getPreviewUrl(item) }}\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon>{{ \"SALES_ORDERS.INVOICE.PREVIEW\" | translate }}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.openRegisterTransactionDialog(item, $event)\"><md-icon \nmd-font-icon=\"icon-credit-card\"></md-icon>{{ \"SALES_ORDERS.INVOICE.REGISTER_TRANSACTION\" | translate }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><div class=\"table-pagination\"><div class=\"results\"><div \nng-if=\"vm.paginatedData && vm.paginatedData.count > 0\"><span translate=\"COMMON.DATA.PAGINATION_INFO\" \ntranslate-values=\"{ start: vm.paginatedData.pageSize * vm.paginatedData.pageIndex + 1, end: vm.getEndPagination(), total: vm.paginatedData.count }\">\n</span> / <span translate=\"COMMON.DATA.PAGINATION_PAGE_INFO\" \ntranslate-values=\"{ currentPage: vm.paginatedData.pageIndex + 1, totalPages: vm.paginatedData.pageCount + 1 }\"></span>\n</div><div ng-if=\"!vm.paginatedData || vm.paginatedData.count === 0\">{{ \"COMMON.DATA.PAGINATION_EMPTY\" | translate }}\n</div></div><div ng-if=\"vm.paginatedData && vm.paginatedData.count > 0\" class=\"pagination-buttons\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.navigateToFirst()\" aria-label=\"Jump backwards\" \nng-disabled=\"vm.paginatedData.pageIndex === 0\" translate-attr-aria-label=\"COMMON.DATA.PAGINATION_FIRST\"><md-tooltip \nmd-direction=\"top\"><span translate=\"COMMON.DATA.PAGINATION_FIRST_TOOLTIP\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-skip-previous\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateBackward(10)\" aria-label=\"Jump backwards\" ng-disabled=\"vm.paginatedData.pageIndex === 0\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_JUMP\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_JUMP_BACKWARD_TOOLTIP\" translate-values=\"{ amount: 10 }\"></span></md-tooltip><md-icon\n md-font-icon=\"icon-fast-forward\" class=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateBackward(1)\" aria-label=\"Previous\" ng-disabled=\"vm.paginatedData.pageIndex === 0\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_PREVIOUS\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_PREVIOUS_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\" \nclass=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.navigateForward(1)\" \nng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" aria-label=\"Next\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_NEXT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_NEXT_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.navigateForward(10)\" \nng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" aria-label=\"Jump Forward\" \ntranslate-attr-aria-label=\"COMMON.DATA.PAGINATION_JUMP_FORWARD\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.PAGINATION_JUMP_FORWARD_TOOLTIP\" translate-values=\"{ amount: 10 }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.navigateToLast()\" ng-disabled=\"vm.paginatedData.pageIndex >= vm.paginatedData.pageCount\" \naria-label=\"Jump backwards\" translate-attr-aria-label=\"COMMON.DATA.PAGINATION_LAST\"><md-tooltip md-direction=\"top\">\n<span translate=\"COMMON.DATA.PAGINATION_LAST_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-skip-next\">\n</md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/song/edit-song/edit-song.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" layout=\"column\" layout-margin layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"edit-song\" \nng-form=\"vm.data.validation.songForm\" ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" layout-gt-lg=\"row\" \nlayout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'SONGS.SONG.SONG\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\"><div><md-input-container class=\"md-block\"><label>{{\'SONGS.SONG.TITLE\' | translate}}</label><input \nng-model=\"vm.data.updateModel.song.title\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'SONGS.SONG.IDENTIFIER\' | translate}}</label><input ng-model=\"vm.data.updateModel.song.identifier\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'SONGS.SONG.FROM_COLLECTION\' | translate}}</label><input ng-model=\"vm.data.updateModel.song.fromCollection\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>{{\'SONGS.SONG.ORIGINAL_TITLE\' | translate}}\n</label><input ng-model=\"vm.data.updateModel.song.originalTitle\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'SONGS.SONG.SEARCH_TERMS\' | translate}}</label><input \nng-model=\"vm.data.updateModel.song.searchTerms\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'SONGS.SONG.LANGUAGE\' | translate}}</label><input ng-model=\"vm.data.updateModel.song.language\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>{{\'SONGS.SONG.YEAR\' | translate}}</label>\n<input type=\"number\" step=\"1\" ng-model=\"vm.data.updateModel.song.year\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{\'SONGS.SONG.TEXT_COMPOSER\' | translate}}</label><input \nng-model=\"vm.data.updateModel.song.textComposer\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'SONGS.SONG.COMPOSER\' | translate}}</label><input ng-model=\"vm.data.updateModel.song.composer\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>{{\'SONGS.SONG.TRANSLATOR\' | translate}}\n</label><input ng-model=\"vm.data.updateModel.song.translator\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.data.updateModel.song.isDeleted\" \naria-label=\"{{\'SONGS.SONG.IS_DELETED\' | translate}}\">{{\'SONGS.SONG.IS_DELETED\' | translate}}</md-checkbox>\n</md-input-container></div></md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\">\n<ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">{{ \'SONGS.SONG.VERSES\' | translate }}</div>\n</div><md-content layout-padding layout=\"column\"><div class=\"verse\" \nng-repeat-start=\"verse in vm.data.updateModel.songVerses | orderBy:\'sortOrder\'\"><div><md-input-container \nclass=\"md-block\"><label>{{\'SONGS.SONG_VERSE.VERSE_NUMBER\' | translate}}</label><input ng-model=\"verse.verseNumber\" \nng-change=\"vm.data.onSongVerseChanged(verse)\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'SONGS.SONG_VERSE.TEXT\' | translate}}</label><textarea ng-model=\"verse.text\" \nng-change=\"vm.data.onSongVerseChanged(verse)\"></textarea></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'SONGS.SONG_VERSE.SORT_ORDER\' | translate}}</label><input type=\"number\" step=\"1\" \nng-model=\"verse.sortOrder\" ng-change=\"vm.data.onSongVerseChanged(verse)\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"verse.isDeleted\" \nng-change=\"vm.data.onSongVerseChanged(verse)\" aria-label=\"{{\'SONGS.SONG_VERSE.IS_DELETED\' | translate}}\">\n{{\'SONGS.SONG_VERSE.IS_DELETED\' | translate}}</md-checkbox></md-input-container></div></div><md-divider ng-repeat-end \nng-if=\"!$last\"></md-divider><div><md-button class=\"md-raised\" ng-click=\"vm.data.addSongVerse()\">\n{{ \'SONGS.EDIT_SONG.ADD_SONG_VERSE\' | translate }}</md-button></div></md-content></ms-widget-front></ms-widget></div>\n<div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.programForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\">{{ \'PROGRAMS.EDIT_PROGRAM.SAVE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/song/song-library/song-library.tmpl.html","<div id=\"song-library\" class=\"two-sidebars-toolbar page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-note\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ \"SONGS.SONG_LIBRARY.SONG_LIBRARY\" | translate }}</span></div></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/song/song-library/partials/song-library-sidebar.tmpl.html\'\"></md-sidenav><div \nclass=\"song-library-toolbar\" ui-view=\"toolbar\"></div><div class=\"main\" ui-view=\"content\" ms-scroll></div></div>\n<md-button class=\"md-fab md-accent md-icon-button add-button\" \nui-sref=\"app.song.songLibrary.editSong({ songId: \'new\' })\" aria-label=\"add song\" translate \ntranslate-attr-aria-label=\"SONGS.SONG_LIBRARY.ADD_SONG\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/statistics/ceremony/ceremony-statistics.tmpl.html","<table class=\"dataTable row-border hover\"><tbody><tr \nng-repeat=\"dataEntry in vm.data | orderBy:[\'ceremonyTypeName\',\'locationName\',\'departmentName\']\"><td>\n{{::vm.getDataName(dataEntry)}}</td><td>{{::dataEntry.count}}</td></tr><tr><td><strong>\n{{\'COMMON.DATA.TOTAL\' | translate}}</strong></td><td><strong>{{vm.getTotal()}}</strong></td></tr></tbody></table>");
$templateCache.put("app/main/statistics/deceased/deceased-statistics.tmpl.html","<table class=\"dataTable row-border hover\"><tbody><tr \nng-repeat=\"dataEntry in vm.data | orderBy:[\'municipalityName\',\'departmentName\']\"><td>{{::vm.getDataName(dataEntry)}}\n</td><td>{{::dataEntry.count}}</td></tr><tr><td><strong>{{ \"COMMON.DATA.TOTAL\" | translate }}</strong></td><td><strong>\n{{ vm.getTotal() }}</strong></td></tr></tbody></table>");
$templateCache.put("app/main/statistics/sales/sales-statistics.tmpl.html","<table class=\"dataTable row-border hover\"><tbody><tr \nng-repeat=\"dataEntry in vm.data | orderBy:[\'departmentName\',\'productType\',\'productName\']\"><td>\n{{::vm.getDataName(dataEntry)}}</td><td>{{::dataEntry.count }}</td><td>{{::dataEntry.amount | currency}}</td></tr><tr>\n<td><strong>{{ \"COMMON.DATA.TOTAL\" | translate }}</strong></td><td><strong>{{ vm.getTotal() }}</strong></td><td>\n<strong>{{ vm.getTotalAmount() | currency }}</strong></td></tr></tbody></table>");
$templateCache.put("app/main/statistics/views/sidebar.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.STATISTICS.STATISTICS\" | translate }}</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nng-if=\"vm.canReadWorkOrderStatistics\" ui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.statistics.deceased\"><p>\n<md-icon md-font-icon=\"icon-clipboard-account\" class=\"s24\"></md-icon>\n{{ \"STATISTICS.DECEASED.DECEASED_STATISTICS\" | translate }}</p></md-list-item><md-list-item \nng-if=\"vm.canReadWorkOrderStatistics\" ui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.statistics.ceremony\"><p>\n<md-icon md-font-icon=\"icon-church\" class=\"s24\"></md-icon>{{ \"STATISTICS.CEREMONY.CEREMONY_STATISTICS\" | translate }}\n</p></md-list-item><md-list-item ng-if=\"vm.canReadSalesStatistics\" ui-sref-active=\"selected md-accent-bg\" \nui-sref=\"app.statistics.sales\"><p><md-icon md-font-icon=\"icon-church\" class=\"s24\"></md-icon>\n{{ \"STATISTICS.SALES.SALES_STATISTICS\" | translate }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/transport/edit-transport/edit-transport.tmpl.html","<div class=\"edit-transport\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.calendarEventForm\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'TRANSPORTS.EDIT_TRANSPORT.TIME_AND_PLACE\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" \nng-include=\"\'app/main/transport/edit-transport/views/transport-calendar-event.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" ng-if=\"!vm.loadingService.isLoading\">\n<ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'TRANSPORTS.TRANSPORT.TRANSPORT\' | translate}}</div></div><md-content layout-padding layout=\"column\" \nng-include=\"\'app/main/transport/edit-transport/views/transport-general.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-repeat=\"category in vm.data.customFieldCategories | orderBy:\'sortOrder\' | filter:vm.data.customFieldCategoryFilter\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingCustomFieldData\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{category.name}}</div></div><md-content layout-padding layout=\"column\" \nclass=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFields | orderBy:\'sortOrder\'  | filter:vm.data.customFieldFilter\">\n</edit-custom-field></md-content></ms-widget-front></ms-widget><div ng-if=\"vm.data.isLoadingCustomFieldData\" flex \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nng-if=\"!vm.loadingService.isLoading && !vm.data.isLoadingEquipment\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'CEREMONIES.CEREMONY.EQUIPMENT\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditCalendarEventEquipmentDialog(null, $event)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"><md-tooltip md-direction=\"top\">\n<span translate=\"CEREMONIES.EDIT_CEREMONY.ADD_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content layout-padding layout=\"column\" class=\"md-padding\"><md-list><md-list-item \nclass=\"md-2-line\" \nng-repeat=\"ceremonyEquipment in vm.data.updateModel.equipment | filter:{ changeState: \'!3\' } | orderBy:\'sortOrder\'\" \nng-click=\"vm.data.openEditCalendarEventEquipmentDialog(ceremonyEquipment, $event)\"><img \nng-if=\"ceremonyEquipment.equipmentImageFilepath\" baldris-img-src=\"ceremonyEquipment.equipmentImageFilepath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ceremonyEquipment.equipmentName}}\"><div class=\"md-list-item-text\">\n<h3>{{ ceremonyEquipment.amount || 0 }} stk. {{ ceremonyEquipment.equipmentName }}</h3><p>\n{{ ceremonyEquipment.equipmentType }}</p></div></md-list-item></md-list></md-content></ms-widget-front></ms-widget><div\n ng-if=\"vm.data.isLoadingEquipment\" flex layout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div></div><div layout=\"row\" class=\"margin-left-20 margin-right-20\">\n<md-button class=\"md-warn\" ng-click=\"vm.deleteCalendarEvent($event)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\">\n{{ \'CALENDAR.DELETE_EVENT.DELETE_EVENT_ACTION\' | translate}}</md-button><span flex></span><md-button \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\">\n{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/transport/logistics/transport-logistics.tmpl.html","<div id=\"transport-logistics\" class=\"page-layout small simple tabbed\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\"><span class=\"h2 white-fg\"><md-icon md-font-icon=\"icon-truck\">\n</md-icon>{{ \"MENU.TRANSPORT.LOGISTICS\" | translate }}</span></div><md-button \nclass=\"add-work-order-button md-fab md-warn\" ng-click=\"vm.addWorkOrder($event)\" aria-label=\"Add work order\" translate \ntranslate-attr-aria-label=\"WORK-ORDERS.ADD-WORK-ORDER\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nclass=\"content\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nng-click=\"vm.previousWeek()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><h2><span>\nUKE {{ vm.currentData.fromDate | date: \"w\" }}</span></h2><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nng-click=\"vm.nextWeek()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><h4>\n{{ vm.currentData.fromDate | date: \"shortDate\" }} – {{ vm.currentData.toDate | date: \"shortDate\" }}</h4><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button></div></md-toolbar>\n<div ui-view></div></div></div>");
$templateCache.put("app/main/work-order/dashboard/work-order-dashboard.tmpl.html","<div id=\"work-order-dashboard\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.WORK_ORDER.WORK_ORDERS\">Work Orders</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"product-list-search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input id=\"product-list-search\" placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.currentData.searchTerm\" translate \ntranslate-attr-placeholder=\"WORK_ORDERS.DASHBOARD.SEARCH_IN_LIST\" ng-change=\"vm.currentData.searchTermChanged()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 750, \'blur\': 0 } }\"></md-input-container></div>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/work-order/dashboard/partials/work-order-dashboard-sidebar.tmpl.html\'\"></md-sidenav><div \nclass=\"main\" ui-view></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-work-order-button\" \nng-click=\"vm.showAddWorkOrderDialog($event, vm.currentDepartment, vm.currentWorkOrderType)\" \naria-label=\"add work order\" translate translate-attr-aria-label=\"WORK-ORDERS.ADD-WORK-ORDER\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/work-order/quick-registration-deceased/quick-registration-deceased.tmpl.html","<div class=\"quick-registration-deceased\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.data.validation.quickRegistrationForm\" ng-if=\"!vm.loadingService.isLoading\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'WORK_ORDERS.WORK_ORDER.WORK_ORDER\' | translate}}</div></div><md-content \nng-include=\"\'app/main/work-order/quick-registration-deceased/views/work-order.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'DECEASED.DECEASED.DECEASED\' | translate}}</div></div><md-content \nng-include=\"\'app/main/work-order/quick-registration-deceased/views/deceased.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'WORK_ORDERS.QUICK_REGISTRATION.CONFERENCE_NAME\' | translate}}</div></div><md-content\n ng-include=\"\'app/main/work-order/quick-registration-deceased/views/appointment.tmpl.html\'\"></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'CEREMONIES.CEREMONY.CEREMONY\' | translate}}</div></div><md-content \nng-if=\"!vm.data.updateModel.ceremony\" layout=\"column\" layout-padding><md-button ng-click=\"vm.data.addCeremony()\">\n{{ \'WORK_ORDERS.QUICK_REGISTRATION.ADD_CEREMONY\' | translate }}</md-button></md-content><md-content \nng-include=\"\'app/main/work-order/quick-registration-deceased/views/ceremony.tmpl.html\'\"></md-content></ms-widget-front>\n</ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.Cancel\">{{ \'CEREMONIES.EDIT_CEREMONY.CANCEL\' | translate}}\n</md-button><md-button click-and-wait=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.quickRegistrationForm.$invalid\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\">{{ \'CEREMONIES.EDIT_CEREMONY.SAVE\' | translate}}</md-button>\n</div></md-content></div>");
$templateCache.put("app/main/work-order/search/work-order-search.tmpl.html","<div id=\"work-order-search\" class=\"page-layout simple tabbed\"><div class=\"header md-primary-bg md-hue-2\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.searchTerm\" \ntype=\"text\" placeholder=\"Search for Work Orders..\" translate \ntranslate-attr-placeholder=\"WORK_ORDERS.SEARCH.SEARCH_WORK_ORDERS\" flex ng-change=\"vm.searchTermChanged()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 750, \'blur\': 0 } }\"></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate \ntranslate-attr-aria-label=\"WORK_ORDERS.SEARCH.SEARCH_SETTINGS\"><md-icon md-menu-origin md-menu-align-target \nmd-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-repeat=\"workOrderType in vm.workOrderTypes\"><md-button ng-click=\"vm.selectWorkOrderType(workOrderType)\"><md-icon \nmd-font-icon=\"{{ vm.selectedWorkOrderType === workOrderType ? \'icon-check\' : \'icon-checkbox-blank-outline\' }}\" \nmd-menu-align-target></md-icon><p>{{ workOrderType.name }}</p></md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item ng-repeat=\"department in vm.departments\"><md-button ng-click=\"vm.selectDepartment(department)\"><md-icon \nmd-font-icon=\"{{ vm.selectedDepartment === department ? \'icon-check\' : \'icon-checkbox-blank-outline\' }}\" \nmd-menu-align-target></md-icon><p>{{ department.organizationDisplayName }}</p></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"content\" flex><md-content><div class=\"result-info\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" \ntranslate=\"MENU.WORK_ORDER.WORK_ORDERS\">Users</span> <span class=\"secondary-text\"><span>{{ vm.searchResults.length }}\n</span> <span translate=\"WORK_ORDERS.SEARCH.SEARCH_RESULTS\">Results</span></span></div></div><div class=\"loading-bar\" \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><table ng-if=\"!vm.loadingService.isLoading\" \nclass=\"results simple clickable\" ms-responsive-table><thead><tr><th class=\"marker\"></th><th \ntranslate=\"WORK_ORDERS.WORK_ORDER.ORDER_CODE\">Order Code</th><th translate=\"WORK_ORDERS.WORK_ORDER.DECEASED.DECEASED\">\nDeceased</th><th translate=\"WORK_ORDERS.WORK_ORDER.WORK_ORDER_TYPE\">Work Order Type</th><th \ntranslate=\"WORK_ORDERS.WORK_ORDER.DEPARTMENT\">Department</th><th \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.REFERENCE_PERSONS\">Reference Persons</th><th \ntranslate=\"WORK_ORDERS.WORK_ORDER.CEREMONY\">Ceremony</th></tr></thead><tbody><tr class=\"result-item user\" \nng-repeat=\"workOrder in vm.searchResults\" ng-click=\"vm.navigateToWorkOrder(workOrder)\"><td class=\"marker\" \nng-style=\"{ \'background-color\': workOrder.firstCeremonyTypeColor }\"></td><td class=\"order-code\" \nmd-highlight-text=\"vm.searchTerm\" md-highlight-flags=\"gi\">{{ workOrder.orderCode }}</td><td class=\"deceased\" \nmd-highlight-text=\"vm.searchTerm\" md-highlight-flags=\"gi\">{{ workOrder.deceasedSerialized }}</td><td \nclass=\"work-order-type\">{{ workOrder.workOrderTypeName }}</td><td class=\"department\">\n{{ workOrder.departmentOrganizationDisplayName }}</td><td class=\"reference-persons\" md-highlight-text=\"vm.searchTerm\" \nmd-highlight-flags=\"gi\">{{ workOrder.referencePersonsSerialized }}</td><td class=\"ceremony\" \nmd-highlight-text=\"vm.searchTerm\" md-highlight-flags=\"gi\">\n{{ workOrder.firstCeremonyLocationSerialized }}, {{ workOrder.firstCeremonyStartTime | date: \"short\" }}</td></tr>\n</tbody></table></md-content></div></div>");
$templateCache.put("app/main/work-order/work-order/work-order.tmpl.html","<div id=\"work-order\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ vm.service.currentData.workOrder.orderCode }} – {{ vm.service.currentData.workOrder.deceased }}</span></div>\n<md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'work-order-sidenav-right\')\" \naria-label=\"Toggle notes and tasks\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\">\n<md-sidenav class=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/work-order/work-order/views/sidenav/work-order-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"main-wrapper\"><div class=\"work-order-top-nav\" ui-view=\"toolbar\"></div><div ms-scroll class=\"scrollable main\" \nui-view=\"content\"></div></div><md-sidenav class=\"sidenav md-sidenav-right work-order-sidenav-right md-white-bg\" \nms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"work-order-sidenav-right\">\n<div class=\"work-order-sidenav-right-view\" ui-view=\"sidenav-right\"></div></md-sidenav></div></div>");
$templateCache.put("app/main/work-order-reference-person/edit-reference-person/edit-reference-person.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"edit-reference-person\" \nng-form=\"vm.data.validation.referencePersonForm\" ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" \nlayout-gt-lg=\"row\"><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.PERSONALIA\" | translate }}</div>\n</div><md-content layout-padding layout=\"column\"><relevant-signature-jobs \nng-if=\"vm.consignmentsActivated && vm.showPrivacyComponents()\" ng-disabled=\"vm.isConsignmentsDisabled()\" \ndisabled-text=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SET_PRIVACY_SETTINGS_TO_ACTIVATE_CONSIGNMENTS\" \nreference-person-id=\"vm.data.updateModel.referencePerson.id\" \nwork-order-id=\"vm.data.updateModel.referencePerson.workOrderId\"></relevant-signature-jobs><p \nclass=\"consignments-disabled\" \nng-if=\"vm.consignmentsActivated && vm.isConsignmentsDisabled() && vm.showPrivacyComponents()\">\n{{\'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SET_PRIVACY_SETTINGS_TO_ACTIVATE_CONSIGNMENTS\' | translate}}</p>\n<party-privacy-summary ng-if=\"vm.showPrivacyComponents()\" party-id=\"vm.data.updateModel.referencePerson.personId\" \nparty-privacy-options=\"vm.data.updateModel.referencePerson.privacyOptions\" \nreference-person-id=\"vm.data.updateModel.referencePerson.id\" \nwork-order-id=\"vm.data.updateModel.referencePerson.workOrderId\" \nreference-person-type-mask=\"vm.data.updateModel.referencePerson.referencePersonType\" \non-update=\"vm.onPrivacyUpdate(privacyFieldsActivated)\"></party-privacy-summary><edit-party \nng-if=\"!vm.data.isPseudomized()\" baldris-model=\"vm.data.updateModel.referencePerson\" is-disabled=\"vm.isDisabled\" \nshow-death-date=\"vm.data.showDateOfDeath\"></edit-party><h2 ng-if=\"vm.data.isPseudomized()\">\n{{ vm.data.updateModel.partyUpdateModel.party.displayName | translate }}</h2><inline-address-list \nng-if=\"!vm.data.isPseudomized()\" party-id=\"vm.data.updateModel.referencePerson.personId\" \ncollection=\"vm.data.updateModel.addresses\"></inline-address-list><inline-email-list ng-if=\"!vm.data.isPseudomized()\" \nparty-id=\"vm.data.updateModel.referencePerson.personId\" collection=\"vm.data.updateModel.emails\"></inline-email-list>\n<inline-telephone-list ng-if=\"!vm.data.isPseudomized()\" party-id=\"vm.data.updateModel.referencePerson.personId\" \ncollection=\"vm.data.updateModel.telephones\"></inline-telephone-list></md-content></ms-widget-front></ms-widget></div>\n<div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.CANCEL\">\n{{ \"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.CANCEL\" | translate }}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" \nng-disabled=\"vm.data.validation.referencePersonForm.$pristine && vm.data.validation.referencePersonSidebarForm.$pristine\" \ntranslate-attr-aria-label=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SAVE\">\n{{ \"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SAVE\" | translate }}</md-button></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" ng-class=\"vm.fuseTheming.getThemeMetaData().mainMenuClass\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"logo-image\" src=\"/assets/images/logos/baldris-logo.svg\"> <span class=\"logo-text\">BALDRIS</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" src=\"/assets/images/logos/baldris-logo.svg\"> <span \nclass=\"logo-text\">BALDRIS</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target ng-if=\"!vm.currentUser.profileImageId\" class=\"avatar\" \ngravatar-src=\"vm.currentUser.email\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{vm.currentUser.displayName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><form method=\"POST\" action=\"/Account/LogOff\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button type=\"submit\">\n{{ \'TOOLBAR.LOGOUT\' | translate }}</md-button></md-menu-item></form></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code.replace(\'_\',\'-\')}}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" src=\"/assets/images/logos/baldris-logo.svg\"> <span \nclass=\"logo-text\">BALDRIS</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><ms-search-bar></ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target ng-if=\"!vm.currentUser.profileImageId\" class=\"avatar\" \ngravatar-src=\"vm.currentUser.email\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{vm.currentUser.displayName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">{{ \'TOOLBAR.LOGOUT\' | translate }}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code.replace(\'_\',\'-\')}}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" ng-class=\"vm.fuseTheming.getThemeMetaData().mainMenuClass\"><div \nlayout=\"row\" layout-align=\"start center\" flex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target ng-if=\"vm.currentUser.profileImageId\" class=\"avatar\" \nbaldris-img-src=\"vm.currentUser.profileImageFilepath || vm.currentUser.profileImage.filepath\" \npreset=\"square-40-cropped\"> <img md-menu-align-target ng-if=\"!vm.currentUser.profileImageId\" class=\"avatar\" \ngravatar-src=\"vm.currentUser.email\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{ vm.currentUser.displayName }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" type=\"button\">{{ \"TOOLBAR.LOGOUT\" | translate }}</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\" ng-repeat=\"(themeName, theme) in vm.themes.list\"><md-icon \nng-if=\"vm.shouldShowTheme(themeName)\" ng-style=\"{\'color\': theme.primary.color}\" md-font-icon=\"icon-palette\" \nclass=\"icon\"></md-icon><md-button ng-if=\"vm.shouldShowTheme(themeName)\" aria-label=\"{{ themeName }}\" \nng-click=\"vm.setActiveTheme(themeName)\" type=\"button\">{{ vm.getThemeMetaData(themeName).friendlyName }}</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{ vm.selectedLanguage.flag }}.png\"> <span \nclass=\"iso\">{{ vm.selectedLanguage.code.replace(\"_\", \"-\") }}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{ lang.title }}\" translate \ntranslate-attr-aria-label=\"{{ lang.title }}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{ lang.flag }}.png\"> <span translate=\"{{ lang.translation }}\">{{ lang.title }}</span>\n</span></md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/account/components/user-single-select/user-single-select.tmpl.html","<div ng-form=\"vm.baldrisUserForm\" class=\"baldris-user-single-select\"><div layout=\"row\"><md-autocomplete flex \nmd-min-length=\"0\" md-input-name=\"baldrisUser\" md-selected-item=\"vm.baldrisUser\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.displayName\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-baldris-user-single-select\" ng-disabled=\"vm.isDisabled\"><md-item-template><div><img \ngravatar-src=\"item.email\" alt=\"{{item.displayName}}\" ng-if=\"!item.profileImageFilepath && item.email\"> <img \nclass=\"profile-image\" ng-if=\"item.profileImageFilepath\" baldris-img-src=\"item.profileImageFilepath\" \npreset=\"square-40-cropped\" alt=\"{{item.displayName}}\"> <span><span class=\"symbol-icon\" \nng-if=\"!item.profileImageFilepath && !item.email\"><md-icon md-font-icon=\"icon-account-circle\"></md-icon></span>\n{{item.displayName}}</span></div></md-item-template><div ng-messages=\"vm.baldrisUserForm.baldrisUser.$error\" \nng-if=\"vm.baldrisUserForm.baldrisUser.$touched\"><div ng-message=\"invalidBaldrisUser\"><span \ntranslate=\"ACCOUNTS.USER_SELECT.INVALID_BALDRIS_USER\" translate-values=\"{ baldrisUser: vm.searchText }\"></span></div>\n</div></md-autocomplete><md-button class=\"md-icon-button reset-button\" ng-click=\"vm.resetInput()\" aria-label=\"Reset\" \ntranslate-attr-aria-label=\"COMMON.DATA.RESET\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled\"><md-tooltip md-direction=\"top\">\n<span translate=\"COMMON.DATA.RESET\"></span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button><md-button class=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog()\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/booking/edit-booking/views/calendar-event.tmpl.html","<div layout=\"column\"><location-select class=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.location\" \nlocation-id=\"vm.data.updateModel.calendarEvent.locationId\" label-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\" \non-selected=\"(vm.data.onLocationSelected)\"></location-select><date-time-range-select \nstart-time=\"vm.data.updateModel.calendarEvent.start\" end-time=\"vm.data.updateModel.calendarEvent.end\">\n</date-time-range-select><label class=\"md-caption\">{{ \"CEREMONIES.CEREMONY.ASSISTANTS\" | translate }}</label>\n<calendar-event-users class=\"margin-bottom\" event-users=\"vm.data.updateModel.calendarEventUsers\">\n</calendar-event-users></div>");
$templateCache.put("app/main/booking/edit-booking/views/sidebar.tmpl.html","<div ng-include=\"\'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html\'\"></div>");
$templateCache.put("app/main/booking/edit-booking/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"CALENDAR.EVENT.EDIT_CALENDAR_EVENT\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CALENDAR.ACTIONS.SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.ACTIONS.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"CALENDAR.ACTIONS.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.ACTIONS.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/calendar/components/calendar-event-card/calendar-event-card.tmpl.html","<md-card class=\"calendar-event-card\" \nng-style=\"{ \'background-color\': \'{{vm.baldrisModel.calendarEventType.color || \\\'#2E8AE9\\\'}}\', \'color\': \'{{vm.getForegroundColor(vm.baldrisModel.calendarEventType.color || \\\'#2E8AE9\\\')}}\' }\">\n<md-card-header ng-click=\"vm.showEditDeceasedDialog(vm.baldrisModel, $event)\"><md-card-avatar><md-icon \nng-if=\"vm.baldrisModel.calendarEventType.iconName\" md-font-icon=\"{{vm.baldrisModel.calendarEventType.iconName}}\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.calendarEventType.iconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.subject}}</span> <span \nclass=\"md-subhead\"><span class=\"icon icon-calendar\"></span> {{vm.baldrisModel.start | date:\'fullDate\'}} <span \nclass=\"icon icon-clock\"></span> {{vm.baldrisModel.start | date:\'shortTime\'}} <span ng-if=\"!vm.baldrisModel.start\">\n{{\'CEREMONIES.CEREMONY_CARD.STARTTIME_UNSET\' | translate}}</span></span></md-card-header-text></md-card-header>\n<md-card-content ng-click=\"vm.showEditDeceasedDialog(vm.baldrisModel, $event)\"><div ng-if=\"vm.baldrisModel.deceased\">\n<label class=\"md-caption\">{{\'CALENDAR.EVENT.DECEASED\' | translate}}</label><p>{{vm.baldrisModel.deceased}}</p></div>\n<div ng-if=\"vm.baldrisModel.locationSerialized\"><label class=\"md-caption\">{{\'CALENDAR.EVENT.LOCATION\' | translate}}\n</label><p>{{vm.baldrisModel.locationSerialized}}</p></div><div ng-if=\"!vm.baldrisModel.locationSerialized\"><label \nclass=\"md-caption\">{{\'CALENDAR.EVENT.LOCATION\' | translate}}</label><p>\n{{\'CEREMONIES.CEREMONY-CARD.LOCATION-UNSET\' | translate}}</p></div><div \nng-if=\"vm.baldrisModel.participants && vm.baldrisModel.participants.length > 0\"><label class=\"md-caption\">\n{{\'CALENDAR.EVENT.ATTENDEES\' | translate}}</label><p>{{ vm.baldrisModel.attendeesSerialized }}</p></div><div \nng-if=\"vm.baldrisModel.description\"><label class=\"md-caption\">{{\'CALENDAR.EVENT.DESCRIPTION\' | translate}}</label><p>\n{{vm.baldrisModel.remarks}}</p></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" \nng-click=\"vm.showEditDeceasedDialog(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-close-circle\">\n</md-icon></md-button></md-card-actions></md-card>");
$templateCache.put("app/main/calendar/components/calendar-event-list/calendar-event-list.tmpl.html","<div class=\"calendar-event-list-container\"><md-list \nng-if=\"!vm.createDateGroups && vm.hourGroups && vm.hourGroups.length > 0\" flex><div \nng-repeat=\"group in vm.hourGroups | orderBy:\'from\'\"><md-subheader class=\"md-primary md-no-sticky\" ng-class-odd=\"\'odd\'\" \nng-class-even=\"\'even\'\"><span ng-show=\"group.isAllDay\">{{ \"CALENDAR.EVENT.ALL_DAY\" | translate }}</span><span \nng-show=\"!group.isAllDay\">{{ group.moment.format(\"YYYY-MM-DDTHH:mm:ss\") | date: \"shortTime\" }}</span></md-subheader>\n<calendar-event-list-item ng-if=\"!vm.shouldBeExcluded(event)\" baldris-model=\"event\" \nng-repeat=\"event in group.events | orderBy:\'start\'\"></calendar-event-list-item><md-divider ng-if=\"!$last\"></md-divider>\n</div></md-list><md-list ng-if=\"vm.createDateGroups && vm.dateGroups && vm.dateGroups.length > 0\" flex><div \nng-repeat=\"dateGroup in vm.dateGroups | orderBy:\'start\'\" layout=\"column\" layout-gt-sm=\"row\" class=\"date-list\" \nmd-whiteframe=\"1\"><div ng-if=\"dateGroup.start\" layout=\"column\" class=\"date-group-calendar-header\"><span \nclass=\"day md-primary-bg\">{{ dateGroup.start | date: \"EEEE\" }}</span><h3 class=\"date\">{{ dateGroup.start | date: \"d\" }}\n</h3><h4 class=\"month\">{{ dateGroup.start | date: \"MMMM\" }}</h4><h4 class=\"year\">{{ dateGroup.start | date: \"yyyy\" }}\n</h4></div><div ng-if=\"!dateGroup.start\" layout=\"column\" class=\"date-group-calendar-header\"><span \nclass=\"day md-primary-bg\">{{ \"CALENDAR.EVENT.UNKNOWN\" | translate }}</span><h3 class=\"date\">00</h3><h4 class=\"month\">\n{{ \"CALENDAR.EVENT.UNKNOWN_TIME\" | translate }}</h4></div><div flex layout=\"column\"><div ng-if=\"dateGroup.start\" \nng-repeat=\"hourGroup in dateGroup.hourGroups | orderBy:\'from\'\"><md-subheader class=\"md-primary md-no-sticky\" \nng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><span ng-show=\"hourGroup.isAllDay\">\n{{ \"CALENDAR.EVENT.ALL_DAY\" | translate }}</span><span ng-show=\"!hourGroup.isAllDay\">\n{{ hourGroup.moment.format(\"YYYY-MM-DDTHH:mm:ss\") | date: \"shortTime\" }}</span></md-subheader><calendar-event-list-item\n ng-if=\"!vm.shouldBeExcluded(event)\" baldris-model=\"event\" ng-repeat=\"event in hourGroup.events | orderBy:\'start\'\">\n</calendar-event-list-item></div><div ng-if=\"!dateGroup.start && dateGroup.events && dateGroup.events.length > 0\">\n<calendar-event-list-item ng-if=\"!vm.shouldBeExcluded(event)\" \nng-repeat=\"event in dateGroup.events | orderBy:\'calendarEventTypeName\'\" baldris-model=\"event\">\n</calendar-event-list-item></div></div></div></md-list></div>");
$templateCache.put("app/main/calendar/components/calendar-event-list-item/calendar-event-list-item.tmpl.html","<div class=\"clickable baldris-calendar-event-list-item-container\" ng-click=\"vm.openEditDialog($event)\" \nng-style=\"{ \'background-color\': vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\', \'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\">\n<md-list-item class=\"md-3-line md-long-text baldris-calendar-event-list-item\" ng-class=\"{ \'all-day\': vm.isAllDay() }\">\n<div ng-if=\"vm.isAllDay()\" class=\"event-body all-day md-list-item-text clickable\" ng-click=\"vm.openEditDialog($event)\">\n<p class=\"summary\"><span class=\"subject\">{{vm.baldrisModel.subject || vm.baldrisModel.calendarEventTypeName}}</span> \n<span class=\"deceased\" ng-show=\"vm.baldrisModel.deceasedSerialized\">{{ vm.baldrisModel.deceasedSerialized }} </span>\n<span class=\"time\" ng-hide=\"vm.baldrisModel.isAllDay\">\n{{ vm.baldrisModel.start | date:\'short\' }} - {{ vm.baldrisModel.end | date:\'short\' }} </span><span class=\"date\" \nng-show=\"vm.baldrisModel.isAllDay\">{{ vm.baldrisModel.start | date:\'mediumDate\' }}<span \nng-if=\"!vm.isSameDay(vm.baldrisModel.start, vm.baldrisModel.end)\"> - {{ vm.baldrisModel.end | date:\'mediumDate\' }}\n</span> </span><span ng-show=\"vm.baldrisModel.attendeesSerialized\" class=\"assistants\">\n({{vm.baldrisModel.attendeesSerialized}})</span></p></div><div ng-if=\"!vm.isAllDay()\" \nclass=\"event-body md-list-item-text\" layout=\"row\"><div class=\"type\" layout=\"column\"><div class=\"type-icon\"><md-icon \nmd-font-icon=\"{{vm.baldrisModel.calendarEventTypeIconName}}\" class=\"icon s32\" \nng-style=\"{\'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\"></md-icon></div><div \nclass=\"type-name\"><md-tooltip>{{vm.baldrisModel.calendarEventTypeName}}</md-tooltip>\n{{vm.baldrisModel.calendarEventTypeName}}</div></div><div flex class=\"details\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title-wrapper\"><span class=\"calendar-event-host\" \nng-show=\"vm.baldrisModel.hostSerialized\">{{vm.baldrisModel.hostSerialized}}</span><h3 class=\"title\">\n{{vm.baldrisModel.subject || vm.baldrisModel.calendarEventTypeName}} <span ng-if=\"vm.baldrisModel.isSilentCeremony\">\n– {{ \'CEREMONIES.CEREMONY.IN_SILENCE\' | translate }}</span> <span class=\"seperator\" \nng-if=\"vm.baldrisModel.deceasedSerialized\">| </span><span class=\"deceased\" \nng-show=\"vm.baldrisModel.deceasedSerialized\" ng-bind-html=\"vm.baldrisModel.deceasedSerialized | serializedList\"></span>\n</h3></div><md-button ng-if=\"vm.baldrisModel.workOrderId\" class=\"md-icon-button\" \nng-click=\"vm.navigateToWorkOrder($event)\"><md-tooltip md-direction=\"left\">\n{{\'CALENDAR.EVENT.NAVIGATE_TO_WORK_ORDER\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-export\" \nng-style=\"{\'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\"></md-icon>\n</md-button></div><h4><span class=\"time\" ng-hide=\"vm.baldrisModel.isAllDay\"><span ng-show=\"vm.baldrisModel.recurrence\" \nclass=\"icon icon-clock\"></span> <span ng-hide=\"vm.baldrisModel.recurrence\" class=\"icon icon-clock\"></span>\n {{ vm.baldrisModel.start | date:\'shortTime\' }} - {{ vm.baldrisModel.end | date:\'shortTime\' }} </span><span \nclass=\"date\" ng-show=\"vm.baldrisModel.isAllDay\"><span class=\"icon icon-date\"></span>\n {{ vm.baldrisModel.start | date:\'mediumDate\' }} - {{ vm.baldrisModel.end | date:\'mediumDate\' }} </span><span \nng-show=\"vm.getLocationText()\" class=\"location\"><span class=\"icon icon-map-marker\"></span> {{vm.getLocationText()}}\n</span></h4><p class=\"department\" \nng-show=\"vm.baldrisModel.workOrderDepartmentOrganizationDisplayName && vm.baldrisModel.workOrderDepartmentOrganizationDisplayName != vm.baldrisModel.hostSerialized\">\n({{ vm.baldrisModel.workOrderDepartmentOrganizationDisplayName }})</p><p ng-show=\"vm.baldrisModel.attendeesSerialized\" \nclass=\"assistants\"><span class=\"icon icon-account-multiple\"></span> <span \nng-bind-html=\"vm.baldrisModel.attendeesSerialized | serializedList\"></span></p><div class=\"md-caption time-ago\" \nam-time-ago=\"vm.baldrisModel.start\"></div></div></div></md-list-item><div ng-if=\"vm.hasCompletedStatus()\" \nclass=\"completed-status\" \nng-class=\"{ \'completed\': vm.baldrisModel.isCompleted, \'un-completed\': !vm.baldrisModel.isCompleted }\"><p class=\"audit\">\n<md-checkbox class=\"md-primary\" ng-checked=\"vm.baldrisModel.isCompleted\" ng-click=\"vm.toggleCompleted($event)\"><span \nng-if=\"vm.baldrisModel.isCompleted && vm.baldrisModel.completedByDisplayName\">\n{{ \'CALENDAR.EVENT.COMPLETED_BY\' | translate }}: {{vm.baldrisModel.completedByDisplayName}}<span \nng-if=\"vm.baldrisModel.completedTime\">, {{vm.baldrisModel.completedTime | date:\'short\'}}</span><br></span><span \nng-if=\"!vm.baldrisModel.isCompleted\" translate=\"CALENDAR.EVENT.NOT_COMPLETED\"></span></md-checkbox></p></div><div \nng-if=\"!vm.isAllDay() && vm.isCeremony()\" class=\"note-and-task-count\" ng-click=\"vm.openViewNoteOrTasksDialog($event)\">\n<md-progress-linear ng-if=\"vm.isLoadingCounters\" md-mode=\"query\"></md-progress-linear><notes-and-tasks-summary \ncompleted-count=\"vm.baldrisModel.completedCount\" uncompleted-count=\"vm.baldrisModel.uncompletedCount\" \nnotes-count=\"vm.baldrisModel.notesCount\"></notes-and-tasks-summary></div><md-divider ng-if=\"!$last\"></md-divider></div>");
$templateCache.put("app/main/calendar/components/calendar-event-list-item-small/calendar-event-list-item-small.tmpl.html","<div class=\"clickable baldris-calendar-event-list-item-small-container\" layout=\"row\" \nng-click=\"vm.openEditDialog($event)\"><div class=\"event-time\"><span ng-if=\"!vm.isAllDay()\">\n{{ vm.baldrisModel.start | date:\'shortTime\' }} - {{ vm.baldrisModel.end | date:\'shortTime\' }}</span> <span \nng-if=\"vm.isAllDay()\">{{\'CALENDAR.EVENT.ALL_DAY\' | translate}}</span></div><div flex \nng-style=\"{ \'background-color\': vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\', \'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\">\n<div class=\"event-body all-day md-list-item-text clickable\" layout=\"row\" layout-align=\"start center\"><div flex \nclass=\"summary\" layout=\"column\"><div class=\"text\"><span class=\"subject\">\n{{vm.baldrisModel.subject || vm.baldrisModel.calendarEventTypeName}}</span> <span class=\"deceased\" \nng-show=\"vm.baldrisModel.deceasedSerialized\">{{ vm.baldrisModel.deceasedSerialized }} </span><span class=\"date\" \nng-show=\"vm.isAllDay()\">{{ vm.baldrisModel.start | date:\'mediumDate\' }}<span \nng-if=\"!vm.isSameDay(vm.baldrisModel.start, vm.baldrisModel.end)\"> - {{ vm.baldrisModel.end | date:\'mediumDate\' }}\n</span> </span><span ng-if=\"vm.isAllDay() && vm.baldrisModel.attendeesSerialized\" class=\"assistants\">\n({{vm.baldrisModel.attendeesSerialized}})</span></div><div class=\"host\" \nng-if=\"!vm.isAllDay() && vm.baldrisModel.hostSerialized !== vm.baldrisModel.workOrderDepartmentOrganizationDisplayName\">\n{{vm.baldrisModel.hostSerialized}}</div><div ng-if=\"!vm.isAllDay() && vm.baldrisModel.attendeesSerialized\" \nclass=\"assistants\">({{vm.baldrisModel.attendeesSerialized}})</div></div><div ng-if=\"vm.baldrisModel.workOrderId\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.navigateToWorkOrder($event)\"><md-tooltip md-direction=\"left\">\n{{\'CALENDAR.EVENT.NAVIGATE_TO_WORK_ORDER\' | translate}}</md-tooltip><md-icon class=\"s-12\" md-font-icon=\"icon-export\" \nng-style=\"{\'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\"></md-icon>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/calendar/components/calendar-event-type-select/calendar-event-type-select.tmpl.html","<md-input-container ng-form=\"vm.calendarEventTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.calendarEventType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select\n name=\"calendarEventType\" ng-model=\"vm.calendarEventTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\">\n<md-option ng-repeat=\"currentCalendarEventType in vm.calendarEventTypes | orderBy:\'name\'\" \nng-value=\"currentCalendarEventType.id\">{{currentCalendarEventType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.calendarEventTypeForm.calendarEventType.$error\" \nng-if=\"vm.calendarEventTypeForm.calendarEventType.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.EVENT.CALENDAR_EVENT_TYPE_REQUIRED\"></span></div></div></md-input-container>");
$templateCache.put("app/main/calendar/components/calendar-event-user/calendar-event-users.tmpl.html","<div class=\"baldris-event-user-container\" layout=\"column\"><label class=\"md-caption\">\n{{ \"CEREMONIES.CEREMONY.ASSISTANTS\" | translate }}</label><md-chips class=\"md-contact-chips baldris-event-user-select\" \nng-model=\"vm.selectedUsers\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" \nmd-on-add=\"vm.onAddUser($chip)\" md-on-remove=\"vm.onRemoveUser($chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedUser\" md-search-text=\"vm.searchTextUser\" \nmd-items=\"item in vm.userSearch(vm.searchTextUser)\" md-item-text=\"item.displayName\" md-min-length=\"vm.minLenght\" \nplaceholder=\"{{ \'CALENDAR.EVENT_USER.ADD_USERS\' | translate }}\" md-menu-class=\"md-contact-chips-suggestions\"><div \nclass=\"md-contact-suggestion\"><img baldris-img-src=\"item.image\" preset=\"square-40-cropped\" \nalt=\"{{ item.displayName }}\" ng-if=\"item.image\"> <span class=\"md-contact-name\" md-highlight-text=\"vm.searchTextUser\">\n{{ item.displayName }} </span><span class=\"md-contact-email\">{{ item.email }}</span></div></md-autocomplete>\n<md-chip-template class=\"clickable\" ng-click=\"vm.onSelectUser($chip)\"><div class=\"md-contact-avatar\"><img \nbaldris-img-src=\"$chip.image\" preset=\"square-40-cropped\" alt=\"{{ $chip.displayName }}\" ng-if=\"$chip.image\"></div><div \nclass=\"md-contact-name ng-binding\">{{ $chip.displayName }} <span ng-show=\"$chip.role\">({{ $chip.role }})</span></div>\n</md-chip-template></md-chips><div class=\"hint\" ng-if=\"vm.selectedUsers && vm.selectedUsers.length > 0\">\n{{ \"CALENDAR.EVENT_USER.HINT_TEXT\" | translate }}</div><md-card ng-show=\"vm.showSelected\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">{{ \"CALENDAR.EVENT_USER.TYPE_ROLE\" | translate }}</span> <span \nclass=\"md-subhead\" translate=\"CALENDAR.EVENT_USER.TYPE_ROLE_USER\" \ntranslate-values=\"{ userDisplayName: vm.currentUser.userDisplayName }\"></span></md-card-title-text>\n<md-card-title-media><div class=\"md-media-sm card-media\"><img gravatar-size=\"80\" \ngravatar-src=\"vm.currentUser.userEmail || vm.currentUser.userDisplayName\" alt=\"{{ vm.currentUser.userDisplayName }}\" \nng-if=\"!vm.currentUser.userProfileImageFilepath\"> <img baldris-img-src=\"vm.currentUser.userProfileImageFilepath\" \npreset=\"square-100-cropped\" alt=\"{{ vm.currentUser.userDisplayName }}\" ng-if=\"vm.currentUser.userProfileImageFilepath\">\n</div></md-card-title-media></md-card-title><md-card-content><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{ \"CALENDAR.EVENT_USER.ROLE_LABEL\" | translate }}</label><input ng-model=\"vm.newRole\"></md-input-container>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.addRole()\">\n{{ \"CALENDAR.EVENT_USER.OK_BUTTON\" | translate }}</md-button><md-button ng-click=\"vm.cancelRole()\">\n{{ \"CALENDAR.EVENT_USER.CANCEL_BUTTON\" | translate }}</md-button></md-card-actions></md-card></div>");
$templateCache.put("app/main/calendar/components/calendar-options-select/calendar-options-select.tmpl.html","<div class=\"baldris-calendar-options-select\" ng-form=\"vm.dataForm\"><label class=\"md-caption\">{{vm.labelText}}</label>\n<div class=\"baldris-options\" layout=\"row\" layout-align=\"start center\" layout-wrap><md-checkbox \nng-if=\"option.value > 0\" ng-repeat=\"option in vm.calendarEventOptions\" ng-checked=\"vm.isSelected(option)\" \nng-click=\"vm.toggle(option)\">{{ option.text | translate }}</md-checkbox></div></div>");
$templateCache.put("app/main/calendar/day-view/sidebar-right/day-view-sidebar-right.tmpl.html","<div class=\"sidenav-title ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\" translate=\"WORK_ORDERS.WORK_ORDER.DECEASED.NOTE_OR_TASKS_TITLE\"></div></div><md-list \nclass=\"note-or-task-list\" flex><div ng-hide=\"vm.loadingService.isLoading\" \nng-if=\"vm.currentBirthdays && vm.currentBirthdays.length > 0\"><md-subheader class=\"birthday md-no-sticky\"><span>\n{{\'CALENDAR.BIRTHDAYS\' | translate}}</span></md-subheader><md-list-item class=\"md-2-line birthday\" \nng-repeat=\"birthdayUser in vm.currentBirthdays | orderBy:\'dateOfBirth\'\"><img ng-show=\"birthdayUser.email\" \nclass=\"md-avatar\" gravatar-src=\"birthdayUser.email\"><div class=\"md-list-item-text\"><h4 class=\"created-by\">\n{{birthdayUser.displayName}}</h4><h3 translate=\"CALENDAR.BIRTHDAY_TEXT\" \ntranslate-values=\"{ age: vm.calculateAge(birthdayUser.dateOfBirth, vm.service.data.selectedDate) }\"></h3></div>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></div></md-list><note-or-task-list \nng-if=\"!vm.loadingService.isLoading\" collection=\"vm.service.data.currentNotesAndTasks\" inheritance-type=\"Calendar\" \ncalendar-start-date=\"vm.service.data.selectedDate\" hide-add-button=\"true\" api=\"vm.service.noteOrTaskApi\">\n</note-or-task-list><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/calendar/dialogs/add-calendar-event-dialog/add-calendar-event-dialog.tmpl.html","<md-dialog class=\"add-grooming-transport-dialog edit-dialog\" \naria-label=\"{{\'CALENDAR.EVENT.CREATE_CALENDAR_EVENT\' | translate}}\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'CALENDAR.EVENT.CREATE_CALENDAR_EVENT\' | translate}}</span></div></md-toolbar><md-dialog-content><p>\n{{ \'CALENDAR.EVENT.SELECT_CALENDAR_EVENT_TYPE\' | translate}}</p><div layout=\"column\" ng-form=\"vm.addCalendarEventForm\">\n<calendar-event-type-select is-required=\"true\" flex calendar-event-type-id=\"vm.model.calendarEventTypeId\" \ncalendar-event-type=\"vm.model.calendarEventType\" label-text=\"{{\'CALENDAR.EVENT.CALENDAR_EVENT_TYPE\' | translate}}\" \noptions-filter=\"vm.flagOption\"></calendar-event-type-select></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}\n</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"(vm.isTransport && vm.addTransportForm.$invalid) || (!vm.isTransport && vm.addGroomingForm.$invalid)\">\n{{ \'TRANSPORTS.ADD_GROOMING_TRANSPORT.OK_ADD\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/calendar/dialogs/edit-calendar-event-dialog/edit-calendar-event-dialog.tmpl.html","<md-dialog ng-form=\"vm.editCalendarEventForm\" class=\"edit-calendar-event-dialog edit-dialog\" \naria-label=\"{{\n    vm.isNew ? \'CALENDAR.EVENT.CREATE_CALENDAR_EVENT\' : (\'CALENDAR.EVENT.EDIT_CALENDAR_EVENT\' | translate)\n  }}\">\n<md-toolbar class=\"md-tall\" layout=\"column\" ng-style=\"vm.eventStyle\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \"CALENDAR.EVENT.CREATE_CALENDAR_EVENT\" : (\"CALENDAR.EVENT.EDIT_CALENDAR_EVENT\" | translate) }}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nng-if=\"vm.updateModel && !vm.isLoading\" class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" \nlayout-align=\"start stretch\"><md-input-container class=\"md-block\" ng-class=\"vm.highlightClass\"><label \ntranslate=\"CALENDAR.EVENT.SUBJECT\">Subject</label><input ng-model=\"vm.updateModel.calendarEvent.subject\">\n</md-input-container></div></md-toolbar><md-dialog-content><md-content ng-if=\"vm.isLoading\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content>\n<md-content ng-if=\"vm.updateModel && !vm.isLoading\" layout=\"column\"><md-input-container \nng-if=\"!vm.updateModel.calendarEvent.internalId\"><calendar-event-type-select \ncalendar-event-type-id=\"vm.updateModel.calendarEvent.calendarEventTypeId\" \ncalendar-event-type=\"vm.updateModel.calendarEvent.calendarEventType\" \nlabel-text=\"{{ \'CALENDAR.EVENT.EVENT_TYPE\' | translate }}\"></calendar-event-type-select></md-input-container>\n<md-input-container flex><label translate=\"CALENDAR.EVENT.TEXT\">Text</label><textarea \nng-model=\"vm.updateModel.calendarEvent.text\"></textarea></md-input-container><div><md-checkbox \nng-model=\"vm.updateModel.calendarEvent.isAllDay\">{{ \"CALENDAR.EVENT.ALL_DAY\" | translate }}</md-checkbox></div>\n<date-time-range-select ng-if=\"!vm.updateModel.calendarEvent.isAllDay\" start-time=\"vm.updateModel.calendarEvent.start\" \nend-time=\"vm.updateModel.calendarEvent.end\"></date-time-range-select><date-range-select \nng-if=\"vm.updateModel.calendarEvent.isAllDay\" start-date=\"vm.updateModel.calendarEvent.start\" \nend-date=\"vm.updateModel.calendarEvent.end\"></date-range-select><calendar-event-users class=\"margin-bottom\" \nevent-users=\"vm.updateModel.calendarEventUsers\"></calendar-event-users><location-select \nlocation-id=\"vm.updateModel.calendarEvent.locationId\" location=\"vm.updateModel.calendarEvent.location\" \nlabel-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\" \ndisplay-text=\"vm.updateModel.calendarEvent.locationSerialized\" disable-search=\"true\"></location-select><party-select \nparty-id=\"vm.updateModel.calendarEvent.hostId\" party=\"vm.updateModel.calendarEvent.host\" \nlabel-text=\"{{ \'CALENDAR.EVENT.HOST\' | translate }}\" disable-search=\"true\"></party-select></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"!vm.updateModel.calendarEvent.workOrderId\" \naria-label=\"Delete\" class=\"md-warn\" ng-click=\"vm.deleteCalendarEvent()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"CALENDAR.EVENT.DELETE_CALENDAR_EVENT\" | translate }}</md-button><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editCalendarEventForm.$invalid\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/calendar/dialogs/edit-calendar-event-equipment-dialog/edit-calendar-event-equipment-dialog.tmpl.html","<md-dialog ng-form=\"vm.editCalendarEventEquipmentForm\" class=\"edit-calendar-event-equipment-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.ADD_EQUIPMENT\' : \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.EDIT_EQUIPMENT\' | translate }}\">\n<md-toolbar layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.ADD_EQUIPMENT\' : \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.EDIT_EQUIPMENT\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div \nflex-gt-sm=\"20\"><md-input-container class=\"md-block\"><label>{{ \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.AMOUNT\' | translate}}\n</label><input ng-model=\"vm.calendarEventEquipment.amount\" type=\"number\"></md-input-container></div><div \nflex-gt-sm=\"80\"><equipment-select label-text=\"{{\'CALENDAR.CALENDAR_EVENT_EQUIPMENT.EQUIPMENT\' | translate}}\" \nequipment=\"vm.calendarEventEquipment.equipment\" equipment-id=\"vm.calendarEventEquipment.equipmentId\" \ndisplay-text=\"vm.calendarEventEquipment.equipmentName\" on-update=\"vm.onEquipmentChanged(item)\"></equipment-select>\n</div></div><div><md-input-container class=\"md-block\"><label>\n{{ \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.SORT_ORDER\' | translate}}</label><input \nng-model=\"vm.calendarEventEquipment.sortOrder\" type=\"number\" step=\"1\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{ \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.REMARKS\' | translate}}</label>\n<textarea ng-model=\"vm.calendarEventEquipment.remarks\"></textarea></md-input-container></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"!vm.isNew\" aria-label=\"Delete\" class=\"md-warn\" \nng-click=\"vm.deleteCalendarEventEquipment()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'CALENDAR.CALENDAR_EVENT_EQUIPMENT.DELETE_EQUIPMENT\' | translate }}</md-button><span flex></span><md-button \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editHeadstoneAdditionForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/calendar/edit-calendar-event/views/calendar-event.tmpl.html","<div layout=\"column\"><party-select ng-if=\"!vm.data.updateModel.calendarEvent.workOrderId\" \nparty=\"vm.data.updateModel.calendarEvent.host\" party-id=\"vm.data.updateModel.calendarEvent.hostId\" \nlabel-text=\"{{ \'CALENDAR.EVENT.HOST\' | translate }}\"></party-select><location-select class=\"margin-bottom\" \nlocation=\"vm.data.updateModel.calendarEvent.location\" location-id=\"vm.data.updateModel.calendarEvent.locationId\" \nlabel-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\" on-selected=\"(vm.data.onLocationSelected)\"></location-select>\n<div></div><md-button class=\"md-raised\" \nng-if=\"!vm.data.updateModel.address || vm.data.updateModel.address.changeState === 3\" ng-click=\"vm.data.addAddress()\">\n{{ \"CALENDAR.EVENT.ADD_ADDRESS\" | translate }}</md-button><div \nng-if=\"vm.data.updateModel.address && vm.data.updateModel.address.changeState !== 3\" class=\"padding-top-20\">\n<md-input-container class=\"md-block\"><label>{{ \"CALENDAR.EVENT.ADDRESS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.address.localizedAddress\" ng-change=\"vm.data.onEntityChanged(vm.data.address)\">\n</md-input-container></div><md-button class=\"md-raised\" \nng-if=\"vm.data.updateModel.address && vm.data.updateModel.address.changeState !== 3\" \nng-click=\"vm.data.removeAddress()\">{{ \"CALENDAR.EVENT.REMOVE_ADDRESS\" | translate }}</md-button><div \nclass=\"padding-top-20\"><md-checkbox ng-model=\"vm.data.updateModel.calendarEvent.isAllDay\">\n{{ \"CALENDAR.EVENT.ALL_DAY\" | translate }}</md-checkbox></div><date-time-range-select \nng-if=\"!vm.data.updateModel.calendarEvent.isAllDay\" start-time=\"vm.data.updateModel.calendarEvent.start\" \nend-time=\"vm.data.updateModel.calendarEvent.end\"></date-time-range-select><date-range-select \nng-if=\"vm.data.updateModel.calendarEvent.isAllDay\" start-date=\"vm.data.updateModel.calendarEvent.start\" \nend-date=\"vm.data.updateModel.calendarEvent.end\"></date-range-select><calendar-event-users class=\"margin-bottom\" \nevent-users=\"vm.data.updateModel.calendarEventUsers\"></calendar-event-users></div>");
$templateCache.put("app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html","<div class=\"edit-calendar-event-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div \nng-if=\"!vm.loadingService.isLoading && vm.data.updateModel\" class=\"sidebar-content\" layout=\"column\" layout-padding>\n<baldris-audit \ntitle-text=\"vm.data.updateModel.calendarEvent.subject || vm.data.updateModel.calendarEvent.calendarEventTypeName || vm.data.updateModel.calendarEvent.calendarEventType.name\" \naudit-model=\"vm.data.updateModel.calendarEvent\"></baldris-audit><div \nng-if=\"(vm.data.options.hasWorkOrder(vm.data.updateModel.calendarEvent.options) && !vm.data.updateModel.calendarEvent.workOrderId) || vm.data.workOrderSelected\">\n<p ng-if=\"!vm.data.updateModel.calendarEvent.workOrderId\" class=\"work-order-missing-text text-bold md-warn-fg\">\n{{\'CALENDAR.EVENT.MISSING_WORK_ORDER_TEXT\' | translate}}</p><work-order-select disable-search=\"true\" \nwork-order=\"vm.data.updateModel.calendarEvent.workOrder\" work-order-id=\"vm.data.updateModel.calendarEvent.workOrderId\" \nlabel-text=\"{{\'CALENDAR.EVENT.WORK_ORDER\' | translate}}\" on-update=\"vm.data.workOrderSelected = true\">\n</work-order-select></div><div><md-input-container class=\"md-block\"><label>{{\'CALENDAR.EVENT.SUBJECT\' | translate }}\n</label><input ng-model=\"vm.data.updateModel.calendarEvent.subject\"></md-input-container></div><div><md-input-container\n class=\"md-block\"><label>{{\'CALENDAR.EVENT.DESCRIPTION\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.calendarEvent.description\"></textarea></md-input-container></div><div \nng-if=\"vm.data.options.hasCompletedStatus(vm.data.updateModel.calendarEvent.options)\"><md-checkbox \nng-model=\"vm.data.updateModel.calendarEvent.isCompleted\" aria-label=\"{{\'CALENDAR.EVENT.IS_COMPLETED\' | translate}}\" \nng-change=\"vm.data.onIsCompletedChange()\">{{\'CALENDAR.EVENT.IS_COMPLETED\' | translate}}</md-checkbox><p \nng-if=\"vm.data.updateModel.calendarEvent.isCompleted\" class=\"audit\"><span \nng-if=\"vm.data.updateModel.calendarEvent.completedByDisplayName\">\n{{ \'CALENDAR.EVENT.COMPLETED_BY\' | translate }}: {{vm.data.updateModel.calendarEvent.completedByDisplayName}}<span \nng-if=\"vm.data.updateModel.calendarEvent.completedTime\">\n, {{vm.data.updateModel.calendarEvent.completedTime | date:\'short\'}}</span><br></span></p><baldris-user-select \ndisplay-text=\"vm.data.updateModel.calendarEvent.completedByDisplayName\" \nbaldris-user=\"vm.data.updateModel.calendarEvent.completedBy\" \nbaldris-user-id=\"vm.data.updateModel.calendarEvent.completedById\" \nlabel-text=\"{{\'CALENDAR.EVENT.COMPLETED_BY\' | translate}}\"></baldris-user-select></div><div \nng-if=\"vm.data.options.isBooking(vm.data.updateModel.calendarEvent.options)\"><md-checkbox \nng-model=\"vm.data.updateModel.calendarEvent.isConfirmed\" aria-label=\"{{\'BOOKINGS.BOOKING.IS_CONFIRMED\' | translate}}\">\n{{\'BOOKINGS.BOOKING.IS_CONFIRMED\' | translate}}</md-checkbox><p \nng-if=\"vm.data.updateModel.calendarEvent.confirmedDate\" class=\"audit\"><span \nng-if=\"vm.data.updateModel.calendarEvent.confirmedBy\">\n{{ \'BOOKINGS.BOOKING.CONFIRMED_BY\' | translate }}: {{vm.data.updateModel.calendarEvent.confirmedBy.displayName}}<span \nng-if=\"vm.data.updateModel.calendarEvent.confirmedDate\">\n, {{vm.data.updateModel.calendarEvent.confirmedDate | date:\'short\'}}</span><br></span></p><baldris-user-select \nbaldris-user=\"vm.data.updateModel.calendarEvent.confirmedBy\" \nbaldris-user-id=\"vm.data.updateModel.calendarEvent.confirmedById\" \nlabel-text=\"{{\'BOOKINGS.BOOKING.CONFIRMED_BY\' | translate}}\"></baldris-user-select></div><div \nng-if=\"vm.data.options.showSupplier(vm.data.updateModel.calendarEvent.options)\"><supplier-select \nsupplier=\"vm.data.updateModel.calendarEvent.supplier\" supplier-id=\"vm.data.updateModel.calendarEvent.supplierId\" \nlabel-text=\"{{ \'BOOKINGS.BOOKING.CONFIRMED_WITH\' | translate }}\"></supplier-select></div><md-button \nclass=\"md-raised md-accent\" ng-if=\"vm.data.updateModel.calendarEvent.workOrderId && vm.data.isConference\" \ntarget=\"_blank\" \nng-href=\"{{vm.baldrisApiBase}}/api/Reports/AsPdf/{{vm.data.registrationReport.id}}/WorkOrderId/{{vm.data.updateModel.calendarEvent.workOrderId}}\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon><span translate=\"CALENDAR.EVENT.PRINT_REGISTRATION_FORM\">\nPrint Registration Form</span></md-button><md-button ng-click=\"vm.toggleShowOptions()\"><span \ntranslate=\"CALENDAR.EVENT.SHOW_EVENT_OPTIONS\">Show Event Options</span></md-button><enum-flag-select \nng-if=\"vm.showEventOptions\" enum-flag=\"vm.data.updateModel.calendarEvent.options\" \nenum-flag-options=\"calendarEventOptions\" label-text=\"{{\'CALENDAR.EVENT.OPTIONS\' | translate}}\"></enum-flag-select>\n</div></div>");
$templateCache.put("app/main/calendar/edit-calendar-event/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"CALENDAR.EVENT.EDITING_TEXT\" \ntranslate-values=\"{ calendarEventString: vm.data.getCalendarEventString() }\"></span> <span \nng-if=\"vm.data.validation.calendarEventForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"CALENDAR.ACTIONS.SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"CALENDAR.ACTIONS.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CALENDAR.ACTIONS.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.ACTIONS.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/calendar/views/main-sidenav/calendar-main-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.CALENDAR.CALENDAR\" | translate }}</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div class=\"current-range\"><div class=\"day-range\" \nng-if=\"vm.service.isSelected(\'DAY\')\"><div class=\"day\">{{ vm.service.data.selectedDate | date: \"EEEE\" }}</div><div \nclass=\"date\">{{ vm.service.data.selectedDate | date: \"d\" }}</div><div class=\"month\">\n{{ vm.service.data.selectedDate | date: \"MMMM\" }} – {{ \"CALENDAR.TOOLBAR.VIEWS.WEEK\" | translate }} {{ vm.service.data.selectedDate | date: \"w\" }}\n</div><div class=\"year\">{{ vm.service.data.selectedDate | date: \"yyyy\" }}</div></div><div class=\"day-range\" \nng-if=\"vm.service.isSelected(\'WEEK\')\"><div class=\"day\">{{ \"CALENDAR.TOOLBAR.VIEWS.WEEK\" | translate }}</div><div \nclass=\"date\">{{ vm.service.data.selectedDate | date: \"w\" }}</div><div class=\"month\">\n{{ vm.service.getFirstDayOfWeek() | date: \"mediumDate\" }} – {{ vm.service.getLastDayOfWeek() | date: \"mediumDate\" }}\n</div><div class=\"year\">{{ vm.service.data.selectedDate | date: \"yyyy\" }}</div></div></div><md-list \nclass=\"calendar-main-menu\"><md-list-item ng-click=\"vm.service.changeTab(\'DAY\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'DAY\'), \'md-accent-bg\': vm.service.isSelected(\'DAY\')}\"><p><md-icon \nmd-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon>{{ \"MENU.CALENDAR.DAY_VIEW\" | translate }}</p></md-list-item>\n<md-list-item ng-click=\"vm.service.changeTab(\'WEEK\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'WEEK\'), \'md-accent-bg\': vm.service.isSelected(\'WEEK\')}\"><p><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s24\"></md-icon>{{ \"MENU.CALENDAR.WEEK_VIEW\" | translate }}</p></md-list-item>\n</md-list></div></div>");
$templateCache.put("app/main/calendar/views/main-toolbar/calendar-main-toolbar.tmpl.html","<div class=\"navigation-controls\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigatePrevious(-7)\" aria-label=\"Jump backwards\" \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS_WEEK\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.PREVIOUS_WEEK\" translate-values=\"{ amount: vm.currentData.viewData.jumpAmount }\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-fast-forward\" class=\"rotate-180\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.service.navigatePrevious()\" aria-label=\"Previous\" \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS_DAY\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.PREVIOUS_DAY\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\" class=\"rotate-180\"></md-icon>\n</md-button><h3><div class=\"baldris-date-time\" layout=\"row\" layout-align=\"start center\"><md-datepicker \nng-model=\"vm.service.data.selectedDate\" ng-change=\"vm.service.selectedDateChanged()\" \nmd-is-open=\"vm.isCalendarSelectOpen\" md-open-on-focus></md-datepicker><span class=\"clickable\" \nng-click=\"vm.isCalendarSelectOpen = !vm.isCalendarSelectOpen\"><span hide-xs>\n{{ vm.service.data.selectedDate | date:\'fullDate\' }}</span><span hide-gt-xs>\n{{ vm.service.data.selectedDate | date:\'shortDate\' }}</span></span></div></h3><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateNext()\" aria-label=\"Next\" translate-attr-aria-label=\"CALENDAR.NEXT_DAY\"><md-tooltip \nmd-direction=\"top\"><span translate=\"CALENDAR.NEXT_DAY\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.service.navigateNext(7)\" aria-label=\"Jump Forward\" \ntranslate-attr-aria-label=\"CALENDAR.NEXT_WEEK\"><md-tooltip md-direction=\"top\"><span translate=\"CALENDAR.NEXT_WEEK\" \ntranslate-values=\"{ amount: vm.currentData.viewData.jumpAmount }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" \nng-disabled=\"!vm.loadingService.isLoadingInBackground\"></md-progress-linear>");
$templateCache.put("app/main/calendar/week-view/sidebar-right/week-view-sidebar.tmpl.html","<div class=\"sidenav-title ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span class=\"title-text\">\n{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div layout-padding layout=\"column\"><h4 \ntranslate=\"CALENDAR.CALENDAR_EVENT_TYPE.CALENDAR_EVENT_TYPES\">Calendar Event Types</h4><md-input-container><md-checkbox\n ng-click=\"vm.service.toggleAllSelectedCalendarEventTypes()\" \nng-checked=\"vm.service.selectedCalendarEventTypes.length > 0\">{{\'CALENDAR.CALENDAR_EVENT_TYPE.SELECT_ALL\' | translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-wrap><md-checkbox \nng-click=\"vm.service.toggleSelectedCalendarEventType(calendarEventType)\" \nng-checked=\"vm.service.selectedCalendarEventTypes.indexOf(calendarEventType) > -1\" \nng-repeat=\"calendarEventType in vm.service.calendarEventTypes | orderBy:\'name\'\">{{calendarEventType.name}}\n</md-checkbox></div></div>");
$templateCache.put("app/main/calendar/week-view/toolbar/week-view-toolbar.tmpl.html","<div class=\"navigation-controls\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigatePrevious(-1, \'months\')\" aria-label=\"Jump backwards\" \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS_MONTH\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.PREVIOUS_MONTH\" translate-values=\"{ amount: vm.currentData.viewData.jumpAmount }\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-fast-forward\" class=\"rotate-180\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.service.navigatePrevious(-7)\" aria-label=\"Previous\" \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS_WEEK\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.PREVIOUS_WEEK\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\" class=\"rotate-180\"></md-icon>\n</md-button><h3><div class=\"baldris-date-time\" layout=\"row\" layout-align=\"start center\"><md-datepicker \nng-model=\"vm.service.data.selectedDate\" ng-change=\"vm.service.selectedDateChanged()\" \nmd-is-open=\"vm.isCalendarSelectOpen\" md-open-on-focus></md-datepicker><span class=\"clickable\" \nng-click=\"vm.isCalendarSelectOpen = !vm.isCalendarSelectOpen\">\n{{\'CALENDAR.TOOLBAR.VIEWS.WEEK\' | translate}} {{ vm.service.data.selectedDate | date:\'w\' }}</span></div></h3><md-button\n class=\"md-icon-button\" ng-click=\"vm.service.navigateNext(7)\" aria-label=\"Next\" \ntranslate-attr-aria-label=\"CALENDAR.NEXT_WEEK\"><md-tooltip md-direction=\"top\"><span translate=\"CALENDAR.NEXT_WEEK\">\n</span></md-tooltip><md-icon md-font-icon=\"icon-play\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateNext(1, \'months\')\" aria-label=\"Jump Forward\" \ntranslate-attr-aria-label=\"CALENDAR.NEXT_MONTH\"><md-tooltip md-direction=\"top\"><span translate=\"CALENDAR.NEXT_MONTH\" \ntranslate-values=\"{ amount: vm.currentData.viewData.jumpAmount }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" \nng-disabled=\"!vm.loadingService.isLoadingInBackground\"></md-progress-linear>");
$templateCache.put("app/main/ceremony/components/ceremony-card/ceremony-card.tmpl.html","<md-card class=\"ceremony-card\"><md-progress-linear ng-if=\"vm.isLoadingParticipants\" md-mode=\"query\">\n</md-progress-linear><md-card-header class=\"clickable\" ng-click=\"vm.navigateToCeremony(vm.baldrisModel)\">\n<md-card-avatar><md-icon ng-if=\"vm.baldrisModel.calendarEventTypeIconName\" \nmd-font-icon=\"{{ vm.baldrisModel.calendarEventTypeIconName }}\" \nng-style=\"{ \'background-color\': vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\', \'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.calendarEventTypeIconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{ vm.baldrisModel.calendarEventTypeName }}</span> <span \nclass=\"md-subhead\"><span class=\"icon icon-calendar\"></span> {{ vm.baldrisModel.start | date: \"fullDate\" }} <span \nclass=\"icon icon-clock\"></span> {{ vm.baldrisModel.start | date: \"shortTime\" }} <span ng-if=\"!vm.baldrisModel.start\">\n{{ \"CEREMONIES.CEREMONY_CARD.STARTTIME_UNSET\" | translate }}</span></span></md-card-header-text></md-card-header><img \nng-if=\"vm.baldrisModel.locationImageFilepath\" baldris-img-src=\"vm.baldrisModel.locationImageFilepath\" \npreset=\"medium-landscape-cropped\" class=\"md-card-image clickable\" ng-click=\"vm.navigateToCeremony(vm.baldrisModel)\">\n<md-card-title class=\"clickable\" ng-click=\"vm.navigateToCeremony(vm.baldrisModel)\"><md-card-title-text><span \nclass=\"md-headline\">{{ vm.baldrisModel.calendarEventTypeName }}</span></md-card-title-text></md-card-title>\n<md-card-content class=\"clickable\" ng-click=\"vm.navigateToCeremony(vm.baldrisModel)\"><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.start\"><label class=\"md-caption\">{{ \"CALENDAR.EVENT.START_TIME\" | translate }}</label><p>\n{{ vm.baldrisModel.start | date: \"short\" }}</p></div><div flex ng-if=\"vm.baldrisModel.end\"><label class=\"md-caption\">\n{{ \"CALENDAR.EVENT.END_TIME\" | translate }}</label><p>{{ vm.baldrisModel.end | date: \"short\" }}</p></div></div><div \nng-if=\"vm.baldrisModel.locationSerialized || vm.baldrisModel.locationName\"><label class=\"md-caption\">\n{{ \"CALENDAR.EVENT.LOCATION\" | translate }}</label><p>\n{{ vm.baldrisModel.locationSerialized || vm.baldrisModel.locationName}}</p></div><div \nng-if=\"!vm.baldrisModel.locationSerialized && !vm.baldrisModel.locationName\"><label class=\"md-caption\">\n{{ \"CALENDAR.EVENT.LOCATION\" | translate }}</label><p>{{ \"CEREMONIES.CEREMONY_CARD.LOCATION_UNSET\" | translate }}</p>\n</div><div ng-if=\"vm.baldrisModel.participantsSerialized\"><label class=\"md-caption\">\n{{ \"CEREMONIES.CEREMONY.PARTICIPANTS\" | translate }}</label><p \nng-bind-html=\"vm.baldrisModel.participantsSerialized | serializedList\"></p></div><div \nng-if=\"vm.baldrisModel.attendeesSerialized\"><label class=\"md-caption\">\n{{ \"CEREMONIES.CEREMONY_CARD.ASSISTANTS\" | translate }}</label><p \nng-bind-html=\"vm.baldrisModel.attendeesSerialized | serializedList\"></p></div><div ng-if=\"vm.baldrisModel.remarks\">\n<label class=\"md-caption\">{{ \"CEREMONIES.CEREMONY.REMARKS\" | translate }}</label><p>{{ vm.baldrisModel.remarks }}</p>\n</div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"!vm.canRead(vm.baldrisModel)\" class=\"md-icon-button md-accent\" aria-label=\"Edit\" \nng-click=\"vm.navigateToCeremony(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button>\n<md-button ng-disabled=\"!vm.canDelete(vm.baldrisModel)\" class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteCeremony(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/ceremony/components/ceremony-participant-select/ceremony-participant-select.tmpl.html","<div class=\"baldris-ceremony-participant-container\" layout=\"column\" ng-form=\"vm.selectForm\"><div><label \nclass=\"md-caption\">{{ vm.labelText ? vm.labelText : (\"CEREMONIES.CEREMONY.PARTICIPANTS\" | translate) }}</label></div>\n<div layout=\"row\" layout-align=\"start center\"><md-chips flex \nclass=\"md-contact-chips baldris-ceremony-participant-select md-block\" ng-model=\"vm.selectedParticipants\" \nmd-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" \nmd-on-add=\"vm.onAddParticipant($chip)\" md-on-remove=\"vm.onRemoveParticipant($chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedParticipant\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.participantSearch(vm.searchText)\" md-item-text=\"item.partyDisplayName\" \nmd-min-length=\"vm.minLenght\" \nplaceholder=\"{{ \'CEREMONIES.CEREMONY_PARTICIPANT_SELECT.SELECT_PARTICIPANTS\' | translate }}\" \nmd-menu-class=\"md-contact-chips-suggestions\"><div class=\"md-contact-suggestion\"><img ng-if=\"item.imageUrl\" \nbaldris-img-src=\"item.imageUrl\" preset=\"square-40-cropped\" alt=\"{{ item.partyDisplayName }}\"> <img \nng-if=\"!item.imageUrl\" gravatar-src=\"item.primaryEmail\" gravatar-default=\"mm\" alt=\"{{ item.partyDisplayName }}\"> <span \nclass=\"md-contact-name\" md-highlight-text=\"vm.searchText\">{{ item.partyDisplayName }} </span><span \nclass=\"md-contact-email\">{{ item.primaryEmail }}</span> <span ng-if=\"item.participantTypes.length > 0\" \nclass=\"search-result-type\" ng-repeat=\"participantType in item.participantTypes\">{{participantType.name}}</span></div>\n</md-autocomplete><md-chip-template class=\"clickable\" ng-click=\"vm.onSelectParticipant($chip)\"><div \nclass=\"md-contact-avatar\"><img ng-if=\"$chip.participantImageUrl\" baldris-img-src=\"$chip.participantImageUrl\" \npreset=\"square-40-cropped\" alt=\"{{ $chip.participantName }}\"> <img ng-if=\"!$chip.participantImageUrl\" \ngravatar-src=\"$chip.participantPrimaryEmail\" gravatar-default=\"mm\" alt=\"{{ $chip.participantName }}\"></div><div \nclass=\"md-contact-name ng-binding\">{{ $chip.participantName }} <span ng-show=\"$chip.participantRole\">\n({{ $chip.participantRole }})</span></div></md-chip-template></md-chips><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div class=\"hint\" \nng-if=\"vm.selectedParticipants && vm.selectedParticipants.length > 0\">\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.SELECT_PARTICIPANTS_HINT_TEXT\" | translate }}</div><md-card \nng-if=\"vm.showSelected\"><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.SELECT_ROLE\" | translate }}</span> <span class=\"md-subhead\" \ntranslate=\"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.SELECT_ROLE_USER\" \ntranslate-values=\"{ participantDisplayName: vm.currentParticipant.participantName }\"></span></md-card-title-text>\n<md-card-title-media><div class=\"md-media-sm card-media\"><img ng-if=\"vm.currentParticipant.imageUrl\" \nbaldris-img-src=\"vm.currentParticipant.imageUrl\" preset=\"square-100-cropped\" alt=\"{{ $chip.partyDisplayName }}\"> <img \nng-if=\"!vm.currentParticipant.imageUrl\" gravatar-src=\"vm.currentParticipant.primaryEmail\" gravatar-default=\"mm\" \nalt=\"{{ vm.currentParticipant.participantName }}\"></div></md-card-title-media></md-card-title><md-card-content>\n<participant-role-select participant-role=\"vm.newRole\" participant-role-id=\"vm.newRoleId\" \nlabel-text=\"{{ \'CEREMONIES.CEREMONY_PARTICIPANT_SELECT.ROLE_LABEL\' | translate }}\"></participant-role-select><div \nng-if=\"vm.newRoleId\"><md-input-container class=\"md-block\"><label>\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.OVERRIDDEN_ROLE_NAME\" | translate }}</label><input \nng-model=\"vm.newOverriddenRoleName\"></md-input-container></div><md-input-container class=\"md-block\"><label>\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.newSortOrder\"></md-input-container></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.addRole()\">\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.OK_BUTTON\" | translate }}</md-button><md-button ng-click=\"vm.cancelRole()\">\n{{ \"CEREMONIES.CEREMONY_PARTICIPANT_SELECT.CANCEL_BUTTON\" | translate }}</md-button></md-card-actions></md-card></div>");
$templateCache.put("app/main/ceremony/components/ceremony-select/ceremony-select.tmpl.html","<md-input-container ng-form=\"vm.ceremonyForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.ceremonyType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"ceremony\" ng-model=\"vm.ceremonyId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentCeremony in vm.availableCeremonies | orderBy:\'name\'\" ng-value=\"currentCeremony.id\">\n{{currentCeremony.ceremonyTypeName}} – {{currentCeremony.calendarEvent.start | date:\'shortDate\'}}</md-option>\n</md-select><div class=\"errors\" ng-messages=\"vm.ceremonyForm.ceremony.$error\" ng-if=\"vm.ceremonyForm.$touched\"><div \nng-message=\"required\"><span translate=\"CEREMONIES.EDIT_CEREMONY.CEREMONY_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/ceremony/components/ceremony-type-select/ceremony-type-select.tmpl.html","<md-input-container ng-form=\"vm.ceremonyTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.ceremonyType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"ceremonyType\" ng-model=\"vm.ceremonyTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentCeremonyType in vm.ceremonyTypes | orderBy:\'name\'\" ng-value=\"currentCeremonyType.id\">\n{{currentCeremonyType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.ceremonyTypeForm.ceremonyType.$error\" ng-if=\"vm.ceremonyTypeForm.ceremonyType.$dirty\"><div \nng-message=\"required\"><span translate=\"CEREMONIES.EDIT_CEREMONY.CEREMONY_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/ceremony/components/edit-ceremony-dialog/edit-ceremony-dialog.tmpl.html","<md-dialog class=\"edit-deceased-dialog edit-dialog\" aria-label=\"Edit Deceased\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.ceremony.ceremonyType.name}}</span></div></md-toolbar>\n<md-dialog-content ng-form=\"vm.ceremonyForm\" novalidate><md-tabs ng-if=\"!vm.isisLoadingCeremony\" md-dynamic-height \nmd-border-bottom><md-tab label=\"{{\'CEREMONIES.EDIT_CEREMONY.GENERAL\' | translate}}\"><md-content layout-padding \nlayout=\"column\"><div \nng-include=\"\'app/main/ceremony/components/edit-ceremony-dialog/views/ceremony-calendar-event.tmpl.html\'\"></div>\n</md-content></md-tab><md-tab label=\"{{category.customFieldCategory.name}}\" \nng-repeat=\"category in vm.categories | orderBy:\'customFieldCategory.sortOrder\'\"><md-content layout-padding \nlayout=\"column\" class=\"md-padding\"><edit-custom-field baldris-model=\"customField\" \nng-repeat=\"customField in category.customFieldCategory.customFields | orderBy:\'sortOrder\'\"></edit-custom-field>\n</md-content></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.CANCEL\' | translate}}</md-button>\n<md-button ng-click=\"vm.saveAndCloseDialog()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.SAVE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ceremony/components/upcoming-ceremony-select/upcoming-ceremony-select.tmpl.html","<div layout=\"row\" layout-align=\"center center\" class=\"upcoming-ceremony-select\"><md-input-container flex \nng-form=\"vm.ceremonySelectForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.ceremonyType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"ceremony\" ng-model=\"vm.ceremonyId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\" \nmd-container-class=\"upcoming-ceremony-select-container\"><md-optgroup ng-repeat=\"ceremonyGroup in vm.ceremonyGroups\" \nlabel=\"{{ceremonyGroup.text}}\"><md-option ng-repeat=\"currentCeremony in ceremonyGroup.ceremonies | orderBy:\'-start\'\" \nng-value=\"currentCeremony.id\"><div class=\"header\"><span class=\"ceremony-type\">\n{{currentCeremony.calendarEventTypeName}}, {{currentCeremony.locationSerialized || currentCeremony.locationName}}\n</span> <span class=\"deceased\">{{currentCeremony.deceasedSerialized}}</span></div><div class=\"sub-header\"><span \nclass=\"start-time\">{{currentCeremony.start | date:\'short\'}}</span> <span class=\"department\">\n{{currentCeremony.workOrderDepartment}}</span></div></md-option></md-optgroup></md-select><div class=\"errors\" \nng-messages=\"vm.ceremonySelectForm.ceremony.$error\" ng-if=\"vm.ceremonySelectForm.$touched\"><div ng-message=\"required\">\n<span translate=\"CEREMONIES.EDIT_CEREMONY.CEREMONY_REQUIRED\"></span></div></div></md-input-container><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div>");
$templateCache.put("app/main/ceremony/dialogs/ceremony-search-dialog/ceremony-search-dialog.tmpl.html","<md-dialog class=\"ceremony-search-dialog\" aria-label=\"Ceremony Search\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'CEREMONIES.CEREMONY_SEARCH_DIALOG.TITLE\' | translate}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"ceremony-type-list\"><md-list flex><div \nng-if=\"vm.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-virtual-repeat-container><div \nmd-virtual-repeat=\"ceremonyType in vm.ceremonyTypes | orderBy:\'name\'\"><md-list-item \nng-click=\"vm.selectCeremonyType(ceremonyType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': ceremonyType.id == vm.ceremonyTypeId }\"><md-icon md-font-icon=\"{{ceremonyType.iconName}}\" \nclass=\"md-avatar-icon\"></md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ ceremonyType.name }}</h3><p>\n{{ ceremonyType.description }}</p></div></md-list-item><md-divider ng-if=\"!$last\"></md-divider></div>\n</md-virtual-repeat-container></md-list></div><div flex class=\"ceremony-list\"><md-list flex><div \nng-if=\"vm.isSearching\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-virtual-repeat-container><div \nmd-virtual-repeat=\"ceremony in vm.ceremonies\"><md-list-item ng-click=\"vm.selectCeremony(ceremony)\" class=\"md-3-line\" \nflex ng-class=\"{ \'md-accent-bg\': ceremony.id == vm.selectedCeremony.id }\"><md-icon \nmd-font-icon=\"{{ceremony.calendarEventTypeIconName}}\" class=\"md-avatar-icon\"></md-icon><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{ ceremony.deceasedSerialized || ceremony.subject}} – {{ ceremony.locationSerialized }}</h3><h4>\n{{ ceremony.start | date:\'short\' }} – {{ ceremony.calendarEventTypeName }}</h4><p>\n{{ ceremony.workOrderDepartmentOrganizationDisplayName }}</p></div></md-list-item><md-divider ng-if=\"!$last\">\n</md-divider></div></md-virtual-repeat-container></md-list></div></div><div layout-padding><md-input-container \nclass=\"md-icon-float md-block\"><label>{{\'CEREMONIES.CEREMONY_SEARCH_DIALOG.SEARCH\' | translate}}</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" ng-change=\"vm.search()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-disabled=\"!vm.selectedCeremony\" ng-click=\"vm.closeDialog(vm.selectedCeremony)\">\n{{ \'CEREMONIES.CEREMONY_SEARCH_DIALOG.CHOOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ceremony/edit-ceremony/views/ceremony-calendar-event.tmpl.html","<div layout=\"column\"><location-select class=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.location\" \nlocation-id=\"vm.data.updateModel.calendarEvent.locationId\" label-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\" \non-selected=\"(vm.data.onLocationSelected)\"></location-select><date-time-range-select \nstart-time=\"vm.data.updateModel.calendarEvent.start\" end-time=\"vm.data.updateModel.calendarEvent.end\">\n</date-time-range-select><ceremony-participant-select location-id=\"vm.data.updateModel.calendarEvent.locationId\" \nceremony-participants=\"vm.data.updateModel.participants\"></ceremony-participant-select><calendar-event-users \nclass=\"margin-bottom\" event-users=\"vm.data.updateModel.calendarEventUsers\"></calendar-event-users></div>");
$templateCache.put("app/main/ceremony/edit-ceremony/views/sidebar.tmpl.html","<div ng-include=\"\'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html\'\"></div>");
$templateCache.put("app/main/ceremony/edit-ceremony/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"CEREMONIES.EDIT_CEREMONY.EDITING_TEXT\" \ntranslate-values=\"{ ceremonyString: vm.data.getCalendarEventString() }\"></span> <span \nng-if=\"vm.data.validation.calendarEventForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.calendarEventForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CEREMONIES.EDIT_CEREMONY.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CEREMONIES.EDIT_CEREMONY.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/common/components/baldris-audit/baldris-audit.tmpl.html","<div class=\"baldris-audit\" ng-if=\"vm.auditModel\" layout=\"column\"><h3>{{vm.titleText}}</h3><div class=\"audit-line\" \nng-if=\"vm.auditModel.createdBy\"><md-tooltip md-direction=\"top\">\n{{ \'COMMON.DATA.CREATED_BY\' | translate }}: {{vm.auditModel.createdBy}}<span ng-if=\"vm.auditModel.createdAt\">\n, {{vm.auditModel.createdAt | date:\'short\'}}</span></md-tooltip>\n{{ \'COMMON.DATA.CREATED_BY\' | translate }}: {{vm.auditModel.createdBy}}<span ng-if=\"vm.auditModel.createdAt\">\n, {{vm.auditModel.createdAt | date:\'short\'}}</span></div><div class=\"audit-line\" ng-if=\"vm.auditModel.lastModifiedBy\">\n<md-tooltip md-direction=\"top\">{{ \'COMMON.DATA.LAST_MODIFIED_BY\' | translate }}: {{vm.auditModel.lastModifiedBy}}<span \nng-if=\"vm.auditModel.lastModifiedAt\">, {{vm.auditModel.lastModifiedAt | date:\'short\'}}</span></md-tooltip>\n{{ \'COMMON.DATA.LAST_MODIFIED_BY\' | translate }}: {{vm.auditModel.lastModifiedBy}}<span \nng-if=\"vm.auditModel.lastModifiedAt\">, {{vm.auditModel.lastModifiedAt | date:\'short\'}}</span></div></div>");
$templateCache.put("app/main/common/components/baldris-file-select/baldris-file-select.tmpl.html","<div ng-form=\"vm.baldrisFileForm\" class=\"baldris-baldris-file-select\"><div class=\"header\" ng-if=\"vm.showPreview\"><h3>\n<md-icon ng-if=\"!vm.baldrisFile\" md-font-icon=\"icon-file-hidden\"></md-icon><md-icon \nng-if=\"!vm.isInitializing && vm.baldrisFile\" md-font-icon=\"icon-file-outline\"></md-icon>{{vm.labelText}}</h3></div><div\n layout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.showPreview\" class=\"selected-file text-center\"><img \nclass=\"preview-image\" ng-if=\"vm.baldrisFile.url\" baldris-img-src=\"vm.baldrisFile.url\" preset=\"square-100-padded\">\n<md-icon ng-if=\"!vm.baldrisFile.url\" md-font-icon=\"icon-file-hidden\" class=\"s80\"></md-icon></div><md-autocomplete \nng-if=\"!vm.showPreview\" flex md-min-length=\"vm.minLength\" md-input-name=\"baldrisFile\" \nmd-selected-item=\"vm.baldrisFile\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-clear-button=\"true\" md-menu-class=\"autocomplete-baldris-file-select\" ng-disabled=\"vm.isDisabled\"><md-item-template>\n<div><img class=\"symbol-image\" ng-if=\"item.url\" baldris-img-src=\"item.url\" preset=\"square-40-padded\" \nalt=\"{{item.name}}\"> <span class=\"symbol-icon\" ng-if=\"!item.url\"><md-icon md-font-icon=\"icon-file\"></md-icon></span>\n{{item.name}}</div></md-item-template><div ng-messages=\"vm.baldrisFileForm.baldrisFile.$error\" \nng-if=\"vm.baldrisFileForm.baldrisFile.$touched\"><div ng-message=\"invalidBaldrisFile\"><span \ntranslate=\"LOCATIONS.LOCATION_SELECT.INVALID_LOCATION\" translate-values=\"{ baldrisFile: vm.searchText }\"></span></div>\n</div></md-autocomplete><md-autocomplete ng-if=\"vm.showPreview\" flex md-min-length=\"vm.minLength\" \nmd-input-name=\"baldrisFile\" md-selected-item=\"vm.baldrisFile\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-clear-button=\"true\" \nmd-menu-class=\"autocomplete-baldris-file-select\" ng-disabled=\"vm.isDisabled\"><md-item-template><div><img \nclass=\"symbol-image\" ng-if=\"item.url\" baldris-img-src=\"item.url\" preset=\"square-40-padded\" alt=\"{{item.name}}\"> <span \nclass=\"symbol-icon\" ng-if=\"!item.url\"><md-icon md-font-icon=\"icon-file\"></md-icon></span>{{item.name}}</div>\n</md-item-template><div ng-messages=\"vm.baldrisFileForm.baldrisFile.$error\" \nng-if=\"vm.baldrisFileForm.baldrisFile.$touched\"><div ng-message=\"invalidBaldrisFile\"><span \ntranslate=\"LOCATIONS.LOCATION_SELECT.INVALID_LOCATION\" translate-values=\"{ baldrisFile: vm.searchText }\"></span></div>\n</div></md-autocomplete><md-button ng-if=\"!vm.showPreview\" class=\"md-icon-button search-button\" \nng-click=\"vm.openSearchDialog()\" aria-label=\"Search\" translate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/common/components/baldris-image/baldris-image.tmpl.html","<img ng-transclude=\"image\" ng-if=\"vm.evaluatedSrc\" src=\"{{vm.evaluatedSrc}}\" alt=\"{{vm.altText}}\" \ntitle=\"{{vm.titleText}}\">");
$templateCache.put("app/main/common/components/baldris-user-select/baldris-user-select.tmpl.html","<div ng-form=\"vm.baldrisUserForm\" class=\"baldris-user-select\" layout=\"row\" layout-align=\"center center\">\n<md-autocomplete flex md-input-name=\"baldrisUser\" md-selected-item=\"vm.baldrisUser\" md-search-text=\"vm.searchText\" \nmd-search-text-change=\"vm.searchTextChanged(vm.searchText)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-clear-button=\"true\" md-item-text=\"item.displayName\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"0\" md-menu-class=\"md-contact-chips-suggestions\" \nng-disabled=\"vm.isDisabled\"><md-item-template><div class=\"md-contact-suggestion\"><img \nng-if=\"!item.profileImageFilepath\" gravatar-src=\"item.email\" alt=\"{{item.displayName}}\"> <img class=\"profile-image\" \nng-if=\"item.profileImageFilepath\" baldris-img-src=\"item.profileImageFilepath\" preset=\"square-40-cropped\" \nalt=\"{{item.displayName}}\"> <span class=\"md-contact-name\" md-highlight-text=\"vm.searchTextUser\">{{item.displayName}} \n</span><span class=\"md-contact-email\">{{item.email}}</span></div></md-item-template><div \nng-messages=\"vm.baldrisUserForm.baldrisUser.$error\" ng-if=\"vm.baldrisUserForm.baldrisUser.$touched\"><div \nng-message=\"invalidBaldrisUser\"><span translate=\"COMMON.BALDRIS_USER_SELECT.INVALID_BALDRIS_USER\" \ntranslate-values=\"{ location: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/common/components/basic-auth-login-form/basic-auth-login-form.tmpl.html","<form name=\"basicAuthLoginForm\" class=\"basic-auth-login-form\" ng-submit=\"vm.authenticate($event)\"><div layout=\"column\">\n<div layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label>\n{{ \'COMMON.BASIC_AUTH_LOGIN.USERNAME\' | translate }}</label><input name=\"username\" ng-model=\"vm.credentials.username\" \nng-required=\"true\"><div layout=\"row\" class=\"errors\" ng-messages=\"basicAuthLoginForm.username.$error\" \nng-if=\"basicAuthLoginForm.username.$dirty\"><span ng-message=\"required\" \ntranslate=\"COMMON.BASIC_AUTH_LOGIN.ERRORS.USERNAME_REQUIRED\"></span></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\"><label>{{ \'COMMON.BASIC_AUTH_LOGIN.PASSWORD\' | translate }}</label>\n<input name=\"password\" ng-model=\"vm.credentials.password\" type=\"password\" ng-required=\"true\"><div layout=\"row\" \nclass=\"errors\" ng-messages=\"basicAuthLoginForm.password.$error\" ng-if=\"basicAuthLoginForm.password.$dirty\"><span \nng-message=\"required\" translate=\"COMMON.BASIC_AUTH_LOGIN.ERRORS.PASSWORD_REQUIRED\"></span></div></md-input-container>\n</div><div layout=\"row\"><md-button type=\"submit\">{{ \'COMMON.BASIC_AUTH_LOGIN.LOGIN\' | translate }}</md-button></div>\n</div></form>");
$templateCache.put("app/main/common/components/bill-to-select/bill-to-select.tmpl.html","<md-input-container class=\"baldris-bil-to-select md-block\"><label>{{vm.labelText}}</label><md-select \nng-model=\"vm.billTo\" ng-change=\"vm.onBillToChanged($event)\"><md-option ng-repeat=\"option in vm.billToOptions\" \nng-value=\"option.value\">{{option.text | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/common/components/date-range-select/date-range-select.tmpl.html","<div ng-form=\"vm.dateRangeForm\" class=\"date-range-select-container\" \nlayout-gt-xs=\"{{ vm.mode === \'vertical\' ? \'column\' : \'row\' }}\"><md-input-container><label>\n{{ vm.labelStartText || \"COMMON.DATE_TIME.START_DATE\" | translate }}</label><date-select name=\"startDate\" \nng-model=\"vm.startDate\" ng-change=\"vm.checkOverlap()\" ng-disabled=\"vm.isDisabled\" md-min-date=\"vm.minTime\" \nmd-max-date=\"vm.maxTime\" ng-required=\"vm.isRequired\"></date-select><div class=\"errors\" \nng-messages=\"vm.dateRangeForm.startDate.$error\"><div ng-message=\"valid\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_DATE\"></span></div><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div ng-message=\"mindate\"><span ng-if=\"!vm.minText\" \ntranslate=\"COMMON.DATE_TIME.MIN_DATE\"></span> <span ng-if=\"vm.minText\">{{ vm.minText }}</span></div><div \nng-message=\"maxdate\"><span ng-if=\"!vm.maxText\" translate=\"COMMON.DATE_TIME.MAX_DATE\"></span> <span ng-if=\"vm.maxText\">\n{{ vm.maxText }}</span></div><div ng-message=\"overlap\">\n{{ vm.overlapStartText || \"COMMON.DATE_TIME.OVERLAP_START\" | translate }}</div></div></md-input-container>\n<md-input-container><label>{{ vm.labelEndText || \"COMMON.DATE_TIME.END_DATE\" | translate }}</label><date-select \nname=\"endDate\" ng-model=\"vm.endDate\" ng-change=\"vm.checkOverlap()\" ng-disabled=\"vm.isDisabled\" \nmd-min-date=\"vm.minTime\" md-max-date=\"vm.maxTime\" ng-required=\"vm.isRequired\"></date-select><div class=\"errors\" \nng-messages=\"vm.dateRangeForm.endDate.$error\"><div ng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\">\n</span></div><div ng-message=\"required\"><span translate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div \nng-message=\"mindate\"><span ng-if=\"!vm.minText\" translate=\"COMMON.DATE_TIME.MIN_DATE\"></span> <span ng-if=\"vm.minText\">\n{{ vm.minText }}</span></div><div ng-message=\"maxdate\"><span ng-if=\"!vm.maxText\" translate=\"COMMON.DATE_TIME.MAX_DATE\">\n</span> <span ng-if=\"vm.maxText\">{{ vm.maxText }}</span></div><div ng-message=\"overlap\">\n{{ vm.overlapEndText || \"COMMON.DATE_TIME.OVERLAP_END\" | translate }}</div></div></md-input-container></div>");
$templateCache.put("app/main/common/components/date-time-range-select/date-time-range-select.tmpl.html","<div ng-form=\"vm.dateTimeRangeForm\" class=\"date-time-range-select-container\" \nlayout-gt-xs=\"{{ vm.mode === \'horizontal\' ? \'row\' : \'column\' }}\"><div><h4>\n{{ vm.labelStartText || \"COMMON.DATE_TIME.START_TIME\" | translate }} <span class=\"date-label\" ng-if=\"vm.startTime\">\n({{ vm.startTime | date: \"fullDate\" }})</span></h4><div class=\"start-time\" layout-gt-xs=\"row\"><md-input-container>\n<label>{{ \"COMMON.DATE_TIME.DATE\" | translate }}</label><date-select name=\"startDate\" ng-model=\"vm.startTime\" \nng-change=\"vm.datePartChanged(\'start\')\" ng-disabled=\"vm.isDisabled\" md-min-date=\"vm.minTime\" md-max-date=\"vm.maxTime\" \nng-required=\"vm.isRequired\"></date-select><div class=\"errors\" ng-messages=\"vm.dateTimeRangeForm.startDate.$error\"><div \nng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\"></span></div><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div ng-message=\"mindate\"><span ng-if=\"!vm.minText\" \ntranslate=\"COMMON.DATE_TIME.MIN_DATE\"></span> <span ng-if=\"vm.minText\">{{ vm.minText }}</span></div><div \nng-message=\"maxdate\"><span ng-if=\"!vm.maxText\" translate=\"COMMON.DATE_TIME.MAX_DATE\"></span> <span ng-if=\"vm.maxText\">\n{{ vm.maxText }}</span></div><div ng-message=\"dateOverlap\"><span translate=\"COMMON.DATE_TIME.OVERLAP\"></span></div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block time-part\" flex-gt-xs><label>\n{{ \"COMMON.DATE_TIME.TIME\" | translate }}</label><md-icon md-font-icon=\"icon-clock\"></md-icon><input ui-mask=\"99:99\" \nui-mask-placeholder-char=\" \" name=\"startTime\" ng-model=\"vm.startTimePart\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.timePartChanged(\'start\')\" ng-model-options=\"{ updateOn: \'blur\', debounce: { \'blur\': 0 } }\"><div \nclass=\"errors\" ng-messages=\"vm.dateTimeRangeForm.startTime.$error\"><div ng-message=\"invalidTime\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_TIME\"></span></div><div ng-message=\"timeOverlap\"><span \ntranslate=\"COMMON.DATE_TIME.OVERLAP\"></span></div></div></md-input-container></div></div><div><h4>\n{{ vm.labelEndText || \"COMMON.DATE_TIME.END_TIME\" | translate }} <span class=\"date-label\" ng-if=\"vm.endTime\">\n({{ vm.endTime | date: \"fullDate\" }})</span></h4><div class=\"end-time\" layout-gt-xs=\"row\"><md-input-container><label>\n{{ \"COMMON.DATE_TIME.DATE\" | translate }}</label><date-select name=\"endDate\" ng-model=\"vm.endTime\" \nng-change=\"vm.datePartChanged(\'end\')\" ng-disabled=\"vm.isDisabled\" md-min-date=\"vm.minTime\" md-max-date=\"vm.maxTime\" \nng-required=\"vm.isRequired\"></date-select><div class=\"errors\" ng-messages=\"vm.dateTimeRangeForm.endDate.$error\"><div \nng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\"></span></div><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div ng-message=\"mindate\"><span ng-if=\"!vm.minText\" \ntranslate=\"COMMON.DATE_TIME.MIN_DATE\"></span> <span ng-if=\"vm.minText\">{{ vm.minText }}</span></div><div \nng-message=\"maxdate\"><span ng-if=\"!vm.maxText\" translate=\"COMMON.DATE_TIME.MAX_DATE\"></span> <span ng-if=\"vm.maxText\">\n{{ vm.maxText }}</span></div><div ng-message=\"dateOverlap\"><span translate=\"COMMON.DATE_TIME.OVERLAP\"></span></div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block time-part\" flex-gt-xs><label>\n{{ \"COMMON.DATE_TIME.TIME\" | translate }}</label><md-icon md-font-icon=\"icon-clock\"></md-icon><input ui-mask=\"99:99\" \nui-mask-placeholder-char=\" \" name=\"endTime\" ng-model=\"vm.endTimePart\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.timePartChanged(\'end\')\" ng-model-options=\"{ updateOn: \'blur\', debounce: { \'blur\': 0 } }\"><div \nclass=\"errors\" ng-messages=\"vm.dateTimeRangeForm.endTime.$error\"><div ng-message=\"invalidTime\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_TIME\"></span></div><div ng-message=\"timeOverlap\"><span \ntranslate=\"COMMON.DATE_TIME.OVERLAP\"></span></div></div></md-input-container></div></div></div>");
$templateCache.put("app/main/common/components/date-time-select/date-time-select.tmpl.html","<div ng-form=\"vm.dateTimeForm\" class=\"date-time-select-container\" layout-gt-xs=\"row\"><md-input-container><label>\n{{ vm.labelDateText || \"COMMON.DATE_TIME.DATE\" | translate }}</label><date-select name=\"datePart\" \nng-model=\"vm.baldrisModel\" ng-change=\"vm.datePartChanged()\" ng-disabled=\"vm.isDisabled\" md-min-date=\"vm.minTime\" \nmd-max-date=\"vm.maxTime\" ng-required=\"vm.isRequired\"></date-select><div class=\"errors\" \nng-messages=\"vm.dateTimeForm.datePart.$error\"><div ng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\">\n</span></div><div ng-message=\"required\"><span translate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div \nng-message=\"mindate\"><span ng-if=\"!vm.minText\" translate=\"COMMON.DATE_TIME.MIN_DATE\"></span> <span ng-if=\"vm.minText\">\n{{ vm.minText }}</span></div><div ng-message=\"maxdate\"><span ng-if=\"!vm.maxText\" translate=\"COMMON.DATE_TIME.MAX_DATE\">\n</span> <span ng-if=\"vm.maxText\">{{ vm.maxText }}</span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block time-part\" flex-gt-xs><label><span ng-if=\"vm.labelTimeText\">{{ vm.labelTimeText }}</span>\n <span ng-if=\"!vm.labelTimeText\">{{ \"COMMON.DATE_TIME.TIME\" | translate }}</span></label><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><input ui-mask=\"99:99\" ui-mask-placeholder-char=\" \" name=\"timePart\" \nng-model=\"vm.timePart\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.timePartChanged()\" \nng-model-options=\"{ updateOn: \'blur\', debounce: { \'blur\': 0 } }\"><div class=\"errors\" \nng-messages=\"vm.dateTimeForm.timePart.$error\"><div ng-message=\"invalidTime\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_TIME\"></span></div></div></md-input-container></div>");
$templateCache.put("app/main/common/components/edit-price-input/edit-price-input.tmpl.html","<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"50\"><label>\n{{ vm.labelText || \'PRODUCTS.PRODUCT.PRICE\' | translate}}</label><input ng-currency ng-model=\"vm.priceExVat\" \nng-disabled=\"vm.isDisabled\" ng-change=\"vm.onPriceChanged()\"></md-input-container><md-input-container flex-gt-sm=\"50\">\n<label translate=\"PRODUCTS.PRODUCT.PRICE_INCLUDING_VAT\">Discount</label><input ng-currency ng-model=\"vm.priceIncVat\" \nng-disabled=\"vm.isDisabled\" ng-change=\"vm.onPriceVatChanged()\"></md-input-container></div>");
$templateCache.put("app/main/common/components/enum-flag-select/enum-flag-select.tmpl.html","<div class=\"baldris-enum-flag-select\" ng-form=\"vm.dataForm\"><label class=\"md-caption\">{{vm.labelText}}</label><div \nclass=\"baldris-options\" layout=\"row\" layout-align=\"start center\" layout-wrap><md-checkbox \nng-if=\"option.value !== \'none\'\" ng-repeat=\"option in vm.options\" ng-checked=\"vm.isSelected(option)\" \nng-click=\"vm.toggle(option)\">{{ option.text | translate }}</md-checkbox></div></div>");
$templateCache.put("app/main/common/components/icon-select/icon-select.tmpl.html","<div class=\"iconselect\" ng-form=\"vm.iconSelectForm\" layout=\"row\" layout-align=\"center start\"><md-autocomplete flex \nmd-input-name=\"iconSelectAutocompleteField\" md-min-length=\"0\" md-selected-item=\"vm.selectedIcon\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.properties.name\" \nmd-require-match md-floating-label=\"{{ vm.labelText }}\" md-selected-item-change=\"vm.onModelChanged()\">\n<md-item-template><md-icon md-font-icon=\"icon-{{item.properties.name}}\" class=\"s40\"></md-icon><span \nmd-highlight-text=\"vm.searchText\">{{item.properties.name}}</span></md-item-template><div \nng-messages=\"vm.iconSelectForm.iconSelectAutocompleteField.$error\" \nng-if=\"vm.iconSelectForm.iconSelectAutocompleteField.$touched\"><div ng-message=\"md-require-match\">\nPlease select an existing icon.</div></div></md-autocomplete><md-icon md-font-icon=\"{{vm.iconName}}\" class=\"s40\">\n</md-icon></div>");
$templateCache.put("app/main/common/components/many-to-many-select/many-to-many-select.tmpl.html","<div class=\"baldris-many-to-many-container\" layout=\"column\" ng-form=\"vm.manyToManyForm\"><label class=\"md-caption\" \nng-class=\"{\'md-warn-fg\': vm.manyToManyForm.$invalid && vm.manyToManyForm.$dirty}\">{{vm.labelText}} <span \nng-if=\"vm.isRequired\">*</span></label><md-chips name=\"selections\" class=\"baldris-many-to-many-select\" \nng-model=\"vm.sourceList\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" ng-required=\"vm.isRequired\" \nmd-require-match=\"true\" ng-class=\"{\'md-warn\': vm.manyToManyForm.$invalid && vm.manyToManyForm.$dirty}\" \nmd-on-add=\"vm.onAddSource($chip)\" md-on-remove=\"vm.onRemoveSource($chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedSource\" md-search-text=\"vm.searchText\" md-items=\"item in vm.search(vm.searchText)\" \nmd-item-text=\"item.name\" md-clear-button=\"true\" md-min-length=\"vm.minLength\" placeholder=\"{{ vm.placeholderText }}\" \nmd-menu-class=\"md-source-chips-suggestions\"><div class=\"md-source-suggestion\"><span class=\"md-source-name\" \nmd-highlight-text=\"vm.searchText\">{{item.name}}</span></div></md-autocomplete><md-chip-template><span>{{$chip.name}}\n</span></md-chip-template></md-chips><div class=\"errors\" ng-messages=\"vm.manyToManyForm.$error\" \nng-if=\"vm.manyToManyForm.$dirty\"><div ng-message=\"required\" translate=\"COMMON.VALIDATION.SELECTION_REQUIRED\" \ntranslate-values=\"{ inputName: vm.labelText }\"></div></div></div>");
$templateCache.put("app/main/common/components/meetup-select/meetup-select.tmpl.html","<md-input-container class=\"baldris-meetup-select md-block\"><label>{{vm.labelText}}</label><md-select \nng-model=\"vm.meetup\" ng-change=\"vm.onMeetupChanged($event)\"><md-option ng-repeat=\"option in vm.meetupOptions\" \nng-value=\"option.value\">{{option.text | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/common/components/open-casket-select/open-casket-select.tmpl.html","<md-input-container class=\"baldris-open-casket-select md-block\"><label>{{vm.labelText}}</label><md-select \nng-model=\"vm.openCasket\" ng-change=\"vm.openCasketChanged()\"><md-option ng-repeat=\"option in vm.openCasketOptions\" \nvalue=\"{{option.value}}\">{{option.text | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/common/dialogs/search-entity-dialog/search-entity-dialog.tmpl.html","<md-dialog class=\"search-entity-dialog\" aria-label=\"{{vm.entityOptions.title}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.entityOptions.title}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"entity-type-list\"><md-list flex><div \nng-if=\"vm.isFetchingTypes\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-repeat=\"entityType in vm.entityTypes\"><div \nng-if=\"vm.entityOptions.entityTypeItemTemplate\" ng-include=\"vm.entityOptions.entityTypeItemTemplate\"></div>\n<md-list-item ng-if=\"!vm.entityOptions.entityTypeItemTemplate\" ng-click=\"vm.selectEntityType(entityType)\" \nclass=\"md-2-line\" flex ng-class=\"{ \'md-accent-bg\': entityType.id == vm.selectedEntityTypeId }\"><img \nng-if=\"vm.entityOptions.entityTypeImageProperty && entityType[vm.entityOptions.entityTypeImageProperty]\" \nbaldris-img-src=\"entityType[vm.entityOptions.entityTypeImageProperty]\" preset=\"square-40-cropped\" class=\"md-avatar\" \nalt=\"{{entity[vm.entityOptions.entityTypePrimaryProperty]}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ entity[vm.entityOptions.entityTypePrimaryProperty] }}</h3><p>\n{{ entity[vm.entityOptions.entityTypeSecondaryProperty] }}</p></div></md-list-item><md-divider ng-if=\"!$last\">\n</md-divider></div></md-list></div><div flex class=\"entity-list\"><md-list flex><div ng-if=\"vm.isSearching\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-repeat=\"entity in vm.searchResults\"><div \nng-if=\"vm.entityOptions.entityItemTemplate\" ng-include=\"vm.entityOptions.entityItemTemplate\"></div><md-list-item \nng-if=\"!vm.entityOptions.entityItemTemplate\" ng-click=\"vm.selectItem(entity)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': entity.id == vm.selectedEntity.id }\"><img \nng-if=\"vm.entityOptions.entityImageProperty && entity[vm.entityOptions.entityImageProperty]\" \nbaldris-img-src=\"entity[vm.entityOptions.entityImageProperty]\" preset=\"square-40-cropped\" class=\"md-avatar\" \nalt=\"{{entity[vm.entityOptions.entityPrimaryProperty]}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ entity[vm.entityOptions.entityPrimaryProperty] }}</h3><p>{{ entity[vm.entityOptions.entitySecondaryProperty] }}</p>\n</div></md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list></div></div><div layout-padding>\n<md-input-container class=\"md-icon-float md-block\"><label>{{\'COMMON.DIALOG.SEARCH\' | translate}}</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" \nng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.closeDialog(vm.selectedEntity)\">{{ \'COMMON.DIALOG.OK_CHOOSE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/common/dialogs/signature-dialog/signature-dialog.tmpl.html","<md-dialog class=\"signature-dialog\" aria-label=\"Signature\"><md-dialog-content><div ng-if=\"vm.getIsInPortrait()\"><p \nclass=\"md-title\">Snu enheten din til landskapsmodus</p></div><div class=\"signature-field\" \nng-if=\"!vm.getIsInPortrait()\"><signature-pad accept=\"vm.acceptSignature\" clear=\"vm.clearSignature\" \nheight=\"{{vm.getSignatureHeight()}}\" width=\"{{vm.getSignatureWidth()}}\" disabled=\"false\"></signature-pad></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"!vm.getIsInPortrait()\" \nng-click=\"vm.clearSignature()\">{{\'PARTY.PARTY_PRIVACY_DIALOG.CLEAR\' | translate}}</md-button><span flex></span>\n<md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}\n</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/common/directives/sex-select/sex-select.tmpl.html","<md-input-container class=\"baldris-sex-select md-block\"><label>{{vm.labelText}}</label><md-select ng-model=\"vm.sex\" \nng-change=\"vm.sexChanged()\"><md-option ng-repeat=\"option in vm.sexOptions\" value=\"{{option.value}}\">\n{{option.text | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/custom-field/components/custom-field-category-select/custom-field-category-select.tmpl.html","<md-input-container class=\"md-block custom-field-category-select\"><label>\n{{ vm.labelText || \"CUSTOM_FIELDS.CUSTOM_FIELD.CUSTOM_FIELD_CATEGORY\" | translate }}</label><md-select \nng-model=\"vm.customFieldCategory\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"customFieldCategory in vm.customFieldCategories | orderBy:\'name\'\" ng-value=\"customFieldCategory\"><span \nng-class=\"{\'is-deleted\': customFieldCategory.isDeleted}\">\n{{ customFieldCategory.name }} ({{ customFieldCategory.internalName }})</span></md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/custom-field/components/custom-field-data-type-select/custom-field-data-type-select.tmpl.html","<md-input-container class=\"baldris-custom-field-data-type-select md-block\"><label>\n{{ vm.labelText || \"CUSTOM_FIELDS.CUSTOM_FIELD.DATA_TYPE\" | translate }}</label><md-select \nng-model=\"vm.selectedDataType\" ng-change=\"vm.onSelectChanged(vm.selectedDataType)\"><md-option \nng-repeat=\"option in vm.dataTypes\" ng-value=\"option.value\">{{ option.text | translate }}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/edit-custom-field.tmpl.html","<div layout=\"row\" ng-form=\"vm.editCustomFieldForm\" ng-include=\"vm.templateUrl\"></div>");
$templateCache.put("app/main/custom-field/components/product-choices-list/product-choices-list.tmpl.html","<md-list class=\"baldris-product-choices-list\" ng-form=\"vm.productChoicesListForm\"><md-subheader class=\"md-no-sticky\">\n{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.PRODUCT_CHOICES\" | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditProductChoiceDialog(productChoice, $event)\" \nng-repeat=\"productChoice in vm.productChoices | orderBy:\'productName\'\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-archive\"></md-icon><div class=\"md-list-item-text\"><h3 \nng-class=\"{ \'text-strike\': productChoice.changeState == 3 }\">\n{{ productChoice.amount || \"0\" }}# – {{ productChoice.productName }}</h3><p \nng-class=\"{ \'text-strike\': productChoice.changeState == 3 }\">\n{{ productChoice.departmentName || \"CUSTOM_FIELDS.PRODUCT_CHOICES.ALL_DEPARTMENTS\" | translate }}</p><p \nclass=\"md-warn-fg\" ng-show=\"productChoice.changeState == 3\">\n{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.DELETE_TEXT\" | translate }}</p></div><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.deleteOrUndoAutoProduct(productChoice, $event)\"><md-tooltip md-direction=\"top\"><span \nng-if=\"productChoice.changeState == 3\" translate=\"CUSTOM_FIELDS.PRODUCT_CHOICES.UNDO_DELETE\"></span> <span \nng-if=\"productChoice.changeState != 3\" translate=\"CUSTOM_FIELDS.PRODUCT_CHOICES.DELETE_PRODUCT_CHOICE\"></span>\n</md-tooltip><md-icon ng-if=\"productChoice.changeState == 3\" md-font-icon=\"icon-undo\"></md-icon><md-icon \nng-if=\"productChoice.changeState != 3\" md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item><md-list-item \nclass=\"md-2-line\" ng-click=\"vm.showEditProductChoiceDialog(null, $event)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-plus\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.ADD_PRODUCT_CHOICE\" | translate }}</h3><p>\n{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.NEW_PRODUCT_CHOICE\" | translate }}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/custom-field/dialogs/edit-product-choice-dialog/edit-product-choice-dialog.tmpl.html","<md-dialog class=\"edit-product-choice-dialog edit-dialog\" aria-label=\"Edit Default Product Choice\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.EDIT_PRODUCT_CHOICE\" | translate }}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><md-input-container flex><label>{{ \"CUSTOM_FIELDS.PRODUCT_CHOICES.AMOUNT\" | translate }}</label><input \ntype=\"number\" ng-model=\"vm.productChoice.amount\"></md-input-container><product-select flex product=\"vm.product\" \nproduct-id=\"vm.productChoice.productId\" label-text=\"{{ \'PRODUCTS.PRODUCT.PRODUCT\' | translate }}\" \non-update=\"vm.onProductSelected(value)\"></product-select><div ng-if=\"vm.product\" class=\"price\">\n{{ vm.product.priceIncludingVat | currency }} <span class=\"excluding-vat\">({{ vm.product.price | currency }})</span>\n</div><bill-to-select bill-to=\"vm.productChoice.billTo\" \nlabel-text=\"{{ \'CUSTOM_FIELDS.PRODUCT_CHOICES.BILL_TO\' | translate}}\"></bill-to-select><department-select \ndepartment-id=\"vm.productChoice.departmentId\" department=\"vm.department\" \ndisplay-text=\"vm.productChoice.departmentName\" is-required=\"false\" \nlabel-text=\"{{ \'CUSTOM_FIELDS.PRODUCT_CHOICES.DEPARTMENT\' | translate}}\"></department-select></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/deceased/components/deceased-card/deceased-card.tmpl.html","<md-card class=\"deceased-card\"><md-card-header class=\"clickable\" ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\">\n<md-card-avatar><img class=\"infection-image\" ng-if=\"vm.baldrisModel.infectionStatusUrl\" \nbaldris-img-src=\"vm.baldrisModel.infectionStatusUrl\" preset=\"square-40-cropped\" \nalt=\"{{vm.baldrisModel.infectionStatus}}\" title=\"{{vm.baldrisModel.infectionStatus}}\"> <img class=\"lookup-image\" \nng-if=\"!vm.baldrisModel.infectionStatusUrl && vm.baldrisModel.personImageUrl\" \nbaldris-img-src=\"vm.baldrisModel.personImageUrl\" preset=\"square-40-cropped\" \nalt=\"{{vm.baldrisModel.personDisplayName}}\"> <img \nng-if=\"!vm.baldrisModel.infectionStatusUrl && !vm.baldrisModel.personImageUrl\" gravatar-src=\"\'post@baldris.no\'\" \ngravatar-default=\"mm\"></md-card-avatar><md-card-header-text><span class=\"md-title\">\n{{vm.baldrisModel.lastName}}, {{vm.baldrisModel.firstName}}</span> <span class=\"md-subhead\"><span \nclass=\"icon icon-cake\"></span> {{vm.baldrisModel.dateOfBirth | date:\'shortDate\'}} <span \nclass=\"icon icon-tag-text-outline\"></span> {{vm.baldrisModel.dateOfDeath | date:\'shortDate\'}}</span>\n</md-card-header-text></md-card-header><md-card-title class=\"clickable\" \nng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><md-card-title-text><span class=\"md-headline\">\n{{vm.baldrisModel.lastName}}, {{vm.baldrisModel.firstName}}</span></md-card-title-text></md-card-title><md-card-content\n class=\"clickable\" ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.dateOfBirth\"><label class=\"md-caption\">{{\'PARTY.PERSON.DATE_OF_BIRTH\' | translate}}</label><p>\n{{vm.baldrisModel.dateOfBirth | date:\'shortDate\'}}</p></div><div flex ng-if=\"vm.baldrisModel.socialSecurityNumber\">\n<label class=\"md-caption\">{{\'PARTY.PERSON.SOCIAL_SECURITY_NUMBER\' | translate}}</label><p>\n{{vm.baldrisModel.socialSecurityNumber}}</p></div></div><div ng-if=\"vm.baldrisModel.dateOfDeath\"><label \nclass=\"md-caption\">{{\'PARTY.PERSON.DATE_OF_DEATH\' | translate}}</label><p>\n{{vm.baldrisModel.dateOfDeath | date:\'shortDate\'}}</p></div><div ng-if=\"vm.baldrisModel.address.localizedAddress\">\n<label class=\"md-caption\">{{vm.baldrisModel.address.addressTypeName || \'ADDRESSES.ADDRESS.ADDRESS\' | translate }}\n</label><p>{{vm.baldrisModel.address.localizedAddress}}</p></div><div ng-if=\"vm.maritalStatusArray.length > 0\"><label \nclass=\"md-caption\">{{\'DECEASED.DECEASED.MARITAL_STATUS\' | translate}}</label><p><span \nng-repeat=\"maritalStatus in vm.maritalStatusArray\">{{maritalStatus | translate}}<span ng-if=\"!$last\">,</span></span>\n</p></div></md-card-content><md-card-actions ng-hide=\"vm.disableLinks\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" \naria-label=\"Delete\" ng-click=\"vm.deleteDeceased(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/deceased/components/deceased-select/deceased-select.tmpl.html","");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/edit-deceased-dialog.tmpl.html","<md-dialog class=\"edit-deceased-dialog edit-dialog\" aria-label=\"Edit Deceased\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.deceased.person.displayName}}</span></div></md-toolbar>\n<md-dialog-content><md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.selectedIndex\"><md-tab \nlabel=\"{{\'DECEASED.PERSONALIA\' | translate}}\"></md-tab><md-tab \nlabel=\"{{\'DECEASED.AFFECTED_MUNICIPALITIES\' | translate}}\"></md-tab><md-tab \nlabel=\"{{\'DECEASED.DEATH_CIRCUMSTANCES\' | translate}}\"></md-tab><md-tab label=\"{{\'DECEASED.PROBATE\' | translate}}\">\n</md-tab><md-tab label=\"{{\'DECEASED.CITIZENSHIP_AND_RELIGION\' | translate}}\"></md-tab><md-tab \nlabel=\"{{\'DECEASED.MISCELLANEOUS\' | translate}}\"></md-tab></md-tabs><div ng-form=\"vm.deceasedForm\" novalidate><div \nng-if=\"vm.selectedIndex == 0\" ng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/personalia.html\'\">\n</div><div ng-if=\"vm.selectedIndex == 1\" \nng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/municipalities.html\'\"></div><div \nng-if=\"vm.selectedIndex == 2\" \nng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/death-circumstances.html\'\"></div><div \nng-if=\"vm.selectedIndex == 3\" ng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/probate.html\'\">\n</div><div ng-if=\"vm.selectedIndex == 4\" \nng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/citizenship-and-religion.html\'\"></div><div \nng-if=\"vm.selectedIndex == 5\" \nng-include=\"\'app/main/deceased/components/edit-deceased-dialog/views/miscellaneous.html\'\"></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.SAVE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/deceased/dialogs/search-deceased-dialog/search-deceased-dialog.tmpl.html","<md-dialog class=\"search-deceased-dialog\" aria-label=\"Search Deceased\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'DECEASED.SEARCH_DECEASED_DIALOG.TITLE\' | translate}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"deceased-list\"><md-list flex><div \nng-if=\"vm.isSearching\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-virtual-repeat-container><div \nmd-virtual-repeat=\"item in vm.searchResults | orderBy:\'personDisplayName\'\"><md-list-item \nng-click=\"vm.selectItem(item)\" class=\"md-3-line\" flex><img class=\"md-avatar\" gravatar-src=\"\'post@baldris.no\'\" \ngravatar-default=\"mm\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.personDisplayName }}</h3><h4>\n{{ item.personDateOfBirth | date:\'shortDate\'}} - {{ item.personDateOfDeath | date:\'shortDate\'}}</h4><p>\n{{ vm.getWorkOrdersString(item) }}</p></div></md-list-item><md-divider ng-if=\"!$last\"></md-divider></div>\n</md-virtual-repeat-container></md-list></div><div flex hide-sm hide-xs class=\"deceased-preview\"><deceased-card \nng-if=\"vm.selectedDeceased\" baldris-model=\"vm.selectedDeceased\" disable-links=\"true\"></deceased-card><div \nng-if=\"vm.isLoadingDeceased\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div><div layout-padding><md-input-container \nclass=\"md-icon-float md-block\"><label>{{\'DECEASED.SEARCH_DECEASED_DIALOG.SEARCH\' | translate}}</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" \nng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.closeDialog(vm.selectedDeceased)\">\n{{ \'DECEASED.SEARCH_DECEASED_DIALOG.CHOOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/deceased/edit-deceased/views/citizenship-and-religion.html","<country-select label-text=\"{{\'DECEASED.DECEASED.CITIZENSHIP\' | translate}}\" country-id=\"vm.countryId\" \ncountry=\"vm.country\" allow-custom=\"true\" custom-value=\"vm.data.updateModel.deceased.citizenship\"></country-select>\n<party-select label-text=\"{{\'DECEASED.DECEASED.RELIGION\' | translate}}\" \nparty-id=\"vm.data.updateModel.deceased.religionId\" party=\"vm.data.updateModel.deceased.religion\" \nparty-config=\"\'ReligionPartyType\'\"></party-select><party-select \nlabel-text=\"{{\'DECEASED.DECEASED.CONGREGATION\' | translate}}\" party-id=\"vm.data.updateModel.deceased.congregationId\" \nparty=\"vm.data.updateModel.deceased.congregation\" party-config=\"\'CongregationPartyType\'\"></party-select>");
$templateCache.put("app/main/deceased/edit-deceased/views/death-circumstances.html","<div layout=\"column\" layout-gt-sm=\"row\"><div flex flex-gt-sm=\"50\"><death-date-select flex-gt-sm=\"50\" \nng-model=\"vm.data.updateModel.deceased.dateOfDeath\" date-of-birth=\"vm.data.updateModel.deceased.dateOfBirth\" \nallow-approximate=\"true\" approximate-model=\"vm.data.updateModel.deceased.dateOfDeathApproximate\"></death-date-select>\n</div><div flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \"DECEASED.DECEASED.CAUSE_OF_DEATH\" | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.causeOfDeath\"></md-input-container></div></div><div><md-checkbox \nng-model=\"vm.data.updateModel.deceased.wasStillborn\">{{ \"DECEASED.DECEASED.WAS_STILLBORN\" | translate }}</md-checkbox>\n</div><location-select label-text=\"{{ \'DECEASED.DECEASED.PLACE_OF_DEATH\' | translate }}\" \nlocation-id=\"vm.data.updateModel.deceased.placeOfDeathId\" location=\"vm.data.updateModel.deceased.placeOfDeath\" \nlocation-config=\"\'PlaceOfDeathLocationType\'\"></location-select><div><md-input-container flex class=\"md-block\"><label>\n{{ \"DECEASED.DECEASED.PLACE_OF_DEATH_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.placeOfDeathRemarks\"></md-input-container></div><div><lookup-string-select \nlookup-string=\"vm.data.updateModel.deceased.infectionStatus\" \nlookup-string-id=\"vm.data.updateModel.deceased.infectionStatusId\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.deceased.infectionStatusRemarks\" \nlookup-string-config=\"\'DeceasedInfectionLookupStringType\'\" min-query-length=\"0\" \nlabel-text=\"{{\'DECEASED.DECEASED.INFECTION_STATUS\' | translate}}\"></lookup-string-select></div><casket-select \nlabel-text=\"{{ \'DECEASED.DECEASED.CASKET\' | translate }}\" \ncasket-attributes=\"vm.data.updateModel.deceased.appliedCasketAttributes\" \ncasket-id=\"vm.data.updateModel.deceased.casketId\" casket=\"vm.data.updateModel.deceased.casket\"></casket-select>");
$templateCache.put("app/main/deceased/edit-deceased/views/miscellaneous.html","<div><md-input-container class=\"md-block\"><label>{{\'DECEASED.DECEASED.WORK_TITLE\' | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.workTitle\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'DECEASED.DECEASED.CLOSEST_FAMILY\' | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.closestFamily\"></md-input-container></div><enum-flag-select \nenum-flag=\"vm.data.updateModel.deceased.implants\" enum-flag-options=\"deceasedImplants\" \nlabel-text=\"{{\'DECEASED.DECEASED.IMPLANTS\' | translate}}\"></enum-flag-select><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-wrap><div flex-gt-sm=\"33\"><md-checkbox ng-model=\"vm.data.updateModel.deceased.isGovernmentEmployee\">\n{{\'DECEASED.DECEASED.IS_GOVERNMENT_EMPLOYEE\' | translate}}</md-checkbox></div><div flex-gt-sm=\"33\"><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isOutOfTown\">{{\'DECEASED.DECEASED.IS_OUT_OF_TOWN\' | translate}}</md-checkbox>\n</div><div flex-gt-sm=\"33\"><md-checkbox ng-model=\"vm.data.updateModel.deceased.isToBeCremated\">\n{{\'DECEASED.DECEASED.IS_TO_BE_CREMATED\' | translate}}</md-checkbox></div><div flex-gt-sm=\"33\"><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isTheRemainsToBeViewed\">\n{{\'DECEASED.DECEASED.IS_THE_REMAINS_TO_BE_VIEWED\' | translate}}</md-checkbox></div></div><urn-select \nng-if=\"vm.data.updateModel.deceased.isToBeCremated\" label-text=\"{{\'DECEASED.DECEASED.URN\' | translate}}\" \nurn-id=\"vm.data.updateModel.deceased.urnId\" urn=\"vm.data.updateModel.deceased.urn\"></urn-select><div \nng-if=\"vm.data.updateModel.deceased.isToBeCremated\" layout=\"column\"><div><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isAuthoritiesNoticedOfCremation\">\n{{\'DECEASED.DECEASED.IS_AUTHORITIES_NOTICED_OF_CREMATION\' | translate}}</md-checkbox></div><div><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isApplyingForAshSpreading\">\n{{\'DECEASED.DECEASED.IS_APPLYING_FOR_ASH_SPREADING\' | translate}}</md-checkbox></div><div><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isFamilyAttendingUrnLowering\">\n{{\'DECEASED.DECEASED.IS_FAMILY_ATTENDING_URN_LOWERING\' | translate}}</md-checkbox></div></div>");
$templateCache.put("app/main/deceased/edit-deceased/views/municipalities.html","<municipality-select label-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_RESIDENCE\' | translate}}\" \nmunicipality-id=\"vm.data.updateModel.deceased.municipalityOfResidenceId\" \nmunicipality=\"vm.data.updateModel.deceased.municipalityOfResidence\"></municipality-select><municipality-select \nlabel-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_BIRTH\' | translate}}\" \nmunicipality-id=\"vm.data.updateModel.deceased.municipalityOfBirthId\" \nmunicipality=\"vm.data.updateModel.deceased.municipalityOfBirth\"></municipality-select><municipality-select \nlabel-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_DEATH\' | translate}}\" \nmunicipality-id=\"vm.data.updateModel.deceased.municipalityOfDeathId\" \nmunicipality=\"vm.data.updateModel.deceased.municipalityOfDeath\"></municipality-select>");
$templateCache.put("app/main/deceased/edit-deceased/views/personalia.html","<edit-party baldris-model=\"vm.data.updateModel.deceased\" is-disabled=\"vm.isDisabled\" show-death-date=\"true\" \ninclude-ssn=\"true\"></edit-party><inline-address-list party-id=\"vm.data.updateModel.person.id\" \ncollection=\"vm.data.updateModel.addresses\"></inline-address-list><enum-flag-select \nenum-flag=\"vm.data.updateModel.deceased.maritalStatus\" enum-flag-options=\"maritalStatusOptions\" \nlabel-text=\"{{\'DECEASED.DECEASED.MARITAL_STATUS\' | translate}}\"></enum-flag-select><div><md-input-container \nclass=\"md-block\" ng-show=\"vm.showYearOfMarriage()\"><label>{{ \"DECEASED.DECEASED.YEAR_OF_MARRIAGE\" | translate }}\n</label><input ng-model=\"vm.data.updateModel.deceased.yearOfMarriage\"></md-input-container></div>");
$templateCache.put("app/main/deceased/edit-deceased/views/probate.html","<enum-flag-select enum-flag=\"vm.data.updateModel.deceased.deceasedLeavesBehind\" \nenum-flag-options=\"deceasedLeavesBehindOptions\" \nlabel-text=\"{{\'DECEASED.DECEASED.DECEASED_LEAVES_BEHIND\' | translate}}\"></enum-flag-select><enum-flag-select \nenum-flag=\"vm.data.updateModel.deceased.probate\" enum-flag-options=\"probateOptions\" \nlabel-text=\"{{\'DECEASED.DECEASED.PROBATE\' | translate}}\"></enum-flag-select><div><md-input-container class=\"md-block\">\n<label>{{\'DECEASED.DECEASED.ASSETS\' | translate }}</label><textarea ng-model=\"vm.data.updateModel.deceased.assets\">\n</textarea></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'DECEASED.DECEASED.REMARKS\' | translate }}</label><textarea ng-model=\"vm.data.updateModel.deceased.remarks\">\n</textarea></md-input-container></div>");
$templateCache.put("app/main/deceased/edit-deceased/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-deceased-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><baldris-audit title-text=\"vm.data.updateModel.person.displayName\" \naudit-model=\"vm.data.updateModel.deceased\"></baldris-audit><md-button \nng-if=\"!vm.data.updateModel.grantApplications || vm.data.updateModel.grantApplications.length === 0\" \nclass=\"md-raised md-accent md-block\" ng-click=\"vm.data.openEditGrantApplicationDialog($event, null)\">\n{{ \'DECEASED.EDIT_DECEASED_DIALOG.ADD_GRANT_APPLICATION\' | translate }}</md-button><md-button \nng-if=\"vm.data.updateModel.grantApplications && vm.data.updateModel.grantApplications.length > 0\" \nclass=\"md-raised md-accent md-block\" \nng-click=\"vm.data.openEditGrantApplicationDialog($event, vm.data.updateModel.grantApplications[0])\">\n{{ \'DECEASED.EDIT_DECEASED_DIALOG.EDIT_GRANT_APPLICATION\' | translate }}</md-button></div></div>");
$templateCache.put("app/main/deceased/edit-deceased/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"DECEASED.EDIT_DECEASED_DIALOG.EDITING_TEXT\" \ntranslate-values=\"{ deceasedName: vm.data.updateModel.deceased.lastName + \', \' + vm.data.updateModel.deceased.firstName }\">\n</span> <span ng-if=\"vm.data.validation.deceasedForm.$dirty\">*</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.deceasedForm.$pristine\" \naria-label=\"Jump backwards\" translate-attr-aria-label=\"WORK-ORDERS.WORK-ORDER.FIRST\"><md-tooltip md-direction=\"top\">\n<span translate=\"DECEASED.EDIT_DECEASED_DIALOG.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Jump backwards\" translate-attr-aria-label=\"WORK-ORDERS.WORK-ORDER.FIRST\"><md-tooltip md-direction=\"top\">\n<span translate=\"DECEASED.EDIT_DECEASED_DIALOG.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/department/components/department-list/department-list.tmpl.html","<div class=\"department-list-component\"><md-toolbar class=\"md-primary\"><div layout=\"row\"><md-toolbar-filler \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"center center\"><md-icon class=\"department-list-filler-icon\" \nmd-font-icon=\"icon-store\"></md-icon></md-toolbar-filler><div class=\"md-toolbar-tools\"><h2 flex md-truncate>\n{{\"DEPARTMENTS.DEPARTMENTS\" | translate }}</h2><md-button class=\"md-icon-button\" aria-label=\"Add new department\" \nng-disabled=\"!vm.canAdd\" ng-click=\"vm.addDepartment()\"><md-tooltip md-direction=\"bottom\">\n{{\"DEPARTMENTS.DEPARTMENT_LIST.ADD_NEW_DEPARTMENT\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-plus\" \nclass=\"favorite-icon\"></md-icon></md-button></div></div></md-toolbar><md-list><md-list-item class=\"md-3-line\" \nng-class=\"{ \'is-deleted\': department.isDeleted}\" \nng-repeat-start=\"department in vm.departments | orderBy:\'organizationDisplayName\'\" \nng-click=\"vm.editDepartment(department)\"><img ng-if=\"department.imageFilepath\" class=\"md-avatar\" \nbaldris-img-src=\"department.imageFilepath\" preset=\"square-40-cropped\"> <img \nng-if=\"!department.imageFilepath && department.logoFilepath\" class=\"md-avatar\" \nbaldris-img-src=\"department.logoFilepath\" preset=\"square-40-padded\"><md-icon \nng-if=\"!department.imageFilepath && !department.logoFilepath\" class=\"md-avatar-icon\" md-font-icon=\"icon-store\">\n</md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ department.organizationDisplayName }}</h3><h4><md-icon \nng-show=\"department.primaryTelephone\" md-font-icon=\"icon-phone\"></md-icon>{{ ::department.primaryTelephone}}<md-icon \nng-show=\"department.postAddressSerialized\" md-font-icon=\"icon-home\"></md-icon>{{ ::department.postAddressSerialized}}\n</h4><p><md-icon ng-show=\"department.primaryEmail\" md-font-icon=\"icon-email\"></md-icon>{{ ::department.primaryEmail }}\n</p></div></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div>");
$templateCache.put("app/main/department/components/department-select/department-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{vm.labelText}}</label><md-select ng-model=\"vm.departmentId\" \nng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"department in vm.departments | orderBy:\'displayName\'\" ng-value=\"department.id\">{{department.displayName}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/department/components/edit-department/edit-department.tmpl.html","<md-content class=\"edit-page\"><ng-form name=\"editDepartmentComponentForm\" novalidate layout=\"column\" layout-padding>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label>\n{{\'DEPARTMENTS.DEPARTMENT.DEPARTMENT_NUMBER\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.departmentDto.departmentNumber\" ng-change=\"vm.onValueChanged(vm.departmentDto)\"></md-input-container>\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.NAME\' | translate}}</label><input name=\"organizationName\" \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.name\" ng-change=\"vm.onValueChanged(vm.organizationDto)\" \nrequired><div ng-messages=\"editDepartmentComponentForm.organizationName.$error\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\">{{\"COMMON.VALIDATION.REQUIRED_FIELD\" |translate}}</div></div>\n</md-input-container></div><div layout=\"column\"><legal-unit-select flex layout=\"column\" \nlabel-text=\"{{\'DEPARTMENTS.DEPARTMENT.LEGAL_UNIT\' | translate}}\" legal-unit-id=\"vm.departmentDto.legalUnitId\" \nlegal-unit=\"vm.temp.legalUnit\" display-text=\"vm.departmentDto.legalUnitOrganizationDisplayName\" \non-update=\"vm.onValueChanged(vm.departmentDto)\"></legal-unit-select></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.ORGANIZATION_NUMBER\' | translate}}</label><input \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.organizationNumber\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.HOME_PAGE\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.homePage\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div>\n<div layout=\"column\"><md-input-container flex><label>{{\'PARTY.ORGANIZATION.BANK_CONNECTION\' | translate}}</label><input\n ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.bankConnection\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.BANK_ACCOUNT\' | translate}}</label><input \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.bankAccount\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.POST_ACCOUNT\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.postAccount\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>{{\'PARTY.ORGANIZATION.SWIFT\' | translate}}\n</label><input ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.swift\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.IBAN\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.iban\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><md-checkbox ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.isLegalUnit\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\">{{\'PARTY.ORGANIZATION.IS_LEGAL_UNIT\' | translate}}</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.isVatRegistered\" ng-change=\"vm.onValueChanged(vm.organizationDto)\">\n{{\'PARTY.ORGANIZATION.IS_VAT_REGISTERED\' | translate}}</md-checkbox></md-input-container></div><div layout=\"column\">\n<md-input-container flex><md-checkbox ng-disabled=\"vm.isDisabled\" ng-model=\"vm.departmentDto.isDeleted\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\">{{\'DEPARTMENTS.DEPARTMENT.IS_DELETED\' | translate}}</md-checkbox>\n</md-input-container></div><div class=\"logos\" layout-padding layout=\"column\" layout-gt-sm=\"row\"><div class=\"logo\" flex>\n<p class=\"md-label\">{{\'DEPARTMENTS.DEPARTMENT.LOGO\' | translate}}</p><img ng-if=\"vm.departmentDto.logoFilepath\" \nbaldris-img-src=\"vm.departmentDto.logoFilepath\" preset=\"logo-landscape\"><br><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"vm.departmentDto.logoFilepath\" class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'logoId\', \'logoFilepath\', vm.departmentDto)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"!vm.departmentDto.logoFilepath\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadImage($file, \'logoId\', \'logoFilepath\', vm.departmentDto)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button></div><div class=\"logo\" flex><p class=\"md-label\">\n{{\'DEPARTMENTS.DEPARTMENT.ALTERNATIVE_LOGO\' | translate}}</p><img ng-if=\"vm.departmentDto.alternativeLogoFilepath\" \nbaldris-img-src=\"vm.departmentDto.alternativeLogoFilepath\" preset=\"logo-portrait\"><br><md-button \nng-disabled=\"vm.isDisabled\" ng-if=\"vm.departmentDto.alternativeLogoFilepath\" class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'alternativeLogoId\', \'alternativeLogoFilepath\', vm.departmentDto)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button><md-button \nng-disabled=\"vm.isDisabled\" ng-if=\"!vm.departmentDto.alternativeLogoFilepath\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadImage($file, \'alternativeLogoId\', \'alternativeLogoFilepath\', vm.departmentDto)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button></div></div><div class=\"profile-images\" layout-padding \nlayout=\"column\" layout-gt-sm=\"row\"><div class=\"profile-image\" flex><p class=\"md-label\">\n{{\'DEPARTMENTS.DEPARTMENT.IMAGE\' | translate}}</p><img ng-if=\"vm.departmentDto.imageFilepath\" \nbaldris-img-src=\"vm.departmentDto.imageFilepath\" preset=\"hd-landscape-cropped\"><br><md-button \nng-disabled=\"vm.isDisabled\" ng-if=\"vm.departmentDto.imageFilepath\" class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'imageId\', \'imageFilepath\', vm.departmentDto)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"!vm.departmentDto.imageFilepath\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadImage($file, \'imageId\', \'imageFilepath\', vm.departmentDto)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button></div></div><div class=\"action-buttons\" layout-padding \nlayout=\"row\"><md-button ng-disabled=\"vm.isDisabled\" ng-click=\"vm.reset(true)\">{{\"COMMON.DATA.RESET\" | translate}}\n</md-button><md-button ng-disabled=\"vm.isDisabled || !editDepartmentComponentForm.$valid\" class=\"md-primary md-raised\" \nng-click=\"vm.submitForm()\">{{\"COMMON.DATA.SAVE\" | translate}}</md-button></div></ng-form></md-content>");
$templateCache.put("app/main/department/components/edit-legal-unit/edit-legal-unit.tmpl.html","<md-content class=\"edit-page\"><ng-form name=\"editLegalUnitComponentForm\" novalidate layout=\"column\" layout-padding><div\n layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>{{\'PARTY.ORGANIZATION.NAME\' | translate}}</label>\n<input name=\"organizationName\" ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.name\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\" required><div \nng-messages=\"editLegalUnitComponentForm.organizationName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">{{\"COMMON.VALIDATION.REQUIRED_FIELD\" |translate}}</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.ORGANIZATION_NUMBER\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.organizationNumber\" ng-change=\"vm.onValueChanged(vm.organizationDto)\">\n</md-input-container><md-input-container flex><label>{{\'PARTY.ORGANIZATION.HOME_PAGE\' | translate}}</label><input \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.homePage\" ng-change=\"vm.onValueChanged(vm.organizationDto)\">\n</md-input-container></div><div layout=\"column\"><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.BANK_CONNECTION\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.bankConnection\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\n{{\'PARTY.ORGANIZATION.BANK_ACCOUNT\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.bankAccount\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container>\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.POST_ACCOUNT\' | translate}}</label><input \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.postAccount\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.SWIFT\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.swift\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container>\n<md-input-container flex><label>{{\'PARTY.ORGANIZATION.IBAN\' | translate}}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.iban\" ng-change=\"vm.onValueChanged(vm.organizationDto)\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-checkbox ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.isLegalUnit\" ng-change=\"vm.onValueChanged(vm.organizationDto)\">\n{{\'PARTY.ORGANIZATION.IS_LEGAL_UNIT\' | translate}}</md-checkbox></md-input-container><md-input-container flex>\n<md-checkbox ng-disabled=\"vm.isDisabled\" ng-model=\"vm.organizationDto.isVatRegistered\" \nng-change=\"vm.onValueChanged(vm.organizationDto)\">{{\'PARTY.ORGANIZATION.IS_VAT_REGISTERED\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\"><md-input-container flex><md-checkbox ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.organizationDto.isDeleted\" ng-change=\"vm.onValueChanged(vm.organizationDto)\">\n{{\'DEPARTMENTS.DEPARTMENT.IS_DELETED\' | translate}}</md-checkbox></md-input-container></div><div class=\"logos\" \nlayout-padding layout=\"column\" layout-gt-sm=\"row\"><div class=\"logo\" flex><p class=\"md-label\">\n{{\'DEPARTMENTS.DEPARTMENT.LOGO\' | translate}}</p><img ng-if=\"vm.legalUnitDto.logoFilepath\" \nbaldris-img-src=\"vm.legalUnitDto.logoFilepath\" preset=\"logo-landscape\"><br><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"vm.legalUnitDto.logoFilepath\" class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'logoId\', \'logoFilepath\', vm.legalUnitDto)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"!vm.legalUnitDto.logoFilepath\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadImage($file, \'logoId\', \'logoFilepath\', vm.legalUnitDto)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button></div></div><div class=\"action-buttons\" layout-padding \nlayout=\"row\"><md-button ng-disabled=\"vm.isDisabled\" ng-click=\"vm.reset(true)\">{{\"COMMON.DATA.RESET\" | translate}}\n</md-button><md-button ng-disabled=\"vm.isDisabled || !editLegalUnitComponentForm.$valid\" class=\"md-primary md-raised\" \nng-click=\"vm.submitForm()\">{{\"COMMON.DATA.SAVE\" | translate}}</md-button></div></ng-form></md-content>");
$templateCache.put("app/main/department/components/legal-unit-select/legal-unit-select.tmpl.html","<md-input-container flex><label>{{vm.labelText}}</label><md-select ng-model=\"vm.legalUnitId\" \nng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"legalUnit in vm.legalUnits | orderBy:\'organizationDisplayName\'\" ng-value=\"legalUnit.id\">\n{{legalUnit.organizationDisplayName}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/external-order/components/external-order-type-select/external-order-type-select.tmpl.html","<md-input-container ng-form=\"vm.externalOrderTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.externalOrderTypeId\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label>\n<md-select name=\"externalOrderType\" ng-model=\"vm.externalOrderTypeId\" ng-required=\"vm.isRequired\" \nng-change=\"vm.onChange()\"><md-option ng-repeat=\"currentExternalOrderType in vm.externalOrderTypes | orderBy:\'name\'\" \nng-value=\"currentExternalOrderType.id\">{{currentExternalOrderType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.externalOrderTypeForm.externalOrderType.$error\" \nng-if=\"vm.externalOrderType.externalOrderType.$touched\"><div ng-message=\"required\"><span \ntranslate=\"EXTERNAL_ORDERS.EXTERNAL_ORDER_TYPE.EXTERNAL_ORDER_TYPE_REQUIRED\"></span></div></div></md-input-container>");
$templateCache.put("app/main/external-order/deceased-shipment/edit-deceased-shipment/edit-deceased-shipment.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-form=\"vm.deceasedShipmentForm\" \nng-if=\"!vm.loadingService.isLoading\" class=\"edit-deceased-shipment-form\"><div layout=\"column\" layout-gt-lg=\"row\" \nlayout-wrap><div flex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment.tmpl.html\'\"></div><div \nflex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment-details.tmpl.html\'\"></div>\n<div flex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment-slips.tmpl.html\'\"></div>\n</div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}\n</md-button><md-button ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/edit-headstone-order.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.headstoneOrderForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-headstone-order-form\">\n<div layout=\"column\" layout-gt-lg=\"row\" layout-wrap><div flex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/headstone-order/edit-headstone-order/views/headstone-order.tmpl.html\'\"></div><div \nflex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/headstone-order/edit-headstone-order/views/inscriptions.tmpl.html\'\"></div><div \nflex flex-gt-lg=\"50\" \nng-include=\"\'app/main/external-order/headstone-order/edit-headstone-order/views/additions.tmpl.html\'\"></div><ms-widget \nlayout=\"column\" class=\"additions-widget\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"EXTERNAL_ORDERS.HEADSTONE_ORDER.ATTACHMENTS\" | translate }}</div></div><md-content \nlayout=\"column\"><work-order-attachment-list attachments=\"vm.data.updateModel.attachments\" \nselected-attachments=\"vm.data.selectedAttachments\" work-order-id=\"vm.data.updateModel.headstoneOrder.workOrderId\" \nexternal-order-id=\"vm.data.updateModel.headstoneOrder.id\"></work-order-attachment-list></md-content></ms-widget-front>\n</ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.headstoneOrderForm.$pristine\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button>\n</div></div>");
$templateCache.put("app/main/flower-order/components/flower-order-card/flower-order-card.tmpl.html","<md-card class=\"flower-order-card\"><md-card-header class=\"clickable\" \nng-click=\"vm.navigateToFlowerOrder(vm.baldrisModel, $event)\"><md-card-avatar><md-icon md-font-icon=\"icon-flower\">\n</md-icon></md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.supplierName}}</span> <span \nclass=\"md-subhead\"><span class=\"icon icon-package\"></span>\n {{vm.baldrisModel.deliveryLocationName}}, {{vm.baldrisModel.deliveryTime | date:\'fullDate\'}} {{vm.baldrisModel.deliveryTime | date:\'shortTime\'}}\n</span></md-card-header-text></md-card-header><md-card-title class=\"clickable\" \nng-click=\"vm.navigateToFlowerOrder(vm.baldrisModel, $event)\"><md-card-title-text><span class=\"md-headline\">\n{{\'FLOWER_ORDERS.FLOWER_ORDER.FLOWER_ORDER\' | translate}}</span></md-card-title-text></md-card-title><md-card-content \nclass=\"clickable\" ng-click=\"vm.navigateToFlowerOrder(vm.baldrisModel, $event)\"><div \nng-if=\"vm.baldrisModel.calendarEventCalendarEventTypeName\"><label class=\"md-caption\">\n{{\'CEREMONIES.CEREMONY.CEREMONY\' | translate}}</label><p>\n{{ vm.baldrisModel.calendarEventType}} {{vm.baldrisModel.calendarEventLocation}}, {{vm.baldrisModel.calendarEventStart | date:\'fullDate\'}} {{vm.baldrisModel.calendarEventStart | date:\'shortTime\'}}\n</p></div><div><label class=\"md-caption\">{{\'FLOWER_ORDERS.FLOWER_ORDER.FLOWER_COUNT\' | translate}}</label><p>\n{{vm.baldrisModel.flowers}}</p></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" \nng-click=\"vm.navigateToFlowerOrder(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteFlowerOrder(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/flower-order/dialogs/edit-flower-dialog/edit-flower-dialog.tmpl.html","<md-dialog ng-form=\"vm.editFlowerForm\" class=\"edit-flower-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'FLOWER_ORDERS.FLOWER.EDIT_FLOWER.ADD_NEW_FLOWER\' : \'FLOWER_ORDERS.FLOWER.EDIT_FLOWER.EDIT_FLOWER\' | translate }}\">\n<md-toolbar layout=\"column\" ng-style=\"vm.eventStyle\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'FLOWER_ORDERS.FLOWER.EDIT_FLOWER.ADD_NEW_FLOWER\' : \'FLOWER_ORDERS.FLOWER.EDIT_FLOWER.EDIT_FLOWER\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content ng-if=\"vm.isLoading\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content><md-content ng-if=\"!vm.isLoading\" \nlayout=\"column\"><product-select on-selected=\"vm.onFlowerProductSelected\" disable-search=\"true\" \nproduct=\"vm.updateModel.flower.product\" product-id=\"vm.updateModel.flower.productId\" \nlabel-text=\"{{\'FLOWER_ORDERS.FLOWER.PRODUCT\' | translate}}\" product-config=\"\'FlowerProductType\'\"></product-select>\n<md-input-container class=\"md-block\" ng-class=\"vm.highlightClass\"><label translate=\"FLOWER_ORDERS.FLOWER.NAME\">Name\n</label><input ng-model=\"vm.updateModel.flower.name\"></md-input-container><md-input-container flex class=\"md-block\">\n<label translate=\"FLOWER_ORDERS.FLOWER.DESCRIPTION\">Description</label><input \nng-model=\"vm.updateModel.flower.description\"></md-input-container><md-input-container flex class=\"md-block\"><label \ntranslate=\"FLOWER_ORDERS.FLOWER.REMARKS\">Remarks</label><input ng-model=\"vm.updateModel.flower.remarks\">\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex flex-gt-sm=\"30\"><label \ntranslate=\"FLOWER_ORDERS.FLOWER.AMOUNT\">Amount</label><input ng-model=\"vm.updateModel.flower.amount\">\n</md-input-container><edit-price-input ng-if=\"vm.updateModel.flower.product\" \nprice-ex-vat=\"vm.updateModel.flower.historicalPrice\" vat-rate=\"vm.updateModel.flower.product.vatRate\" \nis-disabled=\"!vm.updateModel.flower.product\"></edit-price-input></div><md-input-container class=\"md-block\"><label \ntranslate=\"FLOWER_ORDERS.FLOWER.SORT_ORDER\">Sort Order</label><input type=\"number\" step=\"1\" \nng-model=\"vm.updateModel.flower.sortOrder\"></md-input-container><div class=\"ribbons\" layout=\"column\"><md-card \nclass=\"ribbon\" ng-repeat=\"ribbon in vm.updateModel.ribbons | orderBy:\'sortOrder\' | filter:{changeState:\'!3\'}\">\n<md-card-content><h2>Sløyfepar #{{$index + 1}}</h2><lookup-string-select lookup-string=\"ribbon.lookupString\" \non-update=\"vm.onRibbonChanged(ribbon)\" lookup-string-id=\"ribbon.lookupStringId\" \nlabel-text=\"{{\'FLOWER_ORDERS.FLOWER_RIBBON.TEXT\' | translate}}\" custom-value=\"ribbon.text\" allow-custom=\"true\" \nlookup-string-config=\"\'RibbonTextLookupStringType\'\"></lookup-string-select><md-input-container flex class=\"md-block\">\n<label translate=\"FLOWER_ORDERS.FLOWER_RIBBON.NAMES\">Names</label><textarea ng-model=\"ribbon.names\" \nng-change=\"vm.onRibbonChanged(ribbon)\"></textarea></md-input-container><h5 class=\"md-caption\" \nng-if=\"vm.nameSuggestions.length > 0\">Navneforslag</h5><md-chips ng-if=\"vm.nameSuggestions.length > 0\" \nclass=\"custom-chips\" ng-model=\"vm.nameSuggestions\" readonly=\"true\"><md-chip-template class=\"clickable\" \nng-class=\"{ disabled: ribbon.names.indexOf($chip.name) > -1 }\" ng-click=\"vm.addRibbonName($chip, ribbon)\"><span>\n<strong>{{$chip.name}}</strong> <em>({{$chip.relation}})</em></span></md-chip-template></md-chips><div \nclass=\"margin-top-60\"><md-input-container class=\"md-block\"><label translate=\"FLOWER_ORDERS.FLOWER_RIBBON.SORT_ORDER\">\nSort Order</label><input type=\"number\" step=\"1\" ng-model=\"ribbon.sortOrder\"></md-input-container></div>\n</md-card-content><md-card-actions><md-card-icon-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-warn\" aria-label=\"icon\" ng-click=\"vm.deleteRibbon(ribbon)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></md-card-icon-actions></md-card-actions></md-card><md-button \naria-label=\"{ \'FLOWER_ORDERS.FLOWER_RIBBON.EDIT_RIBBON.ADD_RIBBON\' | translate }}\" class=\"md-block\" \nng-click=\"vm.addRibbon()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{ \'FLOWER_ORDERS.FLOWER_RIBBON.EDIT_RIBBON.ADD_RIBBON\' | translate }}</md-button></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"!vm.updateModel.product.internalId\" \naria-label=\"Delete\" class=\"md-warn\" ng-click=\"vm.deleteFlower()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'FLOWER_ORDERS.FLOWER.EDIT_FLOWER.DELETE_FLOWER\' | translate }}</md-button><span flex></span><md-button \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editProductForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/flower-order/edit-flower-order/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"FLOWER_ORDERS.FLOWER_ORDER.EDIT_FLOWER_ORDER.EDIT_FLOWER_ORDER\"></span><span \nng-if=\"vm.data.validation.flowerOrderForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" ng-disabled=\"vm.data.validation.flowerOrderForm.$pristine\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/grave/components/grave-card/grave-card.tmpl.html","<md-card class=\"grave-card\"><md-card-header ng-click=\"vm.navigateToGrave(vm.baldrisModel, $event)\" class=\"clickable\">\n<md-card-avatar><md-icon md-font-icon=\"icon-view-quilt\"></md-icon></md-card-avatar><md-card-header-text><span \nclass=\"md-title\">{{vm.baldrisModel.graveTypeName }}<span ng-if=\"!vm.baldrisModel.graveTypeName\">\n{{ \'GRAVES.GRAVE.GRAVE\' | translate }}</span></span> <span class=\"md-subhead\">{{vm.baldrisModel.cemeteryName}}</span>\n</md-card-header-text></md-card-header><img ng-if=\"vm.baldrisModel.cemeteryImageUrl\" \nbaldris-img-src=\"vm.baldrisModel.cemeteryImageUrl\" preset=\"medium-landscape-cropped\" class=\"md-card-image clickable\" \nng-click=\"vm.navigateToGrave(vm.baldrisModel, $event)\"><md-card-content \nng-click=\"vm.navigateToGrave(vm.baldrisModel, $event)\" class=\"clickable\"><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.leaseHolderName\"><label class=\"md-caption\">{{\'GRAVES.GRAVE.LEASE_HOLDER\' | translate}}</label>\n<p>{{vm.baldrisModel.leaseHolderName | translate}}</p></div><div flex ng-if=\"vm.baldrisModel.temporaryMarkerType\">\n<label class=\"md-caption\">{{\'GRAVES.GRAVE.TEMPORARY_MARKER\' | translate}}</label><p>\n{{vm.baldrisModel.temporaryMarkerType}}</p></div></div><div \nng-if=\"vm.baldrisModel.temporaryMarkerPlaqueName || vm.baldrisModel.deceasedFullNames\"><label class=\"md-caption\">\n{{\'GRAVES.GRAVE.TEMPORARY_MARKER_NAME\' | translate}}</label><p>\n{{vm.baldrisModel.temporaryMarkerPlaqueName || vm.baldrisModel.deceasedFullNames}}<md-button class=\"md-icon-button\" \nng-click=\"vm.copyToClipboard($event)\"><md-tooltip md-direction=\"top\">{{\'COMMON.DATA.COPY_TO_CLIPBOARD\' | translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button></p></div><div \nng-if=\"vm.baldrisModel.deceased && vm.baldrisModel.deceased.length > 0\"><label class=\"md-caption\">\n{{\'GRAVES.GRAVE.DECEASEDS\' | translate}}</label><p><span ng-repeat=\"deceased in vm.baldrisModel.deceased\">\n{{deceased.name}}<span ng-if=\"!$last\"> //</span></span></p></div><div ng-if=\"vm.baldrisModel.remarks\"><label \nclass=\"md-caption\">{{\'GRAVES.GRAVE.REMARKS\' | translate}}</label><p>{{vm.baldrisModel.remarks}}</p></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit\" ng-click=\"vm.navigateToGrave(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-tooltip-edit\">\n</md-icon></md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteGrave(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/grave/components/grave-type-select/grave-type-select.tmpl.html","<md-input-container ng-form=\"vm.graveTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.graveType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"graveType\" ng-model=\"vm.graveTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentGraveType in vm.graveTypes | orderBy:\'name\'\" ng-value=\"currentGraveType.id\">{{currentGraveType.name}}\n</md-option></md-select><div class=\"errors\" ng-messages=\"vm.graveTypeForm.graveType.$error\" \nng-if=\"vm.graveTypeForm.graveType.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"GRAVES.EDIT_GRAVE.GRAVE_TYPE_REQUIRED\"></span></div></div></md-input-container>");
$templateCache.put("app/main/grave/edit-grave/views/grave-general.tmpl.html","<div layout-padding layout=\"column\"><location-select location=\"vm.data.updateModel.grave.cemetery\" \nlocation-id=\"vm.data.updateModel.grave.cemeteryId\" location-config=\"\'CemeteryLocationType\'\" \nlabel-text=\"{{\'GRAVES.GRAVE.CEMETERY\' | translate}}\"></location-select><grave-type-select \nlabel-text=\"{{\'GRAVES.GRAVE.GRAVE_TYPE\' | translate}}\" grave-type-id=\"vm.data.updateModel.grave.graveTypeId\" \ngrave-type=\"vm.data.updateModel.grave.graveType\"></grave-type-select><div><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.data.updateModel.grave.isAnonymousGrave\" \naria-label=\"{{\'GRAVES.GRAVE.IS_ANONYMOUS_GRAVE\' | translate}}\">{{\'GRAVES.GRAVE.IS_ANONYMOUS_GRAVE\' | translate}}\n</md-checkbox></md-input-container></div><div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.data.updateModel.grave.graveShouldBeOnNewField\" \naria-label=\"{{\'GRAVES.GRAVE.GRAVE_SHOULD_BE_ON_NEW_FIELD\' | translate}}\">\n{{\'GRAVES.GRAVE.GRAVE_SHOULD_BE_ON_NEW_FIELD\' | translate}}</md-checkbox></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{\'GRAVES.GRAVE.GRAVE_NUMBER\' | translate}}</label><input \nng-model=\"vm.data.updateModel.grave.graveNumber\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'GRAVES.GRAVE.GRAVE_LEASE_NUMBER\' | translate}}</label><input \nng-model=\"vm.data.updateModel.grave.graveLeaseNumber\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRAVES.GRAVE.REMARKS\' | translate}}</label><textarea \nng-model=\"vm.data.updateModel.grave.remarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/grave/edit-grave/views/grave-lease-holder.tmpl.html","<div layout-padding layout=\"column\"><div \nng-if=\"vm.data.updateModel.grave.leaseHolderId || vm.data.updateModel.leaseHolder\" layout=\"column\" \nclass=\"lease-holder\"><div layout=\"row\"><img class=\"lease-holder-image\" \nng-if=\"vm.data.updateModel.grave.leaseHolderImageUrl\" baldris-img-src=\"vm.data.updateModel.grave.leaseHolderImageUrl\" \npreset=\"square-40-cropped\"> <img class=\"lease-holder-image\" ng-if=\"!vm.data.updateModel.grave.leaseHolderImageUrl\" \ngravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"><div layout=\"column\"><div class=\"lease-holder-name\">\n{{vm.data.updateModel.grave.leaseHolderDisplayName || vm.data.updateModel.leaseHolder.displayName | translate}}</div>\n<div class=\"lease-holder-ssn\"><span ng-if=\"vm.data.updateModel.leaseHolder.primaryAddress\">\n{{vm.data.updateModel.leaseHolder.primaryAddress}} // </span><span \nng-if=\"vm.data.updateModel.leaseHolder.primaryEmail\">{{vm.data.updateModel.leaseHolder.primaryEmail}} // </span><span \nng-if=\"vm.data.updateModel.leaseHolder.primaryTelephone\">{{vm.data.updateModel.leaseHolder.primaryTelephone}}</span>\n</div></div></div><div layout=\"row\" class=\"action-buttons\"><md-button class=\"md-warn\" \nng-click=\"vm.data.removeLeaseHolder()\" aria-label=\"Remove Lease Holder\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.REMOVE_LEASE_HOLDER\">\n{{ \'GRAVES.EDIT_GRAVE.REMOVE_LEASE_HOLDER\' | translate}}</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.data.openChooseLeaseHolderDialog($event)\" aria-label=\"Choose New Lease Holder\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CHOOSE_NEW_LEASE_HOLDER\">\n{{ \'GRAVES.EDIT_GRAVE.CHOOSE_NEW_LEASE_HOLDER\' | translate}}</md-button></div></div><div \nng-if=\"!vm.data.updateModel.grave.leaseHolderId && !vm.data.updateModel.leaseHolder\" class=\"no-lease-holder\"><p \nclass=\"md-warn-bg md-hue-1 border brad-5\">{{\'GRAVES.EDIT_GRAVE.NO_LEASE_HOLDER\' | translate}}</p><div layout=\"row\" \nclass=\"action-buttons\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.data.openChooseLeaseHolderDialog($event)\" \naria-label=\"Choose Lease Holder\" translate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CHOOSE_LEASE_HOLDER\">\n{{ \'GRAVES.EDIT_GRAVE.CHOOSE_LEASE_HOLDER\' | translate}}</md-button></div></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRAVES.GRAVE.LEASE_HOLDER_REMARKS\' | translate}}</label><input \nng-model=\"vm.data.updateModel.grave.leaseHolderRemarks\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.data.updateModel.grave.leaseHolderHasOtherLeases\" \naria-label=\"{{\'GRAVES.GRAVE.IS_ANONYMOUS_GRAVE\' | translate}}\">\n{{\'GRAVES.GRAVE.LEASE_HOLDER_HAS_OTHER_LEASES\' | translate}}</md-checkbox></md-input-container></div><div>\n<md-input-container class=\"md-block\" ng-if=\"vm.data.updateModel.grave.leaseHolderHasOtherLeases\"><label>\n{{\'GRAVES.GRAVE.LEASE_HOLDER_OTHER_LEASES_REMARKS\' | translate}}</label><textarea \nng-model=\"vm.data.updateModel.grave.leaseHolderOtherLeasesRemarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/grave/edit-grave/views/grave-previously-buried.tmpl.html","<div layout-padding layout=\"column\"><div \nng-if=\"vm.data.updateModel.grave.previouslyBuriedId || vm.data.updateModel.previouslyBuried\" layout=\"column\" \nclass=\"previously-buried\"><div layout=\"row\"><img class=\"previously-buried-image\" \nng-if=\"vm.data.updateModel.grave.previouslyBuriedImageFilepath\" \nbaldris-img-src=\"vm.data.updateModel.grave.previouslyBuriedImageFilepath\" preset=\"square-40-cropped\"> <img \nclass=\"previously-buried-image\" ng-if=\"!vm.data.updateModel.grave.previouslyBuriedImageFilepath\" \ngravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"><div layout=\"column\"><div class=\"previously-buried-name\">\n{{vm.data.updateModel.grave.previouslyBuriedDisplayName || vm.data.updateModel.previouslyBuried.displayName | translate}}\n</div><div class=\"previously-buried-ssn\">\n{{vm.data.updateModel.grave.previouslyBuriedDateOfBirth || vm.data.updateModel.previouslyBuried.dateOfBirth | date:\'shortDate\'}} {{vm.data.updateModel.grave.previouslyBuried.socialSecurityNumber || vm.data.updateModel.previouslyBuried.socialSecurityNumber}}\n</div></div></div><div layout=\"row\" class=\"action-buttons\"><md-button class=\"md-warn\" \nng-click=\"vm.data.removePreviouslyBuried()\" aria-label=\"Remove Previously Buried\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.REMOVE_PREVIOUSLY_BURIED\">\n{{ \'GRAVES.EDIT_GRAVE.REMOVE_PREVIOUSLY_BURIED\' | translate}}</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.data.openChoosePreviouslyBuriedDialog($event)\" aria-label=\"Choose New Previously Buried\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CHOOSE_NEW_PREVIOUSLY_BURIED\">\n{{ \'GRAVES.EDIT_GRAVE.CHOOSE_NEW_PREVIOUSLY_BURIED\' | translate}}</md-button></div></div><div \nng-if=\"!vm.data.updateModel.grave.previouslyBuriedId && !vm.data.updateModel.previouslyBuried\" \nclass=\"no-previously-buried\"><p class=\"md-warn-bg md-hue-1 border brad-5\">\n{{\'GRAVES.EDIT_GRAVE.NO_PREVIOUSLY_BURIED\' | translate}}</p><div layout=\"row\" class=\"action-buttons\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.data.openChoosePreviouslyBuriedDialog($event)\" \naria-label=\"Choose Previously Buried\" translate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CHOOSE_PREVIOUSLY_BURIED\">\n{{ \'GRAVES.EDIT_GRAVE.CHOOSE_PREVIOUSLY_BURIED\' | translate}}</md-button></div></div></div>");
$templateCache.put("app/main/grave/edit-grave/views/grave-temporary-marker.tmpl.html","<div layout-padding layout=\"column\"><lookup-string-select lookup-string=\"vm.data.updateModel.grave.temporaryMarker\" \nlookup-string-id=\"vm.data.updateModel.grave.temporaryMarkerId\" \nlookup-string-config=\"\'TemporaryMarkerLookupStringType\'\" min-query-length=\"0\" \nlabel-text=\"{{\'GRAVES.GRAVE.TEMPORARY_MARKER\' | translate}}\"></lookup-string-select><div><md-checkbox \nng-checked=\"vm.data.updateModel.grave.temporaryMarkerPlaqueName || vm.showAlternativeName\" \nng-click=\"vm.showAlternativeName = true\">{{\'GRAVES.GRAVE.USE_ALTERNATIVE_TEMPORARY_MARKER_NAME\' | translate}}\n</md-checkbox></div><div ng-if=\"vm.data.updateModel.grave.temporaryMarkerPlaqueName || vm.showAlternativeName\">\n<md-input-container class=\"md-block\"><label>{{\'GRAVES.GRAVE.TEMPORARY_MARKER_NAME\' | translate}}</label><input \nng-model=\"vm.data.updateModel.grave.temporaryMarkerPlaqueName\"></md-input-container></div><div><lookup-string-select \nlookup-string=\"vm.data.temporaryMarkerRemarks\" lookup-string-id=\"vm.data.temporaryMarkerRemarksId\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.grave.temporaryMarkerRemarks\" \nlookup-string-config=\"\'TemporaryMarkerRemarksLookupStringType\'\" min-query-length=\"0\" \nlabel-text=\"{{\'GRAVES.GRAVE.TEMPORARY_MARKER_REMARKS\' | translate}}\"></lookup-string-select></div></div>");
$templateCache.put("app/main/grave/edit-grave/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"GRAVES.EDIT_GRAVE.EDITING_TEXT\" \ntranslate-values=\"{ graveString: vm.data.getGraveString() }\"></span> <span ng-if=\"vm.data.validation.graveForm.$dirty\">\n*</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"GRAVES.EDIT_GRAVE.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"GRAVES.EDIT_GRAVE.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/grooming/components/grooming-card/grooming-card.tmpl.html","<md-card class=\"grooming-card\"><md-card-header class=\"clickable\" ng-click=\"vm.navigateToGrooming($event)\">\n<md-card-avatar><md-icon ng-if=\"vm.baldrisModel.calendarEventTypeIconName\" \nmd-font-icon=\"{{vm.baldrisModel.calendarEventTypeIconName}}\" \nng-style=\"{ \'background-color\': vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\', \'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.calendarEventTypeIconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.calendarEventTypeName}}</span> <span \nclass=\"md-subhead\"><span class=\"icon icon-calendar\"></span> {{vm.baldrisModel.start | date:\'fullDate\'}} <span \nclass=\"icon icon-clock\"></span> {{vm.baldrisModel.start | date:\'shortTime\'}} <span ng-if=\"!vm.baldrisModel.start\">\n{{\'CEREMONIES.CEREMONY_CARD.STARTTIME_UNSET\' | translate}}</span></span></md-card-header-text></md-card-header>\n<md-card-title class=\"clickable\" ng-click=\"vm.navigateToGrooming($event)\"><md-card-title-text><span \nclass=\"md-headline\" ng-bind-html=\"vm.baldrisModel.deceasedSerialized | serializedList\"></span></md-card-title-text>\n</md-card-title><md-card-content class=\"clickable\" ng-click=\"vm.navigateToGrooming($event)\"><div flex \nng-if=\"vm.baldrisModel.locationSerialized || vm.baldrisModel.locationName\"><label class=\"md-caption\">\n{{\'GROOMINGS.GROOMING.GROOMING_LOCATION\' | translate}}</label><p>\n{{vm.baldrisModel.locationSerialized || vm.baldrisModel.locationName}}</p></div><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.originSerialized || vm.baldrisModel.originName\"><label class=\"md-caption\">\n{{\'GROOMINGS.GROOMING.ORIGIN\' | translate}}</label><p>\n{{vm.baldrisModel.originSerialized || vm.baldrisModel.originName}}</p></div><div flex \nng-if=\"vm.baldrisModel.destinationSerialized || vm.baldrisModel.destinationName\"><label class=\"md-caption\">\n{{\'GROOMINGS.GROOMING.DESTINATION\' | translate}}</label><p>\n{{vm.baldrisModel.destinationSerialized || vm.baldrisModel.destinationName}}</p></div></div><div flex \nng-if=\"vm.baldrisModel.deceased.casketName\"><label class=\"md-caption\">{{\'DECEASED.DECEASED.CASKET\' | translate}}\n</label><p>{{vm.baldrisModel.deceased.casketName}}</p></div><div ng-if=\"vm.baldrisModel.attendeesSerialized\"><label \nclass=\"md-caption\">{{\'TRANSPORTS.TRANSPORT_CARD.ASSISTANTS\' | translate}}</label><p \nng-bind-html=\"vm.baldrisModel.attendeesSerialized | serializedList\"></p></div><div ng-if=\"vm.baldrisModel.isCompleted\">\n<label class=\"md-caption\">{{\'TRANSPORTS.TRANSPORT.COMPLETED_BY\' | translate}}</label><p>\n{{vm.baldrisModel.completedByDisplayName}}, {{vm.baldrisModel.completedTime | date:\'short\'}}</p></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit\" ng-click=\"vm.navigateToGrooming()\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" ng-click=\"vm.deleteGrooming()\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon></md-button></md-card-actions></md-card>");
$templateCache.put("app/main/grooming/components/grooming-type-select/grooming-type-select.tmpl.html","<md-input-container ng-form=\"vm.groomingTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.groomingType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"groomingType\" ng-model=\"vm.groomingTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentGroomingType in vm.groomingTypes | orderBy:\'name\'\" ng-value=\"currentGroomingType.id\">\n{{currentGroomingType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.groomingTypeForm.groomingType.$error\" ng-if=\"vm.groomingTypeForm.groomingType.$dirty\"><div \nng-message=\"required\"><span translate=\"GROOMINGS.EDIT_GROOMING.GROOMING_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/grooming/edit-grooming/views/grooming-calendar-event.tmpl.html","<div layout-padding layout=\"column\"><location-select class=\"margin-bottom-20\" \nlocation=\"vm.data.updateModel.calendarEvent.location\" location-id=\"vm.data.updateModel.calendarEvent.locationId\" \nlabel-text=\"{{ \'GROOMINGS.GROOMING.GROOMING_LOCATION\' | translate }}\"></location-select><div><md-input-container \nclass=\"md-block\"><label>{{ \"GROOMINGS.GROOMING.GROOMING_LOCATION_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.locationRemarks\"></md-input-container></div><date-time-range-select \nstart-time=\"vm.data.updateModel.calendarEvent.start\" end-time=\"vm.data.updateModel.calendarEvent.end\">\n</date-time-range-select><calendar-event-users class=\"margin-bottom\" \nevent-users=\"vm.data.updateModel.calendarEventUsers\"></calendar-event-users></div>");
$templateCache.put("app/main/grooming/edit-grooming/views/grooming-general.tmpl.html","<div layout-padding layout=\"column\"><casket-select class=\"margin-bottom-20\" \nlabel-text=\"{{\'DECEASED.DECEASED.CASKET\' | translate}}\" ng-if=\"vm.data.updateModel.deceased.length === 1\" \ncasket-id=\"vm.data.updateModel.deceased[0].casketId\" casket=\"vm.data.updateModel.deceased[0].casket\"></casket-select>\n<lookup-string-select class=\"margin-bottom-20\" min-query-length=\"0\" \nlookup-string-id=\"vm.data.updateModel.calendarEvent.casketEquipmentId\" \nlookup-string=\"vm.data.updateModel.calendarEvent.casketEquipment\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.calendarEvent.casketEquipmentSerialized\" \nlabel-text=\"{{\'GROOMINGS.GROOMING.CASKET_EQUIPMENT\' | translate}}\" \nlookup-string-config=\"\'CasketEquipmentLookupStringType\'\"></lookup-string-select><lookup-string-select \nclass=\"margin-bottom-20\" min-query-length=\"0\" lookup-string-id=\"vm.data.updateModel.calendarEvent.clothingId\" \nlookup-string=\"vm.data.updateModel.calendarEvent.clothing\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.calendarEvent.clothingSerialized\" \nlabel-text=\"{{\'GROOMINGS.GROOMING.CLOTHING\' | translate}}\" lookup-string-config=\"\'ClothingLookupStringType\'\">\n</lookup-string-select><div><md-input-container class=\"md-block\"><label>\n{{ \'GROOMINGS.GROOMING.PERSONAL_CLOTHING\' | translate}}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.personalClothing\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \'GROOMINGS.GROOMING.PERSONAL_BELONGINGS\' | translate}}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.personalBelongings\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \'GROOMINGS.GROOMING.NOTE_ON_PHYSICIAN\' | translate}}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.noteOnPhysician\"></md-input-container></div><div><md-input-container>\n<label>{{\'GROOMINGS.GROOMING.GROOMING_DESCRIPTION\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.calendarEvent.groomingDescription\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/grooming/edit-grooming/views/grooming-transport.tmpl.html","<div layout-padding layout=\"column\"><div layout=\"row\" layout-gt-sm=\"row\"><div layout=\"column\" flex-gt-sm=\"50\">\n<location-select class=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.origin\" \nlocation-id=\"vm.data.updateModel.calendarEvent.originId\" label-text=\"{{\'TRANSPORTS.TRANSPORT.ORIGIN\' | translate}}\">\n</location-select><div><md-input-container flex class=\"md-block\"><label>\n{{\'TRANSPORTS.TRANSPORT.ORIGIN_REMARKS\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.originRemarks\"></md-input-container></div></div><div layout=\"column\" \nflex-gt-sm=\"50\"><location-select class=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.destination\" \nlocation-id=\"vm.data.updateModel.calendarEvent.destinationId\" \nlabel-text=\"{{\'TRANSPORTS.TRANSPORT.DESTINATION\' | translate}}\"></location-select><div><md-input-container flex \nclass=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.DESTINATION_REMARKS\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.destinationRemarks\"></md-input-container></div></div></div>\n<lookup-string-select class=\"margin-bottom-20\" min-query-length=\"0\" \nlookup-string-id=\"vm.data.updateModel.calendarEvent.transportById\" \nlookup-string=\"vm.data.updateModel.calendarEvent.transportBy\" \nlabel-text=\"{{\'TRANSPORTS.TRANSPORT.TRANSPORT_BY\' | translate}}\" lookup-string-config=\"\'TransportByLookupStringType\'\">\n</lookup-string-select><div layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>\n{{\'TRANSPORTS.TRANSPORT.DISTANCE\' | translate }}</label><input ng-model=\"vm.data.updateModel.calendarEvent.distance\" \ntype=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div flex=\"50\"><md-input-container class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.DRIVER_HOURS\' | translate }}</label>\n<input ng-model=\"vm.data.updateModel.calendarEvent.driverHours\" type=\"number\" step=\"0.1\" \nng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n</div><div layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>\n{{\'TRANSPORTS.TRANSPORT.ADDITIONAL_HOURS\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.additionalHours\" type=\"number\" step=\"0.1\" \nng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div flex=\"50\"><md-input-container class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.ADDITIONAL_COST\' | translate }}\n</label><input ng-model=\"vm.data.updateModel.calendarEvent.additionalCost\" ng-currency \nng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n</div><div><md-input-container class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.PRICE\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.price\" ng-currency ng-change=\"vm.data.registerPrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div><md-input-container class=\"md-block\"><label>{{ \'TRANSPORTS.TRANSPORT.PRICE_REMARKS\' | translate}}</label><textarea\n ng-model=\"vm.data.updateModel.calendarEvent.priceRemarks\"></textarea></md-input-container></div><div><bill-to-select \nbill-to=\"vm.data.updateModel.calendarEvent.billTo\" label-text=\"{{ \'TRANSPORTS.TRANSPORT.BILL_TO\' | translate}}\">\n</bill-to-select></div><div><md-input-container class=\"md-block\"><label>\n{{ \'TRANSPORTS.TRANSPORT.TRANSPORT_DESCRIPTION\' | translate}}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.transportDescription\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.REMARKS\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.calendarEvent.remarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/grooming/edit-grooming/views/sidebar.tmpl.html","<div ng-include=\"\'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html\'\"></div>");
$templateCache.put("app/main/grooming/edit-grooming/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"GROOMINGS.EDIT_GROOMING.EDITING_TEXT\" \ntranslate-values=\"{ groomingString: vm.data.getCalendarEventString() }\"></span> <span \nng-if=\"vm.data.validation.calendarEventForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"GROOMINGS.EDIT_GROOMING.SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"GROOMINGS.EDIT_GROOMING.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task-list.tmpl.html","<div class=\"note-or-task-list-container\" layout=\"column\" layout-align=\"start stretch\" ng-cloak><md-fab-speed-dial \nng-if=\"!vm.hideAddButton\" md-direction=\"left\" md-open=\"vm.isOpen\" class=\"md-scale\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-accent\"><md-tooltip md-direction=\"bottom\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE_OR_TASK\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add Note\" \nclass=\"md-fab md-raised md-mini\" ng-click=\"vm.addNote($event)\"><md-tooltip md-direction=\"bottom\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-note\" \naria-label=\"Note\"></md-icon></md-button><md-button aria-label=\"Add Task\" class=\"md-fab md-raised md-mini\" \nng-click=\"vm.addTask($event)\"><md-tooltip md-direction=\"bottom\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_TASK\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-checkbox-marked\" \naria-label=\"Task\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial><md-list \nng-if=\"vm.noteOrTaskGroups && vm.noteOrTaskGroups.length > 0\" class=\"note-or-task-list\" flex><div \nng-repeat=\"noteOrTaskGroup in vm.noteOrTaskGroups | orderBy:\'sortOrder\'\"><md-subheader class=\"md-primary md-no-sticky\" \nng-if=\"noteOrTaskGroup.noteOrTasks.length > 0 || noteOrTaskGroup.dateGroups.length > 0\" \nng-class=\"{ \'completed\': noteOrTaskGroup.isCompletedGroup, \'uncompleted\': noteOrTaskGroup.isUncompletedGroup, \'note\': noteOrTaskGroup.isNoteGroup, \'follow-up\': noteOrTaskGroup.isFollowUpGroup }\">\n<span>{{noteOrTaskGroup.title | translate}}</span></md-subheader><div ng-if=\"!vm.createDateGroups\" \nng-repeat=\"noteOrTask in noteOrTaskGroup.noteOrTasks | orderBy:\'startTime\'\"><note-or-task baldris-model=\"noteOrTask\" \nshow-work-order-info=\"vm.showWorkOrderInfo\"></note-or-task><md-divider ng-if=\"!$last\"></md-divider></div><div \nng-if=\"vm.createDateGroups && noteOrTaskGroup.dateGroups && noteOrTaskGroup.dateGroups.length > 0\" flex><div \nng-repeat=\"dateGroup in noteOrTaskGroup.dateGroups | orderBy:\'start\'\" layout=\"column\" layout-gt-sm=\"row\" \nclass=\"date-list\"><div ng-if=\"dateGroup.start\" layout=\"column\" class=\"date-group-calendar-header clickable\" \nui-sref=\"app.calendar.day-view({ date: vm.getIsoDate(dateGroup.start)})\"><span class=\"day md-primary-bg\">\n{{dateGroup.start | date:\'EEEE\'}}</span><h3 class=\"date\">{{dateGroup.start | date:\'d\'}}</h3><h4 class=\"month\">\n{{dateGroup.start | date:\'MMMM\'}}</h4><h4 class=\"year\">{{dateGroup.start | date:\'yyyy\'}}</h4></div><div \nng-if=\"!dateGroup.start\" layout=\"column\" class=\"date-group-calendar-header\"><span class=\"day md-primary-bg\">\n{{\'CALENDAR.EVENT.UNKNOWN\' | translate}}</span><h3 class=\"date\">00</h3><h4 class=\"month\">\n{{\'CALENDAR.EVENT.UNKNOWN_TIME\' | translate}}</h4></div><div flex layout=\"column\" class=\"note-or-tasks\"><div \nng-if=\"dateGroup.noteOrTasks && dateGroup.noteOrTasks.length > 0\" class=\"note-or-task-list\" \nng-repeat=\"noteOrTask in dateGroup.noteOrTasks | orderBy:[\'startTime\', \'dueTime\']\"><note-or-task \nbaldris-model=\"noteOrTask\" show-work-order-info=\"vm.showWorkOrderInfo\"></note-or-task><md-divider ng-if=\"!$last\">\n</md-divider></div></div></div></div></div></md-list></div>");
$templateCache.put("app/main/note-or-task/components/note-or-task-type-select/note-or-task-type-select.tmpl.html","<md-input-container><label>{{ (vm.labelText || \'NOTE_OR_TASKS.NOTE_OR_TASK_TYPES.NOTE_OR_TASK_TYPE\') | translate}}\n</label><md-select ng-model=\"vm.noteOrTaskTypeId\" ng-change=\"vm.onChange()\" md-on-close=\"vm.clearSearchTerm()\" \nmd-container-class=\"baldrisSelectNoteOrTaskType\"><md-select-header class=\"baldris-select-note-or-task-type-header\">\n<input ng-model=\"searchTerm\" aria-label=\"{{ \'COMMON.DIALOG.SEARCH\' | translate }}\" type=\"search\" \nplaceholder=\"{{ \'COMMON.DIALOG.SEARCH\' | translate }}\" \nclass=\"baldris-select-note-or-task-type-header-searchbox md-text\"></md-select-header><md-optgroup label=\"vegetables\">\n<md-option ng-value=\"noteOrTaskType.id\" ng-repeat=\"noteOrTaskType in vm.noteOrTaskTypes | filter:searchTerm\">\n{{noteOrTaskType.name}}</md-option></md-optgroup></md-select></md-input-container>");
$templateCache.put("app/main/note-or-task/components/note-or-task-user-multi-select/note-or-task-user-multi-select.tmpl.html","<div class=\"baldris-note-or-task-user-container\" layout=\"column\"><label class=\"md-caption\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK.RECIPIENTS\' | translate}}</label><md-chips \nclass=\"md-contact-chips baldris-note-or-task-user-select\" ng-model=\"vm.selectedUsers\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"true\" md-on-add=\"vm.onAddUser($chip)\" \nmd-on-remove=\"vm.onRemoveUser($chip)\" md-on-select=\"vm.onSelectUser($chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedUser\" md-search-text=\"vm.searchTextUser\" \nmd-items=\"item in vm.userSearch(vm.searchTextUser)\" md-item-text=\"item.displayName\" md-min-length=\"0\" \nplaceholder=\"{{\'NOTE_OR_TASKS.USER_MULTI_SELECT.SELECT_USERS\' | translate}}\" \nmd-menu-class=\"md-contact-chips-suggestions\"><div class=\"md-contact-suggestion\"><img baldris-img-src=\"item.image\" \npreset=\"square-40-cropped\" alt=\"{{item.displayName}}\" ng-if=\"item.image\"> <span class=\"md-contact-name\" \nmd-highlight-text=\"vm.searchTextUser\">{{item.displayName}} </span><span class=\"md-contact-email\">{{item.email}}</span>\n</div></md-autocomplete><md-chip-template \nng-class=\"{ completed: vm.hasComplete && $chip.hasCompletedTask, uncompleted: vm.hasComplete && !$chip.hasCompletedTask }\">\n<div class=\"md-contact-avatar\"><img baldris-img-src=\"$chip.image\" preset=\"square-40-cropped\" \nalt=\"{{$chip.displayName}}\" ng-if=\"$chip.image\"></div><div class=\"md-contact-name ng-binding\">{{$chip.user}}</div>\n<md-icon ng-if=\"$chip.remarks\" md-font-icon=\"icon-note-text\"></md-icon><md-icon \nng-if=\"vm.hasComplete && $chip.hasCompletedTask\" md-font-icon=\"icon-checkbox-marked-circle\"></md-icon><md-icon \nng-if=\"vm.hasComplete && !$chip.hasCompletedTask\" md-font-icon=\"icon-checkbox-blank-circle\"></md-icon>\n</md-chip-template></md-chips><div class=\"hint\" \nng-if=\"vm.hasComplete && vm.selectedUsers && vm.selectedUsers.length > 0\">\n{{ \'NOTE_OR_TASKS.USER_MULTI_SELECT.HINT_TEXT\' | translate}}</div><md-card ng-if=\"vm.hasComplete && vm.currentUser\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">\n{{ \'NOTE_OR_TASKS.USER_MULTI_SELECT.DETAIL_TITLE\' | translate}}</span> <span class=\"md-subhead\" \ntranslate=\"NOTE_OR_TASKS.USER_MULTI_SELECT.DETAIL_SUBTITLE\" \ntranslate-values=\"{ userDisplayName: vm.currentUser.user }\"></span></md-card-title-text><md-card-title-media><div \nclass=\"md-media-sm card-media\"><img ng-if=\"vm.currentUser.userImageUrl\" baldris-img-src=\"vm.currentUser.userImageUrl\" \npreset=\"square-100-cropped\" alt=\"{{vm.currentUser.user}}\"> <img gravatar-size=\"100\" \ngravatar-src=\"vm.currentUser.userEmail || vm.currentUser.user\" alt=\"{{vm.currentUser.user}}\" \nng-if=\"!vm.currentUser.userImageUrl\"></div></md-card-title-media></md-card-title><md-card-content><md-checkbox \nng-checked=\"vm.currentUser.hasCompletedTask\" ng-click=\"vm.toggleCompleted(vm.currentUser)\" \naria-label=\"{{ \'NOTE_OR_TASKS.NOTE_OR_TASK_USER.HAS_COMPLETED_TASK\' | translate }}\">\n{{ \'NOTE_OR_TASKS.NOTE_OR_TASK_USER.HAS_COMPLETED_TASK\' | translate }}</md-checkbox><p \nng-if=\"vm.currentUser.hasCompletedTask\">\n{{ \'NOTE_OR_TASKS.NOTE_OR_TASK_USER.COMPLETED_TASK_DATE\' | translate }} {{ vm.currentUser.completedTaskDate | date:\'short\' }}\n</p><md-input-container class=\"md-block\" flex-gt-sm><label>{{ \'NOTE_OR_TASKS.NOTE_OR_TASK_USER.REMARKS\' | translate}}\n</label><input ng-model=\"vm.currentUser.remarks\"></md-input-container></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.currentUser = null\">{{ \'COMMON.DIALOG.OK\' | translate}}</md-button>\n</md-card-actions></md-card></div>");
$templateCache.put("app/main/note-or-task/components/notes-and-tasks-summary/notes-and-tasks-summary.tmpl.html","<div class=\"notes-and-tasks-summary\" layout=\"column\" \nng-class=\"{ \'no-tasks\': vm.completedCount + vm.uncompletedCount == 0 }\"><div layout=\"row\" flex=\"none\" \nclass=\"notes-and-tasks\"><div class=\"completed\" flex><span class=\"icon icon-checkbox-marked-circle\"></span>\n {{vm.completedCount}}</div><div class=\"uncompleted\" flex><span class=\"icon icon-checkbox-blank-circle\"></span>\n {{vm.uncompletedCount}}</div><div class=\"notes\" flex><span class=\"icon icon-note-text\"></span> {{vm.notesCount}}</div>\n</div><div class=\"progress-bar\" md-theme=\"trafficLight\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.getProgressValue()}}\" \nng-class=\"{\n                    \'md-primary\': vm.getProgressValue() == 100,\n                    \'md-warn\': vm.getProgressValue() == 0,\n                    \'md-accent\': vm.getProgressValue() > 0 && vm.getProgressValue() < 100 }\">\n</md-progress-linear></div><div class=\"progress-value\" \nng-class=\"{\n                    \'green-700-fg\': vm.getProgressValue() == 100,\n                    \'red-700-fg\': vm.getProgressValue() == 0,\n                    \'amber-500-fg\': vm.getProgressValue() > 0 && vm.getProgressValue() < 100 }\">\n{{vm.getProgressValue()}}%</div></div>");
$templateCache.put("app/main/note-or-task/components/status-list/status-list.tmpl.html","<div class=\"status-list\"><div class=\"status-list-container\" layout=\"column\"><status-list-item \nbaldris-model=\"noteOrTask\" ng-repeat=\"noteOrTask in vm.collection | orderBy: [\'sortOrder\', \'dueTime\']\">\n</status-list-item></div></div>");
$templateCache.put("app/main/note-or-task/dialogs/edit-note-or-task-dialog/edit-note-or-task-dialog.tmpl.html","<md-dialog ng-form=\"vm.editNoteOrTaskForm\" class=\"edit-note-or-task-dialog edit-dialog\" \naria-label=\"{{\n    vm.isTask ? \'NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.EDIT_TASK\' : (\'NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.EDIT_TASK\' | translate)\n  }}\">\n<md-toolbar md-theme=\"trafficLight\" class=\"md-tall\" layout=\"column\" \nng-class=\"{\n                    \'md-primary\': vm.isTask && vm.noteOrTask.isCompleted,\n                    \'md-warn\': vm.isTask && !vm.noteOrTask.isCompleted,\n                    \'md-accent\': !vm.isTask }\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">\n{{ (vm.isTask ? \"NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.EDIT_TASK\" : \"NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.EDIT_NOTE\") | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nng-if=\"vm.noteOrTask && !vm.isLoading\" class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" \nlayout-align=\"start stretch\"><md-input-container class=\"md-block\" ng-class=\"{ light: vm.isTask, dark: !vm.isTask }\">\n<label translate=\"NOTE_OR_TASKS.NOTE_OR_TASK.SUBJECT\">Subject</label><input ng-model=\"vm.noteOrTask.subject\">\n</md-input-container></div></md-toolbar><md-dialog-content><md-content ng-if=\"!vm.noteOrTask || vm.isLoading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</md-content><md-content ng-if=\"vm.noteOrTask && !vm.isLoading\" layout=\"column\"><md-input-container flex><label \ntranslate=\"NOTE_OR_TASKS.NOTE_OR_TASK.TEXT\">Text</label><textarea ng-model=\"vm.noteOrTask.text\"></textarea>\n</md-input-container><note-or-task-user-multi-select target-collection=\"vm.noteOrTask.recipients\" \nhas-complete=\"vm.isTask\"></note-or-task-user-multi-select><date-range-select ng-if=\"vm.isCalendarNoteOrTask\" \nstart-date=\"vm.noteOrTask.startTime\" end-date=\"vm.noteOrTask.endTime\"></date-range-select><md-input-container flex \nng-if=\"vm.isTask && !vm.isCalendarNoteOrTask\"><label translate=\"NOTE_OR_TASKS.NOTE_OR_TASK.DUE_TIME\">Due Time</label>\n<date-select ng-model=\"vm.noteOrTask.dueTime\"></date-select></md-input-container><md-input-container \nng-if=\"!vm.isCalendarNoteOrTask\"><label translate=\"NOTE_OR_TASKS.NOTE_OR_TASK.TAB\">Tab</label><md-select \nng-model=\"vm.noteOrTask.tab\"><md-option><em>{{\'NOTE_OR_TASKS.NOTE_OR_TASK.TABS.NONE\' | translate}}</em></md-option>\n<md-option ng-repeat=\"tab in vm.noteOrTaskTabs\" ng-value=\"tab.value\">{{tab.text | translate}}</md-option></md-select>\n</md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><md-button aria-label=\"Delete\" \nclass=\"md-warn\" ng-click=\"vm.deleteNoteOrTask()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ (vm.isTask ? \"NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.DELETE_TASK\" : \"NOTE_OR_TASKS.EDIT_NOTE_OR_TASK.DELETE_NOTE\") | translate }}\n</md-button><span flex></span><md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editNoteOrTaskForm.$invalid\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/obituary-notice/components/obituary-notice-card/obituary-notice-card.tmpl.html","<md-card class=\"obituary-notice-card\"><md-card-header ng-click=\"vm.navigateToObituaryNotice(vm.baldrisModel, $event)\" \nng-class=\"{clickable: !vm.disableLinks}\"><md-card-avatar><md-icon md-font-icon=\"icon-format-align-center\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.obituaryNoticeTypeName }}<span \nng-if=\"!vm.baldrisModel.obituaryNoticeTypeName\">{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE.OBITUARY_NOTICE\' | translate }}\n</span></span> <span class=\"md-subhead\">{{vm.baldrisModel.deceasedName}}</span></md-card-header-text></md-card-header>\n<md-card-content ng-click=\"vm.navigateToObituaryNotice(vm.baldrisModel, $event)\" \nng-class=\"{clickable: !vm.disableLinks}\"><div layout=\"row\"><div flex=\"50\" class=\"publish-info\"><div flex \nclass=\"publish-time\"><label class=\"md-caption\">{{\'OBITUARY_NOTICES.OBITUARY_NOTICE.PUBLISH_TIME\' | translate}}</label>\n<p>{{vm.baldrisModel.publishTime | date:\'shortDate\'}}</p></div><div flex class=\"publisher\"><label class=\"md-caption\">\n{{\'OBITUARY_NOTICES.OBITUARY_NOTICE.SUPPLIER\' | translate}}</label><p>{{vm.baldrisModel.supplierName}}</p></div></div>\n<div class=\"text-center\" flex=\"50\" ng-if=\"vm.baldrisModel.previewUrl\"><img class=\"obituary-preview\" \nbaldris-img-src=\"vm.baldrisModel.previewUrl\" alt=\"{{vm.baldrisModel.obituaryNoticeTypeName}}\"></div><div \nclass=\"text-center\" flex=\"50\" ng-if=\"!vm.baldrisModel.previewFileUrl && !vm.baldrisModel.previewUrl\"><img \nclass=\"obituary-preview\" src=\"/assets/images/ecommerce/product-image-placeholder.png\" \nalt=\"{{vm.baldrisModel.obituaryNoticeTypeName}}\"></div></div><div \nng-repeat=\"field in vm.baldrisModel.fields | orderBy:\'sortOrder\'\" class=\"obituary-field\"><div ng-if=\"field.imageUrl\" \nclass=\"text-center\"><img baldris-img-src=\"{{field.imageUrl}}?h=40\"></div><p ng-if=\"!field.imageUrl\" \nng-style=\"vm.getStyle(field)\" ng-bind-html=\"field.fieldValue | nl2br\"></p></div></md-card-content><md-card-actions \nlayout=\"row\" layout-align=\"end center\" ng-if=\"!vm.disableLinks\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit\" ng-click=\"vm.navigateToObituaryNotice(vm.baldrisModel, $event)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteObituaryNotice(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/obituary-notice/components/obituary-notice-type-select/obituary-notice-type-select.tmpl.html","<md-input-container ng-form=\"vm.obituaryNoticeTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.telephoneType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"obituaryNoticeType\" ng-model=\"vm.obituaryNoticeTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\">\n<md-option ng-repeat=\"currentObituaryNoticeType in vm.obituaryNoticeTypes | orderBy:\'name\'\" \nng-value=\"currentObituaryNoticeType.id\">{{currentObituaryNoticeType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.obituaryNoticeTypeForm.obituaryNoticeType.$error\" \nng-if=\"vm.obituaryNoticeTypeForm.obituaryNoticeType.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.OBITUARY_NOTICE_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/obituary-notice/dialogs/create-adstate-entry-dialog/create-adstate-entry-dialog.tmpl.html","<md-dialog class=\"create-adstate-entry-dialog edit-dialog\" aria-label=\"Add Obituary Notice\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.TITLE\' | translate}}\n</span></div></md-toolbar><md-dialog-content layout=\"column\"><div ng-if=\"!vm.isLoading && !vm.editData\" \nlayout=\"column\"><h2>{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.READY_TO_SEND\' | translate }}</h2><p><strong>\n{{ vm.adstateData.deceasedLastName }}, {{ vm.adstateData.deceasedFirstName }}</strong><br>\n{{ vm.adstateData.ceremonyPlace }} {{ vm.adstateData.ceremonyTime | date:\'fullDate\' }} {{ vm.adstateData.ceremonyTime | date:\'shortTime\' }}\n</p><md-checkbox ng-model=\"vm.editData\" \naria-label=\"{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.EDIT_DATA\' | translate }}\">\n{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.EDIT_DATA\' | translate }}</md-checkbox></div><div \nng-if=\"!vm.isLoading && vm.editData\" layout=\"column\"><h4 \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.REVIEW_DATA\">Review the following data</h4><md-input-container \nflex><label translate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.DECEASED_LAST_NAME\">Deceased Last Name</label>\n<input ng-model=\"vm.adstateData.deceasedLastName\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.DECEASED_FIRST_NAME\">Deceased First Name</label><input \nng-model=\"vm.adstateData.deceasedFirstName\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.DECEASED_SPOUSE\">Spouse</label><input \nng-model=\"vm.adstateData.deceasedSpouse\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.DECEASED_CHILDREN\">Children</label><input \nng-model=\"vm.adstateData.deceasedChildren\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.DECEASED_MUNICIPALITY_OF_RESIDENCE\">Residence</label><input \nng-model=\"vm.adstateData.deceasedMunicipalityOfResidence\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.CEREMONY_PLACE\">Ceremony Place</label><input \nng-model=\"vm.adstateData.ceremonyPlace\"></md-input-container><md-input-container flex><label \ntranslate=\"OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.CEREMONY_TYPE\">Ceremony Place</label><md-select \nng-model=\"vm.adstateData.ceremonyType\"><md-option value=\"B\">\n{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.FUNERAL\' | translate }}</md-option><md-option value=\"C\">\n{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.CREMATION\' | translate }}</md-option><md-option value=\"S\">\n{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.OTHER\' | translate }}</md-option></md-select></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-if=\"!vm.isLoading\" \nclass=\"md-primary\" ng-href=\"{{ vm. getAdstateUrl() }}\" target=\"_blank\">\n{{ \'OBITUARY_NOTICES.CREATE_ADSTATE_ENTRY_DIALOG.OK_CREATE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/obituary-notice/dialogs/retrieve-adstate-entries-dialog/retrieve-adstate-entries-dialog.tmpl.html","<md-dialog class=\"retrieve-adstate-entries-dialog edit-dialog\" aria-label=\"Retrieve adstate entries\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{ \"OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.TITLE\" | translate }}\n</span></div></md-toolbar><md-dialog-content layout=\"column\"><div ng-if=\"!vm.isLoading\" layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"adstate-entry\" ng-repeat=\"adstateEntry in vm.convertedAds\"><div class=\"text-center\"><img\n ng-src=\"{{ adstateEntry.previewLargeUrl || adstateEntry.previewUrl }}\"></div><div class=\"text-center\"><strong>\n{{ adstateEntry.mediaName }}</strong><br><span ng-repeat=\"insertionDate in adstateEntry.insertionDates\">\n{{ insertionDate | date: \"fullDate\" }}<br></span></div><p><strong>Pris til kunde:</strong><br>\n{{ adstateEntry.endCustomerPrice | currency }}</p><p><strong>Lagt inn av:</strong><br>\n{{ adstateEntry.customerContact }}</p><div><md-radio-group class=\"update-choices\" ng-model=\"adstateEntry.targetId\">\n<md-radio-button ng-repeat=\"opt in adstateEntry.updateList\" ng-value=\"opt.value\" \naria-label=\"{{ opt.text | translate }}\">{{ opt.text | translate }}</md-radio-button></md-radio-group></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-input-container><md-checkbox ng-model=\"vm.saveAttachments\" \naria-label=\"Checkbox 1\">\n{{ \"OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES_DIALOG.SAVE_PDF_AND_PREVIEW_FILE_AS_ATTACHMENTS\" | translate }}\n</md-checkbox></md-input-container><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-if=\"!vm.isLoading\" class=\"md-primary\" \nng-click=\"vm.saveAndCloseDialog()\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/views/obituary-notice-attachments.tmpl.html","<md-button class=\"md-primary md-raised\" ngf-select=\"vm.data.uploadAttachments($files)\" multiple=\"multiple\">\n{{ \"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.UPLOAD_ATTACHMENTS\" | translate }}</md-button><div layout-padding \nlayout=\"column\" layout-gt-sm=\"row\" layout-wrap><div class=\"file-container clickable\" flex-gt-sm=\"25\" \nng-repeat=\"attachment in vm.data.updateModel.attachments | orderBy:\'fileName\'\"><div class=\"file\" md-whiteframe=\"1\" \nlayout=\"column\" layout-align=\"end center\" ng-click=\"vm.data.toggleSelected(attachment, $event)\" \nng-class=\" {  \'md-blue-A100-bg\': attachment.changeState === 1 }\"><a target=\"_blank\" \nng-href=\"{{ attachment.fileFilepath }}\"><img baldris-img-src=\"attachment.fileFilepath\" preset=\"square-250-cropped\" \nclass=\"md-avatar\" alt=\"{{ attachment.fileName }}\" ng-if=\"attachment.fileFilepath.indexOf(\'.pdf\') === -1\"><md-icon \nmd-font-icon=\"icon-file-pdf\" ng-if=\"attachment.fileFilepath.indexOf(\'.pdf\') > -1\" class=\"md-avatar-icon\"></md-icon></a>\n<h3>{{ attachment.fileName }}</h3></div></div></div>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/views/obituary-notice-fields.tmpl.html","<div layout=\"column\" class=\"field-types\"><div \nng-repeat=\"fieldType in vm.updateModel.fieldTypeCollection | orderBy:\'sortOrder\'\" class=\"field-type\" layout=\"column\">\n<md-input-container flex><label>{{fieldType.name}}</label><textarea ng-model=\"fieldType.data.fieldValue\" \nng-change=\"vm.onFieldTypeChange(fieldType)\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/views/obituary-notice-general.tmpl.html","<div layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><supplier-select flex flex-gt-sm=\"50\" \nsupplier=\"vm.data.updateModel.obituaryNotice.supplier\" supplier-id=\"vm.data.updateModel.obituaryNotice.supplierId\" \nsupplier-config=\"\'NewspaperSupplierType\'\" label-text=\"{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE.SUPPLIER\' | translate }}\">\n</supplier-select><md-input-container flex flex-gt-sm=\"50\" class=\"md-block\"><label>\n{{ \"OBITUARY_NOTICES.OBITUARY_NOTICE.PUBLISH_TIME\" | translate }}</label><date-select \nng-model=\"vm.data.updateModel.obituaryNotice.publishTime\"></date-select></md-input-container></div>\n<obituary-notice-type-select obituary-notice-type=\"vm.data.updateModel.obituaryNotice.obituaryNoticeType\" \nobituary-notice-type-id=\"vm.data.updateModel.obituaryNotice.obituaryNoticeTypeId\" \nlabel-text=\"{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE.OBITUARY_NOTICE_TYPE\' | translate }}\"></obituary-notice-type-select>\n<div><md-input-container class=\"md-block\"><label>{{ \"OBITUARY_NOTICES.OBITUARY_NOTICE.NOTICE_WIDTH\" | translate }}\n</label><input type=\"number\" step=\"1\" ng-model=\"vm.data.updateModel.obituaryNotice.noticeWidth\"></md-input-container>\n</div><div><md-input-container class=\"md-block\"><label>\n{{ \"OBITUARY_NOTICES.OBITUARY_NOTICE.NOTICE_HEIGHT\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.data.updateModel.obituaryNotice.noticeHeight\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \"OBITUARY_NOTICES.OBITUARY_NOTICE.PRICE\" | translate }}</label><input ng-currency \nng-model=\"vm.data.updateModel.obituaryNotice.price\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \"OBITUARY_NOTICES.OBITUARY_NOTICE.PREVIEW_URL\" | translate }}</label><input \nng-model=\"vm.data.updateModel.obituaryNotice.previewUrl\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \"EXTERNAL_ORDERS.EXTERNAL_ORDER.REMARKS\" | translate }}</label><textarea \nng-model=\"vm.data.updateModel.obituaryNotice.remarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-obituary-notice-sidebar\" layout=\"column\"><div class=\"sidebar-title\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\">\n</md-icon><span class=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div \nclass=\"sidebar-content\" layout=\"column\" layout-padding><baldris-audit \ntitle-text=\"vm.data.updateModel.obituaryNoticeTypeName\" audit-model=\"vm.data.updateModel.obituaryNotice\">\n</baldris-audit><md-button ng-if=\"vm.data.updateModel.obituaryNotice.previewFileId\" class=\"md-raised\" \nng-click=\"vm.data.removePreviewFile()\">{{ \'OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.REMOVE_PREVIEW_FILE\' | translate }}\n</md-button><md-button ng-if=\"!vm.data.updateModel.obituaryNotice.previewFileId\" class=\"md-primary md-raised\" \nngf-select=\"vm.data.uploadPreviewImage($file)\">\n{{ \'OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.UPLOAD_PREVIEW_FILE\' | translate }}</md-button><img width=\"300\" \nng-if=\"vm.data.updateModel.obituaryNotice.previewUrl\" baldris-img-src=\"vm.data.updateModel.obituaryNotice.previewUrl\" \nalt=\"{{vm.data.updateModel.obituaryNoticeType.name}}\"></div></div>");
$templateCache.put("app/main/obituary-notice/edit-obituary-notice/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"OBITUARY_NOTICES.EDIT_OBITUARY_NOTICE.EDITING_TEXT\" \ntranslate-values=\"{ obituaryNoticeString: vm.data.updateModel.obituaryNoticeType.name }\"></span> <span \nng-if=\"vm.data.validation.obituaryNoticeForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.obituaryNoticeForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/privacy/components/privacy-field-multi-select/privacy-field-multi-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{ vm.labelText }}</label><md-select ng-model=\"vm.privacyFieldIds\" \nng-change=\"vm.onChange()\" multiple=\"true\" placeholder=\"{{ vm.labelText }}\" md-selected-text=\"vm.getSelectedItems()\">\n<md-option ng-repeat=\"privacyField in vm.availabelPrivacyFields | orderBy:\'text\'\" ng-value=\"privacyField.id\"><strong>\n{{ privacyField.text }}</strong><br>{{ privacyField.description }}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/privacy/dialogs/delete-party-dialog/delete-party-dialog.tmpl.html","<md-dialog class=\"pseudomize-party-dialog edit-dialog\" aria-label=\"Party Privacy Overview\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'PRIVACY.DELETE_PARTY_DIALOG.TITLE\' | translate}}</span></div>\n</md-toolbar><md-dialog-content layout=\"column\"><div ng-if=\"!vm.loadingService.isLoading\"><div ng-if=\"vm.canDelete\">\n<div layout=\"row\"><md-icon md-font-icon=\"icon-alert\" class=\"md-warn-fg s48\"></md-icon><div flex><p>\n{{ \'PRIVACY.DELETE_PARTY_DIALOG.WARNING\' | translate }}</p></div></div><p>\n{{ \'PRIVACY.DELETE_PARTY_DIALOG.INFO\' | translate }}</p></div><div ng-if=\"!vm.canDelete\"><p>\n{{ \'PRIVACY.DELETE_PARTY_DIALOG.CANNOT_DELETE\' | translate }}</p></div></div><div ng-if=\"vm.loadingService.isLoading\" \nlayout-padding layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-if=\"vm.canDelete\" aria-label=\"Choose\" class=\"md-raised md-primary md-warn\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'PRIVACY.DELETE_PARTY_DIALOG.OK_DELETE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/privacy/dialogs/preview-consent-form-dialog/preview-consent-form-dialog.tmpl.html","<md-dialog class=\"preview-consent-form-dialog edit-dialog\" aria-label=\"Preview Consent Form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ (vm.targetForm === \"consentForm\" ? \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_CONSENT_FORM\" : \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_LETTER_OF_ATTORNEY_FORM\") | translate }}\n</span></div></md-toolbar><md-dialog-content><div layout=\"column\"><p>\n{{ \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.DESCRIPTION\" | translate }}</p><work-order-type-select is-required=\"true\" flex \nwork-order-type-id=\"vm.workOrderTypeId\" work-order-type=\"vm.workOrderType\" \nlabel-text=\"{{ \'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.WORK_ORDER_TYPE\' | translate }}\"></work-order-type-select>\n<department-select is-required=\"true\" flex department-id=\"vm.departmentId\" department=\"vm.department\" \nlabel-text=\"{{ \'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.DEPARTMENT\' | translate }}\"></department-select>\n<reference-person-type-select ng-model=\"vm.referencePersonType\" \nlabel-text=\"{{ \'PRIVACY.PRIVACY_FIELD.REFERENCE_PERSON_TYPE_MASK\' | translate }}\"></reference-person-type-select>\n<md-button ng-href=\"{{ vm.getPreviewUrl() }}\" target=\"_blank\" ng-disabled=\"!vm.getPreviewUrl()\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon>\n{{ (vm.targetForm === \"consentForm\" ? \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_CONSENT_FORM\" : \"PRIVACY.PREVIEW_CONSENT_FORM_DIALOG.PREVIEW_LETTER_OF_ATTORNEY_FORM\") | translate }}\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-primary\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/privacy/dialogs/pseudomize-party-dialog/pseudomize-party-dialog.tmpl.html","<md-dialog class=\"pseudomize-party-dialog edit-dialog\" aria-label=\"Party Privacy Overview\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'PRIVACY.PSEUDOMIZE_PARTY_DIALOG.TITLE\' | translate}}</span></div>\n</md-toolbar><md-dialog-content layout=\"column\"><div ng-if=\"!vm.loadingService.isLoading\"><div ng-if=\"vm.canDelete\">\n<div layout=\"row\"><md-icon md-font-icon=\"icon-alert\" class=\"md-warn-fg s48\"></md-icon><div flex><p>\n{{ \'PRIVACY.PSEUDOMIZE_PARTY_DIALOG.WARNING\' | translate }}</p></div></div><p>\n{{ \'PRIVACY.PSEUDOMIZE_PARTY_DIALOG.INFO\' | translate }}</p></div><div ng-if=\"!vm.canDelete\"><p>\n{{ \'PRIVACY.PSEUDOMIZE_PARTY_DIALOG.CANNOT_PSEUDOMIZE\' | translate }}</p></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout-padding layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button ng-if=\"vm.canDelete\" aria-label=\"Choose\" class=\"md-raised md-primary md-warn\" \nng-click=\"vm.saveAndCloseDialog()\">{{ \'PRIVACY.PSEUDOMIZE_PARTY_DIALOG.OK_PSEUDOMIZE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/privacy/privacy-details/views/related-data.tmpl.html","<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" class=\"work-orders\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'PRIVACY.PRIVACY_DETAILS.WORK_ORDERS\' | translate}}</div></div><md-content><div \nng-if=\"vm.isLoadingCustomerRelationship\" flex><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div>\n<div ng-if=\"!vm.isLoadingCustomerRelationship\"><table class=\"customer-list simple clickable\" ms-responsive-table>\n<thead><tr><th translate=\"WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.REFERENCE_PERSON_TYPE\">\nReference Person Type</th><th translate=\"WORK_ORDERS.WORK_ORDER.ORDER_CODE\">Order Code</th><th \ntranslate=\"WORK_ORDERS.WORK_ORDER.DECEASED\">Deceased</th><th translate=\"WORK_ORDERS.WORK_ORDER.DEPARTMENT\">Department\n</th></tr></thead><tbody><tr class=\"calendar-event\" \nng-repeat=\"workOrderReferencePerson in vm.workOrderReferencePersons | orderBy:\'workOrderOrderCode\'\" \nui-sref=\"app.workOrder.byId.referencePersons({ workOrderId: workOrderReferencePerson.workOrderId, highlightedId: workOrderReferencePerson.id })\">\n<td class=\"customer-number\">{{vm.getReferencePersonTypesString(workOrderReferencePerson.referencePersonType)}}</td><td \nclass=\"display-name\">{{workOrderReferencePerson.workOrderOrderCode}}</td><td class=\"billing-address\">\n{{workOrderReferencePerson.deceasedPersonDisplayName || workOrderReferencePerson.workOrderDeceased}}</td><td \nclass=\"invoices\">{{workOrderReferencePerson.workOrderDepartmentOrganizationDisplayName}}</td></tr></tbody></table><p \nlayout-padding ng-if=\"!vm.workOrderReferencePersons || vm.workOrderReferencePersons.length === 0\">\n{{ \'PRIVACY.PRIVACY_DETAILS.NO_WORK_ORDERS\' | translate}}</p></div></md-content></ms-widget-front></ms-widget>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\" class=\"customer-relation\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'PRIVACY.PRIVACY_DETAILS.CUSTOMER_RELATIONSHIP\' | translate}}</div></div><md-content>\n<div ng-if=\"vm.isLoadingCustomerRelationship\" flex><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear>\n</div><div ng-if=\"!vm.isLoadingCustomerRelationship\"><table class=\"customer-list simple clickable\" ms-responsive-table>\n<thead><tr><th translate=\"CUSTOMERS.CUSTOMER.CUSTOMER_NUMBER\">Customer Number</th><th \ntranslate=\"PARTY.PARTY.DISPLAY_NAME\">Display Name</th><th translate=\"CUSTOMERS.CUSTOMER.BILLING_ADDRESS\">\nBilling Address</th><th translate=\"CUSTOMERS.CUSTOMER.INVOICES\">Invoices</th></tr></thead><tbody><tr \nclass=\"calendar-event\" ng-repeat=\"customer in vm.customers | orderBy:\'customerNumber\'\" \nui-sref=\"app.configuration.customers.editCustomer({ customerId: customer.id })\"><td class=\"customer-number\">\n{{customer.customerNumber}}</td><td class=\"display-name\">{{customer.partyDisplayName}}</td><td class=\"billing-address\">\n{{customer.billingAddressSerialized}}</td><td class=\"invoices\">{{customer.invoiceCount}}</td></tr></tbody></table><p \nlayout-padding ng-if=\"!vm.customers || vm.customers.length === 0\">\n{{ \'PRIVACY.PRIVACY_DETAILS.NO_CUSTOMER_RELATIONSHIP\' | translate}}</p></div></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" class=\"customer-relation\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'PRIVACY.PRIVACY_DETAILS.SALES_ORDERS\' | translate}}</div></div><md-content><div\n ng-if=\"vm.isLoadingSalesOrders\" flex><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div><div \nng-if=\"!vm.isLoadingSalesOrders\"><table class=\"customer-list simple clickable\" ms-responsive-table><thead><tr><th \ntranslate=\"SALES_ORDERS.SALES_ORDER.ORDER_CODE\">Order Code</th><th translate=\"SALES_ORDERS.SALES_ORDER.SUBJECT\">Subject\n</th><th translate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\">Total</th><th \ntranslate=\"SALES_ORDERS.SALES_ORDER.DEPARTMENT\">Department</th></tr></thead><tbody><tr class=\"sales-order\" \nng-repeat=\"salesOrder in vm.salesOrders | orderBy:\'createdTime\'\" \nui-sref=\"app.salesOrder.details({ salesOrderId: salesOrder.id })\"><td class=\"order-code\">{{salesOrder.orderCode}}</td>\n<td class=\"subject\">{{salesOrder.subject}}</td><td class=\"total\">{{salesOrder.totalSumIncludingVat | currency}}</td><td\n class=\"department\">{{salesOrder.departmentOrganizationDisplayName}}</td></tr></tbody></table><p layout-padding \nng-if=\"!vm.salesOrders || vm.salesOrders.length === 0\">{{ \'PRIVACY.PRIVACY_DETAILS.NO_SALES_ORDERS\' | translate}}</p>\n</div></md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nclass=\"customer-relation\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'PRIVACY.PRIVACY_DETAILS.INVOICES\' | translate}}</div></div><md-content><div ng-if=\"vm.isLoadingInvoices\" flex>\n<md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div><div ng-if=\"!vm.isLoadingInvoices\"><table \nclass=\"customer-list simple clickable\" ms-responsive-table><thead><tr><th \ntranslate=\"SALES_ORDERS.INVOICE.INVOICE_NUMBER\">Invoice No.</th><th translate=\"SALES_ORDERS.INVOICE.SUBJECT\">Subject\n</th><th translate=\"SALES_ORDERS.INVOICE.TOTAL_INCLUDING_VAT\">Total</th><th \ntranslate=\"SALES_ORDERS.INVOICE.DEPARTMENT\">Department</th></tr></thead><tbody><tr class=\"invoice\" \nng-repeat=\"invoice in vm.invoices | orderBy:\'invoiceDate\'\" ui-sref=\"app.invoice.details({ invoiceId: invoice.id })\"><td\n class=\"order-code\">{{invoice.prefix}}{{invoice.invoiceNumber}}</td><td class=\"subject\">{{invoice.subject}}</td><td \nclass=\"total\">{{invoice.totalSumIncludingVat | currency}}</td><td class=\"department\">\n{{invoice.departmentOrganizationDisplayName}}</td></tr></tbody></table><p layout-padding \nng-if=\"!vm.invoices || vm.invoices.length === 0\">{{ \'PRIVACY.PRIVACY_DETAILS.NO_INVOICES\' | translate}}</p></div>\n</md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" \nclass=\"lease-holder-responsibility\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'PRIVACY.PRIVACY_DETAILS.LEASE_HOLDER_RESPONSIBILITY\' | translate}}</div></div>\n<md-content><div ng-if=\"vm.isLoadingLeaseHolderResponsibility\" flex><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear></div><div ng-if=\"!vm.isLoadingLeaseHolderResponsibility\"><table \nclass=\"grave-list simple clickable\" ms-responsive-table><thead><tr><th translate=\"GRAVES.GRAVE.GRAVE_NUMBER\">\nGrave Number</th><th translate=\"GRAVES.GRAVE.DECEASED\">Deceased</th></tr></thead><tbody><tr class=\"grave\" \nng-repeat=\"grave in vm.graves | orderBy:\'graveNumber\'\" \nui-sref=\"app.configuration.customers.editCustomer({ customerId: customer.id })\"><td class=\"customer-number\">\n{{grave.graveNumber || \'--\'}}</td><td class=\"display-name\">{{grave.deceasedSerialized}}</td></tr></tbody></table><p \nlayout-padding ng-if=\"!vm.graves || vm.graves.length === 0\">\n{{ \'PRIVACY.PRIVACY_DETAILS.NO_LEASE_HOLDER_RESPONSIBILITY\' | translate}}</p></div></md-content></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\" class=\"calendar-events\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'PRIVACY.PRIVACY_DETAILS.CALENDAR_EVENTS\' | translate}}</div></div><md-content>\n<div ng-if=\"vm.isLoadingCalendarEvents\" flex><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div>\n<div ng-if=\"!vm.isLoadingCalendarEvents\"><table class=\"calendar-event-list simple clickable\" ms-responsive-table>\n<thead><tr><th translate=\"CALENDAR.EVENT.SUBJECT\">Subject</th><th translate=\"CALENDAR.EVENT.LOCATION\">Location</th><th \ntranslate=\"CALENDAR.EVENT.START_TIME\">Start Time</th><th translate=\"CALENDAR.EVENT.HOST\">Host</th></tr></thead><tbody>\n<tr class=\"calendar-event\" ng-repeat=\"calendarEvent in vm.calendarEvents | orderBy:\'startTime\'\" \nui-sref=\"app.configuration.customers.editCustomer({ customerId: customer.id })\"><td class=\"subject\">\n{{calendarEvent.subject || calendarEvent.calendarEventTypeName}}<span ng-if=\"calendarEvent.deceasedSerialized\">\n | {{ calendarEvent.deceasedSerialized }}</span></td><td class=\"location\">{{calendarEvent.locationSerialized}}</td><td \nclass=\"start-time\">{{calendarEvent.start | date:\'short\'}}</td><td class=\"host\">\n{{calendarEvent.hostSerialized || calendarEvent.workOrderDepartmentOrganizationDisplayName}}</td></tr></tbody></table>\n<p layout-padding ng-if=\"!vm.calendarEvents || vm.calendarEvents.length === 0\">\n{{ \'PRIVACY.PRIVACY_DETAILS.NO_CALENDAR_EVENTS\' | translate}}</p></div></md-content></ms-widget-front></ms-widget>");
$templateCache.put("app/main/privacy/privacy-fields/partials/privacy-fields-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"PRIVACY.PRIVACY_FIELD.PRIVACY_FIELDS\" | translate }}</span>\n</div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.privacy.privacyFields.byWorkOrderType({ workOrderTypeId: \'all\', workOrderType: null })\" \nng-class=\"{ \'selected\': vm.data.selectedWorkOrderType === null, \'md-accent-bg\': vm.data.selectedWorkOrderType === null }\">\n<p><md-icon md-font-icon=\"icon-apps\" class=\"s24\"></md-icon>{{ \"PRIVACY.PRIVACY_FIELD.ALL\" | translate }}</p>\n</md-list-item><md-list-item \nui-sref=\"app.privacy.privacyFields.byWorkOrderType({ workOrderTypeId: workOrderType.id, workOrderType: workOrderType })\" \nng-class=\"{ \'selected\': workOrderType.id === vm.data.selectedWorkOrderType.id, \'md-accent-bg\': workOrderType.id === vm.data.selectedWorkOrderType.id }\" \nng-repeat=\"workOrderType in vm.workOrderTypes | orderBy:\'name\'\"><p><md-icon \nmd-font-icon=\"{{ workOrderType.iconName || \'icon-shield\' }}\" class=\"s24\"></md-icon>{{ workOrderType.name }}</p>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/privacy/privacy-fields/privacy-field-list/privacy-field-list.tmpl.html","<table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"PRIVACY.PRIVACY_FIELD.TEXT\">Text\n</th><th translate=\"PRIVACY.PRIVACY_FIELD.DESCRIPTION\">Description</th><th \ntranslate=\"PRIVACY.PRIVACY_FIELD.IS_REQUIRED\">Is Required</th></tr></thead><tbody><tr class=\"privacy-field\" \nng-repeat=\"privacyField in vm.privacyFields | orderBy:\'sortOrder\'\" \nui-sref=\"app.privacy.privacyFields.editPrivacyField({ privacyFieldId: privacyField.id })\"><td class=\"text\" \nng-class=\"{ \'text-strike\': privacyField.isDeleted, \'grey-500-fg\': privacyField.isDeleted }\">{{ privacyField.text }}\n</td><td class=\"description\" \nng-class=\"{ \'text-strike\': privacyField.isDeleted, \'grey-500-fg\': privacyField.isDeleted }\">\n{{ privacyField.description }}<span ng-if=\"privacyField.legalRemarks\"> // {{ privacyField.legalRemarks }}</span></td>\n<td class=\"is-required\"><md-icon \nmd-font-icon=\"{{ privacyField.isRequired ? \'icon-checkbox-marked\' : \'icon-checkbox-blank\' }}\"></md-icon></td></tr>\n</tbody></table>");
$templateCache.put("app/main/product/components/balance-account-select/balance-account-select.tmpl.html","<div class=\"baldris-balance-account-select\"><div layout=\"column\"><div ng-form=\"vm.balanceAccountForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"balanceAccount\" md-selected-item=\"vm.balanceAccount\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.account + \' – \' + item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-balance-account-select\" \nng-disabled=\"vm.isDisabled\"><md-item-template class=\"balance-account-item\"><div><span \nmd-highlight-text=\"vm.searchText\">{{item.account + \' – \' + item.name}}</span></div></md-item-template><div \nng-messages=\"vm.balanceAccountForm.balanceAccount.$error\" ng-if=\"vm.balanceAccountForm.balanceAccount.$touched\"><div \nng-message=\"md-require-match\"><span translate=\"PRODUCTS.BALANCE_ACCOUNT_SELECT.INVALID_BALANCE_ACCOUNT\" \ntranslate-values=\"{ balanceAccount: vm.searchText }\"></span></div><div ng-message=\"invalidBalanceAccount\"><span \ntranslate=\"PRODUCTS.BALANCE_ACCOUNT_SELECT.INVALID_BALANCE_ACCOUNT\" \ntranslate-values=\"{ balanceAccount: vm.searchText }\"></span></div></div></md-autocomplete></div></div></div>");
$templateCache.put("app/main/product/components/product-select/product-item.tmpl.html","<md-list-item ng-click=\"vm.selectItem(entity)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': entity.id == vm.selectedEntity.id }\"><img ng-if=\"entity.productImageFilepath\" \nbaldris-img-src=\"entity.productImageFilepath\" preset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{entity.name}}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><span class=\"product-code\">{{ entity.productCode }}</span>\n — {{ entity.name }}</h3><p>{{ entity.price | currency }} <span class=\"including-vat\" \nng-if=\"entity.priceIncludingVat && entity.priceIncludingVat != entity.price\">{{ entity.priceIncludingVat | currency }}\n</span></p></div></md-list-item>");
$templateCache.put("app/main/product/components/product-select/product-select.tmpl.html","<div ng-form=\"vm.productForm\" class=\"baldris-product-select\" layout=\"row\" layout-align=\"center center\"><md-autocomplete\n flex md-no-cache=\"true\" md-input-name=\"product\" md-selected-item=\"vm.product\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" ng-disabled=\"vm.isDisabled\" \nmd-clear-button=\"true\" md-menu-class=\"autocomplete-product-select\" ng-disabled=\"vm.isDisabled\" \nmd-require-match=\"vm.isRequiredOption\" ng-required=\"vm.isRequiredOption\" md-min-length=\"0\" md-delay=\"300\">\n<md-item-template><div layout=\"row\"><div class=\"product-image\"><img class=\"product-image\" \nng-if=\"item.productImageFilepath\" baldris-img-src=\"item.productImageFilepath\" preset=\"square-40-cropped\" \nalt=\"{{item.name}}\"> <img ng-if=\"!item.productImageFilepath\" height=\"40\" width=\"40\" class=\"product-image\" \nsrc=\"/assets/images/ecommerce/product-image-placeholder.png\"></div><div class=\"description\"><div class=\"name\">\n{{item.name}}</div><div class=\"prices\"><span class=\"product-price\">{{ item.price | currency }}</span> <span \nclass=\"product-price-including-vat\" ng-if=\"item.priceIncludingVat && item.priceIncludingVat != item.price\">\n{{ item.priceIncludingVat | currency }}</span></div></div></div></md-item-template><div \nng-messages=\"vm.productForm.product.$error\" ng-if=\"vm.productForm.product.$touched\"><div ng-message=\"invalidProduct\">\n<span translate=\"PRODUCTS.PRODUCT_SELECT.INVALID_PRODUCT\" translate-values=\"{ product: vm.searchText }\"></span></div>\n<div ng-message=\"md-require-match\"><span ng-if=\"!vm.searchText\" translate=\"PRODUCTS.PRODUCT_SELECT.REQUIRED\">\nProduct is a required field</span> <span ng-if=\"vm.searchText\" translate=\"PRODUCTS.PRODUCT_SELECT.INVALID_PRODUCT\" \ntranslate-values=\"{ product: vm.searchText }\"></span></div></div></md-autocomplete><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" ng-disabled=\"vm.isDisabled || vm.disableSearch\" tabindex=\"-1\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div>");
$templateCache.put("app/main/product/components/product-select/product-type-item.tmpl.html","<md-list-item ng-click=\"vm.selectEntityType(entityType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': entityType.id == vm.selectedEntityTypeId }\"><img ng-if=\"entityType.imageFilepath\" \nbaldris-img-src=\"entityType.imageFilepath\" preset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{entity.name}}\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ entityType.name }}</h3><p>{{ entityType.categoryCode }}</p></div>\n</md-list-item>");
$templateCache.put("app/main/product/components/product-type-select/product-type-select.tmpl.html","<div class=\"baldris-location-select\"><div layout=\"column\"><div ng-form=\"vm.productTypeForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"productType\" md-selected-item=\"vm.productType\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-product-type-select\" \nng-disabled=\"vm.isDisabled\"><md-item-template class=\"location-item\"><div><span md-highlight-text=\"vm.searchText\">\n{{item.name}}</span></div></md-item-template><div ng-messages=\"vm.productTypeForm.productType.$error\" \nng-if=\"vm.productTypeForm.location.$touched\"><div ng-message=\"md-require-match\"><span \ntranslate=\"PRODUCTS.PRODUCT_TYPE_SELECT.INVALID_PRODUCT_TYPE\" translate-values=\"{ location: vm.searchText }\"></span>\n</div><div ng-message=\"invalidLocation\"><span translate=\"PRODUCTS.PRODUCT_TYPE_SELECT.INVALID_PRODUCT_TYPE\" \ntranslate-values=\"{ location: vm.searchText }\"></span></div></div></md-autocomplete></div></div></div>");
$templateCache.put("app/main/product/components/vat-select/vat-select.tmpl.html","<div class=\"baldris-vat-select\"><div layout=\"column\"><div ng-form=\"vm.vatForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"vat\" md-selected-item=\"vm.vat\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.name + \' – \' + item.rate + \'%\'\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-vat-select\" ng-disabled=\"vm.isDisabled\"><md-item-template \nclass=\"vat-item\"><div><span md-highlight-text=\"vm.searchText\">{{item.name}} - {{item.rate}}%</span></div>\n</md-item-template><div ng-messages=\"vm.vatForm.vat.$error\" ng-if=\"vm.vatForm.vat.$touched\"><div \nng-message=\"md-require-match\"><span translate=\"PRODUCTS.VAT_SELECT.INVALID_VAT\" \ntranslate-values=\"{ vat: vm.searchText }\"></span></div><div ng-message=\"invalidVat\"><span \ntranslate=\"PRODUCTS.VAT_SELECT.INVALID_VAT\" translate-values=\"{ vat: vm.searchText }\"></span></div></div>\n</md-autocomplete></div></div></div>");
$templateCache.put("app/main/product/dialogs/edit-product-dialog/edit-product-dialog.tmpl.html","<md-dialog ng-form=\"vm.editProductForm\" class=\"edit-product-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'PRODUCTS.PRODUCT.CREATE_PRODUCT\' : \'PRODUCTS.PRODUCT.EDIT_PRODUCT\' | translate }}\">\n<md-toolbar class=\"md-tall\" layout=\"column\" ng-style=\"vm.eventStyle\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'PRODUCTS.PRODUCT.CREATE_PRODUCT\' : \'PRODUCTS.PRODUCT.EDIT_PRODUCT\' | translate }}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content ng-if=\"vm.isLoading\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content><div \nng-if=\"vm.updateModel && !vm.isLoading\" layout=\"column\"><div ng-if=\"vm.updateModel.product.productImageId\" \nclass=\"product-image\"><img baldris-img-src=\"vm.updateModel.product.productImageFilepath\" \npreset=\"small-landscape-cropped\" alt=\"{{vm.updateModel.product.name}}\"><md-button class=\"md-warn\" \naria-label=\"Remove Image\" ng-click=\"vm.removeProductImage()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'PRODUCTS.PRODUCT.REMOVE_PRODUCT_IMAGE\' | translate }}</md-button></div><md-input-container class=\"md-block\"><label \ntranslate=\"PRODUCTS.PRODUCT.NAME\">Name</label><input ng-model=\"vm.updateModel.product.name\"></md-input-container>\n<product-type-select product-type=\"vm.updateModel.product.productType\" \nproduct-type-id=\"vm.updateModel.product.productTypeId\" label-text=\"{{\'PRODUCTS.PRODUCT.PRODUCT_TYPE\' |translate}}\">\n</product-type-select><md-input-container flex><label translate=\"PRODUCTS.PRODUCT.PRODUCT_CODE\">Product Code</label>\n<input ng-model=\"vm.updateModel.product.productCode\" ng-disabled=\"vm.isDisabled\"></md-input-container>\n<md-input-container flex><label translate=\"PRODUCTS.PRODUCT.DESCRIPTION\">Description</label><textarea \nng-model=\"vm.updateModel.product.description\"></textarea></md-input-container><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex-gt-sm=\"50\"><label translate=\"PRODUCTS.PRODUCT.PRICE\">Price</label><input ng-currency \nng-model=\"vm.updateModel.product.price\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.onPriceChanged()\">\n</md-input-container><md-input-container flex-gt-sm=\"50\"><label translate=\"PRODUCTS.PRODUCT.PRICE_INCLUDING_VAT\">\nDiscount</label><input ng-currency ng-model=\"vm.updateModel.product.priceIncludingVat\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.onPriceVatChanged()\"></md-input-container></div><vat-select vat=\"vm.updateModel.product.vat\" \nvat-id=\"vm.updateModel.product.vatId\" label-text=\"{{\'PRODUCTS.PRODUCT.VAT\' |translate}}\"></vat-select>\n<balance-account-select balance-account=\"vm.updateModel.product.balanceAccount\" \nbalance-account-id=\"vm.updateModel.product.balanceAccountId\" \nlabel-text=\"{{\'PRODUCTS.PRODUCT.BALANCE_ACCOUNT\' |translate}}\"></balance-account-select><supplier-select \nlabel-text=\"{{\'PRODUCTS.PRODUCT.SUPPLIER\' | translate}}\" supplier=\"vm.updateModel.product.supplier\" \nsupplier-id=\"vm.updateModel.product.supplierId\"></supplier-select><md-input-container flex><label \ntranslate=\"PRODUCTS.PRODUCT.DEFAULT_SORT_ORDER\">Default Sort Order</label><input \nng-model=\"vm.updateModel.product.defaultSortOrder\" ng-disabled=\"vm.isDisabled\"></md-input-container>\n<md-input-container><md-checkbox ng-model=\"vm.updateModel.product.isDiscontinued\" \naria-label=\"{{ \'PRODUCTS.PRODUCT.IS_DISCONTINUED\' | translate}}\">{{ \'PRODUCTS.PRODUCT.IS_DISCONTINUED\' | translate}}\n</md-checkbox></md-input-container><div class=\"md-caption\" ng-if=\"!vm.updateModel.product.productImageId\">\n{{ \'PRODUCTS.PRODUCT.PRODUCT_IMAGE\' | translate}}</div><md-button ng-if=\"!vm.updateModel.product.productImageId\" \nclass=\"md-primary md-raised\" ngf-select=\"vm.uploadProductImage($file)\">{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-if=\"!vm.updateModel.product.internalId\" aria-label=\"Delete\" class=\"md-warn\" ng-click=\"vm.deleteProduct()\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \'PRODUCTS.PRODUCT.DELETE_PRODUCT\' | translate }}</md-button><span flex></span>\n<md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button aria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.editProductForm.$invalid\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/product/dialogs/edit-product-type-dialog/edit-product-type-dialog.tmpl.html","<md-dialog ng-form=\"vm.editProductTypeForm\" class=\"edit-product-type-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'PRODUCTS.PRODUCT.CREATE_PRODUCT\' : \'PRODUCTS.PRODUCT.EDIT_PRODUCT\' | translate }}\">\n<md-toolbar layout=\"column\" ng-style=\"vm.eventStyle\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'PRODUCTS.PRODUCT_TYPE.CREATE_PRODUCT_TYPE\' : \'PRODUCTS.PRODUCT_TYPE.EDIT_PRODUCT_TYPE\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content ng-if=\"vm.loadingService.isLoading\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content><div \nng-if=\"vm.productType && !vm.loadingService.isLoading\" layout=\"column\"><md-input-container class=\"md-block\"><label \ntranslate=\"PRODUCTS.PRODUCT_TYPE.NAME\">Name</label><input ng-model=\"vm.productType.name\" ng-required=\"true\" \nng-disabled=\"vm.loadingService.isLoadingInBackground\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PRODUCTS.PRODUCT_TYPE.DESCRIPTION\">Description</label><input ng-model=\"vm.productType.description\" \nng-disabled=\"vm.loadingService.isLoadingInBackground\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"PRODUCTS.PRODUCT_TYPE.CATEGORY_CODE\">Category Code</label><input ng-model=\"vm.productType.categoryCode\" \nng-disabled=\"vm.loadingService.isLoadingInBackground\"></md-input-container><icon-select \nicon-name=\"vm.productType.iconName\" label-text=\"{{ \'PRODUCTS.PRODUCT_TYPE.ICON\' | translate}}\"></icon-select>\n<md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.productType.isDeleted\" \naria-label=\"{{ \'PRODUCTS.PRODUCT_TYPE.IS_DELETED\' | translate}}\">{{ \"PRODUCTS.PRODUCT_TYPE.IS_DELETED\" | translate }}\n</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button aria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.editProductTypeForm.$invalid\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/product/products/partials/product-types-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"PRODUCTS.PRODUCT_TYPE.PRODUCT_TYPES\" | translate }}</span> \n<span flex></span><md-button ng-if=\"vm.getCatalogUrl()\" class=\"md-icon-button\" ng-href=\"{{ vm.getCatalogUrl() }}\" \ntarget=\"_blank\"><md-tooltip md-direction=\"bottom\">{{ \"PRODUCTS.PRODUCTS_VIEW.PRINT_PRODUCT_CATALOG\" | translate }}\n</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditProductTypeDialog(\'new\', $event)\"><md-tooltip md-direction=\"bottom\">\n{{ \"PRODUCTS.PRODUCT_TYPE.CREATE_PRODUCT_TYPE\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list class=\"product-types-list\"><md-list-item \nng-repeat=\"productType in vm.productTypes | orderBy:\'name\' | filter:{ isDeleted: false }\" \nng-click=\"vm.selectProductType(productType)\" \nng-class=\"{\'selected\':vm.currentData.selectedProductType.id === productType.id, \'md-accent-bg\': vm.currentData.selectedProductType.id === productType.id}\">\n<md-icon ng-if=\"!productType.imageFilePath && !productType.iconName\" md-font-icon=\"icon-archive\" class=\"s24\"></md-icon>\n<md-icon ng-if=\"!productType.imageFilePath && productType.iconName\" md-font-icon=\"{{ productType.iconName }}\" \nclass=\"s24\"></md-icon><img ng-if=\"productType.imageFilePath\" baldris-img-src=\"productType.imageFilePath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ productType.name }}\"><p>{{ productType.name }}</p><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.openEditProductTypeDialog(productType.id, $event)\"><md-tooltip \nmd-direction=\"bottom\">{{ \"PRODUCTS.PRODUCT_TYPE.EDIT_PRODUCT_TYPE\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></md-list-item></md-list></div></div>");
$templateCache.put("app/main/product/products/products-view/products-view.tmpl.html","<table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\"></table>");
$templateCache.put("app/main/program/components/program-card/program-card.tmpl.html","<md-card class=\"program-card\"><md-card-header class=\"clickable\" \nng-click=\"vm.navigateToProgram(vm.baldrisModel, $event)\"><md-card-avatar><div class=\"md-media-md card-media\"><img \nng-if=\"vm.baldrisModel.calendarEventLocationImageUrl\" baldris-img-src=\"vm.baldrisModel.calendarEventLocationImageUrl\" \npreset=\"square-40-cropped\"></div><md-icon \nng-if=\"!vm.baldrisModel.calendarEventLocationImageUrl && vm.baldrisModel.programTypeId\" md-font-icon=\"icon-file\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.calendarEventLocationImageUrl && !vm.baldrisModel.programTypeId\" \nmd-font-icon=\"icon-file-hidden\"></md-icon></md-card-avatar><md-card-header-text><span class=\"md-title\">\n{{ vm.baldrisModel.programName || \'PROGRAMS.PROGRAM.PROGRAM\' | translate}}</span> <span class=\"md-subhead\">\n{{vm.baldrisModel.calendarEventLocation}}</span></md-card-header-text></md-card-header><md-card-title \nclass=\"clickable\" ng-click=\"vm.navigateToProgram(vm.baldrisModel, $event)\"><md-card-title-text><span \nclass=\"md-headline\">{{ vm.baldrisModel.programName || \'PROGRAMS.PROGRAM.PROGRAM\' | translate}}</span> <span \nng-if=\"vm.baldrisModel.calendarEventId\" class=\"md-subhead\"><span ng-if=\"vm.baldrisModel.calendarEventType\">\n{{ vm.baldrisModel.calendarEventType }}, </span>\n{{vm.baldrisModel.calendarEventLocation}}, {{vm.baldrisModel.calendarEventStart | date:\'short\'}}</span>\n</md-card-title-text><md-card-title-media><div class=\"md-media-md card-media\"><img \nng-if=\"vm.baldrisModel.programTypePreviewImageUrl\" baldris-img-src=\"vm.baldrisModel.programTypePreviewImageUrl\" \npreset=\"square-150-padded\"></div></md-card-title-media></md-card-title><md-card-content class=\"clickable\" \nng-click=\"vm.navigateToProgram(vm.baldrisModel, $event)\"><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.programTypeName\"><label class=\"md-caption\">{{\'PROGRAMS.PROGRAM.PROGRAM_TYPE\' | translate}}\n</label><p>{{vm.baldrisModel.programTypeName}}</p></div><div flex ng-if=\"vm.baldrisModel.programAmount\"><label \nclass=\"md-caption\">{{\'PROGRAMS.PROGRAM.PROGRAM_AMOUNT\' | translate}}</label><p>{{vm.baldrisModel.programAmount}}</p>\n</div></div><div ng-if=\"vm.baldrisModel.remarks\"><label class=\"md-caption\">\n{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.REMARKS\' | translate}}</label><p>{{vm.baldrisModel.remarks}}</p></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit\" ng-click=\"vm.navigateToProgram(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-tooltip-edit\">\n</md-icon></md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteProgram(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/program/components/program-data-type-select/program-data-type-select.tmpl.html","<md-input-container class=\"baldris-program-data-type-select md-block\"><label>{{vm.labelText}}</label><md-select \nng-model=\"vm.programDataType\" ng-change=\"vm.dataTypeChanged()\"><md-option ng-repeat=\"option in vm.dataTypeOptions\" \nng-value=\"option.value\">{{option.text | translate}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/program/components/program-options-select/program-options-select.tmpl.html","<div class=\"baldris-program-options-select\"><label class=\"md-caption\">{{vm.labelText}}</label><div \nng-form=\"vm.programOptionsForm\" class=\"baldris-options\" layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-checkbox ng-if=\"option.value !== \'none\' && vm.isVisible(option)\" ng-repeat=\"option in vm.programOptions\" \nng-checked=\"vm.isSelected(option)\" ng-click=\"vm.toggle(option)\">{{ option.text | translate }}</md-checkbox></div></div>");
$templateCache.put("app/main/program/components/program-slot-element/program-slot-element.tmpl.html","<div class=\"program-slot-element\" ng-form=\"vm.programSlotElementForm\"><h3><span layout=\"row\"><span \nng-class=\"vm.getSlotIcon(vm.programSlotElement)\"></span>\n {{(vm.programSlotElement.title || vm.programSlotElement.name) | translate}}<span flex></span><span class=\"sort-order\">\n{{vm.programSlotElement.sortOrder}}</span></span></h3><div \nng-if=\"vm.programSlotElement.data.dataType === \'string\' || vm.programSlotElement.data.dataType === \'custom\'\" \nclass=\"string-content\" layout=\"column\" \nng-include=\"\'app/main/program/components/program-slot-element/views/string-element.tmpl.html\'\"></div><div \nng-if=\"vm.programSlotElement.data.dataType === \'boolean\'\" class=\"bool-content\" layout=\"column\" \nng-include=\"\'app/main/program/components/program-slot-element/views/bool-element.tmpl.html\'\"></div><div \nng-if=\"vm.programSlotElement.data.dataType === \'song\' || vm.programSlotElement.data.dataType === \'prayer\'\" \nclass=\"song-content\" layout=\"column\" \nng-include=\"\'app/main/program/components/program-slot-element/views/song-element.tmpl.html\'\"></div><div \nng-if=\"vm.programSlotElement.data.dataType === \'solo\' || vm.programSlotElement.data.dataType === \'music\'\" \nclass=\"solo-content\" layout=\"column\" \nng-include=\"\'app/main/program/components/program-slot-element/views/solo-element.tmpl.html\'\"></div><div \nng-if=\"vm.programSlotElement.data.dataType === \'lookupString\'\" class=\"lookup-string-content\" layout=\"column\" \nng-include=\"\'app/main/program/components/program-slot-element/views/lookup-string-element.tmpl.html\'\"></div><div \nclass=\"tools\" layout=\"row\" layout-align=\"space-between center\"><div \nng-if=\"vm.programSlotElement.data.dataType === \'song\' || vm.programSlotElement.data.dataType === \'prayer\'\" \nng-class=\"{ \'md-warn-fg\': vm.songSelected && vm.recommendedVersesNotFound && !vm.hasVerses(vm.programSlotElement.data) }\" \nclass=\"verses\">\n{{\'PROGRAMS.EDIT_PROGRAM.VERSES\' | translate}}: {{vm.getSongVerses(vm.programSlotElement.data) | translate}}</div><div \nflex></div><div class=\"show-in-program clickable\" ng-click=\"vm.toggleVisibleInPrint()\">\n{{vm.programSlotElement.data.shouldBeVisibleInPrint ? \'PROGRAMS.PROGRAM_SLOT_ELEMENT.WILL_BE_VISIBLE_IN_PRINT\' : \'PROGRAMS.PROGRAM_SLOT_ELEMENT.WILL_NOT_BE_VISIBLE_IN_PRINT\' | translate }}\n</div><md-button tabindex=\"-1\" class=\"md-icon-button\" \nng-click=\"vm.onDelete({ e: $event, value: vm.programSlotElement })\"><md-tooltip md-direction=\"top\">\n{{\'PROGRAMS.PROGRAM_SLOT_ELEMENT.REMOVE_PROGRAM_SLOT\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button tabindex=\"-1\" class=\"md-icon-button\" \nng-click=\"vm.onEdit({ e: $event, value: vm.programSlotElement })\"><md-tooltip md-direction=\"top\">\n{{\'PROGRAMS.PROGRAM_SLOT_ELEMENT.EDIT_PROGRAM_SLOT\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/program/components/program-slot-select/program-slot-select.tmpl.html","<div ng-form=\"vm.programSlotForm\" class=\"baldris-program-slot-select\"><md-autocomplete flex \nmd-min-length=\"vm.minLength\" md-input-name=\"programSlot\" md-selected-item=\"vm.programSlot\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-program-slot-select\" ng-disabled=\"vm.isDisabled\" md-clear-button=\"true\"><md-item-template>\n<div>{{ item.name }} <span class=\"slot-title\">{{ item.title }}</span></div></md-item-template><div \nng-messages=\"vm.programSlotForm.programSlot.$error\" ng-if=\"vm.programSlotForm.programSlot.$touched\"><div \nng-message=\"invalidProgramSlot\"><span translate=\"PROGRAMS.PROGRAM_SLOT_SELECT.INVALID_PROGRAM_SLOT\" \ntranslate-values=\"{ programSlot: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/program/components/program-style-select/program-style-select.tmpl.html","<md-input-container ng-form=\"vm.programStyleForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-if=\"vm.isRequired && !vm.programStyle\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"programStyle\" ng-model=\"vm.programStyleId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentProgramStyle in vm.programStyles | orderBy:\'name\'\" ng-value=\"currentProgramStyle.id\">\n{{currentProgramStyle.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.programStyleForm.programStyle.$error\" ng-if=\"vm.programStyleForm.programStyle.$dirty\"><div \nng-message=\"required\"><span translate=\"PROGRAMS.EDIT_PROGRAM.PROGRAM_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/program/components/program-type-select/program-type-select.tmpl.html","<div ng-form=\"vm.programTypeForm\" class=\"baldris-program-type-select\"><div class=\"header\"><h3><md-icon \nng-if=\"!vm.programType\" md-font-icon=\"icon-file-hidden\"></md-icon><md-icon \nng-if=\"!vm.isInitializing && vm.programType\" md-font-icon=\"icon-file-outline\"></md-icon>{{vm.labelText}}</h3></div><div\n layout=\"row\" ng-hide=\"vm.isInitializing\"><div class=\"selected-program-type text-center\"><img class=\"preview-image\" \nng-if=\"vm.programType.previewImageUrl\" baldris-img-src=\"vm.programType.previewImageUrl\" preset=\"square-100-padded\">\n<md-icon ng-if=\"!vm.programType\" md-font-icon=\"icon-file-hidden\" class=\"s80\"></md-icon><md-icon \nng-if=\"vm.programType && !vm.programType.previewImageUrl\" md-font-icon=\"icon-file-outline\" class=\"s80\"></md-icon></div>\n<md-autocomplete flex md-min-length=\"vm.minLength\" md-input-name=\"programType\" md-selected-item=\"vm.programType\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-menu-class=\"autocomplete-program-type-select\" md-delay=\"300\" \nmd-select-on-match=\"true\" md-require-match=\"true\" ng-disabled=\"vm.isDisabled\" md-clear-button=\"true\" \nplaceholder=\"{{ \'PROGRAMS.PROGRAM_TYPE_SELECT.PLACEHOLDER\' | translate }}\"><md-item-template><div><img \nclass=\"program-type-image\" ng-if=\"item.previewImageUrl\" baldris-img-src=\"item.previewImageUrl\" \npreset=\"square-40-padded\" alt=\"{{item.name}}\"> <span class=\"program-type-icon\" ng-if=\"!item.previewImageUrl\"><md-icon \nmd-font-icon=\"icon-file\" class=\"s40\"></md-icon></span>{{ item.name }}</div></md-item-template><md-not-found><span \nclass=\"red-500-fg\" translate=\"PROGRAMS.PROGRAM_TYPE_SELECT.INVALID_PROGRAM_TYPE\" \ntranslate-values=\"{ programType: vm.searchText }\">Invalid Program Type</span></md-not-found><div class=\"errors\" \nng-messages=\"vm.programTypeForm.programType.$error\" ng-if=\"vm.programTypeForm.programType.$touched\"><div \nng-message=\"invalidProgramType\"><span translate=\"PROGRAMS.PROGRAM_TYPE_SELECT.INVALID_PROGRAM_TYPE\" \ntranslate-values=\"{ programType: vm.searchText }\">Invalid Program Type</span></div><div ng-message=\"md-require-match\">\n<span translate=\"PROGRAMS.PROGRAM_TYPE_SELECT.INVALID_PROGRAM_TYPE\" translate-values=\"{ programType: vm.searchText }\">\nInvalid Program Type</span></div></div></md-autocomplete></div></div>");
$templateCache.put("app/main/program/dialogs/add-program-element-dialog/add-program-element-dialog.tmpl.html","<md-dialog class=\"add-program-element-dialog edit-dialog\" aria-label=\"Add Program Element\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.ADD_PROGRAM_ELEMENT\' | translate}}</span>\n</div></md-toolbar><md-dialog-content><p>{{ \'PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECT_TYPE_SLOT\' | translate}}</p><div \nlayout=\"column\"><program-slot-select is-required=\"true\" flex program-slot-id=\"vm.programElement.programSlotId\" \nprogram-slot=\"vm.programElement.programSlot\" label-text=\"{{\'PROGRAMS.PROGRAM_SLOT_SELECT.PLACEHOLDER\' | translate}}\" \non-selected=\"vm.onProgramSlotSelected\"></program-slot-select><program-data-type-select \nprogram-data-type=\"vm.programElement.dataType\" label-text=\"{{\'PROGRAMS.PROGRAM_ELEMENT.DATA_TYPE\' | translate}}\">\n</program-data-type-select></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\">{{ \'PROGRAMS.EDIT_PROGRAM_ELEMENT.ADD_PROGRAM_ELEMENT\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/edit-program-element-dialog.tmpl.html","<md-dialog class=\"edit-program-element-dialog edit-dialog\" aria-label=\"Edit Program Element\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.EDIT_PROGRAM_ELEMENT\' | translate}}\n</span></div></md-toolbar><md-dialog-content><md-content \nng-if=\"vm.programElement.dataType === \'string\' || vm.programElement.dataType === \'custom\'\" class=\"string-content\" \nlayout=\"column\" ng-include=\"\'app/main/program/dialogs/edit-program-element-dialog/views/string-element.tmpl.html\'\">\n</md-content><md-content ng-if=\"vm.programElement.dataType === \'boolean\'\" class=\"bool-content\" layout=\"column\" \nng-include=\"\'app/main/program/dialogs/edit-program-element-dialog/views/bool-element.tmpl.html\'\"></md-content>\n<md-content ng-if=\"vm.programElement.dataType === \'song\' || vm.programElement.dataType === \'prayer\'\" \nclass=\"song-content\" layout=\"column\" \nng-include=\"\'app/main/program/dialogs/edit-program-element-dialog/views/song-element.tmpl.html\'\"></md-content>\n<md-content ng-if=\"vm.programElement.dataType === \'solo\' || vm.programElement.dataType === \'music\'\" \nclass=\"solo-content\" layout=\"column\" \nng-include=\"\'app/main/program/dialogs/edit-program-element-dialog/views/solo-element.tmpl.html\'\"></md-content>\n<md-content ng-if=\"vm.programElement.dataType === \'lookupString\'\" class=\"lookup-string-content\" layout=\"column\" \nng-include=\"\'app/main/program/dialogs/edit-program-element-dialog/views/lookup-string-element.tmpl.html\'\"></md-content>\n<md-content class=\"default-content\" layout=\"column\" layout-gt-sm=\"row\"><div class=\"dialog-column\" layout=\"column\" \nng-form=\"vm.programElementForm\" layout-margin><program-slot-select is-required=\"true\" flex \nprogram-slot-id=\"vm.programElement.programSlotId\" program-slot=\"vm.programElement.programSlot\" \ndisplay-text=\"vm.programElement.programSlotTitle\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT_SELECT.PLACEHOLDER\' | translate}}\" on-selected=\"vm.onProgramSlotSelected\">\n</program-slot-select><div class=\"hint\">{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.PROGRAM_SLOT_HINT_TEXT\' | translate}}</div>\n<md-input-container ng-if=\"!vm.programElement.programSlotId\" flex><label>\n{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.CUSTOM_SLOT_TITLE\' | translate}}</label><input \nng-model=\"vm.programElement.overridenTitle\"></md-input-container><program-data-type-select \non-update=\"vm.onDataTypeChanged()\" program-data-type=\"vm.programElement.dataType\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_ELEMENT.DATA_TYPE\' | translate}}\"></program-data-type-select></div><div \nclass=\"dialog-column\" layout=\"column\" layout-margin><md-input-container flex><md-checkbox \nng-model=\"vm.programElement.shouldBeVisibleInPrint\" \naria-label=\"{{\'PROGRAMS.PROGRAM_ELEMENT.SHOULD_BE_VISIBLE_IN_PRINT\' | translate}}\">\n{{\'PROGRAMS.PROGRAM_ELEMENT.SHOULD_BE_VISIBLE_IN_PRINT\' | translate}}</md-checkbox></md-input-container>\n<md-input-container flex><label>{{\'PROGRAMS.PROGRAM_ELEMENT.SORT_ORDER\' | translate}}</label><input type=\"number\" \nstep=\"1\" ng-model=\"vm.programElement.sortOrder\"></md-input-container><md-input-container flex><label>\n{{\'PROGRAMS.PROGRAM_ELEMENT.REMARKS\' | translate}}</label><textarea ng-model=\"vm.programElement.remarks\"></textarea>\n</md-input-container></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\" ng-disabled=\"vm.programElementForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/program/dialogs/edit-program-slot-style-dialog/edit-program-slot-style-dialog.tmpl.html","<md-dialog ng-form=\"vm.editProgramSlotStyleForm\" class=\"edit-program-slot-style-dialog edit-dialog\" \naria-label=\"{{ \'PROGRAMS.PROGRAM_SLOT_STYLE.EDIT_PROGRAM_SLOT_STYLE\' | translate }}\"><md-toolbar class=\"md-primary\" \nlayout=\"column\" ng-style=\"vm.eventStyle\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.fontStyle.changeState === 1 ? \'PROGRAMS.PROGRAM_SLOT_STYLE.ADD_PROGRAM_SLOT_STYLE\' : \'PROGRAMS.PROGRAM_SLOT_STYLE.EDIT_PROGRAM_SLOT_STYLE\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content ng-if=\"vm.loadingService.isLoadingInBackground\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content>\n<md-content ng-if=\"!vm.loadingService.isLoadingInBackground\" layout=\"column\"><program-slot-select is-required=\"true\" \nflex program-slot-id=\"vm.programSlotStyle.programSlotId\" program-slot=\"vm.programSlotStyle.programSlot\" \ndisplay-text=\"vm.programSlotStyle.programSlotName\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT_STYLE.PROGRAM_SLOT\' | translate}}\"></program-slot-select><font-style-select \nfont-style-id=\"vm.programSlotStyle.titleStyleId\" font-style=\"vm.programSlotStyle.titleStyle\" \ndisplay-text=\"vm.programSlotStyle.titleStyleDescription\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT_STYLE.TITLE_STYLE\' | translate}}\"></font-style-select><font-style-select \nfont-style-id=\"vm.programSlotStyle.fontStyleId\" font-style=\"vm.programSlotStyle.fontStyle\" \ndisplay-text=\"vm.programSlotStyle.fontStyleDescription\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT_STYLE.FONT_STYLE\' | translate}}\"></font-style-select></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editProgramSlotStyleForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/program/edit-program/views/program-attachments.tmpl.html","<work-order-attachment-list attachments=\"vm.data.updateModel.attachments\" \nselected-attachments=\"vm.data.selectedAttachments\" work-order-id=\"vm.data.updateModel.program.workOrderId\" \nexternal-order-id=\"vm.data.updateModel.program.id\"></work-order-attachment-list>");
$templateCache.put("app/main/program/edit-program/views/program-general.tmpl.html","<div layout-padding layout=\"column\"><supplier-select ng-if=\"vm.data.useProgramSupplier\" \nsupplier=\"vm.data.updateModel.program.supplier\" supplier-id=\"vm.data.updateModel.program.supplierId\" \nsupplier-config=\"\'ProgramSupplierType\'\" label-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.SUPPLIER\' | translate}}\">\n</supplier-select><program-style-select label-text=\"{{\'PROGRAMS.PROGRAM.PROGRAM_STYLE\' | translate}}\" \nprogram-style-id=\"vm.data.updateModel.program.programStyleId\" program-style=\"vm.data.updateModel.program.programStyle\" \non-update=\"vm.data.onProgramStyleChanged(value)\"></program-style-select><program-options-select \nprogram-option=\"vm.data.updateModel.program.programOptions\" visible-options=\"vm.visibleOptions\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM.PROGRAM_OPTIONS\' | translate}}\"></program-options-select><div class=\"options-toggle\" \nlayout=\"column\"><md-button class=\"md-block\" ng-click=\"vm.toggleAllOptions()\">\n{{ vm.visibleOptions === vm.defaultOVisibleOptions ? \'PROGRAMS.EDIT_PROGRAM.SHOW_ALL_OPTIONS\' : \'PROGRAMS.EDIT_PROGRAM.SHOW_COMMON_OPTIONS\' | translate}}\n</md-button></div><div><md-input-container class=\"md-block\" ng-if=\"vm.data.shouldShowAlternateName()\"><label>\n{{\'PROGRAMS.PROGRAM.PROGRAM_ALTERNATE_NAME\' | translate}}</label><input \nng-model=\"vm.data.updateModel.program.programAlternateName\"></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'PROGRAMS.PROGRAM.PROGRAM_AMOUNT\' | translate}}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.data.updateModel.program.programAmount\"></md-input-container></div><program-type-select \nlabel-text=\"{{\'PROGRAMS.PROGRAM.PROGRAM_TYPE\' | translate}}\" \nprogram-type-id=\"vm.data.updateModel.program.programTypeId\" program-type=\"vm.data.updateModel.program.programType\">\n</program-type-select><baldris-file-select show-preview=\"true\" baldris-file-config=\"\'SymbolFileType\'\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM.PROGRAM_SYMBOL\' | translate}}\" \nbaldris-file-id=\"vm.data.updateModel.program.programSymbolId\" baldris-file=\"vm.data.updateModel.program.programSymbol\">\n</baldris-file-select><upcoming-ceremony-select ceremony=\"vm.data.updateModel.program.calendarEvent\" \nceremony-id=\"vm.data.updateModel.program.calendarEventId\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.CEREMONY\' | translate}}\" \nwork-order-id=\"vm.data.updateModel.program.workOrderId\" \ndepartment-id=\"vm.data.updateModel.program.workOrder.departmentId\"></upcoming-ceremony-select><div><md-input-container \nclass=\"md-block\"><label>{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.REMARKS\' | translate}}</label><textarea \nng-model=\"vm.data.updateModel.program.remarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/program/edit-program/views/program-slots.tmpl.html","<div layout=\"column\"><md-list flex class=\"program-slot-list\"><div \nng-repeat=\"programSlot in vm.data.updateModel.slotCollection | orderBy:\'sortOrder\' | filter:{ changeState: \'!3\' }\" \nclass=\"program-slot\"><program-slot-element ng-if=\"!programSlot.data.isNew || vm.showAll\" \non-delete=\"vm.data.deleteData(value, e)\" on-edit=\"vm.data.editData(value, e)\" ng-model=\"programSlot\" \ncalendar-event-type-id=\"vm.data.program.calendarEventId\" location-id=\"vm.data.program.calendarEventLocationId\">\n</program-slot-element><md-divider ng-if=\"!$last && (vm.showAll || !programSlot.data.isNew)\"></md-divider></div>\n</md-list></div>");
$templateCache.put("app/main/program/edit-program/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-program-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \"COMMON.DATA.ACTIONS\" | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><baldris-audit title-text=\"vm.data.updateModel.program.programTypeName\" \naudit-model=\"vm.data.updateModel.program\"></baldris-audit><md-button \nng-if=\"vm.data.validation.programForm.$pristine && vm.data.updateModel.program.programTypeId\" \nclass=\"md-raised md-accent md-block\" ng-click=\"vm.data.downloadTemplateFile()\">\n{{ \"PROGRAMS.EDIT_PROGRAM.DOWNLOAD_TEMPLATE_FILE\" | translate }}</md-button><md-button \nng-if=\"vm.data.validation.programForm.$dirty && vm.data.updateModel.program.programTypeId\" \nclass=\"md-raised md-accent md-block\" ng-click=\"vm.saveAndStay()\">{{ \"COMMON.DIALOG.SAVE\" | translate }}</md-button>\n<md-button ng-disabled=\"vm.data.validation.programForm.$dirty || vm.loadingService.isLoading\" class=\"md-raised\" \nng-if=\"vm.data.updateModel.program.workOrderId && vm.data.programOrderReport\" target=\"_blank\" \nng-href=\"{{ vm.baldrisApiBase }}/api/Reports/AsPdf/{{ vm.data.programOrderReport.id }}/WorkOrderId/{{\n        vm.data.updateModel.program.workOrderId\n      }}\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon><span translate=\"PROGRAMS.EDIT_PROGRAM.PRINT_PROGRAM_ORDER_REPORT\">\nPrint Program Order</span></md-button><md-button \nng-disabled=\"vm.data.validation.programForm.$dirty || vm.loadingService.isLoading || !vm.data.canSendProgramOrder()\" \nclass=\"md-raised md-primary\" ng-if=\"vm.data.updateModel.program.workOrderId && vm.data.programOrderReport\" \nng-click=\"vm.data.sendProgramOrder($event)\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM.SEND_PROGRAM_ORDER_REPORT\">Send Program Order</span></md-button><md-button \nng-disabled=\"vm.data.validation.programForm.$dirty || vm.loadingService.isLoading || !vm.data.canSendProgramOrder()\" \nclass=\"md-raised md-primary\" \nng-if=\"vm.data.updateModel.program.workOrderId && !vm.data.updateModel.program.externalId && vm.data.updateModel.program.supplier.externalId === \'InMemory\'\" \nng-click=\"vm.sendToInMemory($event)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM.SEND_TO_IN_MEMORY\">Send To InMemory</span></md-button><md-button \nng-disabled=\"vm.data.validation.programForm.$dirty || vm.loadingService.isLoading || !vm.data.canSendProgramOrder()\" \nclass=\"md-raised\" \nng-if=\"vm.data.updateModel.program.workOrderId && vm.data.updateModel.program.externalId && vm.data.updateModel.program.supplier.externalId === \'InMemory\'\" \nng-click=\"vm.sendToInMemory($event)\"><md-icon md-font-icon=\"icon-cloud-upload\"></md-icon><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM.UPDATE_TO_IN_MEMORY\">Update To InMemory</span></md-button><md-button \nng-disabled=\"vm.data.validation.programForm.$dirty || vm.loadingService.isLoading || !vm.data.canSendProgramOrder()\" \nclass=\"md-primary\" \nng-if=\"vm.data.updateModel.program.workOrderId && vm.data.updateModel.program.externalOrderId && vm.data.updateModel.program.supplier.externalId === \'InMemory\'\" \nng-href=\"{{ vm.data.updateModel.program.externalOrderId }}\" target=\"_blank\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n<span translate=\"PROGRAMS.EDIT_PROGRAM.VIEW_IN_IN_MEMORY\">View In InMemory</span></md-button><h3 \nng-if=\"vm.data.updateModel.slotCollection.length > 0\" class=\"md-title\">\n{{ \"PROGRAMS.EDIT_PROGRAM.PROGRAM_CONTENT\" | translate }}</h3><div \nng-repeat=\"programSlot in vm.data.updateModel.slotCollection | orderBy:\'sortOrder\' | filter:vm.data.filterSlots\" \nng-class=\"{ \'not-in-print\': !programSlot.data.programElement.shouldBeVisibleInPrint }\" class=\"program-slots\"><div \nclass=\"md-subhead\">{{ programSlot.title | translate }}</div><div class=\"content\">\n{{ vm.data.getProgramSlotContentAsString(programSlot) | translate }}</div></div></div></div>");
$templateCache.put("app/main/program/edit-program/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PROGRAMS.EDIT_PROGRAM.EDITING_TEXT\" \ntranslate-values=\"{ programString: vm.data.updateModel.program.programName }\"></span> <span \nng-if=\"vm.data.validation.programForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.programForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM.SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/reference-types/customer/edit-customer/edit-customer.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\" layout=\"column\" class=\"edit-customer-form\"><ms-widget flex flex-gt-lg=\"50\" \nlayout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">{{\'CUSTOMERS.CUSTOMER.CUSTOMER\' | translate}}\n</div></div><md-content layout-padding layout=\"column\"><edit-party \nbaldris-model=\"vm.data.updateModel.partyUpdateModel.party\" show-death-date=\"false\"></edit-party><div><md-checkbox \nng-model=\"vm.data.updateModel.customer.isDeleted\">{{\'PARTICIPANTS.PARTICIPANT.IS_DELETED\' | translate}}</md-checkbox>\n</div><address-list ng-if=\"vm.data.showAddresses\" party-id=\"vm.data.updateModel.partyUpdateModel.party.id\" \ncollection=\"vm.data.updateModel.partyUpdateModel.addresses\"></address-list><email-list \nparty-id=\"vm.data.updateModel.partyUpdateModel.party.id\" collection=\"vm.data.updateModel.partyUpdateModel.emails\">\n</email-list><telephone-list party-id=\"vm.data.updateModel.partyUpdateModel.party.id\" \ncollection=\"vm.data.updateModel.partyUpdateModel.telephones\"></telephone-list></md-content></ms-widget-front>\n</ms-widget></div><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/reference-types/location/edit-location/edit-location.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\" layout=\"column\" class=\"edit-location-form\"><ms-widget flex flex-gt-lg=\"50\" \nlayout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"LOCATIONS.LOCATION.LOCATION\" | translate }}</div></div><md-content layout-padding layout=\"column\"><div>\n<md-input-container class=\"md-block\"><label>{{ \"LOCATIONS.LOCATION.NAME\" | translate }}</label><input \nng-model=\"vm.data.updateModel.location.name\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{ \"LOCATIONS.LOCATION.DESCRIPTION\" | translate }}</label><textarea \nng-model=\"vm.data.updateModel.location.description\"></textarea></md-input-container></div><meetup-select \nmeetup=\"vm.data.updateModel.location.suggestedMeetUpOffset\" \nlabel-text=\"{{\'LOCATIONS.LOCATION.SUGGESTED_MEET_UP_OFFSET\' | translate}}\"></meetup-select><label class=\"md-caption\">\n{{ \"LOCATIONS.LOCATION.LOCATION_TYPES\" | translate }}</label><location-type-select \nlocation-types=\"vm.data.updateModel.locationTypes\"></location-type-select><div class=\"margin-top-30\">\n<municipality-select label-text=\"{{\'LOCATIONS.LOCATION.MUNICIPALITY\' | translate}}\" \nmunicipality-id=\"vm.data.updateModel.location.municipalityId\" municipality=\"vm.data.updateModel.location.municipality\">\n</municipality-select></div><div><md-input-container class=\"md-block\"><label>\n{{ \"LOCATIONS.LOCATION.REMARKS\" | translate }}</label><textarea ng-model=\"vm.data.updateModel.location.remarks\">\n</textarea></md-input-container></div><div><md-checkbox ng-model=\"vm.data.updateModel.location.isDeleted\" \naria-label=\"{{ \'LOCATIONS.LOCATION.IS_DELETED\' | translate}}\">{{ \"LOCATIONS.LOCATION.IS_DELETED\" | translate }}\n</md-checkbox></div><email-list location-id=\"vm.data.updateModel.location.id\" collection=\"vm.data.updateModel.emails\">\n</email-list><telephone-list location-id=\"vm.data.updateModel.location.id\" collection=\"vm.data.updateModel.telephones\">\n</telephone-list></md-content></ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\">\n<ms-widget-front class=\"white-bg edit-page required-equipment\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"LOCATIONS.LOCATION.REQUIRED_EQUIPMENT\" | translate }}</div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.data.showEditTransportDialog(null, $event)\" aria-label=\"Add a required equipment\" \ntranslate-attr-aria-label=\"LOCATIONS.EDIT_LOCATION.ADD_REQUIRED_EQUIPMENT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"LOCATIONS.EDIT_LOCATION.ADD_REQUIRED_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-list><md-list-item \nng-repeat-start=\"requiredEquipment in vm.data.updateModel.requiredEquipment | orderBy:\'sortOrder\'\" \nclass=\"secondary-button-padding\" ng-click=\"vm.data.showEditRequiredEquipmentDialog(requiredEquipment, $event)\"><img \nng-if=\"requiredEquipment.equipment.imageFilepath\" alt=\"{{ requiredEquipment.equipment.name }}\" \nbaldris-img-src=\"requiredEquipment.equipment.imageFilepath\" preset=\"square-40-cropped\" class=\"md-avatar\"><md-icon \nng-if=\"!requiredEquipment.equipment.imageFilepath\" class=\"md-avatar-icon\" md-font-icon=\"icon-archive\"></md-icon><p>\n{{ requiredEquipment.amount }} – {{ requiredEquipment.equipment.name }}</p><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.data.showDeleteRequiredEquipmentDialog(requiredEquipment, $event)\" \ntranslate-attr-aria-label=\"LOCATIONS.EDIT_LOCATION.DELETE_REQUIRED_EQUIPMENT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"LOCATIONS.EDIT_LOCATION.DELETE_REQUIRED_EQUIPMENT\"></span></md-tooltip><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></ms-widget-front>\n</ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page required-equipment\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"LOCATIONS.LOCATION.ATTACHED_PRODUCTS\" | translate }}</div></div><auto-product-list \nauto-products=\"vm.data.updateModel.attachedProducts\" attached-type=\"Location\"></auto-product-list><auto-task-list \nauto-tasks=\"vm.data.updateModel.autoTasks\" attached-type=\"Location\"></auto-task-list></ms-widget-front></ms-widget>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page related-locations\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"LOCATIONS.LOCATION.RELATED_LOCATIONS\" | translate }}</div></div>\n<related-locations-list related-locations=\"vm.data.updateModel.relatedLocations\" \nlocation-id=\"vm.data.updateModel.location.id\" on-delete=\"vm.data.onDeleteLocationRelationship(value)\" \non-add=\"vm.data.onAddLocationRelationship(value)\" hide-header=\"true\"></related-locations-list></ms-widget-front>\n</ms-widget></div><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/reference-types/participant/edit-participant/edit-participant.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.participantForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-participant-form\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{ \"PARTICIPANTS.PARTICIPANT.PARTICIPANT\" | translate }}</div></div><md-content \nlayout-padding layout=\"column\"><party-privacy-summary ng-if=\"vm.data.isPerson()\" \nparty-update-model=\"vm.data.updateModel.partyUpdateModel\" work-order-type-id=\"null\" work-order-id=\"null\" \nreference-person-type-mask=\"0\"></party-privacy-summary><edit-party \nbaldris-model=\"vm.data.updateModel.partyUpdateModel.party\" show-death-date=\"false\"></edit-party><div>\n<md-input-container class=\"md-block\"><label>{{ \"PARTICIPANTS.PARTICIPANT.TITLE\" | translate }}</label><input \nng-model=\"vm.data.updateModel.participant.title\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{ \"PARTICIPANTS.PARTICIPANT.PROP\" | translate }}</label><input ng-model=\"vm.data.updateModel.participant.prop\">\n</md-input-container></div><many-to-many-select class=\"margin-bottom-30\" \nmany-to-many-list=\"vm.data.updateModel.participantTypeParticipants\" many-to-many-name=\"ParticipantTypeParticipantDto\" \nreference-id=\"vm.data.updateModel.participant.id\" reference-id-name=\"participantId\" \nsource-controller=\"ParticipantTypes\" source-id-name=\"id\" source-name=\"name\" target-id-name=\"participantTypeId\" \ntarget-name=\"participantTypeName\" label-text=\"{{ \'PARTICIPANTS.PARTICIPANT.PARTICIPANT_TYPES\' | translate }}\" \nplaceholder-text=\"{{ \'PARTICIPANTS.PARTICIPANT.PARTICIPANT_TYPES\' | translate }}\"></many-to-many-select><div>\n<md-checkbox ng-model=\"vm.data.updateModel.participant.isDeleted\">\n{{ \"PARTICIPANTS.PARTICIPANT.IS_DELETED\" | translate }}</md-checkbox></div><inline-address-list \nparty-id=\"vm.data.updateModel.partyUpdateModel.party.id\" collection=\"vm.data.updateModel.partyUpdateModel.addresses\">\n</inline-address-list><inline-email-list party-id=\"vm.data.updateModel.partyUpdateModel.party.id\" \ncollection=\"vm.data.updateModel.partyUpdateModel.emails\"></inline-email-list><inline-telephone-list \nparty-id=\"vm.data.updateModel.partyUpdateModel.party.id\" collection=\"vm.data.updateModel.partyUpdateModel.telephones\">\n</inline-telephone-list><auto-product-list auto-products=\"vm.data.updateModel.participantProducts\" \nattached-type=\"Participant\"></auto-product-list><auto-task-list auto-tasks=\"vm.data.updateModel.participantAutoTasks\" \nattached-type=\"Participant\"></auto-task-list></md-content></ms-widget-front></ms-widget></div><div layout=\"row\">\n<md-button class=\"md-warn\" ng-click=\"vm.exitView()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.supplierForm.$pristine\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/reference-types/party/edit-party/edit-party.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-form=\"vm.data.validation.partyForm\" \nng-if=\"!vm.loadingService.isLoading\" class=\"edit-party-form\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap>\n<ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{ \"PARTY.PARTY.PARTY\" | translate }}</div></div><md-content layout-padding \nlayout=\"column\"><edit-party ng-if=\"vm.data.updateModel.party\" baldris-model=\"vm.data.updateModel.party\" \nshow-death-date=\"false\"></edit-party><div ng-if=\"!vm.data.updateModel.party\"><p>\n{{ \"PARTY.NEW_PARTY_DIALOG.CHOOSE_PARTY_TYPE\" | translate }}</p><md-button \naria-label=\"{{ \'PARTY.PERSON.PERSON\' | translate }}\" class=\"md-primary md-raised\" \nng-click=\"vm.data.setPartyType(\'PERSON\')\">{{ \"PARTY.PERSON.PERSON\" | translate }}</md-button><md-button \naria-label=\"{{ \'PARTY.ORGANIZATION.ORGANIZATION\' | translate }}\" class=\"md-primary md-raised\" \nng-click=\"vm.data.setPartyType(\'ORGANIZATION\')\">{{ \"PARTY.ORGANIZATION.ORGANIZATION\" | translate }}</md-button></div>\n<many-to-many-select class=\"margin-bottom-30\" many-to-many-list=\"vm.data.updateModel.partyTypes\" \nmany-to-many-name=\"PartyPartyTypeDto\" reference-id=\"vm.data.updateModel.party.id\" reference-id-name=\"partyId\" \nsource-controller=\"PartyTypes\" source-id-name=\"id\" source-name=\"name\" target-id-name=\"partyTypeId\" \ntarget-name=\"partyTypeName\" label-text=\"{{ \'PARTY.PARTY.PARTY_TYPES\' | translate }}\" \nplaceholder-text=\"{{ \'PARTY.PARTY.PARTY_TYPES\' | translate }}\"></many-to-many-select><div><md-checkbox \nng-model=\"vm.data.updateModel.party.isDeleted\">{{ \"PARTY.PARTY.IS_DELETED\" | translate }}</md-checkbox></div>\n<inline-address-list party-id=\"vm.data.updateModel.party.id\" collection=\"vm.data.updateModel.addresses\">\n</inline-address-list><inline-email-list party-id=\"vm.data.updateModel.party.id\" \ncollection=\"vm.data.updateModel.emails\"></inline-email-list><inline-telephone-list \nparty-id=\"vm.data.updateModel.party.id\" collection=\"vm.data.updateModel.telephones\"></inline-telephone-list>\n</md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.partyForm.$pristine\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/reference-types/supplier/edit-supplier/edit-supplier.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.supplierForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-supplier-form\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{ \"SUPPLIERS.SUPPLIER.SUPPLIER\" | translate }}</div></div><md-content \nlayout-padding layout=\"column\"><edit-party baldris-model=\"vm.data.updateModel.partyUpdateModel.party\" \nshow-death-date=\"false\"></edit-party><div><md-input-container class=\"md-block\" flex><label>\n{{ \"SUPPLIERS.SUPPLIER.SUPPLIER_NUMBER\" | translate }}</label><input \nng-model=\"vm.data.updateModel.supplier.supplierNumber\" ng-disabled=\"vm.isDisabled\"></md-input-container></div><div>\n<md-input-container class=\"md-block\" flex><label>{{ \"SUPPLIERS.SUPPLIER.EXTERNAL_ID\" | translate }}</label><input \nng-model=\"vm.data.updateModel.supplier.externalId\" ng-disabled=\"vm.isDisabled\"></md-input-container></div>\n<md-input-container><md-checkbox ng-model=\"vm.data.updateModel.supplier.isDeleted\" \naria-label=\"{{ \'SUPPLIERS.SUPPLIER.IS_DELETED\' | translate }}\">{{ \"SUPPLIERS.SUPPLIER.IS_DELETED\" | translate }}\n</md-checkbox></md-input-container><inline-address-list party-id=\"vm.data.updateModel.partyUpdateModel.party.id\" \ncollection=\"vm.data.updateModel.partyUpdateModel.addresses\"></inline-address-list><inline-email-list \nparty-id=\"vm.data.updateModel.partyUpdateModel.party.id\" collection=\"vm.data.updateModel.partyUpdateModel.emails\">\n</inline-email-list><inline-telephone-list party-id=\"vm.data.updateModel.partyUpdateModel.party.id\" \ncollection=\"vm.data.updateModel.partyUpdateModel.telephones\"></inline-telephone-list></md-content></ms-widget-front>\n</ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.supplierForm.$pristine\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></div>\n</div>");
$templateCache.put("app/main/report/components/baldris-pdf-viewer/baldris-pdf-viewer.tmpl.html","<div class=\"baldris-pdf-viewer\"><div ng-if=\"vm.isLoading\" class=\"loading-spinner\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><object ng-if=\"!vm.isLoading && vm.pdf\" data=\"{{ vm.pdf }}\" \ntype=\"application/pdf\" style=\"width: 100%; height: 100%\"></object></div>");
$templateCache.put("app/main/report/components/report-multi-select/report-multi-select.tmpl.html","<div class=\"baldris-report-multi-select\"><label class=\"md-caption\">\n{{ vm.labelText ? vm.labelText : (\"REPORTS.REPORTS\" | translate) }}</label><md-chips flex class=\"md-block\" \nng-model=\"vm.selectedReports\" md-autocomplete-snap md-require-match=\"true\" md-on-add=\"vm.onAddReport($chip)\" \nmd-on-remove=\"vm.onRemoveReport($chip)\"><md-autocomplete md-selected-item=\"vm.selectedReport\" \nmd-search-text=\"vm.searchText\" md-items=\"report in vm.querySearch(vm.searchText)\" md-item-text=\"report.name\" \nmd-min-length=\"vm.minLenght\" placeholder=\"{{ \'REPORTS.REPORT_SELECT.CHOOSE_REPORTS\' | translate }}\" \nmd-menu-class=\"baldris-report-suggestions\"><span md-highlight-text=\"vm.searchText\">{{ report.name }}</span>\n</md-autocomplete><md-chip-template class=\"report-chip\" ng-click=\"vm.onSelectParticipant($chip)\">{{ $chip.name }}\n</md-chip-template></md-chips></div>");
$templateCache.put("app/main/report/components/report-select/report-select.tmpl.html","<div class=\"baldris-report-select\"><md-autocomplete ng-form=\"vm.reportForm\" ng-if=\"!vm.internalCategory\" flex \nmd-delay=\"500\" md-min-length=\"1\" md-input-name=\"report\" md-selected-item=\"vm.report\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.title\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-report-select\" ng-disabled=\"vm.isDisabled\"><md-item-template><div class=\"name\">\n{{ item.name }}</div></md-item-template><div ng-messages=\"vm.reportForm.report.$error\" \nng-if=\"vm.reportForm.report.$touched\"><div ng-message=\"invalidReport\"><span \ntranslate=\"REPORTS.REPORT_SELECT.INVALID_REPORT\" translate-values=\"{ report: vm.searchText }\"></span></div></div>\n</md-autocomplete><md-input-container ng-form=\"vm.reportForm\" ng-if=\"vm.internalCategory\" class=\"md-block\"><label>\n{{vm.labelText}}</label><md-select name=\"report\" ng-model=\"vm.reportId\" ng-required=\"vm.isRequired\" \nng-change=\"vm.selectedItemChange(vm.reportId)\"><md-option ng-repeat=\"report in vm.reports | orderBy:\'name\'\" \nng-value=\"report.id\">{{report.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.reportForm.report.$error\" ng-if=\"vm.reportForm.report.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"REPORTS.REPORT.REPORT_REQUIRED\"></span></div></div></md-input-container></div>");
$templateCache.put("app/main/report/dialogs/report-viewer-dialog/report-viewer-dialog.tmpl.html","<md-dialog class=\"report-viewer-dialog edit-dialog\" aria-label=\"Report Preview\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'REPORTS.REPORT_VIEWER_DIALOG.REPORT_PREVIEW\' | translate}}</span></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-gt-sm=\"row\"><div ng-if=\"!vm.isLoading\"></div><div \nng-if=\"!vm.isLoading\" layout-padding><div ng-if=\"vm.reportPdf\"><embed ng-show=\"vm.reportPdf\" ng-src=\"{{vm.reportPdf}}\" \ntype=\"application/pdf\" width=\"{{vm.getReportWidth()}}\" height=\"{{vm.getReportWidth() * 1.414}}\"></div></div><div \nng-if=\"vm.isLoading\" layout-padding layout=\"row\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-disabled=\"!vm.readyToSave\" ng-click=\"vm.saveAndCloseDialog()\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/components/order-line-table/order-line-table.tmpl.html","<div class=\"order-line-table\"><div ng-if=\"vm.canAddOrderLines\" class=\"add-product md-primary-bg md-hue-3\" \nlayout-padding layout=\"column\"><h3 translate=\"SALES_ORDERS.LINE_ITEM.ADD_LINE_ITEM\">Add line item</h3><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-form=\"vm.addNewOrderLineForm\"><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.LINE_ITEM.SORT_ORDER\">Sort.</label><input type=\"number\" step=\"1\" \nng-model=\"vm.newOrderLine.sortOrder\"></md-input-container><product-select flex is-required=\"true\" \non-selected=\"vm.onNewProductSelected\" product=\"vm.newOrderLine.product\" product-id=\"vm.newOrderLine.productId\" \nlabel-text=\"{{\'SALES_ORDERS.LINE_ITEM.PRODUCT\' | translate}}\"></product-select><md-input-container class=\"large\"><label\n translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_AMOUNT\">Quantity</label><input type=\"number\" \nng-model=\"vm.newOrderLine.productAmount\"></md-input-container><edit-price-input \nprice-ex-vat=\"vm.newOrderLine.productPrice\" vat-rate=\"vm.newOrderLine.product.vatRate\" \nis-disabled=\"!vm.newOrderLine.product\"></edit-price-input></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.resetNewOrderLine()\">{{\'COMMON.DATA.RESET\' | translate}}</md-button><md-button \nng-click=\"vm.addNewOrderLine()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.addNewOrderLineForm.$valid\">\n{{\'SALES_ORDERS.LINE_ITEM.ADD_LINE_ITEM\' | translate}}</md-button></div></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header text-center\"><span \nclass=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_IMAGE\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.SORT_ORDER\">Sort.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_CODE\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_AMOUNT\">Quantity</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_PRICE_INC_VAT\">Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-right\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_DISCOUNT\">Discount\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_SUM_INC_VAT\">Total</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.INVOICED\">Invoiced</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.DELETE\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lineItem in vm.lineItemCollection | orderBy:\'sortOrder\'\" class=\"clickable\" \nng-class=\"{ \'md-light-green-100-bg\': lineItem.invoiceProducts.length > 0}\" \nng-click=\"vm.editSalesOrderItem(lineItem, $event)\"><td class=\"text-center\"><img \nng-if=\"lineItem.productProductImageFilepath\" class=\"product-image\" \nbaldris-img-src=\"lineItem.productProductImageFilepath\" preset=\"square-40-cropped\"> <img \nng-if=\"!lineItem.productProductImageFilepath\" height=\"40\" width=\"40\" class=\"product-image\" \nsrc=\"/assets/images/ecommerce/product-image-placeholder.png\"></td><td>{{::lineItem.sortOrder}}</td><td>\n{{::lineItem.productCode}}</td><td>{{::lineItem.productName}}</td><td>{{::lineItem.productAmount}}</td><td \nclass=\"text-right\">{{vm.getPriceIncludingVatLineItem(lineItem) | currency}}</td><td class=\"text-right\">\n{{::lineItem.productDiscount}} %</td><td class=\"text-right\">\n{{vm.getTotalPriceIncludingVatLineItem(lineItem) | currency}}</td><td class=\"text-center\"><md-icon \nng-if=\"!lineItem.invoiceProducts.length\" md-font-icon=\"icon-checkbox-blank\"></md-icon><md-icon \nng-if=\"lineItem.invoiceProducts.length\" md-font-icon=\"icon-checkbox-marked\"></md-icon></td><td \nng-click=\"vm.deleteSalesOrderItem(lineItem, $event)\" class=\"text-center\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</td></tr></tbody></table><div layout=\"column\" layout-padding class=\"table-footer\"><div layout=\"row\" class=\"total-row\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" translate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</span>\n<span class=\"total sum\" ng-class=\"{ \'red-800-fg\': vm.getTotalPrice() < 0, \'grey-500-fg\': vm.getTotalPrice() == 0 }\">\n{{vm.getTotalPrice() | currency}}</span></div><div layout=\"row\" class=\"total-row total-including-vat\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\">Total Including VAT</span> <span \nclass=\"total-including-vat sum\" \nng-class=\"{ \'red-800-fg\': vm.getTotalPriceIncludingVat() < 0, \'grey-500-fg\': vm.getTotalPriceIncludingVat() == 0 }\">\n{{vm.getTotalPriceIncludingVat() | currency}}</span></div><div layout=\"row\" class=\"total-row total-vat\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" translate=\"SALES_ORDERS.SALES_ORDER.VAT\">Vat</span><span\n class=\"total-vat sum\" ng-class=\"{ \'red-800-fg\': vm.getTotalVat() < 0, \'grey-500-fg\': vm.getTotalVat() == 0 }\">\n{{vm.getTotalVat() | currency}}</span></div></div><div ng-if=\"vm.canAddOrderLines\" \nclass=\"add-product md-primary-bg md-hue-3\" layout-padding layout=\"column\"><h3 \ntranslate=\"SALES_ORDERS.LINE_ITEM.ADD_LINE_ITEM\">Add line item</h3><div layout=\"column\" layout-gt-sm=\"row\" \nng-form=\"vm.addNewOrderLineForm\"><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.LINE_ITEM.SORT_ORDER\">Sort.</label><input type=\"number\" step=\"1\" \nng-model=\"vm.newOrderLine.sortOrder\"></md-input-container><product-select flex is-required=\"true\" \non-selected=\"vm.onNewProductSelected\" product=\"vm.newOrderLine.product\" product-id=\"vm.newOrderLine.productId\" \nlabel-text=\"{{\'SALES_ORDERS.LINE_ITEM.PRODUCT\' | translate}}\"></product-select><md-input-container class=\"large\"><label\n translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_AMOUNT\">Quantity</label><input type=\"number\" step=\"1\" \nng-model=\"vm.newOrderLine.productAmount\"></md-input-container><edit-price-input \nprice-ex-vat=\"vm.newOrderLine.productPrice\" vat-rate=\"vm.newOrderLine.product.vatRate\" \nis-disabled=\"!vm.newOrderLine.product\"></edit-price-input></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.resetNewOrderLine()\">{{\'COMMON.DATA.RESET\' | translate}}</md-button>\n<md-button ng-click=\"vm.addNewOrderLine()\" class=\"md-raised md-primary\" ng-disabled=\"!vm.addNewOrderLineForm.$valid\">\n{{\'SALES_ORDERS.LINE_ITEM.ADD_LINE_ITEM\' | translate}}</md-button></div></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header text-center\"><span \nclass=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_IMAGE\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.SORT_ORDER\">Sort.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_CODE\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_AMOUNT\">Quantity</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_PRICE_INC_VAT\">Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-right\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_DISCOUNT\">Discount\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header text-right\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_SUM_INC_VAT\">Total</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"SALES_ORDERS.LINE_ITEM.INVOICED\">Invoiced</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"SALES_ORDERS.LINE_ITEM.DELETE\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"lineItem in vm.lineItemCollection | orderBy:\'sortOrder\'\" class=\"clickable\" \nng-class=\"{ \'md-light-green-100-bg\': lineItem.invoiceProducts.length > 0}\" \nng-click=\"vm.editSalesOrderItem(lineItem, $event)\"><td class=\"text-center\"><img \nng-if=\"lineItem.productProductImageFilepath\" class=\"product-image\" \nbaldris-img-src=\"lineItem.productProductImageFilepath\" preset=\"square-40-cropped\"> <img \nng-if=\"!lineItem.productProductImageFilepath\" height=\"40\" width=\"40\" class=\"product-image\" \nsrc=\"/assets/images/ecommerce/product-image-placeholder.png\"></td><td>{{::lineItem.sortOrder}}</td><td>\n{{::lineItem.productCode}}</td><td>{{::lineItem.productName}}</td><td>{{::lineItem.productAmount}}</td><td \nclass=\"text-right\">{{vm.getPriceIncludingVatLineItem(lineItem) | currency}}</td><td class=\"text-right\">\n{{::lineItem.productDiscount}} %</td><td class=\"text-right\">\n{{vm.getTotalPriceIncludingVatLineItem(lineItem) | currency}}</td><td class=\"text-center\"><md-icon \nng-if=\"!lineItem.invoiceProducts.length\" md-font-icon=\"icon-checkbox-blank\"></md-icon><md-icon \nng-if=\"lineItem.invoiceProducts.length\" md-font-icon=\"icon-checkbox-marked\"></md-icon></td><td \nng-click=\"vm.deleteSalesOrderItem(lineItem, $event)\" class=\"text-center\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</td></tr></tbody></table><div layout=\"column\" layout-padding class=\"table-footer\"><div layout=\"row\" class=\"total-row\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" translate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</span>\n<span class=\"total sum\" ng-class=\"{ \'red-800-fg\': vm.getTotalPrice() < 0, \'grey-500-fg\': vm.getTotalPrice() == 0 }\">\n{{vm.getTotalPrice() | currency}}</span></div><div layout=\"row\" class=\"total-row total-including-vat\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\">Total Including VAT</span> <span \nclass=\"total-including-vat sum\" \nng-class=\"{ \'red-800-fg\': vm.getTotalPriceIncludingVat() < 0, \'grey-500-fg\': vm.getTotalPriceIncludingVat() == 0 }\">\n{{vm.getTotalPriceIncludingVat() | currency}}</span></div><div layout=\"row\" class=\"total-row total-vat\" \nlayout-align=\"end end\"><span flex></span><span class=\"caption\" translate=\"SALES_ORDERS.SALES_ORDER.VAT\">Vat</span><span\n class=\"total-vat sum\" ng-class=\"{ \'red-800-fg\': vm.getTotalVat() < 0, \'grey-500-fg\': vm.getTotalVat() == 0 }\">\n{{vm.getTotalVat() | currency}}</span></div></div></div>");
$templateCache.put("app/main/sales-order/components/sales-order-attachments-section/sales-order-attachments-section.tmpl.html","<div class=\"sales-order-attachments-section-component\"><div class=\"section-header\"><md-icon \nmd-font-icon=\"icon-attachment\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\" \ntranslate=\"SALES_ORDERS.SALES_ORDER.ATTACHMENTS\">Attachments</div></div><div class=\"section-content\"><div \nclass=\"attachment-type clickable\" ng-click=\"vm.editAttachment(attachment, $event)\" \nng-repeat-start=\"attachment in vm.salesOrderAttachments | orderBy:[\'sortOrder\',\'createdAt\']\"><md-icon \nmd-font-icon=\"{{vm.getAttachmentIcon(attachment.fileContentType)}}\"></md-icon></div><div \nclass=\"attachment-name clickable\" ng-click=\"vm.editAttachment(attachment, $event)\">{{attachment.fileName || \"N/A\"}}\n</div><div class=\"attachment-send-with-invoice clickable\" ng-click=\"vm.editAttachment(attachment, $event)\"><md-icon \nng-if=\"attachment.sendWithInvoice\" md-font-icon=\"icon-checkbox-marked-outline\"></md-icon><md-icon \nng-if=\"!attachment.sendWithInvoice\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon></div><div ng-repeat-end \nclass=\"attachment-preview clickable\"><md-button class=\"md-icon-button\" target=\"_blank\" \nng-href=\"{{attachment.filePath}}\"><md-icon ng-if=\"attachment.fileContentType\" md-font-icon=\"icon-eye\"></md-icon>\n</md-button></div></div><div class=\"section-footer\"><md-button class=\"md-primary\" \nng-click=\"vm.editAttachment(null, $event)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n{{ \"SALES_ORDERS.SALES_ORDER.UPLOAD_ATTACHMENT\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/sales-order/dialogs/add-invoice-dialog/add-invoice-dialog.tmpl.html","<md-dialog class=\"add-invoice-dialog\" aria-label=\"{{\'SALES_ORDERS.INVOICE.CREATE_INVOICE\' | translate }}\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><span class=\"title\">{{\'SALES_ORDERS.INVOICE.CREATE_INVOICE\' | translate }}</span></div>\n</md-toolbar><md-dialog-content><md-content class=\"invoice-details\" layout=\"column\" layout-padding><div>\n<md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.INVOICE.SUBJECT\">Subject</label><textarea \nng-model=\"vm.updateModel.invoice.subject\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div><div>\n<md-checkbox ng-model=\"vm.updateModel.invoice.isCreditNote\">{{ \'SALES_ORDERS.INVOICE.IS_CREDIT_NOTE\' | translate }}\n</md-checkbox></div></md-content><div class=\"line-item-list\"><md-list><md-subheader class=\"md-no-sticky\">\n{{\'SALES_ORDERS.INVOICE.ORDER_LINES_TO_ADD\' | translate}}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.toggleAllLineItems()\"><div class=\"md-list-item-text\"><h3 class=\"product-name\">\n{{ vm.selectedLineItems.length > 0 ? \'SALES_ORDERS.INVOICE.REMOVE_ALL\' : \'SALES_ORDERS.INVOICE.ADD_ALL\' | translate }}\n</h3></div><md-checkbox class=\"md-secondary\" ng-checked=\"vm.selectedLineItems.length > 0\" \nng-click=\"vm.toggleAllLineItems()\"></md-checkbox></md-list-item><md-divider></md-divider><md-list-item \nng-repeat=\"lineItem in vm.lineItems | orderBy:\'sortOrder\'\" ng-click=\"vm.toggleLineItem(lineItem)\"><p \nclass=\"product-name\"><span class=\"amount\">\n{{ lineItem.productAmount }} {{ lineItem.product.unitType || \'SALES_ORDERS.LINE_ITEM.DEFAULT_UNIT_TYPE\' | translate }}: \n</span><span flex class=\"name\">{{ lineItem.productName }}</span></p><md-checkbox class=\"md-secondary\" \nng-checked=\"vm.isLineItemSelected(lineItem)\" ng-click=\"vm.toggleLineItem(lineItem)\"></md-checkbox></md-list-item>\n</md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" click-and-wait=\"vm.saveChanges()\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/add-sales-order-dialog/add-sales-order-dialog.tmpl.html","<md-dialog class=\"add-invoice-dialog edit-dialog\" \naria-label=\"{{\'SALES_ORDERS.SALES_ORDER.ADD_SALES_ORDER\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{\'SALES_ORDERS.SALES_ORDER.ADD_SALES_ORDER\' | translate }}</span></div></md-toolbar>\n<md-dialog-content><md-content ng-if=\"!vm.loadingService.isLoadingInBackground\" ng-form=\"vm.addSalesOrderForm\" \nclass=\"invoice-details\" layout=\"column\" layout-padding><work-order-select ng-if=\"vm.showWorkOrderSelect\" \nlabel-text=\"{{\'SALES_ORDERS.SALES_ORDER.WORK_ORDER\' | translate }}\" work-order=\"vm.updateModel.salesOrder.workOrder\" \nwork-order-id=\"vm.updateModel.salesOrder.workOrderId\" on-selected=\"vm.onWorkOrderChanged\"></work-order-select><div>\n<md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.INVOICE.SUBJECT\">Subject</label><textarea \nng-model=\"vm.updateModel.salesOrder.subject\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div>\n<department-select label-text=\"{{\'SALES_ORDERS.SALES_ORDER.DEPARTMENT\' | translate }}\" \ndepartment=\"vm.updateModel.salesOrder.department\" department-id=\"vm.updateModel.salesOrder.departmentId\" \nis-required=\"true\"></department-select></md-content><div class=\"line-item-list\" \nng-if=\"!vm.loadingService.isLoadingInBackground && vm.lineItems && vm.lineItems.length > 0\"><md-list><md-subheader \nclass=\"md-no-sticky\">{{\'SALES_ORDERS.INVOICE.ORDER_LINES_TO_ADD\' | translate}}</md-subheader><md-list-item \nclass=\"md-2-line\" ng-click=\"vm.toggleAllLineItems()\"><div class=\"md-list-item-text\"><h3 class=\"product-name\">\n{{ vm.selectedLineItems.length > 0 ? \'SALES_ORDERS.INVOICE.REMOVE_ALL\' : \'SALES_ORDERS.INVOICE.ADD_ALL\' | translate }}\n</h3></div><md-checkbox class=\"md-secondary\" ng-checked=\"vm.selectedLineItems.length > 0\" \nng-click=\"vm.toggleAllLineItems()\"></md-checkbox></md-list-item><md-divider></md-divider><md-list-item \nclass=\"md-2-line\" ng-repeat=\"lineItem in vm.lineItems | orderBy:\'sortOrder\'\" ng-click=\"vm.toggleLineItem(lineItem)\">\n<div class=\"md-list-item-text\"><h3 class=\"product-name\">\n{{ lineItem.productAmount }} {{ lineItem.workOrderProduct.productUnitType }} – {{ lineItem.productName }}</h3><p>\n{{ vm.getTotalPrice(lineItem) | currency }} – <span \nng-repeat=\"billToOption in vm.getBillToText(lineItem.workOrderProduct.billTo)\">{{ billToOption | translate }}<span \nng-if=\"!$last\">,</span></span></p></div><md-checkbox class=\"md-secondary\" ng-checked=\"vm.isLineItemSelected(lineItem)\" \nng-click=\"vm.toggleLineItem(lineItem)\"></md-checkbox></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" click-and-wait=\"vm.saveChanges()\" \nng-disabled=\"vm.addSalesOrderForm.$invalid || vm.loadingService.isLoadingInBackground\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/confirm-multichannel-dialog/confirm-multichannel-dialog.tmpl.html","<md-dialog class=\"confirm-multichannel-dialog\" \ntranslate-attr-aria-label=\"SALES_ORDERS.MULTI_CHANNEL.CONFIRM_CONSIGNMENT\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{ \"SALES_ORDERS.MULTI_CHANNEL.CONFIRM_CONSIGNMENT\" | translate }}</span></div></md-toolbar>\n<md-progress-linear ng-if=\"vm.isLoading\" md-mode=\"indeterminate\"></md-progress-linear><md-dialog-content><md-content \nclass=\"edit-page\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\"><p>\n<strong>{{\"SALES_ORDERS.MULTI_CHANNEL.RECEIVER\" | translate}}</strong><br>\n{{ vm.updateModel.customer.customer.partyDisplayName }}<br><span \nng-bind-html=\"vm.getFormattedBillingAddress() | nl2br\"></span></p><p><strong>\n{{\"SALES_ORDERS.MULTI_CHANNEL.TYPE\" | translate}}</strong><br><span ng-if=\"vm.isOrganization()\">\n{{\"SALES_ORDERS.MULTI_CHANNEL.EHF_PRINTED_INVOICE\" | translate}}</span> <span ng-if=\"!vm.isOrganization()\">\n{{\"SALES_ORDERS.MULTI_CHANNEL.VIPPS_PRINTED_INVOICE\" | translate}}</span></p></div><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\"><div class=\"total-row total\"><strong \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL\">Total</strong><div class=\"sum total-sum\">{{ vm.getTotalPrice() | currency }}\n</div></div><div class=\"total-row total-including-vat\"><strong \ntranslate=\"SALES_ORDERS.SALES_ORDER.TOTAL_INCLUDING_VAT\">Total Including VAT</strong><div class=\"sum total-sum\">\n{{ vm.getTotalPriceIncludingVat() | currency }}</div></div><div class=\"total-row total-vat\"><strong \ntranslate=\"SALES_ORDERS.SALES_ORDER.VAT\">VAT</strong><div class=\"sum total-sum\">{{ vm.getTotalVat() | currency }}</div>\n</div></div><strong ng-if=\"vm.hasAttachments()\">{{ \"SALES_ORDERS.MULTI_CHANNEL.ATTACHMENTS\" | translate }}</strong><div\n ng-if=\"vm.hasAttachments()\" ng-repeat=\"attachment in vm.updateModel.attachments | filter:{sendWithInvoice: true}\"><a \ntarget=\"_blank\" ng-href=\"{{attachment.filePath}}\"><md-icon md-font-icon=\"icon-file\"></md-icon>{{ attachment.fileName }}\n</a><md-button class=\"md-icon-button\" aria-label=\"Remove attachment\" ng-disabled=\"vm.isLoading\" \nng-click=\"vm.removeAttachment(attachment)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><p \nng-if=\"vm.isOrganization()\"><em>{{\"SALES_ORDERS.MULTI_CHANNEL.ORGANIZATION_DESCRIPTION\" | translate}}</em></p><p \nng-if=\"!vm.isOrganization()\"><em>{{\"SALES_ORDERS.MULTI_CHANNEL.PERSON_DESCRIPTION\" | translate}}</em></p></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\" ng-disabled=\"vm.isLoading\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \naria-label=\"Send\" class=\"md-primary\" ng-click=\"vm.sendToMultiChannel()\" ng-disabled=\"vm.isLoading\">\n{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SEND\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/edit-invoice-details-dialog/edit-invoice-details-dialog.tmpl.html","<md-dialog class=\"edit-invoice-details-dialog\" aria-label=\"{{ \'SALES_ORDERS.INVOICE.EDIT_DETAILS\' | translate }}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">{{ \"SALES_ORDERS.INVOICE.EDIT_DETAILS\" | translate }}\n</span></div></md-toolbar><md-dialog-content><md-content class=\"invoice-details\" layout=\"column\"><md-input-container \nclass=\"large\"><label translate=\"SALES_ORDERS.INVOICE.SUBJECT\">Subject</label><textarea ng-model=\"vm.invoice.subject\" \nng-disabled=\"vm.isDisabled\"></textarea></md-input-container><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.INVOICE.INFO\">Info</label><textarea ng-model=\"vm.invoice.info\" ng-disabled=\"vm.isDisabled\">\n</textarea></md-input-container><date-range-select start-date=\"vm.invoice.invoiceDate\" \non-update=\"vm.onInvoiceDateChanged(startDate)\" \nlabel-start-text=\"{{ \'SALES_ORDERS.INVOICE.INVOICE_DATE\' | translate }}\" \nlabel-end-text=\"{{ \'SALES_ORDERS.INVOICE.DUE_DATE\' | translate }}\" end-date=\"vm.invoice.dueDate\"></date-range-select>\n<report-select label-text=\"{{ \'SALES_ORDERS.INVOICE.REPORT\' | translate }}\" internal-category=\"\'Invoice\'\" \nreport-id=\"vm.invoice.reportId\" report=\"vm.invoice.report\" display-text=\"vm.invoice.reportName\"></report-select>\n<user-single-select label-text=\"{{ \'SALES_ORDERS.INVOICE.SALES_REPRESENTATIVE\' | translate }}\" \nbaldris-user=\"vm.invoice.salesRepresentative\" baldris-user-id=\"vm.invoice.salesRepresentativeId\"></user-single-select>\n<md-input-container class=\"large\"><label translate=\"SALES_ORDERS.INVOICE.REMARKS\">Remarks</label><textarea \nng-model=\"vm.invoice.remarks\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.saveChanges()\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/edit-line-item-dialog/edit-line-item-dialog.tmpl.html","<md-dialog class=\"edit-line-item-dialog\" aria-label=\"{{ \'SALES_ORDERS.LINE_ITEM.EDIT_LINE_ITEM\' | translate }}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">{{ \"SALES_ORDERS.LINE_ITEM.EDIT_LINE_ITEM\" | translate }}\n</span></div></md-toolbar><md-dialog-content><form name=\"vm.lineItemForm\" layout=\"column\" layout-padding><div \nng-if=\"vm.isDisabled\" class=\"md-warn-bg md-hue-3\" layout-padding><p>\n{{ \"SALES_ORDERS.LINE_ITEM.CANNOT_EDIT\" | translate }}</p></div><product-select class=\"margin-top-20 margin-bottom-20\" \nflex is-required=\"true\" is-disabled=\"vm.isDisabled\" product=\"vm.lineItem.product\" product-id=\"vm.lineItem.productId\" \nlabel-text=\"{{ \'SALES_ORDERS.LINE_ITEM.PRODUCT\' | translate }}\" on-selected=\"(vm.productChanged)\" \ndisable-search=\"true\"></product-select><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\"><md-input-container\n class=\"md-block\"><label translate=\"SALES_ORDERS.LINE_ITEM.SORT_ORDER\">Sort.</label><input type=\"number\" step=\"1\" \nng-model=\"vm.lineItem.sortOrder\" ng-disabled=\"vm.isDisabled\"></md-input-container></div><div flex-gt-sm=\"50\">\n<md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_AMOUNT\">Quantity</label><input \ntype=\"number\" ng-model=\"vm.lineItem.productAmount\" ng-disabled=\"vm.isDisabled\"></md-input-container></div></div><div>\n<md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_NAME\">Name</label><textarea \nng-model=\"vm.lineItem.productName\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"70\"><md-input-container class=\"md-block\"><label \ntranslate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_PRICE\">Price</label><input ng-currency ng-model=\"vm.lineItem.productPrice\" \nng-disabled=\"vm.isDisabled\" ng-change=\"vm.priceChanged()\"></md-input-container></div><div flex-gt-sm=\"30\">\n<md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_DISCOUNT\">Discount</label><input \ntype=\"number\" ng-model=\"vm.lineItem.productDiscount\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.discountChanged()\">\n</md-input-container></div></div><div ng-if=\"vm.lineItem.productVatRate > 0\"><md-input-container class=\"md-block\">\n<label translate=\"SALES_ORDERS.LINE_ITEM.PRODUCT_PRICE_INC_VAT\">Price inc. VAT</label><input ng-currency \nng-model=\"vm.priceIncludingVat\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.priceIncludingVatChanged()\">\n</md-input-container></div><div layout=\"row\" class=\"total-sum\"><span flex>\n{{ vm.lineItem.productAmount }} {{ vm.lineItem.product.unitType }} </span><span>{{ vm.getTotalPrice() | currency }}\n</span></div><div layout=\"row\" class=\"total-vat\"><span flex>\n{{ \"SALES_ORDERS.LINE_ITEM.PRODUCT_VAT_Amount\" | translate }} </span><span>{{ vm.getTotalVatAmount() | currency }}\n</span></div><div><md-input-container class=\"md-block\"><label translate=\"SALES_ORDERS.LINE_ITEM.REMARKS\">Remarks\n</label><textarea ng-model=\"vm.lineItem.remarks\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div>\n</form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.closeDialog(vm.lineItem)\" \nng-disabled=\"!vm.canEditChecked || vm.isDisabled || !vm.lineItemForm.$valid\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/edit-sales-order-attachment-dialog/edit-sales-order-attachment-dialog.tmpl.html","<md-dialog class=\"edit-sales-order-attachment-dialog\" \ntranslate-attr-aria-label=\"SALES_ORDERS.SALES_ORDER_ATTACHMENT.EDIT_ATTACHMENT\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{ \"SALES_ORDERS.SALES_ORDER_ATTACHMENT.EDIT_ATTACHMENT\" | translate }}\n</span></div></md-toolbar><md-progress-linear ng-if=\"vm.isLoading\" md-mode=\"indeterminate\"></md-progress-linear>\n<md-dialog-content><md-content class=\"edit-page\" layout=\"column\"><md-input-container class=\"md-block\"><label>\n{{ \"SALES_ORDERS.SALES_ORDER_ATTACHMENT.FILE_NAME\" | translate }}</label><input \nng-model=\"vm.salesOrderAttachment.fileName\" ng-disabled=\"vm.isLoading\"></md-input-container><md-button \nclass=\"md-primary md-raised\" ngf-select=\"vm.loadFile($file)\" ng-disabled=\"vm.isLoading\">\n{{ \'SALES_ORDERS.SALES_ORDER_ATTACHMENT.CHOOSE_FILE\' | translate }}</md-button><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.salesOrderAttachment.sendWithInvoice\" \naria-label=\"{{ \'SALES_ORDERS.SALES_ORDER_ATTACHMENT.SEND_WITH_INVOICE\' | translate}}\" ng-disabled=\"vm.isLoading\">\n{{ \"SALES_ORDERS.SALES_ORDER_ATTACHMENT.SEND_WITH_INVOICE\" | translate }}</md-checkbox></md-input-container>\n<md-input-container class=\"md-block\"><label>{{ \"SALES_ORDERS.SALES_ORDER_ATTACHMENT.REMARKS\" | translate }}</label>\n<input ng-model=\"vm.salesOrderAttachment.remarks\" ng-disabled=\"vm.isLoading\"></md-input-container></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button aria-label=\"Delete\" class=\"md-warn\" \nng-click=\"vm.deleteAttachment()\" ng-disabled=\"vm.isLoading\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"COMMON.DIALOG.DELETE\" | translate }}</md-button><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\" ng-disabled=\"vm.isLoading\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \naria-label=\"Save\" class=\"md-primary\" ng-click=\"vm.saveAttachmentAndCloseDialog()\" \nng-disabled=\"(!vm.uploadFile && !vm.salesOrderAttachment.filePath) || vm.isLoading\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/edit-sales-order-details-dialog/edit-sales-order-details-dialog.tmpl.html","<md-dialog class=\"edit-sales-order-details-dialog\" \naria-label=\"{{ \'SALES_ORDERS.SALES_ORDER.EDIT_DETAILS\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{ \"SALES_ORDERS.SALES_ORDER.EDIT_DETAILS\" | translate }}</span></div></md-toolbar><md-dialog-content>\n<md-content class=\"sales-order-details\" layout=\"column\"><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.SALES_ORDER.SUBJECT\">Subject</label><textarea ng-model=\"vm.salesOrder.subject\" \nng-disabled=\"vm.isDisabled\"></textarea></md-input-container><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.SALES_ORDER.INFO\">Info</label><textarea ng-model=\"vm.salesOrder.info\" \nng-disabled=\"vm.isDisabled\"></textarea></md-input-container><md-input-container class=\"large\"><label \ntranslate=\"SALES_ORDERS.SALES_ORDER.VALID_THROUGH\">Valid Through</label><date-select \nng-model=\"vm.salesOrder.validThrough\"></date-select></md-input-container><report-select \nlabel-text=\"{{ \'SALES_ORDERS.SALES_ORDER.REPORT\' | translate }}\" internal-category=\"\'SalesOrder\'\" \nreport-id=\"vm.salesOrder.reportId\" report=\"vm.salesOrder.report\"></report-select><user-single-select \nlabel-text=\"{{ \'SALES_ORDERS.SALES_ORDER.SALES_REPRESENTATIVE\' | translate }}\" \nbaldris-user=\"vm.salesOrder.salesRepresentative\" baldris-user-id=\"vm.salesOrder.salesRepresentativeId\">\n</user-single-select><md-input-container class=\"large\"><label translate=\"SALES_ORDERS.SALES_ORDER.REMARKS\">Remarks\n</label><textarea ng-model=\"vm.salesOrder.remarks\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/invoice-copied-dialog/invoice-copied-dialog.tmpl.html","<md-dialog class=\"invoice-copied-dialog\" translate-attr-aria-label=\"SALES_ORDERS.INVOICE.INVOICE_COPIED\"><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ (vm.invoiceFdo.isCreditNote ? \"SALES_ORDERS.INVOICE.INVOICE_CREDITED\" : \"SALES_ORDERS.INVOICE.INVOICE_COPIED\") | translate }}\n</span></div></md-toolbar><md-dialog-content><md-content layout=\"column\" layout-padding><div><div class=\"text-bold\">\n{{ \"SALES_ORDERS.INVOICE.DEPARTMENT\" | translate }}</div><span>\n{{ vm.invoiceFdo.salesOrderDepartmentOrganizationDisplayName }}</span></div><div><div class=\"text-bold\">\n{{ \"SALES_ORDERS.INVOICE.SUBJECT\" | translate }}</div><span>{{ vm.invoiceFdo.subject }}</span></div><div><div \nclass=\"text-bold\">{{ \"SALES_ORDERS.INVOICE.CUSTOMER\" | translate }}</div><span>\n{{ vm.invoiceFdo.customerPartyDisplayName }}</span></div><div><div class=\"text-bold\">\n{{ \"SALES_ORDERS.INVOICE.INVOICE_TYPE\" | translate }}</div><span ng-if=\"vm.invoiceFdo.isReminder\">\n{{ \"SALES_ORDERS.INVOICE.REMINDER\" | translate }}</span> <span ng-if=\"vm.invoiceFdo.isCreditNote\" class=\"red-500-fg\">\n{{ \"SALES_ORDERS.INVOICE.CREDIT_NOTE\" | translate }}</span> <span \nng-if=\"!vm.invoiceFdo.isReminder && !vm.invoiceFdo.isCreditNote\">{{ \"SALES_ORDERS.INVOICE.INVOICE\" | translate }}\n</span></div><div><div class=\"text-bold\">{{ \"SALES_ORDERS.INVOICE.TOTAL\" | translate }}</div><span>\n{{ vm.invoiceFdo.totalSum | currency }}</span></div><div><div class=\"text-bold\">\n{{ \"SALES_ORDERS.INVOICE.TOTAL_INCLUDING_VAT\" | translate }}</div><span>\n{{ vm.invoiceFdo.totalSumIncludingVat | currency }}</span></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Go to Sales Order\" class=\"md-primary\" \nng-click=\"vm.gotoSalesOrder()\">{{ \"SALES_ORDERS.INVOICE.GO_TO_SALES_ORDER\" | translate }}</md-button><md-button \naria-label=\"Go to Invoice\" class=\"md-primary md-raised\" ng-click=\"vm.gotoInvoice()\">\n{{ (vm.invoiceFdo.isCreditNote ? \"SALES_ORDERS.INVOICE.GO_TO_CREDIT\" : \"SALES_ORDERS.INVOICE.GO_TO_COPIED\") | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/lock-invoice-dialog/lock-invoice-dialog.tmpl.html","<md-dialog class=\"lock-invoice-dialog\" translate-attr-aria-label=\"SALES_ORDERS.INVOICE.LOCK_INVOICE\"><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ \"SALES_ORDERS.INVOICE.LOCK_INVOICE\" | translate }}</span></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-if=\"vm.isCheckingLockedStatus || vm.isCheckingMultiChannelStatus || vm.isLockingInvoice\"></md-progress-linear>\n<md-dialog-content><md-content layout=\"column\" layout-padding><p class=\"confirmation md-title\">\n{{ \"SALES_ORDERS.INVOICE.LOCK_INVOICE_CONFIRM\" | translate }}</p><div class=\"warnings\" \nng-if=\"vm.warnings.length > 0 || vm.multiChannelErrorCollection.length > 0\"><h3 class=\"md-subhead md-amber-500-bg\" \ntranslate=\"SALES_ORDERS.LOCK_INVOICE_DIALOG.CHECK_THE_FOLLOWING\">Check the following:</h3><ul \nng-if=\"vm.warnings.length > 0 || vm.multiChannelErrorCollection.length > 0\"><li class=\"warning\" \nng-repeat=\"warning in vm.warnings\">{{ warning | translate }}</li><li class=\"error\" \nng-repeat=\"error in vm.multiChannelErrorCollection\">\n({{ \"SALES_ORDERS.MULTI_CHANNEL.MULTI_CHANNEL\" | translate }}) {{ error.key | translate }}</li></ul></div><div \nclass=\"errors md-warn-fg\" ng-if=\"vm.lockErrorCollection.length > 0\"><h3 class=\"md-red-700-bg md-subhead\" \ntranslate=\"SALES_ORDERS.LOCK_INVOICE_DIALOG.CANT_LOCK_THE_INVOICE_BECAUSE\">Can\'t lock the invoice:</h3><ul \nng-if=\"vm.lockErrorCollection.length > 0\"><li class=\"error\" ng-repeat=\"error in vm.lockErrorCollection\">\n{{ error.key | translate }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button aria-label=\"Cancel\" \nng-disabled=\"vm.isCheckingLockedStatus || vm.isCheckingMultiChannelStatus || vm.isLockingInvoice\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" \nng-disabled=\"!vm.canLockInvoice || vm.isCheckingLockedStatus || vm.isCheckingMultiChannelStatus || vm.isLockingInvoice\" \nclass=\"md-primary\" ng-click=\"vm.lockInvoice()\">{{ \"SALES_ORDERS.INVOICE.LOCK_INVOICE_ACTION\" | translate }}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/multi-channel-dialog/multi-channel-dialog.tmpl.html","<md-dialog class=\"multi-channel-dialog\" translate-attr-aria-label=\"SALES_ORDERS.MULTI_CHANNEL.SELECT_OPTION\">\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ \"SALES_ORDERS.MULTI_CHANNEL.SELECT_OPTION\" | translate }}</span></div></md-toolbar><md-dialog-content><md-content \nclass=\"multi-channel-options\" layout=\"column\" layout-padding><p>\n{{ \"SALES_ORDERS.MULTI_CHANNEL.DESCRIPTION\" | translate }}</p><md-radio-group ng-model=\"vm.currentSelection\">\n<md-radio-button ng-value=\"1\"><span translate=\"SALES_ORDERS.MULTI_CHANNEL.REGULAR_EMAIL\">Regular email</span>\n</md-radio-button><md-radio-button ng-value=\"2\"><span translate=\"SALES_ORDERS.MULTI_CHANNEL.TRACKABLE_EMAIL\">\nTrackable email</span></md-radio-button><md-radio-button ng-value=\"3\"><span \ntranslate=\"SALES_ORDERS.MULTI_CHANNEL.MULTI_CHANNEL\">Multi-channel</span></md-radio-button></md-radio-group><div \nclass=\"option-description\"><p ng-if=\"vm.currentSelection === 1\">\n{{ \"SALES_ORDERS.MULTI_CHANNEL.REGULAR_EMAIL_DESCRIPTION\" | translate }}</p><p ng-if=\"vm.currentSelection === 2\">\n{{ \"SALES_ORDERS.MULTI_CHANNEL.TRACKABLE_EMAIL_DESCRIPTION\" | translate }}</p><p ng-if=\"vm.currentSelection === 3\">\n{{ \"SALES_ORDERS.MULTI_CHANNEL.MULTI_CHANNEL_DESCRIPTION\" | translate }}</p><p class=\"errors md-warn-fg\" \nng-if=\"vm.currentSelection === 3 && vm.errorCollection.length > 0\"><span \ntranslate=\"SALES_ORDERS.MULTI_CHANNEL.MULTI_CHANNEL_ERRORS\">Can\'t use multichannel because:</span><ul \nng-if=\"vm.currentSelection === 3 && vm.errorCollection.length > 0\"><li class=\"error\" \nng-repeat=\"error in vm.errorCollection\">{{ error.key | translate }}</li></ul></p></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" \nng-disabled=\"vm.currentSelection === 3 && !vm.canSendInvoice\" class=\"md-primary\" ng-click=\"vm.chooseOption()\">\n{{ \"COMMON.DIALOG.OK\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/dialogs/register-transaction-dialog/register-transaction-dialog.tmpl.html","<md-dialog class=\"register-transaction-dialog\" \naria-label=\"{{ \'SALES_ORDERS.INVOICE.REGISTER_TRANSACTION\' | translate }}\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{ \"SALES_ORDERS.INVOICE.REGISTER_TRANSACTION\" | translate }}</span></div></md-toolbar>\n<md-dialog-content><md-content ng-form=\"vm.transactionForm\" layout=\"column\" layout-padding><p \ntranslate=\"SALES_ORDERS.FINANCIAL_TRANSACTION.REGISTER_TRANSACTION_FOR_INVOICE\" \ntranslate-values=\"{ invoice: vm.invoice.subject }\">Register a transaction for the invoice.</p><p \ntranslate=\"SALES_ORDERS.FINANCIAL_TRANSACTION.TOTAL_TRANSACTIONS\" \ntranslate-values=\"{{ vm.totalTransactionTranslationValues }}\">Total amount for transactions: 0.00.</p><div \nlayout=\"row\" layout-align=\"space-between start\"><md-input-container><label>\n{{ \"SALES_ORDERS.FINANCIAL_TRANSACTION.TRANSACTION_DATE\" | translate }}</label><date-select name=\"transactionDate\" \nng-model=\"vm.transaction.transactionDate\" ng-required=\"true\"></date-select><div class=\"errors\" \nng-messages=\"vm.transactionForm.transactionDate.$error\"><div ng-message=\"valid\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_DATE\"></span></div><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div></div></md-input-container><md-input-container><label>\n{{ \"SALES_ORDERS.FINANCIAL_TRANSACTION.AMOUNT\" | translate }}</label><md-icon md-font-icon=\"icon-cash-100\"></md-icon>\n<input ng-currency ng-model=\"vm.transaction.amount\" ng-required=\"true\"><div class=\"errors\" \nng-messages=\"vm.dateTimeForm.timePart.$error\"><div ng-message=\"required\"><span \ntranslate=\"COMMON.VALIDATION.REQUIRED_FIELD\"></span></div></div></md-input-container></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-disabled=\"vm.transactionForm.$invalid\" ng-click=\"vm.registerTransaction()\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sales-order/edit-sales-order/preview-report/sales-order-preview-report.tmpl.html","<div id=\"sales-order-preview-report\"><telerik-report-viewer name=\"{{vm.report}}\" parameters=\"vm.parameters\">\n</telerik-report-viewer></div>");
$templateCache.put("app/main/settings/configuration/consignments/consignments-config.tmpl.html","<div id=\"consignments-config\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-pen\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{\"MENU.CONFIGURATION.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_SETTINGS\" | translate}}</span></div><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'location-config-sidenav-right\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/consignments/partials/consignments-config-sidenav.tmpl.html\'\">\n</md-sidenav><div class=\"main\" ui-view ms-scroll></div></div></div>");
$templateCache.put("app/main/settings/configuration/contacts/contacts.tmpl.html","<div id=\"contact-settings\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-folder-account\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ vm.data.selectedContactType.name }} <span ng-if=\"vm.data.currentContacts\">({{ vm.data.currentContacts.length }})\n</span></span></div><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'contacts-sidenav-right\')\" aria-label=\"Toggle notes and tasks\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/contacts/partials/contacts-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"contacts-top-nav\" ui-view=\"toolbar\"></div><div class=\"main\" ui-view=\"content\" ms-scroll></div><md-sidenav \nclass=\"sidenav md-sidenav-right contacts-sidenav-right md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"contacts-sidenav-right\"><div class=\"work-order-sidenav-right-view\" \nui-view=\"sidenav-right\"></div></md-sidenav></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-contact-button\" ng-click=\"vm.data.addContact($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/settings/configuration/customers/customers.tmpl.html","<div id=\"customers\" class=\"two-sidebars-toolbar page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-folder-account\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ \"MENU.CONFIGURATION.CUSTOMERS.CUSTOMER_REGISTRY\" | translate }} - «{{ vm.data.searchString }}» <span \nng-if=\"vm.data.currentCustomers\">({{ vm.data.currentCustomers.length }})</span></span></div><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'customers-sidenav-right\')\" \naria-label=\"Toggle notes and tasks\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/customers/partials/customers-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"toolbar-top-nav\" ui-view=\"toolbar\"></div><div class=\"main\" ui-view=\"content\" ms-scroll></div><md-sidenav \nclass=\"sidenav md-sidenav-right common-sidenav-right md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"customers-sidenav-right\"><div class=\"common-sidenav-right-view\" \nui-view=\"sidenav-right\"></div></md-sidenav></div></div>");
$templateCache.put("app/main/settings/configuration/departments/department-config.tmpl.html","<div id=\"department-config\" class=\"one-sidebar page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-sm \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"SETTINGS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-store\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ vm.selectedLegalUnit.displayName || \"MENU.CONFIGURATION.DEPARTMENTS.DEPARTMENT_REGISTRY\" | translate }} <span \nng-if=\"vm.stateParams.legalUnitId\">({{ vm.stateParams.legalUnitId }})</span></span></div></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper><div \nclass=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div class=\"header md-padding\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-city\" class=\"s24\"></md-icon><span \nclass=\"font-weight-500 font-size-14\">{{ \"SETTINGS.REFERENCE_REGISTRY.LEGAL_UNITS\" | translate }}</span> <span flex>\n</span><md-button class=\"md-icon-button\" ui-sref=\"app.configuration.departments.editLegalUnit({ legalUnitId: \'new\' })\">\n<md-tooltip md-direction=\"bottom\">{{ \"LEGAL_UNITS.LEGAL_UNIT_LIST.ADD_NEW_LEGAL_UNIT\" | translate }}</md-tooltip>\n<md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon></md-button></div><md-divider></md-divider><div ms-scroll \nclass=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.configuration.departments.departmentList({ legalUnitId: \'all\' })\" ui-sref-active=\"selected md-accent-bg\">\n<p><md-icon md-font-icon=\"icon-city\" class=\"s24\"></md-icon>\n{{ \"SETTINGS.DEPARTMENT_SETTINGS.ALL_DEPARTMENTS\" | translate }}</p></md-list-item><md-list-item \nui-sref=\"app.configuration.departments.departmentList({ legalUnitId: legalUnit.id })\" \nui-sref-active=\"selected md-accent-bg\" ng-repeat=\"legalUnit in vm.legalUnits | orderBy:\'organizationDisplayName\'\">\n<md-icon md-font-icon=\"icon-city\" class=\"s24\"></md-icon><p>{{ legalUnit.organizationDisplayName }}</p><md-button \nclass=\"md-secondary md-icon-button\" \nui-sref=\"app.configuration.departments.editLegalUnit({ legalUnitId: legalUnit.id })\"><md-tooltip md-direction=\"bottom\">\n{{ \"LEGAL_UNITS.LEGAL_UNIT_LIST.EDIT_LEGAL_UNIT\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-tooltip-edit\">\n</md-icon></md-button></md-list-item></md-list></div></div></md-sidenav><div class=\"main\" ui-view=\"content\" ms-scroll>\n</div></div></div>");
$templateCache.put("app/main/settings/configuration/edit-reference/edit-reference.tmpl.html","<div id=\"configuration-edit-reference\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-tooltip-edit\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"SETTINGS.REFERENCE_REGISTRY.EDIT_REFERENCE\">Edit Reference</span></div></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><div class=\"main\" ui-view ms-scroll></div></div></div>");
$templateCache.put("app/main/settings/configuration/invoice-settings/invoice-settings.tmpl.html","<div id=\"invoice-settings\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-bank\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.CONFIGURATION.INVOICE_SETTINGS.INVOICE_SETTINGS\">Invoice Settings</span></div></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/invoice-settings/partials/invoice-settings-sidenav.tmpl.html\'\">\n</md-sidenav><div class=\"main\" ui-view ms-scroll></div></div></div>");
$templateCache.put("app/main/settings/configuration/locations/location-config.tmpl.html","<div id=\"location-config\" class=\"two-sidebars-toolbar page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header\" ng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-sm ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-folder-account\" class=\"s24\"></md-icon></span><span class=\"logo-text\">\n{{ vm.data.selectedLocationType.name }} <span ng-if=\"vm.data.currentLocations\">({{ vm.data.currentLocations.length }})\n</span></span></div><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'location-config-sidenav-right\')\" aria-label=\"Toggle notes and tasks\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"common-sidenav-left sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/locations/partials/location-config-sidenav.tmpl.html\'\"></md-sidenav><div \nclass=\"toolbar-top-nav\" ui-view=\"toolbar\"></div><div class=\"main\" ui-view=\"content\" ms-scroll></div><md-sidenav \nclass=\"sidenav md-sidenav-right common-sidenav-right md-white-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"location-config-sidenav-right\"><div class=\"common-sidenav-right-view\" \nui-view=\"sidenav-right\"></div></md-sidenav></div><md-button class=\"md-fab md-accent md-icon-button add-button\" \nng-click=\"vm.data.addLocation($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/settings/configuration/program-settings/program-settings.tmpl.html","<div id=\"program-settings\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_SETTINGS\">Service Sheet Settings</span></div></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/program-settings/partials/program-settings-sidenav.tmpl.html\'\">\n</md-sidenav><div class=\"main\" ui-view ms-scroll></div></div></div>");
$templateCache.put("app/main/settings/configuration/reference-types/configuration-reference-types.tmpl.html","<div id=\"configuration-reference-types\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.CONFIGURATION.REFERENCE_REGISTRY\">Reference Types</span></div></div><md-input-container \nclass=\"md-block show-not-in-use\"><md-checkbox ng-checked=\"vm.showDeleted\" \nng-click=\"vm.selectReferenceType(vm.currentData.selectedReferenceType, !vm.showDeleted)\" \naria-label=\"{{ \'SETTINGS.REFERENCE_REGISTRY.SHOW_ELEMENTS_NOT_IN_USE\' | translate }}\">\n{{ \"SETTINGS.REFERENCE_REGISTRY.SHOW_ELEMENTS_NOT_IN_USE\" | translate }}</md-checkbox></md-input-container><div \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"reference-list-search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"reference-list-search\" placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"SETTINGS.REFERENCE_REGISTRY.SEARCH_IN_LIST\"></md-input-container></div></div><div \nng-show=\"vm.currentData.selectedReferences.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" \nng-click=\"vm.currentData.selectedReferences = []\"><md-button layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"COMMON.DIALOG.CANCEL\">Cancel</span></md-button>\n</div><div flex layout=\"row\" layout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>\n{{ vm.currentData.selectedReferences.length }}</span> <span translate=\"SETTINGS.REFERENCE_REGISTRY.SELECTED\">selected\n</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"SETTINGS.REFERENCE_REGISTRY.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllReferences()\" \ntranslate=\"SETTINGS.REFERENCE_REGISTRY.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectedReferences = []\" translate=\"SETTINGS.REFERENCE_REGISTRY.SELECT_NONE\">Select none</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedReferenceTypes($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"SETTINGS.REFERENCE_REGISTRY.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav\n class=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/reference-types/partials/reference-types-sidenav.tmpl.html\'\"></md-sidenav>\n<div class=\"main\" ui-view ms-scroll></div></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-reference-type-button\" ng-click=\"vm.openAddReferenceDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"{{ vm.currentData.selectedReferenceType.addIcon }}\"></md-icon></md-button></div>");
$templateCache.put("app/main/settings/configuration/transport-settings/transport-settings.tmpl.html","<div id=\"transport-settings\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header\" \nng-class=\"vm.fuseTheming.getThemeMetaData().headerClass\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-truck\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"MENU.CONFIGURATION.TRANSPORT_SETTINGS.TRANSPORT_SETTINGS\">Transport Settings</span></div></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-primary-bg md-hue-1\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" \nflex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/settings/configuration/transport-settings/partials/transport-settings-sidenav.tmpl.html\'\">\n</md-sidenav><div class=\"main\" ui-view ms-scroll></div></div></div>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/reference-type-quick-edit-dialog.tmpl.html","<md-dialog ng-form=\"vm.referenceForm\" class=\"reference-type-quick-edit-dialog edit-dialog\" \naria-label=\"{{ vm.referenceDeclaration.templateTitle || \'SETTINGS.REFERENCE_REGISTRY.EDIT_REFERENCE\' | translate }}\">\n<md-toolbar class=\"md-primary\" layout=\"column\" ng-style=\"vm.eventStyle\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ vm.referenceDeclaration.templateTitle || \"SETTINGS.REFERENCE_REGISTRY.EDIT_REFERENCE\" | translate }}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\"><md-content ng-if=\"vm.isLoading\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content>\n<md-content ng-if=\"!vm.isLoading && !vm.referenceDeclaration.quickTemplate\" layout=\"column\"><md-input-container \nclass=\"md-block\" ng-class=\"vm.highlightClass\"><label>{{ vm.referenceDeclaration.primaryTitle | translate }}</label>\n<input ng-model=\"vm.reference[vm.referenceDeclaration.primaryPath]\"></md-input-container><md-input-container \nng-if=\"vm.referenceDeclaration.secondaryPath\" flex><label>{{ vm.referenceDeclaration.secondaryTitle | translate }}\n</label><input ng-model=\"vm.reference[vm.referenceDeclaration.secondaryPath]\"></md-input-container><icon-select \nicon-name=\"vm.reference[vm.referenceDeclaration.iconPath]\" label-text=\"Ikon\"></icon-select><div \nng-if=\"vm.updateModel.product.productImageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.updateModel.product.productImage.filepath\" preset=\"square-250-padded\"><md-button class=\"md-warn\" \naria-label=\"Remove Image\" ng-click=\"vm.removeProductImage()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"PRODUCTS.PRODUCT.REMOVE_PRODUCT_IMAGE\" | translate }}</md-button></div><md-input-container \nng-if=\"vm.referenceDeclaration.sortOrderPath\" flex><label>{{ \"COMMON.DATA.SORT_ORDER\" | translate }}</label><input \ntype=\"number\" step=\"1\" ng-model=\"vm.reference[vm.referenceDeclaration.sortOrderPath]\"></md-input-container><md-checkbox\n ng-if=\"vm.referenceDeclaration.deletedPath\" ng-model=\"vm.reference[vm.referenceDeclaration.deletedPath]\" \naria-label=\"{{ \'CASKETS.CASKET.IS_DELETED\' | translate}}\">{{ \"COMMON.DATA.IS_DELETED\" | translate }}</md-checkbox>\n</md-content><md-content ng-if=\"!vm.isLoading && vm.referenceDeclaration.quickTemplate\" \nng-include=\"vm.referenceDeclaration.quickTemplate\"></md-content></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button aria-label=\"Choose\" class=\"md-icon-button md-primary\" ng-click=\"vm.navigateToFullEdit()\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button ng-if=\"!vm.updateModel.product.internalId\" \naria-label=\"Delete\" class=\"md-warn\" ng-click=\"vm.deleteProduct()\" ng-disabled=\"vm.reference.isRequiredBySystem\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ vm.referenceDeclaration.deleteText || \"SETTINGS.REFERENCE_REGISTRY.DELETE_REFERENCE\" | translate }}</md-button><span\n flex></span><md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}\n</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.editProductForm.$invalid\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/signature-jobs/components/create-signature-job/create-signature-job.tmpl.html","<div class=\"create-signature-job-component\"><div ng-form=\"vm.createSignatureJobForm\"><div class=\"reports\"><h3 \nclass=\"md-headline\">{{\'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SELECT_REPORTS\' | translate}}</h3><p>\n{{\'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SELECT_REPORT_BELOW\' | translate}}</p><signature-job-report-multi-select \nreports=\"vm.createCommand.reportsToInclude\" on-report-added=\"vm.handleReportAdded(value)\" \nwork-order-id=\"vm.workOrderId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\"></signature-job-report-multi-select>\n</div><div class=\"consignment\"><h3 class=\"md-headline\">{{\'SIGNATURE_JOBS.SIGNATURE_JOB.SIGNATURE_JOB\' | translate}}\n</h3><md-input-container class=\"md-block\" flex><label>{{ \'SIGNATURE_JOBS.SIGNATURE_JOB.SUBJECT\' | translate }}</label>\n<input name=\"subject\" ng-model=\"vm.createCommand.subject\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\"><div \nclass=\"errors\" ng-messages=\"vm.createSignatureJobForm.subject.$error\" \nng-if=\"vm.createSignatureJobForm.subject.$touched\"><span ng-message=\"required\" \ntranslate=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SUBJECT_REQUIRED\"></span></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>{{ \'SIGNATURE_JOBS.SIGNATURE_JOB.TEXT\' | translate }}</label><textarea rows=\"5\" \nname=\"text\" ng-model=\"vm.createCommand.text\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container><div \nlayout=\"column\"><md-switch ng-model=\"vm.createCommand.shouldBeSigned\" ng-disabled=\"vm.isDisabled\" \nng-change=\"vm.onShouldBeSignedChanged(vm.createCommand.shouldBeSigned)\">\n{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.SHOULD_BE_SIGNED\" | translate }}</md-switch><md-switch \nng-model=\"vm.createCommand.useSequentialSigning\" ng-disabled=\"vm.isDisabled\">\n{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.USE_SEQUENTIAL_SIGNING\" | translate }}</md-switch><md-switch \nng-model=\"vm.createCommand.canForwardSignature\" ng-disabled=\"vm.isDisabled\">\n{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.CAN_FORWARD_SIGNATURE\" | translate }}</md-switch><md-switch \nng-model=\"vm.createCommand.isSelfSigning\" ng-disabled=\"vm.isDisabled\">\n{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.IS_SELF_SIGNING\" | translate }}</md-switch><md-switch \nng-model=\"vm.createCommand.useAutomaticReminders\" ng-disabled=\"vm.isDisabled\">\n{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.USE_AUTOMATIC_REMINDERS\" | translate }}</md-switch><md-switch \nng-model=\"vm.createCommand.sendAutomatically\" ng-disabled=\"vm.isDisabled\">\n{{ \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SEND_AUTOMATICALLY\" | translate }}</md-switch></div></div><div \nclass=\"recipients\"><h3 class=\"md-headline\">{{\"SIGNATURE_JOBS.SIGNATURE_JOB.RECIPIENTS\" | translate}}</h3><p>\n{{\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SELECT_RECIPIENT\" | translate}}</p><signature-job-recipients \nrecipients=\"vm.createCommand.recipients\" signature-job-signing-is-enabled=\"vm.createCommand.shouldBeSigned\" \nwork-order-id=\"vm.workOrderId\" ng-required=\"true\" ng-disabled=\"vm.isDisabled\"></signature-job-recipients></div></div>\n</div>");
$templateCache.put("app/main/signature-jobs/components/relevant-signature-jobs/relevant-signature-jobs.tmpl.html","<div class=\"relevant-signature-jobs mb-16\"><h3 class=\"md-title mt-0\">\n{{ \"SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS\" | translate }}</h3><div layout=\"row\" layout-wrap \nclass=\"signature-jobs\"><div layout=\"column\" class=\"relevant-signature-job w-200 md-whiteframe-4dp m-8 p-8\" \nng-repeat=\"signatureJob in vm.relevantSignatureJobs\"><md-tooltip ng-if=\"vm.disabledText && vm.isDisabled\" \nmd-direction=\"bottom\">{{vm.disabledText | translate}}</md-tooltip><h4 class=\"md-subhead text-center\">\n{{signatureJob.subject}}<div flex></div><div class=\"consignment-status\" \nng-style=\"{ \'color\': vm.getConsignmentStatusColor(signatureJob) }\">\n{{ vm.getConsignmentStatusText(signatureJob) | translate }}</div><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"!signatureJob.signatureJobId\" class=\"md-raised md-primary\" ng-click=\"vm.startConsignment($event, signatureJob)\" \naria-label=\"Start consignment\" translate-attr-aria-label=\"SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.START_CONSIGNMENT\">\n{{ \"SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.START_CONSIGNMENT\" | translate }}</md-button><md-button \nng-if=\"signatureJob.signatureJobId\" class=\"md-raised\" ng-click=\"vm.gotoConsignment(signatureJob)\" \naria-label=\"Go to consignment\" translate-attr-aria-label=\"SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.GO_TO_CONSIGNMENT\">\n{{ \"SIGNATURE_JOBS.RELEVANT_SIGNATURE_JOBS.GO_TO_CONSIGNMENT\" | translate }}</md-button></h4></div></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-authentication/signature-authentication.tmpl.html","<div class=\"signature-authentication\" layout=\"column\"><div class=\"title\" layout=\"row\">\n{{ \'SIGNATURE_JOBS.SIGNATURE_AUTHENTICATION.LOGIN_TO_GETACCEPT\' | translate }}</div><div ng-if=\"vm.isAuthenticated\" \nclass=\"content\" layout=\"row\"><md-icon md-font-icon=\"icon-thumb-up-outline\" class=\"md-primary-fg s48\"></md-icon>\n{{ \'SIGNATURE_JOBS.SIGNATURE_AUTHENTICATION.SIGNED_IN_TO_GETACCEPT\' | translate }}</div><div \nng-if=\"!vm.isAuthenticated\" class=\"content\" layout=\"row\" layout-align=\"center\"><div ng-if=\"vm.isLoading\" \nlayout=\"column\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!vm.isLoading\" \nlayout=\"column\"><div layout=\"row\" class=\"description\"><p>\n{{ \'SIGNATURE_JOBS.SIGNATURE_AUTHENTICATION.EXTERNAL_AUTHENTICATION_REQUIRED\' | translate }}</p></div><div \nlayout=\"row\" class=\"description\"><p>\n{{ \'SIGNATURE_JOBS.SIGNATURE_AUTHENTICATION.NOT_SIGNED_IN_TO_GETACCEPT\' | translate }}</p></div><div layout=\"row\" \nclass=\"description\"><p>{{ \'SIGNATURE_JOBS.SIGNATURE_AUTHENTICATION.SIGN_IN_TO_GETACCEPT_PROMPT\' | translate }}</p>\n</div><basic-auth-login-form default-credentials=\"vm.defaultCredentials\" \non-authenticate=\"vm.authenticate(credentials)\"></basic-auth-login-form></div></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-documents-list/signature-job-documents-list.tmpl.html","<div class=\"signature-job-documents-list\"><div ng-if=\"vm.documents.length == 0\">\n{{ \'SIGNATURE_JOBS.DOCUMENTS_LIST.NO_DOCUMENTS_IN_SIGNATURE_JOB\' | translate }}</div><div \nng-if=\"vm.documents.length > 0\"><div><span class=\"collapse-trigger\" ng-click=\"vm.toggleCollapse()\"><span \nng-if=\"vm.documents.length > 1\" translate=\"SIGNATURE_JOBS.DOCUMENTS_LIST.NUMBER_OF_DOCUMENTS_IN_SIGNATURE_JOB\" \ntranslate-values=\"{ numberOfDocuments: vm.documents.length }\"></span> <span ng-if=\"vm.documents.length == 1\" \ntranslate=\"SIGNATURE_JOBS.DOCUMENTS_LIST.ONE_DOCUMENT_IN_SIGNATURE_JOB\"></span><md-icon ng-show=\"vm.isCollapsed\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-hide=\"vm.isCollapsed\" md-font-icon=\"icon-chevron-up\"></md-icon>\n</span></div><div class=\"collapse-content\" ng-class=\"vm.isCollapsed ? \'collapse-hidden\' : \'collapse-visible\'\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"document mv-5\" ng-repeat=\"document in vm.documents\"><object \nng-if=\"document.objectURL\" data=\"{{document.objectURL}}\" type=\"application/pdf\" class=\"mr-16 w-50 h-75\"></object><div \nflex>{{document.fileName}}</div><md-button ng-disabled=\"!document.objectURL\" ng-click=\"vm.previewDocument(document)\" \nclass=\"md-icon-button\" aria-label=\"{{ \'COMMON.DATA.PREVIEW\' | translate }}\"><md-tooltip md-direction=\"bottom\">\n{{ \"COMMON.DATA.PREVIEW\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button><md-button \nng-disabled=\"!document.objectURL\" ng-click=\"vm.downloadDocument(document)\" class=\"md-icon-button\" \naria-label=\"{{ \'COMMON.DATA.DOWNLOAD\' | translate }}\"><md-tooltip md-direction=\"bottom\">\n{{ \"COMMON.DATA.DOWNLOAD\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-event-timeline/signature-job-event-timeline.tmpl.html","<div class=\"signature-job-event-timeline\"><div class=\"signature-job-event\" layout=\"row\" \nng-repeat-start=\"event in vm.events | orderBy: \'eventTime\'\"><div class=\"event-avatar\">\n{{vm.getInitials(event.eventInstigator)}}</div><div class=\"event-body\"><div class=\"mb-5\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"name\">{{event.eventInstigator}}</div><div class=\"status\" \nng-style=\"{\'background-color\': vm.getEventTypeColor(event.eventType) }\">\n{{ vm.getEventTypeText(event.eventType) | translate }}</div></div><div class=\"event-time\">\n{{ event.eventTime | date: \'fullDate\' }}, {{ event.eventTime | date: \'shortTime\' }}</div></div></div><div \nclass=\"signature-job-event-spacer\" ng-if=\"!$last\" ng-repeat-end></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-list-item/signature-job-list-item.tmpl.html","<div md-ink-ripple class=\"md-whiteframe-4dp m-8 signature-job-list-item\"><div layout=\"row\"><div class=\"preview-image\" \nng-if=\"vm.signatureJob.externalPreviewUrl\"><img width=\"100\" ng-src=\"{{vm.signatureJob.externalPreviewUrl}}\"></div><div \nflex class=\"description\"><div class=\"subject md-title\">{{vm.signatureJob.subject}}</div><div class=\"owner\">\n{{vm.signatureJob.owner.displayName}}<span ng-if=\"vm.signatureJob.createdAt\">\n, {{vm.signatureJob.createdAt | date: \'fullDate\'}}, {{vm.signatureJob.createdAt | date: \'shortTime\'}}</span></div><div \nclass=\"documents\" layout=\"row\" layout-wrap><div class=\"document\" ng-repeat=\"document in vm.signatureJob.documents\">\n{{document.fileName}}</div></div><div class=\"recipients\" layout=\"row\" layout-wrap><div class=\"recipient\" \nng-repeat=\"recipient in vm.signatureJob.recipients\"><div class=\"initials-and-status\" \nng-style=\"{ border: vm.getBorderStyleForStatus(recipient)}\">{{vm.getRecipientInitials(recipient)}}</div><div \nclass=\"email\">{{recipient.partyEmail}}</div></div></div></div><div layout=\"column\"><div class=\"text-center\"><md-icon \nmd-font-icon=\"{{vm.signatureJob.shouldBeSigned ? \'icon-pen\' : \'icon-email\'}}\"></md-icon></div><div layout=\"column\" \nlayout-align=\"center center\" flex><md-icon class=\"s48\" md-font-icon=\"icon-chevron-right\"></md-icon></div></div></div>\n</div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-recipients/signature-job-recipients.tmpl.html","<div class=\"signature-job-recipients\" ng-class=\"{ \'is-disabled\': vm.isDisabled }\" layout=\"column\" \nng-form=\"vm.selectForm\"><div><label class=\"md-caption\">{{ \"SIGNATURE_JOBS.SIGNATURE_JOB.RECIPIENTS\" | translate }}\n</label></div><md-chips flex name=\"recipients\" class=\"md-contact-chips signature-job-recipients-select md-block\" \nng-model=\"vm.recipients\" ng-required=\"vm.isRequired\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\" md-on-add=\"vm.addRecipient($chip)\" md-on-remove=\"vm.removeRecipient($chip)\" \nmd-removable=\"!vm.isDisabled\"><md-autocomplete md-selected-item=\"vm.selectedParticipant\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.recipientSearch(vm.searchText)\" md-item-text=\"item.displayName\" \nmd-min-length=\"0\" placeholder=\"{{ \'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SELECT_RECIPIENT\' | translate }}\" \nmd-menu-class=\"md-recipient-chips-suggestions\" ng-disabled=\"vm.isDisabled\"><div class=\"md-recipient-suggestion\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"avatar\"><img ng-if=\"item.imageUrl\" \nbaldris-img-src=\"item.imageUrl\" preset=\"square-40-cropped\" alt=\"{{ item.displayName }}\"><md-icon \nng-if=\"!item.imageUrl\" md-font-icon=\"{{ item.partyModelType === \'Person\' ? \'icon-account\' : \'icon-city\' }}\" \nclass=\"s40\"></md-icon></div><div class=\"info\"><div class=\"recipient\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"name\" md-highlight-text=\"vm.searchText\">\n{{ item.displayName || (item.lastName || \'\') + \', \' + (item.firstName || \'\') }}</div><div \nng-if=\"item.partyTypes.length > 0\" class=\"party-type\" ng-repeat=\"partyType in vm.getPartyTypes(item)\">\n{{partyType | translate}}</div></div><div class=\"contact-info\" layout=\"row\" layout-align=\"start center\"><div \nng-if=\"item.primaryEmail\" class=\"email\"><md-icon md-font-icon=\"icon-email\"></md-icon>{{ item.primaryEmail }}</div><div \nng-if=\"item.primaryTelephone\" class=\"phone\"><md-icon md-font-icon=\"icon-phone\"></md-icon>{{ item.primaryTelephone }}\n</div></div></div></div></md-autocomplete><md-chip-template><div class=\"md-contact-avatar\"><img \ngravatar-src=\"$chip.partyEmail\" gravatar-default=\"mm\" alt=\"{{ $chip.partyDisplayName }}\"></div><div \nclass=\"md-contact-name ng-binding\">{{ $chip.partyDisplayName }} <span ng-show=\"$chip.partyEmail\">\n({{ $chip.partyEmail }})</span></div><md-button ng-disabled=\"vm.isDisabled\" ng-if=\"vm.signatureJobSigningIsEnabled\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleRecipientRole($chip, $event)\"><md-tooltip md-direction=\"bottom\">\n{{ vm.getRecipientRoleTooltip($chip) | translate }}</md-tooltip><md-icon \nmd-font-icon=\"{{ vm.getRecipientRoleIcon($chip) }}\"></md-icon></md-button><md-button ng-disabled=\"vm.isDisabled\" \nng-if=\"vm.signatureJobSigningIsEnabled && $chip.shouldSign\" class=\"md-icon-button\" \nng-click=\"vm.toggleSigningMethod($chip, $event)\"><md-tooltip md-direction=\"bottom\">\n{{ $chip.signingMethod === \'email\' ? \'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_SIGN_EMAIL\' : \'SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENT_SHOULD_SIGN_BANK_ID\' | translate }}\n</md-tooltip><md-icon md-font-icon=\"{{$chip.signingMethod === \'email\' ? \'icon-email\' : \'icon-bank\'}}\"></md-icon>\n</md-button></md-chip-template></md-chips><div class=\"md-chips-messages\" \nng-show=\"vm.selectForm.recipients.$touched || vm.selectForm.$submitted\" ng-messages=\"vm.selectForm.recipients.$error\">\n<div ng-message=\"required\">{{ \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.RECIPIENTS_REQUIRED\" | translate }}</div></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-report-multi-select/signature-job-report-multi-select.tmpl.html","<div ng-form=\"vm.editForm\" ng-class=\"{ \'is-disabled\': vm.isDisabled }\" class=\"baldris-report-multi-select\"><md-chips \nflex class=\"md-block\" name=\"reportMultiSelect\" ng-model=\"vm.reports\" ng-required=\"vm.isRequired\" md-autocomplete-snap \nmd-require-match=\"true\" md-on-add=\"vm.onAddReport($chip)\" md-on-remove=\"vm.onRemoveReport($chip)\" \nmd-removable=\"!vm.isDisabled\" md-transform-chip=\"vm.onAppendChip($chip)\"><md-autocomplete \nplaceholder=\"{{ \'REPORTS.REPORT_SELECT.CHOOSE_REPORTS\' | translate }}\" ng-disabled=\"vm.isDisabled\" \nmd-selected-item=\"vm.selectedReport\" md-search-text=\"vm.searchText\" md-items=\"report in vm.querySearch(vm.searchText)\" \nmd-item-text=\"report.name\" md-min-length=\"vm.minLenght\" md-delay=\"500\" md-min-length=\"1\" ng-disabled=\"vm.isDisabled\" \nmd-menu-container-class=\"baldris-signature-job-report-suggestions\"><md-item-template><md-icon ng-if=\"report.iconName\" \nmd-font-icon=\"{{report.iconName}}\"></md-icon><md-icon ng-if=\"!report.iconName\" md-font-icon=\"icon-file-document\">\n</md-icon><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"i\" title=\"{{report.name}}\">{{ report.name }}\n</span> <em class=\"description\" title=\"{{report.description}}\">{{ report.description }}</em></md-item-template>\n</md-autocomplete><md-chip-template class=\"report-chip\">{{ $chip.fileName }}</md-chip-template></md-chips><div \nclass=\"md-chips-messages\" ng-show=\"vm.editForm.reportMultiSelect.$touched\" \nng-messages=\"vm.editForm.reportMultiSelect.$error\"><div ng-message=\"required\">\n{{\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.REPORTS_REQUIRED\" | translate}}</div></div></div>");
$templateCache.put("app/main/signature-jobs/components/signature-job-signed-documents-list/signature-job-signed-documents-list.tmpl.html","<div class=\"signature-job-documents-list\"><div ng-if=\"vm.documents.length == 0\">\n{{ \'SIGNATURE_JOBS.DOCUMENTS_LIST.NO_SIGNED_DOCUMENTS_IN_SIGNATURE_JOB\' | translate }}</div><div \nng-if=\"vm.documents.length > 0\"><div><span class=\"collapse-trigger\" ng-click=\"vm.toggleCollapse()\"><span \nng-if=\"vm.documents.length > 1\" translate=\"SIGNATURE_JOBS.DOCUMENTS_LIST.NUMBER_OF_SIGNED_DOCUMENTS_IN_SIGNATURE_JOB\" \ntranslate-values=\"{ numberOfDocuments: vm.documents.length }\"></span> <span ng-if=\"vm.documents.length == 1\" \ntranslate=\"SIGNATURE_JOBS.DOCUMENTS_LIST.ONE_SIGNED_DOCUMENT_IN_SIGNATURE_JOB\"></span><md-icon \nng-show=\"vm.isCollapsed\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-hide=\"vm.isCollapsed\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></span></div><div class=\"collapse-content\" \nng-class=\"vm.isCollapsed ? \'collapse-hidden\' : \'collapse-visible\'\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"document mv-5\" ng-repeat=\"document in vm.documents\"><object ng-if=\"document.objectURL\" \ndata=\"{{document.objectURL}}\" type=\"application/pdf\" class=\"mr-16 w-50 h-75\"></object><div flex><md-icon \nmd-font-icon=\"icon-file\"></md-icon>{{document.signedFileName}}<br><md-icon md-font-icon=\"icon-pen\"></md-icon>\n{{document.signaturesCompletedTime | date: \'short\'}}</div><md-button ng-disabled=\"!document.objectURL\" \nng-click=\"vm.previewDocument(document)\" class=\"md-icon-button\" aria-label=\"{{ \'COMMON.DATA.PREVIEW\' | translate }}\">\n<md-tooltip md-direction=\"bottom\">{{ \"COMMON.DATA.PREVIEW\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-eye\">\n</md-icon></md-button><md-button ng-disabled=\"!document.objectURL\" ng-click=\"vm.downloadDocument(document)\" \nclass=\"md-icon-button\" aria-label=\"{{ \'COMMON.DATA.DOWNLOAD\' | translate }}\"><md-tooltip md-direction=\"bottom\">\n{{ \"COMMON.DATA.DOWNLOAD\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/signature-jobs/consignment/create-consignment/create-consignment.tmpl.html","<div class=\"create-consignment m-16 p-16 md-whiteframe-1dp\" ng-form=\"vm.data.createForm\"><div \nng-if=\"!vm.isExternalServiceAuthenticated()\" class=\"not-authenticated p-16\"><h3 class=\"md-headline\">\n{{\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SIGN_IN_GET_ACCEPT\" | translate}}</h3><p>\n{{\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.SIGN_IN_WITH_EXTERNAL_REQUIRED\" | translate}}</p></div><create-signature-job \ncreate-command=\"vm.data.createCommand\" work-order-id=\"vm.workOrderId\" \nng-disabled=\"!vm.isExternalServiceAuthenticated() || vm.loadingService.isLoading\"></create-signature-job></div><div \nlayout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CANCEL\">\n{{ \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.export()\" \nng-disabled=\"!vm.data.canSave()\" aria-label=\"Export\" \ntranslate-attr-aria-label=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT\">\n{{ vm.data.createCommand.sendAutomatically ? \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT_AND_SEND\" : \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT\" | translate }}\n</md-button></div>");
$templateCache.put("app/main/signature-jobs/consignment/edit-consignment/edit-consignment.tmpl.html","<div class=\"edit-consignment m-16 p-16 md-whiteframe-1dp\"><h3 class=\"md-headline\">{{vm.signatureJob.subject}}</h3><h3 \nclass=\"md-title\">{{\"SIGNATURE_JOBS.SIGNATURE_JOB.RECIPIENTS\" | translate}}</h3><div class=\"recipients\" layout=\"row\" \nlayout-wrap><div class=\"recipient\" ng-repeat=\"recipient in vm.signatureJob.recipients\"><div \nclass=\"initials-and-status\" ng-style=\"{ border: vm.getBorderStyleForStatus(recipient)}\"><md-tooltip md-direction=\"top\">\n{{vm.getMostRelevantEventTypeText(recipient) | translate}}</md-tooltip>{{vm.getRecipientInitials(recipient)}}</div><div\n class=\"name\">{{recipient.partyDisplayName}}</div><div class=\"email\">({{recipient.partyEmail}})</div></div></div><h3 \nclass=\"mt-32 md-title\">{{\"SIGNATURE_JOBS.SIGNATURE_JOB.DOCUMENTS\" | translate}}</h3><signature-job-documents-list \ndocuments=\"vm.signatureJob.documents\" is-collapsed=\"true\"></signature-job-documents-list><h3 class=\"mt-32 md-title\">\n{{\"SIGNATURE_JOBS.SIGNATURE_JOB.SIGNED_DOCUMENTS\" | translate}}</h3><signature-job-signed-documents-list \ndocuments=\"vm.signatureJob.signedDocuments\"></signature-job-signed-documents-list><h3 class=\"mt-32 md-title\">\n{{\"SIGNATURE_JOBS.SIGNATURE_JOB.EVENTS\" | translate}}</h3><p \nng-if=\"!vm.signatureJob.events || vm.signatureJob.events.length === 0\">\n{{\"SIGNATURE_JOBS.EVENT_LIST.NO_EVENTS_IN_SIGNATURE_JOB\" | translate}}</p><signature-job-event-timeline \nevents=\"vm.signatureJob.events\" signature-job-signing-is-enabled=\"vm.signatureJob.shouldBeSigned\">\n</signature-job-event-timeline></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CANCEL\">\n{{ \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CANCEL\" | translate }}</md-button><md-button class=\"md-primary\" \nng-href=\"{{vm.getExternalUrl()}}\" target=\"_blank\" ng-disabled=\"!vm.isAuthenticated() || !vm.signatureJob.externalId\" \naria-label=\"Open Job in external\" translate-attr-aria-label=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.OPEN_EXTERNAL\">\n{{ \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.OPEN_EXTERNAL\" | translate }}</md-button></div>");
$templateCache.put("app/main/signature-jobs/dialogs/create-consignment-dialog/create-consignment-dialog.tmpl.html","<md-dialog class=\"create-consignment-dialog edit-dialog\" aria-label=\"Create Consignment\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\" translate=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CREATE_NEW_SIGNATURE_JOB\">\n</span> <span class=\"title\" ng-if=\"vm.createForm.$dirty\">*</span></div></md-toolbar><md-dialog-content \nng-form=\"vm.createForm\"><div class=\"authentication\"><signature-authentication></signature-authentication></div><div \nclass=\"create-form\"><create-signature-job ng-if=\"vm.createCommand\" create-command=\"vm.createCommand\" \nwork-order-id=\"vm.workOrderId\" ng-disabled=\"!vm.isExternalServiceAuthenticated() || vm.isDisabled\">\n</create-signature-job></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.export()\" ng-disabled=\"!vm.canSave()\" aria-label=\"Export\" \ntranslate-attr-aria-label=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT\">\n{{ vm.data.createCommand.sendAutomatically ? \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT_AND_SEND\" : \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT\" | translate }}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/song/components/song-select/song-select.tmpl.html","<div ng-form=\"vm.songForm\" class=\"baldris-song-select\"><md-autocomplete ng-if=\"!vm.hideLabel\" \nmd-min-length=\"vm.minLength\" md-autofocus=\"true\" flex md-delay=\"500\" md-min-length=\"1\" md-input-name=\"song\" \nmd-selected-item=\"vm.song\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.title\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-song-select\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nng-disabled=\"vm.isDisabled\" md-clear-button=\"true\"><md-item-template><div class=\"title\">{{ item.title }} <span \nng-if=\"item.originalTitle\" class=\"original-title\">{{ item.originalTitle }}</span> <span class=\"identifier\" \nng-if=\"item.identifier\">({{ item.identifier }})</span></div><div class=\"info\">{{ \'SONGS.SONG.INFO\' | translate }}: \n<span class=\"song-info\">{{ item.info }}</span></div></md-item-template><div ng-messages=\"vm.songForm.song.$error\" \nng-if=\"vm.songForm.song.$touched\"><div ng-message=\"invalidSong\"><span translate=\"SONGS.SONG_SELECT.INVALID_SONG\" \ntranslate-values=\"{ song: vm.searchText }\"></span></div></div></md-autocomplete><md-autocomplete ng-if=\"vm.hideLabel\" \nmd-min-length=\"vm.minLength\" md-autofocus=\"true\" flex md-delay=\"500\" md-min-length=\"1\" md-input-name=\"song\" \nmd-selected-item=\"vm.song\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.title\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-menu-class=\"autocomplete-song-select\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nng-disabled=\"vm.isDisabled\" md-clear-button=\"true\" \nplaceholder=\"{{ \'SONGS.SONG_SELECT.TYPE_IN_SONG_TITLE\' | translate }}\"><md-item-template><div class=\"title\">\n{{ item.title }} <span ng-if=\"item.originalTitle\" class=\"original-title\">{{ item.originalTitle }}</span> <span \nclass=\"identifier\" ng-if=\"item.identifier\">({{ item.identifier }})</span></div><div class=\"info\">\n{{ \'SONGS.SONG.INFO\' | translate }}: <span class=\"song-info\">{{ item.info }}</span></div></md-item-template><div \nng-messages=\"vm.songForm.song.$error\" ng-if=\"vm.songForm.song.$touched\"><div ng-message=\"invalidSong\"><span \ntranslate=\"SONGS.SONG_SELECT.INVALID_SONG\" translate-values=\"{ song: vm.searchText }\"></span></div></div>\n</md-autocomplete></div>");
$templateCache.put("app/main/song/edit-song/partials/edit-song-toolbar.tmpl.html","");
$templateCache.put("app/main/song/song-library/partials/song-library-sidebar.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"SONGS.SONG_LIBRARY.COLLECTIONS\" | translate }}</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.song.songLibrary.songList({ collectionName: \'all\' })\" \nng-class=\"{ \'selected\': vm.data.selectedCollection === \'all\', \'md-accent-bg\': vm.data.selectedCollection === \'all\' }\">\n<p><md-icon md-font-icon=\"icon-book-multiple\" class=\"s24\"></md-icon>{{ \"SONGS.SONG_LIBRARY.ALL\" | translate }}</p>\n</md-list-item><md-list-item ui-sref=\"app.song.songLibrary.songList({ collectionName: songCollectionName })\" \nng-class=\"{ \'selected\': vm.data.selectedCollection === songCollectionName, \'md-accent-bg\': vm.data.selectedCollection === songCollectionName }\" \nng-repeat=\"songCollectionName in vm.songCollectionNames | orderBy:\'\'\"><p><md-icon md-font-icon=\"icon-book\" class=\"s24\">\n</md-icon>{{ songCollectionName }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/song/song-library/song-list/song-list.tmpl.html","<div class=\"loading-bar\" ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><table \nng-if=\"!vm.loadingService.isLoading\" class=\"results simple clickable\" ms-responsive-table><thead><tr><th \nclass=\"text-center\">#</th><th translate=\"SONGS.SONG.TITLE\">Title</th><th translate=\"SONGS.SONG.INFO\">Info</th><th \ntranslate=\"SONGS.SONG.VERSES\">Verses</th></tr></thead><tbody><tr class=\"result-item song\" \nng-repeat=\"song in vm.data.currentSongs | orderBy:\'title\' | filter:vm.data.searchString\" \nng-class=\"{ \'is-deleted\': song.isDeleted }\" ui-sref=\"app.song.songLibrary.editSong({songId: song.id})\"><td \nclass=\"identifier text-center\">{{song.identifier}}</td><td class=\"title\" md-highlight-text=\"vm.searchTerm\" \nmd-highlight-flags=\"gi\">{{song.title}}</td><td class=\"info\">{{song.info}}</td><td class=\"verses\">{{song.verseCount}}\n</td></tr></tbody></table>");
$templateCache.put("app/main/statistics/ceremony/views/sidebar.tmpl.html","<div class=\"common-sidebar edit-location-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-filter\"></md-icon><span \nclass=\"title-text\">{{ \"COMMON.DATA.RANGE\" | translate }}</span></div></div><div layout=\"column\" layout-padding>\n<md-select ng-model=\"vm.service.dataRoute\" ng-change=\"vm.service.onUpdate()\" placeholder=\"Data range\" \nclass=\"md-no-underline\"><md-option value=\"PerCeremonyType\">{{ \"STATISTICS.CEREMONY.PER_CEREMONY_TYPE\" | translate }}\n</md-option><md-option value=\"PerLocation\">{{ \"STATISTICS.CEREMONY.PER_LOCATION\" | translate }}</md-option><md-option \nvalue=\"PerDepartment\">{{ \"STATISTICS.CEREMONY.PER_DEPARTMENT\" | translate }}</md-option><md-option value=\"PerLiturgy\">\n{{ \"STATISTICS.CEREMONY.PER_LITURGY\" | translate }}</md-option><md-option value=\"PerLiturgyAndCeremonyType\">\n{{ \"STATISTICS.CEREMONY.PER_LITURGY_AND_CEREMONY_TYPE\" | translate }}</md-option></md-select><md-radio-group \nng-model=\"vm.service.calculationRoute\" ng-change=\"vm.service.onUpdate()\"><md-radio-button value=\"ByCeremonyDate\">\n{{ \"STATISTICS.CEREMONY.BY_CEREMONY_DATE\" | translate }}</md-radio-button><md-radio-button value=\"ByDateOfDeath\">\n{{ \"STATISTICS.CEREMONY.BY_DATE_OF_DEATH\" | translate }}</md-radio-button></md-radio-group><md-select \nng-model=\"vm.service.currentRange\" ng-change=\"vm.setNewRange()\" placeholder=\"Date range\" class=\"md-no-underline\">\n<md-option value=\"THIS_MONTH\">{{ \"STATISTICS.DATES.THIS_MONTH\" | translate }}</md-option><md-option value=\"LAST_MONTH\">\n{{ \"STATISTICS.DATES.LAST_MONTH\" | translate }}</md-option><md-option value=\"THIS_YEAR\">\n{{ \"STATISTICS.DATES.THIS_YEAR\" | translate }}</md-option><md-option value=\"LAST_YEAR\">\n{{ \"STATISTICS.DATES.LAST_YEAR\" | translate }}</md-option><md-option value=\"CUSTOM_RANGE\">\n{{ \"STATISTICS.DATES.CUSTOM_RANGE\" | translate }}</md-option></md-select><md-divider \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\"></md-divider><div \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" layout=\"row\" layout-align=\"space-between center\"><md-select \nng-model=\"vm.service.selectedMonth\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Month\" \nclass=\"md-no-underline\"><md-option ng-value=\"-1\">{{ \"STATISTICS.DATES.ALL_YEAR\" | translate }}</md-option><md-option \nng-repeat=\"month in vm.service.months\" ng-value=\"month.momentNumber\">{{ month.monthName | translate }}</md-option>\n</md-select><md-select ng-model=\"vm.service.selectedYear\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Year\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"year in vm.service.getYears()\" ng-value=\"year\">{{ year }}</md-option>\n</md-select></div><date-range-select mode=\"vertical\" ng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" \nstart-date=\"vm.service.fromDate\" end-date=\"vm.service.toDate\" on-update=\"vm.service.onUpdate()\"></date-range-select>\n</div></div>");
$templateCache.put("app/main/statistics/ceremony/views/toolbar.tmpl.html","<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{vm.getTitle() | translate}}</h2></div></md-toolbar>");
$templateCache.put("app/main/statistics/deceased/views/sidebar.tmpl.html","<div class=\"common-sidebar edit-location-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-filter\"></md-icon><span \nclass=\"title-text\">{{ \"COMMON.DATA.RANGE\" | translate }}</span></div></div><div layout=\"column\" layout-padding>\n<md-select ng-model=\"vm.service.dataRoute\" ng-change=\"vm.service.onUpdate()\" placeholder=\"Data range\" \nclass=\"md-no-underline\"><md-option value=\"PerMunicipalityOfResidence\">\n{{ \"STATISTICS.DECEASED.PER_MUNICIPALITY_OF_RESIDENCE\" | translate }}</md-option><md-option \nvalue=\"PerCeremonyMunicipality\">{{ \"STATISTICS.DECEASED.PER_CEREMONY_MUNICIPALITY\" | translate }}</md-option><md-option\n value=\"PerDepartment\">{{ \"STATISTICS.DECEASED.PER_DEPARTMENT\" | translate }}</md-option></md-select><md-radio-group \nng-model=\"vm.service.calculationRoute\" ng-change=\"vm.service.onUpdate()\"><md-radio-button value=\"ByCeremonyDate\">\n{{ \"STATISTICS.DECEASED.BY_CEREMONY_DATE\" | translate }}</md-radio-button><md-radio-button value=\"ByDateOfDeath\">\n{{ \"STATISTICS.DECEASED.BY_DATE_OF_DEATH\" | translate }}</md-radio-button></md-radio-group><md-select \nng-model=\"vm.service.currentRange\" ng-change=\"vm.setNewRange()\" placeholder=\"Date range\" class=\"md-no-underline\">\n<md-option value=\"THIS_MONTH\">{{ \"STATISTICS.DATES.THIS_MONTH\" | translate }}</md-option><md-option value=\"LAST_MONTH\">\n{{ \"STATISTICS.DATES.LAST_MONTH\" | translate }}</md-option><md-option value=\"THIS_YEAR\">\n{{ \"STATISTICS.DATES.THIS_YEAR\" | translate }}</md-option><md-option value=\"LAST_YEAR\">\n{{ \"STATISTICS.DATES.LAST_YEAR\" | translate }}</md-option><md-option value=\"CUSTOM_RANGE\">\n{{ \"STATISTICS.DATES.CUSTOM_RANGE\" | translate }}</md-option></md-select><md-divider \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\"></md-divider><div \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" layout=\"row\" layout-align=\"space-between center\"><md-select \nng-model=\"vm.service.selectedMonth\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Month\" \nclass=\"md-no-underline\"><md-option ng-value=\"-1\">{{ \"STATISTICS.DATES.ALL_YEAR\" | translate }}</md-option><md-option \nng-repeat=\"month in vm.service.months\" ng-value=\"month.momentNumber\">{{ month.monthName | translate }}</md-option>\n</md-select><md-select ng-model=\"vm.service.selectedYear\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Year\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"year in vm.service.getYears()\" ng-value=\"year\">{{ year }}</md-option>\n</md-select></div><date-range-select mode=\"vertical\" ng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" \nstart-date=\"vm.service.fromDate\" end-date=\"vm.service.toDate\" on-update=\"vm.service.onUpdate()\"></date-range-select>\n</div></div>");
$templateCache.put("app/main/statistics/deceased/views/toolbar.tmpl.html","<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{vm.getTitle() | translate}}</h2></div></md-toolbar>");
$templateCache.put("app/main/statistics/sales/views/sidebar.tmpl.html","<div class=\"common-sidebar edit-location-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-filter\"></md-icon><span \nclass=\"title-text\">{{ \"COMMON.DATA.RANGE\" | translate }}</span></div></div><div layout=\"column\" layout-padding>\n<md-select ng-model=\"vm.service.dataRoute\" ng-change=\"vm.service.onUpdate()\" placeholder=\"Data range\" \nclass=\"md-no-underline\"><md-option value=\"PerProductType\">{{ \"STATISTICS.SALES.PER_PRODUCT_TYPE\" | translate }}\n</md-option><md-option value=\"PerProduct\">{{ \"STATISTICS.SALES.PER_PRODUCT\" | translate }}</md-option><md-option \nvalue=\"PerDepartment\">{{ \"STATISTICS.SALES.PER_DEPARTMENT\" | translate }}</md-option></md-select><md-radio-group \nng-model=\"vm.service.calculationRoute\" ng-change=\"vm.service.onUpdate()\"><md-radio-button value=\"ByInvoiceDate\">\n{{ \"STATISTICS.SALES.BY_INVOICE_DATE\" | translate }}</md-radio-button><md-radio-button value=\"BySalesOrderDate\">\n{{ \"STATISTICS.SALES.BY_SALES_ORDER_DATE\" | translate }}</md-radio-button></md-radio-group><md-select \nng-model=\"vm.service.currentRange\" ng-change=\"vm.setNewRange()\" placeholder=\"Date range\" class=\"md-no-underline\">\n<md-option value=\"THIS_MONTH\">{{ \"STATISTICS.DATES.THIS_MONTH\" | translate }}</md-option><md-option value=\"LAST_MONTH\">\n{{ \"STATISTICS.DATES.LAST_MONTH\" | translate }}</md-option><md-option value=\"THIS_YEAR\">\n{{ \"STATISTICS.DATES.THIS_YEAR\" | translate }}</md-option><md-option value=\"LAST_YEAR\">\n{{ \"STATISTICS.DATES.LAST_YEAR\" | translate }}</md-option><md-option value=\"CUSTOM_RANGE\">\n{{ \"STATISTICS.DATES.CUSTOM_RANGE\" | translate }}</md-option></md-select><md-divider \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\"></md-divider><div \nng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" layout=\"row\" layout-align=\"space-between center\"><md-select \nng-model=\"vm.service.selectedMonth\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Month\" \nclass=\"md-no-underline\"><md-option ng-value=\"-1\">{{ \"STATISTICS.DATES.ALL_YEAR\" | translate }}</md-option><md-option \nng-repeat=\"month in vm.service.months\" ng-value=\"month.momentNumber\">{{ month.monthName | translate }}</md-option>\n</md-select><md-select ng-model=\"vm.service.selectedYear\" \nng-change=\"vm.service.setYearMonth(vm.service.selectedYear, vm.service.selectedMonth)\" placeholder=\"Year\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"year in vm.service.getYears()\" ng-value=\"year\">{{ year }}</md-option>\n</md-select></div><date-range-select mode=\"vertical\" ng-if=\"vm.service.currentRange === \'CUSTOM_RANGE\'\" \nstart-date=\"vm.service.fromDate\" end-date=\"vm.service.toDate\" on-update=\"vm.service.onUpdate()\"></date-range-select>\n</div></div>");
$templateCache.put("app/main/statistics/sales/views/toolbar.tmpl.html","<md-toolbar class=\"md-primary\"><div class=\"md-toolbar-tools\"><h2>{{vm.getTitle() | translate}}</h2></div></md-toolbar>");
$templateCache.put("app/main/transactional-mail/components/transactional-email-address-list/transactional-email-address-list.tmpl.html","<div class=\"transactional-email-address-list\" layout=\"column\"><h4 class=\"md-caption\">\n{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.TO\" | translate }}</h4><md-chips class=\"email-to-list\" \nng-model=\"vm.transactionalEmailAddresses\" md-add-on-blur=\"true\" md-removable=\"true\" \nmd-transform-chip=\"vm.transformChip($chip)\" md-on-remove=\"vm.onRemoveChip($chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedSearchItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.partyDisplayName + \' (\' + item.emailAddress + \')\'\" \nmd-min-length=\"2\" md-menu-class=\"baldris-email-search\" md-delay=\"500\" \nplaceholder=\"{{ \'TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.ADD_RECIPIENT\' | translate }}\"><md-item-template><md-checkbox \nng-checked=\"vm.isAdded(item)\" ng-click=\"vm.addEmailItem(item, $event)\"></md-checkbox><strong>\n{{ item.partyDisplayName }}</strong> <em md-highlight-text=\"vm.searchText\">({{ item.emailAddress }})</em>\n</md-item-template></md-autocomplete><md-chip-template><span><strong>{{ $chip.name }}</strong> <em>({{ $chip.email }})\n</em></span></md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</button></md-chips><md-button class=\"margin-top -10 margin-bottom-10 md-block\" ng-if=\"vm.emailSuggestions.length > 0\" \nng-click=\"vm.showSuggestions = ! vm.showSuggestions\">\n{{ vm.showSuggestions ? \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.HIDE_SUGGESTIONS\" : (\"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SHOW_SUGGESTIONS\" | translate) }}\n</md-button><div ng-if=\"vm.emailSuggestions.length > 0 && vm.showSuggestions\" class=\"email-suggestions\" layout=\"row\" \nlayout-wrap layout-align=\"end start\"><span ng-if=\"vm.isNotSelected(suggestion)\" \nclass=\"suggestion-container clickable md-accent-bg\" ng-repeat=\"suggestion in vm.emailSuggestions\" \nng-click=\"vm.selectSuggestion(suggestion)\"><span class=\"name\">{{ suggestion.fullName }}</span> <span class=\"relevance\" \ntitle=\"{{ suggestion.relevance }}\">{{ suggestion.relevance ? suggestion.relevance.substring(0, 13) : \"\" }}<span \nng-if=\"suggestion.relevance.length > 13\">...</span></span> <span class=\"email\">{{ suggestion.email }}</span></span>\n</div></div>");
$templateCache.put("app/main/transactional-mail/dialogs/add-custom-email-recipient-dialog/add-custom-email-recipient-dialog.tmpl.html","<md-dialog class=\"send-email-dialog edit-dialog\" aria-label=\"Send email\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{\'TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SEND_EMAIL\' | translate}}</span></div></md-toolbar>\n<md-dialog-content layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{\'TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.EMAIL_RECIPIENT.EMAIL\' | translate}}</label><input \nng-model=\"vm.recipient.email\" type=\"email\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.EMAIL_RECIPIENT.NAME\' | translate}}</label><input \nng-model=\"vm.recipient.name\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Send\" \nng-disabled=\"!vm.recipient.email || !vm.recipient.name\" class=\"md-primary\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'COMMON.DIALOG.OK\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/transactional-mail/dialogs/send-email-dialog/send-email-dialog.tmpl.html","<md-dialog class=\"send-email-dialog edit-dialog\" aria-label=\"Send email\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SEND_EMAIL\" | translate }}</span></div></md-toolbar>\n<md-dialog-content><div ng-if=\"!vm.isProcessing\" ng-form=\"vm.emailForm\" layout=\"column\"><div><md-input-container \nclass=\"md-block\"><label>{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.FROM\" | translate }}</label><md-select \nng-model=\"vm.email.from\"><md-option ng-repeat=\"emailAddress in vm.fromList\" ng-value=\"emailAddress\">\n{{ emailAddress.name }} ({{ emailAddress.email }})</md-option></md-select></md-input-container><md-input-container>\n<md-checkbox ng-checked=\"vm.useUserAddressAsDefault\" ng-click=\"vm.toggleUseUserAddressAsDefault()\">\n{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.USE_MY_ADDRESS_AS_DEFAULT_ON_THIS_BROWSER\" | translate }}</md-checkbox>\n</md-input-container><md-input-container \nng-if=\"vm.trackableEmailsIsAllowed && (vm.email.originType === \'Invoice\' || vm.email.originType === \'SalesOrder\')\">\n<md-checkbox ng-checked=\"!vm.email.skipTracking\" ng-click=\"vm.email.skipTracking = !vm.email.skipTracking\">\n{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.TRACK_THIS_EMAIL\" | translate }}</md-checkbox></md-input-container></div><div\n layout=\"column\"><h4 class=\"md-caption\">{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.TO\" | translate }}</h4><md-chips \nclass=\"email-to-list\" ng-model=\"vm.email.to\" md-removable=\"true\" md-transform-chip=\"vm.transformChip($chip)\">\n<md-autocomplete md-selected-item=\"vm.selectedSearchItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.partyDisplayName + \' (\' + item.emailAddress + \')\'\" \nmd-min-length=\"2\" md-menu-class=\"baldris-email-search\" md-delay=\"500\" \nplaceholder=\"{{ \'TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.ADD_RECIPIENT\' | translate }}\"><md-item-template><md-checkbox \nng-checked=\"vm.isAdded(item)\" ng-click=\"vm.addEmailItem(item, $event)\"></md-checkbox><strong>\n{{ item.partyDisplayName }}</strong> <em md-highlight-text=\"vm.searchText\">({{ item.emailAddress }})</em>\n</md-item-template></md-autocomplete><md-chip-template><span><strong>{{ $chip.name }}</strong> <em>({{ $chip.email }})\n</em></span></md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</button></md-chips><md-button class=\"margin-top -10 margin-bottom-10 md-block\" ng-if=\"vm.emailSuggestions.length > 0\" \nng-click=\"vm.showSuggestions = ! vm.showSuggestions\">\n{{ vm.showSuggestions ? \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.HIDE_SUGGESTIONS\" : (\"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SHOW_SUGGESTIONS\" | translate) }}\n</md-button><div ng-if=\"vm.emailSuggestions.length > 0 && vm.showSuggestions\" class=\"email-suggestions\" layout=\"row\" \nlayout-wrap layout-align=\"end start\"><span ng-if=\"vm.isNotSelected(suggestion)\" \nclass=\"suggestion-container clickable md-accent-bg\" ng-repeat=\"suggestion in vm.emailSuggestions\" \nng-click=\"vm.selectSuggestion(suggestion)\"><span class=\"name\">{{ suggestion.fullName }}</span> <span class=\"relevance\" \ntitle=\"{{ suggestion.relevance }}\">{{ suggestion.relevance ? suggestion.relevance.substring(0, 13) : \"\" }}<span \nng-if=\"suggestion.relevance.length > 13\">...</span></span> <span class=\"email\">{{ suggestion.email }}</span></span>\n</div></div><h4 class=\"md-caption\">{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.ATTACHMENTS\" | translate }}</h4><div \nng-repeat=\"attachment in vm.email.attachments\" class=\"margin-bottom-20\"><a target=\"_blank\" \nng-href=\"{{ vm.getPreviewUrl(attachment) }}\"><md-icon md-font-icon=\"icon-file\"></md-icon>{{ attachment.filename }}</a>\n<md-button class=\"md-icon-button\" aria-label=\"Remove attachment\" ng-click=\"vm.removeAttachment(attachment)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"password-protection\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.togglePasswordProtection()\"><md-icon \nmd-font-icon=\"{{ !vm.password ? \'icon-lock\' : \'icon-lock-unlocked\'}}\"></md-icon>\n{{!vm.password ? \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.PASSWORD_PROTECT\" : \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.REMOVE_PASSWORD_PROTECTION\" | translate }}\n</md-button><div ng-if=\"vm.password\" class=\"padding-top-20\"><md-input-container class=\"md-block\"><label>\n{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.PASSWORD\" | translate }}</label><input ng-model=\"vm.password\">\n</md-input-container></div></div><div class=\"padding-top-20\"><md-input-container class=\"md-block\"><label>\n{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.SUBJECT\" | translate }}</label><input ng-model=\"vm.email.subject\" \nng-required=\"true\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"TRANSACTIONAL_MAILS.TRANSACTIONAL_MAIL.BODY\" | translate }}</label><textarea ng-model=\"vm.email.bodyText\" rows=\"7\">\n</textarea></md-input-container></div></div><div ng-if=\"vm.isProcessing\" layout=\"row\" layout-align=\"space-around\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Send\" \nng-disabled=\"!vm.email.to || vm.email.to.length === 0 || vm.emailForm.$invalid\" class=\"md-primary\" \nng-click=\"vm.sendEmail()\">{{ \"TRANSACTIONAL_MAILS.SEND_EMAIL_DIALOG.SEND\" | translate }}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/transport/components/transport-card/transport-card.tmpl.html","<md-card class=\"transport-card\"><md-card-header class=\"clickable\" ng-click=\"vm.navigateToTransport()\"><md-card-avatar>\n<md-icon ng-if=\"vm.baldrisModel.calendarEventTypeIconName\" \nmd-font-icon=\"{{vm.baldrisModel.calendarEventTypeIconName}}\" \nng-style=\"{ \'background-color\': vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\', \'color\': vm.getForegroundColor(vm.baldrisModel.calendarEventTypeColor || \'#2E8AE9\') }\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.calendarEventTypeIconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.calendarEventTypeName}}</span> <span \nclass=\"md-subhead\"><span class=\"icon icon-calendar\"></span> {{vm.baldrisModel.start | date:\'fullDate\'}} <span \nclass=\"icon icon-clock\"></span> {{vm.baldrisModel.start | date:\'shortTime\'}} <span ng-if=\"!vm.baldrisModel.start\">\n{{\'CEREMONIES.CEREMONY_CARD.STARTTIME_UNSET\' | translate}}</span></span></md-card-header-text></md-card-header>\n<md-card-title class=\"clickable\" ng-click=\"vm.navigateToTransport()\"><md-card-title-text><span class=\"md-headline\" \nng-bind-html=\"vm.baldrisModel.deceasedSerialized | serializedList\"></span></md-card-title-text></md-card-title>\n<md-card-content class=\"clickable\" ng-click=\"vm.navigateToTransport()\"><div layout=\"row\"><div flex \nng-if=\"vm.baldrisModel.originSerialized || vm.baldrisModel.originName\"><label class=\"md-caption\">\n{{\'TRANSPORTS.TRANSPORT.ORIGIN\' | translate}}</label><p>\n{{vm.baldrisModel.originSerialized || vm.baldrisModel.originName}}</p></div><div flex \nng-if=\"vm.baldrisModel.destinationSerialized || vm.baldrisModel.destinationName\"><label class=\"md-caption\">\n{{\'TRANSPORTS.TRANSPORT.DESTINATION\' | translate}}</label><p>\n{{vm.baldrisModel.destinationSerialized || vm.baldrisModel.destinationName}}</p></div></div><div layout=\"row\"><div \nflex ng-if=\"vm.baldrisModel.transportBySerialized || vm.baldrisModel.transportByLookupValue\"><label class=\"md-caption\">\n{{\'TRANSPORTS.TRANSPORT.TRANSPORT_BY\' | translate}}</label><p>\n{{vm.baldrisModel.transportBySerialized || vm.baldrisModel.transportByLookupValue}}</p></div><div flex \nng-if=\"vm.baldrisModel.deceased.casketName\"><label class=\"md-caption\">{{\'DECEASED.DECEASED.CASKET\' | translate}}\n</label><p>{{vm.baldrisModel.deceased.casketName}}</p></div></div><div ng-if=\"vm.baldrisModel.attendeesSerialized\">\n<label class=\"md-caption\">{{\'TRANSPORTS.TRANSPORT_CARD.ASSISTANTS\' | translate}}</label><p \nng-bind-html=\"vm.baldrisModel.attendeesSerialized | serializedList\"></p></div><div ng-if=\"vm.baldrisModel.isCompleted\">\n<label class=\"md-caption\">{{\'TRANSPORTS.TRANSPORT.COMPLETED_BY\' | translate}}</label><p>\n{{vm.baldrisModel.completedByDisplayName}}, {{vm.baldrisModel.completedTime | date:\'short\'}}</p></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-accent\" \naria-label=\"Edit\" ng-click=\"vm.navigateToTransport()\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" ng-click=\"vm.deleteTransport()\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon></md-button></md-card-actions></md-card>");
$templateCache.put("app/main/transport/components/transport-list-item/transport-list-item.tmpl.html","<div class=\"transport-list-item clickable\" ng-class=\"vm.getTransportClasses(vm.baldrisModel)\" layout=\"column\" \nlayout-gt-xs=\"row\" ng-click=\"vm.showEditTransportDialog(vm.baldrisModel, $event)\"><div flex layout=\"column\"><div \nclass=\"transport-type\">{{ vm.baldrisModel.calendarEventTypeName }} <span \nng-show=\"vm.showDeceased && vm.baldrisModel.deceasedSerialized\">– {{ vm.baldrisModel.deceasedSerialized }}</span></div>\n<div class=\"transport-description\">\nFra {{ vm.baldrisModel.originSerialized }} til {{ vm.baldrisModel.destinationSerialized }}</div><div \nclass=\"transport-time\"><span class=\"icon icon-calendar\"></span> {{ vm.baldrisModel.start | date:\'fullDate\' }} <span \nclass=\"icon icon-clock\"></span> {{ vm.baldrisModel.start | date:\'shortTime\' }}</div><div \nng-show=\"vm.baldrisModel.isCompleted\">\n{{\'TRANSPORTS.TRANSPORT.COMPLETED_BY\' | translate}} {{vm.baldrisModel.completedByDisplayName}}, {{vm.baldrisModel.completedTime | date:\'short\'}}\n</div></div><div layout=\"column\" layout-align=\"start end\"><md-checkbox \nng-click=\"vm.toggleTransport(vm.baldrisModel, $event)\" ng-checked=\"vm.baldrisModel.isCompleted\" \naria-label=\"{{ \'TRANSPORTS.TRANSPORT.IS-COMPLETED\' | translate }}\"></md-checkbox></div></div>");
$templateCache.put("app/main/transport/components/transport-type-select/transport-type-select.tmpl.html","<md-input-container ng-form=\"vm.transportTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.transportType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"transportType\" ng-model=\"vm.transportTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentTransportType in vm.transportTypes | orderBy:\'name\'\" ng-value=\"currentTransportType.id\">\n{{currentTransportType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.transportTypeForm.transportType.$error\" ng-if=\"vm.transportTypeForm.transportType.$dirty\"><div \nng-message=\"required\"><span translate=\"TRANSPORTS.EDIT_TRANSPORT.TRANSPORT_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/transport/edit-transport/views/sidebar.tmpl.html","<div ng-include=\"\'app/main/calendar/edit-calendar-event/views/sidebar.tmpl.html\'\"></div>");
$templateCache.put("app/main/transport/edit-transport/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"TRANSPORTS.EDIT_TRANSPORT.EDITING_TEXT\" \ntranslate-values=\"{ transportString: vm.data.getCalendarEventString() }\"></span> <span \nng-if=\"vm.data.validation.calendarEventForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"TRANSPORTS.EDIT_TRANSPORT.SAVE\">\n<md-tooltip md-direction=\"top\"><span translate=\"TRANSPORTS.EDIT_TRANSPORT.SAVE\"></span></md-tooltip><md-icon \nclass=\"md-primary-fg\" md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"TRANSPORTS.EDIT_TRANSPORT.CANCEL\"><md-tooltip \nmd-direction=\"top\"><span translate=\"TRANSPORTS.EDIT_TRANSPORT.CANCEL\"></span></md-tooltip><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/transport/edit-transport/views/transport-calendar-event.tmpl.html","<div layout=\"column\"><div layout=\"row\" layout-gt-sm=\"row\"><div layout=\"column\" flex-gt-sm=\"50\"><location-select \nclass=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.origin\" \nlocation-id=\"vm.data.updateModel.calendarEvent.originId\" label-text=\"{{ \'TRANSPORTS.TRANSPORT.ORIGIN\' | translate }}\">\n</location-select><div><md-input-container flex class=\"md-block\"><label>\n{{ \"TRANSPORTS.TRANSPORT.ORIGIN_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.originRemarks\"></md-input-container></div></div><div layout=\"column\" \nflex-gt-sm=\"50\"><location-select class=\"margin-bottom\" location=\"vm.data.updateModel.calendarEvent.destination\" \nlocation-id=\"vm.data.updateModel.calendarEvent.destinationId\" \nlabel-text=\"{{ \'TRANSPORTS.TRANSPORT.DESTINATION\' | translate }}\"></location-select><div><md-input-container flex \nclass=\"md-block\"><label>{{ \"TRANSPORTS.TRANSPORT.DESTINATION_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.destinationRemarks\"></md-input-container></div></div></div>\n<date-time-range-select start-time=\"vm.data.updateModel.calendarEvent.start\" \nend-time=\"vm.data.updateModel.calendarEvent.end\"></date-time-range-select><label class=\"md-caption\">\n{{ \"CEREMONIES.CEREMONY.ASSISTANTS\" | translate }}</label><calendar-event-users class=\"margin-bottom\" \nevent-users=\"vm.data.updateModel.calendarEventUsers\"></calendar-event-users></div>");
$templateCache.put("app/main/transport/edit-transport/views/transport-general.tmpl.html","<div layout=\"column\"><lookup-string-select min-query-length=\"0\" \nlookup-string-id=\"vm.data.updateModel.calendarEvent.transportById\" \nlookup-string=\"vm.data.updateModel.calendarEvent.transportBy\" \nlabel-text=\"{{\'TRANSPORTS.TRANSPORT.TRANSPORT_BY\' | translate}}\" lookup-string-config=\"\'TransportByLookupStringType\'\">\n</lookup-string-select><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\n{{\'TRANSPORTS.TRANSPORT.DISTANCE\' | translate }}</label><input ng-model=\"vm.data.updateModel.calendarEvent.distance\" \ntype=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.DRIVER_HOURS\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.driverHours\" type=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\n{{\'TRANSPORTS.TRANSPORT.ADDITIONAL_HOURS\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.additionalHours\" type=\"number\" step=\"0.1\" \nng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.ADDITIONAL_COST\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.additionalCost\" ng-currency ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<md-input-container class=\"md-block\"><label>{{\'TRANSPORTS.TRANSPORT.PRICE\' | translate }}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.price\" ng-currency ng-change=\"vm.data.registerPrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>{{ \'TRANSPORTS.TRANSPORT.PRICE_REMARKS\' | translate}}</label><textarea\n ng-model=\"vm.data.updateModel.calendarEvent.priceRemarks\"></textarea></md-input-container><bill-to-select \nbill-to=\"vm.data.updateModel.calendarEvent.billTo\" label-text=\"{{ \'TRANSPORTS.TRANSPORT.BILL_TO\' | translate}}\">\n</bill-to-select><md-input-container class=\"md-block\" flex><label>\n{{ \'TRANSPORTS.TRANSPORT.TRANSPORT_DESCRIPTION\' | translate}}</label><input \nng-model=\"vm.data.updateModel.calendarEvent.transportDescription\"></md-input-container><md-input-container flex><label>\n{{\'TRANSPORTS.TRANSPORT.REMARKS\' | translate }}</label><textarea ng-model=\"vm.data.updateModel.calendarEvent.remarks\">\n</textarea></md-input-container></div>");
$templateCache.put("app/main/transport/logistics/dashboard/transport-logistics-dashboard.tmpl.html","<div ng-if=\"vm.currentData.isSet\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-click=\"vm.goToState(\'deceased\')\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{\'TRANSPORTS.LOGISTICS.DECEASED\' | translate }}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\">{{vm.currentData.deceased.length || 0}}</div><div\n class=\"h3 font-weight-500\">{{\'TRANSPORTS.LOGISTICS.DECEASED\' | translate }}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-click=\"vm.goToState(\'dates\')\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'TRANSPORTS.LOGISTICS.DATES\' | translate }}</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\">\n{{vm.currentData.dates.length || 0}}</div><div class=\"h3 font-weight-500\">\n{{\'TRANSPORTS.LOGISTICS.ACTIVE_DATES\' | translate }}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-click=\"vm.goToState(\'locations\')\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{\'TRANSPORTS.LOGISTICS.LOCATIONS\' | translate }}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\">{{vm.currentData.locations.length || 0}}</div>\n<div class=\"h3 font-weight-500\">{{\'TRANSPORTS.LOGISTICS.ACTIVE_LOCATIONS\' | translate }}</div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140 clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nng-click=\"vm.goToState(\'completed\')\"><ms-widget-front class=\"p-16 green-bg white-fg\" layout=\"row\" flex><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">\n{{vm.getFinishedCount()}}</div><div class=\"font-weight-500 secondary-text\">\n{{\'TRANSPORTS.LOGISTICS.COMPLETED_TRANSPORTS\' | translate }}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-140 clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-click=\"vm.goToState(\'upcoming\')\">\n<ms-widget-front class=\"p-16 orange-bg white-fg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">{{vm.getUnfinishedCount()}}</div><div \nclass=\"font-weight-500 secondary-text\">{{\'TRANSPORTS.LOGISTICS.UPCOMING_TRANSPORTS\' | translate }}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140 clickable\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\" ng-click=\"vm.goToState(\'overdue\')\"><ms-widget-front class=\"p-16 red-bg white-fg\" layout=\"row\" flex><div\n class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">\n{{vm.getOverdueCount()}}</div><div class=\"font-weight-500 secondary-text\">\n{{\'TRANSPORTS.LOGISTICS.OVERDUE_TRANSPORTS\' | translate }}</div></div></ms-widget-front></ms-widget></div><div \nng-if=\"!vm.currentData.isSet\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/transport/logistics/dates/transport-logistics-dates.tmpl.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><div flex=\"none\" flex-gt-sm=\"33\" \nng-repeat=\"date in vm.currentData.dates | orderBy:\'date\'\"><md-card class=\"date-transports-list-card\"><md-card-title>\n<md-card-title-text><span class=\"md-headline\">{{ date.date | date:\'fullDate\' }}</span></md-card-title-text>\n</md-card-title><md-card-content ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><div class=\"transport-list\" \nlayout=\"column\"><transport-list-item ng-repeat=\"transport in date.transports | orderBy:\'start\'\" \nbaldris-model=\"transport\" on-change=\"vm.onChangedTransport\" show-deceased=\"true\"></transport-list-item></div>\n</md-card-content></md-card></div></div>");
$templateCache.put("app/main/transport/logistics/deceased/transport-logistics-deceased.tmpl.html","<div layout=\"column\" layout-gt-sm=\"row\" layout-wrap><div flex-gt-sm=\"33\" \nng-repeat=\"deceased in vm.currentData.deceased | orderBy:\'displayName\'\"><md-card class=\"deceased-transports-list-card\">\n<md-card-header ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><md-card-avatar><img \ngravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"></md-card-avatar><md-card-header-text><span class=\"md-title\">\n{{deceased.displayName}}</span> <span class=\"md-subhead\"><span class=\"icon icon-cake\"></span>\n {{deceased.dateOfBirth | date:\'shortDate\'}} <span class=\"icon icon-hanger\"></span>\n {{deceased.dateOfDeath | date:\'shortDate\'}}</span></md-card-header-text></md-card-header><md-card-content \nng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><div class=\"transport-list\" layout=\"column\"><transport-list-item \nng-repeat=\"transport in deceased.transports | orderBy:\'start\'\" baldris-model=\"transport\" \non-change=\"vm.onChangedTransport\"></transport-list-item></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/transport/logistics/locations/transport-logistics-locations.tmpl.html","<div layout=\"column\"><md-card ng-repeat=\"location in vm.currentData.locations | orderBy:\'name\'\" \nclass=\"location-transports-list-card\"><md-card-header ng-click=\"vm.navigateToDeceased(vm.baldrisModel)\">\n<md-card-avatar><md-icon md-font-icon=\"icon-help\"></md-icon></md-card-avatar><md-card-header-text><span \nclass=\"md-title\">{{location.name}}</span></md-card-header-text></md-card-header><md-card-content \nng-click=\"vm.navigateToDeceased(vm.baldrisModel)\"><div class=\"transport-list\" layout=\"column\"><div hide-xs \nclass=\"header-row\" layout=\"column\" layout-gt-xs=\"row\"><div flex=\"33\" class=\"header-text\">\n{{\'TRANSPORTS.LOGISTICS.DECEASED\' | translate}}</div><div flex=\"33\" class=\"header-text\">\n{{\'TRANSPORTS.LOGISTICS.BROUGHT_BY\' | translate}}</div><div flex=\"33\" class=\"header-text\">\n{{\'TRANSPORTS.LOGISTICS.NEXT_LOCATION\' | translate}}</div></div><div class=\"deceased-transport\" \nng-repeat=\"deceased in location.deceased\" layout=\"column\" layout-gt-xs=\"row\"><div flex-gt-sm=\"33\" class=\"deceased\">\n<span class=\"header-text\" hide-gt-xs>{{\'TRANSPORTS.LOGISTICS.DECEASED\' | translate}}: </span><span class=\"name\">\n{{ deceased.displayName}}</span></div><div flex-gt-sm=\"33\" class=\"current-location\"><span class=\"header-text\" \nhide-gt-xs>{{\'TRANSPORTS.LOGISTICS.BROUGHT_BY\' | translate}}: </span>\n{{ vm.getCurrentTransport(deceased).completedByDisplayName }}</div><div flex-gt-sm=\"33\" class=\"next-destination\" \nlayout=\"row\"><div flex class=\"name\"><span class=\"header-text\" hide-gt-xs>\n{{\'TRANSPORTS.LOGISTICS.NEXT_LOCATION\' | translate}}: </span>{{ vm.getNextTransport(deceased).destinationSerialized }}\n</div><md-checkbox ng-disabled=\"!vm.getNextTransport(deceased)\" \nng-click=\"vm.toggleTransport(vm.getNextTransport(deceased))\" ng-checked=\"vm.getNextTransport(deceased).isCompleted\" \naria-label=\"{{ \'TRANSPORTS.TRANSPORT.IS-COMPLETED\' | translate }}\"></md-checkbox></div></div></div></md-card-content>\n</md-card></div>");
$templateCache.put("app/main/work-order/components/work-order-attachment-list/work-order-attachment-list.tmpl.html","<div class=\"work-order-attachment-list\" flex layout=\"row\" layout-align=\"center start\" layout-wrap><md-card \nng-if=\"!vm.loadingService.isLoading\" class=\"file-container\" \nng-repeat=\"attachment in vm.attachments | orderBy:\'fileName\'\" \nng-class=\" { \'md-accent-bg\': vm.isAttachmentSelected(attachment) }\"><img baldris-img-src=\"attachment.fileUrl\" \npreset=\"square-250-padded\" ng-if=\"attachment.fileContentType.indexOf(\'image\') > -1\" class=\"md-card-image clickable\" \nalt=\"{{ attachment.fileName }}\" ng-click=\"vm.toggleSelected(attachment, $event)\"><div \nng-if=\"attachment.fileContentType.indexOf(\'image\') == -1\" class=\"icon-container clickable\" \nng-click=\"vm.toggleSelected(attachment, $event)\"><md-icon ng-if=\"attachment.fileContentType.indexOf(\'pdf\') > -1\" \nmd-font-icon=\"icon-file-pdf\" class=\"md-avatar-icon s96\"></md-icon><md-icon \nng-if=\"attachment.fileContentType.indexOf(\'pdf\') == -1\" md-font-icon=\"icon-file\" class=\"md-avatar-icon s96\"></md-icon>\n</div><md-card-title class=\"clickable\" ng-click=\"vm.toggleSelected(attachment, $event)\"><md-card-title-text><span \nclass=\"md-headline\">{{ attachment.fileName }}</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" \nlayout-align=\"start center\"><md-card-icon-actions layout-align=\"end center\"><md-button target=\"_blank\" \nng-href=\"{{ attachment.fileUrl }}\" class=\"md-icon-button\" aria-label=\"{{ \'COMMON.DATA.DOWNLOAD\' | translate }}\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon></md-button><md-button ng-click=\"vm.downloadSingle(attachment, $event)\" \nclass=\"md-icon-button\" aria-label=\"{{ \'COMMON.DATA.DOWNLOAD\' | translate }}\"><md-icon md-font-icon=\"icon-download\">\n</md-icon></md-button><md-button ng-click=\"vm.toggleSelected(attachment, $event)\" class=\"md-icon-button\" \naria-label=\"{{ \'COMMON.DATA.DOWNLOAD\' | translate }}\"><md-icon md-font-icon=\"icon-check\"></md-icon></md-button>\n</md-card-icon-actions></md-card-actions></md-card></div><lf-ng-md-file-input lf-files=\"vm.uploadFiles\" \nmultiple=\"multiple\" ng-hide=\"vm.loadingService.isLoadingBackground\" \nlf-browse-label=\"{{ \'COMMON.DATA.CHOOSE\' | translate }}\" name=\"files\" \nlf-remove-label=\"{{ \'COMMON.DATA.RESET\' | translate }}\" \nlf-drag-and-drop-label=\"{{ \'COMMON.DATA.DRAG_AND_DROP_HERE\' | translate }}\" drag preview></lf-ng-md-file-input>\n<md-button ng-disabled=\"!vm.uploadFiles || vm.uploadFiles.length < 1\" \naria-label=\"{{ \'COMMON.DIALOG.UPLOAD_FILES\' | translate }}\" ng-hide=\"vm.loadingService.isLoadingBackground\" \nng-click=\"vm.uploadSelectedFiles()\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n{{ \"COMMON.DIALOG.UPLOAD_FILES\" | translate }}</md-button>");
$templateCache.put("app/main/work-order/components/work-order-deceased-card/work-order-deceased-card.tmpl.html","");
$templateCache.put("app/main/work-order/components/work-order-list-item/work-order-list-item.tmpl.html","<div class=\"baldris-work-order-list-item clickable\" md-ink-ripple layout=\"column\" ng-click=\"vm.navigateToWorkOrder()\">\n<div class=\"header md-primary-bg md-hue-2\" layout=\"row\"><div class=\"marker\" \nng-style=\"{ \'background-color\': vm.baldrisModel.firstCeremony.calendarEventTypeColor }\"></div><div flex \nclass=\"deceased\"><span ng-repeat=\"deceased in vm.baldrisModel.deceased\">{{deceased}} <span ng-if=\"!$last\">//</span>\n</span></div><div class=\"order-code\">{{vm.baldrisModel.orderCode}}</div></div><div class=\"body\" layout=\"column\" \nlayout-gt-xs=\"row\"><div flex-gt-xs class=\"details\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"department-name\" flex-gt-xs=\"33\">{{vm.baldrisModel.department.displayName}}</div><div class=\"other-details\" \nflex-gt-xs><span class=\"work-order-type\">{{vm.baldrisModel.workOrderType}}</span> <span \nng-if=\"vm.baldrisModel.firstCeremony\"><span class=\"ceremony-type\">| {{vm.baldrisModel.firstCeremony.calendarEventType}}\n<span ng-if=\"vm.baldrisModel.firstCeremony.location\">, {{vm.baldrisModel.firstCeremony.location}}</span></span> <span \nng-if=\"vm.baldrisModel.firstCeremony.startTime\" class=\"ceremony-time\">\n| {{vm.baldrisModel.firstCeremony.startTime | date:\'short\' }}</span></span></div></div><div class=\"assistants\">\n{{\'WORK_ORDERS.WORK_ORDER.CASEWORKER\' | translate}}: {{vm.baldrisModel.caseWorker.displayName}}</div></div>\n<notes-and-tasks-summary completed-count=\"vm.baldrisModel.completedTasksCount\" \nuncompleted-count=\"vm.baldrisModel.uncompletedTasksCount\" notes-count=\"vm.baldrisModel.notesCount\">\n</notes-and-tasks-summary></div></div>");
$templateCache.put("app/main/work-order/components/work-order-options-select/work-order-options-select.tmpl.html","<div class=\"work-order-options-select\"><label class=\"md-caption\">{{vm.labelText}}</label><div class=\"baldris-options\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><md-checkbox ng-if=\"option.value > 0\" \nng-repeat=\"option in vm.workOrderOptions\" ng-checked=\"vm.isSelected(option)\" ng-click=\"vm.toggle(option)\">\n{{ option.text | translate }}</md-checkbox></div></div>");
$templateCache.put("app/main/work-order/components/work-order-select/work-order-select.tmpl.html","<div class=\"baldris-work-order-select\"><div layout=\"column\"><div ng-form=\"vm.workOrderForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"workOrder\" md-selected-item=\"vm.workOrder\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.orderCode + \' – \' + item.workOrderType\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-work-order-select\" ng-disabled=\"vm.isDisabled || false\" \nng-required=\"vm.isRequired || false\"><md-item-template class=\"work-order-item\"><div class=\"department\">\n{{item.department.displayName}}</div><div class=\"work-order-type\"><span><md-icon \nmd-font-icon=\"{{item.workOrderTypeIcon || \'icon-briefcase\'}}\"></md-icon></span><span md-highlight-text=\"vm.searchText\">\n{{item.orderCode}}</span> – {{item.workOrderType}}</div><div class=\"deceased\"><span ng-if=\"item.deceased\" \nclass=\"deceased-item\" ng-repeat=\"deceased in item.deceased\">{{deceased}}</span></div><div class=\"case-worker\">\n{{\'WORK_ORDERS.WORK_ORDER.CASEWORKER\' | translate}}: {{item.caseWorker.displayName}}</div></md-item-template><div \nng-messages=\"vm.workOrderForm.workOrder.$error\" ng-if=\"vm.workOrderForm.workOrder.$touched\"><div \nng-message=\"md-require-match\"><span translate=\"WORK_ORDERS.WORK_ORDER_SELECT.INVALID_WORK_ORDER\" \ntranslate-values=\"{ workOrder: vm.searchText }\"></span></div><div ng-message=\"invalidWorkOrder\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER_SELECT.INVALID_WORK_ORDER\" translate-values=\"{ workOrder: vm.searchText }\"></span>\n</div></div></md-autocomplete></div></div></div>");
$templateCache.put("app/main/work-order/dashboard/latest-view/work-order-dashboard-latest.tmpl.html","<md-list class=\"work-order-list md-dense\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"list-title\" \ntranslate=\"WORK_ORDERS.DASHBOARD.LATEST\" translate-values=\"{ amount: vm.latestAmount }\"></div></md-subheader>\n<work-order-list-item baldris-model=\"workOrder\" ng-repeat=\"workOrder in vm.workOrders\"></work-order-list-item><div \nng-if=\"vm.isLoadingWorkOrders\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-list>");
$templateCache.put("app/main/work-order/dashboard/partials/work-order-dashboard-sidebar.tmpl.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{\'WORK_ORDERS.DASHBOARD.WORK_ORDER_TYPES\' | translate}}</span>\n</div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list class=\"work-order-types-list\">\n<md-list-item ng-click=\"vm.selectWorkOrderType(null)\" \nng-class=\"{\'selected\': !vm.currentData.selectedWorkOrderType, \'md-accent-bg\': !vm.currentData.selectedWorkOrderType}\">\n<p><md-icon md-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon>\n{{ \'WORK_ORDERS.DASHBOARD.ALL_WORK_ORDER_TYPES\' | translate }}</p></md-list-item><md-list-item \nng-repeat=\"workOrderType in vm.currentData.workOrderTypes | orderBy:\'name\'\" \nng-click=\"vm.selectWorkOrderType(workOrderType)\" \nng-class=\"{\'selected\':vm.currentData.selectedWorkOrderType === workOrderType, \'md-accent-bg\': vm.currentData.selectedWorkOrderType === workOrderType}\">\n<p><md-icon ng-if=\"!workOrderType.imageFilePath && !workOrderType.iconName\" md-font-icon=\"icon-briefcase\" class=\"s24\">\n</md-icon><md-icon ng-if=\"!workOrderType.imageFilePath && workOrderType.iconName\" \nmd-font-icon=\"{{workOrderType.iconName}}\" class=\"s24\"></md-icon><img ng-if=\"workOrderType.imageFilepath\" \nbaldris-img-src=\"workOrderType.imageFilepath\" preset=\"square-40-cropped\" class=\"md-avatar\" \nalt=\"{{workOrderType.name}}\"> {{ workOrderType.name }}</p></md-list-item></md-list><md-divider \nng-if=\"vm.currentData.departments.length > 1\"></md-divider><md-list ng-if=\"vm.currentData.departments.length > 1\" \nclass=\"department-list\"><md-list-item ng-click=\"vm.selectDepartment(null)\" \nng-class=\"{\'selected\': !vm.currentData.selectedDepartment, \'md-accent-bg\': !vm.currentData.selectedDepartment}\"><p>\n<md-icon md-font-icon=\"icon-store\" class=\"s24\"></md-icon>{{ \'WORK_ORDERS.DASHBOARD.ALL_DEPARTMENTS\' | translate }}</p>\n</md-list-item><md-list-item ng-repeat=\"department in vm.currentData.departments | orderBy:\'organizationDisplayName\'\" \nng-click=\"vm.selectDepartment(department)\" \nng-class=\"{\'selected\':vm.currentData.selectedDepartment === department, \'md-accent-bg\': vm.currentData.selectedDepartment === department}\">\n<p><md-icon ng-if=\"!department.imageFilePath\" md-font-icon=\"icon-store\" class=\"s24\"></md-icon><img \nng-if=\"department.imageFilePath\" baldris-img-src=\"department.imageFilePath\" preset=\"square-40-padded\" \nclass=\"md-avatar\" alt=\"{{department.organizationDisplayName}}\"> {{ department.organizationDisplayName }}</p>\n</md-list-item></md-list></div>");
$templateCache.put("app/main/work-order/dialogs/add-ceremony-dialog/add-ceremony-dialog.tmpl.html","<md-dialog class=\"add-ceremony-dialog edit-dialog\" aria-label=\"Add Ceremony\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{\'CEREMONIES.ADD_CEREMONY.ADD_NEW_CEREMONY\' | translate}}</span></div></md-toolbar>\n<md-dialog-content><p>{{ \'CEREMONIES.ADD_CEREMONY.SELECT_CEREMONY_TYPE\' | translate}}</p><div layout=\"column\" \nng-form=\"vm.addCeremonyForm\"><ceremony-type-select is-required=\"true\" preselect-include-options=\"vm.includeOptions\" \npreselect-exclude-options=\"vm.excludeOptions\" flex ceremony-type-id=\"vm.ceremonyTypeId\" \nceremony-type=\"vm.ceremonyType\" label-text=\"{{\'CEREMONIES.CEREMONY_TYPE.CEREMONY_TYPE\' | translate}}\">\n</ceremony-type-select></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\" ng-disabled=\"vm.addCeremonyForm.$invalid\">\n{{ \'CEREMONIES.ADD_CEREMONY.ADD_CEREMONY\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-grave-dialog/add-grave-dialog.tmpl.html","<md-dialog class=\"add-grave-dialog edit-dialog\" aria-label=\"Add Grave\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'GRAVES.ADD_GRAVE.ADD_NEW_GRAVE\' | translate}}</span></div></md-toolbar><md-dialog-content><div \nlayout=\"column\" ng-if=\"!vm.isLoadingDeceased && vm.foundDeceasedWithoutGrave\"><p>\n{{ \'GRAVES.ADD_GRAVE.SELECT_GRAVE_TYPE\' | translate}}</p><div layout=\"column\" ng-form=\"vm.addGraveForm\">\n<grave-type-select is-required=\"true\" flex grave-type-id=\"vm.grave.graveTypeId\" grave-type=\"vm.grave.graveType\" \nlabel-text=\"{{\'GRAVES.GRAVE.GRAVE_TYPE\' | translate}}\"></grave-type-select></div><div ng-if=\"vm.suggestedLeaseHolder\">\n<p class=\"suggested-header\">{{ \'GRAVES.ADD_GRAVE.USE_FOLLOWING_LEASEHOLDER\' | translate}}</p><md-input-container>\n<md-checkbox ng-checked=\"vm.grave.leaseHolderId !== null\" ng-click=\"vm.toggleSuggestedLeaseHolder()\">\n{{ vm.suggestedLeaseHolder.lastName }}, {{ vm.suggestedLeaseHolder.firstName }}<br><small>\n{{ vm.getReferencePersonTypesString(vm.suggestedLeaseHolder.referencePersonType) }}</small></md-checkbox>\n</md-input-container></div><div ng-if=\"vm.suggestedPrevioulsyBuried\"><p class=\"suggested-header\">\n{{ \'GRAVES.ADD_GRAVE.USE_FOLLOWING_PREVIOUSLY_BURIED\' | translate}}</p><md-input-container><md-checkbox \nng-checked=\"vm.grave.previouslyBuriedId !== null\" ng-click=\"vm.toggleSuggestedPreviouslyBuried()\">\n{{ vm.suggestedPrevioulsyBuried.lastName }}, {{ vm.suggestedPrevioulsyBuried.firstName }}<br><small>\n{{ vm.getReferencePersonTypesString(vm.suggestedPrevioulsyBuried.referencePersonType) }}</small></md-checkbox>\n</md-input-container></div></div><div layout=\"column\" ng-if=\"!vm.isLoadingDeceased && !vm.foundDeceasedWithoutGrave\">\n<p>{{ \'GRAVES.ADD_GRAVE.NO_DECEASED_FOUND\' | translate}}</p></div><div ng-if=\"vm.isLoadingDeceased\" layout=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-if=\"!vm.isLoadingDeceased && vm.foundDeceasedWithoutGrave\" ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"vm.addGraveForm.$invalid\">{{ \'GRAVES.ADD_GRAVE.ADD_GRAVE\' | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-grooming-transport-dialog/add-grooming-transport-dialog.tmpl.html","<md-dialog class=\"add-grooming-transport-dialog edit-dialog\" aria-label=\"Add Grooming/Transport\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">\n{{\'TRANSPORTS.ADD_GROOMING_TRANSPORT.ADD_NEW_GROOMING_TRANSPORT\' | translate}}</span></div></md-toolbar>\n<md-dialog-content><div ng-if=\"vm.isLoadingSuggestedTransports\" layout=\"row\" layout-align=\"center center\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!vm.isLoadingSuggestedTransports && vm.suggestedTransports.length > 0\"><p>\n{{ \'TRANSPORTS.ADD_GROOMING_TRANSPORT.SUGGESTED_TRANSPORTS\' | translate}}</p><md-list><md-list-item class=\"md-3-line\" \nng-repeat-start=\"suggestedTransport in vm.suggestedTransports | orderBy:[\'description\']\" \nng-click=\"vm.selectSuggestion(suggestedTransport)\" \nng-class=\"{ \'md-accent-bg\': suggestedTransport === vm.selectedSuggestion }\"><md-icon \nmd-font-icon=\"{{ suggestedTransport.suggestedTransportTypeIconName || \'icon-truck\' }}\" class=\"s24\"></md-icon><div \nclass=\"md-list-item-text\"><h3>{{ suggestedTransport.description }}</h3><h4>\n{{ suggestedTransport.suggestedTransportTypeName }}</h4><p>{{ suggestedTransport.remarks }}</p></div></md-list-item>\n<md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><p>\n{{ \'TRANSPORTS.ADD_GROOMING_TRANSPORT.SELECT_TYPE\' | translate}}</p><div layout=\"column\" ng-form=\"vm.addTransportForm\">\n<calendar-event-type-select is-required=\"true\" flex calendar-event-type-id=\"vm.model.calendarEventTypeId\" \ncalendar-event-type=\"vm.model.calendarEventType\" label-text=\"{{\'TRANSPORTS.TRANSPORT.TRANSPORT_TYPE\' | translate}}\" \noptions-filter=\"\'isTransport, isGrooming\'\"></calendar-event-type-select></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"(vm.isTransport && vm.addTransportForm.$invalid) || (!vm.isTransport && vm.addGroomingForm.$invalid)\">\n{{ \'TRANSPORTS.ADD_GROOMING_TRANSPORT.OK_ADD\' | translate}}</md-button><md-button class=\"md-raised\" \nng-if=\"vm.selectedSuggestion\" ng-click=\"vm.selectSuggestionAndClose()\">\n{{ \'TRANSPORTS.ADD_GROOMING_TRANSPORT.OK_ADD_SUGGESTION\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-headstone-order-dialog/add-headstone-order-dialog.tmpl.html","<md-dialog class=\"add-headstone-order-dialog edit-dialog\" \naria-label=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.CREATE_HEADSTONE_ORDER\' | translate}}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.CREATE_HEADSTONE_ORDER\' | translate}}\n</span></div></md-toolbar><md-dialog-content><p>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.SELECT_HEADSTONE_ORDER_TYPE\' | translate}}</p><div layout=\"column\" \nng-form=\"vm.addHeadstoneOrderForm\"><external-order-type-select is-required=\"true\" flex \nexternal-order-type-id=\"vm.externalOrderId\" external-order-type=\"vm.externalOrderType\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.EXTERNAL_ORDER_TYPE\' | translate}}\" \nexternal-order-type-config=\"\'HeadstoneOrderType\'\"></external-order-type-select></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"vm.addHeadstoneOrderForm.$invalid\">{{ \'COMMON.DIALOG.OK_CHOOSE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-obituary-notice-dialog/add-obituary-notice-dialog.tmpl.html","<md-dialog class=\"add-obituary-notice-dialog edit-dialog\" aria-label=\"Add Obituary Notice\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'WORK_ORDERS.ADD_OBITUARY_NOTICE_DIALOG.TITLE\' | translate}}</span>\n</div></md-toolbar><md-dialog-content layout=\"column\"><md-radio-group ng-model=\"vm.type\"><md-radio-button ng-value=\"1\" \nclass=\"md-primary\">{{\'WORK_ORDERS.ADD_OBITUARY_NOTICE_DIALOG.ADSTATE_NOTICE\' | translate}}</md-radio-button>\n<md-radio-button ng-value=\"2\">{{\'WORK_ORDERS.ADD_OBITUARY_NOTICE_DIALOG.CUSTOM_NOTICE\' | translate}}</md-radio-button>\n</md-radio-group><md-select ng-model=\"vm.selectedDeceased\" placeholder=\"Select Deceased\"><md-option \nng-repeat=\"deceased in vm.deceased\" ng-value=\"deceased\">{{ deceased.lastName }}, {{ deceased.firstName}}</md-option>\n</md-select></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button class=\"md-primary\" \nng-click=\"vm.closeAndCreate()\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-program-dialog/add-program-dialog.tmpl.html","<md-dialog class=\"add-program-dialog edit-dialog\" aria-label=\"Add Program\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{\'PROGRAMS.ADD_PROGRAM.ADD_NEW_PROGRAM\' | translate}}</span></div></md-toolbar><md-dialog-content>\n<p>{{ \'PROGRAMS.ADD_PROGRAM.SELECT_CEREMONY\' | translate}}</p><div layout=\"column\" ng-form=\"vm.addProgramForm\">\n<upcoming-ceremony-select ceremony=\"vm.ceremony\" ceremony-id=\"vm.ceremonyId\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.CEREMONY\' | translate}}\" work-order-id=\"vm.workOrderId\" \ndepartment-id=\"vm.departmentId\" select-ceremonial-on-load=\"true\"></upcoming-ceremony-select></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"!vm.ceremony\">{{ \'PROGRAMS.ADD_PROGRAM.ADD_PROGRAM\' | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-reference-person-dialog/add-reference-person-dialog.tmpl.html","<md-dialog class=\"add-reference-person-dialog edit-dialog\" aria-label=\"Add Reference Person\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.title | translate}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div flex-gt-xs=\"50\"><md-input-container class=\"md-block\">\n<label>{{\'PARTY.PERSON.LASTNAME\' | translate }}</label><input ng-model=\"vm.newPerson.lastName\" \nng-change=\"vm.onNameChange()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" \nflex md-autofocus></md-input-container></div><div flex-gt-xs=\"50\"><md-input-container class=\"md-block\"><label>\n{{\'PARTY.PERSON.FIRSTNAME\' | translate }}</label><input ng-model=\"vm.newPerson.firstName\" \nng-change=\"vm.onNameChange()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\">\n</md-input-container></div></div><div ng-if=\"!vm.isSearching && vm.searchResults && vm.searchResults.length > 0\" \nclass=\"search-results\"><h3 translate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.FOUND_MATCHES\" \ntranslate-values=\"{ count: vm.searchResults.length }\">Found matches</h3><p class=\"md-caption\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.CLICK_TO_SELECT\">Click to select</p><md-virtual-repeat-container>\n<md-list flex><div ng-if=\"vm.isSearching\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResults\"><md-list-item ng-click=\"vm.selectPerson(item)\" class=\"md-3-line\" flex \nng-class=\"{ \'md-accent-bg\': item.id == vm.selectedParty.id }\"><img ng-if=\"!item.imageUrl\" class=\"md-avatar\" \ngravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img ng-if=\"item.imageUrl\" class=\"md-avatar\" \nbaldris-img-src=\"item.imageUrl\" preset=\"square-40-cropped\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.displayName }}</h3><h4>{{ item.dateOfBirth | date:\'shortDate\' }} {{ item.socialSecurityNumber }}</h4><p><span \nng-repeat=\"partyType in item.partyTypes\">{{ partyType.name }}<span ng-if=\"!$last\">,</span></span></p></div>\n</md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list></md-virtual-repeat-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.openSearchDialog()\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.OPEN_SEARCH_DIALOG\">Open search dialog</md-button><span flex></span>\n<md-button ng-disabled=\"vm.isSearching\" ng-if=\"vm.selectedParty\" class=\"md-primary\" ng-click=\"vm.choosePerson()\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.ADD_SELECTED_REFERENCE_PERSON\" \ntranslate-values=\"{ referencePersonName: vm.selectedParty.displayName }\">Add selected person</md-button><md-button \nng-disabled=\"vm.isSearching\" ng-if=\"!vm.selectedParty\" class=\"md-primary\" ng-click=\"vm.chooseNew()\">\n{{ vm.addText | translate}}</md-button><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-to-existing-sales-order-dialog/add-to-existing-sales-order-dialog.tmpl.html","<md-dialog class=\"add-to-existing-sales-order-dialog edit-dialog\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.INVOICING.ADD_TO_EXISTING_SALES_ORDER\' | translate }}\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.INVOICING.ADD_TO_EXISTING_SALES_ORDER\' | translate }}</span></div></md-toolbar>\n<md-dialog-content><md-content class=\"sales-orders\" layout=\"column\" layout-padding><div \nng-if=\"!vm.updateModel.salesOrder\" class=\"sales-orders-list\"><div class=\"title\">\n{{ \'WORK_ORDERS.WORK_ORDER.INVOICING.SELECT_SALES_ORDER\' | translate }}</div><div md-ink-ripple \nclass=\"sales-order clickable md-body-1\" ng-click=\"vm.selectSalesOrder(salesOrder)\" \nng-repeat-start=\"salesOrder in vm.salesOrders | orderBy:\'sortOrder\'\"><div class=\"details\" layout-padding \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" layout-align-gt-sm=\"start center\"><div flex-gt-sm=\"20\" \nclass=\"product-code text-bold\">{{salesOrder.orderCode}}</div><div flex-gt-sm=\"20\" class=\"product-name\">\n{{salesOrder.createdTime | date:\'shortDate\'}}</div><div flex-gt-sm=\"40\" class=\"amount\">\n{{salesOrder.customerPartyDisplayName | translate}}</div><div flex-gt-sm=\"20\" class=\"price text-right\">\n{{salesOrder.totalSumIncludingVat | currency}}</div></div><div ng-if=\"salesOrder.subject\" \nclass=\"sales-order-subject md-caption\" layout-padding layout=\"column\">{{salesOrder.subject}}</div></div><md-divider \nng-if=\"!$last\" ng-repeat-end></md-divider></div><div ng-if=\"vm.updateModel.salesOrder\" class=\"selected-sales-order\">\n<div class=\"title\">{{ \'WORK_ORDERS.WORK_ORDER.INVOICING.ADDING_TO_SALES_ORDER\' | translate }}</div><div \nclass=\"sales-order md-body-1\"><div class=\"details\" layout-padding layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" layout-align-gt-sm=\"start center\"><div flex-gt-sm=\"20\" class=\"product-code text-bold\">\n{{vm.selectedSalesOrder.orderCode}}</div><div flex-gt-sm=\"20\" class=\"product-name\">\n{{vm.selectedSalesOrder.createdTime | date:\'shortDate\'}}</div><div flex-gt-sm=\"40\" class=\"amount\">\n{{vm.selectedSalesOrder.customerPartyDisplayName | translate}}</div><div flex-gt-sm=\"20\" class=\"price text-right\">\n{{vm.selectedSalesOrder.totalSumIncludingVat | currency}}</div></div><div ng-if=\"vm.selectedSalesOrder.subject\" \nclass=\"sales-order-subject md-caption\" layout-padding layout=\"column\">{{vm.selectedSalesOrder.subject}}</div></div>\n</div></md-content><div ng-if=\"vm.updateModel.salesOrder\" class=\"line-item-list\" \nng-if=\"vm.lineItems && vm.lineItems.length > 0\"><md-list><md-subheader class=\"md-no-sticky\">\n{{\'SALES_ORDERS.INVOICE.ORDER_LINES_TO_ADD\' | translate}}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.toggleAllLineItems()\"><div class=\"md-list-item-text\"><h3 class=\"product-name\">\n{{ vm.selectedLineItems.length > 0 ? \'SALES_ORDERS.INVOICE.REMOVE_ALL\' : \'SALES_ORDERS.INVOICE.ADD_ALL\' | translate }}\n</h3></div><md-checkbox class=\"md-secondary\" ng-checked=\"vm.selectedLineItems.length > 0\" \nng-click=\"vm.toggleAllLineItems()\"></md-checkbox></md-list-item><md-divider></md-divider><md-list-item \nclass=\"md-2-line\" ng-repeat=\"lineItem in vm.lineItems | orderBy:\'sortOrder\'\" ng-click=\"vm.toggleLineItem(lineItem)\">\n<div class=\"md-list-item-text\"><h3 class=\"product-name\">\n{{ lineItem.productAmount }} {{ lineItem.workOrderProduct.productUnitType }} – {{ lineItem.productName }}</h3><p>\n{{ vm.getTotalPrice(lineItem) | currency }} – <span \nng-repeat=\"billToOption in vm.getBillToText(lineItem.workOrderProduct.billTo)\">{{ billToOption | translate }}<span \nng-if=\"!$last\">, </span></span></p></div><md-checkbox class=\"md-secondary\" \nng-checked=\"vm.isLineItemSelected(lineItem)\" ng-click=\"vm.toggleLineItem(lineItem)\"></md-checkbox></md-list-item>\n</md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nclass=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" click-and-wait=\"vm.saveChanges()\" ng-disabled=\"!vm.updateModel.salesOrder\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/add-work-order-dialog/add-work-order-dialog.tmpl.html","<md-dialog class=\"add-work-order-dialog edit-dialog\" aria-label=\"Add WorkOrder\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\"><span class=\"title\">{{\'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.TITLE\' | translate}}</span>\n</div></md-toolbar><md-dialog-content><div layout=\"column\" ng-form=\"vm.addWorkOrderForm\"><work-order-type-select \nis-required=\"true\" flex work-order-type-id=\"vm.workOrderTypeId\" work-order-type=\"vm.workOrderType\" \nlabel-text=\"{{\'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.WORK_ORDER_TYPE\' | translate}}\"></work-order-type-select>\n<department-select is-required=\"true\" flex department-id=\"vm.departmentId\" department=\"vm.department\" \nlabel-text=\"{{\'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.DEPARTMENT\' | translate}}\"></department-select></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'DECEASED.EDIT_DECEASED_DIALOG.CANCEL\' | translate}}</md-button><md-button \nclick-and-wait=\"vm.saveAndCloseDialog()\" ng-disabled=\"vm.addWorkOrderForm.$invalid\">\n{{ \'DECEASED.EDIT_DECEASED_DIALOG.SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/edit-work-order-product-dialog/edit-work-order-product-dialog.tmpl.html","<md-dialog class=\"edit-work-order-product-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'WORK_ORDERS.EDIT_WORK_ORDER_PRODUCT_DIALOG.ADD_TITLE\' : \'WORK_ORDERS.EDIT_WORK_ORDER_PRODUCT_DIALOG.EDIT_TITLE\' | translate }}\">\n<md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ vm.isNew ? \'WORK_ORDERS.EDIT_WORK_ORDER_PRODUCT_DIALOG.ADD_TITLE\' : \'WORK_ORDERS.EDIT_WORK_ORDER_PRODUCT_DIALOG.EDIT_TITLE\' | translate }}\n</span></div></md-toolbar><md-dialog-content ng-form=\"vm.editWorkOrderProductForm\"><div ng-if=\"vm.isDisabled\" \nclass=\"md-warn-bg md-hue-3\" layout-padding><p>{{\'SALES_ORDERS.LINE_ITEM.CANNOT_EDIT\' | translate }}</p></div><div \nlayout=\"column\"><product-select flex is-required=\"true\" is-disabled=\"vm.isDisabled\" \nproduct=\"vm.workOrderProduct.product\" product-id=\"vm.workOrderProduct.productId\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER_PRODUCT.PRODUCT\' | translate}}\" on-selected=\"vm.onProductChanged\">\n</product-select></div><div layout=\"column\"><md-input-container><label \ntranslate=\"WORK_ORDERS.WORK_ORDER_PRODUCT.AMOUNT\">Quantity</label><input type=\"number\" \nng-model=\"vm.workOrderProduct.amount\" ng-disabled=\"vm.isDisabled\"></md-input-container><edit-price-input \nprice-ex-vat=\"vm.workOrderProduct.overriddenPrice\" vat-rate=\"vm.workOrderProduct.productVatRate\" \nis-disabled=\"!vm.workOrderProduct.product\"></edit-price-input></div><div layout=\"column\"><md-input-container><label \ntranslate=\"WORK_ORDERS.WORK_ORDER_PRODUCT.OVERRIDDEN_NAME\">Name</label><textarea \nng-model=\"vm.workOrderProduct.overriddenName\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container>\n<bill-to-select bill-to=\"vm.workOrderProduct.billTo\" \nlabel-text=\"{{ \'WORK_ORDERS.WORK_ORDER_PRODUCT.BILL_TO\' | translate}}\"></bill-to-select><md-input-container><label \ntranslate=\"WORK_ORDERS.WORK_ORDER_PRODUCT.ADDED_REMARKS\">Added Remarks</label><textarea \nng-model=\"vm.workOrderProduct.addedRemarks\" ng-disabled=\"vm.isDisabled\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.deleteAndCloseDialog()\" ng-disabled=\"vm.workOrderProduct.isTransferedToOrder\">\n{{ \'COMMON.DATA.DELETE\' | translate}}</md-button><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\" ng-disabled=\"vm.editWorkOrderProductForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/dialogs/view-work-order-note-or-tasks-dialog/view-work-order-note-or-tasks-dialog.tmpl.html","<md-dialog md-theme=\"default\" class=\"view-work-order-note-or-tasks-dialog edit-dialog\" \naria-label=\"WorkOrder Notes and Tasks\"><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.NOTES_AND_TASKS.NOTES_AND_TASKS\' | translate}}</span></div></md-toolbar><md-dialog-content>\n<h3 translate=\"WORK_ORDERS.WORK_ORDER.NOTES_AND_TASKS.SHOWING_NOTES_AND_TASK\" \ntranslate-values=\"{ workOrderText: vm.workOrder.orderCode + \' (\' + vm.workOrder.workOrderTypeName + \')\' }\"></h3>\n<note-or-task-list ng-if=\"!vm.isLoading\" collection=\"vm.noteOrTasks\" hide-statuses=\"true\" \nwork-order-id=\"vm.workOrder.id\" inheritance-type=\"WorkOrder\"></note-or-task-list><div ng-if=\"vm.isLoading\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.OK\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/appointment.tmpl.html","<div layout=\"column\" layout-padding ng-if=\"!vm.loadingService.isLoading\"><location-select class=\"margin-bottom\" \nlocation=\"vm.data.updateModel.appointment.location\" location-id=\"vm.data.updateModel.appointment.locationId\" \nlabel-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\"></location-select><div><md-input-container class=\"md-block\">\n<label>{{ \"CALENDAR.EVENT.LOCATION_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.appointment.locationRemarks\" \nng-change=\"vm.data.onEntityChanged(vm.data.updateModel.appointment)\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{ \"ADDRESSES.ADDRESS.ADDRESS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.appointmentAddress.localizedAddress\" \nng-change=\"vm.data.onEntityChanged(vm.data.updateModel.appointmentAddress)\"></md-input-container></div>\n<date-time-range-select start-time=\"vm.data.updateModel.appointment.start\" \nend-time=\"vm.data.updateModel.appointment.end\"></date-time-range-select><calendar-event-users class=\"margin-bottom\" \nevent-users=\"vm.data.updateModel.appointmentAssistants\"></calendar-event-users><h2>\n{{ \"WORK_ORDERS.QUICK_REGISTRATION.CONTACT_PERON\" | translate }}</h2><div layout=\"column\" layout-gt-sm=\"row\"><div \nflex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>{{ \"PARTY.PERSON.LASTNAME\" | translate }}</label><input \nng-disabled=\"vm.isContactDisabled()\" ng-model=\"vm.data.updateModel.contact.lastName\" \nng-change=\"vm.onContactNameChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" flex md-autofocus>\n</md-input-container></div><div flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \"PARTY.PERSON.FIRSTNAME\" | translate }}</label><input ng-disabled=\"vm.isContactDisabled()\" \nng-model=\"vm.data.updateModel.contact.firstName\" ng-change=\"vm.onContactNameChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</div><div ng-if=\"!vm.isSearchingContact && vm.searchResultsContact && vm.searchResultsContact.length > 0\" \nclass=\"search-results\"><h3 translate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.FOUND_MATCHES\" \ntranslate-values=\"{ count: vm.searchResultsContact.length }\">Found matches</h3><p class=\"md-caption\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.CLICK_TO_SELECT\">Click to select</p><md-virtual-repeat-container>\n<md-list flex><div ng-if=\"vm.isSearchingContact\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResultsContact\"><md-list-item ng-click=\"vm.selectContactPerson(item)\" \nclass=\"md-3-line\" flex ng-class=\"{ \'md-accent-bg\': item.id == vm.selectedContactParty.id }\"><img \nng-if=\"!item.image.filepath\" class=\"md-avatar\" gravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"item.image.filepath\" class=\"md-avatar\" baldris-img-src=\"item.image.filepath\" preset=\"square-40-cropped\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.displayName }}</h3><h4><md-icon md-font-icon=\"icon-phone\">\n</md-icon>{{ item.primaryTelephone }}<md-icon md-font-icon=\"icon-home\"></md-icon>{{ item.primaryAddress }}</h4><p>\n{{ item.dateOfBirth | date: \"shortDate\" }} || {{ item.socialSecurityNumber }} {{ item.partyTypes }}</p></div>\n</md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list></md-virtual-repeat-container></div><div>\n<reference-person-type-select ng-model=\"vm.data.updateModel.contact.referencePersonType\" \nlabel-text=\"{{ \'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.REFERENCE_PERSON_TYPE\' | translate }}\">\n</reference-person-type-select></div><div><lookup-string-select \nlabel-text=\"{{ \'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.FAMILY_RELATION\' | translate }}\" \nlookup-string-id=\"vm.familyRelationId\" lookup-string=\"vm.familyRelation\" \nlookup-string-config=\"\'FamilyRelationLookupStringType\'\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.contact.familyRelation\"></lookup-string-select></div><md-button \nng-if=\"vm.selectedContactParty\" class=\"md-raised md-accent\" ng-click=\"vm.useExistingContact(vm.selectedContactParty)\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.ADD_SELECTED_REFERENCE_PERSON\" \ntranslate-values=\"{ referencePersonName: vm.selectedContactParty.displayName }\">Choose person</md-button><div>\n<md-input-container class=\"md-block\"><label>{{ \"TELEPHONES.TELEPHONE.TELEPHONE_NUMBER\" | translate }}</label><input \nng-model=\"vm.data.updateModel.contactTelephones[0].telephoneNumber\" phone-number country-code=\"\'NO\'\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>{{ \"CALENDAR.EVENT.REMARKS\" | translate }}\n</label><input ng-model=\"vm.data.updateModel.appointment.remarks\"></md-input-container></div></div>");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/ceremony.tmpl.html","<div ng-if=\"vm.data.updateModel.ceremony\" layout=\"column\" layout-padding ng-if=\"!vm.loadingService.isLoading\">\n<calendar-event-type-select is-required=\"true\" flex \ncalendar-event-type-id=\"vm.data.updateModel.ceremony.calendarEventTypeId\" \ncalendar-event-type=\"vm.data.updateModel.ceremony.calendarEventType\" \nlabel-text=\"{{ \'CALENDAR.EVENT.CALENDAR_EVENT_TYPE\' | translate }}\" options-filter=\"16\" \non-update=\"vm.data.onCeremonyTypeChanged(value)\"></calendar-event-type-select><location-select class=\"margin-bottom\" \nlocation=\"vm.data.updateModel.ceremony.location\" location-id=\"vm.data.updateModel.ceremony.locationId\" \nlabel-text=\"{{ \'CALENDAR.EVENT.LOCATION\' | translate }}\"></location-select><date-time-range-select \nstart-time=\"vm.data.updateModel.ceremony.start\" end-time=\"vm.data.updateModel.ceremony.end\"></date-time-range-select>\n<calendar-event-users class=\"margin-bottom\" event-users=\"vm.data.updateModel.ceremonyAssistants\">\n</calendar-event-users><div><md-input-container class=\"md-block\"><label>{{ \"CALENDAR.EVENT.REMARKS\" | translate }}\n</label><input ng-model=\"vm.data.updateModel.ceremony.remarks\"></md-input-container></div></div>");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/deceased.tmpl.html","<div layout=\"column\" layout-padding ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" layout-gt-sm=\"row\"><div \nflex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>{{ \"PARTY.PERSON.LASTNAME\" | translate }}</label><input \nng-disabled=\"vm.isDeceasedDisabled()\" ng-model=\"vm.data.updateModel.deceased.lastName\" \nng-change=\"vm.onDeceasedNameChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" flex md-autofocus>\n</md-input-container></div><div flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \"PARTY.PERSON.FIRSTNAME\" | translate }}</label><input ng-disabled=\"vm.isDeceasedDisabled()\" \nng-model=\"vm.data.updateModel.deceased.firstName\" ng-change=\"vm.onDeceasedNameChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</div><div ng-if=\"!vm.isSearchingDeceased && vm.searchResultsDeceased && vm.searchResultsDeceased.length > 0\" \nclass=\"search-results\"><h3 translate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.FOUND_MATCHES\" \ntranslate-values=\"{ count: vm.searchResultsDeceased.length }\">Found matches</h3><p class=\"md-caption\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.CLICK_TO_SELECT\">Click to select</p><md-virtual-repeat-container>\n<md-list flex><div ng-if=\"vm.isSearchingDeceased\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResultsDeceased\"><md-list-item ng-click=\"vm.selectDeceasedPerson(item)\" \nclass=\"md-3-line\" flex ng-class=\"{ \'md-accent-bg\': item.id == vm.selectedDeceasedParty.id }\"><img \nng-if=\"!item.image.filepath\" class=\"md-avatar\" gravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"item.image.filepath\" class=\"md-avatar\" baldris-img-src=\"item.image.filepath\" preset=\"square-40-cropped\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.displayName }}</h3><h4><md-icon md-font-icon=\"icon-phone\">\n</md-icon>{{ item.primaryTelephone }}<md-icon md-font-icon=\"icon-home\"></md-icon>{{ item.primaryAddress }}</h4><p>\n{{ item.dateOfBirth | date: \"shortDate\" }} || {{ item.socialSecurityNumber }} {{ item.partyTypes }}</p></div>\n</md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list></md-virtual-repeat-container></div><md-button \nng-if=\"vm.selectedDeceasedParty\" class=\"md-raised md-accent\" \nng-click=\"vm.useExistingDeceased(vm.selectedDeceasedParty)\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.ADD_SELECTED_REFERENCE_PERSON\" \ntranslate-values=\"{ referencePersonName: vm.selectedDeceasedParty.displayName }\">Choose person</md-button><div \nclass=\"margin-top-20 margin-bottom-20\"><sex-select flex sex=\"vm.baldrisModel.sex\" \nlabel-text=\"{{ \'PARTY.PERSON.SEX\' | translate }}\" on-change=\"(vm.onSexChange)\"></sex-select></div><div \nlayout-gt-xs=\"row\"><birth-date-select flex-gt-xs=\"50\" ng-model=\"vm.data.updateModel.deceased.dateOfBirth\" \ndate-of-death=\"vm.data.updateModel.deceased.dateOfDeath\" allow-approximate=\"true\" \napproximate-model=\"vm.data.updateModel.deceased.dateOfBirthApproximate\"></birth-date-select><death-date-select \nflex-gt-xs=\"50\" ng-model=\"vm.data.updateModel.deceased.dateOfDeath\" \ndate-of-birth=\"vm.data.updateModel.deceased.dateOfBirth\" allow-approximate=\"true\" \napproximate-model=\"vm.data.updateModel.deceased.dateOfDeathApproximate\"></death-date-select></div><div \nclass=\"margin-top-20 margin-bottom-20\"><ssn-input ng-model=\"vm.data.updateModel.deceased.socialSecurityNumber\" \ndate-of-birth=\"vm.data.updateModel.deceased.dateOfBirth\" sex=\"vm.data.updateModel.deceased.sex\"></ssn-input></div><div>\n<md-input-container class=\"md-block\"><label>{{ \"PARTY.PERSON.REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.remarks\"></md-input-container></div><address-list \nparty-id=\"vm.data.updateModel.deceased.personId\" collection=\"vm.data.updateModel.deceasedAddresses\"></address-list>\n<location-select label-text=\"{{ \'DECEASED.DECEASED.PLACE_OF_DEATH\' | translate }}\" \nlocation-id=\"vm.data.updateModel.deceased.placeOfDeathId\" location=\"vm.data.updateModel.deceased.placeOfDeath\" \nlocation-config=\"\'PlaceOfDeathLocationType\'\"></location-select><div><md-input-container flex class=\"md-block\"><label>\n{{ \"DECEASED.DECEASED.PLACE_OF_DEATH_REMARKS\" | translate }}</label><input \nng-model=\"vm.data.updateModel.deceased.placeOfDeathRemarks\"></md-input-container></div><casket-select \nlabel-text=\"{{ \'DECEASED.DECEASED.CASKET\' | translate }}\" casket-id=\"vm.data.updateModel.deceased.casketId\" \ncasket=\"vm.data.updateModel.deceased.casket\"></casket-select><div><md-checkbox \nng-model=\"vm.data.updateModel.deceased.isToBeCremated\">{{ \"DECEASED.DECEASED.IS_TO_BE_CREMATED\" | translate }}\n</md-checkbox></div></div>");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/sidebar.tmpl.html","");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"WORK_ORDERS.QUICK_REGISTRATION.QUICK_REGISTRATION\"></span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-disabled=\"vm.data.validation.quickRegistrationForm.$invalid\" \nclick-and-wait=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"CALENDAR.ACTIONS.SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"CALENDAR.ACTIONS.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"CALENDAR.ACTIONS.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"CALENDAR.ACTIONS.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/transport.tmpl.html","");
$templateCache.put("app/main/work-order/quick-registration-deceased/views/work-order.tmpl.html","<div layout=\"column\" layout-padding><work-order-type-select is-required=\"true\" flex \non-update=\"vm.data.onWorkOrderTypeChanged(item)\" work-order-type-id=\"vm.data.updateModel.workOrder.workOrderTypeId\" \nwork-order-type=\"vm.workOrderType\" label-text=\"{{\'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.WORK_ORDER_TYPE\' | translate}}\">\n</work-order-type-select><department-select is-required=\"true\" flex \ndepartment-id=\"vm.data.updateModel.workOrder.departmentId\" department=\"vm.department\" \nlabel-text=\"{{\'WORK_ORDERS.ADD_WORK_ORDER_DIALOG.DEPARTMENT\' | translate}}\"></department-select><baldris-user-select \nbaldris-user=\"vm.data.updateModel.workOrder.caseWorker\" baldris-user-id=\"vm.data.updateModel.workOrder.caseWorkerId\" \ndisplay-text=\"vm.data.updateModel.workOrder.caseWorkerDisplayName\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER.CASEWORKER\' | translate}}\"></baldris-user-select></div>");
$templateCache.put("app/main/work-order/work-order/attachments/work-order-attachments.tmpl.html","<form name=\"workOrderAttachmentForm\" class=\"work-order-attachments\" flex><work-order-attachment-list \nattachments=\"vm.data.workOrderAttachments\" selected-attachments=\"vm.data.selectedAttachments\" \nwork-order-id=\"vm.service.currentData.workOrder.id\"></work-order-attachment-list><div \nng-if=\"vm.loadingService.isLoading\" layout-padding layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></form>");
$templateCache.put("app/main/work-order/work-order/calendar-events/work-order-calendar-events.tmpl.html","<form name=\"workOrderCalendarEventsForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasEvents\') || vm.data.calendarEvents.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\"><calendar-event-list \ncollection=\"vm.data.calendarEvents\" hide-add-button=\"true\" create-date-groups=\"true\" \non-open=\"vm.data.navigateToCalendarEvent(calendarEvent)\"></calendar-event-list></div><div \nclass=\"add-card-element-container\" flex layout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\">\n<md-button class=\"item md-block\" aria-label=\"Add new Ceremony\" ng-click=\"vm.data.showAddCalendarEventDialog($event)\">\n<div layout=\"row\" layout-align=\"center center\"><span class=\"icon icon-calendar-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.CALENDAR_EVENTS.ADD_CALENDAR_EVENT\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasEvents\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.CALENDAR_EVENTS.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button \nclass=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/ceremony/work-order-ceremony.tmpl.html","<form name=\"workOrderCeremonyForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasCeremonies\') || vm.data.ceremonies.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"ceremony in vm.data.ceremonies\" flex-gt-lg=\"50\"><ceremony-card baldris-model=\"ceremony\" \non-open=\"vm.data.navigateToCeremony\" on-delete=\"vm.data.deleteCeremony\"></ceremony-card></div><div \nclass=\"add-deceased-container\" flex layout=\"column\"><div class=\"add-deceased-border\" flex layout=\"column\"><md-button \nclass=\"item md-block\" aria-label=\"Add new Ceremony\" ng-click=\"vm.data.showAddCeremonyDialog($event)\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"icon icon-bookmark-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.CEREMONY.ADD_CEREMONY\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasCeremonies\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.CEREMONY.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button class=\"md-primary md-raised\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/consignments/work-order-consignments.tmpl.html","<div class=\"work-order-consignments\" flex><div class=\"consignments p-8\" layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><signature-job-list-item class=\"mb-8\" signature-job=\"consignment\" \nng-if=\"!vm.loadingService.isLoading\" ng-repeat=\"consignment in vm.consignments\" flex-gt-lg=\"50\" \nng-click=\"vm.openConsignment($event, consignment)\"></signature-job-list-item></div><div \nclass=\"add-deceased-container p-8\" flex layout=\"column\"><div class=\"add-deceased-border\" flex layout=\"column\">\n<md-button class=\"item md-block\" aria-label=\"Add new Consignment\" ng-click=\"vm.addConsignment($event)\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"icon icon-bookmark-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.CONSIGNMENTS.ADD_CONSIGNMENT\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/main/work-order/work-order/deceased/work-order-deceased.tmpl.html","<form name=\"workOrderDeceasedsForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasDeceased\') || vm.data.deceased.length > 0\"><div flex layout=\"column\" \nlayout-gt-lg=\"row\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" ng-repeat=\"deceased in vm.data.deceased\" \nflex-gt-lg=\"50\"><deceased-card baldris-model=\"deceased\" on-open=\"vm.data.navigateToDeceased\" \non-delete=\"vm.data.deleteWorkOrderDeceased\"></deceased-card></div><div class=\"add-deceased-container\" flex \nlayout=\"column\"><div class=\"add-deceased-border\" flex layout=\"column\"><md-button class=\"item md-block\" \naria-label=\"Add new Address\" ng-click=\"vm.data.showAddNewDeceasedDialog($event)\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"icon icon-account-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.DECEASED.ADD_DECEASED\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasDeceased\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.DECEASED.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button class=\"md-primary md-raised\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/flower-order/work-order-flower-order.tmpl.html","<form name=\"workOrderFlowerOrderForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasFlowers\') || vm.data.flowerOrders.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-repeat=\"flowerOrder in vm.data.flowerOrders\" flex-gt-lg=\"50\">\n<flower-order-card baldris-model=\"flowerOrder\" on-open=\"vm.data.navigateToFlowerOrder\" \non-delete=\"vm.data.deleteFlowerOrder\"></flower-order-card></div><div class=\"add-card-element-container\" flex \nlayout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\"><md-button class=\"item md-block\" \naria-label=\"Add new Flower Order\" ng-click=\"vm.data.addFlowerOrder($event)\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"icon icon-plus-box s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.FLOWER_ORDERS.ADD_FLOWER_ORDER\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"column\" layout-margin layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasFlowers\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.FLOWER_ORDERS.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button \nclass=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/grave/work-order-grave.tmpl.html","<form name=\"workOrderGraveForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasGrave\') || vm.data.graves.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"grave in vm.data.graves | orderBy:\'start\'\" flex-gt-lg=\"50\"><grave-card baldris-model=\"grave\" \non-open=\"vm.data.navigateToGrave\" on-delete=\"vm.data.deleteGrave\"></grave-card></div><div \nclass=\"add-card-element-container\" flex layout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\">\n<md-button class=\"item md-block\" aria-label=\"Add new Ceremony\" ng-click=\"vm.data.showAddGraveDialog($event)\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"icon icon-plus-box s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.GRAVES.ADD_GRAVE\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div ng-if=\"!vm.service.isOptionEnabled(\'hasGrave\')\" \nlayout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.GRAVES.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button class=\"md-primary md-raised\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/headstone-order/work-order-headstone-order.tmpl.html","<form name=\"workOrderHeadstoneOrderForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasHeadstones\') || vm.data.headstoneOrders.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-repeat=\"headstoneOrder in vm.data.headstoneOrders\" \nflex-gt-lg=\"50\"><headstone-order-card baldris-model=\"headstoneOrder\" on-open=\"vm.data.navigateToHeadstoneOrder\" \non-delete=\"vm.data.deleteHeadstoneOrder\"></headstone-order-card></div><div class=\"add-card-element-container\" flex \nlayout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\"><md-button class=\"item md-block\" \naria-label=\"Add new Headstone Order\" ng-click=\"vm.data.addHeadstoneOrder($event)\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"icon icon-plus-box s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.HEADSTONES.ADD_HEADSTONE\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"column\" layout-margin layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasHeadstones\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.HEADSTONES.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button \nclass=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/invoicing/work-order-invoicing.tmpl.html","<div class=\"work-order-invoicing\" layout=\"column\" layout-gt-lg=\"row\" layout-wrap layout-align-gt-lg=\"start start\"><div \nng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div><ms-widget \nng-if=\"!vm.loadingService.isLoading && vm.data.canReadInvoice\" flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\" translate=\"WORK_ORDERS.WORK_ORDER.INVOICING.SALES_ORDERS_IN_WORK_ORDER\">\nSales Orders associated with Work Order</div></div><md-content><div><div hide show-gt-sm layout-padding layout=\"row\" \nlayout-align=\"start start\"><div flex=\"20\" class=\"text-bold\">Ordrenr.</div><div flex=\"20\" class=\"text-bold\">Opprettet\n</div><div flex=\"30\" class=\"text-bold\">Kunde</div><div flex=\"20\" class=\"text-right text-bold\">Totalsum</div></div>\n<md-divider ng-if=\"vm.data.salesOrders.length > 0\"></md-divider><div md-ink-ripple \nclass=\"sales-order clickable md-body-1\" ng-click=\"vm.data.navigateToSalesOrder(salesOrder)\" \nng-repeat-start=\"salesOrder in vm.data.salesOrders | orderBy:\'sortOrder\'\"><div layout-padding layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" layout-align-gt-sm=\"start center\"><div flex-gt-sm=\"20\" \nclass=\"product-code text-bold\">{{ salesOrder.orderCode }}</div><div flex-gt-sm=\"20\" class=\"product-name\">\n{{ salesOrder.createdTime | date: \"shortDate\" }}</div><div flex-gt-sm=\"30\" class=\"amount\">\n{{ salesOrder.customerPartyDisplayName | translate }}</div><div flex-gt-sm=\"20\" class=\"price text-right\">\n{{ salesOrder.totalSumIncludingVat | currency }}</div><div flex-gt-sm=\"10\" class=\"preview-file\"></div></div><div \nng-if=\"salesOrder.subject\" class=\"sales-order-subject md-caption\" layout-padding layout=\"column\">\n{{ salesOrder.subject }}</div></div><md-divider ng-if=\"!$last\" ng-repeat-end></md-divider></div></md-content>\n</ms-widget-front></ms-widget><ms-widget ng-if=\"!vm.loadingService.isLoading && vm.data.canReadInvoice\" flex \nflex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.INVOICING.INVOICES_IN_WORK_ORDER\">Invoices associated with Work Order</div></div>\n<md-content><div><div hide show-gt-sm layout-padding layout=\"row\" layout-align=\"start start\"><div flex=\"20\" \nclass=\"text-bold\">Fakturanr.</div><div flex=\"20\" class=\"text-bold\">Fakturadato</div><div flex=\"40\" class=\"text-bold\">\nKunde</div><div flex=\"20\" class=\"text-right text-bold\">Totalsum</div></div><md-divider \nng-if=\"vm.data.invoices.length > 0\"></md-divider><div md-ink-ripple class=\"invoice clickable md-body-1\" \nng-click=\"vm.data.navigateToInvoice(invoice)\" ng-repeat-start=\"invoice in vm.data.invoices | orderBy:\'sortOrder\'\"><div \nlayout-padding layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" layout-align-gt-sm=\"start center\"><div \nflex-gt-sm=\"20\" class=\"product-code text-bold\">{{ invoice.prefix }}{{ invoice.invoiceNumber }} <span \nclass=\"icon icon-lock\" ng-show=\"invoice.isLocked\"></span><span class=\"icon icon-lock-unlocked\" \nng-hide=\"invoice.isLocked\"></span></div><div flex-gt-sm=\"20\" class=\"product-name\">\n{{ invoice.invoiceDate | date: \"shortDate\" }}</div><div flex-gt-sm=\"40\" class=\"amount\">\n{{ invoice.customerPartyDisplayName | translate }}</div><div flex-gt-sm=\"20\" class=\"price text-right\">\n{{ invoice.totalSumIncludingVat | currency }}</div></div><div ng-if=\"invoice.subject\" \nclass=\"invoice-subject md-caption\" layout-padding layout=\"column\">{{ invoice.subject }}</div></div><md-divider \nng-if=\"!$last\" ng-repeat-end></md-divider></div></md-content></ms-widget-front></ms-widget><ms-widget \nng-if=\"!vm.loadingService.isLoading\" flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\">\n<div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\" translate=\"WORK_ORDERS.WORK_ORDER.INVOICING.PRODUCTS_IN_WORK_ORDER\">\nProduct Lines associated with Work Order</div></div><md-content layout=\"column\" class=\"work-order-products\"><div><div \nclass=\"show-transferred-products\"><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.showTransferredProducts\">{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.SHOW_TRANSFERRED_PRODUCTS\" | translate }}\n</md-checkbox></md-input-container></div><div hide show-gt-sm layout-padding layout=\"row\" layout-align=\"start start\">\n<div flex=\"10\" class=\"text-bold\">Varenr.</div><div flex=\"60\" class=\"text-bold\">Produktnavn</div><div flex=\"10\" \nclass=\"text-center text-bold\">Antall</div><div flex=\"20\" class=\"text-right text-bold\">Enhetspris</div></div><div \nmd-ink-ripple class=\"work-order-product clickable md-body-1\" \nng-repeat-start=\"workOrderProduct in vm.data.workOrderProducts | orderBy:\'productDefaultSortOrder\' | filter:vm.productFilter\" \nng-click=\"vm.data.showEditWorkOrderProductDialog(workOrderProduct, $event)\"><div layout-padding layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div flex-gt-sm=\"10\" hide show-gt-sm class=\"product-code text-bold\">\n{{ workOrderProduct.productCode }}</div><div flex-gt-sm=\"60\" class=\"product-name\"><span hide show-sm show-xs>\n{{ workOrderProduct.amount }}# </span>{{ workOrderProduct.productName }}</div><div flex-gt-sm=\"10\" hide show-gt-sm \nclass=\"amount text-center\">{{ workOrderProduct.amount }}</div><div flex-gt-sm=\"20\" class=\"price text-right\">\n{{ workOrderProduct.productPriceIncludingVat | currency }}</div></div><div class=\"md-caption other-info\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div flex-gt-sm=\"10\"></div><div flex-gt-sm=\"30\" \nclass=\"product-type-name\">{{ workOrderProduct.productType}}</div><div flex-gt-sm=\"30\" class=\"added-remarks\">\n{{ workOrderProduct.addedRemarks }}</div><div flex-gt-sm=\"30\" class=\"transferred text-right\" \nng-if=\"workOrderProduct.isTransferedToOrder\"><md-icon md-font-icon=\"icon-check\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER_PRODUCT.IS_TRANSFERRED_TO_ORDER\" | translate }}</div><div flex-gt-sm=\"30\" \nclass=\"transferred text-right md-warn-fg\" ng-if=\"!workOrderProduct.isTransferedToOrder\"><md-icon \nmd-font-icon=\"icon-alert\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER_PRODUCT.NOT_TRANSFERRED_TO_ORDER\" | translate }}</div>\n</div></div><md-divider ng-if=\"!$last\" ng-repeat-end></md-divider></div><div class=\"footer\"><md-divider></md-divider>\n<div class=\"total text-right\"><p><span \nng-class=\"{\'md-warn-fg\': vm.data.getUntransferredPriceWorkOrderProducts(vm.data.workOrderProducts) > 0}\">\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.TOTAL_UNTRANSFERRED_INCLUDING_VAT\" | translate }} {{ vm.data.getUntransferredPriceWorkOrderProducts(vm.data.workOrderProducts) | currency }}\n</span><br>\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.TOTAL_TRANSFERRED_INCLUDING_VAT\" | translate }} {{ vm.data.getTransferredPriceWorkOrderProducts(vm.data.workOrderProducts) | currency }}\n</p><md-divider></md-divider><p>\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.TOTAL_INCLUDING_VAT\" | translate }} {{ vm.data.getTotalPriceWorkOrderProducts(vm.data.workOrderProducts) | currency }}\n</p></div></div></md-content></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/work-order/work-order/notes-and-tasks/work-order-notes-and-tasks.tmpl.html","<div class=\"work-order-notes-and-tasks\"><div class=\"fab-container\"><md-fab-speed-dial md-direction=\"up\" \nmd-open=\"vm.isOpen\" class=\"md-scale\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent\"><md-tooltip \nmd-direction=\"left\">{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE_OR_TASK\' | translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add Note\" \nclass=\"md-fab md-raised md-mini\" ng-click=\"vm.addNote($event)\"><md-tooltip md-direction=\"left\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_NOTE\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-note\" \naria-label=\"Note\"></md-icon></md-button><md-button aria-label=\"Add Task\" class=\"md-fab md-raised md-mini\" \nng-click=\"vm.addTask($event)\"><md-tooltip md-direction=\"left\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.ADD_TASK\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-checkbox-marked\" \naria-label=\"Task\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div><note-or-task-list \nng-if=\"!vm.currentData.viewData.isLoadingNoteOrTasks\" api=\"vm.listApi\" \ncollection=\"vm.currentData.workOrder.notesAndTasks\" hide-statuses=\"true\" work-order-id=\"vm.currentData.workOrder.id\" \ninheritance-type=\"WorkOrder\" hide-add-button=\"true\"></note-or-task-list><div \nng-if=\"vm.currentData.viewData.isLoadingNoteOrTasks\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/main/work-order/work-order/obituary-notice/work-order-obituary-notice.tmpl.html","<form name=\"workOrderObituaryNoticeForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasObituaries\') || vm.data.obituaryNotices.length > 0\"><md-button flex \nng-disabled=\"!vm.data.hasAdstateConfig\" class=\"md-block md-raised\" aria-label=\"Add new Address\" \nng-click=\"vm.data.showRetrieveAdstateEntriesDialog($event)\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"icon icon-download s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.OBITUARY_NOTICES.RETRIEVE_ADSTATE_ENTRIES\' | translate}}</span></div></md-button><div flex \nlayout-gt-lg=\"row\" layout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"obituaryNotice in vm.data.obituaryNotices\" flex-gt-lg=\"50\"><obituary-notice-card \nbaldris-model=\"obituaryNotice\" on-open=\"vm.data.navigateToObituaryNotice\" on-delete=\"vm.deleteObituaryNotice\">\n</obituary-notice-card></div><div class=\"add-deceased-container\" flex layout=\"column\"><div class=\"add-deceased-border\" \nflex layout=\"column\"><md-button class=\"item md-block\" aria-label=\"Add new Address\" \nng-click=\"vm.data.showAddNewObituaryNoticeDialog($event)\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"icon icon-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.OBITUARY_NOTICES.ADD_OBITUARY_NOTICE\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasObituaries\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.OBITUARY_NOTICES.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button \nclass=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/options/work-order-options.tmpl.html","<div class=\"edit-work-order-options\"><div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content \nclass=\"content\" ng-form=\"vm.workOrderOptionsForm\" ng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" \nlayout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{\'WORK_ORDERS.WORK_ORDER.OPTIONS.OPTIONS\' | translate}}</div></div><md-content \nlayout-padding layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><div class=\"margin-bottom-20\"><enum-flag-select \nenum-flag=\"vm.data.workOrderDto.options\" enum-flag-options=\"workOrderOptions\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER.OPTIONS.OPTIONS\' | translate}}\"></enum-flag-select></div><div>\n<work-order-type-select work-order-type=\"vm.data.workOrderDto.workOrderType\" \nwork-order-type-id=\"vm.data.workOrderDto.workOrderTypeId\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER.WORK_ORDER_TYPE\' | translate}}\" \ndisplay-text=\"vm.data.workOrderDto.workOrderTypeName\"></work-order-type-select></div><div><baldris-user-select \nbaldris-user=\"vm.data.workOrderDto.caseWorker\" baldris-user-id=\"vm.data.workOrderDto.caseWorkerId\" \ndisplay-text=\"vm.data.workOrderDto.caseWorkerDisplayName\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER.CASEWORKER\' | translate}}\"></baldris-user-select></div><div><department-select \ndepartment=\"vm.data.workOrderDto.department\" department-id=\"vm.data.workOrderDto.departmentId\" \ndisplay-text=\"vm.data.workOrderDto.departmentOrganiationDisplayName\" \nlabel-text=\"{{\'WORK_ORDERS.WORK_ORDER.DEPARTMENT\' | translate}}\"></department-select></div><div><md-input-container \nclass=\"md-block\"><label>{{\'WORK_ORDERS.WORK_ORDER.REMARKS\' | translate }}</label><textarea \nng-model=\"vm.data.workOrderDto.remarks\"></textarea></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'WORK_ORDERS.WORK_ORDER.REMARKS_FOR_INVOICE\' | translate }}</label><textarea \nng-model=\"vm.data.workOrderDto.remarksForInvoice\"></textarea></md-input-container></div></md-content></ms-widget-front>\n</ms-widget></div><div layout=\"row\"><md-button class=\"md-warn md-raised\" ng-disabled=\"!vm.data.canDeleteWorkOrder\" \nng-click=\"vm.data.deleteWorkOrder($event)\" aria-label=\"Delete Work Order\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER\">\n{{ \'WORK_ORDERS.WORK_ORDER.DELETE_WORK_ORDER\' | translate}}</md-button><span flex></span><md-button class=\"md-warn\" \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" translate-attr-aria-label=\"CEREMONIES.EDIT_CEREMONY.OK_SAVE\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></div></md-content></div>");
$templateCache.put("app/main/work-order/work-order/program/work-order-program.tmpl.html","<form name=\"workOrderProgramForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasPrograms\') || vm.data.programs.length > 0\"><div layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"program in vm.data.programs\" flex-gt-lg=\"50\"><program-card on-open=\"vm.data.navigateToProgram\" \non-delete=\"vm.data.deleteProgram\" baldris-model=\"program\"></program-card></div><div class=\"add-deceased-container\" \nflex layout=\"column\"><div class=\"add-deceased-border\" flex layout=\"column\"><md-button class=\"item md-block\" \naria-label=\"Add new Address\" ng-click=\"vm.data.showAddProgramDialog($event)\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"icon icon-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.PROGRAMS.ADD_PROGRAM\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!vm.service.isOptionEnabled(\'hasPrograms\')\" layout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.PROGRAMS.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button class=\"md-primary md-raised\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/reference-persons/work-order-reference-persons.tmpl.html","<div class=\"workOrderReferencePersons\" flex layout-padding \nng-if=\"vm.service.isOptionEnabled(\'hasReferencePersons\') || vm.data.referencePersons.length > 0\"><div flex><ms-widget>\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.REFERENCE_PERSONS\"></div></div><md-content><md-list \nclass=\"reference-person-list\" flex><div ng-if=\"!vm.vm.loadingService.isLoading\" \nng-repeat=\"referencePerson in vm.data.referencePersons | orderBy:\'sortOrder\'\"><reference-person-list-item \nhighlight=\"vm.highlightedId === referencePerson.id\" ng-model=\"referencePerson\" on-open=\"vm.data.openReferencePerson\" \non-delete=\"vm.data.deleteReferencePerson(value, $event)\"></reference-person-list-item><md-divider></md-divider></div>\n<md-list-item class=\"md-2-line add-reference-person\" ng-click=\"vm.data.showAddNewReferencePersonDialog($event)\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-account-plus\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{\'WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.ADD_REFERENCE_PERSON\' | translate}}</h3></div></md-list-item></md-list>\n</md-content></ms-widget-front></ms-widget><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div><div\n ng-if=\"!vm.service.isOptionEnabled(\'hasReferencePersons\')\" layout-padding layout=\"column\"><p \nclass=\"md-title text-center\">{{ \'WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p>\n<md-button class=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order/work-order/reports/work-order-reports.tmpl.html","<div class=\"workOrderReportsForm\" flex layout-padding layout=\"column\"><ms-widget flex layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">{{ \"WORK_ORDERS.WORK_ORDER.REPORTS.REPORTS\" | translate }}</div></div><md-content \nlayout=\"column\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat-start=\"report in vm.data.reports | filter: vm.data.reportFilter | orderBy:\'sortOrder\'\" target=\"_blank\" \nng-href=\"{{ vm.baldrisApiBase }}/api/Reports/AsPdf/{{ report.id }}/WorkOrderId/{{ vm.data.workOrder.id }}\" \nng-class=\"{ \'is-deleted\': report.isDeleted }\"><img ng-if=\"report.imageFilepath\" baldris-img-src=\"report.imageFilepath\" \npreset=\"square-40-cropped\" class=\"md-avatar\" alt=\"{{ report.name }}\"><md-icon ng-if=\"!report.imageFilepath\" \nmd-font-icon=\"{{ report.iconName || \'icon-file\' }}\" class=\"md-avatar-icon\"></md-icon><div class=\"md-list-item-text\">\n<h3>{{ report.name }}</h3><p>{{ report.description }}</p></div><md-button \nng-if=\"report.attachedPrivacyFields > 0 && !vm.data.isReportConsented(report.id)\" class=\"md-secondary md-icon-button\" \naria-label=\"Unconsented report\" ng-click=\"null\"><md-tooltip md-direction=\"left\">\n{{ \"PRIVACY.PRIVACY_FIELD.NO_CONSENT_REGISTERED_FOR_REPORT\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-shield\" class=\"amber-500-fg\"></md-icon></md-button><md-button \nng-if=\"report.attachedPrivacyFields > 0 && vm.data.isReportConsented(report.id)\" class=\"md-secondary md-icon-button\" \naria-label=\"Consented report\" ng-click=\"null\"><md-tooltip md-direction=\"left\">\n{{ \"PRIVACY.PRIVACY_FIELD.CONSENT_REGISTERED_FOR_REPORT\" | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-shield\" class=\"green-500-fg\"></md-icon></md-button><md-button \nng-if=\"vm.data.getFailedCountByReportId(report.id) > 0\" class=\"md-secondary md-icon-button\" \naria-label=\"Failed reports\" ng-click=\"vm.showReportLogs(report, $event)\"><md-tooltip md-direction=\"left\">\n{{ vm.data.getFailedCountByReportId(report.id) }}</md-tooltip><md-icon md-font-icon=\"icon-alert\" class=\"red-500-fg\">\n</md-icon></md-button><md-button ng-if=\"vm.data.getLatestReportLogByReportId(report.id)\" \nclass=\"md-secondary md-icon-button\" aria-label=\"Show report logs\" ng-click=\"vm.showReportLogs(report, $event)\">\n<md-tooltip md-direction=\"left\">\n{{ vm.data.getStatusAction(vm.data.getLatestReportLogByReportId(report.id)) | translate }} <span \nng-if=\"vm.data.getLatestReportLogByReportId(report.id).userDisplayName\">\n({{ vm.data.getLatestReportLogByReportId(report.id).userDisplayName }}) </span>\n{{ vm.data.getLatestReportLogByReportId(report.id).statusTime | date: \"short\" }}: {{ vm.data.getLatestReportLogByReportId(report.id).recipient }}\n</md-tooltip><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nng-class=\"vm.data.getStatusColor(vm.data.getLatestReportLogByReportId(report.id))\"></md-icon></md-button><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.openSendEmailDialog(report, $event)\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon></md-button></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider>\n</md-list></md-content></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/work-order/work-order/shipments/work-order-shipments.tmpl.html","<form name=\"workOrderShipmentsForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(512) || vm.data.shipments.length > 0\"><div flex layout-gt-lg=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"shipment in vm.data.shipments\" flex-gt-lg=\"50\"><deceased-shipment-card baldris-model=\"shipment\" \non-open=\"vm.data.navigateToShipment\" on-delete=\"vm.data.deleteShipment\"></deceased-shipment-card></div><div \nclass=\"add-card-element-container\" flex layout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\">\n<md-button class=\"item md-block\" aria-label=\"Add new Ceremony\" ng-click=\"vm.data.showAddShipmentDialog($event)\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"icon icon-bookmark-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.SHIPMENTS.ADD_SHIPMENT\' | translate}}</span></div></md-button></div></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></form><div ng-if=\"!vm.service.isOptionEnabled(512)\" \nlayout-padding layout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.SHIPMENTS.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button class=\"md-primary md-raised\" \naria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/main/work-order-reference-person/components/edit-reference-person-dialog/edit-reference-person-dialog.tmpl.html","<md-dialog class=\"edit-reference-person-dialog edit-dialog\" aria-label=\"Edit Reference Person\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.referencePerson.person.displayName}}\n</span></div></md-toolbar><md-dialog-content><md-content layout-padding layout=\"column\" class=\"deceased personalia\" \nng-form=\"vm.referencePersonForm\"><edit-party baldris-model=\"vm.referencePerson.person\" is-disabled=\"vm.isDisabled\">\n</edit-party><funeral-arrangement-rights-select funeral-arrangement-right=\"vm.referencePerson.funeralArrangementRight\" \nlabel-text=\"{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.FUNERAL_ARRANGEMENT-RIGHT\' | translate}}\">\n</funeral-arrangement-rights-select><reference-person-type-select \nreference-person-type=\"vm.referencePerson.referencePersonType\" \nlabel-text=\"{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.REFERENCE_PERSON-TYPE\' | translate}}\">\n</reference-person-type-select></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON_DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndCloseDialog()\">{{ \'WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON_DIALOG.SAVE\' | translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/work-order-reference-person/components/funeral-arrangement-rights-select/funeral-arrangement-rights-select.tmpl.html","<md-input-container class=\"baldris-funeral-arrangement-rights-select md-block\"><label>{{vm.labelText}}</label>\n<md-select ng-model=\"vm.funeralArrangementRight\" ng-disabled=\"vm.isDisabled\"><md-option \nng-repeat=\"option in vm.options\" value=\"{{option.value}}\">{{option.text | translate}}</md-option></md-select>\n</md-input-container>");
$templateCache.put("app/main/work-order-reference-person/components/reference-person-list-item/reference-person-list-item.tmpl.html","<md-list-item class=\"reference-person-list-item md-3-line md-long-text\" \nng-click=\"vm.showEditReferencePersonDialog(vm.baldrisModel, $event)\" \nng-class=\"{\'selected\': vm.highlight, \'md-grey-300-bg\': vm.highlight}\"><md-icon md-font-icon=\"icon-account\" \nclass=\"md-avatar-icon\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{ vm.baldrisModel.lastName | translate }}, {{ vm.baldrisModel.firstName | translate }}</h3><h4>\n{{ vm.getReferencePersonTypesString() }}</h4><p>{{ vm.baldrisModel.familyRelation }}</p></div><md-button \nng-if=\"vm.baldrisModel.privacyOptions === \'none\'\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.showEditReferencePersonDialog(vm.baldrisModel, $event)\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PARTY.EDIT_PARTY.PRIVACY_NOT_SET\"></span></md-tooltip><md-icon md-font-icon=\"icon-shield\" \nclass=\"md-warn-fg\" aria-label=\"Privacy Options not set!\"></md-icon></md-button><md-button ng-if=\"vm.isRestricted()\" \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.showEditReferencePersonDialog(vm.baldrisModel, $event)\"><md-tooltip \nmd-direction=\"top\"><span translate=\"PARTY.EDIT_PARTY.PRIVACY_RESTRICTED\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-block-helper\" class=\"md-warn-fg\" aria-label=\"Privacy Options not set!\"></md-icon></md-button>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteReferencePerson($event)\"><md-tooltip \nmd-direction=\"top\"><span translate=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.REMOVE_REFERENCE_PERSON\"></span>\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item>");
$templateCache.put("app/main/work-order-reference-person/components/reference-person-type-multi-select/reference-person-type-multi-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{ vm.labelText }}</label><md-select ng-model=\"vm.referencePersonTypes\" \nng-change=\"vm.onChange()\" multiple=\"true\"><md-option ng-repeat=\"option in vm.referencePersonTypeOptions\" \nng-value=\"option\">{{ option.text | translate }}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/work-order-reference-person/components/reference-person-type-select/reference-person-type-select.tmpl.html","<div class=\"baldris-reference-person-type-select\" ng-form=\"vm.referenceTypeForm\"><label class=\"md-caption\">\n{{vm.labelText}}</label><div class=\"baldris-options\" layout=\"row\" layout-align=\"start center\" layout-wrap><md-checkbox \nng-disabled=\"vm.isDisabled\" ng-if=\"option.value > 0\" ng-repeat=\"option in vm.options\" \nng-checked=\"vm.isSelected(option)\" ng-click=\"vm.toggle(option)\">{{ option.text | translate }}</md-checkbox></div></div>");
$templateCache.put("app/main/work-order-reference-person/edit-reference-person/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-edit-reference-person-sidebar\" layout=\"column\"><div class=\"sidebar-title\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\">\n</md-icon><span class=\"title-text\">{{\'COMMON.DATA.PROPERTIES\' | translate}}</span></div></div><div \nng-form=\"vm.data.validation.referencePersonSidebarForm\" class=\"sidebar-content\" layout=\"column\" layout-padding \nng-if=\"!vm.loadingService.isLoading\"><baldris-audit title-text=\"vm.data.updateModel.referencePerson.lastName\" \naudit-model=\"vm.data.updateModel.referencePerson\"></baldris-audit><div class=\"margin-top-20\">\n<funeral-arrangement-rights-select ng-disabled=\"vm.data.isPseudomized()\" \nng-model=\"vm.data.updateModel.referencePerson.funeralArrangementRight\" \nlabel-text=\"{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.FUNERAL_ARRANGEMENT_RIGHT\' | translate}}\">\n</funeral-arrangement-rights-select></div><div><enum-flag-select \nenum-flag=\"vm.data.updateModel.referencePerson.referencePersonType\" enum-flag-options=\"referencePersonTypeOptions\" \nlabel-text=\"{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.REFERENCE_PERSON_TYPE\' | translate}}\" \nis-disabled=\"vm.data.isPseudomized()\" on-update=\"vm.referenceTypeChanged(value)\"></enum-flag-select></div><div>\n<lookup-string-select ng-disabled=\"vm.data.isPseudomized()\" \nlabel-text=\"{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.FAMILY_RELATION\' | translate}}\" \nlookup-string-id=\"vm.familyRelationId\" lookup-string=\"vm.familyRelation\" \nlookup-string-config=\"\'FamilyRelationLookupStringType\'\" allow-custom=\"true\" \ncustom-value=\"vm.data.updateModel.referencePerson.familyRelation\"></lookup-string-select></div><div layout=\"column\">\n<div class=\"margin-bottom-20\"><md-checkbox flex ng-disabled=\"vm.data.isPseudomized()\" \nng-model=\"vm.data.updateModel.referencePerson.shouldGetOrderSummary\" aria-label=\"Should get order summary\">\n{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.SHOULD_GET_ORDER_SUMMARY\' | translate}}</md-checkbox></div>\n<div><md-input-container class=\"md-block\"><label>\n{{\'WORK_ORDER_REFERENCE_PERSONS.WORK_ORDER_REFERENCE_PERSON.SORT_ORDER\' | translate }}</label><input \nng-disabled=\"vm.data.isPseudomized()\" ng-model=\"vm.data.updateModel.referencePerson.sortOrder\" type=\"number\" step=\"10\">\n</md-input-container></div></div></div></div>");
$templateCache.put("app/main/work-order-reference-person/edit-reference-person/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span ng-if=\"!vm.data.isPseudomized()\" \ntranslate=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.EDITING_TEXT\" \ntranslate-values=\"{ personName: vm.data.updateModel.referencePerson.lastName + \', \' + vm.data.updateModel.referencePerson.firstName }\">\n</span> <span ng-if=\"vm.data.isPseudomized()\">{{ vm.data.updateModel.referencePerson.displayName | translate }}</span> \n<span ng-if=\"vm.data.validation.referencePersonForm.$dirty || vm.data.validation.referencePersonSidebarForm.$dirty\">*\n</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-disabled=\"vm.data.validation.referencePersonForm.$pristine && vm.data.validation.referencePersonSidebarForm.$pristine\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SAVE\"><md-tooltip md-direction=\"top\">\n<span translate=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.SAVE\"></span></md-tooltip><md-icon \nclass=\"md-primary-fg\" md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.CANCEL\"><md-tooltip md-direction=\"top\">\n<span translate=\"WORK_ORDER_REFERENCE_PERSONS.EDIT_REFERENCE_PERSON.CANCEL\"></span></md-tooltip><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/privacy/privacy-fields/edit-privacy-field/edit-privacy-field.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PRIVACY.PRIVACY_FIELD.EDIT_PRIVACY_FIELD\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"COMMON.DATA.SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"COMMON.DIALOG.SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DATA.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><div class=\"edit-privacy-field\"><div ng-if=\"vm.loadingService.isLoading\" flex \nlayout=\"row\" layout-padding layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><md-content class=\"content\" ng-form=\"vm.editPrivacyFieldForm\" \nng-if=\"!vm.loadingService.isLoading\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex \nflex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"PRIVACY.PRIVACY_FIELD.PRIVACY_FIELD\" | translate }}</div></div><md-content layout-padding layout=\"column\"><div>\n<md-input-container class=\"md-block\"><label>{{ \"PRIVACY.PRIVACY_FIELD.TEXT\" | translate }}</label><input \nng-model=\"vm.privacyField.text\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PRIVACY.PRIVACY_FIELD.DESCRIPTION\" | translate }}</label><input ng-model=\"vm.privacyField.description\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PRIVACY.PRIVACY_FIELD.LEGAL_REMARKS\" | translate }}</label><input ng-model=\"vm.privacyField.legalRemarks\">\n</md-input-container></div><div ng-if=\"vm.privacyField.legalRemarks\"><report-multi-select \nlabel-text=\"{{ \'PRIVACY.PRIVACY_FIELD.ATTACHED_REPORTS\' | translate }}\" reports=\"vm.attachedReports\" \non-update=\"vm.onAttachedReportChange(action, item)\"></report-multi-select></div><div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.privacyField.isRequired\" \naria-label=\"{{ \'PRIVACY.PRIVACY_FIELD.IS_REQUIRED\' | translate }}\">\n{{ \"PRIVACY.PRIVACY_FIELD.IS_REQUIRED\" | translate }}</md-checkbox></md-input-container></div><div><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.privacyField.isDeleted\" \naria-label=\"{{ \'PRIVACY.PRIVACY_FIELD.IS_DELETED\' | translate }}\">{{ \"PRIVACY.PRIVACY_FIELD.IS_DELETED\" | translate }}\n</md-checkbox></md-input-container></div><div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.privacyField.onlyWhenNoMatch\" aria-label=\"{{ \'PRIVACY.PRIVACY_FIELD.ONLY_WHEN_NO_MATCH\' | translate }}\">\n{{ \"PRIVACY.PRIVACY_FIELD.ONLY_WHEN_NO_MATCH\" | translate }}</md-checkbox></md-input-container></div><div>\n<work-order-type-select is-required=\"false\" flex work-order-type-id=\"vm.privacyField.workOrderTypeId\" \nwork-order-type=\"vm.privacyField.workOrderType\" label-text=\"{{ \'PRIVACY.PRIVACY_FIELD.WORK_ORDER_TYPE\' | translate }}\">\n</work-order-type-select></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PRIVACY.PRIVACY_FIELD.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.privacyField.sortOrder\"></md-input-container></div><div><reference-person-type-select \nng-model=\"vm.privacyField.referencePersonTypeMask\" \nlabel-text=\"{{ \'PRIVACY.PRIVACY_FIELD.REFERENCE_PERSON_TYPE_MASK\' | translate }}\"></reference-person-type-select></div>\n</md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CANCEL\">{{ \"GRAVES.EDIT_GRAVE.CANCEL\" | translate }}\n</md-button><md-button ng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.ceremonyForm.$pristine\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.SAVE\">{{ \"GRAVES.EDIT_GRAVE.SAVE\" | translate }}</md-button></div>\n</md-content></div>");
$templateCache.put("app/main/work-order/work-order/grooming-transport/work-order-grooming-transport.tmpl.html","<form name=\"workOrderTransportForm\" flex layout-padding layout=\"column\" \nng-if=\"vm.service.isOptionEnabled(\'hasTransports\') || vm.service.isOptionEnabled(\'hasGrooming\') || vm.data.groomingTransports.length > 0\">\n<div flex layout-gt-lg=\"row\" layout-align=\"space-between start\" layout-wrap><div ng-if=\"!vm.loadingService.isLoading\" \nng-repeat=\"groomingTransport in vm.data.groomingTransports | orderBy:\'start\'\" flex-gt-lg=\"50\"><transport-card \nng-if=\"vm.data.isGrooming(groomingTransport)\" baldris-model=\"groomingTransport\" \non-open=\"vm.data.navigateToGroomingTransport\" on-delete=\"vm.data.deleteGroomingTransport\"></transport-card>\n<grooming-card ng-if=\"vm.data.isTransport(groomingTransport, true)\" baldris-model=\"groomingTransport\" \non-open=\"vm.data.navigateToGroomingTransport\" on-delete=\"vm.data.deleteGroomingTransport\"></grooming-card></div><div \nclass=\"add-card-element-container\" flex layout=\"column\"><div class=\"add-card-element-border\" flex layout=\"column\">\n<md-button class=\"item md-block\" aria-label=\"Add new Ceremony\" \nng-click=\"vm.data.showAddGroomingTransportDialog($event)\"><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"icon icon-bookmark-plus s16\"></span> <span class=\"title\">\n{{\'WORK_ORDERS.WORK_ORDER.GROOMING_TRANSPORT.ADD_GROOMING_TRANSPORT\' | translate}}</span></div></md-button></div></div>\n<div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></form><div \nng-if=\"!(vm.service.isOptionEnabled(\'hasTransports\') || vm.service.isOptionEnabled(\'hasGrooming\'))\" layout-padding \nlayout=\"column\"><p class=\"md-title text-center\">\n{{ \'WORK_ORDERS.WORK_ORDER.GROOMING_TRANSPORT.NOT_IN_WORK_ORDER_TYPE\' | translate }}</p><md-button \nclass=\"md-primary md-raised\" aria-label=\"{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\" \nng-click=\"vm.service.openModifyOptionsDialog($event)\">{{\'WORK_ORDERS.WORK_ORDER.MODIFY_OPTIONS\' | translate}}\n</md-button></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/ceremony/components/edit-ceremony-dialog/views/ceremony-calendar-event.tmpl.html","<div layout-column><label class=\"md-caption\">{{\'CALENDAR.EVENT.START_TIME\' | translate}}</label><div \nclass=\"baldris-date-time\" layout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" \nmoment-picker=\"vm.startMoment\" format=\"x\" min-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"s18 icon icon-calendar\"></i> <span>{{vm.startMoment | date:\'mediumDate\'}}</span>\n</div></div><div class=\"picker hour-picker\" moment-picker=\"vm.startMoment\" format=\"x\" min-view=\"day\" max-view=\"hour\" \nstart-view=\"day\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>\n{{vm.startMoment | date:\'shortTime\'}}</span></div></div><div class=\"remove-date\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"vm.startMoment = \'\'\"><i class=\"s16 icon icon-close\"></i></div></div><label \nclass=\"md-caption\">{{\'CALENDAR.EVENT.END_TIME\' | translate}}</label><div class=\"baldris-date-time\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.endMoment\" format=\"x\" min-view=\"year\" \nmax-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-calendar\">\n</i> <span>{{vm.endMoment | date:\'mediumDate\'}}</span></div></div><div class=\"picker hour-picker\" \nmoment-picker=\"vm.endMoment\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.endMoment | date:\'shortTime\'}}</span></div>\n</div><div class=\"remove-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.endMoment = \'\'\"><i \nclass=\"s16 icon icon-close\"></i></div></div></div>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-boolean.tmpl.html","<div flex><md-checkbox ng-model=\"vm.baldrisModel.data[0].boolData\" aria-label=\"{{vm.baldrisModel.label}}\" \nng-change=\"vm.onValueChanged()\">{{ vm.baldrisModel.label }}</md-checkbox></div>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-date-time.tmpl.html","<div layout=\"column\" flex><h4>{{ vm.baldrisModel.label }}</h4><date-time-select \nbaldris-model=\"vm.baldrisModel.data[0].dateTimeData\" on-update=\"vm.onValueChanged()\"></date-time-select></div>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-decimal.tmpl.html","<md-input-container flex><label>{{ vm.baldrisModel.label }}</label><input \nng-model=\"vm.baldrisModel.data[0].decimalData\" type=\"number\" step=\"0.1\" ng-change=\"vm.onValueChanged()\">\n</md-input-container>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-long.tmpl.html","<md-input-container flex><label>{{ vm.baldrisModel.label }}</label><input ng-model=\"vm.baldrisModel.data[0].longData\" \nng-change=\"vm.onValueChanged()\"></md-input-container>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-lookup-string.tmpl.html","<lookup-string-select flex lookup-string=\"vm.baldrisModel.data[0].lookupString\" \non-update=\"vm.selectedItemChange(value)\" lookup-string-id=\"vm.baldrisModel.data[0].lookupStringId\" \ndisplay-text=\"vm.baldrisModel.data[0].lookupStringLookupValue\" \nlookup-string-config=\"vm.baldrisModel.dataTypeDiscriminator\" min-query-length=\"0\" \nallow-custom=\"vm.baldrisModel.allowCustom\" custom-value=\"vm.baldrisModel.data[0].stringData\" \nlabel-text=\"{{vm.baldrisModel.label}}\"></lookup-string-select>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-product.tmpl.html","<div class=\"edit-custom-field-product\" layout=\"column\" flex><h5 class=\"md-caption\">{{ vm.baldrisModel.label }}</h5><div\n layout=\"column\" layout-gt-xs=\"row\" flex \nng-repeat=\"currentData in vm.baldrisModel.data | filter: { changeState: \'!3\' } | orderBy:\'sortOrder\'\"><div \nflex-gt-xs=\"20\"><md-input-container><label>{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.AMOUNT\' | translate }}</label><input \nng-model=\"currentData.decimalData\" type=\"number\" step=\"0.1\" ng-change=\"vm.onValueChanged()\"></md-input-container></div>\n<div layout=\"row\" layout-align=\"center\" flex-gt-xs=\"80\"><product-select flex suggested-products=\"vm.suggestedProducts\" \nquery-controller=\"CustomFields\" \nquery-uri-override=\"vm.baldrisModel.attachedProductsIsChoices ? \'GetAttachedProducts/\' + vm.baldrisModel.id : null\" \nproduct=\"currentData.product\" product-id=\"currentData.productId\" \nlabel-text=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.OPTIONS.PRODUCT\' | translate }}\" \non-update=\"vm.onProductChanged(currentData, value)\"></product-select><md-button class=\"md-icon-button delete-button\" \nng-click=\"vm.deleteData(currentData)\" aria-label=\"Search\" translate-attr-aria-label=\"COMMON.DATA.DELETE\" \nng-disabled=\"vm.isDisabled || vm.disableSearch\" tabindex=\"-1\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.DELETE\"></span></md-tooltip><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div><md-button ng-if=\"vm.baldrisModel.isMultiSelect\" class=\"md-raised\" ng-click=\"vm.addNewData()\">\n{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.ADD_MORE\' | translate }}</md-button></div>");
$templateCache.put("app/main/custom-field/components/edit-custom-field/templates/edit-string.tmpl.html","<md-input-container flex><label>{{ vm.baldrisModel.label }}</label><input \nng-model=\"vm.baldrisModel.data[0].stringData\" ng-change=\"vm.onValueChanged()\"></md-input-container>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/citizenship-and-religion.html","<md-content class=\"deceased citizenship-and-religion\" layout-padding layout=\"column\"><country-select \nlabel-text=\"{{\'DECEASED.DECEASED.CITIZENSHIP\' | translate}}\" country-id=\"vm.countryId\" country=\"vm.country\" \nallow-custom=\"true\" custom-value=\"vm.deceased.citizenship\"></country-select><party-select \nlabel-text=\"{{\'DECEASED.DECEASED.RELIGION\' | translate}}\" party-id=\"vm.deceased.religionId\" \nparty=\"vm.deceased.religion\" allowed-party-type-ids=\"vm.allowedReligionPartyTypeIds\"></party-select><party-select \nlabel-text=\"{{\'DECEASED.DECEASED.CONGREGATION\' | translate}}\" party-id=\"vm.deceased.congregationId\" \nparty=\"vm.deceased.congregation\" allowed-party-type-ids=\"vm.allowedCongregationPartyTypeIds\"></party-select>\n</md-content>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/death-circumstances.html","<md-content class=\"deceased death-circumstances\" layout-padding layout=\"column\"><div layout-gt-sm=\"row\"><div \nlayout=\"column\"><label class=\"md-caption\">{{\'PARTY.PERSON.DATE_OF_DEATH\' | translate}}</label><md-datepicker \nng-model=\"vm.deceased.person.dateOfDeath\" md-placeholder=\"{{\'PARTY.PERSON.DATE_OF_DEATH\' | translate}}\">\n</md-datepicker></div><md-input-container flex><label>{{\'DECEASED.DECEASED.CAUSE_OF_DEATH\' | translate }}</label><input\n ng-model=\"vm.deceased.causeOfDeath\"></md-input-container></div><md-checkbox ng-model=\"vm.deceased.wasStillborn\">\n{{\'DECEASED.DECEASED.WAS_STILLBORN\' | translate}}</md-checkbox><location-select \nlabel-text=\"{{\'DECEASED.DECEASED.PLACE_OF_DEATH\' | translate}}\" location-id=\"vm.deceased.placeOfDeathId\" \nlocation=\"vm.deceased.placeOfDeath\"></location-select></md-content>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/miscellaneous.html","<md-content class=\"deceased miscellaneous\" layout-padding layout=\"column\"><md-input-container flex><label>\n{{\'DECEASED.DECEASED.WORK_TITLE\' | translate }}</label><input ng-model=\"vm.deceased.workTitle\"></md-input-container>\n<md-input-container flex><label>{{\'DECEASED.DECEASED.CLOSEST_FAMILY\' | translate }}</label><input \nng-model=\"vm.deceased.closestFamily\"></md-input-container><div layout=\"row\"><md-checkbox \nng-model=\"vm.deceased.isGovernmentEmployee\">{{\'DECEASED.DECEASED.IS_GOVERNMENT_EMPLOYEE\' | translate}}</md-checkbox>\n<md-checkbox ng-model=\"vm.deceased.isOutOfTown\">{{\'DECEASED.DECEASED.IS_OUT_OF_TOWN\' | translate}}</md-checkbox>\n<md-checkbox ng-model=\"vm.deceased.isToBeCremated\">{{\'DECEASED.DECEASED.IS_TO_BE_CREMATED\' | translate}}</md-checkbox>\n</div></md-content>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/municipalities.html","<md-content class=\"deceased municipalities\" layout-padding layout=\"column\"><municipality-select \nlabel-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_RESIDENCE\' | translate}}\" \nmunicipality-id=\"vm.deceased.municipalityOfResidenceId\" municipality=\"vm.deceased.municipalityOfResidence\">\n</municipality-select><municipality-select label-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_BIRTH\' | translate}}\" \nmunicipality-id=\"vm.deceased.municipalityOfBirthId\" municipality=\"vm.deceased.municipalityOfBirth\">\n</municipality-select><municipality-select label-text=\"{{\'DECEASED.DECEASED.MUNICIPALITY_OF_DEATH\' | translate}}\" \nmunicipality-id=\"vm.deceased.municipalityOfDeathId\" municipality=\"vm.deceased.municipalityOfDeath\">\n</municipality-select></md-content>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/personalia.html","<md-content layout-padding layout=\"column\" class=\"deceased personalia\"><edit-party baldris-model=\"vm.deceased.person\" \nis-disabled=\"vm.isDisabled\"></edit-party><marital-status-select on-changed=\"vm.onMaritalStatusChanged\" \nlabel-text=\"{{\'DECEASED.DECEASED.MARITAL_STATUS\' | translate}}\" marital-status=\"vm.deceased.maritalStatus\">\n</marital-status-select><md-input-container flex ng-show=\"vm.showYearOfMarriage\"><label>\n{{\'DECEASED.DECEASED.YEAR_OF_MARRIAGE\' | translate }}</label><input ng-model=\"vm.deceased.yearOfMarriage\">\n</md-input-container></md-content>");
$templateCache.put("app/main/deceased/components/edit-deceased-dialog/views/probate.html","<md-content class=\"deceased probate\" layout-padding layout=\"column\"><leaves-behind-select \nlabel-text=\"{{\'DECEASED.DECEASED.DECEASED_LEAVES_BEHIND\' | translate}}\" \ndeceased-leaves-behind=\"vm.deceased.deceasedLeavesBehind\"></leaves-behind-select><probate-select \nlabel-text=\"{{\'DECEASED.DECEASED.PROBATE\' | translate}}\" probate=\"vm.deceased.probate\"></probate-select>\n<md-input-container flex><label>{{\'DECEASED.DECEASED.ASSETS\' | translate }}</label><textarea \nng-model=\"vm.deceased.assets\" rows=\"5\"></textarea></md-input-container><md-input-container flex><label>\n{{\'DECEASED.DECEASED.REMARKS\' | translate }}</label><textarea ng-model=\"vm.deceased.remarks\" rows=\"5\"></textarea>\n</md-input-container></md-content>");
$templateCache.put("app/main/deceased/grant-application/dialogs/edit-grant-application-dialog/edit-grant-application-dialog.tmpl.html","<md-dialog class=\"edit-grant-application-dialog edit-dialog\" aria-label=\"Edit Grant Application\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">\n{{\'GRANT_APPLICATIONS.EDIT_GRANT_APPLICATION.EDIT_GRANT_APPLICATION\' | translate}}</span></div></md-toolbar>\n<md-dialog-content layout=\"column\"><div><enum-flag-select enum-flag=\"vm.grantApplication.options\" \nenum-flag-options=\"grantApplicationOptions\" \nlabel-text=\"{{\'GRANT_APPLICATIONS.GRANT_APPLICATION_OPTIONS.GRANT_APPLICATION_OPTIONS\' | translate}}\">\n</enum-flag-select></div><div><md-input-container class=\"md-block\"><label>\n{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.FUNERAL_COST\' | translate }}</label><input \nng-model=\"vm.grantApplication.funeralCost\" ng-currency md-autofocus></md-input-container></div><div><md-input-container\n class=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.TRANSPORT_COST\' | translate }}</label><input \nng-model=\"vm.grantApplication.transportCost\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.HEADSTONE_COST\' | translate }}</label><input \nng-model=\"vm.grantApplication.headstoneCost\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.GOVERNMENT_COST\' | translate }}</label><input \nng-model=\"vm.grantApplication.governmentCost\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.ASSETS_DECEASED\' | translate }}</label><input \nng-model=\"vm.grantApplication.assets\" ng-currency></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.INSURANCE_PAYOUT\' | translate }}</label><input \nng-model=\"vm.grantApplication.insurancePayout\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.PENSION_PAYOUT\' | translate }}</label><input \nng-model=\"vm.grantApplication.pensionPayout\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.OTHER_PAYOUT\' | translate }}</label><input \nng-model=\"vm.grantApplication.otherPayout\" ng-currency></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.UNION_FORM\' | translate }}</label><input \nng-model=\"vm.grantApplication.unionForm\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.WORK_PLACE\' | translate }}</label><input \nng-model=\"vm.grantApplication.workPlace\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{\'GRANT_APPLICATIONS.GRANT_APPLICATION.REMARKS\' | translate }}</label><textarea \nng-model=\"vm.grantApplication.remarks\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button class=\"md-primary\" ng-click=\"vm.closeDialog(vm.grantApplication)\">\n{{ \'COMMON.DIALOG.OK\' | translate}}</md-button><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/external-order/deceased-shipment/components/deceased-shipment-card/deceased-shipment-card.tmpl.html","<md-card class=\"deceased-shipment-card\"><md-card-header class=\"clickable\" \nng-click=\"vm.navigateToShipment(vm.baldrisModel)\"><md-card-avatar><md-icon \nng-if=\"vm.baldrisModel.carrierTypeLookupIconName\" md-font-icon=\"{{vm.baldrisModel.carrierTypeLookupIconName}}\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.carrierTypeLookupIconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.externalOrderTypeName}} <span \nng-if=\"vm.baldrisModel.carrierTypeLookupValue\">({{vm.baldrisModel.carrierTypeLookupValue}})</span></span> <span \nclass=\"md-subhead\"><span class=\"icon icon-map-marker\"></span> {{vm.baldrisModel.departureLocationName}} <span \nclass=\"icon icon-crosshairs-gps\"></span> {{vm.baldrisModel.arrivalLocationName}}</span></md-card-header-text>\n</md-card-header><md-card-title class=\"clickable\" ng-click=\"vm.navigateToShipment(vm.baldrisModel)\">\n<md-card-title-text><span class=\"md-headline\">{{vm.baldrisModel.externalOrderTypeName}} <span \nng-if=\"vm.baldrisModel.carrierTypeLookupValue\">({{vm.baldrisModel.carrierTypeLookupValue}})</span></span>\n</md-card-title-text></md-card-title><md-card-content class=\"clickable\" \nng-click=\"vm.navigateToShipment(vm.baldrisModel)\"><div ng-if=\"vm.baldrisModel.deceasedPersonDisplayName\"><label \nclass=\"md-caption\">{{\'DECEASED.DECEASED.DECEASED\' | translate}}</label><p>{{vm.baldrisModel.deceasedPersonDisplayName}}\n</p></div></md-card-content><md-card-actions ng-hide=\"vm.disableLinks\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" ng-click=\"vm.navigateToShipment(vm.baldrisModel)\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" \naria-label=\"Delete\" ng-click=\"vm.deleteShipment(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment-details.tmpl.html","<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SHIPMENT_DETAILS\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\"><div><enum-flag-select enum-flag=\"vm.data.updateModel.deceasedShipment.options\" \nenum-flag-options=\"shipmentOptions\" label-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.OPTIONS\' | translate}}\">\n</enum-flag-select></div><div><enum-flag-select enum-flag=\"vm.data.updateModel.deceasedShipment.casketAttributes\" \nenum-flag-options=\"casketAttributes\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.CASKET_ATTRIBUTES\' | translate}}\"></enum-flag-select></div><div>\n<md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SHIPMENT_REMARKS\' | translate}}\n</label><textarea ng-model=\"vm.data.updateModel.deceasedShipment.shipmentRemarks\"></textarea></md-input-container>\n</div></md-content></ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment-slips.tmpl.html","<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ \"EXTERNAL_ORDERS.DECEASED_SHIPMENT.SHIPMENT_SLIPS\" | translate }}</div></div><md-content layout-padding \nlayout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \"EXTERNAL_ORDERS.DECEASED_SHIPMENT.ENCLOSED_DOCUMENTS\" | translate }}</label><textarea \nng-model=\"vm.data.updateModel.deceasedShipment.enclosedDocuments\"></textarea></md-input-container></div><div>\n<md-checkbox ng-model=\"vm.data.updateModel.deceasedShipment.enclosedDocumentsAreOriginals\">\n{{ \"EXTERNAL_ORDERS.DECEASED_SHIPMENT.ENCLOSED_DOCUMENTS_ARE_ORIGINALS\" | translate }}</md-checkbox></div><div>\n<md-input-container class=\"md-block\"><label>\n{{ \"EXTERNAL_ORDERS.DECEASED_SHIPMENT.LAISSES_PASSER_AUTHORITY_OF_ISSUE\" | translate }}</label><input \nng-model=\"vm.data.updateModel.deceasedShipment.laissesPasserAuthorityOfIssue\"></md-input-container></div>\n<md-input-container class=\"md-block\"><label>\n{{ \"EXTERNAL_ORDERS.DECEASED_SHIPMENT.LAISSES_PASSER_ISSUE_DATE\" | translate }}</label><date-select \nng-model=\"vm.data.updateModel.deceasedShipment.laissesPasserIssueDate\"></date-select></md-input-container></md-content>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/deceased-shipment/edit-deceased-shipment/views/shipment.tmpl.html","<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.DECEASED_SHIPMENT\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\"><lookup-string-select label-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.CARRIER_TYPE\' | translate}}\" \nmin-query-length=\"0\" lookup-string-config=\"\'CarrierType\'\" \nlookup-string-id=\"vm.data.updateModel.deceasedShipment.carrierTypeId\" \nlookup-string=\"vm.data.updateModel.deceasedShipment.carrierType\"></lookup-string-select><supplier-select \nlabel-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.CARRIER\' | translate}}\" \nsupplier=\"vm.data.updateModel.deceasedShipment.carrier\" supplier-id=\"vm.data.updateModel.deceasedShipment.carrierId\" \nsupplier-config=\"\'CarrierSupplierType\'\"></supplier-select><div><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.CARRIER_WAY_BILL\' | translate}}</label><input \nng-model=\"vm.data.updateModel.deceasedShipment.carrierWayBill\"></md-input-container></div><location-select \nlabel-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.DEPARTURE_LOCATION\' | translate}}\" \nlocation-id=\"vm.data.updateModel.deceasedShipment.departureLocationId\" \nlocation=\"vm.data.updateModel.deceasedShipment.departureLocation\" location-config=\"\'DepartureLocationType\'\" \nmin-query-length=\"0\"></location-select><div><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.STOP_OVER\' | translate}}</label><input \nng-model=\"vm.data.updateModel.deceasedShipment.stopOver\"></md-input-container></div><location-select \nlabel-text=\"{{\'EXTERNAL_ORDERS.DECEASED_SHIPMENT.ARRIVAL_LOCATION\' | translate}}\" \nlocation-id=\"vm.data.updateModel.deceasedShipment.arrivalLocationId\" \nlocation=\"vm.data.updateModel.deceasedShipment.arrivalLocation\" location-config=\"\'ArrivalLocationType\'\" \nmin-query-length=\"0\"></location-select><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\" class=\"sender\">\n<label class=\"md-caption\">{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SENDER\' | translate }}</label><p class=\"not-selected\" \nng-if=\"!vm.data.updateModel.deceasedShipment.senderId\">\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SENDER_WILL_BE_SELECTED\' | translate }}</p><p \nng-if=\"vm.data.updateModel.deceasedShipment.senderId\">{{ vm.data.updateModel.deceasedShipment.senderDisplayName }}</p>\n<md-button ng-click=\"vm.data.openSelectSenderDialog($event)\" class=\"md-raised md-accent\">\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SELECT_SENDER\' | translate }}</md-button></div><div flex-gt-sm=\"50\" \nclass=\"receiver\"><label class=\"md-caption\">{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.RECEIVER\' | translate }}</label><p \nclass=\"not-selected\" ng-if=\"!vm.data.updateModel.receiver\">\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.NO_RECEIVER_SELECTED\' | translate }}</p><div \nng-if=\"vm.data.updateModel.receiver\" class=\"selected-reciever\"><p>{{ vm.data.updateModel.receiver.displayName }}</p>\n<div ng-if=\"vm.data.isLoadingReceiverAddress\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-if=\"!vm.data.isLoadingReceiverAddress && vm.data.updateModel.receiverAddress\"><address \nng-bind-html=\"vm.data.getFormattedReceiverAddress() | nl2br\"></address></div></div><md-button \nng-click=\"vm.data.openSelectReceiverDialog($event)\" class=\"md-raised md-accent\">\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.SELECT_RECEIVER\' | translate }}</md-button><md-button \nng-click=\"vm.data.openEditAddressDialog($event)\">\n{{ \'EXTERNAL_ORDERS.DECEASED_SHIPMENT.EDIT_RECEIVER_ADDRESS\' | translate }}</md-button></div></div></md-content>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/deceased-shipment/edit-deceased-shipment/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"EXTERNAL_ORDERS.DECEASED_SHIPMENT.EDITING_TEXT\" \ntranslate-values=\"{ deceasedShipmentText: vm.data.updateModel.deceasedShipment.departureLocation.name + \' -> \' + vm.data.updateModel.deceasedShipment.arrivalLocation.name }\">\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" \naria-label=\"OK, save...\" translate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/external-order/headstone-order/components/headstone-order-card/headstone-order-card.tmpl.html","<md-card class=\"headstone-order-card\"><md-card-header class=\"clickable\" \nng-click=\"vm.navigateToHeadstoneOrder(vm.baldrisModel)\"><md-card-avatar><md-icon \nng-if=\"vm.baldrisModel.externalOrderTypeIconName\" md-font-icon=\"{{vm.baldrisModel.externalOrderTypeIconName}}\">\n</md-icon><md-icon ng-if=\"!vm.baldrisModel.externalOrderTypeIconName\" md-font-icon=\"icon-help\"></md-icon>\n</md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.externalOrderTypeName}}</span> <span \nclass=\"md-subhead\">{{vm.baldrisModel.supplierName}}</span></md-card-header-text></md-card-header><img \nng-if=\"vm.baldrisModel.productProductImageUrl\" baldris-img-src=\"vm.baldrisModel.productProductImageUrl\" \npreset=\"small-landscape-cropped\" class=\"md-card-image\"><md-card-title class=\"clickable\" \nng-click=\"vm.navigateToHeadstoneOrder(vm.baldrisModel)\"><md-card-title-text><span class=\"md-headline\">\n{{vm.baldrisModel.externalOrderTypeName}}</span> <span class=\"md-subhead\">\n{{vm.baldrisModel.overriddenName || vm.baldrisModel.productName}}</span></md-card-title-text></md-card-title>\n<md-card-content class=\"clickable\" ng-click=\"vm.navigateToHeadstoneOrder(vm.baldrisModel)\"><div \nng-if=\"vm.baldrisModel.deceasedName\"><label class=\"md-caption\">{{\'DECEASED.DECEASED.DECEASED\' | translate}}</label><p>\n{{vm.baldrisModel.deceasedName}}</p></div></md-card-content><md-card-actions ng-hide=\"vm.disableLinks\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-accent\" aria-label=\"Edit\" \nng-click=\"vm.navigateToHeadstoneOrder(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>\n</md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteHeadstoneOrder(vm.baldrisModel, $event)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>\n</md-button></md-card-actions></md-card>");
$templateCache.put("app/main/external-order/headstone-order/dialogs/edit-grave-info-dialog/edit-grave-info-dialog.tmpl.html","<md-dialog ng-form=\"vm.editHeadstoneAdditionForm\" class=\"edit-flower-dialog edit-dialog\" \naria-label=\"{{ \'GRAVES.EDIT_GRAVE.EDITING_TEXT\' | translate }}\"><md-toolbar layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ \'GRAVES.EDIT_GRAVE.EDITING_TEXT\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content layout=\"column\"><p \nclass=\"md-warn-bg md-padding\">{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.EDIT_GRAVE_WARNING\' | translate }}</p>\n<location-select min-query-length=\"0\" display-text=\"vm.grave.cemeteryName\" location=\"vm.grave.cemetery\" \nlocation-id=\"vm.grave.cemeteryId\" location-config=\"\'CemeteryLocationType\'\" \nlabel-text=\"{{\'GRAVES.GRAVE.CEMETERY\' | translate}}\"></location-select><div><md-input-container class=\"md-block\">\n<label>{{\'GRAVES.GRAVE.GRAVE_NUMBER\' | translate}}</label><input ng-model=\"vm.grave.graveNumber\"></md-input-container>\n</div><div ng-if=\"vm.grave.leaseHolderId\" layout=\"column\" class=\"lease-holder\"><div class=\"lease-holder-name\">\n{{ \'GRAVES.GRAVE.LEASE_HOLDER\' | translate }}: {{vm.grave.leaseHolderName}}</div><div layout=\"row\" \nclass=\"action-buttons\"><md-button class=\"md-warn\" ng-click=\"vm.removeLeaseHolder()\" aria-label=\"Remove Lease Holder\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.REMOVE_LEASE_HOLDER\">\n{{ \'GRAVES.EDIT_GRAVE.REMOVE_LEASE_HOLDER\' | translate}}</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openChooseLeaseHolderDialog($event)\" aria-label=\"Choose New Lease Holder\" \ntranslate-attr-aria-label=\"GRAVES.EDIT_GRAVE.CHOOSE_NEW_LEASE_HOLDER\">\n{{ \'GRAVES.EDIT_GRAVE.CHOOSE_NEW_LEASE_HOLDER\' | translate}}</md-button></div></div><div><md-input-container \nclass=\"md-block\"><label>{{\'GRAVES.GRAVE.GRAVE_LEASE_NUMBER\' | translate}}</label><input \nng-model=\"vm.grave.graveLeaseNumber\"></md-input-container></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editHeadstoneAdditionForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/external-order/headstone-order/dialogs/edit-headstone-addition-dialog/edit-headstone-addition-dialog.tmpl.html","<md-dialog ng-form=\"vm.editHeadstoneAdditionForm\" class=\"edit-flower-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_ADDITION\' : \'EXTERNAL_ORDERS.HEADSTONE_ORDER.EDIT_ADDITION\' | translate }}\">\n<md-toolbar layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_ADDITION\' : \'EXTERNAL_ORDERS.HEADSTONE_ORDER.EDIT_ADDITION\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\"><product-select \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITION.PRODUCT\' | translate}}\" product=\"vm.headstoneAddition.product\" \nproduct-id=\"vm.headstoneAddition.productId\" on-selected=\"vm.onProductChanged\"></product-select><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex-gt-sm=\"15\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITION.PRODUCT_AMOUNT\' | translate}}</label><input \nng-model=\"vm.headstoneAddition.productAmount\" type=\"number\" step=\"0.1\"></md-input-container></div><div flex-gt-sm=\"85\">\n<md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITION.PRODUCT_NAME\' | translate}}\n</label><input ng-model=\"vm.headstoneAddition.overriddenName\"></md-input-container></div></div><edit-price-input \nng-if=\"vm.headstoneAddition.product\" price-ex-vat=\"vm.headstoneAddition.overriddenPrice\" \nvat-rate=\"vm.headstoneAddition.product.vatRate\" is-disabled=\"!vm.headstoneAddition.product\"></edit-price-input><div>\n<md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITION.SORT_ORDER\' | translate}}\n</label><input ng-model=\"vm.headstoneAddition.sortOrder\" type=\"number\" step=\"1\"></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITION.REMARKS\' | translate}}</label>\n<textarea ng-model=\"vm.headstoneAddition.remarks\"></textarea></md-input-container></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"!vm.isNew\" aria-label=\"Delete\" class=\"md-warn\" \nng-click=\"vm.deleteHeadstoneAddition()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_ADDITION\' | translate }}</md-button><span flex></span><md-button \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editHeadstoneAdditionForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/external-order/headstone-order/dialogs/edit-headstone-inscription-dialog/edit-headstone-inscription-dialog.tmpl.html","<md-dialog ng-form=\"vm.editHeadstoneInscriptionForm\" class=\"edit-headstone-inscription-dialog edit-dialog\" \naria-label=\"{{ vm.isNew ? \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_INSCRIPTION\' : \'EXTERNAL_ORDERS.HEADSTONE_ORDER.EDIT_INSCRIPTION\' | translate }}\">\n<md-toolbar layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.isNew ? \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_INSCRIPTION\' : \'EXTERNAL_ORDERS.HEADSTONE_ORDER.EDIT_INSCRIPTION\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content layout=\"column\"><div class=\"inscription-text\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex-gt-sm=\"80\" class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.TEXT\' | translate}}</label><textarea \nng-model=\"vm.headstoneInscription.text\"></textarea></md-input-container><md-input-container flex-gt-sm=\"20\" \nclass=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.SORT_ORDER\' | translate}}</label><input \nng-model=\"vm.headstoneInscription.sortOrder\" type=\"number\" step=\"1\"></md-input-container></div><h5 class=\"md-caption\" \nng-if=\"vm.nameSuggestions.length > 0\">Navneforslag</h5><md-chips ng-if=\"vm.nameSuggestions.length > 0\" \nclass=\"custom-chips\" ng-model=\"vm.nameSuggestions\" readonly=\"true\"><md-chip-template class=\"clickable\" \nng-class=\"{ disabled: vm.headstoneInscription.text.indexOf($chip.name) > -1 }\" ng-click=\"vm.addNameSuggestion($chip)\">\n<div><div><strong>{{$chip.name}}</strong></div><div><em>{{$chip.lifeSpan}}</em></div></div></md-chip-template>\n</md-chips></div><lookup-string-select min-query-length=\"0\" \ndisplay-text=\"vm.headstoneInscription.inscriptionTypeLookupValue\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.INSCRIPTION_TYPE\' | translate}}\" \nlookup-string=\"vm.headstoneInscription.inscriptionType\" lookup-string-id=\"vm.headstoneInscription.inscriptionTypeId\" \nlookup-string-config=\"\'HeadStoneInscriptionTypeLookupStringType\'\"></lookup-string-select><lookup-string-select \nmin-query-length=\"0\" display-text=\"vm.headstoneInscription.inscriptionFormLookupValue\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.INSCRIPTION_FORM\' | translate}}\" \nlookup-string=\"vm.headstoneInscription.inscriptionForm\" lookup-string-id=\"vm.headstoneInscription.inscriptionFormId\" \nlookup-string-config=\"\'HeadStoneInscriptionMethodLookupStringType\'\"></lookup-string-select><lookup-string-select \nmin-query-length=\"0\" display-text=\"vm.headstoneInscription.inscriptionColorLookupValue\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.INSCRIPTION_COLOR\' | translate}}\" \nlookup-string=\"vm.headstoneInscription.inscriptionColor\" lookup-string-id=\"vm.headstoneInscription.inscriptionColorId\" \nlookup-string-config=\"\'HeadStoneInscriptionColorLookupStringType\'\"></lookup-string-select><lookup-string-select \nmin-query-length=\"0\" display-text=\"vm.headstoneInscription.inscriptionFontLookupValue\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.INSCRIPTION_FONT\' | translate}}\" \nlookup-string=\"vm.headstoneInscription.inscriptionFont\" lookup-string-id=\"vm.headstoneInscription.inscriptionFontId\" \nlookup-string-config=\"\'HeadStoneInscriptionFontLookupStringType\'\"></lookup-string-select><div><md-checkbox \nng-model=\"vm.hasProduct\">{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.ADD_PRODUCT\' | translate}}</md-checkbox></div>\n<product-select ng-if=\"vm.hasProduct\" \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.PRODUCT\' | translate}}\" \nproduct=\"vm.headstoneInscription.product\" product-id=\"vm.headstoneInscription.productId\" \non-selected=\"vm.onProductChanged\"></product-select><div ng-if=\"vm.hasProduct\" layout=\"column\" layout-gt-sm=\"row\"><div \nflex-gt-sm=\"15\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.PRODUCT_AMOUNT\' | translate}}</label><input \nng-model=\"vm.headstoneInscription.productAmount\" type=\"number\" step=\"0.1\"></md-input-container></div><div \nflex-gt-sm=\"85\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.PRODUCT_NAME\' | translate}}</label><input \nng-model=\"vm.headstoneInscription.overriddenName\"></md-input-container></div></div><edit-price-input \nng-if=\"vm.headstoneInscription.product\" price-ex-vat=\"vm.headstoneInscription.overriddenPrice\" \nvat-rate=\"vm.headstoneInscription.product.vatRate\" is-disabled=\"!vm.headstoneInscription.product\"></edit-price-input>\n<div><md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTION.REMARKS\' | translate}}\n</label><textarea ng-model=\"vm.headstoneInscription.remarks\"></textarea></md-input-container></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button aria-label=\"Delete\" class=\"md-warn\" \nng-click=\"vm.deleteHeadstoneInscription()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.DELETE_INSCRIPTION\' | translate }}</md-button><span flex></span><md-button \naria-label=\"Cancel\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \naria-label=\"Choose\" class=\"md-primary\" ng-click=\"vm.saveChanges()\" \nng-disabled=\"vm.editHeadstoneInscriptionForm.$invalid\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/views/additions.tmpl.html","<ms-widget layout=\"column\" class=\"additions-widget\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.ADDITIONS\' | translate}}</div><span flex></span>\n<md-button class=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditHeadstoneAdditionDialog($event, null)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_ADDITION\"><md-tooltip \nmd-direction=\"top\"><span translate=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_ADDITION\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content layout=\"column\"><md-list flex><md-list-item \nclass=\"md-3-line\" \nng-repeat-start=\"addition in vm.data.updateModel.headstoneOrderAdditions | filter:{ changeState: \'!3\' } | orderBy: \'sortOrder\'\" \nng-click=\"vm.data.openEditHeadstoneAdditionDialog($event, addition)\"><div class=\"md-list-item-text\" layout=\"column\">\n<h3>{{ addition.productAmount || 0 }} – {{ addition.overriddenName || addition.productName }}</h3><h4>\n{{ addition.remarks }}</h4><p>{{ addition.overriddenPrice | currency }}</p></div></md-list-item><md-divider \nng-repeat-end ng-if=\"!$last\"></md-divider></md-list></md-content></ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/views/headstone-order.tmpl.html","<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.HEADSTONE_ORDER\' | translate}}</div></div><md-content layout-padding \nlayout=\"column\"><supplier-select label-text=\"{{\'EXTERNAL_ORDERS.EXTERNAL_ORDER.SUPPLIER\' | translate}}\" \nsupplier=\"vm.data.updateModel.headstoneOrder.supplier\" supplier-id=\"vm.data.updateModel.headstoneOrder.supplierId\" \nsupplier-config=\"\'HeadstoneSupplierType\'\"></supplier-select><div><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ESTIMATED_DELIVERY_TIME\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.estimatedDeliveryTime\"></md-input-container></div><product-select \nlabel-text=\"{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.MAIN_PRODUCT\' | translate}}\" \nproduct=\"vm.data.updateModel.headstoneOrder.product\" product-id=\"vm.data.updateModel.headstoneOrder.productId\" \non-selected=\"vm.data.onProductChanged\"></product-select><div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"15\">\n<md-input-container class=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.PRODUCT_AMOUNT\' | translate}}</label>\n<input ng-model=\"vm.data.updateModel.headstoneOrder.productAmount\" type=\"number\" step=\"0.1\"></md-input-container></div>\n<div flex-gt-sm=\"85\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.PRODUCT_NAME\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.overriddenName\"></md-input-container></div></div><edit-price-input \nng-if=\"vm.data.updateModel.headstoneOrder.product\" price-ex-vat=\"vm.data.updateModel.headstoneOrder.overriddenPrice\" \nvat-rate=\"vm.data.updateModel.headstoneOrder.product.vatRate\" \nis-disabled=\"!vm.data.updateModel.headstoneOrder.product\"></edit-price-input><div><md-checkbox \nng-model=\"vm.data.updateModel.headstoneOrder.isNewHeadstone\">\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.IS_NEW_HEADSTONE\' | translate}}</md-checkbox></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.data.updateModel.headstoneOrder.isNewHeadstone\"><div flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.HEADSTONE_WIDTH\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.headstoneWidth\" type=\"number\" step=\"0.1\"></md-input-container></div><div \nflex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.HEADSTONE_HEIGHT\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.headstoneHeight\" type=\"number\" step=\"0.1\"></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.data.updateModel.headstoneOrder.isNewHeadstone\"><div \nflex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.HEADSTONE_DEPTH\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.headstoneDepth\" type=\"number\" step=\"0.1\"></md-input-container></div><div \nflex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.HEADSTONE_WEIGHT\' | translate}}</label><input \nng-model=\"vm.data.updateModel.headstoneOrder.headstoneWeight\" type=\"number\" step=\"0.1\"></md-input-container></div>\n</div><div><md-checkbox ng-model=\"vm.data.updateModel.headstoneOrder.shouldReserveSpaceForFurtherInscriptions\">\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.SHOULD_RESERVE_SPACE_FOR_FURTHER_INSCRIPTIONS\' | translate}}</md-checkbox></div>\n<div ng-if=\"vm.data.updateModel.headstoneOrder.shouldReserveSpaceForFurtherInscriptions\"><md-input-container \nclass=\"md-block\"><label>{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.ESTIMATED_FURTHER_INSCRIPTIONS\' | translate}}</label><input\n ng-model=\"vm.data.updateModel.headstoneOrder.estimatedFurtherInscriptions\" type=\"number\" step=\"1\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \'EXTERNAL_ORDERS.EXTERNAL_ORDER.REMARKS\' | translate}}</label><textarea \nng-model=\"vm.data.updateModel.headstoneOrder.remarks\"></textarea></md-input-container></div></md-content>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/views/inscriptions.tmpl.html","<ms-widget layout=\"column\" class=\"inscriptions-widget\"><ms-widget-front class=\"white-bg edit-page\"><div \nclass=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"md-title text-uppercase\">{{\'EXTERNAL_ORDERS.HEADSTONE_ORDER.INSCRIPTIONS\' | translate}}</div><span flex></span>\n<md-button class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.data.openEditHeadstoneInscriptionDialog($event, null)\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_INSCRIPTION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.ADD_NEW_INSCRIPTION\"></span></md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content layout=\"column\"><md-list flex><md-list-item class=\"md-3-line\" \nng-repeat-start=\"inscription in vm.data.updateModel.headstoneOrderInscriptions | filter:{ changeState: \'!3\' } | orderBy: \'sortOrder\'\" \nng-click=\"vm.data.openEditHeadstoneInscriptionDialog($event, inscription)\"><img ng-if=\"inscription.imageFilepath\" \nbaldris-img-src=\"inscription.imageFilepath\" preset=\"square-40-cropped\" class=\"md-avatar\" \nalt=\"{{inscription.inscriptionTypeLookupValue}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ inscription.inscriptionTypeLookupValue }}</h3><h4 ng-bind-html=\"inscription.text | nl2br\"></h4><p>\n{{ inscription.remarks }} <span ng-if=\"inscription.overriddenPrice\">({{ inscription.overriddenPrice | currency }})\n</span></p></div></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></md-content>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-headstone-order-sidebar\" layout=\"column\"><div class=\"sidebar-title\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" \nmd-font-icon=\"icon-briefcase-checked\"></md-icon><span class=\"title-text\">Status</span></div></div><div \nclass=\"sidebar-content\" layout=\"column\"><div class=\"audit\" ng-if=\"!vm.loadingService.isLoading\" layout=\"column\"><h3>\n{{vm.data.updateModel.headstoneOrder.externalOrderTypeName}}</h3><span \nng-if=\"vm.data.updateModel.headstoneOrder.createdBy\">\n{{ \'COMMON.DATA.CREATED_BY\' | translate }}: {{vm.data.updateModel.headstoneOrder.createdBy}}<span \nng-if=\"vm.data.updateModel.headstoneOrder.createdAt\">, {{vm.data.updateModel.headstoneOrder.createdAt | date:\'short\'}}\n</span><br></span><span ng-if=\"vm.data.updateModel.headstoneOrder.lastModifiedBy\">\n{{ \'COMMON.DATA.LAST_MODIFIED_BY\' | translate }}: {{vm.data.updateModel.headstoneOrder.lastModifiedBy}}<span \nng-if=\"vm.data.updateModel.headstoneOrder.lastModifiedAt\">\n, {{vm.data.updateModel.headstoneOrder.lastModifiedAt | date:\'short\'}}</span><br></span><p>\n{{ \'DECEASED.DECEASED.DECEASED\' | translate }}: {{vm.data.updateModel.headstoneOrder.deceasedName}}<br>\n{{ \'GRAVES.GRAVE.CEMETERY\' | translate }}: {{vm.data.updateModel.grave.cemeteryName}}<br>\n{{ \'GRAVES.GRAVE.GRAVE_NUMBER\' | translate }}: {{vm.data.updateModel.grave.graveNumber}}<br>\n{{ \'GRAVES.GRAVE.LEASE_HOLDER\' | translate }}: {{vm.data.updateModel.grave.leaseHolderName}}<br>\n{{ \'GRAVES.GRAVE.GRAVE_LEASE_NUMBER\' | translate }}: {{vm.data.updateModel.grave.graveLeaseNumber}}<br></p><md-button \nclass=\"md-raised md-accent md-block\" ng-click=\"vm.data.openEditGraveInfoDialog($event, vm.data.updateModel.grave)\">\n{{ \'EXTERNAL_ORDERS.HEADSTONE_ORDER.CHANGE_GRAVE_DATA\' | translate }}</md-button></div></div></div>");
$templateCache.put("app/main/external-order/headstone-order/edit-headstone-order/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"EXTERNAL_ORDERS.HEADSTONE_ORDER.EDITING_TEXT\" \ntranslate-values=\"{ headstoneOrderText: vm.data.updateModel.headstoneOrder.externalOrderTypeName }\"></span> <span \nng-if=\"vm.data.validation.headstoneOrderForm.$dirty\">*</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task/note-or-task.tmpl.html","<div class=\"note-or-task clickable\" ng-click=\"vm.openEditDialog($event)\"><div class=\"item\" \nng-if=\"!(vm.isTask || vm.isFollowUp)\" \nng-include=\"\'app/main/note-or-task/components/note-or-task-list/note-or-task/templates/note.tmpl.html\'\" \nclass=\"md-3-line\"></div><div class=\"item\" ng-if=\"vm.isTask && vm.baldrisModel.isCompleted\" \nng-include=\"\'app/main/note-or-task/components/note-or-task-list/note-or-task/templates/task-completed.tmpl.html\'\" \nclass=\"md-3-line\"></div><div class=\"item\" ng-if=\"vm.isTask && !vm.baldrisModel.isCompleted\" \nng-include=\"\'app/main/note-or-task/components/note-or-task-list/note-or-task/templates/task-uncompleted.tmpl.html\'\" \nclass=\"md-3-line\"></div></div>");
$templateCache.put("app/main/note-or-task/components/status-list/status-list-item/status-list-item.tmpl.html","<div md-theme=\"trafficLight\"><div class=\"status-list-item\" \nng-class=\"{ \'md-primary-bg\': vm.baldrisModel.isCompleted, \'md-warn-bg\': !vm.baldrisModel.isCompleted && vm.isOverDue(), \'md-accent-bg\': !vm.baldrisModel.isCompleted && !vm.isOverDue() }\">\n<div class=\"status\" layout=\"row\"><span class=\"status-text\" flex>{{vm.baldrisModel.subject}} {{vm.baldrisModel.text}}\n</span><md-checkbox ng-click=\"vm.toggleTask($event)\" class=\"toggle-task\" ng-checked=\"vm.baldrisModel.isCompleted\" \naria-label=\"{{\'NOTE_OR_TASKS.NOTE_OR_TASK.SET_COMPLETED\' | translate}}\" \nng-class=\"{ \'md-primary\': vm.baldrisModel.isCompleted, \'md-warn\': !vm.baldrisModel.isCompleted && vm.isOverDue(), \'md-accent\': !vm.baldrisModel.isCompleted && !vm.isOverDue() }\">\n</md-checkbox></div><div class=\"status-info\"><span ng-if=\"vm.baldrisModel.isCompleted\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK.COMPLETED_BY\' | translate}} <span \nng-bind-html=\"vm.baldrisModel.completedBySerialized | serializedList\"></span>\n {{ vm.baldrisModel.firstCompleted | date:\'short\' }} </span><span ng-if=\"!vm.baldrisModel.isCompleted\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK.DUE_TIME\' | translate}} {{ vm.baldrisModel.dueTime | date:\'shortDate\' }}</span></div>\n</div></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/bool-element.tmpl.html","<div class=\"bool-element\" layout=\"column\"><md-input-container flex><md-checkbox \nng-change=\"vm.onProgramElementChanged(vm.programSlotElement.data)\" ng-model=\"vm.programSlotElement.data.boolData\" \naria-label=\"{{vm.programSlotElement.data.overriddenTitle || vm.programSlotElement.data.programSlot.title}}\">\n{{ vm.programSlotElement.data.boolData ? \'PROGRAMS.EDIT_PROGRAM.IS_SELECTED\' : \'PROGRAMS.EDIT_PROGRAM.IS_NOT_SELECTED\' | translate}}\n</md-checkbox></md-input-container></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/lookup-string-element.tmpl.html","<div class=\"lookup-string-element\" layout=\"column\"><lookup-string-select \nlookup-string=\"vm.programSlotElement.data.lookupStringData\" \nlookup-string-id=\"vm.programSlotElement.data.lookupStringDataId\" hide-label=\"true\" allow-custom=\"true\" \ncustom-value=\"vm.programSlotElement.data.stringData\" \nlookup-string-description=\"vm.programSlotElement.data.lookupStringDataDescription\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT_ELEMENT.SELECT_A_VALUE\' | translate}}\" use-description=\"true\" \ndisplay-text=\"vm.programSlotElement.data.lookupStringDataLookupValue\" \non-update=\"vm.onProgramElementChanged(vm.programSlotElement.data)\" \nlookup-string-type-id=\"vm.programSlotElement.data.programSlotLookupStringCategoryId\"></lookup-string-select></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/music-element.tmpl.html","<div class=\"music-element\" layout=\"column\"><song-select flex song-id=\"vm.programSlotElement.data.songDataId\" \nsong=\"vm.programSlotElement.data.songData\" allow-custom=\"true\" custom-value=\"vm.programSlotElement.data.stringData\" \nlabel-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" hide-label=\"true\" \non-update=\"vm.onProgramElementChanged(vm.programSlotElement.data)\" \ndisplay-text=\"vm.programSlotElement.data.songDataTitle\"></song-select></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/solo-element.tmpl.html","<div class=\"solo-element\" layout=\"column\"><song-select flex song-id=\"vm.programSlotElement.data.songDataId\" \nsong=\"vm.programSlotElement.data.songData\" allow-custom=\"true\" custom-value=\"vm.programSlotElement.data.stringData\" \nlabel-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" hide-label=\"true\" \non-update=\"vm.onProgramElementChanged(vm.programSlotElement.data)\" \ndisplay-text=\"vm.programSlotElement.data.songDataTitle\"></song-select></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/song-element.tmpl.html","<div class=\"song-element\" layout=\"column\"><song-select flex song-id=\"vm.programSlotElement.data.songDataId\" \nsong=\"vm.programSlotElement.data.songData\" allow-custom=\"true\" custom-value=\"vm.programSlotElement.data.stringData\" \nlabel-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" hide-label=\"true\" \non-update=\"vm.onSongChanged(action, value, vm.programSlotElement)\" \ndisplay-text=\"vm.programSlotElement.data.songDataTitle\"></song-select></div>");
$templateCache.put("app/main/program/components/program-slot-element/views/string-element.tmpl.html","<div class=\"string-element\" layout=\"column\" layout-padding><md-input-container md-no-float flex><textarea \nplaceholder=\"{{\'PROGRAMS.PROGRAM_SLOT_ELEMENT.ENTER_TEXT\' | translate}}\" \nng-change=\"vm.onProgramElementChanged(vm.programSlotElement.data)\" ng-model=\"vm.programSlotElement.data.stringData\">\n</textarea></md-input-container></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/bool-element.tmpl.html","<div class=\"bool-element\" layout=\"column\" layout-padding><h4>\n{{vm.programElement.overridenTitle || vm.programElement.programSlotTitle}}</h4><md-input-container flex><md-checkbox \nng-model=\"vm.programElement.boolData\" \naria-label=\"{{vm.programElement.overriddenTitle || vm.programElement.programSlot.title}}\">\n{{ vm.programElement.boolData ? \'PROGRAMS.EDIT_PROGRAM.IS_SELECTED\' : \'PROGRAMS.EDIT_PROGRAM.IS_NOT_SELECTED\' | translate}}\n</md-checkbox></md-input-container></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/lookup-string-element.tmpl.html","<div class=\"lookup-string-element\" layout=\"column\"><lookup-string-select \nlookup-string=\"vm.programElement.lookupStringData\" lookup-string-id=\"vm.programElement.lookupStringDataId\" \nlabel-text=\"{{vm.programElement.overridenTitle || vm.programElement.programSlotTitle}}\" allow-custom=\"true\" \ncustom-value=\"vm.programElement.stringData\" \nlookup-string-type-id=\"vm.programElement.programSlotLookupStringCategoryId\"></lookup-string-select></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/music-element.tmpl.html","<div class=\"music-element\" layout=\"column\"><song-select flex song-id=\"vm.programElement.songDataId\" \nsong=\"vm.programElement.songData\" ng-change=\"vm.onInputChange()\" allow-custom=\"true\" \ncustom-value=\"vm.programElement.stringData\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" \nlabel-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" display-text=\"vm.programElement.songDataTitle\"></song-select></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/solo-element.tmpl.html","<div class=\"solo-element\" layout=\"column\"><song-select flex song-id=\"vm.programElement.songDataId\" \nsong=\"vm.programElement.songData\" allow-custom=\"true\" custom-value=\"vm.programElement.stringData\" \nlabel-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" display-text=\"vm.programElement.songDataTitle\"></song-select></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/song-element.tmpl.html","<div class=\"song-element\" layout=\"column\"><song-select flex song-id=\"vm.programElement.songDataId\" \nsong=\"vm.programElement.songData\" label-text=\"{{\'SONGS.SONG.SONG\' | translate}}\" \ndisplay-text=\"vm.programElement.songDataTitle\" on-selected=\"vm.onSongSelected\"></song-select><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-list class=\"available-verses\"><md-subheader class=\"md-no-sticky\">\n{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.AVAILABLE_VERSES\' | translate}}</md-subheader><md-list-item \nng-class=\"{ \'md-accent-bg\': songVerse.id == vm.currentAvailableVerse.id }\" \nng-dblclick=\"vm.selectSongVerse(songVerse, $event)\" ng-click=\"vm.markAsSelected(songVerse)\" \nclass=\"md-2-line md-long-text\" ng-repeat=\"songVerse in vm.availableVerses | orderBy:\'sortOrder\'\"><div \nclass=\"md-list-item-text\"><h3>{{\'SONGS.SONG_VERSE.SONG_VERSE\' | translate}} - {{songVerse.verseNumber}}</h3><p>\n{{songVerse.text}}</p></div></md-list-item></md-list><div layout=\"column\" layout-align=\"space-around center\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.selectAllVerses()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECT_ALL_VERSES\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECT_ALL_VERSES\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right-bold\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.selectCurrentVerse()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECT_CURRENT_VERSE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECT_CURRENT_VERSE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeCurrentVerse()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.REMOVE_CURRENT_VERSE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.REMOVE_CURRENT_VERSE\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeAllVerses()\" \naria-label=\"Save\" translate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.REMOVE_ALL_VERSES\"><md-tooltip \nmd-direction=\"top\"><span translate=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.REMOVE_ALL_VERSES\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-left-bold\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.getRecommendedVerses()\" aria-label=\"Save\" \ntranslate-attr-aria-label=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.GET_RECOMMENDED_VERSES\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"PROGRAMS.EDIT_PROGRAM_ELEMENT.GET_RECOMMENDED_VERSES\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-auto-fix\"></md-icon></md-button></div><md-list class=\"selected-verses\"><md-subheader \nclass=\"md-no-sticky\">{{\'PROGRAMS.EDIT_PROGRAM_ELEMENT.SELECTED_VERSES\' | translate}}</md-subheader><md-list-item \nng-class=\"{ \'md-accent-bg\': programElementVerse == vm.currentElementVerse }\" \nng-dblclick=\"vm.removeProgramElementVerse(programElementVerse, $event)\" \nng-click=\"vm.markAsSelected(programElementVerse)\" class=\"md-2-line md-long-text\" \nng-repeat=\"programElementVerse in vm.programElement.programElementVerses | filter:{changeState:\'!3\'} | orderBy:\'sortOrder\'\">\n<div class=\"md-list-item-text\"><h3>{{\'SONGS.SONG_VERSE.SONG_VERSE\' | translate}} - {{programElementVerse.verseNumber}}\n</h3><p>{{programElementVerse.verseText || vm.getVerseText(programElementVerse.verseNumber)}}</p></div></md-list-item>\n</md-list></div></div>");
$templateCache.put("app/main/program/dialogs/edit-program-element-dialog/views/string-element.tmpl.html","<div class=\"string-element\" layout=\"column\" layout-padding><md-input-container flex><label>\n{{vm.programElement.overriddenTitle || vm.programElement.programSlotTitle}}</label><textarea md-autofocus \nng-model=\"vm.programElement.stringData\"></textarea></md-input-container></div>");
$templateCache.put("app/main/reference-types/address/components/address-list/address-list.tmpl.html","<md-list class=\"baldris-address-list\" ng-form=\"vm.addressListForm\"><md-subheader class=\"md-no-sticky\">\n{{ \'ADDRESSES.ADDRESSES\' | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditAddressDialog(address, $event)\" ng-repeat=\"address in vm.collection | orderBy:\'sortOrder\'\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"{{vm.getIconName(address)}}\"></md-icon><div class=\"md-list-item-text\"><h3\n ng-class=\"{ \'text-strike\': address.changeState == 3 }\">{{ vm.getAddressAsString(address) }}</h3><p \nng-class=\"{ \'text-strike\': address.changeState == 3 }\">{{ address.addressTypeName || address.addressType.name }}</p><p \nclass=\"md-warn-fg\" ng-show=\"address.changeState == 3\">{{\'ADDRESSES.ADDRESS_LIST.DELETE_TEXT\' | translate}}</p></div>\n<md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteOrUndo(address, $event)\"><md-tooltip \nmd-direction=\"top\"><span ng-if=\"address.changeState == 3\" translate=\"ADDRESSES.ADDRESS_LIST.UNDO_DELETE\"></span> <span \nng-if=\"address.changeState != 3\" translate=\"ADDRESSES.ADDRESS_LIST.DELETE_ADDRESS\"></span></md-tooltip><md-icon \nng-if=\"address.changeState == 3\" md-font-icon=\"icon-undo\"></md-icon><md-icon ng-if=\"address.changeState != 3\" \nmd-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item><md-list-item class=\"md-2-line\" \nng-click=\"vm.addNewAddress($event)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-plus\"></md-icon><div \nclass=\"md-list-item-text\"><h3>{{\'ADDRESSES.ADDRESS_LIST.ADD_NEW_ADDRESS\' | translate}}</h3><p>\n{{\'ADDRESSES.ADDRESS_LIST.NEW_ADDRESS\' | translate}}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/reference-types/address/components/address-type-select/address-type-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{vm.labelText}}</label><md-select ng-change=\"vm.onChange()\" \nng-model=\"vm.addressType\" ng-required=\"vm.isRequired\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"addressType in vm.addressTypes | orderBy:\'name\'\" ng-value=\"addressType\">{{addressType.name}}</md-option>\n</md-select></md-input-container>");
$templateCache.put("app/main/reference-types/address/components/inline-address-list/inline-address-list.tmpl.html","<div class=\"baldris-inline-address-list\" ng-form=\"vm.addressListForm\"><div layout=\"column\" \nclass=\"address-item default-address\"><div class=\"address-type\"><md-menu><md-button ng-disabled=\"vm.isDisabled\" \naria-label=\"Address Type\" class=\"address-type-select\" ng-click=\"vm.openAddressTypeMenu($mdMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"{{ vm.getSelectedAddressType().iconName }}\"></md-icon>\n{{ vm.getSelectedAddressType().name }}<md-icon class=\"caret\" md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"addressType in vm.addressTypes | orderBy:\'name\'\"><md-button \nng-click=\"vm.setAddressType(addressType)\"><md-icon md-font-icon=\"{{ addressType.iconName || \'icon-help\' }}\" \nmd-menu-align-target></md-icon>{{ addressType.name }}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"address-input\" layout=\"column\"><div><address-search address=\"vm.selectedAddress\" \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.STREET_ADDRESS_1\' | translate }}\" on-update=\"vm.onAddressChanged(value)\" \nis-disabled=\"vm.isDisabled\"></address-search></div><div ng-if=\"vm.showMoreOptions\"><md-input-container \nclass=\"md-block\"><label>{{ \"ADDRESSES.ADDRESS.STREET_ADDRESS_2\" | translate }}</label><input \nng-disabled=\"vm.isDisabled\" ng-model=\"vm.selectedAddress.streetAddress2\" \nng-change=\"vm.onAddressChanged(vm.selectedAddress)\" ng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex flex-gt-xs=\"30\"><label>\n{{ \"ADDRESSES.ADDRESS.ZIP_CODE\" | translate }}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.selectedAddress.zipCode\" ng-change=\"vm.onAddressChanged(vm.selectedAddress)\" \nng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container><md-input-container flex flex-gt-xs=\"70\"><label>\n{{ \"ADDRESSES.ADDRESS.CITY\" | translate }}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.selectedAddress.city\" ng-change=\"vm.onAddressChanged(vm.selectedAddress)\" \nng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div><state-select ng-if=\"vm.showMoreOptions\" \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.STATE_NAME\' | translate }}\" state-id=\"vm.selectedAddress.stateId\" \ncountry-id=\"vm.selectedAddress.countryId\" state=\"vm.selectedAddress.state\" is-disabled=\"vm.isDisabled\" \non-update=\"vm.onAddressChanged(vm.selectedAddress)\"></state-select><country-select ng-if=\"vm.showMoreOptions\" \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.COUNTRY_NAME\' | translate }}\" country-id=\"vm.selectedAddress.countryId\" \ncountry=\"vm.selectedAddress.country\" is-disabled=\"vm.isDisabled\" on-update=\"vm.onAddressChanged(vm.selectedAddress)\">\n</country-select><div ng-if=\"vm.showMoreOptions\"><md-input-container class=\"md-block\"><label>\n{{ \"ADDRESSES.ADDRESS.FORMATTED_ADDRESS\" | translate }}</label><input ng-disabled=\"vm.isDisabled\" \nng-model=\"vm.selectedAddress.localizedAddress\" ng-change=\"vm.onAddressChanged(vm.selectedAddress, true)\">\n</md-input-container></div><div ng-if=\"vm.showMoreOptions\"><md-input-container class=\"md-block\"><label>\n{{ \"ADDRESSES.ADDRESS.SORT_ORDER\" | translate }}</label><input type=\"number\" ng-disabled=\"vm.isDisabled\" step=\"1\" \nng-model=\"vm.selectedAddress.sortOrder\" ng-change=\"vm.onAddressChanged(vm.selectedAddress)\" \nng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div></div><md-button class=\"md-block\" \nng-click=\"vm.showMoreOptions = !vm.showMoreOptions\"><md-tooltip md-direction=\"up\">\n{{ vm.showMoreOptions ? (\"COMMON.DATA.SHOW_LESS_OPTIONS\" | translate) : (\"COMMON.DATA.SHOW_MORE_OPTIONS\" | translate) }}\n</md-tooltip><md-icon md-font-icon=\"{{ vm.showMoreOptions ? \'icon-menu-up\' : \'icon-menu-down\' }}\"></md-icon>\n</md-button></div><div layout=\"column\" ng-if=\"!vm.isSingleEntry\"><md-chips tabindex=\"-1\" class=\"address-chips\" \nng-model=\"vm.collection\" ng-disabled=\"vm.isDisabled\" readonly=\"true\" md-transform-chip=\"vm.newAddressChip($chip)\" \nmd-removable=\"false\" input-aria-label=\"Addresses\" md-on-select=\"vm.selectAddress($chip)\"><md-chip-template \nclass=\"clickable\" ng-click=\"vm.selectAddress($chip)\"><span ng-class=\"{ selected: $chip === vm.selectedAddress }\">\n<strong>{{ $chip.streetAddress1 || \"~ N/A ~\" }}</strong><br><em>{{ $chip.zipCode || \"~ N/A ~\" }} {{ $chip.city }}</em>\n<br><span class=\"address-type\">{{ $chip.addressTypeName }}</span></span><div class=\"md-chip-remove-container\"><button \nng-disabled=\"vm.isDisabled\" tabindex=\"-1\" ng-click=\"vm.deleteAddress($chip, $event)\" class=\"md-primary address-remove\" \naria-label=\"Remove {{ $chip.streetAddress1 }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></div>\n</md-chip-template></md-chips><md-button ng-disabled=\"vm.isDisabled\" ng-if=\"!vm.disableAdd\" tabindex=\"-1\" \nclass=\"md-block\" ng-click=\"vm.addNewAddress($event)\">{{ \"ADDRESSES.ADDRESS_LIST.ADD_EXTRA_ADDRESS\" | translate }}\n</md-button></div></div>");
$templateCache.put("app/main/reference-types/address/dialogs/edit-address-dialog/edit-address-dialog.tmpl.html","<md-dialog class=\"edit-address-dialog edit-dialog\" aria-label=\"Edit Address\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\"><span class=\"title\">{{ \"ADDRESSES.EDIT_ADDRESS.EDIT_ADDRESS\" | translate }}</span></div>\n</md-toolbar><md-dialog-content><div ng-form=\"vm.editAddressForm\" class=\"baldris-edit-address\" layout=\"column\">\n<address-type-select address-type-id=\"vm.address.addressTypeId\" address-type=\"vm.address.addressType\" \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.ADDRESS_TYPE\' | translate }}\"></address-type-select><street-address-search \nlabel-text=\"Søk etter addresse\" on-selected=\"(vm.onAddressSelected)\"></street-address-search><div layout=\"column\" \nng-if=\"vm.editManually\"><md-input-container flex><label>{{ \"ADDRESSES.ADDRESS.STREET_ADDRESS_1\" | translate }}</label>\n<input ng-model=\"vm.address.streetAddress1\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex flex-gt-xs=\"30\"><label>{{ \"ADDRESSES.ADDRESS.ZIP_CODE\" | translate }}</label><input \nng-model=\"vm.address.zipCode\" ng-change=\"vm.onZipCodeChange()\" ng-model-options=\"{ updateOn: \'blur\' }\">\n</md-input-container><md-input-container flex flex-gt-xs=\"70\"><label>{{ \"ADDRESSES.ADDRESS.CITY\" | translate }}</label>\n<input ng-model=\"vm.address.city\"></md-input-container></div><state-select \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.STATE_NAME\' | translate }}\" state-id=\"vm.address.stateId\" \ncountry-id=\"vm.address.countryId\" state=\"vm.address.state\"></state-select><country-select \nlabel-text=\"{{ \'ADDRESSES.ADDRESS.COUNTRY_NAME\' | translate }}\" country-id=\"vm.address.countryId\" \ncountry=\"vm.address.country\"></country-select><md-input-container flex><label>\n{{ \"ADDRESSES.ADDRESS.FORMATTED_ADDRESS\" | translate }}</label><input ng-model=\"vm.address.localizedAddress\">\n</md-input-container></div><div layout=\"column\" ng-if=\"!vm.editManually\"><label class=\"md-caption\">\n{{ \"ADDRESSES.ADDRESS.FORMATTED_ADDRESS\" | translate }}</label><address \nng-bind-html=\"vm.getFormattedAddress() | nl2br\"></address></div><md-switch ng-model=\"vm.editManually\">\n{{ \"ADDRESSES.EDIT_ADDRESS.EDIT_ADDRESS_MANUALLY\" | translate }}</md-switch></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/address/directives/address-search/address-search.tmpl.html","<md-input-container class=\"md-block\" flex-gt-sm><label>{{ labelText }}</label><input ng-model=\"address.streetAddress1\" \nplaceholder=\"{{ labelText }}\" ng-disabled=\"isDisabled\" id=\"AddressSearchInput\" md-autofocus \nng-change=\"onTextInputChanged()\" ng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container>");
$templateCache.put("app/main/reference-types/address/directives/edit-address/edit-address.tmpl.html","<div ng-form=\"vm.editAddressForm\" class=\"baldris-edit-address\" layout=\"column\"><md-input-container flex><label>\n{{\'ADDRESSES.ADDRESS.STREET-ADDRESS-1\' | translate }}</label><input ng-model=\"vm.baldrisModel.streetAddress1\" \nng-change=\"vm.addressChanged()\"></md-input-container><div layout=\"row\"><md-input-container flex=\"30\"><label>\n{{\'ADDRESSES.ADDRESS.ZIP-CODE\' | translate }}</label><input ng-model=\"vm.baldrisModel.zipCode\" \nng-change=\"vm.addressChanged()\"></md-input-container><md-input-container flex=\"70\"><label>\n{{\'ADDRESSES.ADDRESS.CITY\' | translate }}</label><input ng-model=\"vm.baldrisModel.city\" \nng-change=\"vm.addressChanged()\"></md-input-container></div><md-button class=\"md-button\" \nng-click=\"vm.toggleMoreOptions()\"><md-icon ng-hide=\"vm.showMoreOptions\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"vm.showMoreOptions\" md-font-icon=\"icon-chevron-up\"></md-icon><span ng-hide=\"vm.showMoreOptions\">\n{{\'ADDRESSES.EDIT-ADDRESS.MORE-OPTIONS\' | translate}}</span> <span ng-show=\"vm.showMoreOptions\">\n{{\'ADDRESSES.EDIT-ADDRESS.LESS-OPTIONS\' | translate}}</span></md-button><div \nng-show=\"vm.showMoreOptions || vm.baldrisModel.isNew\" layout=\"column\"><md-input-container flex><label>\n{{\'ADDRESSES.ADDRESS.STATE-NAME\' | translate }}</label><input ng-model=\"vm.baldrisModel.stateName\" \nng-change=\"vm.addressChanged()\"></md-input-container><md-input-container flex><label>\n{{\'ADDRESSES.ADDRESS.COUNTRY-NAME\' | translate }}</label><input ng-model=\"vm.baldrisModel.countryName\" \nng-change=\"vm.addressChanged()\"></md-input-container><md-input-container flex><label>\n{{\'ADDRESSES.ADDRESS.ADDRESS-TYPE\' | translate }}</label><input ng-model=\"vm.baldrisModel.addressType\" \nng-change=\"vm.addressChanged()\"></md-input-container></div></div>");
$templateCache.put("app/main/reference-types/address/directives/street-address-search/street-address-search.tmpl.html","<md-input-container class=\"md-block\" flex-gt-sm><label>{{ labelText }}</label><input ng-model=\"searchText\" \nplaceholder=\"{{ labelText }}\" md-autofocus></md-input-container>");
$templateCache.put("app/main/reference-types/auto-product/components/auto-product-list/auto-product-list.tmpl.html","<md-list class=\"baldris-auto-product-list\" ng-form=\"vm.autoProductListForm\"><md-subheader class=\"md-no-sticky\">\n{{ \"AUTO_PRODUCTS.ATTACHED_PRODUCTS\" | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditAutoProductDialog(autoProduct, $event)\" \nng-repeat=\"autoProduct in vm.autoProducts | orderBy:\'productName\'\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-archive\"></md-icon><div class=\"md-list-item-text\"><h3 \nng-class=\"{ \'text-strike\': autoProduct.changeState == 3 }\">\n{{ autoProduct.amount || \"0\" }}# – {{ autoProduct.productName }}</h3><p \nng-class=\"{ \'text-strike\': autoProduct.changeState == 3 }\">\n{{ autoProduct.departmentName || \"AUTO_PRODUCTS.ALL_DEPARTMENTS\" | translate }} <span \nng-if=\"vm.getDiscriminatorText(autoProduct)\">// {{ vm.getDiscriminatorText(autoProduct) | translate }}</span> <span \nng-if=\"!autoProduct.attachedTypeId\">// {{ \"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.UNIVERSAL\" | translate }}</span></p><p \nclass=\"md-warn-fg\" ng-show=\"autoProduct.changeState == 3\">\n{{ \"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.DELETE_TEXT\" | translate }}</p></div><div ng-if=\"!autoProduct.attachedTypeId\" \nclass=\"md-secondary\"><md-tooltip md-direction=\"top\"><span translate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.UNIVERSAL_TEXT\">\n</span></md-tooltip><md-icon md-font-icon=\"icon-alert-circle\"></md-icon></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.deleteOrUndoAutoProduct(autoProduct, $event)\"><md-tooltip \nmd-direction=\"top\"><span ng-if=\"autoProduct.changeState == 3\" translate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.UNDO_DELETE\">\n</span> <span ng-if=\"autoProduct.changeState != 3\" translate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.DELETE_AUTO_PRODUCT\">\n</span></md-tooltip><md-icon ng-if=\"autoProduct.changeState == 3\" md-font-icon=\"icon-undo\"></md-icon><md-icon \nng-if=\"autoProduct.changeState != 3\" md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item><md-list-item \nclass=\"md-2-line\" ng-click=\"vm.showEditAutoProductDialog(null, $event)\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-plus\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{ \"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.ADD_AUTO_PRODUCT\" | translate }}</h3><p>\n{{ \"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.NEW_AUTO_PRODUCT\" | translate }}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/reference-types/auto-product/dialogs/edit-auto-product-dialog/edit-auto-product-dialog.tmpl.html","<md-dialog class=\"edit-auto-product-dialog edit-dialog\" aria-label=\"Edit Auto Product\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ \"AUTO_PRODUCTS.EDIT_AUTO_PRODUCT.EDIT_AUTO_PRODUCT\" | translate }}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><md-checkbox ng-checked=\"!vm.autoProduct.attachedTypeId\" ng-click=\"vm.toggleAttachedTypeId()\"><span \ntranslate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.UNIVERSAL\"></span><br><span ng-if=\"!vm.autoProduct.attachedTypeId\" \ntranslate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.UNIVERSAL_TEXT\"></span> <span ng-if=\"vm.autoProduct.attachedTypeId\" \ntranslate=\"AUTO_PRODUCTS.AUTO_PRODUCT_LIST.SPECIFIC_TEXT\"></span></md-checkbox><md-input-container flex><label>\n{{ \"AUTO_PRODUCTS.ATTACHED_PRODUCT.AMOUNT\" | translate }}</label><input type=\"number\" ng-model=\"vm.autoProduct.amount\">\n</md-input-container><product-select flex product=\"vm.product\" product-id=\"vm.autoProduct.productId\" \nlabel-text=\"{{ \'PRODUCTS.PRODUCT.PRODUCT\' | translate }}\" on-update=\"vm.onProductSelected(value)\"></product-select><div\n ng-if=\"vm.product\" class=\"price\">{{ vm.product.priceIncludingVat | currency }} <span class=\"excluding-vat\">\n({{ vm.product.price | currency }})</span></div><bill-to-select bill-to=\"vm.autoProduct.billTo\" \nlabel-text=\"{{ \'AUTO_PRODUCTS.ATTACHED_PRODUCT.BILL_TO\' | translate}}\"></bill-to-select><department-select \ndepartment-id=\"vm.autoProduct.departmentId\" department=\"vm.department\" \ndisplay-text=\"vm.autoProduct.departmentOrganizationDisplayName\" is-required=\"false\" \nlabel-text=\"{{ \'AUTO_PRODUCTS.ATTACHED_PRODUCT.DEPARTMENT\' | translate}}\"></department-select><label>\n{{ \"AUTO_PRODUCTS.ATTACHED_PRODUCT.DISCRIMINATOR\" | translate }}</label><md-select \nng-model=\"vm.autoProduct.discriminator\"><md-option ng-value=\"null\"><em>--</em></md-option><md-option \nng-repeat=\"discriminator in vm.attachedProductDiscriminator\" ng-value=\"discriminator.value\">\n{{ discriminator.text | translate }}</md-option></md-select></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button>\n<md-button ng-click=\"vm.saveAndCloseDialog()\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/reference-types/auto-task/components/attached-auto-task-list/attached-auto-task-list.tmpl.html","<md-list class=\"baldris-auto-task-list\" ng-form=\"vm.autoTaskListForm\"><md-subheader class=\"md-no-sticky\">\n{{ \"AUTO_TASKS.ATTACHED_AUTO_TASKS\" | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditAutoTaskDialog(autoTask, $event)\" \nng-repeat=\"autoTask in vm.autoTasks | orderBy:\'autoTaskSubject\'\"><md-icon class=\"md-avatar-icon\" \nmd-font-icon=\"icon-archive\"></md-icon><div class=\"md-list-item-text\"><h3 \nng-class=\"{ \'text-strike\': autoTask.changeState == 3 }\">{{ autoTask.autoTaskSubject }}</h3><p \nng-class=\"{ \'text-strike\': autoTask.changeState == 3 }\">\n{{ autoTask.departmentName || \"AUTO_TASKS.ALL_DEPARTMENTS\" | translate }} <span \nng-if=\"vm.getDiscriminatorText(autoTask)\">// {{ vm.getDiscriminatorText(autoTask) | translate }}</span> <span \nng-if=\"!autoTask.attachedTypeId\">// {{ \"AUTO_TASKS.AUTO_TASK_LIST.UNIVERSAL\" | translate }}</span></p><p \nclass=\"md-warn-fg\" ng-show=\"autoTask.changeState == 3\">{{ \"AUTO_TASKS.AUTO_TASK_LIST.DELETE_TEXT\" | translate }}</p>\n</div><div ng-if=\"!autoTask.attachedTypeId\" class=\"md-secondary\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"AUTO_TASKS.AUTO_TASK_LIST.UNIVERSAL_TEXT\"></span></md-tooltip><md-icon md-font-icon=\"icon-alert-circle\">\n</md-icon></div><md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteOrUndoAutoTask(autoTask, $event)\">\n<md-tooltip md-direction=\"top\"><span ng-if=\"autoTask.changeState == 3\" \ntranslate=\"AUTO_TASKS.AUTO_TASK_LIST.UNDO_DELETE\"></span> <span ng-if=\"autoTask.changeState != 3\" \ntranslate=\"AUTO_TASKS.AUTO_TASK_LIST.DELETE_AUTO_TASK\"></span></md-tooltip><md-icon ng-if=\"autoTask.changeState == 3\" \nmd-font-icon=\"icon-undo\"></md-icon><md-icon ng-if=\"autoTask.changeState != 3\" md-font-icon=\"icon-delete\"></md-icon>\n</md-button></md-list-item><md-list-item class=\"md-2-line\" ng-click=\"vm.showEditAutoTaskDialog(null, $event)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-plus\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{ \"AUTO_TASKS.AUTO_TASK_LIST.ADD_AUTO_TASK\" | translate }}</h3><p>\n{{ \"AUTO_TASKS.AUTO_TASK_LIST.NEW_AUTO_TASK\" | translate }}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/reference-types/auto-task/components/auto-task-select/auto-task-select.tmpl.html","<div ng-form=\"vm.autoTaskForm\"><label class=\"md-label\" id=\"autoTaskSelectLabel\">\n{{ vm.labelText || \'AUTO_TASKS.AUTO_TASK.AUTO_TASK\' | translate }}</label><md-autocomplete ng-disabled=\"vm.isDisabled\" \nmd-no-cache=\"true\" md-selected-item=\"vm.autoTask\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-input-name=\"autoTask\" md-item-text=\"item.subject\" md-min-length=\"0\" placeholder=\"Ex. Solo\" \ninput-aria-labelledby=\"autoTaskSelectLabel\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.subject}}</span>: <span class=\"hint-text\" md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.text}}</span></md-item-template></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/auto-task/dialogs/edit-attached-auto-task-dialog/edit-attached-auto-task-dialog.tmpl.html","<md-dialog class=\"edit-auto-product-dialog edit-dialog\" aria-label=\"Edit Auto Product\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ \"AUTO_TASKS.ATTACHED_AUTO_TASK.NEW_OR_EXISTING\" | translate }}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><md-checkbox ng-checked=\"!vm.attachedAutoTask.attachedTypeId\" ng-click=\"vm.toggleAttachedTypeId()\">\n<span translate=\"AUTO_TASKS.AUTO_TASK_LIST.UNIVERSAL\"></span><br><span ng-if=\"!vm.attachedAutoTask.attachedTypeId\" \ntranslate=\"AUTO_TASKS.AUTO_TASK_LIST.UNIVERSAL_TEXT\"></span> <span ng-if=\"vm.attachedAutoTask.attachedTypeId\" \ntranslate=\"AUTO_TASKS.AUTO_TASK_LIST.SPECIFIC_TEXT\"></span></md-checkbox><auto-task-select flex \nauto-task=\"vm.attachedAutoTask.autoTask\" auto-task-id=\"vm.attachedAutoTask.autoTaskId\" \nlabel-text=\"{{ \'AUTO_TASKS.AUTO_TASK.AUTO_TASK\' | translate }}\" on-update=\"vm.onAutoTaskSelected(value)\">\n</auto-task-select><department-select department-id=\"vm.attachedAutoTask.departmentId\" department=\"vm.department\" \ndisplay-text=\"vm.attachedAutoTask.departmentName\" is-required=\"false\" \nlabel-text=\"{{ \'AUTO_TASKS.ATTACHED_AUTO_TASK.DEPARTMENT\' | translate}}\"></department-select><label>\n{{ \"AUTO_TASKS.ATTACHED_AUTO_TASK.DISCRIMINATOR\" | translate }}</label><md-select \nng-model=\"vm.attachedAutoTask.discriminator\"><md-option ng-value=\"null\"><em>--</em></md-option><md-option \nng-repeat=\"discriminator in vm.attachedProductDiscriminator\" ng-value=\"discriminator.value\">\n{{ discriminator.text | translate }}</md-option></md-select></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button>\n<md-button ng-click=\"vm.saveAndCloseDialog()\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/reference-types/casket/components/casket-select/casket-select.tmpl.html","<div ng-form=\"vm.casketForm\" class=\"baldris-casket-select\"><md-autocomplete flex md-min-length=\"vm.minLength\" \nmd-input-name=\"casket\" md-selected-item=\"vm.casket\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-casket-select\" md-clear-button=\"true\" ng-disabled=\"vm.isDisabled\"><md-item-template><div>\n<img class=\"casket-image\" ng-if=\"item.imageFilepath\" baldris-img-src=\"item.imageFilepath\" preset=\"square-40-cropped\" \nalt=\"{{item.name}}\"> <span class=\"casket-icon\" ng-if=\"!item.imageFilepath\"><md-icon md-font-icon=\"icon-archive\">\n</md-icon></span>{{item.name}} <span class=\"casket-type\">{{ vm.getType(item) }}</span></div></md-item-template><div \nng-messages=\"vm.casketForm.casket.$error\" ng-if=\"vm.casketForm.casket.$touched\"><div ng-message=\"invalidCasket\"><span \ntranslate=\"CASKETS.CASKET_SELECT.INVALID_CASKET\" translate-values=\"{ casket: vm.searchText }\"></span></div></div>\n</md-autocomplete><div layout=\"column\"><div ng-if=\"vm.casketAttributesChanged\" class=\"casket-attributes-changed\">\n<small><md-icon class=\"blue-500-fg\" md-font-icon=\"icon-information\"></md-icon>\n{{ \'CASKETS.CASKET_SELECT.CASKET_ATTRIBUTES_CHANGED\' | translate }}</small></div><md-button class=\"md-block\" \nng-click=\"vm.showMoreOptions = !vm.showMoreOptions\">\n{{ vm.showMoreOptions ? \'COMMON.DATA.SHOW_LESS_OPTIONS\' : \'COMMON.DATA.SHOW_MORE_OPTIONS\' | translate }}</md-button>\n<div ng-if=\"vm.showMoreOptions\"><enum-flag-select enum-flag=\"vm.casketAttributes\" enum-flag-options=\"casketAttributes\" \nlabel-text=\"{{\'DECEASED.DECEASED.APPLIED_CASKET_ATTRIBUTES\' | translate}}\"></enum-flag-select></div></div></div>");
$templateCache.put("app/main/reference-types/country/components/country-iso2-select/country-iso2-select.tmpl.html","<div ng-form=\"vm.countryForm\" class=\"baldris-country-iso2-select\"><md-autocomplete flex md-input-name=\"country\" \nmd-selected-item=\"vm.country\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-min-length=\"vm.minLength\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-floating-label=\"{{ vm.labelText }}\" \nmd-menu-class=\"autocomplete-country-select\" md-item-text=\"item.isoCode2 + \' – \' + item.name\" md-clear-button=\"true\">\n<md-item-template><div layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{ item.isoCode2 }}.png\"><div class=\"name\" flex>{{ item.isoCode2 }} – {{ item.name }}</div>\n</div></md-item-template><div ng-messages=\"vm.countryForm.country.$error\" ng-if=\"vm.countryForm.country.$touched\"><div \nng-message=\"invalidCountry\"><span translate=\"COUNTRIES.COUNTRY_SELECT.INVALID_COUNTRY\" \ntranslate-values=\"{ country: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/country/components/country-select/country-select.tmpl.html","<div ng-form=\"vm.countryForm\" class=\"baldris-country-select\"><md-autocomplete flex md-input-name=\"country\" \nmd-selected-item=\"vm.country\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-min-length=\"vm.minLength\" md-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-floating-label=\"{{ vm.labelText }}\" \nmd-menu-class=\"autocomplete-country-select\" md-clear-button=\"true\" ng-disabled=\"vm.isDisabled\"><md-item-template><div \nlayout=\"row\" layout-align=\"start center\"><img ng-if=\"item.isoCode2\" class=\"flag\" \nng-src=\"assets/images/flags/{{ item.isoCode2.toLowerCase() }}.png\"><div class=\"name\" flex>{{ item.name }}</div></div>\n</md-item-template><div ng-messages=\"vm.countryForm.country.$error\" ng-if=\"vm.countryForm.country.$touched\"><div \nng-message=\"invalidCountry\"><span translate=\"COUNTRIES.COUNTRY_SELECT.INVALID_COUNTRY\" \ntranslate-values=\"{ country: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/customer/edit-customer/views/customer-sidenav.tmpl.html","<div class=\"common-sidebar edit-customer-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div ng-if=\"!vm.loadingService.isLoading\" \nclass=\"sidebar-content\" layout=\"column\" layout-padding><baldris-audit \ntitle-text=\"vm.data.updateModel.party.displayName\" audit-model=\"vm.data.updateModel.customer\"></baldris-audit><h3 \ntranslate=\"CUSTOMERS.CUSTOMER.BILLING_ADDRESS\">Address</h3><address ng-if=\"vm.data.updateModel.billingAddress\"><span \nng-if=\"vm.data.updateModel.billingAddress.streetAddress1\">{{vm.data.updateModel.billingAddress.streetAddress1}}<br>\n</span><span ng-if=\"vm.data.updateModel.billingAddress.streetAddress2\">\n{{vm.data.updateModel.billingAddress.streetAddress2}}<br></span><span \nng-if=\"vm.data.updateModel.billingAddress.zipCode || vm.data.updateModel.billingAddress.city\">\n{{vm.data.updateModel.billingAddress.zipCode}} {{vm.data.updateModel.billingAddress.city}}<br></span><span \nng-if=\"vm.data.updateModel.billingAddress.stateCountrySerialized\">\n{{vm.data.updateModel.billingAddress.stateCountrySerialized}}<br></span></address><ui-gmap-google-map \nng-if=\"vm.data.addressCoordinates\" center=\"vm.data.addressCoordinates.center\" zoom=\"vm.data.addressCoordinates.zoom\">\n<ui-gmap-marker coords=\"vm.data.addressCoordinates.marker.coords\" options=\"vm.data.addressCoordinates.marker.options\" \nevents=\"vm.data.addressCoordinates.marker.events\" idkey=\"vm.data.addressCoordinates.marker.id\"></ui-gmap-marker>\n</ui-gmap-google-map><md-button class=\"md-raised md-block\" ng-if=\"!vm.data.updateModel.billingAddress\" \naria-label=\"Add Address\" ng-click=\"vm.data.showEditAddressDialog(null, $event)\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>{{ \'LOCATIONS.EDIT_LOCATION.ADD_ADDRESS\' | translate }}</md-button><md-button class=\"md-block\" \nng-if=\"vm.data.updateModel.billingAddress\" aria-label=\"Edit Address\" \nng-click=\"vm.data.showEditAddressDialog(vm.data.updateModel.billingAddress, $event)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon>{{ \'LOCATIONS.EDIT_LOCATION.EDIT_ADDRESS\' | translate }}</md-button></div>\n</div>");
$templateCache.put("app/main/reference-types/customer/edit-customer/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"CUSTOMERS.EDIT_CUSTOMER.EDIT_CUSTOMER\"></span> <span ng-if=\"vm.data.validation.customerForm.$dirty\">*</span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.customerForm.$pristine\" aria-label=\"OK, save\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/reference-types/email/components/edit-email-dialog/edit-email-dialog.tmpl.html","<md-dialog class=\"edit-email-dialog edit-dialog\" aria-label=\"Edit Email\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{\'EMAILS.EDIT_EMAIL.EDIT_EMAIL\' | translate }}</span></div></md-toolbar><md-dialog-content><div \nng-form=\"vm.editEmailForm\" class=\"baldris-edit-email\" layout=\"column\"><md-input-container flex><label>\n{{\'EMAILS.EMAIL.EMAIL_ADDRESS\' | translate }}<span ng-hide=\"vm.email.emailAddress\">\n {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><input md-autofocus name=\"emailAddress\" type=\"email\" \nng-required=\"true\" ng-model=\"vm.email.emailAddress\"><div class=\"errors\" \nng-messages=\"vm.editEmailForm.emailAddress.$error\" ng-if=\"vm.editEmailForm.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"EMAILS.EDIT_EMAIL.EMAIL_ADDRESS_REQUIRED\"></span></div><div ng-message=\"email\"><span \ntranslate=\"EMAILS.EDIT_EMAIL.INVALID_EMAIL\"></span></div></div></md-input-container><email-type-select \nis-required=\"true\" email-type-id=\"vm.email.emailTypeId\" email-type=\"vm.email.emailType\" \nlabel-text=\"{{\'EMAILS.EMAIL.EMAIL_TYPE\' | translate }}\"></email-type-select></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"vm.editEmailForm.$pristine || vm.editEmailForm.$invalid\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/email/components/email-list/email-list.tmpl.html","<md-list class=\"baldris-email-list\" ng-form=\"vm.emailListForm\"><md-subheader class=\"md-no-sticky\">\n{{ \'EMAILS.EMAILS\' | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditEmailDialog(email, $event)\" ng-repeat=\"email in vm.collection | orderBy:\'sortOrder\'\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"{{vm.getIconName(email)}}\"></md-icon><div class=\"md-list-item-text\"><h3 \nng-class=\"{ \'text-strike\': email.changeState == 3 }\">{{ email.emailAddress }}</h3><p \nng-class=\"{ \'text-strike\': email.changeState == 3 }\">{{ email.emailTypeName || email.emailType.name }}</p><p \nclass=\"md-warn-fg\" ng-show=\"email.changeState == 3\">{{\'EMAILS.EMAIL_LIST.DELETE_TEXT\' | translate}}</p></div><md-button\n class=\"md-secondary md-icon-button\" ng-click=\"vm.deleteOrUndo(email, $event)\"><md-tooltip md-direction=\"top\"><span \nng-if=\"email.changeState == 3\" translate=\"EMAILS.EMAIL_LIST.UNDO_DELETE\"></span> <span ng-if=\"email.changeState != 3\" \ntranslate=\"EMAILS.EMAIL_LIST.DELETE_EMAIL\"></span></md-tooltip><md-icon ng-if=\"email.changeState == 3\" \nmd-font-icon=\"icon-undo\"></md-icon><md-icon ng-if=\"email.changeState != 3\" md-font-icon=\"icon-delete\"></md-icon>\n</md-button></md-list-item><md-list-item class=\"md-2-line\" ng-click=\"vm.addNewEmail($event)\"><md-icon \nclass=\"md-avatar-icon\" md-font-icon=\"icon-plus\"></md-icon><div class=\"md-list-item-text\"><h3>\n{{\'EMAILS.EMAIL_LIST.ADD_NEW_EMAIL\' | translate}}</h3><p>{{\'EMAILS.EMAIL_LIST.NEW_EMAIL\' | translate}}</p></div>\n</md-list-item></md-list>");
$templateCache.put("app/main/reference-types/email/components/email-type-select/email-type-select.tmpl.html","<md-input-container ng-form=\"vm.emailTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.emailType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"emailType\" ng-model=\"vm.emailTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentEmailType in vm.emailTypes | orderBy:\'name\'\" ng-value=\"currentEmailType.id\">{{currentEmailType.name}}\n</md-option></md-select><div class=\"errors\" ng-messages=\"vm.emailTypeForm.emailType.$error\" \nng-if=\"vm.emailTypeForm.emailType.$dirty\"><div ng-message=\"required\"><span \ntranslate=\"EMAILS.EDIT_EMAIL.EMAIL_TYPE_REQUIRED\"></span></div></div></md-input-container>");
$templateCache.put("app/main/reference-types/email/components/inline-email-list/inline-email-list.tmpl.html","<div class=\"baldris-inline-email-list\" ng-form=\"vm.emailListForm\"><div layout=\"column\" \nclass=\"email-item default-email\"><div class=\"email-type\"><md-menu><md-button ng-disabled=\"vm.isDisabled\" \naria-label=\"Email Type\" class=\"email-type-select\" ng-click=\"vm.openEmailTypeMenu($mdMenu, $event)\"><md-icon \nmd-menu-origin md-font-icon=\"{{ vm.getSelectedEmailType().iconName }}\"></md-icon>{{ vm.getSelectedEmailType().name }}\n<md-icon class=\"caret\" md-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"emailType in vm.emailTypes | orderBy:\'name\'\"><md-button ng-click=\"vm.setEmailType(emailType)\"><md-icon \nmd-font-icon=\"{{ emailType.iconName || \'icon-help\' }}\" md-menu-align-target></md-icon>{{ emailType.name }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"email-input\" layout=\"column\"><div><md-input-container \nclass=\"md-block\"><label>{{ \"EMAILS.EMAIL.EMAIL_ADDRESS\" | translate }}</label><input type=\"email\" \nng-disabled=\"vm.isDisabled\" id=\"DefaultEmailAddress\" name=\"emailAddress\" ng-model=\"vm.selectedEmail.emailAddress\" \nng-change=\"vm.onEmailChanged(vm.selectedEmail)\" ng-model-options=\"{ updateOn: \'blur\' }\"><div class=\"errors\" \nng-messages=\"vm.emailListForm.emailAddress.$error\"><div ng-message=\"required\"><span \ntranslate=\"EMAILS.EDIT_EMAIL.EMAIL_ADDRESS_REQUIRED\"></span></div><div ng-message=\"email\"><span \ntranslate=\"EMAILS.EDIT_EMAIL.INVALID_EMAIL\"></span></div></div></md-input-container></div><div \nng-if=\"vm.showMoreOptions\"><md-input-container class=\"md-block\"><label>{{ \"EMAILS.EMAIL.SORT_ORDER\" | translate }}\n</label><input type=\"number\" ng-disabled=\"vm.isDisabled\" step=\"1\" ng-model=\"vm.selectedEmail.sortOrder\" \nng-change=\"vm.onEmailChanged(vm.selectedEmail)\" ng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div>\n</div><md-button class=\"md-block\" ng-click=\"vm.showMoreOptions = !vm.showMoreOptions\"><md-tooltip md-direction=\"up\">\n{{ vm.showMoreOptions ? (\"COMMON.DATA.SHOW_LESS_OPTIONS\" | translate) : (\"COMMON.DATA.SHOW_MORE_OPTIONS\" | translate) }}\n</md-tooltip><md-icon md-font-icon=\"{{ vm.showMoreOptions ? \'icon-menu-up\' : \'icon-menu-down\' }}\"></md-icon>\n</md-button></div><div layout=\"column\" ng-if=\"!vm.isSingleEntry\"><md-chips ng-disabled=\"vm.isDisabled\" tabindex=\"-1\" \nclass=\"email-chips\" ng-model=\"vm.collection\" readonly=\"true\" md-transform-chip=\"vm.newEmailChip($chip)\" \nmd-removable=\"false\" input-aria-label=\"Emails\" md-on-select=\"vm.selectEmail($chip)\"><md-chip-template \nclass=\"clickable\" ng-click=\"vm.selectEmail($chip)\"><span ng-class=\"{ selected: $chip === vm.selectedEmail }\"><strong>\n{{ $chip.emailAddress || \"~ N/A ~\" }}</strong><br><em>{{ $chip.emailTypeName || \"~ N/A ~\" }} {{ $chip.city }}</em><br>\n</span><div class=\"md-chip-remove-container\"><button ng-disabled=\"vm.isDisabled\" tabindex=\"-1\" \nng-click=\"vm.deleteEmail($chip, $event)\" class=\"md-primary email-remove\" aria-label=\"Remove {{ $chip.emailAddress }}\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div></md-chip-template></md-chips><md-button \nng-disabled=\"vm.isDisabled\" ng-if=\"!vm.disableAdd\" tabindex=\"-1\" class=\"md-block\" ng-click=\"vm.addNewEmail($event)\">\n{{ \"EMAILS.EMAIL_LIST.ADD_EXTRA_EMAIL\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/reference-types/equipment/components/equipment-select/equipment-select.tmpl.html","<div ng-form=\"vm.equipmentForm\" class=\"baldris-location-select\" layout=\"row\" layout-align=\"center center\">\n<md-autocomplete flex md-input-name=\"equipment\" md-selected-item=\"vm.equipment\" md-search-text=\"vm.searchText\" \nmd-search-text-change=\"vm.searchTextChanged(vm.searchText)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-clear-button=\"true\" md-item-text=\"item.name\" md-selected-item-change=\"vm.onEquipmentChanged(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-equipment-select\" \nng-disabled=\"vm.isDisabled\"><md-item-template><div layout=\"row\"><div class=\"equipment-image\"><img \nclass=\"equipment-image\" ng-if=\"item.imageFilePath\" baldris-img-src=\"item.imageFilePath\" preset=\"square-40-cropped\" \nalt=\"{{item.name}}\"> <img ng-if=\"!item.imageFilePath\" height=\"40\" width=\"40\" class=\"equipment-image\" \nsrc=\"/assets/images/ecommerce/product-image-placeholder.png\"></div><div class=\"description\"><div class=\"name\">\n{{item.name}}</div><div class=\"equipment-type\">{{item.equipmentTypeName}}</div></div></div></md-item-template><div \nng-messages=\"vm.equipmentForm.equipment.$error\" ng-if=\"vm.equipmentForm.equipment.$touched\"><div \nng-message=\"invalidEquipment\"><span translate=\"LOCATIONS.LOCATION_SELECT.INVALID_LOCATION\" \ntranslate-values=\"{ location: vm.searchText }\"></span></div></div></md-autocomplete><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div>");
$templateCache.put("app/main/reference-types/font-style/components/font-style-select/font-style-select.tmpl.html","<div class=\"baldris-font-style-select\"><div layout=\"column\"><div ng-form=\"vm.fontStyleForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"fontStyle\" md-selected-item=\"vm.fontStyle\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.font + \' (\' + (item.style || \'~ NA ~\') + \', \' + (item.size || \'--\') + \' pt.)\'\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-fontStyle-select\" ng-disabled=\"vm.isDisabled\">\n<md-item-template class=\"fontStyle-item\"><div><span md-highlight-text=\"vm.searchText\">\n{{item.font || \'~ UNKNOWN FONT ~\'}} ({{ item.style || \'~ NA ~\'}}, {{ item.size || \'--\' }} pt.)</span></div><div><span \nmd-highlight-text=\"vm.searchText\">{{item.description}}</span></div></md-item-template><div \nng-messages=\"vm.fontStyleForm.fontStyle.$error\" ng-if=\"vm.fontStyleForm.fontStyle.$touched\"><div \nng-message=\"md-require-match\"><span translate=\"FONT_STYLES.FONT_STYLE.INVALID_FONT_STYLE\" \ntranslate-values=\"{ fontStyleName: vm.searchText }\"></span></div><div ng-message=\"invalidFontStyle\"><span \ntranslate=\"FONT_STYLES.FONT_STYLE.INVALID_FONT_STYLE\" translate-values=\"{ fontStyleName: vm.searchText }\"></span></div>\n</div></md-autocomplete><md-button class=\"md-icon-button edit-button\" ng-click=\"vm.openEditFontStyleDialog($event)\" \naria-label=\"Edit Font Style\" translate-attr-aria-label=\"FONT_STYLES.EDIT_FONT_STYLE.EDIT_FONT_STYLE\" tabindex=\"-1\" \nng-disabled=\"vm.isDisabled || !vm.fontStyle\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"FONT_STYLES.EDIT_FONT_STYLE.EDIT_FONT_STYLE\"></span></md-tooltip><md-icon md-font-icon=\"icon-tooltip-edit\">\n</md-icon></md-button></div><md-button ng-click=\"vm.openAddFontStyleDialog($event)\" class=\"md-raised\" \nng-if=\"vm.fontStyleForm.fontStyle.$touched && vm.fontStyleForm.fontStyle.$invalid && vm.searchText\"><span \ntranslate=\"COMMON.DATA.ADD_ELEMENT\" translate-values=\"{ elementName: vm.searchText }\"></span></md-button></div></div>");
$templateCache.put("app/main/reference-types/font-style/dialogs/edit-font-style-dialog/edit-font-style-dialog.tmpl.html","<md-dialog ng-form=\"vm.editFontStyleForm\" class=\"edit-font-style-dialog edit-dialog\" \naria-label=\"{{ \'FONT_STYLES.EDIT_FONT_STYLE.EDIT_FONT_STYLE\' | translate }}\"><md-toolbar class=\"md-primary\" \nlayout=\"column\" ng-style=\"vm.eventStyle\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\n{{ vm.fontStyle.changeState === 1 ? \'FONT_STYLES.EDIT_FONT_STYLE.ADD_FONT_STYLE\' : \'FONT_STYLES.EDIT_FONT_STYLE.EDIT_FONT_STYLE\' | translate }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content ng-if=\"vm.loadingService.isLoadingInBackground\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></md-content>\n<md-content ng-if=\"!vm.loadingService.isLoadingInBackground\" layout=\"column\"><div><md-input-container class=\"md-block\">\n<label>{{ \'FONT_STYLES.FONT_STYLE.FONT\' | translate}}</label><input name=\"font\" required ng-model=\"vm.fontStyle.font\">\n<div ng-messages=\"vm.editFontStyleForm.font.$error\" multiple=\"multiple\"><div ng-message=\"required\">\n{{ \'COMMON.VALIDATION.REQUIRED_FIELD\' | translate }}</div></div></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \'FONT_STYLES.FONT_STYLE.STYLE\' | translate}}</label><input name=\"font\" \nng-model=\"vm.fontStyle.style\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \'FONT_STYLES.FONT_STYLE.SIZE\' | translate}}</label><input name=\"font\" type=\"number\" ng-model=\"vm.fontStyle.size\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \'FONT_STYLES.FONT_STYLE_ALIGNMENT.ALIGNMENT\' | translate }}</label><md-select ng-model=\"vm.fontStyle.alignment\">\n<md-option ng-value=\"0\">{{ \'FONT_STYLES.FONT_STYLE_ALIGNMENT.LEFT\' | translate }}</md-option><md-option ng-value=\"1\">\n{{ \'FONT_STYLES.FONT_STYLE_ALIGNMENT.CENTERED\' | translate }}</md-option><md-option ng-value=\"2\">\n{{ \'FONT_STYLES.FONT_STYLE_ALIGNMENT.RIGHT\' | translate }}</md-option><md-option ng-value=\"3\">\n{{ \'FONT_STYLES.FONT_STYLE_ALIGNMENT.JUSTIFY\' | translate }}</md-option></md-select></md-input-container></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.editFontStyleForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/location/components/location-select/location-select.tmpl.html","<div class=\"baldris-location-select\"><div layout=\"column\"><div ng-form=\"vm.locationForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"location\" md-selected-item=\"vm.location\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-require-match md-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-location-select\" \nng-disabled=\"vm.isDisabled\"><md-item-template class=\"location-item\"><div><span><md-icon \nmd-font-icon=\"icon-file-document-box\"></md-icon></span><span md-highlight-text=\"vm.searchText\">{{item.name}}</span>\n</div><div class=\"address\"><span><md-icon md-font-icon=\"{{item.addressTypeIconName || \'icon-map-marker\'}}\"></md-icon>\n</span><span>{{item.address || \'LOCATIONS.LOCATION_SELECT.UNKNOWN_ADDRESS\' | translate}}</span></div><span \nng-if=\"item.locationTypes.length > 0\" class=\"search-result-type\" ng-repeat=\"locationType in item.locationTypes\">\n{{locationType.name}}</span></md-item-template><div ng-messages=\"vm.locationForm.location.$error\" \nng-if=\"vm.locationForm.location.$touched\"><div ng-message=\"md-require-match\"><span \ntranslate=\"LOCATIONS.LOCATION_SELECT.INVALID_LOCATION\" translate-values=\"{ location: vm.searchText }\"></span></div><div\n ng-message=\"invalidLocation\"><span translate=\"LOCATIONS.LOCATION_SELECT.INVALID_LOCATION\" \ntranslate-values=\"{ location: vm.searchText }\"></span></div></div></md-autocomplete><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-button ng-click=\"vm.openAddLocationDialog($event)\" \nclass=\"md-raised\" ng-if=\"vm.locationForm.location.$touched && vm.locationForm.location.$invalid && vm.searchText\"><span\n translate=\"COMMON.DATA.ADD_ELEMENT\" translate-values=\"{ elementName: vm.searchText }\"></span></md-button></div></div>");
$templateCache.put("app/main/reference-types/location/components/location-type-select/location-type-select.tmpl.html","<div class=\"baldris-location-types-container\" layout=\"column\" ng-form=\"vm.selectForm\"><md-chips \nng-model=\"vm.selectedLocationTypes\" md-autocomplete-snap md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"true\" md-on-add=\"vm.onAddLocationType($chip)\" md-on-remove=\"vm.onRemoveLocationType($chip)\" \nmd-on-select=\"vm.onSelectLocationType($chip)\"><md-autocomplete md-selected-item=\"vm.selectedLocationType\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.locationTypeSearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-min-length=\"vm.minLength\" placeholder=\"{{\'LOCATIONS.LOCATION_TYPES.SELECT_LOCATION_TYPE\' | translate}}\" \nmd-menu-class=\"md-location-type-suggestions\"><div class=\"md-location-type-suggestion\"><img ng-if=\"item.imageFilepath\" \nbaldris-img-src=\"item.imageFilepath\" preset=\"square-40-cropped\" alt=\"{{item.name}}\"> <span \nmd-highlight-text=\"vm.searchText\">{{item.name}}</span></div></md-autocomplete><md-chip-template>{{$chip.name}}\n</md-chip-template></md-chips></div>");
$templateCache.put("app/main/reference-types/location/components/location-type-single-select/location-type-single-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{vm.labelText}}</label><md-select ng-model=\"vm.locationTypeId\" \nng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option ng-value=\"null\" md-option-empty \nng-if=\"!vm.isRequired\"><em>{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.NONE\' | translate }}</em></md-option><md-option \nng-repeat=\"locationType in vm.locationTypes | orderBy:\'name\'\" ng-value=\"locationType.id\">{{locationType.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/reference-types/location/components/related-locations-list/related-locations-list.tmpl.html","<md-list class=\"related-locations-list\"><md-subheader ng-if=\"!vm.hideHeader\" class=\"md-no-sticky\">\n{{ \"LOCATIONS.RELATED_LOCATIONS_LIST.RELATED_LOCATIONS\" | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"locationRelationshipVM in vm.relatedLocations | orderBy:\'relatedLocationName\'\"><md-icon \nng-if=\"!locationRelationshipVM.relatedLocationImageUrl\" class=\"md-avatar-icon\" md-font-icon=\"icon-map-marker\">\n</md-icon><img ng-if=\"locationRelationshipVM.relatedLocationImageUrl\" class=\"md-avatar\" \nbaldris-img-src=\"locationRelationshipVM.relatedLocationImageUrl\" preset=\"square-40-cropped\"><div \nclass=\"md-list-item-text\"><h3>{{ locationRelationshipVM.relatedLocationName }}</h3><p>\n{{ vm.getTranslatedRelationshipText(locationRelationshipVM.relationship) }}</p></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.deleteRelatedLocation(locationRelationshipVM, $event)\"><md-tooltip \nmd-direction=\"top\"><span translate=\"LOCATIONS.RELATED_LOCATIONS_LIST.DELETE_RELATIONSHIP\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item><md-list-item class=\"md-2-line\" \nng-click=\"vm.addRelatedLocation($event)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-plus\"></md-icon><div \nclass=\"md-list-item-text\"><h3>{{ \"LOCATIONS.RELATED_LOCATIONS_LIST.ADD_RELATED_LOCATION\" | translate }}</h3><p>\n{{ \"LOCATIONS.RELATED_LOCATIONS_LIST.NEW_LOCATION_RELATIONSHIP\" | translate }}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/reference-types/location/dialogs/add-location-dialog/add-location-dialog.tmpl.html","<md-dialog ng-form=\"vm.addLocationForm\" class=\"add-location-dialog edit-dialog\" \naria-label=\"{{ vm.referenceDeclaration.templateTitle || \'SETTINGS.REFERENCE_REGISTRY.EDIT_REFERENCE\' | translate }}\">\n<md-toolbar class=\"md-primary\" layout=\"column\" ng-style=\"vm.eventStyle\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ \'LOCATIONS.EDIT_LOCATION.ADD_LOCATION\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content \nng-if=\"vm.loadingService.isLoadingInBackground\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></md-content><md-content \nng-if=\"!vm.loadingService.isLoadingInBackground\" layout=\"column\"><md-input-container class=\"md-block\"><label>\n{{ \'LOCATIONS.LOCATION.NAME\' | translate}}</label><input name=\"locationName\" required \nng-model=\"vm.updateModel.location.name\" ng-change=\"vm.onLocationNameChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }\"><div \nng-messages=\"vm.addLocationForm.locationName.$error\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\">{{ \'LOCATIONS.EDIT_LOCATION.LOCATION_NAME_REQUIRED\' | translate }}</div><div \nng-message=\"existingLocations\">{{vm.getExistingLocationsAsString()}}</div></div></md-input-container>\n<many-to-many-select class=\"margin-bottom-20\" many-to-many-list=\"vm.updateModel.location.locationTypeIds\" \nmany-to-many-name=\"LocationLocationTypeDto\" reference-id=\"vm.updateModel.location.id\" reference-id-name=\"locationId\" \nlist-contains-only-foreign-keys=\"true\" source-controller=\"LocationTypes\" source-id-name=\"id\" source-name=\"name\" \ntarget-id-name=\"id\" target-name=\"name\" label-text=\"{{\'LOCATIONS.LOCATION.LOCATION_TYPES\' | translate}}\" \nplaceholder-text=\"{{\'LOCATIONS.LOCATION.LOCATION_TYPES\' | translate}}\" is-required=\"true\" \non-update=\"vm.setChangeState(vm.updateModel.location)\"></many-to-many-select><md-checkbox \nng-click=\"vm.setIgnoreStatus(!vm.ignoreExisting)\" ng-checked=\"vm.ignoreExisting\" \nng-if=\"vm.ignoreExisting || vm.addLocationForm.locationName.$error.existingLocations\">Ignorer eksisterende\n</md-checkbox><md-input-container class=\"md-block\"><label>{{ \'LOCATIONS.LOCATION.DESCRIPTION\' | translate}}</label>\n<textarea ng-model=\"vm.updateModel.location.description\"></textarea></md-input-container></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.saveChanges()\" ng-disabled=\"vm.addLocationForm.$invalid\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/location/dialogs/add-location-relationship-dialog/add-location-relationship-dialog.tmpl.html","");
$templateCache.put("app/main/reference-types/location/dialogs/edit-required-equipment-dialog/edit-required-equipment-dialog.tmpl.html","<md-dialog class=\"edit-required-equipment-dialog edit-dialog\" aria-label=\"Edit Required Equipment\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ (vm.locationEquipment.changeState === 1 ? \'LOCATIONS.EDIT_LOCATION.ADD_REQUIRED_EQUIPMENT\' : \'LOCATIONS.EDIT_LOCATION.EDIT_REQUIRED_EQUIPMENT\') | translate }}\n</span></div></md-toolbar><md-dialog-content><equipment-select equipment=\"vm.locationEquipment.equipment\" \nequipment-id=\"vm.locationEquipment.equipmentId\" label-text=\"{{\'LOCATIONS.LOCATION_EQUIPMENT.EQUIPMENT\' | translate }}\">\n</equipment-select><div ng-form=\"vm.editRequiredEquipmentForm\" class=\"edit-required-equipment-form\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>{{\'LOCATIONS.LOCATION_EQUIPMENT.AMOUNT\' | translate }}</label><input \nng-model=\"vm.locationEquipment.amount\" type=\"number\" step=\"0.01\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/location/dialogs/edit-suggested-transport-dialog/edit-suggested-transport-dialog.tmpl.html","<md-dialog class=\"edit-suggested-transport-dialog edit-dialog\" aria-label=\"Edit Suggested Transport\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">\n{{ (vm.suggestedTransport.changeState === 1 ? \'LOCATIONS.EDIT_LOCATION.ADD_SUGGESTED_TRANSPORT\' : \'LOCATIONS.EDIT_LOCATION.EDIT_SUGGESTED_TRANSPORT\') | translate }}\n</span></div></md-toolbar><md-dialog-content><div ng-form=\"vm.editSuggestedTransportForm\" \nclass=\"baldris-edit-suggestedTransport\" layout=\"column\"><md-content><h5 class=\"md-subhead\" \ntranslate=\"LOCATIONS.LOCATION_TRANSPORTS.GENERAL\">General</h5><location-select \nlocation=\"vm.suggestedTransport.departureLocation\" location-id=\"vm.suggestedTransport.departureLocationId\" \nlabel-text=\"{{ \'LOCATIONS.LOCATION_TRANSPORTS.DEPARTURE_LOCATION\' | translate}}\"></location-select><location-select \nlocation=\"vm.suggestedTransport.destinationLocation\" on-selected=\"vm.onDestinationChanged\" \nlocation-id=\"vm.suggestedTransport.destinationLocationId\" \nlabel-text=\"{{ \'LOCATIONS.LOCATION_TRANSPORTS.DESTINATION_LOCATION\' | translate}}\"></location-select>\n<md-input-container class=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.DESCRIPTION\' | translate }}</label><input \nng-model=\"vm.suggestedTransport.description\"></md-input-container><md-checkbox \nng-model=\"vm.suggestedTransport.isOptional\" aria-label=\"{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_OPTIONAL\' | translate}}\">\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_OPTIONAL\' | translate}}</md-checkbox></md-content><md-divider></md-divider>\n<md-content><h5 class=\"md-subhead\" translate=\"LOCATIONS.LOCATION_TRANSPORTS.PRICING\">Pricing</h5><md-input-container \nclass=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.DISTANCE\' | translate }}</label><input \nng-model=\"vm.suggestedTransport.distance\" type=\"number\" step=\"0.01\"></md-input-container><md-input-container \nclass=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.DRIVER_HOURS\' | translate }}</label><input \nng-model=\"vm.suggestedTransport.driverHours\" type=\"number\" step=\"0.01\"></md-input-container><md-input-container \nclass=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.ADDITIONAL_HOURS\' | translate }}</label><input \nng-model=\"vm.suggestedTransport.additionalHours\" type=\"number\" step=\"0.01\"></md-input-container><md-input-container \nclass=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.ADDITIONAL_COST\' | translate }}</label><input \nng-model=\"vm.suggestedTransport.additionalCost\" ng-currency></md-input-container><bill-to-select \nbill-to=\"vm.suggestedTransport.billTo\" label-text=\"{{ \'LOCATIONS.LOCATION_TRANSPORTS.BILL_TO\' | translate}}\">\n</bill-to-select></md-content><md-divider></md-divider><md-content><md-input-container class=\"md-block\" flex><label>\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.REMARKS\' | translate}}</label><textarea ng-model=\"vm.suggestedTransport.remarks\">\n</textarea></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button ng-click=\"vm.saveAndCloseDialog()\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/reference-types/location/dialogs/search-location-dialog/search-location-dialog.tmpl.html","<md-dialog class=\"search-location-dialog\" aria-label=\"Search Location\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'LOCATIONS.SEARCH_LOCATION_DIALOG.TITLE\' | translate}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"location-type-list\"><md-list flex><div \nng-if=\"vm.isFetchingTypes\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-virtual-repeat-container><div \nmd-virtual-repeat=\"locationType in vm.locationTypes | orderBy:\'name\'\"><md-list-item \nng-click=\"vm.selectLocationType(locationType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': locationType.id == vm.selectedLocationTypeId }\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{ locationType.name }}</h3><p>{{ locationType.description }}</p></div></md-list-item><md-divider \nng-if=\"!$last\"></md-divider></div></md-virtual-repeat-container></md-list></div><div flex class=\"location-list\">\n<md-list flex><div ng-if=\"vm.isSearching\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-virtual-repeat-container><div \nmd-virtual-repeat=\"location in vm.searchResults | orderBy:\'name\'\"><md-list-item ng-click=\"vm.selectItem(location)\" \nclass=\"md-3-line\" flex ng-class=\"{ \'md-accent-bg\': location.id == vm.selectedLocation.id }\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ location.name }}</h3><h4>{{ location.address }}</h4><p><span \nng-if=\"location.locationTypes.length > 0\" class=\"search-result-type\" \nng-repeat=\"locationType in location.locationTypes\">{{locationType.name}}</span></p></div></md-list-item><md-divider \nng-if=\"!$last\"></md-divider></div></md-virtual-repeat-container></md-list></div></div><div layout-padding>\n<md-input-container class=\"md-icon-float md-block\"><label>{{\'LOCATIONS.SEARCH_LOCATION_DIALOG.SEARCH\' | translate}}\n</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" \nng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" \nclass=\"md-primary\" ng-click=\"vm.closeDialog(vm.selectedLocation)\">\n{{ \'LOCATIONS.SEARCH_LOCATION_DIALOG.CHOOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/location/edit-location/views/location-sidenav.tmpl.html","<div class=\"common-sidebar edit-location-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div ng-if=\"!vm.loadingService.isLoading\" \nclass=\"sidebar-content\" layout=\"column\" layout-padding><baldris-audit \ntitle-text=\"vm.data.updateModel.partyUpdateModel.party.displayName\" audit-model=\"vm.data.updateModel.participant\">\n</baldris-audit><md-button ng-if=\"vm.data.updateModel.location.imageId\" class=\"md-raised\" \nng-click=\"vm.data.removeImage()\">{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button><md-button \nng-if=\"!vm.data.updateModel.location.imageId\" class=\"md-primary md-raised\" ngf-select=\"vm.data.uploadImage($file)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button><img ng-if=\"vm.data.updateModel.location.imageId\" \nbaldris-img-src=\"vm.data.updateModel.location.imageFilepath\" preset=\"small-landscape-cropped\" \nalt=\"{{vm.data.updateModel.location.name}}\"><h3 translate=\"LOCATIONS.LOCATION.ADDRESS\">Address</h3><address \nng-if=\"vm.data.updateModel.address\"><span ng-if=\"vm.data.updateModel.address.streetAddress1\">\n{{vm.data.updateModel.address.streetAddress1}}<br></span><span ng-if=\"vm.data.updateModel.address.streetAddress2\">\n{{vm.data.updateModel.address.streetAddress2}}<br></span><span \nng-if=\"vm.data.updateModel.address.zipCode || vm.data.updateModel.address.city\">\n{{vm.data.updateModel.address.zipCode}} {{vm.data.updateModel.address.city}}<br></span><span \nng-if=\"vm.data.updateModel.address.stateCountrySerialized\">{{vm.data.updateModel.address.stateCountrySerialized}}<br>\n</span></address><ui-gmap-google-map ng-if=\"vm.data.addressCoordinates\" center=\"vm.data.addressCoordinates.center\" \nzoom=\"vm.data.addressCoordinates.zoom\"><ui-gmap-marker coords=\"vm.data.addressCoordinates.marker.coords\" \noptions=\"vm.data.addressCoordinates.marker.options\" events=\"vm.data.addressCoordinates.marker.events\" \nidkey=\"vm.data.addressCoordinates.marker.id\"></ui-gmap-marker></ui-gmap-google-map><md-button \nclass=\"md-raised md-block\" ng-if=\"!vm.data.updateModel.address\" aria-label=\"Upload Image\" \nng-click=\"vm.data.showEditAddressDialog(null, $event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{ \'LOCATIONS.EDIT_LOCATION.ADD_ADDRESS\' | translate }}</md-button><md-button class=\"md-block\" \nng-if=\"vm.data.updateModel.address\" aria-label=\"Upload Image\" \nng-click=\"vm.data.showEditAddressDialog(vm.data.updateModel.address, $event)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon>{{ \'LOCATIONS.EDIT_LOCATION.EDIT_ADDRESS\' | translate }}</md-button></div>\n</div>");
$templateCache.put("app/main/reference-types/location/edit-location/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"LOCATIONS.EDIT_LOCATION.EDIT_LOCATION\"></span> <span ng-if=\"vm.data.validation.locationForm.$dirty\">*</span>\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.locationForm.$pristine\" aria-label=\"OK, save\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/reference-types/lookup-string/components/lookup-string-select/lookup-string-select.tmpl.html","<div ng-form=\"vm.lookupStringForm\" class=\"baldris-lookup-string-select\"><md-autocomplete ng-if=\"!vm.hideLabel\" flex \nmd-min-length=\"vm.minLength\" md-input-name=\"lookupString\" md-selected-item=\"vm.lookupString\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" \nmd-item-text=\"vm.getText(item)\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-lookup-string-select\" ng-disabled=\"vm.isDisabled\"><md-item-template><div><img \nclass=\"lookup-image\" ng-if=\"item.imageFilepath\" baldris-img-src=\"item.imageFilepath\" preset=\"square-40-cropped\" \nalt=\"{{item.lookupValue}}\"><md-icon ng-if=\"!item.imageFilepath && item.lookupIconName\" \nmd-font-icon=\"{{item.lookupIconName}}\"></md-icon><span ng-if=\"item.lookupStringTypeShouldShowValueNumbers\" \nclass=\"lookup-number\">{{ item.lookupNumber }} - </span><span class=\"lookup-value\">{{ vm.getText(item) }}</span></div>\n</md-item-template><div ng-messages=\"vm.lookupStringForm.lookupString.$error\" \nng-if=\"vm.lookupStringForm.lookupString.$touched\"><div ng-message=\"invalidLookupString\"><span \ntranslate=\"LOOKUP_STRINGS.LOOKUP_STRING_SELECT.INVALID_LOOKUP_STRING\" translate-values=\"{ value: vm.searchText }\">\n</span></div></div></md-autocomplete><md-autocomplete ng-if=\"vm.hideLabel\" flex md-min-length=\"vm.minLength\" \nmd-input-name=\"lookupString\" md-selected-item=\"vm.lookupString\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-clear-button=\"true\" md-item-text=\"vm.getText(item)\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nplaceholder=\"{{vm.labelText}}\" md-menu-class=\"autocomplete-lookup-string-select\" ng-disabled=\"vm.isDisabled\">\n<md-item-template><div><md-icon ng-if=\"item.lookupIconName\" md-font-icon=\"{{item.lookupIconName}}\"></md-icon><span \nng-if=\"item.lookupStringTypeShouldShowValueNumbers\" class=\"lookup-number\">{{ item.lookupNumber }} - </span><span \nclass=\"lookup-value\">{{ vm.getText(item) }}</span></div></md-item-template><div \nng-messages=\"vm.lookupStringForm.lookupString.$error\" ng-if=\"vm.lookupStringForm.lookupString.$touched\"><div \nng-message=\"invalidLookupString\"><span translate=\"LOOKUP_STRINGS.LOOKUP_STRING_SELECT.INVALID_LOOKUP_STRING\" \ntranslate-values=\"{ value: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/lookup-string/components/lookup-string-type-select/lookup-string-type-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{vm.labelText}}</label><md-select ng-model=\"vm.lookupStringTypeId\" \nng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option ng-value=\"null\" md-option-empty \nng-if=\"!vm.isRequired\"><em>{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.NONE\' | translate }}</em></md-option><md-option \nng-repeat=\"lookupStringType in vm.lookupStringTypes | orderBy:\'name\'\" ng-value=\"lookupStringType.id\">\n{{lookupStringType.name}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/reference-types/municipality/components/municipality-select/municipality-select.tmpl.html","<div ng-form=\"vm.municipalityForm\" class=\"baldris-municipality-select\"><md-autocomplete flex \nmd-input-name=\"municipality\" md-selected-item=\"vm.municipality\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-min-length=\"vm.minLength\" md-clear-button=\"true\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.name}}</span> <span class=\"text-italic\" ng-show=\"item.stateName\">({{item.stateName}})</span></md-item-template>\n<div ng-messages=\"vm.municipalityForm.municipality.$error\" ng-if=\"vm.municipalityForm.municipality.$touched\"><div \nng-message=\"invalidMunicipality\"><span translate=\"MUNICIPALITIES.MUNICIPALITY_SELECT.INVALID_MUNICIPALITY\" \ntranslate-values=\"{ municipality: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/participant/dialogs/edit-participant-dialog/edit-participant-dialog.tmpl.html","<md-dialog class=\"edit-participant-dialog edit-dialog\" aria-label=\"Add Reference Person\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">\n{{vm.isNew ? \'PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.ADD_PARTICIPANT\' : \'PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.EDIT_PARTICIPANT\' | translate}}\n</span></div></md-toolbar><md-dialog-content layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"margin-bottom-10\"><div flex-gt-xs=\"50\"><md-input-container class=\"md-block\" flex><label>\n{{\'PARTY.PERSON.LASTNAME\' | translate }}</label><input ng-model=\"vm.updateModel.partyUpdateModel.party.lastName\" \nng-change=\"vm.onNameChange()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" \nflex md-autofocus></md-input-container></div><div flex-gt-xs=\"50\"><md-input-container class=\"md-block\"><label>\n{{\'PARTY.PERSON.FIRSTNAME\' | translate }}</label><input ng-model=\"vm.updateModel.partyUpdateModel.party.firstName\" \nng-change=\"vm.onNameChange()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\">\n</md-input-container></div></div><many-to-many-select class=\"margin-bottom-30\" \nmany-to-many-list=\"vm.updateModel.participantTypeParticipants\" many-to-many-name=\"ParticipantTypeParticipantDto\" \nreference-id=\"vm.updateModel.participant.id\" reference-id-name=\"participantId\" source-controller=\"ParticipantTypes\" \nsource-id-name=\"id\" source-name=\"name\" target-id-name=\"participantTypeId\" target-name=\"participantTypeName\" \nlabel-text=\"{{\'PARTICIPANTS.PARTICIPANT.PARTICIPANT_TYPES\' | translate}}\" \nplaceholder-text=\"{{\'PARTICIPANTS.PARTICIPANT.PARTICIPANT_TYPES\' | translate}}\"></many-to-many-select><div><md-checkbox\n ng-model=\"vm.updateModel.participant.isDeleted\">{{\'PARTICIPANTS.PARTICIPANT.IS_DELETED\' | translate}}</md-checkbox>\n</div><div ng-if=\"vm.isNew && !vm.isSearching && vm.searchResults && vm.searchResults.length > 0\" \nclass=\"search-results\"><h3 translate=\"PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.FOUND_MATCHES\" \ntranslate-values=\"{ count: vm.searchResults.length }\">Found matches</h3><p class=\"md-caption\" \ntranslate=\"PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.CLICK_TO_SELECT\">Click to select</p><md-virtual-repeat-container>\n<md-list flex><div ng-if=\"vm.isSearching\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResults\"><md-list-item ng-click=\"vm.selectPerson(item)\" class=\"md-3-line\" flex \nng-class=\"{ \'md-accent-bg\': item.id == vm.selectedParty.id }\"><img ng-if=\"!item.image.filepath\" class=\"md-avatar\" \ngravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img ng-if=\"item.image.filepath\" class=\"md-avatar\" \nbaldris-img-src=\"item.image.filepath\" preset=\"square-40-cropped\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.displayName }}</h3><h4>{{ item.dateOfBirth | date:\'shortDate\' }} {{ item.socialSecurityNumber }}</h4><p>\n{{ item.partyTypes }}</p></div></md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list>\n</md-virtual-repeat-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-disabled=\"vm.isSearching\" ng-if=\"vm.selectedParty\" class=\"md-primary\" ng-click=\"vm.choosePerson()\" \ntranslate=\"PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.ADD_SELECTED_REFERENCE_PERSON\" \ntranslate-values=\"{ partyDisplayName: vm.selectedParty.displayName }\">Add selected person</md-button><md-button \nng-disabled=\"vm.isSearching\" ng-if=\"!vm.selectedParty\" class=\"md-primary\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'PARTICIPANTS.EDIT_PARTICIPANT_DIALOG.ADD_NEW_REFERENCE_PERSON\' | translate}}</md-button><md-button class=\"md-warn\" \nng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/participant/dialogs/search-participant-dialog/search-participant-dialog.tmpl.html","<md-dialog class=\"search-participant-dialog\" aria-label=\"Search Participant\"><md-toolbar><div class=\"md-toolbar-tools\">\n<span class=\"title\">{{ \'PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.SEARCH_PARTICIPANTS\' | translate}}</span></div>\n</md-toolbar><md-dialog-content layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex \nclass=\"participant-type-list\"><md-list flex><div \nng-repeat=\"participantType in vm.participantTypes | orderBy:[\'sortOrder\',\'name\']\"><md-list-item \nng-click=\"vm.selectParticipantType(participantType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': participantType.id == vm.selectedParticipantType.id }\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{ participantType.name }}</h3><p>{{ participantType.description }}</p></div></md-list-item>\n<md-divider ng-if=\"!$last\"></md-divider></div></md-list></div><div flex class=\"participant-list\">\n<md-virtual-repeat-container><md-list flex><div ng-if=\"vm.isSearching\" layout=\"row\" layout-padding layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResults\"><md-list-item ng-click=\"vm.selectItem(item)\" class=\"md-3-line\" flex \nng-class=\"{ \'md-accent-bg\': item.id == vm.selectedParticipant.id }\"><img ng-if=\"!item.partyImageFilePath\" \nclass=\"md-avatar\" gravatar-src=\"item.partyPrimaryEmail || \'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"item.partyImageFilePath\" class=\"md-avatar\" baldris-img-src=\"item.partyImageFilePath\" preset=\"square-40-cropped\">\n<div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.partyDisplayName }}</h3><h4>{{ item.participantTypes }}</h4>\n<p>{{ item.prop || item.title }}</p></div></md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list>\n</md-virtual-repeat-container></div></div><div layout-padding class=\"margin-top-20\"><md-input-container \nclass=\"md-icon-float md-block\"><label>{{\'PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.SEARCH\' | translate}}</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" \nng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"vm.allowAdditions\" aria-label=\"Choose\" \nng-click=\"vm.openAddParticipantDialog($event)\">{{ \'PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.ADD_NEW\' | translate}}\n</md-button><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-disabled=\"!vm.selectedParticipant\" ng-click=\"vm.closeDialog(vm.selectedParticipant)\">\n{{ \'PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.CHOOSE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/participant/edit-participant/views/sidebar.tmpl.html","<div class=\"contacts-sidebar edit-participant-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><baldris-audit title-text=\"vm.data.updateModel.partyUpdateModel.party.displayName\" \naudit-model=\"vm.data.updateModel.participant\"></baldris-audit><md-button \nng-if=\"vm.data.updateModel.partyUpdateModel.party.imageId\" class=\"md-raised\" ng-click=\"vm.data.removeProfileImage()\">\n{{ \'PARTY.EDIT_PARTY.REMOVE_PROFILE_IMAGE\' | translate }}</md-button><md-button \nng-if=\"!vm.data.updateModel.partyUpdateModel.party.imageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.data.uploadProfileImage($file)\">{{ \'PARTY.EDIT_PARTY.UPLOAD_PROFILE_IMAGE\' | translate }}</md-button>\n<img ng-if=\"vm.data.updateModel.partyUpdateModel.party.imageId\" \nbaldris-img-src=\"vm.data.updateModel.partyUpdateModel.party.imageFilepath\" preset=\"square-250-cropped\" \nalt=\"{{vm.data.updateModel.partyUpdateModel.party.displayName}}\"></div></div>");
$templateCache.put("app/main/reference-types/participant/edit-participant/views/toolbar.tmpl.html","");
$templateCache.put("app/main/reference-types/participant-role/components/participant-role-select/participant-role-select.tmpl.html","<div ng-form=\"vm.participantRoleForm\" class=\"baldris-participant-role-select\"><md-autocomplete flex \nmd-input-name=\"participantRole\" md-selected-item=\"vm.participantRole\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-participant-role-select\" ng-disabled=\"vm.isDisabled\" md-clear-button=\"true\" \nmd-min-length=\"vm.minLength\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">\n{{item.name}}</span></md-item-template><div ng-messages=\"vm.participantRoleForm.participantRole.$error\" \nng-if=\"vm.participantRoleForm.participantRole.$touched\"><div ng-message=\"invalidRole\"><span \ntranslate=\"PARTICIPANT_ROLES.PARTICIPANT_ROLE_SELECT.INVALID_ROLE\" \ntranslate-values=\"{ participantRole: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/party/components/birth-date-select/birth-date-select.tmpl.html","<div ng-form=\"vm.birthDateForm\" class=\"birth-date-select-container\" layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container ng-if=\"!vm.showApproximate\"><label>{{ \"PARTY.PERSON.DATE_OF_BIRTH\" | translate }}</label>\n<date-select name=\"datePart\" ng-model=\"vm.dateOfBirth\" ng-change=\"vm.datePartChanged()\" ng-disabled=\"vm.isDisabled\" \nmd-min-date=\"vm.minTime\" md-max-date=\"vm.maxTime\" ng-required=\"vm.isRequired\"></date-select><div class=\"errors\" \nng-messages=\"vm.birthDateForm.datePart.$error\"><div ng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\">\n</span></div><div ng-message=\"required\"><span translate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div \nng-message=\"mindate\">{{ vm.minText || \"COMMON.DATE_TIME.MIN_DATE\" | translate }}</div><div ng-message=\"maxdate\">\n{{ vm.maxText || \"COMMON.DATE_TIME.MAX_DATE\" | translate }}</div><div ng-message=\"afterDeath\">\n{{ \"PARTY.EDIT_PARTY.AFTER_DEATH\" | translate }}</div></div></md-input-container><md-input-container \nng-if=\"vm.showApproximate\" class=\"md-icon-float\"><label>{{ \"PARTY.PERSON.DATE_OF_BIRTH\" | translate }}</label><md-icon \nmd-font-icon=\"icon-calendar-text\"></md-icon><input name=\"approximatePart\" ng-model=\"vm.approximateModel\" \nng-disabled=\"vm.isDisabled\" ng-change=\"vm.approximateChanged()\"><div class=\"errors\" \nng-messages=\"vm.birthDateForm.approximatePart.$error\"><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div></div></md-input-container><md-menu><md-button \naria-label=\"{{ \'COMMON.DATA.SHOW_MORE_OPTIONS\' | translate }}\" class=\"md-icon-button\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.allowApproximate && !vm.showApproximate\"><md-button \nng-click=\"vm.toggleApproximate(true)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{ \"COMMON.DATE_TIME.USE_APPROXIMATE_DATE\" | translate }}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.allowApproximate && vm.showApproximate\"><md-button ng-click=\"vm.toggleApproximate(false)\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon>{{ \"COMMON.DATE_TIME.USE_PRECISE_DATE\" | translate }}</md-button>\n</md-menu-item><md-menu-item ng-if=\"!vm.showApproximate\"><md-button ng-click=\"vm.showTimePart = !vm.showTimePart\">\n<md-icon md-font-icon=\"icon-clock\"></md-icon>{{ \"COMMON.DATE_TIME.ENTER_TIME_VALUE\" | translate }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-input-container ng-if=\"vm.showTimePart\" \nclass=\"md-icon-float md-block time-part\" flex-gt-xs><label><span ng-if=\"vm.labelTimeText\">{{ vm.labelTimeText }}</span>\n <span ng-if=\"!vm.labelTimeText\">{{ \"COMMON.DATE_TIME.TIME\" | translate }}</span></label><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><input ui-mask=\"99:99\" ui-mask-placeholder-char=\" \" name=\"timePart\" \nng-model=\"vm.timePart\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.timePartChanged()\" \nng-model-options=\"{ updateOn: \'blur\', debounce: { \'blur\': 0 } }\"><div class=\"errors\" \nng-messages=\"vm.birthDateForm.timePart.$error\"><div ng-message=\"invalidTime\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_TIME\"></span></div></div></md-input-container></div>");
$templateCache.put("app/main/reference-types/party/components/death-date-select/death-date-select.tmpl.html","<div ng-form=\"vm.deathDateForm\" class=\"death-date-select-container\" layout-gt-xs=\"row\"><div layout=\"row\">\n<md-input-container ng-if=\"!vm.showApproximate\"><label>{{ \"PARTY.PERSON.DATE_OF_DEATH\" | translate }}</label>\n<date-select name=\"datePart\" ng-model=\"vm.dateOfDeath\" ng-change=\"vm.datePartChanged()\" ng-disabled=\"vm.isDisabled\" \nmd-min-date=\"vm.minTime\" md-max-date=\"vm.maxTime\" ng-required=\"vm.isRequired\"></date-select><div class=\"errors\" \nng-messages=\"vm.deathDateForm.datePart.$error\"><div ng-message=\"valid\"><span translate=\"COMMON.DATE_TIME.INVALID_DATE\">\n</span></div><div ng-message=\"required\"><span translate=\"COMMON.DATE_TIME.REQUIRED\"></span></div><div \nng-message=\"mindate\">{{ vm.minText || \"COMMON.DATE_TIME.MIN_DATE\" | translate }}</div><div ng-message=\"maxdate\">\n{{ vm.maxText || \"COMMON.DATE_TIME.MAX_DATE\" | translate }}</div><div ng-message=\"beforeBirth\">\n{{ \"PARTY.EDIT_PARTY.BEFORE_BIRTH\" | translate }}</div></div></md-input-container><md-input-container \nng-if=\"vm.showApproximate\" class=\"md-icon-float\"><label>{{ \"PARTY.PERSON.DATE_OF_DEATH\" | translate }}</label><md-icon \nmd-font-icon=\"icon-calendar-text\"></md-icon><input name=\"approximatePart\" ng-model=\"vm.approximateModel\" \nng-disabled=\"vm.isDisabled\" ng-change=\"vm.approximateChanged()\"><div class=\"errors\" \nng-messages=\"vm.deathDateForm.approximatePart.$error\"><div ng-message=\"required\"><span \ntranslate=\"COMMON.DATE_TIME.REQUIRED\"></span></div></div></md-input-container><md-menu><md-button \naria-label=\"{{ \'COMMON.DATA.SHOW_MORE_OPTIONS\' | translate }}\" class=\"md-icon-button\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"vm.allowApproximate && !vm.showApproximate\"><md-button \nng-click=\"vm.toggleApproximate(true)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{ \"COMMON.DATE_TIME.USE_APPROXIMATE_DATE\" | translate }}</md-button></md-menu-item><md-menu-item \nng-if=\"vm.allowApproximate && vm.showApproximate\"><md-button ng-click=\"vm.toggleApproximate(false)\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon>{{ \"COMMON.DATE_TIME.USE_PRECISE_DATE\" | translate }}</md-button>\n</md-menu-item><md-menu-item ng-if=\"!vm.showApproximate\"><md-button ng-click=\"vm.showTimePart = !vm.showTimePart\">\n<md-icon md-font-icon=\"icon-clock\"></md-icon>{{ \"COMMON.DATE_TIME.ENTER_TIME_VALUE\" | translate }}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-input-container ng-if=\"vm.showTimePart\" \nclass=\"md-icon-float md-block time-part\" flex-gt-xs><label><span ng-if=\"vm.labelTimeText\">{{ vm.labelTimeText }}</span>\n <span ng-if=\"!vm.labelTimeText\">{{ \"COMMON.DATE_TIME.TIME\" | translate }}</span></label><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><input ui-mask=\"99:99\" ui-mask-placeholder-char=\" \" name=\"timePart\" \nng-model=\"vm.timePart\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.timePartChanged()\" \nng-model-options=\"{ updateOn: \'blur\', debounce: { \'blur\': 0 } }\"><div class=\"errors\" \nng-messages=\"vm.deathDateForm.timePart.$error\"><div ng-message=\"invalidTime\"><span \ntranslate=\"COMMON.DATE_TIME.INVALID_TIME\"></span></div></div></md-input-container></div>");
$templateCache.put("app/main/reference-types/party/components/edit-party/edit-party.tmpl.html","<div ng-form=\"vm.partyForm\" class=\"baldris-edit-party\" layout=\"column\"><div ng-if=\"vm.isOrganization()\" \nng-include=\"\'app/main/reference-types/party/components/edit-party/views/organization.view.html\'\"></div><div \nng-if=\"!vm.isOrganization()\" \nng-include=\"\'app/main/reference-types/party/components/edit-party/views/person.view.html\'\"></div><div \nng-if=\"vm.showRemarks\"><md-input-container class=\"md-block\"><label>\n{{ (vm.isOrganization() ? \'PARTY.ORGANIZATION.REMARKS\' : \'PARTY.PERSON.REMARKS\') | translate }}</label><textarea \nng-model=\"vm.baldrisModel.remarks\"></textarea></md-input-container></div></div>");
$templateCache.put("app/main/reference-types/party/components/organization-card/organization-card.tmpl.html","<md-card class=\"organization-card\"><md-card-header ng-click=\"vm.navigateToOrganization(vm.baldrisModel)\">\n<md-card-avatar><md-icon ng-if=\"!vm.baldrisModel.image.filepath\" md-font-icon=\"icon-city\"></md-icon><img \nng-if=\"vm.baldrisModel.image.filepath\" class=\"md-avatar\" baldris-img-src=\"vm.baldrisModel.image.filepath\" \npreset=\"square-40-cropped\"></md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.displayName}}\n</span> <span class=\"md-subhead\">{{ vm.baldrisModel.organizationNumber }}</span></md-card-header-text></md-card-header>\n<md-card-title ng-click=\"vm.navigateToOrganization(vm.baldrisModel)\"><md-card-title-text><span class=\"md-headline\">\n{{vm.baldrisModel.displayName}}</span></md-card-title-text></md-card-title><md-card-content \nng-click=\"vm.navigateToOrganization(vm.baldrisModel)\"><div ng-if=\"vm.baldrisModel.homePage\"><label class=\"md-caption\">\n{{\'PARTY.ORGANIZATION.HOME_PAGE\' | translate}}</label><p><a ng-href=\"{{vm.baldrisModel.homePage}}\" target=\"_blank\">\n{{vm.baldrisModel.homePage}}</a></p></div><div ng-if=\"vm.baldrisModel.addresses\" \nng-repeat=\"address in vm.baldrisModel.addresses | orderBy:\'sortOrder\'\"><label class=\"md-caption\">\n{{address.addressTypeName}}</label><p>{{address.addressSerialized}}</p></div><div ng-if=\"vm.baldrisModel.emails\" \nng-repeat=\"email in vm.baldrisModel.emails | orderBy:\'sortOrder\'\"><label class=\"md-caption\">{{email.emailTypeName}}\n</label><p>{{email.emailAddress}}</p></div><div ng-if=\"vm.baldrisModel.telephones\" \nng-repeat=\"telephone in vm.baldrisModel.telephones | orderBy:\'sortOrder\'\"><label class=\"md-caption\">\n{{telephone.telephoneTypeName}}</label><p>{{vm.getFormattedNumber(telephone)}}</p></div></md-card-content>\n<md-card-actions ng-hide=\"vm.disableLinks\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Edit\" ng-click=\"vm.navigateToOrganization(vm.baldrisModel)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteDeceased(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/reference-types/party/components/party-privacy-summary/party-privacy-summary.tmpl.html","<div class=\"party-privacy-summary\" ng-form=\"vm.privacyOptionsForm\"><div class=\"inner-container\"><div layout=\"row\">\n<md-icon ng-if=\"!vm.isLoading\" md-font-icon=\"{{ vm.getPrivacyIcon() }}\" class=\"s48\" \nng-class=\"vm.getPrivacyIconClass()\"></md-icon><md-progress-circular ng-if=\"vm.isLoading\" md-mode=\"indeterminate\">\n</md-progress-circular><div flex><h2>{{ vm.getHeaderText() | translate }}</h2><h5>\n{{ vm.getSubheaderText() | translate }}</h5></div></div><md-button class=\"md-raised\" ng-if=\"!vm.isPseudomized()\" \nng-click=\"vm.openPartyPrivacyDialog($event)\">{{ \'PARTY.EDIT_PARTY.REVIEW_PRIVACY_OPTIONS\' | translate }}</md-button>\n</div></div>");
$templateCache.put("app/main/reference-types/party/components/party-select/party-select.tmpl.html","<div ng-form=\"vm.partyForm\" class=\"baldris-party-select\"><div layout=\"column\"><div ng-form=\"vm.partyForm\" layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete flex md-input-name=\"party\" md-selected-item=\"vm.party\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-require-match=\"true\" \nmd-select-on-match=\"true\" md-item-text=\"item.displayName\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-menu-class=\"autocomplete-party-select\" ng-disabled=\"vm.isDisabled\" \nmd-min-length=\"vm.minLength\" md-clear-button=\"true\"><md-item-template><div><span><md-icon \nmd-font-icon=\"icon-file-document-box\"></md-icon></span>{{item.displayName}}</div><div>{{item.partyTypes}}</div>\n</md-item-template><div ng-messages=\"vm.partyForm.party.$error\" ng-if=\"vm.partyForm.party.$touched\"><div \nng-message=\"invalidParty\"><span translate=\"PARTY.PARTY-SELECT.INVALID_PARTY\" \ntranslate-values=\"{ party: vm.searchText }\"></span></div></div></md-autocomplete><md-button \nclass=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" aria-label=\"Search\" \ntranslate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" ng-disabled=\"vm.isDisabled || vm.disableSearch\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/reference-types/party/components/person-card/person-card.tmpl.html","<md-card class=\"person-card\"><md-card-header ng-click=\"vm.navigateToPerson(vm.baldrisModel)\"><md-card-avatar><img \nng-if=\"!vm.baldrisModel.image.filepath\" class=\"md-avatar\" gravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"vm.baldrisModel.image.filepath\" class=\"md-avatar\" baldris-img-src=\"vm.baldrisModel.image.filepath\" \npreset=\"square-40-cropped\"></md-card-avatar><md-card-header-text><span class=\"md-title\">{{vm.baldrisModel.displayName}}\n</span> <span class=\"md-subhead\"><span ng-if=\"vm.baldrisModel.dateOfBirth\"><span class=\"icon icon-cake\"></span>\n {{vm.baldrisModel.dateOfBirth | date:\'shortDate\'}}</span> <span ng-if=\"vm.baldrisModel.dateOfDeath\"><span \nclass=\"icon icon-hanger\"></span> {{vm.baldrisModel.dateOfDeath | date:\'shortDate\'}}</span></span></md-card-header-text>\n</md-card-header><md-card-title ng-click=\"vm.navigateToPerson(vm.baldrisModel)\"><md-card-title-text><span \nclass=\"md-headline\">{{vm.baldrisModel.displayName}}</span></md-card-title-text></md-card-title><md-card-content \nng-click=\"vm.navigateToPerson(vm.baldrisModel)\"><div layout=\"row\"><div flex ng-if=\"vm.baldrisModel.dateOfBirth\"><label \nclass=\"md-caption\">{{\'PARTY.PERSON.DATE_OF_BIRTH\' | translate}}</label><p>\n{{vm.baldrisModel.dateOfBirth | date:\'shortDate\'}}</p></div><div flex ng-if=\"vm.baldrisModel.socialSecurityNumber\">\n<label class=\"md-caption\">{{\'PARTY.PERSON.SOCIAL_SECURITY_NUMBER\' | translate}}</label><p>\n{{vm.baldrisModel.socialSecurityNumber}}</p></div></div><div ng-if=\"vm.baldrisModel.dateOfDeath\"><label \nclass=\"md-caption\">{{\'PARTY.PERSON.DATE_OF_DEATH\' | translate}}</label><p>\n{{vm.baldrisModel.dateOfDeath | date:\'shortDate\'}}</p></div><div ng-if=\"vm.baldrisModel.addresses\" \nng-repeat=\"address in vm.baldrisModel.addresses | orderBy:\'sortOrder\'\"><label class=\"md-caption\">\n{{address.addressTypeName}}</label><p>{{address.addressSerialized}}</p></div><div ng-if=\"vm.baldrisModel.emails\" \nng-repeat=\"email in vm.baldrisModel.emails | orderBy:\'sortOrder\'\"><label class=\"md-caption\">{{email.emailTypeName}}\n</label><p>{{email.emailAddress}}</p></div><div ng-if=\"vm.baldrisModel.telephones\" \nng-repeat=\"telephone in vm.baldrisModel.telephones | orderBy:\'sortOrder\'\"><label class=\"md-caption\">\n{{telephone.telephoneTypeName}}</label><p>{{vm.getFormattedNumber(telephone)}}</p></div></md-card-content>\n<md-card-actions ng-hide=\"vm.disableLinks\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Edit\" ng-click=\"vm.navigateToPerson(vm.baldrisModel)\"><md-icon \nmd-font-icon=\"icon-tooltip-edit\"></md-icon></md-button><md-button class=\"md-icon-button md-warn\" aria-label=\"Delete\" \nng-click=\"vm.deleteDeceased(vm.baldrisModel)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/reference-types/party/components/ssn-input/ssn-input.tmpl.html","<div layout=\"row\" ng-form=\"vm.ssnForm\"><md-input-container flex class=\"md-block\"><label>\n{{ \"PARTY.PERSON.SOCIAL_SECURITY_NUMBER\" | translate }}</label><input name=\"socialSecurityNumber\" \nmd-maxlength=\"vm.ssnMaxLength\" type=\"{{ vm.showSsn ? \'text\' : \'password\' }}\" ng-model=\"vm.ssn\" \nng-disabled=\"vm.isDisabled || !vm.showSsn\" ng-required=\"vm.isRequired\" ng-change=\"vm.onSocialSecurityNumberChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"><div class=\"errors\" \nng-messages=\"vm.ssnForm.socialSecurityNumber.$error\" md-auto-hide=\"false\" multiple=\"true\"><div ng-message=\"invalidSSN\">\n<span translate=\"PARTY.EDIT_PARTY.INVALID_SSN\"></span></div><div ng-message=\"missingDateOfBirth\"><span \ntranslate=\"PARTY.EDIT_PARTY.MISSING_DATE_OF_BIRTH\"></span></div><div ng-message=\"sexMismatch\"><span \ntranslate=\"PARTY.EDIT_PARTY.SEX_MISMATCH\"></span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"PARTY.EDIT_PARTY.SSN_TOO_LONG\"></span></div></div></md-input-container><md-menu><md-button \naria-label=\"{{ \'COMMON.DATA.SHOW_MORE_OPTIONS\' | translate }}\" class=\"md-icon-button\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.showSsn = !vm.showSsn\"><md-icon \nmd-font-icon=\"{{ vm.showSsn ? \'icon-eye-off\' : \'icon-eye\' }}\"></md-icon>\n{{ (vm.showSsn ? \"PARTY.EDIT_PARTY.HIDE_SSN\" : \"PARTY.EDIT_PARTY.SHOW_SSN\") | translate }}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.toggleIgnoreValidation()\"><md-icon md-font-icon=\"icon-alert\"></md-icon>\n{{ \"PARTY.EDIT_PARTY.IGNORE_INVALID_SSN\" | translate }}</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/reference-types/party/dialogs/new-party-dialog/new-party-dialog.tmpl.html","<md-dialog class=\"new-party-dialog edit-dialog\" aria-label=\"New Party\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{\'PARTY.NEW_PARTY_DIALOG.TITLE\' | translate}}</span></div></md-toolbar><md-dialog-content \nlayout=\"column\"><div ng-if=\"!vm.party\" layout=\"column\"><p>{{ \'PARTY.NEW_PARTY_DIALOG.CHOOSE_PARTY_TYPE\' | translate}}\n</p><md-button aria-label=\"{{ \'PARTY.PERSON.PERSON\' | translate}}\" class=\"md-primary md-raised\" \nng-click=\"vm.onPartyTypeChange(\'PERSON\')\">{{ \'PARTY.PERSON.PERSON\' | translate}}</md-button><md-button \naria-label=\"{{ \'PARTY.ORGANIZATION.ORGANIZATION\' | translate}}\" class=\"md-primary md-raised\" \nng-click=\"vm.onPartyTypeChange(\'ORGANIZATION\')\">{{ \'PARTY.ORGANIZATION.ORGANIZATION\' | translate}}</md-button></div>\n<div ng-if=\"vm.party\" layout=\"column\"><edit-party baldris-model=\"vm.party\" show-death-date=\"true\"></edit-party>\n<many-to-many-select class=\"margin-bottom-30\" many-to-many-list=\"vm.party.partyTypes\" \nmany-to-many-name=\"PartyPartyTypeDto\" list-contains-only-foreign-keys=\"true\" reference-id=\"vm.party.id\" \nreference-id-name=\"partyId\" source-controller=\"PartyTypes\" source-id-name=\"id\" source-name=\"name\" target-id-name=\"id\" \ntarget-name=\"name\" label-text=\"{{\'PARTY.PARTY.PARTY_TYPES\' | translate}}\" \nplaceholder-text=\"{{\'PARTY.PARTY.PARTY_TYPES\' | translate}}\" is-required=\"true\"></many-to-many-select>\n<inline-address-list party-id=\"vm.party.id\" collection=\"vm.addresses\" is-single-entry=\"true\"></inline-address-list>\n<inline-email-list party-id=\"vm.party.id\" collection=\"vm.emails\" is-single-entry=\"true\"></inline-email-list>\n<inline-telephone-list party-id=\"vm.party.id\" collection=\"vm.telephones\" is-single-entry=\"true\">\n</inline-telephone-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \naria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button aria-label=\"Choose\" ng-disabled=\"!vm.party\" class=\"md-primary\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/party/dialogs/party-privacy-dialog/party-privacy-dialog.tmpl.html","<md-dialog class=\"party-privacy-dialog edit-dialog\" aria-label=\"Party Privacy Overview\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.TITLE\" | translate }}</span></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-gt-sm=\"row\"><div ng-if=\"!vm.isSaving\"><div \nng-if=\"vm.showNameInputs\" layout=\"column\" layout-gt-sm=\"row\" layout-padding><div flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block\"><label>{{ \"PARTY.PERSON.LASTNAME\" | translate }}</label><input ng-model=\"vm.partyDto.lastName\" \nng-change=\"vm.partyChanged()\"></md-input-container></div><div flex-gt-sm=\"50\"><md-input-container class=\"md-block\">\n<label>{{ \"PARTY.PERSON.FIRSTNAME\" | translate }}</label><input ng-model=\"vm.partyDto.firstName\" \nng-change=\"vm.partyChanged()\"></md-input-container></div></div><div ng-if=\"!vm.showNameInputs\" class=\"party-name\" \nlayout=\"row\" layout-align=\"start center\" layout-padding><md-icon md-font-icon=\"icon-shield-outline\" class=\"s48\">\n</md-icon><div flex><h3 class=\"md-title\">{{ vm.partyDto.displayName }} <span ng-if=\"vm.partyDto.dateOfBirth\">\n({{ vm.partyDto.dateOfBirth | date: \"ddMMyy\" }} <span ng-if=\"vm.partyDto.socialSecurityNumber\">\n{{ vm.partyDto.socialSecurityNumber }}</span>)</span></h3><p class=\"md-subhead\">\n{{ vm.partyDto.primaryAddress }}, {{ vm.partyDto.primaryEmail }}, {{ vm.partyDto.primaryTelephone }}<br>\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.PRIVACY_OPTIONS\" | translate }}</p></div></div><md-divider></md-divider><h3 \nclass=\"required-fields-title\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNEE_CONFIRMS\" | translate }}</h3><md-divider>\n</md-divider><div class=\"required-fields\" layout-padding><div class=\"privacy-field\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s48\"></md-icon><div flex><div \nclass=\"privacy-text\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.PERSONAL_INFORMATION\" | translate }}</div><div \nclass=\"privacy-description\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNEE_ACCEPTS_PERSONAL_INFORMATION\" | translate }}</div>\n</div></div><div ng-if=\"vm.isResponsibleForFuneral\" class=\"privacy-field\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-church\" class=\"s48\"></md-icon><div flex><div class=\"privacy-text\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.RESPONSIBLE_FOR_FUNERAL\" | translate }}</div><div class=\"privacy-description\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNEE_ACCEPTS_RESPONSIBILITY_FOR_FUNERAL\" | translate }}</div></div></div></div>\n<md-divider></md-divider><h3 class=\"required-fields-title\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.REQUIRED_FIELDS\" | translate }}</h3><md-divider></md-divider><div \nclass=\"required-fields\" ng-if=\"vm.requiredFields.length > 0\" layout-padding><div class=\"privacy-field\" \nng-repeat=\"privacyField in vm.requiredFields | orderBy:\'sortOrder\'\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-document\" class=\"s48\"></md-icon><div flex><div class=\"privacy-text\">{{ privacyField.text }}</div>\n<div class=\"privacy-description\">{{ privacyField.description }}</div></div></div></div><md-divider></md-divider><div \nng-if=\"vm.generalAttorneyFields.length > 0\"><h3 class=\"general-attorney-fields-title\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.GENERAL_ATTORNEY_FIELDS\" | translate }}</h3><md-divider></md-divider></div><div \nclass=\"general-attorney-fields\" ng-if=\"vm.generalAttorneyFields.length > 0\" layout-padding><p class=\"check-to-allow\">\n({{ \"PARTY.PARTY_PRIVACY_DIALOG.CHECK_TO_APPROVE\" | translate }})</p><div class=\"privacy-field\" \nng-repeat=\"privacyField in vm.generalAttorneyFields | orderBy:\'sortOrder\'\" layout=\"row\"><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"privacyField.value\" ng-change=\"vm.fieldChanged(privacyField)\" \nng-disabled=\"vm.isReadOnly\" aria-label=\"{{ privacyField.description }}\"><div><div class=\"privacy-text\">\n{{ privacyField.text }}</div><div class=\"privacy-legal-remarks\">{{ privacyField.legalRemarks }}</div><div \nclass=\"privacy-description\">{{ privacyField.description }}</div></div></md-checkbox></md-input-container></div></div>\n<md-divider></md-divider><div ng-if=\"vm.optionalFields.length > 0\"><h3 class=\"optional-fields-title\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.OPTIONAL_FIELDS\" | translate }}</h3><md-divider></md-divider></div><div \nclass=\"optional-fields\" ng-if=\"vm.optionalFields.length > 0\" layout-padding><p class=\"check-to-allow\">\n({{ \"PARTY.PARTY_PRIVACY_DIALOG.CHECK_TO_APPROVE\" | translate }})</p><div class=\"privacy-field\" \nng-repeat=\"privacyField in vm.optionalFields | orderBy:\'sortOrder\'\" layout=\"row\"><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"privacyField.value\" ng-change=\"vm.fieldChanged(privacyField)\" ng-disabled=\"vm.isReadOnly\" \naria-label=\"{{ privacyField.description }}\"><div><div class=\"privacy-text\">{{ privacyField.text }}</div><div \nclass=\"privacy-description\">{{ privacyField.description }}</div></div></md-checkbox></md-input-container></div></div>\n</div><div ng-if=\"!vm.isSaving && vm.isSigned\" layout=\"column\"><div class=\"signed-forms\" layout=\"column\"><md-tabs \nmd-center-tabs><md-tab label=\"{{ \'PARTY.PARTY_PRIVACY_DIALOG.CONSENT_FORM\' | translate }}\" \nng-click=\"vm.selectPdf(vm.getSignedConsentFileId())\"></md-tab><md-tab \nng-if=\"vm.hasApprovedLetterOfAttorneyFields() && vm.getSignedLetterOfAttorneyFileId()\" \nlabel=\"{{ \'PARTY.PARTY_PRIVACY_DIALOG.LETTER_OF_ATTORNEY_FORM\' | translate }}\" \nng-click=\"vm.selectPdf(vm.getSignedLetterOfAttorneyFileId())\"></md-tab></md-tabs><baldris-pdf-viewer \npdf-id=\"vm.selectedPdf\"></baldris-pdf-viewer></div></div><div ng-if=\"!vm.isSaving && !vm.isSigned\" layout-padding><div \nclass=\"print-options\" layout=\"column\"><h3 class=\"optional-fields-title\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.PREVIEW_FORM\" | translate }}</h3><md-divider></md-divider><md-input-container \nng-if=\"vm.hasApprovedLetterOfAttorneyFields()\" class=\"md-block\"><md-checkbox ng-model=\"vm.printLetterOfAttorneyForm\" \naria-label=\"Include Letter of Attorney Form\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.INCLUDE_LETTER_OF_ATTORNEY\" | translate }}\n</md-checkbox></md-input-container><md-button ng-disabled=\"vm.fieldsHaveChanges()\" aria-label=\"Print selected forms\" \nclass=\"md-block md-primary md-raised\" target=\"_blank\" ng-href=\"{{ vm.getPreviewUrl() }}\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.PREVIEW_SELECTED_FORMS\" | translate }}</md-button><p layout-padding \nclass=\"changes-must-be-saved\" ng-if=\"vm.fieldsHaveChanges()\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.CHANGES_MUST_BE_SAVED\" | translate }}</p></div><div ng-if=\"!vm.consignmentsActivated\" \nclass=\"signing-options\" layout=\"column\"><h3 class=\"optional-fields-title\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNING_OPTIONS\" | translate }}</h3><md-divider></md-divider><md-button \nng-disabled=\"vm.useUploadedFile\" aria-label=\"Use Signature Field\" class=\"md-block md-accent md-raised\" \nng-click=\"vm.openSignatureDialog($event)\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.USE_SIGNATURE_FIELD\" | translate }}\n</md-button><md-button ng-disabled=\"vm.signatureUrl\" aria-label=\"Upload signed consent form\" \nclass=\"md-block md-raised\" ngf-select=\"vm.uploadSignedConsentForm($file)\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.UPLOAD_SIGNED_CONSENT_FORM\" | translate }}</md-button><md-button \nng-disabled=\"vm.signatureUrl\" ng-if=\"vm.hasApprovedLetterOfAttorneyFields()\" \naria-label=\"Upload signed Letter of Attorney\" class=\"md-block md-raised\" \nngf-select=\"vm.uploadSignedLetterOfAttorney($file)\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.UPLOAD_SIGNED_LETTER_OF_ATTORNEY\" | translate }}</md-button></div><div \nng-if=\"vm.consignmentsActivated && vm.hasStarted\" class=\"signing-options\" layout=\"column\"><h3 \nclass=\"optional-fields-title\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNING_OPTIONS\" | translate }}</h3><md-divider>\n</md-divider><p>{{ \"PARTY.PARTY_PRIVACY_DIALOG.SIGNING_IS_CONDUCTED_BY_DIGITAL_SIGNING\" | translate }}</p><md-menu>\n<md-button aria-label=\"{{ \'PARTY.PARTY_PRIVACY_DIALOG.OTHER_SIGNING_METHODS\' | translate }}\" class=\"md-block\" \nng-click=\"vm.openSigningMethodMenu($mdMenu, $event)\">\n{{ \'PARTY.PARTY_PRIVACY_DIALOG.OTHER_SIGNING_METHODS\' | translate }}</md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-disabled=\"vm.useUploadedFile\" ng-click=\"vm.openSignatureDialog($event)\"><md-icon \nmd-font-icon=\"icon-pen\"></md-icon>{{ \"PARTY.PARTY_PRIVACY_DIALOG.USE_SIGNATURE_FIELD\" | translate }}</md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"vm.signatureUrl\" ngf-select=\"vm.uploadSignedConsentForm($file)\">\n<md-icon md-font-icon=\"icon-upload\"></md-icon>{{ \"PARTY.PARTY_PRIVACY_DIALOG.UPLOAD_SIGNED_CONSENT_FORM\" | translate }}\n</md-button></md-menu-item><md-menu-item ng-if=\"vm.hasApprovedLetterOfAttorneyFields()\"><md-button \nng-disabled=\"vm.signatureUrl\" ngf-select=\"vm.uploadSignedLetterOfAttorney($file)\"><md-icon md-font-icon=\"icon-upload\">\n</md-icon>{{ \"PARTY.PARTY_PRIVACY_DIALOG.UPLOAD_SIGNED_LETTER_OF_ATTORNEY\" | translate }}</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div ng-if=\"vm.readyToSave()\" class=\"ready-to-save\"><h3 \nclass=\"optional-fields-title\">{{ \"PARTY.PARTY_PRIVACY_DIALOG.READY_TO_SIGN\" | translate }}</h3><md-divider>\n</md-divider><p class=\"letter-of-attorney-missing\" \nng-if=\"vm.hasApprovedLetterOfAttorneyFields() && !vm.workOrderReferencePersonDto.signedLetterOfAttorneyFileId && !vm.signatureUrl\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.LETTER_OF_ATTORNEY_MISSING\" | translate }}</p><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.sendSignedCopy\" aria-label=\"Send copy to following recipients:\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.SEND_COPY_TO_FOLLOWING_RECIPIENTS\" | translate }}</md-checkbox></md-input-container>\n<transactional-email-address-list transactional-email-addresses=\"vm.sendSignedCopiesTo\">\n</transactional-email-address-list></div></div><div ng-if=\"vm.isSaving\" class=\"md-block\" layout-padding layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button aria-label=\"Cancel\" \nng-click=\"vm.closeDialog()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-if=\"!vm.isSigned\" \nng-disabled=\"vm.isSaving || !vm.fieldsHaveChanges()\" aria-label=\"Save temporary changes\" class=\"md-block md-raised\" \nng-class=\"vm.consignmentsActivated ? \'md-primary\' : \'md-accent\'\" ng-click=\"vm.saveTemporaryChanges($event)\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.SAVE_TEMPORARY_CHANGES\" | translate }}</md-button><md-button \nng-if=\"(!vm.isSigned && !vm.consignmentsActivated) || (!vm.isSigned && vm.consignmentsActivated && vm.readyToSave())\" \naria-label=\"Choose\" class=\"md-primary md-raised\" ng-disabled=\"!vm.readyToSave()\" ng-click=\"vm.saveAndCloseDialog()\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.ACCEPT_AND_SIGN\" | translate }}</md-button><md-button ng-if=\"vm.isSigned\" \naria-label=\"Retract consent\" class=\"md-warn md-raised\" ng-click=\"vm.retractConsent($event)\">\n{{ \"PARTY.PARTY_PRIVACY_DIALOG.RETRACT_CONSENT\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/party/dialogs/search-party-dialog/search-party-dialog.tmpl.html","<md-dialog class=\"search-party-dialog\" aria-label=\"Search Party\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{vm.getTitle() | translate}}</span></div></md-toolbar><md-dialog-content layout=\"column\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex class=\"party-type-list\"><md-list flex><div \nng-repeat=\"partyType in vm.partyTypes | orderBy:[\'sortOrder\',\'name\']\"><md-list-item \nng-click=\"vm.selectPartyType(partyType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': partyType.id == vm.selectedPartyType.id }\"><div class=\"md-list-item-text\" layout=\"column\">\n<h3>{{ partyType.name }}</h3><p>{{ partyType.description }}</p></div></md-list-item><md-divider ng-if=\"!$last\">\n</md-divider></div></md-list></div><div flex class=\"party-list\"><md-virtual-repeat-container><md-list flex><div \nng-if=\"vm.isSearching\" layout=\"row\" layout-padding layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div><div md-virtual-repeat=\"item in vm.searchResults\"><md-list-item \nng-click=\"vm.selectItem(item)\" class=\"md-3-line\" flex ng-class=\"{ \'md-accent-bg\': item.id == vm.selectedParty.id }\">\n<img ng-if=\"!item.image.filepath\" class=\"md-avatar\" gravatar-src=\"\'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"item.image.filepath\" class=\"md-avatar\" baldris-img-src=\"item.image.filepath\" preset=\"square-40-cropped\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.displayName }}</h3><h4><md-icon ng-show=\"item.primaryTelephone\" \nmd-font-icon=\"icon-phone\"></md-icon>{{ item.primaryTelephone}}<md-icon ng-show=\"item.primaryAddress\" \nmd-font-icon=\"icon-home\"></md-icon>{{ item.primaryAddress}}</h4><p><md-icon \nng-show=\"item.dateOfBirth || item.socialSecurityNumber\" md-font-icon=\"icon-cake\"></md-icon>\n{{ item.dateOfBirth | date:\'shortDate\' }} {{ item.socialSecurityNumber }}<md-icon ng-show=\"item.dateOfDeath\" \nmd-font-icon=\"icon-tag-text-outline\"></md-icon>{{ item.dateOfDeath | date:\'shortDate\' }} <span \nng-if=\"item.partyTypes && item.partyTypes.length > 0\">(<span ng-repeat=\"partyType in item.partyTypes\">\n{{ vm.getPartyTypeText(partyType) | translate }}<span ng-if=\"!$last\"> // </span></span>)</span></p></div>\n</md-list-item><md-divider ng-if=\"!$last\"></md-divider></div></md-list></md-virtual-repeat-container></div></div><div \nlayout-padding ng-if=\"!vm.showOnlyFromWorkOrder\"><md-input-container class=\"md-icon-float md-block\"><label>\n{{\'PARTY.SEARCH_PARTY_DIALOG.SEARCH\' | translate}}</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nmd-autofocus ng-model=\"vm.searchText\" type=\"text\" ng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"vm.allowAdditions\" aria-label=\"Choose\" \nng-click=\"vm.openAddPartyDialog($event)\">{{ \'PARTY.SEARCH_PARTY_DIALOG.ADD_NEW\' | translate}}</md-button><span flex>\n</span><md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-click=\"vm.closeDialog(vm.selectedParty)\">{{ \'PARTY.SEARCH_PARTY_DIALOG.CHOOSE\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/party/edit-party/views/sidebar.tmpl.html","<div class=\"contacts-sidebar edit-participant-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><baldris-audit title-text=\"vm.data.updateModel.party.displayName\" \naudit-model=\"vm.data.updateModel.party\"></baldris-audit><md-button ng-if=\"vm.data.updateModel.party.imageId\" \nclass=\"md-raised\" ng-click=\"vm.data.removeProfileImage()\">{{ \'PARTY.EDIT_PARTY.REMOVE_PROFILE_IMAGE\' | translate }}\n</md-button><md-button ng-if=\"!vm.data.updateModel.party.imageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.data.uploadProfileImage($file)\">{{ \'PARTY.EDIT_PARTY.UPLOAD_PROFILE_IMAGE\' | translate }}</md-button>\n<img ng-if=\"vm.data.updateModel.party.imageId\" baldris-img-src=\"vm.data.updateModel.party.imageFilepath\" \npreset=\"square-250-cropped\" alt=\"{{vm.data.updateModel.party.displayName}}\"></div></div>");
$templateCache.put("app/main/reference-types/party/edit-party/views/toolbar.tmpl.html","");
$templateCache.put("app/main/reference-types/state/components/state-select/state-select.tmpl.html","<div ng-form=\"vm.stateForm\" class=\"baldris-state-select\"><md-autocomplete flex md-no-cache=\"true\" \nng-disabled=\"vm.isDisabled\" md-input-name=\"state\" md-selected-item=\"vm.state\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-min-length=\"vm.minLength\" md-clear-button=\"true\" \nmd-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-state-select\"><md-item-template><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"name\" flex>{{item.name}}</div></div></md-item-template><div ng-messages=\"vm.stateForm.state.$error\" \nng-if=\"vm.stateForm.state.$touched\"><div ng-message=\"invalidState\"><span translate=\"STATES.STATE_SELECT.INVALID_STATE\" \ntranslate-values=\"{ state: vm.searchText }\"></span></div></div></md-autocomplete></div>");
$templateCache.put("app/main/reference-types/supplier/components/supplier-select/supplier-select.tmpl.html","<div ng-form=\"vm.supplierForm\" class=\"supplier-select\" layout=\"row\" layout-align=\"center center\"><md-autocomplete flex \nmd-input-name=\"supplier\" md-selected-item=\"vm.supplier\" md-search-text=\"vm.searchText\" \nmd-search-text-change=\"vm.searchTextChanged(vm.searchText)\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-clear-button=\"true\" md-item-text=\"item.partyName\" md-selected-item-change=\"vm.onSupplierChanged(item)\" \nmd-floating-label=\"{{vm.labelText}}\" md-min-length=\"vm.minLength\" md-menu-class=\"autocomplete-supplier-select\" \nng-disabled=\"vm.isDisabled\"><md-item-template>{{item.partyName}} <span ng-if=\"item.supplierTypeName\">\n({{item.supplierTypeName}})</span></md-item-template><div ng-messages=\"vm.supplierForm.supplier.$error\" \nng-if=\"vm.supplierForm.supplier.$touched\"><div ng-message=\"invalidSupplier\"><span \ntranslate=\"SUPPLIERS.SUPPLIER_SELECT.INVALID_SUPPLIER\" translate-values=\"{ supplier: vm.searchText }\"></span></div>\n</div></md-autocomplete><md-button class=\"md-icon-button search-button\" ng-click=\"vm.openSearchDialog($event)\" \naria-label=\"Search\" translate-attr-aria-label=\"COMMON.DATA.OPEN_SEARCH\" tabindex=\"-1\" \nng-disabled=\"vm.isDisabled || vm.disableSearch\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DATA.OPEN_SEARCH\"></span></md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div>");
$templateCache.put("app/main/reference-types/supplier/dialogs/search-supplier-dialog/search-supplier-dialog.tmpl.html","<md-dialog class=\"search-supplier-dialog\" aria-label=\"Search Supplier\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"title\">{{ \"SUPPLIERS.SUPPLIER_SELECT.SEARCH_SUPPLIER\" | translate }}</span></div></md-toolbar><md-dialog-content\n layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\"><div flex class=\"supplier-type-list\"><md-list flex><div \nng-repeat=\"supplierType in vm.supplierTypes | orderBy:[\'sortOrder\',\'name\']\"><md-list-item \nng-click=\"vm.selectSupplierType(supplierType)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': supplierType.id == vm.selectedSupplierType.id }\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{ supplierType.name }}</h3><p>{{ supplierType.description }}</p></div></md-list-item><md-divider \nng-if=\"!$last\"></md-divider></div></md-list></div><div flex class=\"supplier-list\"><md-virtual-repeat-container><md-list\n flex><div ng-if=\"vm.isSearching\" layout=\"row\" layout-padding layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nmd-virtual-repeat=\"item in vm.searchResults\"><md-list-item ng-click=\"vm.selectItem(item)\" class=\"md-2-line\" flex \nng-class=\"{ \'md-accent-bg\': item.id == vm.selectedSupplier.id }\"><img ng-if=\"!item.partyImageUrl\" class=\"md-avatar\" \ngravatar-src=\"item.partyPrimaryEmail || \'post@baldris.no\'\" gravatar-default=\"mm\"> <img ng-if=\"item.partyImageFilePath\" \nclass=\"md-avatar\" baldris-img-src=\"item.partyImageUrl\" preset=\"square-40-cropped\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{ item.partyName }}</h3><p>{{ item.supplierTypeName }}</p></div></md-list-item><md-divider \nng-if=\"!$last\"></md-divider></div></md-list></md-virtual-repeat-container></div></div><div layout-padding \nclass=\"margin-top-20\"><md-input-container class=\"md-icon-float md-block\"><label>\n{{ \"PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.SEARCH\" | translate }}</label><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><input md-autofocus ng-model=\"vm.searchText\" type=\"text\" ng-change=\"vm.onSearchChange()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-if=\"vm.allowAdditions\" aria-label=\"Choose\" \nng-click=\"vm.openAddSupplierDialog($event)\">{{ \"PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.ADD_NEW\" | translate }}\n</md-button><span flex></span><md-button aria-label=\"Cancel\" class=\"md-warn\" ng-click=\"vm.closeDialog()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button aria-label=\"Choose\" class=\"md-primary\" \nng-disabled=\"!vm.selectedSupplier\" ng-click=\"vm.closeDialog(vm.selectedSupplier)\">\n{{ \"PARTICIPANTS.SEARCH_PARTICIPANT_DIALOG.CHOOSE\" | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/supplier/edit-supplier/views/sidebar.tmpl.html","<div class=\"contacts-sidebar edit-participant-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><baldris-audit title-text=\"vm.data.updateModel.partyUpdateModel.party.displayName\" \naudit-model=\"vm.data.updateModel.supplier\"></baldris-audit><md-button \nng-if=\"vm.data.updateModel.partyUpdateModel.party.imageId\" class=\"md-raised\" ng-click=\"vm.data.removeProfileImage()\">\n{{ \'PARTY.EDIT_PARTY.REMOVE_PROFILE_IMAGE\' | translate }}</md-button><md-button \nng-if=\"!vm.data.updateModel.partyUpdateModel.party.imageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.data.uploadProfileImage($file)\">{{ \'PARTY.EDIT_PARTY.UPLOAD_PROFILE_IMAGE\' | translate }}</md-button>\n<img ng-if=\"vm.data.updateModel.partyUpdateModel.party.imageId\" \nbaldris-img-src=\"vm.data.updateModel.partyUpdateModel.party.imageFilepath\" preset=\"square-250-cropped\" \nalt=\"{{vm.data.updateModel.partyUpdateModel.party.displayName}}\"></div></div>");
$templateCache.put("app/main/reference-types/supplier/edit-supplier/views/toolbar.tmpl.html","");
$templateCache.put("app/main/reference-types/telephone/components/edit-telephone-dialog/edit-telephone-dialog.tmpl.html","<md-dialog class=\"edit-telephone-dialog edit-dialog\" aria-label=\"Edit Telephone\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{\'TELEPHONES.EDIT_TELEPHONE.EDIT_TELEPHONE\' | translate }}</span></div>\n</md-toolbar><md-dialog-content><div ng-form=\"vm.editTelephoneForm\" class=\"baldris-edit-telephone\" layout=\"column\">\n<md-input-container flex><label>{{\'TELEPHONES.TELEPHONE.TELEPHONE_NUMBER\' | translate }}<span \nng-hide=\"vm.telephone.telephoneNumber\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><input md-autofocus \nname=\"telephoneNumber\" ng-required=\"true\" ng-model=\"vm.telephone.telephoneNumber\" phone-number \ncountry-code=\"vm.selectedCountry.isoCode2 || \'NO\'\"><div class=\"errors\" \nng-messages=\"vm.editTelephoneForm.telephoneNumber.$error\" ng-if=\"vm.editTelephoneForm.$dirty\"><div \nng-message=\"required\"><span translate=\"TELEPHONES.EDIT_TELEPHONE.TELEPHONE_NUMBER_REQUIRED\"></span></div><div \nng-message=\"telephone\"><span translate=\"TELEPHONES.EDIT_TELEPHONE.INVALID_TELEPHONE\"></span></div></div>\n</md-input-container><telephone-type-select is-required=\"true\" telephone-type-id=\"vm.telephone.telephoneTypeId\" \ntelephone-type=\"vm.telephone.telephoneType\" label-text=\"{{\'TELEPHONES.TELEPHONE.TELEPHONE_TYPE\' | translate }}\">\n</telephone-type-select><country-select on-selected=\"vm.onCountryChange\" \nlabel-text=\"{{\'COUNTRIES.COUNTRY.COUNTRY\' | translate }}\" country-id=\"vm.selectedCountryId\" \ncountry=\"vm.selectedCountry\"></country-select></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button>\n<md-button ng-click=\"vm.saveAndCloseDialog()\" \nng-disabled=\"vm.editTelephoneForm.$pristine || vm.editTelephoneForm.$invalid\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/reference-types/telephone/components/inline-telephone-list/inline-telephone-list.tmpl.html","<div class=\"baldris-inline-telephone-list\" ng-form=\"vm.telephoneListForm\"><div layout=\"column\" \nclass=\"telephone-item default-telephone\"><div class=\"telephone-type\"><md-menu><md-button ng-disabled=\"vm.isDisabled\" \naria-label=\"Telephone Type\" class=\"telephone-type-select\" ng-click=\"vm.openTelephoneTypeMenu($mdMenu, $event)\"><md-icon\n md-menu-origin md-font-icon=\"{{ vm.getSelectedTelephoneType().iconName }}\"></md-icon>\n{{ vm.getSelectedTelephoneType().name }}<md-icon class=\"caret\" md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item ng-repeat=\"telephoneType in vm.telephoneTypes | orderBy:\'name\'\"><md-button \nng-click=\"vm.setTelephoneType(telephoneType)\"><md-icon md-font-icon=\"{{ telephoneType.iconName || \'icon-help\' }}\" \nmd-menu-align-target></md-icon>{{ telephoneType.name }}</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"telephone-input\" layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \"TELEPHONES.TELEPHONE.TELEPHONE_NUMBER\" | translate }}</label><input ng-disabled=\"vm.isDisabled\" type=\"telephone\" \nid=\"DefaultTelephoneNumber\" ng-model=\"vm.selectedTelephone.telephoneNumber\" \nng-change=\"vm.onTelephoneChanged(vm.selectedTelephone)\" name=\"telephoneNumber\" phone-number \ncountry-code=\"vm.selectedTelephone.isoCode2 || \'NO\'\"><div class=\"errors\" \nng-messages=\"vm.telephoneListForm.telephoneNumber.$error\"><div ng-message=\"required\"><span \ntranslate=\"TELEPHONES.EDIT_TELEPHONE.TELEPHONE_NUMBER_REQUIRED\"></span></div><div ng-message=\"phoneNumber\"><span \ntranslate=\"TELEPHONES.EDIT_TELEPHONE.INVALID_TELEPHONE\"></span></div></div></md-input-container></div>\n<country-iso2-select is-disabled=\"vm.isDisabled\" ng-if=\"vm.showMoreOptions\" iso2-code=\"vm.selectedTelephone.isoCode2\" \ncountry-id=\"vm.selectedTelephone.countryId\" country=\"vm.selectedTelephone.country\" \nlabel-text=\"{{ \'TELEPHONES.TELEPHONE.COUNTRY_CODE\' | translate }}\"></country-iso2-select><div \nng-if=\"vm.showMoreOptions\"><md-input-container class=\"md-block\"><label>\n{{ \"TELEPHONES.TELEPHONE.SORT_ORDER\" | translate }}</label><input ng-disabled=\"vm.isDisabled\" type=\"number\" step=\"1\" \nng-model=\"vm.selectedTelephone.sortOrder\" ng-change=\"vm.onTelephoneChanged(vm.selectedTelephone)\" \nng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div></div><md-button class=\"md-block\" \nng-click=\"vm.showMoreOptions = !vm.showMoreOptions\"><md-tooltip md-direction=\"up\">\n{{ vm.showMoreOptions ? (\"COMMON.DATA.SHOW_LESS_OPTIONS\" | translate) : (\"COMMON.DATA.SHOW_MORE_OPTIONS\" | translate) }}\n</md-tooltip><md-icon md-font-icon=\"{{ vm.showMoreOptions ? \'icon-menu-up\' : \'icon-menu-down\' }}\"></md-icon>\n</md-button></div><div layout=\"column\" ng-if=\"!vm.isSingleEntry\"><md-chips ng-disabled=\"vm.isDisabled\" tabindex=\"-1\" \nclass=\"telephone-chips\" ng-model=\"vm.collection\" readonly=\"true\" md-transform-chip=\"vm.newTelephoneChip($chip)\" \nmd-removable=\"false\" input-aria-label=\"Telephones\" md-on-select=\"vm.selectTelephone($chip)\"><md-chip-template \nclass=\"clickable\" ng-click=\"vm.selectTelephone($chip)\"><span ng-class=\"{ selected: $chip === vm.selectedTelephone }\">\n<strong>{{ $chip.telephoneNumber || \"~ N/A ~\" }}</strong><br><em>\n{{ $chip.telephoneTypeName || \"~ N/A ~\" }} {{ $chip.city }}</em><br></span><div class=\"md-chip-remove-container\">\n<button ng-disabled=\"vm.isDisabled\" tabindex=\"-1\" ng-click=\"vm.deleteTelephone($chip, $event)\" \nclass=\"md-primary telephone-remove\" aria-label=\"Remove {{ $chip.telephoneAddress }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></md-chip-template></md-chips><md-button \nng-disabled=\"vm.isDisabled\" ng-if=\"!vm.disableAdd\" tabindex=\"-1\" class=\"md-block\" \nng-click=\"vm.addNewTelephone($event)\">{{ \"TELEPHONES.TELEPHONE_LIST.ADD_EXTRA_TELEPHONE\" | translate }}</md-button>\n</div></div>");
$templateCache.put("app/main/reference-types/telephone/components/telephone-list/telephone-list.tmpl.html","<md-list class=\"baldris-telephone-list\" ng-form=\"vm.telephoneForm\"><md-subheader class=\"md-no-sticky\">\n{{ \'TELEPHONES.TELEPHONES\' | translate }}</md-subheader><md-list-item class=\"md-2-line\" \nng-click=\"vm.showEditTelephoneDialog(telephone, $event)\" ng-repeat=\"telephone in vm.collection | orderBy:\'sortOrder\'\">\n<md-icon class=\"md-avatar-icon\" md-font-icon=\"{{vm.getIconName(telephone)}}\"></md-icon><div class=\"md-list-item-text\">\n<h3 ng-class=\"{ \'text-strike\': telephone.changeState == 3 }\">{{ vm.getFormattedNumber(telephone) }}</h3><p \nng-class=\"{ \'text-strike\': telephone.changeState == 3 }\">\n{{ telephone.telephoneTypeName || telephone.telephoneType.name }}</p><p class=\"md-warn-fg\" \nng-show=\"telephone.changeState == 3\">{{\'TELEPHONES.TELEPHONE_LIST.DELETE_TEXT\' | translate}}</p></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.deleteOrUndo(telephone, $event)\"><md-tooltip md-direction=\"top\"><span \nng-if=\"telephone.changeState == 3\" translate=\"TELEPHONES.TELEPHONE_LIST.UNDO_DELETE\"></span> <span \nng-if=\"telephone.changeState != 3\" translate=\"TELEPHONES.TELEPHONE_LIST.DELETE_TELEPHONE\"></span></md-tooltip><md-icon \nng-if=\"telephone.changeState == 3\" md-font-icon=\"icon-undo\"></md-icon><md-icon ng-if=\"telephone.changeState != 3\" \nmd-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item><md-list-item class=\"md-2-line\" \nng-click=\"vm.addNewTelephone($event)\"><md-icon class=\"md-avatar-icon\" md-font-icon=\"icon-plus\"></md-icon><div \nclass=\"md-list-item-text\"><h3>{{\'TELEPHONES.TELEPHONE_LIST.ADD_NEW_TELEPHONE\' | translate}}</h3><p>\n{{\'TELEPHONES.TELEPHONE_LIST.NEW_TELEPHONE\' | translate}}</p></div></md-list-item></md-list>");
$templateCache.put("app/main/reference-types/telephone/components/telephone-type-select/telephone-type-select.tmpl.html","<md-input-container ng-form=\"vm.telephoneTypeForm\" class=\"md-block\"><label>{{vm.labelText}}<span \nng-show=\"vm.isRequired || !vm.telephoneType\"> {{\'COMMON.VALIDATION.REQUIRED\' | translate}}</span></label><md-select \nname=\"telephoneType\" ng-model=\"vm.telephoneTypeId\" ng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option \nng-repeat=\"currentTelephoneType in vm.telephoneTypes | orderBy:\'name\'\" ng-value=\"currentTelephoneType.id\">\n{{currentTelephoneType.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"vm.telephoneTypeForm.telephoneType.$error\" ng-if=\"vm.telephoneTypeForm.telephoneType.$dirty\"><div \nng-message=\"required\"><span translate=\"TELEPHONES.EDIT_TELEPHONE.TELEPHONE_TYPE_REQUIRED\"></span></div></div>\n</md-input-container>");
$templateCache.put("app/main/reference-types/urn/components/urn-select/urn-select.tmpl.html","<div ng-form=\"vm.urnForm\" class=\"baldris-urn-select\"><md-autocomplete flex md-min-length=\"vm.minLength\" \nmd-input-name=\"urn\" md-selected-item=\"vm.urn\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-floating-label=\"{{vm.labelText}}\" \nmd-menu-class=\"autocomplete-urn-select\" md-clear-button=\"true\" ng-disabled=\"vm.isDisabled\"><md-item-template><div><img \nclass=\"urn-image\" ng-if=\"item.imageFilePath\" baldris-img-src=\"item.imageFilePath\" preset=\"square-40-cropped\" \nalt=\"{{item.name}}\"> <span class=\"urn-icon\" ng-if=\"!item.imageFilePath\"><md-icon md-font-icon=\"icon-archive\"></md-icon>\n</span>{{item.name}} <span class=\"urn-type\">{{ vm.getType(item) }}</span></div></md-item-template><div \nng-messages=\"vm.urnForm.urn.$error\" ng-if=\"vm.urnForm.urn.$touched\"><div ng-message=\"invalidUrn\"><span \ntranslate=\"URNS.URN_SELECT.INVALID_URN\" translate-values=\"{ urn: vm.searchText }\"></span></div></div></md-autocomplete>\n</div>");
$templateCache.put("app/main/reference-types/work-order-type/components/work-order-type-multi-select/work-order-type-multi-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{ vm.labelText }}</label><md-select ng-model=\"vm.workOrderTypeIds\" \nng-change=\"vm.onChange()\" multiple=\"true\"><md-option \nng-repeat=\"workOrderType in vm.availabelWorkOrderTypes | orderBy:\'name\'\" ng-value=\"workOrderType.id\">\n{{ workOrderType.name }}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/reference-types/work-order-type/components/work-order-type-select/work-order-type-select.tmpl.html","<md-input-container class=\"md-block\"><label>{{vm.labelText}}</label><md-select ng-model=\"vm.workOrderTypeId\" \nng-required=\"vm.isRequired\" ng-change=\"vm.onChange()\"><md-option ng-value=\"null\" md-option-empty \nng-if=\"!vm.isRequired\"><em>{{ \'WORK_ORDERS.WORK_ORDER_TYPE.NONE\' | translate }}</em></md-option><md-option \nng-repeat=\"workOrderType in vm.workOrderTypes | orderBy:\'name\'\" ng-value=\"workOrderType.id\">{{workOrderType.name}}\n</md-option></md-select></md-input-container>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/edit-baldris-config.tmpl.html","<div ng-if=\"!vm.isLoading\" layout=\"row\" ng-form=\"vm.editCustomFieldForm\" ng-include=\"vm.templateUrl\"></div>");
$templateCache.put("app/main/settings/configuration/consignments/general-settings/consignments-general-settings.tmpl.html","<div class=\"consignments-genaral-settings edit-page\" ng-if=\"!vm.loadingService.isLoading\"><div layout-padding \nlayout=\"column\" ng-form=\"vm.generalSettingsForm\"><h1>\n{{ \'SETTINGS.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_SETTINGS\' | translate }} <span ng-if=\"vm.generalSettingsForm.$dirty\">*\n</span></h1><div layout=\"column\" layout-gt-xs=\"row\"><signature-authentication></signature-authentication><div \nlayout=\"column\" flex-gt-xs><div class=\"consignments\" \nng-class=\"vm.consignmentsActivated ? \'activated\': \'not-activated\'\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"{{ vm.consignmentsActivated ? \'icon-checkbox-marked\' : \'icon-close-circle\'}}\" class=\"icon\">\n</md-icon><span flex class=\"info-text md-title\">\n{{ vm.consignmentsActivated ? \'SETTINGS.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_ACTIVATED\' : \'SETTINGS.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_NOT_ACTIVATED\' | translate }}\n</span></div><md-button class=\"mt-10 md-raised md-primary\" ng-click=\"vm.toggleConsignments()\" \nng-disabled=\"!vm.isExternalServiceAuthenticated()\">\n{{ vm.consignmentsActivated ? \'SETTINGS.CONSIGNMENTS_SETTINGS.DEACTIVATE_CONSIGNMENTS\' : \'SETTINGS.CONSIGNMENTS_SETTINGS.ACTIVATE_CONSIGNMENTS\' | translate}}\n</md-button></div><div ng-if=\"vm.consignmentsActivated\" class=\"webhooks mt-16\" \nng-class=\"vm.webhooksActivated ? \'activated\': \'not-activated\'\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{ vm.webhooksActivated ? \'icon-checkbox-marked\' : \'icon-close-circle\'}}\" class=\"icon\"></md-icon><span \nng-if=\"vm.webhooksActivated\" flex class=\"info-text md-title\" \ntranslate=\"SETTINGS.CONSIGNMENTS_SETTINGS.WEBHOOKS_ARE_CONFIGURED\" \ntranslate-values=\"{ webhookamount: vm.webHooksCount }\">Webhooks are configured </span><span \nng-if=\"!vm.webhooksActivated\" flex class=\"info-text md-title\" \ntranslate=\"SETTINGS.CONSIGNMENTS_SETTINGS.WEBHOOKS_NOT_CONFIGURED\">There\'s no webhooks configured</span></div>\n<md-button ng-if=\"vm.webHooksCount === 0\" class=\"mt-10 md-raised md-primary\" ng-click=\"vm.createWebhooks()\" \nng-disabled=\"!vm.isExternalServiceAuthenticated()\">{{ \'SETTINGS.CONSIGNMENTS_SETTINGS.CONFIGURE_WEBHOOKS\' | translate}}\n</md-button></div></div></div></div></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/consignments/partials/consignments-config-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">\n{{ \"MENU.CONFIGURATION.CONSIGNMENTS_SETTINGS.CONSIGNMENTS_SETTINGS\" | translate }}</span></div><md-divider>\n</md-divider><div ms-scroll class=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\">\n<md-list><md-list-item ui-sref-active=\"selected md-accent-bg\" \nui-sref=\"app.configuration.consignmentsSettings.generalSettings\"><p><md-icon md-font-icon=\"icon-pen\" class=\"s24\">\n</md-icon>{{ \"MENU.CONFIGURATION.CONSIGNMENTS_SETTINGS.GENERAL_SETTINGS\" | translate }}</p></md-list-item></md-list>\n</div></div>");
$templateCache.put("app/main/settings/configuration/contacts/contact-list/contact-list.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list class=\"contact-list\" md-whiteframe=\"1\"><md-list-item \nclass=\"md-3-line\" ng-repeat-start=\"contact in vm.contacts | filter:{ displayName: vm.data.searchString}\" \nng-click=\"vm.editContact(contact)\"><img ng-if=\"!contact.imageFilepath\" class=\"md-avatar\" \ngravatar-src=\"contact.primaryEmailAddress || \'post@baldris.no\'\" gravatar-default=\"mm\"> <img \nng-if=\"contact.imageFilepath\" class=\"md-avatar\" alt=\"contact.displayName\" baldris-img-src=\"contact.imageFilepath\" \npreset=\"square-40-cropped\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ contact.displayName }}</h3><h4>\n<md-icon ng-show=\"contact.primaryTelephoneNumber\" md-font-icon=\"icon-phone\"></md-icon>\n{{ ::contact.primaryTelephoneNumber}}<md-icon ng-show=\"contact.primaryAddress\" md-font-icon=\"icon-home\"></md-icon>\n{{ ::contact.primaryAddress}}</h4><p><md-icon ng-show=\"contact.primaryEmailAddress\" md-font-icon=\"icon-email\">\n</md-icon>{{ ::contact.primaryEmailAddress }}</p></div></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\">\n</md-divider></md-list></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/contacts/partials/contacts-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.CONFIGURATION.CONTACTS.CONTACT_REGISTRY\" | translate }}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.configuration.contacts.contactList({ internalType: contactType.internalType, internalTypeId: contactType.id, contactType: contactType })\" \nng-class=\"{ \'selected\': contactType.id === vm.data.selectedContactType.id, \'md-accent-bg\': contactType.id === vm.data.selectedContactType.id }\" \nng-repeat=\"contactType in vm.contactTypes | orderBy:\'name\'\"><p><md-icon \nmd-font-icon=\"{{ contactType.iconName || \'icon-format-list-bulleted\' }}\" class=\"s24\"></md-icon>{{ contactType.name }}\n</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/contacts/partials/contacts-toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><div flex><md-input-container md-no-float \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-search\"></md-icon><input \nng-model=\"vm.data.searchString\" type=\"text\" \nplaceholder=\"{{ \'MENU.CONFIGURATION.CONTACTS.SEARCH_CONTACTS\' | translate }}\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 300, \'blur\': 0 } }\"></md-input-container></div>\n</div></md-toolbar>");
$templateCache.put("app/main/settings/configuration/customers/customer-list/customer-list.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list class=\"customer-list\" md-whiteframe=\"1\"><md-list-item \nclass=\"md-3-line\" ng-repeat-start=\"customer in vm.customers\" ng-click=\"vm.editCustomer(customer)\"><md-icon \nng-if=\"!customer.partyImageFilepath\" class=\"md-avatar-icon\" md-font-icon=\"icon-account\"></md-icon><img \nng-if=\"customer.partyImageFilepath\" class=\"md-avatar\" baldris-img-src=\"customer.partyImageFilepath\" \npreset=\"square-40-cropped\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ ::customer.partyDisplayName }} – {{ ::customer.customerNumber }}</h3><h4><md-icon \nng-show=\"customer.partyPrimaryTelephone\" md-font-icon=\"icon-phone\"></md-icon>{{ ::customer.partyPrimaryTelephone}}\n<md-icon ng-show=\"customer.billingAddressSerialized\" md-font-icon=\"icon-home\"></md-icon>\n{{ ::customer.billingAddressSerialized}}</h4><p><md-icon ng-show=\"customer.partyPrimaryEmail\" \nmd-font-icon=\"icon-email\"></md-icon>{{ ::customer.partyPrimaryEmail }}</p></div></md-list-item><md-divider \nng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/customers/partials/customers-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.CONFIGURATION.CONTACTS.CONTACT_REGISTRY\" | translate }}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.configuration.customers.customerList({ searchString: letter })\" \nng-class=\"{ \'selected\': letter === vm.data.searchString, \'md-accent-bg\': letter === vm.data.searchString }\" \nng-repeat=\"letter in vm.alphabet | orderBy:\'name\'\"><p>{{ letter }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/customers/partials/customers-toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><div flex><md-input-container md-no-float \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-account-search\"></md-icon><input md-autofocus \nng-model=\"vm.searchString\" type=\"text\" placeholder=\"{{ \'MENU.CONFIGURATION.CUSTOMERS.SEARCH_CUSTOMERS\' | translate }}\" \nng-change=\"vm.search()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 } }\">\n</md-input-container></div></div></md-toolbar>");
$templateCache.put("app/main/settings/configuration/departments/department-list/department-list.tmpl.html","<department-list departments=\"vm.currentDepartments\" can-add=\"true\" can-edit=\"true\" on-edit=\"vm.editDepartment(value)\" \non-add=\"vm.addDepartment()\"></department-list>");
$templateCache.put("app/main/settings/configuration/departments/edit-department/edit-department.tmpl.html","<div id=\"edit-department\"><div class=\"header\" ng-style=\"vm.getBackgroundImage()\"><div class=\"department-info\"><div \nclass=\"logo\"><img ng-if=\"vm.department.alternativeLogoFilepath\" \nbaldris-img-src=\"vm.department.alternativeLogoFilepath\" preset=\"square-150-padded\"> <img \nng-if=\"!vm.department.alternativeLogoFilepath && vm.department.logoFilepath\" \nbaldris-img-src=\"vm.department.logoFilepath\" preset=\"square-150-padded\"><md-icon \nng-if=\"!vm.department.logoFilepath && !vm.department.alternativeLogoFilepath\" class=\"s150\" md-font-icon=\"icon-store\">\n</md-icon></div><div class=\"organization-name\"><h2 class=\"md-title\">{{ vm.organization.displayName}}</h2><h3 \nclass=\"md-subhead\">{{ vm.department.postAddressLocalizedAddress }}</h3></div></div></div><div class=\"editable-content\" \nng-form=\"vm.editableContentForm\" layout=\"column\" layout-gt-md=\"row\"><div class=\"department\" flex-gt-md=\"66\">\n<edit-department department=\"vm.department\" organization=\"vm.organization\" on-change=\"vm.onDepartmentChanged(value)\" \non-submit=\"vm.submitDepartment(department, organization)\" is-disabled=\"vm.loadingService.isLoading\"></edit-department>\n</div><div class=\"addresses emails telephones md-primary-bg md-hue-1\" layout-padding flex-gt-md=\"33\"><h5 \nclass=\"md-title\">{{\'DEPARTMENTS.DEPARTMENT.POST_ADDRESS\' | translate}}</h5><inline-address-list ng-if=\"vm.initialized\" \ncollection=\"vm.postAddress\" party-id=\"vm.organization.id\" disable-add=\"true\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-address-list><h5 class=\"md-title\">\n{{\'LOCATIONS.LOCATION.STREET_ADDRESS\' | translate}}</h5><inline-address-list ng-if=\"vm.initialized\" \ncollection=\"vm.streetAddress\" party-id=\"vm.organization.id\" disable-add=\"true\" \nis-disabled=\"vm.loadingService.isLoading\" on-update=\"vm.onAddressChanged(action, value)\"></inline-address-list><h5 \nclass=\"md-title\">{{\'PARTY.PARTY.EMAILS\' | translate}}</h5><inline-email-list ng-if=\"vm.initialized\" \ncollection=\"vm.updateModel.emails\" party-id=\"vm.organization.id\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-email-list><h5 class=\"md-title\">\n{{\'PARTY.PARTY.TELEPHONES\' | translate}}</h5><inline-telephone-list ng-if=\"vm.initialized\" \ncollection=\"vm.updateModel.telephones\" party-id=\"vm.organization.id\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-telephone-list></div></div></div>");
$templateCache.put("app/main/settings/configuration/departments/edit-legal-unit/edit-legal-unit.tmpl.html","<div id=\"edit-legal-unit\"><div class=\"header\" ng-style=\"vm.getBackgroundImage()\"><div class=\"legal-unit-info\"><div \nclass=\"logo\"><img ng-if=\"vm.legalUnit.alternativeLogoFilepath\" baldris-img-src=\"vm.legalUnit.alternativeLogoFilepath\" \npreset=\"square-150-padded\"> <img ng-if=\"!vm.legalUnit.alternativeLogoFilepath && vm.legalUnit.logoFilepath\" \nbaldris-img-src=\"vm.legalUnit.logoFilepath\" preset=\"square-150-padded\"><md-icon \nng-if=\"!vm.legalUnit.logoFilepath && !vm.legalUnit.alternativeLogoFilepath\" class=\"s150\" md-font-icon=\"icon-store\">\n</md-icon></div><div class=\"organization-name\"><h2 class=\"md-title\">{{ vm.organization.displayName}}</h2><h3 \nclass=\"md-subhead\">{{ vm.legalUnit.postAddressLocalizedAddress }}</h3></div></div></div><div class=\"editable-content\" \nng-form=\"vm.editableContentForm\" layout=\"column\" layout-gt-md=\"row\"><div class=\"legal-unit\" flex-gt-md=\"66\">\n<edit-legal-unit legal-unit=\"vm.legalUnit\" organization=\"vm.organization\" on-change=\"vm.onLegalUnitChanged(value)\" \non-submit=\"vm.submitLegalUnit(legalUnit, organization)\" is-disabled=\"vm.loadingService.isLoading\"></edit-legal-unit>\n</div><div class=\"addresses emails telephones md-primary-bg md-hue-1\" layout-padding flex-gt-md=\"33\"><h5 \nclass=\"md-title\">{{\'DEPARTMENTS.DEPARTMENT.POST_ADDRESS\' | translate}}</h5><inline-address-list ng-if=\"vm.initialized\" \ncollection=\"vm.postAddress\" party-id=\"vm.organization.id\" disable-add=\"true\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-address-list><h5 class=\"md-title\">\n{{\'LOCATIONS.LOCATION.STREET_ADDRESS\' | translate}}</h5><inline-address-list ng-if=\"vm.initialized\" \ncollection=\"vm.streetAddress\" party-id=\"vm.organization.id\" disable-add=\"true\" \nis-disabled=\"vm.loadingService.isLoading\" on-update=\"vm.onAddressChanged(action, value)\"></inline-address-list><h5 \nclass=\"md-title\">{{\'PARTY.PARTY.EMAILS\' | translate}}</h5><inline-email-list ng-if=\"vm.initialized\" \ncollection=\"vm.updateModel.emails\" party-id=\"vm.organization.id\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-email-list><h5 class=\"md-title\">\n{{\'PARTY.PARTY.TELEPHONES\' | translate}}</h5><inline-telephone-list ng-if=\"vm.initialized\" \ncollection=\"vm.updateModel.telephones\" party-id=\"vm.organization.id\" is-disabled=\"vm.loadingService.isLoading\" \non-update=\"vm.onAddressChanged(action, value)\"></inline-telephone-list></div></div></div>");
$templateCache.put("app/main/settings/configuration/invoice-settings/general-settings/invoice-general-settings.tmpl.html","<div class=\"edit-page\" ng-if=\"!vm.loadingService.isLoading\"><div layout-padding layout=\"column\" \nng-form=\"vm.generalSettingsForm\"><h1>{{ \"MENU.CONFIGURATION.INVOICE_SETTINGS.GENERAL_SETTINGS\" | translate }} <span \nng-if=\"vm.generalSettingsForm.$dirty\">*</span></h1><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"!vm.loadingService.isLoading\"><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'InvoiceDueFee\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceDueFee\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceDueFee\'] | translate }}\" is-currency=\"vm.isCurrencyMap[\'InvoiceDueFee\']\">\n</edit-baldris-config></div><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'InvoiceDueInterest\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceDueInterest\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceDueInterest\'] | translate }}\" \nis-currency=\"vm.isCurrencyMap[\'InvoiceDueInterest\']\"></edit-baldris-config></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.loadingService.isLoading\"><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'InvoiceTermsText\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceTermsText\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceTermsText\'] | translate }}\" is-currency=\"vm.isCurrencyMap[\'InvoiceTermsText\']\">\n</edit-baldris-config></div><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'InvoiceDueOffset\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceDueOffset\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceDueOffset\'] | translate }}\" is-currency=\"vm.isCurrencyMap[\'InvoiceDueOffset\']\">\n</edit-baldris-config></div></div><div layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'UseInvoiceIdentificationSystem\')\" \ncustom-field-data=\"vm.getConfigByName(\'UseInvoiceIdentificationSystem\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'UseInvoiceIdentificationSystem\'] | translate }}\" \nis-currency=\"vm.isCurrencyMap[\'UseInvoiceIdentificationSystem\']\"></edit-baldris-config></div><div layout=\"column\" \nng-if=\"!vm.loadingService.isLoading && vm.getConfigByName(\'InvoiceIdentificationConfigOrder\').customFieldData\">\n<md-input-container><label>{{ vm.labelTextMap[\"InvoiceIdentificationConfigOrder\"] | translate }}</label><md-select \nng-model=\"vm.getConfigByName(\'InvoiceIdentificationConfigOrder\').customFieldData.longData\" \nng-change=\"vm.onValueChanged(vm.getConfigByName(\'InvoiceIdentificationConfigOrder\'))\"><md-option ng-value=\"1\">\n{{ \"SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CONFIG_ORDER_INVOICE_CUSTOMER\" | translate }}</md-option><md-option \nng-value=\"2\">{{ \"SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CONFIG_ORDER_CUSTOMER_INVOICE\" | translate }}</md-option>\n<md-option ng-value=\"3\">{{ \"SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CONFIG_ORDER_INVOICE\" | translate }}</md-option>\n<md-option ng-value=\"4\">{{ \"SETTINGS.INVOICE_SETTINGS.GENERAL_SETTINGS.CONFIG_ORDER_CUSTOMER\" | translate }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"!vm.loadingService.isLoading\"><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'InvoiceIdentificationCustomerLength\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceIdentificationCustomerLength\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceIdentificationCustomerLength\'] | translate }}\" \nis-currency=\"vm.isCurrencyMap[\'InvoiceIdentificationCustomerLength\']\"></edit-baldris-config></div><div flex-gt-sm=\"50\">\n<edit-baldris-config baldris-config=\"vm.getConfigByName(\'InvoiceIdentificationInvoiceLength\')\" \ncustom-field-data=\"vm.getConfigByName(\'InvoiceIdentificationInvoiceLength\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'InvoiceIdentificationInvoiceLength\'] | translate }}\" \nis-currency=\"vm.isCurrencyMap[\'InvoiceIdentificationInvoiceLength\']\"></edit-baldris-config></div></div><div \nlayout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'UseYearPrefix\')\" \ncustom-field-data=\"vm.getConfigByName(\'UseYearPrefix\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'UseYearPrefix\'] | translate }}\" is-currency=\"vm.isCurrencyMap[\'UseYearPrefix\']\">\n</edit-baldris-config></div><div layout=\"column\" ng-if=\"!vm.loadingService.isLoading\"><md-input-container><label>\n{{ vm.labelTextMap[\"InvoiceJournalWriter\"] | translate }}</label><md-select \nng-model=\"vm.getConfigByName(\'InvoiceJournalWriter\').customFieldData.stringData\" \nng-change=\"vm.onValueChanged(vm.getConfigByName(\'InvoiceJournalWriter\'))\"><md-option \nng-repeat=\"exportFileType in vm.exportFileTypes\" ng-value=\"exportFileType.value\">{{ exportFileType.text | translate }}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-padding><md-button \nng-click=\"vm.saveView()\" ng-disabled=\"vm.generalSettingsForm.$pristine\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></div></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/invoice-settings/partials/invoice-settings-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">\n{{ \"MENU.CONFIGURATION.INVOICE_SETTINGS.INVOICE_SETTINGS\" | translate }}</span></div><md-divider></md-divider><div \nms-scroll class=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list>\n<md-list-item ui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.invoiceSettings.generalSettings\"><p>\n<md-icon md-font-icon=\"icon-bank\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.INVOICE_SETTINGS.GENERAL_SETTINGS\" | translate }}</p></md-list-item><md-list-item \nui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.invoiceSettings.multiChannelSettings\"><p><md-icon \nmd-font-icon=\"icon-credit-card-multiple\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.INVOICE_SETTINGS.MULTI_CHANNEL_SETTINGS\" | translate }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/invoice-settings/transfer-settings/invoice-transfer-settings.tmpl.html","<div class=\"edit-page invoice-transfer-settings\" ng-if=\"!vm.loadingService.isLoading\"><div layout-padding \nlayout=\"column\" ng-form=\"vm.tranferSettingsForm\"><h1>\n{{ \"MENU.CONFIGURATION.INVOICE_SETTINGS.MULTI_CHANNEL_SETTINGS\" | translate }} <span \nng-if=\"vm.generalSettingsForm.$dirty\">*</span></h1><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"!vm.loadingService.isLoading\"><div flex-gt-sm=\"50\"><edit-baldris-config \nbaldris-config=\"vm.getConfigByName(\'AllowPaidTrackableEmails\')\" \ncustom-field-data=\"vm.getConfigByName(\'AllowPaidTrackableEmails\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'AllowPaidTrackableEmails\'] | translate }}\"></edit-baldris-config></div><div \nflex-gt-sm=\"50\"><edit-baldris-config baldris-config=\"vm.getConfigByName(\'AllowPaidMultiChannel\')\" \ncustom-field-data=\"vm.getConfigByName(\'AllowPaidMultiChannel\').customFieldData\" \nlabel-text=\"{{ vm.labelTextMap[\'AllowPaidMultiChannel\'] | translate }}\" \nis-currency=\"vm.isCurrencyMap[\'AllowPaidMultiChannel\']\"></edit-baldris-config></div></div><p class=\"info\">\n{{ \"SETTINGS.INVOICE_SETTINGS.TRANSFER_SETTINGS.PAID_INFO\" | translate }}</p></div><div layout=\"row\" layout-padding>\n<md-button ng-click=\"vm.saveView()\" ng-disabled=\"vm.generalSettingsForm.$pristine\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></div></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/locations/location-list/location-list.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list class=\"contact-list\" md-whiteframe=\"1\"><md-list-item \nclass=\"md-3-line\" ng-repeat-start=\"location in vm.locations | filter:{ name: vm.data.searchString}\" \nng-click=\"vm.editLocation(location)\"><md-icon ng-if=\"!location.imageFilepath\" class=\"md-avatar-icon\" \nmd-font-icon=\"icon-home-modern\"></md-icon><img ng-if=\"location.imageFilepath\" class=\"md-avatar\" \nbaldris-img-src=\"location.imageFilepath\" preset=\"square-40-cropped\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ location.name }}</h3><h4><md-icon ng-show=\"location.addressSerialized\" md-font-icon=\"icon-home\"></md-icon>\n{{ ::location.addressSerialized}}</h4><p>{{ ::location.locationTypes }}</p></div></md-list-item><md-divider \nng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/locations/partials/location-config-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"MENU.CONFIGURATION.LOCATIONS.LOCATION_REGISTRY\" | translate }}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nui-sref=\"app.configuration.locations.locationList({ locationTypeId: locationType.id, locationType: locationType })\" \nng-class=\"{ \'selected\': locationType.id === vm.data.selectedLocationType.id, \'md-accent-bg\': locationType.id === vm.data.selectedLocationType.id }\" \nng-repeat=\"locationType in vm.locationTypes | orderBy:\'name\'\"><p><md-icon \nmd-font-icon=\"{{ locationType.iconName || \'icon-map-marker\' }}\" class=\"s24\"></md-icon>{{ locationType.name }}</p>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/locations/partials/location-config-toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><div flex><md-input-container md-no-float \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><input \nng-model=\"vm.data.searchString\" type=\"text\" \nplaceholder=\"{{ \'MENU.CONFIGURATION.LOCATIONS.SEARCH_LOCATIONS\' | translate }}\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\"></md-input-container></div>\n</div></md-toolbar>");
$templateCache.put("app/main/settings/configuration/program-settings/partials/program-settings-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">\n{{ \"MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_SETTINGS\" | translate }}</span></div><md-divider></md-divider><div \nms-scroll class=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list>\n<md-list-item ui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.programSettings.programTypes\"><p>\n<md-icon md-font-icon=\"icon-book\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_TYPES\" | translate }}</p></md-list-item><md-list-item \nui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.programSettings.programSlots\"><p><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_SLOTS\" | translate }}</p></md-list-item><md-list-item \nui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.programSettings.styles\"><p><md-icon \nmd-font-icon=\"icon-format-text\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.PROGRAM_SETTINGS.PROGRAM_STYLES\" | translate }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/program-settings/program-slots/program-slots.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list class=\"program-slots\"><md-list-item \nng-repeat-start=\"programSlot in vm.programSlots | orderBy:\'sortOrder\'\" \nui-sref=\"app.configuration.programSettings.programSlotById({ programSlotId: programSlot.id })\" class=\"md-3-line\">\n<md-icon md-font-icon=\"{{vm.getSlotIcon(programSlot)}}\" class=\"md-avatar-icon\" \nng-class=\"{ \'is-deleted\': programSlot.isDeleted}\"></md-icon><div class=\"md-list-item-text\" layout=\"column\" \nng-class=\"{ \'is-deleted\': programSlot.isDeleted}\"><h3>{{ programSlot.title || programSlot.name }}</h3><h4>\n{{ vm.getDataTypeText(programSlot) | translate }}</h4><p>\n{{ (programSlot.shouldBeVisibleInPrint ? \"PROGRAMS.PROGRAM_SLOT_ELEMENT.WILL_BE_VISIBLE_IN_PRINT\" : \"PROGRAMS.PROGRAM_SLOT_ELEMENT.WILL_NOT_BE_VISIBLE_IN_PRINT\") | translate }}\n</p></div></md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" layout-padding><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-program-slot-button\" aria-label=\"add contact\" \nui-sref=\"app.configuration.programSettings.programSlotById({ programSlotId: \'new\' })\" translate \ntranslate-attr-aria-label=\"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_SLOT.ADD_PROGRAM_SLOT\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/settings/configuration/program-settings/program-styles/program-styles.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list><md-list-item ng-repeat-start=\"programStyle in vm.programStyles\" \nui-sref=\"app.configuration.programSettings.programStyleById({ programStyleId: programStyle.id })\"><p><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"s24\"></md-icon>{{ programStyle.name }}</p></md-list-item><md-divider \nng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" \nlayout-align=\"center center\" layout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/program-settings/program-types/program-types.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list class=\"program-types\"><md-list-item \nng-repeat-start=\"programType in vm.programTypes | orderBy:\'name\'\" \nui-sref=\"app.configuration.programSettings.programTypeById({ programTypeId: programType.id })\" class=\"md-3-line\"><img \nbaldris-img-src=\"programType.previewImageUrl\" preset=\"square-40-padded\" class=\"md-avatar\" alt=\"{{programType.name}}\">\n<div class=\"md-list-item-text\" layout=\"column\" ng-class=\"{ \'is-deleted\': programType.isDeleted}\"><h3>\n{{ programType.name }}</h3><h4>{{ programType.description }}</h4><p>{{ programType.templateFileName }}</p></div>\n</md-list-item><md-divider ng-repeat-end ng-if=\"!$last\"></md-divider></md-list></div><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" layout-padding><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-program-type-button\" aria-label=\"add program type\" \nui-sref=\"app.configuration.programSettings.programTypeById({ programTypeId: \'new\' })\" translate \ntranslate-attr-aria-label=\"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.ADD_PROGRAM_TYPE\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/settings/configuration/reference-types/partials/reference-types-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ \"SETTINGS.REFERENCE_REGISTRY.REFERENCE_TYPES\" | translate }}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list><md-list-item \nng-repeat=\"referenceType in vm.referenceTypes | filter:vm.canViewReferenceType | orderBy:vm.translated\" \nng-click=\"vm.selectReferenceType(referenceType, vm.showDeleted)\" \nng-class=\"{\'selected\':vm.currentData.selectedReferenceType === referenceType, \'md-accent-bg\': vm.currentData.selectedReferenceType === referenceType}\">\n<p><md-icon md-font-icon=\"{{ referenceType.icon }}\" class=\"s24\"></md-icon>{{ referenceType.name | translate }}</p>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/configuration/reference-types/reference-type-view/configuration-reference-type-view.tmpl.html","<table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" dt-column-defs=\"vm.dtColumnDefs\"></table><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item>");
$templateCache.put("app/main/settings/configuration/transport-settings/general-settings/transport-general-settings.tmpl.html","<div class=\"edit-page\" ng-if=\"!vm.loadingService.isLoading\"><div layout-padding layout=\"column\" \nng-form=\"vm.generalSettingsForm\"><h1>{{ \'MENU.CONFIGURATION.TRANSPORT_SETTINGS.GENERAL_SETTINGS\' | translate }} <span \nng-if=\"vm.generalSettingsForm.$dirty\">*</span></h1><div \nng-repeat=\"baldrisConfig in vm.baldrisConfigs | orderBy:\'name\'\"><edit-baldris-config baldris-config=\"baldrisConfig\" \ncustom-field-data=\"baldrisConfig.customFieldData\" label-text=\"{{vm.labelTextMap[baldrisConfig.name] | translate}}\" \nis-currency=\"vm.isCurrencyMap[baldrisConfig.name]\"></edit-baldris-config></div></div><div layout=\"row\" layout-padding>\n<md-button class=\"md-warn\" ng-click=\"vm.exitView()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.generalSettingsForm.$pristine\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}\n</md-button></div></div><div ng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" \nlayout-padding><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/transport-settings/location-transports/location-transports.tmpl.html","<div ng-if=\"!vm.loadingService.isLoading\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat-start=\"locationTransport in vm.locationTransports | orderBy:[\'departmentOrganizationDisplayName\', \'description\']\" \nui-sref=\"app.configuration.transportSettings.locationTransportById({ locationTransportId: locationTransport.id })\">\n<md-icon md-font-icon=\"{{ locationTransport.suggestedTransportTypeIconName || \'icon-truck\' }}\" class=\"s24\"></md-icon>\n<div class=\"md-list-item-text\" ng-class=\"{\'md-offset\': phone.options.offset }\"><h3>{{ locationTransport.description }}\n</h3><h4>{{ locationTransport.suggestedTransportTypeName }}</h4><p>\n{{ locationTransport.departmentOrganizationDisplayName }}</p></div></md-list-item><md-divider ng-repeat-end \nng-if=\"!$last\"></md-divider></md-list></div><md-button class=\"md-fab md-accent md-icon-button\" \nid=\"add-location-transport-button\" ng-click=\"vm.addLocationTransport($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><div \nng-if=\"vm.loadingService.isLoading\" layout=\"row\" layout-align=\"center center\" layout-padding><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div>");
$templateCache.put("app/main/settings/configuration/transport-settings/partials/transport-settings-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">\n{{ \"MENU.CONFIGURATION.TRANSPORT_SETTINGS.TRANSPORT_SETTINGS\" | translate }}</span></div><md-divider></md-divider><div \nms-scroll class=\"content scrollable\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list>\n<md-list-item ui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.transportSettings.generalSettings\"><p>\n<md-icon md-font-icon=\"icon-truck\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.TRANSPORT_SETTINGS.GENERAL_SETTINGS\" | translate }}</p></md-list-item><md-list-item \nui-sref-active=\"selected md-accent-bg\" ui-sref=\"app.configuration.transportSettings.locationTransports\"><p><md-icon \nmd-font-icon=\"icon-truck\" class=\"s24\"></md-icon>\n{{ \"MENU.CONFIGURATION.TRANSPORT_SETTINGS.LOCATION_TRANSPORTS\" | translate }}</p></md-list-item></md-list></div></div>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/address-type.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \'ADDRESSES.ADDRESS_TYPE.NAME\' | translate}}</label><input \nng-model=\"vm.reference.name\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'ADDRESSES.ADDRESS_TYPE.ICON\' | translate}}\"></icon-select><md-input-container class=\"md-block\" flex>\n<label>{{ \'ADDRESSES.ADDRESS_TYPE.DESCRIPTION\' | translate}}</label><textarea ng-model=\"vm.reference.description\">\n</textarea></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'ADDRESSES.ADDRESS_TYPE.IS_DELETED\' | translate}}\">{{ \'ADDRESSES.ADDRESS_TYPE.IS_DELETED\' | translate}}\n</md-checkbox>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/auto-task.tmpl.html","<note-or-task-type-select ng-model=\"vm.reference.noteOrTaskTypeId\"></note-or-task-type-select><md-input-container \nclass=\"md-block\" flex><label>{{ \"AUTO_TASKS.AUTO_TASK.SUBJECT\" | translate }}</label><input \nng-model=\"vm.reference.subject\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"AUTO_TASKS.AUTO_TASK.TEXT\" | translate }}</label><textarea ng-model=\"vm.reference.text\"></textarea>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><div class=\"md-block\" flex-gt-sm=\"50\"><md-input-container>\n<label>{{ \"AUTO_TASKS.AUTO_TASK.DUE_TIME_OFFSET\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.reference.dueTimeOffset\"></md-input-container></div><div class=\"md-block\" flex-gt-sm=\"50\">\n<md-input-container class=\"md-block\" flex><label>{{ \"AUTO_TASKS.AUTO_TASK.DUE_TIME_MODIFIER\" | translate }}</label>\n<md-select ng-model=\"vm.reference.dueTimeModifier\"><md-option ng-value=\"\'d\'\">\n{{ \"AUTO_TASKS.DUE_TIME_MODIFIERS.DAYS\" | translate }}</md-option><md-option ng-value=\"\'w\'\">\n{{ \"AUTO_TASKS.DUE_TIME_MODIFIERS.WEEKS\" | translate }}</md-option><md-option ng-value=\"\'M\'\">\n{{ \"AUTO_TASKS.DUE_TIME_MODIFIERS.MONTHS\" | translate }}</md-option><md-option ng-value=\"\'y\'\">\n{{ \"AUTO_TASKS.DUE_TIME_MODIFIERS.YEARS\" | translate }}</md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/balance-account.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"BALANCE_ACCOUNTS.BALANCE_ACCOUNT.ACCOUNT\" | translate }}</label>\n<input ng-model=\"vm.reference.account\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"BALANCE_ACCOUNTS.BALANCE_ACCOUNT.NAME\" | translate }}</label><input ng-model=\"vm.reference.name\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"BALANCE_ACCOUNTS.BALANCE_ACCOUNT.DESCRIPTION\" | translate }}</label><input ng-model=\"vm.reference.description\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"BALANCE_ACCOUNTS.BALANCE_ACCOUNT.VAT_CODE\" | translate }}</label><input ng-model=\"vm.reference.vatCode\">\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'BALANCE_ACCOUNTS.BALANCE_ACCOUNT.IS_DELETED\' | translate}}\">\n{{ \"BALANCE_ACCOUNTS.BALANCE_ACCOUNT.IS_DELETED\" | translate }}</md-checkbox></md-input-container>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/calendar-event-type.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"CALENDAR.CALENDAR_EVENT_TYPE.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CALENDAR.CALENDAR_EVENT_TYPE.PROGRAM_TITLE\" | translate }}</label><input ng-model=\"vm.reference.programTitle\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CALENDAR.CALENDAR_EVENT_TYPE.PROGRAM_TITLE_ALTERNATIVE\" | translate }}</label><input \nng-model=\"vm.reference.programTitleAlternative\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CALENDAR.CALENDAR_EVENT_TYPE.PROGRAM_TITLE_ENGLISH\" | translate }}</label><input \nng-model=\"vm.reference.programTitleEnglish\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'CALENDAR.CALENDAR_EVENT_TYPE.ICON\' | translate}}\"></icon-select><md-input-container class=\"md-block\" \nflex><label>{{ \"CALENDAR.CALENDAR_EVENT_TYPE.COLOR\" | translate }}</label><input ng-model=\"vm.reference.color\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CALENDAR.CALENDAR_EVENT_TYPE.DESCRIPTION\" | translate }}</label><textarea ng-model=\"vm.reference.description\">\n</textarea></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'CALENDAR.CALENDAR_EVENT_TYPE.IS_DELETED\' | translate}}\">\n{{ \"CALENDAR.CALENDAR_EVENT_TYPE.IS_DELETED\" | translate }}</md-checkbox><calendar-options-select \nng-model=\"vm.reference.options\" label-text=\"{{ \'CALENDAR.CALENDAR_EVENT_TYPE.OPTIONS\' | translate}}\">\n</calendar-options-select><auto-product-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-products=\"vm.autoProducts\" attached-type=\"CalendarEventType\" attached-type-id=\"vm.reference.id\">\n</auto-product-list><auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-tasks=\"vm.autoTasks\" \nattached-type=\"CalendarEventType\" attached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/casket.tmpl.html","<div ng-if=\"vm.reference.imageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.reference.imageFilepath || vm.reference.image.filepath\" preset=\"square-250-padded\"><md-button \nclass=\"md-warn\" aria-label=\"Remove Image\" ng-click=\"vm.removeImage(\'image\', \'imageId\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \"COMMON.DIALOG.REMOVE_IMAGE\" | translate }}</md-button></div><div>\n<md-input-container class=\"md-block\" flex><label>{{ \"CASKETS.CASKET.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{ \"CASKETS.CASKET.DESCRIPTION\" | translate }}</label><textarea ng-model=\"vm.reference.description\"></textarea>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><div><md-input-container class=\"md-block\" flex>\n<label>{{ \"CASKETS.CASKET.WIDTH\" | translate }}</label><input type=\"number\" ng-model=\"vm.reference.width\">\n</md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{ \"CASKETS.CASKET.LENGTH\" | translate }}</label><input type=\"number\" ng-model=\"vm.reference.lenght\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-xs=\"row\"><div><md-input-container class=\"md-block\" \nflex><label>{{ \"CASKETS.CASKET.HEIGHT\" | translate }}</label><input type=\"number\" ng-model=\"vm.reference.height\">\n</md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{ \"CASKETS.CASKET.WEIGHT\" | translate }}</label><input type=\"number\" ng-model=\"vm.reference.weight\">\n</md-input-container></div></div><enum-flag-select enum-flag=\"vm.reference.attributes\" \nenum-flag-options=\"casketAttributes\" label-text=\"{{\'CASKETS.CASKET.ATTRIBUTES\' | translate}}\"></enum-flag-select>\n<md-checkbox ng-model=\"vm.reference.isDeleted\" aria-label=\"{{ \'CASKETS.CASKET.IS_DELETED\' | translate}}\">\n{{ \"CASKETS.CASKET.IS_DELETED\" | translate }}</md-checkbox><div class=\"md-caption\" ng-if=\"!vm.reference.imageId\">\n{{ \"CASKETS.CASKET.IMAGE\" | translate }}</div><md-button ng-if=\"!vm.reference.imageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadPreviewImage($file, \'image\', \'imageId\')\">{{ \"COMMON.DIALOG.UPLOAD_IMAGE\" | translate }}\n</md-button><auto-product-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" \nattached-type=\"Casket\" attached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-tasks=\"vm.autoTasks\" attached-type=\"Casket\" \nattached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/custom-field-category.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.NAME\" | translate }}</label>\n<input ng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.DESCRIPTION\" | translate }}</label><textarea \nng-model=\"vm.reference.description\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.INTERNAL_NAME\" | translate }}</label><input \nng-model=\"vm.reference.internalName\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.reference.sortOrder\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.ICON\' | translate}}\"></icon-select><md-checkbox \nng-model=\"vm.reference.isDeleted\" aria-label=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD_CATEGORY.IS_DELETED\' | translate}}\">\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.IS_DELETED\" | translate }}</md-checkbox>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/custom-field.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.LABEL\" | translate }}</label><input ng-model=\"vm.reference.label\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.DESCRIPTION\" | translate }}</label>\n<textarea ng-model=\"vm.reference.description\"></textarea></md-input-container><md-input-container class=\"md-block\" \nflex><label>{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.reference.sortOrder\"></md-input-container><md-checkbox \nng-model=\"vm.reference.numericValueIsProductAmount\" \naria-label=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.NUMERIC_VALUE_IS_PRODUCT_AMOUNT\' | translate}}\">\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.NUMERIC_VALUE_IS_PRODUCT_AMOUNT\" | translate }}</md-checkbox><md-checkbox \nng-model=\"vm.reference.isMultiSelect\" aria-label=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.IS_MULTI_SELECT\' | translate}}\">\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.IS_MULTI_SELECT\" | translate }}</md-checkbox><md-checkbox \nng-model=\"vm.reference.allowCustom\" aria-label=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.ALLOW_CUSTOM\' | translate}}\">\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.ALLOW_CUSTOM\" | translate }}</md-checkbox><md-checkbox \nng-model=\"vm.reference.isDeleted\" aria-label=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.IS_DELETED\' | translate}}\">\n{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.IS_DELETED\" | translate }}</md-checkbox><custom-field-category-select \ncustom-field-category-id=\"vm.reference.customFieldCategoryId\" custom-field-category=\"vm.reference.customFieldCategory\" \nlabel-text=\"{{\'CUSTOM_FIELDS.CUSTOM_FIELD.CUSTOM_FIELD_CATEGORY\' | translate}}\"></custom-field-category-select>\n<custom-field-data-type-select selected-data-type=\"vm.reference.dataType\" \nlabel-text=\"{{ \'CUSTOM_FIELDS.CUSTOM_FIELD.DATA_TYPE\' | translate}}\"></custom-field-data-type-select>\n<md-input-container class=\"md-block\" flex><label>{{ \"CUSTOM_FIELDS.CUSTOM_FIELD.INTERNAL_NAME\" | translate }}</label>\n<input ng-model=\"vm.reference.internalName\"></md-input-container><product-choices-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew && vm.reference.dataType === 21\" product-choices=\"vm.productChoices\" \ncustom-field-id=\"vm.reference.id\"></product-choices-list><auto-product-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" attached-type=\"CustomField\" \nattached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-tasks=\"vm.autoTasks\" attached-type=\"CustomField\" attached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/department.tmpl.html","<div ng-if=\"vm.updateModel.department.logoId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.updateModel.department.logo.filepath || vm.updateModel.department.logoFilepath\" \npreset=\"square-150-padded\"><md-button class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'logo\', \'logoId\', vm.updateModel.department)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button></div><md-input-container class=\"md-block\" flex><label>\n{{ \'PARTY.ORGANIZATION.NAME\' | translate}}</label><input ng-model=\"vm.updateModel.organization.name\" \nng-change=\"vm.setChangeState(vm.updateModel.organization)\"></md-input-container><md-input-container class=\"md-block\" \nflex><label>{{ \'PARTY.ORGANIZATION.ORGANIZATION_NUMBER\' | translate}}</label><input \nng-model=\"vm.updateModel.organization.organizationNumber\" ng-change=\"vm.setChangeState(vm.updateModel.organization)\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>{{ \'PARTY.ORGANIZATION.HOME_PAGE\' | translate}}\n</label><input ng-model=\"vm.updateModel.organization.homePage\" \nng-change=\"vm.setChangeState(vm.updateModel.organization)\"></md-input-container><md-checkbox \nng-model=\"vm.updateModel.department.isDeleted\" aria-label=\"{{ \'LOCATIONS.LOCATION.IS_DELETED\' | translate}}\" \nng-change=\"vm.setChangeState(vm.updateModel.department)\">{{ \'LOCATIONS.LOCATION.IS_DELETED\' | translate}}</md-checkbox>\n<div class=\"md-caption\" ng-if=\"!vm.updateModel.department.logoId\">{{ \'DEPARTMENTS.DEPARTMENT.LOGO\' | translate}}</div>\n<md-button ng-if=\"!vm.updateModel.department.logoId\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadPreviewImage($file, \'logo\', \'logoId\', vm.updateModel.department)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button><div class=\"md-caption\">\n{{ \'DEPARTMENTS.DEPARTMENT.ALTERNATIVE_LOGO\' | translate}}</div><div \nng-if=\"vm.updateModel.department.alternativeLogoId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.updateModel.department.alternativeLogo.filepath || vm.updateModel.department.alternativeLogoFilepath\" \npreset=\"square-150-padded\"><md-button class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'alternativeLogo\', \'alternativeLogoId\', vm.updateModel.department)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button></div><md-button \nng-if=\"!vm.updateModel.department.alternativeLogoId\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadPreviewImage($file, \'alternativeLogo\', \'alternativeLogoId\', vm.updateModel.department)\">\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/location.tmpl.html","<div ng-if=\"vm.updateModel.location.imageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.updateModel.location.image.filepath || vm.updateModel.location.imageFilepath\" \npreset=\"square-250-cropped\"><md-button class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'image\', \'imageId\', vm.updateModel.location)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button></div><md-input-container class=\"md-block\" flex><label>\n{{ \'LOCATIONS.LOCATION.NAME\' | translate}}</label><input ng-model=\"vm.updateModel.location.name\" \nng-change=\"vm.setChangeState(vm.updateModel.location)\"></md-input-container><md-input-container class=\"md-block\" flex>\n<label>{{ \'LOCATIONS.LOCATION.DESCRIPTION\' | translate}}</label><textarea \nng-model=\"vm.updateModel.location.description\" ng-change=\"vm.setChangeState(vm.updateModel.location)\"></textarea>\n</md-input-container><md-input-container class=\"md-block\" flex><label>{{ \'LOCATIONS.LOCATION.REMARKS\' | translate}}\n</label><textarea ng-model=\"vm.updateModel.location.remarks\" ng-change=\"vm.setChangeState(vm.updateModel.location)\">\n</textarea></md-input-container><many-to-many-select many-to-many-list=\"vm.updateModel.locationTypes\" \nmany-to-many-name=\"LocationLocationTypeDto\" reference-id=\"vm.updateModel.location.id\" reference-id-name=\"locationId\" \nsource-controller=\"LocationTypes\" source-id-name=\"id\" source-name=\"name\" target-id-name=\"locationTypeId\" \ntarget-name=\"locationTypeName\" label-text=\"{{\'LOCATIONS.LOCATION.LOCATION_TYPES\' | translate}}\" \nplaceholder-text=\"{{\'LOCATIONS.LOCATION.LOCATION_TYPES\' | translate}}\" \non-update=\"vm.setChangeState(vm.updateModel.location)\"></many-to-many-select><md-checkbox \nng-model=\"vm.updateModel.location.isDeleted\" aria-label=\"{{ \'LOCATIONS.LOCATION.IS_DELETED\' | translate}}\" \nng-change=\"vm.setChangeState(vm.updateModel.location)\">{{ \'LOCATIONS.LOCATION.IS_DELETED\' | translate}}</md-checkbox>\n<municipality-select label-text=\"{{\'LOCATIONS.LOCATION.MUNICIPALITY\' | translate}}\" \nmunicipality-id=\"vm.updateModel.location.municipalityId\" municipality=\"vm.updateModel.location.municipality\">\n</municipality-select><lf-ng-md-file-input ng-if=\"!vm.reference.imageId\" lf-files=\"vm.uploadFiles\" \nlf-browse-label=\"{{\'COMMON.DATA.CHOOSE\' | translate}}\" lf-remove-label=\"{{\'COMMON.DATA.RESET\' | translate}}\" \nlf-drag-and-drop-label=\"{{\'COMMON.DATA.DRAG_AND_DROP_HERE\' | translate}}\" drag preview></lf-ng-md-file-input><md-button\n ng-if=\"!vm.updateModel.location.imageId\" ng-disabled=\"!vm.uploadFiles || vm.uploadFiles.length < 1\" \naria-label=\"{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}\" \nng-click=\"vm.uploadImage(\'image\', \'imageId\', vm.updateModel.location)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/lookup-string-type.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.NAME\' | translate}}</label>\n<input ng-model=\"vm.reference.name\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.ICON\' | translate}}\"></icon-select><md-input-container \nclass=\"md-block\" flex><label>{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.DESCRIPTION\' | translate}}</label><textarea \nng-model=\"vm.reference.description\"></textarea></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.IS_DELETED\' | translate}}\">\n{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.IS_DELETED\' | translate}}</md-checkbox><md-checkbox \nng-model=\"vm.reference.shouldShowValueNumbers\" \naria-label=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.SHOULD_SHOW_VALUE_NUMBERS\' | translate}}\">\n{{ \'LOOKUP_STRINGS.LOOKUP_STRING_TYPE.SHOULD_SHOW_VALUE_NUMBERS\' | translate}}</md-checkbox>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/lookup-string.tmpl.html","<div ng-if=\"vm.reference.imageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.reference.imageFilepath || vm.reference.image.filepath\" preset=\"square-250-cropped\"><md-button \nclass=\"md-warn\" aria-label=\"Remove Image\" ng-click=\"vm.removeImage(\'image\', \'imageId\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \"COMMON.DIALOG.REMOVE_IMAGE\" | translate }}</md-button></div>\n<md-input-container class=\"md-block\" flex><label>{{ \"LOOKUP_STRINGS.LOOKUP_STRING.LOOKUP_NUMBER\" | translate }}</label>\n<input type=\"number\" step=\"1\" ng-model=\"vm.reference.lookupNumber\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>{{ \"LOOKUP_STRINGS.LOOKUP_STRING.LOOKUP_VALUE\" | translate }}</label><textarea \nng-model=\"vm.reference.lookupValue\"></textarea></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"LOOKUP_STRINGS.LOOKUP_STRING.DESCRIPTION\" | translate }}</label><textarea ng-model=\"vm.reference.description\">\n</textarea></md-input-container><icon-select icon-name=\"vm.reference.lookupIconName\" \nlabel-text=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING.LOOKUP_ICON_NAME\' | translate}}\"></icon-select><lookup-string-type-select \nlookup-string-type=\"vm.reference.lookupStringType\" lookup-string-type-id=\"vm.reference.lookupStringTypeId\" \nlabel-text=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING.LOOKUP_STRING_TYPE\' | translate }}\" is-required=\"true\">\n</lookup-string-type-select><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'LOOKUP_STRINGS.LOOKUP_STRING.IS_DELETED\' | translate}}\">\n{{ \"LOOKUP_STRINGS.LOOKUP_STRING.IS_DELETED\" | translate }}</md-checkbox><div class=\"md-caption\" \nng-if=\"!vm.reference.imageId\">{{ \"CASKETS.CASKET.IMAGE\" | translate }}</div><md-button ng-if=\"!vm.reference.imageId\" \nclass=\"md-primary md-raised\" ngf-select=\"vm.uploadPreviewImage($file, \'image\', \'imageId\')\">\n{{ \"COMMON.DIALOG.UPLOAD_IMAGE\" | translate }}</md-button><auto-product-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" attached-type=\"LookupString\" \nattached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-tasks=\"vm.autoTasks\" attached-type=\"LookupString\" attached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/municipality.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \'MUNICIPALITIES.MUNICIPALITY.NAME\' | translate}}</label><input \nng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \'MUNICIPALITIES.MUNICIPALITY.NAME_ALTERNATIVE\' | translate}}</label><input ng-model=\"vm.reference.nameAlternative\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \'MUNICIPALITIES.MUNICIPALITY.ENGLISH_NAME\' | translate}}</label><input ng-model=\"vm.reference.englishName\">\n</md-input-container><state-select state-id=\"vm.reference.stateId\" state=\"vm.reference.state\" \nlabel-text=\"{{ \'MUNICIPALITIES.MUNICIPALITY.STATE\' | translate}}\"></state-select><md-checkbox \nng-model=\"vm.reference.isDeleted\" aria-label=\"{{ \'MUNICIPALITIES.MUNICIPALITY.IS_DELETED\' | translate}}\">\n{{ \'MUNICIPALITIES.MUNICIPALITY.IS_DELETED\' | translate}}</md-checkbox><auto-product-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" attached-type=\"Municipality\" \nattached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-tasks=\"vm.autoTasks\" attached-type=\"Municipality\" attached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/obituary-notice-type.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.NAME\' | translate}}</label>\n<input ng-model=\"vm.reference.name\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.ICON\' | translate}}\"></icon-select><md-input-container \nclass=\"md-block\" flex><label>{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.DESCRIPTION\' | translate}}</label><textarea \nng-model=\"vm.reference.description\"></textarea></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.IS_DELETED\' | translate}}\">\n{{ \'OBITUARY_NOTICES.OBITUARY_NOTICE_TYPE.IS_DELETED\' | translate}}</md-checkbox><form ng-if=\"!vm.reference.imageId\" \nname=\"imageForm\" enctype=\"multipart/form-data\" ng-disabled=\"vm.isLoading\" layout=\"column\"><label class=\"md-caption\" \ntranslate=\"PRODUCTS.PRODUCT.PRODUCT_IMAGE\">Product Image</label><md-input-container flex-gt-sm=\"50\"><input type=\"file\" \ninput-files=\"vm.uploadFiles\" has-files=\"vm.hasUploadFiles\"></md-input-container><md-button \nng-disabled=\"!vm.hasUploadFiles\" aria-label=\"Upload Image\" ng-click=\"vm.uploadImage(\'image\', \'imageId\')\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}</md-button></form><div \nng-if=\"vm.reference.imageId\" class=\"product-image\"><img baldris-img-src=\"vm.reference.image.filepath\" \npreset=\"square-250-cropped\"><md-button class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'image\', \'imageId\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \'COMMON.DIALOG.REMOVE_IMAGE\' | translate }}</md-button></div>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/participant-role.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"PARTICIPANT_ROLES.PARTICIPANT_ROLE.NAME\" | translate }}</label>\n<input ng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"PARTICIPANT_ROLES.PARTICIPANT_ROLE.DESCRIPTION\" | translate }}</label><input ng-model=\"vm.reference.description\">\n</md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'CALENDAR.CALENDAR_EVENT_TYPE.ICON\' | translate}}\"></icon-select><md-input-container class=\"md-block\">\n<label>{{ \"PARTICIPANT_ROLES.PARTICIPANT_ROLE.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.reference.sortOrder\"></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'CALENDAR.CALENDAR_EVENT_TYPE.IS_DELETED\' | translate}}\">\n{{ \"PARTICIPANT_ROLES.PARTICIPANT_ROLE.IS_DELETED\" | translate }}</md-checkbox><auto-product-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" attached-type=\"ParticipantRole\" \nattached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-tasks=\"vm.autoTasks\" attached-type=\"ParticipantRole\" attached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/report.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"REPORTS.REPORT.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"REPORTS.REPORT.DESCRIPTION\" | translate }}</label><input ng-model=\"vm.reference.description\"></md-input-container>\n<icon-select icon-name=\"vm.reference.iconName\" label-text=\"{{ \'REPORTS.REPORT.ICON\' | translate}}\"></icon-select>\n<md-input-container class=\"md-block\" flex><label>{{ \"REPORTS.REPORT.PASSWORD\" | translate }}</label><input \nng-model=\"vm.reference.password\"></md-input-container><md-input-container class=\"md-block\"><label>\n{{ \"REPORTS.REPORT.SORT_ORDER\" | translate }}</label><input type=\"number\" step=\"1\" ng-model=\"vm.reference.sortOrder\">\n</md-input-container><md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'REPORTS.REPORT.IS_DELETED\' | translate}}\">{{ \"REPORTS.REPORT.IS_DELETED\" | translate }}</md-checkbox>\n</md-input-container>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/urn.tmpl.html","<div ng-if=\"vm.reference.imageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.reference.imageFilepath || vm.reference.image.filepath\" preset=\"square-250-cropped\"><md-button \nclass=\"md-warn\" aria-label=\"Remove Image\" ng-click=\"vm.removeImage(\'image\', \'imageId\')\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{ \"COMMON.DIALOG.REMOVE_IMAGE\" | translate }}</md-button></div><div>\n<md-input-container class=\"md-block\" flex><label>{{ \"URNS.URN.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{ \"URNS.URN.COLOR\" | translate }}</label><input ng-model=\"vm.reference.color\"></md-input-container></div><div>\n<md-input-container class=\"md-block\" flex><label>{{ \"URNS.URN.MATERIAL\" | translate }}</label><input \nng-model=\"vm.reference.material\"></md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{ \"URNS.URN.DESCRIPTION\" | translate }}</label><textarea ng-model=\"vm.reference.description\"></textarea>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><div><md-input-container class=\"md-block\" flex>\n<label>{{ \"URNS.URN.WIDTH\" | translate }}</label><input type=\"number\" ng-model=\"vm.reference.width\">\n</md-input-container></div><div><md-input-container class=\"md-block\" flex><label>{{ \"URNS.URN.LENGHT\" | translate }}\n</label><input type=\"number\" ng-model=\"vm.reference.lenght\"></md-input-container></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><div><md-input-container class=\"md-block\" flex><label>{{ \"URNS.URN.HEIGHT\" | translate }}</label>\n<input type=\"number\" ng-model=\"vm.reference.height\"></md-input-container></div><div><md-input-container \nclass=\"md-block\" flex><label>{{ \"URNS.URN.WEIGHT\" | translate }}</label><input type=\"number\" \nng-model=\"vm.reference.weight\"></md-input-container></div></div><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'URNS.URN.IS_DELETED\' | translate}}\">{{ \"URNS.URN.IS_DELETED\" | translate }}</md-checkbox><div \nclass=\"md-caption\" ng-if=\"!vm.reference.imageId\">{{ \"URNS.URN.IMAGE\" | translate }}</div><md-button \nng-if=\"!vm.reference.imageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadPreviewImage($file, \'image\', \'imageId\')\">{{ \"COMMON.DIALOG.UPLOAD_IMAGE\" | translate }}\n</md-button><auto-product-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-products=\"vm.autoProducts\" \nattached-type=\"Urn\" attached-type-id=\"vm.reference.id\"></auto-product-list><auto-task-list \nng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-tasks=\"vm.autoTasks\" attached-type=\"Urn\" \nattached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/user.tmpl.html","<div ng-if=\"vm.reference.profileImageId\" class=\"product-image\"><img \nbaldris-img-src=\"vm.reference.profileImageFilepath || vm.reference.profileImage.filepath\" preset=\"square-250-cropped\">\n<md-button class=\"md-warn\" aria-label=\"Remove Image\" ng-click=\"vm.removeImage(\'profileImage\', \'profileImageId\')\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon>{{ \"COMMON.DIALOG.REMOVE_IMAGE\" | translate }}</md-button></div>\n<md-input-container class=\"md-block\" flex><label>{{ \"BALDRIS_USERS.BALDRIS_USER.LAST_NAME\" | translate }}</label><input\n ng-model=\"vm.reference.lastName\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"BALDRIS_USERS.BALDRIS_USER.FIRST_NAME\" | translate }}</label><textarea ng-model=\"vm.reference.firstName\">\n</textarea></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"BALDRIS_USERS.BALDRIS_USER.SHORT_NAME\" | translate }}</label><textarea ng-model=\"vm.reference.shortName\">\n</textarea></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"PARTY.PERSON.DATE_OF_BIRTH\" | translate }}</label><date-select ng-model=\"vm.reference.dateOfBirth\"></date-select>\n</md-input-container><md-checkbox class=\"margin-top-20\" ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'BALDRIS_USERS.BALDRIS_USER.IS_DELETED\' | translate }}\">\n{{ \"BALDRIS_USERS.BALDRIS_USER.IS_DELETED\" | translate }}</md-checkbox><md-checkbox class=\"margin-top-20\" \nng-model=\"vm.reference.isAlumni\" aria-label=\"{{ \'BALDRIS_USERS.BALDRIS_USER.IS_ALUMNI\' | translate }}\">\n{{ \"BALDRIS_USERS.BALDRIS_USER.IS_ALUMNI\" | translate }}</md-checkbox><div class=\"md-caption\" \nng-if=\"!vm.reference.profileImageId\">{{ \"BALDRIS_USERS.BALDRIS_USER.PROFILE_IMAGE\" | translate }}</div><md-button \nng-if=\"!vm.reference.profileImageId\" class=\"md-primary md-raised\" \nngf-select=\"vm.uploadPreviewImage($file, \'profileImage\', \'profileImageId\')\">\n{{ \"COMMON.DIALOG.UPLOAD_IMAGE\" | translate }}</md-button>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/vat.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"VATS.VAT.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \"VATS.VAT.VAT_CODE\" | translate }}</label><input ng-model=\"vm.reference.vatCode\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>{{ \"VATS.VAT.RATE\" | translate }}</label><input type=\"number\" \nng-model=\"vm.reference.rate\"></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nng-model=\"vm.reference.isDeleted\" aria-label=\"{{ \'VATS.VAT.IS_DELETED\' | translate}}\">\n{{ \"VATS.VAT.IS_DELETED\" | translate }}</md-checkbox></md-input-container>");
$templateCache.put("app/main/settings/dialogs/reference-type-quick-edit-dialog/partials/work-order-type.tmpl.html","<md-input-container class=\"md-block\" flex><label>{{ \"WORK_ORDERS.WORK_ORDER_TYPE.NAME\" | translate }}</label><input \nng-model=\"vm.reference.name\"></md-input-container><icon-select icon-name=\"vm.reference.iconName\" \nlabel-text=\"{{ \'WORK_ORDERS.WORK_ORDER_TYPE.ICON\' | translate}}\"></icon-select><md-input-container class=\"md-block\" \nflex><label>{{ \"WORK_ORDERS.WORK_ORDER_TYPE.DESCRIPTION\" | translate }}</label><textarea \nng-model=\"vm.reference.description\"></textarea></md-input-container><md-checkbox ng-model=\"vm.reference.isDeleted\" \naria-label=\"{{ \'WORK_ORDERS.WORK_ORDER_TYPE.IS_DELETED\' | translate}}\">\n{{ \"WORK_ORDERS.WORK_ORDER_TYPE.IS_DELETED\" | translate }}</md-checkbox><md-checkbox ng-model=\"vm.reference.isDefault\" \naria-label=\"{{ \'WORK_ORDERS.WORK_ORDER_TYPE.IS_DEFAULT\' | translate}}\">\n{{ \"WORK_ORDERS.WORK_ORDER_TYPE.IS_DEFAULT\" | translate }}</md-checkbox><work-order-options-select \nlabel-text=\"{{ \'WORK_ORDERS.WORK_ORDER_TYPE.OPTIONS\' | translate }}\" options=\"vm.reference.options\">\n</work-order-options-select><auto-product-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" \nauto-products=\"vm.autoProducts\" attached-type=\"WorkOrderType\" attached-type-id=\"vm.reference.id\"></auto-product-list>\n<auto-task-list ng-if=\"!vm.isLoadingAutoProducts && !vm.isNew\" auto-tasks=\"vm.autoTasks\" attached-type=\"WorkOrderType\" \nattached-type-id=\"vm.reference.id\"></auto-task-list>");
$templateCache.put("app/main/signature-jobs/consignment/create-consignment/views/sidebar.tmpl.html","<div class=\"work-order-sidebar create-consignment-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><signature-authentication></signature-authentication></div></div>");
$templateCache.put("app/main/signature-jobs/consignment/create-consignment/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.CREATE_NEW_SIGNATURE_JOB\"></span> <span ng-if=\"vm.data.createForm.$dirty\">\n*</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.export()\" \nng-disabled=\"!vm.data.canSave()\" aria-label=\"Export\" translate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip \nmd-direction=\"top\">\n{{ vm.data.createCommand.sendAutomatically ? \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT_AND_SEND\" : \"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EXPORT\" | translate }}\n</md-tooltip><md-icon class=\"md-primary-fg\" md-font-icon=\"icon-content-save\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\">\n<md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\"></span></md-tooltip><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/signature-jobs/consignment/edit-consignment/views/sidebar.tmpl.html","<div class=\"work-order-sidebar edit-consignment-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \'COMMON.DATA.ACTIONS\' | translate }}</span></div></div><div class=\"sidebar-content\" \nlayout=\"column\" layout-padding><signature-authentication></signature-authentication></div></div>");
$templateCache.put("app/main/signature-jobs/consignment/edit-consignment/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"SIGNATURE_JOBS.EDIT_SIGNATURE_JOB.EDITING_SIGNATURE_JOB\"></span> <span ng-if=\"vm.data.editForm.$dirty\">*\n</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" aria-label=\"Cancel\" \ntranslate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span translate=\"COMMON.DIALOG.CANCEL\">\n</span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar>");
$templateCache.put("app/main/song/song-library/song-list/partials/song-list-toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><div flex><md-input-container md-no-float \nclass=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.data.searchString\" \ntype=\"text\" placeholder=\"{{ \'SONGS.SONG_LIBRARY.SEARCH_LIST\' | translate }}\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 300, \'blur\': 0 } }\"></md-input-container></div>\n</div></md-toolbar>");
$templateCache.put("app/main/work-order/work-order/attachments/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-attachment-sidebar\" layout=\"column\"><div class=\"sidebar-title\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\">\n</md-icon><span class=\"title-text\">Handlinger</span></div></div><div class=\"sidebar-content\" layout=\"column\" \nlayout-padding><md-button class=\"md-raised md-block\" ng-click=\"vm.data.toggleAll()\">\n{{ vm.data.selectedAttachments.length === vm.data.workOrderAttachments.length ? \'WORK_ORDERS.WORK_ORDER.ATTACHMENTS.DESELECT_ALL\' : \'WORK_ORDERS.WORK_ORDER.ATTACHMENTS.SELECT_ALL\' | translate }}\n</md-button><h4 ng-if=\"vm.data.selectedAttachments.length > 0\" \ntranslate=\"WORK_ORDERS.WORK_ORDER.ATTACHMENTS.AMOUNT_SELECTED\" \ntranslate-values=\"{selectedAmount: vm.data.selectedAttachments.length, totalAmount: vm.data.workOrderAttachments.length}\">\n0 of 0 attachments selected</h4><md-button ng-if=\"vm.data.selectedAttachments.length > 0\" \nclass=\"md-raised md-primary md-block\" ng-click=\"vm.data.downloadSelected($event)\">\n{{ \'WORK_ORDERS.WORK_ORDER.ATTACHMENTS.DOWNLOAD_SELECTED\' | translate }}</md-button><md-button \nng-if=\"vm.data.selectedAttachments.length > 0\" class=\"md-warn md-block\" ng-click=\"vm.data.deleteSelected($event)\">\n{{ \'WORK_ORDERS.WORK_ORDER.ATTACHMENTS.DELETE_SELECTED\' | translate }}</md-button></div></div>");
$templateCache.put("app/main/work-order/work-order/consignments/views/sidebar.tmpl.html","");
$templateCache.put("app/main/work-order/work-order/invoicing/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-invoicing-sidebar\" layout=\"column\"><div class=\"sidebar-title\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\">\n</md-icon><span class=\"title-text\">Handlinger</span></div></div><div class=\"sidebar-content\" layout=\"column\" \nlayout-padding><md-button class=\"md-raised md-accent md-block\" \nng-click=\"vm.data.showEditWorkOrderProductDialog(null, $event)\">\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.ADD_WORK_ORDER_PRODUCT\" | translate }}</md-button><md-button \nng-if=\"vm.data.canWriteInvoice\" class=\"md-raised md-block\" ng-click=\"vm.data.showAddSalesOrderDialog($event)\">\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.ADD_SALES_ORDER\" | translate }}</md-button><md-button \nng-if=\"vm.data.canWriteInvoice && vm.data.salesOrders && vm.data.salesOrders.length > 0 && vm.data.hasUntransferredProducts()\" \nclass=\"md-raised md-block\" ng-click=\"vm.data.showAddToExistingSalesOrderDialog($event)\">\n{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.ADD_TO_EXISTING_SALES_ORDER\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/work-order/work-order/options/views/toolbar.tmpl.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.OPTIONS.OPTIONS\"></span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.saveAndExitView()\" aria-label=\"Save\" translate-attr-aria-label=\"COMMON.DIALOG.OK_SAVE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"COMMON.DIALOG.OK_SAVE\"></span></md-tooltip><md-icon class=\"md-primary-fg\" \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.exitView()\" \naria-label=\"Cancel\" translate-attr-aria-label=\"COMMON.DIALOG.CANCEL\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMMON.DIALOG.CANCEL\"></span></md-tooltip><md-icon class=\"md-background-fg\" md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/main/work-order/work-order/reports/views/sidebar.tmpl.html","<div class=\"work-order-sidebar work-order-reports-sidebar\" layout=\"column\"><div class=\"sidebar-title\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\"><md-icon class=\"title-icon\" md-font-icon=\"icon-flash\"></md-icon><span \nclass=\"title-text\">{{ \"COMMON.DATA.ACTIONS\" | translate }}</span></div></div><div class=\"md-padding\">\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.data.showDeleted\" \naria-label=\"{{ \'WORK_ORDERS.WORK_ORDER.REPORTS.SHOW_REPORTS_NOT_IN_USE\' | translate }}\">\n{{ \"WORK_ORDERS.WORK_ORDER.REPORTS.SHOW_REPORTS_NOT_IN_USE\" | translate }}</md-checkbox></md-input-container></div><div\n class=\"md-padding\" ng-if=\"vm.data.selectedReport\"><h2>{{ vm.data.selectedReport.name }}</h2><div class=\"status-list\">\n<h3><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.REPORTS.E_MAIL_LOG\" | translate }}</h3><div class=\"log-entry md-padding\" \nng-repeat-start=\"reportLog in vm.data.getReportLogsByReportId(vm.data.selectedReport.id)\"><md-tooltip \nng-if=\"reportLog.statusText\" md-direction=\"top\">{{ reportLog.statusText }}</md-tooltip><div class=\"recipients\"><md-icon\n md-font-icon=\"{{ vm.data.getStatusIcon(reportLog) }}\" ng-class=\"vm.data.getStatusColor(reportLog)\"></md-icon>\n{{ reportLog.recipient }} <span ng-if=\"reportLog.password\" class=\"password-protection\"><md-icon \nmd-font-icon=\"icon-lock\" class=\"s16\"></md-icon>{{ reportLog.password }}</span></div><div class=\"user-info\">\n{{ vm.data.getStatusAction(reportLog) | translate }}<md-icon ng-if=\"reportLog.userDisplayName\" \nmd-font-icon=\"icon-account\" class=\"s12\"></md-icon><span ng-if=\"reportLog.userDisplayName\">\n{{ reportLog.userDisplayName }} </span><md-icon md-font-icon=\"icon-clock\" class=\"s12\"></md-icon>\n{{ reportLog.timestamp || reportLog.statusTime | date: \"short\" }}</div></div><md-divider ng-repeat-end ng-if=\"!$last\">\n</md-divider></div></div></div>");
$templateCache.put("app/main/work-order/work-order/views/sidenav/work-order-notes-and-tasks.tmpl.html","<div class=\"sidenav-title ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\" translate=\"WORK_ORDERS.WORK_ORDER.DECEASED.NOTE_OR_TASKS_TITLE\"></div></div><note-or-task-list \nng-if=\"!vm.service.currentData.viewData.isLoadingNoteOrTasks\" \ncollection=\"vm.service.currentData.workOrder.notesAndTasks\" hide-statuses=\"true\" \ntab-filter=\"{{vm.service.currentData.viewData.tabFilter}}\" work-order-id=\"vm.service.currentData.workOrder.id\" \ninheritance-type=\"WorkOrder\"></note-or-task-list><div ng-if=\"vm.service.currentData.viewData.isLoadingNoteOrTasks\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div>");
$templateCache.put("app/main/work-order/work-order/views/sidenav/work-order-sidenav.tmpl.html","<div class=\"sidenav-inner\" ng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><div \nclass=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-apps\" class=\"s24\">\n</md-icon><span class=\"font-weight-500 font-size-14\">{{ vm.service.currentData.workOrder.workOrderType }}</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\" \nng-class=\"vm.fuseTheming.getThemeMetaData().secondaryMenuClass\"><md-list class=\"work-order-types-list\"><md-list-item \nng-click=\"vm.service.changeTab(0)\" ng-if=\"vm.service.isOptionEnabled(\'hasDeceased\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'DECEASED\'), \'md-accent-bg\': vm.service.isSelected(\'DECEASED\')}\"><p>\n<md-icon md-font-icon=\"icon-briefcase\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.DECEASED.DECEASED\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(1)\" ng-if=\"vm.service.isOptionEnabled(\'hasReferencePersons\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'REFERENCE_PERSONS\'), \'md-accent-bg\': vm.service.isSelected(\'REFERENCE_PERSONS\')}\">\n<p><md-icon md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.REFERENCE_PERSON.REFERENCE_PERSONS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(2)\" ng-if=\"vm.service.isOptionEnabled(\'hasCeremonies\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'CEREMONY\'), \'md-accent-bg\': vm.service.isSelected(\'CEREMONY\')}\"><p>\n<md-icon md-font-icon=\"icon-bookmark\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.CEREMONY.CEREMONY\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(3)\" ng-if=\"vm.service.isOptionEnabled(\'hasFlowers\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'FLOWER_ORDERS\'), \'md-accent-bg\': vm.service.isSelected(\'FLOWER_ORDERS\')}\">\n<p><md-icon md-font-icon=\"icon-flower\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.FLOWER_ORDERS.FLOWER_ORDERS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(4)\" ng-if=\"vm.service.isOptionEnabled(\'hasPrograms\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'PROGRAMS\'), \'md-accent-bg\': vm.service.isSelected(\'PROGRAMS\')}\"><p>\n<md-icon md-font-icon=\"icon-file\" class=\"s24\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER.PROGRAMS.PROGRAMS\" | translate }}\n</p></md-list-item><md-list-item ng-click=\"vm.service.changeTab(5)\" \nng-if=\"vm.service.isOptionEnabled(\'hasTransports\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'GROOMING_TRANSPORT\'), \'md-accent-bg\': vm.service.isSelected(\'GROOMING_TRANSPORT\')}\">\n<p><md-icon md-font-icon=\"icon-truck\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.GROOMING_TRANSPORT.GROOMING_TRANSPORT\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(11)\" ng-if=\"vm.service.isOptionEnabled(\'hasShipments\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'SHIPMENTS\'), \'md-accent-bg\': vm.service.isSelected(\'SHIPMENTS\')}\"><p>\n<md-icon md-font-icon=\"icon-airplane\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.SHIPMENTS.SHIPMENTS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(6)\" ng-if=\"vm.service.isOptionEnabled(\'hasGrave\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'GRAVES\'), \'md-accent-bg\': vm.service.isSelected(\'GRAVES\')}\"><p><md-icon \nmd-font-icon=\"icon-view-quilt\" class=\"s24\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER.GRAVES.GRAVES\" | translate }}</p>\n</md-list-item><md-list-item ng-click=\"vm.service.changeTab(12)\" ng-if=\"vm.service.isOptionEnabled(\'hasHeadstones\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'HEADSTONE_ORDERS\'), \'md-accent-bg\': vm.service.isSelected(\'HEADSTONE_ORDERS\')}\">\n<p><md-icon md-font-icon=\"icon-heart-box\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.HEADSTONES.HEADSTONES\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(7)\" ng-if=\"vm.service.isOptionEnabled(\'hasObituaries\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'OBITUARY_NOTICES\'), \'md-accent-bg\': vm.service.isSelected(\'OBITUARY_NOTICES\')}\">\n<p><md-icon md-font-icon=\"icon-format-align-center\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.OBITUARY_NOTICES.OBITUARY_NOTICES\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(8)\" ng-if=\"vm.service.isOptionEnabled(\'hasEvents\')\" \nng-class=\"{\'selected\': vm.service.isSelected(\'CALENDAR_EVENTS\'), \'md-accent-bg\': vm.service.isSelected(\'CALENDAR_EVENTS\')}\">\n<p><md-icon md-font-icon=\"icon-calendar\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.CALENDAR_EVENTS.CALENDAR_EVENTS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(9)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'NOTES_AND_TASKS\'), \'md-accent-bg\': vm.service.isSelected(\'NOTES_AND_TASKS\')}\">\n<p><md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.NOTES_AND_TASKS.NOTES_AND_TASKS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(10)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'INVOICING\'), \'md-accent-bg\': vm.service.isSelected(\'INVOICING\')}\"><p>\n<md-icon md-font-icon=\"icon-cash\" class=\"s24\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER.INVOICING.INVOICING\" | translate }}\n</p></md-list-item><md-list-item ng-if=\"vm.consignmentsActivated\" ng-click=\"vm.service.changeTab(17)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'CONSIGNMENTS\'), \'md-accent-bg\': vm.service.isSelected(\'CONSIGNMENTS\')}\">\n<p><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER.CONSIGNMENTS.CONSIGNMENTS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(14)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'REPORTS\'), \'md-accent-bg\': vm.service.isSelected(\'REPORTS\')}\"><p><md-icon\n md-font-icon=\"icon-printer\" class=\"s24\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER.REPORTS.REPORTS\" | translate }}</p>\n</md-list-item><md-list-item ng-click=\"vm.service.changeTab(15)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'ATTACHMENTS\'), \'md-accent-bg\': vm.service.isSelected(\'ATTACHMENTS\')}\"><p>\n<md-icon md-font-icon=\"icon-upload\" class=\"s24\"></md-icon>\n{{ \"WORK_ORDERS.WORK_ORDER_ATTACHMENT.WORK_ORDER_ATTACHMENTS\" | translate }}</p></md-list-item><md-list-item \nng-click=\"vm.service.changeTab(13)\" \nng-class=\"{\'selected\': vm.service.isSelected(\'OPTIONS\'), \'md-accent-bg\': vm.service.isSelected(\'OPTIONS\')}\"><p><md-icon\n md-font-icon=\"icon-cog\" class=\"s24\"></md-icon>{{ \"WORK_ORDERS.WORK_ORDER.OPTIONS.OPTIONS\" | translate }}</p>\n</md-list-item></md-list></div></div>");
$templateCache.put("app/main/work-order/work-order/views/toolbar/work-order-toolbar.tmpl.html","<div class=\"navigation-controls\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateToFirst()\" aria-label=\"Jump backwards\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.FIRST\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.FIRST_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-skip-previous\">\n</md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateBackward(vm.service.currentData.viewData.jumpAmount)\" aria-label=\"Jump backwards\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.JUMP\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.JUMP_BACKWARD_TOOLTIP\" \ntranslate-values=\"{ amount: vm.service.currentData.viewData.jumpAmount }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\" class=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigatePrevious()\" aria-label=\"Previous\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.PREVIOUS\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.PREVIOUS_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\" \nclass=\"rotate-180\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.service.navigateNext()\" \naria-label=\"Next\" translate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.NEXT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.NEXT_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-play\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateForward(vm.service.currentData.viewData.jumpAmount)\" aria-label=\"Jump Forward\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.JUMP_FORWARD\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.JUMP_FORWARD_TOOLTIP\" \ntranslate-values=\"{ amount: vm.service.currentData.viewData.jumpAmount }\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-fast-forward\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.service.navigateToLast()\" aria-label=\"Jump backwards\" \ntranslate-attr-aria-label=\"WORK_ORDERS.WORK_ORDER.LAST\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"WORK_ORDERS.WORK_ORDER.LAST_TOOLTIP\"></span></md-tooltip><md-icon md-font-icon=\"icon-skip-next\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" ng-disabled=\"!vm.loadingService.isLoadingInBackground\">\n</md-progress-linear>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task/templates/follow-up.tmpl.html","");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task/templates/note.tmpl.html","<div class=\"note\"><div ng-if=\"vm.showWorkOrderInfo && vm.baldrisModel.workOrderId\" class=\"work-order\" layout=\"row\" \nlayout-align=\"start center\"><span>\n{{ vm.baldrisModel.workOrderFirstCeremonyTypeName || vm.baldrisModel.workOrderTypeName }} <span \nng-if=\"vm.baldrisModel.workOrderDeceasedSerialized\">| {{ vm.baldrisModel.workOrderDeceasedSerialized }}</span> </span>\n<span flex></span><md-button ng-if=\"vm.baldrisModel.workOrderId\" class=\"md-icon-button\" \nng-click=\"vm.navigateToWorkOrder($event)\"><md-tooltip md-direction=\"left\">\n{{ \"CALENDAR.EVENT.NAVIGATE_TO_WORK_ORDER\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-export\"></md-icon>\n</md-button></div><div class=\"note-header\"><img ng-if=\"vm.baldrisModel.createdByUserImageUrl\" \nbaldris-img-src=\"vm.baldrisModel.createdByUserImageUrl\" preset=\"square-40-cropped\" class=\"md-avatar\"><md-icon \nclass=\"md-avatar-icon\" ng-if=\"!vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" \nmd-font-icon=\"icon-account\"></md-icon><md-icon class=\"md-avatar-icon\" \nng-if=\"vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" md-font-icon=\"icon-auto-fix\"></md-icon><div \nclass=\"created-by\" ng-class=\"{ \'auto-generated\': !vm.baldrisModel.createdByUser && vm.isAutogenerated }\" \ntitle=\"{{ \'NOTE_OR_TASKS.NOTE_OR_TASK.CREATED_BY\' | translate }} {{ task.createdByUser }} {{\n        task.createdAt | date: \'short\'\n      }}\">\n<span ng-if=\"vm.baldrisModel.createdByUser\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK_LIST.USER_ADDED\" | translate: { userDisplayName: vm.baldrisModel.createdByUser } }}\n</span><span ng-if=\"!vm.baldrisModel.createdByUser && !vm.isAutogenerated\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.UNKNOWN_USER\" | translate }}</span> <span \nng-if=\"!vm.baldrisModel.createdByUser && vm.isAutogenerated\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.AUTO_GENERATED\" | translate }}</span><br><span class=\"created-date\">\n{{ vm.baldrisModel.createdAt | date: \"short\" }}</span></div></div><div class=\"note-body\"><div class=\"note-details\"><h3 \nclass=\"subject\">{{ vm.baldrisModel.subject }}</h3><p class=\"text\" ng-bind-html=\"vm.baldrisModel.text | nl2br\"></p><p \nclass=\"attn-text\">{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.ATTN\" | translate }} <span \nng-repeat=\"recipient in vm.baldrisModel.recipients\">{{recipient.user}}<span ng-if=\"!$last\"> //</span></span></p></div>\n</div></div>");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task/templates/task-completed.tmpl.html","<div class=\"completed\"><div ng-if=\"vm.showWorkOrderInfo && vm.baldrisModel.workOrderId\" class=\"work-order\" \nlayout=\"row\" layout-align=\"start center\"><span>\n{{ vm.baldrisModel.workOrderFirstCeremonyTypeName || vm.baldrisModel.workOrderTypeName }} <span \nng-if=\"vm.baldrisModel.workOrderDeceasedSerialized\">| {{vm.baldrisModel.workOrderDeceasedSerialized}}</span> </span>\n<span flex></span><md-button ng-if=\"vm.baldrisModel.workOrderId\" class=\"md-icon-button\" \nng-click=\"vm.navigateToWorkOrder($event)\"><md-tooltip md-direction=\"left\">\n{{\'CALENDAR.EVENT.NAVIGATE_TO_WORK_ORDER\' | translate}}</md-tooltip><md-icon md-font-icon=\"icon-export\"></md-icon>\n</md-button></div><div class=\"task-header\"><img ng-if=\"vm.baldrisModel.createdByUserImageUrl\" \nbaldris-img-src=\"vm.baldrisModel.createdByUserImageUrl\" preset=\"square-40-cropped\" class=\"md-avatar\"><md-icon \nclass=\"md-avatar-icon\" ng-if=\"!vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" \nmd-font-icon=\"icon-account\"></md-icon><md-icon class=\"md-avatar-icon\" \nng-if=\"vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" md-font-icon=\"icon-auto-fix\"></md-icon><div \nclass=\"created-by\" ng-class=\"{ \'auto-generated\': !vm.baldrisModel.createdByUser && vm.isAutogenerated }\" \ntitle=\"{{\'NOTE_OR_TASKS.NOTE_OR_TASK.CREATED_BY\' | translate}} {{task.createdByUser}} {{task.createdAt | date: \'short\'}}\">\n<span ng-if=\"vm.baldrisModel.createdByUser\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK_LIST.USER_ADDED\' | translate:{ userDisplayName: vm.baldrisModel.createdByUser } }}</span>\n<span ng-if=\"!vm.baldrisModel.createdByUser && !vm.isAutogenerated\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK.UNKNOWN_USER\' | translate}}</span> <span \nng-if=\"!vm.baldrisModel.createdByUser && vm.isAutogenerated\">\n{{\'NOTE_OR_TASKS.NOTE_OR_TASK.AUTO_GENERATED\' | translate}}</span><br><span class=\"created-date\">\n{{vm.baldrisModel.createdAt | date: \'short\'}}</span></div></div><div class=\"task-body\"><div class=\"task-details\"><h3 \nclass=\"subject\">{{vm.baldrisModel.subject}}</h3><p class=\"text\" ng-bind-html=\"vm.baldrisModel.text | nl2br\"></p><p \nclass=\"completed-text\">{{\'NOTE_OR_TASKS.NOTE_OR_TASK.COMPLETED_BY\' | translate}} <span \nng-repeat=\"recipient in vm.getCompletedUsers()\">{{recipient.user}}, {{recipient.completedTaskDate | date:\'short\'}} \n<span ng-if=\"!$last\">//</span></span></p></div><md-checkbox ng-click=\"vm.toggleTask($event)\" class=\"md-primary\" \nng-checked=\"vm.baldrisModel.isCompleted\" aria-label=\"{{\'NOTE_OR_TASKS.NOTE_OR_TASK.SET_COMPLETED\' | translate}}\">\n</md-checkbox></div></div>");
$templateCache.put("app/main/note-or-task/components/note-or-task-list/note-or-task/templates/task-uncompleted.tmpl.html","<div class=\"uncompleted\"><div ng-if=\"vm.showWorkOrderInfo && vm.baldrisModel.workOrderId\" class=\"work-order\" \nlayout=\"row\" layout-align=\"start center\"><span>\n{{ vm.baldrisModel.workOrderFirstCeremonyTypeName || vm.baldrisModel.workOrderTypeName }} <span \nng-if=\"vm.baldrisModel.workOrderDeceasedSerialized\">| {{ vm.baldrisModel.workOrderDeceasedSerialized }}</span> </span>\n<span flex></span><md-button ng-if=\"vm.baldrisModel.workOrderId\" class=\"md-icon-button\" \nng-click=\"vm.navigateToWorkOrder($event)\"><md-tooltip md-direction=\"left\">\n{{ \"CALENDAR.EVENT.NAVIGATE_TO_WORK_ORDER\" | translate }}</md-tooltip><md-icon md-font-icon=\"icon-export\"></md-icon>\n</md-button></div><div class=\"task-header\"><img ng-if=\"vm.baldrisModel.createdByUserImageUrl\" \nbaldris-img-src=\"vm.baldrisModel.createdByUserImageUrl\" preset=\"square-40-cropped\" class=\"md-avatar\"><md-icon \nclass=\"md-avatar-icon\" ng-if=\"!vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" \nmd-font-icon=\"icon-account\"></md-icon><md-icon class=\"md-avatar-icon\" \nng-if=\"vm.isAutogenerated && !vm.baldrisModel.createdByUserImageUrl\" md-font-icon=\"icon-auto-fix\"></md-icon><div \nclass=\"created-by\" ng-class=\"{ \'auto-generated\': !vm.baldrisModel.createdByUser && vm.isAutogenerated }\" \ntitle=\"{{ \'NOTE_OR_TASKS.NOTE_OR_TASK.CREATED_BY\' | translate }} {{ task.createdByUser }} {{\n        task.createdAt | date: \'short\'\n      }}\">\n<span ng-if=\"vm.baldrisModel.createdByUser\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK_LIST.USER_ADDED\" | translate: { userDisplayName: vm.baldrisModel.createdByUser } }}\n</span><span ng-if=\"!vm.baldrisModel.createdByUser && !vm.isAutogenerated\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.UNKNOWN_USER\" | translate }}</span> <span \nng-if=\"!vm.baldrisModel.createdByUser && vm.isAutogenerated\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.AUTO_GENERATED\" | translate }}</span><br><span class=\"created-date\">\n{{ vm.baldrisModel.createdAt | date: \"short\" }} <span ng-if=\"!vm.baldrisModel.isCompleted && vm.toDate\" \nclass=\"due-date\" ng-class=\"{ \'is-overdue\': vm.isOverdue() }\"><span class=\"separator\"></span><md-icon \nmd-font-icon=\"icon-alarm\"></md-icon>{{ vm.toDate | date: \"shortDate\" }}</span></span></div></div><div \nclass=\"task-body\"><div class=\"task-details\"><h3 class=\"subject\">{{ vm.baldrisModel.subject }}</h3><p class=\"text\" \nng-bind-html=\"vm.baldrisModel.text | nl2br\"></p><p class=\"uncompleted-text\">\n{{ \"NOTE_OR_TASKS.NOTE_OR_TASK.ATTN\" | translate }} <span ng-repeat=\"recipient in vm.baldrisModel.recipients\">\n{{recipient.user}}<span ng-if=\"!$last\"> //</span></span></p></div><md-checkbox ng-click=\"vm.toggleTask($event)\" \nclass=\"md-primary\" ng-checked=\"vm.baldrisModel.isCompleted\" \naria-label=\"{{ \'NOTE_OR_TASKS.NOTE_OR_TASK.SET_COMPLETED\' | translate }}\"></md-checkbox></div></div>");
$templateCache.put("app/main/reference-types/party/components/edit-party/views/organization.view.html","<div layout=\"column\"><div><md-input-container class=\"md-block\" flex><label>{{\'PARTY.ORGANIZATION.NAME\' | translate }}\n</label><input ng-model=\"vm.baldrisModel.name\" ng-change=\"vm.partyChanged()\" ng-disabled=\"vm.isDisabled\">\n</md-input-container></div><div><md-input-container class=\"md-block\" flex><label>\n{{\'PARTY.ORGANIZATION.SHORT_NAME\' | translate }}</label><input ng-model=\"vm.baldrisModel.shortName\" \nng-change=\"vm.partyChanged()\" ng-disabled=\"vm.isDisabled\"></md-input-container></div><div><md-checkbox \nng-model=\"vm.baldrisModel.preferShortName\">{{\'PARTY.ORGANIZATION.PREFER_SHORT_NAME\' | translate }}</md-checkbox></div>\n<div><md-input-container class=\"md-block\" flex><label>{{\'PARTY.ORGANIZATION.ORGANIZATION_NUMBER\' | translate }}</label>\n<input ng-model=\"vm.baldrisModel.organizationNumber\" ng-change=\"vm.partyChanged()\" ng-disabled=\"vm.isDisabled\">\n</md-input-container></div></div>");
$templateCache.put("app/main/reference-types/party/components/edit-party/views/person.view.html","<div layout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\"><md-input-container class=\"md-block\"><label>\n{{ \"PARTY.PERSON.LASTNAME\" | translate }}</label><input ng-model=\"vm.baldrisModel.lastName\" \nng-change=\"vm.partyChanged()\" ng-disabled=\"vm.isDisabled\"></md-input-container></div><div flex-gt-sm=\"50\">\n<md-input-container class=\"md-block\"><label>{{ \"PARTY.PERSON.FIRSTNAME\" | translate }}</label><input \nng-model=\"vm.baldrisModel.firstName\" ng-disabled=\"vm.isDisabled\" ng-change=\"vm.partyChanged()\"></md-input-container>\n</div></div><div class=\"margin-top-20 margin-bottom-20\"><sex-select flex sex=\"vm.baldrisModel.sex\" \nlabel-text=\"{{ \'PARTY.PERSON.SEX\' | translate }}\" on-change=\"(vm.onSexChange)\"></sex-select></div><div \nlayout-gt-sm=\"row\" class=\"padding-bottom-20\"><birth-date-select flex-gt-sm=\"50\" ng-model=\"vm.baldrisModel.dateOfBirth\" \ndate-of-death=\"vm.baldrisModel.dateOfDeath\" allow-approximate=\"true\" on-update=\"vm.onDateOfBirthChange()\" \napproximate-model=\"vm.baldrisModel.dateOfBirthApproximate\"></birth-date-select><death-date-select flex-gt-sm=\"50\" \nng-if=\"vm.showDeathDate\" ng-model=\"vm.baldrisModel.dateOfDeath\" date-of-birth=\"vm.baldrisModel.dateOfBirth\" \nallow-approximate=\"true\" on-update=\"vm.onDateOfDeathChange()\" \napproximate-model=\"vm.baldrisModel.dateOfDeathApproximate\"></death-date-select></div><div \nclass=\"margin-top-20 margin-bottom-20\"><ssn-input ng-if=\"vm.includeSsn !== false\" \nng-model=\"vm.baldrisModel.socialSecurityNumber\" date-of-birth=\"vm.baldrisModel.dateOfBirth\" sex=\"vm.baldrisModel.sex\">\n</ssn-input></div>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-boolean.tmpl.html","<div flex><md-checkbox ng-model=\"vm.customFieldData.boolData\" aria-label=\"{{vm.labelText}}\" \nng-change=\"vm.onValueChanged()\">{{ vm.labelText }}</md-checkbox></div>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-date-time.tmpl.html","<div layout=\"column\" flex><h4>{{ vm.labelText }}</h4><date-time-select ng-model=\"vm.customFieldData.dateTimeData\" \non-update=\"vm.onValueChanged()\"></date-time-select></div>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-decimal.tmpl.html","<md-input-container ng-if=\"!vm.isCurrency\" flex><label>{{ vm.labelText }}</label><input \nng-model=\"vm.customFieldData.decimalData\" type=\"number\" step=\"0.1\" ng-change=\"vm.onValueChanged()\">\n</md-input-container><md-input-container ng-if=\"vm.isCurrency\" flex><label>{{ vm.labelText }}</label><input \nng-model=\"vm.customFieldData.decimalData\" ng-currency ng-change=\"vm.onValueChanged()\"></md-input-container>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-location-type.tmpl.html","<location-type-single-select flex location-type-id=\"vm.customFieldData.locationTypeId\" \nlocation-type=\"vm.customFieldData.locationType\" label-text=\"{{vm.labelText}}\" \ndisplay-text=\"vm.customFieldData.locationTypeName\" on-update=\"vm.selectedItemChange(value)\">\n</location-type-single-select>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-long.tmpl.html","<md-input-container flex><label>{{ vm.labelText }}</label><input type=\"number\" step=\"1\" \nng-model=\"vm.customFieldData.longData\" ng-change=\"vm.onValueChanged()\"></md-input-container>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-lookup-string-type.tmpl.html","<lookup-string-type-select flex lookup-string-type-id=\"vm.customFieldData.lookUpStringTypeId\" \nlookup-string-type=\"vm.customFieldData.lookUpStringType\" label-text=\"{{vm.labelText}}\" \ndisplay-text=\"vm.customFieldData.lookupStringTypeName\" on-update=\"vm.selectedItemChange(value)\">\n</lookup-string-type-select>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-lookup-string.tmpl.html","<lookup-string-select flex lookup-string=\"vm.customFieldData.lookupString\" on-update=\"vm.selectedItemChange(value)\" \nlookup-string-id=\"vm.customFieldData.lookupStringId\" display-text=\"vm.customFieldData.lookupStringLookupValue\" \nlookup-string-config=\"vm.baldrisModel.dataTypeDiscriminator\" min-query-length=\"0\" \nallow-custom=\"vm.baldrisModel.allowCustom\" custom-value=\"vm.customFieldData.stringData\" \nlabel-text=\"{{vm.baldrisModel.label}}\"></lookup-string-select>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-product.tmpl.html","<product-select flex product=\"vm.customFieldData.product\" product-id=\"vm.customFieldData.productId\" \nlabel-text=\"{{ vm.labelText }}\" on-update=\"vm.onValueChanged()\"></product-select>");
$templateCache.put("app/main/settings/configuration/components/edit-baldris-config/templates/edit-string.tmpl.html","<md-input-container flex><label>{{ vm.labelText }}</label><input ng-model=\"vm.customFieldData.stringData\" \nng-change=\"vm.onValueChanged()\"></md-input-container>");
$templateCache.put("app/main/settings/configuration/program-settings/program-slots/edit-program-slot/edit-program-slot.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.validation.programSlotForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-program-slot-form\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55 header\" layout=\"column\"><div \nclass=\"md-title text-uppercase\">\n{{ (vm.programSlot.changeState === 1 ? \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_SLOT.ADD_PROGRAM_SLOT\" : \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_SLOT.EDIT_PROGRAM_SLOT\") | translate }}\n</div></div><md-content layout-padding layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_SLOT.NAME\" | translate }}</label><input ng-model=\"vm.programSlot.name\"></md-input-container></div>\n<div><md-input-container class=\"md-block\"><label>{{ \"PROGRAMS.PROGRAM_SLOT.DESCRIPTION\" | translate }}</label><textarea\n ng-model=\"vm.programSlot.description\"></textarea></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{ \"PROGRAMS.PROGRAM_SLOT.TITLE\" | translate }}</label><input ng-model=\"vm.programSlot.title\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_SLOT.TITLE_ALTERNATIVE\" | translate }}</label><input ng-model=\"vm.programSlot.titleAlternative\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_SLOT.ENGLISH_TITLE\" | translate }}</label><input ng-model=\"vm.programSlot.englishTitle\">\n</md-input-container></div><md-input-container><md-checkbox ng-model=\"vm.programSlot.shouldBeVisibleInPrint\" \naria-label=\"{{ \'PROGRAMS.PROGRAM_SLOT.SHOULD_BE_VISIBLE_IN_PRINT\' | translate}}\">\n{{ \"PROGRAMS.PROGRAM_SLOT.SHOULD_BE_VISIBLE_IN_PRINT\" | translate }}</md-checkbox></md-input-container>\n<program-data-type-select program-data-type=\"vm.programSlot.dataType\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_SLOT.DATA_TYPE\' | translate}}\"></program-data-type-select><lookup-string-type-select \nng-if=\"vm.programSlot.dataType === 1\" lookup-string-type=\"vm.programSlot.lookupStringCategory\" \nlookup-string-type-id=\"vm.programSlot.lookupStringCategoryId\" \nlabel-text=\"{{ \'PROGRAMS.PROGRAM_SLOT.LOOKUP_STRING_CATEGORY\' | translate }}\" is-required=\"false\">\n</lookup-string-type-select><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_SLOT.DATA_TYPE_DISCRIMINATOR\" | translate }}</label><input ng-disabled=\"vm.isProcessing\" \nng-model=\"vm.programSlot.dataTypeDiscriminator\"></md-input-container></div><div><md-input-container class=\"md-block\">\n<label>{{ \"PROGRAMS.PROGRAM_SLOT.SORT_ORDER\" | translate }}</label><input ng-model=\"vm.programSlot.sortOrder\" \ntype=\"number\" step=\"1\"></md-input-container></div><md-input-container><md-checkbox ng-model=\"vm.programSlot.isDeleted\" \naria-label=\"{{ \'PROGRAMS.PROGRAM_SLOT.IS_DELETED\' | translate}}\">{{ \"PROGRAMS.PROGRAM_SLOT.IS_DELETED\" | translate }}\n</md-checkbox></md-input-container></md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><md-button \nclass=\"md-warn\" ng-click=\"vm.exitView()\">{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.validation.programSlotForm.$pristine\">\n{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}</md-button></div></div>");
$templateCache.put("app/main/settings/configuration/program-settings/program-styles/edit-program-style/edit-program-style.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.programStyleForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-program-style-form\"><div\n layout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">\n{{ vm.data.isNew ? \'SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.ADD_PROGRAM_STYLE\' : \'SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.EDIT_PROGRAM_STYLE\' | translate}}\n</div></div><md-content layout-padding layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \'PROGRAMS.PROGRAM_STYLE.NAME\' | translate }}</label><input ng-model=\"vm.data.updateModel.programStyle.name\">\n</md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \'PROGRAMS.PROGRAM_STYLE.DESCRIPTION\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.programStyle.description\"></textarea></md-input-container></div><program-options-select \nprogram-option=\"vm.data.updateModel.programStyle.options\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_STYLE.OPTIONS\' | translate}}\"></program-options-select><div><md-input-container \nclass=\"md-block\"><label>{{ \'PROGRAMS.PROGRAM_STYLE.DATE_OF_BIRTH_FORMAT\' | translate }}</label><textarea \nng-model=\"vm.data.updateModel.programStyle.dateOfBirthFormat\"></textarea></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{ \'PROGRAMS.PROGRAM_STYLE.DATE_OF_DEATH_FORMAT\' | translate }}</label>\n<textarea ng-model=\"vm.data.updateModel.programStyle.dateOfDeathFormat\"></textarea></md-input-container></div><div>\n<md-input-container class=\"md-block\"><label>{{ \'PROGRAMS.PROGRAM_STYLE.CEREMONY_TIME_FORMAT\' | translate }}</label>\n<textarea ng-model=\"vm.data.updateModel.programStyle.ceremonyTimeFormat\"></textarea></md-input-container></div>\n<font-style-select font-style-id=\"vm.data.updateModel.programStyle.deceasedNameStyleId\" \nfont-style=\"vm.data.updateModel.programStyle.deceasedNameStyle\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_STYLE.DECEASED_NAME_STYLE\' | translate}}\"></font-style-select><font-style-select \nfont-style-id=\"vm.data.updateModel.programStyle.deceasedDatesStyleId\" \nfont-style=\"vm.data.updateModel.programStyle.deceasedDatesStyle\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_STYLE.DECEASED_DATES_STYLE\' | translate}}\"></font-style-select><font-style-select \nfont-style-id=\"vm.data.updateModel.programStyle.ceremonyDetailsStyleId\" \nfont-style=\"vm.data.updateModel.programStyle.ceremonyDetailsStyle\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_STYLE.CEREMONY_DETAILS_STYLE\' | translate}}\"></font-style-select><font-style-select \nfont-style-id=\"vm.data.updateModel.programStyle.participantsStyleId\" \nfont-style=\"vm.data.updateModel.programStyle.participantsStyle\" \nlabel-text=\"{{\'PROGRAMS.PROGRAM_STYLE.PARTICIPANTS_STYLE\' | translate}}\"></font-style-select></md-content>\n</ms-widget-front></ms-widget><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"md-title text-uppercase\">\n{{ \'SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.PROGRAM_SLOT_STYLES\' | translate}}</div><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.data.openEditProgramSlotStyleDialog($event, null)\" \naria-label=\"Cancel\" translate-attr-aria-label=\"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.ADD_PROGRAM_SLOT_STYLE\">\n<md-tooltip md-direction=\"top\"><span translate=\"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.ADD_PROGRAM_SLOT_STYLE\">\n</span></md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content layout-padding \nlayout=\"column\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"slotStyle in vm.data.updateModel.slotStyles\" \nng-click=\"vm.data.openEditProgramSlotStyleDialog($event, slotStyle)\"><div class=\"md-list-item-text\"><h3>\n{{ slotStyle.programSlot.name || slotStyle.programSlotName || \'SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_STYLE.DEFAULT_PROGRAM_SLOT_STYLE\' | translate }}\n</h3><p>\n{{ vm.getFontStyleDescription(slotStyle.titleStyleDescription, slotStyle.titleStyle) }} | {{ vm.getFontStyleDescription(slotStyle.fontStyleDescription, slotStyle.fontStyle) }}\n</p></div></md-list-item></md-list></md-content></ms-widget-front></ms-widget></div><div layout=\"row\"><md-button \nclass=\"md-warn\" ng-click=\"vm.exitView()\">{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button \nng-click=\"vm.saveAndExitView()\" ng-disabled=\"vm.data.validation.programStyleForm.$pristine\">\n{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/settings/configuration/program-settings/program-types/edit-program-type/edit-program-type.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.validation.programTypeForm\" ng-if=\"!vm.loadingService.isLoading\" class=\"edit-program-type-form\"><div \nlayout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex flex-gt-lg=\"50\" layout=\"column\"><ms-widget-front \nclass=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55 header\" layout=\"column\"><div \nclass=\"md-title text-uppercase\">\n{{ (vm.programType.changeState === 1 ? \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.ADD_PROGRAM_TYPE\" : \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.EDIT_PROGRAM_TYPE\") | translate }}\n</div></div><div ng-if=\"vm.isProcessing\"><md-progress-linear md-mode=\"query\"></md-progress-linear></div><md-content \nlayout-padding layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_TYPE.NAME\" | translate }}</label><input ng-disabled=\"vm.isProcessing\" \nng-model=\"vm.programType.name\"></md-input-container></div><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_TYPE.DESCRIPTION\" | translate }}</label><textarea ng-disabled=\"vm.isProcessing\" \nng-model=\"vm.programType.description\"></textarea></md-input-container></div><md-input-container><md-checkbox \nng-disabled=\"vm.isProcessing\" ng-model=\"vm.programType.isDeleted\" \naria-label=\"{{ \'PROGRAMS.PROGRAM_TYPE.IS_DELETED\' | translate}}\">{{ \"PROGRAMS.PROGRAM_TYPE.IS_DELETED\" | translate }}\n</md-checkbox></md-input-container><div><md-input-container class=\"md-block\"><label>\n{{ \"PROGRAMS.PROGRAM_TYPE.EXTERNAL_TEMPLATE_ID\" | translate }}</label><input ng-disabled=\"vm.isProcessing\" \nng-model=\"vm.programType.externalTemplateId\"></md-input-container></div><p>\n{{ \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.TEMPLATE_FILE\" | translate }}</p><div \nng-if=\"vm.programType.templateFileId\">{{ vm.programType.templateFileName }}<md-button ng-disabled=\"vm.isProcessing\" \nclass=\"md-warn\" aria-label=\"Remove Image\" ng-click=\"vm.removeTemplate()\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.REMOVE_TEMPLATE_FILE\" | translate }}</md-button></div><md-button \nng-disabled=\"vm.isProcessing\" ng-if=\"!vm.programType.templateFileId\" \naria-label=\"{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}\" ngf-select=\"vm.uploadTemplate($file)\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>\n{{ \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.UPLOAD_TEMPLATE_FILE\" | translate }}</md-button><p>\n{{ \"SETTINGS.PROGRAM_SETTINGS.EDIT_PROGRAM_TYPE.PREVIEW\" | translate }}</p><div ng-if=\"vm.programType.previewImageId\" \nclass=\"image\"><img baldris-img-src=\"vm.programType.previewImageUrl\" preset=\"square-250-padded\"><md-button \nng-disabled=\"vm.isProcessing\" class=\"md-warn\" aria-label=\"Remove Image\" \nng-click=\"vm.removeImage(\'image\', \'imageId\', vm.updateModel.location)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{ \"COMMON.DIALOG.REMOVE_IMAGE\" | translate }}</md-button></div><md-button ng-disabled=\"vm.isProcessing\" \nng-if=\"!vm.programType.previewImageId\" aria-label=\"{{ \'COMMON.DIALOG.UPLOAD_IMAGE\' | translate }}\" \nngf-select=\"vm.uploadImage($file)\"><md-icon md-font-icon=\"icon-upload\"></md-icon>\n{{ \"COMMON.DIALOG.UPLOAD_IMAGE\" | translate }}</md-button></md-content></ms-widget-front></ms-widget></div><div \nlayout=\"row\"><md-button class=\"md-warn\" ng-disabled=\"vm.isProcessing\" ng-click=\"vm.exitView()\">\n{{ \"COMMON.DIALOG.CANCEL\" | translate }}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.validation.programTypeForm.$pristine || vm.isProcessing\">{{ \"COMMON.DIALOG.OK_SAVE\" | translate }}\n</md-button></div></div>");
$templateCache.put("app/main/settings/configuration/transport-settings/location-transports/edit-location-transport/edit-location-transport.tmpl.html","<div ng-if=\"vm.loadingService.isLoading\" flex layout=\"row\" layout-padding layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-form=\"vm.data.validation.locationTransportForm\" ng-if=\"!vm.loadingService.isLoading\" \nclass=\"edit-location-transport-form\"><div layout=\"column\" layout-gt-lg=\"row\" layout-wrap><ms-widget flex \nflex-gt-lg=\"50\" layout=\"column\"><ms-widget-front class=\"white-bg edit-page\"><div class=\"border-bottom ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"md-title text-uppercase\">\n{{ vm.data.isNew ? \'SETTINGS.TRANSPORT_SETTINGS.EDIT_LOCATION_TRANSPORT.ADD_LOCATION_TRANSPORT\' : \'SETTINGS.TRANSPORT_SETTINGS.EDIT_LOCATION_TRANSPORT.EDIT_LOCATION_TRANSPORT\' | translate}}\n</div></div><md-content layout-padding layout=\"column\"><div><md-input-container class=\"md-block\"><label>\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.DESCRIPTION\' | translate }}</label><input \nng-model=\"vm.data.locationTransport.description\"></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\"><div \nlayout=\"column\" flex-gt-sm=\"50\"><location-select \nis-disabled=\"vm.data.isGeneralCollection() || vm.data.isGeneralCremation() || vm.data.isGeneralDepartment()\" \nclass=\"margin-bottom\" location=\"vm.data.locationTransport.departureLocation\" \nlocation-id=\"vm.data.locationTransport.departureLocationId\" \nlabel-text=\"{{\'LOCATIONS.LOCATION_TRANSPORTS.DEPARTURE_LOCATION\' | translate}}\"></location-select><div>\n<md-input-container flex class=\"md-block\"><label>\n{{\'LOCATIONS.LOCATION_TRANSPORTS.DEPARTURE_LOCATION_REMARKS\' | translate }}</label><input \nng-disabled=\"vm.data.isGeneralCollection() || vm.data.isGeneralCremation() || vm.data.isGeneralDepartment()\" \nng-model=\"vm.data.locationTransport.departureLocationRemarks\"></md-input-container></div></div><div layout=\"column\" \nflex-gt-sm=\"50\"><location-select class=\"margin-bottom\" location=\"vm.data.locationTransport.destinationLocation\" \nlocation-id=\"vm.data.locationTransport.destinationLocationId\" \nlabel-text=\"{{\'LOCATIONS.LOCATION_TRANSPORTS.DESTINATION_LOCATION\' | translate}}\"></location-select><div>\n<md-input-container flex class=\"md-block\"><label>\n{{\'LOCATIONS.LOCATION_TRANSPORTS.DESTINATION_LOCATION_REMARKS\' | translate }}</label><input \nng-model=\"vm.data.locationTransport.destinationLocationRemarks\"></md-input-container></div></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\"><md-checkbox ng-checked=\"vm.data.isGeneralCollection()\" \nng-click=\"vm.data.toggleGeneralCollection()\">\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_GENERAL_COLLECTION_TRANSPORT\' | translate }}</md-checkbox></div><div \nflex-gt-sm=\"50\"><md-checkbox ng-checked=\"vm.data.isGeneralCremation()\" ng-click=\"vm.data.toggleGeneralCremation()\">\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_GENERAL_CREMATION_TRANSPORT\' | translate }}</md-checkbox></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div flex-gt-sm=\"50\"><md-checkbox ng-checked=\"vm.data.isCremationTransport()\" \nng-click=\"vm.data.toggleCremationTransport()\">{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_CREMATION_TRANSPORT\' | translate }}\n</md-checkbox></div><div flex-gt-sm=\"50\"><md-checkbox ng-checked=\"vm.data.isGeneralDepartment()\" \nng-click=\"vm.data.toggleGeneralDepartment()\">\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.IS_GENERAL_DEPARTMENT_TOCEREMONY_TRANSPORT\' | translate }}</md-checkbox></div></div>\n<div><md-input-container class=\"md-block\"><label>{{ \'LOCATIONS.LOCATION_TRANSPORTS.REMARKS\' | translate }}</label>\n<textarea ng-model=\"vm.data.locationTransport.remarks\"></textarea></md-input-container></div><div><md-input-container \nclass=\"md-block\"><label>{{ \'LOCATIONS.LOCATION_TRANSPORTS.INVOICE_TEXT\' | translate }}</label><textarea \nng-model=\"vm.data.locationTransport.invoiceText\"></textarea></md-input-container></div><bill-to-select \nbill-to=\"vm.data.locationTransport.billTo\" label-text=\"{{ \'LOCATIONS.LOCATION_TRANSPORTS.BILL_TO\' | translate}}\">\n</bill-to-select><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\n{{\'LOCATIONS.LOCATION_TRANSPORTS.DISTANCE\' | translate }}</label><input ng-model=\"vm.data.locationTransport.distance\" \ntype=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.DRIVER_HOURS\' | translate }}</label>\n<input ng-model=\"vm.data.locationTransport.driverHours\" type=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\n{{\'LOCATIONS.LOCATION_TRANSPORTS.ADDITIONAL_HOURS\' | translate }}</label><input \nng-model=\"vm.data.locationTransport.additionalHours\" type=\"number\" step=\"0.1\" ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>{{\'LOCATIONS.LOCATION_TRANSPORTS.ADDITIONAL_COST\' | translate }}\n</label><input ng-model=\"vm.data.locationTransport.additionalCost\" ng-currency ng-change=\"vm.data.calculatePrice()\" \nng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 2000, \'blur\': 0 } }\"></md-input-container></div>\n<div layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\"><label>\n{{\'LOCATIONS.LOCATION_TRANSPORTS.OVERRIDDEN_PRICE\' | translate }}</label><input \nng-model=\"vm.data.locationTransport.overriddenPrice\" ng-currency></md-input-container></div><div flex=\"50\"><div \nclass=\"md-block\"><label class=\"md-caption\">{{\'LOCATIONS.LOCATION_TRANSPORTS.CALCULATED_PRICE\' | translate }}</label><p>\n{{vm.data.locationTransport.price || 0 | currency}}</p></div></div></div><div flex-gt-sm=\"50\"><md-checkbox \nng-checked=\"vm.data.shouldNotCalculatePrice()\" ng-click=\"vm.data.toggleShouldNotCalculatePrice()\">\n{{ \'LOCATIONS.LOCATION_TRANSPORTS.SHOULD_NOT_CALCULATE_PRICE\' | translate }}</md-checkbox></div>\n<calendar-event-type-select flex calendar-event-type-id=\"vm.data.locationTransport.suggestedTransportTypeId\" \ncalendar-event-type=\"vm.data.locationTransport.suggestedTransportType\" \nlabel-text=\"{{\'LOCATIONS.LOCATION_TRANSPORTS.SUGGESTED_CALENDAR_EVENT_TYPE\' | translate}}\" options-filter=\"192\">\n</calendar-event-type-select><department-select flex department-id=\"vm.data.locationTransport.departmentId\" \ndepartment=\"vm.data.locationTransport.department\" \nlabel-text=\"{{\'LOCATIONS.LOCATION_TRANSPORTS.DEPARTMENT\' | translate}}\"></department-select></md-content>\n</ms-widget-front></ms-widget></div><div layout=\"row\"><md-button class=\"md-warn\" ng-click=\"vm.exitView()\">\n{{ \'COMMON.DIALOG.CANCEL\' | translate}}</md-button><md-button ng-click=\"vm.saveAndExitView()\" \nng-disabled=\"vm.data.validation.locationTransportForm.$pristine\">{{ \'COMMON.DIALOG.OK_SAVE\' | translate}}</md-button>\n</div></div>");}]);